(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 38951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; }
/* harmony export */ });
var timezoneToCurrency = {
  'Pacific/Midway': 'USD',
  'Pacific/Niue': 'NZD',
  'Pacific/Pago_Pago': 'USD',
  'America/Adak': 'USD',
  'Pacific/Honolulu': 'USD',
  'Pacific/Rarotonga': 'NZD',
  'Pacific/Tahiti': 'XPF',
  'Pacific/Marquesas': 'XPF',
  'America/Anchorage': 'USD',
  'America/Juneau': 'USD',
  'America/Metlakatla': 'USD',
  'America/Nome': 'USD',
  'America/Sitka': 'USD',
  'America/Yakutat': 'USD',
  'Pacific/Gambier': 'XPF',
  'America/Los_Angeles': 'USD',
  'America/Tijuana': 'MXN',
  'America/Vancouver': 'CAD',
  'Pacific/Pitcairn': 'NZD',
  'America/Boise': 'USD',
  'America/Cambridge_Bay': 'CAD',
  'America/Chihuahua': 'MXN',
  'America/Creston': 'CAD',
  'America/Dawson': 'CAD',
  'America/Dawson_Creek': 'CAD',
  'America/Denver': 'USD',
  'America/Edmonton': 'CAD',
  'America/Fort_Nelson': 'CAD',
  'America/Hermosillo': 'MXN',
  'America/Inuvik': 'CAD',
  'America/Mazatlan': 'MXN',
  'America/Ojinaga': 'MXN',
  'America/Phoenix': 'USD',
  'America/Whitehorse': 'CAD',
  'America/Yellowknife': 'CAD',
  'America/Bahia_Banderas': 'MXN',
  'America/Belize': 'BZD',
  'America/Chicago': 'USD',
  'America/Costa_Rica': 'CRC',
  'America/El_Salvador': 'USD',
  'America/Guatemala': 'GTQ',
  'America/Indiana/Knox': 'USD',
  'America/Indiana/Tell_City': 'USD',
  'America/Managua': 'NIO',
  'America/Matamoros': 'MXN',
  'America/Menominee': 'USD',
  'America/Merida': 'MXN',
  'America/Mexico_City': 'MXN',
  'America/Monterrey': 'MXN',
  'America/North_Dakota/Beulah': 'USD',
  'America/North_Dakota/Center': 'USD',
  'America/North_Dakota/New_Salem': 'USD',
  'America/Rainy_River': 'CAD',
  'America/Rankin_Inlet': 'CAD',
  'America/Regina': 'CAD',
  'America/Resolute': 'CAD',
  'America/Swift_Current': 'CAD',
  'America/Tegucigalpa': 'HNL',
  'America/Winnipeg': 'CAD',
  'Pacific/Easter': 'CLP',
  'Pacific/Galapagos': 'USD',
  'America/Atikokan': 'CAD',
  'America/Bogota': 'COP',
  'America/Cancun': 'MXN',
  'America/Cayman': 'KYD',
  'America/Detroit': 'USD',
  'America/Eirunepe': 'BRL',
  'America/Grand_Turk': 'USD',
  'America/Guayaquil': 'USD',
  'America/Havana': 'CUP',
  'America/Indiana/Indianapolis': 'USD',
  'America/Indiana/Marengo': 'USD',
  'America/Indiana/Petersburg': 'USD',
  'America/Indiana/Vevay': 'USD',
  'America/Indiana/Vincennes': 'USD',
  'America/Indiana/Winamac': 'USD',
  'America/Iqaluit': 'CAD',
  'America/Jamaica': 'JMD',
  'America/Kentucky/Louisville': 'USD',
  'America/Kentucky/Monticello': 'USD',
  'America/Lima': 'PEN',
  'America/Nassau': 'BSD',
  'America/New_York': 'USD',
  'America/Nipigon': 'CAD',
  'America/Panama': 'PAB',
  'America/Pangnirtung': 'CAD',
  'America/Port-au-Prince': 'HTG',
  'America/Rio_Branco': 'BRL',
  'America/Thunder_Bay': 'CAD',
  'America/Toronto': 'CAD',
  'America/AnguillaSandy Hill': 'XCD',
  'America/Antigua': 'XCD',
  'America/Aruba': 'AWG',
  'America/Asuncion': 'PYG',
  'America/Barbados': 'BBD',
  'America/Blanc-Sablon': 'CAD',
  'America/Boa_Vista': 'BRL',
  'America/Campo_Grande': 'BRL',
  'America/Caracas': 'VEB',
  'America/Cuiaba': 'BRL',
  'America/Curacao': 'ANG',
  'America/Dominica': 'DOP',
  'America/Glace_Bay': 'CAD',
  'America/Goose_Bay': 'CAD',
  'America/Grenada': 'XCD',
  'America/Guadeloupe': 'EUR',
  'America/Guyana': 'GYD',
  'America/Halifax': 'CAD',
  'America/Kralendijk': 'USD',
  'America/La_Paz': 'BOB',
  'America/Lower_Princes': 'USD',
  'America/Manaus': 'BRL',
  'America/Marigot': 'EUR',
  'America/Martinique': 'EUR',
  'America/Moncton': 'CAD',
  'America/Montserrat': 'XCD',
  'America/Porto_Velho': 'BRL',
  'America/Port_of_Spain': 'BZD',
  'America/Puerto_Rico': 'USD',
  'America/Santiago': 'CLP',
  'America/Santo_Domingo': 'DOP',
  'America/St_Barthelemy': 'EUR',
  'America/St_Kitts': 'XCD',
  'America/St_Lucia': 'XCD',
  'America/St_Thomas': 'USD',
  'America/St_Vincent': 'XCD',
  'America/Thule': 'DKK',
  'America/Tortola': 'USD',
  'Atlantic/Bermuda': 'BMD',
  'America/St_Johns': 'CAD',
  'America/Araguaina': 'BRL',
  'America/Argentina/Buenos_Aires': 'ARS',
  'America/Argentina/Catamarca': 'ARS',
  'America/Argentina/Cordoba': 'ARS',
  'America/Argentina/Jujuy': 'ARS',
  'America/Argentina/La_Rioja': 'ARS',
  'America/Argentina/Mendoza': 'ARS',
  'America/Argentina/Rio_Gallegos': 'ARS',
  'America/Argentina/Salta': 'ARS',
  'America/Argentina/San_Juan': 'ARS',
  'America/Argentina/San_Luis': 'ARS',
  'America/Argentina/Tucuman': 'ARS',
  'America/Argentina/Ushuaia': 'ARS',
  'America/Bahia': 'BRL',
  'America/Belem': 'BRL',
  'America/Cayenne': 'EUR',
  'America/Fortaleza': 'BRL',
  'America/Godthab': 'DKK',
  'America/Maceio': 'BRL',
  'America/Miquelon': 'EUR',
  'America/Montevideo': 'UYU',
  'America/Paramaribo': 'SRD',
  'America/Punta_Arenas': 'CLP',
  'America/Recife': 'BRL',
  'America/Santarem': 'BRL',
  'America/Sao_Paulo': 'BRL',
  'Antarctica/Palmer': 'USD',
  'Antarctica/Rothera': 'USD',
  'Atlantic/Stanley': 'FKP',
  'America/Noronha': 'BRL',
  'Atlantic/South_Georgia': 'GBP',
  'America/Scoresbysund': 'DKK',
  'Atlantic/Azores': 'EUR',
  'Atlantic/Cape_Verde': 'CVE',
  'Africa/Abidjan': 'XOF',
  'Africa/Accra': 'GHC',
  'Africa/Bamako': 'XOF',
  'Africa/Banjul': 'GMD',
  'Africa/Bissau': 'XOF',
  'Africa/Casablanca': 'MAD',
  'Africa/Conakry': 'GNF',
  'Africa/Dakar': 'XOF',
  'Africa/El_Aaiun': 'MAD',
  'Africa/Freetown': 'SLL',
  'Africa/Lome': 'XOF',
  'Africa/Monrovia': 'LRD',
  'Africa/Nouakchott': 'MRU',
  'Africa/Ouagadougou': 'XOF',
  'Africa/Sao_Tome': 'STD',
  'America/Danmarkshavn': 'DKK',
  'Antarctica/Troll': 'NOK',
  'Atlantic/Canary': 'EUR',
  'Atlantic/Faroe': 'DKK',
  'Atlantic/Madeira': 'EUR',
  'Atlantic/Reykjavik': 'ISK',
  'Atlantic/St_Helena': 'SHP',
  'Europe/Dublin': 'EUR',
  'Europe/Guernsey': 'GBP',
  'Europe/Isle_of_Man': 'IMP',
  'Europe/Jersey': 'GBP',
  'Europe/Lisbon': 'EUR',
  'Europe/London': 'GBP',
  'Africa/Algiers': 'DZD',
  'Africa/Bangui': 'XAF',
  'Africa/Brazzaville': 'XAF',
  'Africa/Ceuta': 'EUR',
  'Africa/Douala': 'XAF',
  'Africa/Kinshasa': 'CDF',
  'Africa/Lagos': 'NGN',
  'Africa/Libreville': 'XAF',
  'Africa/Luanda': 'AOA',
  'Africa/Malabo': 'XAF',
  'Africa/Ndjamena': 'XAF',
  'Africa/Niamey': 'XOF',
  'Africa/Porto-Novo': 'XOF',
  'Africa/Tunis': 'TND',
  'Africa/Windhoek': 'NAD',
  'Arctic/Longyearbyen': 'NOK',
  'Europe/Amsterdam': 'EUR',
  'Europe/Andorra': 'EUR',
  'Europe/Belgrade': 'RSD',
  'Europe/Berlin': 'EUR',
  'Europe/Bratislava': 'EUR',
  'Europe/Brussels': 'EUR',
  'Europe/Budapest': 'HUF',
  'Europe/Copenhagen': 'DKK',
  'Europe/Gibraltar': 'GIP',
  'Europe/Ljubljana': 'EUR',
  'Europe/Luxembourg': 'EUR',
  'Europe/Madrid': 'EUR',
  'Europe/Malta': 'EUR',
  'Europe/Monaco': 'EUR',
  'Europe/Oslo': 'NOK',
  'Europe/Paris': 'EUR',
  'Europe/Podgorica': 'EUR',
  'Europe/Prague': 'CZK',
  'Europe/Rome': 'EUR',
  'Europe/San_Marino': 'EUR',
  'Europe/Sarajevo': 'BAM',
  'Europe/Skopje': 'MKD',
  'Europe/Stockholm': 'SEK',
  'Europe/Tirane': 'ALL',
  'Europe/Vaduz': 'CHF',
  'Europe/Vatican': 'EUR',
  'Europe/Vienna': 'EUR',
  'Europe/Warsaw': 'PLN',
  'Europe/Zagreb': 'HRK',
  'Europe/Zurich': 'CHF',
  'Africa/Blantyre': 'MWK',
  'Africa/Bujumbura': 'BIF',
  'Africa/Cairo': 'EGP',
  'Africa/Gaborone': 'BWP',
  'Africa/Harare': 'ZWL',
  'Africa/Johannesburg': 'ZAR',
  'Africa/Juba': 'SSP',
  'Africa/Khartoum': 'SDG',
  'Africa/Kigali': 'RWF',
  'Africa/Lubumbashi': 'CDF',
  'Africa/Lusaka': 'ZMW',
  'Africa/Maputo': 'MZM',
  'Africa/Maseru': 'LSL',
  'Africa/Mbabane': 'SZL',
  'Africa/Tripoli': 'LYD',
  'Asia/Amman': 'JOD',
  'Asia/Beirut': 'LBP',
  'Asia/Damascus': 'SYP',
  'Asia/Famagusta': 'TRY',
  'Asia/Gaza': 'ILS',
  'Asia/Hebron': 'ILS',
  'Asia/Jerusalem': 'ILS',
  'Asia/Nicosia': 'EUR',
  'Europe/Athens': 'EUR',
  'Europe/Bucharest': 'RON',
  'Europe/Chisinau': 'MDL',
  'Europe/Helsinki': 'EUR',
  'Europe/Kaliningrad': 'RUB',
  'Europe/Kiev': 'UAH',
  'Europe/Mariehamn': 'EUR',
  'Europe/Riga': 'EUR',
  'Europe/Sofia': 'BGN',
  'Europe/Tallinn': 'EUR',
  'Europe/Uzhgorod': 'UAH',
  'Europe/Vilnius': 'EUR',
  'Europe/Zaporozhye': 'UAH',
  'Africa/Addis_Ababa': 'ETB',
  'Africa/Asmara': 'ERN',
  'Africa/Dar_es_Salaam': 'TZS',
  'Africa/Djibouti': 'DJF',
  'Africa/Kampala': 'UGX',
  'Africa/Mogadishu': 'SOS',
  'Africa/Nairobi': 'KES',
  'Antarctica/Syowa': 'EUR',
  'Asia/Aden': 'YER',
  'Asia/Baghdad': 'IQD',
  'Asia/Bahrain': 'BHD',
  'Asia/Kuwait': 'KWD',
  'Asia/Qatar': 'QAR',
  'Asia/Riyadh': 'SAR',
  'Europe/Istanbul': 'TRY',
  'Europe/Kirov': 'RUB',
  'Europe/Minsk': 'BYN',
  'Europe/Moscow': 'RUB',
  'Europe/Simferopol': 'RUB',
  'Europe/Volgograd': 'RUB',
  'Indian/Antananarivo': 'MGA',
  'Indian/Comoro': 'USD',
  'Indian/Mayotte': 'EUR',
  'Asia/Tehran': 'IRR',
  'Asia/Baku': 'AZN',
  'Asia/Dubai': 'AED',
  'Asia/Muscat': 'OMR',
  'Asia/Tbilisi': 'GEL',
  'Asia/Yerevan': 'AMD',
  'Europe/Astrakhan': 'RUB',
  'Europe/Samara': 'RUB',
  'Europe/Saratov': 'RUB',
  'Europe/Ulyanovsk': 'RUB',
  'Indian/Mahe': 'SCR',
  'Indian/Mauritius': 'MUR',
  'Indian/Reunion': 'EUR',
  'Asia/Kabul': 'AFN',
  'Antarctica/Mawson': 'USD',
  'Asia/Aqtau': 'KZT',
  'Asia/Aqtobe': 'KZT',
  'Asia/Ashgabat': 'TMM',
  'Asia/Atyrau': 'KZT',
  'Asia/Dushanbe': 'TJS',
  'Asia/Karachi': 'PKR',
  'Asia/Oral': 'KZT',
  'Asia/Qyzylorda': 'KZT',
  'Asia/Samarkand': 'UZS',
  'Asia/Tashkent': 'UZS',
  'Asia/Yekaterinburg': 'RUB',
  'Indian/Kerguelen': 'EUR',
  'Indian/Maldives': 'MVR',
  'Asia/Colombo': 'LKR',
  'Asia/Kolkata': 'INR',
  'Asia/Kathmandu': 'NPR',
  'Antarctica/Vostok': 'USD',
  'Asia/Almaty': 'KZT',
  'Asia/Bishkek': 'KGS',
  'Asia/Dhaka': 'BDT',
  'Asia/Omsk': 'RUB',
  'Asia/Qostanay': 'KZT',
  'Asia/Thimphu': 'BTN',
  'Asia/Urumqi': 'CNY',
  'Indian/Chagos': 'USD',
  'Asia/Yangon': 'MMK',
  'Indian/Cocos': 'AUD',
  'Antarctica/Davis': 'USD',
  'Asia/Bangkok': 'THB',
  'Asia/Barnaul': 'RUB',
  'Asia/Hovd': 'MNT',
  'Asia/Ho_Chi_Minh': 'VND',
  'Asia/Jakarta': 'IDR',
  'Asia/Krasnoyarsk': 'RUB',
  'Asia/Novokuznetsk': 'RUB',
  'Asia/Novosibirsk': 'RUB',
  'Asia/Phnom_Penh': 'KHR',
  'Asia/Pontianak': 'IDR',
  'Asia/Tomsk': 'RUB',
  'Asia/Vientiane': 'LAK',
  'Indian/Christmas': 'AUD',
  'Asia/Brunei': 'BND',
  'Asia/Choibalsan': 'MNT',
  'Asia/Hong_Kong': 'HKD',
  'Asia/Irkutsk': 'RUB',
  'Asia/Kuala_Lumpur': 'MYR',
  'Asia/Kuching': 'MYR',
  'Asia/Macau': 'MOP',
  'Asia/Makassar': 'IDR',
  'Asia/Manila': 'PHP',
  'Asia/Shanghai': 'CNY',
  'Asia/Singapore': 'SGD',
  'Asia/Taipei': 'TWD',
  'Asia/Ulaanbaatar': 'MNT',
  'Australia/Perth': 'AUD',
  'Australia/Eucla': 'AUD',
  'Asia/Chita': 'RUB',
  'Asia/Dili': 'USD',
  'Asia/Jayapura': 'IDR',
  'Asia/Khandyga': 'RUB',
  'Asia/Pyongyang': 'KPW',
  'Asia/Seoul': 'KRW',
  'Asia/Tokyo': 'JPY',
  'Asia/Yakutsk': 'RUB',
  'Pacific/Palau': 'USD',
  'Australia/Adelaide': 'AUD',
  'Australia/Broken_Hill': 'AUD',
  'Australia/Darwin': 'AUD',
  'Antarctica/DumontDUrville': 'USD',
  'Antarctica/Macquarie': 'USD',
  'Asia/Ust-Nera': 'RUB',
  'Asia/Vladivostok': 'RUB',
  'Australia/Brisbane': 'AUD',
  'Australia/Currie': 'AUD',
  'Australia/Hobart': 'AUD',
  'Australia/Lindeman': 'AUD',
  'Australia/Melbourne': 'AUD',
  'Australia/Sydney': 'AUD',
  'Pacific/Chuuk': 'USD',
  'Pacific/GuamVillage': 'USD',
  'Pacific/Port_Moresby': 'PGK',
  'Pacific/Saipan': 'USD',
  'Australia/Lord_Howe': 'AUD',
  'Antarctica/Casey': 'USD',
  'Asia/Magadan': 'RUB',
  'Asia/Sakhalin': 'RUB',
  'Asia/Srednekolymsk': 'RUB',
  'Pacific/Bougainville': 'PGK',
  'Pacific/Efate': 'VUV',
  'Pacific/Guadalcanal': 'SBD',
  'Pacific/Kosrae': 'USD',
  'Pacific/Norfolk': 'USD',
  'Pacific/Noumea': 'XPF',
  'Pacific/Pohnpei': 'USD',
  'Antarctica/McMurdo': 'USD',
  'Asia/Anadyr': 'RUB',
  'Asia/Kamchatka': 'RUB',
  'Pacific/Auckland': 'NZD',
  'Pacific/Fiji': 'FJD',
  'Pacific/Funafuti': 'AUD',
  'Pacific/Kwajalein': 'USD',
  'Pacific/Majuro': 'USD',
  'Pacific/Nauru': 'AUD',
  'Pacific/Tarawa': 'AUD',
  'Pacific/Wake': 'USD',
  'Pacific/Wallis': 'XPF',
  'Pacific/Chatham': 'CAD',
  'Pacific/Apia': 'NGN',
  'Pacific/Enderbury': 'USD',
  'Pacific/Fakaofo': 'NZD',
  'Pacific/Tongatapu': 'TOP',
  'Pacific/Kiritimati': 'AUD',
};

class Currency {
  constructor({ amount, code, timeZone = Currency.timeZone() }) {
    this.amount = amount;
    this.code = code || window._LocalCurrencyCode || Currency.getCode(timeZone);
    this.timeZone = timeZone;
  }

  static getCode(timeZone) {
    return window._LocalCurrencyCode || timezoneToCurrency[timeZone || Currency.timeZone()] || 'USD'
  }

  static async rate({ from, to }) {
    if(to == undefined) { to = Currency.getCode(); }
    let fromToUsd = await Currency.fromUSD({ amount: 1, code: from });
    let toToUsd = await Currency.fromUSD({ amount: 1, code: to });
    if(fromToUsd.code != from || toToUsd.code != to) {
      throw('Failed fetching rate!')
    }
    return fromToUsd.amount / toToUsd.amount
  }

  static async fromUSD({ amount, code, timeZone }) {
    let currency = new Currency({ amount, code, timeZone });
    let rate = await fetch('https://public.depay.com/currencies/' + currency.code)
      .then((response) => response.json())
      .then((data) => parseFloat(data))
      .catch(()=>{
        currency.code = "USD";
        return 1
      });
    currency.amount = currency.amount * rate;
    return currency
  }

  static timeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  toString(options = {}) {
    if(options.minimumFractionDigits == undefined && (this.amount % 1 === 0) && this.amount >= 100) {
      options.minimumFractionDigits = 0;
    } else if(options.minimumFractionDigits == undefined) {
      options.minimumFractionDigits = 2;
    }
    return new Intl.NumberFormat(navigator.language, {...options,
      style: 'currency',
      currency: this.code,
    }).format(this.amount)
  }
}




/***/ }),

/***/ 8417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 45042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 75260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CacheProvider; },
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "i": function() { return /* binding */ isBrowser; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports E, _, a, b, c, h, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8417);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48137);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27278);










var isBrowser = "object" !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = (0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
          key: 'css'
        });
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

var useTheme = function useTheme() {
  return React.useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = React.useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = React.useContext(ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/React.forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React.useContext(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React.createElement(WrappedComponent, newProps));
})));

if (false) {}

var Emotion$1 = (/* unused pure expression or super */ null && (Emotion));




/***/ }),

/***/ 70917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement, jsx */
/* harmony import */ var _emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75260);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70444);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27278);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48137);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8417);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__);












var pkg = {
	name: "@emotion/react",
	version: "11.11.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"import": "./dist/emotion-react.cjs.mjs",
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": {
			types: {
				"import": "./macro.d.mts",
				"default": "./macro.d.ts"
			},
			"default": "./macro.js"
		}
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.*"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.11.0",
		"@emotion/cache": "^11.11.0",
		"@emotion/serialize": "^1.1.2",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
		"@emotion/utils": "^1.2.1",
		"@emotion/weak-memoize": "^0.3.1",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.11.0",
		"@emotion/css-prettifier": "1.1.3",
		"@emotion/server": "11.11.0",
		"@emotion/styled": "11.11.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": {
					types: {
						"import": "./macro.d.mts",
						"default": "./macro.d.ts"
					},
					"default": "./macro.js"
				}
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return React.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return React.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)([styles], undefined, react__WEBPACK_IMPORTED_MODULE_0__.useContext(_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));

  if (!_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.i) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, isBrowser; }




/***/ }),

/***/ 48137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 27278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 70444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 90438:
/***/ (function(module) {

"use strict";



if (true) {
  module.exports = {
    DevTool: () => null,
  };
} else {}


/***/ }),

/***/ 17553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Atom": function() { return /* binding */ Atom; },
/* harmony export */   "addChangeHandler": function() { return /* binding */ addChangeHandler; },
/* harmony export */   "deref": function() { return /* binding */ deref; },
/* harmony export */   "getValidator": function() { return /* binding */ getValidator; },
/* harmony export */   "removeChangeHandler": function() { return /* binding */ removeChangeHandler; },
/* harmony export */   "set": function() { return /* binding */ set; },
/* harmony export */   "setValidator": function() { return /* binding */ setValidator; },
/* harmony export */   "swap": function() { return /* binding */ swap; }
/* harmony export */ });
var nextAtomUid = 0;
var stateByAtomId = Object.create(null);
var validatorByAtomId = Object.create(null);
var changeHandlersByAtomId = {};
/** @ignore */
function _useNextAtomId() {
    return nextAtomUid++;
}
/** @ignore */
function _getState(atom) {
    return stateByAtomId[atom["$$id"]];
}
/** @ignore */
function _setState(atom, state) {
    stateByAtomId[atom["$$id"]] = state;
}
/** @ignore */
function _getValidator(atom) {
    return validatorByAtomId[atom["$$id"]];
}
/** @ignore */
function _setValidator(atom, validator) {
    validatorByAtomId[atom["$$id"]] = validator;
}
/** @ignore */
function _initChangeHandlerDict(atom) {
    changeHandlersByAtomId[atom["$$id"]] = {};
}
/** @ignore */
function _addChangeHandler(atom, key, handler) {
    if (typeof changeHandlersByAtomId[atom["$$id"]][key] === "function") {
        throw new Error("Change handler already registered for key \"" + key + "\" on " + atom + ".\nRemove the existing handler before registering a new one.");
    }
    changeHandlersByAtomId[atom["$$id"]][key] = handler;
}
/** @ignore */
function _removeChangeHandler(atom, key) {
    delete changeHandlersByAtomId[atom["$$id"]][key];
}
/** @ignore */
function _runChangeHandlers(atom, previous, current) {
    Object.keys(changeHandlersByAtomId[atom["$$id"]]).forEach(function (k) {
        if (typeof changeHandlersByAtomId[atom["$$id"]][k] === "function") {
            changeHandlersByAtomId[atom["$$id"]][k]({ previous: previous, current: current });
        }
    });
}

/**
 * Registers a function to be run each time the state of `atom` changes.
 *
 * Will throw an Error if `key` is already taken by another handler.
 *
 * @example
```js

import {Atom, addChangeHandler, swap} from '@libre/atom'

const countAtom = Atom.of({ count: 0 })

addChangeHandler(countAtom, "log", ({current, previous}) => {
  console.log(previous, current)
})

swap(countAtom, (state) => ({ count: state.count + 1 }))


// stdout logs:
// { count: 0 }
// { count: 1 }

```
 */
function addChangeHandler(atom, key, handler) {
    _addChangeHandler(atom, key, handler);
}
/**
 * Deletes the `key` and the handler associated with `key` so that it not longer runs
 * when the state of `atom` changes.
 *
 * @example
```js

import {Atom, addChangeHandler, removeChangeHandler, swap} from '@libre/atom'

const countAtom = Atom.of({ count: 0 })

addChangeHandler(countAtom, "log", ({current, previous}) => {
  console.log(previous, current)
})

swap(countAtom, (state) => ({ count: state.count + 1 }))

// stdout logs:
// { count: 0 }
// { count: 1 }

removeChangeHandler(atom, "log")

swap(countAtom, (state) => ({ count: state.count + 1 }))

// nothing is logged
```
 */
function removeChangeHandler(atom, key) {
    _removeChangeHandler(atom, key);
}

/** @ignore */
function prettyPrint(val) {
    return JSON.stringify(val, null, "  ");
}

/**
 * A data structure useful for providing a controlled, predictable mechanism for mutability.
 * Allows multiple components of a program to share read/write access to some state in such
 * a way that no component can mutate another component's current reference to the state in
 * the middle of some process or asynchronous operation.
 *
 */
var Atom = /** @class */ (function () {
    /** @ignore */
    function Atom(state, _a) {
        var validator = (_a === void 0 ? {} : _a).validator;
        validator = validator || (function () { return true; });
        if (!validator(state)) {
            var errMsg = "Atom initialized with invalid state:\n\n" + prettyPrint(state) + "\n\naccording to validator function:\n" + validator + "\n\n";
            var err = Error(errMsg);
            err.name = "AtomInvalidStateError";
            throw err;
        }
        Object.defineProperty(this, "$$id", { value: _useNextAtomId() });
        _setState(this, state);
        _setValidator(this, validator);
        _initChangeHandlerDict(this);
        return this;
    }
    /**
     * Constructs a new instance of [[Atom]] with its internal state
     * set to `state`.
     *
     * @param S the type of the value being set as an [[Atom]]'s internal state
     * @example
  ```js
  
  import { Atom } from '@libre/atom'
  
  const a1 = Atom.of(0)
  const a2 = Atom.of("zero")
  const a3 = Atom.of({ count: 0 })
  ```
     */
    Atom.of = function (state, options) {
        return new Atom(state, options);
    };
    /** @ignore */
    Atom.prototype.toString = function () {
        return "Atom<" + prettyPrint(_getState(this)) + ">";
    };
    /** @ignore */
    Atom.prototype.inspect = function () {
        return this.toString();
    };
    return Atom;
}());

/** @ignore */
var expectedAtomButGot = "Expected an Atom instances, but got:";

/** @ignore */
function throwIfNotAtom(atom) {
    if (!(atom instanceof Atom)) {
        throw TypeError(expectedAtomButGot + "\n\n" + prettyPrint(atom));
    }
}

/**
 * Dereferences (i.e. "*reads*") the current state of an [[Atom]]. The dereferenced value
 * should ___not___ be mutated.
 *
 * @param <S> the type of `atom`'s inner state
 *
 * @example
```js

import {Atom, deref} from '@libre/atom'

const stateAtom = Atom.of({ count: 0 })

deref(stateAtom) // => { count: 0 }
```
 */
function deref(atom) {
    throwIfNotAtom(atom);
    return _getState(atom);
}

/**
 * Gets `atom`'s validator function
 *
 * @param <S> the type of `atom`'s inner state
 *
 * @example
```js

import {Atom, deref, getValidator, swap} from '@libre/atom'

const atom = Atom.of({ count: 0 }, { validator: (state) => isEven(state.count) })
const validator = getValidator(atom)
validator({ count: 3 }) // => false
validator({ count: 2 }) // => true
```
 */
function getValidator(atom) {
    throwIfNotAtom(atom);
    return _getValidator(atom);
}

/**
 * Sets `atom`s state to `nextState`.
 *
 * It is equivalent to `swap(atom, () => newState)`.
 *
 * @param <S> the type of `atom`'s inner state
 * @param atom an instance of [[Atom]]
 * @param nextState the value to which to set the state; it should be the same type/interface as current state
 *
  * @example
```js

import {Atom, deref, set} from '@libre/atom'

const atom = Atom.of({ count: 0 })

set(atom, { count: 100 })
deref(atom) // => { count: 100 }
```
 */
function set(atom, nextState) {
    throwIfNotAtom(atom);
    var validator = _getValidator(atom);
    var didValidate = validator(nextState);
    if (!didValidate) {
        var errMsg = "Attempted to set the state of\n\n" + atom + "\n\nwith:\n\n" + prettyPrint(nextState) + "\n\nbut it did not pass validator:\n" + validator + "\n\n";
        var err = Error(errMsg);
        err.name = "AtomInvalidStateError";
        throw err;
    }
    else {
        var prevState = deref(atom);
        _setState(atom, nextState);
        _runChangeHandlers(atom, prevState, nextState);
    }
}

/**
 * Sets the `validator` for `atom`. `validator` must be a pure function of one argument,
 * which will be passed the intended new state on any state change. If the new state is
 * unacceptable, `validator` should return false or throw an exception. If the current state
 * is not acceptable to the new validator, an exception will be thrown and the validator will
 * not be changed.
 *
 * @param <S> the type of `atom`'s inner state
 *
 * @example
```js

import {Atom, deref, setValidator, set} from '@libre/atom'
import { _setValidator } from './internal-state';

const atom = Atom.of({ count: 0 }, {validator: (state) => isNumber(state.count) })
setValidator(atom, (state) => isOdd(state.count)) // Error; new validator rejected
set(atom, {count: "not number"}) // Error; new state not set
setValidator(atom, (state) => isEven(state.count)) // All good
set(atom, {count: 2}) // All good

```
 */
function setValidator(atom, validator) {
    throwIfNotAtom(atom);
    if (!validator(_getState(atom))) {
        var errMsg = "Could not set validator on\n\n" + atom + "\n\nbecause current state would be invalid according to new validator:\n" + validator + "\n\n";
        var err = Error(errMsg);
        err.name = "AtomInvalidStateError";
        throw err;
    }
    else {
        _setValidator(atom, validator);
    }
}

/**
 * Swaps `atom`'s state with the value returned from applying `updateFn` to `atom`'s
 * current state. `updateFn` should be a pure function and ___not___ mutate `state`.
 *
 * @param <S> the type of `atom`'s inner state
 * @param atom an instance of [[Atom]]
 * @param updateFn a pure function that takes the current state and returns the next state; the next state should be of the same type/interface as the current state;
 *
 * @example
 * ```jsx
 *
 *import {Atom, swap} from '@libre/atom'
import {prettyPrint} from './prettyPrint'
 *
 *const stateAtom = Atom.of({ count: 0 })
 *const increment = () => swap(stateAtom, (state) => ({
 *  count: state.count + 1
 *}));
 * ```
 */
function swap(atom, updateFn) {
    throwIfNotAtom(atom);
    var prevState = _getState(atom);
    var nextState = updateFn(prevState);
    var validator = _getValidator(atom);
    var didValidate = validator(nextState);
    if (!didValidate) {
        var errMsg = "swap updateFn\n" + updateFn + "\n\nattempted to swap the state of\n\n" + atom + "\n\nwith:\n\n" + prettyPrint(nextState) + "\n\nbut it did not pass validator:\n" + validator + "\n\n";
        var err = Error(errMsg);
        err.name = "AtomInvalidStateError";
        throw err;
    }
    else {
        _setState(atom, nextState);
        _runChangeHandlers(atom, prevState, nextState);
    }
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 23926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33703);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59948);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82690);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';





// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1

function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */
function ClickAwayListener(props) {
  const {
    children,
    disableReactTree = false,
    mouseEvent = 'onClick',
    onClickAway,
    touchEvent = 'onTouchEnd'
  } = props;
  const movedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  const nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const activatedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  const syntheticEventRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(() => {
      activatedRef.current = true;
    }, 0);
    return () => {
      activatedRef.current = false;
    };
  }, []);
  const handleRef = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(
  // @ts-expect-error TODO upstream fix
  children.ref, nodeRef);

  // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.
  const handleClickAway = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);

    // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.
    if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    }

    // Do not act if user performed touchmove
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    let insideDOM;

    // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target) || nodeRef.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target);
    }
    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  });

  // Keep track of mouse/touch events that bubbled up through the portal.
  const createHandleSynthetic = handlerName => event => {
    syntheticEventRef.current = true;
    const childrenPropsHandler = children.props[handlerName];
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const childrenProps = {
    ref: handleRef
  };
  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (touchEvent !== false) {
      const mappedTouchEvent = mapEventPropToEvent(touchEvent);
      const doc = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);
      const handleTouchMove = () => {
        movedRef.current = true;
      };
      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }
    return undefined;
  }, [handleClickAway, touchEvent]);
  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (mouseEvent !== false) {
      const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      const doc = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return () => {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }
    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, childrenProps)
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (ClickAwayListener);

/***/ }),

/***/ 78385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33703);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73546);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7960);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
'use client';






function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}

/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */
const Portal = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Portal(props, forwardedRef) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  // @ts-expect-error TODO upstream fix
  const handleRef = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) ? children.ref : null, forwardedRef);
  (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(() => {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(() => {
    if (mountNode && !disablePortal) {
      (0,_mui_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(forwardedRef, mountNode);
      return () => {
        (0,_mui_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(forwardedRef, null);
      };
    }
    return undefined;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children)) {
      const newProps = {
        ref: handleRef
      };
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, newProps);
    }
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: mountNode ? /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, mountNode) : mountNode
  });
});
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (Portal);

/***/ }),

/***/ 31873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useClassNamesOverride; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const defaultContextValue = {
  disableDefaultClasses: false
};
const ClassNameConfiguratorContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultContextValue);
/**
 * @ignore - internal hook.
 *
 * Wraps the `generateUtilityClass` function and controls how the classes are generated.
 * Currently it only affects whether the classes are applied or not.
 *
 * @returns Function to be called with the `generateUtilityClass` function specific to a component to generate the classes.
 */
function useClassNamesOverride(generateUtilityClass) {
  const {
    disableDefaultClasses
  } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(ClassNameConfiguratorContext);
  return slot => {
    if (disableDefaultClasses) {
      return '';
    }
    return generateUtilityClass(slot);
  };
}

/**
 * Allows to configure the components within to not apply any built-in classes.
 */
function ClassNameConfigurator(props) {
  const {
    disableDefaultClasses,
    children
  } = props;
  const contextValue = React.useMemo(() => ({
    disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
  }), [disableDefaultClasses]);
  return /*#__PURE__*/_jsx(ClassNameConfiguratorContext.Provider, {
    value: contextValue,
    children: children
  });
}

/***/ }),

/***/ 10238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ appendOwnerState; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _isHostComponent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28442);



/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === undefined || (0,_isHostComponent__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(elementType)) {
    return otherProps;
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, otherProps, {
    ownerState: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, otherProps.ownerState, ownerState)
  });
}

/***/ }),

/***/ 28442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isHostComponent; }
/* harmony export */ });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

/***/ }),

/***/ 71276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ resolveComponentProps; }
/* harmony export */ });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}

/***/ }),

/***/ 18793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useSlotProps; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(33703);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/appendOwnerState.js
var appendOwnerState = __webpack_require__(10238);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/extractEventHandlers.js
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */
function extractEventHandlers(object, excludeKeys = []) {
  if (object === undefined) {
    return {};
  }
  const result = {};
  Object.keys(object).filter(prop => prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/omitEventHandlers.js
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */
function omitEventHandlers(object) {
  if (object === undefined) {
    return {};
  }
  const result = {};
  Object.keys(object).filter(prop => !(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/mergeSlotProps.js




/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
    // so we can simply merge all the props without having to worry about extracting event handlers.
    const joinedClasses = (0,clsx_m/* default */.Z)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
    const mergedStyle = (0,esm_extends/* default */.Z)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0,esm_extends/* default */.Z)({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (joinedClasses.length > 0) {
      props.className = joinedClasses;
    }
    if (Object.keys(mergedStyle).length > 0) {
      props.style = mergedStyle;
    }
    return {
      props,
      internalRef: undefined
    };
  }

  // In this case, getSlotProps is responsible for calling the external event handlers.
  // We don't need to include them in the merged props because of this.

  const eventHandlers = extractEventHandlers((0,esm_extends/* default */.Z)({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);

  // The order of classes is important here.
  // Emotion (that we use in libraries consuming Base UI) depends on this order
  // to properly override style. It requires the most important classes to be last
  // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
  const joinedClasses = (0,clsx_m/* default */.Z)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  const mergedStyle = (0,esm_extends/* default */.Z)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  const props = (0,esm_extends/* default */.Z)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/resolveComponentProps.js
var resolveComponentProps = __webpack_require__(71276);
;// CONCATENATED MODULE: ./node_modules/@mui/base/utils/useSlotProps.js
'use client';



const _excluded = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];




/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */
function useSlotProps(parameters) {
  var _parameters$additiona;
  const {
      elementType,
      externalSlotProps,
      ownerState,
      skipResolvingSlotProps = false
    } = parameters,
    rest = (0,objectWithoutPropertiesLoose/* default */.Z)(parameters, _excluded);
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0,resolveComponentProps/* default */.Z)(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps((0,esm_extends/* default */.Z)({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = (0,useForkRef/* default */.Z)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  const props = (0,appendOwnerState/* default */.Z)(elementType, (0,esm_extends/* default */.Z)({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}

/***/ }),

/***/ 40075:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z"
}), 'ArrowForwardRounded');
exports.Z = _default;

/***/ }),

/***/ 97090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6 7c0 .55.45 1 1 1h7.59l-8.88 8.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L16 9.41V17c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1z"
}), 'ArrowOutwardRounded');
exports.Z = _default;

/***/ }),

/***/ 75237:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m18 9-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4zm1-6h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
}), 'AssignmentTurnedInOutlined');
exports.Z = _default;

/***/ }),

/***/ 75652:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6 20c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2s-2 .9-2 2v7c0 1.1.9 2 2 2zm10-5v3c0 1.1.9 2 2 2s2-.9 2-2v-3c0-1.1-.9-2-2-2s-2 .9-2 2zm-4 5c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2s-2 .9-2 2v12c0 1.1.9 2 2 2z"
}), 'BarChartRounded');
exports.Z = _default;

/***/ }),

/***/ 53707:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m19 8-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
}), 'Cached');
exports.Z = _default;

/***/ }),

/***/ 55813:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z"
}), 'CalendarTodayOutlined');
exports.Z = _default;

/***/ }),

/***/ 27036:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
exports.Z = _default;

/***/ }),

/***/ 97529:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z"
}), 'CheckCircleOutlineRounded');
exports.Z = _default;

/***/ }),

/***/ 58442:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29 5.7 12.7a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z"
}), 'CheckCircleRounded');
exports.Z = _default;

/***/ }),

/***/ 50594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
exports.Z = _default;

/***/ }),

/***/ 36191:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
}), 'CloseRounded');
exports.Z = _default;

/***/ }),

/***/ 82553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8.7 15.9 4.8 12l3.9-3.9c.39-.39.39-1.01 0-1.4a.9839.9839 0 0 0-1.4 0l-4.59 4.59c-.39.39-.39 1.02 0 1.41l4.59 4.6c.39.39 1.01.39 1.4 0 .39-.39.39-1.01 0-1.4zm6.6 0 3.9-3.9-3.9-3.9a.9839.9839 0 0 1 0-1.4c.39-.39 1.01-.39 1.4 0l4.59 4.59c.39.39.39 1.02 0 1.41l-4.59 4.6c-.39.39-1.01.39-1.4 0a.9839.9839 0 0 1 0-1.4z"
}), 'CodeRounded');
exports.Z = _default;

/***/ }),

/***/ 6516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67 0 1.38-1.12 2.5-2.5 2.5zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "6.5",
  cy: "11.5",
  r: "1.5"
}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "9.5",
  cy: "7.5",
  r: "1.5"
}, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "14.5",
  cy: "7.5",
  r: "1.5"
}, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "17.5",
  cy: "11.5",
  r: "1.5"
}, "4")], 'ColorLensOutlined');
exports.Z = _default;

/***/ }),

/***/ 57959:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"
}), 'DateRangeOutlined');
exports.Z = _default;

/***/ }),

/***/ 51161:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutlineOutlined');
exports.Z = _default;

/***/ }),

/***/ 90008:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z"
}), 'ErrorOutlineRounded');
exports.Z = _default;

/***/ }),

/***/ 51182:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
}), 'ErrorRounded');
exports.Z = _default;

/***/ }),

/***/ 74151:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm5.56 10.46 5.93-5.93-1.06-1.06-4.87 4.87-2.11-2.11-1.06 1.06z"
}), 'EventAvailableOutlined');
exports.Z = _default;

/***/ }),

/***/ 23241:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.29 8.71 6.7 13.3c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71c-.38-.39-1.02-.39-1.41 0z"
}), 'ExpandLessRounded');
exports.Z = _default;

/***/ }),

/***/ 40876:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.88 9.29 12 13.17 8.12 9.29a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z"
}), 'ExpandMoreRounded');
exports.Z = _default;

/***/ }),

/***/ 27608:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
}), 'HelpOutline');
exports.Z = _default;

/***/ }),

/***/ 2548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'InfoOutlined');
exports.Z = _default;

/***/ }),

/***/ 71496:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8.12 9.29 12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7a.9959.9959 0 0 1 0-1.41c.39-.38 1.03-.39 1.42 0z"
}), 'KeyboardArrowDownRounded');
exports.Z = _default;

/***/ }),

/***/ 38736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 7h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3 1.35 3 3s-1.35 3-3 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-9 5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1zm2 3H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h3c.55 0 1-.45 1-1s-.45-1-1-1H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h3c.55 0 1-.45 1-1s-.45-1-1-1z"
}), 'LinkRounded');
exports.Z = _default;

/***/ }),

/***/ 13328:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m23 12-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
}), 'NewReleases');
exports.Z = _default;

/***/ }),

/***/ 11145:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
}), 'Phone');
exports.Z = _default;

/***/ }),

/***/ 57875:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7 7h10v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V5H6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V7zm10 10H7v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.31.31.85.09.85-.36V19h11c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v3z"
}), 'RepeatRounded');
exports.Z = _default;

/***/ }),

/***/ 51325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z"
}), 'TodayOutlined');
exports.Z = _default;

/***/ }),

/***/ 64938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _utils.createSvgIcon;
  }
}));
var _utils = __webpack_require__(58372);

/***/ }),

/***/ 46901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Alert_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Alert/alertClasses.js


function getAlertUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiAlert', slot);
}
const alertClasses = (0,generateUtilityClasses/* default */.Z)('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
/* harmony default export */ var Alert_alertClasses = (alertClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/SuccessOutlined.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var SuccessOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ReportProblemOutlined.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var ReportProblemOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ErrorOutline.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var ErrorOutline = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/InfoOutlined.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var InfoOutlined = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined'));
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/svg-icons/Close.js
var Close = __webpack_require__(34484);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Alert/Alert.js
'use client';



const _excluded = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"];


















const useUtilityClasses = ownerState => {
  const {
    variant,
    color,
    severity,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${variant}${(0,capitalize/* default */.Z)(color || severity)}`, `${variant}`],
    icon: ['icon'],
    message: ['message'],
    action: ['action']
  };
  return (0,composeClasses/* default */.Z)(slots, getAlertUtilityClass, classes);
};
const AlertRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiAlert',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0,capitalize/* default */.Z)(ownerState.color || ownerState.severity)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const getColor = theme.palette.mode === 'light' ? colorManipulator/* darken */._j : colorManipulator/* lighten */.$n;
  const getBackgroundColor = theme.palette.mode === 'light' ? colorManipulator/* lighten */.$n : colorManipulator/* darken */._j;
  const color = ownerState.color || ownerState.severity;
  return (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
    backgroundColor: 'transparent',
    display: 'flex',
    padding: '6px 16px'
  }, color && ownerState.variant === 'standard' && {
    color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
    backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
    [`& .${Alert_alertClasses.icon}`]: theme.vars ? {
      color: theme.vars.palette.Alert[`${color}IconColor`]
    } : {
      color: theme.palette[color].main
    }
  }, color && ownerState.variant === 'outlined' && {
    color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
    border: `1px solid ${(theme.vars || theme).palette[color].light}`,
    [`& .${Alert_alertClasses.icon}`]: theme.vars ? {
      color: theme.vars.palette.Alert[`${color}IconColor`]
    } : {
      color: theme.palette[color].main
    }
  }, color && ownerState.variant === 'filled' && (0,esm_extends/* default */.Z)({
    fontWeight: theme.typography.fontWeightMedium
  }, theme.vars ? {
    color: theme.vars.palette.Alert[`${color}FilledColor`],
    backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
  } : {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
    color: theme.palette.getContrastText(theme.palette[color].main)
  }));
});
const AlertIcon = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})({
  marginRight: 12,
  padding: '7px 0',
  display: 'flex',
  fontSize: 22,
  opacity: 0.9
});
const AlertMessage = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0',
  minWidth: 0,
  overflow: 'auto'
});
const AlertAction = (0,styled/* default */.ZP)('div', {
  name: 'MuiAlert',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '4px 0 0 16px',
  marginLeft: 'auto',
  marginRight: -8
});
const defaultIconMapping = {
  success: /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessOutlined, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/(0,jsx_runtime.jsx)(ReportProblemOutlined, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorOutline, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoOutlined, {
    fontSize: "inherit"
  })
};
const Alert = /*#__PURE__*/react.forwardRef(function Alert(inProps, ref) {
  var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAlert'
  });
  const {
      action,
      children,
      className,
      closeText = 'Close',
      color,
      components = {},
      componentsProps = {},
      icon,
      iconMapping = defaultIconMapping,
      onClose,
      role = 'alert',
      severity = 'success',
      slotProps = {},
      slots = {},
      variant = 'standard'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    severity,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : IconButton/* default */.Z;
  const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : Close/* default */.Z;
  const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
  const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AlertRoot, (0,esm_extends/* default */.Z)({
    role: role,
    elevation: 0,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: [icon !== false ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertIcon, {
      ownerState: ownerState,
      className: classes.icon,
      children: icon || iconMapping[severity] || defaultIconMapping[severity]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(AlertMessage, {
      ownerState: ownerState,
      className: classes.message,
      children: children
    }), action != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: action
    }) : null, action == null && onClose ? /*#__PURE__*/(0,jsx_runtime.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AlertCloseButton, (0,esm_extends/* default */.Z)({
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
      }, closeButtonProps, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AlertCloseIcon, (0,esm_extends/* default */.Z)({
          fontSize: "small"
        }, closeIconProps))
      }))
    }) : null]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Alert_Alert = (Alert);

/***/ }),

/***/ 92401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertTitle_AlertTitle; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/AlertTitle/alertTitleClasses.js


function getAlertTitleUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiAlertTitle', slot);
}
const alertTitleClasses = (0,generateUtilityClasses/* default */.Z)('MuiAlertTitle', ['root']);
/* harmony default export */ var AlertTitle_alertTitleClasses = ((/* unused pure expression or super */ null && (alertTitleClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/AlertTitle/AlertTitle.js
'use client';



const _excluded = ["className"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getAlertTitleUtilityClass, classes);
};
const AlertTitleRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiAlertTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  return {
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: -2
  };
});
const AlertTitle = /*#__PURE__*/react.forwardRef(function AlertTitle(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAlertTitle'
  });
  const {
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AlertTitleRoot, (0,esm_extends/* default */.Z)({
    gutterBottom: true,
    component: "div",
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var AlertTitle_AlertTitle = (AlertTitle);

/***/ }),

/***/ 84808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Backdrop_Backdrop; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Backdrop/backdropClasses.js


function getBackdropUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiBackdrop', slot);
}
const backdropClasses = (0,generateUtilityClasses/* default */.Z)('MuiBackdrop', ['root', 'invisible']);
/* harmony default export */ var Backdrop_backdropClasses = ((/* unused pure expression or super */ null && (backdropClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js
'use client';



const _excluded = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ['root', invisible && 'invisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getBackdropUtilityClass, classes);
};
const BackdropRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent'
}, ownerState.invisible && {
  backgroundColor: 'transparent'
}));
const Backdrop = /*#__PURE__*/react.forwardRef(function Backdrop(inProps, ref) {
  var _slotProps$root, _ref, _slots$root;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBackdrop'
  });
  const {
      children,
      className,
      component = 'div',
      components = {},
      componentsProps = {},
      invisible = false,
      open,
      slotProps = {},
      slots = {},
      TransitionComponent = Fade/* default */.Z,
      transitionDuration
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    invisible
  });
  const classes = useUtilityClasses(ownerState);
  const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropRoot, (0,esm_extends/* default */.Z)({
      "aria-hidden": true
    }, rootSlotProps, {
      as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
      className: (0,clsx_m/* default */.Z)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
      ownerState: (0,esm_extends/* default */.Z)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
      classes: classes,
      ref: ref,
      children: children
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Backdrop_Backdrop = (Backdrop);

/***/ }),

/***/ 90263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Badge_Badge; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/usePreviousProps.js
var usePreviousProps = __webpack_require__(2097);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
;// CONCATENATED MODULE: ./node_modules/@mui/base/useBadge/useBadge.js
'use client';


/**
 *
 * Demos:
 *
 * - [Badge](https://mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */
function useBadge(parameters) {
  const {
    badgeContent: badgeContentProp,
    invisible: invisibleProp = false,
    max: maxProp = 99,
    showZero = false
  } = parameters;
  const prevProps = (0,usePreviousProps/* default */.Z)({
    badgeContent: badgeContentProp,
    max: maxProp
  });
  let invisible = invisibleProp;
  if (invisibleProp === false && badgeContentProp === 0 && !showZero) {
    invisible = true;
  }
  const {
    badgeContent,
    max = maxProp
  } = invisible ? prevProps : parameters;
  const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
  return {
    badgeContent,
    invisible,
    max,
    displayValue
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 3 modules
var useSlotProps = __webpack_require__(18793);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Badge/badgeClasses.js


function getBadgeUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiBadge', slot);
}
const badgeClasses = (0,generateUtilityClasses/* default */.Z)('MuiBadge', ['root', 'badge', 'dot', 'standard', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft', 'invisible', 'colorError', 'colorInfo', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorWarning', 'overlapRectangular', 'overlapCircular',
// TODO: v6 remove the overlap value from these class keys
'anchorOriginTopLeftCircular', 'anchorOriginTopLeftRectangular', 'anchorOriginTopRightCircular', 'anchorOriginTopRightRectangular', 'anchorOriginBottomLeftCircular', 'anchorOriginBottomLeftRectangular', 'anchorOriginBottomRightCircular', 'anchorOriginBottomRightRectangular']);
/* harmony default export */ var Badge_badgeClasses = (badgeClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Badge/Badge.js
'use client';



const _excluded = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"];













const RADIUS_STANDARD = 10;
const RADIUS_DOT = 4;
const useUtilityClasses = ownerState => {
  const {
    color,
    anchorOrigin,
    invisible,
    overlap,
    variant,
    classes = {}
  } = ownerState;
  const slots = {
    root: ['root'],
    badge: ['badge', variant, invisible && 'invisible', `anchorOrigin${(0,capitalize/* default */.Z)(anchorOrigin.vertical)}${(0,capitalize/* default */.Z)(anchorOrigin.horizontal)}`, `anchorOrigin${(0,capitalize/* default */.Z)(anchorOrigin.vertical)}${(0,capitalize/* default */.Z)(anchorOrigin.horizontal)}${(0,capitalize/* default */.Z)(overlap)}`, `overlap${(0,capitalize/* default */.Z)(overlap)}`, color !== 'default' && `color${(0,capitalize/* default */.Z)(color)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getBadgeUtilityClass, classes);
};
const BadgeRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiBadge',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  position: 'relative',
  display: 'inline-flex',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  flexShrink: 0
});
const BadgeBadge = (0,styled/* default */.ZP)('span', {
  name: 'MuiBadge',
  slot: 'Badge',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.badge, styles[ownerState.variant], styles[`anchorOrigin${(0,capitalize/* default */.Z)(ownerState.anchorOrigin.vertical)}${(0,capitalize/* default */.Z)(ownerState.anchorOrigin.horizontal)}${(0,capitalize/* default */.Z)(ownerState.overlap)}`], ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], ownerState.invisible && styles.invisible];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  boxSizing: 'border-box',
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(12),
  minWidth: RADIUS_STANDARD * 2,
  lineHeight: 1,
  padding: '0 6px',
  height: RADIUS_STANDARD * 2,
  borderRadius: RADIUS_STANDARD,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.enteringScreen
  })
}, ownerState.color !== 'default' && {
  backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
  color: (theme.vars || theme).palette[ownerState.color].contrastText
}, ownerState.variant === 'dot' && {
  borderRadius: RADIUS_DOT,
  height: RADIUS_DOT * 2,
  minWidth: RADIUS_DOT * 2,
  padding: 0
}, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular' && {
  top: 0,
  right: 0,
  transform: 'scale(1) translate(50%, -50%)',
  transformOrigin: '100% 0%',
  [`&.${Badge_badgeClasses.invisible}`]: {
    transform: 'scale(0) translate(50%, -50%)'
  }
}, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular' && {
  bottom: 0,
  right: 0,
  transform: 'scale(1) translate(50%, 50%)',
  transformOrigin: '100% 100%',
  [`&.${Badge_badgeClasses.invisible}`]: {
    transform: 'scale(0) translate(50%, 50%)'
  }
}, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular' && {
  top: 0,
  left: 0,
  transform: 'scale(1) translate(-50%, -50%)',
  transformOrigin: '0% 0%',
  [`&.${Badge_badgeClasses.invisible}`]: {
    transform: 'scale(0) translate(-50%, -50%)'
  }
}, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular' && {
  bottom: 0,
  left: 0,
  transform: 'scale(1) translate(-50%, 50%)',
  transformOrigin: '0% 100%',
  [`&.${Badge_badgeClasses.invisible}`]: {
    transform: 'scale(0) translate(-50%, 50%)'
  }
}, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular' && {
  top: '14%',
  right: '14%',
  transform: 'scale(1) translate(50%, -50%)',
  transformOrigin: '100% 0%',
  [`&.${Badge_badgeClasses.invisible}`]: {
    transform: 'scale(0) translate(50%, -50%)'
  }
}, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular' && {
  bottom: '14%',
  right: '14%',
  transform: 'scale(1) translate(50%, 50%)',
  transformOrigin: '100% 100%',
  [`&.${Badge_badgeClasses.invisible}`]: {
    transform: 'scale(0) translate(50%, 50%)'
  }
}, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular' && {
  top: '14%',
  left: '14%',
  transform: 'scale(1) translate(-50%, -50%)',
  transformOrigin: '0% 0%',
  [`&.${Badge_badgeClasses.invisible}`]: {
    transform: 'scale(0) translate(-50%, -50%)'
  }
}, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular' && {
  bottom: '14%',
  left: '14%',
  transform: 'scale(1) translate(-50%, 50%)',
  transformOrigin: '0% 100%',
  [`&.${Badge_badgeClasses.invisible}`]: {
    transform: 'scale(0) translate(-50%, 50%)'
  }
}, ownerState.invisible && {
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.leavingScreen
  })
}));
const Badge = /*#__PURE__*/react.forwardRef(function Badge(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBadge'
  });
  const {
      anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
      },
      className,
      component,
      components = {},
      componentsProps = {},
      children,
      overlap: overlapProp = 'rectangular',
      color: colorProp = 'default',
      invisible: invisibleProp = false,
      max: maxProp = 99,
      badgeContent: badgeContentProp,
      slots,
      slotProps,
      showZero = false,
      variant: variantProp = 'standard'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    badgeContent,
    invisible: invisibleFromHook,
    max,
    displayValue: displayValueFromHook
  } = useBadge({
    max: maxProp,
    invisible: invisibleProp,
    badgeContent: badgeContentProp,
    showZero
  });
  const prevProps = (0,usePreviousProps/* default */.Z)({
    anchorOrigin: anchorOriginProp,
    color: colorProp,
    overlap: overlapProp,
    variant: variantProp,
    badgeContent: badgeContentProp
  });
  const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
  const {
    color = colorProp,
    overlap = overlapProp,
    anchorOrigin = anchorOriginProp,
    variant = variantProp
  } = invisible ? prevProps : props;
  const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    badgeContent,
    invisible,
    max,
    displayValue,
    showZero,
    anchorOrigin,
    color,
    overlap,
    variant
  });
  const classes = useUtilityClasses(ownerState);

  // support both `slots` and `components` for backward compatibility
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : BadgeRoot;
  const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : BadgeBadge;
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: RootSlot,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    additionalProps: {
      ref,
      as: component
    },
    ownerState,
    className: (0,clsx_m/* default */.Z)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
  });
  const badgeProps = (0,useSlotProps/* default */.Z)({
    elementType: BadgeSlot,
    externalSlotProps: badgeSlotProps,
    ownerState,
    className: (0,clsx_m/* default */.Z)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RootSlot, (0,esm_extends/* default */.Z)({}, rootProps, {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(BadgeSlot, (0,esm_extends/* default */.Z)({}, badgeProps, {
      children: displayValue
    }))]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Badge_Badge = (Badge);

/***/ }),

/***/ 87357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 3 modules
var styled_engine = __webpack_require__(49731);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(96682);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createBox.js
'use client';



const _excluded = ["className", "component"];






function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = (0,styled_engine/* default */.ZP)('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(styleFunctionSx/* default */.Z);
  const Box = /*#__PURE__*/react.forwardRef(function Box(inProps, ref) {
    const theme = (0,useTheme/* default */.Z)(defaultTheme);
    const _extendSxProp = (0,extendSxProp/* default */.Z)(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(_extendSxProp, _excluded);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ref: ref,
      className: (0,clsx_m/* default */.Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(37078);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/identifier.js
var identifier = __webpack_require__(10606);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/Box.js
'use client';






const defaultTheme = (0,createTheme/* default */.Z)();
const Box = createBox({
  themeId: identifier/* default */.Z,
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 11057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/resolveProps.js
var resolveProps = __webpack_require__(47925);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Button/buttonClasses.js


function getButtonUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiButton', slot);
}
const buttonClasses = (0,generateUtilityClasses/* default */.Z)('MuiButton', ['root', 'text', 'textInherit', 'textPrimary', 'textSecondary', 'textSuccess', 'textError', 'textInfo', 'textWarning', 'outlined', 'outlinedInherit', 'outlinedPrimary', 'outlinedSecondary', 'outlinedSuccess', 'outlinedError', 'outlinedInfo', 'outlinedWarning', 'contained', 'containedInherit', 'containedPrimary', 'containedSecondary', 'containedSuccess', 'containedError', 'containedInfo', 'containedWarning', 'disableElevation', 'focusVisible', 'disabled', 'colorInherit', 'textSizeSmall', 'textSizeMedium', 'textSizeLarge', 'outlinedSizeSmall', 'outlinedSizeMedium', 'outlinedSizeLarge', 'containedSizeSmall', 'containedSizeMedium', 'containedSizeLarge', 'sizeMedium', 'sizeSmall', 'sizeLarge', 'fullWidth', 'startIcon', 'endIcon', 'iconSizeSmall', 'iconSizeMedium', 'iconSizeLarge']);
/* harmony default export */ var Button_buttonClasses = (buttonClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonGroup/ButtonGroupContext.js
var ButtonGroupContext = __webpack_require__(98363);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Button/Button.js
'use client';



const _excluded = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"];














const useUtilityClasses = ownerState => {
  const {
    color,
    disableElevation,
    fullWidth,
    size,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, `${variant}${(0,capitalize/* default */.Z)(color)}`, `size${(0,capitalize/* default */.Z)(size)}`, `${variant}Size${(0,capitalize/* default */.Z)(size)}`, color === 'inherit' && 'colorInherit', disableElevation && 'disableElevation', fullWidth && 'fullWidth'],
    label: ['label'],
    startIcon: ['startIcon', `iconSize${(0,capitalize/* default */.Z)(size)}`],
    endIcon: ['endIcon', `iconSize${(0,capitalize/* default */.Z)(size)}`]
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getButtonUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const commonIconStyles = ownerState => (0,esm_extends/* default */.Z)({}, ownerState.size === 'small' && {
  '& > *:nth-of-type(1)': {
    fontSize: 18
  }
}, ownerState.size === 'medium' && {
  '& > *:nth-of-type(1)': {
    fontSize: 20
  }
}, ownerState.size === 'large' && {
  '& > *:nth-of-type(1)': {
    fontSize: 22
  }
});
const ButtonRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0,capitalize/* default */.Z)(ownerState.color)}`], styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`], styles[`${ownerState.variant}Size${(0,capitalize/* default */.Z)(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$palette$getCon, _theme$palette;
  const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
  const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
  return (0,esm_extends/* default */.Z)({}, theme.typography.button, {
    minWidth: 64,
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
      duration: theme.transitions.duration.short
    }),
    '&:hover': (0,esm_extends/* default */.Z)({
      textDecoration: 'none',
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
      border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'contained' && {
      backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
      boxShadow: (theme.vars || theme).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: (theme.vars || theme).shadows[2],
        backgroundColor: (theme.vars || theme).palette.grey[300]
      }
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
      }
    }),
    '&:active': (0,esm_extends/* default */.Z)({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[8]
    }),
    [`&.${Button_buttonClasses.focusVisible}`]: (0,esm_extends/* default */.Z)({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[6]
    }),
    [`&.${Button_buttonClasses.disabled}`]: (0,esm_extends/* default */.Z)({
      color: (theme.vars || theme).palette.action.disabled
    }, ownerState.variant === 'outlined' && {
      border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
    }, ownerState.variant === 'contained' && {
      color: (theme.vars || theme).palette.action.disabled,
      boxShadow: (theme.vars || theme).shadows[0],
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    })
  }, ownerState.variant === 'text' && {
    padding: '6px 8px'
  }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.variant === 'outlined' && {
    padding: '5px 15px',
    border: '1px solid currentColor'
  }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main,
    border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, 0.5)}`
  }, ownerState.variant === 'contained' && {
    color: theme.vars ?
    // this is safe because grey does not change between default light/dark mode
    theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
    backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
    boxShadow: (theme.vars || theme).shadows[2]
  }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].contrastText,
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.color === 'inherit' && {
    color: 'inherit',
    borderColor: 'currentColor'
  }, ownerState.size === 'small' && ownerState.variant === 'text' && {
    padding: '4px 5px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'text' && {
    padding: '8px 11px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
    padding: '3px 9px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
    padding: '7px 21px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
    padding: '4px 10px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
    padding: '8px 22px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.fullWidth && {
    width: '100%'
  });
}, ({
  ownerState
}) => ownerState.disableElevation && {
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none'
  },
  [`&.${Button_buttonClasses.focusVisible}`]: {
    boxShadow: 'none'
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${Button_buttonClasses.disabled}`]: {
    boxShadow: 'none'
  }
});
const ButtonStartIcon = (0,styled/* default */.ZP)('span', {
  name: 'MuiButton',
  slot: 'StartIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.startIcon, styles[`iconSize${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'inherit',
  marginRight: 8,
  marginLeft: -4
}, ownerState.size === 'small' && {
  marginLeft: -2
}, commonIconStyles(ownerState)));
const ButtonEndIcon = (0,styled/* default */.ZP)('span', {
  name: 'MuiButton',
  slot: 'EndIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.endIcon, styles[`iconSize${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'inherit',
  marginRight: -4,
  marginLeft: 8
}, ownerState.size === 'small' && {
  marginRight: -2
}, commonIconStyles(ownerState)));
const Button = /*#__PURE__*/react.forwardRef(function Button(inProps, ref) {
  // props priority: `inProps` > `contextProps` > `themeDefaultProps`
  const contextProps = react.useContext(ButtonGroupContext/* default */.Z);
  const resolvedProps = (0,resolveProps/* default */.Z)(contextProps, inProps);
  const props = (0,useThemeProps/* default */.Z)({
    props: resolvedProps,
    name: 'MuiButton'
  });
  const {
      children,
      color = 'primary',
      component = 'button',
      className,
      disabled = false,
      disableElevation = false,
      disableFocusRipple = false,
      endIcon: endIconProp,
      focusVisibleClassName,
      fullWidth = false,
      size = 'medium',
      startIcon: startIconProp,
      type,
      variant = 'text'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    fullWidth,
    size,
    type,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const startIcon = startIconProp && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState: ownerState,
    children: startIconProp
  });
  const endIcon = endIconProp && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState: ownerState,
    children: endIconProp
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonRoot, (0,esm_extends/* default */.Z)({
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(contextProps.className, classes.root, className),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0,clsx_m/* default */.Z)(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other, {
    classes: classes,
    children: [startIcon, children, endIcon]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Button_Button = (Button);

/***/ }),

/***/ 49990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ButtonBase_ButtonBase; }
});

// UNUSED EXPORTS: ButtonBaseRoot

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEventCallback.js
var useEventCallback = __webpack_require__(2068);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(79674);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ButtonBase/Ripple.js
'use client';





/**
 * @ignore - internal component.
 */

function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout
  } = props;
  const [leaving, setLeaving] = react.useState(false);
  const rippleClassName = (0,clsx_m/* default */.Z)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = (0,clsx_m/* default */.Z)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  if (!inProp && !leaving) {
    setLeaving(true);
  }
  react.useEffect(() => {
    if (!inProp && onExited != null) {
      // react-transition-group#onExited
      const timeoutId = setTimeout(onExited, timeout);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return undefined;
  }, [onExited, inProp, timeout]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: childClassName
    })
  });
}
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_Ripple = (Ripple);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ButtonBase/touchRippleClasses.js


function getTouchRippleUtilityClass(slot) {
  return generateUtilityClass('MuiTouchRipple', slot);
}
const touchRippleClasses = (0,generateUtilityClasses/* default */.Z)('MuiTouchRipple', ['root', 'ripple', 'rippleVisible', 'ripplePulsate', 'child', 'childLeaving', 'childPulsate']);
/* harmony default export */ var ButtonBase_touchRippleClasses = (touchRippleClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ButtonBase/TouchRipple.js
'use client';



const _excluded = ["center", "classes", "className"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;










const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiTouchRipple',
  slot: 'Root'
})({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit'
});

// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const TouchRippleRipple = (0,styled/* default */.ZP)(ButtonBase_Ripple, {
  name: 'MuiTouchRipple',
  slot: 'Ripple'
})(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), ButtonBase_touchRippleClasses.rippleVisible, enterKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, ButtonBase_touchRippleClasses.ripplePulsate, ({
  theme
}) => theme.transitions.duration.shorter, ButtonBase_touchRippleClasses.child, ButtonBase_touchRippleClasses.childLeaving, exitKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, ButtonBase_touchRippleClasses.childPulsate, pulsateKeyframe, ({
  theme
}) => theme.transitions.easing.easeInOut);

/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */
const TouchRipple = /*#__PURE__*/react.forwardRef(function TouchRipple(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTouchRipple'
  });
  const {
      center: centerProp = false,
      classes = {},
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const [ripples, setRipples] = react.useState([]);
  const nextKey = react.useRef(0);
  const rippleCallback = react.useRef(null);
  react.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);

  // Used to filter out mouse emulated events on mobile.
  const ignoringMouseDown = react.useRef(false);
  // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.
  const startTimer = react.useRef(0);

  // This is the hook called once the previous timeout is ready.
  const startTimerCommit = react.useRef(null);
  const container = react.useRef(null);
  react.useEffect(() => {
    return () => {
      if (startTimer.current) {
        clearTimeout(startTimer.current);
      }
    };
  }, []);
  const startCommit = react.useCallback(params => {
    const {
      pulsate,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples(oldRipples => [...oldRipples, /*#__PURE__*/(0,jsx_runtime.jsx)(TouchRippleRipple, {
      classes: {
        ripple: (0,clsx_m/* default */.Z)(classes.ripple, ButtonBase_touchRippleClasses.ripple),
        rippleVisible: (0,clsx_m/* default */.Z)(classes.rippleVisible, ButtonBase_touchRippleClasses.rippleVisible),
        ripplePulsate: (0,clsx_m/* default */.Z)(classes.ripplePulsate, ButtonBase_touchRippleClasses.ripplePulsate),
        child: (0,clsx_m/* default */.Z)(classes.child, ButtonBase_touchRippleClasses.child),
        childLeaving: (0,clsx_m/* default */.Z)(classes.childLeaving, ButtonBase_touchRippleClasses.childLeaving),
        childPulsate: (0,clsx_m/* default */.Z)(classes.childPulsate, ButtonBase_touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate,
      rippleX: rippleX,
      rippleY: rippleY,
      rippleSize: rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start = react.useCallback((event = {}, options = {}, cb = () => {}) => {
    const {
      pulsate = false,
      center = centerProp || options.pulsate,
      fakeElement = false // For test purposes
    } = options;
    if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if ((event == null ? void 0 : event.type) === 'touchstart') {
      ignoringMouseDown.current = true;
    }
    const element = fakeElement ? null : container.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };

    // Get the size of the ripple
    let rippleX;
    let rippleY;
    let rippleSize;
    if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);

      // For some reason the animation is broken on Mobile Chrome if the size is even.
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }

    // Touche devices
    if (event != null && event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = () => {
          startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        };
        // Delay the execution of the ripple effect.
        startTimer.current = setTimeout(() => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit]);
  const pulsate = react.useCallback(() => {
    start({}, {
      pulsate: true
    });
  }, [start]);
  const stop = react.useCallback((event, cb) => {
    clearTimeout(startTimer.current);

    // The touch interaction occurs too quickly.
    // We still want to show ripple effect.
    if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(() => {
        stop(event, cb);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples(oldRipples => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  react.useImperativeHandle(ref, () => ({
    pulsate,
    start,
    stop
  }), [pulsate, start, stop]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TouchRippleRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(ButtonBase_touchRippleClasses.root, classes.root, className),
    ref: container
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionGroup/* default */.Z, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_TouchRipple = (TouchRipple);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass_generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ButtonBase/buttonBaseClasses.js


function getButtonBaseUtilityClass(slot) {
  return (0,generateUtilityClass_generateUtilityClass/* default */.Z)('MuiButtonBase', slot);
}
const buttonBaseClasses = (0,generateUtilityClasses/* default */.Z)('MuiButtonBase', ['root', 'disabled', 'focusVisible']);
/* harmony default export */ var ButtonBase_buttonBaseClasses = (buttonBaseClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js
'use client';



const ButtonBase_excluded = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"];














const useUtilityClasses = ownerState => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', focusVisible && 'focusVisible']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getButtonBaseUtilityClass, classes);
  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }
  return composedClasses;
};
const ButtonBaseRoot = (0,styled/* default */.ZP)('button', {
  name: 'MuiButtonBase',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  WebkitTapHighlightColor: 'transparent',
  backgroundColor: 'transparent',
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: 'pointer',
  userSelect: 'none',
  verticalAlign: 'middle',
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  textDecoration: 'none',
  // So we take precedent over the style of a native <a /> element.
  color: 'inherit',
  '&::-moz-focus-inner': {
    borderStyle: 'none' // Remove Firefox dotted outline.
  },

  [`&.${ButtonBase_buttonBaseClasses.disabled}`]: {
    pointerEvents: 'none',
    // Disable link interactions
    cursor: 'default'
  },
  '@media print': {
    colorAdjust: 'exact'
  }
});

/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */
const ButtonBase = /*#__PURE__*/react.forwardRef(function ButtonBase(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiButtonBase'
  });
  const {
      action,
      centerRipple = false,
      children,
      className,
      component = 'button',
      disabled = false,
      disableRipple = false,
      disableTouchRipple = false,
      focusRipple = false,
      LinkComponent = 'a',
      onBlur,
      onClick,
      onContextMenu,
      onDragLeave,
      onFocus,
      onFocusVisible,
      onKeyDown,
      onKeyUp,
      onMouseDown,
      onMouseLeave,
      onMouseUp,
      onTouchEnd,
      onTouchMove,
      onTouchStart,
      tabIndex = 0,
      TouchRippleProps,
      touchRippleRef,
      type
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ButtonBase_excluded);
  const buttonRef = react.useRef(null);
  const rippleRef = react.useRef(null);
  const handleRippleRef = (0,useForkRef/* default */.Z)(rippleRef, touchRippleRef);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  const [focusVisible, setFocusVisible] = react.useState(false);
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  react.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const [mountedState, setMountedState] = react.useState(false);
  react.useEffect(() => {
    setMountedState(true);
  }, []);
  const enableTouchRipple = mountedState && !disableRipple && !disabled;
  react.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple && mountedState) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, mountedState]);
  function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
    return (0,useEventCallback/* default */.Z)(event => {
      if (eventCallback) {
        eventCallback(event);
      }
      const ignore = skipRippleAction;
      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }
      return true;
    });
  }
  const handleMouseDown = useRippleHandler('start', onMouseDown);
  const handleContextMenu = useRippleHandler('stop', onContextMenu);
  const handleDragLeave = useRippleHandler('stop', onDragLeave);
  const handleMouseUp = useRippleHandler('stop', onMouseUp);
  const handleMouseLeave = useRippleHandler('stop', event => {
    if (focusVisible) {
      event.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  const handleTouchStart = useRippleHandler('start', onTouchStart);
  const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  const handleTouchMove = useRippleHandler('stop', onTouchMove);
  const handleBlur = useRippleHandler('stop', event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  }, false);
  const handleFocus = (0,useEventCallback/* default */.Z)(event => {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }
    if (onFocus) {
      onFocus(event);
    }
  });
  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };

  /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */
  const keydownRef = react.useRef(false);
  const handleKeyDown = (0,useEventCallback/* default */.Z)(event => {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      rippleRef.current.stop(event, () => {
        rippleRef.current.start(event);
      });
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }

    // Keyboard accessibility for non interactive elements
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();
      if (onClick) {
        onClick(event);
      }
    }
  });
  const handleKeyUp = (0,useEventCallback/* default */.Z)(event => {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, () => {
        rippleRef.current.pulsate(event);
      });
    }
    if (onKeyUp) {
      onKeyUp(event);
    }

    // Keyboard accessibility for non interactive elements
    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  let ComponentProp = component;
  if (ComponentProp === 'button' && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }
  const buttonProps = {};
  if (ComponentProp === 'button') {
    buttonProps.type = type === undefined ? 'button' : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = 'button';
    }
    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
    }
  }
  const handleRef = (0,useForkRef/* default */.Z)(ref, focusVisibleRef, buttonRef);
  if (false) {}
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonBaseRoot, (0,esm_extends/* default */.Z)({
    as: ComponentProp,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    onBlur: handleBlur,
    onClick: onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type: type
  }, buttonProps, other, {
    children: [children, enableTouchRipple ?
    /*#__PURE__*/
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    (0,jsx_runtime.jsx)(ButtonBase_TouchRipple, (0,esm_extends/* default */.Z)({
      ref: handleRippleRef,
      center: centerRipple
    }, TouchRippleProps)) : null]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_ButtonBase = (ButtonBase);

/***/ }),

/***/ 56863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ButtonGroup_ButtonGroup; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ButtonGroup/buttonGroupClasses.js


function getButtonGroupUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiButtonGroup', slot);
}
const buttonGroupClasses = (0,generateUtilityClasses/* default */.Z)('MuiButtonGroup', ['root', 'contained', 'outlined', 'text', 'disableElevation', 'disabled', 'fullWidth', 'vertical', 'grouped', 'groupedHorizontal', 'groupedVertical', 'groupedText', 'groupedTextHorizontal', 'groupedTextVertical', 'groupedTextPrimary', 'groupedTextSecondary', 'groupedOutlined', 'groupedOutlinedHorizontal', 'groupedOutlinedVertical', 'groupedOutlinedPrimary', 'groupedOutlinedSecondary', 'groupedContained', 'groupedContainedHorizontal', 'groupedContainedVertical', 'groupedContainedPrimary', 'groupedContainedSecondary']);
/* harmony default export */ var ButtonGroup_buttonGroupClasses = (buttonGroupClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonGroup/ButtonGroupContext.js
var ButtonGroupContext = __webpack_require__(98363);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ButtonGroup/ButtonGroup.js
'use client';



const _excluded = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"];











const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [{
    [`& .${ButtonGroup_buttonGroupClasses.grouped}`]: styles.grouped
  }, {
    [`& .${ButtonGroup_buttonGroupClasses.grouped}`]: styles[`grouped${(0,capitalize/* default */.Z)(ownerState.orientation)}`]
  }, {
    [`& .${ButtonGroup_buttonGroupClasses.grouped}`]: styles[`grouped${(0,capitalize/* default */.Z)(ownerState.variant)}`]
  }, {
    [`& .${ButtonGroup_buttonGroupClasses.grouped}`]: styles[`grouped${(0,capitalize/* default */.Z)(ownerState.variant)}${(0,capitalize/* default */.Z)(ownerState.orientation)}`]
  }, {
    [`& .${ButtonGroup_buttonGroupClasses.grouped}`]: styles[`grouped${(0,capitalize/* default */.Z)(ownerState.variant)}${(0,capitalize/* default */.Z)(ownerState.color)}`]
  }, styles.root, styles[ownerState.variant], ownerState.disableElevation === true && styles.disableElevation, ownerState.fullWidth && styles.fullWidth, ownerState.orientation === 'vertical' && styles.vertical];
};
const useUtilityClasses = ownerState => {
  const {
    classes,
    color,
    disabled,
    disableElevation,
    fullWidth,
    orientation,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant, orientation === 'vertical' && 'vertical', fullWidth && 'fullWidth', disableElevation && 'disableElevation'],
    grouped: ['grouped', `grouped${(0,capitalize/* default */.Z)(orientation)}`, `grouped${(0,capitalize/* default */.Z)(variant)}`, `grouped${(0,capitalize/* default */.Z)(variant)}${(0,capitalize/* default */.Z)(orientation)}`, `grouped${(0,capitalize/* default */.Z)(variant)}${(0,capitalize/* default */.Z)(color)}`, disabled && 'disabled']
  };
  return (0,composeClasses/* default */.Z)(slots, getButtonGroupUtilityClass, classes);
};
const ButtonGroupRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiButtonGroup',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-flex',
  borderRadius: (theme.vars || theme).shape.borderRadius
}, ownerState.variant === 'contained' && {
  boxShadow: (theme.vars || theme).shadows[2]
}, ownerState.disableElevation && {
  boxShadow: 'none'
}, ownerState.fullWidth && {
  width: '100%'
}, ownerState.orientation === 'vertical' && {
  flexDirection: 'column'
}, {
  [`& .${ButtonGroup_buttonGroupClasses.grouped}`]: (0,esm_extends/* default */.Z)({
    minWidth: 40,
    '&:not(:first-of-type)': (0,esm_extends/* default */.Z)({}, ownerState.orientation === 'horizontal' && {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }, ownerState.orientation === 'vertical' && {
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0
    }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
      marginLeft: -1
    }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
      marginTop: -1
    }),
    '&:not(:last-of-type)': (0,esm_extends/* default */.Z)({}, ownerState.orientation === 'horizontal' && {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }, ownerState.orientation === 'vertical' && {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0
    }, ownerState.variant === 'text' && ownerState.orientation === 'horizontal' && {
      borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
      [`&.${ButtonGroup_buttonGroupClasses.disabled}`]: {
        borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
      }
    }, ownerState.variant === 'text' && ownerState.orientation === 'vertical' && {
      borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
      [`&.${ButtonGroup_buttonGroupClasses.disabled}`]: {
        borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
      }
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
      borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0,colorManipulator/* alpha */.Fq)(theme.palette[ownerState.color].main, 0.5)
    }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
      borderRightColor: 'transparent'
    }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
      borderBottomColor: 'transparent'
    }, ownerState.variant === 'contained' && ownerState.orientation === 'horizontal' && {
      borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
      [`&.${ButtonGroup_buttonGroupClasses.disabled}`]: {
        borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
      }
    }, ownerState.variant === 'contained' && ownerState.orientation === 'vertical' && {
      borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
      [`&.${ButtonGroup_buttonGroupClasses.disabled}`]: {
        borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
      }
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
      borderColor: (theme.vars || theme).palette[ownerState.color].dark
    }, {
      '&:hover': (0,esm_extends/* default */.Z)({}, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
        borderRightColor: 'currentColor'
      }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
        borderBottomColor: 'currentColor'
      })
    }),
    '&:hover': (0,esm_extends/* default */.Z)({}, ownerState.variant === 'contained' && {
      boxShadow: 'none'
    })
  }, ownerState.variant === 'contained' && {
    boxShadow: 'none'
  })
}));
const ButtonGroup = /*#__PURE__*/react.forwardRef(function ButtonGroup(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiButtonGroup'
  });
  const {
      children,
      className,
      color = 'primary',
      component = 'div',
      disabled = false,
      disableElevation = false,
      disableFocusRipple = false,
      disableRipple = false,
      fullWidth = false,
      orientation = 'horizontal',
      size = 'medium',
      variant = 'outlined'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    disableRipple,
    fullWidth,
    orientation,
    size,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const context = react.useMemo(() => ({
    className: classes.grouped,
    color,
    disabled,
    disableElevation,
    disableFocusRipple,
    disableRipple,
    fullWidth,
    size,
    variant
  }), [color, disabled, disableElevation, disableFocusRipple, disableRipple, fullWidth, size, variant, classes.grouped]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonGroupRoot, (0,esm_extends/* default */.Z)({
    as: component,
    role: "group",
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonGroupContext/* default.Provider */.Z.Provider, {
      value: context,
      children: children
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonGroup_ButtonGroup = (ButtonGroup);

/***/ }),

/***/ 98363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */
const ButtonGroupContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (ButtonGroupContext);

/***/ }),

/***/ 69368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/SwitchBase.js + 1 modules
var SwitchBase = __webpack_require__(21964);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/CheckBoxOutlineBlank.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBoxOutlineBlank = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/CheckBox.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/IndeterminateCheckBox.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var IndeterminateCheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Checkbox/checkboxClasses.js


function getCheckboxUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCheckbox', slot);
}
const checkboxClasses = (0,generateUtilityClasses/* default */.Z)('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary']);
/* harmony default export */ var Checkbox_checkboxClasses = (checkboxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js
'use client';



const _excluded = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"];















const useUtilityClasses = ownerState => {
  const {
    classes,
    indeterminate,
    color
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${(0,capitalize/* default */.Z)(color)}`]
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getCheckboxUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const CheckboxRoot = (0,styled/* default */.ZP)(SwitchBase/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${Checkbox_checkboxClasses.checked}, &.${Checkbox_checkboxClasses.indeterminate}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${Checkbox_checkboxClasses.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
const defaultCheckedIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBox, {});
const defaultIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBoxOutlineBlank, {});
const defaultIndeterminateIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(IndeterminateCheckBox, {});
const Checkbox = /*#__PURE__*/react.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCheckbox'
  });
  const {
      checkedIcon = defaultCheckedIcon,
      color = 'primary',
      icon: iconProp = defaultIcon,
      indeterminate = false,
      indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
      inputProps,
      size = 'medium',
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    indeterminate,
    size
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxRoot, (0,esm_extends/* default */.Z)({
    type: "checkbox",
    inputProps: (0,esm_extends/* default */.Z)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/react.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other, {
    classes: classes
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

/***/ }),

/***/ 98456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CircularProgress_CircularProgress; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/circularProgressClasses.js


function getCircularProgressUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0,generateUtilityClasses/* default */.Z)('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);
/* harmony default export */ var CircularProgress_circularProgressClasses = ((/* unused pure expression or super */ null && (circularProgressClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
'use client';



const _excluded = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;











const SIZE = 44;
const circularRotateKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${(0,capitalize/* default */.Z)(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${(0,capitalize/* default */.Z)(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return (0,composeClasses/* default */.Z)(slots, getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: (theme.vars || theme).palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = (0,styled/* default */.ZP)('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered
});

const CircularProgressCircle = (0,styled/* default */.ZP)('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${(0,capitalize/* default */.Z)(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const CircularProgress = /*#__PURE__*/react.forwardRef(function CircularProgress(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCircularProgress'
  });
  const {
      className,
      color = 'primary',
      disableShrink = false,
      size = 40,
      style,
      thickness = 3.6,
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    style: (0,esm_extends/* default */.Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CircularProgress_CircularProgress = (CircularProgress);

/***/ }),

/***/ 57922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Collapse_Collapse; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTransitions.js
var createTransitions = __webpack_require__(96067);
// EXTERNAL MODULE: ./node_modules/@mui/material/transitions/utils.js
var utils = __webpack_require__(30577);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Collapse/collapseClasses.js


function getCollapseUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCollapse', slot);
}
const collapseClasses = (0,generateUtilityClasses/* default */.Z)('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);
/* harmony default export */ var Collapse_collapseClasses = ((/* unused pure expression or super */ null && (collapseClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Collapse/Collapse.js
'use client';



const _excluded = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];














const useUtilityClasses = ownerState => {
  const {
    orientation,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${orientation}`],
    entered: ['entered'],
    hidden: ['hidden'],
    wrapper: ['wrapper', `${orientation}`],
    wrapperInner: ['wrapperInner', `${orientation}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getCollapseUtilityClass, classes);
};
const CollapseRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCollapse',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.state === 'entered' && styles.entered, ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  height: 0,
  overflow: 'hidden',
  transition: theme.transitions.create('height')
}, ownerState.orientation === 'horizontal' && {
  height: 'auto',
  width: 0,
  transition: theme.transitions.create('width')
}, ownerState.state === 'entered' && (0,esm_extends/* default */.Z)({
  height: 'auto',
  overflow: 'visible'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto'
}), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
  visibility: 'hidden'
}));
const CollapseWrapper = (0,styled/* default */.ZP)('div', {
  name: 'MuiCollapse',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => styles.wrapper
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: 'flex',
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));
const CollapseWrapperInner = (0,styled/* default */.ZP)('div', {
  name: 'MuiCollapse',
  slot: 'WrapperInner',
  overridesResolver: (props, styles) => styles.wrapperInner
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));

/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Collapse = /*#__PURE__*/react.forwardRef(function Collapse(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCollapse'
  });
  const {
      addEndListener,
      children,
      className,
      collapsedSize: collapsedSizeProp = '0px',
      component,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      orientation = 'vertical',
      style,
      timeout = createTransitions/* duration.standard */.x9.standard,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Transition/* default */.ZP
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    orientation,
    collapsedSize: collapsedSizeProp
  });
  const classes = useUtilityClasses(ownerState);
  const theme = (0,useTheme/* default */.Z)();
  const timer = react.useRef();
  const wrapperRef = react.useRef(null);
  const autoTransitionDuration = react.useRef();
  const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
  const isHorizontal = orientation === 'horizontal';
  const size = isHorizontal ? 'width' : 'height';
  react.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  const nodeRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(ref, nodeRef);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    if (wrapperRef.current && isHorizontal) {
      // Set absolute position to get the size of collapsed content
      wrapperRef.current.style.position = 'absolute';
    }
    node.style[size] = collapsedSize;
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const wrapperSize = getWrapperSize();
    if (wrapperRef.current && isHorizontal) {
      // After the size is read reset the position back to default
      wrapperRef.current.style.position = '';
    }
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = (0,utils/* getTransitionProps */.C)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    if (timeout === 'auto') {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style[size] = `${wrapperSize}px`;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback((node, isAppearing) => {
    node.style[size] = 'auto';
    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback(node => {
    node.style[size] = `${getWrapperSize()}px`;
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleExiting = normalizedTransitionCallback(node => {
    const wrapperSize = getWrapperSize();
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = (0,utils/* getTransitionProps */.C)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    if (timeout === 'auto') {
      // TODO: rename getAutoHeightDuration to something more generic (width support)
      // Actually it just calculates animation duration based on size
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style[size] = collapsedSize;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onExiting) {
      onExiting(node);
    }
  });
  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => /*#__PURE__*/(0,jsx_runtime.jsx)(CollapseRoot, (0,esm_extends/* default */.Z)({
      as: component,
      className: (0,clsx_m/* default */.Z)(classes.root, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedSize === '0px' && classes.hidden
      }[state]),
      style: (0,esm_extends/* default */.Z)({
        [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
      }, style),
      ownerState: (0,esm_extends/* default */.Z)({}, ownerState, {
        state
      }),
      ref: handleRef
    }, childProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CollapseWrapper, {
        ownerState: (0,esm_extends/* default */.Z)({}, ownerState, {
          state
        }),
        className: classes.wrapper,
        ref: wrapperRef,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CollapseWrapperInner, {
          ownerState: (0,esm_extends/* default */.Z)({}, ownerState, {
            state
          }),
          className: classes.wrapperInner,
          children: children
        })
      })
    }))
  }));
});
 false ? 0 : void 0;
Collapse.muiSupportAuto = true;
/* harmony default export */ var Collapse_Collapse = (Collapse);

/***/ }),

/***/ 50657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Dialog_Dialog; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useId/useId.js
var useId = __webpack_require__(92996);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(72908);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Dialog/dialogClasses.js


function getDialogUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDialog', slot);
}
const dialogClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
/* harmony default export */ var Dialog_dialogClasses = (dialogClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/DialogContext.js
var DialogContext = __webpack_require__(34182);
// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(84808);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
'use client';



const _excluded = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
















const DialogBackdrop = (0,styled/* default */.ZP)(Backdrop/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});
const useUtilityClasses = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${(0,capitalize/* default */.Z)(scroll)}`],
    paper: ['paper', `paperScroll${(0,capitalize/* default */.Z)(scroll)}`, `paperWidth${(0,capitalize/* default */.Z)(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogUtilityClass, classes);
};
const DialogRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${(0,capitalize/* default */.Z)(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&:after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${(0,capitalize/* default */.Z)(ownerState.scroll)}`], styles[`paperWidth${(0,capitalize/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11
}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${Dialog_dialogClasses.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
const Dialog = /*#__PURE__*/react.forwardRef(function Dialog(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      'aria-describedby': ariaDescribedby,
      'aria-labelledby': ariaLabelledbyProp,
      BackdropComponent,
      BackdropProps,
      children,
      className,
      disableEscapeKeyDown = false,
      fullScreen = false,
      fullWidth = false,
      maxWidth = 'sm',
      onBackdropClick,
      onClose,
      open,
      PaperComponent = Paper/* default */.Z,
      PaperProps = {},
      scroll = 'paper',
      TransitionComponent = Fade/* default */.Z,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });
  const classes = useUtilityClasses(ownerState);
  const backdropClick = react.useRef();
  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };
  const handleBackdropClick = event => {
    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }
    backdropClick.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const ariaLabelledby = (0,useId/* default */.Z)(ariaLabelledbyProp);
  const dialogContextValue = react.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    closeAfterTransition: true,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: (0,esm_extends/* default */.Z)({
        transitionDuration,
        as: BackdropComponent
      }, BackdropProps)
    },
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContainer, {
        className: (0,clsx_m/* default */.Z)(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogPaper, (0,esm_extends/* default */.Z)({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: (0,clsx_m/* default */.Z)(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContext/* default.Provider */.Z.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Dialog_Dialog = (Dialog);

/***/ }),

/***/ 34182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const DialogContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (DialogContext);

/***/ }),

/***/ 31425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DialogActions_DialogActions; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogActions/dialogActionsClasses.js


function getDialogActionsUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDialogActions', slot);
}
const dialogActionsClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogActions', ['root', 'spacing']);
/* harmony default export */ var DialogActions_dialogActionsClasses = ((/* unused pure expression or super */ null && (dialogActionsClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js
'use client';



const _excluded = ["className", "disableSpacing"];








const useUtilityClasses = ownerState => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ['root', !disableSpacing && 'spacing']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogActionsUtilityClass, classes);
};
const DialogActionsRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialogActions',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableSpacing && styles.spacing];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  alignItems: 'center',
  padding: 8,
  justifyContent: 'flex-end',
  flex: '0 0 auto'
}, !ownerState.disableSpacing && {
  '& > :not(:first-of-type)': {
    marginLeft: 8
  }
}));
const DialogActions = /*#__PURE__*/react.forwardRef(function DialogActions(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDialogActions'
  });
  const {
      className,
      disableSpacing = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableSpacing
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogActionsRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogActions_DialogActions = (DialogActions);

/***/ }),

/***/ 6514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DialogContent_DialogContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogContent/dialogContentClasses.js


function getDialogContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDialogContent', slot);
}
const dialogContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogContent', ['root', 'dividers']);
/* harmony default export */ var DialogContent_dialogContentClasses = ((/* unused pure expression or super */ null && (dialogContentClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/dialogTitleClasses.js
var dialogTitleClasses = __webpack_require__(4472);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js
'use client';



const _excluded = ["className", "dividers"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ['root', dividers && 'dividers']
  };
  return (0,composeClasses/* default */.Z)(slots, getDialogContentUtilityClass, classes);
};
const DialogContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiDialogContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dividers && styles.dividers];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  flex: '1 1 auto',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  padding: '20px 24px'
}, ownerState.dividers ? {
  padding: '16px 24px',
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
} : {
  [`.${dialogTitleClasses/* default.root */.Z.root} + &`]: {
    paddingTop: 0
  }
}));
const DialogContent = /*#__PURE__*/react.forwardRef(function DialogContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDialogContent'
  });
  const {
      className,
      dividers = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    dividers
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogContent_DialogContent = (DialogContent);

/***/ }),

/***/ 58951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DialogContentText_DialogContentText; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogContentText/dialogContentTextClasses.js


function getDialogContentTextUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDialogContentText', slot);
}
const dialogContentTextClasses = (0,generateUtilityClasses/* default */.Z)('MuiDialogContentText', ['root']);
/* harmony default export */ var DialogContentText_dialogContentTextClasses = ((/* unused pure expression or super */ null && (dialogContentTextClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/DialogContentText/DialogContentText.js
'use client';



const _excluded = ["children", "className"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getDialogContentTextUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const DialogContentTextRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiDialogContentText',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const DialogContentText = /*#__PURE__*/react.forwardRef(function DialogContentText(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDialogContentText'
  });
  const {
      className
    } = props,
    ownerState = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentTextRoot, (0,esm_extends/* default */.Z)({
    component: "p",
    variant: "body1",
    color: "text.secondary",
    ref: ref,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, props, {
    classes: classes
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogContentText_DialogContentText = (DialogContentText);

/***/ }),

/***/ 37645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71657);
/* harmony import */ var _dialogTitleClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4472);
/* harmony import */ var _Dialog_DialogContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34182);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["className", "id"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _dialogTitleClasses__WEBPACK_IMPORTED_MODULE_3__/* .getDialogTitleUtilityClass */ .a, classes);
};
const DialogTitleRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
  name: 'MuiDialogTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  padding: '16px 24px',
  flex: '0 0 auto'
});
const DialogTitle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function DialogTitle(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiDialogTitle'
  });
  const {
      className,
      id: idProp
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  const {
    titleId = idProp
  } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_Dialog_DialogContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DialogTitleRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
    component: "h2",
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    variant: "h6",
    id: idProp != null ? idProp : titleId
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (DialogTitle);

/***/ }),

/***/ 4472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getDialogTitleUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);


function getDialogTitleUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiDialogTitle', slot);
}
const dialogTitleClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiDialogTitle', ['root']);
/* harmony default export */ __webpack_exports__["Z"] = (dialogTitleClasses);

/***/ }),

/***/ 67720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41796);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71657);
/* harmony import */ var _dividerClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35097);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"];









const useUtilityClasses = ownerState => {
  const {
    absolute,
    children,
    classes,
    flexItem,
    light,
    orientation,
    textAlign,
    variant
  } = ownerState;
  const slots = {
    root: ['root', absolute && 'absolute', variant, light && 'light', orientation === 'vertical' && 'vertical', flexItem && 'flexItem', children && 'withChildren', children && orientation === 'vertical' && 'withChildrenVertical', textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight', textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'],
    wrapper: ['wrapper', orientation === 'vertical' && 'wrapperVertical']
  };
  return (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _dividerClasses__WEBPACK_IMPORTED_MODULE_3__/* .getDividerUtilityClass */ .V, classes);
};
const DividerRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)('div', {
  name: 'MuiDivider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.absolute && styles.absolute, styles[ownerState.variant], ownerState.light && styles.light, ownerState.orientation === 'vertical' && styles.vertical, ownerState.flexItem && styles.flexItem, ownerState.children && styles.withChildren, ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft];
  }
})(({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: 'solid',
  borderColor: (theme.vars || theme).palette.divider,
  borderBottomWidth: 'thin'
}, ownerState.absolute && {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%'
}, ownerState.light && {
  borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* .alpha */ .Fq)(theme.palette.divider, 0.08)
}, ownerState.variant === 'inset' && {
  marginLeft: 72
}, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2)
}, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1)
}, ownerState.orientation === 'vertical' && {
  height: '100%',
  borderBottomWidth: 0,
  borderRightWidth: 'thin'
}, ownerState.flexItem && {
  alignSelf: 'stretch',
  height: 'auto'
}), ({
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, ownerState.children && {
  display: 'flex',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  border: 0,
  '&::before, &::after': {
    content: '""',
    alignSelf: 'center'
  }
}), ({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
  '&::before, &::after': {
    width: '100%',
    borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
  }
}), ({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, ownerState.children && ownerState.orientation === 'vertical' && {
  flexDirection: 'column',
  '&::before, &::after': {
    height: '100%',
    borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
  }
}), ({
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '90%'
  },
  '&::after': {
    width: '10%'
  }
}, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '10%'
  },
  '&::after': {
    width: '90%'
  }
}));
const DividerWrapper = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)('span', {
  name: 'MuiDivider',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.wrapper, ownerState.orientation === 'vertical' && styles.wrapperVertical];
  }
})(({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  display: 'inline-block',
  paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
  paddingRight: `calc(${theme.spacing(1)} * 1.2)`
}, ownerState.orientation === 'vertical' && {
  paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
}));
const Divider = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Divider(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiDivider'
  });
  const {
      absolute = false,
      children,
      className,
      component = children ? 'div' : 'hr',
      flexItem = false,
      light = false,
      orientation = 'horizontal',
      role = component !== 'hr' ? 'separator' : undefined,
      textAlign = 'center',
      variant = 'fullWidth'
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, {
    absolute,
    component,
    flexItem,
    light,
    orientation,
    role,
    textAlign,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DividerRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    as: component,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(classes.root, className),
    role: role,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DividerWrapper, {
      className: classes.wrapper,
      ownerState: ownerState,
      children: children
    }) : null
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Divider);

/***/ }),

/***/ 35097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getDividerUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);


function getDividerUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiDivider', slot);
}
const dividerClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiDivider', ['root', 'absolute', 'fullWidth', 'inset', 'middle', 'flexItem', 'light', 'vertical', 'withChildren', 'withChildrenVertical', 'textAlignRight', 'textAlignLeft', 'wrapper', 'wrapperVertical']);
/* harmony default export */ __webpack_exports__["Z"] = (dividerClasses);

/***/ }),

/***/ 58826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Drawer_Drawer; }
});

// UNUSED EXPORTS: getAnchor, isHorizontal

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(72908);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(54776);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Drawer/drawerClasses.js


function getDrawerUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDrawer', slot);
}
const drawerClasses = (0,generateUtilityClasses/* default */.Z)('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);
/* harmony default export */ var Drawer_drawerClasses = ((/* unused pure expression or super */ null && (drawerClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Drawer/Drawer.js
'use client';



const _excluded = ["BackdropProps"],
  _excluded2 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];














const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};
const useUtilityClasses = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${(0,capitalize/* default */.Z)(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${(0,capitalize/* default */.Z)(anchor)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getDrawerUtilityClass, classes);
};
const DrawerRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.drawer
}));
const DrawerDockedRoot = (0,styled/* default */.ZP)('div', {
  shouldForwardProp: styled/* rootShouldForwardProp */.FO,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver
})({
  flex: '0 0 auto'
});
const DrawerPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${(0,capitalize/* default */.Z)(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0,capitalize/* default */.Z)(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: (theme.vars || theme).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}

/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */
const Drawer = /*#__PURE__*/react.forwardRef(function Drawer(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDrawer'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      anchor: anchorProp = 'left',
      BackdropProps,
      children,
      className,
      elevation = 16,
      hideBackdrop = false,
      ModalProps: {
        BackdropProps: BackdropPropsProp
      } = {},
      onClose,
      open = false,
      PaperProps = {},
      SlideProps,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Slide/* default */.Z,
      transitionDuration = defaultTransitionDuration,
      variant = 'temporary'
    } = props,
    ModalProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.ModalProps, _excluded),
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

  // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.
  const mounted = react.useRef(false);
  react.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor(theme, anchorProp);
  const anchor = anchorProp;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);
  const classes = useUtilityClasses(ownerState);
  const drawer = /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerPaper, (0,esm_extends/* default */.Z)({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: (0,clsx_m/* default */.Z)(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));
  if (variant === 'permanent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }
  const slidingDrawer = /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));
  if (variant === 'persistent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  }

  // variant === temporary
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerRoot, (0,esm_extends/* default */.Z)({
    BackdropProps: (0,esm_extends/* default */.Z)({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: (0,clsx_m/* default */.Z)(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Drawer_Drawer = (Drawer);

/***/ }),

/***/ 16628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98885);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30577);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51705);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








const styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};

/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Fade = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Fade(props, ref) {
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);
  const enableStrictModeCompat = true;
  const nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .reflow */ .n)(node); // So the animation always start from the start.

    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    appear: appear,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Fade);

/***/ }),

/***/ 6135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59766);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13970);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90948);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71657);
/* harmony import */ var _filledInputClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24707);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _filledInputClasses__WEBPACK_IMPORTED_MODULE_3__/* .getFilledInputUtilityClass */ ._, classes);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, classes, composedClasses);
};
const FilledInputRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* .InputBaseRoot */ .Ej, {
  shouldForwardProp: prop => (0,_styles_styled__WEBPACK_IMPORTED_MODULE_5__/* .rootShouldForwardProp */ .FO)(prop) || prop === 'classes',
  name: 'MuiFilledInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...(0,_InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* .rootOverridesResolver */ .Gx)(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  var _palette;
  const light = theme.palette.mode === 'light';
  const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
  const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
  const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    position: 'relative',
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
    borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
    borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    '&:hover': {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
      }
    },
    [`&.${_filledInputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].focused */ .Z.focused}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
    },
    [`&.${_filledInputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].disabled */ .Z.disabled}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
    }
  }, !ownerState.disableUnderline && {
    '&:after': {
      borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },

    [`&.${_filledInputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].focused */ .Z.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: 'scaleX(1) translateX(0)'
    },
    [`&.${_filledInputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error}`]: {
      '&:before, &:after': {
        borderBottomColor: (theme.vars || theme).palette.error.main
      }
    },
    '&:before': {
      borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },

    [`&:hover:not(.${_filledInputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].disabled */ .Z.disabled}, .${_filledInputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error}):before`]: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
    },
    [`&.${_filledInputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].disabled */ .Z.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  }, ownerState.startAdornment && {
    paddingLeft: 12
  }, ownerState.endAdornment && {
    paddingRight: 12
  }, ownerState.multiline && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    padding: '25px 12px 8px'
  }, ownerState.size === 'small' && {
    paddingTop: 21,
    paddingBottom: 4
  }, ownerState.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }));
});
const FilledInputInput = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* .InputBaseComponent */ .rA, {
  name: 'MuiFilledInput',
  slot: 'Input',
  overridesResolver: _InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* .inputOverridesResolver */ ._o
})(({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !theme.vars && {
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  }
}, theme.vars && {
  '&:-webkit-autofill': {
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  },
  [theme.getColorSchemeSelector('dark')]: {
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #266798 inset',
      WebkitTextFillColor: '#fff',
      caretColor: '#fff'
    }
  }
}, ownerState.size === 'small' && {
  paddingTop: 21,
  paddingBottom: 4
}, ownerState.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, ownerState.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}, ownerState.hiddenLabel && ownerState.size === 'small' && {
  paddingTop: 8,
  paddingBottom: 9
}));
const FilledInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function FilledInput(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input;
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiFilledInput'
  });
  const {
      components = {},
      componentsProps: componentsPropsProp,
      fullWidth = false,
      // declare here to prevent spreading to DOM
      inputComponent = 'input',
      multiline = false,
      slotProps,
      slots = {},
      type = 'text'
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props, {
    fullWidth,
    inputComponent,
    multiline,
    type
  });
  const classes = useUtilityClasses(props);
  const filledInputComponentsProps = {
    root: {
      ownerState
    },
    input: {
      ownerState
    }
  };
  const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0,_mui_utils__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : FilledInputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : FilledInputInput;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    componentsProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
 false ? 0 : void 0;
FilledInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["Z"] = (FilledInput);

/***/ }),

/***/ 24707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getFilledInputUtilityClass; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);
/* harmony import */ var _InputBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55827);




function getFilledInputUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiFilledInput', slot);
}
const filledInputClasses = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _InputBase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_mui_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)('MuiFilledInput', ['root', 'underline', 'input']));
/* harmony default export */ __webpack_exports__["Z"] = (filledInputClasses);

/***/ }),

/***/ 94054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormControl_FormControl; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputBase/utils.js
var utils = __webpack_require__(5108);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(71579);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControlContext.js
var FormControlContext = __webpack_require__(47167);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormControl/formControlClasses.js


function getFormControlUtilityClasses(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiFormControl', slot);
}
const formControlClasses = (0,generateUtilityClasses/* default */.Z)('MuiFormControl', ['root', 'marginNone', 'marginNormal', 'marginDense', 'fullWidth', 'disabled']);
/* harmony default export */ var FormControl_formControlClasses = ((/* unused pure expression or super */ null && (formControlClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormControl/FormControl.js
'use client';



const _excluded = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"];












const useUtilityClasses = ownerState => {
  const {
    classes,
    margin,
    fullWidth
  } = ownerState;
  const slots = {
    root: ['root', margin !== 'none' && `margin${(0,capitalize/* default */.Z)(margin)}`, fullWidth && 'fullWidth']
  };
  return (0,composeClasses/* default */.Z)(slots, getFormControlUtilityClasses, classes);
};
const FormControlRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiFormControl',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return (0,esm_extends/* default */.Z)({}, styles.root, styles[`margin${(0,capitalize/* default */.Z)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: 'top'
}, ownerState.margin === 'normal' && {
  marginTop: 16,
  marginBottom: 8
}, ownerState.margin === 'dense' && {
  marginTop: 8,
  marginBottom: 4
}, ownerState.fullWidth && {
  width: '100%'
}));

/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */
const FormControl = /*#__PURE__*/react.forwardRef(function FormControl(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiFormControl'
  });
  const {
      children,
      className,
      color = 'primary',
      component = 'div',
      disabled = false,
      error = false,
      focused: visuallyFocused,
      fullWidth = false,
      hiddenLabel = false,
      margin = 'none',
      required = false,
      size = 'medium',
      variant = 'outlined'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    disabled,
    error,
    fullWidth,
    hiddenLabel,
    margin,
    required,
    size,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const [adornedStart, setAdornedStart] = react.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialAdornedStart = false;
    if (children) {
      react.Children.forEach(children, child => {
        if (!(0,isMuiElement/* default */.Z)(child, ['Input', 'Select'])) {
          return;
        }
        const input = (0,isMuiElement/* default */.Z)(child, ['Select']) ? child.props.input : child;
        if (input && (0,utils/* isAdornedStart */.B7)(input.props)) {
          initialAdornedStart = true;
        }
      });
    }
    return initialAdornedStart;
  });
  const [filled, setFilled] = react.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialFilled = false;
    if (children) {
      react.Children.forEach(children, child => {
        if (!(0,isMuiElement/* default */.Z)(child, ['Input', 'Select'])) {
          return;
        }
        if ((0,utils/* isFilled */.vd)(child.props, true) || (0,utils/* isFilled */.vd)(child.props.inputProps, true)) {
          initialFilled = true;
        }
      });
    }
    return initialFilled;
  });
  const [focusedState, setFocused] = react.useState(false);
  if (disabled && focusedState) {
    setFocused(false);
  }
  const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
  let registerEffect;
  if (false) {}
  const childContext = react.useMemo(() => {
    return {
      adornedStart,
      setAdornedStart,
      color,
      disabled,
      error,
      filled,
      focused,
      fullWidth,
      hiddenLabel,
      size,
      onBlur: () => {
        setFocused(false);
      },
      onEmpty: () => {
        setFilled(false);
      },
      onFilled: () => {
        setFilled(true);
      },
      onFocus: () => {
        setFocused(true);
      },
      registerEffect,
      required,
      variant
    };
  }, [adornedStart, color, disabled, error, filled, focused, fullWidth, hiddenLabel, registerEffect, required, size, variant]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormControlContext/* default.Provider */.Z.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormControlRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ownerState: ownerState,
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      ref: ref
    }, other, {
      children: children
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var FormControl_FormControl = (FormControl);

/***/ }),

/***/ 47167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */
const FormControlContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (FormControlContext);

/***/ }),

/***/ 15704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formControlState; }
/* harmony export */ });
function formControlState({
  props,
  states,
  muiFormControl
}) {
  return states.reduce((acc, state) => {
    acc[state] = props[state];
    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }
    return acc;
  }, {});
}

/***/ }),

/***/ 74423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFormControl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _FormControlContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47167);
'use client';



function useFormControl() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(_FormControlContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
}

/***/ }),

/***/ 50480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormControlLabel_FormControlLabel; }
});

// UNUSED EXPORTS: FormControlLabelRoot

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormControlLabel/formControlLabelClasses.js


function getFormControlLabelUtilityClasses(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiFormControlLabel', slot);
}
const formControlLabelClasses = (0,generateUtilityClasses/* default */.Z)('MuiFormControlLabel', ['root', 'labelPlacementStart', 'labelPlacementTop', 'labelPlacementBottom', 'disabled', 'label', 'error', 'required', 'asterisk']);
/* harmony default export */ var FormControlLabel_formControlLabelClasses = (formControlLabelClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/formControlState.js
var formControlState = __webpack_require__(15704);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js
'use client';



const _excluded = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"];















const useUtilityClasses = ownerState => {
  const {
    classes,
    disabled,
    labelPlacement,
    error,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', `labelPlacement${(0,capitalize/* default */.Z)(labelPlacement)}`, error && 'error', required && 'required'],
    label: ['label', disabled && 'disabled'],
    asterisk: ['asterisk', error && 'error']
  };
  return (0,composeClasses/* default */.Z)(slots, getFormControlLabelUtilityClasses, classes);
};
const FormControlLabelRoot = (0,styled/* default */.ZP)('label', {
  name: 'MuiFormControlLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${FormControlLabel_formControlLabelClasses.label}`]: styles.label
    }, styles.root, styles[`labelPlacement${(0,capitalize/* default */.Z)(ownerState.labelPlacement)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  WebkitTapHighlightColor: 'transparent',
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${FormControlLabel_formControlLabelClasses.disabled}`]: {
    cursor: 'default'
  }
}, ownerState.labelPlacement === 'start' && {
  flexDirection: 'row-reverse',
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, ownerState.labelPlacement === 'top' && {
  flexDirection: 'column-reverse',
  marginLeft: 16
}, ownerState.labelPlacement === 'bottom' && {
  flexDirection: 'column',
  marginLeft: 16
}, {
  [`& .${FormControlLabel_formControlLabelClasses.label}`]: {
    [`&.${FormControlLabel_formControlLabelClasses.disabled}`]: {
      color: (theme.vars || theme).palette.text.disabled
    }
  }
}));
const AsteriskComponent = (0,styled/* default */.ZP)('span', {
  name: 'MuiFormControlLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${FormControlLabel_formControlLabelClasses.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));

/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */
const FormControlLabel = /*#__PURE__*/react.forwardRef(function FormControlLabel(inProps, ref) {
  var _ref, _slotProps$typography;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiFormControlLabel'
  });
  const {
      className,
      componentsProps = {},
      control,
      disabled: disabledProp,
      disableTypography,
      label: labelProp,
      labelPlacement = 'end',
      required: requiredProp,
      slotProps = {}
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const muiFormControl = (0,useFormControl/* default */.Z)();
  const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
  const required = requiredProp != null ? requiredProp : control.props.required;
  const controlProps = {
    disabled,
    required
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(key => {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  const fcs = (0,formControlState/* default */.Z)({
    props,
    muiFormControl,
    states: ['error']
  });
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disabled,
    labelPlacement,
    required,
    error: fcs.error
  });
  const classes = useUtilityClasses(ownerState);
  const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
  let label = labelProp;
  if (label != null && label.type !== Typography/* default */.Z && !disableTypography) {
    label = /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
      component: "span"
    }, typographySlotProps, {
      className: (0,clsx_m/* default */.Z)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
      children: label
    }));
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormControlLabelRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/react.cloneElement(control, controlProps), required ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
      direction: "row",
      alignItems: "center",
      children: [label, /*#__PURE__*/(0,jsx_runtime.jsxs)(AsteriskComponent, {
        ownerState: ownerState,
        "aria-hidden": true,
        className: classes.asterisk,
        children: ["\u2009", '*']
      })]
    }) : label]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var FormControlLabel_FormControlLabel = (FormControlLabel);

/***/ }),

/***/ 56815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormHelperText_FormHelperText; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/formControlState.js
var formControlState = __webpack_require__(15704);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormHelperText/formHelperTextClasses.js


function getFormHelperTextUtilityClasses(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiFormHelperText', slot);
}
const formHelperTextClasses = (0,generateUtilityClasses/* default */.Z)('MuiFormHelperText', ['root', 'error', 'disabled', 'sizeSmall', 'sizeMedium', 'contained', 'focused', 'filled', 'required']);
/* harmony default export */ var FormHelperText_formHelperTextClasses = (formHelperTextClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js
'use client';



var _span;
const _excluded = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"];











const useUtilityClasses = ownerState => {
  const {
    classes,
    contained,
    size,
    disabled,
    error,
    filled,
    focused,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', error && 'error', size && `size${(0,capitalize/* default */.Z)(size)}`, contained && 'contained', focused && 'focused', filled && 'filled', required && 'required']
  };
  return (0,composeClasses/* default */.Z)(slots, getFormHelperTextUtilityClasses, classes);
};
const FormHelperTextRoot = (0,styled/* default */.ZP)('p', {
  name: 'MuiFormHelperText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.size && styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`], ownerState.contained && styles.contained, ownerState.filled && styles.filled];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.secondary
}, theme.typography.caption, {
  textAlign: 'left',
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${FormHelperText_formHelperTextClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${FormHelperText_formHelperTextClasses.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}, ownerState.size === 'small' && {
  marginTop: 4
}, ownerState.contained && {
  marginLeft: 14,
  marginRight: 14
}));
const FormHelperText = /*#__PURE__*/react.forwardRef(function FormHelperText(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiFormHelperText'
  });
  const {
      children,
      className,
      component = 'p'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const muiFormControl = (0,useFormControl/* default */.Z)();
  const fcs = (0,formControlState/* default */.Z)({
    props,
    muiFormControl,
    states: ['variant', 'size', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
    variant: fcs.variant,
    size: fcs.size,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormHelperTextRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: children === ' ' ? // notranslate needed while Google Translate will not fix zero-width space issue
    _span || (_span = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "notranslate",
      children: "\u200B"
    })) : children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var FormHelperText_FormHelperText = (FormHelperText);

/***/ }),

/***/ 17297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ material_GlobalStyles_GlobalStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/styled-engine/GlobalStyles/GlobalStyles.js




function isEmpty(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(emotion_react_browser_esm/* Global */.xB, {
    styles: globalStyles
  });
}
 false ? 0 : void 0;
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(96682);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/GlobalStyles/GlobalStyles.js
'use client';






function GlobalStyles_GlobalStyles({
  styles,
  themeId,
  defaultTheme = {}
}) {
  const upperTheme = (0,useTheme/* default */.Z)(defaultTheme);
  const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalStyles, {
    styles: globalStyles
  });
}
 false ? 0 : void 0;
/* harmony default export */ var esm_GlobalStyles_GlobalStyles = (GlobalStyles_GlobalStyles);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/defaultTheme.js
var defaultTheme = __webpack_require__(90247);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/identifier.js
var identifier = __webpack_require__(10606);
;// CONCATENATED MODULE: ./node_modules/@mui/material/GlobalStyles/GlobalStyles.js
'use client';








function GlobalStyles_GlobalStyles_GlobalStyles(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_GlobalStyles_GlobalStyles, (0,esm_extends/* default */.Z)({}, props, {
    defaultTheme: defaultTheme/* default */.Z,
    themeId: identifier/* default */.Z
  }));
}
 false ? 0 : void 0;
/* harmony default export */ var material_GlobalStyles_GlobalStyles = (GlobalStyles_GlobalStyles_GlobalStyles);

/***/ }),

/***/ 96514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98885);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30577);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51705);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}
const styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};

/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */
const isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);

/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Grow = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Grow(props, ref) {
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = 'auto',
      // eslint-disable-next-line react/prop-types
      TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);
  const timer = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const autoTimeout = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .reflow */ .n)(node); // So the animation always start from the start.

    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    let duration;
    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay,
      easing: transitionTimingFunction
    })].join(',');
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    let duration;
    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay: isWebKit154 ? delay : delay || duration * 0.333,
      easing: transitionTimingFunction
    })].join(',');
    node.style.opacity = 0;
    node.style.transform = getScale(0.75);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
          opacity: 0,
          transform: getScale(0.75),
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
Grow.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["Z"] = (Grow);

/***/ }),

/***/ 93946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IconButton_IconButton; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/IconButton/iconButtonClasses.js


function getIconButtonUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiIconButton', slot);
}
const iconButtonClasses = (0,generateUtilityClasses/* default */.Z)('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
/* harmony default export */ var IconButton_iconButtonClasses = (iconButtonClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
'use client';



const _excluded = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];












const useUtilityClasses = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${(0,capitalize/* default */.Z)(color)}`, edge && `edge${(0,capitalize/* default */.Z)(edge)}`, `size${(0,capitalize/* default */.Z)(size)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getIconButtonUtilityClass, classes);
};
const IconButtonRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], ownerState.edge && styles[`edge${(0,capitalize/* default */.Z)(ownerState.edge)}`], styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: (theme.vars || theme).palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  })
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => {
  var _palette;
  const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
  return (0,esm_extends/* default */.Z)({}, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0,esm_extends/* default */.Z)({
    color: palette == null ? void 0 : palette.main
  }, !ownerState.disableRipple && {
    '&:hover': (0,esm_extends/* default */.Z)({}, palette && {
      backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(palette.main, theme.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    })
  }), ownerState.size === 'small' && {
    padding: 5,
    fontSize: theme.typography.pxToRem(18)
  }, ownerState.size === 'large' && {
    padding: 12,
    fontSize: theme.typography.pxToRem(28)
  }, {
    [`&.${IconButton_iconButtonClasses.disabled}`]: {
      backgroundColor: 'transparent',
      color: (theme.vars || theme).palette.action.disabled
    }
  });
});

/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */
const IconButton = /*#__PURE__*/react.forwardRef(function IconButton(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiIconButton'
  });
  const {
      edge = false,
      children,
      className,
      color = 'default',
      disabled = false,
      disableFocusRipple = false,
      size = 'medium'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButtonRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var IconButton_IconButton = (IconButton);

/***/ }),

/***/ 79332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59766);
/* harmony import */ var _InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13970);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90948);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71657);
/* harmony import */ var _inputClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7021);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _inputClasses__WEBPACK_IMPORTED_MODULE_3__/* .getInputUtilityClass */ .l, classes);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, classes, composedClasses);
};
const InputRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* .InputBaseRoot */ .Ej, {
  shouldForwardProp: prop => (0,_styles_styled__WEBPACK_IMPORTED_MODULE_5__/* .rootShouldForwardProp */ .FO)(prop) || prop === 'classes',
  name: 'MuiInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...(0,_InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* .rootOverridesResolver */ .Gx)(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  if (theme.vars) {
    bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    position: 'relative'
  }, ownerState.formControl && {
    'label + &': {
      marginTop: 16
    }
  }, !ownerState.disableUnderline && {
    '&:after': {
      borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },

    [`&.${_inputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].focused */ .Z.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: 'scaleX(1) translateX(0)'
    },
    [`&.${_inputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error}`]: {
      '&:before, &:after': {
        borderBottomColor: (theme.vars || theme).palette.error.main
      }
    },
    '&:before': {
      borderBottom: `1px solid ${bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },

    [`&:hover:not(.${_inputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].disabled */ .Z.disabled}, .${_inputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error}):before`]: {
      borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        borderBottom: `1px solid ${bottomLineColor}`
      }
    },
    [`&.${_inputClasses__WEBPACK_IMPORTED_MODULE_3__/* ["default"].disabled */ .Z.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  });
});
const InputInput = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* .InputBaseComponent */ .rA, {
  name: 'MuiInput',
  slot: 'Input',
  overridesResolver: _InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* .inputOverridesResolver */ ._o
})({});
const Input = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Input(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input;
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiInput'
  });
  const {
      disableUnderline,
      components = {},
      componentsProps: componentsPropsProp,
      fullWidth = false,
      inputComponent = 'input',
      multiline = false,
      slotProps,
      slots = {},
      type = 'text'
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(props, _excluded);
  const classes = useUtilityClasses(props);
  const ownerState = {
    disableUnderline
  };
  const inputComponentsProps = {
    root: {
      ownerState
    }
  };
  const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0,_mui_utils__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : InputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : InputInput;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_InputBase_InputBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    slotProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
 false ? 0 : void 0;
Input.muiName = 'Input';
/* harmony default export */ __webpack_exports__["Z"] = (Input);

/***/ }),

/***/ 7021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ getInputUtilityClass; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);
/* harmony import */ var _InputBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55827);




function getInputUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiInput', slot);
}
const inputClasses = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _InputBase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_mui_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)('MuiInput', ['root', 'underline', 'input']));
/* harmony default export */ __webpack_exports__["Z"] = (inputClasses);

/***/ }),

/***/ 13970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rA": function() { return /* binding */ InputBaseComponent; },
  "Ej": function() { return /* binding */ InputBaseRoot; },
  "ZP": function() { return /* binding */ InputBase_InputBase; },
  "_o": function() { return /* binding */ inputOverridesResolver; },
  "Gx": function() { return /* binding */ rootOverridesResolver; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(33703);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerWindow/ownerWindow.js
var ownerWindow = __webpack_require__(74161);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/debounce/debounce.js
var debounce = __webpack_require__(39336);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(73546);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/base/TextareaAutosize/TextareaAutosize.js
'use client';



const _excluded = ["onChange", "maxRows", "minRows", "style", "value"];






function getStyleValue(value) {
  return parseInt(value, 10) || 0;
}
const styles = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
function isEmpty(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}

/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */
const TextareaAutosize = /*#__PURE__*/react.forwardRef(function TextareaAutosize(props, forwardedRef) {
  const {
      onChange,
      maxRows,
      minRows = 1,
      style,
      value
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    current: isControlled
  } = react.useRef(value != null);
  const inputRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(forwardedRef, inputRef);
  const shadowRef = react.useRef(null);
  const renders = react.useRef(0);
  const [state, setState] = react.useState({
    outerHeightStyle: 0
  });
  const getUpdatedState = react.useCallback(() => {
    const input = inputRef.current;
    const containerWindow = (0,ownerWindow/* default */.Z)(input);
    const computedStyle = containerWindow.getComputedStyle(input);

    // If input's width is shrunk and it's not visible, don't sync height.
    if (computedStyle.width === '0px') {
      return {
        outerHeightStyle: 0
      };
    }
    const inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';
    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }
    const boxSizing = computedStyle.boxSizing;
    const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
    const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);

    // The height of the inner content
    const innerHeight = inputShallow.scrollHeight;

    // Measure height of a textarea with a single row
    inputShallow.value = 'x';
    const singleRowHeight = inputShallow.scrollHeight;

    // The height of the outer content
    let outerHeight = innerHeight;
    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }
    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }
    outerHeight = Math.max(outerHeight, singleRowHeight);

    // Take the box sizing into account for applying this value as a style.
    const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    const overflow = Math.abs(outerHeight - innerHeight) <= 1;
    return {
      outerHeightStyle,
      overflow
    };
  }, [maxRows, minRows, props.placeholder]);
  const updateState = (prevState, newState) => {
    const {
      outerHeightStyle,
      overflow
    } = newState;
    // Need a large enough difference to update the height.
    // This prevents infinite rendering loop.
    if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
      renders.current += 1;
      return {
        overflow,
        outerHeightStyle
      };
    }
    if (false) {}
    return prevState;
  };
  const syncHeight = react.useCallback(() => {
    const newState = getUpdatedState();
    if (isEmpty(newState)) {
      return;
    }
    setState(prevState => {
      return updateState(prevState, newState);
    });
  }, [getUpdatedState]);
  const syncHeightWithFlushSync = () => {
    const newState = getUpdatedState();
    if (isEmpty(newState)) {
      return;
    }

    // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
    // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
    // Related issue - https://github.com/facebook/react/issues/24331
    react_dom.flushSync(() => {
      setState(prevState => {
        return updateState(prevState, newState);
      });
    });
  };
  react.useEffect(() => {
    const handleResize = (0,debounce/* default */.Z)(() => {
      renders.current = 0;

      // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
      // ResizeObserver's handler that runs because of the change in the layout is trying to
      // access a dom node that is no longer there (as the fallback component is being shown instead).
      // See https://github.com/mui/material-ui/issues/32640
      if (inputRef.current) {
        syncHeightWithFlushSync();
      }
    });
    let resizeObserver;
    const input = inputRef.current;
    const containerWindow = (0,ownerWindow/* default */.Z)(input);
    containerWindow.addEventListener('resize', handleResize);
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(input);
    }
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  });
  (0,useEnhancedEffect/* default */.Z)(() => {
    syncHeight();
  });
  react.useEffect(() => {
    renders.current = 0;
  }, [value]);
  const handleChange = event => {
    renders.current = 0;
    if (!isControlled) {
      syncHeight();
    }
    if (onChange) {
      onChange(event);
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("textarea", (0,esm_extends/* default */.Z)({
      value: value,
      onChange: handleChange,
      ref: handleRef
      // Apply the rows prop to get a "correct" first SSR paint
      ,
      rows: minRows,
      style: (0,esm_extends/* default */.Z)({
        height: state.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: state.overflow ? 'hidden' : undefined
      }, style)
    }, other)), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
      "aria-hidden": true,
      className: props.className,
      readOnly: true,
      ref: shadowRef,
      tabIndex: -1,
      style: (0,esm_extends/* default */.Z)({}, styles.shadow, style, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
 false ? 0 : void 0;
/* harmony default export */ var TextareaAutosize_TextareaAutosize = (TextareaAutosize);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/isHostComponent.js
var isHostComponent = __webpack_require__(28442);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/formControlState.js
var formControlState = __webpack_require__(15704);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControlContext.js
var FormControlContext = __webpack_require__(47167);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var utils_useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEnhancedEffect.js
var utils_useEnhancedEffect = __webpack_require__(58974);
// EXTERNAL MODULE: ./node_modules/@mui/material/GlobalStyles/GlobalStyles.js + 2 modules
var GlobalStyles = __webpack_require__(17297);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputBase/utils.js
var utils = __webpack_require__(5108);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputBase/inputBaseClasses.js
var inputBaseClasses = __webpack_require__(55827);
;// CONCATENATED MODULE: ./node_modules/@mui/material/InputBase/InputBase.js
'use client';




const InputBase_excluded = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"];


















const rootOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.formControl && styles.formControl, ownerState.startAdornment && styles.adornedStart, ownerState.endAdornment && styles.adornedEnd, ownerState.error && styles.error, ownerState.size === 'small' && styles.sizeSmall, ownerState.multiline && styles.multiline, ownerState.color && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], ownerState.fullWidth && styles.fullWidth, ownerState.hiddenLabel && styles.hiddenLabel];
};
const inputOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.input, ownerState.size === 'small' && styles.inputSizeSmall, ownerState.multiline && styles.inputMultiline, ownerState.type === 'search' && styles.inputTypeSearch, ownerState.startAdornment && styles.inputAdornedStart, ownerState.endAdornment && styles.inputAdornedEnd, ownerState.hiddenLabel && styles.inputHiddenLabel];
};
const useUtilityClasses = ownerState => {
  const {
    classes,
    color,
    disabled,
    error,
    endAdornment,
    focused,
    formControl,
    fullWidth,
    hiddenLabel,
    multiline,
    readOnly,
    size,
    startAdornment,
    type
  } = ownerState;
  const slots = {
    root: ['root', `color${(0,capitalize/* default */.Z)(color)}`, disabled && 'disabled', error && 'error', fullWidth && 'fullWidth', focused && 'focused', formControl && 'formControl', size === 'small' && 'sizeSmall', multiline && 'multiline', startAdornment && 'adornedStart', endAdornment && 'adornedEnd', hiddenLabel && 'hiddenLabel', readOnly && 'readOnly'],
    input: ['input', disabled && 'disabled', type === 'search' && 'inputTypeSearch', multiline && 'inputMultiline', size === 'small' && 'inputSizeSmall', hiddenLabel && 'inputHiddenLabel', startAdornment && 'inputAdornedStart', endAdornment && 'inputAdornedEnd', readOnly && 'readOnly']
  };
  return (0,composeClasses/* default */.Z)(slots, inputBaseClasses/* getInputBaseUtilityClass */.u, classes);
};
const InputBaseRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiInputBase',
  slot: 'Root',
  overridesResolver: rootOverridesResolver
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({}, theme.typography.body1, {
  color: (theme.vars || theme).palette.text.primary,
  lineHeight: '1.4375em',
  // 23px
  boxSizing: 'border-box',
  // Prevent padding issue with fullWidth.
  position: 'relative',
  cursor: 'text',
  display: 'inline-flex',
  alignItems: 'center',
  [`&.${inputBaseClasses/* default.disabled */.Z.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled,
    cursor: 'default'
  }
}, ownerState.multiline && (0,esm_extends/* default */.Z)({
  padding: '4px 0 5px'
}, ownerState.size === 'small' && {
  paddingTop: 1
}), ownerState.fullWidth && {
  width: '100%'
}));
const InputBaseComponent = (0,styled/* default */.ZP)('input', {
  name: 'MuiInputBase',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const placeholder = (0,esm_extends/* default */.Z)({
    color: 'currentColor'
  }, theme.vars ? {
    opacity: theme.vars.opacity.inputPlaceholder
  } : {
    opacity: light ? 0.42 : 0.5
  }, {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  });
  const placeholderHidden = {
    opacity: '0 !important'
  };
  const placeholderVisible = theme.vars ? {
    opacity: theme.vars.opacity.inputPlaceholder
  } : {
    opacity: light ? 0.42 : 0.5
  };
  return (0,esm_extends/* default */.Z)({
    font: 'inherit',
    letterSpacing: 'inherit',
    color: 'currentColor',
    padding: '4px 0 5px',
    border: 0,
    boxSizing: 'content-box',
    background: 'none',
    height: '1.4375em',
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: 'transparent',
    display: 'block',
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: '100%',
    // Fix IE11 width issue
    animationName: 'mui-auto-fill-cancel',
    animationDuration: '10ms',
    '&::-webkit-input-placeholder': placeholder,
    '&::-moz-placeholder': placeholder,
    // Firefox 19+
    '&:-ms-input-placeholder': placeholder,
    // IE11
    '&::-ms-input-placeholder': placeholder,
    // Edge
    '&:focus': {
      outline: 0
    },
    // Reset Firefox invalid required input style
    '&:invalid': {
      boxShadow: 'none'
    },
    '&::-webkit-search-decoration': {
      // Remove the padding when type=search.
      WebkitAppearance: 'none'
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses/* default.formControl */.Z.formControl} &`]: {
      '&::-webkit-input-placeholder': placeholderHidden,
      '&::-moz-placeholder': placeholderHidden,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholderHidden,
      // IE11
      '&::-ms-input-placeholder': placeholderHidden,
      // Edge
      '&:focus::-webkit-input-placeholder': placeholderVisible,
      '&:focus::-moz-placeholder': placeholderVisible,
      // Firefox 19+
      '&:focus:-ms-input-placeholder': placeholderVisible,
      // IE11
      '&:focus::-ms-input-placeholder': placeholderVisible // Edge
    },

    [`&.${inputBaseClasses/* default.disabled */.Z.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
    },

    '&:-webkit-autofill': {
      animationDuration: '5000s',
      animationName: 'mui-auto-fill'
    }
  }, ownerState.size === 'small' && {
    paddingTop: 1
  }, ownerState.multiline && {
    height: 'auto',
    resize: 'none',
    padding: 0,
    paddingTop: 0
  }, ownerState.type === 'search' && {
    // Improve type search style.
    MozAppearance: 'textfield'
  });
});
const inputGlobalStyles = /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
  styles: {
    '@keyframes mui-auto-fill': {
      from: {
        display: 'block'
      }
    },
    '@keyframes mui-auto-fill-cancel': {
      from: {
        display: 'block'
      }
    }
  }
});

/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */
const InputBase = /*#__PURE__*/react.forwardRef(function InputBase(inProps, ref) {
  var _slotProps$input;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiInputBase'
  });
  const {
      'aria-describedby': ariaDescribedby,
      autoComplete,
      autoFocus,
      className,
      components = {},
      componentsProps = {},
      defaultValue,
      disabled,
      disableInjectingGlobalStyles,
      endAdornment,
      fullWidth = false,
      id,
      inputComponent = 'input',
      inputProps: inputPropsProp = {},
      inputRef: inputRefProp,
      maxRows,
      minRows,
      multiline = false,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      onKeyDown,
      onKeyUp,
      placeholder,
      readOnly,
      renderSuffix,
      rows,
      slotProps = {},
      slots = {},
      startAdornment,
      type = 'text',
      value: valueProp
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, InputBase_excluded);
  const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
  const {
    current: isControlled
  } = react.useRef(value != null);
  const inputRef = react.useRef();
  const handleInputRefWarning = react.useCallback(instance => {
    if (false) {}
  }, []);
  const handleInputRef = (0,utils_useForkRef/* default */.Z)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
  const [focused, setFocused] = react.useState(false);
  const muiFormControl = (0,useFormControl/* default */.Z)();
  if (false) {}
  const fcs = (0,formControlState/* default */.Z)({
    props,
    muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'size', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused;

  // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.
  react.useEffect(() => {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);
      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  const onFilled = muiFormControl && muiFormControl.onFilled;
  const onEmpty = muiFormControl && muiFormControl.onEmpty;
  const checkDirty = react.useCallback(obj => {
    if ((0,utils/* isFilled */.vd)(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  (0,utils_useEnhancedEffect/* default */.Z)(() => {
    if (isControlled) {
      checkDirty({
        value
      });
    }
  }, [value, checkDirty, isControlled]);
  const handleFocus = event => {
    // Fix a bug with IE11 where the focus/blur events are triggered
    // while the component is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }
    if (onFocus) {
      onFocus(event);
    }
    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };
  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };
  const handleChange = (event, ...args) => {
    if (!isControlled) {
      const element = event.target || inputRef.current;
      if (element == null) {
        throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(1));
      }
      checkDirty({
        value: element.value
      });
    }
    if (inputPropsProp.onChange) {
      inputPropsProp.onChange(event, ...args);
    }

    // Perform in the willUpdate
    if (onChange) {
      onChange(event, ...args);
    }
  };

  // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).
  react.useEffect(() => {
    checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClick = event => {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }
    if (onClick && !fcs.disabled) {
      onClick(event);
    }
  };
  let InputComponent = inputComponent;
  let inputProps = inputPropsProp;
  if (multiline && InputComponent === 'input') {
    if (rows) {
      if (false) {}
      inputProps = (0,esm_extends/* default */.Z)({
        type: undefined,
        minRows: rows,
        maxRows: rows
      }, inputProps);
    } else {
      inputProps = (0,esm_extends/* default */.Z)({
        type: undefined,
        maxRows,
        minRows
      }, inputProps);
    }
    InputComponent = TextareaAutosize_TextareaAutosize;
  }
  const handleAutoFill = event => {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };
  react.useEffect(() => {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color: fcs.color || 'primary',
    disabled: fcs.disabled,
    endAdornment,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    startAdornment,
    type
  });
  const classes = useUtilityClasses(ownerState);
  const Root = slots.root || components.Root || InputBaseRoot;
  const rootProps = slotProps.root || componentsProps.root || {};
  const Input = slots.input || components.Input || InputBaseComponent;
  inputProps = (0,esm_extends/* default */.Z)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [!disableInjectingGlobalStyles && inputGlobalStyles, /*#__PURE__*/(0,jsx_runtime.jsxs)(Root, (0,esm_extends/* default */.Z)({}, rootProps, !(0,isHostComponent/* default */.Z)(Root) && {
      ownerState: (0,esm_extends/* default */.Z)({}, ownerState, rootProps.ownerState)
    }, {
      ref: ref,
      onClick: handleClick
    }, other, {
      className: (0,clsx_m/* default */.Z)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
      children: [startAdornment, /*#__PURE__*/(0,jsx_runtime.jsx)(FormControlContext/* default.Provider */.Z.Provider, {
        value: null,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input, (0,esm_extends/* default */.Z)({
          ownerState: ownerState,
          "aria-invalid": fcs.error,
          "aria-describedby": ariaDescribedby,
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          defaultValue: defaultValue,
          disabled: fcs.disabled,
          id: id,
          onAnimationStart: handleAutoFill,
          name: name,
          placeholder: placeholder,
          readOnly: readOnly,
          required: fcs.required,
          rows: rows,
          value: value,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          type: type
        }, inputProps, !(0,isHostComponent/* default */.Z)(Input) && {
          as: InputComponent,
          ownerState: (0,esm_extends/* default */.Z)({}, ownerState, inputProps.ownerState)
        }, {
          ref: handleInputRef,
          className: (0,clsx_m/* default */.Z)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
          onBlur: handleBlur,
          onChange: handleChange,
          onFocus: handleFocus
        }))
      }), endAdornment, renderSuffix ? renderSuffix((0,esm_extends/* default */.Z)({}, fcs, {
        startAdornment
      })) : null]
    }))]
  });
});
 false ? 0 : void 0;
/* harmony default export */ var InputBase_InputBase = (InputBase);

/***/ }),

/***/ 55827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getInputBaseUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);


function getInputBaseUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiInputBase', slot);
}
const inputBaseClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiInputBase', ['root', 'formControl', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'colorSecondary', 'fullWidth', 'hiddenLabel', 'readOnly', 'input', 'inputSizeSmall', 'inputMultiline', 'inputTypeSearch', 'inputAdornedStart', 'inputAdornedEnd', 'inputHiddenLabel']);
/* harmony default export */ __webpack_exports__["Z"] = (inputBaseClasses);

/***/ }),

/***/ 5108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B7": function() { return /* binding */ isAdornedStart; },
/* harmony export */   "vd": function() { return /* binding */ isFilled; }
/* harmony export */ });
/* unused harmony export hasValue */
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
}

// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isFilled(obj, SSR = false) {
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}

// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function isAdornedStart(obj) {
  return obj.startAdornment;
}

/***/ }),

/***/ 33841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InputLabel_InputLabel; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/formControlState.js
var formControlState = __webpack_require__(15704);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormLabel/formLabelClasses.js


function getFormLabelUtilityClasses(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiFormLabel', slot);
}
const formLabelClasses = (0,generateUtilityClasses/* default */.Z)('MuiFormLabel', ['root', 'colorSecondary', 'focused', 'disabled', 'error', 'filled', 'required', 'asterisk']);
/* harmony default export */ var FormLabel_formLabelClasses = (formLabelClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormLabel/FormLabel.js
'use client';



const _excluded = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"];











const useUtilityClasses = ownerState => {
  const {
    classes,
    color,
    focused,
    disabled,
    error,
    filled,
    required
  } = ownerState;
  const slots = {
    root: ['root', `color${(0,capitalize/* default */.Z)(color)}`, disabled && 'disabled', error && 'error', filled && 'filled', focused && 'focused', required && 'required'],
    asterisk: ['asterisk', error && 'error']
  };
  return (0,composeClasses/* default */.Z)(slots, getFormLabelUtilityClasses, classes);
};
const FormLabelRoot = (0,styled/* default */.ZP)('label', {
  name: 'MuiFormLabel',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return (0,esm_extends/* default */.Z)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.secondary
}, theme.typography.body1, {
  lineHeight: '1.4375em',
  padding: 0,
  position: 'relative',
  [`&.${FormLabel_formLabelClasses.focused}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${FormLabel_formLabelClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${FormLabel_formLabelClasses.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const AsteriskComponent = (0,styled/* default */.ZP)('span', {
  name: 'MuiFormLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${FormLabel_formLabelClasses.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const FormLabel = /*#__PURE__*/react.forwardRef(function FormLabel(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiFormLabel'
  });
  const {
      children,
      className,
      component = 'label'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const muiFormControl = (0,useFormControl/* default */.Z)();
  const fcs = (0,formControlState/* default */.Z)({
    props,
    muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color: fcs.color || 'primary',
    component,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormLabelRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: [children, fcs.required && /*#__PURE__*/(0,jsx_runtime.jsxs)(AsteriskComponent, {
      ownerState: ownerState,
      "aria-hidden": true,
      className: classes.asterisk,
      children: ["\u2009", '*']
    })]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var FormLabel_FormLabel = (FormLabel);
;// CONCATENATED MODULE: ./node_modules/@mui/material/InputLabel/inputLabelClasses.js


function getInputLabelUtilityClasses(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiInputLabel', slot);
}
const inputLabelClasses = (0,generateUtilityClasses/* default */.Z)('MuiInputLabel', ['root', 'focused', 'disabled', 'error', 'required', 'asterisk', 'formControl', 'sizeSmall', 'shrink', 'animated', 'standard', 'filled', 'outlined']);
/* harmony default export */ var InputLabel_inputLabelClasses = ((/* unused pure expression or super */ null && (inputLabelClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js
'use client';



const InputLabel_excluded = ["disableAnimation", "margin", "shrink", "variant", "className"];











const InputLabel_useUtilityClasses = ownerState => {
  const {
    classes,
    formControl,
    size,
    shrink,
    disableAnimation,
    variant,
    required
  } = ownerState;
  const slots = {
    root: ['root', formControl && 'formControl', !disableAnimation && 'animated', shrink && 'shrink', size === 'small' && 'sizeSmall', variant],
    asterisk: [required && 'asterisk']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getInputLabelUtilityClasses, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const InputLabelRoot = (0,styled/* default */.ZP)(FormLabel_FormLabel, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiInputLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${FormLabel_formLabelClasses.asterisk}`]: styles.asterisk
    }, styles.root, ownerState.formControl && styles.formControl, ownerState.size === 'small' && styles.sizeSmall, ownerState.shrink && styles.shrink, !ownerState.disableAnimation && styles.animated, styles[ownerState.variant]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'block',
  transformOrigin: 'top left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
}, ownerState.formControl && {
  position: 'absolute',
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: 'translate(0, 20px) scale(1)'
}, ownerState.size === 'small' && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: 'translate(0, 17px) scale(1)'
}, ownerState.shrink && {
  transform: 'translate(0, -1.5px) scale(0.75)',
  transformOrigin: 'top left',
  maxWidth: '133%'
}, !ownerState.disableAnimation && {
  transition: theme.transitions.create(['color', 'transform', 'max-width'], {
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.variant === 'filled' && (0,esm_extends/* default */.Z)({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(12px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 13px) scale(1)'
}, ownerState.shrink && (0,esm_extends/* default */.Z)({
  userSelect: 'none',
  pointerEvents: 'auto',
  transform: 'translate(12px, 7px) scale(0.75)',
  maxWidth: 'calc(133% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 4px) scale(0.75)'
})), ownerState.variant === 'outlined' && (0,esm_extends/* default */.Z)({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(14px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(14px, 9px) scale(1)'
}, ownerState.shrink && {
  userSelect: 'none',
  pointerEvents: 'auto',
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: 'calc(133% - 32px)',
  transform: 'translate(14px, -9px) scale(0.75)'
})));
const InputLabel = /*#__PURE__*/react.forwardRef(function InputLabel(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    name: 'MuiInputLabel',
    props: inProps
  });
  const {
      disableAnimation = false,
      shrink: shrinkProp,
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, InputLabel_excluded);
  const muiFormControl = (0,useFormControl/* default */.Z)();
  let shrink = shrinkProp;
  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }
  const fcs = (0,formControlState/* default */.Z)({
    props,
    muiFormControl,
    states: ['size', 'variant', 'required']
  });
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableAnimation,
    formControl: muiFormControl,
    shrink,
    size: fcs.size,
    variant: fcs.variant,
    required: fcs.required
  });
  const classes = InputLabel_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InputLabelRoot, (0,esm_extends/* default */.Z)({
    "data-shrink": shrink,
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other, {
    classes: classes
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var InputLabel_InputLabel = (InputLabel);

/***/ }),

/***/ 23795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(79674);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/linkClasses.js


function getLinkUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiLink', slot);
}
const linkClasses = (0,generateUtilityClasses/* default */.Z)('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
/* harmony default export */ var Link_linkClasses = (linkClasses);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/getTextDecoration.js

const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};
const getTextDecoration = ({
  theme,
  ownerState
}) => {
  const transformedColor = transformDeprecatedColors(ownerState.color);
  const color = (0,style/* getPath */.DW)(theme, `palette.${transformedColor}`, false) || ownerState.color;
  const channelColor = (0,style/* getPath */.DW)(theme, `palette.${transformedColor}Channel`);
  if ('vars' in theme && channelColor) {
    return `rgba(${channelColor} / 0.4)`;
  }
  return (0,colorManipulator/* alpha */.Fq)(color, 0.4);
};
/* harmony default export */ var Link_getTextDecoration = (getTextDecoration);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/Link.js
'use client';



const _excluded = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"];














const useUtilityClasses = ownerState => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ['root', `underline${(0,capitalize/* default */.Z)(underline)}`, component === 'button' && 'button', focusVisible && 'focusVisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getLinkUtilityClass, classes);
};
const LinkRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiLink',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`underline${(0,capitalize/* default */.Z)(ownerState.underline)}`], ownerState.component === 'button' && styles.button];
  }
})(({
  theme,
  ownerState
}) => {
  return (0,esm_extends/* default */.Z)({}, ownerState.underline === 'none' && {
    textDecoration: 'none'
  }, ownerState.underline === 'hover' && {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }, ownerState.underline === 'always' && (0,esm_extends/* default */.Z)({
    textDecoration: 'underline'
  }, ownerState.color !== 'inherit' && {
    textDecorationColor: Link_getTextDecoration({
      theme,
      ownerState
    })
  }, {
    '&:hover': {
      textDecorationColor: 'inherit'
    }
  }), ownerState.component === 'button' && {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.
    },

    [`&.${Link_linkClasses.focusVisible}`]: {
      outline: 'auto'
    }
  });
});
const Link = /*#__PURE__*/react.forwardRef(function Link(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiLink'
  });
  const {
      className,
      color = 'primary',
      component = 'a',
      onBlur,
      onFocus,
      TypographyClasses,
      underline = 'always',
      variant = 'inherit',
      sx
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  const [focusVisible, setFocusVisible] = react.useState(false);
  const handlerRef = (0,useForkRef/* default */.Z)(ref, focusVisibleRef);
  const handleBlur = event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  const handleFocus = event => {
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    focusVisible,
    underline,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRoot, (0,esm_extends/* default */.Z)({
    color: color,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    classes: TypographyClasses,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    ownerState: ownerState,
    variant: variant,
    sx: [...(!Object.keys(colorTransformations).includes(color) ? [{
      color
    }] : []), ...(Array.isArray(sx) ? sx : [sx])]
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Link_Link = (Link);

/***/ }),

/***/ 78462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ List_List; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/ListContext.js
var ListContext = __webpack_require__(59773);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/List/listClasses.js


function getListUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiList', slot);
}
const listClasses = (0,generateUtilityClasses/* default */.Z)('MuiList', ['root', 'padding', 'dense', 'subheader']);
/* harmony default export */ var List_listClasses = ((/* unused pure expression or super */ null && (listClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/List/List.js
'use client';



const _excluded = ["children", "className", "component", "dense", "disablePadding", "subheader"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    disablePadding,
    dense,
    subheader
  } = ownerState;
  const slots = {
    root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
  };
  return (0,composeClasses/* default */.Z)(slots, getListUtilityClass, classes);
};
const ListRoot = (0,styled/* default */.ZP)('ul', {
  name: 'MuiList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  position: 'relative'
}, !ownerState.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.subheader && {
  paddingTop: 0
}));
const List = /*#__PURE__*/react.forwardRef(function List(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiList'
  });
  const {
      children,
      className,
      component = 'ul',
      dense = false,
      disablePadding = false,
      subheader
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const context = react.useMemo(() => ({
    dense
  }), [dense]);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    dense,
    disablePadding
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListContext/* default.Provider */.Z.Provider, {
    value: context,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ListRoot, (0,esm_extends/* default */.Z)({
      as: component,
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [subheader, children]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var List_List = (List);

/***/ }),

/***/ 59773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



/**
 * @ignore - internal component.
 */
const ListContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (ListContext);

/***/ }),

/***/ 19294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ ListItem_ListItem; }
});

// UNUSED EXPORTS: ListItemRoot, overridesResolver

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/isHostComponent.js
var isHostComponent = __webpack_require__(28442);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(71579);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(58974);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/ListContext.js
var ListContext = __webpack_require__(59773);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListItem/listItemClasses.js


function getListItemUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiListItem', slot);
}
const listItemClasses = (0,generateUtilityClasses/* default */.Z)('MuiListItem', ['root', 'container', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'padding', 'button', 'secondaryAction', 'selected']);
/* harmony default export */ var ListItem_listItemClasses = (listItemClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/listItemButtonClasses.js
var listItemButtonClasses = __webpack_require__(68686);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemSecondaryAction/ListItemSecondaryAction.js + 1 modules
var ListItemSecondaryAction = __webpack_require__(93395);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListItem/ListItem.js
'use client';



const _excluded = ["className"],
  _excluded2 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"];


















const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters, !ownerState.disablePadding && styles.padding, ownerState.button && styles.button, ownerState.hasSecondaryAction && styles.secondaryAction];
};
const useUtilityClasses = ownerState => {
  const {
    alignItems,
    button,
    classes,
    dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', !disablePadding && 'padding', divider && 'divider', disabled && 'disabled', button && 'button', alignItems === 'flex-start' && 'alignItemsFlexStart', hasSecondaryAction && 'secondaryAction', selected && 'selected'],
    container: ['container']
  };
  return (0,composeClasses/* default */.Z)(slots, getListItemUtilityClass, classes);
};
const ListItemRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiListItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  width: '100%',
  boxSizing: 'border-box',
  textAlign: 'left'
}, !ownerState.disablePadding && (0,esm_extends/* default */.Z)({
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!ownerState.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!ownerState.secondaryAction && {
  [`& > .${listItemButtonClasses/* default.root */.Z.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${ListItem_listItemClasses.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${ListItem_listItemClasses.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${ListItem_listItemClasses.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${ListItem_listItemClasses.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.button && {
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${ListItem_listItemClasses.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  }
}, ownerState.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}));
const ListItemContainer = (0,styled/* default */.ZP)('li', {
  name: 'MuiListItem',
  slot: 'Container',
  overridesResolver: (props, styles) => styles.container
})({
  position: 'relative'
});

/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */
const ListItem = /*#__PURE__*/react.forwardRef(function ListItem(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiListItem'
  });
  const {
      alignItems = 'center',
      autoFocus = false,
      button = false,
      children: childrenProp,
      className,
      component: componentProp,
      components = {},
      componentsProps = {},
      ContainerComponent = 'li',
      ContainerProps: {
        className: ContainerClassName
      } = {},
      dense = false,
      disabled = false,
      disableGutters = false,
      disablePadding = false,
      divider = false,
      focusVisibleClassName,
      secondaryAction,
      selected = false,
      slotProps = {},
      slots = {}
    } = props,
    ContainerProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.ContainerProps, _excluded),
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);
  const context = react.useContext(ListContext/* default */.Z);
  const childContext = react.useMemo(() => ({
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  }), [alignItems, context.dense, dense, disableGutters]);
  const listItemRef = react.useRef(null);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);
  const children = react.Children.toArray(childrenProp);

  // v4 implementation, deprecated in v5, will be removed in v6
  const hasSecondaryAction = children.length && (0,isMuiElement/* default */.Z)(children[children.length - 1], ['ListItemSecondaryAction']);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    alignItems,
    autoFocus,
    button,
    dense: childContext.dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  });
  const classes = useUtilityClasses(ownerState);
  const handleRef = (0,useForkRef/* default */.Z)(listItemRef, ref);
  const Root = slots.root || components.Root || ListItemRoot;
  const rootProps = slotProps.root || componentsProps.root || {};
  const componentProps = (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, rootProps.className, className),
    disabled
  }, other);
  let Component = componentProp || 'li';
  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = (0,clsx_m/* default */.Z)(ListItem_listItemClasses.focusVisible, focusVisibleClassName);
    Component = ButtonBase/* default */.Z;
  }

  // v4 implementation, deprecated in v5, will be removed in v6
  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component;

    // Avoid nesting of li > li.
    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ListContext/* default.Provider */.Z.Provider, {
      value: childContext,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ListItemContainer, (0,esm_extends/* default */.Z)({
        as: ContainerComponent,
        className: (0,clsx_m/* default */.Z)(classes.container, ContainerClassName),
        ref: handleRef,
        ownerState: ownerState
      }, ContainerProps, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Root, (0,esm_extends/* default */.Z)({}, rootProps, !(0,isHostComponent/* default */.Z)(Root) && {
          as: Component,
          ownerState: (0,esm_extends/* default */.Z)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
          children: children
        })), children.pop()]
      }))
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListContext/* default.Provider */.Z.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Root, (0,esm_extends/* default */.Z)({}, rootProps, {
      as: Component,
      ref: handleRef
    }, !(0,isHostComponent/* default */.Z)(Root) && {
      ownerState: (0,esm_extends/* default */.Z)({}, ownerState, rootProps.ownerState)
    }, componentProps, {
      children: [children, secondaryAction && /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemSecondaryAction/* default */.Z, {
        children: secondaryAction
      })]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var ListItem_ListItem = (ListItem);

/***/ }),

/***/ 68686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getListItemButtonUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);


function getListItemButtonUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiListItemButton', slot);
}
const listItemButtonClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiListItemButton', ['root', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'selected']);
/* harmony default export */ __webpack_exports__["Z"] = (listItemButtonClasses);

/***/ }),

/***/ 48885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71657);
/* harmony import */ var _listItemIconClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84592);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59773);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["className"];









const useUtilityClasses = ownerState => {
  const {
    alignItems,
    classes
  } = ownerState;
  const slots = {
    root: ['root', alignItems === 'flex-start' && 'alignItemsFlexStart']
  };
  return (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _listItemIconClasses__WEBPACK_IMPORTED_MODULE_3__/* .getListItemIconUtilityClass */ .f, classes);
};
const ListItemIconRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)('div', {
  name: 'MuiListItemIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart];
  }
})(({
  theme,
  ownerState
}) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  minWidth: 56,
  color: (theme.vars || theme).palette.action.active,
  flexShrink: 0,
  display: 'inline-flex'
}, ownerState.alignItems === 'flex-start' && {
  marginTop: 8
}));

/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
const ListItemIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListItemIcon(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiListItemIcon'
  });
  const {
      className
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, _excluded);
  const context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, {
    alignItems: context.alignItems
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItemIconRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (ListItemIcon);

/***/ }),

/***/ 84592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getListItemIconUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);


function getListItemIconUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiListItemIcon', slot);
}
const listItemIconClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
/* harmony default export */ __webpack_exports__["Z"] = (listItemIconClasses);

/***/ }),

/***/ 93395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ListItemSecondaryAction_ListItemSecondaryAction; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/ListContext.js
var ListContext = __webpack_require__(59773);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListItemSecondaryAction/listItemSecondaryActionClasses.js


function getListItemSecondaryActionClassesUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiListItemSecondaryAction', slot);
}
const listItemSecondaryActionClasses = (0,generateUtilityClasses/* default */.Z)('MuiListItemSecondaryAction', ['root', 'disableGutters']);
/* harmony default export */ var ListItemSecondaryAction_listItemSecondaryActionClasses = ((/* unused pure expression or super */ null && (listItemSecondaryActionClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListItemSecondaryAction/ListItemSecondaryAction.js
'use client';



const _excluded = ["className"];









const useUtilityClasses = ownerState => {
  const {
    disableGutters,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disableGutters && 'disableGutters']
  };
  return (0,composeClasses/* default */.Z)(slots, getListItemSecondaryActionClassesUtilityClass, classes);
};
const ListItemSecondaryActionRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiListItemSecondaryAction',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.disableGutters && styles.disableGutters];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)'
}, ownerState.disableGutters && {
  right: 0
}));

/**
 * Must be used as the last child of ListItem to function properly.
 */
const ListItemSecondaryAction = /*#__PURE__*/react.forwardRef(function ListItemSecondaryAction(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiListItemSecondaryAction'
  });
  const {
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const context = react.useContext(ListContext/* default */.Z);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableGutters: context.disableGutters
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListItemSecondaryActionRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
/* harmony default export */ var ListItemSecondaryAction_ListItemSecondaryAction = (ListItemSecondaryAction);

/***/ }),

/***/ 26336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getListItemTextUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);


function getListItemTextUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiListItemText', slot);
}
const listItemTextClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiListItemText', ['root', 'multiline', 'dense', 'inset', 'primary', 'secondary']);
/* harmony default export */ __webpack_exports__["Z"] = (listItemTextClasses);

/***/ }),

/***/ 75438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ListSubheader_ListSubheader; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListSubheader/listSubheaderClasses.js


function getListSubheaderUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiListSubheader', slot);
}
const listSubheaderClasses = (0,generateUtilityClasses/* default */.Z)('MuiListSubheader', ['root', 'colorPrimary', 'colorInherit', 'gutters', 'inset', 'sticky']);
/* harmony default export */ var ListSubheader_listSubheaderClasses = ((/* unused pure expression or super */ null && (listSubheaderClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListSubheader/ListSubheader.js
'use client';



const _excluded = ["className", "color", "component", "disableGutters", "disableSticky", "inset"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    color,
    disableGutters,
    inset,
    disableSticky
  } = ownerState;
  const slots = {
    root: ['root', color !== 'default' && `color${(0,capitalize/* default */.Z)(color)}`, !disableGutters && 'gutters', inset && 'inset', !disableSticky && 'sticky']
  };
  return (0,composeClasses/* default */.Z)(slots, getListSubheaderUtilityClass, classes);
};
const ListSubheaderRoot = (0,styled/* default */.ZP)('li', {
  name: 'MuiListSubheader',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], !ownerState.disableGutters && styles.gutters, ownerState.inset && styles.inset, !ownerState.disableSticky && styles.sticky];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  boxSizing: 'border-box',
  lineHeight: '48px',
  listStyle: 'none',
  color: (theme.vars || theme).palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(14)
}, ownerState.color === 'primary' && {
  color: (theme.vars || theme).palette.primary.main
}, ownerState.color === 'inherit' && {
  color: 'inherit'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.inset && {
  paddingLeft: 72
}, !ownerState.disableSticky && {
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: (theme.vars || theme).palette.background.paper
}));
const ListSubheader = /*#__PURE__*/react.forwardRef(function ListSubheader(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiListSubheader'
  });
  const {
      className,
      color = 'default',
      component = 'li',
      disableGutters = false,
      disableSticky = false,
      inset = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    disableGutters,
    disableSticky,
    inset
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListSubheaderRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
ListSubheader.muiSkipListHighlight = true;
 false ? 0 : void 0;
/* harmony default export */ var ListSubheader_ListSubheader = (ListSubheader);

/***/ }),

/***/ 25464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Menu_Menu; }
});

// UNUSED EXPORTS: MenuPaper

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuList/MenuList.js + 1 modules
var MenuList = __webpack_require__(84118);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(14564);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Menu/menuClasses.js


function getMenuUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiMenu', slot);
}
const menuClasses = (0,generateUtilityClasses/* default */.Z)('MuiMenu', ['root', 'paper', 'list']);
/* harmony default export */ var Menu_menuClasses = ((/* unused pure expression or super */ null && (menuClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Menu/Menu.js
'use client';



const _excluded = ["onEntering"],
  _excluded2 = ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"];













const RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
const LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper'],
    list: ['list']
  };
  return (0,composeClasses/* default */.Z)(slots, getMenuUtilityClass, classes);
};
const MenuRoot = (0,styled/* default */.ZP)(Popover/* default */.ZP, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiMenu',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const MenuPaper = (0,styled/* default */.ZP)(Popover/* PopoverPaper */.XS, {
  name: 'MuiMenu',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: 'calc(100% - 96px)',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = (0,styled/* default */.ZP)(MenuList/* default */.Z, {
  name: 'MuiMenu',
  slot: 'List',
  overridesResolver: (props, styles) => styles.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Menu = /*#__PURE__*/react.forwardRef(function Menu(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiMenu'
  });
  const {
      autoFocus = true,
      children,
      disableAutoFocusItem = false,
      MenuListProps = {},
      onClose,
      open,
      PaperProps = {},
      PopoverClasses,
      transitionDuration = 'auto',
      TransitionProps: {
        onEntering
      } = {},
      variant = 'selectedMenu'
    } = props,
    TransitionProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.TransitionProps, _excluded),
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);
  const theme = (0,useTheme/* default */.Z)();
  const isRtl = theme.direction === 'rtl';
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    autoFocus,
    disableAutoFocusItem,
    MenuListProps,
    onEntering,
    PaperProps,
    transitionDuration,
    TransitionProps,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  const menuListActionsRef = react.useRef(null);
  const handleEntering = (element, isAppearing) => {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }
    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };
  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();
      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };

  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */
  let activeItemIndex = -1;
  // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback
  react.Children.map(children, (child, index) => {
    if (! /*#__PURE__*/react.isValidElement(child)) {
      return;
    }
    if (false) {}
    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuRoot, (0,esm_extends/* default */.Z)({
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: isRtl ? 'right' : 'left'
    },
    transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: MenuPaper
    },
    slotProps: {
      paper: (0,esm_extends/* default */.Z)({}, PaperProps, {
        classes: (0,esm_extends/* default */.Z)({}, PaperProps.classes, {
          root: classes.paper
        })
      })
    },
    className: classes.root,
    open: open,
    ref: ref,
    transitionDuration: transitionDuration,
    TransitionProps: (0,esm_extends/* default */.Z)({
      onEntering: handleEntering
    }, TransitionProps),
    ownerState: ownerState
  }, other, {
    classes: PopoverClasses,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuMenuList, (0,esm_extends/* default */.Z)({
      onKeyDown: handleListKeyDown,
      actions: menuListActionsRef,
      autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
      autoFocusItem: autoFocusItem,
      variant: variant
    }, MenuListProps, {
      className: (0,clsx_m/* default */.Z)(classes.list, MenuListProps.className),
      children: children
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Menu_Menu = (Menu);

/***/ }),

/***/ 18972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MenuItem_MenuItem; }
});

// UNUSED EXPORTS: overridesResolver

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/ListContext.js
var ListContext = __webpack_require__(59773);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(58974);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/dividerClasses.js
var dividerClasses = __webpack_require__(35097);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/listItemIconClasses.js
var listItemIconClasses = __webpack_require__(84592);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/listItemTextClasses.js
var listItemTextClasses = __webpack_require__(26336);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/MenuItem/menuItemClasses.js


function getMenuItemUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiMenuItem', slot);
}
const menuItemClasses = (0,generateUtilityClasses/* default */.Z)('MuiMenuItem', ['root', 'focusVisible', 'dense', 'disabled', 'divider', 'gutters', 'selected']);
/* harmony default export */ var MenuItem_menuItemClasses = (menuItemClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
'use client';



const _excluded = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"];
















const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};
const useUtilityClasses = ownerState => {
  const {
    disabled,
    dense,
    divider,
    disableGutters,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', disabled && 'disabled', !disableGutters && 'gutters', divider && 'divider', selected && 'selected']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getMenuItemUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const MenuItemRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiMenuItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({}, theme.typography.body1, {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: 'border-box',
  whiteSpace: 'nowrap'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, {
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${MenuItem_menuItemClasses.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${MenuItem_menuItemClasses.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${MenuItem_menuItemClasses.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${MenuItem_menuItemClasses.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${MenuItem_menuItemClasses.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses/* default.root */.Z.root}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  [`& + .${dividerClasses/* default.inset */.Z.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses/* default.root */.Z.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses/* default.inset */.Z.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses/* default.root */.Z.root}`]: {
    minWidth: 36
  }
}, !ownerState.dense && {
  [theme.breakpoints.up('sm')]: {
    minHeight: 'auto'
  }
}, ownerState.dense && (0,esm_extends/* default */.Z)({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, theme.typography.body2, {
  [`& .${listItemIconClasses/* default.root */.Z.root} svg`]: {
    fontSize: '1.25rem'
  }
})));
const MenuItem = /*#__PURE__*/react.forwardRef(function MenuItem(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiMenuItem'
  });
  const {
      autoFocus = false,
      component = 'li',
      dense = false,
      divider = false,
      disableGutters = false,
      focusVisibleClassName,
      role = 'menuitem',
      tabIndex: tabIndexProp,
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const context = react.useContext(ListContext/* default */.Z);
  const childContext = react.useMemo(() => ({
    dense: dense || context.dense || false,
    disableGutters
  }), [context.dense, dense, disableGutters]);
  const menuItemRef = react.useRef(null);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (autoFocus) {
      if (menuItemRef.current) {
        menuItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    dense: childContext.dense,
    divider,
    disableGutters
  });
  const classes = useUtilityClasses(props);
  const handleRef = (0,useForkRef/* default */.Z)(menuItemRef, ref);
  let tabIndex;
  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListContext/* default.Provider */.Z.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItemRoot, (0,esm_extends/* default */.Z)({
      ref: handleRef,
      role: role,
      tabIndex: tabIndex,
      component: component,
      focusVisibleClassName: (0,clsx_m/* default */.Z)(classes.focusVisible, focusVisibleClassName),
      className: (0,clsx_m/* default */.Z)(classes.root, className)
    }, other, {
      ownerState: ownerState,
      classes: classes
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var MenuItem_MenuItem = (MenuItem);

/***/ }),

/***/ 84118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MenuList_MenuList; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerDocument.js
var ownerDocument = __webpack_require__(8038);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/getScrollbarSize.js
var getScrollbarSize = __webpack_require__(95806);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/getScrollbarSize.js

/* harmony default export */ var utils_getScrollbarSize = (getScrollbarSize/* default */.Z);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(58974);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/MenuList/MenuList.js
'use client';



const _excluded = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];









function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }
  let text = nextFocus.innerText;
  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }
  text = text.trim().toLowerCase();
  if (text.length === 0) {
    return false;
  }
  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }
  return text.indexOf(textCriteria.keys.join('')) === 0;
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }
      wrappedOnce = true;
    }

    // Same logic as useAutocomplete.js
    const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }
  return false;
}

/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */
const MenuList = /*#__PURE__*/react.forwardRef(function MenuList(props, ref) {
  const {
      // private
      // eslint-disable-next-line react/prop-types
      actions,
      autoFocus = false,
      autoFocusItem = false,
      children,
      className,
      disabledItemsFocusable = false,
      disableListWrap = false,
      onKeyDown,
      variant = 'selectedMenu'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const listRef = react.useRef(null);
  const textCriteriaRef = react.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  react.useImperativeHandle(actions, () => ({
    adjustStyleForScrollbar: (containerElement, theme) => {
      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      const noExplicitWidth = !listRef.current.style.width;
      if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
        const scrollbarSize = `${utils_getScrollbarSize((0,ownerDocument/* default */.Z)(containerElement))}px`;
        listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
        listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
      }
      return listRef.current;
    }
  }), []);
  const handleKeyDown = event => {
    const list = listRef.current;
    const key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */
    const currentFocus = (0,ownerDocument/* default */.Z)(list).activeElement;
    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      const criteria = textCriteriaRef.current;
      const lowerKey = key.toLowerCase();
      const currTime = performance.now();
      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }
      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  const handleRef = (0,useForkRef/* default */.Z)(listRef, ref);

  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */
  let activeItemIndex = -1;
  // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback
  react.Children.forEach(children, (child, index) => {
    if (! /*#__PURE__*/react.isValidElement(child)) {
      if (activeItemIndex === index) {
        activeItemIndex += 1;
        if (activeItemIndex >= children.length) {
          // there are no focusable items within the list.
          activeItemIndex = -1;
        }
      }
      return;
    }
    if (false) {}
    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
    if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
      activeItemIndex += 1;
      if (activeItemIndex >= children.length) {
        // there are no focusable items within the list.
        activeItemIndex = -1;
      }
    }
  });
  const items = react.Children.map(children, (child, index) => {
    if (index === activeItemIndex) {
      const newChildProps = {};
      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }
      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }
      return /*#__PURE__*/react.cloneElement(child, newChildProps);
    }
    return child;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(List/* default */.Z, (0,esm_extends/* default */.Z)({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other, {
    children: items
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var MenuList_MenuList = (MenuList);

/***/ }),

/***/ 72908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ material_Modal_Modal; }
});

// UNUSED EXPORTS: modalClasses

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(33703);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerDocument/ownerDocument.js
var ownerDocument = __webpack_require__(82690);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js
var useEventCallback = __webpack_require__(59948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/createChainedFunction.js
var createChainedFunction = __webpack_require__(49064);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/Portal/Portal.js
var Portal = __webpack_require__(78385);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerWindow/ownerWindow.js
var ownerWindow = __webpack_require__(74161);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/getScrollbarSize.js
var getScrollbarSize = __webpack_require__(95806);
;// CONCATENATED MODULE: ./node_modules/@mui/base/Modal/ModalManager.js

// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  const doc = (0,ownerDocument/* default */.Z)(container);
  if (doc.body === container) {
    return (0,ownerWindow/* default */.Z)(container).innerWidth > doc.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}
function getPaddingRight(element) {
  return parseInt((0,ownerWindow/* default */.Z)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
  // The forbidden HTML tags are the ones from ARIA specification that
  // can be children of body and can't have aria-hidden attribute.
  // cf. https://www.w3.org/TR/html-aria/#docconformance
  const forbiddenTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE', 'LINK', 'MAP', 'META', 'NOSCRIPT', 'PICTURE', 'COL', 'COLGROUP', 'PARAM', 'SLOT', 'SOURCE', 'TRACK'];
  const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
  const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
  return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  [].forEach.call(container.children, element => {
    const isNotExcludedElement = blacklist.indexOf(element) === -1;
    const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, show);
    }
  });
}
function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index) => {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}
function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;
  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      const scrollbarSize = (0,getScrollbarSize/* default */.Z)((0,ownerDocument/* default */.Z)(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      });
      // Use computed style, here to get the real padding to add our scrollbar width.
      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;

      // .mui-fixed is a global helper.
      const fixedElements = (0,ownerDocument/* default */.Z)(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, element => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    }
    let scrollContainer;
    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = (0,ownerDocument/* default */.Z)(container).body;
    } else {
      // Improve Gatsby support
      // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
      const parent = container.parentElement;
      const containerWindow = (0,ownerWindow/* default */.Z)(container);
      scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
    }

    // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }
  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };
  return restore;
}
function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, element => {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }
  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);
    if (modalIndex !== -1) {
      return modalIndex;
    }
    modalIndex = this.modals.length;
    this.modals.push(modal);

    // If the modal we are adding is already in the DOM.
    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }
    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, item => item.container === container);
    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }
    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }
  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }
  remove(modal, ariaHiddenState = true) {
    const modalIndex = this.modals.indexOf(modal);
    if (modalIndex === -1) {
      return modalIndex;
    }
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1);

    // If that was the last modal in a container, clean up the container.
    if (containerInfo.modals.length === 0) {
      // The modal might be closed before it had the chance to be mounted in the DOM.
      if (containerInfo.restore) {
        containerInfo.restore();
      }
      if (modal.modalRef) {
        // In case the modal wasn't in the DOM yet.
        ariaHidden(modal.modalRef, ariaHiddenState);
      }
      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      // Otherwise make sure the next top modal is visible to a screen reader.
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
      // as soon as a modal is adding its modalRef is undefined. it can't set
      // aria-hidden because the dom element doesn't exist either
      // when modal was unmounted before modalRef gets null
      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }
    return modalIndex;
  }
  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/base/FocusTrap/FocusTrap.js
'use client';

/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */





// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');
function getTabIndex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  }

  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.
  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }
  return node.tabIndex;
}
function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }
  if (!node.name) {
    return false;
  }
  const getRadio = selector => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
  let roving = getRadio(`[name="${node.name}"]:checked`);
  if (!roving) {
    roving = getRadio(`[name="${node.name}"]`);
  }
  return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }
  return true;
}
function defaultGetTabbable(root) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
    const nodeTabIndex = getTabIndex(node);
    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }
    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node: node
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map(a => a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
  return true;
}

/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */
function FocusTrap(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = react.useRef(false);
  const sentinelStart = react.useRef(null);
  const sentinelEnd = react.useRef(null);
  const nodeToRestore = react.useRef(null);
  const reactFocusEventTarget = react.useRef(null);
  // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.
  const activated = react.useRef(false);
  const rootRef = react.useRef(null);
  // @ts-expect-error TODO upstream fix
  const handleRef = (0,useForkRef/* default */.Z)(children.ref, rootRef);
  const lastKeydown = react.useRef(null);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    const doc = (0,ownerDocument/* default */.Z)(rootRef.current);
    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {}
        rootRef.current.setAttribute('tabIndex', '-1');
      }
      if (activated.current) {
        rootRef.current.focus();
      }
    }
    return () => {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }
        nodeToRestore.current = null;
      }
    };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    const doc = (0,ownerDocument/* default */.Z)(rootRef.current);
    const contain = nativeEvent => {
      const {
        current: rootElement
      } = rootRef;

      // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.
      if (rootElement === null) {
        return;
      }
      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }
      if (!rootElement.contains(doc.activeElement)) {
        // if the focus event is not coming from inside the children's react tree, reset the refs
        if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) {
          reactFocusEventTarget.current = null;
        } else if (reactFocusEventTarget.current !== null) {
          return;
        }
        if (!activated.current) {
          return;
        }
        let tabbable = [];
        if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
          tabbable = getTabbable(rootRef.current);
        }
        if (tabbable.length > 0) {
          var _lastKeydown$current, _lastKeydown$current2;
          const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
          const focusNext = tabbable[0];
          const focusPrevious = tabbable[tabbable.length - 1];
          if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
            if (isShiftTab) {
              focusPrevious.focus();
            } else {
              focusNext.focus();
            }
          }
        } else {
          rootElement.focus();
        }
      }
    };
    const loopFocus = nativeEvent => {
      lastKeydown.current = nativeEvent;
      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      }

      // Make sure the next tab starts from the right place.
      // doc.activeElement refers to the origin.
      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        if (sentinelEnd.current) {
          sentinelEnd.current.focus();
        }
      }
    };
    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true);

    // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
    const interval = setInterval(() => {
      if (doc.activeElement && doc.activeElement.tagName === 'BODY') {
        contain(null);
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);
  const onFocus = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const handleFocusSentinel = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /*#__PURE__*/react.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ var FocusTrap_FocusTrap = (FocusTrap);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/base/Modal/modalClasses.js


function getModalUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiModal', slot);
}
const modalClasses = (0,generateUtilityClasses/* default */.Z)('MuiModal', ['root', 'hidden', 'backdrop']);
/* harmony default export */ var Modal_modalClasses = ((/* unused pure expression or super */ null && (modalClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 3 modules
var useSlotProps = __webpack_require__(18793);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/ClassNameConfigurator.js
var ClassNameConfigurator = __webpack_require__(31873);
;// CONCATENATED MODULE: ./node_modules/@mui/base/Modal/Modal.js
'use client';



const _excluded = ["children", "closeAfterTransition", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "onTransitionEnter", "onTransitionExited", "slotProps", "slots"];












const useUtilityClasses = ownerState => {
  const {
    open,
    exited
  } = ownerState;
  const slots = {
    root: ['root', !open && exited && 'hidden'],
    backdrop: ['backdrop']
  };
  return (0,composeClasses/* default */.Z)(slots, (0,ClassNameConfigurator/* useClassNamesOverride */.T)(getModalUtilityClass));
};
function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
function getHasTransition(children) {
  return children ? children.props.hasOwnProperty('in') : false;
}

// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const defaultManager = new ModalManager();

/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * *   [Dialog](https://mui.com/material-ui/api/dialog/)
 * *   [Drawer](https://mui.com/material-ui/api/drawer/)
 * *   [Menu](https://mui.com/material-ui/api/menu/)
 * *   [Popover](https://mui.com/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](https://mui.com/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/)
 *
 * API:
 *
 * - [Modal API](https://mui.com/base-ui/react-modal/components-api/#modal)
 */
const Modal = /*#__PURE__*/react.forwardRef(function Modal(props, forwardedRef) {
  var _props$ariaHidden, _slots$root;
  const {
      children,
      closeAfterTransition = false,
      container,
      disableAutoFocus = false,
      disableEnforceFocus = false,
      disableEscapeKeyDown = false,
      disablePortal = false,
      disableRestoreFocus = false,
      disableScrollLock = false,
      hideBackdrop = false,
      keepMounted = false,
      // private
      manager: managerProp = defaultManager,
      onBackdropClick,
      onClose,
      onKeyDown,
      open,
      onTransitionEnter,
      onTransitionExited,
      slotProps = {},
      slots = {}
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  // TODO: `modal`` must change its type in this file to match the type of methods
  // provided by `ModalManager`
  const manager = managerProp;
  const [exited, setExited] = react.useState(!open);
  const modal = react.useRef({});
  const mountNodeRef = react.useRef(null);
  const modalRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(modalRef, forwardedRef);
  const hasTransition = getHasTransition(children);
  const ariaHiddenProp = (_props$ariaHidden = props['aria-hidden']) != null ? _props$ariaHidden : true;
  const getDoc = () => (0,ownerDocument/* default */.Z)(mountNodeRef.current);
  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };
  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    });

    // Fix a bug on Chrome where the scroll isn't initially 0.
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  };
  const handleOpen = (0,useEventCallback/* default */.Z)(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer);

    // The element was already mounted.
    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = react.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = (0,useEventCallback/* default */.Z)(node => {
    mountNodeRef.current = node;
    if (!node || !modalRef.current) {
      return;
    }
    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, ariaHiddenProp);
    }
  });
  const handleClose = react.useCallback(() => {
    manager.remove(getModal(), ariaHiddenProp);
  }, [manager, ariaHiddenProp]);
  react.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  react.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    exited,
    hideBackdrop,
    keepMounted
  });
  const classes = useUtilityClasses(ownerState);
  const handleEnter = () => {
    setExited(false);
    if (onTransitionEnter) {
      onTransitionEnter();
    }
  };
  const handleExited = () => {
    setExited(true);
    if (onTransitionExited) {
      onTransitionExited();
    }
    if (closeAfterTransition) {
      handleClose();
    }
  };
  const handleBackdropClick = event => {
    if (event.target !== event.currentTarget) {
      return;
    }
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const handleKeyDown = event => {
    if (onKeyDown) {
      onKeyDown(event);
    }

    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }
    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();
      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };
  const childProps = {};
  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  }

  // It's a Transition like component
  if (hasTransition) {
    childProps.onEnter = (0,createChainedFunction/* default */.Z)(handleEnter, children.props.onEnter);
    childProps.onExited = (0,createChainedFunction/* default */.Z)(handleExited, children.props.onExited);
  }
  const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      ref: handleRef,
      role: 'presentation',
      onKeyDown: handleKeyDown
    },
    className: classes.root,
    ownerState
  });
  const BackdropComponent = slots.backdrop;
  const backdropProps = (0,useSlotProps/* default */.Z)({
    elementType: BackdropComponent,
    externalSlotProps: slotProps.backdrop,
    additionalProps: {
      'aria-hidden': true,
      onClick: handleBackdropClick,
      open
    },
    className: classes.backdrop,
    ownerState
  });
  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Portal/* default */.Z
  // @ts-expect-error TODO: include ref to Base UI Portal props
  , {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Root, (0,esm_extends/* default */.Z)({}, rootProps, {
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropComponent, (0,esm_extends/* default */.Z)({}, backdropProps)) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(FocusTrap_FocusTrap, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/react.cloneElement(children, childProps)
      })]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_Modal = (Modal);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/resolveComponentProps.js
var resolveComponentProps = __webpack_require__(71276);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/isHostComponent.js
var isHostComponent = __webpack_require__(28442);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(84808);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Modal/Modal.js
'use client';



const Modal_excluded = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "open", "slotProps", "slots", "theme"];










const Modal_Modal_modalClasses = (/* unused pure expression or super */ null && (modalUnstyledClasses));
const ModalRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  zIndex: (theme.vars || theme).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !ownerState.open && ownerState.exited && {
  visibility: 'hidden'
}));
const ModalBackdrop = (0,styled/* default */.ZP)(Backdrop/* default */.Z, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  }
})({
  zIndex: -1
});

/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
const Modal_Modal_Modal = /*#__PURE__*/react.forwardRef(function Modal(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
  const props = (0,useThemeProps/* default */.Z)({
    name: 'MuiModal',
    props: inProps
  });
  const {
      BackdropComponent = ModalBackdrop,
      BackdropProps,
      classes,
      className,
      closeAfterTransition = false,
      children,
      container,
      component,
      components = {},
      componentsProps = {},
      disableAutoFocus = false,
      disableEnforceFocus = false,
      disableEscapeKeyDown = false,
      disablePortal = false,
      disableRestoreFocus = false,
      disableScrollLock = false,
      hideBackdrop = false,
      keepMounted = false,
      onBackdropClick,
      onClose,
      open,
      slotProps,
      slots,
      // eslint-disable-next-line react/prop-types
      theme
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Modal_excluded);
  const [exited, setExited] = react.useState(true);
  const commonProps = {
    container,
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted,
    onBackdropClick,
    onClose,
    open
  };
  const ownerState = (0,esm_extends/* default */.Z)({}, props, commonProps, {
    exited
  });
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
  const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal_Modal, (0,esm_extends/* default */.Z)({
    slots: {
      root: RootSlot,
      backdrop: BackdropSlot
    },
    slotProps: {
      root: () => (0,esm_extends/* default */.Z)({}, (0,resolveComponentProps/* default */.Z)(rootSlotProps, ownerState), !(0,isHostComponent/* default */.Z)(RootSlot) && {
        as: component,
        theme
      }, {
        className: (0,clsx_m/* default */.Z)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
      }),
      backdrop: () => (0,esm_extends/* default */.Z)({}, BackdropProps, (0,resolveComponentProps/* default */.Z)(backdropSlotProps, ownerState), {
        className: (0,clsx_m/* default */.Z)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop)
      })
    },
    onTransitionEnter: () => setExited(false),
    onTransitionExited: () => setExited(true),
    ref: ref
  }, other, commonProps, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var material_Modal_Modal = (Modal_Modal_Modal);

/***/ }),

/***/ 57709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OutlinedInput_OutlinedInput; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/OutlinedInput/NotchedOutline.js
'use client';



var _span;
const _excluded = ["children", "classes", "className", "label", "notched"];




const NotchedOutlineRoot = (0,styled/* default */.ZP)('fieldset')({
  textAlign: 'left',
  position: 'absolute',
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: '0 8px',
  pointerEvents: 'none',
  borderRadius: 'inherit',
  borderStyle: 'solid',
  borderWidth: 1,
  overflow: 'hidden',
  minWidth: '0%'
});
const NotchedOutlineLegend = (0,styled/* default */.ZP)('legend')(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  float: 'unset',
  // Fix conflict with bootstrap
  width: 'auto',
  // Fix conflict with bootstrap
  overflow: 'hidden'
}, !ownerState.withLabel && {
  padding: 0,
  lineHeight: '11px',
  // sync with `height` in `legend` styles
  transition: theme.transitions.create('width', {
    duration: 150,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.withLabel && (0,esm_extends/* default */.Z)({
  display: 'block',
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: '0.75em',
  visibility: 'hidden',
  maxWidth: 0.01,
  transition: theme.transitions.create('max-width', {
    duration: 50,
    easing: theme.transitions.easing.easeOut
  }),
  whiteSpace: 'nowrap',
  '& > span': {
    paddingLeft: 5,
    paddingRight: 5,
    display: 'inline-block',
    opacity: 0,
    visibility: 'visible'
  }
}, ownerState.notched && {
  maxWidth: '100%',
  transition: theme.transitions.create('max-width', {
    duration: 100,
    easing: theme.transitions.easing.easeOut,
    delay: 50
  })
})));

/**
 * @ignore - internal component.
 */
function NotchedOutline(props) {
  const {
      className,
      label,
      notched
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const withLabel = label != null && label !== '';
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    notched,
    withLabel
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NotchedOutlineRoot, (0,esm_extends/* default */.Z)({
    "aria-hidden": true,
    className: className,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotchedOutlineLegend, {
      ownerState: ownerState,
      children: withLabel ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: label
      }) : // notranslate needed while Google Translate will not fix zero-width space issue
      _span || (_span = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "notranslate",
        children: "\u200B"
      }))
    })
  }));
}
 false ? 0 : void 0;
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/formControlState.js
var formControlState = __webpack_require__(15704);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/outlinedInputClasses.js
var outlinedInputClasses = __webpack_require__(54656);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(13970);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
;// CONCATENATED MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js
'use client';



const OutlinedInput_excluded = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"];













const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    notchedOutline: ['notchedOutline'],
    input: ['input']
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, outlinedInputClasses/* getOutlinedInputUtilityClass */.e, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const OutlinedInputRoot = (0,styled/* default */.ZP)(InputBase/* InputBaseRoot */.Ej, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiOutlinedInput',
  slot: 'Root',
  overridesResolver: InputBase/* rootOverridesResolver */.Gx
})(({
  theme,
  ownerState
}) => {
  const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return (0,esm_extends/* default */.Z)({
    position: 'relative',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    [`&:hover .${outlinedInputClasses/* default.notchedOutline */.Z.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      [`&:hover .${outlinedInputClasses/* default.notchedOutline */.Z.notchedOutline}`]: {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
      }
    },
    [`&.${outlinedInputClasses/* default.focused */.Z.focused} .${outlinedInputClasses/* default.notchedOutline */.Z.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette[ownerState.color].main,
      borderWidth: 2
    },
    [`&.${outlinedInputClasses/* default.error */.Z.error} .${outlinedInputClasses/* default.notchedOutline */.Z.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.error.main
    },
    [`&.${outlinedInputClasses/* default.disabled */.Z.disabled} .${outlinedInputClasses/* default.notchedOutline */.Z.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.action.disabled
    }
  }, ownerState.startAdornment && {
    paddingLeft: 14
  }, ownerState.endAdornment && {
    paddingRight: 14
  }, ownerState.multiline && (0,esm_extends/* default */.Z)({
    padding: '16.5px 14px'
  }, ownerState.size === 'small' && {
    padding: '8.5px 14px'
  }));
});
const OutlinedInput_NotchedOutlineRoot = (0,styled/* default */.ZP)(NotchedOutline, {
  name: 'MuiOutlinedInput',
  slot: 'NotchedOutline',
  overridesResolver: (props, styles) => styles.notchedOutline
})(({
  theme
}) => {
  const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
  };
});
const OutlinedInputInput = (0,styled/* default */.ZP)(InputBase/* InputBaseComponent */.rA, {
  name: 'MuiOutlinedInput',
  slot: 'Input',
  overridesResolver: InputBase/* inputOverridesResolver */._o
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  padding: '16.5px 14px'
}, !theme.vars && {
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderRadius: 'inherit'
  }
}, theme.vars && {
  '&:-webkit-autofill': {
    borderRadius: 'inherit'
  },
  [theme.getColorSchemeSelector('dark')]: {
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #266798 inset',
      WebkitTextFillColor: '#fff',
      caretColor: '#fff'
    }
  }
}, ownerState.size === 'small' && {
  padding: '8.5px 14px'
}, ownerState.multiline && {
  padding: 0
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}));
const OutlinedInput = /*#__PURE__*/react.forwardRef(function OutlinedInput(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiOutlinedInput'
  });
  const {
      components = {},
      fullWidth = false,
      inputComponent = 'input',
      label,
      multiline = false,
      notched,
      slots = {},
      type = 'text'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, OutlinedInput_excluded);
  const classes = useUtilityClasses(props);
  const muiFormControl = (0,useFormControl/* default */.Z)();
  const fcs = (0,formControlState/* default */.Z)({
    props,
    muiFormControl,
    states: ['color', 'disabled', 'error', 'focused', 'hiddenLabel', 'size', 'required']
  });
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color: fcs.color || 'primary',
    disabled: fcs.disabled,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    type
  });
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : OutlinedInputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : OutlinedInputInput;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InputBase/* default */.ZP, (0,esm_extends/* default */.Z)({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    renderSuffix: state => /*#__PURE__*/(0,jsx_runtime.jsx)(OutlinedInput_NotchedOutlineRoot, {
      ownerState: ownerState,
      className: classes.notchedOutline,
      label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [label, "\u2009", '*']
      })) : label,
      notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: (0,esm_extends/* default */.Z)({}, classes, {
      notchedOutline: null
    })
  }));
});
 false ? 0 : void 0;
OutlinedInput.muiName = 'Input';
/* harmony default export */ var OutlinedInput_OutlinedInput = (OutlinedInput);

/***/ }),

/***/ 54656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getOutlinedInputUtilityClass; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1588);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);
/* harmony import */ var _InputBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55827);




function getOutlinedInputUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiOutlinedInput', slot);
}
const outlinedInputClasses = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _InputBase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_mui_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)('MuiOutlinedInput', ['root', 'notchedOutline', 'input']));
/* harmony default export */ __webpack_exports__["Z"] = (outlinedInputClasses);

/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paper_Paper; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/getOverlayAlpha.js
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const getOverlayAlpha = elevation => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
/* harmony default export */ var styles_getOverlayAlpha = (getOverlayAlpha);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/paperClasses.js


function getPaperUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPaper', slot);
}
const paperClasses = (0,generateUtilityClasses/* default */.Z)('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
/* harmony default export */ var Paper_paperClasses = ((/* unused pure expression or super */ null && (paperClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/Paper.js
'use client';



const _excluded = ["className", "component", "elevation", "square", "variant"];












const useUtilityClasses = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getPaperUtilityClass, classes);
};
const PaperRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return (0,esm_extends/* default */.Z)({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && (0,esm_extends/* default */.Z)({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))}, ${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /*#__PURE__*/react.forwardRef(function Paper(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPaper'
  });
  const {
      className,
      component = 'div',
      elevation = 1,
      square = false,
      variant = 'elevation'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    elevation,
    square,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  if (false) {}
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PaperRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Paper_Paper = (Paper);

/***/ }),

/***/ 14564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XS": function() { return /* binding */ PopoverPaper; },
  "ZP": function() { return /* binding */ Popover_Popover; }
});

// UNUSED EXPORTS: PopoverRoot, getOffsetLeft, getOffsetTop

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 3 modules
var useSlotProps = __webpack_require__(18793);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/isHostComponent.js
var isHostComponent = __webpack_require__(28442);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerDocument.js
var ownerDocument = __webpack_require__(8038);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerWindow.js
var ownerWindow = __webpack_require__(5340);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(96514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(72908);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Popover/popoverClasses.js


function getPopoverUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPopover', slot);
}
const popoverClasses = (0,generateUtilityClasses/* default */.Z)('MuiPopover', ['root', 'paper']);
/* harmony default export */ var Popover_popoverClasses = ((/* unused pure expression or super */ null && (popoverClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Popover/Popover.js
'use client';



const _excluded = ["onEntering"],
  _excluded2 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"],
  _excluded3 = ["slotProps"];
















function getOffsetTop(rect, vertical) {
  let offset = 0;
  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }
  return offset;
}
function getOffsetLeft(rect, horizontal) {
  let offset = 0;
  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }
  return offset;
}
function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(n => typeof n === 'number' ? `${n}px` : n).join(' ');
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper']
  };
  return (0,composeClasses/* default */.Z)(slots, getPopoverUtilityClass, classes);
};
const PopoverRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiPopover',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const PopoverPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiPopover',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  position: 'absolute',
  overflowY: 'auto',
  overflowX: 'hidden',
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: 'calc(100% - 32px)',
  maxHeight: 'calc(100% - 32px)',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Popover = /*#__PURE__*/react.forwardRef(function Popover(inProps, ref) {
  var _slotProps$paper, _slots$root, _slots$paper;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPopover'
  });
  const {
      action,
      anchorEl,
      anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
      },
      anchorPosition,
      anchorReference = 'anchorEl',
      children,
      className,
      container: containerProp,
      elevation = 8,
      marginThreshold = 16,
      open,
      PaperProps: PaperPropsProp = {},
      slots,
      slotProps,
      transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
      },
      TransitionComponent = Grow/* default */.Z,
      transitionDuration: transitionDurationProp = 'auto',
      TransitionProps: {
        onEntering
      } = {}
    } = props,
    TransitionProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.TransitionProps, _excluded),
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);
  const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
  const paperRef = react.useRef();
  const handlePaperRef = (0,useForkRef/* default */.Z)(paperRef, externalPaperSlotProps.ref);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchorOrigin,
    anchorReference,
    elevation,
    marginThreshold,
    externalPaperSlotProps,
    transformOrigin,
    TransitionComponent,
    transitionDuration: transitionDurationProp,
    TransitionProps
  });
  const classes = useUtilityClasses(ownerState);

  // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)
  const getAnchorOffset = react.useCallback(() => {
    if (anchorReference === 'anchorPosition') {
      if (false) {}
      return anchorPosition;
    }
    const resolvedAnchorEl = resolveAnchorEl(anchorEl);

    // If an anchor element wasn't provided, just use the parent body element of this Popover
    const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0,ownerDocument/* default */.Z)(paperRef.current).body;
    const anchorRect = anchorElement.getBoundingClientRect();
    if (false) {}
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]);

  // Returns the base transform origin using the element
  const getTransformOrigin = react.useCallback(elemRect => {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  const getPositioningStyle = react.useCallback(element => {
    const elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };

    // Get the transform origin point on the element itself
    const elemTransformOrigin = getTransformOrigin(elemRect);
    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    }

    // Get the offset of the anchoring element
    const anchorOffset = getAnchorOffset();

    // Calculate element positioning
    let top = anchorOffset.top - elemTransformOrigin.vertical;
    let left = anchorOffset.left - elemTransformOrigin.horizontal;
    const bottom = top + elemRect.height;
    const right = left + elemRect.width;

    // Use the parent window of the anchorEl if provided
    const containerWindow = (0,ownerWindow/* default */.Z)(resolveAnchorEl(anchorEl));

    // Window thresholds taking required margin into account
    const heightThreshold = containerWindow.innerHeight - marginThreshold;
    const widthThreshold = containerWindow.innerWidth - marginThreshold;

    // Check if the vertical axis needs shifting
    if (top < marginThreshold) {
      const diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      const diff = bottom - heightThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    }
    if (false) {}

    // Check if the horizontal axis needs shifting
    if (left < marginThreshold) {
      const diff = left - marginThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    } else if (right > widthThreshold) {
      const diff = right - widthThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    }
    return {
      top: `${Math.round(top)}px`,
      left: `${Math.round(left)}px`,
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
  const [isPositioned, setIsPositioned] = react.useState(open);
  const setPositioningStyles = react.useCallback(() => {
    const element = paperRef.current;
    if (!element) {
      return;
    }
    const positioning = getPositioningStyle(element);
    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }
    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }
    element.style.transformOrigin = positioning.transformOrigin;
    setIsPositioned(true);
  }, [getPositioningStyle]);
  const handleEntering = (element, isAppearing) => {
    if (onEntering) {
      onEntering(element, isAppearing);
    }
    setPositioningStyles();
  };
  const handleExited = () => {
    setIsPositioned(false);
  };
  react.useEffect(() => {
    if (open) {
      setPositioningStyles();
    }
  });
  react.useImperativeHandle(action, () => open ? {
    updatePosition: () => {
      setPositioningStyles();
    }
  } : null, [open, setPositioningStyles]);
  react.useEffect(() => {
    if (!open) {
      return undefined;
    }
    const handleResize = (0,debounce/* default */.Z)(() => {
      setPositioningStyles();
    });
    const containerWindow = (0,ownerWindow/* default */.Z)(anchorEl);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);
  let transitionDuration = transitionDurationProp;
  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container
  const container = containerProp || (anchorEl ? (0,ownerDocument/* default */.Z)(resolveAnchorEl(anchorEl)).body : undefined);
  const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : PopoverRoot;
  const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : PopoverPaper;
  const paperProps = (0,useSlotProps/* default */.Z)({
    elementType: PaperSlot,
    externalSlotProps: (0,esm_extends/* default */.Z)({}, externalPaperSlotProps, {
      style: isPositioned ? externalPaperSlotProps.style : (0,esm_extends/* default */.Z)({}, externalPaperSlotProps.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation,
      ref: handlePaperRef
    },
    ownerState,
    className: (0,clsx_m/* default */.Z)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
  });
  const _useSlotProps = (0,useSlotProps/* default */.Z)({
      elementType: RootSlot,
      externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
      externalForwardedProps: other,
      additionalProps: {
        ref,
        slotProps: {
          backdrop: {
            invisible: true
          }
        },
        container,
        open
      },
      ownerState,
      className: (0,clsx_m/* default */.Z)(classes.root, className)
    }),
    {
      slotProps: rootSlotPropsProp
    } = _useSlotProps,
    rootProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_useSlotProps, _excluded3);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RootSlot, (0,esm_extends/* default */.Z)({}, rootProps, !(0,isHostComponent/* default */.Z)(RootSlot) && {
    slotProps: rootSlotPropsProp
  }, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
      appear: true,
      in: open,
      onEntering: handleEntering,
      onExited: handleExited,
      timeout: transitionDuration
    }, TransitionProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PaperSlot, (0,esm_extends/* default */.Z)({}, paperProps, {
        children: children
      }))
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Popover_Popover = (Popover);

/***/ }),

/***/ 16078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ material_Popper_Popper; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(33703);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(73546);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerDocument/ownerDocument.js
var ownerDocument = __webpack_require__(82690);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/Portal/Portal.js
var Portal = __webpack_require__(78385);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/base/Popper/popperClasses.js


function getPopperUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPopper', slot);
}
const popperClasses = (0,generateUtilityClasses/* default */.Z)('MuiPopper', ['root']);
/* harmony default export */ var Popper_popperClasses = ((/* unused pure expression or super */ null && (popperClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 3 modules
var useSlotProps = __webpack_require__(18793);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/ClassNameConfigurator.js
var ClassNameConfigurator = __webpack_require__(31873);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/base/Popper/Popper.js
'use client';



const _excluded = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"],
  _excluded2 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];










function flipPlacement(placement, direction) {
  if (direction === 'ltr') {
    return placement;
  }
  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';
    case 'bottom-start':
      return 'bottom-end';
    case 'top-end':
      return 'top-start';
    case 'top-start':
      return 'top-end';
    default:
      return placement;
  }
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function Popper_isHTMLElement(element) {
  return element.nodeType !== undefined;
}
function isVirtualElement(element) {
  return !Popper_isHTMLElement(element);
}
const useUtilityClasses = () => {
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, (0,ClassNameConfigurator/* useClassNamesOverride */.T)(getPopperUtilityClass));
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/react.forwardRef(function PopperTooltip(props, forwardedRef) {
  var _slots$root;
  const {
      anchorEl,
      children,
      direction,
      disablePortal,
      modifiers,
      open,
      placement: initialPlacement,
      popperOptions,
      popperRef: popperRefProp,
      slotProps = {},
      slots = {},
      TransitionProps
      // @ts-ignore internal logic
      // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const tooltipRef = react.useRef(null);
  const ownRef = (0,useForkRef/* default */.Z)(tooltipRef, forwardedRef);
  const popperRef = react.useRef(null);
  const handlePopperRef = (0,useForkRef/* default */.Z)(popperRef, popperRefProp);
  const handlePopperRefRef = react.useRef(handlePopperRef);
  (0,useEnhancedEffect/* default */.Z)(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  react.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const rtlPlacement = flipPlacement(initialPlacement, direction);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */
  const [placement, setPlacement] = react.useState(rtlPlacement);
  const [resolvedAnchorElement, setResolvedAnchorElement] = react.useState(resolveAnchorEl(anchorEl));
  react.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  react.useEffect(() => {
    if (anchorEl) {
      setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }
  }, [anchorEl]);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (!resolvedAnchorElement || !open) {
      return undefined;
    }
    const handlePopperUpdate = data => {
      setPlacement(data.placement);
    };
    if (false) {}
    let popperModifiers = [{
      name: 'preventOverflow',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'flip',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'onUpdate',
      enabled: true,
      phase: 'afterWrite',
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];
    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }
    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }
    const popper = popper_createPopper(resolvedAnchorElement, tooltipRef.current, (0,esm_extends/* default */.Z)({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper);
    return () => {
      popper.destroy();
      handlePopperRefRef.current(null);
    };
  }, [resolvedAnchorElement, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  const childProps = {
    placement: placement
  };
  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }
  const classes = useUtilityClasses();
  const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      role: 'tooltip',
      ref: ownRef
    },
    ownerState: props,
    className: classes.root
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Root, (0,esm_extends/* default */.Z)({}, rootProps, {
    children: typeof children === 'function' ? children(childProps) : children
  }));
});

/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */
const Popper = /*#__PURE__*/react.forwardRef(function Popper(props, forwardedRef) {
  const {
      anchorEl,
      children,
      container: containerProp,
      direction = 'ltr',
      disablePortal = false,
      keepMounted = false,
      modifiers,
      open,
      placement = 'bottom',
      popperOptions = defaultPopperOptions,
      popperRef,
      style,
      transition = false,
      slotProps = {},
      slots = {}
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);
  const [exited, setExited] = react.useState(true);
  const handleEnter = () => {
    setExited(false);
  };
  const handleExited = () => {
    setExited(true);
  };
  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container
  let container;
  if (containerProp) {
    container = containerProp;
  } else if (anchorEl) {
    const resolvedAnchorEl = resolveAnchorEl(anchorEl);
    container = resolvedAnchorEl && Popper_isHTMLElement(resolvedAnchorEl) ? (0,ownerDocument/* default */.Z)(resolvedAnchorEl).body : (0,ownerDocument/* default */.Z)(null).body;
  }
  const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
  const transitionProps = transition ? {
    in: open,
    onEnter: handleEnter,
    onExited: handleExited
  } : undefined;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Portal/* default */.Z, {
    disablePortal: disablePortal,
    container: container,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(PopperTooltip, (0,esm_extends/* default */.Z)({
      anchorEl: anchorEl,
      direction: direction,
      disablePortal: disablePortal,
      modifiers: modifiers,
      ref: forwardedRef,
      open: transition ? !exited : open,
      placement: placement,
      popperOptions: popperOptions,
      popperRef: popperRef,
      slotProps: slotProps,
      slots: slots
    }, other, {
      style: (0,esm_extends/* default */.Z)({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: 'fixed',
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display
      }, style),
      TransitionProps: transitionProps,
      children: children
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Popper_Popper = (Popper);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeWithoutDefault.js
var useThemeWithoutDefault = __webpack_require__(34168);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Popper/Popper.js
'use client';



const Popper_excluded = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"];







const PopperRoot = (0,styled/* default */.ZP)(Popper_Popper, {
  name: 'MuiPopper',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});

/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */
const Popper_Popper_Popper = /*#__PURE__*/react.forwardRef(function Popper(inProps, ref) {
  var _slots$root;
  const theme = (0,useThemeWithoutDefault/* default */.Z)();
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPopper'
  });
  const {
      anchorEl,
      component,
      components,
      componentsProps,
      container,
      disablePortal,
      keepMounted,
      modifiers,
      open,
      placement,
      popperOptions,
      popperRef,
      transition,
      slots,
      slotProps
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Popper_excluded);
  const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
  const otherProps = (0,esm_extends/* default */.Z)({
    anchorEl,
    container,
    disablePortal,
    keepMounted,
    modifiers,
    open,
    placement,
    popperOptions,
    popperRef,
    transition
  }, other);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PopperRoot, (0,esm_extends/* default */.Z)({
    as: component,
    direction: theme == null ? void 0 : theme.direction,
    slots: {
      root: RootComponent
    },
    slotProps: slotProps != null ? slotProps : componentsProps
  }, otherProps, {
    ref: ref
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var material_Popper_Popper = (Popper_Popper_Popper);

/***/ }),

/***/ 36872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Radio_Radio; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/SwitchBase.js + 1 modules
var SwitchBase = __webpack_require__(21964);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/RadioButtonUnchecked.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonUnchecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/RadioButtonChecked.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonChecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Radio/RadioButtonIcon.js
'use client';









const RadioButtonIconRoot = (0,styled/* default */.ZP)('span')({
  position: 'relative',
  display: 'flex'
});
const RadioButtonIconBackground = (0,styled/* default */.ZP)(RadioButtonUnchecked)({
  // Scale applied to prevent dot misalignment in Safari
  transform: 'scale(1)'
});
const RadioButtonIconDot = (0,styled/* default */.ZP)(RadioButtonChecked)(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  left: 0,
  position: 'absolute',
  transform: 'scale(0)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.shortest
  })
}, ownerState.checked && {
  transform: 'scale(1)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.shortest
  })
}));

/**
 * @ignore - internal component.
 */
function RadioButtonIcon(props) {
  const {
    checked = false,
    classes = {},
    fontSize
  } = props;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    checked
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RadioButtonIconRoot, {
    className: classes.root,
    ownerState: ownerState,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonIconBackground, {
      fontSize: fontSize,
      className: classes.background,
      ownerState: ownerState
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonIconDot, {
      fontSize: fontSize,
      className: classes.dot,
      ownerState: ownerState
    })]
  });
}
 false ? 0 : void 0;
/* harmony default export */ var Radio_RadioButtonIcon = (RadioButtonIcon);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(35893);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroupContext.js
var RadioGroupContext = __webpack_require__(80209);
;// CONCATENATED MODULE: ./node_modules/@mui/material/RadioGroup/useRadioGroup.js
'use client';



function useRadioGroup() {
  return react.useContext(RadioGroupContext/* default */.Z);
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Radio/radioClasses.js


function getRadioUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiRadio', slot);
}
const radioClasses = (0,generateUtilityClasses/* default */.Z)('MuiRadio', ['root', 'checked', 'disabled', 'colorPrimary', 'colorSecondary']);
/* harmony default export */ var Radio_radioClasses = (radioClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Radio/Radio.js
'use client';



const _excluded = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"];















const useUtilityClasses = ownerState => {
  const {
    classes,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${(0,capitalize/* default */.Z)(color)}`]
  };
  return (0,esm_extends/* default */.Z)({}, classes, (0,composeClasses/* default */.Z)(slots, getRadioUtilityClass, classes));
};
const RadioRoot = (0,styled/* default */.ZP)(SwitchBase/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiRadio',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${Radio_radioClasses.checked}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  }
}, {
  [`&.${Radio_radioClasses.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b);
}
const defaultCheckedIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(Radio_RadioButtonIcon, {
  checked: true
});
const defaultIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(Radio_RadioButtonIcon, {});
const Radio = /*#__PURE__*/react.forwardRef(function Radio(inProps, ref) {
  var _defaultIcon$props$fo, _defaultCheckedIcon$p;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiRadio'
  });
  const {
      checked: checkedProp,
      checkedIcon = defaultCheckedIcon,
      color = 'primary',
      icon = defaultIcon,
      name: nameProp,
      onChange: onChangeProp,
      size = 'medium',
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    size
  });
  const classes = useUtilityClasses(ownerState);
  const radioGroup = useRadioGroup();
  let checked = checkedProp;
  const onChange = (0,createChainedFunction/* default */.Z)(onChangeProp, radioGroup && radioGroup.onChange);
  let name = nameProp;
  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = areEqualValues(radioGroup.value, props.value);
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioRoot, (0,esm_extends/* default */.Z)({
    type: "radio",
    icon: /*#__PURE__*/react.cloneElement(icon, {
      fontSize: (_defaultIcon$props$fo = defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(checkedIcon, {
      fontSize: (_defaultCheckedIcon$p = defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
    }),
    ownerState: ownerState,
    classes: classes,
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Radio_Radio = (Radio);

/***/ }),

/***/ 72890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RadioGroup_RadioGroup; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormGroup/formGroupClasses.js


function getFormGroupUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiFormGroup', slot);
}
const formGroupClasses = (0,generateUtilityClasses/* default */.Z)('MuiFormGroup', ['root', 'row', 'error']);
/* harmony default export */ var FormGroup_formGroupClasses = ((/* unused pure expression or super */ null && (formGroupClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/formControlState.js
var formControlState = __webpack_require__(15704);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/FormGroup/FormGroup.js
'use client';



const _excluded = ["className", "row"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    row,
    error
  } = ownerState;
  const slots = {
    root: ['root', row && 'row', error && 'error']
  };
  return (0,composeClasses/* default */.Z)(slots, getFormGroupUtilityClass, classes);
};
const FormGroupRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiFormGroup',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.row && styles.row];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap'
}, ownerState.row && {
  flexDirection: 'row'
}));

/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */
const FormGroup = /*#__PURE__*/react.forwardRef(function FormGroup(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiFormGroup'
  });
  const {
      className,
      row = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const muiFormControl = (0,useFormControl/* default */.Z)();
  const fcs = (0,formControlState/* default */.Z)({
    props,
    muiFormControl,
    states: ['error']
  });
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    row,
    error: fcs.error
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormGroupRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var FormGroup_FormGroup = (FormGroup);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useControlled.js
var useControlled = __webpack_require__(49299);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroupContext.js
var RadioGroupContext = __webpack_require__(80209);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useId.js
var useId = __webpack_require__(27909);
;// CONCATENATED MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroup.js
'use client';



const RadioGroup_excluded = ["actions", "children", "defaultValue", "name", "onChange", "value"];








const RadioGroup = /*#__PURE__*/react.forwardRef(function RadioGroup(props, ref) {
  const {
      // private
      // eslint-disable-next-line react/prop-types
      actions,
      children,
      defaultValue,
      name: nameProp,
      onChange,
      value: valueProp
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, RadioGroup_excluded);
  const rootRef = react.useRef(null);
  const [value, setValueState] = (0,useControlled/* default */.Z)({
    controlled: valueProp,
    default: defaultValue,
    name: 'RadioGroup'
  });
  react.useImperativeHandle(actions, () => ({
    focus: () => {
      let input = rootRef.current.querySelector('input:not(:disabled):checked');
      if (!input) {
        input = rootRef.current.querySelector('input:not(:disabled)');
      }
      if (input) {
        input.focus();
      }
    }
  }), []);
  const handleRef = (0,useForkRef/* default */.Z)(ref, rootRef);
  const name = (0,useId/* default */.Z)(nameProp);
  const contextValue = react.useMemo(() => ({
    name,
    onChange(event) {
      setValueState(event.target.value);
      if (onChange) {
        onChange(event, event.target.value);
      }
    },
    value
  }), [name, onChange, setValueState, value]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioGroupContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormGroup_FormGroup, (0,esm_extends/* default */.Z)({
      role: "radiogroup",
      ref: handleRef
    }, other, {
      children: children
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var RadioGroup_RadioGroup = (RadioGroup);

/***/ }),

/***/ 80209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */
const RadioGroupContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (RadioGroupContext);

/***/ }),

/***/ 18360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Select_Select; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(59766);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerDocument.js
var ownerDocument = __webpack_require__(8038);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 1 modules
var Menu = __webpack_require__(25464);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/NativeSelect/nativeSelectClasses.js


function getNativeSelectUtilityClasses(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiNativeSelect', slot);
}
const nativeSelectClasses = (0,generateUtilityClasses/* default */.Z)('MuiNativeSelect', ['root', 'select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput', 'error']);
/* harmony default export */ var NativeSelect_nativeSelectClasses = (nativeSelectClasses);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/NativeSelect/NativeSelectInput.js
'use client';



const _excluded = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open,
    error
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple', error && 'error'],
    icon: ['icon', `icon${(0,capitalize/* default */.Z)(variant)}`, open && 'iconOpen', disabled && 'disabled']
  };
  return (0,composeClasses/* default */.Z)(slots, getNativeSelectUtilityClasses, classes);
};
const nativeSelectSelectStyles = ({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: 'none',
  borderRadius: 0,
  // Reset
  cursor: 'pointer',
  '&:focus': (0,esm_extends/* default */.Z)({}, theme.vars ? {
    backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
  }, {
    borderRadius: 0 // Reset Chrome style
  }),

  // Remove IE11 arrow
  '&::-ms-expand': {
    display: 'none'
  },
  [`&.${NativeSelect_nativeSelectClasses.disabled}`]: {
    cursor: 'default'
  },
  '&[multiple]': {
    height: 'auto'
  },
  '&:not([multiple]) option, &:not([multiple]) optgroup': {
    backgroundColor: (theme.vars || theme).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  '&&&': {
    paddingRight: 24,
    minWidth: 16 // So it doesn't collapse.
  }
}, ownerState.variant === 'filled' && {
  '&&&': {
    paddingRight: 32
  }
}, ownerState.variant === 'outlined' && {
  borderRadius: (theme.vars || theme).shape.borderRadius,
  '&:focus': {
    borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
  },

  '&&&': {
    paddingRight: 32
  }
});
const NativeSelectSelect = (0,styled/* default */.ZP)('select', {
  name: 'MuiNativeSelect',
  slot: 'Select',
  shouldForwardProp: styled/* rootShouldForwardProp */.FO,
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.select, styles[ownerState.variant], ownerState.error && styles.error, {
      [`&.${NativeSelect_nativeSelectClasses.multiple}`]: styles.multiple
    }];
  }
})(nativeSelectSelectStyles);
const nativeSelectIconStyles = ({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: 'absolute',
  right: 0,
  top: 'calc(50% - .5em)',
  // Center vertically, height is 1em
  pointerEvents: 'none',
  // Don't block pointer events on the select under the icon.
  color: (theme.vars || theme).palette.action.active,
  [`&.${NativeSelect_nativeSelectClasses.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}, ownerState.open && {
  transform: 'rotate(180deg)'
}, ownerState.variant === 'filled' && {
  right: 7
}, ownerState.variant === 'outlined' && {
  right: 7
});
const NativeSelectIcon = (0,styled/* default */.ZP)('svg', {
  name: 'MuiNativeSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${(0,capitalize/* default */.Z)(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);

/**
 * @ignore - internal component.
 */
const NativeSelectInput = /*#__PURE__*/react.forwardRef(function NativeSelectInput(props, ref) {
  const {
      className,
      disabled,
      error,
      IconComponent,
      inputRef,
      variant = 'standard'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disabled,
    variant,
    error
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NativeSelectSelect, (0,esm_extends/* default */.Z)({
      ownerState: ownerState,
      className: (0,clsx_m/* default */.Z)(classes.select, className),
      disabled: disabled,
      ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(NativeSelectIcon, {
      as: IconComponent,
      ownerState: ownerState,
      className: classes.icon
    })]
  });
});
 false ? 0 : void 0;
/* harmony default export */ var NativeSelect_NativeSelectInput = (NativeSelectInput);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputBase/utils.js
var utils = __webpack_require__(5108);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useControlled.js
var useControlled = __webpack_require__(49299);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Select/selectClasses.js


function getSelectUtilityClasses(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSelect', slot);
}
const selectClasses = (0,generateUtilityClasses/* default */.Z)('MuiSelect', ['select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'focused', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput', 'error']);
/* harmony default export */ var Select_selectClasses = (selectClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Select/SelectInput.js
'use client';




var _span;
const SelectInput_excluded = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"];

















const SelectSelect = (0,styled/* default */.ZP)('div', {
  name: 'MuiSelect',
  slot: 'Select',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [
    // Win specificity over the input base
    {
      [`&.${Select_selectClasses.select}`]: styles.select
    }, {
      [`&.${Select_selectClasses.select}`]: styles[ownerState.variant]
    }, {
      [`&.${Select_selectClasses.error}`]: styles.error
    }, {
      [`&.${Select_selectClasses.multiple}`]: styles.multiple
    }];
  }
})(nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${Select_selectClasses.select}`]: {
    height: 'auto',
    // Resets for multiple select with chips
    minHeight: '1.4375em',
    // Required for select\text-field height consistency
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
});
const SelectIcon = (0,styled/* default */.ZP)('svg', {
  name: 'MuiSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${(0,capitalize/* default */.Z)(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);
const SelectNativeInput = (0,styled/* default */.ZP)('input', {
  shouldForwardProp: prop => (0,styled/* slotShouldForwardProp */.Dz)(prop) && prop !== 'classes',
  name: 'MuiSelect',
  slot: 'NativeInput',
  overridesResolver: (props, styles) => styles.nativeInput
})({
  bottom: 0,
  left: 0,
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: '100%',
  boxSizing: 'border-box'
});
function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b);
}
function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
const SelectInput_useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open,
    error
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple', error && 'error'],
    icon: ['icon', `icon${(0,capitalize/* default */.Z)(variant)}`, open && 'iconOpen', disabled && 'disabled'],
    nativeInput: ['nativeInput']
  };
  return (0,composeClasses/* default */.Z)(slots, getSelectUtilityClasses, classes);
};

/**
 * @ignore - internal component.
 */
const SelectInput = /*#__PURE__*/react.forwardRef(function SelectInput(props, ref) {
  const {
      'aria-describedby': ariaDescribedby,
      'aria-label': ariaLabel,
      autoFocus,
      autoWidth,
      children,
      className,
      defaultOpen,
      defaultValue,
      disabled,
      displayEmpty,
      error = false,
      IconComponent,
      inputRef: inputRefProp,
      labelId,
      MenuProps = {},
      multiple,
      name,
      onBlur,
      onChange,
      onClose,
      onFocus,
      onOpen,
      open: openProp,
      readOnly,
      renderValue,
      SelectDisplayProps = {},
      tabIndex: tabIndexProp
      // catching `type` from Input which makes no sense for SelectInput
      ,

      value: valueProp,
      variant = 'standard'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, SelectInput_excluded);
  const [value, setValueState] = (0,useControlled/* default */.Z)({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  });
  const [openState, setOpenState] = (0,useControlled/* default */.Z)({
    controlled: openProp,
    default: defaultOpen,
    name: 'Select'
  });
  const inputRef = react.useRef(null);
  const displayRef = react.useRef(null);
  const [displayNode, setDisplayNode] = react.useState(null);
  const {
    current: isOpenControlled
  } = react.useRef(openProp != null);
  const [menuMinWidthState, setMenuMinWidthState] = react.useState();
  const handleRef = (0,useForkRef/* default */.Z)(ref, inputRefProp);
  const handleDisplayRef = react.useCallback(node => {
    displayRef.current = node;
    if (node) {
      setDisplayNode(node);
    }
  }, []);
  const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
  react.useImperativeHandle(handleRef, () => ({
    focus: () => {
      displayRef.current.focus();
    },
    node: inputRef.current,
    value
  }), [value]);

  // Resize menu on `defaultOpen` automatic toggle.
  react.useEffect(() => {
    if (defaultOpen && openState && displayNode && !isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
      displayRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayNode, autoWidth]);
  // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
  // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
  react.useEffect(() => {
    if (autoFocus) {
      displayRef.current.focus();
    }
  }, [autoFocus]);
  react.useEffect(() => {
    if (!labelId) {
      return undefined;
    }
    const label = (0,ownerDocument/* default */.Z)(displayRef.current).getElementById(labelId);
    if (label) {
      const handler = () => {
        if (getSelection().isCollapsed) {
          displayRef.current.focus();
        }
      };
      label.addEventListener('click', handler);
      return () => {
        label.removeEventListener('click', handler);
      };
    }
    return undefined;
  }, [labelId]);
  const update = (open, event) => {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }
    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
      setOpenState(open);
    }
  };
  const handleMouseDown = event => {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    }
    // Hijack the default focus behavior.
    event.preventDefault();
    displayRef.current.focus();
    update(true, event);
  };
  const handleClose = event => {
    update(false, event);
  };
  const childrenArray = react.Children.toArray(children);

  // Support autofill.
  const handleChange = event => {
    const child = childrenArray.find(childItem => childItem.props.value === event.target.value);
    if (child === undefined) {
      return;
    }
    setValueState(child.props.value);
    if (onChange) {
      onChange(event, child);
    }
  };
  const handleItemClick = child => event => {
    let newValue;

    // We use the tabindex attribute to signal the available options.
    if (!event.currentTarget.hasAttribute('tabindex')) {
      return;
    }
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      const itemIndex = value.indexOf(child.props.value);
      if (itemIndex === -1) {
        newValue.push(child.props.value);
      } else {
        newValue.splice(itemIndex, 1);
      }
    } else {
      newValue = child.props.value;
    }
    if (child.props.onClick) {
      child.props.onClick(event);
    }
    if (value !== newValue) {
      setValueState(newValue);
      if (onChange) {
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
          writable: true,
          value: {
            value: newValue,
            name
          }
        });
        onChange(clonedEvent, child);
      }
    }
    if (!multiple) {
      update(false, event);
    }
  };
  const handleKeyDown = event => {
    if (!readOnly) {
      const validKeys = [' ', 'ArrowUp', 'ArrowDown',
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      'Enter'];
      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };
  const open = displayNode !== null && openState;
  const handleBlur = event => {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      // Preact support, target is read only property on a native event.
      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value,
          name
        }
      });
      onBlur(event);
    }
  };
  delete other['aria-invalid'];
  let display;
  let displaySingle;
  const displayMultiple = [];
  let computeDisplay = false;
  let foundMatch = false;

  // No need to display any value if the field is empty.
  if ((0,utils/* isFilled */.vd)({
    value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }
  const items = childrenArray.map(child => {
    if (! /*#__PURE__*/react.isValidElement(child)) {
      return null;
    }
    if (false) {}
    let selected;
    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(2));
      }
      selected = value.some(v => areEqualValues(v, child.props.value));
      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);
      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }
    if (selected) {
      foundMatch = true;
    }
    return /*#__PURE__*/react.cloneElement(child, {
      'aria-selected': selected ? 'true' : 'false',
      onClick: handleItemClick(child),
      onKeyUp: event => {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }
        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.
    });
  });

  if (false) {}
  if (computeDisplay) {
    if (multiple) {
      if (displayMultiple.length === 0) {
        display = null;
      } else {
        display = displayMultiple.reduce((output, child, index) => {
          output.push(child);
          if (index < displayMultiple.length - 1) {
            output.push(', ');
          }
          return output;
        }, []);
      }
    } else {
      display = displaySingle;
    }
  }

  // Avoid performing a layout computation in the render method.
  let menuMinWidth = menuMinWidthState;
  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = anchorElement.clientWidth;
  }
  let tabIndex;
  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }
  const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    variant,
    value,
    open,
    error
  });
  const classes = SelectInput_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SelectSelect, (0,esm_extends/* default */.Z)({
      ref: handleDisplayRef,
      tabIndex: tabIndex,
      role: "button",
      "aria-disabled": disabled ? 'true' : undefined,
      "aria-expanded": open ? 'true' : 'false',
      "aria-haspopup": "listbox",
      "aria-label": ariaLabel,
      "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
      "aria-describedby": ariaDescribedby,
      onKeyDown: handleKeyDown,
      onMouseDown: disabled || readOnly ? null : handleMouseDown,
      onBlur: handleBlur,
      onFocus: onFocus
    }, SelectDisplayProps, {
      ownerState: ownerState,
      className: (0,clsx_m/* default */.Z)(SelectDisplayProps.className, classes.select, className)
      // The id is required for proper a11y
      ,
      id: buttonId,
      children: isEmpty(display) ? // notranslate needed while Google Translate will not fix zero-width space issue
      _span || (_span = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "notranslate",
        children: "\u200B"
      })) : display
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectNativeInput, (0,esm_extends/* default */.Z)({
      "aria-invalid": error,
      value: Array.isArray(value) ? value.join(',') : value,
      name: name,
      ref: inputRef,
      "aria-hidden": true,
      onChange: handleChange,
      tabIndex: -1,
      disabled: disabled,
      className: classes.nativeInput,
      autoFocus: autoFocus,
      ownerState: ownerState
    }, other)), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectIcon, {
      as: IconComponent,
      className: classes.icon,
      ownerState: ownerState
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Menu/* default */.Z, (0,esm_extends/* default */.Z)({
      id: `menu-${name || ''}`,
      anchorEl: anchorElement,
      open: open,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, MenuProps, {
      MenuListProps: (0,esm_extends/* default */.Z)({
        'aria-labelledby': labelId,
        role: 'listbox',
        disableListWrap: true
      }, MenuProps.MenuListProps),
      PaperProps: (0,esm_extends/* default */.Z)({}, MenuProps.PaperProps, {
        style: (0,esm_extends/* default */.Z)({
          minWidth: menuMinWidth
        }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
      }),
      children: items
    }))]
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Select_SelectInput = (SelectInput);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/formControlState.js
var formControlState = __webpack_require__(15704);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/svg-icons/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(60224);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./node_modules/@mui/material/FilledInput/FilledInput.js
var FilledInput = __webpack_require__(6135);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(57709);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Select/Select.js
'use client';



const Select_excluded = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"];
















const Select_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  return classes;
};
const styledRootConfig = {
  name: 'MuiSelect',
  overridesResolver: (props, styles) => styles.root,
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) && prop !== 'variant',
  slot: 'Root'
};
const StyledInput = (0,styled/* default */.ZP)(Input/* default */.Z, styledRootConfig)('');
const StyledOutlinedInput = (0,styled/* default */.ZP)(OutlinedInput/* default */.Z, styledRootConfig)('');
const StyledFilledInput = (0,styled/* default */.ZP)(FilledInput/* default */.Z, styledRootConfig)('');
const Select = /*#__PURE__*/react.forwardRef(function Select(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    name: 'MuiSelect',
    props: inProps
  });
  const {
      autoWidth = false,
      children,
      classes: classesProp = {},
      className,
      defaultOpen = false,
      displayEmpty = false,
      IconComponent = ArrowDropDown/* default */.Z,
      id,
      input,
      inputProps,
      label,
      labelId,
      MenuProps,
      multiple = false,
      native = false,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps,
      variant: variantProp = 'outlined'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Select_excluded);
  const inputComponent = native ? NativeSelect_NativeSelectInput : Select_SelectInput;
  const muiFormControl = (0,useFormControl/* default */.Z)();
  const fcs = (0,formControlState/* default */.Z)({
    props,
    muiFormControl,
    states: ['variant', 'error']
  });
  const variant = fcs.variant || variantProp;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    variant,
    classes: classesProp
  });
  const classes = Select_useUtilityClasses(ownerState);
  const InputComponent = input || {
    standard: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledInput, {
      ownerState: ownerState
    }),
    outlined: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledOutlinedInput, {
      label: label,
      ownerState: ownerState
    }),
    filled: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFilledInput, {
      ownerState: ownerState
    })
  }[variant];
  const inputComponentRef = (0,useForkRef/* default */.Z)(ref, InputComponent.ref);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/react.cloneElement(InputComponent, (0,esm_extends/* default */.Z)({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent,
      inputProps: (0,esm_extends/* default */.Z)({
        children,
        error: fcs.error,
        IconComponent,
        variant,
        type: undefined,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple
      }, native ? {
        id
      } : {
        autoWidth,
        defaultOpen,
        displayEmpty,
        labelId,
        MenuProps,
        onClose,
        onOpen,
        open,
        renderValue,
        SelectDisplayProps: (0,esm_extends/* default */.Z)({
          id
        }, SelectDisplayProps)
      }, inputProps, {
        classes: inputProps ? (0,deepmerge/* default */.Z)(classes, inputProps.classes) : classes
      }, input ? input.props.inputProps : {})
    }, multiple && native && variant === 'outlined' ? {
      notched: true
    } : {}, {
      ref: inputComponentRef,
      className: (0,clsx_m/* default */.Z)(InputComponent.props.className, className)
    }, !input && {
      variant
    }, other))
  });
});
 false ? 0 : void 0;
Select.muiName = 'Select';
/* harmony default export */ var Select_Select = (Select);

/***/ }),

/***/ 18979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/cssUtils.js
var cssUtils = __webpack_require__(88606);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Skeleton/skeletonClasses.js


function getSkeletonUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSkeleton', slot);
}
const skeletonClasses = (0,generateUtilityClasses/* default */.Z)('MuiSkeleton', ['root', 'text', 'rectangular', 'rounded', 'circular', 'pulse', 'wave', 'withChildren', 'fitContent', 'heightAuto']);
/* harmony default export */ var Skeleton_skeletonClasses = ((/* unused pure expression or super */ null && (skeletonClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js
'use client';



const _excluded = ["animation", "className", "component", "height", "style", "variant", "width"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;










const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    animation,
    hasChildren,
    width,
    height
  } = ownerState;
  const slots = {
    root: ['root', variant, animation, hasChildren && 'withChildren', hasChildren && !width && 'fitContent', hasChildren && !height && 'heightAuto']
  };
  return (0,composeClasses/* default */.Z)(slots, getSkeletonUtilityClass, classes);
};
const pulseKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const waveKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const SkeletonRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiSkeleton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.animation !== false && styles[ownerState.animation], ownerState.hasChildren && styles.withChildren, ownerState.hasChildren && !ownerState.width && styles.fitContent, ownerState.hasChildren && !ownerState.height && styles.heightAuto];
  }
})(({
  theme,
  ownerState
}) => {
  const radiusUnit = (0,cssUtils/* getUnit */.Wy)(theme.shape.borderRadius) || 'px';
  const radiusValue = (0,cssUtils/* toUnitless */.YL)(theme.shape.borderRadius);
  return (0,esm_extends/* default */.Z)({
    display: 'block',
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0,colorManipulator/* alpha */.Fq)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
    height: '1.2em'
  }, ownerState.variant === 'text' && {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    transformOrigin: '0 55%',
    transform: 'scale(1, 0.60)',
    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
    '&:empty:before': {
      content: '"\\00a0"'
    }
  }, ownerState.variant === 'circular' && {
    borderRadius: '50%'
  }, ownerState.variant === 'rounded' && {
    borderRadius: (theme.vars || theme).shape.borderRadius
  }, ownerState.hasChildren && {
    '& > *': {
      visibility: 'hidden'
    }
  }, ownerState.hasChildren && !ownerState.width && {
    maxWidth: 'fit-content'
  }, ownerState.hasChildren && !ownerState.height && {
    height: 'auto'
  });
}, ({
  ownerState
}) => ownerState.animation === 'pulse' && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _`
      animation: ${0} 1.5s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({
  ownerState,
  theme
}) => ownerState.animation === 'wave' && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 1.6s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, (theme.vars || theme).palette.action.hover));
const Skeleton = /*#__PURE__*/react.forwardRef(function Skeleton(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSkeleton'
  });
  const {
      animation = 'pulse',
      className,
      component = 'span',
      height,
      style,
      variant = 'text',
      width
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    animation,
    component,
    variant,
    hasChildren: Boolean(other.children)
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    style: (0,esm_extends/* default */.Z)({
      width,
      height
    }, style)
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);

/***/ }),

/***/ 54776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setTranslateValue */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98885);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57144);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51705);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30577);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5340);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];










// Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.

function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(node);
  let transform;
  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }
  let offsetX = 0;
  let offsetY = 0;
  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }
  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }
    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }
  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }
    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }
  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }
    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  }

  // direction === 'down'
  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }
  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);
  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}

/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Slide = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Slide(props, ref) {
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      container: containerProp,
      direction = 'down',
      easing: easingProp = defaultEasing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);
  const childrenRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(children.ref, childrenRef, ref);
  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .reflow */ .n)(node);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';
    if (onExited) {
      onExited(node);
    }
  });
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };
  const updatePosition = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }
    const handleResize = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        ref: handleRef,
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Slide);

/***/ }),

/***/ 51233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Stack_Stack; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(59766);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeProps/useThemeProps.js
var useThemeProps = __webpack_require__(29628);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(66500);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(95408);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(98700);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/Stack/createStack.js


const _excluded = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"];











const defaultTheme = (0,createTheme/* default */.Z)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0,styled/* default */.Z)('div', {
  name: 'MuiStack',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
});
function useThemePropsDefault(props) {
  return (0,useThemeProps/* default */.Z)({
    props,
    name: 'MuiStack',
    defaultTheme
  });
}

/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */
function joinChildren(children, separator) {
  const childrenArray = react.Children.toArray(children).filter(Boolean);
  return childrenArray.reduce((output, child, index) => {
    output.push(child);
    if (index < childrenArray.length - 1) {
      output.push( /*#__PURE__*/react.cloneElement(separator, {
        key: `separator-${index}`
      }));
    }
    return output;
  }, []);
}
const getSideFromDirection = direction => {
  return {
    row: 'Left',
    'row-reverse': 'Right',
    column: 'Top',
    'column-reverse': 'Bottom'
  }[direction];
};
const style = ({
  ownerState,
  theme
}) => {
  let styles = (0,esm_extends/* default */.Z)({
    display: 'flex',
    flexDirection: 'column'
  }, (0,breakpoints/* handleBreakpoints */.k9)({
    theme
  }, (0,breakpoints/* resolveBreakpointValues */.P$)({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  }), propValue => ({
    flexDirection: propValue
  })));
  if (ownerState.spacing) {
    const transformer = (0,spacing/* createUnarySpacing */.hB)(theme);
    const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint) => {
      if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) {
        acc[breakpoint] = true;
      }
      return acc;
    }, {});
    const directionValues = (0,breakpoints/* resolveBreakpointValues */.P$)({
      values: ownerState.direction,
      base
    });
    const spacingValues = (0,breakpoints/* resolveBreakpointValues */.P$)({
      values: ownerState.spacing,
      base
    });
    if (typeof directionValues === 'object') {
      Object.keys(directionValues).forEach((breakpoint, index, breakpoints) => {
        const directionValue = directionValues[breakpoint];
        if (!directionValue) {
          const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
          directionValues[breakpoint] = previousDirectionValue;
        }
      });
    }
    const styleFromPropValue = (propValue, breakpoint) => {
      if (ownerState.useFlexGap) {
        return {
          gap: (0,spacing/* getValue */.NA)(transformer, propValue)
        };
      }
      return {
        '& > :not(style) ~ :not(style)': {
          margin: 0,
          [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0,spacing/* getValue */.NA)(transformer, propValue)
        }
      };
    };
    styles = (0,deepmerge/* default */.Z)(styles, (0,breakpoints/* handleBreakpoints */.k9)({
      theme
    }, spacingValues, styleFromPropValue));
  }
  styles = (0,breakpoints/* mergeBreakpointsInOrder */.dt)(theme.breakpoints, styles);
  return styles;
};
function createStack(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps = useThemePropsDefault,
    componentName = 'MuiStack'
  } = options;
  const useUtilityClasses = () => {
    const slots = {
      root: ['root']
    };
    return (0,composeClasses/* default */.Z)(slots, slot => (0,generateUtilityClass/* default */.Z)(componentName, slot), {});
  };
  const StackRoot = createStyledComponent(style);
  const Stack = /*#__PURE__*/react.forwardRef(function Grid(inProps, ref) {
    const themeProps = useThemeProps(inProps);
    const props = (0,extendSxProp/* default */.Z)(themeProps); // `color` type conflicts with html color attribute.
    const {
        component = 'div',
        direction = 'column',
        spacing = 0,
        divider,
        children,
        className,
        useFlexGap = false
      } = props,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    const ownerState = {
      direction,
      spacing,
      useFlexGap
    };
    const classes = useUtilityClasses();
    return /*#__PURE__*/(0,jsx_runtime.jsx)(StackRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ownerState: ownerState,
      ref: ref,
      className: (0,clsx_m/* default */.Z)(classes.root, className)
    }, other, {
      children: divider ? joinChildren(children, divider) : children
    }));
  });
   false ? 0 : void 0;
  return Stack;
}
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styles_styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var styles_useThemeProps = __webpack_require__(71657);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Stack/Stack.js
'use client';





const Stack = createStack({
  createStyledComponent: (0,styles_styled/* default */.ZP)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root
  }),
  useThemeProps: inProps => (0,styles_useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiStack'
  })
});
 false ? 0 : void 0;
/* harmony default export */ var Stack_Stack = (Stack);

/***/ }),

/***/ 53219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SvgIcon_SvgIcon; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/SvgIcon/svgIconClasses.js


function getSvgIconUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSvgIcon', slot);
}
const svgIconClasses = (0,generateUtilityClasses/* default */.Z)('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);
/* harmony default export */ var SvgIcon_svgIconClasses = ((/* unused pure expression or super */ null && (svgIconClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js
'use client';



const _excluded = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];










const useUtilityClasses = ownerState => {
  const {
    color,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ['root', color !== 'inherit' && `color${(0,capitalize/* default */.Z)(color)}`, `fontSize${(0,capitalize/* default */.Z)(fontSize)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getSvgIconUtilityClass, classes);
};
const SvgIconRoot = (0,styled/* default */.ZP)('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'inherit' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], styles[`fontSize${(0,capitalize/* default */.Z)(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    // the <svg> will define the property that has `currentColor`
    // e.g. heroicons uses fill="none" and stroke="currentColor"
    fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
      duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
    }),
    fontSize: {
      inherit: 'inherit',
      small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
      medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
      large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : {
      action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
      disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
      inherit: undefined
    }[ownerState.color]
  };
});
const SvgIcon = /*#__PURE__*/react.forwardRef(function SvgIcon(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSvgIcon'
  });
  const {
      children,
      className,
      color = 'inherit',
      component = 'svg',
      fontSize = 'medium',
      htmlColor,
      inheritViewBox = false,
      titleAccess,
      viewBox = '0 0 24 24'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const hasSvgAsChild = /*#__PURE__*/react.isValidElement(children) && children.type === 'svg';
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox,
    hasSvgAsChild
  });
  const more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SvgIconRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, more, other, hasSvgAsChild && children.props, {
    ownerState: ownerState,
    children: [hasSvgAsChild ? children.props.children : children, titleAccess ? /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: titleAccess
    }) : null]
  }));
});
 false ? 0 : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ var SvgIcon_SvgIcon = (SvgIcon);

/***/ }),

/***/ 7906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Table_Table; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/TableContext.js
var TableContext = __webpack_require__(31618);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Table/tableClasses.js


function getTableUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTable', slot);
}
const tableClasses = (0,generateUtilityClasses/* default */.Z)('MuiTable', ['root', 'stickyHeader']);
/* harmony default export */ var Table_tableClasses = ((/* unused pure expression or super */ null && (tableClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Table/Table.js
'use client';



const _excluded = ["className", "component", "padding", "size", "stickyHeader"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', stickyHeader && 'stickyHeader']
  };
  return (0,composeClasses/* default */.Z)(slots, getTableUtilityClass, classes);
};
const TableRoot = (0,styled/* default */.ZP)('table', {
  name: 'MuiTable',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'table',
  width: '100%',
  borderCollapse: 'collapse',
  borderSpacing: 0,
  '& caption': (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
    padding: theme.spacing(2),
    color: (theme.vars || theme).palette.text.secondary,
    textAlign: 'left',
    captionSide: 'bottom'
  })
}, ownerState.stickyHeader && {
  borderCollapse: 'separate'
}));
const defaultComponent = 'table';
const Table = /*#__PURE__*/react.forwardRef(function Table(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTable'
  });
  const {
      className,
      component = defaultComponent,
      padding = 'normal',
      size = 'medium',
      stickyHeader = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    padding,
    size,
    stickyHeader
  });
  const classes = useUtilityClasses(ownerState);
  const table = react.useMemo(() => ({
    padding,
    size,
    stickyHeader
  }), [padding, size, stickyHeader]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TableContext/* default.Provider */.Z.Provider, {
    value: table,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableRoot, (0,esm_extends/* default */.Z)({
      as: component,
      role: component === defaultComponent ? null : 'table',
      ref: ref,
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      ownerState: ownerState
    }, other))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Table_Table = (Table);

/***/ }),

/***/ 31618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



/**
 * @ignore - internal component.
 */
const TableContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (TableContext);

/***/ }),

/***/ 44063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * @ignore - internal component.
 */
const Tablelvl2Context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (Tablelvl2Context);

/***/ }),

/***/ 295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TableBody_TableBody; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Tablelvl2Context.js
var Tablelvl2Context = __webpack_require__(44063);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableBody/tableBodyClasses.js


function getTableBodyUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTableBody', slot);
}
const tableBodyClasses = (0,generateUtilityClasses/* default */.Z)('MuiTableBody', ['root']);
/* harmony default export */ var TableBody_tableBodyClasses = ((/* unused pure expression or super */ null && (tableBodyClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableBody/TableBody.js
'use client';



const _excluded = ["className", "component"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getTableBodyUtilityClass, classes);
};
const TableBodyRoot = (0,styled/* default */.ZP)('tbody', {
  name: 'MuiTableBody',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-row-group'
});
const tablelvl2 = {
  variant: 'body'
};
const defaultComponent = 'tbody';
const TableBody = /*#__PURE__*/react.forwardRef(function TableBody(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTableBody'
  });
  const {
      className,
      component = defaultComponent
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tablelvl2Context/* default.Provider */.Z.Provider, {
    value: tablelvl2,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableBodyRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      as: component,
      ref: ref,
      role: component === defaultComponent ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var TableBody_TableBody = (TableBody);

/***/ }),

/***/ 53252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TableCell_TableCell; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/TableContext.js
var TableContext = __webpack_require__(31618);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Tablelvl2Context.js
var Tablelvl2Context = __webpack_require__(44063);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableCell/tableCellClasses.js


function getTableCellUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTableCell', slot);
}
const tableCellClasses = (0,generateUtilityClasses/* default */.Z)('MuiTableCell', ['root', 'head', 'body', 'footer', 'sizeSmall', 'sizeMedium', 'paddingCheckbox', 'paddingNone', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'stickyHeader']);
/* harmony default export */ var TableCell_tableCellClasses = (tableCellClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableCell/TableCell.js
'use client';



const _excluded = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"];












const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    align,
    padding,
    size,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', variant, stickyHeader && 'stickyHeader', align !== 'inherit' && `align${(0,capitalize/* default */.Z)(align)}`, padding !== 'normal' && `padding${(0,capitalize/* default */.Z)(padding)}`, `size${(0,capitalize/* default */.Z)(size)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getTableCellUtilityClass, classes);
};
const TableCellRoot = (0,styled/* default */.ZP)('td', {
  name: 'MuiTableCell',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`], ownerState.padding !== 'normal' && styles[`padding${(0,capitalize/* default */.Z)(ownerState.padding)}`], ownerState.align !== 'inherit' && styles[`align${(0,capitalize/* default */.Z)(ownerState.align)}`], ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
  display: 'table-cell',
  verticalAlign: 'inherit',
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0,colorManipulator/* lighten */.$n)((0,colorManipulator/* alpha */.Fq)(theme.palette.divider, 1), 0.88) : (0,colorManipulator/* darken */._j)((0,colorManipulator/* alpha */.Fq)(theme.palette.divider, 1), 0.68)}`,
  textAlign: 'left',
  padding: 16
}, ownerState.variant === 'head' && {
  color: (theme.vars || theme).palette.text.primary,
  lineHeight: theme.typography.pxToRem(24),
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.variant === 'body' && {
  color: (theme.vars || theme).palette.text.primary
}, ownerState.variant === 'footer' && {
  color: (theme.vars || theme).palette.text.secondary,
  lineHeight: theme.typography.pxToRem(21),
  fontSize: theme.typography.pxToRem(12)
}, ownerState.size === 'small' && {
  padding: '6px 16px',
  [`&.${TableCell_tableCellClasses.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: '0 12px 0 16px',
    '& > *': {
      padding: 0
    }
  }
}, ownerState.padding === 'checkbox' && {
  width: 48,
  // prevent the checkbox column from growing
  padding: '0 0 0 4px'
}, ownerState.padding === 'none' && {
  padding: 0
}, ownerState.align === 'left' && {
  textAlign: 'left'
}, ownerState.align === 'center' && {
  textAlign: 'center'
}, ownerState.align === 'right' && {
  textAlign: 'right',
  flexDirection: 'row-reverse'
}, ownerState.align === 'justify' && {
  textAlign: 'justify'
}, ownerState.stickyHeader && {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: (theme.vars || theme).palette.background.default
}));

/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */
const TableCell = /*#__PURE__*/react.forwardRef(function TableCell(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTableCell'
  });
  const {
      align = 'inherit',
      className,
      component: componentProp,
      padding: paddingProp,
      scope: scopeProp,
      size: sizeProp,
      sortDirection,
      variant: variantProp
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const table = react.useContext(TableContext/* default */.Z);
  const tablelvl2 = react.useContext(Tablelvl2Context/* default */.Z);
  const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  let component;
  if (componentProp) {
    component = componentProp;
  } else {
    component = isHeadCell ? 'th' : 'td';
  }
  let scope = scopeProp;
  // scope is not a valid attribute for <td/> elements.
  // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
  if (component === 'td') {
    scope = undefined;
  } else if (!scope && isHeadCell) {
    scope = 'col';
  }
  const variant = variantProp || tablelvl2 && tablelvl2.variant;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    align,
    component,
    padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
    size: sizeProp || (table && table.size ? table.size : 'medium'),
    sortDirection,
    stickyHeader: variant === 'head' && table && table.stickyHeader,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  let ariaSort = null;
  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TableCellRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    "aria-sort": ariaSort,
    scope: scope,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var TableCell_TableCell = (TableCell);

/***/ }),

/***/ 53184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TableHead_TableHead; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Tablelvl2Context.js
var Tablelvl2Context = __webpack_require__(44063);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableHead/tableHeadClasses.js


function getTableHeadUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTableHead', slot);
}
const tableHeadClasses = (0,generateUtilityClasses/* default */.Z)('MuiTableHead', ['root']);
/* harmony default export */ var TableHead_tableHeadClasses = ((/* unused pure expression or super */ null && (tableHeadClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableHead/TableHead.js
'use client';



const _excluded = ["className", "component"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getTableHeadUtilityClass, classes);
};
const TableHeadRoot = (0,styled/* default */.ZP)('thead', {
  name: 'MuiTableHead',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-header-group'
});
const tablelvl2 = {
  variant: 'head'
};
const defaultComponent = 'thead';
const TableHead = /*#__PURE__*/react.forwardRef(function TableHead(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTableHead'
  });
  const {
      className,
      component = defaultComponent
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tablelvl2Context/* default.Provider */.Z.Provider, {
    value: tablelvl2,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableHeadRoot, (0,esm_extends/* default */.Z)({
      as: component,
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      ref: ref,
      role: component === defaultComponent ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var TableHead_TableHead = (TableHead);

/***/ }),

/***/ 53816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TableRow_TableRow; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Tablelvl2Context.js
var Tablelvl2Context = __webpack_require__(44063);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableRow/tableRowClasses.js


function getTableRowUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTableRow', slot);
}
const tableRowClasses = (0,generateUtilityClasses/* default */.Z)('MuiTableRow', ['root', 'selected', 'hover', 'head', 'footer']);
/* harmony default export */ var TableRow_tableRowClasses = (tableRowClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableRow/TableRow.js
'use client';



const _excluded = ["className", "component", "hover", "selected"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    selected,
    hover,
    head,
    footer
  } = ownerState;
  const slots = {
    root: ['root', selected && 'selected', hover && 'hover', head && 'head', footer && 'footer']
  };
  return (0,composeClasses/* default */.Z)(slots, getTableRowUtilityClass, classes);
};
const TableRowRoot = (0,styled/* default */.ZP)('tr', {
  name: 'MuiTableRow',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.head && styles.head, ownerState.footer && styles.footer];
  }
})(({
  theme
}) => ({
  color: 'inherit',
  display: 'table-row',
  verticalAlign: 'middle',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${TableRow_tableRowClasses.hover}:hover`]: {
    backgroundColor: (theme.vars || theme).palette.action.hover
  },
  [`&.${TableRow_tableRowClasses.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
    }
  }
}));
const defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */
const TableRow = /*#__PURE__*/react.forwardRef(function TableRow(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTableRow'
  });
  const {
      className,
      component = defaultComponent,
      hover = false,
      selected = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const tablelvl2 = react.useContext(Tablelvl2Context/* default */.Z);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    hover,
    selected,
    head: tablelvl2 && tablelvl2.variant === 'head',
    footer: tablelvl2 && tablelvl2.variant === 'footer'
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TableRowRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    role: component === defaultComponent ? null : 'row',
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var TableRow_TableRow = (TableRow);

/***/ }),

/***/ 50135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextField_TextField; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useId/useId.js
var useId = __webpack_require__(92996);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./node_modules/@mui/material/FilledInput/FilledInput.js
var FilledInput = __webpack_require__(6135);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(57709);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(56815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(18360);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TextField/textFieldClasses.js


function getTextFieldUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTextField', slot);
}
const textFieldClasses = (0,generateUtilityClasses/* default */.Z)('MuiTextField', ['root']);
/* harmony default export */ var TextField_textFieldClasses = ((/* unused pure expression or super */ null && (textFieldClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TextField/TextField.js
'use client';



const _excluded = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];

















const variantComponent = {
  standard: Input/* default */.Z,
  filled: FilledInput/* default */.Z,
  outlined: OutlinedInput/* default */.Z
};
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getTextFieldUtilityClass, classes);
};
const TextFieldRoot = (0,styled/* default */.ZP)(FormControl/* default */.Z, {
  name: 'MuiTextField',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */
const TextField = /*#__PURE__*/react.forwardRef(function TextField(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTextField'
  });
  const {
      autoComplete,
      autoFocus = false,
      children,
      className,
      color = 'primary',
      defaultValue,
      disabled = false,
      error = false,
      FormHelperTextProps,
      fullWidth = false,
      helperText,
      id: idOverride,
      InputLabelProps,
      inputProps,
      InputProps,
      inputRef,
      label,
      maxRows,
      minRows,
      multiline = false,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      placeholder,
      required = false,
      rows,
      select = false,
      SelectProps,
      type,
      value,
      variant = 'outlined'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    autoFocus,
    color,
    disabled,
    error,
    fullWidth,
    multiline,
    required,
    select,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  if (false) {}
  const InputMore = {};
  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }
    InputMore.label = label;
  }
  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }
    InputMore['aria-describedby'] = undefined;
  }
  const id = (0,useId/* default */.Z)(idOverride);
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;
  const InputComponent = variantComponent[variant];
  const InputElement = /*#__PURE__*/(0,jsx_runtime.jsx)(InputComponent, (0,esm_extends/* default */.Z)({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onClick: onClick,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextFieldRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    ref: ref,
    required: required,
    color: color,
    variant: variant,
    ownerState: ownerState
  }, other, {
    children: [label != null && label !== '' && /*#__PURE__*/(0,jsx_runtime.jsx)(InputLabel/* default */.Z, (0,esm_extends/* default */.Z)({
      htmlFor: id,
      id: inputLabelId
    }, InputLabelProps, {
      children: label
    })), select ? /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, (0,esm_extends/* default */.Z)({
      "aria-describedby": helperTextId,
      id: id,
      labelId: inputLabelId,
      value: value,
      input: InputElement
    }, SelectProps, {
      children: children
    })) : InputElement, helperText && /*#__PURE__*/(0,jsx_runtime.jsx)(FormHelperText/* default */.Z, (0,esm_extends/* default */.Z)({
      id: helperTextId
    }, FormHelperTextProps, {
      children: helperText
    }))]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var TextField_TextField = (TextField);

/***/ }),

/***/ 34386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tooltip_Tooltip; }
});

// UNUSED EXPORTS: testReset

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/appendOwnerState.js
var appendOwnerState = __webpack_require__(10238);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(96514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(16078);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEventCallback.js
var useEventCallback = __webpack_require__(2068);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useId.js
var useId = __webpack_require__(27909);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(79674);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useControlled.js
var useControlled = __webpack_require__(49299);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js


function getTooltipUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTooltip', slot);
}
const tooltipClasses = (0,generateUtilityClasses/* default */.Z)('MuiTooltip', ['popper', 'popperInteractive', 'popperArrow', 'popperClose', 'tooltip', 'tooltipArrow', 'touch', 'tooltipPlacementLeft', 'tooltipPlacementRight', 'tooltipPlacementTop', 'tooltipPlacementBottom', 'arrow']);
/* harmony default export */ var Tooltip_tooltipClasses = (tooltipClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
'use client';



const _excluded = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];




















function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses = ownerState => {
  const {
    classes,
    disableInteractive,
    arrow,
    touch,
    placement
  } = ownerState;
  const slots = {
    popper: ['popper', !disableInteractive && 'popperInteractive', arrow && 'popperArrow'],
    tooltip: ['tooltip', arrow && 'tooltipArrow', touch && 'touch', `tooltipPlacement${(0,capitalize/* default */.Z)(placement.split('-')[0])}`],
    arrow: ['arrow']
  };
  return (0,composeClasses/* default */.Z)(slots, getTooltipUtilityClass, classes);
};
const TooltipPopper = (0,styled/* default */.ZP)(Popper/* default */.Z, {
  name: 'MuiTooltip',
  slot: 'Popper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.popper, !ownerState.disableInteractive && styles.popperInteractive, ownerState.arrow && styles.popperArrow, !ownerState.open && styles.popperClose];
  }
})(({
  theme,
  ownerState,
  open
}) => (0,esm_extends/* default */.Z)({
  zIndex: (theme.vars || theme).zIndex.tooltip,
  pointerEvents: 'none'
}, !ownerState.disableInteractive && {
  pointerEvents: 'auto'
}, !open && {
  pointerEvents: 'none'
}, ownerState.arrow && {
  [`&[data-popper-placement*="bottom"] .${Tooltip_tooltipClasses.arrow}`]: {
    top: 0,
    marginTop: '-0.71em',
    '&::before': {
      transformOrigin: '0 100%'
    }
  },
  [`&[data-popper-placement*="top"] .${Tooltip_tooltipClasses.arrow}`]: {
    bottom: 0,
    marginBottom: '-0.71em',
    '&::before': {
      transformOrigin: '100% 0'
    }
  },
  [`&[data-popper-placement*="right"] .${Tooltip_tooltipClasses.arrow}`]: (0,esm_extends/* default */.Z)({}, !ownerState.isRtl ? {
    left: 0,
    marginLeft: '-0.71em'
  } : {
    right: 0,
    marginRight: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '100% 100%'
    }
  }),
  [`&[data-popper-placement*="left"] .${Tooltip_tooltipClasses.arrow}`]: (0,esm_extends/* default */.Z)({}, !ownerState.isRtl ? {
    right: 0,
    marginRight: '-0.71em'
  } : {
    left: 0,
    marginLeft: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '0 0'
    }
  })
}));
const TooltipTooltip = (0,styled/* default */.ZP)('div', {
  name: 'MuiTooltip',
  slot: 'Tooltip',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.tooltip, ownerState.touch && styles.touch, ownerState.arrow && styles.tooltipArrow, styles[`tooltipPlacement${(0,capitalize/* default */.Z)(ownerState.placement.split('-')[0])}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[700], 0.92),
  borderRadius: (theme.vars || theme).shape.borderRadius,
  color: (theme.vars || theme).palette.common.white,
  fontFamily: theme.typography.fontFamily,
  padding: '4px 8px',
  fontSize: theme.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: 'break-word',
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.arrow && {
  position: 'relative',
  margin: 0
}, ownerState.touch && {
  padding: '8px 16px',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: `${round(16 / 14)}em`,
  fontWeight: theme.typography.fontWeightRegular
}, {
  [`.${Tooltip_tooltipClasses.popper}[data-popper-placement*="left"] &`]: (0,esm_extends/* default */.Z)({
    transformOrigin: 'right center'
  }, !ownerState.isRtl ? (0,esm_extends/* default */.Z)({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  }) : (0,esm_extends/* default */.Z)({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  })),
  [`.${Tooltip_tooltipClasses.popper}[data-popper-placement*="right"] &`]: (0,esm_extends/* default */.Z)({
    transformOrigin: 'left center'
  }, !ownerState.isRtl ? (0,esm_extends/* default */.Z)({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  }) : (0,esm_extends/* default */.Z)({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  })),
  [`.${Tooltip_tooltipClasses.popper}[data-popper-placement*="top"] &`]: (0,esm_extends/* default */.Z)({
    transformOrigin: 'center bottom',
    marginBottom: '14px'
  }, ownerState.touch && {
    marginBottom: '24px'
  }),
  [`.${Tooltip_tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: (0,esm_extends/* default */.Z)({
    transformOrigin: 'center top',
    marginTop: '14px'
  }, ownerState.touch && {
    marginTop: '24px'
  })
}));
const TooltipArrow = (0,styled/* default */.ZP)('span', {
  name: 'MuiTooltip',
  slot: 'Arrow',
  overridesResolver: (props, styles) => styles.arrow
})(({
  theme
}) => ({
  overflow: 'hidden',
  position: 'absolute',
  width: '1em',
  height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */,
  boxSizing: 'border-box',
  color: theme.vars ? theme.vars.palette.Tooltip.bg : (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[700], 0.9),
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'currentColor',
    transform: 'rotate(45deg)'
  }
}));
let hystersisOpen = false;
let hystersisTimer = null;
let cursorPosition = {
  x: 0,
  y: 0
};
function testReset() {
  hystersisOpen = false;
  clearTimeout(hystersisTimer);
}
function composeEventHandler(handler, eventHandler) {
  return event => {
    if (eventHandler) {
      eventHandler(event);
    }
    handler(event);
  };
}

// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const Tooltip = /*#__PURE__*/react.forwardRef(function Tooltip(inProps, ref) {
  var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTooltip'
  });
  const {
      arrow = false,
      children: childrenProp,
      components = {},
      componentsProps = {},
      describeChild = false,
      disableFocusListener = false,
      disableHoverListener = false,
      disableInteractive: disableInteractiveProp = false,
      disableTouchListener = false,
      enterDelay = 100,
      enterNextDelay = 0,
      enterTouchDelay = 700,
      followCursor = false,
      id: idProp,
      leaveDelay = 0,
      leaveTouchDelay = 1500,
      onClose,
      onOpen,
      open: openProp,
      placement = 'bottom',
      PopperComponent: PopperComponentProp,
      PopperProps = {},
      slotProps = {},
      slots = {},
      title,
      TransitionComponent: TransitionComponentProp = Grow/* default */.Z,
      TransitionProps
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  // to prevent runtime errors, developers will need to provide a child as a React element anyway.
  const children = /*#__PURE__*/react.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: childrenProp
  });
  const theme = (0,useTheme/* default */.Z)();
  const isRtl = theme.direction === 'rtl';
  const [childNode, setChildNode] = react.useState();
  const [arrowRef, setArrowRef] = react.useState(null);
  const ignoreNonTouchEvents = react.useRef(false);
  const disableInteractive = disableInteractiveProp || followCursor;
  const closeTimer = react.useRef();
  const enterTimer = react.useRef();
  const leaveTimer = react.useRef();
  const touchTimer = react.useRef();
  const [openState, setOpenState] = (0,useControlled/* default */.Z)({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  });
  let open = openState;
  if (false) {}
  const id = (0,useId/* default */.Z)(idProp);
  const prevUserSelect = react.useRef();
  const stopTouchInteraction = react.useCallback(() => {
    if (prevUserSelect.current !== undefined) {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      prevUserSelect.current = undefined;
    }
    clearTimeout(touchTimer.current);
  }, []);
  react.useEffect(() => {
    return () => {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      stopTouchInteraction();
    };
  }, [stopTouchInteraction]);
  const handleOpen = event => {
    clearTimeout(hystersisTimer);
    hystersisOpen = true;

    // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
    setOpenState(true);
    if (onOpen && !open) {
      onOpen(event);
    }
  };
  const handleClose = (0,useEventCallback/* default */.Z)(
  /**
   * @param {React.SyntheticEvent | Event} event
   */
  event => {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(() => {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);
    if (onClose && open) {
      onClose(event);
    }
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  });
  const handleEnter = event => {
    if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
      return;
    }

    // Remove the title ahead of time.
    // We don't want to wait for the next render commit.
    // We would risk displaying two tooltips at the same time (native + this one).
    if (childNode) {
      childNode.removeAttribute('title');
    }
    clearTimeout(enterTimer.current);
    clearTimeout(leaveTimer.current);
    if (enterDelay || hystersisOpen && enterNextDelay) {
      enterTimer.current = setTimeout(() => {
        handleOpen(event);
      }, hystersisOpen ? enterNextDelay : enterDelay);
    } else {
      handleOpen(event);
    }
  };
  const handleLeave = event => {
    clearTimeout(enterTimer.current);
    clearTimeout(leaveTimer.current);
    leaveTimer.current = setTimeout(() => {
      handleClose(event);
    }, leaveDelay);
  };
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
  // We just need to re-render the Tooltip if the focus-visible state changes.
  const [, setChildIsFocusVisible] = react.useState(false);
  const handleBlur = event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setChildIsFocusVisible(false);
      handleLeave(event);
    }
  };
  const handleFocus = event => {
    // Workaround for https://github.com/facebook/react/issues/7769
    // The autoFocus of React might trigger the event before the componentDidMount.
    // We need to account for this eventuality.
    if (!childNode) {
      setChildNode(event.currentTarget);
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setChildIsFocusVisible(true);
      handleEnter(event);
    }
  };
  const detectTouchStart = event => {
    ignoreNonTouchEvents.current = true;
    const childrenProps = children.props;
    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };
  const handleMouseOver = handleEnter;
  const handleMouseLeave = handleLeave;
  const handleTouchStart = event => {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    stopTouchInteraction();
    prevUserSelect.current = document.body.style.WebkitUserSelect;
    // Prevent iOS text selection on long-tap.
    document.body.style.WebkitUserSelect = 'none';
    touchTimer.current = setTimeout(() => {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      handleEnter(event);
    }, enterTouchDelay);
  };
  const handleTouchEnd = event => {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }
    stopTouchInteraction();
    clearTimeout(leaveTimer.current);
    leaveTimer.current = setTimeout(() => {
      handleClose(event);
    }, leaveTouchDelay);
  };
  react.useEffect(() => {
    if (!open) {
      return undefined;
    }

    /**
     * @param {KeyboardEvent} nativeEvent
     */
    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        handleClose(nativeEvent);
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleClose, open]);
  const handleRef = (0,useForkRef/* default */.Z)(children.ref, focusVisibleRef, setChildNode, ref);

  // There is no point in displaying an empty tooltip.
  if (!title && title !== 0) {
    open = false;
  }
  const popperRef = react.useRef();
  const handleMouseMove = event => {
    const childrenProps = children.props;
    if (childrenProps.onMouseMove) {
      childrenProps.onMouseMove(event);
    }
    cursorPosition = {
      x: event.clientX,
      y: event.clientY
    };
    if (popperRef.current) {
      popperRef.current.update();
    }
  };
  const nameOrDescProps = {};
  const titleIsString = typeof title === 'string';
  if (describeChild) {
    nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
    nameOrDescProps['aria-describedby'] = open ? id : null;
  } else {
    nameOrDescProps['aria-label'] = titleIsString ? title : null;
    nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
  }
  const childrenProps = (0,esm_extends/* default */.Z)({}, nameOrDescProps, other, children.props, {
    className: (0,clsx_m/* default */.Z)(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  }, followCursor ? {
    onMouseMove: handleMouseMove
  } : {});
  if (false) {}
  const interactiveWrapperListeners = {};
  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }
  if (!disableHoverListener) {
    childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
    childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
    if (!disableInteractive) {
      interactiveWrapperListeners.onMouseOver = handleMouseOver;
      interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
    }
  }
  if (!disableFocusListener) {
    childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
    childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
    if (!disableInteractive) {
      interactiveWrapperListeners.onFocus = handleFocus;
      interactiveWrapperListeners.onBlur = handleBlur;
    }
  }
  if (false) {}
  const popperOptions = react.useMemo(() => {
    var _PopperProps$popperOp;
    let tooltipModifiers = [{
      name: 'arrow',
      enabled: Boolean(arrowRef),
      options: {
        element: arrowRef,
        padding: 4
      }
    }];
    if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) {
      tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
    }
    return (0,esm_extends/* default */.Z)({}, PopperProps.popperOptions, {
      modifiers: tooltipModifiers
    });
  }, [arrowRef, PopperProps]);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    isRtl,
    arrow,
    disableInteractive,
    placement,
    PopperComponentProp,
    touch: ignoreNonTouchEvents.current
  });
  const classes = useUtilityClasses(ownerState);
  const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : TooltipPopper;
  const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : Grow/* default */.Z;
  const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : TooltipTooltip;
  const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : TooltipArrow;
  const popperProps = (0,appendOwnerState/* default */.Z)(PopperComponent, (0,esm_extends/* default */.Z)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
    className: (0,clsx_m/* default */.Z)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
  }), ownerState);
  const transitionProps = (0,appendOwnerState/* default */.Z)(TransitionComponent, (0,esm_extends/* default */.Z)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
  const tooltipProps = (0,appendOwnerState/* default */.Z)(TooltipComponent, (0,esm_extends/* default */.Z)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
    className: (0,clsx_m/* default */.Z)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
  }), ownerState);
  const tooltipArrowProps = (0,appendOwnerState/* default */.Z)(ArrowComponent, (0,esm_extends/* default */.Z)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
    className: (0,clsx_m/* default */.Z)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
  }), ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/react.cloneElement(children, childrenProps), /*#__PURE__*/(0,jsx_runtime.jsx)(PopperComponent, (0,esm_extends/* default */.Z)({
      as: PopperComponentProp != null ? PopperComponentProp : Popper/* default */.Z,
      placement: placement,
      anchorEl: followCursor ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : childNode,
      popperRef: popperRef,
      open: childNode ? open : false,
      id: id,
      transition: true
    }, interactiveWrapperListeners, popperProps, {
      popperOptions: popperOptions,
      children: ({
        TransitionProps: TransitionPropsInner
      }) => /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
        timeout: theme.transitions.duration.shorter
      }, TransitionPropsInner, transitionProps, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TooltipComponent, (0,esm_extends/* default */.Z)({}, tooltipProps, {
          children: [title, arrow ? /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowComponent, (0,esm_extends/* default */.Z)({}, tooltipArrowProps, {
            ref: setArrowRef
          })) : null]
        }))
      }))
    }))]
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Tooltip_Tooltip = (Tooltip);

/***/ }),

/***/ 15861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography_Typography; }
});

// UNUSED EXPORTS: TypographyRoot

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Typography/typographyClasses.js


function getTypographyUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTypography', slot);
}
const typographyClasses = (0,generateUtilityClasses/* default */.Z)('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);
/* harmony default export */ var Typography_typographyClasses = ((/* unused pure expression or super */ null && (typographyClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Typography/Typography.js
'use client';



const _excluded = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];










const useUtilityClasses = ownerState => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && `align${(0,capitalize/* default */.Z)(align)}`, gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return (0,composeClasses/* default */.Z)(slots, getTypographyUtilityClass, classes);
};
const TypographyRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles[`align${(0,capitalize/* default */.Z)(ownerState.align)}`], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  margin: 0
}, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, ownerState.gutterBottom && {
  marginBottom: '0.35em'
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
};

// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};
const Typography = /*#__PURE__*/react.forwardRef(function Typography(inProps, ref) {
  const themeProps = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTypography'
  });
  const color = transformDeprecatedColors(themeProps.color);
  const props = (0,extendSxProp/* default */.Z)((0,esm_extends/* default */.Z)({}, themeProps, {
    color
  }));
  const {
      align = 'inherit',
      className,
      component,
      gutterBottom = false,
      noWrap = false,
      paragraph = false,
      variant = 'body1',
      variantMapping = defaultVariantMapping
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    align,
    color,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });
  const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TypographyRoot, (0,esm_extends/* default */.Z)({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Typography_Typography = (Typography);

/***/ }),

/***/ 21964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ internal_SwitchBase; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useControlled.js
var useControlled = __webpack_require__(49299);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/switchBaseClasses.js


function getSwitchBaseUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('PrivateSwitchBase', slot);
}
const switchBaseClasses = (0,generateUtilityClasses/* default */.Z)('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);
/* harmony default export */ var internal_switchBaseClasses = ((/* unused pure expression or super */ null && (switchBaseClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/SwitchBase.js
'use client';



const _excluded = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"];













const useUtilityClasses = ownerState => {
  const {
    classes,
    checked,
    disabled,
    edge
  } = ownerState;
  const slots = {
    root: ['root', checked && 'checked', disabled && 'disabled', edge && `edge${(0,capitalize/* default */.Z)(edge)}`],
    input: ['input']
  };
  return (0,composeClasses/* default */.Z)(slots, getSwitchBaseUtilityClass, classes);
};
const SwitchBaseRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z)(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  padding: 9,
  borderRadius: '50%'
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}));
const SwitchBaseInput = (0,styled/* default */.ZP)('input')({
  cursor: 'inherit',
  position: 'absolute',
  opacity: 0,
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
});

/**
 * @ignore - internal component.
 */
const SwitchBase = /*#__PURE__*/react.forwardRef(function SwitchBase(props, ref) {
  const {
      autoFocus,
      checked: checkedProp,
      checkedIcon,
      className,
      defaultChecked,
      disabled: disabledProp,
      disableFocusRipple = false,
      edge = false,
      icon,
      id,
      inputProps,
      inputRef,
      name,
      onBlur,
      onChange,
      onFocus,
      readOnly,
      required = false,
      tabIndex,
      type,
      value
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const [checked, setCheckedState] = (0,useControlled/* default */.Z)({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  });
  const muiFormControl = (0,useFormControl/* default */.Z)();
  const handleFocus = event => {
    if (onFocus) {
      onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };
  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };
  const handleInputChange = event => {
    // Workaround for https://github.com/facebook/react/issues/9023
    if (event.nativeEvent.defaultPrevented) {
      return;
    }
    const newChecked = event.target.checked;
    setCheckedState(newChecked);
    if (onChange) {
      // TODO v6: remove the second argument.
      onChange(event, newChecked);
    }
  };
  let disabled = disabledProp;
  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }
  const hasLabelFor = type === 'checkbox' || type === 'radio';
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    checked,
    disabled,
    disableFocusRipple,
    edge
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SwitchBaseRoot, (0,esm_extends/* default */.Z)({
    component: "span",
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SwitchBaseInput, (0,esm_extends/* default */.Z)({
      autoFocus: autoFocus,
      checked: checkedProp,
      defaultChecked: defaultChecked,
      className: classes.input,
      disabled: disabled,
      id: hasLabelFor ? id : undefined,
      name: name,
      onChange: handleInputChange,
      readOnly: readOnly,
      ref: inputRef,
      required: required,
      ownerState: ownerState,
      tabIndex: tabIndex,
      type: type
    }, type === 'checkbox' && value === undefined ? {} : {
      value
    }, inputProps)), checked ? checkedIcon : icon]
  }));
});

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
 false ? 0 : void 0;
/* harmony default export */ var internal_SwitchBase = (SwitchBase);

/***/ }),

/***/ 60224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown'));

/***/ }),

/***/ 34484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';




/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */

/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close'));

/***/ }),

/***/ 68239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_createTheme; }
});

// UNUSED EXPORTS: createMuiTheme

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(59766);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(66500);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js + 5 modules
var defaultSxConfig = __webpack_require__(44920);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createMixins.js

function createMixins(breakpoints, mixins) {
  return (0,esm_extends/* default */.Z)({
    toolbar: {
      minHeight: 56,
      [breakpoints.up('xs')]: {
        '@media (orientation: landscape)': {
          minHeight: 48
        }
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/common.js
const common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ var colors_common = (common);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/grey.js
const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
/* harmony default export */ var colors_grey = (grey);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/purple.js
const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* harmony default export */ var colors_purple = (purple);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/red.js
const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ var colors_red = (red);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/orange.js
const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ var colors_orange = (orange);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/blue.js
const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ var colors_blue = (blue);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/lightBlue.js
const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* harmony default export */ var colors_lightBlue = (lightBlue);
;// CONCATENATED MODULE: ./node_modules/@mui/material/colors/green.js
const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ var colors_green = (green);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createPalette.js



const _excluded = ["mode", "contrastThreshold", "tonalOffset"];










const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: colors_common.white,
    default: colors_common.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: colors_common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: colors_common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_blue[200],
      light: colors_blue[50],
      dark: colors_blue[400]
    };
  }
  return {
    main: colors_blue[700],
    light: colors_blue[400],
    dark: colors_blue[800]
  };
}
function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_purple[200],
      light: colors_purple[50],
      dark: colors_purple[400]
    };
  }
  return {
    main: colors_purple[500],
    light: colors_purple[300],
    dark: colors_purple[700]
  };
}
function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_red[500],
      light: colors_red[300],
      dark: colors_red[700]
    };
  }
  return {
    main: colors_red[700],
    light: colors_red[400],
    dark: colors_red[800]
  };
}
function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_lightBlue[400],
      light: colors_lightBlue[300],
      dark: colors_lightBlue[700]
    };
  }
  return {
    main: colors_lightBlue[700],
    light: colors_lightBlue[500],
    dark: colors_lightBlue[900]
  };
}
function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_green[400],
      light: colors_green[300],
      dark: colors_green[700]
    };
  }
  return {
    main: colors_green[800],
    light: colors_green[500],
    dark: colors_green[900]
  };
}
function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_orange[400],
      light: colors_orange[300],
      dark: colors_orange[700]
    };
  }
  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: colors_orange[500],
    dark: colors_orange[900]
  };
}
function createPalette(palette) {
  const {
      mode = 'light',
      contrastThreshold = 3,
      tonalOffset = 0.2
    } = palette,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(palette, _excluded);
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);

  // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
  function getContrastText(background) {
    const contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (false) {}
    return contrastText;
  }
  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = (0,esm_extends/* default */.Z)({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.hasOwnProperty('main')) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(11, name ? ` (${name})` : '', mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  const modes = {
    dark,
    light
  };
  if (false) {}
  const paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: (0,esm_extends/* default */.Z)({}, colors_common),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: colors_grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createTypography.js


const createTypography_excluded = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */
function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
    {
      fontFamily = defaultFontFamily,
      // The default font size of the Material Specification.
      fontSize = 14,
      // px
      fontWeightLight = 300,
      fontWeightRegular = 400,
      fontWeightMedium = 500,
      fontWeightBold = 700,
      // Tell MUI what's the font-size on the html element.
      // 16px is the default font-size used by browsers.
      htmlFontSize = 16,
      // Apply the CSS properties to all the variants.
      allVariants,
      pxToRem: pxToRem2
    } = _ref,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, createTypography_excluded);
  if (false) {}
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => (0,esm_extends/* default */.Z)({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    inherit: {
      fontFamily: 'inherit',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit'
    }
  };
  return (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep
  });
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/shadows.js
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
}

// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTransitions.js
var createTransitions = __webpack_require__(96067);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/zIndex.js
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ var styles_zIndex = (zIndex);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createTheme.js



const createTheme_excluded = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];









function createTheme_createTheme(options = {}, ...args) {
  const {
      mixins: mixinsInput = {},
      palette: paletteInput = {},
      transitions: transitionsInput = {},
      typography: typographyInput = {}
    } = options,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);
  if (options.vars) {
    throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(18));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = (0,createTheme/* default */.Z)(options);
  let muiTheme = (0,deepmerge/* default */.Z)(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: styles_shadows.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: (0,createTransitions/* default */.ZP)(transitionsInput),
    zIndex: (0,esm_extends/* default */.Z)({}, styles_zIndex)
  });
  muiTheme = (0,deepmerge/* default */.Z)(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);
  if (false) {}
  muiTheme.unstable_sxConfig = (0,esm_extends/* default */.Z)({}, defaultSxConfig/* default */.Z, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0,styleFunctionSx/* default */.Z)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
let warnedOnce = false;
function createMuiTheme(...args) {
  if (false) {}
  return createTheme_createTheme(...args);
}
/* harmony default export */ var styles_createTheme = (createTheme_createTheme);

/***/ }),

/***/ 96067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ createTransitions; },
/* harmony export */   "x9": function() { return /* binding */ duration; }
/* harmony export */ });
/* unused harmony export easing */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


const _excluded = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }
  const constant = height / 36;

  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, easing, inputTransitions.easing);
  const mergedDuration = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, duration, inputTransitions.duration);
  const create = (props = ['all'], options = {}) => {
    const {
        duration: durationOption = mergedDuration.standard,
        easing: easingOption = mergedEasing.easeInOut,
        delay = 0
      } = options,
      other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options, _excluded);
    if (false) {}
    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

/***/ }),

/***/ 88606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LV": function() { return /* binding */ alignProperty; },
/* harmony export */   "Wy": function() { return /* binding */ getUnit; },
/* harmony export */   "YL": function() { return /* binding */ toUnitless; },
/* harmony export */   "dA": function() { return /* binding */ isUnitless; },
/* harmony export */   "vY": function() { return /* binding */ fontGrid; },
/* harmony export */   "vs": function() { return /* binding */ convertLength; },
/* harmony export */   "ze": function() { return /* binding */ responsiveProperty; }
/* harmony export */ });
function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
}

// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}

// Emulate the sass function "unitless"
function toUnitless(length) {
  return parseFloat(length);
}

// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function convertLength(baseFontSize) {
  return (length, toUnit) => {
    const fromUnit = getUnit(length);

    // Optimize for cases where `from` and `to` units are accidentally the same.
    if (fromUnit === toUnit) {
      return length;
    }

    // Convert input length to pixels.
    let pxLength = toUnitless(length);
    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      }
    }

    // Convert length in pixels to the output unit
    let outputLength = pxLength;
    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }
    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty({
  size,
  grid
}) {
  const sizeBelow = size - size % grid;
  const sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}

// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function fontGrid({
  lineHeight,
  pixels,
  htmlFontSize
}) {
  return pixels / (lineHeight * htmlFontSize);
}

/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */
function responsiveProperty({
  cssProperty,
  min,
  max,
  unit = 'rem',
  breakpoints = [600, 900, 1200],
  transform = null
}) {
  const output = {
    [cssProperty]: `${min}${unit}`
  };
  const factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(breakpoint => {
    let value = min + factor * breakpoint;
    if (transform !== null) {
      value = transform(value);
    }
    output[`@media (min-width:${breakpoint}px)`] = {
      [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
    };
  });
  return output;
}

/***/ }),

/***/ 90247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68239);
'use client';


const defaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (defaultTheme);

/***/ }),

/***/ 10606:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ('$$material');

/***/ }),

/***/ 90948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dz": function() { return /* binding */ slotShouldForwardProp; },
/* harmony export */   "FO": function() { return /* binding */ rootShouldForwardProp; }
/* harmony export */ });
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70182);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90247);
/* harmony import */ var _identifier__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10606);
'use client';




const rootShouldForwardProp = prop => (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* .shouldForwardProp */ .x9)(prop) && prop !== 'classes';
const slotShouldForwardProp = _mui_system__WEBPACK_IMPORTED_MODULE_0__/* .shouldForwardProp */ .x9;
const styled = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
  themeId: _identifier__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
  defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
  rootShouldForwardProp
});
/* harmony default export */ __webpack_exports__["ZP"] = (styled);

/***/ }),

/***/ 2734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96682);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90247);
/* harmony import */ var _identifier__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10606);
'use client';





function useTheme() {
  const theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  if (false) {}
  return theme[_identifier__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z] || theme;
}

/***/ }),

/***/ 71657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29628);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90247);
/* harmony import */ var _identifier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10606);
'use client';




function useThemeProps({
  props,
  name
}) {
  return (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    props,
    name,
    defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    themeId: _identifier__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
  });
}

/***/ }),

/***/ 30577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getTransitionProps; },
/* harmony export */   "n": function() { return /* binding */ reflow; }
/* harmony export */ });
const reflow = node => node.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;
  const {
    timeout,
    easing,
    style = {}
  } = props;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}

/***/ }),

/***/ 98396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34168);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58974);
'use client';





/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match, setMatch] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }

    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });
  (0,_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    let active = true;
    if (!matchMedia) {
      return undefined;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    // TODO: Use `addEventListener` once support for Safari < 14 is dropped
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useSyncExternalStore' + ''];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery(queryInput, options = {}) {
  const theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr = false
  } = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });
  if (false) {}
  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');

  // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (false) {}
  return match;
}

/***/ }),

/***/ 98216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14142);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 35893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49064);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 82066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createSvgIcon; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53219);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';





/**
 * Private module reserved for @mui packages.
 */

function createSvgIcon(path, displayName) {
  function Component(props, ref) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      "data-testid": `${displayName}Icon`,
      ref: ref
    }, props, {
      children: path
    }));
  }
  if (false) {}
  Component.muiName = _SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"].muiName */ .Z.muiName;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Component));
}

/***/ }),

/***/ 57144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39336);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 58372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ createChainedFunction/* default */.Z; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ utils_deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ utils_requirePropFactory; },
  "setRef": function() { return /* reexport */ utils_setRef; },
  "unstable_ClassNameGenerator": function() { return /* binding */ unstable_ClassNameGenerator; },
  "unstable_useEnhancedEffect": function() { return /* reexport */ useEnhancedEffect/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ utils_unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(37078);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(35893);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return () => null;
  }
  return (props, propName, componentName, location, propFullName) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
      return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
    }
    return null;
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/deprecatedPropType.js

/* harmony default export */ var utils_deprecatedPropType = (deprecatedPropType);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(71579);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerDocument.js
var ownerDocument = __webpack_require__(8038);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerWindow.js
var ownerWindow = __webpack_require__(5340);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/requirePropFactory.js

function requirePropFactory(componentNameInError, Component) {
  if (true) {
    return () => null;
  }

  // eslint-disable-next-line react/forbid-foreign-prop-types
  const prevPropTypes = Component ? (0,esm_extends/* default */.Z)({}, Component.propTypes) : null;
  const requireProp = requiredProp => (props, propName, componentName, location, propFullName, ...args) => {
    const propFullNameSafe = propFullName || propName;
    const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
    if (defaultTypeChecker) {
      const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
      if (typeCheckerResult) {
        return typeCheckerResult;
      }
    }
    if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
      return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
    }
    return null;
  };
  return requireProp;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/requirePropFactory.js

/* harmony default export */ var utils_requirePropFactory = (requirePropFactory);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/setRef.js
var setRef = __webpack_require__(7960);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/setRef.js

/* harmony default export */ var utils_setRef = (setRef/* default */.Z);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(58974);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useId.js
var useId = __webpack_require__(27909);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/unsupportedProp.js

/* harmony default export */ var utils_unsupportedProp = (unsupportedProp);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useControlled.js
var useControlled = __webpack_require__(49299);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEventCallback.js
var useEventCallback = __webpack_require__(2068);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(79674);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/index.js
'use client';



















// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_ClassNameGenerator = {
  configure: generator => {
    if (false) {}
    ClassNameGenerator/* default.configure */.Z.configure(generator);
  }
};

/***/ }),

/***/ 71579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_isMuiElement; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/isMuiElement.js

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/react.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/isMuiElement.js

/* harmony default export */ var utils_isMuiElement = (isMuiElement);

/***/ }),

/***/ 8038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82690);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 5340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74161);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 49299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19032);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 58974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73546);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 2068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59948);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 51705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33703);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 27909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92996);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 79674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99962);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 51825:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["Z"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),

/***/ 44819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (ThemeContext);

/***/ }),

/***/ 56760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44819);


function useTheme() {
  const theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
  if (false) {}
  return theme;
}

/***/ }),

/***/ 49731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ styled; },
  "Co": function() { return /* binding */ internal_processStyles; }
});

// UNUSED EXPORTS: GlobalStyles, StyledEngineProvider, ThemeContext, css, keyframes

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js
var emotion_element_c39617d8_browser_esm = __webpack_require__(75260);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(48137);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_c39617d8_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react.useContext(emotion_element_c39617d8_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});



;// CONCATENATED MODULE: ./node_modules/@mui/styled-engine/index.js
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable no-underscore-dangle */

function styled(tag, options) {
  const stylesFactory = newStyled(tag, options);
  if (false) {}
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};




/***/ }),

/***/ 73327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createStyles; }
/* harmony export */ });
function createStyles(styles) {
  return styles;
}

/***/ }),

/***/ 61214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ makeStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js + 5 modules
var jss_esm = __webpack_require__(33512);
;// CONCATENATED MODULE: ./node_modules/@mui/styles/mergeClasses/mergeClasses.js


function mergeClasses(options = {}) {
  const {
    baseClasses,
    newClasses,
    Component
  } = options;
  if (!newClasses) {
    return baseClasses;
  }
  const nextClasses = (0,esm_extends/* default */.Z)({}, baseClasses);
  if (false) {}
  Object.keys(newClasses).forEach(key => {
    if (false) {}
    if (newClasses[key]) {
      nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    }
  });
  return nextClasses;
}
;// CONCATENATED MODULE: ./node_modules/@mui/styles/makeStyles/multiKeyStore.js
// Used https://github.com/thinkloop/multi-key-cache as inspiration

const multiKeyStore = {
  set: (cache, key1, key2, value) => {
    let subCache = cache.get(key1);
    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }
    subCache.set(key2, value);
  },
  get: (cache, key1, key2) => {
    const subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: (cache, key1, key2) => {
    const subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ var makeStyles_multiKeyStore = (multiKeyStore);
// EXTERNAL MODULE: ./node_modules/@mui/styles/useTheme/index.js
var useTheme = __webpack_require__(48678);
// EXTERNAL MODULE: ./node_modules/@mui/private-theming/ThemeProvider/nested.js
var nested = __webpack_require__(51825);
;// CONCATENATED MODULE: ./node_modules/@mui/styles/createGenerateClassName/createGenerateClassName.js


/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */
const stateClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

// Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
function createGenerateClassName(options = {}) {
  const {
    disableGlobal = false,
    productionPrefix = 'jss',
    seed = ''
  } = options;
  const seedPrefix = seed === '' ? '' : `${seed}-`;
  let ruleCounter = 0;
  const getNextCounterId = () => {
    ruleCounter += 1;
    if (false) {}
    return ruleCounter;
  };
  return (rule, styleSheet) => {
    const name = styleSheet.options.name;

    // Is a global static MUI style?
    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (stateClasses.indexOf(rule.key) !== -1) {
        return `Mui-${rule.key}`;
      }
      const prefix = `${seedPrefix}${name}-${rule.key}`;
      if (!styleSheet.options.theme[nested/* default */.Z] || seed !== '') {
        return prefix;
      }
      return `${prefix}-${getNextCounterId()}`;
    }
    if (true) {
      return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    }
    const suffix = `${rule.key}-${getNextCounterId()}`;

    // Help with debuggability.
    if (styleSheet.options.classNamePrefix) {
      return `${seedPrefix}${styleSheet.options.classNamePrefix}-${suffix}`;
    }
    return `${seedPrefix}${suffix}`;
  };
}
// EXTERNAL MODULE: ./node_modules/jss-plugin-rule-value-function/dist/jss-plugin-rule-value-function.esm.js
var jss_plugin_rule_value_function_esm = __webpack_require__(27202);
// EXTERNAL MODULE: ./node_modules/jss-plugin-global/dist/jss-plugin-global.esm.js
var jss_plugin_global_esm = __webpack_require__(5019);
// EXTERNAL MODULE: ./node_modules/jss-plugin-nested/dist/jss-plugin-nested.esm.js
var jss_plugin_nested_esm = __webpack_require__(63057);
// EXTERNAL MODULE: ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js + 1 modules
var jss_plugin_camel_case_esm = __webpack_require__(16345);
// EXTERNAL MODULE: ./node_modules/jss-plugin-default-unit/dist/jss-plugin-default-unit.esm.js
var jss_plugin_default_unit_esm = __webpack_require__(83961);
// EXTERNAL MODULE: ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js + 7 modules
var jss_plugin_vendor_prefixer_esm = __webpack_require__(79368);
// EXTERNAL MODULE: ./node_modules/jss-plugin-props-sort/dist/jss-plugin-props-sort.esm.js
var jss_plugin_props_sort_esm = __webpack_require__(26895);
;// CONCATENATED MODULE: ./node_modules/@mui/styles/jssPreset/jssPreset.js








// Subset of jss-preset-default with only the plugins the MUI components are using.
function jssPreset_jssPreset() {
  return {
    plugins: [(0,jss_plugin_rule_value_function_esm/* default */.Z)(), (0,jss_plugin_global_esm/* default */.Z)(), (0,jss_plugin_nested_esm/* default */.Z)(), (0,jss_plugin_camel_case_esm/* default */.Z)(), (0,jss_plugin_default_unit_esm/* default */.Z)(),
    // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : (0,jss_plugin_vendor_prefixer_esm/* default */.Z)(), (0,jss_plugin_props_sort_esm/* default */.Z)()]
  };
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/styles/StylesProvider/StylesProvider.js


const _excluded = (/* unused pure expression or super */ null && (["children", "injectFirst", "disableGeneration"]));







// Default JSS instance.

const defaultJSS = (0,jss_esm/* create */.Ue)(jssPreset_jssPreset());

// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const defaultGenerateClassName = createGenerateClassName();
const defaultSheetsManager = new Map();
// Exported for test purposes

const defaultOptions = {
  disableGeneration: false,
  generateClassName: defaultGenerateClassName,
  jss: defaultJSS,
  sheetsCache: null,
  sheetsManager: defaultSheetsManager,
  sheetsRegistry: null
};
const StylesContext = /*#__PURE__*/react.createContext(defaultOptions);
if (false) {}
let injectFirstNode;
function StylesProvider(props) {
  const {
      children,
      injectFirst = false,
      disableGeneration = false
    } = props,
    localOptions = _objectWithoutPropertiesLoose(props, _excluded);
  const outerOptions = React.useContext(StylesContext);
  const {
    generateClassName,
    jss,
    serverGenerateClassName,
    sheetsCache,
    sheetsManager,
    sheetsRegistry
  } = _extends({}, outerOptions, localOptions);
  if (false) {}
  const value = React.useMemo(() => {
    const context = {
      disableGeneration,
      generateClassName,
      jss,
      serverGenerateClassName,
      sheetsCache,
      sheetsManager,
      sheetsRegistry
    };
    if (false) {}
    if (false) {}
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
      if (!injectFirstNode) {
        const head = document.head;
        injectFirstNode = document.createComment('mui-inject-first');
        head.insertBefore(injectFirstNode, head.firstChild);
      }
      context.jss = create({
        plugins: jssPreset().plugins,
        insertionPoint: injectFirstNode
      });
    }
    return context;
  }, [injectFirst, disableGeneration, generateClassName, jss, serverGenerateClassName, sheetsCache, sheetsManager, sheetsRegistry]);
  return /*#__PURE__*/_jsx(StylesContext.Provider, {
    value: value,
    children: children
  });
}
 false ? 0 : void 0;
if (false) {}
;// CONCATENATED MODULE: ./node_modules/@mui/styles/makeStyles/indexCounter.js
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let indexCounter = -1e9;
function increment() {
  indexCounter += 1;
  if (false) {}
  return indexCounter;
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(59766);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize/capitalize.js
var capitalize = __webpack_require__(14142);
;// CONCATENATED MODULE: ./node_modules/@mui/styles/propsToClassKey/propsToClassKey.js

const propsToClassKey_excluded = ["variant"];

function isEmpty(string) {
  return string.length === 0;
}

/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created
 */
function propsToClassKey(props) {
  const {
      variant
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, propsToClassKey_excluded);
  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty(classKey) ? props[key] : (0,capitalize/* default */.Z)(props[key]);
    } else {
      classKey += `${isEmpty(classKey) ? key : (0,capitalize/* default */.Z)(key)}${(0,capitalize/* default */.Z)(props[key].toString())}`;
    }
  });
  return classKey;
}
;// CONCATENATED MODULE: ./node_modules/@mui/styles/getStylesCreator/getStylesCreator.js




function getStylesCreator(stylesOrCreator) {
  const themingEnabled = typeof stylesOrCreator === 'function';
  if (false) {}
  return {
    create: (theme, name) => {
      let styles;
      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {}
        throw err;
      }
      if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) {
        return styles;
      }
      const overrides = theme.components[name].styleOverrides || {};
      const variants = theme.components[name].variants || [];
      const stylesWithOverrides = (0,esm_extends/* default */.Z)({}, styles);
      Object.keys(overrides).forEach(key => {
        if (false) {}
        stylesWithOverrides[key] = (0,deepmerge/* default */.Z)(stylesWithOverrides[key] || {}, overrides[key]);
      });
      variants.forEach(definition => {
        const classKey = propsToClassKey(definition.props);
        stylesWithOverrides[classKey] = (0,deepmerge/* default */.Z)(stylesWithOverrides[classKey] || {}, definition.style);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/styles/getStylesCreator/noopTheme.js
// We use the same empty object to ref count the styles that don't need a theme object.
const noopTheme = {};
/* harmony default export */ var getStylesCreator_noopTheme = (noopTheme);
;// CONCATENATED MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js


const makeStyles_excluded = ["name", "classNamePrefix", "Component", "defaultTheme"];









function getClasses({
  state,
  stylesOptions
}, classes, Component) {
  if (stylesOptions.disableGeneration) {
    return classes || {};
  }
  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  }

  // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.
  let generate = false;
  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }
  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }
  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component
    });
  }
  return state.cacheClasses.value;
}
function attach({
  state,
  theme,
  stylesOptions,
  stylesCreator,
  name
}, props) {
  if (stylesOptions.disableGeneration) {
    return;
  }
  let sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    makeStyles_multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }
  const options = (0,esm_extends/* default */.Z)({}, stylesCreator.options, stylesOptions, {
    theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });
  options.generateId = options.serverGenerateClassName || options.generateClassName;
  const sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    let staticSheet;
    if (stylesOptions.sheetsCache) {
      staticSheet = makeStyles_multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }
    const styles = stylesCreator.create(theme, name);
    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0,esm_extends/* default */.Z)({
        link: false
      }, options));
      staticSheet.attach();
      if (stylesOptions.sheetsCache) {
        makeStyles_multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }
    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }
    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = (0,jss_esm/* getDynamicStyles */._$)(styles);
  }
  if (sheetManager.dynamicStyles) {
    const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0,esm_extends/* default */.Z)({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });
    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }
  sheetManager.refs += 1;
}
function update({
  state
}, props) {
  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}
function detach({
  state,
  theme,
  stylesOptions,
  stylesCreator
}) {
  if (stylesOptions.disableGeneration) {
    return;
  }
  const sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  const sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    makeStyles_multiKeyStore["delete"](stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }
  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}
function useSynchronousEffect(func, values) {
  const key = react.useRef([]);
  let output;

  // Store "generation" key. Just returns a new object every time
  const currentKey = react.useMemo(() => ({}), values); // eslint-disable-line react-hooks/exhaustive-deps

  // "the first render", or "memo dropped the value"
  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }
  react.useEffect(() => () => {
    if (output) {
      output();
    }
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator, options = {}) {
  const {
      // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
      name,
      // Help with debuggability.
      classNamePrefix: classNamePrefixOption,
      Component,
      defaultTheme = getStylesCreator_noopTheme
    } = options,
    stylesOptions2 = (0,objectWithoutPropertiesLoose/* default */.Z)(options, makeStyles_excluded);
  const stylesCreator = getStylesCreator(stylesOrCreator);
  const classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name,
    meta: classNamePrefix,
    classNamePrefix
  };
  const useStyles = (props = {}) => {
    const theme = (0,useTheme/* default */.Z)() || defaultTheme;
    const stylesOptions = (0,esm_extends/* default */.Z)({}, react.useContext(StylesContext), stylesOptions2);
    const instance = react.useRef();
    const shouldUpdate = react.useRef();
    useSynchronousEffect(() => {
      const current = {
        name,
        state: {},
        stylesCreator,
        stylesOptions,
        theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return () => {
        detach(current);
      };
    }, [theme, stylesCreator]);
    react.useEffect(() => {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }
      shouldUpdate.current = true;
    });
    const classes = getClasses(instance.current, props.classes, Component);
    if (false) {}
    if (false) {}
    return classes;
  };
  return useStyles;
}

/***/ }),

/***/ 48678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var _mui_private_theming_useTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56760);

function useTheme() {
  var _privateTheme$$$mater;
  const privateTheme = (0,_mui_private_theming_useTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  return (_privateTheme$$$mater = privateTheme == null ? void 0 : privateTheme.$$material) != null ? _privateTheme$$$mater : privateTheme;
}

/***/ }),

/***/ 95408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ removeUnusedBreakpoints; },
/* harmony export */   "P$": function() { return /* binding */ resolveBreakpointValues; },
/* harmony export */   "VO": function() { return /* binding */ values; },
/* harmony export */   "W8": function() { return /* binding */ createEmptyBreakpointObject; },
/* harmony export */   "dt": function() { return /* binding */ mergeBreakpointsInOrder; },
/* harmony export */   "k9": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* unused harmony export computeBreakpointsBase */
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59766);





// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};

const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function breakpoints(styleFunction) {
  // false positive
  // eslint-disable-next-line react/function-component-definition
  const newStyleFunction = props => {
    const theme = props.theme || {};
    const base = styleFunction(props);
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    const extended = themeBreakpoints.keys.reduce((acc, key) => {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme
        }, props[key]));
      }
      return acc;
    }, null);
    return merge(base, extended);
  };
  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl', ...styleFunction.filterProps];
  return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [emptyBreakpoints, ...styles].reduce((prev, next) => (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}

// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }
  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));

/***/ }),

/***/ 41796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "Fq": function() { return /* binding */ alpha; },
/* harmony export */   "_j": function() { return /* binding */ darken; },
/* harmony export */   "mi": function() { return /* binding */ getContrastRatio; }
/* harmony export */ });
/* unused harmony exports hexToRgb, decomposeColor, colorChannel, private_safeColorChannel, recomposeColor, rgbToHex, hslToRgb, getLuminance, private_safeAlpha, private_safeDarken, private_safeLighten, emphasize, private_safeEmphasize */
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71387);

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min = 0, max = 1) {
  if (false) {}
  return Math.min(Math.max(min, value), max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error( false ? 0 : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }

    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return private_safeEmphasize(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/***/ }),

/***/ 70182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ createStyled; },
  "x9": function() { return /* binding */ shouldForwardProp; }
});

// UNUSED EXPORTS: systemDefaultTheme

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 3 modules
var styled_engine = __webpack_require__(49731);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(66500);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize/capitalize.js
var capitalize = __webpack_require__(14142);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/propsToClassKey.js

const _excluded = ["variant"];

function isEmpty(string) {
  return string.length === 0;
}

/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created.
 */
function propsToClassKey(props) {
  const {
      variant
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty(classKey) ? props[key] : (0,capitalize/* default */.Z)(props[key]);
    } else {
      classKey += `${isEmpty(classKey) ? key : (0,capitalize/* default */.Z)(key)}${(0,capitalize/* default */.Z)(props[key].toString())}`;
    }
  });
  return classKey;
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createStyled.js


const createStyled_excluded = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
/* eslint-disable no-underscore-dangle */





function createStyled_isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }
  return null;
};
const getVariantStyles = (name, theme) => {
  let variants = [];
  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }
  const variantsStyles = {};
  variants.forEach(definition => {
    const key = propsToClassKey(definition.props);
    variantsStyles[key] = definition.style;
  });
  return variantsStyles;
};
const variantsResolver = (props, styles, theme, name) => {
  var _theme$components;
  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
  if (themeVariants) {
    themeVariants.forEach(themeVariant => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach(key => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });
      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
      }
    });
  }
  return variantsStyles;
};

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = (0,createTheme/* default */.Z)();
const lowercaseFirstLetter = string => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme,
  theme,
  themeId
}) {
  return createStyled_isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = props => {
    return (0,styleFunctionSx/* default */.Z)((0,esm_extends/* default */.Z)({}, props, {
      theme: resolveTheme((0,esm_extends/* default */.Z)({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    (0,styled_engine/* internal_processStyles */.Co)(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        overridesResolver
      } = inputOptions,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(inputOptions, createStyled_excluded);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== 'Root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (false) {}
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === 'Root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = (0,styled_engine/* default */.ZP)(tag, (0,esm_extends/* default */.Z)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map(stylesArg => {
        // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        return typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg ? props => {
          return stylesArg((0,esm_extends/* default */.Z)({}, props, {
            theme: resolveTheme((0,esm_extends/* default */.Z)({}, props, {
              defaultTheme,
              themeId
            }))
          }));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme((0,esm_extends/* default */.Z)({}, props, {
            defaultTheme,
            themeId
          }));
          const styleOverrides = getStyleOverrides(componentName, theme);
          if (styleOverrides) {
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = typeof slotStyle === 'function' ? slotStyle((0,esm_extends/* default */.Z)({}, props, {
                theme
              })) : slotStyle;
            });
            return overridesResolver(props, resolvedStyleOverrides);
          }
          return null;
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme((0,esm_extends/* default */.Z)({}, props, {
            defaultTheme,
            themeId
          }));
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === 'function' &&
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      styleArg.__emotion_real !== styleArg) {
        // If the type is function, we need to define the default theme.
        transformedStyleArg = props => styleArg((0,esm_extends/* default */.Z)({}, props, {
          theme: resolveTheme((0,esm_extends/* default */.Z)({}, props, {
            defaultTheme,
            themeId
          }))
        }));
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (false) {}
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

/***/ }),

/***/ 66500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createTheme_createTheme; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(59766);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createBreakpoints.js


const _excluded = ["values", "unit", "step"];
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const breakpointKeys = (/* unused pure expression or super */ null && (['xs', 'sm', 'md', 'lg', 'xl']));
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return (0,esm_extends/* default */.Z)({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },

      unit = 'px',
      step = 5
    } = breakpoints,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(breakpoints, _excluded);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return (0,esm_extends/* default */.Z)({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/shape.js
const shape = {
  borderRadius: 4
};
/* harmony default export */ var createTheme_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(98700);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createSpacing.js


// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
/* tslint:disable:unified-signatures */
/* tslint:enable:unified-signatures */

function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  const transform = (0,esm_spacing/* createUnarySpacing */.hB)({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (false) {}
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js + 5 modules
var defaultSxConfig = __webpack_require__(44920);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js


const createTheme_excluded = ["breakpoints", "palette", "spacing", "shape"];






function createTheme(options = {}, ...args) {
  const {
      breakpoints: breakpointsInput = {},
      palette: paletteInput = {},
      spacing: spacingInput,
      shape: shapeInput = {}
    } = options,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: (0,esm_extends/* default */.Z)({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: (0,esm_extends/* default */.Z)({}, createTheme_shape, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = (0,esm_extends/* default */.Z)({}, defaultSxConfig/* default */.Z, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0,styleFunctionSx/* default */.Z)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
/* harmony default export */ var createTheme_createTheme = (createTheme);

/***/ }),

/***/ 47730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59766);

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 98700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ createUnarySpacing; },
  "eI": function() { return /* binding */ createUnaryUnit; },
  "NA": function() { return /* binding */ getValue; },
  "e6": function() { return /* binding */ margin; },
  "o3": function() { return /* binding */ padding; }
});

// UNUSED EXPORTS: default, getStyleFromPropValue, marginKeys, paddingKeys

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(95408);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(47730);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/memoize.js
function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/spacing.js





const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = (0,style/* getPath */.DW)(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (false) {}
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (false) {}
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (false) {}
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return (0,breakpoints/* handleBreakpoints */.k9)(props, propValue, styleFromPropValue);
}
function spacing_style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge/* default */.Z, {});
}
function margin(props) {
  return spacing_style(props, marginKeys);
}
margin.propTypes =  false ? 0 : {};
margin.filterProps = marginKeys;
function padding(props) {
  return spacing_style(props, paddingKeys);
}
padding.propTypes =  false ? 0 : {};
padding.filterProps = paddingKeys;
function spacing(props) {
  return spacing_style(props, spacingKeys);
}
spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = ((/* unused pure expression or super */ null && (spacing)));

/***/ }),

/***/ 54844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DW": function() { return /* binding */ getPath; },
/* harmony export */   "Jq": function() { return /* binding */ getStyleValue; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14142);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95408);



function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .handleBreakpoints */ .k9)(props, propValue, styleFromPropValue);
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = [prop];
  return fn;
}
/* harmony default export */ __webpack_exports__["ZP"] = (style);

/***/ }),

/***/ 44920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styleFunctionSx_defaultSxConfig; }
});

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(98700);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(47730);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/compose.js

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return (0,merge/* default */.Z)(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}
/* harmony default export */ var esm_compose = (compose);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(95408);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/borders.js





function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
const border = (0,style/* default */.ZP)({
  prop: 'border',
  themeKey: 'borders',
  transform: borderTransform
});
const borderTop = (0,style/* default */.ZP)({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: borderTransform
});
const borderRight = (0,style/* default */.ZP)({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: borderTransform
});
const borderBottom = (0,style/* default */.ZP)({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: borderTransform
});
const borderLeft = (0,style/* default */.ZP)({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: borderTransform
});
const borderColor = (0,style/* default */.ZP)({
  prop: 'borderColor',
  themeKey: 'palette'
});
const borderTopColor = (0,style/* default */.ZP)({
  prop: 'borderTopColor',
  themeKey: 'palette'
});
const borderRightColor = (0,style/* default */.ZP)({
  prop: 'borderRightColor',
  themeKey: 'palette'
});
const borderBottomColor = (0,style/* default */.ZP)({
  prop: 'borderBottomColor',
  themeKey: 'palette'
});
const borderLeftColor = (0,style/* default */.ZP)({
  prop: 'borderLeftColor',
  themeKey: 'palette'
});

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes =  false ? 0 : {};
borderRadius.filterProps = ['borderRadius'];
const borders = esm_compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
/* harmony default export */ var esm_borders = ((/* unused pure expression or super */ null && (borders)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/cssGrid.js






// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes =  false ? 0 : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes =  false ? 0 : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes =  false ? 0 : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = (0,style/* default */.ZP)({
  prop: 'gridColumn'
});
const gridRow = (0,style/* default */.ZP)({
  prop: 'gridRow'
});
const gridAutoFlow = (0,style/* default */.ZP)({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = (0,style/* default */.ZP)({
  prop: 'gridAutoColumns'
});
const gridAutoRows = (0,style/* default */.ZP)({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = (0,style/* default */.ZP)({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = (0,style/* default */.ZP)({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = (0,style/* default */.ZP)({
  prop: 'gridTemplateAreas'
});
const gridArea = (0,style/* default */.ZP)({
  prop: 'gridArea'
});
const grid = esm_compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ var cssGrid = ((/* unused pure expression or super */ null && (grid)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/palette.js


function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color = (0,style/* default */.ZP)({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = (0,style/* default */.ZP)({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = (0,style/* default */.ZP)({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const palette = esm_compose(color, bgcolor, backgroundColor);
/* harmony default export */ var esm_palette = ((/* unused pure expression or super */ null && (palette)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/sizing.js



function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0,style/* default */.ZP)({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || breakpoints/* values */.VO[propValue];
      return {
        maxWidth: breakpoint || sizingTransform(propValue)
      };
    };
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = (0,style/* default */.ZP)({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = (0,style/* default */.ZP)({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = (0,style/* default */.ZP)({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = (0,style/* default */.ZP)({
  prop: 'minHeight',
  transform: sizingTransform
});
const sizeWidth = (0,style/* default */.ZP)({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
const sizeHeight = (0,style/* default */.ZP)({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = (0,style/* default */.ZP)({
  prop: 'boxSizing'
});
const sizing = esm_compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ var esm_sizing = ((/* unused pure expression or super */ null && (sizing)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js





const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: spacing/* padding */.o3
  },
  pt: {
    style: spacing/* padding */.o3
  },
  pr: {
    style: spacing/* padding */.o3
  },
  pb: {
    style: spacing/* padding */.o3
  },
  pl: {
    style: spacing/* padding */.o3
  },
  px: {
    style: spacing/* padding */.o3
  },
  py: {
    style: spacing/* padding */.o3
  },
  padding: {
    style: spacing/* padding */.o3
  },
  paddingTop: {
    style: spacing/* padding */.o3
  },
  paddingRight: {
    style: spacing/* padding */.o3
  },
  paddingBottom: {
    style: spacing/* padding */.o3
  },
  paddingLeft: {
    style: spacing/* padding */.o3
  },
  paddingX: {
    style: spacing/* padding */.o3
  },
  paddingY: {
    style: spacing/* padding */.o3
  },
  paddingInline: {
    style: spacing/* padding */.o3
  },
  paddingInlineStart: {
    style: spacing/* padding */.o3
  },
  paddingInlineEnd: {
    style: spacing/* padding */.o3
  },
  paddingBlock: {
    style: spacing/* padding */.o3
  },
  paddingBlockStart: {
    style: spacing/* padding */.o3
  },
  paddingBlockEnd: {
    style: spacing/* padding */.o3
  },
  m: {
    style: spacing/* margin */.e6
  },
  mt: {
    style: spacing/* margin */.e6
  },
  mr: {
    style: spacing/* margin */.e6
  },
  mb: {
    style: spacing/* margin */.e6
  },
  ml: {
    style: spacing/* margin */.e6
  },
  mx: {
    style: spacing/* margin */.e6
  },
  my: {
    style: spacing/* margin */.e6
  },
  margin: {
    style: spacing/* margin */.e6
  },
  marginTop: {
    style: spacing/* margin */.e6
  },
  marginRight: {
    style: spacing/* margin */.e6
  },
  marginBottom: {
    style: spacing/* margin */.e6
  },
  marginLeft: {
    style: spacing/* margin */.e6
  },
  marginX: {
    style: spacing/* margin */.e6
  },
  marginY: {
    style: spacing/* margin */.e6
  },
  marginInline: {
    style: spacing/* margin */.e6
  },
  marginInlineStart: {
    style: spacing/* margin */.e6
  },
  marginInlineEnd: {
    style: spacing/* margin */.e6
  },
  marginBlock: {
    style: spacing/* margin */.e6
  },
  marginBlockStart: {
    style: spacing/* margin */.e6
  },
  marginBlockEnd: {
    style: spacing/* margin */.e6
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};
/* harmony default export */ var styleFunctionSx_defaultSxConfig = (defaultSxConfig);

/***/ }),

/***/ 39707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ extendSxProp; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59766);
/* harmony import */ var _defaultSxConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44920);


const _excluded = ["sx"];


const splitProps = props => {
  var _props$theme$unstable, _props$theme;
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : _defaultSxConfig__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
  Object.keys(props).forEach(prop => {
    if (config[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
      sx: inSx
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, _excluded);
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!(0,_mui_utils__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .P)(result)) {
        return systemProps;
      }
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, systemProps, result);
    };
  } else {
    finalSx = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, systemProps, inSx);
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, otherProps, {
    sx: finalSx
  });
}

/***/ }),

/***/ 86523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unstable_createStyleFunctionSx */
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14142);
/* harmony import */ var _merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47730);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54844);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95408);
/* harmony import */ var _defaultSxConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44920);





function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getPath */ .DW)(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getStyleValue */ .Jq)(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getStyleValue */ .Jq)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .handleBreakpoints */ .k9)(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }

    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : _defaultSxConfig__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .createEmptyBreakpointObject */ .W8)(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .handleBreakpoints */ .k9)({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, breakpointsValues);
              }
            }
          } else {
            css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .removeUnusedBreakpoints */ .L7)(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];
/* harmony default export */ __webpack_exports__["Z"] = (styleFunctionSx);

/***/ }),

/***/ 13264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createStyled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70182);

const styled = (0,_createStyled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();
/* harmony default export */ __webpack_exports__["Z"] = (styled);

/***/ }),

/***/ 96682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export systemDefaultTheme */
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66500);
/* harmony import */ var _useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34168);
'use client';



const systemDefaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
function useTheme(defaultTheme = systemDefaultTheme) {
  return (0,_useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(defaultTheme);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47925);

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(theme.components[name].defaultProps, props);
}

/***/ }),

/***/ 29628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useThemeProps; }
/* harmony export */ });
/* harmony import */ var _getThemeProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20539);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96682);
'use client';



function useThemeProps({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = (0,_getThemeProps__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    theme,
    name,
    props
  });
  return mergedProps;
}

/***/ }),

/***/ 34168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75260);
'use client';



function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__.T);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 37078:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
/* harmony default export */ __webpack_exports__["Z"] = (ClassNameGenerator);

/***/ }),

/***/ 14142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71387);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 94780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ composeClasses; }
/* harmony export */ });
function composeClasses(slots, getUtilityClass, classes = undefined) {
  const output = {};
  Object.keys(slots).forEach(
  // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        const utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

/***/ }),

/***/ 49064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

/***/ }),

/***/ 39336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ debounce; }
/* harmony export */ });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      // @ts-ignore
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}

/***/ }),

/***/ 59766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ isPlainObject; },
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

function isPlainObject(item) {
  return item !== null && typeof item === 'object' && item.constructor === Object;
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }
      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

/***/ }),

/***/ 71387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 34867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ generateUtilityClass; }
/* harmony export */ });
/* harmony import */ var _ClassNameGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37078);

const globalStateClassesMapping = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  readOnly: 'readOnly',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${_ClassNameGenerator__WEBPACK_IMPORTED_MODULE_0__/* ["default"].generate */ .Z.generate(componentName)}-${slot}`;
}

/***/ }),

/***/ 1588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ generateUtilityClasses; }
/* harmony export */ });
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34867);

function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(componentName, slot, globalStatePrefix);
  });
  return result;
}

/***/ }),

/***/ 95806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getScrollbarSize; }
/* harmony export */ });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}

/***/ }),

/***/ 82690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 74161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82690);

function ownerWindow(node) {
  const doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  return doc.defaultView || window;
}

/***/ }),

/***/ 47925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ resolveProps; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, props);
  Object.keys(defaultProps).forEach(propName => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        // Reduce the iteration if the slot props is empty
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        // Reduce the iteration if the default slot props is empty
        output[propName] = slotProps;
      } else {
        output[propName] = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, slotProps);
        Object.keys(defaultSlotProps).forEach(slotPropName => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

/***/ }),

/***/ 7960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setRef; }
/* harmony export */ });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),

/***/ 19032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useControlled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = react__WEBPACK_IMPORTED_MODULE_0__.useRef(controlled !== undefined);
  const [valueState, setValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (false) {}
  const setValueIfUncontrolled = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/***/ }),

/***/ 73546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';


const useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useEnhancedEffect);

/***/ }),

/***/ 59948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73546);
'use client';




/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */

function useEventCallback(fn) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  (0,_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback((...args) =>
  // @ts-expect-error hide `this`
  // tslint:disable-next-line:ban-comma-operator
  (0, ref.current)(...args), []);
}
/* harmony default export */ __webpack_exports__["Z"] = (useEventCallback);

/***/ }),

/***/ 33703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7960);
'use client';



function useForkRef(...refs) {
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return instance => {
      refs.forEach(ref => {
        (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref, instance);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

/***/ }),

/***/ 92996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';


let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride);
  const id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}

// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useId'.toString()];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

/***/ }),

/***/ 99962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsFocusVisible; }
/* harmony export */ });
/* unused harmony export teardown */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
let hadFocusVisibleRecentlyTimeout;
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};

/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */
function focusTriggersKeyboardModality(node) {
  const {
    type,
    tagName
  } = node;
  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}

/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}

/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(':focus-visible');
  } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  }

  // No need for validFocusTarget check. The user does that by attaching it to
  // focusable events only.
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);

  /**
   * Should be called if a blur event is fired
   */
  function handleBlurVisible() {
    // checking against potential state variable does not suffice if we focus and blur synchronously.
    // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
    // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
    // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
    // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
    if (isFocusVisibleRef.current) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      window.clearTimeout(hadFocusVisibleRecentlyTimeout);
      hadFocusVisibleRecentlyTimeout = window.setTimeout(() => {
        hadFocusVisibleRecently = false;
      }, 100);
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }

  /**
   * Should be called if a blur event is fired
   */
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}

/***/ }),

/***/ 2097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';


const usePreviousProps = value => {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef({});
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePreviousProps);

/***/ }),

/***/ 47520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ DayCalendar; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js
var useEventCallback = __webpack_require__(59948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 3 modules
var useSlotProps = __webpack_require__(18793);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useControlled/useControlled.js
var useControlled = __webpack_require__(19032);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/PickersDay/PickersDay.js + 1 modules
var PickersDay = __webpack_require__(53075);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/useUtils.js + 2 modules
var useUtils = __webpack_require__(48865);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/constants/dimensions.js
var dimensions = __webpack_require__(67542);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(59391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js











var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) (0,reflow/* forceReflow */.Q)(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["classNames"]);

    return /*#__PURE__*/react.createElement(Transition/* default */.ZP, (0,esm_extends/* default */.Z)({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/pickersSlideTransitionClasses.js

const getPickersSlideTransitionUtilityClass = slot => (0,generateUtilityClass/* default */.Z)('MuiPickersSlideTransition', slot);
const pickersSlideTransitionClasses = (0,generateUtilityClasses/* default */.Z)('MuiPickersSlideTransition', ['root', 'slideEnter-left', 'slideEnter-right', 'slideEnterActive', 'slideExit', 'slideExitActiveLeft-left', 'slideExitActiveLeft-right']);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/PickersSlideTransition.js


const _excluded = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"];







const useUtilityClasses = ownerState => {
  const {
    classes,
    slideDirection
  } = ownerState;
  const slots = {
    root: ['root'],
    exit: ['slideExit'],
    enterActive: ['slideEnterActive'],
    enter: [`slideEnter-${slideDirection}`],
    exitActive: [`slideExitActiveLeft-${slideDirection}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getPickersSlideTransitionUtilityClass, classes);
};
const slideAnimationDuration = 350;
const PickersSlideTransitionRoot = (0,styled/* default */.ZP)(TransitionGroup/* default */.Z, {
  name: 'MuiPickersSlideTransition',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root, {
    [`.${pickersSlideTransitionClasses["slideEnter-left"]}`]: styles['slideEnter-left']
  }, {
    [`.${pickersSlideTransitionClasses["slideEnter-right"]}`]: styles['slideEnter-right']
  }, {
    [`.${pickersSlideTransitionClasses.slideEnterActive}`]: styles.slideEnterActive
  }, {
    [`.${pickersSlideTransitionClasses.slideExit}`]: styles.slideExit
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: styles['slideExitActiveLeft-left']
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: styles['slideExitActiveLeft-right']
  }]
})(({
  theme
}) => {
  const slideTransition = theme.transitions.create('transform', {
    duration: slideAnimationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    display: 'block',
    position: 'relative',
    overflowX: 'hidden',
    '& > *': {
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-left"]}`]: {
      willChange: 'transform',
      transform: 'translate(100%)',
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-right"]}`]: {
      willChange: 'transform',
      transform: 'translate(-100%)',
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses.slideEnterActive}`]: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    [`& .${pickersSlideTransitionClasses.slideExit}`]: {
      transform: 'translate(0%)'
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: {
      willChange: 'transform',
      transform: 'translate(-100%)',
      transition: slideTransition,
      zIndex: 0
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: {
      willChange: 'transform',
      transform: 'translate(100%)',
      transition: slideTransition,
      zIndex: 0
    }
  };
});

/**
 * @ignore - do not document.
 */
function PickersSlideTransition(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPickersSlideTransition'
  });
  const {
      children,
      className,
      reduceAnimations,
      transKey
      // extracting `classes` from `other`
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const classes = useUtilityClasses(props);
  if (reduceAnimations) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      children: children
    });
  }
  const transitionClasses = {
    exit: classes.exit,
    enterActive: classes.enterActive,
    enter: classes.enter,
    exitActive: classes.exitActive
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersSlideTransitionRoot, {
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    childFactory: element => /*#__PURE__*/react.cloneElement(element, {
      classNames: transitionClasses
    }),
    role: "presentation",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_CSSTransition, (0,esm_extends/* default */.Z)({
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: slideAnimationDuration,
      classNames: transitionClasses
    }, other, {
      children: children
    }), transKey)
  });
}
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/useIsDateDisabled.js + 1 modules
var useIsDateDisabled = __webpack_require__(50729);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/date-utils.js
var date_utils = __webpack_require__(5535);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/dayCalendarClasses.js

const getDayCalendarUtilityClass = slot => (0,generateUtilityClass/* default */.Z)('MuiDayCalendar', slot);
const dayPickerClasses = (0,generateUtilityClasses/* default */.Z)('MuiDayCalendar', ['header', 'weekDayLabel', 'loadingContainer', 'slideTransition', 'monthContainer', 'weekContainer', 'weekNumberLabel', 'weekNumber']);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/DayCalendar.js


const DayCalendar_excluded = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"],
  _excluded2 = ["ownerState"];
















const DayCalendar_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    header: ['header'],
    weekDayLabel: ['weekDayLabel'],
    loadingContainer: ['loadingContainer'],
    slideTransition: ['slideTransition'],
    monthContainer: ['monthContainer'],
    weekContainer: ['weekContainer'],
    weekNumberLabel: ['weekNumberLabel'],
    weekNumber: ['weekNumber']
  };
  return (0,composeClasses/* default */.Z)(slots, getDayCalendarUtilityClass, classes);
};
const defaultDayOfWeekFormatter = day => day.charAt(0).toUpperCase();
const weeksContainerHeight = (dimensions/* DAY_SIZE */.p2 + dimensions/* DAY_MARGIN */.yh * 2) * 6;
const PickersCalendarDayHeader = (0,styled/* default */.ZP)('div', {
  name: 'MuiDayCalendar',
  slot: 'Header',
  overridesResolver: (_, styles) => styles.header
})({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
const PickersCalendarWeekDayLabel = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiDayCalendar',
  slot: 'WeekDayLabel',
  overridesResolver: (_, styles) => styles.weekDayLabel
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: '0 2px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: (theme.vars || theme).palette.text.secondary
}));
const PickersCalendarWeekNumberLabel = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiDayPicker',
  slot: 'WeekNumberLabel',
  overridesResolver: (_, styles) => styles.weekNumberLabel
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: '0 2px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.text.disabled
}));
const PickersCalendarWeekNumber = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiDayPicker',
  slot: 'WeekNumber',
  overridesResolver: (_, styles) => styles.weekNumber
})(({
  theme
}) => (0,esm_extends/* default */.Z)({}, theme.typography.caption, {
  width: dimensions/* DAY_SIZE */.p2,
  height: dimensions/* DAY_SIZE */.p2,
  padding: 0,
  margin: `0 ${dimensions/* DAY_MARGIN */.yh}px`,
  color: theme.palette.text.disabled,
  fontSize: '0.75rem',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'inline-flex'
}));
const PickersCalendarLoadingContainer = (0,styled/* default */.ZP)('div', {
  name: 'MuiDayCalendar',
  slot: 'LoadingContainer',
  overridesResolver: (_, styles) => styles.loadingContainer
})({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = (0,styled/* default */.ZP)(PickersSlideTransition, {
  name: 'MuiDayCalendar',
  slot: 'SlideTransition',
  overridesResolver: (_, styles) => styles.slideTransition
})({
  minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = (0,styled/* default */.ZP)('div', {
  name: 'MuiDayCalendar',
  slot: 'MonthContainer',
  overridesResolver: (_, styles) => styles.monthContainer
})({
  overflow: 'hidden'
});
const PickersCalendarWeek = (0,styled/* default */.ZP)('div', {
  name: 'MuiDayCalendar',
  slot: 'WeekContainer',
  overridesResolver: (_, styles) => styles.weekContainer
})({
  margin: `${dimensions/* DAY_MARGIN */.yh}px 0`,
  display: 'flex',
  justifyContent: 'center'
});
function WrappedDay(_ref) {
  var _ref2, _slots$day, _slotProps$day;
  let {
      parentProps,
      day,
      focusableDay,
      selectedDays,
      isDateDisabled,
      currentMonthNumber,
      isViewFocused
    } = _ref,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, DayCalendar_excluded);
  const {
    disabled,
    disableHighlightToday,
    isMonthSwitchingAnimating,
    showDaysOutsideCurrentMonth,
    components,
    componentsProps,
    slots,
    slotProps,
    timezone
  } = parentProps;
  const utils = (0,useUtils/* useUtils */.nB)();
  const now = (0,useUtils/* useNow */.mX)(timezone);
  const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
  const isSelected = selectedDays.some(selectedDay => utils.isSameDay(selectedDay, day));
  const isToday = utils.isSameDay(day, now);
  const Day = (_ref2 = (_slots$day = slots == null ? void 0 : slots.day) != null ? _slots$day : components == null ? void 0 : components.Day) != null ? _ref2 : PickersDay/* PickersDay */.H;
  // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
  const _useSlotProps = (0,useSlotProps/* default */.Z)({
      elementType: Day,
      externalSlotProps: (_slotProps$day = slotProps == null ? void 0 : slotProps.day) != null ? _slotProps$day : componentsProps == null ? void 0 : componentsProps.day,
      additionalProps: (0,esm_extends/* default */.Z)({
        disableHighlightToday,
        showDaysOutsideCurrentMonth,
        role: 'gridcell',
        isAnimating: isMonthSwitchingAnimating,
        // it is used in date range dragging logic by accessing `dataset.timestamp`
        'data-timestamp': utils.toJsDate(day).valueOf()
      }, other),
      ownerState: (0,esm_extends/* default */.Z)({}, parentProps, {
        day,
        selected: isSelected
      })
    }),
    dayProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_useSlotProps, _excluded2);
  const isDisabled = react.useMemo(() => disabled || isDateDisabled(day), [disabled, isDateDisabled, day]);
  const outsideCurrentMonth = react.useMemo(() => utils.getMonth(day) !== currentMonthNumber, [utils, day, currentMonthNumber]);
  const isFirstVisibleCell = react.useMemo(() => {
    const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return utils.isSameDay(day, startOfMonth);
    }
    return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, utils]);
  const isLastVisibleCell = react.useMemo(() => {
    const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return utils.isSameDay(day, endOfMonth);
    }
    return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, utils]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Day, (0,esm_extends/* default */.Z)({}, dayProps, {
    day: day,
    disabled: isDisabled,
    autoFocus: isViewFocused && isFocusableDay,
    today: isToday,
    outsideCurrentMonth: outsideCurrentMonth,
    isFirstVisibleCell: isFirstVisibleCell,
    isLastVisibleCell: isLastVisibleCell,
    selected: isSelected,
    tabIndex: isFocusableDay ? 0 : -1,
    "aria-selected": isSelected,
    "aria-current": isToday ? 'date' : undefined
  }));
}

/**
 * @ignore - do not document.
 */
function DayCalendar(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDayCalendar'
  });
  const {
    onFocusedDayChange,
    className,
    currentMonth,
    selectedDays,
    focusedDay,
    loading,
    onSelectedDaysChange,
    onMonthSwitchingAnimationEnd,
    readOnly,
    reduceAnimations,
    renderLoading = () => /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "..."
    }),
    slideDirection,
    TransitionProps,
    disablePast,
    disableFuture,
    minDate,
    maxDate,
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    dayOfWeekFormatter = defaultDayOfWeekFormatter,
    hasFocus,
    onFocusedViewChange,
    gridLabelId,
    displayWeekNumber,
    fixedWeekNumber,
    autoFocus,
    timezone
  } = props;
  const now = (0,useUtils/* useNow */.mX)(timezone);
  const utils = (0,useUtils/* useUtils */.nB)();
  const classes = DayCalendar_useUtilityClasses(props);
  const theme = (0,useTheme/* default */.Z)();
  const isRTL = theme.direction === 'rtl';
  const isDateDisabled = (0,useIsDateDisabled/* useIsDateDisabled */.Q)({
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    minDate,
    maxDate,
    disablePast,
    disableFuture,
    timezone
  });
  const localeText = (0,useUtils/* useLocaleText */.og)();
  const [internalHasFocus, setInternalHasFocus] = (0,useControlled/* default */.Z)({
    name: 'DayCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus != null ? autoFocus : false
  });
  const [internalFocusedDay, setInternalFocusedDay] = react.useState(() => focusedDay || now);
  const handleDaySelect = (0,useEventCallback/* default */.Z)(day => {
    if (readOnly) {
      return;
    }
    onSelectedDaysChange(day);
  });
  const focusDay = day => {
    if (!isDateDisabled(day)) {
      onFocusedDayChange(day);
      setInternalFocusedDay(day);
      onFocusedViewChange == null ? void 0 : onFocusedViewChange(true);
      setInternalHasFocus(true);
    }
  };
  const handleKeyDown = (0,useEventCallback/* default */.Z)((event, day) => {
    switch (event.key) {
      case 'ArrowUp':
        focusDay(utils.addDays(day, -7));
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusDay(utils.addDays(day, 7));
        event.preventDefault();
        break;
      case 'ArrowLeft':
        {
          const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
          const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
          const closestDayToFocus = (0,date_utils/* findClosestEnabledDate */.xP)({
            utils,
            date: newFocusedDayDefault,
            minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
            maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
            isDateDisabled,
            timezone
          });
          focusDay(closestDayToFocus || newFocusedDayDefault);
          event.preventDefault();
          break;
        }
      case 'ArrowRight':
        {
          const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
          const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
          const closestDayToFocus = (0,date_utils/* findClosestEnabledDate */.xP)({
            utils,
            date: newFocusedDayDefault,
            minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
            maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
            isDateDisabled,
            timezone
          });
          focusDay(closestDayToFocus || newFocusedDayDefault);
          event.preventDefault();
          break;
        }
      case 'Home':
        focusDay(utils.startOfWeek(day));
        event.preventDefault();
        break;
      case 'End':
        focusDay(utils.endOfWeek(day));
        event.preventDefault();
        break;
      case 'PageUp':
        focusDay(utils.addMonths(day, 1));
        event.preventDefault();
        break;
      case 'PageDown':
        focusDay(utils.addMonths(day, -1));
        event.preventDefault();
        break;
      default:
        break;
    }
  });
  const handleFocus = (0,useEventCallback/* default */.Z)((event, day) => focusDay(day));
  const handleBlur = (0,useEventCallback/* default */.Z)((event, day) => {
    if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) {
      onFocusedViewChange == null ? void 0 : onFocusedViewChange(false);
    }
  });
  const currentMonthNumber = utils.getMonth(currentMonth);
  const validSelectedDays = react.useMemo(() => selectedDays.filter(day => !!day).map(day => utils.startOfDay(day)), [utils, selectedDays]);

  // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
  const transitionKey = currentMonthNumber;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const slideNodeRef = react.useMemo(() => /*#__PURE__*/react.createRef(), [transitionKey]);
  const startOfCurrentWeek = utils.startOfWeek(now);
  const focusableDay = react.useMemo(() => {
    const startOfMonth = utils.startOfMonth(currentMonth);
    const endOfMonth = utils.endOfMonth(currentMonth);
    if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) {
      return (0,date_utils/* findClosestEnabledDate */.xP)({
        utils,
        date: internalFocusedDay,
        minDate: startOfMonth,
        maxDate: endOfMonth,
        disablePast,
        disableFuture,
        isDateDisabled,
        timezone
      });
    }
    return internalFocusedDay;
  }, [currentMonth, disableFuture, disablePast, internalFocusedDay, isDateDisabled, utils, timezone]);
  const weeksToDisplay = react.useMemo(() => {
    const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
    const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
    let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
    while (fixedWeekNumber && toDisplay.length < fixedWeekNumber) {
      const additionalWeeks = utils.getWeekArray(nextMonth);
      const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
      additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach(week => {
        if (toDisplay.length < fixedWeekNumber) {
          toDisplay.push(week);
        }
      });
      nextMonth = utils.addMonths(nextMonth, 1);
    }
    return toDisplay;
  }, [currentMonth, fixedWeekNumber, utils, timezone]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    role: "grid",
    "aria-labelledby": gridLabelId,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PickersCalendarDayHeader, {
      role: "row",
      className: classes.header,
      children: [displayWeekNumber && /*#__PURE__*/(0,jsx_runtime.jsx)(PickersCalendarWeekNumberLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": localeText.calendarWeekNumberHeaderLabel,
        className: classes.weekNumberLabel,
        children: localeText.calendarWeekNumberHeaderText
      }), utils.getWeekdays().map((day, i) => {
        var _dayOfWeekFormatter;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersCalendarWeekDayLabel, {
          variant: "caption",
          role: "columnheader",
          "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), 'weekday'),
          className: classes.weekDayLabel,
          children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
        }, day + i.toString());
      })]
    }), loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(PickersCalendarLoadingContainer, {
      className: classes.loadingContainer,
      children: renderLoading()
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PickersCalendarSlideTransition, (0,esm_extends/* default */.Z)({
      transKey: transitionKey,
      onExited: onMonthSwitchingAnimationEnd,
      reduceAnimations: reduceAnimations,
      slideDirection: slideDirection,
      className: (0,clsx_m/* default */.Z)(className, classes.slideTransition)
    }, TransitionProps, {
      nodeRef: slideNodeRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PickersCalendarWeekContainer, {
        ref: slideNodeRef,
        role: "rowgroup",
        className: classes.monthContainer,
        children: weeksToDisplay.map((week, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(PickersCalendarWeek, {
          role: "row",
          className: classes.weekContainer
          // fix issue of announcing row 1 as row 2
          // caused by week day labels row
          ,
          "aria-rowindex": index + 1,
          children: [displayWeekNumber && /*#__PURE__*/(0,jsx_runtime.jsx)(PickersCalendarWeekNumber, {
            className: classes.weekNumber,
            role: "rowheader",
            "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
            children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
          }), week.map((day, dayIndex) => /*#__PURE__*/(0,jsx_runtime.jsx)(WrappedDay, {
            parentProps: props,
            day: day,
            selectedDays: validSelectedDays,
            focusableDay: focusableDay,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onDaySelect: handleDaySelect,
            isDateDisabled: isDateDisabled,
            currentMonthNumber: currentMonthNumber,
            isViewFocused: internalHasFocus
            // fix issue of announcing column 1 as column 2 when `displayWeekNumber` is enabled
            ,
            "aria-colindex": dayIndex + 1
          }, day.toString()))]
        }, `week-${week[0]}`))
      })
    }))]
  });
}

/***/ }),

/***/ 92317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ PickersCalendarHeader; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 3 modules
var useSlotProps = __webpack_require__(18793);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/useUtils.js + 2 modules
var useUtils = __webpack_require__(48865);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/PickersFadeTransitionGroup.js + 1 modules
var PickersFadeTransitionGroup = __webpack_require__(70869);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/icons/index.js
var icons = __webpack_require__(83205);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/components/PickersArrowSwitcher/PickersArrowSwitcher.js + 1 modules
var PickersArrowSwitcher = __webpack_require__(16943);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/date-helpers-hooks.js
var date_helpers_hooks = __webpack_require__(73207);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/pickersCalendarHeaderClasses.js

const getPickersCalendarHeaderUtilityClass = slot => (0,generateUtilityClass/* default */.Z)('MuiPickersCalendarHeader', slot);
const pickersCalendarHeaderClasses = (0,generateUtilityClasses/* default */.Z)('MuiPickersCalendarHeader', ['root', 'labelContainer', 'label', 'switchViewButton', 'switchViewIcon']);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/PickersCalendarHeader.js


const _excluded = ["ownerState"];













// We keep the interface to allow module augmentation


const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    labelContainer: ['labelContainer'],
    label: ['label'],
    switchViewButton: ['switchViewButton'],
    switchViewIcon: ['switchViewIcon']
  };
  return (0,composeClasses/* default */.Z)(slots, getPickersCalendarHeaderUtilityClass, classes);
};
const PickersCalendarHeaderRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({
  display: 'flex',
  alignItems: 'center',
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
});
const PickersCalendarHeaderLabelContainer = (0,styled/* default */.ZP)('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'LabelContainer',
  overridesResolver: (_, styles) => styles.labelContainer
})(({
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  overflow: 'hidden',
  alignItems: 'center',
  cursor: 'pointer',
  marginRight: 'auto'
}, theme.typography.body1, {
  fontWeight: theme.typography.fontWeightMedium
}));
const PickersCalendarHeaderLabel = (0,styled/* default */.ZP)('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'Label',
  overridesResolver: (_, styles) => styles.label
})({
  marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = (0,styled/* default */.ZP)(IconButton/* default */.Z, {
  name: 'MuiPickersCalendarHeader',
  slot: 'SwitchViewButton',
  overridesResolver: (_, styles) => styles.switchViewButton
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  marginRight: 'auto'
}, ownerState.view === 'year' && {
  [`.${pickersCalendarHeaderClasses.switchViewIcon}`]: {
    transform: 'rotate(180deg)'
  }
}));
const PickersCalendarHeaderSwitchViewIcon = (0,styled/* default */.ZP)(icons/* ArrowDropDownIcon */.ch, {
  name: 'MuiPickersCalendarHeader',
  slot: 'SwitchViewIcon',
  overridesResolver: (_, styles) => styles.switchViewIcon
})(({
  theme
}) => ({
  willChange: 'transform',
  transition: theme.transitions.create('transform'),
  transform: 'rotate(0deg)'
}));

/**
 * @ignore - do not document.
 */
function PickersCalendarHeader(inProps) {
  var _slots$switchViewButt, _slots$switchViewIcon;
  const localeText = (0,useUtils/* useLocaleText */.og)();
  const utils = (0,useUtils/* useUtils */.nB)();
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPickersCalendarHeader'
  });
  const {
    slots,
    slotProps,
    currentMonth: month,
    disabled,
    disableFuture,
    disablePast,
    maxDate,
    minDate,
    onMonthChange,
    onViewChange,
    view,
    reduceAnimations,
    views,
    labelId,
    timezone
  } = props;
  const ownerState = props;
  const classes = useUtilityClasses(props);
  const SwitchViewButton = (_slots$switchViewButt = slots == null ? void 0 : slots.switchViewButton) != null ? _slots$switchViewButt : PickersCalendarHeaderSwitchViewButton;
  const switchViewButtonProps = (0,useSlotProps/* default */.Z)({
    elementType: SwitchViewButton,
    externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewButton,
    additionalProps: {
      size: 'small',
      'aria-label': localeText.calendarViewSwitchingButtonAriaLabel(view)
    },
    ownerState,
    className: classes.switchViewButton
  });
  const SwitchViewIcon = (_slots$switchViewIcon = slots == null ? void 0 : slots.switchViewIcon) != null ? _slots$switchViewIcon : PickersCalendarHeaderSwitchViewIcon;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps = (0,useSlotProps/* default */.Z)({
      elementType: SwitchViewIcon,
      externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewIcon,
      ownerState: undefined,
      className: classes.switchViewIcon
    }),
    switchViewIconProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_useSlotProps, _excluded);
  const selectNextMonth = () => onMonthChange(utils.addMonths(month, 1), 'left');
  const selectPreviousMonth = () => onMonthChange(utils.addMonths(month, -1), 'right');
  const isNextMonthDisabled = (0,date_helpers_hooks/* useNextMonthDisabled */.MS)(month, {
    disableFuture,
    maxDate,
    timezone
  });
  const isPreviousMonthDisabled = (0,date_helpers_hooks/* usePreviousMonthDisabled */.tw)(month, {
    disablePast,
    minDate,
    timezone
  });
  const handleToggleView = () => {
    if (views.length === 1 || !onViewChange || disabled) {
      return;
    }
    if (views.length === 2) {
      onViewChange(views.find(el => el !== view) || views[0]);
    } else {
      // switching only between first 2
      const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
      onViewChange(views[nextIndexToOpen]);
    }
  };

  // No need to display more information
  if (views.length === 1 && views[0] === 'year') {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PickersCalendarHeaderRoot, {
    ownerState: ownerState,
    className: classes.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PickersCalendarHeaderLabelContainer, {
      role: "presentation",
      onClick: handleToggleView,
      ownerState: ownerState
      // putting this on the label item element below breaks when using transition
      ,
      "aria-live": "polite",
      className: classes.labelContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PickersFadeTransitionGroup/* PickersFadeTransitionGroup */.s, {
        reduceAnimations: reduceAnimations,
        transKey: utils.format(month, 'monthAndYear'),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PickersCalendarHeaderLabel, {
          id: labelId,
          ownerState: ownerState,
          className: classes.label,
          children: utils.format(month, 'monthAndYear')
        })
      }), views.length > 1 && !disabled && /*#__PURE__*/(0,jsx_runtime.jsx)(SwitchViewButton, (0,esm_extends/* default */.Z)({}, switchViewButtonProps, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SwitchViewIcon, (0,esm_extends/* default */.Z)({}, switchViewIconProps))
      }))]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, {
      in: view === 'day',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PickersArrowSwitcher/* PickersArrowSwitcher */.u, {
        slots: slots,
        slotProps: slotProps,
        onGoToPrevious: selectPreviousMonth,
        isPreviousDisabled: isPreviousMonthDisabled,
        previousLabel: localeText.previousMonth,
        onGoToNext: selectNextMonth,
        isNextDisabled: isNextMonthDisabled,
        nextLabel: localeText.nextMonth
      })
    })]
  });
}

/***/ }),

/***/ 70869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ PickersFadeTransitionGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/pickersFadeTransitionGroupClasses.js

const getPickersFadeTransitionGroupUtilityClass = slot => (0,generateUtilityClass/* default */.Z)('MuiPickersFadeTransitionGroup', slot);
const pickersFadeTransitionGroupClasses = (0,generateUtilityClasses/* default */.Z)('MuiPickersFadeTransitionGroup', ['root']);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/PickersFadeTransitionGroup.js








const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getPickersFadeTransitionGroupUtilityClass, classes);
};
const animationDuration = 500;
const PickersFadeTransitionGroupRoot = (0,styled/* default */.ZP)(TransitionGroup/* default */.Z, {
  name: 'MuiPickersFadeTransitionGroup',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({
  display: 'block',
  position: 'relative'
});

/**
 * @ignore - do not document.
 */
function PickersFadeTransitionGroup(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPickersFadeTransitionGroup'
  });
  const {
    children,
    className,
    reduceAnimations,
    transKey
  } = props;
  const classes = useUtilityClasses(props);
  if (reduceAnimations) {
    return children;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersFadeTransitionGroupRoot, {
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: animationDuration,
        enter: animationDuration / 2,
        exit: 0
      },
      children: children
    }, transKey)
  });
}

/***/ }),

/***/ 80872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useCalendarState; }
/* harmony export */ });
/* unused harmony export createCalendarStateReducer */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_utils_useEventCallback__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59948);
/* harmony import */ var _useIsDateDisabled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50729);
/* harmony import */ var _internals_hooks_useUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48865);
/* harmony import */ var _internals_utils_valueManagers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55071);
/* harmony import */ var _internals_utils_getDefaultReferenceDate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95318);







const createCalendarStateReducer = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils) => (state, action) => {
  switch (action.type) {
    case 'changeMonth':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state, {
        slideDirection: action.direction,
        currentMonth: action.newMonth,
        isMonthSwitchingAnimating: !reduceAnimations
      });
    case 'finishMonthSwitchingAnimation':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state, {
        isMonthSwitchingAnimating: false
      });
    case 'changeFocusedDay':
      {
        if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) {
          return state;
        }
        const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
        return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state, {
          focusedDay: action.focusedDay,
          isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
          currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
          slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
        });
      }
    default:
      throw new Error('missing support');
  }
};
const useCalendarState = params => {
  const {
    value,
    referenceDate: referenceDateProp,
    defaultCalendarMonth,
    disableFuture,
    disablePast,
    disableSwitchToMonthOnDayFocus = false,
    maxDate,
    minDate,
    onMonthChange,
    reduceAnimations,
    shouldDisableDate,
    timezone
  } = params;
  const now = (0,_internals_hooks_useUtils__WEBPACK_IMPORTED_MODULE_2__/* .useNow */ .mX)(timezone);
  const utils = (0,_internals_hooks_useUtils__WEBPACK_IMPORTED_MODULE_2__/* .useUtils */ .nB)();
  const reducerFn = react__WEBPACK_IMPORTED_MODULE_0__.useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
  const referenceDate = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    let externalReferenceDate = null;
    if (referenceDateProp) {
      externalReferenceDate = referenceDateProp;
    } else if (defaultCalendarMonth) {
      // For `defaultCalendarMonth`, we just want to keep the month and the year to avoid a behavior change.
      externalReferenceDate = utils.startOfMonth(defaultCalendarMonth);
    }
    return _internals_utils_valueManagers__WEBPACK_IMPORTED_MODULE_3__/* .singleItemValueManager.getInitialReferenceValue */ .h.getInitialReferenceValue({
      value,
      utils,
      timezone,
      props: params,
      referenceDate: externalReferenceDate,
      granularity: _internals_utils_getDefaultReferenceDate__WEBPACK_IMPORTED_MODULE_4__/* .SECTION_TYPE_GRANULARITY.day */ .Kn.day
    });
  }, [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const [calendarState, dispatch] = react__WEBPACK_IMPORTED_MODULE_0__.useReducer(reducerFn, {
    isMonthSwitchingAnimating: false,
    focusedDay: value || now,
    currentMonth: utils.startOfMonth(referenceDate),
    slideDirection: 'left'
  });
  const handleChangeMonth = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(payload => {
    dispatch((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      type: 'changeMonth'
    }, payload));
    if (onMonthChange) {
      onMonthChange(payload.newMonth);
    }
  }, [onMonthChange]);
  const changeMonth = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(newDate => {
    const newDateRequested = newDate;
    if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
      return;
    }
    handleChangeMonth({
      newMonth: utils.startOfMonth(newDateRequested),
      direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
    });
  }, [calendarState.currentMonth, handleChangeMonth, utils]);
  const isDateDisabled = (0,_useIsDateDisabled__WEBPACK_IMPORTED_MODULE_5__/* .useIsDateDisabled */ .Q)({
    shouldDisableDate,
    minDate,
    maxDate,
    disableFuture,
    disablePast,
    timezone
  });
  const onMonthSwitchingAnimationEnd = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    dispatch({
      type: 'finishMonthSwitchingAnimation'
    });
  }, []);
  const changeFocusedDay = (0,_mui_utils_useEventCallback__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((newFocusedDate, withoutMonthSwitchingAnimation) => {
    if (!isDateDisabled(newFocusedDate)) {
      dispatch({
        type: 'changeFocusedDay',
        focusedDay: newFocusedDate,
        withoutMonthSwitchingAnimation
      });
    }
  });
  return {
    referenceDate,
    calendarState,
    changeMonth,
    changeFocusedDay,
    isDateDisabled,
    onMonthSwitchingAnimationEnd,
    handleChangeMonth
  };
};

/***/ }),

/***/ 50729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ useIsDateDisabled; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/date-utils.js
var date_utils = __webpack_require__(5535);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/validation/validateDate.js

const validateDate = ({
  props,
  value,
  adapter
}) => {
  if (value === null) {
    return null;
  }
  const {
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    disablePast,
    disableFuture,
    timezone
  } = props;
  const now = adapter.utils.dateWithTimezone(undefined, timezone);
  const minDate = (0,date_utils/* applyDefaultDate */.US)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
  const maxDate = (0,date_utils/* applyDefaultDate */.US)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
  switch (true) {
    case !adapter.utils.isValid(value):
      return 'invalidDate';
    case Boolean(shouldDisableDate && shouldDisableDate(value)):
      return 'shouldDisableDate';
    case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
      return 'shouldDisableMonth';
    case Boolean(shouldDisableYear && shouldDisableYear(value)):
      return 'shouldDisableYear';
    case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
      return 'disableFuture';
    case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
      return 'disablePast';
    case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
      return 'minDate';
    case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
      return 'maxDate';
    default:
      return null;
  }
};
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/useUtils.js + 2 modules
var useUtils = __webpack_require__(48865);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/useIsDateDisabled.js



const useIsDateDisabled = ({
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  minDate,
  maxDate,
  disableFuture,
  disablePast,
  timezone
}) => {
  const adapter = (0,useUtils/* useLocalizationContext */.Do)();
  return react.useCallback(day => validateDate({
    adapter,
    value: day,
    props: {
      shouldDisableDate,
      shouldDisableMonth,
      shouldDisableYear,
      minDate,
      maxDate,
      disableFuture,
      disablePast,
      timezone
    }
  }) !== null, [adapter, shouldDisableDate, shouldDisableMonth, shouldDisableYear, minDate, maxDate, disableFuture, disablePast, timezone]);
};

/***/ }),

/***/ 50720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ LocalizationProvider; },
/* harmony export */   "y": function() { return /* binding */ MuiPickersAdapterContext; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71657);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["localeText"];




const MuiPickersAdapterContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
if (false) {}
/**
 * @ignore - do not document.
 */
const LocalizationProvider = function LocalizationProvider(inProps) {
  var _React$useContext;
  const {
      localeText: inLocaleText
    } = inProps,
    otherInProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(inProps, _excluded);
  const {
    utils: parentUtils,
    localeText: parentLocaleText
  } = (_React$useContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MuiPickersAdapterContext)) != null ? _React$useContext : {
    utils: undefined,
    localeText: undefined
  };
  const props = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: otherInProps,
    name: 'MuiLocalizationProvider'
  });
  const {
    children,
    dateAdapter: DateAdapter,
    dateFormats,
    dateLibInstance,
    adapterLocale,
    localeText: themeLocaleText
  } = props;
  const localeText = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, themeLocaleText, parentLocaleText, inLocaleText), [themeLocaleText, parentLocaleText, inLocaleText]);
  const utils = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (!DateAdapter) {
      if (parentUtils) {
        return parentUtils;
      }
      return null;
    }
    const adapter = new DateAdapter({
      locale: adapterLocale,
      formats: dateFormats,
      instance: dateLibInstance
    });
    if (!adapter.isMUIAdapter) {
      throw new Error(['MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`', "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", 'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'].join(`\n`));
    }
    return adapter;
  }, [DateAdapter, adapterLocale, dateFormats, dateLibInstance, parentUtils]);
  const defaultDates = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (!utils) {
      return null;
    }
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  const contextValue = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    return {
      utils,
      defaultDates,
      localeText
    };
  }, [defaultDates, utils, localeText]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children: children
  });
};
 false ? 0 : void 0;

/***/ }),

/***/ 53075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PickersDay; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(33703);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(73546);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/useUtils.js + 2 modules
var useUtils = __webpack_require__(48865);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/constants/dimensions.js
var dimensions = __webpack_require__(67542);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/PickersDay/pickersDayClasses.js

function getPickersDayUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPickersDay', slot);
}
const pickersDayClasses = (0,generateUtilityClasses/* default */.Z)('MuiPickersDay', ['root', 'dayWithMargin', 'dayOutsideMonth', 'hiddenDaySpacingFiller', 'today', 'selected', 'disabled']);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/PickersDay/PickersDay.js


const _excluded = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"];










const useUtilityClasses = ownerState => {
  const {
    selected,
    disableMargin,
    disableHighlightToday,
    today,
    disabled,
    outsideCurrentMonth,
    showDaysOutsideCurrentMonth,
    classes
  } = ownerState;
  const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
  const slots = {
    root: ['root', selected && !isHiddenDaySpacingFiller && 'selected', disabled && 'disabled', !disableMargin && 'dayWithMargin', !disableHighlightToday && today && 'today', outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth', isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'],
    hiddenDaySpacingFiller: ['hiddenDaySpacingFiller']
  };
  return (0,composeClasses/* default */.Z)(slots, getPickersDayUtilityClass, classes);
};
const styleArg = ({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({}, theme.typography.caption, {
  width: dimensions/* DAY_SIZE */.p2,
  height: dimensions/* DAY_SIZE */.p2,
  borderRadius: '50%',
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: 'transparent',
  color: (theme.vars || theme).palette.text.primary,
  '@media (pointer: fine)': {
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
    }
  },
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.focusOpacity),
    [`&.${pickersDayClasses.selected}`]: {
      willChange: 'background-color',
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.short
    }),
    '&:hover': {
      willChange: 'background-color',
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.disabled}:not(.${pickersDayClasses.selected})`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${pickersDayClasses.disabled}&.${pickersDayClasses.selected}`]: {
    opacity: 0.6
  }
}, !ownerState.disableMargin && {
  margin: `0 ${dimensions/* DAY_MARGIN */.yh}px`
}, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableHighlightToday && ownerState.today && {
  [`&:not(.${pickersDayClasses.selected})`]: {
    border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
  }
});
const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, !ownerState.disableMargin && styles.dayWithMargin, !ownerState.disableHighlightToday && ownerState.today && styles.today, !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth, ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller];
};
const PickersDayRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver
})(styleArg);
const PickersDayFiller = (0,styled/* default */.ZP)('div', {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({}, styleArg({
  theme,
  ownerState
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: 'none'
}));
const noop = () => {};
const PickersDayRaw = /*#__PURE__*/react.forwardRef(function PickersDay(inProps, forwardedRef) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPickersDay'
  });
  const {
      autoFocus = false,
      className,
      day,
      disabled = false,
      disableHighlightToday = false,
      disableMargin = false,
      isAnimating,
      onClick,
      onDaySelect,
      onFocus = noop,
      onBlur = noop,
      onKeyDown = noop,
      onMouseDown = noop,
      onMouseEnter = noop,
      outsideCurrentMonth,
      selected = false,
      showDaysOutsideCurrentMonth = false,
      children,
      today: isToday = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    autoFocus,
    disabled,
    disableHighlightToday,
    disableMargin,
    selected,
    showDaysOutsideCurrentMonth,
    today: isToday
  });
  const classes = useUtilityClasses(ownerState);
  const utils = (0,useUtils/* useUtils */.nB)();
  const ref = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(ref, forwardedRef);

  // Since this is rendered when a Popper is opened we can't use passive effects.
  // Focusing in passive effects in Popper causes scroll jump.
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
      // ref.current being null would be a bug in MUI
      ref.current.focus();
    }
  }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);

  // For day outside of current month, move focus from mouseDown to mouseUp
  // Goal: have the onClick ends before sliding to the new month
  const handleMouseDown = event => {
    onMouseDown(event);
    if (outsideCurrentMonth) {
      event.preventDefault();
    }
  };
  const handleClick = event => {
    if (!disabled) {
      onDaySelect(day);
    }
    if (outsideCurrentMonth) {
      event.currentTarget.focus();
    }
    if (onClick) {
      onClick(event);
    }
  };
  if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersDayFiller, {
      className: (0,clsx_m/* default */.Z)(classes.root, classes.hiddenDaySpacingFiller, className),
      ownerState: ownerState,
      role: other.role
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersDayRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: handleRef,
    centerRipple: true,
    disabled: disabled,
    tabIndex: selected ? 0 : -1,
    onKeyDown: event => onKeyDown(event, day),
    onFocus: event => onFocus(event, day),
    onBlur: event => onBlur(event, day),
    onMouseEnter: event => onMouseEnter(event, day),
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }, other, {
    ownerState: ownerState,
    children: !children ? utils.format(day, 'dayOfMonth') : children
  }));
});
 false ? 0 : void 0;

/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/x/react-date-pickers/date-picker/)
 *
 * API:
 *
 * - [PickersDay API](https://mui.com/x/api/date-pickers/pickers-day/)
 */
const PickersDay = /*#__PURE__*/react.memo(PickersDayRaw);

/***/ }),

/***/ 83205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ ArrowRightIcon; },
/* harmony export */   "Y4": function() { return /* binding */ ArrowLeftIcon; },
/* harmony export */   "ch": function() { return /* binding */ ArrowDropDownIcon; }
/* harmony export */ });
/* unused harmony exports CalendarIcon, ClockIcon, DateRangeIcon, TimeIcon */
/* harmony import */ var _mui_material_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82066);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



/**
 * @ignore - internal component.
 */


const ArrowDropDownIcon = (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

/**
 * @ignore - internal component.
 */
const ArrowLeftIcon = (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');

/**
 * @ignore - internal component.
 */
const ArrowRightIcon = (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');

/**
 * @ignore - internal component.
 */
const CalendarIcon = (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');

/**
 * @ignore - internal component.
 */
const ClockIcon = (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Clock');

/**
 * @ignore - internal component.
 */
const DateRangeIcon = (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');

/**
 * @ignore - internal component.
 */
const TimeIcon = (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Time');

/***/ }),

/***/ 16943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ PickersArrowSwitcher; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 3 modules
var useSlotProps = __webpack_require__(18793);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/icons/index.js
var icons = __webpack_require__(83205);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/internals/components/PickersArrowSwitcher/pickersArrowSwitcherClasses.js

function getPickersArrowSwitcherUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPickersArrowSwitcher', slot);
}
const pickersArrowSwitcherClasses = (0,generateUtilityClasses/* default */.Z)('MuiPickersArrowSwitcher', ['root', 'spacer', 'button']);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/internals/components/PickersArrowSwitcher/PickersArrowSwitcher.js


const _excluded = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"],
  _excluded2 = ["ownerState"],
  _excluded3 = ["ownerState"];











const PickersArrowSwitcherRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex'
});
const PickersArrowSwitcherSpacer = (0,styled/* default */.ZP)('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Spacer',
  overridesResolver: (props, styles) => styles.spacer
})(({
  theme
}) => ({
  width: theme.spacing(3)
}));
const PickersArrowSwitcherButton = (0,styled/* default */.ZP)(IconButton/* default */.Z, {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Button',
  overridesResolver: (props, styles) => styles.button
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({}, ownerState.hidden && {
  visibility: 'hidden'
}));
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    spacer: ['spacer'],
    button: ['button']
  };
  return (0,composeClasses/* default */.Z)(slots, getPickersArrowSwitcherUtilityClass, classes);
};
const PickersArrowSwitcher = /*#__PURE__*/react.forwardRef(function PickersArrowSwitcher(inProps, ref) {
  var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
  const theme = (0,useTheme/* default */.Z)();
  const isRTL = theme.direction === 'rtl';
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPickersArrowSwitcher'
  });
  const {
      children,
      className,
      slots,
      slotProps,
      isNextDisabled,
      isNextHidden,
      onGoToNext,
      nextLabel,
      isPreviousDisabled,
      isPreviousHidden,
      onGoToPrevious,
      previousLabel
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  const nextProps = {
    isDisabled: isNextDisabled,
    isHidden: isNextHidden,
    goTo: onGoToNext,
    label: nextLabel
  };
  const previousProps = {
    isDisabled: isPreviousDisabled,
    isHidden: isPreviousHidden,
    goTo: onGoToPrevious,
    label: previousLabel
  };
  const [leftProps, rightProps] = isRTL ? [nextProps, previousProps] : [previousProps, nextProps];
  const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : PickersArrowSwitcherButton;
  const previousIconButtonProps = (0,useSlotProps/* default */.Z)({
    elementType: PreviousIconButton,
    externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
    additionalProps: {
      size: 'medium',
      title: leftProps.label,
      'aria-label': leftProps.label,
      disabled: leftProps.isDisabled,
      edge: 'end',
      onClick: leftProps.goTo
    },
    ownerState: (0,esm_extends/* default */.Z)({}, ownerState, {
      hidden: leftProps.isHidden
    }),
    className: classes.button
  });
  const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : PickersArrowSwitcherButton;
  const nextIconButtonProps = (0,useSlotProps/* default */.Z)({
    elementType: NextIconButton,
    externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
    additionalProps: {
      size: 'medium',
      title: rightProps.label,
      'aria-label': rightProps.label,
      disabled: rightProps.isDisabled,
      edge: 'start',
      onClick: rightProps.goTo
    },
    ownerState: (0,esm_extends/* default */.Z)({}, ownerState, {
      hidden: rightProps.isHidden
    }),
    className: classes.button
  });
  const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : icons/* ArrowLeftIcon */.Y4;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps = (0,useSlotProps/* default */.Z)({
      elementType: LeftArrowIcon,
      externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
      additionalProps: {
        fontSize: 'inherit'
      },
      ownerState: undefined
    }),
    leftArrowIconProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_useSlotProps, _excluded2);
  const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : icons/* ArrowRightIcon */.LZ;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps2 = (0,useSlotProps/* default */.Z)({
      elementType: RightArrowIcon,
      externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
      additionalProps: {
        fontSize: 'inherit'
      },
      ownerState: undefined
    }),
    rightArrowIconProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_useSlotProps2, _excluded3);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PickersArrowSwitcherRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PreviousIconButton, (0,esm_extends/* default */.Z)({}, previousIconButtonProps, {
      children: isRTL ? /*#__PURE__*/(0,jsx_runtime.jsx)(RightArrowIcon, (0,esm_extends/* default */.Z)({}, rightArrowIconProps)) : /*#__PURE__*/(0,jsx_runtime.jsx)(LeftArrowIcon, (0,esm_extends/* default */.Z)({}, leftArrowIconProps))
    })), children ? /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
      variant: "subtitle1",
      component: "span",
      children: children
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PickersArrowSwitcherSpacer, {
      className: classes.spacer,
      ownerState: ownerState
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NextIconButton, (0,esm_extends/* default */.Z)({}, nextIconButtonProps, {
      children: isRTL ? /*#__PURE__*/(0,jsx_runtime.jsx)(LeftArrowIcon, (0,esm_extends/* default */.Z)({}, leftArrowIconProps)) : /*#__PURE__*/(0,jsx_runtime.jsx)(RightArrowIcon, (0,esm_extends/* default */.Z)({}, rightArrowIconProps))
    }))]
  }));
});

/***/ }),

/***/ 67542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ VIEW_HEIGHT; },
/* harmony export */   "Pl": function() { return /* binding */ DIALOG_WIDTH; },
/* harmony export */   "p2": function() { return /* binding */ DAY_SIZE; },
/* harmony export */   "yh": function() { return /* binding */ DAY_MARGIN; }
/* harmony export */ });
/* unused harmony exports DIGITAL_CLOCK_VIEW_HEIGHT, MULTI_SECTION_CLOCK_SECTION_WIDTH */
const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const VIEW_HEIGHT = 358;
const DIGITAL_CLOCK_VIEW_HEIGHT = 232;
const MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;

/***/ }),

/***/ 73207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ useNextMonthDisabled; },
/* harmony export */   "tw": function() { return /* binding */ usePreviousMonthDisabled; }
/* harmony export */ });
/* unused harmony export useMeridiemMode */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48865);



function useNextMonthDisabled(month, {
  disableFuture,
  maxDate,
  timezone
}) {
  const utils = (0,_useUtils__WEBPACK_IMPORTED_MODULE_1__/* .useUtils */ .nB)();
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const now = utils.dateWithTimezone(undefined, timezone);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    return !utils.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, utils, timezone]);
}
function usePreviousMonthDisabled(month, {
  disablePast,
  minDate,
  timezone
}) {
  const utils = (0,_useUtils__WEBPACK_IMPORTED_MODULE_1__/* .useUtils */ .nB)();
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const now = utils.dateWithTimezone(undefined, timezone);
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    return !utils.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, utils, timezone]);
}
function useMeridiemMode(date, ampm, onChange, selectionState) {
  const utils = useUtils();
  const meridiemMode = getMeridiem(date, utils);
  const handleMeridiemChange = React.useCallback(mode => {
    const timeWithMeridiem = date == null ? null : convertToMeridiem(date, mode, Boolean(ampm), utils);
    onChange(timeWithMeridiem, selectionState != null ? selectionState : 'partial');
  }, [ampm, date, onChange, selectionState, utils]);
  return {
    meridiemMode,
    handleMeridiemChange
  };
}

/***/ }),

/***/ 96107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WE": function() { return /* binding */ createDateStrForInputFromSections; },
/* harmony export */   "qc": function() { return /* binding */ addPositionPropertiesToSections; }
/* harmony export */ });
/* unused harmony exports getDateSectionConfigFromFormatToken, getDaysInWeekStr, getLetterEditingOptions, cleanLeadingZeros, cleanDigitSectionValue, adjustSectionValue, getSectionVisibleValue, cleanString, changeSectionValueFormat, doesSectionFormatHaveLeadingZeros, splitFormatIntoSections, getDateFromDateSections, getSectionsBoundaries, validateSections, mergeDateIntoReferenceDate, isAndroid, clampDaySectionIfPossible, getSectionOrder */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


const getDateSectionConfigFromFormatToken = (utils, formatToken) => {
  const config = utils.formatTokenMap[formatToken];
  if (config == null) {
    throw new Error([`MUI: The token "${formatToken}" is not supported by the Date and Time Pickers.`, 'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'].join('\n'));
  }
  if (typeof config === 'string') {
    return {
      type: config,
      contentType: config === 'meridiem' ? 'letter' : 'digit',
      maxLength: undefined
    };
  }
  return {
    type: config.sectionType,
    contentType: config.contentType,
    maxLength: config.maxLength
  };
};
const getDeltaFromKeyCode = keyCode => {
  switch (keyCode) {
    case 'ArrowUp':
      return 1;
    case 'ArrowDown':
      return -1;
    case 'PageUp':
      return 5;
    case 'PageDown':
      return -5;
    default:
      return 0;
  }
};
const getDaysInWeekStr = (utils, timezone, format) => {
  const elements = [];
  const now = utils.dateWithTimezone(undefined, timezone);
  const startDate = utils.startOfWeek(now);
  const endDate = utils.endOfWeek(now);
  let current = startDate;
  while (utils.isBefore(current, endDate)) {
    elements.push(current);
    current = utils.addDays(current, 1);
  }
  return elements.map(weekDay => utils.formatByString(weekDay, format));
};
const getLetterEditingOptions = (utils, timezone, sectionType, format) => {
  switch (sectionType) {
    case 'month':
      {
        return getMonthsInYear(utils, utils.dateWithTimezone(undefined, timezone)).map(month => utils.formatByString(month, format));
      }
    case 'weekDay':
      {
        return getDaysInWeekStr(utils, timezone, format);
      }
    case 'meridiem':
      {
        const now = utils.dateWithTimezone(undefined, timezone);
        return [utils.startOfDay(now), utils.endOfDay(now)].map(date => utils.formatByString(date, format));
      }
    default:
      {
        return [];
      }
  }
};
const cleanLeadingZeros = (utils, valueStr, size) => {
  let cleanValueStr = valueStr;

  // Remove the leading zeros
  cleanValueStr = Number(cleanValueStr).toString();

  // Add enough leading zeros to fill the section
  while (cleanValueStr.length < size) {
    cleanValueStr = `0${cleanValueStr}`;
  }
  return cleanValueStr;
};
const cleanDigitSectionValue = (utils, timezone, value, sectionBoundaries, section) => {
  if (false) {}
  if (section.type === 'day' && section.contentType === 'digit-with-letter') {
    const date = utils.setDate(sectionBoundaries.longestMonth, value);
    return utils.formatByString(date, section.format);
  }

  // queryValue without leading `0` (`01` => `1`)
  const valueStr = value.toString();
  if (section.hasLeadingZerosInInput) {
    return cleanLeadingZeros(utils, valueStr, section.maxLength);
  }
  return valueStr;
};
const adjustSectionValue = (utils, timezone, section, keyCode, sectionsValueBoundaries, activeDate, stepsAttribues) => {
  const delta = getDeltaFromKeyCode(keyCode);
  const isStart = keyCode === 'Home';
  const isEnd = keyCode === 'End';
  const shouldSetAbsolute = section.value === '' || isStart || isEnd;
  const adjustDigitSection = () => {
    const sectionBoundaries = sectionsValueBoundaries[section.type]({
      currentDate: activeDate,
      format: section.format,
      contentType: section.contentType
    });
    const getCleanValue = value => cleanDigitSectionValue(utils, timezone, value, sectionBoundaries, section);
    const step = section.type === 'minutes' && stepsAttribues != null && stepsAttribues.minutesStep ? stepsAttribues.minutesStep : 1;
    const currentSectionValue = parseInt(section.value, 10);
    let newSectionValueNumber = currentSectionValue + delta * step;
    if (shouldSetAbsolute) {
      if (section.type === 'year' && !isEnd && !isStart) {
        return utils.formatByString(utils.dateWithTimezone(undefined, timezone), section.format);
      }
      if (delta > 0 || isStart) {
        newSectionValueNumber = sectionBoundaries.minimum;
      } else {
        newSectionValueNumber = sectionBoundaries.maximum;
      }
    }
    if (newSectionValueNumber % step !== 0) {
      if (delta < 0 || isStart) {
        newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
      }

      if (delta > 0 || isEnd) {
        newSectionValueNumber -= newSectionValueNumber % step;
      }
    }
    if (newSectionValueNumber > sectionBoundaries.maximum) {
      return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
    }
    if (newSectionValueNumber < sectionBoundaries.minimum) {
      return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
    }
    return getCleanValue(newSectionValueNumber);
  };
  const adjustLetterSection = () => {
    const options = getLetterEditingOptions(utils, timezone, section.type, section.format);
    if (options.length === 0) {
      return section.value;
    }
    if (shouldSetAbsolute) {
      if (delta > 0 || isStart) {
        return options[0];
      }
      return options[options.length - 1];
    }
    const currentOptionIndex = options.indexOf(section.value);
    const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
    return options[newOptionIndex];
  };
  if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') {
    return adjustDigitSection();
  }
  return adjustLetterSection();
};
const getSectionVisibleValue = (section, target) => {
  let value = section.value || section.placeholder;
  const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
  if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) {
    value = Number(value).toString();
  }

  // In the input, we add an empty character at the end of each section without leading zeros.
  // This makes sure that `onChange` will always be fired.
  // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
  // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
  // So the browser will not fire the input `onChange`.
  const shouldAddInvisibleSpace = ['input-rtl', 'input-ltr'].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
  if (shouldAddInvisibleSpace) {
    value = `${value}\u200e`;
  }
  if (target === 'input-rtl') {
    value = `\u2068${value}\u2069`;
  }
  return value;
};
const cleanString = dirtyString => dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const addPositionPropertiesToSections = (sections, isRTL) => {
  let position = 0;
  let positionInInput = isRTL ? 1 : 0;
  const newSections = [];
  for (let i = 0; i < sections.length; i += 1) {
    const section = sections[i];
    const renderedValue = getSectionVisibleValue(section, isRTL ? 'input-rtl' : 'input-ltr');
    const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
    const sectionLength = cleanString(sectionStr).length;
    const sectionLengthInInput = sectionStr.length;

    // The ...InInput values consider the unicode characters but do include them in their indexes
    const cleanedValue = cleanString(renderedValue);
    const startInInput = positionInInput + renderedValue.indexOf(cleanedValue[0]) + section.startSeparator.length;
    const endInInput = startInInput + cleanedValue.length;
    newSections.push((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, section, {
      start: position,
      end: position + sectionLength,
      startInInput,
      endInInput
    }));
    position += sectionLength;
    // Move position to the end of string associated to the current section
    positionInInput += sectionLengthInInput;
  }
  return newSections;
};
const getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, currentTokenValue) => {
  switch (sectionConfig.type) {
    case 'year':
      {
        return localeText.fieldYearPlaceholder({
          digitAmount: utils.formatByString(utils.dateWithTimezone(undefined, timezone), currentTokenValue).length
        });
      }
    case 'month':
      {
        return localeText.fieldMonthPlaceholder({
          contentType: sectionConfig.contentType
        });
      }
    case 'day':
      {
        return localeText.fieldDayPlaceholder();
      }
    case 'weekDay':
      {
        return localeText.fieldWeekDayPlaceholder({
          contentType: sectionConfig.contentType
        });
      }
    case 'hours':
      {
        return localeText.fieldHoursPlaceholder();
      }
    case 'minutes':
      {
        return localeText.fieldMinutesPlaceholder();
      }
    case 'seconds':
      {
        return localeText.fieldSecondsPlaceholder();
      }
    case 'meridiem':
      {
        return localeText.fieldMeridiemPlaceholder();
      }
    default:
      {
        return currentTokenValue;
      }
  }
};
const changeSectionValueFormat = (utils, valueStr, currentFormat, newFormat) => {
  if (false) {}
  return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const isFourDigitYearFormat = (utils, timezone, format) => utils.formatByString(utils.dateWithTimezone(undefined, timezone), format).length === 4;
const doesSectionFormatHaveLeadingZeros = (utils, timezone, contentType, sectionType, format) => {
  if (contentType !== 'digit') {
    return false;
  }
  const now = utils.dateWithTimezone(undefined, timezone);
  switch (sectionType) {
    // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
    case 'year':
      {
        if (isFourDigitYearFormat(utils, timezone, format)) {
          const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
          return formatted0001 === '0001';
        }
        const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
        return formatted2001 === '01';
      }
    case 'month':
      {
        return utils.formatByString(utils.startOfYear(now), format).length > 1;
      }
    case 'day':
      {
        return utils.formatByString(utils.startOfMonth(now), format).length > 1;
      }
    case 'weekDay':
      {
        return utils.formatByString(utils.startOfWeek(now), format).length > 1;
      }
    case 'hours':
      {
        return utils.formatByString(utils.setHours(now, 1), format).length > 1;
      }
    case 'minutes':
      {
        return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
      }
    case 'seconds':
      {
        return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
      }
    default:
      {
        throw new Error('Invalid section type');
      }
  }
};
const getEscapedPartsFromFormat = (utils, format) => {
  const escapedParts = [];
  const {
    start: startChar,
    end: endChar
  } = utils.escapedCharacters;
  const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
  let match = null;
  // eslint-disable-next-line no-cond-assign
  while (match = regExp.exec(format)) {
    escapedParts.push({
      start: match.index,
      end: regExp.lastIndex - 1
    });
  }
  return escapedParts;
};
const splitFormatIntoSections = (utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL) => {
  let startSeparator = '';
  const sections = [];
  const now = utils.date();
  const commitToken = token => {
    if (token === '') {
      return null;
    }
    const sectionConfig = getDateSectionConfigFromFormatToken(utils, token);
    const hasLeadingZerosInFormat = doesSectionFormatHaveLeadingZeros(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = date != null && utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
      if (hasLeadingZerosInFormat) {
        maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
      } else {
        if (sectionConfig.maxLength == null) {
          throw new Error(`MUI: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
        }
        maxLength = sectionConfig.maxLength;
        if (isValidDate) {
          sectionValue = cleanLeadingZeros(utils, sectionValue, maxLength);
        }
      }
    }
    sections.push(_extends({}, sectionConfig, {
      format: token,
      maxLength,
      value: sectionValue,
      placeholder: getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
      hasLeadingZeros: hasLeadingZerosInFormat,
      hasLeadingZerosInFormat,
      hasLeadingZerosInInput,
      startSeparator: sections.length === 0 ? startSeparator : '',
      endSeparator: '',
      modified: false
    }));
    return null;
  };

  // Expand the provided format
  let formatExpansionOverflow = 10;
  let prevFormat = format;
  let nextFormat = utils.expandFormat(format);
  while (nextFormat !== prevFormat) {
    prevFormat = nextFormat;
    nextFormat = utils.expandFormat(prevFormat);
    formatExpansionOverflow -= 1;
    if (formatExpansionOverflow < 0) {
      throw new Error('MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component');
    }
  }
  const expandedFormat = nextFormat;

  // Get start/end indexes of escaped sections
  const escapedParts = getEscapedPartsFromFormat(utils, expandedFormat);

  // This RegExp test if the beginning of a string correspond to a supported token
  const isTokenStartRegExp = new RegExp(`^(${Object.keys(utils.formatTokenMap).join('|')})`);
  let currentTokenValue = '';
  for (let i = 0; i < expandedFormat.length; i += 1) {
    const escapedPartOfCurrentChar = escapedParts.find(escapeIndex => escapeIndex.start <= i && escapeIndex.end >= i);
    const char = expandedFormat[i];
    const isEscapedChar = escapedPartOfCurrentChar != null;
    const potentialToken = `${currentTokenValue}${expandedFormat.slice(i)}`;
    if (!isEscapedChar && char.match(/([A-Za-z]+)/) && isTokenStartRegExp.test(potentialToken)) {
      currentTokenValue += char;
    } else {
      // If we are on the opening or closing character of an escaped part of the format,
      // Then we ignore this character.
      const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.end) === i;
      if (!isEscapeBoundary) {
        commitToken(currentTokenValue);
        currentTokenValue = '';
        if (sections.length === 0) {
          startSeparator += char;
        } else {
          sections[sections.length - 1].endSeparator += char;
        }
      }
    }
  }
  commitToken(currentTokenValue);
  return sections.map(section => {
    const cleanSeparator = separator => {
      let cleanedSeparator = separator;
      if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(' ')) {
        cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
      }
      if (formatDensity === 'spacious' && ['/', '.', '-'].includes(cleanedSeparator)) {
        cleanedSeparator = ` ${cleanedSeparator} `;
      }
      return cleanedSeparator;
    };
    section.startSeparator = cleanSeparator(section.startSeparator);
    section.endSeparator = cleanSeparator(section.endSeparator);
    return section;
  });
};

/**
 * Some date libraries like `dayjs` don't support parsing from date with escaped characters.
 * To make sure that the parsing works, we are building a format and a date without any separator.
 */
const getDateFromDateSections = (utils, sections) => {
  // If we have both a day and a weekDay section,
  // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
  // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
  const shouldSkipWeekDays = sections.some(section => section.type === 'day');
  const sectionFormats = [];
  const sectionValues = [];
  for (let i = 0; i < sections.length; i += 1) {
    const section = sections[i];
    const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
    if (!shouldSkip) {
      sectionFormats.push(section.format);
      sectionValues.push(getSectionVisibleValue(section, 'non-input'));
    }
  }
  const formatWithoutSeparator = sectionFormats.join(' ');
  const dateWithoutSeparatorStr = sectionValues.join(' ');
  return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const createDateStrForInputFromSections = (sections, isRTL) => {
  const formattedSections = sections.map(section => {
    const dateValue = getSectionVisibleValue(section, isRTL ? 'input-rtl' : 'input-ltr');
    return `${section.startSeparator}${dateValue}${section.endSeparator}`;
  });
  const dateStr = formattedSections.join('');
  if (!isRTL) {
    return dateStr;
  }

  // \u2066: start left-to-right isolation
  // \u2067: start right-to-left isolation
  // \u2068: start first strong character isolation
  // \u2069: pop isolation
  // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
  return `\u2066${dateStr}\u2069`;
};
const getSectionsBoundaries = (utils, timezone) => {
  const today = utils.dateWithTimezone(undefined, timezone);
  const endOfYear = utils.endOfYear(today);
  const {
    maxDaysInMonth,
    longestMonth
  } = getMonthsInYear(utils, today).reduce((acc, month) => {
    const daysInMonth = utils.getDaysInMonth(month);
    if (daysInMonth > acc.maxDaysInMonth) {
      return {
        maxDaysInMonth: daysInMonth,
        longestMonth: month
      };
    }
    return acc;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format
    }) => ({
      minimum: 0,
      maximum: isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: utils.getMonth(endOfYear) + 1
    }),
    day: ({
      currentDate
    }) => ({
      minimum: 1,
      maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
      longestMonth: longestMonth
    }),
    weekDay: ({
      format,
      contentType
    }) => {
      if (contentType === 'digit') {
        const daysInWeek = getDaysInWeekStr(utils, timezone, format).map(Number);
        return {
          minimum: Math.min(...daysInWeek),
          maximum: Math.max(...daysInWeek)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format
    }) => {
      const lastHourInDay = utils.getHours(endOfYear);
      const hasMeridiem = utils.formatByString(utils.endOfDay(today), format) !== lastHourInDay.toString();
      if (hasMeridiem) {
        return {
          minimum: 1,
          maximum: Number(utils.formatByString(utils.startOfDay(today), format))
        };
      }
      return {
        minimum: 0,
        maximum: lastHourInDay
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: utils.getMinutes(endOfYear)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: utils.getSeconds(endOfYear)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let warnedOnceInvalidSection = false;
const validateSections = (sections, valueType) => {
  if (false) {}
};
const transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo) => {
  switch (section.type) {
    case 'year':
      {
        return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
      }
    case 'month':
      {
        return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
      }
    case 'weekDay':
      {
        const formattedDaysInWeek = getDaysInWeekStr(utils, timezone, section.format);
        const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
        const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
        const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
        const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
        return utils.addDays(dateToTransferFrom, diff);
      }
    case 'day':
      {
        return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
      }
    case 'meridiem':
      {
        const isAM = utils.getHours(dateToTransferFrom) < 12;
        const mergedDateHours = utils.getHours(dateToTransferTo);
        if (isAM && mergedDateHours >= 12) {
          return utils.addHours(dateToTransferTo, -12);
        }
        if (!isAM && mergedDateHours < 12) {
          return utils.addHours(dateToTransferTo, 12);
        }
        return dateToTransferTo;
      }
    case 'hours':
      {
        return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
      }
    case 'minutes':
      {
        return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
      }
    case 'seconds':
      {
        return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
      }
    default:
      {
        return dateToTransferTo;
      }
  }
};
const reliableSectionModificationOrder = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8
};
const mergeDateIntoReferenceDate = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections) =>
// cloning sections before sort to avoid mutating it
[...sections].sort((a, b) => reliableSectionModificationOrder[a.type] - reliableSectionModificationOrder[b.type]).reduce((mergedDate, section) => {
  if (!shouldLimitToEditedSections || section.modified) {
    return transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
  }
  return mergedDate;
}, referenceDate);
const isAndroid = () => navigator.userAgent.toLowerCase().indexOf('android') > -1;
const clampDaySectionIfPossible = (utils, timezone, sections, sectionsValueBoundaries) => {
  // We can only clamp the day value if:
  // 1. if all the sections are filled (except the week day section which can be empty)
  // 2. there is a day section
  const canClamp = sections.every(section => section.type === 'weekDay' || section.value !== '') && sections.some(section => section.type === 'day');
  if (!canClamp) {
    return null;
  }

  // We try to generate a valid date representing the start of the month of the invalid date typed by the user.
  const sectionsForStartOfMonth = sections.map(section => {
    if (section.type !== 'day') {
      return section;
    }
    const dayBoundaries = sectionsValueBoundaries.day({
      currentDate: null,
      format: section.format,
      contentType: section.contentType
    });
    return _extends({}, section, {
      value: cleanDigitSectionValue(utils, timezone, dayBoundaries.minimum, dayBoundaries, section)
    });
  });
  const startOfMonth = getDateFromDateSections(utils, sectionsForStartOfMonth);

  // Even the start of the month is invalid, we probably have other invalid sections, the clamping failed.
  if (startOfMonth == null || !utils.isValid(startOfMonth)) {
    return null;
  }

  // The only invalid section was the day of the month, we replace its value with the maximum boundary for the correct month.
  return sections.map(section => {
    if (section.type !== 'day') {
      return section;
    }
    const dayBoundaries = sectionsValueBoundaries.day({
      currentDate: startOfMonth,
      format: section.format,
      contentType: section.contentType
    });
    if (Number(section.value) <= dayBoundaries.maximum) {
      return section;
    }
    return _extends({}, section, {
      value: dayBoundaries.maximum.toString()
    });
  });
};
const getSectionOrder = (sections, isRTL) => {
  const neighbors = {};
  if (!isRTL) {
    sections.forEach((_, index) => {
      const leftIndex = index === 0 ? null : index - 1;
      const rightIndex = index === sections.length - 1 ? null : index + 1;
      neighbors[index] = {
        leftIndex,
        rightIndex
      };
    });
    return {
      neighbors,
      startIndex: 0,
      endIndex: sections.length - 1
    };
  }
  const rtl2ltr = {};
  const ltr2rtl = {};
  let groupedSectionsStart = 0;
  let groupedSectionsEnd = 0;
  let RTLIndex = sections.length - 1;
  while (RTLIndex >= 0) {
    groupedSectionsEnd = sections.findIndex(
    // eslint-disable-next-line @typescript-eslint/no-loop-func
    (section, index) => {
      var _section$endSeparator;
      return index >= groupedSectionsStart && ((_section$endSeparator = section.endSeparator) == null ? void 0 : _section$endSeparator.includes(' ')) &&
      // Special case where the spaces were not there in the initial input
      section.endSeparator !== ' / ';
    });
    if (groupedSectionsEnd === -1) {
      groupedSectionsEnd = sections.length - 1;
    }
    for (let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1) {
      ltr2rtl[i] = RTLIndex;
      rtl2ltr[RTLIndex] = i;
      RTLIndex -= 1;
    }
    groupedSectionsStart = groupedSectionsEnd + 1;
  }
  sections.forEach((_, index) => {
    const rtlIndex = ltr2rtl[index];
    const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
    const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
    neighbors[index] = {
      leftIndex,
      rightIndex
    };
  });
  return {
    neighbors,
    startIndex: rtl2ltr[0],
    endIndex: rtl2ltr[sections.length - 1]
  };
};

/***/ }),

/***/ 48865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PP": function() { return /* binding */ useDefaultDates; },
  "og": function() { return /* binding */ useLocaleText; },
  "Do": function() { return /* binding */ useLocalizationContext; },
  "mX": function() { return /* binding */ useNow; },
  "nB": function() { return /* binding */ useUtils; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js
var LocalizationProvider = __webpack_require__(50720);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/locales/utils/getPickersLocalization.js

const getPickersLocalization = pickersTranslations => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: (0,esm_extends/* default */.Z)({}, pickersTranslations)
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/locales/enUS.js


// This object is not Partial<PickersLocaleText> because it is the default values

const enUSPickers = {
  // Calendar navigation
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  // View navigation
  openPreviousView: 'open previous view',
  openNextView: 'open next view',
  calendarViewSwitchingButtonAriaLabel: view => view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
  // DateRange placeholders
  start: 'Start',
  end: 'End',
  // Action bar
  cancelButtonLabel: 'Cancel',
  clearButtonLabel: 'Clear',
  okButtonLabel: 'OK',
  todayButtonLabel: 'Today',
  // Toolbar titles
  datePickerToolbarTitle: 'Select date',
  dateTimePickerToolbarTitle: 'Select date & time',
  timePickerToolbarTitle: 'Select time',
  dateRangePickerToolbarTitle: 'Select date range',
  // Clock labels
  clockLabelText: (view, time, adapter) => `Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
  hoursClockNumberText: hours => `${hours} hours`,
  minutesClockNumberText: minutes => `${minutes} minutes`,
  secondsClockNumberText: seconds => `${seconds} seconds`,
  // Digital clock labels
  selectViewText: view => `Select ${view}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: 'Week number',
  calendarWeekNumberHeaderText: '#',
  calendarWeekNumberAriaLabelText: weekNumber => `Week ${weekNumber}`,
  calendarWeekNumberText: weekNumber => `${weekNumber}`,
  // Open picker labels
  openDatePickerDialogue: (value, utils) => value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, 'fullDate')}` : 'Choose date',
  openTimePickerDialogue: (value, utils) => value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, 'fullTime')}` : 'Choose time',
  // Table labels
  timeTableLabel: 'pick time',
  dateTableLabel: 'pick date',
  // Field section placeholders
  fieldYearPlaceholder: params => 'Y'.repeat(params.digitAmount),
  fieldMonthPlaceholder: params => params.contentType === 'letter' ? 'MMMM' : 'MM',
  fieldDayPlaceholder: () => 'DD',
  fieldWeekDayPlaceholder: params => params.contentType === 'letter' ? 'EEEE' : 'EE',
  fieldHoursPlaceholder: () => 'hh',
  fieldMinutesPlaceholder: () => 'mm',
  fieldSecondsPlaceholder: () => 'ss',
  fieldMeridiemPlaceholder: () => 'aa'
};
const DEFAULT_LOCALE = enUSPickers;
const enUS = getPickersLocalization(enUSPickers);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/useUtils.js




const useLocalizationContext = () => {
  const localization = react.useContext(LocalizationProvider/* MuiPickersAdapterContext */.y);
  if (localization === null) {
    throw new Error(['MUI: Can not find the date and time pickers localization context.', 'It looks like you forgot to wrap your component in LocalizationProvider.', 'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'].join('\n'));
  }
  if (localization.utils === null) {
    throw new Error(['MUI: Can not find the date and time pickers adapter from its localization context.', 'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'].join('\n'));
  }
  const localeText = react.useMemo(() => (0,esm_extends/* default */.Z)({}, DEFAULT_LOCALE, localization.localeText), [localization.localeText]);
  return react.useMemo(() => (0,esm_extends/* default */.Z)({}, localization, {
    localeText
  }), [localization, localeText]);
};
const useUtils = () => useLocalizationContext().utils;
const useDefaultDates = () => useLocalizationContext().defaultDates;
const useLocaleText = () => useLocalizationContext().localeText;
const useNow = timezone => {
  const utils = useUtils();
  const now = react.useRef();
  if (now.current === undefined) {
    now.current = utils.dateWithTimezone(undefined, timezone);
  }
  return now.current;
};

/***/ }),

/***/ 57605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useControlledValueWithTimezone; }
/* harmony export */ });
/* unused harmony export useValueWithTimezone */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_utils_useEventCallback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59948);
/* harmony import */ var _mui_utils_useControlled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19032);
/* harmony import */ var _useUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48865);




/**
 * Hooks making sure that:
 * - The value returned by `onChange` always have the timezone of `props.value` or `props.defaultValue` if defined
 * - The value rendered is always the one from `props.timezone` if defined
 */
const useValueWithTimezone = ({
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  onChange,
  valueManager
}) => {
  var _ref, _ref2;
  const utils = (0,_useUtils__WEBPACK_IMPORTED_MODULE_1__/* .useUtils */ .nB)();
  const firstDefaultValue = react__WEBPACK_IMPORTED_MODULE_0__.useRef(defaultValue);
  const inputValue = (_ref = valueProp != null ? valueProp : firstDefaultValue.current) != null ? _ref : valueManager.emptyValue;
  const inputTimezone = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => valueManager.getTimezone(utils, inputValue), [utils, valueManager, inputValue]);
  const setInputTimezone = (0,_mui_utils_useEventCallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newValue => {
    if (inputTimezone == null) {
      return newValue;
    }
    return valueManager.setTimezone(utils, inputTimezone, newValue);
  });
  const timezoneToRender = (_ref2 = timezoneProp != null ? timezoneProp : inputTimezone) != null ? _ref2 : 'default';
  const valueWithTimezoneToRender = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => valueManager.setTimezone(utils, timezoneToRender, inputValue), [valueManager, utils, timezoneToRender, inputValue]);
  const handleValueChange = (0,_mui_utils_useEventCallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((newValue, ...otherParams) => {
    const newValueWithInputTimezone = setInputTimezone(newValue);
    onChange == null ? void 0 : onChange(newValueWithInputTimezone, ...otherParams);
  });
  return {
    value: valueWithTimezoneToRender,
    handleValueChange,
    timezone: timezoneToRender
  };
};

/**
 * Wrapper around `useControlled` and `useValueWithTimezone`
 */
const useControlledValueWithTimezone = ({
  name,
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  onChange: onChangeProp,
  valueManager
}) => {
  const [valueWithInputTimezone, setValue] = (0,_mui_utils_useControlled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    name,
    state: 'value',
    controlled: valueProp,
    default: defaultValue != null ? defaultValue : valueManager.emptyValue
  });
  const onChange = (0,_mui_utils_useEventCallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((newValue, ...otherParams) => {
    setValue(newValue);
    onChangeProp == null ? void 0 : onChangeProp(newValue, ...otherParams);
  });
  return useValueWithTimezone({
    timezone: timezoneProp,
    value: valueWithInputTimezone,
    defaultValue: undefined,
    onChange,
    valueManager
  });
};

/***/ }),

/***/ 5535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ areDatesEqual; },
/* harmony export */   "SV": function() { return /* binding */ getMonthsInYear; },
/* harmony export */   "US": function() { return /* binding */ applyDefaultDate; },
/* harmony export */   "X$": function() { return /* binding */ getTodayDate; },
/* harmony export */   "ai": function() { return /* binding */ replaceInvalidDateByNull; },
/* harmony export */   "xP": function() { return /* binding */ findClosestEnabledDate; },
/* harmony export */   "zu": function() { return /* binding */ mergeDateAndTime; }
/* harmony export */ });
/* unused harmony exports isDatePickerView, resolveDateFormat */

const findClosestEnabledDate = ({
  date,
  disableFuture,
  disablePast,
  maxDate,
  minDate,
  isDateDisabled,
  utils,
  timezone
}) => {
  const today = utils.startOfDay(utils.dateWithTimezone(undefined, timezone));
  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }
  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }
  let forward = date;
  let backward = date;
  if (utils.isBefore(date, minDate)) {
    forward = minDate;
    backward = null;
  }
  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = maxDate;
    }
    forward = null;
  }
  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }
    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }
    if (forward) {
      if (!isDateDisabled(forward)) {
        return forward;
      }
      forward = utils.addDays(forward, 1);
    }
    if (backward) {
      if (!isDateDisabled(backward)) {
        return backward;
      }
      backward = utils.addDays(backward, -1);
    }
  }
  return null;
};
const replaceInvalidDateByNull = (utils, value) => value == null || !utils.isValid(value) ? null : value;
const applyDefaultDate = (utils, value, defaultValue) => {
  if (value == null || !utils.isValid(value)) {
    return defaultValue;
  }
  return value;
};
const areDatesEqual = (utils, a, b) => {
  if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) {
    return true;
  }
  return utils.isEqual(a, b);
};
const getMonthsInYear = (utils, year) => {
  const firstMonth = utils.startOfYear(year);
  const months = [firstMonth];
  while (months.length < 12) {
    const prevMonth = months[months.length - 1];
    months.push(utils.addMonths(prevMonth, 1));
  }
  return months;
};
const mergeDateAndTime = (utils, dateParam, timeParam) => {
  let mergedDate = dateParam;
  mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
  mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
  mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
  return mergedDate;
};
const getTodayDate = (utils, timezone, valueType) => valueType === 'date' ? utils.startOfDay(utils.dateWithTimezone(undefined, timezone)) : utils.dateWithTimezone(undefined, timezone);
const dateViews = (/* unused pure expression or super */ null && (['year', 'month', 'day']));
const isDatePickerView = view => dateViews.includes(view);
const resolveDateFormat = (utils, {
  format,
  views
}, isInToolbar) => {
  if (format != null) {
    return format;
  }
  const formats = utils.formats;
  if (areViewsEqual(views, ['year'])) {
    return formats.year;
  }
  if (areViewsEqual(views, ['month'])) {
    return formats.month;
  }
  if (areViewsEqual(views, ['day'])) {
    return formats.dayOfMonth;
  }
  if (areViewsEqual(views, ['month', 'year'])) {
    return `${formats.month} ${formats.year}`;
  }
  if (areViewsEqual(views, ['day', 'month'])) {
    return `${formats.month} ${formats.dayOfMonth}`;
  }
  if (isInToolbar) {
    // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
  }
  return formats.keyboardDate;
};

/***/ }),

/***/ 21783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ defaultReduceAnimations; }
/* harmony export */ });
const defaultReduceAnimations = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);

/***/ }),

/***/ 95318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kn": function() { return /* binding */ SECTION_TYPE_GRANULARITY; },
  "yw": function() { return /* binding */ getDefaultReferenceDate; }
});

// UNUSED EXPORTS: getSectionTypeGranularity, getViewsGranularity

;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/time-utils.js

const timeViews = (/* unused pure expression or super */ null && (['hours', 'minutes', 'seconds']));
const isTimeView = view => timeViews.includes(view);
const isInternalTimeView = view => timeViews.includes(view) || view === 'meridiem';
const getMeridiem = (date, utils) => {
  if (!date) {
    return null;
  }
  return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const convertValueToMeridiem = (value, meridiem, ampm) => {
  if (ampm) {
    const currentMeridiem = value >= 12 ? 'pm' : 'am';
    if (currentMeridiem !== meridiem) {
      return meridiem === 'am' ? value - 12 : value + 12;
    }
  }
  return value;
};
const convertToMeridiem = (time, meridiem, ampm, utils) => {
  const newHoursAmount = convertValueToMeridiem(utils.getHours(time), meridiem, ampm);
  return utils.setHours(time, newHoursAmount);
};
const getSecondsInDay = (date, utils) => {
  return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, utils) => (dateLeft, dateRight) => {
  if (disableIgnoringDatePartForTimeValidation) {
    return utils.isAfter(dateLeft, dateRight);
  }
  return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
};
const resolveTimeFormat = (utils, {
  format,
  views,
  ampm
}) => {
  if (format != null) {
    return format;
  }
  const formats = utils.formats;
  if (areViewsEqual(views, ['hours'])) {
    return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
  }
  if (areViewsEqual(views, ['minutes'])) {
    return formats.minutes;
  }
  if (areViewsEqual(views, ['seconds'])) {
    return formats.seconds;
  }
  if (areViewsEqual(views, ['minutes', 'seconds'])) {
    return `${formats.minutes}:${formats.seconds}`;
  }
  if (areViewsEqual(views, ['hours', 'minutes', 'seconds'])) {
    return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
  }
  return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/date-utils.js
var date_utils = __webpack_require__(5535);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/getDefaultReferenceDate.js


const SECTION_TYPE_GRANULARITY = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
};
const getSectionTypeGranularity = sections => Math.max(...sections.map(section => {
  var _SECTION_TYPE_GRANULA;
  return (_SECTION_TYPE_GRANULA = SECTION_TYPE_GRANULARITY[section.type]) != null ? _SECTION_TYPE_GRANULA : 1;
}));
const getViewsGranularity = views => Math.max(...views.map(view => {
  var _SECTION_TYPE_GRANULA2;
  return (_SECTION_TYPE_GRANULA2 = SECTION_TYPE_GRANULARITY[view]) != null ? _SECTION_TYPE_GRANULA2 : 1;
}));
const roundDate = (utils, granularity, date) => {
  if (granularity === SECTION_TYPE_GRANULARITY.year) {
    return utils.startOfYear(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.month) {
    return utils.startOfMonth(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.day) {
    return utils.startOfDay(date);
  }

  // We don't have startOfHour / startOfMinute / startOfSecond
  let roundedDate = date;
  if (granularity < SECTION_TYPE_GRANULARITY.minutes) {
    roundedDate = utils.setMinutes(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.seconds) {
    roundedDate = utils.setSeconds(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.milliseconds) {
    roundedDate = utils.setMilliseconds(roundedDate, 0);
  }
  return roundedDate;
};
const getDefaultReferenceDate = ({
  props,
  utils,
  granularity,
  timezone,
  getTodayDate: inGetTodayDate
}) => {
  var _props$disableIgnorin;
  let referenceDate = inGetTodayDate ? inGetTodayDate() : roundDate(utils, granularity, (0,date_utils/* getTodayDate */.X$)(utils, timezone));
  if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.minDate);
  }
  if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.maxDate);
  }
  const isAfter = createIsAfterIgnoreDatePart((_props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation) != null ? _props$disableIgnorin : false, utils);
  if (props.minTime != null && isAfter(props.minTime, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0,date_utils/* mergeDateAndTime */.zu)(utils, referenceDate, props.minTime));
  }
  if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) {
    referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0,date_utils/* mergeDateAndTime */.zu)(utils, referenceDate, props.maxTime));
  }
  return referenceDate;
};

/***/ }),

/***/ 55071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ singleItemValueManager; }
/* harmony export */ });
/* unused harmony export singleItemFieldValueManager */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var _date_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5535);
/* harmony import */ var _getDefaultReferenceDate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95318);
/* harmony import */ var _hooks_useField_useField_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96107);

const _excluded = ["value", "referenceDate"];



const singleItemValueManager = {
  emptyValue: null,
  getTodayValue: _date_utils__WEBPACK_IMPORTED_MODULE_0__/* .getTodayDate */ .X$,
  getInitialReferenceValue: _ref => {
    let {
        value,
        referenceDate
      } = _ref,
      params = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);
    if (value != null && params.utils.isValid(value)) {
      return value;
    }
    if (referenceDate != null) {
      return referenceDate;
    }
    return (0,_getDefaultReferenceDate__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultReferenceDate */ .yw)(params);
  },
  cleanValue: _date_utils__WEBPACK_IMPORTED_MODULE_0__/* .replaceInvalidDateByNull */ .ai,
  areValuesEqual: _date_utils__WEBPACK_IMPORTED_MODULE_0__/* .areDatesEqual */ .LZ,
  isSameError: (a, b) => a === b,
  hasError: error => error != null,
  defaultErrorState: null,
  getTimezone: (utils, value) => value == null ? null : utils.getTimezone(value),
  setTimezone: (utils, timezone, value) => value == null ? null : utils.setTimezone(value, timezone)
};
const singleItemFieldValueManager = {
  updateReferenceValue: (utils, value, prevReferenceValue) => value == null || !utils.isValid(value) ? prevReferenceValue : value,
  getSectionsFromValue: (utils, date, prevSections, isRTL, getSectionsFromDate) => {
    const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
    if (shouldReUsePrevDateSections) {
      return prevSections;
    }
    return (0,_hooks_useField_useField_utils__WEBPACK_IMPORTED_MODULE_3__/* .addPositionPropertiesToSections */ .qc)(getSectionsFromDate(date), isRTL);
  },
  getValueStrFromSections: _hooks_useField_useField_utils__WEBPACK_IMPORTED_MODULE_3__/* .createDateStrForInputFromSections */ .WE,
  getActiveDateManager: (utils, state) => ({
    date: state.value,
    referenceDate: state.referenceValue,
    getSections: sections => sections,
    getNewValuesFromNewActiveDate: newActiveDate => ({
      value: newActiveDate,
      referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
    })
  }),
  parseValueStr: (valueStr, referenceValue, parseDate) => parseDate(valueStr.trim(), referenceValue)
};

/***/ }),

/***/ 62814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ LicenseInfo; }
});

;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/ponyfillGlobal/ponyfillGlobal.js
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* harmony default export */ var ponyfillGlobal = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());
;// CONCATENATED MODULE: ./node_modules/@mui/x-license-pro/utils/licenseInfo.js

// Store the license information in a global, so it can be shared
// when module duplication occurs. The duplication of the modules can happen
// if using multiple version of MUI X at the same time of the bundler
// decide to duplicate to improve the size of the chunks.
// eslint-disable-next-line no-underscore-dangle
ponyfillGlobal.__MUI_LICENSE_INFO__ = ponyfillGlobal.__MUI_LICENSE_INFO__ || {
  key: undefined
};
class LicenseInfo {
  static getLicenseInfo() {
    // eslint-disable-next-line no-underscore-dangle
    return ponyfillGlobal.__MUI_LICENSE_INFO__;
  }
  static getLicenseKey() {
    return LicenseInfo.getLicenseInfo().key;
  }
  static setLicenseKey(key) {
    const licenseInfo = LicenseInfo.getLicenseInfo();
    licenseInfo.key = key;
  }
}

/***/ }),

/***/ 88025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gE": function() { return /* binding */ BrowserTracing; }
});

// UNUSED EXPORTS: BROWSER_TRACING_INTEGRATION_ID, getMetaContent

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js
var idletransaction = __webpack_require__(65544);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(77850);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(9791);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(77638);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js


const WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (WINDOW && WINDOW.document) {
    WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      // eslint-disable-next-line deprecation/deprecation
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    onHidden(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return WINDOW.document.visibilityState === 'hidden' && !WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js










/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  // @ts-ignore we want to make sure all of these are available, even if TS is sure they are
  return WINDOW && WINDOW.addEventListener && WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    // @ts-ignore we want to make sure all of these are available, even if TS is sure they are
    if (performance.mark) {
      WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();

    return () => {
      if (clsCallback) {
        clsCallback();
      }
      if (lcpCallback) {
        lcpCallback();
      }
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        transaction.startChild({
          description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        });
      }
    }
  };

  observe('event', entryHandler, { durationThreshold: 0 });
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  return onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return onLCP(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !WINDOW.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
        requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + msToSec(entry.requestStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + msToSec(entry.responseStart ),
    endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['http.response_transfer_size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['http.response_content_length'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['http.decoded_response_content_length'] = entry.decodedBodySize;
  }
  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js
var request = __webpack_require__(10516);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(35648);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!WINDOW || !WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: WINDOW.location.pathname,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: time/* browserPerformanceTimeOrigin */.Z1 ? time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.oq)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js








const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...idletransaction/* TRACING_DEFAULTS */.AT,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  _experiments: {},
  ...request/* defaultRequestInstrumentationOptions */.k3,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   __init2() {this._hasSetTracePropagationTargets = false;}

   constructor(_options) {BrowserTracing.prototype.__init.call(this);BrowserTracing.prototype.__init2.call(this);
    (0,hubextensions/* addTracingExtensions */.T)();

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      this._hasSetTracePropagationTargets = !!(
        _options &&
        // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins)
      );
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;
    const hub = getCurrentHub();
    const client = hub.getClient();
    const clientOptions = client && client.getOptions();

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
      _experiments,
    } = this.options;

    const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
    // There are three ways to configure tracePropagationTargets:
    // 1. via top level client option `tracePropagationTargets`
    // 2. via BrowserTracing option `tracePropagationTargets`
    // 3. via BrowserTracing option `tracingOrigins` (deprecated)
    //
    // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
    // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
    // This is done as it minimizes bundle size (we don't have to have undefined checks).
    //
    // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
    const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
      logger/* logger.warn */.kg.warn(
        '[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.',
      );
    }

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    (0,request/* instrumentOutgoingRequests */.L7)({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const hub = this._getCurrentHub();

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
    const baggage = isPageloadTransaction ? getMetaContent('baggage') : '';
    const { traceparentData, dynamicSamplingContext, propagationContext } = (0,tracing/* tracingContextFromHeaders */.KA)(
      sentryTrace,
      baggage,
    );

    const expandedContext = {
      ...context,
      ...traceparentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const { location } = WINDOW;

    const idleTransaction = (0,hubextensions/* startIdleTransaction */.l)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );

    const scope = hub.getScope();

    // If it's a pageload and there is a meta tag set
    // use the traceparentData as the propagation context
    if (isPageloadTransaction && traceparentData) {
      scope.setPropagationContext(propagationContext);
    } else {
      // Navigation transactions should set a new propagation context based on the
      // created idle transaction.
      scope.setPropagationContext({
        traceId: idleTransaction.traceId,
        spanId: idleTransaction.spanId,
        parentSpanId: idleTransaction.parentSpanId,
        sampled: !!idleTransaction.sampled,
      });
    }

    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
      const op = 'ui.action.click';

      const currentTransaction = (0,utils/* getActiveTransaction */.x1)();
      if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.warn */.kg.warn(
            `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
          );
        return undefined;
      }

      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: this._latestRouteSource || 'url',
        },
      };

      inflightInteractionTransaction = (0,hubextensions/* startIdleTransaction */.l)(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}


//# sourceMappingURL=browsertracing.js.map


/***/ }),

/***/ 10516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ instrumentOutgoingRequests; },
/* harmony export */   "k3": function() { return /* binding */ defaultRequestInstrumentationOptions; }
/* harmony export */ });
/* unused harmony exports DEFAULT_TRACE_PROPAGATION_TARGETS, addTracingHeadersToFetchRequest, extractNetworkProtocol, fetchCallback, shouldAttachHeaders, xhrCallback */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47522);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95659);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90454);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35648);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77638);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99181);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67597);



/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  const {
    traceFetch,
    traceXHR,
    tracePropagationTargets,
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
  } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)('fetch', (handlerData) => {
      const createdSpan = fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }

  if (traceXHR) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)('xhr', (handlerData) => {
      const createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
}

/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */
function addHTTPTimings(span) {
  const url = span.data.url;
  const observer = new PerformanceObserver(list => {
    const entries = list.getEntries() ;
    entries.forEach(entry => {
      if ((entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest') && entry.name.endsWith(url)) {
        const spanData = resourceTimingEntryToSpanData(entry);
        spanData.forEach(data => span.setData(...data));
        observer.disconnect();
      }
    });
  });
  observer.observe({
    entryTypes: ['resource'],
  });
}

/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */
function extractNetworkProtocol(nextHopProtocol) {
  let name = 'unknown';
  let version = 'unknown';
  let _name = '';
  for (const char of nextHopProtocol) {
    // http/1.1 etc.
    if (char === '/') {
      [name, version] = nextHopProtocol.split('/');
      break;
    }
    // h2, h3 etc.
    if (!isNaN(Number(char))) {
      name = _name === 'h' ? 'http' : _name;
      version = nextHopProtocol.split(_name)[1];
      break;
    }
    _name += char;
  }
  if (_name === nextHopProtocol) {
    // webrtc, ftp, etc.
    name = _name;
  }
  return { name, version };
}

function getAbsoluteTime(time) {
  return ((_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .browserPerformanceTimeOrigin */ .Z1 || performance.timeOrigin) + time) / 1000;
}

function resourceTimingEntryToSpanData(resourceTiming) {
  const { name, version } = extractNetworkProtocol(resourceTiming.nextHopProtocol);

  const timingSpanData = [];

  timingSpanData.push(['network.protocol.version', version], ['network.protocol.name', name]);

  if (!_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .browserPerformanceTimeOrigin */ .Z1) {
    return timingSpanData;
  }
  return [
    ...timingSpanData,
    ['http.request.redirect_start', getAbsoluteTime(resourceTiming.redirectStart)],
    ['http.request.fetch_start', getAbsoluteTime(resourceTiming.fetchStart)],
    ['http.request.domain_lookup_start', getAbsoluteTime(resourceTiming.domainLookupStart)],
    ['http.request.domain_lookup_end', getAbsoluteTime(resourceTiming.domainLookupEnd)],
    ['http.request.connect_start', getAbsoluteTime(resourceTiming.connectStart)],
    ['http.request.secure_connection_start', getAbsoluteTime(resourceTiming.secureConnectionStart)],
    ['http.request.connection_end', getAbsoluteTime(resourceTiming.connectEnd)],
    ['http.request.request_start', getAbsoluteTime(resourceTiming.requestStart)],
    ['http.request.response_start', getAbsoluteTime(resourceTiming.responseStart)],
    ['http.request.response_end', getAbsoluteTime(resourceTiming.responseEnd)],
  ];
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!(0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .hasTracingEnabled */ .z)() || !handlerData.fetchData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);

  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);

        const contentLength =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');

        const contentLengthNum = parseInt(contentLength);
        if (contentLengthNum > 0) {
          span.setData('http.response_content_length', contentLengthNum);
        }
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  const client = hub.getClient();
  const parentSpan = scope.getSpan();

  const { method, url } = handlerData.fetchData;

  const span =
    shouldCreateSpanResult && parentSpan
      ? parentSpan.startChild({
          data: {
            url,
            type: 'fetch',
            'http.method': method,
          },
          description: `${method} ${url}`,
          op: 'http.client',
        })
      : undefined;

  if (span) {
    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;
  }

  if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    options.headers = addTracingHeadersToFetchRequest(request, client, scope, options);
  }

  return span;
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */
function addTracingHeadersToFetchRequest(
  request, // unknown is actually type Request but we can't export DOM types from this package,
  client,
  scope,
  options

,
) {
  const span = scope.getSpan();

  const transaction = span && span.transaction;

  const { traceId, sampled, dsc } = scope.getPropagationContext();

  const sentryTraceHeader = span ? span.toTraceparent() : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .generateSentryTraceHeader */ .$p)(traceId, undefined, sampled);
  const dynamicSamplingContext = transaction
    ? transaction.getDynamicSamplingContext()
    : dsc
    ? dsc
    : (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .getDynamicSamplingContextFromClient */ ._)(traceId, client, scope);

  const sentryBaggageHeader = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .dynamicSamplingContextToSentryBaggageHeader */ .IQ)(dynamicSamplingContext);

  const headers =
    typeof Request !== 'undefined' && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .isInstanceOf */ .V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .isInstanceOf */ .V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended multiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .BAGGAGE_HEADER_NAME */ .bU, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .BAGGAGE_HEADER_NAME */ .bU, sentryBaggageHeader]);
    }

    return newHeaders ;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
// eslint-disable-next-line complexity
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .SENTRY_XHR_DATA_KEY */ .xU];

  if (!(0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .hasTracingEnabled */ .z)() || (xhr && xhr.__sentry_own_request__) || !xhr || !sentryXhrData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(sentryXhrData.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  const parentSpan = scope.getSpan();

  const span =
    shouldCreateSpanResult && parentSpan
      ? parentSpan.startChild({
          data: {
            ...sentryXhrData.data,
            type: 'xhr',
            'http.method': sentryXhrData.method,
            url: sentryXhrData.url,
          },
          description: `${sentryXhrData.method} ${sentryXhrData.url}`,
          op: 'http.client',
        })
      : undefined;

  if (span) {
    xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
  }

  if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
    if (span) {
      const transaction = span && span.transaction;
      const dynamicSamplingContext = transaction && transaction.getDynamicSamplingContext();
      const sentryBaggageHeader = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .dynamicSamplingContextToSentryBaggageHeader */ .IQ)(dynamicSamplingContext);
      setHeaderOnXhr(xhr, span.toTraceparent(), sentryBaggageHeader);
    } else {
      const client = hub.getClient();
      const { traceId, sampled, dsc } = scope.getPropagationContext();
      const sentryTraceHeader = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .generateSentryTraceHeader */ .$p)(traceId, undefined, sampled);
      const dynamicSamplingContext =
        dsc || (client ? (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .getDynamicSamplingContextFromClient */ ._)(traceId, client, scope) : undefined);
      const sentryBaggageHeader = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .dynamicSamplingContextToSentryBaggageHeader */ .IQ)(dynamicSamplingContext);
      setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
  }

  return span;
}

function setHeaderOnXhr(
  xhr,
  sentryTraceHeader,
  sentryBaggageHeader,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
    if (sentryBaggageHeader) {
      // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
      // We can therefore simply set a baggage header without checking what was there before
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xhr.setRequestHeader(_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .BAGGAGE_HEADER_NAME */ .bU, sentryBaggageHeader);
    }
  } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
  }
}


//# sourceMappingURL=request.js.map


/***/ }),

/***/ 49262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ BrowserClient; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(30292);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(58725);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/error.js
var error = __webpack_require__(80409);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(1984);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = (0,envelope/* getSdkMetadataForEnvelopeHeader */.HY)(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: (0,esm_dsn/* dsnToString */.RA)(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session.toJSON()];

  return (0,envelope/* createEnvelope */.Jd)(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = (0,envelope/* getSdkMetadataForEnvelopeHeader */.HY)(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = (0,envelope/* createEventEnvelopeHeaders */.Cd)(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return (0,envelope/* createEnvelope */.Jd)(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integration.js
var esm_integration = __webpack_require__(22967);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(9015);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(90454);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(88942);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js








const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  // eslint-disable-next-line @typescript-eslint/ban-types
   __init5() {this._hooks = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);BaseClient.prototype.__init5.call(this);
    this._options = options;

    if (options.dsn) {
      this._dsn = (0,esm_dsn/* makeDsn */.vK)(options.dsn);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }

    if (this._dsn) {
      const url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.U)(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = (0,esm_integration/* setupIntegrations */.q4)(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    (0,esm_integration/* setupIntegration */.m7)(integration, this._integrations);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = (0,envelope/* addItemToEnvelope */.BO)(
          env,
          (0,envelope/* createAttachmentEnvelopeItem */.zQ)(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      const promise = this._sendEnvelope(env);
      if (promise) {
        promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
      }
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      void this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-ignore We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      // @ts-ignore we cannot enforce the callback to match the hook
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }
    return (0,prepareEvent/* prepareEvent */.R)(options, event, hint, scope).then(evt => {
      if (evt === null) {
        return evt;
      }

      // If a trace context is not set on the event, we use the propagationContext set on the event to
      // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
      // also generate one for it.
      const { propagationContext } = evt.sdkProcessingMetadata || {};
      const trace = evt.contexts && evt.contexts.trace;
      if (!trace && propagationContext) {
        const { traceId: trace_id, spanId, parentSpanId, dsc } = propagationContext ;
        evt.contexts = {
          trace: {
            trace_id,
            span_id: spanId,
            parent_span_id: parentSpanId,
          },
          ...evt.contexts,
        };

        const dynamicSamplingContext = dsc ? dsc : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(trace_id, this, scope);

        evt.sdkProcessingMetadata = {
          dynamicSamplingContext,
          ...evt.sdkProcessingMetadata,
        };
      }
      return evt;
    });
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            logger/* logger.log */.kg.log(sentryError.message);
          } else {
            logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new error/* SentryError */.b(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new error/* SentryError */.b('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          throw new error/* SentryError */.b(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof error/* SentryError */.b) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new error/* SentryError */.b(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this.emit('beforeEnvelope', envelope);

      return this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new error/* SentryError */.b(invalidValueError);
        }
        return event;
      },
      e => {
        throw new error/* SentryError */.b(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new error/* SentryError */.b(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(68518);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return (0,envelope/* createEnvelope */.Jd)(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(84773);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(86891);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js
var breadcrumbs = __webpack_require__(90564);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/userfeedback.js
var userfeedback = __webpack_require__(70911);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js







/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers/* WINDOW.SENTRY_SDK_SOURCE */.m9.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();

    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: `${sdkSource}:@sentry/browser`,
          version: version/* SDK_VERSION */.J,
        },
      ],
      version: version/* SDK_VERSION */.J,
    };

    super(options);

    if (options.sendClientReports && helpers/* WINDOW.document */.m9.document) {
      helpers/* WINDOW.document.addEventListener */.m9.document.addEventListener('visibilitychange', () => {
        if (helpers/* WINDOW.document.visibilityState */.m9.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return (0,eventbuilder/* eventFromException */.dr)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return (0,eventbuilder/* eventFromMessage */.aB)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(breadcrumbs/* BREADCRUMB_INTEGRATION_ID */.p) ;
    // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
    // "Breadcrumbs" that does not have this function.
    if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) {
      breadcrumbIntegration.addSentryBreadcrumb(event);
    }

    super.sendEvent(event, hint);
  }

  /**
   * Sends user feedback to Sentry.
   */
   captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = (0,userfeedback/* createUserFeedbackEnvelope */.r)(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });
    void this._sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && (0,esm_dsn/* dsnToString */.RA)(this._dsn));
    void this._sendEnvelope(envelope);
  }
}


//# sourceMappingURL=client.js.map


/***/ }),

/***/ 84773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GJ": function() { return /* binding */ exceptionFromError; },
/* harmony export */   "ME": function() { return /* binding */ eventFromUnknownInput; },
/* harmony export */   "aB": function() { return /* binding */ eventFromMessage; },
/* harmony export */   "dr": function() { return /* binding */ eventFromException; }
/* harmony export */ });
/* unused harmony exports eventFromError, eventFromPlainObject, eventFromString, parseStackFrames */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95659);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34754);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20535);



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }),
        },
      ],
    },
    extra: {
      __serialized__: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .normalizeToSize */ .Qy)(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .resolvedSyncPromise */ .WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .resolvedSyncPromise */ .WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isErrorEvent */ .VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMError */ .TX)(exception) || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMException */ .fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMError */ .TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, message);
    }
    if ('code' in domException) {
      // eslint-disable-next-line deprecation/deprecation
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isError */ .VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(exception) || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, `${exception}`, undefined);
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}

function getNonErrorObjectExceptionValue(
  exception,
  { isUnhandledRejection },
) {
  const keys = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .extractExceptionKeysForMessage */ .zf)(exception);
  const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';

  // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
  // We still want to try to get a decent message for these cases
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isErrorEvent */ .VW)(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }

  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }

  return `Object captured as ${captureType} with keys: ${keys}`;
}

function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : undefined;
  } catch (e) {
    // ignore errors here
  }
}


//# sourceMappingURL=eventbuilder.js.map


/***/ }),

/***/ 86891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wz": function() { return /* binding */ shouldIgnoreOnError; },
/* harmony export */   "m9": function() { return /* binding */ WINDOW; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64487);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62844);



const WINDOW = _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, undefined, undefined);
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .markFunctionWrapped */ .$Q)(sentryWrapped, fn);

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 90564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; },
/* harmony export */   "p": function() { return /* binding */ BREADCRUMB_INTEGRATION_ID; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95659);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35648);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58464);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16547);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57321);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26956);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86891);




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)('history', _historyBreadcrumb);
    }
  }

  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
   addSentryBreadcrumb(event) {
    if (this.options.sentry) {
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getEventDescription */ .jH)(event),
        },
        {
          event,
        },
      );
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      target = _isEvent(event)
        ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .htmlTreeAsString */ .Rt)(event.target, { keyAttrs, maxStringLength })
        : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .htmlTreeAsString */ .Rt)(event, { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .severityLevelFromString */ .VT)(handlerData.level),
    message: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .safeJoin */ .nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .safeJoin */ .nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  const sentryXhrData = handlerData.xhr[_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .SENTRY_XHR_DATA_KEY */ .xU];

  // We only capture complete, non-sentry requests
  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return;
  }

  const { method, url, status_code, body } = sentryXhrData;

  const data = {
    method,
    url,
    status_code,
  };

  const hint = {
    xhr: handlerData.xhr,
    input: body,
    startTimestamp,
    endTimestamp,
  };

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().addBreadcrumb(
    {
      category: 'xhr',
      data,
      type: 'http',
    },
    hint,
  );
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;

  // We only capture complete fetch requests
  if (!endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    const data = handlerData.fetchData;
    const hint = {
      data: handlerData.error,
      input: handlerData.args,
      startTimestamp,
      endTimestamp,
    };

    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        level: 'error',
        type: 'http',
      },
      hint,
    );
  } else {
    const data = {
      ...handlerData.fetchData,
      status_code: handlerData.response && handlerData.response.status,
    };
    const hint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp,
      endTimestamp,
    };
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data,
        type: 'http',
      },
      hint,
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .parseUrl */ .en)(_helpers_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location.href */ .m9.location.href);
  let parsedFrom = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .parseUrl */ .en)(from);
  const parsedTo = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .parseUrl */ .en)(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}

function _isEvent(event) {
  return !!event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map


/***/ }),

/***/ 69730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Dedupe; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12343);


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function _shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map


/***/ }),

/***/ 52136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GlobalHandlers; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95659);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35648);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58464);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62844);
/* harmony import */ var _eventbuilder_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84773);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86891);





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if ((0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .shouldIgnoreOnError */ .Wz)() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_3__/* .eventFromUnknownInput */ .ME)(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addInstrumentationHandler */ .oq)(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if ((0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .shouldIgnoreOnError */ .Wz)() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isPrimitive */ .pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_3__/* .eventFromUnknownInput */ .ME)(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isErrorEvent */ .VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(url) && url.length > 0 ? url : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getLocationHref */ .l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.log */ .kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .addExceptionMechanism */ .EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getCurrentHub */ .Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map


/***/ }),

/***/ 61945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ HttpContext; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10350);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95659);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86891);



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addGlobalEventProcessor */ .c)((event) => {
      if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.navigator */ .m9.navigator && !_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.location */ .m9.location && !_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.document */ .m9.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.location */ .m9.location && _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.location.href */ .m9.location.href);
        const { referrer } = _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.document */ .m9.document || {};
        const { userAgent } = _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW.navigator */ .m9.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...event.request, ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map


/***/ }),

/***/ 29145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ LinkedErrors; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/aggregate-errors.js



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */
function applyAggregateErrorsToEvent(
  exceptionFromErrorImplementation,
  parser,
  maxValueLimit = 250,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return;
  }

  // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
  const originalException =
    event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;

  // We only create exception grouping if there is an exception in the event.
  if (originalException) {
    event.exception.values = truncateAggregateExceptions(
      aggregateExceptionsFromError(
        exceptionFromErrorImplementation,
        parser,
        limit,
        hint.originalException ,
        key,
        event.exception.values,
        originalException,
        0,
      ),
      maxValueLimit,
    );
  }
}

function aggregateExceptionsFromError(
  exceptionFromErrorImplementation,
  parser,
  limit,
  error,
  key,
  prevExceptions,
  exception,
  exceptionId,
) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }

  let newExceptions = [...prevExceptions];

  if ((0,is/* isInstanceOf */.V9)(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId,
    );
  }

  // This will create exception grouping for AggregateErrors
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
  if (Array.isArray(error.errors)) {
    error.errors.forEach((childError, i) => {
      if ((0,is/* isInstanceOf */.V9)(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId,
        );
      }
    });
  }

  return newExceptions;
}

function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    is_exception_group: true,
    exception_id: exceptionId,
  };
}

function applyExceptionGroupFieldsForChildException(
  exception,
  source,
  exceptionId,
  parentId,
) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    type: 'chained',
    source,
    exception_id: exceptionId,
    parent_id: parentId,
  };
}

/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */
function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map(exception => {
    if (exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }
    return exception;
  });
}


//# sourceMappingURL=aggregate-errors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(84773);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js



const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor((event, hint) => {
      const hub = getCurrentHub();
      const client = hub.getClient();
      const self = hub.getIntegration(LinkedErrors);

      if (!client || !self) {
        return event;
      }

      const options = client.getOptions();
      applyAggregateErrorsToEvent(
        eventbuilder/* exceptionFromError */.GJ,
        options.stackParser,
        options.maxValueLength,
        self._key,
        self._limit,
        event,
        hint,
      );

      return event;
    });
  }
} LinkedErrors.__initStatic();


//# sourceMappingURL=linkederrors.js.map


/***/ }),

/***/ 53692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TryCatch; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30360);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86891);



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in _helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9) {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(originalCallback, {
      mechanism: {
        data: { function: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(originalFunction);
          }

          // Otherwise wrap directly
          return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = _helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .WINDOW */ .m9 ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,_helpers_js__WEBPACK_IMPORTED_MODULE_1__/* .wrap */ .re)(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .fill */ .hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map


/***/ }),

/***/ 79074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jd": function() { return /* binding */ captureUserFeedback; },
  "xv": function() { return /* binding */ sdk_close; },
  "SS": function() { return /* binding */ defaultIntegrations; },
  "yl": function() { return /* binding */ flush; },
  "Eg": function() { return /* binding */ forceLoad; },
  "S1": function() { return /* binding */ init; },
  "eW": function() { return /* binding */ lastEventId; },
  "lA": function() { return /* binding */ onLoad; },
  "jp": function() { return /* binding */ showReportDialog; },
  "re": function() { return /* binding */ wrap; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(42422);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(19116);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integration.js
var integration = __webpack_require__(22967);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(95659);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  scope.update(options.initialScope);

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(1984);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(35648);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/client.js + 3 modules
var client = __webpack_require__(49262);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(86891);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(52136);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(53692);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js
var breadcrumbs = __webpack_require__(90564);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js + 1 modules
var linkederrors = __webpack_require__(29145);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js
var httpcontext = __webpack_require__(61945);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(69730);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js
var stack_parsers = __webpack_require__(34469);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js + 1 modules
var fetch = __webpack_require__(54025);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js
var xhr = __webpack_require__(68131);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js














const defaultIntegrations = [
  new inboundfilters/* InboundFilters */.QD(),
  new functiontostring/* FunctionToString */.c(),
  new trycatch/* TryCatch */.p(),
  new breadcrumbs/* Breadcrumbs */.O(),
  new globalhandlers/* GlobalHandlers */.d(),
  new linkederrors/* LinkedErrors */.i(),
  new dedupe/* Dedupe */.I(),
  new httpcontext/* HttpContext */.q(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers/* WINDOW.SENTRY_RELEASE */.m9.SENTRY_RELEASE && helpers/* WINDOW.SENTRY_RELEASE.id */.m9.SENTRY_RELEASE.id) {
      options.release = helpers/* WINDOW.SENTRY_RELEASE.id */.m9.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || stack_parsers/* defaultStackParser */.Dt),
    integrations: (0,integration/* getIntegrationsToSetup */.m8)(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? fetch/* makeFetchTransport */.f : xhr/* makeXHRTransport */.K),
  };

  initAndBind(client/* BrowserClient */.R, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = (0,esm_hub/* getCurrentHub */.Gd)()) {
  // doesn't work without a document (React Native)
  if (!helpers/* WINDOW.document */.m9.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = helpers/* WINDOW.document.createElement */.m9.document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = (0,api/* getReportDialogEndpoint */.h)(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const injectionPoint = helpers/* WINDOW.document.head */.m9.document.head || helpers/* WINDOW.document.body */.m9.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return (0,esm_hub/* getCurrentHub */.Gd)().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Cannot flush events. No client defined.');
  return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Cannot flush events and disable SDK. No client defined.');
  return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
  return (0,helpers/* wrap */.re)(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers/* WINDOW.document */.m9.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.oq)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}

/**
 * Captures user feedback and sends it to Sentry.
 */
function captureUserFeedback(feedback) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    client.captureUserFeedback(feedback);
  }
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 34469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ chromeStackLineParser; },
/* harmony export */   "$Q": function() { return /* binding */ geckoStackLineParser; },
/* harmony export */   "Dt": function() { return /* binding */ defaultStackParser; },
/* harmony export */   "HH": function() { return /* binding */ opera11StackLineParser; },
/* harmony export */   "NP": function() { return /* binding */ opera10StackLineParser; },
/* harmony export */   "R2": function() { return /* binding */ winjsStackLineParser; },
/* harmony export */   "d8": function() { return /* binding */ defaultStackLineParsers; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30360);


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .createStackParser */ .pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map


/***/ }),

/***/ 54025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ makeFetchTransport; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/transports/base.js + 1 modules
var base = __webpack_require__(32570);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(86891);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers/* WINDOW.fetch */.m9.fetch)) {
    return (cachedFetchImpl = helpers/* WINDOW.fetch.bind */.m9.fetch.bind(helpers/* WINDOW */.m9));
  }

  const document = helpers/* WINDOW.document */.m9.document;
  let fetchImpl = helpers/* WINDOW.fetch */.m9.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers/* WINDOW */.m9));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  let pendingBodySize = 0;
  let pendingCount = 0;

  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;

    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After'),
          },
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return (0,base/* createTransport */.q)(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map


/***/ }),

/***/ 68131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ makeXHRTransport; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32570);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96893);



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .SyncPromise */ .cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .createTransport */ .q)(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map


/***/ }),

/***/ 70911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ createUserFeedbackEnvelope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30292);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58725);


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(
  feedback,
  {
    metadata,
    tunnel,
    dsn,
  }

,
) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata &&
      metadata.sdk && {
        sdk: {
          name: metadata.sdk.name,
          version: metadata.sdk.version,
        },
      }),
    ...(!!tunnel && !!dsn && { dsn: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dsnToString */ .RA)(dsn) }),
  };
  const item = createUserFeedbackEnvelopeItem(feedback);

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .createEnvelope */ .Jd)(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report',
  };
  return [feedbackHeaders, feedback];
}


//# sourceMappingURL=userfeedback.js.map


/***/ }),

/***/ 1984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getEnvelopeEndpointWithUrlEncodedAuth; },
/* harmony export */   "h": function() { return /* binding */ getReportDialogEndpoint; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30292);


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .urlEncode */ ._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .makeDsn */ .vK)(dsnLike);
  if (!dsn) {
    return '';
  }

  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dsnToString */ .RA)(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map


/***/ }),

/***/ 51131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 64487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "YA": function() { return /* binding */ setTag; },
/* harmony export */   "Yr": function() { return /* binding */ startTransaction; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; },
/* harmony export */   "mG": function() { return /* binding */ setTags; },
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "rJ": function() { return /* binding */ setExtras; },
/* harmony export */   "sU": function() { return /* binding */ setExtra; },
/* harmony export */   "uT": function() { return /* binding */ captureMessage; },
/* harmony export */   "v": function() { return /* binding */ setContext; }
/* harmony export */ });
/* unused harmony export captureCheckIn */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95659);



// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().startTransaction({ ...context }, customSamplingContext);
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const hub = getCurrentHub();
  const scope = hub.getScope();
  const client = hub.getClient();
  if (!client) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
  }

  return uuid4();
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 95659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "Xb": function() { return /* binding */ Hub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; },
/* harmony export */   "pj": function() { return /* binding */ makeMain; },
/* harmony export */   "vi": function() { return /* binding */ getHubFromCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, ensureHubOnCarrier, runWithAsyncContext, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71235);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51131);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10350);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9015);





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {this._version = _version;
    this._stack = [{ scope }];
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this.getScope().setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this.getScope().setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this.getScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.getScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this.getScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    this.getScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && !result) {
      // eslint-disable-next-line no-console
      console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
    }

    return result;
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
    }
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (!hasHubOnCarrier(carrier) || getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
    const globalHubTopStack = parent.getStackTop();
    setHubOnCarrier(carrier, new Hub(globalHubTopStack.client, Scope.clone(globalHubTopStack.scope)));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 22967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m7": function() { return /* binding */ setupIntegration; },
/* harmony export */   "m8": function() { return /* binding */ getIntegrationsToSetup; },
/* harmony export */   "q4": function() { return /* binding */ setupIntegrations; }
/* harmony export */ });
/* unused harmony export installedIntegrations */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95659);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10350);




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .arrayify */ .lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/** Setup a single integration.  */
function setupIntegration(integration, integrationIndex) {
  integrationIndex[integration.name] = integration;

  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(_scope_js__WEBPACK_IMPORTED_MODULE_1__/* .addGlobalEventProcessor */ .c, _hub_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentHub */ .Gd);
    installedIntegrations.push(integration.name);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Integration installed: ${integration.name}`);
  }
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}


//# sourceMappingURL=integration.js.map


/***/ }),

/***/ 19116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FunctionToString; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20535);


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // intrinsics (like Function.prototype) might be immutable in some environments
    // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Function.prototype.toString = function ( ...args) {
        const context = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(this) || this;
        return originalFunctionToString.apply(context, args);
      };
    } catch (e) {
      // ignore errors here, just don't patch this
    }
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map


/***/ }),

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QD": function() { return /* binding */ InboundFilters; }
/* harmony export */ });
/* unused harmony exports _mergeOptions, _shouldDropEvent */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*healthcheck.*$/,
  /^.*healthy.*$/,
  /^.*live.*$/,
  /^.*ready.*$/,
  /^.*heartbeat.*$/,
  /^.*\/health$/,
  /^.*\/healthz$/,
];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS),
    ],
    ignoreTransactions: [
      ...(internalOptions.ignoreTransactions || []),
      ...(clientOptions.ignoreTransactions || []),
      ...(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS),
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`,
      );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(message, ignoreErrors));
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  const name = event.transaction;
  return name ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringMatchesSomePattern */ .U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    const { values } = event.exception;
    try {
      const { type = '', value = '' } = (values && values[values.length - 1]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Cannot extract message for event ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Cannot extract url for event ${(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getEventDescription */ .jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map


/***/ }),

/***/ 10350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71235);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9015);



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
      newScope._propagationContext = { ...scope._propagationContext };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
      if (captureContext._propagationContext) {
        this._propagationContext = captureContext._propagationContext;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
      if (captureContext.propagationContext) {
        this._propagationContext = captureContext.propagationContext;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    this._propagationContext = generatePropagationContext();
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transaction = this._span.transaction;
      if (transaction) {
        event.sdkProcessingMetadata = {
          dynamicSamplingContext: transaction.getDynamicSamplingContext(),
          ...event.sdkProcessingMetadata,
        };
        const transactionName = transaction.name;
        if (transactionName) {
          event.tags = { transaction: transactionName, ...event.tags };
        }
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = {
      ...event.sdkProcessingMetadata,
      ...this._sdkProcessingMetadata,
      propagationContext: this._propagationContext,
    };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * @inheritDoc
   */
   setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }

  /**
   * @inheritDoc
   */
   getPropagationContext() {
    return this._propagationContext;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}

function generatePropagationContext() {
  return {
    traceId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)(),
    spanId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)().substring(16),
    sampled: false,
  };
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 9015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 90454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getDynamicSamplingContextFromClient; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20535);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51131);



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */
function getDynamicSamplingContextFromClient(
  trace_id,
  client,
  scope,
) {
  const options = client.getOptions();

  const { publicKey: public_key } = client.getDsn() || {};
  const { segment: user_segment } = (scope && scope.getUser()) || {};

  const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    environment: options.environment || _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_ENVIRONMENT */ .J,
    release: options.release,
    user_segment,
    public_key,
    trace_id,
  }) ;

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}


//# sourceMappingURL=dynamicSamplingContext.js.map


/***/ }),

/***/ 77850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ addTracingExtensions; },
  "l": function() { return /* binding */ startIdleTransaction; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(95659);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(47522);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(35648);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(9791);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/errors.js



let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  (0,instrument/* addInstrumentationHandler */.oq)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.oq)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js
var idletransaction = __webpack_require__(65544);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/transaction.js
var tracing_transaction = __webpack_require__(78069);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  const span = scope.getSpan();

  return span
    ? {
        'sentry-trace': span.toTraceparent(),
      }
    : {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setMetadata({
      sampleRate,
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new tracing_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 65544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": function() { return /* binding */ TRACING_DEFAULTS; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38903);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78069);




const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampInSeconds */ .ph)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

  // Idle timeout was canceled and we should finish the transaction with the last span end.
   __init4() {this._idleTimeoutCanceledPermanently = false;}

    __init5() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   __init6() {this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];}

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);IdleTransaction.prototype.__init5.call(this);IdleTransaction.prototype.__init6.call(this);
    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._restartIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampInSeconds */ .ph)()) {
    this._finished = true;
    this.activities = {};

    if (this.op === 'ui.action.click') {
      this.setTag(FINISH_REASON_TAG, this._finishReason);
    }

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      const scope = this._idleHub.getScope();
      if (scope.getTransaction() === this) {
        scope.setSpan(undefined);
      }
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      }
    }
  }

  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
   setFinishReason(reason) {
    this._finishReason = reason;
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampInSeconds */ .ph)();
      if (this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.finish(endTimestamp);
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampInSeconds is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 38903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "Zd": function() { return /* binding */ spanStatusfromHttpCode; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77638);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20535);


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampInSeconds */ .ph)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */
   __init7() {this.instrumenter = 'sentry';}

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);Span.prototype.__init7.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
    if (spanContext.instrumenter) {
      this.instrumenter = spanContext.instrumenter;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    this.setData('http.response.status_code', httpStatus);
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampInSeconds */ .ph)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .generateSentryTraceHeader */ .$p)(this.traceId, this.spanId, this.sampled);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = spanContext.data || {};
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = spanContext.spanId || this.spanId;
    this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
    this.status = spanContext.status;
    this.tags = spanContext.tags || {};
    this.traceId = spanContext.traceId || this.traceId;

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 78069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95659);
/* harmony import */ var _dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90454);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38903);





/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._contexts = {};}

   __init3() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);Transaction.prototype.__init3.call(this);
    this._hub = hub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = transactionContext.name || '';

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    const client = hub.getClient();

    if (!client) return {};

    const scope = hub.getScope();
    const dsc = (0,_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_4__/* .getDynamicSamplingContextFromClient */ ._)(this.traceId, client, scope);

    const maybeSampleRate = this.metadata.sampleRate;
    if (maybeSampleRate !== undefined) {
      dsc.sample_rate = `${maybeSampleRate}`;
    }

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = this.metadata.source;
    if (source && source !== 'url') {
      dsc.transaction = this.name;
    }

    if (this.sampled !== undefined) {
      dsc.sampled = String(this.sampled);
    }

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }

  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
   setHub(hub) {
    this._hub = hub;
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 9791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; }
/* harmony export */ });
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95659);



/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  return scope.getTransaction() ;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 32570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ createTransport; }
});

// UNUSED EXPORTS: DEFAULT_TRANSPORT_BUFFER_SIZE

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/error.js
var esm_error = __webpack_require__(80409);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new esm_error/* SentryError */.b('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/envelope.js
var esm_envelope = __webpack_require__(58725);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
var ratelimit = __webpack_require__(80228);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, (item, type) => {
      const envelopeItemDataCategory = (0,esm_envelope/* envelopeItemTypeToDataCategory */.mL)(type);
      if ((0,ratelimit/* isRateLimited */.Q)(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = (0,esm_envelope/* createEnvelope */.Jd)(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      (0,esm_envelope/* forEachEnvelopeItem */.gv)(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, (0,esm_envelope/* envelopeItemTypeToDataCategory */.mL)(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: (0,esm_envelope/* serializeEnvelope */.V$)(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = (0,ratelimit/* updateRateLimits */.WG)(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof esm_error/* SentryError */.b) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map


/***/ }),

/***/ 47522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95659);


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map


/***/ }),

/***/ 88942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ prepareEvent; }
/* harmony export */ });
/* unused harmony exports applyDebugIds, applyDebugMeta */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57321);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71235);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34754);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51131);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10350);




/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)(),
    timestamp: event.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dateTimestampInSeconds */ .yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);

  // Only put debug IDs onto frames for error events.
  if (event.type === undefined) {
    applyDebugIds(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope.clone */ .s.clone(finalScope).update(hint.captureContext);
  }

  // We prepare the result here with a resolved Event.
  let result = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolvedSyncPromise */ .WD)(prepared);

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  //
  // We need to check for the existence of `finalScope.getAttachments`
  // because `getAttachments` can be undefined if users are using an older version
  // of `@sentry/core` that does not have the `getAttachments` method.
  // See: https://github.com/getsentry/sentry-javascript/issues/5229
  if (finalScope) {
    // Collect attachments from the hint and scope
    if (finalScope.getAttachments) {
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }
    }

    // In case we have a hub we reassign it.
    result = finalScope.applyToEvent(prepared, hint);
  }

  return result.then(evt => {
    if (evt) {
      // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
      // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
      // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
      // any new data
      applyDebugMeta(evt);
    }

    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : _constants_js__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_ENVIRONMENT */ .J;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(request.url, maxValueLength);
  }
}

const debugIdStackParserCache = new WeakMap();

/**
 * Puts debug IDs into the stack frames of an error event.
 */
function applyDebugIds(event, stackParser) {
  const debugIdMap = _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ._sentryDebugIds */ .n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */
function applyDebugMeta(event) {
  // Extract debug IDs and filenames from the stack frames on the event.
  const filenameDebugIdMap = {};
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.keys(filenameDebugIdMap).forEach(filename => {
    images.push({
      type: 'sourcemap',
      code_file: filename,
      debug_id: filenameDebugIdMap[filename],
    });
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
      if (span.data) {
        span.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalize */ .Fv)(span.data, depth, maxBreadth);
      }
      return span;
    });
  }

  return normalized;
}


//# sourceMappingURL=prepareEvent.js.map


/***/ }),

/***/ 40105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
const SDK_VERSION = '7.60.0';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 59150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oo": function() { return /* reexport */ breadcrumbs/* Breadcrumbs */.O; },
  "RE": function() { return /* reexport */ client/* BrowserClient */.R; },
  "_p": function() { return /* reexport */ BrowserProfilingIntegration; },
  "gE": function() { return /* reexport */ browsertracing/* BrowserTracing */.gE; },
  "Iq": function() { return /* reexport */ dedupe/* Dedupe */.I; },
  "SV": function() { return /* reexport */ errorboundary/* ErrorBoundary */.SV; },
  "cq": function() { return /* reexport */ functiontostring/* FunctionToString */.c; },
  "dJ": function() { return /* reexport */ globalhandlers/* GlobalHandlers */.d; },
  "qT": function() { return /* reexport */ httpcontext/* HttpContext */.q; },
  "Xb": function() { return /* reexport */ esm_hub/* Hub */.Xb; },
  "QD": function() { return /* reexport */ inboundfilters/* InboundFilters */.QD; },
  "jK": function() { return /* reexport */ INTEGRATIONS; },
  "iP": function() { return /* reexport */ linkederrors/* LinkedErrors */.i; },
  "_e": function() { return /* reexport */ ModuleMetadata; },
  "Q1": function() { return /* reexport */ Profiler; },
  "UH": function() { return /* reexport */ Replay; },
  "Jn": function() { return /* reexport */ version/* SDK_VERSION */.J; },
  "sX": function() { return /* reexport */ esm_scope/* Scope */.s; },
  "pT": function() { return /* reexport */ trycatch/* TryCatch */.p; },
  "m9": function() { return /* reexport */ helpers/* WINDOW */.m9; },
  "n_": function() { return /* reexport */ esm_exports/* addBreadcrumb */.n_; },
  "cc": function() { return /* reexport */ esm_scope/* addGlobalEventProcessor */.c; },
  "Ts": function() { return /* reexport */ hubextensions/* addTracingExtensions */.T; },
  "eN": function() { return /* reexport */ esm_exports/* captureEvent */.eN; },
  "Tb": function() { return /* reexport */ esm_exports/* captureException */.Tb; },
  "uT": function() { return /* reexport */ esm_exports/* captureMessage */.uT; },
  "ud": function() { return /* reexport */ captureUnderscoreErrorException; },
  "Jd": function() { return /* reexport */ sdk/* captureUserFeedback */.Jd; },
  "$3": function() { return /* reexport */ stack_parsers/* chromeStackLineParser */.$3; },
  "xv": function() { return /* reexport */ sdk/* close */.xv; },
  "e": function() { return /* reexport */ esm_exports/* configureScope */.e; },
  "wS": function() { return /* reexport */ createReduxEnhancer; },
  "qv": function() { return /* reexport */ base/* createTransport */.q; },
  "rQ": function() { return /* reexport */ userfeedback/* createUserFeedbackEnvelope */.r; },
  "SS": function() { return /* reexport */ sdk/* defaultIntegrations */.SS; },
  "k3": function() { return /* reexport */ request/* defaultRequestInstrumentationOptions */.k3; },
  "d8": function() { return /* reexport */ stack_parsers/* defaultStackLineParsers */.d8; },
  "Dt": function() { return /* reexport */ stack_parsers/* defaultStackParser */.Dt; },
  "dr": function() { return /* reexport */ eventbuilder/* eventFromException */.dr; },
  "aB": function() { return /* reexport */ eventbuilder/* eventFromMessage */.aB; },
  "qG": function() { return /* reexport */ tracing/* extractTraceparentData */.qG; },
  "yl": function() { return /* reexport */ sdk/* flush */.yl; },
  "Eg": function() { return /* reexport */ sdk/* forceLoad */.Eg; },
  "$Q": function() { return /* reexport */ stack_parsers/* geckoStackLineParser */.$Q; },
  "x1": function() { return /* reexport */ utils/* getActiveTransaction */.x1; },
  "Gd": function() { return /* reexport */ esm_hub/* getCurrentHub */.Gd; },
  "vi": function() { return /* reexport */ esm_hub/* getHubFromCarrier */.vi; },
  "S1": function() { return /* binding */ client_init; },
  "L7": function() { return /* reexport */ request/* instrumentOutgoingRequests */.L7; },
  "eW": function() { return /* reexport */ sdk/* lastEventId */.eW; },
  "O1": function() { return /* reexport */ makeBrowserOfflineTransport; },
  "fD": function() { return /* reexport */ fetch/* makeFetchTransport */.f; },
  "pj": function() { return /* reexport */ esm_hub/* makeMain */.pj; },
  "Wq": function() { return /* reexport */ makeMultiplexedTransport; },
  "KC": function() { return /* reexport */ xhr/* makeXHRTransport */.K; },
  "q$": function() { return /* reexport */ nextRouterInstrumentation; },
  "lA": function() { return /* reexport */ sdk/* onLoad */.lA; },
  "Uv": function() { return /* reexport */ onProfilingStartRouteTransaction; },
  "NP": function() { return /* reexport */ stack_parsers/* opera10StackLineParser */.NP; },
  "HH": function() { return /* reexport */ stack_parsers/* opera11StackLineParser */.HH; },
  "XQ": function() { return /* reexport */ reactRouterV3Instrumentation; },
  "qr": function() { return /* reexport */ reactRouterV4Instrumentation; },
  "qp": function() { return /* reexport */ reactRouterV5Instrumentation; },
  "KO": function() { return /* reexport */ reactRouterV6Instrumentation; },
  "v": function() { return /* reexport */ esm_exports/* setContext */.v; },
  "sU": function() { return /* reexport */ esm_exports/* setExtra */.sU; },
  "rJ": function() { return /* reexport */ esm_exports/* setExtras */.rJ; },
  "YA": function() { return /* reexport */ esm_exports/* setTag */.YA; },
  "mG": function() { return /* reexport */ esm_exports/* setTags */.mG; },
  "av": function() { return /* reexport */ esm_exports/* setUser */.av; },
  "jp": function() { return /* reexport */ sdk/* showReportDialog */.jp; },
  "Zd": function() { return /* reexport */ span/* spanStatusfromHttpCode */.Zd; },
  "Yr": function() { return /* reexport */ esm_exports/* startTransaction */.Yr; },
  "g4": function() { return /* reexport */ trace; },
  "ED": function() { return /* reexport */ useProfiler; },
  "R2": function() { return /* reexport */ stack_parsers/* winjsStackLineParser */.R2; },
  "Pf": function() { return /* reexport */ errorboundary/* withErrorBoundary */.Pf; },
  "zH": function() { return /* reexport */ withProfiler; },
  "$e": function() { return /* reexport */ esm_exports/* withScope */.$e; },
  "wO": function() { return /* binding */ withSentryConfig; },
  "sT": function() { return /* reexport */ withSentryGetServerSideProps; },
  "SF": function() { return /* reexport */ withSentryGetStaticProps; },
  "H0": function() { return /* reexport */ withSentryReactRouterV6Routing; },
  "gy": function() { return /* reexport */ withSentryRouting; },
  "Im": function() { return /* reexport */ withSentryServerSideAppGetInitialProps; },
  "W9": function() { return /* reexport */ withSentryServerSideDocumentGetInitialProps; },
  "vw": function() { return /* reexport */ withSentryServerSideErrorGetInitialProps; },
  "EC": function() { return /* reexport */ withSentryServerSideGetInitialProps; },
  "re": function() { return /* reexport */ sdk/* wrap */.re; },
  "$l": function() { return /* reexport */ wrapAppGetInitialPropsWithSentry; },
  "vG": function() { return /* reexport */ wrapCreateBrowserRouter; },
  "B4": function() { return /* reexport */ wrapDocumentGetInitialPropsWithSentry; },
  "rO": function() { return /* reexport */ wrapErrorGetInitialPropsWithSentry; },
  "O5": function() { return /* reexport */ wrapGetInitialPropsWithSentry; },
  "rC": function() { return /* reexport */ wrapGetServerSidePropsWithSentry; },
  "ug": function() { return /* reexport */ wrapGetStaticPropsWithSentry; },
  "M1": function() { return /* reexport */ wrapUseRoutes; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return functiontostring/* FunctionToString */.c; },
  "InboundFilters": function() { return inboundfilters/* InboundFilters */.QD; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return breadcrumbs/* Breadcrumbs */.O; },
  "Dedupe": function() { return dedupe/* Dedupe */.I; },
  "GlobalHandlers": function() { return globalhandlers/* GlobalHandlers */.d; },
  "HttpContext": function() { return httpcontext/* HttpContext */.q; },
  "LinkedErrors": function() { return linkederrors/* LinkedErrors */.i; },
  "TryCatch": function() { return trycatch/* TryCatch */.p; }
});

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(47522);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
  const parts = splitPathRe.exec(filename);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */
   __init() {this.name = RewriteFrames.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
    __init2() {this._prefix = 'app:///';}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);RewriteFrames.prototype.__init2.call(this);RewriteFrames.prototype.__init3.call(this);
    if (options.root) {
      this._root = options.root;
    }
    if (options.prefix) {
      this._prefix = options.prefix;
    }
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor(event => {
      const self = getCurrentHub().getIntegration(RewriteFrames);
      if (self) {
        return self.process(event);
      }
      return event;
    });
  }

  /** JSDoc */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init3() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    const isWindowsFrame =
      /^[a-zA-Z]:\\/.test(frame.filename) ||
      // or the presence of a backslash without a forward slash (which are not allowed on Windows)
      (frame.filename.includes('\\') && !frame.filename.includes('/'));
    // Check if the frame filename begins with `/`
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js + 1 modules
var sdk = __webpack_require__(79074);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: version/* SDK_VERSION */.J,
      },
    ],
    version: version/* SDK_VERSION */.J,
  };
  (0,sdk/* init */.S1)(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js + 16 modules
var browsertracing = __webpack_require__(88025);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js
var request = __webpack_require__(10516);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(19116);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(42422);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(95659);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/envelope.js
var esm_envelope = __webpack_require__(58725);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metadata.js


/** Keys are source filename/url, values are metadata objects. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */
const parsedStacks = new Set();

function ensureMetadataStacksAreParsed(parser) {
  if (!worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata) {
    return;
  }

  for (const stack of Object.keys(worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata)) {
    const metadata = worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata[stack];

    if (parsedStacks.has(stack)) {
      continue;
    }

    // Ensure this stack doesn't get parsed again
    parsedStacks.add(stack);

    const frames = parser(stack);

    // Go through the frames starting from the top of the stack and find the first one with a filename
    for (const frame of frames.reverse()) {
      if (frame.filename) {
        // Save the metadata for this filename
        filenameMetadataMap.set(frame.filename, metadata);
        break;
      }
    }
  }
}

/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMetadataForUrl(parser, filename) {
  ensureMetadataStacksAreParsed(parser);
  return filenameMetadataMap.get(filename);
}

/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */
function addMetadataToStackFrames(parser, event) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      if (!exception.stacktrace) {
        return;
      }

      for (const frame of exception.stacktrace.frames || []) {
        if (!frame.filename) {
          continue;
        }

        const metadata = getMetadataForUrl(parser, frame.filename);

        if (metadata) {
          frame.module_metadata = metadata;
        }
      }
    });
  } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Strips metadata from stack frames.
 */
function stripMetadataFromStackFrames(event) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      if (!exception.stacktrace) {
        return;
      }

      for (const frame of exception.stacktrace.frames || []) {
        delete frame.module_metadata;
      }
    });
  } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/metadata.js



/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 */
class ModuleMetadata  {constructor() { ModuleMetadata.prototype.__init.call(this); }
  /*
   * @inheritDoc
   */
   static __initStatic() {this.id = 'ModuleMetadata';}

  /**
   * @inheritDoc
   */
   __init() {this.name = ModuleMetadata.id;}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const client = getCurrentHub().getClient();

    if (!client || typeof client.on !== 'function') {
      return;
    }

    // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
    client.on('beforeEnvelope', envelope => {
      (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, (item, type) => {
        if (type === 'event') {
          const event = Array.isArray(item) ? (item )[1] : undefined;

          if (event) {
            stripMetadataFromStackFrames(event);
            item[1] = event;
          }
        }
      });
    });

    const stackParser = client.getOptions().stackParser;

    addGlobalEventProcessor(event => {
      addMetadataToStackFrames(stackParser, event);
      return event;
    });
  }
} ModuleMetadata.__initStatic();


//# sourceMappingURL=metadata.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(10350);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(77850);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/transports/base.js + 1 modules
var base = __webpack_require__(32570);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(77638);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(9791);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(30292);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(1984);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/multiplexed.js



/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */
function eventFromEnvelope(env, types) {
  let event;

  (0,esm_envelope/* forEachEnvelopeItem */.gv)(env, (item, type) => {
    if (types.includes(type)) {
      event = Array.isArray(item) ? (item )[1] : undefined;
    }
    // bail out if we found an event
    return !!event;
  });

  return event;
}

/**
 * Creates a transport that overrides the release on all events.
 */
function makeOverrideReleaseTransport(
  createTransport,
  release,
) {
  return options => {
    const transport = createTransport(options);

    return {
      send: async (envelope) => {
        const event = eventFromEnvelope(envelope, ['event', 'transaction', 'profile', 'replay_event']);

        if (event) {
          event.release = release;
        }
        return transport.send(envelope);
      },
      flush: timeout => transport.flush(timeout),
    };
  };
}

/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */
function makeMultiplexedTransport(
  createTransport,
  matcher,
) {
  return options => {
    const fallbackTransport = createTransport(options);
    const otherTransports = {};

    function getTransport(dsn, release) {
      // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
      // use at the same time
      const key = release ? `${dsn}:${release}` : dsn;

      if (!otherTransports[key]) {
        const validatedDsn = (0,esm_dsn/* dsnFromString */.U4)(dsn);
        if (!validatedDsn) {
          return undefined;
        }
        const url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.U)(validatedDsn);

        otherTransports[key] = release
          ? makeOverrideReleaseTransport(createTransport, release)({ ...options, url })
          : createTransport({ ...options, url });
      }

      return otherTransports[key];
    }

    async function send(envelope) {
      function getEvent(types) {
        const eventTypes = types && types.length ? types : ['event'];
        return eventFromEnvelope(envelope, eventTypes);
      }

      const transports = matcher({ envelope, getEvent })
        .map(result => {
          if (typeof result === 'string') {
            return getTransport(result, undefined);
          } else {
            return getTransport(result.dsn, result.release);
          }
        })
        .filter((t) => !!t);

      // If we have no transports to send to, use the fallback transport
      if (transports.length === 0) {
        transports.push(fallbackTransport);
      }

      const results = await Promise.all(transports.map(transport => transport.send(envelope)));

      return results[0];
    }

    async function flush(timeout) {
      const allTransports = [...Object.keys(otherTransports).map(dsn => otherTransports[dsn]), fallbackTransport];
      const results = await Promise.all(allTransports.map(transport => transport.flush(timeout)));
      return results.every(r => r);
    }

    return {
      send,
      flush,
    };
  };
}


//# sourceMappingURL=multiplexed.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/span.js
var span = __webpack_require__(38903);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/trace.js




/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 */
function trace(
  context,
  callback,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onError = () => {},
) {
  const ctx = { ...context };
  // If a name is set and a description is not, set the description to the name.
  if (ctx.name !== undefined && ctx.description === undefined) {
    ctx.description = ctx.name;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();

  const parentSpan = scope.getSpan();

  function getActiveSpan() {
    if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)()) {
      return undefined;
    }
    return parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
  }

  const activeSpan = getActiveSpan();
  scope.setSpan(activeSpan);

  function finishAndSetSpan() {
    activeSpan && activeSpan.finish();
    hub.getScope().setSpan(parentSpan);
  }

  let maybePromiseResult;
  try {
    maybePromiseResult = callback(activeSpan);
  } catch (e) {
    activeSpan && activeSpan.setStatus('internal_error');
    onError(e);
    finishAndSetSpan();
    throw e;
  }

  if ((0,is/* isThenable */.J8)(maybePromiseResult)) {
    Promise.resolve(maybePromiseResult).then(
      () => {
        finishAndSetSpan();
      },
      e => {
        activeSpan && activeSpan.setStatus('internal_error');
        onError(e);
        finishAndSetSpan();
      },
    );
  } else {
    finishAndSetSpan();
  }

  return maybePromiseResult;
}


//# sourceMappingURL=trace.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(86891);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/client.js + 3 modules
var client = __webpack_require__(49262);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js + 1 modules
var fetch = __webpack_require__(54025);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js
var xhr = __webpack_require__(68131);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js
var stack_parsers = __webpack_require__(34469);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(84773);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/userfeedback.js
var userfeedback = __webpack_require__(70911);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(52136);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(53692);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js
var breadcrumbs = __webpack_require__(90564);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js + 1 modules
var linkederrors = __webpack_require__(29145);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js
var httpcontext = __webpack_require__(61945);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(69730);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(88942);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(34754);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js + 1 modules
var instrument = __webpack_require__(35648);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__(61422);
;// CONCATENATED MODULE: ./node_modules/@sentry/replay/esm/index.js
/* provided dependency */ var process = __webpack_require__(83454);



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const REPLAY_SESSION_KEY = 'sentryReplaySession';
const REPLAY_EVENT_NAME = 'replay_event';
const UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';

// The idle limit for a session after which recording is paused.
const SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms

// The idle limit for a session after which the session expires.
const SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms

// The maximum length of a session
const MAX_SESSION_LIFE = 3600000; // 60 minutes in ms

/** Default flush delays */
const DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const DEFAULT_FLUSH_MAX_DELAY = 5500;

/* How long to wait for error checkouts */
const BUFFER_CHECKOUT_TIME = 60000;

const RETRY_BASE_INTERVAL = 5000;
const RETRY_MAX_COUNT = 3;

/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */
const NETWORK_BODY_MAX_SIZE = 150000;

/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */
const CONSOLE_ARG_MAX_SIZE = 5000;

/* Min. time to wait before we consider something a slow click. */
const SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */
const SLOW_CLICK_SCROLL_TIMEOUT = 300;

/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */
const REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB

/** Replays must be min. 5s long before we send them. */
const MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */
const MIN_REPLAY_DURATION_LIMIT = 15000;

var NodeType$1;
(function (NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$1 || (NodeType$1 = {}));

function isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
    const host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean(host && host.shadowRoot && host.shadowRoot === n);
}
function isInputTypeMasked({ maskInputOptions, tagName, type, }) {
    if (tagName.toLowerCase() === 'option') {
        tagName = 'select';
    }
    const actualType = typeof type === 'string' ? type.toLowerCase() : undefined;
    return (maskInputOptions[tagName.toLowerCase()] ||
        (actualType && maskInputOptions[actualType]) ||
        actualType === 'password' ||
        (tagName === 'input' && !type && maskInputOptions['text']));
}
function hasInputMaskOptions({ tagName, type, maskInputOptions, maskInputSelector, }) {
    return (maskInputSelector || isInputTypeMasked({ maskInputOptions, tagName, type }));
}
function maskInputValue({ input, maskInputSelector, unmaskInputSelector, maskInputOptions, tagName, type, value, maskInputFn, }) {
    let text = value || '';
    if (unmaskInputSelector && input.matches(unmaskInputSelector)) {
        return text;
    }
    if (input.hasAttribute('data-rr-is-password')) {
        type = 'password';
    }
    if (isInputTypeMasked({ maskInputOptions, tagName, type }) ||
        (maskInputSelector && input.matches(maskInputSelector))) {
        if (maskInputFn) {
            text = maskInputFn(text);
        }
        else {
            text = '*'.repeat(text.length);
        }
    }
    return text;
}
const ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx)
        return true;
    const chunkSize = 50;
    for (let x = 0; x < canvas.width; x += chunkSize) {
        for (let y = 0; y < canvas.height; y += chunkSize) {
            const getImageData = ctx.getImageData;
            const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData
                ? getImageData[ORIGINAL_ATTRIBUTE_NAME]
                : getImageData;
            const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
            if (pixelBuffer.some((pixel) => pixel !== 0))
                return false;
        }
    }
    return true;
}
function getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password')
        ? 'password'
        : type
            ? type.toLowerCase()
            : null;
}
function getInputValue(el, tagName, type) {
    typeof type === 'string' ? type.toLowerCase() : '';
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) {
        return el.getAttribute('value') || '';
    }
    return el.value;
}

let _id = 1;
const tagNameRegex = new RegExp('[^a-z0-9-_:]');
const IGNORED_NODE = -2;
function defaultMaskFn(str) {
    return str ? str.replace(/[\S]/g, '*') : '';
}
function genId() {
    return _id++;
}
function getValidTagName(element) {
    if (element instanceof HTMLFormElement) {
        return 'form';
    }
    const processedTagName = element.tagName.toLowerCase().trim();
    if (tagNameRegex.test(processedTagName)) {
        return 'div';
    }
    return processedTagName;
}
function getCssRulesString(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map(getCssRuleString).join('') : null;
    }
    catch (error) {
        return null;
    }
}
function getCssRuleString(rule) {
    let cssStringified = rule.cssText;
    if (isCSSImportRule(rule)) {
        try {
            cssStringified = getCssRulesString(rule.styleSheet) || cssStringified;
        }
        catch (_a) {
        }
    }
    return validateStringifiedCssRule(cssStringified);
}
function validateStringifiedCssRule(cssStringified) {
    if (cssStringified.indexOf(':') > -1) {
        const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
        return cssStringified.replace(regex, '$1\\$2');
    }
    return cssStringified;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function stringifyStyleSheet(sheet) {
    return sheet.cssRules
        ? Array.from(sheet.cssRules)
            .map((rule) => rule.cssText ? validateStringifiedCssRule(rule.cssText) : '')
            .join('')
        : '';
}
function extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) {
        origin = url.split('/').slice(0, 3).join('/');
    }
    else {
        origin = url.split('/')[0];
    }
    origin = origin.split('?')[0];
    return origin;
}
let canvasService;
let canvasCtx;
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const RELATIVE_PATH = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/;
const DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace(URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3) => {
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) {
            return origin;
        }
        if (!RELATIVE_PATH.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (DATA_URI.test(filePath)) {
            return `url(${maybeQuote}${filePath}${maybeQuote})`;
        }
        if (filePath[0] === '/') {
            return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
        }
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts) {
            if (part === '.') {
                continue;
            }
            else if (part === '..') {
                stack.pop();
            }
            else {
                stack.push(part);
            }
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') {
        return attributeValue;
    }
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        let match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    let output = [];
    while (true) {
        collectCharacters(SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) {
            break;
        }
        let url = collectCharacters(SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        }
        else {
            let descriptorsStr = '';
            url = absoluteToDoc(doc, url);
            let inParens = false;
            while (true) {
                let c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                }
                else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    }
                    else if (c === '(') {
                        inParens = true;
                    }
                }
                else {
                    if (c === ')') {
                        inParens = false;
                    }
                }
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') {
        return attributeValue;
    }
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function transformAttribute(doc, element, _tagName, _name, value, maskAllText, unmaskTextSelector, maskTextFn) {
    if (!value) {
        return value;
    }
    const name = _name.toLowerCase();
    const tagName = _tagName.toLowerCase();
    if (name === 'src' || name === 'href') {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'xlink:href' && value[0] !== '#') {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'background' &&
        (tagName === 'table' || tagName === 'td' || tagName === 'th')) {
        return absoluteToDoc(doc, value);
    }
    else if (name === 'srcset') {
        return getAbsoluteSrcsetString(doc, value);
    }
    else if (name === 'style') {
        return absoluteToStylesheet(value, getHref());
    }
    else if (tagName === 'object' && name === 'data') {
        return absoluteToDoc(doc, value);
    }
    else if (maskAllText &&
        _shouldMaskAttribute(element, name, tagName, unmaskTextSelector)) {
        return maskTextFn ? maskTextFn(value) : defaultMaskFn(value);
    }
    return value;
}
function _shouldMaskAttribute(element, attribute, tagName, unmaskTextSelector) {
    if (unmaskTextSelector && element.matches(unmaskTextSelector)) {
        return false;
    }
    return (['placeholder', 'title', 'aria-label'].indexOf(attribute) > -1 ||
        (tagName === 'input' &&
            attribute === 'value' &&
            element.hasAttribute('type') &&
            ['submit', 'button'].indexOf(element.getAttribute('type').toLowerCase()) > -1));
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    if (unblockSelector && element.matches(unblockSelector)) {
        return false;
    }
    if (typeof blockClass === 'string') {
        if (element.classList.contains(blockClass)) {
            return true;
        }
    }
    else {
        for (let eIndex = 0; eIndex < element.classList.length; eIndex++) {
            const className = element.classList[eIndex];
            if (blockClass.test(className)) {
                return true;
            }
        }
    }
    if (blockSelector) {
        return element.matches(blockSelector);
    }
    return false;
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) {
    if (!node) {
        return false;
    }
    if (node.nodeType !== node.ELEMENT_NODE) {
        return needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
    }
    if (unmaskTextSelector) {
        if (node.matches(unmaskTextSelector) ||
            node.closest(unmaskTextSelector)) {
            return false;
        }
    }
    if (maskAllText) {
        return true;
    }
    if (typeof maskTextClass === 'string') {
        if (node.classList.contains(maskTextClass)) {
            return true;
        }
    }
    else {
        for (let eIndex = 0; eIndex < node.classList.length; eIndex++) {
            const className = node.classList[eIndex];
            if (maskTextClass.test(className)) {
                return true;
            }
        }
    }
    if (maskTextSelector) {
        if (node.matches(maskTextSelector)) {
            return true;
        }
    }
    return needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) {
        return;
    }
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    }
    catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(() => {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', () => {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl ||
        iframeEl.src === blankUrl ||
        iframeEl.src === '') {
        setTimeout(listener, 0);
        return;
    }
    iframeEl.addEventListener('load', listener);
}
function serializeNode(n, options) {
    var _a;
    const { doc, blockClass, blockSelector, unblockSelector, maskTextClass, maskTextSelector, unmaskTextSelector, inlineStylesheet, maskInputSelector, unmaskInputSelector, maskAllText, maskInputOptions = {}, maskTextFn, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, } = options;
    let rootId;
    if (doc.__sn) {
        const docId = doc.__sn.id;
        rootId = docId === 1 ? undefined : docId;
    }
    switch (n.nodeType) {
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') {
                return {
                    type: NodeType$1.Document,
                    childNodes: [],
                    compatMode: n.compatMode,
                    rootId,
                };
            }
            else {
                return {
                    type: NodeType$1.Document,
                    childNodes: [],
                    rootId,
                };
            }
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId,
            };
        case n.ELEMENT_NODE:
            const needBlock = _isBlockedElement(n, blockClass, blockSelector, unblockSelector);
            const tagName = getValidTagName(n);
            let attributes = {};
            for (const { name, value } of Array.from(n.attributes)) {
                if (!skipAttribute(tagName, name)) {
                    attributes[name] = transformAttribute(doc, n, tagName, name, value, maskAllText, unmaskTextSelector, maskTextFn);
                }
            }
            if (tagName === 'link' && inlineStylesheet) {
                const stylesheet = Array.from(doc.styleSheets).find((s) => {
                    return s.href === n.href;
                });
                let cssText = null;
                if (stylesheet) {
                    cssText = getCssRulesString(stylesheet);
                }
                if (cssText) {
                    delete attributes.rel;
                    delete attributes.href;
                    attributes._cssText = absoluteToStylesheet(cssText, stylesheet.href);
                }
            }
            if (tagName === 'style' &&
                n.sheet &&
                !(n.innerText ||
                    n.textContent ||
                    '').trim().length) {
                const cssText = getCssRulesString(n.sheet);
                if (cssText) {
                    attributes._cssText = absoluteToStylesheet(cssText, getHref());
                }
            }
            if (tagName === 'input' ||
                tagName === 'textarea' ||
                tagName === 'select' ||
                tagName === 'option') {
                const el = n;
                const type = getInputType(el);
                const value = getInputValue(el, tagName.toUpperCase(), type);
                const checked = n.checked;
                if (type !== 'submit' &&
                    type !== 'button' &&
                    value) {
                    attributes.value = maskInputValue({
                        input: el,
                        type,
                        tagName,
                        value,
                        maskInputSelector,
                        unmaskInputSelector,
                        maskInputOptions,
                        maskInputFn,
                    });
                }
                if (checked) {
                    attributes.checked = checked;
                }
            }
            if (tagName === 'option') {
                if (n.selected && !maskInputOptions['select']) {
                    attributes.selected = true;
                }
                else {
                    delete attributes.selected;
                }
            }
            if (tagName === 'canvas' && recordCanvas) {
                if (n.__context === '2d') {
                    if (!is2DCanvasBlank(n)) {
                        attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    }
                }
                else if (!('__context' in n)) {
                    const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    const blankCanvas = document.createElement('canvas');
                    blankCanvas.width = n.width;
                    blankCanvas.height = n.height;
                    const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    if (canvasDataURL !== blankCanvasDataURL) {
                        attributes.rr_dataURL = canvasDataURL;
                    }
                }
            }
            if (tagName === 'img' && inlineImages) {
                if (!canvasService) {
                    canvasService = doc.createElement('canvas');
                    canvasCtx = canvasService.getContext('2d');
                }
                const image = n;
                const oldValue = image.crossOrigin;
                image.crossOrigin = 'anonymous';
                const recordInlineImage = () => {
                    try {
                        canvasService.width = image.naturalWidth;
                        canvasService.height = image.naturalHeight;
                        canvasCtx.drawImage(image, 0, 0);
                        attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    }
                    catch (err) {
                        console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
                    }
                    oldValue
                        ? (attributes.crossOrigin = oldValue)
                        : delete attributes.crossOrigin;
                };
                if (image.complete && image.naturalWidth !== 0)
                    recordInlineImage();
                else
                    image.onload = recordInlineImage;
            }
            if (tagName === 'audio' || tagName === 'video') {
                attributes.rr_mediaState = n.paused
                    ? 'paused'
                    : 'played';
                attributes.rr_mediaCurrentTime = n.currentTime;
            }
            if (n.scrollLeft) {
                attributes.rr_scrollLeft = n.scrollLeft;
            }
            if (n.scrollTop) {
                attributes.rr_scrollTop = n.scrollTop;
            }
            if (needBlock) {
                const { width, height } = n.getBoundingClientRect();
                attributes = {
                    class: attributes.class,
                    rr_width: `${width}px`,
                    rr_height: `${height}px`,
                };
            }
            if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
                if (!n.contentDocument) {
                    attributes.rr_src = attributes.src;
                }
                delete attributes.src;
            }
            return {
                type: NodeType$1.Element,
                tagName,
                attributes,
                childNodes: [],
                isSVG: isSVGElement(n) || undefined,
                needBlock,
                rootId,
            };
        case n.TEXT_NODE:
            const parentTagName = n.parentNode && n.parentNode.tagName;
            let textContent = n.textContent;
            const isStyle = parentTagName === 'STYLE' ? true : undefined;
            const isScript = parentTagName === 'SCRIPT' ? true : undefined;
            if (isStyle && textContent) {
                try {
                    if (n.nextSibling || n.previousSibling) {
                    }
                    else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) {
                        textContent = stringifyStyleSheet(n.parentNode.sheet);
                    }
                }
                catch (err) {
                    console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
                }
                textContent = absoluteToStylesheet(textContent, getHref());
            }
            if (isScript) {
                textContent = 'SCRIPT_PLACEHOLDER';
            }
            if (parentTagName === 'TEXTAREA' && textContent) {
                textContent = '';
            }
            else if (parentTagName === 'OPTION' && textContent) {
                const option = n.parentNode;
                textContent = maskInputValue({
                    input: option,
                    type: null,
                    tagName: parentTagName,
                    value: textContent,
                    maskInputSelector,
                    unmaskInputSelector,
                    maskInputOptions,
                    maskInputFn,
                });
            }
            else if (!isStyle &&
                !isScript &&
                needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) &&
                textContent) {
                textContent = maskTextFn
                    ? maskTextFn(textContent)
                    : defaultMaskFn(textContent);
            }
            return {
                type: NodeType$1.Text,
                textContent: textContent || '',
                isStyle,
                rootId,
            };
        case n.CDATA_SECTION_NODE:
            return {
                type: NodeType$1.CDATA,
                textContent: '',
                rootId,
            };
        case n.COMMENT_NODE:
            return {
                type: NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId,
            };
        default:
            return false;
    }
}
function lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) {
        return '';
    }
    else {
        return maybeAttr.toLowerCase();
    }
}
function slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === NodeType$1.Comment) {
        return true;
    }
    else if (sn.type === NodeType$1.Element) {
        if (slimDOMOptions.script &&
            (sn.tagName === 'script' ||
                (sn.tagName === 'link' &&
                    (sn.attributes.rel === 'preload' ||
                        sn.attributes.rel === 'modulepreload') &&
                    sn.attributes.as === 'script') ||
                (sn.tagName === 'link' &&
                    sn.attributes.rel === 'prefetch' &&
                    typeof sn.attributes.href === 'string' &&
                    sn.attributes.href.endsWith('.js')))) {
            return true;
        }
        else if (slimDOMOptions.headFavicon &&
            ((sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon') ||
                (sn.tagName === 'meta' &&
                    (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) ||
                        lowerIfExists(sn.attributes.name) === 'application-name' ||
                        lowerIfExists(sn.attributes.rel) === 'icon' ||
                        lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' ||
                        lowerIfExists(sn.attributes.rel) === 'shortcut icon')))) {
            return true;
        }
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords &&
                lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
                return true;
            }
            else if (slimDOMOptions.headMetaSocial &&
                (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) ||
                    lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) ||
                    lowerIfExists(sn.attributes.name) === 'pinterest')) {
                return true;
            }
            else if (slimDOMOptions.headMetaRobots &&
                (lowerIfExists(sn.attributes.name) === 'robots' ||
                    lowerIfExists(sn.attributes.name) === 'googlebot' ||
                    lowerIfExists(sn.attributes.name) === 'bingbot')) {
                return true;
            }
            else if (slimDOMOptions.headMetaHttpEquiv &&
                sn.attributes['http-equiv'] !== undefined) {
                return true;
            }
            else if (slimDOMOptions.headMetaAuthorship &&
                (lowerIfExists(sn.attributes.name) === 'author' ||
                    lowerIfExists(sn.attributes.name) === 'generator' ||
                    lowerIfExists(sn.attributes.name) === 'framework' ||
                    lowerIfExists(sn.attributes.name) === 'publisher' ||
                    lowerIfExists(sn.attributes.name) === 'progid' ||
                    lowerIfExists(sn.attributes.property).match(/^article:/) ||
                    lowerIfExists(sn.attributes.property).match(/^product:/))) {
                return true;
            }
            else if (slimDOMOptions.headMetaVerification &&
                (lowerIfExists(sn.attributes.name) === 'google-site-verification' ||
                    lowerIfExists(sn.attributes.name) === 'yandex-verification' ||
                    lowerIfExists(sn.attributes.name) === 'csrf-token' ||
                    lowerIfExists(sn.attributes.name) === 'p:domain_verify' ||
                    lowerIfExists(sn.attributes.name) === 'verify-v1' ||
                    lowerIfExists(sn.attributes.name) === 'verification' ||
                    lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) {
                return true;
            }
        }
    }
    return false;
}
function serializeNodeWithId(n, options) {
    const { doc, map, blockClass, blockSelector, unblockSelector, maskTextClass, maskTextSelector, unmaskTextSelector, skipChild = false, inlineStylesheet = true, maskInputSelector, unmaskInputSelector, maskAllText, maskInputOptions = {}, maskTextFn, maskInputFn, slimDOMOptions, dataURLOptions = {}, inlineImages = false, recordCanvas = false, onSerialize, onIframeLoad, iframeLoadTimeout = 5000, keepIframeSrcFn = () => false, } = options;
    let { preserveWhiteSpace = true } = options;
    const _serializedNode = serializeNode(n, {
        doc,
        blockClass,
        blockSelector,
        unblockSelector,
        maskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        inlineStylesheet,
        maskInputSelector,
        unmaskInputSelector,
        maskAllText,
        maskInputOptions,
        maskTextFn,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if ('__sn' in n) {
        id = n.__sn.id;
    }
    else if (slimDOMExcluded(_serializedNode, slimDOMOptions) ||
        (!preserveWhiteSpace &&
            _serializedNode.type === NodeType$1.Text &&
            !_serializedNode.isStyle &&
            !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length)) {
        id = IGNORED_NODE;
    }
    else {
        id = genId();
    }
    const serializedNode = Object.assign(_serializedNode, { id });
    n.__sn = serializedNode;
    if (id === IGNORED_NODE) {
        return null;
    }
    map[id] = n;
    if (onSerialize) {
        onSerialize(n);
    }
    let recordChild = !skipChild;
    if (serializedNode.type === NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        if (n.shadowRoot)
            serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === NodeType$1.Document ||
        serializedNode.type === NodeType$1.Element) &&
        recordChild) {
        if (slimDOMOptions.headWhitespace &&
            _serializedNode.type === NodeType$1.Element &&
            _serializedNode.tagName === 'head') {
            preserveWhiteSpace = false;
        }
        const bypassOptions = {
            doc,
            map,
            blockClass,
            blockSelector,
            unblockSelector,
            maskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            skipChild,
            inlineStylesheet,
            maskInputSelector,
            unmaskInputSelector,
            maskAllText,
            maskInputOptions,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            keepIframeSrcFn,
        };
        for (const childN of Array.from(n.childNodes)) {
            const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
        if (isElement(n) && n.shadowRoot) {
            for (const childN of Array.from(n.shadowRoot.childNodes)) {
                const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) {
                    serializedChildNode.isShadow = true;
                    serializedNode.childNodes.push(serializedChildNode);
                }
            }
        }
    }
    if (n.parentNode && isShadowRoot(n.parentNode)) {
        serializedNode.isShadow = true;
    }
    if (serializedNode.type === NodeType$1.Element &&
        serializedNode.tagName === 'iframe') {
        onceIframeLoaded(n, () => {
            const iframeDoc = n.contentDocument;
            if (iframeDoc && onIframeLoad) {
                const serializedIframeNode = serializeNodeWithId(iframeDoc, {
                    doc: iframeDoc,
                    map,
                    blockClass,
                    blockSelector,
                    unblockSelector,
                    maskTextClass,
                    maskTextSelector,
                    unmaskTextSelector,
                    skipChild: false,
                    inlineStylesheet,
                    maskInputSelector,
                    unmaskInputSelector,
                    maskAllText,
                    maskInputOptions,
                    maskTextFn,
                    maskInputFn,
                    slimDOMOptions,
                    dataURLOptions,
                    inlineImages,
                    recordCanvas,
                    preserveWhiteSpace,
                    onSerialize,
                    onIframeLoad,
                    iframeLoadTimeout,
                    keepIframeSrcFn,
                });
                if (serializedIframeNode) {
                    onIframeLoad(n, serializedIframeNode);
                }
            }
        }, iframeLoadTimeout);
    }
    return serializedNode;
}
function snapshot(n, options) {
    const { blockClass = 'rr-block', blockSelector = null, unblockSelector = null, maskTextClass = 'rr-mask', maskTextSelector = null, unmaskTextSelector = null, inlineStylesheet = true, inlineImages = false, recordCanvas = false, maskInputSelector = null, unmaskInputSelector = null, maskAllText = false, maskAllInputs = false, maskTextFn, maskInputFn, slimDOM = false, dataURLOptions, preserveWhiteSpace, onSerialize, onIframeLoad, iframeLoadTimeout, keepIframeSrcFn = () => false, } = options || {};
    const idNodeMap = {};
    const maskInputOptions = maskAllInputs === true
        ? {
            color: true,
            date: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true,
            textarea: true,
            select: true,
        }
        : maskAllInputs === false
            ? {}
            : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all'
        ?
            {
                script: true,
                comment: true,
                headFavicon: true,
                headWhitespace: true,
                headMetaDescKeywords: slimDOM === 'all',
                headMetaSocial: true,
                headMetaRobots: true,
                headMetaHttpEquiv: true,
                headMetaAuthorship: true,
                headMetaVerification: true,
            }
        : slimDOM === false
            ? {}
            : slimDOM;
    return [
        serializeNodeWithId(n, {
            doc: n,
            map: idNodeMap,
            blockClass,
            blockSelector,
            unblockSelector,
            maskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            skipChild: false,
            inlineStylesheet,
            maskInputSelector,
            unmaskInputSelector,
            maskAllText,
            maskInputOptions,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            keepIframeSrcFn,
        }),
        idNodeMap,
    ];
}
function skipAttribute(tagName, attributeName, value) {
    return ((tagName === 'video' || tagName === 'audio') && attributeName === 'autoplay');
}

var EventType;
(function (EventType) {
    EventType[EventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType[EventType["Load"] = 1] = "Load";
    EventType[EventType["FullSnapshot"] = 2] = "FullSnapshot";
    EventType[EventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType[EventType["Meta"] = 4] = "Meta";
    EventType[EventType["Custom"] = 5] = "Custom";
    EventType[EventType["Plugin"] = 6] = "Plugin";
})(EventType || (EventType = {}));
var IncrementalSource;
(function (IncrementalSource) {
    IncrementalSource[IncrementalSource["Mutation"] = 0] = "Mutation";
    IncrementalSource[IncrementalSource["MouseMove"] = 1] = "MouseMove";
    IncrementalSource[IncrementalSource["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource[IncrementalSource["Scroll"] = 3] = "Scroll";
    IncrementalSource[IncrementalSource["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource[IncrementalSource["Input"] = 5] = "Input";
    IncrementalSource[IncrementalSource["TouchMove"] = 6] = "TouchMove";
    IncrementalSource[IncrementalSource["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource[IncrementalSource["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource[IncrementalSource["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource[IncrementalSource["Font"] = 10] = "Font";
    IncrementalSource[IncrementalSource["Log"] = 11] = "Log";
    IncrementalSource[IncrementalSource["Drag"] = 12] = "Drag";
    IncrementalSource[IncrementalSource["StyleDeclaration"] = 13] = "StyleDeclaration";
})(IncrementalSource || (IncrementalSource = {}));
var MouseInteractions;
(function (MouseInteractions) {
    MouseInteractions[MouseInteractions["MouseUp"] = 0] = "MouseUp";
    MouseInteractions[MouseInteractions["MouseDown"] = 1] = "MouseDown";
    MouseInteractions[MouseInteractions["Click"] = 2] = "Click";
    MouseInteractions[MouseInteractions["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions[MouseInteractions["DblClick"] = 4] = "DblClick";
    MouseInteractions[MouseInteractions["Focus"] = 5] = "Focus";
    MouseInteractions[MouseInteractions["Blur"] = 6] = "Blur";
    MouseInteractions[MouseInteractions["TouchStart"] = 7] = "TouchStart";
    MouseInteractions[MouseInteractions["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions[MouseInteractions["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions[MouseInteractions["TouchCancel"] = 10] = "TouchCancel";
})(MouseInteractions || (MouseInteractions = {}));
var CanvasContext;
(function (CanvasContext) {
    CanvasContext[CanvasContext["2D"] = 0] = "2D";
    CanvasContext[CanvasContext["WebGL"] = 1] = "WebGL";
    CanvasContext[CanvasContext["WebGL2"] = 2] = "WebGL2";
})(CanvasContext || (CanvasContext = {}));
var MediaInteractions;
(function (MediaInteractions) {
    MediaInteractions[MediaInteractions["Play"] = 0] = "Play";
    MediaInteractions[MediaInteractions["Pause"] = 1] = "Pause";
    MediaInteractions[MediaInteractions["Seeked"] = 2] = "Seeked";
    MediaInteractions[MediaInteractions["VolumeChange"] = 3] = "VolumeChange";
})(MediaInteractions || (MediaInteractions = {}));
var ReplayerEvents;
(function (ReplayerEvents) {
    ReplayerEvents["Start"] = "start";
    ReplayerEvents["Pause"] = "pause";
    ReplayerEvents["Resume"] = "resume";
    ReplayerEvents["Resize"] = "resize";
    ReplayerEvents["Finish"] = "finish";
    ReplayerEvents["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents["SkipStart"] = "skip-start";
    ReplayerEvents["SkipEnd"] = "skip-end";
    ReplayerEvents["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents["EventCast"] = "event-cast";
    ReplayerEvents["CustomEvent"] = "custom-event";
    ReplayerEvents["Flush"] = "flush";
    ReplayerEvents["StateChange"] = "state-change";
    ReplayerEvents["PlayBack"] = "play-back";
})(ReplayerEvents || (ReplayerEvents = {}));

function on(type, fn, target = document) {
    const options = { capture: true, passive: true };
    target.addEventListener(type, fn, options);
    return () => target.removeEventListener(type, fn, options);
}
function createMirror() {
    return {
        map: {},
        getId(n) {
            if (!n || !n.__sn) {
                return -1;
            }
            return n.__sn.id;
        },
        getNode(id) {
            return this.map[id] || null;
        },
        removeNodeFromMap(n) {
            const id = n.__sn && n.__sn.id;
            delete this.map[id];
            if (n.childNodes) {
                n.childNodes.forEach((child) => this.removeNodeFromMap(child));
            }
        },
        has(id) {
            return this.map.hasOwnProperty(id);
        },
        reset() {
            this.map = {};
        },
    };
}
const DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' +
    '\r\n' +
    'now you can use replayer.getMirror() to access the mirror instance of a replayer,' +
    '\r\n' +
    'or you can use record.mirror to access the mirror instance during recording.';
let _mirror = {
    map: {},
    getId() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
    _mirror = new Proxy(_mirror, {
        get(target, prop, receiver) {
            if (prop === 'map') {
                console.error(DEPARTED_MIRROR_ACCESS_WARNING);
            }
            return Reflect.get(target, prop, receiver);
        },
    });
}
function throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function (arg) {
        let now = Date.now();
        if (!previous && options.leading === false) {
            previous = now;
        }
        let remaining = wait - (now - previous);
        let context = this;
        let args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(() => {
                previous = options.leading === false ? 0 : Date.now();
                timeout = null;
                func.apply(context, args);
            }, remaining);
        }
    };
}
function hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked
        ? d
        : {
            set(value) {
                setTimeout(() => {
                    d.set.call(this, value);
                }, 0);
                if (original && original.set) {
                    original.set.call(this, value);
                }
            },
        });
    return () => hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) {
            return () => { };
        }
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        source[name] = wrapped;
        return () => {
            source[name] = original;
        };
    }
    catch (_a) {
        return () => { };
    }
}
function getWindowHeight() {
    return (window.innerHeight ||
        (document.documentElement && document.documentElement.clientHeight) ||
        (document.body && document.body.clientHeight));
}
function getWindowWidth() {
    return (window.innerWidth ||
        (document.documentElement && document.documentElement.clientWidth) ||
        (document.body && document.body.clientWidth));
}
function isBlocked(node, blockClass, blockSelector, unblockSelector) {
    if (!node) {
        return false;
    }
    if (node.nodeType === node.ELEMENT_NODE) {
        let needBlock = false;
        const needUnblock = unblockSelector && node.matches(unblockSelector);
        if (typeof blockClass === 'string') {
            if (node.closest !== undefined) {
                needBlock =
                    !needUnblock &&
                        node.closest('.' + blockClass) !== null;
            }
            else {
                needBlock =
                    !needUnblock && node.classList.contains(blockClass);
            }
        }
        else {
            !needUnblock &&
                node.classList.forEach((className) => {
                    if (blockClass.test(className)) {
                        needBlock = true;
                    }
                });
        }
        if (!needBlock && blockSelector) {
            needBlock = node.matches(blockSelector);
        }
        return ((!needUnblock && needBlock) ||
            isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector));
    }
    if (node.nodeType === node.TEXT_NODE) {
        return isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    }
    return isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
}
function isIgnored(n) {
    if ('__sn' in n) {
        return n.__sn.id === IGNORED_NODE;
    }
    return false;
}
function isAncestorRemoved(target, mirror) {
    if (isShadowRoot(target)) {
        return false;
    }
    const id = mirror.getId(target);
    if (!mirror.has(id)) {
        return true;
    }
    if (target.parentNode &&
        target.parentNode.nodeType === target.DOCUMENT_NODE) {
        return false;
    }
    if (!target.parentNode) {
        return true;
    }
    return isAncestorRemoved(target.parentNode, mirror);
}
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) {
        win.NodeList.prototype.forEach = Array.prototype
            .forEach;
    }
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) {
        win.DOMTokenList.prototype.forEach = Array.prototype
            .forEach;
    }
    if (!Node.prototype.contains) {
        Node.prototype.contains = function contains(node) {
            if (!(0 in arguments)) {
                throw new TypeError('1 argument is required');
            }
            do {
                if (this === node) {
                    return true;
                }
            } while ((node = node && node.parentNode));
            return false;
        };
    }
}
function isIframeINode(node) {
    if ('__sn' in node) {
        return (node.__sn.type === NodeType$1.Element && node.__sn.tagName === 'iframe');
    }
    return false;
}
function hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}

function isNodeInLinkedList(n) {
    return '__ln' in n;
}
class DoubleLinkedList {
    constructor() {
        this.length = 0;
        this.head = null;
    }
    get(position) {
        if (position >= this.length) {
            throw new Error('Position outside of list range');
        }
        let current = this.head;
        for (let index = 0; index < position; index++) {
            current = (current === null || current === void 0 ? void 0 : current.next) || null;
        }
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null,
        };
        n.__ln = node;
        if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) {
                current.previous = node;
            }
        }
        else if (n.nextSibling &&
            isNodeInLinkedList(n.nextSibling) &&
            n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) {
                current.next = node;
            }
        }
        else {
            if (this.head) {
                this.head.previous = node;
            }
            node.next = this.head;
            this.head = node;
        }
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) {
            return;
        }
        if (!current.previous) {
            this.head = current.next;
            if (this.head) {
                this.head.previous = null;
            }
        }
        else {
            current.previous.next = current.next;
            if (current.next) {
                current.next.previous = current.previous;
            }
        }
        if (n.__ln) {
            delete n.__ln;
        }
        this.length--;
    }
}
const moveKey = (id, parentId) => `${id}@${parentId}`;
function isINode(n) {
    return '__sn' in n;
}
class MutationBuffer {
    constructor() {
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations) => {
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = () => {
            if (this.frozen || this.locked) {
                return;
            }
            const adds = [];
            const addList = new DoubleLinkedList();
            const getNextId = (n) => {
                let ns = n;
                let nextId = IGNORED_NODE;
                while (nextId === IGNORED_NODE) {
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n) => {
                var _a, _b, _c, _d, _e;
                const shadowHost = n.getRootNode
                    ? (_a = n.getRootNode()) === null || _a === void 0 ? void 0 : _a.host
                    : null;
                let rootShadowHost = shadowHost;
                while ((_c = (_b = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _b === void 0 ? void 0 : _b.call(rootShadowHost)) === null || _c === void 0 ? void 0 : _c.host)
                    rootShadowHost =
                        ((_e = (_d = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _d === void 0 ? void 0 : _d.call(rootShadowHost)) === null || _e === void 0 ? void 0 : _e.host) ||
                            null;
                const notInDoc = !this.doc.contains(n) &&
                    (!rootShadowHost || !this.doc.contains(rootShadowHost));
                if (!n.parentNode || notInDoc) {
                    return;
                }
                const parentId = isShadowRoot(n.parentNode)
                    ? this.mirror.getId(shadowHost)
                    : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) {
                    return addList.addNode(n);
                }
                let sn = serializeNodeWithId(n, {
                    doc: this.doc,
                    map: this.mirror.map,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    maskInputSelector: this.maskInputSelector,
                    unmaskInputSelector: this.unmaskInputSelector,
                    skipChild: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskAllText: this.maskAllText,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN) => {
                        if (isIframeINode(currentN)) {
                            this.iframeManager.addIframe(currentN);
                        }
                        if (hasShadowRoot(n)) {
                            this.shadowDomManager.addShadowRoot(n.shadowRoot, document);
                        }
                    },
                    onIframeLoad: (iframe, childSn) => {
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                });
                if (sn) {
                    adds.push({
                        parentId,
                        nextId,
                        node: sn,
                    });
                }
            };
            while (this.mapRemoves.length) {
                this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            }
            for (const n of this.movedSet) {
                if (isParentRemoved(this.removes, n, this.mirror) &&
                    !this.movedSet.has(n.parentNode)) {
                    continue;
                }
                pushAdd(n);
            }
            for (const n of this.addedSet) {
                if (!isAncestorInSet(this.droppedSet, n) &&
                    !isParentRemoved(this.removes, n, this.mirror)) {
                    pushAdd(n);
                }
                else if (isAncestorInSet(this.movedSet, n)) {
                    pushAdd(n);
                }
                else {
                    this.droppedSet.add(n);
                }
            }
            let candidate = null;
            while (addList.length) {
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) {
                        node = candidate;
                    }
                }
                if (!node) {
                    for (let index = addList.length - 1; index >= 0; index--) {
                        const _node = addList.get(index);
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (parentId !== -1 && nextId !== -1) {
                                node = _node;
                                break;
                            }
                        }
                    }
                }
                if (!node) {
                    while (addList.head) {
                        addList.removeNode(addList.head.value);
                    }
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts
                    .map((text) => ({
                    id: this.mirror.getId(text.node),
                    value: text.value,
                }))
                    .filter((text) => this.mirror.has(text.id)),
                attributes: this.attributes
                    .map((attribute) => ({
                    id: this.mirror.getId(attribute.node),
                    attributes: attribute.attributes,
                }))
                    .filter((attribute) => this.mirror.has(attribute.id)),
                removes: this.removes,
                adds,
            };
            if (!payload.texts.length &&
                !payload.attributes.length &&
                !payload.removes.length &&
                !payload.adds.length) {
                return;
            }
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m) => {
            if (isIgnored(m.target)) {
                return;
            }
            switch (m.type) {
                case 'characterData': {
                    const value = m.target.textContent;
                    if (!isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) && value !== m.oldValue) {
                        this.texts.push({
                            value: needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextSelector, this.maskAllText) && value
                                ? this.maskTextFn
                                    ? this.maskTextFn(value)
                                    : value.replace(/[\S]/g, '*')
                                : value,
                            node: m.target,
                        });
                    }
                    break;
                }
                case 'attributes': {
                    const target = m.target;
                    let value = target.getAttribute(m.attributeName);
                    if (m.attributeName === 'value') {
                        value = maskInputValue({
                            input: target,
                            maskInputSelector: this.maskInputSelector,
                            unmaskInputSelector: this.unmaskInputSelector,
                            maskInputOptions: this.maskInputOptions,
                            tagName: target.tagName,
                            type: target.getAttribute('type'),
                            value,
                            maskInputFn: this.maskInputFn,
                        });
                    }
                    if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || value === m.oldValue) {
                        return;
                    }
                    let item = this.attributes.find((a) => a.node === m.target);
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                        };
                        this.attributes.push(item);
                    }
                    if (m.attributeName === 'type' &&
                        target.tagName === 'INPUT' &&
                        (m.oldValue || '').toLowerCase() === 'password') {
                        target.setAttribute('data-rr-is-password', 'true');
                    }
                    if (m.attributeName === 'style') {
                        const old = this.doc.createElement('span');
                        if (m.oldValue) {
                            old.setAttribute('style', m.oldValue);
                        }
                        if (item.attributes.style === undefined ||
                            item.attributes.style === null) {
                            item.attributes.style = {};
                        }
                        try {
                            const styleObj = item.attributes.style;
                            for (const pname of Array.from(target.style)) {
                                const newValue = target.style.getPropertyValue(pname);
                                const newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) ||
                                    newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === '') {
                                        styleObj[pname] = newValue;
                                    }
                                    else {
                                        styleObj[pname] = [newValue, newPriority];
                                    }
                                }
                            }
                            for (const pname of Array.from(old.style)) {
                                if (target.style.getPropertyValue(pname) === '') {
                                    styleObj[pname] = false;
                                }
                            }
                        }
                        catch (error) {
                            console.warn('[rrweb] Error when parsing update to style attribute:', error);
                        }
                    }
                    else {
                        const element = m.target;
                        item.attributes[m.attributeName] = transformAttribute(this.doc, element, element.tagName, m.attributeName, value, this.maskAllText, this.unmaskTextSelector, this.maskTextFn);
                    }
                    break;
                }
                case 'childList': {
                    m.addedNodes.forEach((n) => this.genAdds(n, m.target));
                    m.removedNodes.forEach((n) => {
                        const nodeId = this.mirror.getId(n);
                        const parentId = isShadowRoot(m.target)
                            ? this.mirror.getId(m.target.host)
                            : this.mirror.getId(m.target);
                        if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || isIgnored(n)) {
                            return;
                        }
                        if (this.addedSet.has(n)) {
                            deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        }
                        else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if (isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) &&
                            this.movedMap[moveKey(nodeId, parentId)]) {
                            deepDelete(this.movedSet, n);
                        }
                        else {
                            this.removes.push({
                                parentId,
                                id: nodeId,
                                isShadow: isShadowRoot(m.target) ? true : undefined,
                            });
                        }
                        this.mapRemoves.push(n);
                    });
                    break;
                }
            }
        };
        this.genAdds = (n, target) => {
            if (target && isBlocked(target, this.blockClass, this.blockSelector, this.unblockSelector)) {
                return;
            }
            if (isINode(n)) {
                if (isIgnored(n)) {
                    return;
                }
                this.movedSet.add(n);
                let targetId = null;
                if (target && isINode(target)) {
                    targetId = target.__sn.id;
                }
                if (targetId) {
                    this.movedMap[moveKey(n.__sn.id, targetId)] = true;
                }
            }
            else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector))
                n.childNodes.forEach((childN) => this.genAdds(childN));
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'maskInputSelector',
            'unmaskInputSelector',
            'inlineStylesheet',
            'maskAllText',
            'maskInputOptions',
            'maskTextFn',
            'maskInputFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'doc',
            'mirror',
            'iframeManager',
            'shadowDomManager',
            'canvasManager',
        ].forEach((key) => {
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN) => deepDelete(addsSet, childN));
}
function isParentRemoved(removes, n, mirror) {
    const { parentNode } = n;
    if (!parentNode) {
        return false;
    }
    const parentId = mirror.getId(parentNode);
    if (removes.some((r) => r.id === parentId)) {
        return true;
    }
    return isParentRemoved(removes, parentNode, mirror);
}
function isAncestorInSet(set, n) {
    const { parentNode } = n;
    if (!parentNode) {
        return false;
    }
    if (set.has(parentNode)) {
        return true;
    }
    return isAncestorInSet(set, parentNode);
}

const callbackWrapper = (cb) => {
    const rrwebWrapped = (...rest) => {
        try {
            return cb(...rest);
        }
        catch (error) {
            try {
                error.__rrweb__ = true;
            }
            catch (_a) {
            }
            throw error;
        }
    };
    return rrwebWrapped;
};

const mutationBuffers = [];
function getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) {
                return path[0];
            }
        }
        else if ('path' in event && event.path.length) {
            return event.path[0];
        }
    }
    catch (_a) { }
    return event && event.target;
}
function initMutationObserver(options, rootEl) {
    var _a, _b;
    const mutationBuffer = new MutationBuffer();
    mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver ||
        window.__rrMutationObserver;
    const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
    if (angularZoneSymbol &&
        window[angularZoneSymbol]) {
        mutationObserverCtor = window[angularZoneSymbol];
    }
    const observer = new mutationObserverCtor(callbackWrapper((mutations) => {
        if (options.onMutation && options.onMutation(mutations) === false) {
            return;
        }
        mutationBuffer.processMutations(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return observer;
}
function initMoveObserver({ mousemoveCb, sampling, doc, mirror, }) {
    if (sampling.mousemove === false) {
        return () => { };
    }
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number'
        ? sampling.mousemoveCallback
        : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = throttle$1((source) => {
        const totalOffset = Date.now() - timeBaseline;
        callbackWrapper(mousemoveCb)(positions.map((p) => {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }, callbackThreshold);
    const updatePosition = throttle$1((evt) => {
        const target = getEventTarget(evt);
        const { clientX, clientY } = isTouchEvent(evt)
            ? evt.changedTouches[0]
            : evt;
        if (!timeBaseline) {
            timeBaseline = Date.now();
        }
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: Date.now() - timeBaseline,
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent
            ? IncrementalSource.Drag
            : evt instanceof MouseEvent
                ? IncrementalSource.MouseMove
                : IncrementalSource.TouchMove);
    }, threshold, {
        trailing: false,
    });
    const handlers = [
        on('mousemove', callbackWrapper(updatePosition), doc),
        on('touchmove', callbackWrapper(updatePosition), doc),
        on('drag', callbackWrapper(updatePosition), doc),
    ];
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initMouseInteractionObserver({ mouseInteractionCb, doc, mirror, blockClass, blockSelector, unblockSelector, sampling, }) {
    if (sampling.mouseInteraction === false) {
        return () => { };
    }
    const disableMap = sampling.mouseInteraction === true ||
        sampling.mouseInteraction === undefined
        ? {}
        : sampling.mouseInteraction;
    const handlers = [];
    const getHandler = (eventKey) => {
        return (event) => {
            const target = getEventTarget(event);
            if (isBlocked(target, blockClass, blockSelector, unblockSelector)) {
                return;
            }
            const e = isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) {
                return;
            }
            const id = mirror.getId(target);
            const { clientX, clientY } = e;
            callbackWrapper(mouseInteractionCb)({
                type: MouseInteractions[eventKey],
                id,
                x: clientX,
                y: clientY,
            });
        };
    };
    Object.keys(MouseInteractions)
        .filter((key) => Number.isNaN(Number(key)) &&
        !key.endsWith('_Departed') &&
        disableMap[key] !== false)
        .forEach((eventKey) => {
        const eventName = eventKey.toLowerCase();
        const handler = callbackWrapper(getHandler(eventKey));
        handlers.push(on(eventName, handler, doc));
    });
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initScrollObserver({ scrollCb, doc, mirror, blockClass, blockSelector, unblockSelector, sampling, }) {
    const updatePosition = throttle$1((evt) => {
        const target = getEventTarget(evt);
        if (!target ||
            isBlocked(target, blockClass, blockSelector, unblockSelector)) {
            return;
        }
        const id = mirror.getId(target);
        if (target === doc) {
            const scrollEl = (doc.scrollingElement || doc.documentElement);
            callbackWrapper(scrollCb)({
                id,
                x: scrollEl.scrollLeft,
                y: scrollEl.scrollTop,
            });
        }
        else {
            callbackWrapper(scrollCb)({
                id,
                x: target.scrollLeft,
                y: target.scrollTop,
            });
        }
    }, sampling.scroll || 100);
    return on('scroll', callbackWrapper(updatePosition), doc);
}
function initViewportResizeObserver({ viewportResizeCb, }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = throttle$1(() => {
        const height = getWindowHeight();
        const width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
            callbackWrapper(viewportResizeCb)({
                width: Number(width),
                height: Number(height),
            });
            lastH = height;
            lastW = width;
        }
    }, 200);
    return on('resize', callbackWrapper(updateDimension), window);
}
function wrapEventWithUserTriggeredFlag(v, enable) {
    const value = Object.assign({}, v);
    if (!enable)
        delete value.userTriggered;
    return value;
}
const INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
const lastInputValueMap = new WeakMap();
function initInputObserver({ inputCb, doc, mirror, blockClass, blockSelector, unblockSelector, ignoreClass, ignoreSelector, maskInputSelector, unmaskInputSelector, maskInputOptions, maskInputFn, sampling, userTriggeredOnInput, }) {
    function eventHandler(event) {
        let target = getEventTarget(event);
        const tagName = target && target.tagName;
        const userTriggered = event.isTrusted;
        if (tagName === 'OPTION')
            target = target.parentElement;
        if (!target ||
            !tagName ||
            INPUT_TAGS.indexOf(tagName) < 0 ||
            isBlocked(target, blockClass, blockSelector, unblockSelector)) {
            return;
        }
        const el = target;
        const type = getInputType(el);
        if (el.classList.contains(ignoreClass) ||
            (ignoreSelector && el.matches(ignoreSelector))) {
            return;
        }
        let text = getInputValue(el, tagName, type);
        let isChecked = false;
        if (type === 'radio' || type === 'checkbox') {
            isChecked = target.checked;
        }
        if (hasInputMaskOptions({
            maskInputOptions,
            maskInputSelector,
            tagName,
            type,
        })) {
            text = maskInputValue({
                input: el,
                maskInputOptions,
                maskInputSelector,
                unmaskInputSelector,
                tagName,
                type,
                value: text,
                maskInputFn,
            });
        }
        cbWithDedup(target, callbackWrapper(wrapEventWithUserTriggeredFlag)({ text, isChecked, userTriggered }, userTriggeredOnInput));
        const name = target.name;
        if (type === 'radio' && name && isChecked) {
            doc
                .querySelectorAll(`input[type="radio"][name="${name}"]`)
                .forEach((el) => {
                if (el !== target) {
                    const text = maskInputValue({
                        input: el,
                        maskInputOptions,
                        maskInputSelector,
                        unmaskInputSelector,
                        tagName,
                        type,
                        value: getInputValue(el, tagName, type),
                        maskInputFn,
                    });
                    cbWithDedup(el, callbackWrapper(wrapEventWithUserTriggeredFlag)({
                        text,
                        isChecked: !isChecked,
                        userTriggered: false,
                    }, userTriggeredOnInput));
                }
            });
        }
    }
    function cbWithDedup(target, v) {
        const lastInputValue = lastInputValueMap.get(target);
        if (!lastInputValue ||
            lastInputValue.text !== v.text ||
            lastInputValue.isChecked !== v.isChecked) {
            lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            inputCb(Object.assign(Object.assign({}, v), { id }));
        }
    }
    const events = sampling.input === 'last' ? ['change'] : ['input', 'change'];
    const handlers = events.map((eventName) => on(eventName, callbackWrapper(eventHandler), doc));
    const propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [HTMLInputElement.prototype, 'value'],
        [HTMLInputElement.prototype, 'checked'],
        [HTMLSelectElement.prototype, 'value'],
        [HTMLTextAreaElement.prototype, 'value'],
        [HTMLSelectElement.prototype, 'selectedIndex'],
        [HTMLOptionElement.prototype, 'selected'],
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        handlers.push(...hookProperties.map((p) => hookSetter(p[0], p[1], {
            set() {
                callbackWrapper(eventHandler)({ target: this });
            },
        })));
    }
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ((hasNestedCSSRule('CSSGroupingRule') &&
            childRule.parentRule instanceof CSSGroupingRule) ||
            (hasNestedCSSRule('CSSMediaRule') &&
                childRule.parentRule instanceof CSSMediaRule) ||
            (hasNestedCSSRule('CSSSupportsRule') &&
                childRule.parentRule instanceof CSSSupportsRule) ||
            (hasNestedCSSRule('CSSConditionRule') &&
                childRule.parentRule instanceof CSSConditionRule)) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        else {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function initStyleSheetObserver({ styleSheetRuleCb, mirror }, { win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
        return () => { };
    }
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            const [rule, index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) {
                styleSheetRuleCb({
                    id,
                    adds: [{ rule, index }],
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            const [index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) {
                styleSheetRuleCb({
                    id,
                    removes: [{ index }],
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    const supportedNestedCSSRuleTypes = {};
    if (canMonkeyPatchNestedCSSRule('CSSGroupingRule')) {
        supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    }
    else {
        if (canMonkeyPatchNestedCSSRule('CSSMediaRule')) {
            supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        }
        if (canMonkeyPatchNestedCSSRule('CSSConditionRule')) {
            supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        }
        if (canMonkeyPatchNestedCSSRule('CSSSupportsRule')) {
            supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
        }
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule,
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: callbackWrapper((target, thisArg, argumentsList) => {
                const [rule, index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) {
                    styleSheetRuleCb({
                        id,
                        adds: [
                            {
                                rule,
                                index: [
                                    ...getNestedCSSRulePositions(thisArg),
                                    index || 0,
                                ],
                            },
                        ],
                    });
                }
                return target.apply(thisArg, argumentsList);
            }),
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: callbackWrapper((target, thisArg, argumentsList) => {
                const [index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) {
                    styleSheetRuleCb({
                        id,
                        removes: [
                            { index: [...getNestedCSSRulePositions(thisArg), index] },
                        ],
                    });
                }
                return target.apply(thisArg, argumentsList);
            }),
        });
    });
    return callbackWrapper(() => {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function initStyleDeclarationObserver({ styleDeclarationCb, mirror }, { win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            var _a, _b;
            const [property, value, priority] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) {
                styleDeclarationCb({
                    id,
                    set: {
                        property,
                        value,
                        priority,
                    },
                    index: getNestedCSSRulePositions(thisArg.parentRule),
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList) => {
            var _a, _b;
            const [property] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) {
                styleDeclarationCb({
                    id,
                    remove: {
                        property,
                    },
                    index: getNestedCSSRulePositions(thisArg.parentRule),
                });
            }
            return target.apply(thisArg, argumentsList);
        }),
    });
    return callbackWrapper(() => {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function initMediaInteractionObserver({ mediaInteractionCb, blockClass, blockSelector, unblockSelector, mirror, sampling, }) {
    const handler = (type) => throttle$1(callbackWrapper((event) => {
        const target = getEventTarget(event);
        if (!target ||
            isBlocked(target, blockClass, blockSelector, unblockSelector)) {
            return;
        }
        const { currentTime, volume, muted } = target;
        mediaInteractionCb({
            type,
            id: mirror.getId(target),
            currentTime,
            volume,
            muted,
        });
    }), sampling.media || 500);
    const handlers = [
        on('play', handler(0)),
        on('pause', handler(1)),
        on('seeked', handler(2)),
        on('volumechange', handler(3)),
    ];
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function initFontObserver({ fontCb, doc }) {
    const win = doc.defaultView;
    if (!win) {
        return () => { };
    }
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family,
            buffer: typeof source !== 'string',
            descriptors,
            fontSource: typeof source === 'string'
                ? source
                :
                    JSON.stringify(Array.from(new Uint8Array(source))),
        });
        return fontFace;
    };
    const restoreHandler = patch(doc.fonts, 'add', function (original) {
        return function (fontFace) {
            setTimeout(() => {
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }, 0);
            return original.apply(this, [fontFace]);
        };
    });
    handlers.push(() => {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return callbackWrapper(() => {
        handlers.forEach((h) => h());
    });
}
function mergeHooks(o, hooks) {
    const { mutationCb, mousemoveCb, mouseInteractionCb, scrollCb, viewportResizeCb, inputCb, mediaInteractionCb, styleSheetRuleCb, styleDeclarationCb, canvasMutationCb, fontCb, } = o;
    o.mutationCb = (...p) => {
        if (hooks.mutation) {
            hooks.mutation(...p);
        }
        mutationCb(...p);
    };
    o.mousemoveCb = (...p) => {
        if (hooks.mousemove) {
            hooks.mousemove(...p);
        }
        mousemoveCb(...p);
    };
    o.mouseInteractionCb = (...p) => {
        if (hooks.mouseInteraction) {
            hooks.mouseInteraction(...p);
        }
        mouseInteractionCb(...p);
    };
    o.scrollCb = (...p) => {
        if (hooks.scroll) {
            hooks.scroll(...p);
        }
        scrollCb(...p);
    };
    o.viewportResizeCb = (...p) => {
        if (hooks.viewportResize) {
            hooks.viewportResize(...p);
        }
        viewportResizeCb(...p);
    };
    o.inputCb = (...p) => {
        if (hooks.input) {
            hooks.input(...p);
        }
        inputCb(...p);
    };
    o.mediaInteractionCb = (...p) => {
        if (hooks.mediaInteaction) {
            hooks.mediaInteaction(...p);
        }
        mediaInteractionCb(...p);
    };
    o.styleSheetRuleCb = (...p) => {
        if (hooks.styleSheetRule) {
            hooks.styleSheetRule(...p);
        }
        styleSheetRuleCb(...p);
    };
    o.styleDeclarationCb = (...p) => {
        if (hooks.styleDeclaration) {
            hooks.styleDeclaration(...p);
        }
        styleDeclarationCb(...p);
    };
    o.canvasMutationCb = (...p) => {
        if (hooks.canvasMutation) {
            hooks.canvasMutation(...p);
        }
        canvasMutationCb(...p);
    };
    o.fontCb = (...p) => {
        if (hooks.font) {
            hooks.font(...p);
        }
        fontCb(...p);
    };
}
function initObservers(o, hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) {
        return () => { };
    }
    mergeHooks(o, hooks);
    const mutationObserver = initMutationObserver(o, o.doc);
    const mousemoveHandler = initMoveObserver(o);
    const mouseInteractionHandler = initMouseInteractionObserver(o);
    const scrollHandler = initScrollObserver(o);
    const viewportResizeHandler = initViewportResizeObserver(o);
    const inputHandler = initInputObserver(o);
    const mediaInteractionHandler = initMediaInteractionObserver(o);
    const styleSheetObserver = initStyleSheetObserver(o, { win: currentWindow });
    const styleDeclarationObserver = initStyleDeclarationObserver(o, {
        win: currentWindow,
    });
    const fontObserver = o.collectFonts ? initFontObserver(o) : () => { };
    const pluginHandlers = [];
    for (const plugin of o.plugins) {
        pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    }
    return callbackWrapper(() => {
        mutationBuffers.forEach((b) => b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        try {
            styleSheetObserver();
            styleDeclarationObserver();
        }
        catch (e) {
        }
        fontObserver();
        pluginHandlers.forEach((h) => h());
    });
}
function hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' &&
        window[prop].prototype &&
        'insertRule' in window[prop].prototype &&
        'deleteRule' in window[prop].prototype);
}

class IframeManager {
    constructor(options) {
        this.iframes = new WeakMap();
        this.mutationCb = options.mutationCb;
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: iframeEl.__sn.id,
                    nextId: null,
                    node: childSn,
                },
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true,
        });
        (_a = this.loadListener) === null || _a === void 0 ? void 0 : _a.call(this, iframeEl);
    }
}

class ShadowDomManager {
    constructor(options) {
        this.restorePatches = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        const manager = this;
        this.restorePatches.push(patch(HTMLElement.prototype, 'attachShadow', function (original) {
            return function () {
                const shadowRoot = original.apply(this, arguments);
                if (this.shadowRoot)
                    manager.addShadowRoot(this.shadowRoot, this.ownerDocument);
                return shadowRoot;
            };
        }));
    }
    addShadowRoot(shadowRoot, doc) {
        initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), { doc, mutationCb: this.mutationCb, mirror: this.mirror, shadowDomManager: this }), shadowRoot);
        initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), { scrollCb: this.scrollCb, doc: shadowRoot, mirror: this.mirror }));
    }
    observeAttachShadow(iframeElement) {
        if (iframeElement.contentWindow) {
            const manager = this;
            this.restorePatches.push(patch(iframeElement.contentWindow.HTMLElement.prototype, 'attachShadow', function (original) {
                return function () {
                    const shadowRoot = original.apply(this, arguments);
                    if (this.shadowRoot)
                        manager.addShadowRoot(this.shadowRoot, iframeElement.contentDocument);
                    return shadowRoot;
                };
            }));
        }
    }
    reset() {
        this.restorePatches.forEach((restorePatch) => restorePatch());
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function initCanvas2DMutationObserver(cb, win, blockClass, unblockSelector, blockSelector, mirror) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D) {
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') {
                continue;
            }
            const restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function (original) {
                return function (...args) {
                    if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) {
                        setTimeout(() => {
                            const recordArgs = [...args];
                            if (prop === 'drawImage') {
                                if (recordArgs[0] &&
                                    recordArgs[0] instanceof HTMLCanvasElement) {
                                    const canvas = recordArgs[0];
                                    const ctx = canvas.getContext('2d');
                                    let imgd = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                                    let pix = imgd === null || imgd === void 0 ? void 0 : imgd.data;
                                    recordArgs[0] = JSON.stringify(pix);
                                }
                            }
                            cb(this.canvas, {
                                type: CanvasContext['2D'],
                                property: prop,
                                args: recordArgs,
                            });
                        }, 0);
                    }
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        }
        catch (_a) {
            const hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set(v) {
                    cb(this.canvas, {
                        type: CanvasContext['2D'],
                        property: prop,
                        args: [v],
                        setter: true,
                    });
                },
            });
            handlers.push(hookHandler);
        }
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    try {
        const restoreHandler = patch(win.HTMLCanvasElement.prototype, 'getContext', function (original) {
            return function (contextType, ...args) {
                if (!isBlocked(this, blockClass, blockSelector, unblockSelector)) {
                    if (!('__context' in this))
                        this.__context = contextType;
                }
                return original.apply(this, [contextType, ...args]);
            };
        });
        handlers.push(restoreHandler);
    }
    catch (_a) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
var encode = function (arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for (i = 0; i < len; i += 3) {
        base64 += chars[bytes[i] >> 2];
        base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + '=';
    }
    else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + '==';
    }
    return base64;
};

const webGLVarMap = new Map();
function variableListFor(ctx, ctor) {
    let contextMap = webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) {
        contextMap.set(ctor, []);
    }
    return contextMap.get(ctor);
}
const saveWebGLVar = (value, win, ctx) => {
    if (!value ||
        !(isInstanceOfWebGLObject(value, win) || typeof value === 'object'))
        return;
    const name = value.constructor.name;
    const list = variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function serializeArg(value, win, ctx) {
    if (value instanceof Array) {
        return value.map((arg) => serializeArg(arg, win, ctx));
    }
    else if (value === null) {
        return value;
    }
    else if (value instanceof Float32Array ||
        value instanceof Float64Array ||
        value instanceof Int32Array ||
        value instanceof Uint32Array ||
        value instanceof Uint8Array ||
        value instanceof Uint16Array ||
        value instanceof Int16Array ||
        value instanceof Int8Array ||
        value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [Object.values(value)],
        };
    }
    else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = encode(value);
        return {
            rr_type: name,
            base64,
        };
    }
    else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength,
            ],
        };
    }
    else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src } = value;
        return {
            rr_type: name,
            src,
        };
    }
    else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [serializeArg(value.data, win, ctx), value.width, value.height],
        };
    }
    else if (isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        const name = value.constructor.name;
        const index = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index,
        };
    }
    return value;
}
const serializeArgs = (args, win, ctx) => {
    return [...args].map((arg) => serializeArg(arg, win, ctx));
};
const isInstanceOfWebGLObject = (value, win) => {
    const webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES',
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name) => typeof win[name] === 'function');
    return Boolean(supportedWebGLConstructorNames.find((name) => value instanceof win[name]));
};

function patchGLPrototype(prototype, type, cb, blockClass, unblockSelector, blockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props) {
        try {
            if (typeof prototype[prop] !== 'function') {
                continue;
            }
            const restoreHandler = patch(prototype, prop, function (original) {
                return function (...args) {
                    const result = original.apply(this, args);
                    saveWebGLVar(result, win, prototype);
                    if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) {
                        const id = mirror.getId(this.canvas);
                        const recordArgs = serializeArgs([...args], win, prototype);
                        const mutation = {
                            type,
                            property: prop,
                            args: recordArgs,
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        }
        catch (_a) {
            const hookHandler = hookSetter(prototype, prop, {
                set(v) {
                    cb(this.canvas, {
                        type,
                        property: prop,
                        args: [v],
                        setter: true,
                    });
                },
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== 'undefined') {
        handlers.push(...patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    }
    return () => {
        handlers.forEach((h) => h());
    };
}

class CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options) {
        this.pendingCanvasMutations = new Map();
        this.rafStamps = { latestId: 0, invokeId: null };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function (target, mutation) {
            const newFrame = this.rafStamps.invokeId &&
                this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId)
                this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) {
                this.pendingCanvasMutations.set(target, []);
            }
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (options.recordCanvas === true)
            this.initCanvasMutationObserver(options.win, options.blockClass, options.blockSelector, options.unblockSelector);
    }
    initCanvasMutationObserver(win, blockClass, unblockSelector, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector);
        const canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        const canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = () => {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(() => this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp) => {
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas) => {
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(() => this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) {
            return;
        }
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1)
            return;
        const values = valuesWithType.map((value) => {
            const rest = __rest(value, ["type"]);
            return rest;
        });
        const { type } = valuesWithType[0];
        this.mutationCb({ id, type, commands: values });
        this.pendingCanvasMutations.delete(canvas);
    }
}

function wrapEvent(e) {
    return Object.assign(Object.assign({}, e), { timestamp: Date.now() });
}
let wrappedEmit;
let takeFullSnapshot;
const mirror = createMirror();
function record(options = {}) {
    const { emit, checkoutEveryNms, checkoutEveryNth, blockClass = 'rr-block', blockSelector = null, unblockSelector = null, ignoreClass = 'rr-ignore', ignoreSelector = null, maskTextClass = 'rr-mask', maskTextSelector = null, maskInputSelector = null, unmaskTextSelector = null, unmaskInputSelector = null, inlineStylesheet = true, maskAllText = false, maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn, maskTextFn, hooks, packFn, sampling = {}, mousemoveWait, recordCanvas = false, userTriggeredOnInput = false, collectFonts = false, inlineImages = false, plugins, keepIframeSrcFn = () => false, onMutation, } = options;
    if (!emit) {
        throw new Error('emit function is required');
    }
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) {
        sampling.mousemove = mousemoveWait;
    }
    const maskInputOptions = maskAllInputs === true
        ? {
            color: true,
            date: true,
            'datetime-local': true,
            email: true,
            month: true,
            number: true,
            range: true,
            search: true,
            tel: true,
            text: true,
            time: true,
            url: true,
            week: true,
            textarea: true,
            select: true,
            radio: true,
            checkbox: true,
        }
        : _maskInputOptions !== undefined
            ? _maskInputOptions
            : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all'
        ? {
            script: true,
            comment: true,
            headFavicon: true,
            headWhitespace: true,
            headMetaSocial: true,
            headMetaRobots: true,
            headMetaHttpEquiv: true,
            headMetaVerification: true,
            headMetaAuthorship: _slimDOMOptions === 'all',
            headMetaDescKeywords: _slimDOMOptions === 'all',
        }
        : _slimDOMOptions
            ? _slimDOMOptions
            : {};
    polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e) => {
        for (const plugin of plugins || []) {
            if (plugin.eventProcessor) {
                e = plugin.eventProcessor(e);
            }
        }
        if (packFn) {
            e = packFn(e);
        }
        return e;
    };
    wrappedEmit = (e, isCheckout) => {
        var _a;
        if (((_a = mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) &&
            e.type !== EventType.FullSnapshot &&
            !(e.type === EventType.IncrementalSnapshot &&
                e.data.source === IncrementalSource.Mutation)) {
            mutationBuffers.forEach((buf) => buf.unfreeze());
        }
        emit(eventProcessor(e), isCheckout);
        if (e.type === EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        }
        else if (e.type === EventType.IncrementalSnapshot) {
            if (e.data.source === IncrementalSource.Mutation &&
                e.data.isAttachIframe) {
                return;
            }
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms &&
                e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) {
                takeFullSnapshot(true);
            }
        }
    };
    const wrappedMutationEmit = (m) => {
        wrappedEmit(wrapEvent({
            type: EventType.IncrementalSnapshot,
            data: Object.assign({ source: IncrementalSource.Mutation }, m),
        }));
    };
    const wrappedScrollEmit = (p) => wrappedEmit(wrapEvent({
        type: EventType.IncrementalSnapshot,
        data: Object.assign({ source: IncrementalSource.Scroll }, p),
    }));
    const wrappedCanvasMutationEmit = (p) => wrappedEmit(wrapEvent({
        type: EventType.IncrementalSnapshot,
        data: Object.assign({ source: IncrementalSource.CanvasMutation }, p),
    }));
    const iframeManager = new IframeManager({
        mutationCb: wrappedMutationEmit,
    });
    const canvasManager = new CanvasManager({
        recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass,
        blockSelector,
        unblockSelector,
        mirror,
    });
    const shadowDomManager = new ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation,
            blockClass,
            blockSelector,
            unblockSelector,
            maskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            maskInputSelector,
            unmaskInputSelector,
            inlineStylesheet,
            maskAllText,
            maskInputOptions,
            maskTextFn,
            maskInputFn,
            recordCanvas,
            inlineImages,
            sampling,
            slimDOMOptions,
            iframeManager,
            canvasManager,
        },
        mirror,
    });
    takeFullSnapshot = (isCheckout = false) => {
        var _a, _b, _c, _d;
        wrappedEmit(wrapEvent({
            type: EventType.Meta,
            data: {
                href: window.location.href,
                width: getWindowWidth(),
                height: getWindowHeight(),
            },
        }), isCheckout);
        mutationBuffers.forEach((buf) => buf.lock());
        const [node, idNodeMap] = snapshot(document, {
            blockClass,
            blockSelector,
            unblockSelector,
            maskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            maskInputSelector,
            unmaskInputSelector,
            inlineStylesheet,
            maskAllText,
            maskAllInputs: maskInputOptions,
            maskTextFn,
            slimDOM: slimDOMOptions,
            recordCanvas,
            inlineImages,
            onSerialize: (n) => {
                if (isIframeINode(n)) {
                    iframeManager.addIframe(n);
                }
                if (hasShadowRoot(n)) {
                    shadowDomManager.addShadowRoot(n.shadowRoot, document);
                }
            },
            onIframeLoad: (iframe, childSn) => {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            keepIframeSrcFn,
        });
        if (!node) {
            return console.warn('Failed to snapshot the document');
        }
        mirror.map = idNodeMap;
        wrappedEmit(wrapEvent({
            type: EventType.FullSnapshot,
            data: {
                node,
                initialOffset: {
                    left: window.pageXOffset !== undefined
                        ? window.pageXOffset
                        : (document === null || document === void 0 ? void 0 : document.documentElement.scrollLeft) ||
                            ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) ||
                            (document === null || document === void 0 ? void 0 : document.body.scrollLeft) ||
                            0,
                    top: window.pageYOffset !== undefined
                        ? window.pageYOffset
                        : (document === null || document === void 0 ? void 0 : document.documentElement.scrollTop) ||
                            ((_d = (_c = document === null || document === void 0 ? void 0 : document.body) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) ||
                            (document === null || document === void 0 ? void 0 : document.body.scrollTop) ||
                            0,
                },
            },
        }));
        mutationBuffers.forEach((buf) => buf.unlock());
    };
    try {
        const handlers = [];
        handlers.push(on('DOMContentLoaded', () => {
            wrappedEmit(wrapEvent({
                type: EventType.DomContentLoaded,
                data: {},
            }));
        }));
        const observe = (doc) => {
            var _a;
            return callbackWrapper(initObservers)({
                onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: {
                        source,
                        positions,
                    },
                })),
                mouseInteractionCb: (d) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.MouseInteraction }, d),
                })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.ViewportResize }, d),
                })),
                inputCb: (v) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.Input }, v),
                })),
                mediaInteractionCb: (p) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.MediaInteraction }, p),
                })),
                styleSheetRuleCb: (r) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.StyleSheetRule }, r),
                })),
                styleDeclarationCb: (r) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.StyleDeclaration }, r),
                })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p) => wrappedEmit(wrapEvent({
                    type: EventType.IncrementalSnapshot,
                    data: Object.assign({ source: IncrementalSource.Font }, p),
                })),
                blockClass,
                ignoreClass,
                ignoreSelector,
                maskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                maskInputSelector,
                unmaskInputSelector,
                maskInputOptions,
                inlineStylesheet,
                sampling,
                recordCanvas,
                inlineImages,
                userTriggeredOnInput,
                collectFonts,
                doc,
                maskAllText,
                maskInputFn,
                maskTextFn,
                blockSelector,
                unblockSelector,
                slimDOMOptions,
                mirror,
                iframeManager,
                shadowDomManager,
                canvasManager,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter((p) => p.observer)) === null || _a === void 0 ? void 0 : _a.map((p) => ({
                    observer: p.observer,
                    options: p.options,
                    callback: (payload) => wrappedEmit(wrapEvent({
                        type: EventType.Plugin,
                        data: {
                            plugin: p.name,
                            payload,
                        },
                    })),
                }))) || [],
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl) => {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            }
            catch (error) {
                console.warn(error);
            }
        });
        const init = () => {
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' ||
            document.readyState === 'complete') {
            init();
        }
        else {
            handlers.push(on('load', () => {
                wrappedEmit(wrapEvent({
                    type: EventType.Load,
                    data: {},
                }));
                init();
            }, window));
        }
        return () => {
            handlers.forEach((h) => h());
        };
    }
    catch (error) {
        console.warn(error);
    }
}
record.addCustomEvent = (tag, payload) => {
    if (!wrappedEmit) {
        throw new Error('please add custom event after start recording');
    }
    wrappedEmit(wrapEvent({
        type: EventType.Custom,
        data: {
            tag,
            payload,
        },
    }));
};
record.freezePage = () => {
    mutationBuffers.forEach((buf) => buf.freeze());
};
record.takeFullSnapshot = (isCheckout) => {
    if (!takeFullSnapshot) {
        throw new Error('please take full snapshot after start recording');
    }
    takeFullSnapshot(isCheckout);
};
record.mirror = mirror;

/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */
function timestampToMs(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp : timestamp * 1000;
}

/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */
function timestampToS(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1000 : timestamp;
}

/**
 * Add a breadcrumb event to replay.
 */
function addBreadcrumbEvent(replay, breadcrumb) {
  if (breadcrumb.category === 'sentry.transaction') {
    return;
  }

  if (['ui.click', 'ui.input'].includes(breadcrumb.category )) {
    replay.triggerUserActivity();
  } else {
    replay.checkAndHandleExpiredSession();
  }

  replay.addUpdate(() => {
    void replay.throttledAddEvent({
      type: EventType.Custom,
      // TODO: We were converting from ms to seconds for breadcrumbs, spans,
      // but maybe we should just keep them as milliseconds
      timestamp: (breadcrumb.timestamp || 0) * 1000,
      data: {
        tag: 'breadcrumb',
        // normalize to max. 10 depth and 1_000 properties per object
        payload: (0,normalize/* normalize */.Fv)(breadcrumb, 10, 1000),
      },
    });

    // Do not flush after console log messages
    return breadcrumb.category === 'console';
  });
}

const INTERACTIVE_SELECTOR = 'button,a';

/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */
function getClickTargetNode(event) {
  const target = getTargetNode(event);

  if (!target || !(target instanceof Element)) {
    return target;
  }

  const closestInteractive = target.closest(INTERACTIVE_SELECTOR);
  return closestInteractive || target;
}

/** Get the event target node. */
function getTargetNode(event) {
  if (isEventWithTarget(event)) {
    return event.target ;
  }

  return event;
}

function isEventWithTarget(event) {
  return typeof event === 'object' && !!event && 'target' in event;
}

let handlers;

/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */
function onWindowOpen(cb) {
  // Ensure to only register this once
  if (!handlers) {
    handlers = [];
    monkeyPatchWindowOpen();
  }

  handlers.push(cb);

  return () => {
    const pos = handlers ? handlers.indexOf(cb) : -1;
    if (pos > -1) {
      (handlers ).splice(pos, 1);
    }
  };
}

function monkeyPatchWindowOpen() {
  (0,object/* fill */.hl)(WINDOW, 'open', function (originalWindowOpen) {
    return function (...args) {
      if (handlers) {
        try {
          handlers.forEach(handler => handler());
        } catch (e) {
          // ignore errors in here
        }
      }

      return originalWindowOpen.apply(WINDOW, args);
    };
  });
}

/** Handle a click. */
function handleClick(clickDetector, clickBreadcrumb, node) {
  clickDetector.handleClick(clickBreadcrumb, node);
}

/** A click detector class that can be used to detect slow or rage clicks on elements. */
class ClickDetector  {
  // protected for testing
   __init() {this._lastMutation = 0;}
   __init2() {this._lastScroll = 0;}

   __init3() {this._clicks = [];}

   constructor(
    replay,
    slowClickConfig,
    // Just for easier testing
    _addBreadcrumbEvent = addBreadcrumbEvent,
  ) {ClickDetector.prototype.__init.call(this);ClickDetector.prototype.__init2.call(this);ClickDetector.prototype.__init3.call(this);
    // We want everything in s, but options are in ms
    this._timeout = slowClickConfig.timeout / 1000;
    this._threshold = slowClickConfig.threshold / 1000;
    this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
    this._replay = replay;
    this._ignoreSelector = slowClickConfig.ignoreSelector;
    this._addBreadcrumbEvent = _addBreadcrumbEvent;
  }

  /** Register click detection handlers on mutation or scroll. */
   addListeners() {
    const mutationHandler = () => {
      this._lastMutation = nowInSeconds();
    };

    const scrollHandler = () => {
      this._lastScroll = nowInSeconds();
    };

    const cleanupWindowOpen = onWindowOpen(() => {
      // Treat window.open as mutation
      this._lastMutation = nowInSeconds();
    });

    const clickHandler = (event) => {
      if (!event.target) {
        return;
      }

      const node = getClickTargetNode(event);
      if (node) {
        this._handleMultiClick(node );
      }
    };

    const obs = new MutationObserver(mutationHandler);

    obs.observe(WINDOW.document.documentElement, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });

    WINDOW.addEventListener('scroll', scrollHandler, { passive: true });
    WINDOW.addEventListener('click', clickHandler, { passive: true });

    this._teardown = () => {
      WINDOW.removeEventListener('scroll', scrollHandler);
      WINDOW.removeEventListener('click', clickHandler);
      cleanupWindowOpen();

      obs.disconnect();
      this._clicks = [];
      this._lastMutation = 0;
      this._lastScroll = 0;
    };
  }

  /** Clean up listeners. */
   removeListeners() {
    if (this._teardown) {
      this._teardown();
    }

    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }
  }

  /** Handle a click */
   handleClick(breadcrumb, node) {
    if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) {
      return;
    }

    const newClick = {
      timestamp: timestampToS(breadcrumb.timestamp),
      clickBreadcrumb: breadcrumb,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node,
    };
    this._clicks.push(newClick);

    // If this is the first new click, set a timeout to check for multi clicks
    if (this._clicks.length === 1) {
      this._scheduleCheckClicks();
    }
  }

  /** Count multiple clicks on elements. */
   _handleMultiClick(node) {
    this._getClicks(node).forEach(click => {
      click.clickCount++;
    });
  }

  /** Get all pending clicks for a given node. */
   _getClicks(node) {
    return this._clicks.filter(click => click.node === node);
  }

  /** Check the clicks that happened. */
   _checkClicks() {
    const timedOutClicks = [];

    const now = nowInSeconds();

    this._clicks.forEach(click => {
      if (!click.mutationAfter && this._lastMutation) {
        click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
      }
      if (!click.scrollAfter && this._lastScroll) {
        click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
      }

      // All of these are in seconds!
      if (click.timestamp + this._timeout <= now) {
        timedOutClicks.push(click);
      }
    });

    // Remove "old" clicks
    for (const click of timedOutClicks) {
      const pos = this._clicks.indexOf(click);

      if (pos > -1) {
        this._generateBreadcrumbs(click);
        this._clicks.splice(pos, 1);
      }
    }

    // Trigger new check, unless no clicks left
    if (this._clicks.length) {
      this._scheduleCheckClicks();
    }
  }

  /** Generate matching breadcrumb(s) for the click. */
   _generateBreadcrumbs(click) {
    const replay = this._replay;
    const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
    const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;

    const isSlowClick = !hadScroll && !hadMutation;
    const { clickCount, clickBreadcrumb } = click;

    // Slow click
    if (isSlowClick) {
      // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
      // If not, it means we just timed out without scroll & mutation
      const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
      const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';

      const breadcrumb = {
        type: 'default',
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.slowClickDetected',
        data: {
          ...clickBreadcrumb.data,
          url: WINDOW.location.href,
          route: replay.getCurrentRoute(),
          timeAfterClickMs,
          endReason,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: clickCount || 1,
        },
      };

      this._addBreadcrumbEvent(replay, breadcrumb);
      return;
    }

    // Multi click
    if (clickCount > 1) {
      const breadcrumb = {
        type: 'default',
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.multiClick',
        data: {
          ...clickBreadcrumb.data,
          url: WINDOW.location.href,
          route: replay.getCurrentRoute(),
          clickCount,
          metric: true,
        },
      };

      this._addBreadcrumbEvent(replay, breadcrumb);
    }
  }

  /** Schedule to check current clicks. */
   _scheduleCheckClicks() {
    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }

    this._checkClickTimeout = setTimeout(() => this._checkClicks(), 1000);
  }
}

const SLOW_CLICK_TAGS = ['A', 'BUTTON', 'INPUT'];

/** exported for tests only */
function ignoreElement(node, ignoreSelector) {
  if (!SLOW_CLICK_TAGS.includes(node.tagName)) {
    return true;
  }

  // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
  if (node.tagName === 'INPUT' && !['submit', 'button'].includes(node.getAttribute('type') || '')) {
    return true;
  }

  // If <a> tag, detect special variants that may not lead to an action
  // If target !== _self, we may open the link somewhere else, which would lead to no action
  // Also, when downloading a file, we may not leave the page, but still not trigger an action
  if (
    node.tagName === 'A' &&
    (node.hasAttribute('download') || (node.hasAttribute('target') && node.getAttribute('target') !== '_self'))
  ) {
    return true;
  }

  if (ignoreSelector && node.matches(ignoreSelector)) {
    return true;
  }

  return false;
}

function isClickBreadcrumb(breadcrumb) {
  return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}

// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds() {
  return Date.now() / 1000;
}

/**
 * Create a breadcrumb for a replay.
 */
function createBreadcrumb(
  breadcrumb,
) {
  return {
    timestamp: Date.now() / 1000,
    type: 'default',
    ...breadcrumb,
  };
}

var NodeType;
(function (NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));

// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const ATTRIBUTES_TO_RECORD = new Set([
  'id',
  'class',
  'aria-label',
  'role',
  'name',
  'alt',
  'title',
  'data-test-id',
  'data-testid',
  'disabled',
  'aria-disabled',
]);

/**
 * Inclusion list of attributes that we want to record from the DOM element
 */
function getAttributesToRecord(attributes) {
  const obj = {};
  for (const key in attributes) {
    if (ATTRIBUTES_TO_RECORD.has(key)) {
      let normalizedKey = key;

      if (key === 'data-testid' || key === 'data-test-id') {
        normalizedKey = 'testId';
      }

      obj[normalizedKey] = attributes[key];
    }
  }

  return obj;
}

const handleDomListener = (
  replay,
) => {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleDom(handlerData);

    if (!result) {
      return;
    }

    const isClick = handlerData.name === 'click';
    const event = isClick && (handlerData.event );
    // Ignore clicks if ctrl/alt/meta keys are held down as they alter behavior of clicks (e.g. open in new tab)
    if (isClick && replay.clickDetector && event && !event.altKey && !event.metaKey && !event.ctrlKey) {
      handleClick(
        replay.clickDetector,
        result ,
        getClickTargetNode(handlerData.event) ,
      );
    }

    addBreadcrumbEvent(replay, result);
  };
};

/** Get the base DOM breadcrumb. */
function getBaseDomBreadcrumb(target, message) {
  // `__sn` property is the serialized node created by rrweb
  const serializedNode = target && isRrwebNode(target) && target.__sn.type === NodeType.Element ? target.__sn : null;

  return {
    message,
    data: serializedNode
      ? {
          nodeId: serializedNode.id,
          node: {
            id: serializedNode.id,
            tagName: serializedNode.tagName,
            textContent: target
              ? Array.from(target.childNodes)
                  .map(
                    (node) => '__sn' in node && node.__sn.type === NodeType.Text && node.__sn.textContent,
                  )
                  .filter(Boolean) // filter out empty values
                  .map(text => (text ).trim())
                  .join('')
              : '',
            attributes: getAttributesToRecord(serializedNode.attributes),
          },
        }
      : {},
  };
}

/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */
function handleDom(handlerData) {
  const { target, message } = getDomTarget(handlerData);

  return createBreadcrumb({
    category: `ui.${handlerData.name}`,
    ...getBaseDomBreadcrumb(target, message),
  });
}

function getDomTarget(handlerData) {
  const isClick = handlerData.name === 'click';

  let message;
  let target = null;

  // Accessing event.target can throw (see getsentry/raven-js#838, #768)
  try {
    target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
    message = (0,browser/* htmlTreeAsString */.Rt)(target, { maxStringLength: 200 }) || '<unknown>';
  } catch (e) {
    message = '<unknown>';
  }

  return { target, message };
}

function isRrwebNode(node) {
  return '__sn' in node;
}

/** Handle keyboard events & create breadcrumbs. */
function handleKeyboardEvent(replay, event) {
  if (!replay.isEnabled()) {
    return;
  }

  // Update user activity, but do not restart recording as it can create
  // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
  // session with a single "keydown" breadcrumb is created)
  replay.updateUserActivity();

  const breadcrumb = getKeyboardBreadcrumb(event);

  if (!breadcrumb) {
    return;
  }

  addBreadcrumbEvent(replay, breadcrumb);
}

/** exported only for tests */
function getKeyboardBreadcrumb(event) {
  const { metaKey, shiftKey, ctrlKey, altKey, key, target } = event;

  // never capture for input fields
  if (!target || isInputElement(target ) || !key) {
    return null;
  }

  // Note: We do not consider shift here, as that means "uppercase"
  const hasModifierKey = metaKey || ctrlKey || altKey;
  const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length

  // Do not capture breadcrumb if only a word key is pressed
  // This could leak e.g. user input
  if (!hasModifierKey && isCharacterKey) {
    return null;
  }

  const message = (0,browser/* htmlTreeAsString */.Rt)(target, { maxStringLength: 200 }) || '<unknown>';
  const baseBreadcrumb = getBaseDomBreadcrumb(target , message);

  return createBreadcrumb({
    category: 'ui.keyDown',
    message,
    data: {
      ...baseBreadcrumb.data,
      metaKey,
      shiftKey,
      ctrlKey,
      altKey,
      key,
    },
  });
}

function isInputElement(target) {
  return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}

const NAVIGATION_ENTRY_KEYS = [
  'name',
  'type',
  'startTime',
  'transferSize',
  'duration',
];

function isNavigationEntryEqual(a) {
  return function (b) {
    return NAVIGATION_ENTRY_KEYS.every(key => a[key] === b[key]);
  };
}

/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */
// TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function dedupePerformanceEntries(
  currentList,
  newList,
) {
  // Partition `currentList` into 3 different lists based on entryType
  const [existingNavigationEntries, existingLcpEntries, existingEntries] = currentList.reduce(
    (acc, entry) => {
      if (entry.entryType === 'navigation') {
        acc[0].push(entry );
      } else if (entry.entryType === 'largest-contentful-paint') {
        acc[1].push(entry );
      } else {
        acc[2].push(entry);
      }
      return acc;
    },
    [[], [], []],
  );

  const newEntries = [];
  const newNavigationEntries = [];
  let newLcpEntry = existingLcpEntries.length
    ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
    : undefined;

  newList.forEach(entry => {
    if (entry.entryType === 'largest-contentful-paint') {
      // We want the latest LCP event only
      if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) {
        newLcpEntry = entry;
      }
      return;
    }

    if (entry.entryType === 'navigation') {
      const navigationEntry = entry ;

      // Check if the navigation entry is contained in currentList or newList
      if (
        // Ignore any navigation entries with duration 0, as they are likely duplicates
        entry.duration > 0 &&
        // Ensure new entry does not already exist in existing entries
        !existingNavigationEntries.find(isNavigationEntryEqual(navigationEntry)) &&
        // Ensure new entry does not already exist in new list of navigation entries
        !newNavigationEntries.find(isNavigationEntryEqual(navigationEntry))
      ) {
        newNavigationEntries.push(navigationEntry);
      }

      // Otherwise this navigation entry is considered a duplicate and is thrown away
      return;
    }

    newEntries.push(entry);
  });

  // Re-combine and sort by startTime
  return [
    ...(newLcpEntry ? [newLcpEntry] : []),
    ...existingNavigationEntries,
    ...existingEntries,
    ...newEntries,
    ...newNavigationEntries,
  ].sort((a, b) => a.startTime - b.startTime);
}

/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 */
function setupPerformanceObserver(replay) {
  const performanceObserverHandler = (list) => {
    // For whatever reason the observer was returning duplicate navigation
    // entries (the other entry types were not duplicated).
    const newPerformanceEntries = dedupePerformanceEntries(
      replay.performanceEvents,
      list.getEntries() ,
    );
    replay.performanceEvents = newPerformanceEntries;
  };

  const performanceObserver = new PerformanceObserver(performanceObserverHandler);

  [
    'element',
    'event',
    'first-input',
    'largest-contentful-paint',
    'layout-shift',
    'longtask',
    'navigation',
    'paint',
    'resource',
  ].forEach(type => {
    try {
      performanceObserver.observe({
        type,
        buffered: true,
      });
    } catch (e) {
      // This can throw if an entry type is not supported in the browser.
      // Ignore these errors.
    }
  });

  return performanceObserver;
}

const r = `/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
function t(t){let e=t.length;for(;--e>=0;)t[e]=0}const e=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),a=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),i=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),n=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=new Array(576);t(s);const r=new Array(60);t(r);const o=new Array(512);t(o);const l=new Array(256);t(l);const h=new Array(29);t(h);const d=new Array(30);function _(t,e,a,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=i,this.max_length=n,this.has_stree=t&&t.length}let f,c,u;function w(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}t(d);const m=t=>t<256?o[t]:o[256+(t>>>7)],b=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},g=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,b(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},p=(t,e,a)=>{g(t,a[2*e],a[2*e+1])},k=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},v=(t,e,a)=>{const i=new Array(16);let n,s,r=0;for(n=1;n<=15;n++)r=r+a[n-1]<<1,i[n]=r;for(s=0;s<=e;s++){let e=t[2*s+1];0!==e&&(t[2*s]=k(i[e]++,e))}},y=t=>{let e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.sym_next=t.matches=0},x=t=>{t.bi_valid>8?b(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},z=(t,e,a,i)=>{const n=2*e,s=2*a;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[a]},A=(t,e,a)=>{const i=t.heap[a];let n=a<<1;for(;n<=t.heap_len&&(n<t.heap_len&&z(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!z(e,i,t.heap[n],t.depth));)t.heap[a]=t.heap[n],a=n,n<<=1;t.heap[a]=i},E=(t,i,n)=>{let s,r,o,_,f=0;if(0!==t.sym_next)do{s=255&t.pending_buf[t.sym_buf+f++],s+=(255&t.pending_buf[t.sym_buf+f++])<<8,r=t.pending_buf[t.sym_buf+f++],0===s?p(t,r,i):(o=l[r],p(t,o+256+1,i),_=e[o],0!==_&&(r-=h[o],g(t,r,_)),s--,o=m(s),p(t,o,n),_=a[o],0!==_&&(s-=d[o],g(t,s,_)))}while(f<t.sym_next);p(t,256,i)},R=(t,e)=>{const a=e.dyn_tree,i=e.stat_desc.static_tree,n=e.stat_desc.has_stree,s=e.stat_desc.elems;let r,o,l,h=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<s;r++)0!==a[2*r]?(t.heap[++t.heap_len]=h=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)l=t.heap[++t.heap_len]=h<2?++h:0,a[2*l]=1,t.depth[l]=0,t.opt_len--,n&&(t.static_len-=i[2*l+1]);for(e.max_code=h,r=t.heap_len>>1;r>=1;r--)A(t,a,r);l=s;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],A(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=o,a[2*l]=a[2*r]+a[2*o],t.depth[l]=(t.depth[r]>=t.depth[o]?t.depth[r]:t.depth[o])+1,a[2*r+1]=a[2*o+1]=l,t.heap[1]=l++,A(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,i=e.max_code,n=e.stat_desc.static_tree,s=e.stat_desc.has_stree,r=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,l=e.stat_desc.max_length;let h,d,_,f,c,u,w=0;for(f=0;f<=15;f++)t.bl_count[f]=0;for(a[2*t.heap[t.heap_max]+1]=0,h=t.heap_max+1;h<573;h++)d=t.heap[h],f=a[2*a[2*d+1]+1]+1,f>l&&(f=l,w++),a[2*d+1]=f,d>i||(t.bl_count[f]++,c=0,d>=o&&(c=r[d-o]),u=a[2*d],t.opt_len+=u*(f+c),s&&(t.static_len+=u*(n[2*d+1]+c)));if(0!==w){do{for(f=l-1;0===t.bl_count[f];)f--;t.bl_count[f]--,t.bl_count[f+1]+=2,t.bl_count[l]--,w-=2}while(w>0);for(f=l;0!==f;f--)for(d=t.bl_count[f];0!==d;)_=t.heap[--h],_>i||(a[2*_+1]!==f&&(t.opt_len+=(f-a[2*_+1])*a[2*_],a[2*_+1]=f),d--)}})(t,e),v(a,h,t.bl_count)},Z=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),e[2*(a+1)+1]=65535,i=0;i<=a;i++)n=r,r=e[2*(i+1)+1],++o<l&&n===r||(o<h?t.bl_tree[2*n]+=o:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[32]++):o<=10?t.bl_tree[34]++:t.bl_tree[36]++,o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4))},U=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),i=0;i<=a;i++)if(n=r,r=e[2*(i+1)+1],!(++o<l&&n===r)){if(o<h)do{p(t,n,t.bl_tree)}while(0!=--o);else 0!==n?(n!==s&&(p(t,n,t.bl_tree),o--),p(t,16,t.bl_tree),g(t,o-3,2)):o<=10?(p(t,17,t.bl_tree),g(t,o-3,3)):(p(t,18,t.bl_tree),g(t,o-11,7));o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4)}};let S=!1;const D=(t,e,a,i)=>{g(t,0+(i?1:0),3),x(t),b(t,a),b(t,~a),a&&t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a};var T=(t,e,a,i)=>{let o,l,h=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),R(t,t.l_desc),R(t,t.d_desc),h=(t=>{let e;for(Z(t,t.dyn_ltree,t.l_desc.max_code),Z(t,t.dyn_dtree,t.d_desc.max_code),R(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*n[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),o=t.opt_len+3+7>>>3,l=t.static_len+3+7>>>3,l<=o&&(o=l)):o=l=a+5,a+4<=o&&-1!==e?D(t,e,a,i):4===t.strategy||l===o?(g(t,2+(i?1:0),3),E(t,s,r)):(g(t,4+(i?1:0),3),((t,e,a,i)=>{let s;for(g(t,e-257,5),g(t,a-1,5),g(t,i-4,4),s=0;s<i;s++)g(t,t.bl_tree[2*n[s]+1],3);U(t,t.dyn_ltree,e-1),U(t,t.dyn_dtree,a-1)})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,h+1),E(t,t.dyn_ltree,t.dyn_dtree)),y(t),i&&x(t)},O={_tr_init:t=>{S||((()=>{let t,n,w,m,b;const g=new Array(16);for(w=0,m=0;m<28;m++)for(h[m]=w,t=0;t<1<<e[m];t++)l[w++]=m;for(l[w-1]=m,b=0,m=0;m<16;m++)for(d[m]=b,t=0;t<1<<a[m];t++)o[b++]=m;for(b>>=7;m<30;m++)for(d[m]=b<<7,t=0;t<1<<a[m]-7;t++)o[256+b++]=m;for(n=0;n<=15;n++)g[n]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,g[8]++;for(;t<=255;)s[2*t+1]=9,t++,g[9]++;for(;t<=279;)s[2*t+1]=7,t++,g[7]++;for(;t<=287;)s[2*t+1]=8,t++,g[8]++;for(v(s,287,g),t=0;t<30;t++)r[2*t+1]=5,r[2*t]=k(t,5);f=new _(s,e,257,286,15),c=new _(r,a,0,30,15),u=new _(new Array(0),i,0,19,7)})(),S=!0),t.l_desc=new w(t.dyn_ltree,f),t.d_desc=new w(t.dyn_dtree,c),t.bl_desc=new w(t.bl_tree,u),t.bi_buf=0,t.bi_valid=0,y(t)},_tr_stored_block:D,_tr_flush_block:T,_tr_tally:(t,e,a)=>(t.pending_buf[t.sym_buf+t.sym_next++]=e,t.pending_buf[t.sym_buf+t.sym_next++]=e>>8,t.pending_buf[t.sym_buf+t.sym_next++]=a,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(l[a]+256+1)]++,t.dyn_dtree[2*m(e)]++),t.sym_next===t.sym_end),_tr_align:t=>{g(t,2,3),p(t,256,s),(t=>{16===t.bi_valid?(b(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)})(t)}};var F=(t,e,a,i)=>{let n=65535&t|0,s=t>>>16&65535|0,r=0;for(;0!==a;){r=a>2e3?2e3:a,a-=r;do{n=n+e[i++]|0,s=s+n|0}while(--r);n%=65521,s%=65521}return n|s<<16|0};const L=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e})());var N=(t,e,a,i)=>{const n=L,s=i+a;t^=-1;for(let a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t},I={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},B={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:C,_tr_stored_block:H,_tr_flush_block:M,_tr_tally:j,_tr_align:K}=O,{Z_NO_FLUSH:P,Z_PARTIAL_FLUSH:Y,Z_FULL_FLUSH:G,Z_FINISH:X,Z_BLOCK:W,Z_OK:q,Z_STREAM_END:J,Z_STREAM_ERROR:Q,Z_DATA_ERROR:V,Z_BUF_ERROR:$,Z_DEFAULT_COMPRESSION:tt,Z_FILTERED:et,Z_HUFFMAN_ONLY:at,Z_RLE:it,Z_FIXED:nt,Z_DEFAULT_STRATEGY:st,Z_UNKNOWN:rt,Z_DEFLATED:ot}=B,lt=(t,e)=>(t.msg=I[e],e),ht=t=>2*t-(t>4?9:0),dt=t=>{let e=t.length;for(;--e>=0;)t[e]=0},_t=t=>{let e,a,i,n=t.w_size;e=t.hash_size,i=e;do{a=t.head[--i],t.head[i]=a>=n?a-n:0}while(--e);e=n,i=e;do{a=t.prev[--i],t.prev[i]=a>=n?a-n:0}while(--e)};let ft=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const ct=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},ut=(t,e)=>{M(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,ct(t.strm)},wt=(t,e)=>{t.pending_buf[t.pending++]=e},mt=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},bt=(t,e,a,i)=>{let n=t.avail_in;return n>i&&(n=i),0===n?0:(t.avail_in-=n,e.set(t.input.subarray(t.next_in,t.next_in+n),a),1===t.state.wrap?t.adler=F(t.adler,e,n,a):2===t.state.wrap&&(t.adler=N(t.adler,e,n,a)),t.next_in+=n,t.total_in+=n,n)},gt=(t,e)=>{let a,i,n=t.max_chain_length,s=t.strstart,r=t.prev_length,o=t.nice_match;const l=t.strstart>t.w_size-262?t.strstart-(t.w_size-262):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+258;let c=h[s+r-1],u=h[s+r];t.prev_length>=t.good_match&&(n>>=2),o>t.lookahead&&(o=t.lookahead);do{if(a=e,h[a+r]===u&&h[a+r-1]===c&&h[a]===h[s]&&h[++a]===h[s+1]){s+=2,a++;do{}while(h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&s<f);if(i=258-(f-s),s=f-258,i>r){if(t.match_start=e,r=i,i>=o)break;c=h[s+r-1],u=h[s+r]}}}while((e=_[e&d])>l&&0!=--n);return r<=t.lookahead?r:t.lookahead},pt=t=>{const e=t.w_size;let a,i,n;do{if(i=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-262)&&(t.window.set(t.window.subarray(e,e+e-i),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,t.insert>t.strstart&&(t.insert=t.strstart),_t(t),i+=e),0===t.strm.avail_in)break;if(a=bt(t.strm,t.window,t.strstart+t.lookahead,i),t.lookahead+=a,t.lookahead+t.insert>=3)for(n=t.strstart-t.insert,t.ins_h=t.window[n],t.ins_h=ft(t,t.ins_h,t.window[n+1]);t.insert&&(t.ins_h=ft(t,t.ins_h,t.window[n+3-1]),t.prev[n&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=n,n++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<262&&0!==t.strm.avail_in)},kt=(t,e)=>{let a,i,n,s=t.pending_buf_size-5>t.w_size?t.w_size:t.pending_buf_size-5,r=0,o=t.strm.avail_in;do{if(a=65535,n=t.bi_valid+42>>3,t.strm.avail_out<n)break;if(n=t.strm.avail_out-n,i=t.strstart-t.block_start,a>i+t.strm.avail_in&&(a=i+t.strm.avail_in),a>n&&(a=n),a<s&&(0===a&&e!==X||e===P||a!==i+t.strm.avail_in))break;r=e===X&&a===i+t.strm.avail_in?1:0,H(t,0,0,r),t.pending_buf[t.pending-4]=a,t.pending_buf[t.pending-3]=a>>8,t.pending_buf[t.pending-2]=~a,t.pending_buf[t.pending-1]=~a>>8,ct(t.strm),i&&(i>a&&(i=a),t.strm.output.set(t.window.subarray(t.block_start,t.block_start+i),t.strm.next_out),t.strm.next_out+=i,t.strm.avail_out-=i,t.strm.total_out+=i,t.block_start+=i,a-=i),a&&(bt(t.strm,t.strm.output,t.strm.next_out,a),t.strm.next_out+=a,t.strm.avail_out-=a,t.strm.total_out+=a)}while(0===r);return o-=t.strm.avail_in,o&&(o>=t.w_size?(t.matches=2,t.window.set(t.strm.input.subarray(t.strm.next_in-t.w_size,t.strm.next_in),0),t.strstart=t.w_size,t.insert=t.strstart):(t.window_size-t.strstart<=o&&(t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,t.insert>t.strstart&&(t.insert=t.strstart)),t.window.set(t.strm.input.subarray(t.strm.next_in-o,t.strm.next_in),t.strstart),t.strstart+=o,t.insert+=o>t.w_size-t.insert?t.w_size-t.insert:o),t.block_start=t.strstart),t.high_water<t.strstart&&(t.high_water=t.strstart),r?4:e!==P&&e!==X&&0===t.strm.avail_in&&t.strstart===t.block_start?2:(n=t.window_size-t.strstart,t.strm.avail_in>n&&t.block_start>=t.w_size&&(t.block_start-=t.w_size,t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,n+=t.w_size,t.insert>t.strstart&&(t.insert=t.strstart)),n>t.strm.avail_in&&(n=t.strm.avail_in),n&&(bt(t.strm,t.window,t.strstart,n),t.strstart+=n,t.insert+=n>t.w_size-t.insert?t.w_size-t.insert:n),t.high_water<t.strstart&&(t.high_water=t.strstart),n=t.bi_valid+42>>3,n=t.pending_buf_size-n>65535?65535:t.pending_buf_size-n,s=n>t.w_size?t.w_size:n,i=t.strstart-t.block_start,(i>=s||(i||e===X)&&e!==P&&0===t.strm.avail_in&&i<=n)&&(a=i>n?n:i,r=e===X&&0===t.strm.avail_in&&a===i?1:0,H(t,t.block_start,a,r),t.block_start+=a,ct(t.strm)),r?3:1)},vt=(t,e)=>{let a,i;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a)),t.match_length>=3)if(i=j(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=ft(t,t.ins_h,t.window[t.strstart+1]);else i=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2},yt=(t,e)=>{let a,i,n;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a),t.match_length<=5&&(t.strategy===et||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-3,i=j(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=n&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,i&&(ut(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if(i=j(t,0,t.window[t.strstart-1]),i&&ut(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=j(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2};function xt(t,e,a,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=i,this.func=n}const zt=[new xt(0,0,0,0,kt),new xt(4,4,8,4,vt),new xt(4,5,16,8,vt),new xt(4,6,32,32,vt),new xt(4,4,16,16,yt),new xt(8,16,32,32,yt),new xt(8,16,128,128,yt),new xt(8,32,128,256,yt),new xt(32,128,258,1024,yt),new xt(32,258,258,4096,yt)];function At(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ot,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),dt(this.dyn_ltree),dt(this.dyn_dtree),dt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),dt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),dt(this.depth),this.sym_buf=0,this.lit_bufsize=0,this.sym_next=0,this.sym_end=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}const Et=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||42!==e.status&&57!==e.status&&69!==e.status&&73!==e.status&&91!==e.status&&103!==e.status&&113!==e.status&&666!==e.status?1:0},Rt=t=>{if(Et(t))return lt(t,Q);t.total_in=t.total_out=0,t.data_type=rt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=2===e.wrap?57:e.wrap?42:113,t.adler=2===e.wrap?0:1,e.last_flush=-2,C(e),q},Zt=t=>{const e=Rt(t);var a;return e===q&&((a=t.state).window_size=2*a.w_size,dt(a.head),a.max_lazy_match=zt[a.level].max_lazy,a.good_match=zt[a.level].good_length,a.nice_match=zt[a.level].nice_length,a.max_chain_length=zt[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=2,a.match_available=0,a.ins_h=0),e},Ut=(t,e,a,i,n,s)=>{if(!t)return Q;let r=1;if(e===tt&&(e=6),i<0?(r=0,i=-i):i>15&&(r=2,i-=16),n<1||n>9||a!==ot||i<8||i>15||e<0||e>9||s<0||s>nt||8===i&&1!==r)return lt(t,Q);8===i&&(i=9);const o=new At;return t.state=o,o.strm=t,o.status=42,o.wrap=r,o.gzhead=null,o.w_bits=i,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=n+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+3-1)/3),o.window=new Uint8Array(2*o.w_size),o.head=new Uint16Array(o.hash_size),o.prev=new Uint16Array(o.w_size),o.lit_bufsize=1<<n+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new Uint8Array(o.pending_buf_size),o.sym_buf=o.lit_bufsize,o.sym_end=3*(o.lit_bufsize-1),o.level=e,o.strategy=s,o.method=a,Zt(t)};var St={deflateInit:(t,e)=>Ut(t,e,ot,15,8,st),deflateInit2:Ut,deflateReset:Zt,deflateResetKeep:Rt,deflateSetHeader:(t,e)=>Et(t)||2!==t.state.wrap?Q:(t.state.gzhead=e,q),deflate:(t,e)=>{if(Et(t)||e>W||e<0)return t?lt(t,Q):Q;const a=t.state;if(!t.output||0!==t.avail_in&&!t.input||666===a.status&&e!==X)return lt(t,0===t.avail_out?$:Q);const i=a.last_flush;if(a.last_flush=e,0!==a.pending){if(ct(t),0===t.avail_out)return a.last_flush=-1,q}else if(0===t.avail_in&&ht(e)<=ht(i)&&e!==X)return lt(t,$);if(666===a.status&&0!==t.avail_in)return lt(t,$);if(42===a.status&&0===a.wrap&&(a.status=113),42===a.status){let e=ot+(a.w_bits-8<<4)<<8,i=-1;if(i=a.strategy>=at||a.level<2?0:a.level<6?1:6===a.level?2:3,e|=i<<6,0!==a.strstart&&(e|=32),e+=31-e%31,mt(a,e),0!==a.strstart&&(mt(a,t.adler>>>16),mt(a,65535&t.adler)),t.adler=1,a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(57===a.status)if(t.adler=0,wt(a,31),wt(a,139),wt(a,8),a.gzhead)wt(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(a.gzhead.extra?4:0)+(a.gzhead.name?8:0)+(a.gzhead.comment?16:0)),wt(a,255&a.gzhead.time),wt(a,a.gzhead.time>>8&255),wt(a,a.gzhead.time>>16&255),wt(a,a.gzhead.time>>24&255),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,255&a.gzhead.os),a.gzhead.extra&&a.gzhead.extra.length&&(wt(a,255&a.gzhead.extra.length),wt(a,a.gzhead.extra.length>>8&255)),a.gzhead.hcrc&&(t.adler=N(t.adler,a.pending_buf,a.pending,0)),a.gzindex=0,a.status=69;else if(wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,3),a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q;if(69===a.status){if(a.gzhead.extra){let e=a.pending,i=(65535&a.gzhead.extra.length)-a.gzindex;for(;a.pending+i>a.pending_buf_size;){let n=a.pending_buf_size-a.pending;if(a.pending_buf.set(a.gzhead.extra.subarray(a.gzindex,a.gzindex+n),a.pending),a.pending=a.pending_buf_size,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex+=n,ct(t),0!==a.pending)return a.last_flush=-1,q;e=0,i-=n}let n=new Uint8Array(a.gzhead.extra);a.pending_buf.set(n.subarray(a.gzindex,a.gzindex+i),a.pending),a.pending+=i,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex=0}a.status=73}if(73===a.status){if(a.gzhead.name){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.name.length?255&a.gzhead.name.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),a.gzindex=0}a.status=91}if(91===a.status){if(a.gzhead.comment){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.comment.length?255&a.gzhead.comment.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i))}a.status=103}if(103===a.status){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size&&(ct(t),0!==a.pending))return a.last_flush=-1,q;wt(a,255&t.adler),wt(a,t.adler>>8&255),t.adler=0}if(a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(0!==t.avail_in||0!==a.lookahead||e!==P&&666!==a.status){let i=0===a.level?kt(a,e):a.strategy===at?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(pt(t),0===t.lookahead)){if(e===P)return 1;break}if(t.match_length=0,a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):a.strategy===it?((t,e)=>{let a,i,n,s;const r=t.window;for(;;){if(t.lookahead<=258){if(pt(t),t.lookahead<=258&&e===P)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=t.strstart-1,i=r[n],i===r[++n]&&i===r[++n]&&i===r[++n])){s=t.strstart+258;do{}while(i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&n<s);t.match_length=258-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=j(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):zt[a.level].func(a,e);if(3!==i&&4!==i||(a.status=666),1===i||3===i)return 0===t.avail_out&&(a.last_flush=-1),q;if(2===i&&(e===Y?K(a):e!==W&&(H(a,0,0,!1),e===G&&(dt(a.head),0===a.lookahead&&(a.strstart=0,a.block_start=0,a.insert=0))),ct(t),0===t.avail_out))return a.last_flush=-1,q}return e!==X?q:a.wrap<=0?J:(2===a.wrap?(wt(a,255&t.adler),wt(a,t.adler>>8&255),wt(a,t.adler>>16&255),wt(a,t.adler>>24&255),wt(a,255&t.total_in),wt(a,t.total_in>>8&255),wt(a,t.total_in>>16&255),wt(a,t.total_in>>24&255)):(mt(a,t.adler>>>16),mt(a,65535&t.adler)),ct(t),a.wrap>0&&(a.wrap=-a.wrap),0!==a.pending?q:J)},deflateEnd:t=>{if(Et(t))return Q;const e=t.state.status;return t.state=null,113===e?lt(t,V):q},deflateSetDictionary:(t,e)=>{let a=e.length;if(Et(t))return Q;const i=t.state,n=i.wrap;if(2===n||1===n&&42!==i.status||i.lookahead)return Q;if(1===n&&(t.adler=F(t.adler,e,a,0)),i.wrap=0,a>=i.w_size){0===n&&(dt(i.head),i.strstart=0,i.block_start=0,i.insert=0);let t=new Uint8Array(i.w_size);t.set(e.subarray(a-i.w_size,a),0),e=t,a=i.w_size}const s=t.avail_in,r=t.next_in,o=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,pt(i);i.lookahead>=3;){let t=i.strstart,e=i.lookahead-2;do{i.ins_h=ft(i,i.ins_h,i.window[t+3-1]),i.prev[t&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=t,t++}while(--e);i.strstart=t,i.lookahead=2,pt(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=2,i.match_available=0,t.next_in=r,t.input=o,t.avail_in=s,i.wrap=n,q},deflateInfo:"pako deflate (from Nodeca project)"};const Dt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Tt=function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Dt(a,e)&&(t[e]=a[e])}}return t},Ot=t=>{let e=0;for(let a=0,i=t.length;a<i;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,i=0,n=t.length;e<n;e++){let n=t[e];a.set(n,i),i+=n.length}return a};let Ft=!0;try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){Ft=!1}const Lt=new Uint8Array(256);for(let t=0;t<256;t++)Lt[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Lt[254]=Lt[254]=1;var Nt=t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,i,n,s,r=t.length,o=0;for(n=0;n<r;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),o+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(o),s=0,n=0;s<o;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),a<128?e[s++]=a:a<2048?(e[s++]=192|a>>>6,e[s++]=128|63&a):a<65536?(e[s++]=224|a>>>12,e[s++]=128|a>>>6&63,e[s++]=128|63&a):(e[s++]=240|a>>>18,e[s++]=128|a>>>12&63,e[s++]=128|a>>>6&63,e[s++]=128|63&a);return e},It=(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return(new TextDecoder).decode(t.subarray(0,e));let i,n;const s=new Array(2*a);for(n=0,i=0;i<a;){let e=t[i++];if(e<128){s[n++]=e;continue}let r=Lt[e];if(r>4)s[n++]=65533,i+=r-1;else{for(e&=2===r?31:3===r?15:7;r>1&&i<a;)e=e<<6|63&t[i++],r--;r>1?s[n++]=65533:e<65536?s[n++]=e:(e-=65536,s[n++]=55296|e>>10&1023,s[n++]=56320|1023&e)}}return((t,e)=>{if(e<65534&&t.subarray&&Ft)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let i=0;i<e;i++)a+=String.fromCharCode(t[i]);return a})(s,n)},Bt=(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0||0===a?e:a+Lt[t[a]]>e?a:e};var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0};const Ht=Object.prototype.toString,{Z_NO_FLUSH:Mt,Z_SYNC_FLUSH:jt,Z_FULL_FLUSH:Kt,Z_FINISH:Pt,Z_OK:Yt,Z_STREAM_END:Gt,Z_DEFAULT_COMPRESSION:Xt,Z_DEFAULT_STRATEGY:Wt,Z_DEFLATED:qt}=B;function Jt(t){this.options=Tt({level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=St.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==Yt)throw new Error(I[a]);if(e.header&&St.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?Nt(e.dictionary):"[object ArrayBuffer]"===Ht.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,a=St.deflateSetDictionary(this.strm,t),a!==Yt)throw new Error(I[a]);this._dict_set=!0}}function Qt(t,e){const a=new Jt(e);if(a.push(t,!0),a.err)throw a.msg||I[a.err];return a.result}Jt.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize;let n,s;if(this.ended)return!1;for(s=e===~~e?e:!0===e?Pt:Mt,"string"==typeof t?a.input=Nt(t):"[object ArrayBuffer]"===Ht.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),(s===jt||s===Kt)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else{if(n=St.deflate(a,s),n===Gt)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),n=St.deflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===Yt;if(0!==a.avail_out){if(s>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===Yt&&(this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var Vt={Deflate:Jt,deflate:Qt,deflateRaw:function(t,e){return(e=e||{}).raw=!0,Qt(t,e)},gzip:function(t,e){return(e=e||{}).gzip=!0,Qt(t,e)},constants:B};var $t=function(t,e){let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,i=a+(t.avail_in-5),n=t.next_out,A=t.output,s=n-(e-t.avail_out),r=n+(t.avail_out-257),o=E.dmax,l=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,m=(1<<E.lenbits)-1,b=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=u[f&m];e:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,0===p)A[n++]=65535&g;else{if(!(16&p)){if(0==(64&p)){g=u[(65535&g)+(f&(1<<p)-1)];continue e}if(32&p){E.mode=16191;break t}t.msg="invalid literal/length code",E.mode=16209;break t}k=65535&g,p&=15,p&&(c<p&&(f+=z[a++]<<c,c+=8),k+=f&(1<<p)-1,f>>>=p,c-=p),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=w[f&b];a:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,!(16&p)){if(0==(64&p)){g=w[(65535&g)+(f&(1<<p)-1)];continue a}t.msg="invalid distance code",E.mode=16209;break t}if(v=65535&g,p&=15,c<p&&(f+=z[a++]<<c,c+=8,c<p&&(f+=z[a++]<<c,c+=8)),v+=f&(1<<p)-1,v>o){t.msg="invalid distance too far back",E.mode=16209;break t}if(f>>>=p,c-=p,p=n-s,v>p){if(p=v-p,p>h&&E.sane){t.msg="invalid distance too far back",E.mode=16209;break t}if(y=0,x=_,0===d){if(y+=l-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}else if(d<p){if(y+=l+d-p,p-=d,p<k){k-=p;do{A[n++]=_[y++]}while(--p);if(y=0,d<k){p=d,k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}}else if(y+=d-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}for(;k>2;)A[n++]=x[y++],A[n++]=x[y++],A[n++]=x[y++],k-=3;k&&(A[n++]=x[y++],k>1&&(A[n++]=x[y++]))}else{y=n-v;do{A[n++]=A[y++],A[n++]=A[y++],A[n++]=A[y++],k-=3}while(k>2);k&&(A[n++]=A[y++],k>1&&(A[n++]=A[y++]))}break}}break}}while(a<i&&n<r);k=c>>3,a-=k,c-=k<<3,f&=(1<<c)-1,t.next_in=a,t.next_out=n,t.avail_in=a<i?i-a+5:5-(a-i),t.avail_out=n<r?r-n+257:257-(n-r),E.hold=f,E.bits=c};const te=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),ee=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),ae=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),ie=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var ne=(t,e,a,i,n,s,r,o)=>{const l=o.bits;let h,d,_,f,c,u,w=0,m=0,b=0,g=0,p=0,k=0,v=0,y=0,x=0,z=0,A=null;const E=new Uint16Array(16),R=new Uint16Array(16);let Z,U,S,D=null;for(w=0;w<=15;w++)E[w]=0;for(m=0;m<i;m++)E[e[a+m]]++;for(p=l,g=15;g>=1&&0===E[g];g--);if(p>g&&(p=g),0===g)return n[s++]=20971520,n[s++]=20971520,o.bits=1,0;for(b=1;b<g&&0===E[b];b++);for(p<b&&(p=b),y=1,w=1;w<=15;w++)if(y<<=1,y-=E[w],y<0)return-1;if(y>0&&(0===t||1!==g))return-1;for(R[1]=0,w=1;w<15;w++)R[w+1]=R[w]+E[w];for(m=0;m<i;m++)0!==e[a+m]&&(r[R[e[a+m]]++]=m);if(0===t?(A=D=r,u=20):1===t?(A=te,D=ee,u=257):(A=ae,D=ie,u=0),z=0,m=0,w=b,c=s,k=p,v=0,_=-1,x=1<<p,f=x-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){Z=w-v,r[m]+1<u?(U=0,S=r[m]):r[m]>=u?(U=D[r[m]-u],S=A[r[m]-u]):(U=96,S=0),h=1<<w-v,d=1<<k,b=d;do{d-=h,n[c+(z>>v)+d]=Z<<24|U<<16|S|0}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,m++,0==--E[w]){if(w===g)break;w=e[a+r[m]]}if(w>p&&(z&f)!==_){for(0===v&&(v=p),c+=b,k=w-v,y=1<<k;k+v<g&&(y-=E[k+v],!(y<=0));)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;_=z&f,n[_]=p<<24|k<<16|c-s|0}}return 0!==z&&(n[c+z]=w-v<<24|64<<16|0),o.bits=p,0};const{Z_FINISH:se,Z_BLOCK:re,Z_TREES:oe,Z_OK:le,Z_STREAM_END:he,Z_NEED_DICT:de,Z_STREAM_ERROR:_e,Z_DATA_ERROR:fe,Z_MEM_ERROR:ce,Z_BUF_ERROR:ue,Z_DEFLATED:we}=B,me=16209,be=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function ge(){this.strm=null,this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}const pe=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||e.mode<16180||e.mode>16211?1:0},ke=t=>{if(pe(t))return _e;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=16180,e.last=0,e.havedict=0,e.flags=-1,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,le},ve=t=>{if(pe(t))return _e;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,ke(t)},ye=(t,e)=>{let a;if(pe(t))return _e;const i=t.state;return e<0?(a=0,e=-e):(a=5+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?_e:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=a,i.wbits=e,ve(t))},xe=(t,e)=>{if(!t)return _e;const a=new ge;t.state=a,a.strm=t,a.window=null,a.mode=16180;const i=ye(t,e);return i!==le&&(t.state=null),i};let ze,Ae,Ee=!0;const Re=t=>{if(Ee){ze=new Int32Array(512),Ae=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(ne(1,t.lens,0,288,ze,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;ne(2,t.lens,0,32,Ae,0,t.work,{bits:5}),Ee=!1}t.lencode=ze,t.lenbits=9,t.distcode=Ae,t.distbits=5},Ze=(t,e,a,i)=>{let n;const s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new Uint8Array(s.wsize)),i>=s.wsize?(s.window.set(e.subarray(a-s.wsize,a),0),s.wnext=0,s.whave=s.wsize):(n=s.wsize-s.wnext,n>i&&(n=i),s.window.set(e.subarray(a-i,a-i+n),s.wnext),(i-=n)?(s.window.set(e.subarray(a-i,a),0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0};var Ue={inflateReset:ve,inflateReset2:ye,inflateResetKeep:ke,inflateInit:t=>xe(t,15),inflateInit2:xe,inflate:(t,e)=>{let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(pe(t)||!t.output||!t.input&&0!==t.avail_in)return _e;a=t.state,16191===a.mode&&(a.mode=16192),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,_=o,f=l,x=le;t:for(;;)switch(a.mode){case 16180:if(0===a.wrap){a.mode=16192;break}for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(2&a.wrap&&35615===h){0===a.wbits&&(a.wbits=15),a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0),h=0,d=0,a.mode=16181;break}if(a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=me;break}if((15&h)!==we){t.msg="unknown compression method",a.mode=me;break}if(h>>>=4,d-=4,y=8+(15&h),0===a.wbits&&(a.wbits=y),y>15||y>a.wbits){t.msg="invalid window size",a.mode=me;break}a.dmax=1<<a.wbits,a.flags=0,t.adler=a.check=1,a.mode=512&h?16189:16191,h=0,d=0;break;case 16181:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.flags=h,(255&a.flags)!==we){t.msg="unknown compression method",a.mode=me;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=me;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16182;case 16182:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.time=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=N(a.check,A,4,0)),h=0,d=0,a.mode=16183;case 16183:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16184;case 16184:if(1024&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0}else a.head&&(a.head.extra=null);a.mode=16185;case 16185:if(1024&a.flags&&(c=a.length,c>o&&(c=o),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(i.subarray(s,s+c),y)),512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,a.length-=c),a.length))break t;a.length=0,a.mode=16186;case 16186:if(2048&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=16187;case 16187:if(4096&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=16188;case 16188:if(512&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=me;break}h=0,d=0}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=16191;break;case 16189:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}t.adler=a.check=be(h),h=0,d=0,a.mode=16190;case 16190:if(0===a.havedict)return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,de;t.adler=a.check=1,a.mode=16191;case 16191:if(e===re||e===oe)break t;case 16192:if(a.last){h>>>=7&d,d-=7&d,a.mode=16206;break}for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}switch(a.last=1&h,h>>>=1,d-=1,3&h){case 0:a.mode=16193;break;case 1:if(Re(a),a.mode=16199,e===oe){h>>>=2,d-=2;break t}break;case 2:a.mode=16196;break;case 3:t.msg="invalid block type",a.mode=me}h>>>=2,d-=2;break;case 16193:for(h>>>=7&d,d-=7&d;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=me;break}if(a.length=65535&h,h=0,d=0,a.mode=16194,e===oe)break t;case 16194:a.mode=16195;case 16195:if(c=a.length,c){if(c>o&&(c=o),c>l&&(c=l),0===c)break t;n.set(i.subarray(s,s+c),r),o-=c,s+=c,l-=c,r+=c,a.length-=c;break}a.mode=16191;break;case 16196:for(;d<14;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=me;break}a.have=0,a.mode=16197;case 16197:for(;a.have<a.ncode;){for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=ne(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=me;break}a.have=0,a.mode=16198;case 16198:for(;a.have<a.nlen+a.ndist;){for(;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(g<16)h>>>=m,d-=m,a.lens[a.have++]=g;else{if(16===g){for(R=m+2;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(h>>>=m,d-=m,0===a.have){t.msg="invalid bit length repeat",a.mode=me;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2}else if(17===g){for(R=m+3;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=3+(7&h),h>>>=3,d-=3}else{for(R=m+7;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=11+(127&h),h>>>=7,d-=7}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=me;break}for(;c--;)a.lens[a.have++]=y}}if(a.mode===me)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=me;break}if(a.lenbits=9,E={bits:a.lenbits},x=ne(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=me;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=ne(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=me;break}if(a.mode=16199,e===oe)break t;case 16199:a.mode=16200;case 16200:if(o>=6&&l>=258){t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,$t(t,f),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,16191===a.mode&&(a.back=-1);break}for(a.back=0;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(b&&0==(240&b)){for(p=m,k=b,v=g;z=a.lencode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,a.length=g,0===b){a.mode=16205;break}if(32&b){a.back=-1,a.mode=16191;break}if(64&b){t.msg="invalid literal/length code",a.mode=me;break}a.extra=15&b,a.mode=16201;case 16201:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}a.was=a.length,a.mode=16202;case 16202:for(;z=a.distcode[h&(1<<a.distbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(0==(240&b)){for(p=m,k=b,v=g;z=a.distcode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,64&b){t.msg="invalid distance code",a.mode=me;break}a.offset=g,a.extra=15&b,a.mode=16203;case 16203:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=me;break}a.mode=16204;case 16204:if(0===l)break t;if(c=f-l,a.offset>c){if(c=a.offset-c,c>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=me;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window}else w=n,u=r-a.offset,c=a.length;c>l&&(c=l),l-=c,a.length-=c;do{n[r++]=w[u++]}while(--c);0===a.length&&(a.mode=16200);break;case 16205:if(0===l)break t;n[r++]=a.length,l--,a.mode=16200;break;case 16206:if(a.wrap){for(;d<32;){if(0===o)break t;o--,h|=i[s++]<<d,d+=8}if(f-=l,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,r-f):F(a.check,n,f,r-f)),f=l,4&a.wrap&&(a.flags?h:be(h))!==a.check){t.msg="incorrect data check",a.mode=me;break}h=0,d=0}a.mode=16207;case 16207:if(a.wrap&&a.flags){for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=me;break}h=0,d=0}a.mode=16208;case 16208:x=he;break t;case me:x=fe;break t;case 16210:return ce;default:return _e}return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<me&&(a.mode<16206||e!==se))&&Ze(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,t.next_out-f):F(a.check,n,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(16191===a.mode?128:0)+(16199===a.mode||16194===a.mode?256:0),(0===_&&0===f||e===se)&&x===le&&(x=ue),x},inflateEnd:t=>{if(pe(t))return _e;let e=t.state;return e.window&&(e.window=null),t.state=null,le},inflateGetHeader:(t,e)=>{if(pe(t))return _e;const a=t.state;return 0==(2&a.wrap)?_e:(a.head=e,e.done=!1,le)},inflateSetDictionary:(t,e)=>{const a=e.length;let i,n,s;return pe(t)?_e:(i=t.state,0!==i.wrap&&16190!==i.mode?_e:16190===i.mode&&(n=1,n=F(n,e,a,0),n!==i.check)?fe:(s=Ze(t,e,a,a),s?(i.mode=16210,ce):(i.havedict=1,le)))},inflateInfo:"pako inflate (from Nodeca project)"};var Se=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1};const De=Object.prototype.toString,{Z_NO_FLUSH:Te,Z_FINISH:Oe,Z_OK:Fe,Z_STREAM_END:Le,Z_NEED_DICT:Ne,Z_STREAM_ERROR:Ie,Z_DATA_ERROR:Be,Z_MEM_ERROR:Ce}=B;function He(t){this.options=Tt({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=Ue.inflateInit2(this.strm,e.windowBits);if(a!==Fe)throw new Error(I[a]);if(this.header=new Se,Ue.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=Nt(e.dictionary):"[object ArrayBuffer]"===De.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Ue.inflateSetDictionary(this.strm,e.dictionary),a!==Fe)))throw new Error(I[a])}He.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize,n=this.options.dictionary;let s,r,o;if(this.ended)return!1;for(r=e===~~e?e:!0===e?Oe:Te,"[object ArrayBuffer]"===De.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),s=Ue.inflate(a,r),s===Ne&&n&&(s=Ue.inflateSetDictionary(a,n),s===Fe?s=Ue.inflate(a,r):s===Be&&(s=Ne));a.avail_in>0&&s===Le&&a.state.wrap>0&&0!==t[a.next_in];)Ue.inflateReset(a),s=Ue.inflate(a,r);switch(s){case Ie:case Be:case Ne:case Ce:return this.onEnd(s),this.ended=!0,!1}if(o=a.avail_out,a.next_out&&(0===a.avail_out||s===Le))if("string"===this.options.to){let t=Bt(a.output,a.next_out),e=a.next_out-t,n=It(a.output,t);a.next_out=e,a.avail_out=i-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(n)}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(s!==Fe||0!==o){if(s===Le)return s=Ue.inflateEnd(this.strm),this.onEnd(s),this.ended=!0,!0;if(0===a.avail_in)break}}return!0},He.prototype.onData=function(t){this.chunks.push(t)},He.prototype.onEnd=function(t){t===Fe&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};const{Deflate:Me,deflate:je,deflateRaw:Ke,gzip:Pe}=Vt;var Ye=Me,Ge=je,Xe=B;const We=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const e=this._hasEvents?",":"";this.deflate.push(e+t,Xe.Z_SYNC_FLUSH),this._hasEvents=!0}finish(){if(this.deflate.push("]",Xe.Z_FINISH),this.deflate.err)throw this.deflate.err;const t=this.deflate.result;return this._init(),t}_init(){this._hasEvents=!1,this.deflate=new Ye,this.deflate.push("[",Xe.Z_NO_FLUSH)}},qe={clear:()=>{We.clear()},addEvent:t=>We.addEvent(t),finish:()=>We.finish(),compress:t=>function(t){return Ge(t)}(t)};addEventListener("message",(function(t){const e=t.data.method,a=t.data.id,i=t.data.arg;if(e in qe&&"function"==typeof qe[e])try{const t=qe[e](i);postMessage({id:a,method:e,success:!0,response:t})}catch(t){postMessage({id:a,method:e,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;

function e(){const e=new Blob([r]);return URL.createObjectURL(e)}

/** This error indicates that the event buffer size exceeded the limit.. */
class EventBufferSizeExceededError extends Error {
   constructor() {
    super(`Event buffer exceeded maximum size of ${REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
  }
}

/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */
class EventBufferArray  {
  /** All the events that are buffered to be sent. */

   __init() {this._totalSize = 0;}

   constructor() {EventBufferArray.prototype.__init.call(this);
    this.events = [];
  }

  /** @inheritdoc */
   get hasEvents() {
    return this.events.length > 0;
  }

  /** @inheritdoc */
   get type() {
    return 'sync';
  }

  /** @inheritdoc */
   destroy() {
    this.events = [];
  }

  /** @inheritdoc */
   async addEvent(event) {
    const eventSize = JSON.stringify(event).length;
    this._totalSize += eventSize;
    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      throw new EventBufferSizeExceededError();
    }

    this.events.push(event);
  }

  /** @inheritdoc */
   finish() {
    return new Promise(resolve => {
      // Make a copy of the events array reference and immediately clear the
      // events member so that we do not lose new events while uploading
      // attachment.
      const eventsRet = this.events;
      this.clear();
      resolve(JSON.stringify(eventsRet));
    });
  }

  /** @inheritdoc */
   clear() {
    this.events = [];
    this._totalSize = 0;
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    const timestamp = this.events.map(event => event.timestamp).sort()[0];

    if (!timestamp) {
      return null;
    }

    return timestampToMs(timestamp);
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class WorkerHandler {

   constructor(worker) {
    this._worker = worker;
    this._id = 0;
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
   ensureReady() {
    // Ensure we only check once
    if (this._ensureReadyPromise) {
      return this._ensureReadyPromise;
    }

    this._ensureReadyPromise = new Promise((resolve, reject) => {
      this._worker.addEventListener(
        'message',
        ({ data }) => {
          if ((data ).success) {
            resolve();
          } else {
            reject();
          }
        },
        { once: true },
      );

      this._worker.addEventListener(
        'error',
        error => {
          reject(error);
        },
        { once: true },
      );
    });

    return this._ensureReadyPromise;
  }

  /**
   * Destroy the worker.
   */
   destroy() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Destroying compression worker');
    this._worker.terminate();
  }

  /**
   * Post message to worker and wait for response before resolving promise.
   */
   postMessage(method, arg) {
    const id = this._getAndIncrementId();

    return new Promise((resolve, reject) => {
      const listener = ({ data }) => {
        const response = data ;
        if (response.method !== method) {
          return;
        }

        // There can be multiple listeners for a single method, the id ensures
        // that the response matches the caller.
        if (response.id !== id) {
          return;
        }

        // At this point, we'll always want to remove listener regardless of result status
        this._worker.removeEventListener('message', listener);

        if (!response.success) {
          // TODO: Do some error handling, not sure what
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay]', response.response);

          reject(new Error('Error in compression worker'));
          return;
        }

        resolve(response.response );
      };

      // Note: we can't use `once` option because it's possible it needs to
      // listen to multiple messages
      this._worker.addEventListener('message', listener);
      this._worker.postMessage({ id, method, arg });
    });
  }

  /** Get the current ID and increment it for the next call. */
   _getAndIncrementId() {
    return this._id++;
  }
}

/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */
class EventBufferCompressionWorker  {

   __init() {this._totalSize = 0;}

   constructor(worker) {EventBufferCompressionWorker.prototype.__init.call(this);
    this._worker = new WorkerHandler(worker);
    this._earliestTimestamp = null;
  }

  /** @inheritdoc */
   get hasEvents() {
    return !!this._earliestTimestamp;
  }

  /** @inheritdoc */
   get type() {
    return 'worker';
  }

  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
   ensureReady() {
    return this._worker.ensureReady();
  }

  /**
   * Destroy the event buffer.
   */
   destroy() {
    this._worker.destroy();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */
   addEvent(event) {
    const timestamp = timestampToMs(event.timestamp);
    if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) {
      this._earliestTimestamp = timestamp;
    }

    const data = JSON.stringify(event);
    this._totalSize += data.length;

    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      return Promise.reject(new EventBufferSizeExceededError());
    }

    return this._sendEventToWorker(data);
  }

  /**
   * Finish the event buffer and return the compressed data.
   */
   finish() {
    return this._finishRequest();
  }

  /** @inheritdoc */
   clear() {
    this._earliestTimestamp = null;
    this._totalSize = 0;
    // We do not wait on this, as we assume the order of messages is consistent for the worker
    void this._worker.postMessage('clear');
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    return this._earliestTimestamp;
  }

  /**
   * Send the event to the worker.
   */
   _sendEventToWorker(data) {
    return this._worker.postMessage('addEvent', data);
  }

  /**
   * Finish the request and return the compressed data from the worker.
   */
   async _finishRequest() {
    const response = await this._worker.postMessage('finish');

    this._earliestTimestamp = null;
    this._totalSize = 0;

    return response;
  }
}

/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */
class EventBufferProxy  {

   constructor(worker) {
    this._fallback = new EventBufferArray();
    this._compression = new EventBufferCompressionWorker(worker);
    this._used = this._fallback;

    this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }

  /** @inheritdoc */
   get type() {
    return this._used.type;
  }

  /** @inheritDoc */
   get hasEvents() {
    return this._used.hasEvents;
  }

  /** @inheritDoc */
   destroy() {
    this._fallback.destroy();
    this._compression.destroy();
  }

  /** @inheritdoc */
   clear() {
    return this._used.clear();
  }

  /** @inheritdoc */
   getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }

  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
   addEvent(event) {
    return this._used.addEvent(event);
  }

  /** @inheritDoc */
   async finish() {
    // Ensure the worker is loaded, so the sent event is compressed
    await this.ensureWorkerIsLoaded();

    return this._used.finish();
  }

  /** Ensure the worker has loaded. */
   ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }

  /** Actually check if the worker has been loaded. */
   async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (error) {
      // If the worker fails to load, we fall back to the simple buffer.
      // Nothing more to do from our side here
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Failed to load the compression worker, falling back to simple buffer');
      return;
    }

    // Now we need to switch over the array buffer to the compression worker
    await this._switchToCompressionWorker();
  }

  /** Switch the used buffer to the compression worker. */
   async _switchToCompressionWorker() {
    const { events } = this._fallback;

    const addEventPromises = [];
    for (const event of events) {
      addEventPromises.push(this._compression.addEvent(event));
    }

    // We switch over to the new buffer immediately - any further events will be added
    // after the previously buffered ones
    this._used = this._compression;

    // Wait for original events to be re-added before resolving
    try {
      await Promise.all(addEventPromises);
    } catch (error) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Replay] Failed to add events when switching buffers.', error);
    }
  }
}

/**
 * Create an event buffer for replays.
 */
function createEventBuffer({ useCompression }) {
  // eslint-disable-next-line no-restricted-globals
  if (useCompression && window.Worker) {
    try {
      const workerUrl = e();

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Using compression worker');
      const worker = new Worker(workerUrl);
      return new EventBufferProxy(worker);
    } catch (error) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Failed to create compression worker');
      // Fall back to use simple event buffer array
    }
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Using simple buffer');
  return new EventBufferArray();
}

/** If sessionStorage is available. */
function hasSessionStorage() {
  try {
    // This can throw, e.g. when being accessed in a sandboxed iframe
    return 'sessionStorage' in WINDOW && !!WINDOW.sessionStorage;
  } catch (e) {
    return false;
  }
}

/**
 * Removes the session from Session Storage and unsets session in replay instance
 */
function clearSession(replay) {
  deleteSession();
  replay.session = undefined;
}

/**
 * Deletes a session from storage
 */
function deleteSession() {
  if (!hasSessionStorage()) {
    return;
  }

  try {
    WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */
function isExpired(
  initialTime,
  expiry,
  targetTime = +new Date(),
) {
  // Always expired if < 0
  if (initialTime === null || expiry === undefined || expiry < 0) {
    return true;
  }

  // Never expires if == 0
  if (expiry === 0) {
    return false;
  }

  return initialTime + expiry <= targetTime;
}

/**
 * Checks to see if session is expired
 */
function isSessionExpired(session, timeouts, targetTime = +new Date()) {
  return (
    // First, check that maximum session length has not been exceeded
    isExpired(session.started, timeouts.maxSessionLife, targetTime) ||
    // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, timeouts.sessionIdleExpire, targetTime)
  );
}

/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */
function isSampled(sampleRate) {
  if (sampleRate === undefined) {
    return false;
  }

  // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
  return Math.random() < sampleRate;
}

/**
 * Save a session to session storage.
 */
function saveSession(session) {
  if (!hasSessionStorage()) {
    return;
  }

  try {
    WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
  } catch (e) {
    // Ignore potential SecurityError exceptions
  }
}

/**
 * Get a session with defaults & applied sampling.
 */
function makeSession(session) {
  const now = Date.now();
  const id = session.id || (0,misc/* uuid4 */.DM)();
  // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
  const started = session.started || now;
  const lastActivity = session.lastActivity || now;
  const segmentId = session.segmentId || 0;
  const sampled = session.sampled;

  return {
    id,
    started,
    lastActivity,
    segmentId,
    sampled,
    shouldRefresh: true,
  };
}

/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */
function getSessionSampleType(sessionSampleRate, allowBuffering) {
  return isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}

/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */
function createSession({ sessionSampleRate, allowBuffering, stickySession = false }) {
  const sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
  const session = makeSession({
    sampled,
  });

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Replay] Creating new session: ${session.id}`);

  if (stickySession) {
    saveSession(session);
  }

  return session;
}

/**
 * Fetches a session from storage
 */
function fetchSession() {
  if (!hasSessionStorage()) {
    return null;
  }

  try {
    // This can throw if cookies are disabled
    const sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);

    if (!sessionStringFromStorage) {
      return null;
    }

    const sessionObj = JSON.parse(sessionStringFromStorage) ;

    return makeSession(sessionObj);
  } catch (e) {
    return null;
  }
}

/**
 * Get or create a session
 */
function getSession({
  timeouts,
  currentSession,
  stickySession,
  sessionSampleRate,
  allowBuffering,
}) {
  // If session exists and is passed, use it instead of always hitting session storage
  const session = currentSession || (stickySession && fetchSession());

  if (session) {
    // If there is a session, check if it is valid (e.g. "last activity" time
    // should be within the "session idle time", and "session started" time is
    // within "max session time").
    const isExpired = isSessionExpired(session, timeouts);

    if (!isExpired || (allowBuffering && session.shouldRefresh)) {
      return { type: 'saved', session };
    } else if (!session.shouldRefresh) {
      // This is the case if we have an error session that is completed
      // (=triggered an error). Session will continue as session-based replay,
      // and when this session is expired, it will not be renewed until user
      // reloads.
      const discardedSession = makeSession({ sampled: false });
      return { type: 'new', session: discardedSession };
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Session has expired');
    }
    // Otherwise continue to create a new session
  }

  const newSession = createSession({
    stickySession,
    sessionSampleRate,
    allowBuffering,
  });

  return { type: 'new', session: newSession };
}

function isCustomEvent(event) {
  return event.type === EventType.Custom;
}

/**
 * Add an event to the event buffer.
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */
async function addEvent(
  replay,
  event,
  isCheckout,
) {
  if (!replay.eventBuffer) {
    // This implies that `_isEnabled` is false
    return null;
  }

  if (replay.isPaused()) {
    // Do not add to event buffer when recording is paused
    return null;
  }

  const timestampInMs = timestampToMs(event.timestamp);

  // Throw out events that happen more than 5 minutes ago. This can happen if
  // page has been left open and idle for a long period of time and user
  // comes back to trigger a new session. The performance entries rely on
  // `performance.timeOrigin`, which is when the page first opened.
  if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) {
    return null;
  }

  try {
    if (isCheckout) {
      replay.eventBuffer.clear();
    }

    const replayOptions = replay.getOptions();

    const eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);

    if (!eventAfterPossibleCallback) {
      return;
    }

    return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
  } catch (error) {
    const reason = error && error instanceof EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error(error);
    await replay.stop(reason);

    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

    if (client) {
      client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
  }
}

function maybeApplyCallback(
  event,
  callback,
) {
  try {
    if (typeof callback === 'function' && isCustomEvent(event)) {
      return callback(event);
    }
  } catch (error) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...', error);
    return null;
  }

  return event;
}

/** If the event is an error event */
function isErrorEvent(event) {
  return !event.type;
}

/** If the event is a transaction event */
function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/** If the event is an replay event */
function isReplayEvent(event) {
  return event.type === 'replay_event';
}

/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */
function handleAfterSendEvent(replay) {
  // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
  // TODO (v8): remove this check as it will no longer be necessary
  const enforceStatusCode = isBaseTransportSend();

  return (event, sendResponse) => {
    if (!isErrorEvent(event) && !isTransactionEvent(event)) {
      return;
    }

    const statusCode = sendResponse && sendResponse.statusCode;

    // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
    // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
    // If we do use the base transport, we skip if we encountered an non-OK status code
    if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) {
      return;
    }

    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    if (isTransactionEvent(event) && event.contexts && event.contexts.trace && event.contexts.trace.trace_id) {
      replay.getContext().traceIds.add(event.contexts.trace.trace_id );
      return;
    }

    // Everything below is just for error events
    if (!isErrorEvent(event)) {
      return;
    }

    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    if (event.event_id) {
      replay.getContext().errorIds.add(event.event_id);
    }

    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode === 'buffer' && event.tags && event.tags.replayId) {
      setTimeout(() => {
        // Capture current event buffer as new replay
        void replay.sendBufferedReplayOrFlush();
      });
    }
  };
}

function isBaseTransportSend() {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (!client) {
    return false;
  }

  const transport = client.getTransport();
  if (!transport) {
    return false;
  }

  return (
    (transport.send ).__sentry__baseTransport__ || false
  );
}

/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */
function isRrwebError(event, hint) {
  if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) {
    return false;
  }

  // @ts-ignore this may be set by rrweb when it finds errors
  if (hint.originalException && hint.originalException.__rrweb__) {
    return true;
  }

  // Check if any exception originates from rrweb
  return event.exception.values.some(exception => {
    if (!exception.stacktrace || !exception.stacktrace.frames || !exception.stacktrace.frames.length) {
      return false;
    }

    return exception.stacktrace.frames.some(frame => frame.filename && frame.filename.includes('/rrweb/src/'));
  });
}

/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */
function shouldSampleForBufferEvent(replay, event) {
  if (replay.recordingMode !== 'buffer') {
    return false;
  }

  // ignore this error because otherwise we could loop indefinitely with
  // trying to capture replay and failing
  if (event.message === UNABLE_TO_SEND_REPLAY) {
    return false;
  }

  // Require the event to be an error event & to have an exception
  if (!event.exception || event.type) {
    return false;
  }

  return isSampled(replay.getOptions().errorSampleRate);
}

/**
 * Returns a listener to be added to `addGlobalEventProcessor(listener)`.
 */
function handleGlobalEventListener(
  replay,
  includeAfterSendEventHandling = false,
) {
  const afterSendHandler = includeAfterSendEventHandling ? handleAfterSendEvent(replay) : undefined;

  return (event, hint) => {
    if (isReplayEvent(event)) {
      // Replays have separate set of breadcrumbs, do not include breadcrumbs
      // from core SDK
      delete event.breadcrumbs;
      return event;
    }

    // We only want to handle errors & transactions, nothing else
    if (!isErrorEvent(event) && !isTransactionEvent(event)) {
      return event;
    }

    // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
    // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
    if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Ignoring error from rrweb internals', event);
      return null;
    }

    // When in buffer mode, we decide to sample here.
    // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
    // And convert the buffer session to a full session
    const isErrorEventSampled = shouldSampleForBufferEvent(replay, event);

    // Tag errors if it has been sampled in buffer mode, or if it is session mode
    // Only tag transactions if in session mode
    const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';

    if (shouldTagReplayId) {
      event.tags = { ...event.tags, replayId: replay.getSessionId() };
    }

    // In cases where a custom client is used that does not support the new hooks (yet),
    // we manually call this hook method here
    if (afterSendHandler) {
      // Pretend the error had a 200 response so we always capture it
      afterSendHandler(event, { statusCode: 200 });
    }

    return event;
  };
}

/**
 * Create a "span" for each performance entry.
 */
function createPerformanceSpans(
  replay,
  entries,
) {
  return entries.map(({ type, start, end, name, data }) => {
    const response = replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: start,
      data: {
        tag: 'performanceSpan',
        payload: {
          op: type,
          description: name,
          startTimestamp: start,
          endTimestamp: end,
          data,
        },
      },
    });

    // If response is a string, it means its either THROTTLED or SKIPPED
    return typeof response === 'string' ? Promise.resolve(null) : response;
  });
}

function handleHistory(handlerData) {
  const { from, to } = handlerData;

  const now = Date.now() / 1000;

  return {
    type: 'navigation.push',
    start: now,
    end: now,
    name: to,
    data: {
      previous: from,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('history', listener)`.
 */
function handleHistorySpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleHistory(handlerData);

    if (result === null) {
      return;
    }

    // Need to collect visited URLs
    replay.getContext().urls.push(result.name);
    replay.triggerUserActivity();

    replay.addUpdate(() => {
      createPerformanceSpans(replay, [result]);
      // Returning false to flush
      return false;
    });
  };
}

/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */
function shouldFilterRequest(replay, url) {
  // If we enabled the `traceInternals` experiment, we want to trace everything
  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals) {
    return false;
  }

  return _isSentryRequest(url);
}

/**
 * Checks wether a given URL belongs to the configured Sentry DSN.
 */
function _isSentryRequest(url) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const dsn = client && client.getDsn();
  return dsn ? url.includes(dsn.host) : false;
}

/** Add a performance entry breadcrumb */
function addNetworkBreadcrumb(
  replay,
  result,
) {
  if (!replay.isEnabled()) {
    return;
  }

  if (result === null) {
    return;
  }

  if (shouldFilterRequest(replay, result.name)) {
    return;
  }

  replay.addUpdate(() => {
    createPerformanceSpans(replay, [result]);
    // Returning true will cause `addUpdate` to not flush
    // We do not want network requests to cause a flush. This will prevent
    // recurring/polling requests from keeping the replay session alive.
    return true;
  });
}

/** only exported for tests */
function handleFetch(handlerData) {
  const { startTimestamp, endTimestamp, fetchData, response } = handlerData;

  if (!endTimestamp) {
    return null;
  }

  // This is only used as a fallback, so we know the body sizes are never set here
  const { method, url } = fetchData;

  return {
    type: 'resource.fetch',
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: url,
    data: {
      method,
      statusCode: response ? (response ).status : undefined,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('fetch', listener)`.
 */
function handleFetchSpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleFetch(handlerData);

    addNetworkBreadcrumb(replay, result);
  };
}

/** only exported for tests */
function handleXhr(handlerData) {
  const { startTimestamp, endTimestamp, xhr } = handlerData;

  const sentryXhrData = xhr[instrument/* SENTRY_XHR_DATA_KEY */.xU];

  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return null;
  }

  // This is only used as a fallback, so we know the body sizes are never set here
  const { method, url, status_code: statusCode } = sentryXhrData;

  if (url === undefined) {
    return null;
  }

  return {
    type: 'resource.xhr',
    name: url,
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    data: {
      method,
      statusCode,
    },
  };
}

/**
 * Returns a listener to be added to `addInstrumentationHandler('xhr', listener)`.
 */
function handleXhrSpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleXhr(handlerData);

    addNetworkBreadcrumb(replay, result);
  };
}

const OBJ = 10;
const OBJ_KEY = 11;
const OBJ_KEY_STR = 12;
const OBJ_VAL = 13;
const OBJ_VAL_STR = 14;
const OBJ_VAL_COMPLETED = 15;

const ARR = 20;
const ARR_VAL = 21;
const ARR_VAL_STR = 22;
const ARR_VAL_COMPLETED = 23;

const ALLOWED_PRIMITIVES = ['true', 'false', 'null'];

/**
 * Complete an incomplete JSON string.
 * This will ensure that the last element always has a `"~~"` to indicate it was truncated.
 * For example, `[1,2,` will be completed to `[1,2,"~~"]`
 * and `{"aa":"b` will be completed to `{"aa":"b~~"}`
 */
function completeJson(incompleteJson, stack) {
  if (!stack.length) {
    return incompleteJson;
  }

  let json = incompleteJson;

  // Most checks are only needed for the last step in the stack
  const lastPos = stack.length - 1;
  const lastStep = stack[lastPos];

  json = _fixLastStep(json, lastStep);

  // Complete remaining steps - just add closing brackets
  for (let i = lastPos; i >= 0; i--) {
    const step = stack[i];

    switch (step) {
      case OBJ:
        json = `${json}}`;
        break;
      case ARR:
        json = `${json}]`;
        break;
    }
  }

  return json;
}

function _fixLastStep(json, lastStep) {
  switch (lastStep) {
    // Object cases
    case OBJ:
      return `${json}"~~":"~~"`;
    case OBJ_KEY:
      return `${json}:"~~"`;
    case OBJ_KEY_STR:
      return `${json}~~":"~~"`;
    case OBJ_VAL:
      return _maybeFixIncompleteObjValue(json);
    case OBJ_VAL_STR:
      return `${json}~~"`;
    case OBJ_VAL_COMPLETED:
      return `${json},"~~":"~~"`;

    // Array cases
    case ARR:
      return `${json}"~~"`;
    case ARR_VAL:
      return _maybeFixIncompleteArrValue(json);
    case ARR_VAL_STR:
      return `${json}~~"`;
    case ARR_VAL_COMPLETED:
      return `${json},"~~"`;
  }

  return json;
}

function _maybeFixIncompleteArrValue(json) {
  const pos = _findLastArrayDelimiter(json);

  if (pos > -1) {
    const part = json.slice(pos + 1);

    if (ALLOWED_PRIMITIVES.includes(part.trim())) {
      return `${json},"~~"`;
    }

    // Everything else is replaced with `"~~"`
    return `${json.slice(0, pos + 1)}"~~"`;
  }

  // fallback, this shouldn't happen, to be save
  return json;
}

function _findLastArrayDelimiter(json) {
  for (let i = json.length - 1; i >= 0; i--) {
    const char = json[i];

    if (char === ',' || char === '[') {
      return i;
    }
  }

  return -1;
}

function _maybeFixIncompleteObjValue(json) {
  const startPos = json.lastIndexOf(':');

  const part = json.slice(startPos + 1);

  if (ALLOWED_PRIMITIVES.includes(part.trim())) {
    return `${json},"~~":"~~"`;
  }

  // Everything else is replaced with `"~~"`
  // This also means we do not have incomplete numbers, e.g `[1` is replaced with `["~~"]`
  return `${json.slice(0, startPos + 1)}"~~"`;
}

/**
 * Evaluate an (incomplete) JSON string.
 */
function evaluateJson(json) {
  const stack = [];

  for (let pos = 0; pos < json.length; pos++) {
    _evaluateJsonPos(stack, json, pos);
  }

  return stack;
}

function _evaluateJsonPos(stack, json, pos) {
  const curStep = stack[stack.length - 1];

  const char = json[pos];

  const whitespaceRegex = /\s/;

  if (whitespaceRegex.test(char)) {
    return;
  }

  if (char === '"' && !_isEscaped(json, pos)) {
    _handleQuote(stack, curStep);
    return;
  }

  switch (char) {
    case '{':
      _handleObj(stack, curStep);
      break;
    case '[':
      _handleArr(stack, curStep);
      break;
    case ':':
      _handleColon(stack, curStep);
      break;
    case ',':
      _handleComma(stack, curStep);
      break;
    case '}':
      _handleObjClose(stack, curStep);
      break;
    case ']':
      _handleArrClose(stack, curStep);
      break;
  }
}

function _handleQuote(stack, curStep) {
  // End of obj value
  if (curStep === OBJ_VAL_STR) {
    stack.pop();
    stack.push(OBJ_VAL_COMPLETED);
    return;
  }

  // End of arr value
  if (curStep === ARR_VAL_STR) {
    stack.pop();
    stack.push(ARR_VAL_COMPLETED);
    return;
  }

  // Start of obj value
  if (curStep === OBJ_VAL) {
    stack.push(OBJ_VAL_STR);
    return;
  }

  // Start of arr value
  if (curStep === ARR_VAL) {
    stack.push(ARR_VAL_STR);
    return;
  }

  // Start of obj key
  if (curStep === OBJ) {
    stack.push(OBJ_KEY_STR);
    return;
  }

  // End of obj key
  if (curStep === OBJ_KEY_STR) {
    stack.pop();
    stack.push(OBJ_KEY);
    return;
  }
}

function _handleObj(stack, curStep) {
  // Initial object
  if (!curStep) {
    stack.push(OBJ);
    return;
  }

  // New object as obj value
  if (curStep === OBJ_VAL) {
    stack.push(OBJ);
    return;
  }

  // New object as array element
  if (curStep === ARR_VAL) {
    stack.push(OBJ);
  }

  // New object as first array element
  if (curStep === ARR) {
    stack.push(OBJ);
    return;
  }
}

function _handleArr(stack, curStep) {
  // Initial array
  if (!curStep) {
    stack.push(ARR);
    stack.push(ARR_VAL);
    return;
  }

  // New array as obj value
  if (curStep === OBJ_VAL) {
    stack.push(ARR);
    stack.push(ARR_VAL);
    return;
  }

  // New array as array element
  if (curStep === ARR_VAL) {
    stack.push(ARR);
    stack.push(ARR_VAL);
  }

  // New array as first array element
  if (curStep === ARR) {
    stack.push(ARR);
    stack.push(ARR_VAL);
    return;
  }
}

function _handleColon(stack, curStep) {
  if (curStep === OBJ_KEY) {
    stack.pop();
    stack.push(OBJ_VAL);
  }
}

function _handleComma(stack, curStep) {
  // Comma after obj value
  if (curStep === OBJ_VAL) {
    stack.pop();
    return;
  }
  if (curStep === OBJ_VAL_COMPLETED) {
    // Pop OBJ_VAL_COMPLETED & OBJ_VAL
    stack.pop();
    stack.pop();
    return;
  }

  // Comma after arr value
  if (curStep === ARR_VAL) {
    // do nothing - basically we'd pop ARR_VAL but add it right back
    return;
  }

  if (curStep === ARR_VAL_COMPLETED) {
    // Pop ARR_VAL_COMPLETED
    stack.pop();

    // basically we'd pop ARR_VAL but add it right back
    return;
  }
}

function _handleObjClose(stack, curStep) {
  // Empty object {}
  if (curStep === OBJ) {
    stack.pop();
  }

  // Object with element
  if (curStep === OBJ_VAL) {
    // Pop OBJ_VAL, OBJ
    stack.pop();
    stack.pop();
  }

  // Obj with element
  if (curStep === OBJ_VAL_COMPLETED) {
    // Pop OBJ_VAL_COMPLETED, OBJ_VAL, OBJ
    stack.pop();
    stack.pop();
    stack.pop();
  }

  // if was obj value, complete it
  if (stack[stack.length - 1] === OBJ_VAL) {
    stack.push(OBJ_VAL_COMPLETED);
  }

  // if was arr value, complete it
  if (stack[stack.length - 1] === ARR_VAL) {
    stack.push(ARR_VAL_COMPLETED);
  }
}

function _handleArrClose(stack, curStep) {
  // Empty array []
  if (curStep === ARR) {
    stack.pop();
  }

  // Array with element
  if (curStep === ARR_VAL) {
    // Pop ARR_VAL, ARR
    stack.pop();
    stack.pop();
  }

  // Array with element
  if (curStep === ARR_VAL_COMPLETED) {
    // Pop ARR_VAL_COMPLETED, ARR_VAL, ARR
    stack.pop();
    stack.pop();
    stack.pop();
  }

  // if was obj value, complete it
  if (stack[stack.length - 1] === OBJ_VAL) {
    stack.push(OBJ_VAL_COMPLETED);
  }

  // if was arr value, complete it
  if (stack[stack.length - 1] === ARR_VAL) {
    stack.push(ARR_VAL_COMPLETED);
  }
}

function _isEscaped(str, pos) {
  const previousChar = str[pos - 1];

  return previousChar === '\\' && !_isEscaped(str, pos - 1);
}

/* eslint-disable max-lines */

/**
 * Takes an incomplete JSON string, and returns a hopefully valid JSON string.
 * Note that this _can_ fail, so you should check the return value is valid JSON.
 */
function fixJson(incompleteJson) {
  const stack = evaluateJson(incompleteJson);

  return completeJson(incompleteJson, stack);
}

/** Get the size of a body. */
function getBodySize(
  body,
  textEncoder,
) {
  if (!body) {
    return undefined;
  }

  try {
    if (typeof body === 'string') {
      return textEncoder.encode(body).length;
    }

    if (body instanceof URLSearchParams) {
      return textEncoder.encode(body.toString()).length;
    }

    if (body instanceof FormData) {
      const formDataStr = _serializeFormData(body);
      return textEncoder.encode(formDataStr).length;
    }

    if (body instanceof Blob) {
      return body.size;
    }

    if (body instanceof ArrayBuffer) {
      return body.byteLength;
    }

    // Currently unhandled types: ArrayBufferView, ReadableStream
  } catch (e) {
    // just return undefined
  }

  return undefined;
}

/** Convert a Content-Length header to number/undefined.  */
function parseContentLengthHeader(header) {
  if (!header) {
    return undefined;
  }

  const size = parseInt(header, 10);
  return isNaN(size) ? undefined : size;
}

/** Get the string representation of a body. */
function getBodyString(body) {
  if (typeof body === 'string') {
    return body;
  }

  if (body instanceof URLSearchParams) {
    return body.toString();
  }

  if (body instanceof FormData) {
    return _serializeFormData(body);
  }

  return undefined;
}

/** Convert ReplayNetworkRequestData to a PerformanceEntry. */
function makeNetworkReplayBreadcrumb(
  type,
  data,
) {
  if (!data) {
    return null;
  }

  const { startTimestamp, endTimestamp, url, method, statusCode, request, response } = data;

  const result = {
    type,
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: url,
    data: (0,object/* dropUndefinedKeys */.Jr)({
      method,
      statusCode,
      request,
      response,
    }),
  };

  return result;
}

/** Build the request or response part of a replay network breadcrumb that was skipped. */
function buildSkippedNetworkRequestOrResponse(bodySize) {
  return {
    headers: {},
    size: bodySize,
    _meta: {
      warnings: ['URL_SKIPPED'],
    },
  };
}

/** Build the request or response part of a replay network breadcrumb. */
function buildNetworkRequestOrResponse(
  headers,
  bodySize,
  body,
) {
  if (!bodySize && Object.keys(headers).length === 0) {
    return undefined;
  }

  if (!bodySize) {
    return {
      headers,
    };
  }

  if (!body) {
    return {
      headers,
      size: bodySize,
    };
  }

  const info = {
    headers,
    size: bodySize,
  };

  const { body: normalizedBody, warnings } = normalizeNetworkBody(body);
  info.body = normalizedBody;
  if (warnings.length > 0) {
    info._meta = {
      warnings,
    };
  }

  return info;
}

/** Filter a set of headers */
function getAllowedHeaders(headers, allowedHeaders) {
  return Object.keys(headers).reduce((filteredHeaders, key) => {
    const normalizedKey = key.toLowerCase();
    // Avoid putting empty strings into the headers
    if (allowedHeaders.includes(normalizedKey) && headers[key]) {
      filteredHeaders[normalizedKey] = headers[key];
    }
    return filteredHeaders;
  }, {});
}

function _serializeFormData(formData) {
  // This is a bit simplified, but gives us a decent estimate
  // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
  // @ts-ignore passing FormData to URLSearchParams actually works
  return new URLSearchParams(formData).toString();
}

function normalizeNetworkBody(body)

 {
  if (!body || typeof body !== 'string') {
    return {
      body,
      warnings: [],
    };
  }

  const exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;

  if (_strIsProbablyJson(body)) {
    try {
      const json = exceedsSizeLimit ? fixJson(body.slice(0, NETWORK_BODY_MAX_SIZE)) : body;
      const normalizedBody = JSON.parse(json);
      return {
        body: normalizedBody,
        warnings: exceedsSizeLimit ? ['JSON_TRUNCATED'] : [],
      };
    } catch (e3) {
      return {
        body: exceedsSizeLimit ? `${body.slice(0, NETWORK_BODY_MAX_SIZE)}…` : body,
        warnings: exceedsSizeLimit ? ['INVALID_JSON', 'TEXT_TRUNCATED'] : ['INVALID_JSON'],
      };
    }
  }

  return {
    body: exceedsSizeLimit ? `${body.slice(0, NETWORK_BODY_MAX_SIZE)}…` : body,
    warnings: exceedsSizeLimit ? ['TEXT_TRUNCATED'] : [],
  };
}

function _strIsProbablyJson(str) {
  const first = str[0];
  const last = str[str.length - 1];

  // Simple check: If this does not start & end with {} or [], it's not JSON
  return (first === '[' && last === ']') || (first === '{' && last === '}');
}

/** Match an URL against a list of strings/Regex. */
function urlMatches(url, urls) {
  const fullUrl = getFullUrl(url);

  return (0,string/* stringMatchesSomePattern */.U0)(fullUrl, urls);
}

/** exported for tests */
function getFullUrl(url, baseURI = WINDOW.document.baseURI) {
  // Short circuit for common cases:
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith(WINDOW.location.origin)) {
    return url;
  }
  const fixedUrl = new URL(url, baseURI);

  // If these do not match, we are not dealing with a relative URL, so just return it
  if (fixedUrl.origin !== new URL(baseURI).origin) {
    return url;
  }

  const fullUrl = fixedUrl.href;

  // Remove trailing slashes, if they don't match the original URL
  if (!url.endsWith('/') && fullUrl.endsWith('/')) {
    return fullUrl.slice(0, -1);
  }

  return fullUrl;
}

/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */
async function captureFetchBreadcrumbToReplay(
  breadcrumb,
  hint,
  options

,
) {
  try {
    const data = await _prepareFetchData(breadcrumb, hint, options);

    // Create a replay performance entry from this breadcrumb
    const result = makeNetworkReplayBreadcrumb('resource.fetch', data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] Failed to capture fetch breadcrumb', error);
  }
}

/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function enrichFetchBreadcrumb(
  breadcrumb,
  hint,
  options,
) {
  const { input, response } = hint;

  const body = _getFetchRequestArgBody(input);
  const reqSize = getBodySize(body, options.textEncoder);

  const resSize = response ? parseContentLengthHeader(response.headers.get('content-length')) : undefined;

  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}

async function _prepareFetchData(
  breadcrumb,
  hint,
  options

,
) {
  const { startTimestamp, endTimestamp } = hint;

  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize,
  } = breadcrumb.data;

  const captureDetails =
    urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);

  const request = captureDetails
    ? _getRequestInfo(options, hint.input, requestBodySize)
    : buildSkippedNetworkRequestOrResponse(requestBodySize);
  const response = await _getResponseInfo(captureDetails, options, hint.response, responseBodySize);

  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request,
    response,
  };
}

function _getRequestInfo(
  { networkCaptureBodies, networkRequestHeaders },
  input,
  requestBodySize,
) {
  const headers = getRequestHeaders(input, networkRequestHeaders);

  if (!networkCaptureBodies) {
    return buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
  }

  // We only want to transmit string or string-like bodies
  const requestBody = _getFetchRequestArgBody(input);
  const bodyStr = getBodyString(requestBody);
  return buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
}

async function _getResponseInfo(
  captureDetails,
  {
    networkCaptureBodies,
    textEncoder,
    networkResponseHeaders,
  }

,
  response,
  responseBodySize,
) {
  if (!captureDetails && responseBodySize !== undefined) {
    return buildSkippedNetworkRequestOrResponse(responseBodySize);
  }

  const headers = getAllHeaders(response.headers, networkResponseHeaders);

  if (!networkCaptureBodies && responseBodySize !== undefined) {
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }

  // Only clone the response if we need to
  try {
    // We have to clone this, as the body can only be read once
    const res = response.clone();
    const bodyText = await _parseFetchBody(res);

    const size =
      bodyText && bodyText.length && responseBodySize === undefined
        ? getBodySize(bodyText, textEncoder)
        : responseBodySize;

    if (!captureDetails) {
      return buildSkippedNetworkRequestOrResponse(size);
    }

    if (networkCaptureBodies) {
      return buildNetworkRequestOrResponse(headers, size, bodyText);
    }

    return buildNetworkRequestOrResponse(headers, size, undefined);
  } catch (e) {
    // fallback
    return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
  }
}

async function _parseFetchBody(response) {
  try {
    return await response.text();
  } catch (e2) {
    return undefined;
  }
}

function _getFetchRequestArgBody(fetchArgs = []) {
  // We only support getting the body from the fetch options
  if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') {
    return undefined;
  }

  return (fetchArgs[1] ).body;
}

function getAllHeaders(headers, allowedHeaders) {
  const allHeaders = {};

  allowedHeaders.forEach(header => {
    if (headers.get(header)) {
      allHeaders[header] = headers.get(header) ;
    }
  });

  return allHeaders;
}

function getRequestHeaders(fetchArgs, allowedHeaders) {
  if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') {
    return getHeadersFromOptions(fetchArgs[0] , allowedHeaders);
  }

  if (fetchArgs.length === 2) {
    return getHeadersFromOptions(fetchArgs[1] , allowedHeaders);
  }

  return {};
}

function getHeadersFromOptions(
  input,
  allowedHeaders,
) {
  if (!input) {
    return {};
  }

  const headers = input.headers;

  if (!headers) {
    return {};
  }

  if (headers instanceof Headers) {
    return getAllHeaders(headers, allowedHeaders);
  }

  // We do not support this, as it is not really documented (anymore?)
  if (Array.isArray(headers)) {
    return {};
  }

  return getAllowedHeaders(headers, allowedHeaders);
}

/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */
async function captureXhrBreadcrumbToReplay(
  breadcrumb,
  hint,
  options,
) {
  try {
    const data = _prepareXhrData(breadcrumb, hint, options);

    // Create a replay performance entry from this breadcrumb
    const result = makeNetworkReplayBreadcrumb('resource.xhr', data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] Failed to capture fetch breadcrumb', error);
  }
}

/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */
function enrichXhrBreadcrumb(
  breadcrumb,
  hint,
  options,
) {
  const { xhr, input } = hint;

  const reqSize = getBodySize(input, options.textEncoder);
  const resSize = xhr.getResponseHeader('content-length')
    ? parseContentLengthHeader(xhr.getResponseHeader('content-length'))
    : getBodySize(xhr.response, options.textEncoder);

  if (reqSize !== undefined) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== undefined) {
    breadcrumb.data.response_body_size = resSize;
  }
}

function _prepareXhrData(
  breadcrumb,
  hint,
  options,
) {
  const { startTimestamp, endTimestamp, input, xhr } = hint;

  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize,
  } = breadcrumb.data;

  if (!url) {
    return null;
  }

  if (!urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
    const request = buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = buildSkippedNetworkRequestOrResponse(responseBodySize);
    return {
      startTimestamp,
      endTimestamp,
      url,
      method,
      statusCode,
      request,
      response,
    };
  }

  const xhrInfo = xhr[instrument/* SENTRY_XHR_DATA_KEY */.xU];
  const networkRequestHeaders = xhrInfo
    ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders)
    : {};
  const networkResponseHeaders = getAllowedHeaders(getResponseHeaders(xhr), options.networkResponseHeaders);

  const request = buildNetworkRequestOrResponse(
    networkRequestHeaders,
    requestBodySize,
    options.networkCaptureBodies ? getBodyString(input) : undefined,
  );
  const response = buildNetworkRequestOrResponse(
    networkResponseHeaders,
    responseBodySize,
    options.networkCaptureBodies ? hint.xhr.responseText : undefined,
  );

  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request,
    response,
  };
}

function getResponseHeaders(xhr) {
  const headers = xhr.getAllResponseHeaders();

  if (!headers) {
    return {};
  }

  return headers.split('\r\n').reduce((acc, line) => {
    const [key, value] = line.split(': ');
    acc[key.toLowerCase()] = value;
    return acc;
  }, {});
}

/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */
function handleNetworkBreadcrumbs(replay) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

  try {
    const textEncoder = new TextEncoder();

    const {
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders,
    } = replay.getOptions();

    const options = {
      replay,
      textEncoder,
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders,
    };

    if (client && client.on) {
      client.on('beforeAddBreadcrumb', (breadcrumb, hint) => beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } else {
      // Fallback behavior
      (0,instrument/* addInstrumentationHandler */.oq)('fetch', handleFetchSpanListener(replay));
      (0,instrument/* addInstrumentationHandler */.oq)('xhr', handleXhrSpanListener(replay));
    }
  } catch (e2) {
    // Do nothing
  }
}

/** just exported for tests */
function beforeAddNetworkBreadcrumb(
  options,
  breadcrumb,
  hint,
) {
  if (!breadcrumb.data) {
    return;
  }

  try {
    if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichXhrBreadcrumb(breadcrumb, hint, options);

      void captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
    }

    if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
      // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
      // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
      // So any async mutations to it will not be reflected in the final breadcrumb
      enrichFetchBreadcrumb(breadcrumb, hint, options);

      void captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
    }
  } catch (e) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Error when enriching network breadcrumb');
  }
}

function _isXhrBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'xhr';
}

function _isFetchBreadcrumb(breadcrumb) {
  return breadcrumb.category === 'fetch';
}

function _isXhrHint(hint) {
  return hint && hint.xhr;
}

function _isFetchHint(hint) {
  return hint && hint.response;
}

let _LAST_BREADCRUMB = null;

function isBreadcrumbWithCategory(breadcrumb) {
  return !!breadcrumb.category;
}

const handleScopeListener =
  (replay) =>
  (scope) => {
    if (!replay.isEnabled()) {
      return;
    }

    const result = handleScope(scope);

    if (!result) {
      return;
    }

    addBreadcrumbEvent(replay, result);
  };

/**
 * An event handler to handle scope changes.
 */
function handleScope(scope) {
  // TODO (v8): Remove this guard. This was put in place because we introduced
  // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
  // For now, we'll just return null if the method doesn't exist but we should eventually
  // get rid of this guard.
  const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();

  // Listener can be called when breadcrumbs have not changed, so we store the
  // reference to the last crumb and only return a crumb if it has changed
  if (_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) {
    return null;
  }

  _LAST_BREADCRUMB = newBreadcrumb;

  if (
    !isBreadcrumbWithCategory(newBreadcrumb) ||
    ['fetch', 'xhr', 'sentry.event', 'sentry.transaction'].includes(newBreadcrumb.category) ||
    newBreadcrumb.category.startsWith('ui.')
  ) {
    return null;
  }

  if (newBreadcrumb.category === 'console') {
    return normalizeConsoleBreadcrumb(newBreadcrumb);
  }

  return createBreadcrumb(newBreadcrumb);
}

/** exported for tests only */
function normalizeConsoleBreadcrumb(
  breadcrumb,
) {
  const args = breadcrumb.data && breadcrumb.data.arguments;

  if (!Array.isArray(args) || args.length === 0) {
    return createBreadcrumb(breadcrumb);
  }

  let isTruncated = false;

  // Avoid giant args captures
  const normalizedArgs = args.map(arg => {
    if (!arg) {
      return arg;
    }
    if (typeof arg === 'string') {
      if (arg.length > CONSOLE_ARG_MAX_SIZE) {
        isTruncated = true;
        return `${arg.slice(0, CONSOLE_ARG_MAX_SIZE)}…`;
      }

      return arg;
    }
    if (typeof arg === 'object') {
      try {
        const normalizedArg = (0,normalize/* normalize */.Fv)(arg, 7);
        const stringified = JSON.stringify(normalizedArg);
        if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
          const fixedJson = fixJson(stringified.slice(0, CONSOLE_ARG_MAX_SIZE));
          const json = JSON.parse(fixedJson);
          // We only set this after JSON.parse() was successfull, so we know we didn't run into `catch`
          isTruncated = true;
          return json;
        }
        return normalizedArg;
      } catch (e) {
        // fall back to default
      }
    }

    return arg;
  });

  return createBreadcrumb({
    ...breadcrumb,
    data: {
      ...breadcrumb.data,
      arguments: normalizedArgs,
      ...(isTruncated ? { _meta: { warnings: ['CONSOLE_ARG_TRUNCATED'] } } : {}),
    },
  });
}

/**
 * Add global listeners that cannot be removed.
 */
function addGlobalListeners(replay) {
  // Listeners from core SDK //
  const scope = (0,esm_hub/* getCurrentHub */.Gd)().getScope();
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

  if (scope) {
    scope.addScopeListener(handleScopeListener(replay));
  }
  (0,instrument/* addInstrumentationHandler */.oq)('dom', handleDomListener(replay));
  (0,instrument/* addInstrumentationHandler */.oq)('history', handleHistorySpanListener(replay));
  handleNetworkBreadcrumbs(replay);

  // Tag all (non replay) events that get sent to Sentry with the current
  // replay ID so that we can reference them later in the UI
  (0,esm_scope/* addGlobalEventProcessor */.c)(handleGlobalEventListener(replay, !hasHooks(client)));

  // If a custom client has no hooks yet, we continue to use the "old" implementation
  if (hasHooks(client)) {
    client.on('afterSendEvent', handleAfterSendEvent(replay));
    client.on('createDsc', (dsc) => {
      const replayId = replay.getSessionId();
      // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
      if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
        dsc.replay_id = replayId;
      }
    });

    client.on('startTransaction', transaction => {
      replay.lastTransaction = transaction;
    });

    // We may be missing the initial startTransaction due to timing issues,
    // so we capture it on finish again.
    client.on('finishTransaction', transaction => {
      replay.lastTransaction = transaction;
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasHooks(client) {
  return !!(client && client.on);
}

/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */
async function addMemoryEntry(replay) {
  // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
  try {
    return Promise.all(
      createPerformanceSpans(replay, [
        // @ts-ignore memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        createMemoryEntry(WINDOW.performance.memory),
      ]),
    );
  } catch (error) {
    // Do nothing
    return [];
  }
}

function createMemoryEntry(memoryEntry) {
  const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = memoryEntry;
  // we don't want to use `getAbsoluteTime` because it adds the event time to the
  // time origin, so we get the current timestamp instead
  const time = Date.now() / 1000;
  return {
    type: 'memory',
    name: 'memory',
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit,
        totalJSHeapSize,
        usedJSHeapSize,
      },
    },
  };
}

// Map entryType -> function to normalize data for event
// @ts-ignore TODO: entry type does not fit the create* functions entry type
const ENTRY_TYPES

 = {
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  resource: createResourceEntry,
  paint: createPaintEntry,
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  navigation: createNavigationEntry,
  // @ts-ignore TODO: entry type does not fit the create* functions entry type
  ['largest-contentful-paint']: createLargestContentfulPaint,
};

/**
 * Create replay performance entries from the browser performance entries.
 */
function createPerformanceEntries(
  entries,
) {
  return entries.map(createPerformanceEntry).filter(Boolean) ;
}

function createPerformanceEntry(entry) {
  if (ENTRY_TYPES[entry.entryType] === undefined) {
    return null;
  }

  return ENTRY_TYPES[entry.entryType](entry);
}

function getAbsoluteTime(time) {
  // browserPerformanceTimeOrigin can be undefined if `performance` or
  // `performance.now` doesn't exist, but this is already checked by this integration
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || WINDOW.performance.timeOrigin) + time) / 1000;
}

function createPaintEntry(entry) {
  const { duration, entryType, name, startTime } = entry;

  const start = getAbsoluteTime(startTime);
  return {
    type: entryType,
    name,
    start,
    end: start + duration,
    data: undefined,
  };
}

function createNavigationEntry(entry) {
  const {
    entryType,
    name,
    decodedBodySize,
    duration,
    domComplete,
    encodedBodySize,
    domContentLoadedEventStart,
    domContentLoadedEventEnd,
    domInteractive,
    loadEventStart,
    loadEventEnd,
    redirectCount,
    startTime,
    transferSize,
    type,
  } = entry;

  // Ignore entries with no duration, they do not seem to be useful and cause dupes
  if (duration === 0) {
    return null;
  }

  return {
    type: `${entryType}.${type}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(domComplete),
    name,
    data: {
      size: transferSize,
      decodedBodySize,
      encodedBodySize,
      duration,
      domInteractive,
      domContentLoadedEventStart,
      domContentLoadedEventEnd,
      loadEventStart,
      loadEventEnd,
      domComplete,
      redirectCount,
    },
  };
}

function createResourceEntry(
  entry,
) {
  const {
    entryType,
    initiatorType,
    name,
    responseEnd,
    startTime,
    decodedBodySize,
    encodedBodySize,
    responseStatus,
    transferSize,
  } = entry;

  // Core SDK handles these
  if (['fetch', 'xmlhttprequest'].includes(initiatorType)) {
    return null;
  }

  return {
    type: `${entryType}.${initiatorType}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(responseEnd),
    name,
    data: {
      size: transferSize,
      statusCode: responseStatus,
      decodedBodySize,
      encodedBodySize,
    },
  };
}

function createLargestContentfulPaint(
  entry,
) {
  const { entryType, startTime, size } = entry;

  let startTimeOrNavigationActivation = 0;

  if (WINDOW.performance) {
    const navEntry = WINDOW.performance.getEntriesByType('navigation')[0]

;

    // See https://github.com/GoogleChrome/web-vitals/blob/9f11c4c6578fb4c5ee6fa4e32b9d1d756475f135/src/lib/getActivationStart.ts#L21
    startTimeOrNavigationActivation = (navEntry && navEntry.activationStart) || 0;
  }

  // value is in ms
  const value = Math.max(startTime - startTimeOrNavigationActivation, 0);
  // LCP doesn't have a "duration", it just happens at a single point in time.
  // But the UI expects both, so use end (in seconds) for both timestamps.
  const end = getAbsoluteTime(startTimeOrNavigationActivation) + value / 1000;

  return {
    type: entryType,
    name: entryType,
    start: end,
    end,
    data: {
      value, // LCP "duration" in ms
      size,
      // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      nodeId: record.mirror.getId(entry.element ),
    },
  };
}

/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */
function debounce(func, wait, options) {
  let callbackReturnValue;

  let timerId;
  let maxTimerId;

  const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;

  function invokeFunc() {
    cancelTimers();
    callbackReturnValue = func();
    return callbackReturnValue;
  }

  function cancelTimers() {
    timerId !== undefined && clearTimeout(timerId);
    maxTimerId !== undefined && clearTimeout(maxTimerId);
    timerId = maxTimerId = undefined;
  }

  function flush() {
    if (timerId !== undefined || maxTimerId !== undefined) {
      return invokeFunc();
    }
    return callbackReturnValue;
  }

  function debounced() {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(invokeFunc, wait);

    if (maxWait && maxTimerId === undefined) {
      maxTimerId = setTimeout(invokeFunc, maxWait);
    }

    return callbackReturnValue;
  }

  debounced.cancel = cancelTimers;
  debounced.flush = flush;
  return debounced;
}

/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */
function getHandleRecordingEmit(replay) {
  let hadFirstEvent = false;

  return (event, _isCheckout) => {
    // If this is false, it means session is expired, create and a new session and wait for checkout
    if (!replay.checkAndHandleExpiredSession()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Replay] Received replay event after session expired.');

      return;
    }

    // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
    // We also want to treat the first event as a checkout, so we handle this specifically here
    const isCheckout = _isCheckout || !hadFirstEvent;
    hadFirstEvent = true;

    // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
    replay.addUpdate(() => {
      // The session is always started immediately on pageload/init, but for
      // error-only replays, it should reflect the most recent checkout
      // when an error occurs. Clear any state that happens before this current
      // checkout. This needs to happen before `addEvent()` which updates state
      // dependent on this reset.
      if (replay.recordingMode === 'buffer' && isCheckout) {
        replay.setInitialState();
      }

      // We need to clear existing events on a checkout, otherwise they are
      // incremental event updates and should be appended
      void addEvent(replay, event, isCheckout);

      // Different behavior for full snapshots (type=2), ignore other event types
      // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
      if (!isCheckout) {
        return false;
      }

      // Additionally, create a meta event that will capture certain SDK settings.
      // In order to handle buffer mode, this needs to either be done when we
      // receive checkout events or at flush time.
      //
      // `isCheckout` is always true, but want to be explicit that it should
      // only be added for checkouts
      void addSettingsEvent(replay, isCheckout);

      // If there is a previousSessionId after a full snapshot occurs, then
      // the replay session was started due to session expiration. The new session
      // is started before triggering a new checkout and contains the id
      // of the previous session. Do not immediately flush in this case
      // to avoid capturing only the checkout and instead the replay will
      // be captured if they perform any follow-up actions.
      if (replay.session && replay.session.previousSessionId) {
        return true;
      }

      // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
      // this should usually be the timestamp of the checkout event, but to be safe...
      if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
        const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
        if (earliestEvent) {
          replay.session.started = earliestEvent;

          if (replay.getOptions().stickySession) {
            saveSession(replay.session);
          }
        }
      }

      if (replay.recordingMode === 'session') {
        // If the full snapshot is due to an initial load, we will not have
        // a previous session ID. In this case, we want to buffer events
        // for a set amount of time before flushing. This can help avoid
        // capturing replays of users that immediately close the window.
        void replay.flush();
      }

      return true;
    });
  };
}

/**
 * Exported for tests
 */
function createOptionsEvent(replay) {
  const options = replay.getOptions();
  return {
    type: EventType.Custom,
    timestamp: Date.now(),
    data: {
      tag: 'options',
      payload: {
        sessionSampleRate: options.sessionSampleRate,
        errorSampleRate: options.errorSampleRate,
        useCompressionOption: options.useCompression,
        blockAllMedia: options.blockAllMedia,
        maskAllText: options.maskAllText,
        maskAllInputs: options.maskAllInputs,
        useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
        networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: options.networkCaptureBodies,
        networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: options.networkResponseHeaders.length > 0,
      },
    },
  };
}

/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */
function addSettingsEvent(replay, isCheckout) {
  // Only need to add this event when sending the first segment
  if (!isCheckout || !replay.session || replay.session.segmentId !== 0) {
    return Promise.resolve(null);
  }

  return addEvent(replay, createOptionsEvent(replay), false);
}

/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */
function createReplayEnvelope(
  replayEvent,
  recordingData,
  dsn,
  tunnel,
) {
  return (0,esm_envelope/* createEnvelope */.Jd)(
    (0,esm_envelope/* createEventEnvelopeHeaders */.Cd)(replayEvent, (0,esm_envelope/* getSdkMetadataForEnvelopeHeader */.HY)(replayEvent), tunnel, dsn),
    [
      [{ type: 'replay_event' }, replayEvent],
      [
        {
          type: 'replay_recording',
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length:
            typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length,
        },
        recordingData,
      ],
    ],
  );
}

/**
 * Prepare the recording data ready to be sent.
 */
function prepareRecordingData({
  recordingData,
  headers,
}

) {
  let payloadWithSequence;

  // XXX: newline is needed to separate sequence id from events
  const replayHeaders = `${JSON.stringify(headers)}
`;

  if (typeof recordingData === 'string') {
    payloadWithSequence = `${replayHeaders}${recordingData}`;
  } else {
    const enc = new TextEncoder();
    // XXX: newline is needed to separate sequence id from events
    const sequence = enc.encode(replayHeaders);
    // Merge the two Uint8Arrays
    payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
    payloadWithSequence.set(sequence);
    payloadWithSequence.set(recordingData, sequence.length);
  }

  return payloadWithSequence;
}

/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */
async function prepareReplayEvent({
  client,
  scope,
  replayId: event_id,
  event,
}

) {
  const integrations =
    typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations)
      ? Object.keys(client._integrations)
      : undefined;
  const preparedEvent = (await (0,prepareEvent/* prepareEvent */.R)(
    client.getOptions(),
    event,
    { event_id, integrations },
    scope,
  )) ;

  // If e.g. a global event processor returned null
  if (!preparedEvent) {
    return null;
  }

  // This normally happens in browser client "_prepareEvent"
  // but since we do not use this private method from the client, but rather the plain import
  // we need to do this manually.
  preparedEvent.platform = preparedEvent.platform || 'javascript';

  // extract the SDK name because `client._prepareEvent` doesn't add it to the event
  const metadata = client.getSdkMetadata && client.getSdkMetadata();
  const { name, version } = (metadata && metadata.sdk) || {};

  preparedEvent.sdk = {
    ...preparedEvent.sdk,
    name: name || 'sentry.javascript.unknown',
    version: version || '0.0.0',
  };

  return preparedEvent;
}

/**
 * Send replay attachment using `fetch()`
 */
async function sendReplayRequest({
  recordingData,
  replayId,
  segmentId: segment_id,
  eventContext,
  timestamp,
  session,
}) {
  const preparedRecordingData = prepareRecordingData({
    recordingData,
    headers: {
      segment_id,
    },
  });

  const { urls, errorIds, traceIds, initialTimestamp } = eventContext;

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const scope = hub.getScope();
  const transport = client && client.getTransport();
  const dsn = client && client.getDsn();

  if (!client || !transport || !dsn || !session.sampled) {
    return;
  }

  const baseEvent = {
    type: REPLAY_EVENT_NAME,
    replay_start_timestamp: initialTimestamp / 1000,
    timestamp: timestamp / 1000,
    error_ids: errorIds,
    trace_ids: traceIds,
    urls,
    replay_id: replayId,
    segment_id,
    replay_type: session.sampled,
  };

  const replayEvent = await prepareReplayEvent({ scope, client, replayId, event: baseEvent });

  if (!replayEvent) {
    // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
    client.recordDroppedEvent('event_processor', 'replay', baseEvent);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('An event processor returned `null`, will not send event.');
    return;
  }

  /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete replayEvent.sdkProcessingMetadata;

  const envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);

  let response;

  try {
    response = await transport.send(envelope);
  } catch (err) {
    const error = new Error(UNABLE_TO_SEND_REPLAY);

    try {
      // In case browsers don't allow this property to be writable
      // @ts-ignore This needs lib es2022 and newer
      error.cause = err;
    } catch (e) {
      // nothing to do
    }
    throw error;
  }

  // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
  if (!response) {
    return response;
  }

  // If the status code is invalid, we want to immediately stop & not retry
  if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) {
    throw new TransportStatusCodeError(response.statusCode);
  }

  return response;
}

/**
 * This error indicates that the transport returned an invalid status code.
 */
class TransportStatusCodeError extends Error {
   constructor(statusCode) {
    super(`Transport returned status code ${statusCode}`);
  }
}

/**
 * Finalize and send the current replay event to Sentry
 */
async function sendReplay(
  replayData,
  retryConfig = {
    count: 0,
    interval: RETRY_BASE_INTERVAL,
  },
) {
  const { recordingData, options } = replayData;

  // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
  if (!recordingData.length) {
    return;
  }

  try {
    await sendReplayRequest(replayData);
    return true;
  } catch (err) {
    if (err instanceof TransportStatusCodeError) {
      throw err;
    }

    // Capture error for every failed replay
    (0,esm_exports/* setContext */.v)('Replays', {
      _retryCount: retryConfig.count,
    });

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && options._experiments && options._experiments.captureExceptions) {
      (0,esm_exports/* captureException */.Tb)(err);
    }

    // If an error happened here, it's likely that uploading the attachment
    // failed, we'll can retry with the same events payload
    if (retryConfig.count >= RETRY_MAX_COUNT) {
      const error = new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);

      try {
        // In case browsers don't allow this property to be writable
        // @ts-ignore This needs lib es2022 and newer
        error.cause = err;
      } catch (e) {
        // nothing to do
      }

      throw error;
    }

    // will retry in intervals of 5, 10, 30
    retryConfig.interval *= ++retryConfig.count;

    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        try {
          await sendReplay(replayData, retryConfig);
          resolve(true);
        } catch (err) {
          reject(err);
        }
      }, retryConfig.interval);
    });
  }
}

const THROTTLED = '__THROTTLED';
const SKIPPED = '__SKIPPED';

/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(
  fn,
  maxCount,
  durationSeconds,
) {
  const counter = new Map();

  const _cleanup = (now) => {
    const threshold = now - durationSeconds;
    counter.forEach((_value, key) => {
      if (key < threshold) {
        counter.delete(key);
      }
    });
  };

  const _getTotalCount = () => {
    return [...counter.values()].reduce((a, b) => a + b, 0);
  };

  let isThrottled = false;

  return (...rest) => {
    // Date in second-precision, which we use as basis for the throttling
    const now = Math.floor(Date.now() / 1000);

    // First, make sure to delete any old entries
    _cleanup(now);

    // If already over limit, do nothing
    if (_getTotalCount() >= maxCount) {
      const wasThrottled = isThrottled;
      isThrottled = true;
      return wasThrottled ? SKIPPED : THROTTLED;
    }

    isThrottled = false;
    const count = counter.get(now) || 0;
    counter.set(now, count + 1);

    return fn(...rest);
  };
}

/* eslint-disable max-lines */ // TODO: We might want to split this file up

/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */
class ReplayContainer  {
   __init() {this.eventBuffer = null;}

  /**
   * List of PerformanceEntry from PerformanceObserver
   */
   __init2() {this.performanceEvents = [];}

  /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
   __init3() {this.recordingMode = 'session';}

  /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */

  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
    __init4() {this.timeouts = {
    sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
    sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION,
    maxSessionLife: MAX_SESSION_LIFE,
  }; }

  /**
   * Options to pass to `rrweb.record()`
   */

   __init5() {this._performanceObserver = null;}

   __init6() {this._flushLock = null;}

  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
   __init7() {this._lastActivity = Date.now();}

  /**
   * Is the integration currently active?
   */
   __init8() {this._isEnabled = false;}

  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
   __init9() {this._isPaused = false;}

  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
   __init10() {this._hasInitializedCoreListeners = false;}

  /**
   * Function to stop recording
   */
   __init11() {this._stopRecording = null;}

   __init12() {this._context = {
    errorIds: new Set(),
    traceIds: new Set(),
    urls: [],
    initialTimestamp: Date.now(),
    initialUrl: '',
  };}

   constructor({
    options,
    recordingOptions,
  }

) {ReplayContainer.prototype.__init.call(this);ReplayContainer.prototype.__init2.call(this);ReplayContainer.prototype.__init3.call(this);ReplayContainer.prototype.__init4.call(this);ReplayContainer.prototype.__init5.call(this);ReplayContainer.prototype.__init6.call(this);ReplayContainer.prototype.__init7.call(this);ReplayContainer.prototype.__init8.call(this);ReplayContainer.prototype.__init9.call(this);ReplayContainer.prototype.__init10.call(this);ReplayContainer.prototype.__init11.call(this);ReplayContainer.prototype.__init12.call(this);ReplayContainer.prototype.__init13.call(this);ReplayContainer.prototype.__init14.call(this);ReplayContainer.prototype.__init15.call(this);ReplayContainer.prototype.__init16.call(this);ReplayContainer.prototype.__init17.call(this);ReplayContainer.prototype.__init18.call(this);
    this._recordingOptions = recordingOptions;
    this._options = options;

    this._debouncedFlush = debounce(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay,
    });

    this._throttledAddEvent = throttle(
      (event, isCheckout) => addEvent(this, event, isCheckout),
      // Max 300 events...
      300,
      // ... per 5s
      5,
    );

    const { slowClickTimeout, slowClickIgnoreSelectors } = this.getOptions();

    const slowClickConfig = slowClickTimeout
      ? {
          threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
          timeout: slowClickTimeout,
          scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
          ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : '',
        }
      : undefined;

    if (slowClickConfig) {
      this.clickDetector = new ClickDetector(this, slowClickConfig);
    }
  }

  /** Get the event context. */
   getContext() {
    return this._context;
  }

  /** If recording is currently enabled. */
   isEnabled() {
    return this._isEnabled;
  }

  /** If recording is currently paused. */
   isPaused() {
    return this._isPaused;
  }

  /** Get the replay integration options. */
   getOptions() {
    return this._options;
  }

  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
   initializeSampling() {
    const { errorSampleRate, sessionSampleRate } = this._options;

    // If neither sample rate is > 0, then do nothing - user will need to call one of
    // `start()` or `startBuffering` themselves.
    if (errorSampleRate <= 0 && sessionSampleRate <= 0) {
      return;
    }

    // Otherwise if there is _any_ sample rate set, try to load an existing
    // session, or create a new one.
    const isSessionSampled = this._loadAndCheckSession();

    if (!isSessionSampled) {
      // This should only occur if `errorSampleRate` is 0 and was unsampled for
      // session-based replay. In this case there is nothing to do.
      return;
    }

    if (!this.session) {
      // This should not happen, something wrong has occurred
      this._handleException(new Error('Unable to initialize and create session'));
      return;
    }

    if (this.session.sampled && this.session.sampled !== 'session') {
      // If not sampled as session-based, then recording mode will be `buffer`
      // Note that we don't explicitly check if `sampled === 'buffer'` because we
      // could have sessions from Session storage that are still `error` from
      // prior SDK version.
      this.recordingMode = 'buffer';
    }

    this._initializeRecording();
  }

  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
   start() {
    if (this._isEnabled && this.recordingMode === 'session') {
      throw new Error('Replay recording is already in progress');
    }

    if (this._isEnabled && this.recordingMode === 'buffer') {
      throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
    }

    const previousSessionId = this.session && this.session.id;

    const { session } = getSession({
      timeouts: this.timeouts,
      stickySession: Boolean(this._options.stickySession),
      currentSession: this.session,
      // This is intentional: create a new session-based replay when calling `start()`
      sessionSampleRate: 1,
      allowBuffering: false,
    });

    session.previousSessionId = previousSessionId;
    this.session = session;

    this._initializeRecording();
  }

  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
   startBuffering() {
    if (this._isEnabled) {
      throw new Error('Replay recording is already in progress');
    }

    const previousSessionId = this.session && this.session.id;

    const { session } = getSession({
      timeouts: this.timeouts,
      stickySession: Boolean(this._options.stickySession),
      currentSession: this.session,
      sessionSampleRate: 0,
      allowBuffering: true,
    });

    session.previousSessionId = previousSessionId;
    this.session = session;

    this.recordingMode = 'buffer';
    this._initializeRecording();
  }

  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
   startRecording() {
    try {
      this._stopRecording = record({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...(this.recordingMode === 'buffer' && { checkoutEveryNms: BUFFER_CHECKOUT_TIME }),
        emit: getHandleRecordingEmit(this),
        onMutation: this._onMutationHandler,
      });
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
   stopRecording() {
    try {
      if (this._stopRecording) {
        this._stopRecording();
        this._stopRecording = undefined;
      }

      return true;
    } catch (err) {
      this._handleException(err);
      return false;
    }
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
   async stop(reason) {
    if (!this._isEnabled) {
      return;
    }

    try {
      if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
        const msg = `[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`;

        // When `traceInternals` is enabled, we want to log this to the console
        // Else, use the regular debug output
        // eslint-disable-next-line
        const log = this.getOptions()._experiments.traceInternals ? console.warn : logger/* logger.log */.kg.log;
        log(msg);
      }

      // We can't move `_isEnabled` after awaiting a flush, otherwise we can
      // enter into an infinite loop when `stop()` is called while flushing.
      this._isEnabled = false;
      this._removeListeners();
      this.stopRecording();

      this._debouncedFlush.cancel();
      // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
      // `_isEnabled` state of the plugin since it was disabled above.
      if (this.recordingMode === 'session') {
        await this._flush({ force: true });
      }

      // After flush, destroy event buffer
      this.eventBuffer && this.eventBuffer.destroy();
      this.eventBuffer = null;

      // Clear session from session storage, note this means if a new session
      // is started after, it will not have `previousSessionId`
      clearSession(this);
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
   pause() {
    this._isPaused = true;
    this.stopRecording();
  }

  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
   resume() {
    if (!this._loadAndCheckSession()) {
      return;
    }

    this._isPaused = false;
    this.startRecording();
  }

  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
   async sendBufferedReplayOrFlush({ continueRecording = true } = {}) {
    if (this.recordingMode === 'session') {
      return this.flushImmediate();
    }

    const activityTime = Date.now();

    // Allow flush to complete before resuming as a session recording, otherwise
    // the checkout from `startRecording` may be included in the payload.
    // Prefer to keep the error replay as a separate (and smaller) segment
    // than the session replay.
    await this.flushImmediate();

    const hasStoppedRecording = this.stopRecording();

    if (!continueRecording || !hasStoppedRecording) {
      return;
    }

    // Re-start recording, but in "session" recording mode

    // Reset all "capture on error" configuration before
    // starting a new recording
    this.recordingMode = 'session';

    // Once this session ends, we do not want to refresh it
    if (this.session) {
      this.session.shouldRefresh = false;

      // It's possible that the session lifespan is > max session lifespan
      // because we have been buffering beyond max session lifespan (we ignore
      // expiration given that `shouldRefresh` is true). Since we flip
      // `shouldRefresh`, the session could be considered expired due to
      // lifespan, which is not what we want. Update session start date to be
      // the current timestamp, so that session is not considered to be
      // expired. This means that max replay duration can be MAX_SESSION_LIFE +
      // (length of buffer), which we are ok with.
      this._updateUserActivity(activityTime);
      this._updateSessionActivity(activityTime);
      this.session.started = activityTime;
      this._maybeSaveSession();
    }

    this.startRecording();
  }

  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
   addUpdate(cb) {
    // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
    const cbResult = cb();

    // If this option is turned on then we will only want to call `flush`
    // explicitly
    if (this.recordingMode === 'buffer') {
      return;
    }

    // If callback is true, we do not want to continue with flushing -- the
    // caller will need to handle it.
    if (cbResult === true) {
      return;
    }

    // addUpdate is called quite frequently - use _debouncedFlush so that it
    // respects the flush delays and does not flush immediately
    this._debouncedFlush();
  }

  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
   triggerUserActivity() {
    this._updateUserActivity();

    // This case means that recording was once stopped due to inactivity.
    // Ensure that recording is resumed.
    if (!this._stopRecording) {
      // Create a new session, otherwise when the user action is flushed, it
      // will get rejected due to an expired session.
      if (!this._loadAndCheckSession()) {
        return;
      }

      // Note: This will cause a new DOM checkout
      this.resume();
      return;
    }

    // Otherwise... recording was never suspended, continue as normalish
    this.checkAndHandleExpiredSession();

    this._updateSessionActivity();
  }

  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
   updateUserActivity() {
    this._updateUserActivity();
    this._updateSessionActivity();
  }

  /**
   * Only flush if `this.recordingMode === 'session'`
   */
   conditionalFlush() {
    if (this.recordingMode === 'buffer') {
      return Promise.resolve();
    }

    return this.flushImmediate();
  }

  /**
   * Flush using debounce flush
   */
   flush() {
    return this._debouncedFlush() ;
  }

  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */
   flushImmediate() {
    this._debouncedFlush();
    // `.flush` is provided by the debounced function, analogously to lodash.debounce
    return this._debouncedFlush.flush() ;
  }

  /**
   * Cancels queued up flushes.
   */
   cancelFlush() {
    this._debouncedFlush.cancel();
  }

  /** Get the current sesion (=replay) ID */
   getSessionId() {
    return this.session && this.session.id;
  }

  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
   checkAndHandleExpiredSession() {
    const oldSessionId = this.getSessionId();

    // Prevent starting a new session if the last user activity is older than
    // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
    // session+recording. This creates noisy replays that do not have much
    // content in them.
    if (
      this._lastActivity &&
      isExpired(this._lastActivity, this.timeouts.sessionIdlePause) &&
      this.session &&
      this.session.sampled === 'session'
    ) {
      // Pause recording only for session-based replays. Otherwise, resuming
      // will create a new replay and will conflict with users who only choose
      // to record error-based replays only. (e.g. the resumed replay will not
      // contain a reference to an error)
      this.pause();
      return;
    }

    // --- There is recent user activity --- //
    // This will create a new session if expired, based on expiry length
    if (!this._loadAndCheckSession()) {
      return;
    }

    // Session was expired if session ids do not match
    const expired = oldSessionId !== this.getSessionId();

    if (!expired) {
      return true;
    }

    // Session is expired, trigger a full snapshot (which will create a new session)
    this._triggerFullSnapshot();

    return false;
  }

  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
   setInitialState() {
    const urlPath = `${WINDOW.location.pathname}${WINDOW.location.hash}${WINDOW.location.search}`;
    const url = `${WINDOW.location.origin}${urlPath}`;

    this.performanceEvents = [];

    // Reset _context as well
    this._clearContext();

    this._context.initialUrl = url;
    this._context.initialTimestamp = Date.now();
    this._context.urls.push(url);
  }

  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
   throttledAddEvent(
    event,
    isCheckout,
  ) {
    const res = this._throttledAddEvent(event, isCheckout);

    // If this is THROTTLED, it means we have throttled the event for the first time
    // In this case, we want to add a breadcrumb indicating that something was skipped
    if (res === THROTTLED) {
      const breadcrumb = createBreadcrumb({
        category: 'replay.throttled',
      });

      this.addUpdate(() => {
        void addEvent(this, {
          type: EventType.Custom,
          timestamp: breadcrumb.timestamp || 0,
          data: {
            tag: 'breadcrumb',
            payload: breadcrumb,
            metric: true,
          },
        });
      });
    }

    return res;
  }

  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
   getCurrentRoute() {
    const lastTransaction = this.lastTransaction || (0,esm_hub/* getCurrentHub */.Gd)().getScope().getTransaction();
    if (!lastTransaction || !['route', 'custom'].includes(lastTransaction.metadata.source)) {
      return undefined;
    }

    return lastTransaction.name;
  }

  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
   _initializeRecording() {
    this.setInitialState();

    // this method is generally called on page load or manually - in both cases
    // we should treat it as an activity
    this._updateSessionActivity();

    this.eventBuffer = createEventBuffer({
      useCompression: this._options.useCompression,
    });

    this._removeListeners();
    this._addListeners();

    // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
    this._isEnabled = true;

    this.startRecording();
  }

  /** A wrapper to conditionally capture exceptions. */
   _handleException(error) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay]', error);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._options._experiments && this._options._experiments.captureExceptions) {
      (0,esm_exports/* captureException */.Tb)(error);
    }
  }

  /**
   * Loads (or refreshes) the current session.
   * Returns false if session is not recorded.
   */
   _loadAndCheckSession() {
    const { type, session } = getSession({
      timeouts: this.timeouts,
      stickySession: Boolean(this._options.stickySession),
      currentSession: this.session,
      sessionSampleRate: this._options.sessionSampleRate,
      allowBuffering: this._options.errorSampleRate > 0 || this.recordingMode === 'buffer',
    });

    // If session was newly created (i.e. was not loaded from storage), then
    // enable flag to create the root replay
    if (type === 'new') {
      this.setInitialState();
    }

    const currentSessionId = this.getSessionId();
    if (session.id !== currentSessionId) {
      session.previousSessionId = currentSessionId;
    }

    this.session = session;

    if (!this.session.sampled) {
      void this.stop('session unsampled');
      return false;
    }

    return true;
  }

  /**
   * Adds listeners to record events for the replay
   */
   _addListeners() {
    try {
      WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
      WINDOW.addEventListener('blur', this._handleWindowBlur);
      WINDOW.addEventListener('focus', this._handleWindowFocus);
      WINDOW.addEventListener('keydown', this._handleKeyboardEvent);

      if (this.clickDetector) {
        this.clickDetector.addListeners();
      }

      // There is no way to remove these listeners, so ensure they are only added once
      if (!this._hasInitializedCoreListeners) {
        addGlobalListeners(this);

        this._hasInitializedCoreListeners = true;
      }
    } catch (err) {
      this._handleException(err);
    }

    // PerformanceObserver //
    if (!('PerformanceObserver' in WINDOW)) {
      return;
    }

    this._performanceObserver = setupPerformanceObserver(this);
  }

  /**
   * Cleans up listeners that were created in `_addListeners`
   */
   _removeListeners() {
    try {
      WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);

      WINDOW.removeEventListener('blur', this._handleWindowBlur);
      WINDOW.removeEventListener('focus', this._handleWindowFocus);
      WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);

      if (this.clickDetector) {
        this.clickDetector.removeListeners();
      }

      if (this._performanceObserver) {
        this._performanceObserver.disconnect();
        this._performanceObserver = null;
      }
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
   __init13() {this._handleVisibilityChange = () => {
    if (WINDOW.document.visibilityState === 'visible') {
      this._doChangeToForegroundTasks();
    } else {
      this._doChangeToBackgroundTasks();
    }
  };}

  /**
   * Handle when page is blurred
   */
   __init14() {this._handleWindowBlur = () => {
    const breadcrumb = createBreadcrumb({
      category: 'ui.blur',
    });

    // Do not count blur as a user action -- it's part of the process of them
    // leaving the page
    this._doChangeToBackgroundTasks(breadcrumb);
  };}

  /**
   * Handle when page is focused
   */
   __init15() {this._handleWindowFocus = () => {
    const breadcrumb = createBreadcrumb({
      category: 'ui.focus',
    });

    // Do not count focus as a user action -- instead wait until they focus and
    // interactive with page
    this._doChangeToForegroundTasks(breadcrumb);
  };}

  /** Ensure page remains active when a key is pressed. */
   __init16() {this._handleKeyboardEvent = (event) => {
    handleKeyboardEvent(this, event);
  };}

  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
   _doChangeToBackgroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }

    const expired = isSessionExpired(this.session, this.timeouts);

    if (breadcrumb && !expired) {
      this._createCustomBreadcrumb(breadcrumb);
    }

    // Send replay when the page/tab becomes hidden. There is no reason to send
    // replay if it becomes visible, since no actions we care about were done
    // while it was hidden
    void this.conditionalFlush();
  }

  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
   _doChangeToForegroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }

    const isSessionActive = this.checkAndHandleExpiredSession();

    if (!isSessionActive) {
      // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
      // ms, we will re-use the existing session, otherwise create a new
      // session
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Document has become active, but session has expired');
      return;
    }

    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }
  }

  /**
   * Trigger rrweb to take a full snapshot which will cause this plugin to
   * create a new Replay event.
   */
   _triggerFullSnapshot(checkout = true) {
    try {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Replay] Taking full rrweb snapshot');
      record.takeFullSnapshot(checkout);
    } catch (err) {
      this._handleException(err);
    }
  }

  /**
   * Update user activity (across session lifespans)
   */
   _updateUserActivity(_lastActivity = Date.now()) {
    this._lastActivity = _lastActivity;
  }

  /**
   * Updates the session's last activity timestamp
   */
   _updateSessionActivity(_lastActivity = Date.now()) {
    if (this.session) {
      this.session.lastActivity = _lastActivity;
      this._maybeSaveSession();
    }
  }

  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
   _createCustomBreadcrumb(breadcrumb) {
    this.addUpdate(() => {
      void this.throttledAddEvent({
        type: EventType.Custom,
        timestamp: breadcrumb.timestamp || 0,
        data: {
          tag: 'breadcrumb',
          payload: breadcrumb,
        },
      });
    });
  }

  /**
   * Observed performance events are added to `this.performanceEvents`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
   _addPerformanceEntries() {
    // Copy and reset entries before processing
    const entries = [...this.performanceEvents];
    this.performanceEvents = [];

    return Promise.all(createPerformanceSpans(this, createPerformanceEntries(entries)));
  }

  /**
   * Clear _context
   */
   _clearContext() {
    // XXX: `initialTimestamp` and `initialUrl` do not get cleared
    this._context.errorIds.clear();
    this._context.traceIds.clear();
    this._context.urls = [];
  }

  /** Update the initial timestamp based on the buffer content. */
   _updateInitialTimestampFromEventBuffer() {
    const { session, eventBuffer } = this;
    if (!session || !eventBuffer) {
      return;
    }

    // we only ever update this on the initial segment
    if (session.segmentId) {
      return;
    }

    const earliestEvent = eventBuffer.getEarliestTimestamp();
    if (earliestEvent && earliestEvent < this._context.initialTimestamp) {
      // eslint-disable-next-line no-console
      const log = this.getOptions()._experiments.traceInternals ? console.info : logger/* logger.info */.kg.info;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && log(`[Replay] Updating initial timestamp to ${earliestEvent}`);
      this._context.initialTimestamp = earliestEvent;
    }
  }

  /**
   * Return and clear _context
   */
   _popEventContext() {
    const _context = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls,
    };

    this._clearContext();

    return _context;
  }

  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
   async _runFlush() {
    if (!this.session || !this.eventBuffer) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] No session or eventBuffer found to flush.');
      return;
    }

    await this._addPerformanceEntries();

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer || !this.eventBuffer.hasEvents) {
      return;
    }

    // Only attach memory event if eventBuffer is not empty
    await addMemoryEntry(this);

    // Check eventBuffer again, as it could have been stopped in the meanwhile
    if (!this.eventBuffer) {
      return;
    }

    try {
      // This uses the data from the eventBuffer, so we need to call this before `finish()
      this._updateInitialTimestampFromEventBuffer();

      // Note this empties the event buffer regardless of outcome of sending replay
      const recordingData = await this.eventBuffer.finish();

      // NOTE: Copy values from instance members, as it's possible they could
      // change before the flush finishes.
      const replayId = this.session.id;
      const eventContext = this._popEventContext();
      // Always increment segmentId regardless of outcome of sending replay
      const segmentId = this.session.segmentId++;
      this._maybeSaveSession();

      await sendReplay({
        replayId,
        recordingData,
        segmentId,
        eventContext,
        session: this.session,
        options: this.getOptions(),
        timestamp: Date.now(),
      });
    } catch (err) {
      this._handleException(err);

      // This means we retried 3 times and all of them failed,
      // or we ran into a problem we don't want to retry, like rate limiting.
      // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
      void this.stop('sendReplay');

      const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

      if (client) {
        client.recordDroppedEvent('send_error', 'replay');
      }
    }
  }

  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
   __init17() {this._flush = async ({
    force = false,
  }

 = {}) => {
    if (!this._isEnabled && !force) {
      // This can happen if e.g. the replay was stopped because of exceeding the retry limit
      return;
    }

    if (!this.checkAndHandleExpiredSession()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] Attempting to finish replay event after session expired.');
      return;
    }

    if (!this.session) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('[Replay] No session found to flush.');
      return;
    }

    const start = this._context.initialTimestamp;
    const now = Date.now();
    const duration = now - start;

    // If session is too short, or too long (allow some wiggle room over maxSessionLife), do not send it
    // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
    if (duration < this._options.minReplayDuration || duration > this.timeouts.maxSessionLife + 5000) {
      // eslint-disable-next-line no-console
      const log = this.getOptions()._experiments.traceInternals ? console.warn : logger/* logger.warn */.kg.warn;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        log(
          `[Replay] Session duration (${Math.floor(duration / 1000)}s) is too short or too long, not sending replay.`,
        );

      return;
    }

    // A flush is about to happen, cancel any queued flushes
    this._debouncedFlush.cancel();

    // this._flushLock acts as a lock so that future calls to `_flush()`
    // will be blocked until this promise resolves
    if (!this._flushLock) {
      this._flushLock = this._runFlush();
      await this._flushLock;
      this._flushLock = null;
      return;
    }

    // Wait for previous flush to finish, then call the debounced `_flush()`.
    // It's possible there are other flush requests queued and waiting for it
    // to resolve. We want to reduce all outstanding requests (as well as any
    // new flush requests that occur within a second of the locked flush
    // completing) into a single flush.

    try {
      await this._flushLock;
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error(err);
    } finally {
      this._debouncedFlush();
    }
  };}

  /** Save the session, if it is sticky */
   _maybeSaveSession() {
    if (this.session && this._options.stickySession) {
      saveSession(this.session);
    }
  }

  /** Handler for rrweb.record.onMutation */
   __init18() {this._onMutationHandler = (mutations) => {
    const count = mutations.length;

    const mutationLimit = this._options.mutationLimit;
    const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
    const overMutationLimit = mutationLimit && count > mutationLimit;

    // Create a breadcrumb if a lot of mutations happen at the same time
    // We can show this in the UI as an information with potential performance improvements
    if (count > mutationBreadcrumbLimit || overMutationLimit) {
      const breadcrumb = createBreadcrumb({
        category: 'replay.mutations',
        data: {
          count,
          limit: overMutationLimit,
        },
      });
      this._createCustomBreadcrumb(breadcrumb);
    }

    // Stop replay if over the mutation limit
    if (overMutationLimit) {
      void this.stop('mutationLimit');
      return false;
    }

    // `true` means we use the regular mutation handling by rrweb
    return true;
  };}
}

function getOption(
  selectors,
  defaultSelectors,
  deprecatedClassOption,
  deprecatedSelectorOption,
) {
  const deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];

  const allSelectors = [
    ...selectors,
    // @deprecated
    ...deprecatedSelectors,

    // sentry defaults
    ...defaultSelectors,
  ];

  // @deprecated
  if (typeof deprecatedClassOption !== 'undefined') {
    // NOTE: No support for RegExp
    if (typeof deprecatedClassOption === 'string') {
      allSelectors.push(`.${deprecatedClassOption}`);
    }

    // eslint-disable-next-line no-console
    console.warn(
      '[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.',
    );
  }

  return allSelectors.join(',');
}

/**
 * Returns privacy related configuration for use in rrweb
 */
function getPrivacyOptions({
  mask,
  unmask,
  block,
  unblock,
  ignore,

  // eslint-disable-next-line deprecation/deprecation
  blockClass,
  // eslint-disable-next-line deprecation/deprecation
  blockSelector,
  // eslint-disable-next-line deprecation/deprecation
  maskTextClass,
  // eslint-disable-next-line deprecation/deprecation
  maskTextSelector,
  // eslint-disable-next-line deprecation/deprecation
  ignoreClass,
}) {
  const defaultBlockedElements = ['base[href="/"]'];

  const maskSelector = getOption(mask, ['.sentry-mask', '[data-sentry-mask]'], maskTextClass, maskTextSelector);
  const unmaskSelector = getOption(unmask, ['.sentry-unmask', '[data-sentry-unmask]']);

  const options = {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: maskSelector,
    unmaskTextSelector: unmaskSelector,
    maskInputSelector: maskSelector,
    unmaskInputSelector: unmaskSelector,

    blockSelector: getOption(
      block,
      ['.sentry-block', '[data-sentry-block]', ...defaultBlockedElements],
      blockClass,
      blockSelector,
    ),
    unblockSelector: getOption(unblock, ['.sentry-unblock', '[data-sentry-unblock]']),
    ignoreSelector: getOption(ignore, ['.sentry-ignore', '[data-sentry-ignore]', 'input[type="file"]'], ignoreClass),
  };

  if (blockClass instanceof RegExp) {
    options.blockClass = blockClass;
  }

  if (maskTextClass instanceof RegExp) {
    options.maskTextClass = maskTextClass;
  }

  return options;
}

/**
 * Returns true if we are in the browser.
 */
function isBrowser() {
  // eslint-disable-next-line no-restricted-globals
  return typeof window !== 'undefined' && (!(0,node/* isNodeEnv */.KV)() || isElectronNodeRenderer());
}

// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
  return typeof process !== 'undefined' && (process ).type === 'renderer';
}

const MEDIA_SELECTORS =
  'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';

const DEFAULT_NETWORK_HEADERS = ['content-length', 'content-type', 'accept'];

let _initialized = false;

/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 */
class Replay  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Replay';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Replay.id;}

  /**
   * Options to pass to `rrweb.record()`
   */

  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */

   constructor({
    flushMinDelay = DEFAULT_FLUSH_MIN_DELAY,
    flushMaxDelay = DEFAULT_FLUSH_MAX_DELAY,
    minReplayDuration = MIN_REPLAY_DURATION,
    stickySession = true,
    useCompression = true,
    _experiments = {},
    sessionSampleRate,
    errorSampleRate,
    maskAllText = true,
    maskAllInputs = true,
    blockAllMedia = true,

    mutationBreadcrumbLimit = 750,
    mutationLimit = 10000,

    slowClickTimeout = 7000,
    slowClickIgnoreSelectors = [],

    networkDetailAllowUrls = [],
    networkDetailDenyUrls = [],
    networkCaptureBodies = true,
    networkRequestHeaders = [],
    networkResponseHeaders = [],

    mask = [],
    unmask = [],
    block = [],
    unblock = [],
    ignore = [],
    maskFn,

    beforeAddRecordingEvent,

    // eslint-disable-next-line deprecation/deprecation
    blockClass,
    // eslint-disable-next-line deprecation/deprecation
    blockSelector,
    // eslint-disable-next-line deprecation/deprecation
    maskInputOptions,
    // eslint-disable-next-line deprecation/deprecation
    maskTextClass,
    // eslint-disable-next-line deprecation/deprecation
    maskTextSelector,
    // eslint-disable-next-line deprecation/deprecation
    ignoreClass,
  } = {}) {Replay.prototype.__init.call(this);
    this._recordingOptions = {
      maskAllInputs,
      maskAllText,
      maskInputOptions: { ...(maskInputOptions || {}), password: true },
      maskTextFn: maskFn,
      maskInputFn: maskFn,

      ...getPrivacyOptions({
        mask,
        unmask,
        block,
        unblock,
        ignore,
        blockClass,
        blockSelector,
        maskTextClass,
        maskTextSelector,
        ignoreClass,
      }),

      // Our defaults
      slimDOMOptions: 'all',
      inlineStylesheet: true,
      // Disable inline images as it will increase segment/replay size
      inlineImages: false,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: true,
    };

    this._initialOptions = {
      flushMinDelay,
      flushMaxDelay,
      minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
      stickySession,
      sessionSampleRate,
      errorSampleRate,
      useCompression,
      blockAllMedia,
      maskAllInputs,
      maskAllText,
      mutationBreadcrumbLimit,
      mutationLimit,
      slowClickTimeout,
      slowClickIgnoreSelectors,
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
      networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
      beforeAddRecordingEvent,

      _experiments,
    };

    if (typeof sessionSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn(
        `[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`,
      );

      this._initialOptions.sessionSampleRate = sessionSampleRate;
    }

    if (typeof errorSampleRate === 'number') {
      // eslint-disable-next-line
      console.warn(
        `[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`,
      );

      this._initialOptions.errorSampleRate = errorSampleRate;
    }

    if (this._initialOptions.blockAllMedia) {
      // `blockAllMedia` is a more user friendly option to configure blocking
      // embedded media elements
      this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector
        ? MEDIA_SELECTORS
        : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
    }

    if (this._isInitialized && isBrowser()) {
      throw new Error('Multiple Sentry Session Replay instances are not supported');
    }

    this._isInitialized = true;
  }

  /** If replay has already been initialized */
   get _isInitialized() {
    return _initialized;
  }

  /** Update _isInitialized */
   set _isInitialized(value) {
    _initialized = value;
  }

  /**
   * Setup and initialize replay container
   */
   setupOnce() {
    if (!isBrowser()) {
      return;
    }

    this._setup();

    // Once upon a time, we tried to create a transaction in `setupOnce` and it would
    // potentially create a transaction before some native SDK integrations have run
    // and applied their own global event processor. An example is:
    // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
    //
    // So we call `this._initialize()` in next event loop as a workaround to wait for other
    // global event processors to finish. This is no longer needed, but keeping it
    // here to avoid any future issues.
    setTimeout(() => this._initialize());
  }

  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
   start() {
    if (!this._replay) {
      return;
    }

    this._replay.start();
  }

  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
   startBuffering() {
    if (!this._replay) {
      return;
    }

    this._replay.startBuffering();
  }

  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
   stop() {
    if (!this._replay) {
      return Promise.resolve();
    }

    return this._replay.stop();
  }

  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
   flush(options) {
    if (!this._replay || !this._replay.isEnabled()) {
      return Promise.resolve();
    }

    return this._replay.sendBufferedReplayOrFlush(options);
  }

  /**
   * Get the current session ID.
   */
   getReplayId() {
    if (!this._replay || !this._replay.isEnabled()) {
      return;
    }

    return this._replay.getSessionId();
  }
  /**
   * Initializes replay.
   */
   _initialize() {
    if (!this._replay) {
      return;
    }

    this._replay.initializeSampling();
  }

  /** Setup the integration. */
   _setup() {
    // Client is not available in constructor, so we need to wait until setupOnce
    const finalOptions = loadReplayOptionsFromClient(this._initialOptions);

    this._replay = new ReplayContainer({
      options: finalOptions,
      recordingOptions: this._recordingOptions,
    });
  }
} Replay.__initStatic();

/** Parse Replay-related options from SDK options */
function loadReplayOptionsFromClient(initialOptions) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const opt = client && (client.getOptions() );

  const finalOptions = { sessionSampleRate: 0, errorSampleRate: 0, ...(0,object/* dropUndefinedKeys */.Jr)(initialOptions) };

  if (!opt) {
    // eslint-disable-next-line no-console
    console.warn('SDK client is not available.');
    return finalOptions;
  }

  if (
    initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null &&
    opt.replaysOnErrorSampleRate == null
  ) {
    // eslint-disable-next-line no-console
    console.warn(
      'Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.',
    );
  }

  if (typeof opt.replaysSessionSampleRate === 'number') {
    finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
  }

  if (typeof opt.replaysOnErrorSampleRate === 'number') {
    finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
  }

  return finalOptions;
}

function _getMergedNetworkHeaders(headers) {
  return [...DEFAULT_NETWORK_HEADERS, ...headers.map(header => header.toLowerCase())];
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
var ratelimit = __webpack_require__(80228);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/offline.js


const MIN_DELAY = 100; // 100 ms
const START_DELAY = 5000; // 5 seconds
const MAX_DELAY = 3.6e6; // 1 hour

function log(msg, error) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.info */.kg.info(`[Offline]: ${msg}`, error);
}

/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */
function makeOfflineTransport(
  createTransport,
) {
  return options => {
    const transport = createTransport(options);
    const store = options.createStore ? options.createStore(options) : undefined;

    let retryDelay = START_DELAY;
    let flushTimer;

    function shouldQueue(env, error, retryDelay) {
      // We don't queue Session Replay envelopes because they are:
      // - Ordered and Replay relies on the response status to know when they're successfully sent.
      // - Likely to fill the queue quickly and block other events from being sent.
      // We also want to drop client reports because they can be generated when we retry sending events while offline.
      if ((0,esm_envelope/* envelopeContainsItemType */.R)(env, ['replay_event', 'replay_recording', 'client_report'])) {
        return false;
      }

      if (options.shouldStore) {
        return options.shouldStore(env, error, retryDelay);
      }

      return true;
    }

    function flushIn(delay) {
      if (!store) {
        return;
      }

      if (flushTimer) {
        clearTimeout(flushTimer );
      }

      flushTimer = setTimeout(async () => {
        flushTimer = undefined;

        const found = await store.pop();
        if (found) {
          log('Attempting to send previously queued event');
          void send(found).catch(e => {
            log('Failed to retry sending', e);
          });
        }
      }, delay) ;

      // We need to unref the timer in node.js, otherwise the node process never exit.
      if (typeof flushTimer !== 'number' && flushTimer.unref) {
        flushTimer.unref();
      }
    }

    function flushWithBackOff() {
      if (flushTimer) {
        return;
      }

      flushIn(retryDelay);

      retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
    }

    async function send(envelope) {
      try {
        const result = await transport.send(envelope);

        let delay = MIN_DELAY;

        if (result) {
          // If there's a retry-after header, use that as the next delay.
          if (result.headers && result.headers['retry-after']) {
            delay = (0,ratelimit/* parseRetryAfterHeader */.JY)(result.headers['retry-after']);
          } // If we have a server error, return now so we don't flush the queue.
          else if ((result.statusCode || 0) >= 400) {
            return result;
          }
        }

        flushIn(delay);
        retryDelay = START_DELAY;
        return result;
      } catch (e) {
        if (store && (await shouldQueue(envelope, e , retryDelay))) {
          await store.insert(envelope);
          flushWithBackOff();
          log('Error sending. Event queued', e );
          return {};
        } else {
          throw e;
        }
      }
    }

    if (options.flushAtStartup) {
      flushWithBackOff();
    }

    return {
      send,
      flush: t => transport.flush(t),
    };
  };
}


//# sourceMappingURL=offline.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/offline.js



// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:

// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function promisifyRequest(request) {
  return new Promise((resolve, reject) => {
    // @ts-ignore - file size hacks
    request.oncomplete = request.onsuccess = () => resolve(request.result);
    // @ts-ignore - file size hacks
    request.onabort = request.onerror = () => reject(request.error);
  });
}

/** Create or open an IndexedDb store */
function createStore(dbName, storeName) {
  const request = indexedDB.open(dbName);
  request.onupgradeneeded = () => request.result.createObjectStore(storeName);
  const dbp = promisifyRequest(request);

  return callback => dbp.then(db => callback(db.transaction(storeName, 'readwrite').objectStore(storeName)));
}

function keys(store) {
  return promisifyRequest(store.getAllKeys() );
}

/** Insert into the store */
function insert(store, value, maxQueueSize) {
  return store(store => {
    return keys(store).then(keys => {
      if (keys.length >= maxQueueSize) {
        return;
      }

      // We insert with an incremented key so that the entries are popped in order
      store.put(value, Math.max(...keys, 0) + 1);
      return promisifyRequest(store.transaction);
    });
  });
}

/** Pop the oldest value from the store */
function pop(store) {
  return store(store => {
    return keys(store).then(keys => {
      if (keys.length === 0) {
        return undefined;
      }

      return promisifyRequest(store.get(keys[0])).then(value => {
        store.delete(keys[0]);
        return promisifyRequest(store.transaction).then(() => value);
      });
    });
  });
}

function createIndexedDbStore(options) {
  let store;

  // Lazily create the store only when it's needed
  function getStore() {
    if (store == undefined) {
      store = createStore(options.dbName || 'sentry-offline', options.storeName || 'queue');
    }

    return store;
  }

  return {
    insert: async (env) => {
      try {
        const serialized = await (0,esm_envelope/* serializeEnvelope */.V$)(env, options.textEncoder);
        await insert(getStore(), serialized, options.maxQueueSize || 30);
      } catch (_) {
        //
      }
    },
    pop: async () => {
      try {
        const deserialized = await pop(getStore());
        if (deserialized) {
          return (0,esm_envelope/* parseEnvelope */.f4)(
            deserialized,
            options.textEncoder || new TextEncoder(),
            options.textDecoder || new TextDecoder(),
          );
        }
      } catch (_) {
        //
      }

      return undefined;
    },
  };
}

function makeIndexedDbOfflineTransport(
  createTransport,
) {
  return options => createTransport({ ...options, createStore: createIndexedDbStore });
}

/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */
function makeBrowserOfflineTransport(
  createTransport,
) {
  return makeIndexedDbOfflineTransport(makeOfflineTransport(createTransport));
}


//# sourceMappingURL=offline.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/constants.js
var constants = __webpack_require__(51131);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/profiling/utils.js




/* eslint-disable max-lines */

const MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const THREAD_ID_STRING = String(0);
const THREAD_NAME = 'main';

// Machine properties (eval only once)
let OS_PLATFORM = '';
let OS_PLATFORM_VERSION = '';
let OS_ARCH = '';
let OS_BROWSER = (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.userAgent */.m9.navigator.userAgent) || '';
let OS_MODEL = '';
const OS_LOCALE =
  (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.language */.m9.navigator.language) ||
  (helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.languages */.m9.navigator.languages && helpers/* WINDOW.navigator.languages.0 */.m9.navigator.languages[0]) ||
  '';

function isUserAgentData(data) {
  return typeof data === 'object' && data !== null && 'getHighEntropyValues' in data;
}

// @ts-ignore userAgentData is not part of the navigator interface yet
const userAgentData = helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.userAgentData */.m9.navigator.userAgentData;

if (isUserAgentData(userAgentData)) {
  userAgentData
    .getHighEntropyValues(['architecture', 'model', 'platform', 'platformVersion', 'fullVersionList'])
    .then((ua) => {
      OS_PLATFORM = ua.platform || '';
      OS_ARCH = ua.architecture || '';
      OS_MODEL = ua.model || '';
      OS_PLATFORM_VERSION = ua.platformVersion || '';

      if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
      }
    })
    .catch(e => void e);
}

function isProcessedJSSelfProfile(profile) {
  return !('thread_metadata' in profile);
}

// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */
function enrichWithThreadInformation(profile) {
  if (!isProcessedJSSelfProfile(profile)) {
    return profile;
  }

  return convertJSSelfProfileToSampledFormat(profile);
}

// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.

function getTraceId(event) {
  const traceId = event && event.contexts && event.contexts['trace'] && event.contexts['trace']['trace_id'];
  // Log a warning if the profile has an invalid traceId (should be uuidv4).
  // All profiles and transactions are rejected if this is the case and we want to
  // warn users that this is happening if they enable debug flag
  if (typeof traceId === 'string' && traceId.length !== 32) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
  }
  if (typeof traceId !== 'string') {
    return '';
  }

  return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */

/**
 * Creates a profiling event envelope from a Sentry event.
 */
function createProfilePayload(
  event,
  processedProfile,
  profile_id,
) {
  if (event.type !== 'transaction') {
    // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');
  }

  if (processedProfile === undefined || processedProfile === null) {
    throw new TypeError(
      `Cannot construct profiling event envelope without a valid profile. Got ${processedProfile} instead.`,
    );
  }

  const traceId = getTraceId(event);
  const enrichedThreadProfile = enrichWithThreadInformation(processedProfile);
  const transactionStartMs = typeof event.start_timestamp === 'number' ? event.start_timestamp * 1000 : Date.now();
  const transactionEndMs = typeof event.timestamp === 'number' ? event.timestamp * 1000 : Date.now();

  const profile = {
    event_id: profile_id,
    timestamp: new Date(transactionStartMs).toISOString(),
    platform: 'javascript',
    version: '1',
    release: event.release || '',
    environment: event.environment || constants/* DEFAULT_ENVIRONMENT */.J,
    runtime: {
      name: 'javascript',
      version: helpers/* WINDOW.navigator.userAgent */.m9.navigator.userAgent,
    },
    os: {
      name: OS_PLATFORM,
      version: OS_PLATFORM_VERSION,
      build_number: OS_BROWSER,
    },
    device: {
      locale: OS_LOCALE,
      model: OS_MODEL,
      manufacturer: OS_BROWSER,
      architecture: OS_ARCH,
      is_emulator: false,
    },
    debug_meta: {
      images: applyDebugMetadata(processedProfile.resources),
    },
    profile: enrichedThreadProfile,
    transactions: [
      {
        name: event.transaction || '',
        id: event.event_id || (0,misc/* uuid4 */.DM)(),
        trace_id: traceId,
        active_thread_id: THREAD_ID_STRING,
        relative_start_ns: '0',
        relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0),
      },
    ],
  };

  return profile;
}

/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */
function convertJSSelfProfileToSampledFormat(input) {
  let EMPTY_STACK_ID = undefined;
  let STACK_ID = 0;

  // Initialize the profile that we will fill with data
  const profile = {
    samples: [],
    stacks: [],
    frames: [],
    thread_metadata: {
      [THREAD_ID_STRING]: { name: THREAD_NAME },
    },
  };

  if (!input.samples.length) {
    return profile;
  }

  // We assert samples.length > 0 above and timestamp should always be present
  const start = input.samples[0].timestamp;
  // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
  // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
  // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
  // the drift between the SDK selected value and our profile time origin.
  const origin =
    typeof performance.timeOrigin === 'number' ? performance.timeOrigin : esm_time/* browserPerformanceTimeOrigin */.Z1 || 0;
  const adjustForOriginChange = origin - (esm_time/* browserPerformanceTimeOrigin */.Z1 || origin);

  for (let i = 0; i < input.samples.length; i++) {
    const jsSample = input.samples[i];

    // If sample has no stack, add an empty sample
    if (jsSample.stackId === undefined) {
      if (EMPTY_STACK_ID === undefined) {
        EMPTY_STACK_ID = STACK_ID;
        profile.stacks[EMPTY_STACK_ID] = [];
        STACK_ID++;
      }

      profile['samples'][i] = {
        // convert ms timestamp to ns
        elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
        stack_id: EMPTY_STACK_ID,
        thread_id: THREAD_ID_STRING,
      };
      continue;
    }

    let stackTop = input.stacks[jsSample.stackId];

    // Functions in top->down order (root is last)
    // We follow the stackTop.parentId trail and collect each visited frameId
    const stack = [];

    while (stackTop) {
      stack.push(stackTop.frameId);

      const frame = input.frames[stackTop.frameId];

      // If our frame has not been indexed yet, index it
      if (profile.frames[stackTop.frameId] === undefined) {
        profile.frames[stackTop.frameId] = {
          function: frame.name,
          abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
          lineno: frame.line,
          colno: frame.column,
        };
      }

      stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
    }

    const sample = {
      // convert ms timestamp to ns
      elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
      stack_id: STACK_ID,
      thread_id: THREAD_ID_STRING,
    };

    profile['stacks'][STACK_ID] = stack;
    profile['samples'][i] = sample;
    STACK_ID++;
  }

  return profile;
}

/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */
function addProfilesToEnvelope(envelope, profiles) {
  if (!profiles.length) {
    return envelope;
  }

  for (const profile of profiles) {
    // @ts-ignore untyped envelope
    envelope[1].push([{ type: 'profile' }, profile]);
  }
  return envelope;
}

/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */
function findProfiledTransactionsFromEnvelope(envelope) {
  const events = [];

  (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, (item, type) => {
    if (type !== 'transaction') {
      return;
    }

    for (let j = 1; j < item.length; j++) {
      const event = item[j] ;

      if (event && event.contexts && event.contexts['profile'] && event.contexts['profile']['profile_id']) {
        events.push(item[j] );
      }
    }
  });

  return events;
}

const debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */
function applyDebugMetadata(resource_paths) {
  const debugIdMap = worldwide/* GLOBAL_OBJ._sentryDebugIds */.n2._sentryDebugIds;

  if (!debugIdMap) {
    return [];
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  if (!hub) {
    return [];
  }
  const client = hub.getClient();
  if (!client) {
    return [];
  }
  const options = client.getOptions();
  if (!options) {
    return [];
  }
  const stackParser = options.stackParser;
  if (!stackParser) {
    return [];
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;

    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      const file = stackFrame && stackFrame.filename;

      if (stackFrame && file) {
        acc[file] = debugIdMap[debugIdStackTrace] ;
        break;
      }
    }
    return acc;
  }, {});

  const images = [];
  for (const path of resource_paths) {
    if (path && filenameDebugIdMap[path]) {
      images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path] ,
      });
    }
  }

  return images;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  if ((typeof rate !== 'number' && typeof rate !== 'boolean') || (typeof rate === 'number' && isNaN(rate))) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // Boolean sample rates are always valid
  if (rate === true || rate === false) {
    return true;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

function isValidProfile(profile) {
  if (profile.samples.length < 2) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      // Log a warning if the profile has less than 2 samples so users can know why
      // they are not seeing any profiling data and we cant avoid the back and forth
      // of asking them to provide us with a dump of the profile data.
      logger/* logger.log */.kg.log('[Profiling] Discarding profile because it contains less than 2 samples');
    }
    return false;
  }

  if (!profile.frames.length) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Discarding profile because it contains no frames');
    }
    return false;
  }

  return true;
}

/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */
function createProfilingEvent(profile_id, profile, event) {
  if (!isValidProfile(profile)) {
    return null;
  }

  return createProfilePayload(event, profile, profile_id);
}

const PROFILE_MAP = new Map();
/**
 *
 */
function addProfileToMap(profile_id, profile) {
  PROFILE_MAP.set(profile_id, profile);

  if (PROFILE_MAP.size > 30) {
    const last = PROFILE_MAP.keys().next().value;
    PROFILE_MAP.delete(last);
  }
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/profiling/hubextensions.js





/* eslint-disable complexity */

const MAX_PROFILE_DURATION_MS = 30000;
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let PROFILING_CONSTRUCTOR_FAILED = false;

/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */
function isJSProfilerSupported(maybeProfiler) {
  return typeof maybeProfiler === 'function';
}

/**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */
function onProfilingStartRouteTransaction(transaction) {
  if (!transaction) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Transaction is undefined, skipping profiling');
    }
    return transaction;
  }

  return wrapTransactionWithProfiling(transaction);
}

/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfiling is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */
function wrapTransactionWithProfiling(transaction) {
  // Feature support check first
  const JSProfilerConstructor = helpers/* WINDOW.Profiler */.m9.Profiler;

  if (!isJSProfilerSupported(JSProfilerConstructor)) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        '[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.',
      );
    }
    return transaction;
  }

  // If constructor failed once, it will always fail, so we can early return.
  if (PROFILING_CONSTRUCTOR_FAILED) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log('[Profiling] Profiling has been disabled for the duration of the current user session.');
    }
    return transaction;
  }

  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  const options = client && client.getOptions();
  if (!options) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Profiling] Profiling disabled, no options found.');
    return transaction;
  }

  // @ts-ignore profilesSampleRate is not part of the browser options yet
  const profilesSampleRate = options.profilesSampleRate;

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(profilesSampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Profiling] Discarding profile because of invalid sample rate.');
    return transaction;
  }

  // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
  if (!profilesSampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        '[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0',
      );
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
  // Check if we should sample this profile
  if (!sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(
          profilesSampleRate,
        )})`,
      );
    return transaction;
  }

  // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
  const samplingIntervalMS = 10;
  // Start the profiler
  const maxSamples = Math.floor(MAX_PROFILE_DURATION_MS / samplingIntervalMS);
  let profiler;

  // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
  // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
  // as we risk breaking the user's application, so just disable profiling and log an error.
  try {
    profiler = new JSProfilerConstructor({ sampleInterval: samplingIntervalMS, maxBufferSize: maxSamples });
  } catch (e) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        "[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.",
      );
      logger/* logger.log */.kg.log('[Profiling] Disabling profiling for current user session.');
    }
    PROFILING_CONSTRUCTOR_FAILED = true;
  }

  // We failed to construct the profiler, fallback to original transaction - there is no need to log
  // anything as we already did that in the try/catch block.
  if (!profiler) {
    return transaction;
  }

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    logger/* logger.log */.kg.log(`[Profiling] started profiling transaction: ${transaction.name || transaction.description}`);
  }

  // We create "unique" transaction names to avoid concurrent transactions with same names
  // from being ignored by the profiler. From here on, only this transaction name should be used when
  // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
  const profileId = (0,misc/* uuid4 */.DM)();

  /**
   * Idempotent handler for profile stop
   */
  async function onProfileHandler() {
    // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
    if (!transaction) {
      return null;
    }
    // Satisfy the type checker, but profiler will always be defined here.
    if (!profiler) {
      return null;
    }

    // This is temporary - we will use the collected span data to evaluate
    // if deferring txn.finish until profiler resolves is a viable approach.
    const stopProfilerSpan = transaction.startChild({ description: 'profiler.stop', op: 'profiler' });

    return profiler
      .stop()
      .then((p) => {
        stopProfilerSpan.finish();

        if (maxDurationTimeoutID) {
          helpers/* WINDOW.clearTimeout */.m9.clearTimeout(maxDurationTimeoutID);
          maxDurationTimeoutID = undefined;
        }

        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          logger/* logger.log */.kg.log(`[Profiling] stopped profiling of transaction: ${transaction.name || transaction.description}`);
        }

        // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
        if (!p) {
          if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
            logger/* logger.log */.kg.log(
              `[Profiling] profiler returned null profile for: ${transaction.name || transaction.description}`,
              'this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started',
            );
          }
          return null;
        }

        addProfileToMap(profileId, p);
        return null;
      })
      .catch(error => {
        stopProfilerSpan.finish();
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          logger/* logger.log */.kg.log('[Profiling] error while stopping profiler:', error);
        }
        return null;
      });
  }

  // Enqueue a timeout to prevent profiles from running over max duration.
  let maxDurationTimeoutID = helpers/* WINDOW.setTimeout */.m9.setTimeout(() => {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      logger/* logger.log */.kg.log(
        '[Profiling] max profile duration elapsed, stopping profiling for:',
        transaction.name || transaction.description,
      );
    }
    // If the timeout exceeds, we want to stop profiling, but not finish the transaction
    void onProfileHandler();
  }, MAX_PROFILE_DURATION_MS);

  // We need to reference the original finish call to avoid creating an infinite loop
  const originalFinish = transaction.finish.bind(transaction);

  /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */
  function profilingWrappedTransactionFinish() {
    if (!transaction) {
      return originalFinish();
    }
    // onProfileHandler should always return the same profile even if this is called multiple times.
    // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
    void onProfileHandler().then(
      () => {
        transaction.setContext('profile', { profile_id: profileId });
        originalFinish();
      },
      () => {
        // If onProfileHandler fails, we still want to call the original finish method.
        originalFinish();
      },
    );

    return transaction;
  }

  transaction.finish = profilingWrappedTransactionFinish;
  return transaction;
}


//# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/profiling/integration.js




/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 */
class BrowserProfilingIntegration  {constructor() { BrowserProfilingIntegration.prototype.__init.call(this);BrowserProfilingIntegration.prototype.__init2.call(this); }
    __init() {this.name = 'BrowserProfilingIntegration';}
   __init2() {this.getCurrentHub = undefined;}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    this.getCurrentHub = getCurrentHub;
    const client = this.getCurrentHub().getClient() ;

    if (client && typeof client.on === 'function') {
      client.on('startTransaction', (transaction) => {
        wrapTransactionWithProfiling(transaction);
      });

      client.on('beforeEnvelope', (envelope) => {
        // if not profiles are in queue, there is nothing to add to the envelope.
        if (!PROFILE_MAP.size) {
          return;
        }

        const profiledTransactionEvents = findProfiledTransactionsFromEnvelope(envelope);
        if (!profiledTransactionEvents.length) {
          return;
        }

        const profilesToAddToEnvelope = [];

        for (const profiledTransaction of profiledTransactionEvents) {
          const context = profiledTransaction && profiledTransaction.contexts;
          const profile_id = context && context['profile'] && (context['profile']['profile_id'] );

          if (!profile_id) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
              logger/* logger.log */.kg.log('[Profiling] cannot find profile for a transaction without a profile context');
            continue;
          }

          // Remove the profile from the transaction context before sending, relay will take care of the rest.
          if (context && context['profile']) {
            delete context.profile;
          }

          const profile = PROFILE_MAP.get(profile_id);
          if (!profile) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
            continue;
          }

          PROFILE_MAP["delete"](profile_id);
          const profileEvent = createProfilingEvent(profile_id, profile, profiledTransaction );

          if (profileEvent) {
            profilesToAddToEnvelope.push(profileEvent);
          }
        }

        addProfilesToEnvelope(envelope, profilesToAddToEnvelope);
      });
    } else {
      logger/* logger.warn */.kg.warn('[Profiling] Client does not support hooks, profiling will be disabled');
    }
  }
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/index.js
























let windowIntegrations = {};

// This block is needed to add compatibility with the integrations packages when used with a CDN
if (helpers/* WINDOW.Sentry */.m9.Sentry && helpers/* WINDOW.Sentry.Integrations */.m9.Sentry.Integrations) {
  windowIntegrations = helpers/* WINDOW.Sentry.Integrations */.m9.Sentry.Integrations;
}

const INTEGRATIONS = {
  ...windowIntegrations,
  ...integrations_namespaceObject,
  ...esm_integrations_namespaceObject,
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/constants.js
const REACT_RENDER_OP = 'ui.react.render';

const REACT_UPDATE_OP = 'ui.react.update';

const REACT_MOUNT_OP = 'ui.react.mount';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/profiler.js






const _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";

const UNKNOWN_COMPONENT = 'unknown';

/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */
class Profiler extends react.Component {
  /**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   */
   __init() {this._mountSpan = undefined;}
  /**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */
   __init2() {this._updateSpan = undefined;}

  // eslint-disable-next-line @typescript-eslint/member-ordering
   static __initStatic() {this.defaultProps = {
    disabled: false,
    includeRender: true,
    includeUpdates: true,
  };}

   constructor(props) {
    super(props);Profiler.prototype.__init.call(this);Profiler.prototype.__init2.call(this);    const { name, disabled = false } = this.props;

    if (disabled) {
      return;
    }

    const activeTransaction = getActiveTransaction();
    if (activeTransaction) {
      this._mountSpan = activeTransaction.startChild({
        description: `<${name}>`,
        op: REACT_MOUNT_OP,
      });
    }
  }

  // If a component mounted, we can finish the mount activity.
   componentDidMount() {
    if (this._mountSpan) {
      this._mountSpan.finish();
    }
  }

   shouldComponentUpdate({ updateProps, includeUpdates = true }) {
    // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
    // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
    // We are just trying to give baseline clues for further investigation.
    if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
      // See what props haved changed between the previous props, and the current props. This is
      // set as data on the span. We just store the prop keys as the values could be potenially very large.
      const changedProps = Object.keys(updateProps).filter(k => updateProps[k] !== this.props.updateProps[k]);
      if (changedProps.length > 0) {
        const now = (0,esm_time/* timestampInSeconds */.ph)();
        this._updateSpan = this._mountSpan.startChild({
          data: {
            changedProps,
          },
          description: `<${this.props.name}>`,
          op: REACT_UPDATE_OP,
          startTimestamp: now,
        });
      }
    }

    return true;
  }

   componentDidUpdate() {
    if (this._updateSpan) {
      this._updateSpan.finish();
      this._updateSpan = undefined;
    }
  }

  // If a component is unmounted, we can say it is no longer on the screen.
  // This means we can finish the span representing the component render.
   componentWillUnmount() {
    const { name, includeRender = true } = this.props;

    if (this._mountSpan && includeRender) {
      // If we were able to obtain the spanId of the mount activity, we should set the
      // next activity as a child to the component mount activity.
      this._mountSpan.startChild({
        description: `<${name}>`,
        endTimestamp: (0,esm_time/* timestampInSeconds */.ph)(),
        op: REACT_RENDER_OP,
        startTimestamp: this._mountSpan.endTimestamp,
      });
    }
  }

   render() {
    return this.props.children;
  }
} Profiler.__initStatic();

/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */
function withProfiler(
  WrappedComponent,
  // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
  options,
) {
  const componentDisplayName =
    (options && options.name) || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;

  const Wrapped = (props) => (
    react.createElement(Profiler, { ...options, name: componentDisplayName, updateProps: props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
      , react.createElement(WrappedComponent, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}} )
    )
  );

  Wrapped.displayName = `profiler(${componentDisplayName})`;

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoist_non_react_statics_cjs_default()(Wrapped, WrappedComponent);
  return Wrapped;
}

/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */
function useProfiler(
  name,
  options = {
    disabled: false,
    hasRenderSpan: true,
  },
) {
  const [mountSpan] = react.useState(() => {
    if (options && options.disabled) {
      return undefined;
    }

    const activeTransaction = getActiveTransaction();
    if (activeTransaction) {
      return activeTransaction.startChild({
        description: `<${name}>`,
        op: REACT_MOUNT_OP,
      });
    }

    return undefined;
  });

  react.useEffect(() => {
    if (mountSpan) {
      mountSpan.finish();
    }

    return () => {
      if (mountSpan && options.hasRenderSpan) {
        mountSpan.startChild({
          description: `<${name}>`,
          endTimestamp: (0,esm_time/* timestampInSeconds */.ph)(),
          op: REACT_RENDER_OP,
          startTimestamp: mountSpan.endTimestamp,
        });
      }
    };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

/** Grabs active transaction off scope */
function getActiveTransaction(hub = (0,esm_hub/* getCurrentHub */.Gd)()) {
  if (hub) {
    const scope = hub.getScope();
    if (scope) {
      return scope.getTransaction() ;
    }
  }

  return undefined;
}


//# sourceMappingURL=profiler.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/redux.js



/* eslint-disable @typescript-eslint/no-explicit-any */

const ACTION_BREADCRUMB_CATEGORY = 'redux.action';
const ACTION_BREADCRUMB_TYPE = 'info';

const defaultOptions = {
  actionTransformer: action => action,
  stateTransformer: state => state || null,
};

/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */
function createReduxEnhancer(enhancerOptions) {
  // Note: We return an any type as to not have type conflicts.
  const options = {
    ...defaultOptions,
    ...enhancerOptions,
  };

  return (next) =>
    (reducer, initialState) => {
      const sentryReducer = (state, action) => {
        const newState = reducer(state, action);

        (0,esm_exports/* configureScope */.e)(scope => {
          /* Action breadcrumbs */
          const transformedAction = options.actionTransformer(action);
          if (typeof transformedAction !== 'undefined' && transformedAction !== null) {
            scope.addBreadcrumb({
              category: ACTION_BREADCRUMB_CATEGORY,
              data: transformedAction,
              type: ACTION_BREADCRUMB_TYPE,
            });
          }

          /* Set latest state to scope */
          const transformedState = options.stateTransformer(newState);
          if (typeof transformedState !== 'undefined' && transformedState !== null) {
            const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
            const options = client && client.getOptions();
            const normalizationDepth = (options && options.normalizeDepth) || 3; // default state normalization depth to 3

            // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
            const newStateContext = { state: { type: 'redux', value: transformedState } };
            (0,object/* addNonEnumerableProperty */.xp)(
              newStateContext,
              '__sentry_override_normalization_depth__',
              3 + // 3 layers for `state.value.transformedState`
                normalizationDepth, // rest for the actual state
            );

            scope.setContext('state', newStateContext);
          } else {
            scope.setContext('state', null);
          }

          /* Allow user to configure scope with latest state */
          const { configureScopeWithState } = options;
          if (typeof configureScopeWithState === 'function') {
            configureScopeWithState(scope, newState);
          }
        });

        return newState;
      };

      return next(sentryReducer, initialState);
    };
}


//# sourceMappingURL=redux.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/reactrouterv3.js


// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.

/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 */
function reactRouterV3Instrumentation(
  history,
  routes,
  match,
) {
  return (
    startTransaction,
    startTransactionOnPageLoad = true,
    startTransactionOnLocationChange = true,
  ) => {
    let activeTransaction;
    let prevName;

    // Have to use window.location because history.location might not be defined.
    if (startTransactionOnPageLoad && helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location) {
      normalizeTransactionName(
        routes,
        helpers/* WINDOW.location */.m9.location ,
        match,
        (localName, source = 'url') => {
          prevName = localName;
          activeTransaction = startTransaction({
            name: prevName,
            op: 'pageload',
            tags: {
              'routing.instrumentation': 'react-router-v3',
            },
            metadata: {
              source,
            },
          });
        },
      );
    }

    if (startTransactionOnLocationChange && history.listen) {
      history.listen(location => {
        if (location.action === 'PUSH' || location.action === 'POP') {
          if (activeTransaction) {
            activeTransaction.finish();
          }
          const tags = {
            'routing.instrumentation': 'react-router-v3',
          };
          if (prevName) {
            tags.from = prevName;
          }
          normalizeTransactionName(routes, location, match, (localName, source = 'url') => {
            prevName = localName;
            activeTransaction = startTransaction({
              name: prevName,
              op: 'navigation',
              tags,
              metadata: {
                source,
              },
            });
          });
        }
      });
    }
  };
}

/**
 * Normalize transaction names using `Router.match`
 */
function normalizeTransactionName(
  appRoutes,
  location,
  match,
  callback,
) {
  let name = location.pathname;
  match(
    {
      location,
      routes: appRoutes,
    },
    (error, _redirectLocation, renderProps) => {
      if (error || !renderProps) {
        return callback(name);
      }

      const routePath = getRouteStringFromRoutes(renderProps.routes || []);
      if (routePath.length === 0 || routePath === '/*') {
        return callback(name);
      }

      name = routePath;
      return callback(name, 'route');
    },
  );
}

/**
 * Generate route name from array of routes
 */
function getRouteStringFromRoutes(routes) {
  if (!Array.isArray(routes) || routes.length === 0) {
    return '';
  }

  const routesWithPaths = routes.filter((route) => !!route.path);

  let index = -1;
  for (let x = routesWithPaths.length - 1; x >= 0; x--) {
    const route = routesWithPaths[x];
    if (route.path && route.path.startsWith('/')) {
      index = x;
      break;
    }
  }

  return routesWithPaths
    .slice(index)
    .filter(({ path }) => !!path)
    .map(({ path }) => path)
    .join('');
}


//# sourceMappingURL=reactrouterv3.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/reactrouter.js




const reactrouter_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouter.tsx";
// We need to disable eslint no-explict-any because any is required for the
// react-router typings.
/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-enable @typescript-eslint/no-explicit-any */

let activeTransaction;

function reactRouterV4Instrumentation(
  history,
  routes,
  matchPath,
) {
  return createReactRouterInstrumentation(history, 'react-router-v4', routes, matchPath);
}

function reactRouterV5Instrumentation(
  history,
  routes,
  matchPath,
) {
  return createReactRouterInstrumentation(history, 'react-router-v5', routes, matchPath);
}

function createReactRouterInstrumentation(
  history,
  name,
  allRoutes = [],
  matchPath,
) {
  function getInitPathName() {
    if (history && history.location) {
      return history.location.pathname;
    }

    if (helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location) {
      return helpers/* WINDOW.location.pathname */.m9.location.pathname;
    }

    return undefined;
  }

  /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */
  function normalizeTransactionName(pathname) {
    if (allRoutes.length === 0 || !matchPath) {
      return [pathname, 'url'];
    }

    const branches = matchRoutes(allRoutes, pathname, matchPath);
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let x = 0; x < branches.length; x++) {
      if (branches[x].match.isExact) {
        return [branches[x].match.path, 'route'];
      }
    }

    return [pathname, 'url'];
  }

  const tags = {
    'routing.instrumentation': name,
  };

  return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) => {
    const initPathName = getInitPathName();
    if (startTransactionOnPageLoad && initPathName) {
      const [name, source] = normalizeTransactionName(initPathName);
      activeTransaction = customStartTransaction({
        name,
        op: 'pageload',
        tags,
        metadata: {
          source,
        },
      });
    }

    if (startTransactionOnLocationChange && history.listen) {
      history.listen((location, action) => {
        if (action && (action === 'PUSH' || action === 'POP')) {
          if (activeTransaction) {
            activeTransaction.finish();
          }

          const [name, source] = normalizeTransactionName(location.pathname);
          activeTransaction = customStartTransaction({
            name,
            op: 'navigation',
            tags,
            metadata: {
              source,
            },
          });
        }
      });
    }
  };
}

/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */
function matchRoutes(
  routes,
  pathname,
  matchPath,
  branch = [],
) {
  routes.some(route => {
    const match = route.path
      ? matchPath(pathname, route)
      : branch.length
      ? branch[branch.length - 1].match // use parent match
      : computeRootMatch(pathname); // use default "root" match

    if (match) {
      branch.push({ route, match });

      if (route.routes) {
        matchRoutes(route.routes, pathname, matchPath, branch);
      }
    }

    return !!match;
  });

  return branch;
}

function computeRootMatch(pathname) {
  return { path: '/', url: '/', params: {}, isExact: pathname === '/' };
}

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
function withSentryRouting(Route) {
  const componentDisplayName = (Route ).displayName || (Route ).name;

  const WrappedRoute = (props) => {
    if (activeTransaction && props && props.computedMatch && props.computedMatch.isExact) {
      activeTransaction.setName(props.computedMatch.path, 'route');
    }

    // @ts-ignore Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return react.createElement(Route, { ...props, __self: this, __source: {fileName: reactrouter_jsxFileName, lineNumber: 174}} );
  };

  WrappedRoute.displayName = `sentryRoute(${componentDisplayName})`;
  hoist_non_react_statics_cjs_default()(WrappedRoute, Route);
  // @ts-ignore Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params:
  // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
  return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */


//# sourceMappingURL=reactrouter.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(26956);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/reactrouterv6.js





const reactrouterv6_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx";// Inspired from Donnie McNeal's solution:

let reactrouterv6_activeTransaction;

let _useEffect;
let _useLocation;
let _useNavigationType;
let _createRoutesFromChildren;
let _matchRoutes;
let _customStartTransaction;
let _startTransactionOnLocationChange;

const SENTRY_TAGS = {
  'routing.instrumentation': 'react-router-v6',
};

function reactRouterV6Instrumentation(
  useEffect,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
) {
  return (
    customStartTransaction,
    startTransactionOnPageLoad = true,
    startTransactionOnLocationChange = true,
  ) => {
    const initPathName = helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.pathname */.m9.location.pathname;
    if (startTransactionOnPageLoad && initPathName) {
      reactrouterv6_activeTransaction = customStartTransaction({
        name: initPathName,
        op: 'pageload',
        tags: SENTRY_TAGS,
        metadata: {
          source: 'url',
        },
      });
    }

    _useEffect = useEffect;
    _useLocation = useLocation;
    _useNavigationType = useNavigationType;
    _matchRoutes = matchRoutes;
    _createRoutesFromChildren = createRoutesFromChildren;

    _customStartTransaction = customStartTransaction;
    _startTransactionOnLocationChange = startTransactionOnLocationChange;
  };
}

function getNormalizedName(
  routes,
  location,
  branches,
) {
  if (!routes || routes.length === 0) {
    return [location.pathname, 'url'];
  }

  let pathBuilder = '';
  if (branches) {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let x = 0; x < branches.length; x++) {
      const branch = branches[x];
      const route = branch.route;
      if (route) {
        // Early return if index route
        if (route.index) {
          return [branch.pathname, 'route'];
        }

        const path = route.path;
        if (path) {
          const newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : `/${path}`;
          pathBuilder += newPath;
          if (branch.pathname === location.pathname) {
            if (
              // If the route defined on the element is something like
              // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
              // We should check against the branch.pathname for the number of / seperators
              (0,url/* getNumberOfUrlSegments */.$A)(pathBuilder) !== (0,url/* getNumberOfUrlSegments */.$A)(branch.pathname) &&
              // We should not count wildcard operators in the url segments calculation
              pathBuilder.slice(-2) !== '/*'
            ) {
              return [newPath, 'route'];
            }
            return [pathBuilder, 'route'];
          }
        }
      }
    }
  }

  return [location.pathname, 'url'];
}

function updatePageloadTransaction(
  location,
  routes,
  matches,
  basename,
) {
  const branches = Array.isArray(matches)
    ? matches
    : (_matchRoutes(routes, location, basename) );

  if (reactrouterv6_activeTransaction && branches) {
    reactrouterv6_activeTransaction.setName(...getNormalizedName(routes, location, branches));
  }
}

function handleNavigation(
  location,
  routes,
  navigationType,
  matches,
  basename,
) {
  const branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location, basename);

  if (_startTransactionOnLocationChange && (navigationType === 'PUSH' || navigationType === 'POP') && branches) {
    if (reactrouterv6_activeTransaction) {
      reactrouterv6_activeTransaction.finish();
    }

    const [name, source] = getNormalizedName(routes, location, branches);
    reactrouterv6_activeTransaction = _customStartTransaction({
      name,
      op: 'navigation',
      tags: SENTRY_TAGS,
      metadata: {
        source,
      },
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV6Routing(Routes) {
  if (
    !_useEffect ||
    !_useLocation ||
    !_useNavigationType ||
    !_createRoutesFromChildren ||
    !_matchRoutes ||
    !_customStartTransaction
  ) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${_useEffect}. useLocation: ${_useLocation}. useNavigationType: ${_useNavigationType}.
      createRoutesFromChildren: ${_createRoutesFromChildren}. matchRoutes: ${_matchRoutes}. customStartTransaction: ${_customStartTransaction}.`);

    return Routes;
  }

  let isMountRenderPass = true;

  const SentryRoutes = (props) => {
    const location = _useLocation();
    const navigationType = _useNavigationType();

    _useEffect(
      () => {
        const routes = _createRoutesFromChildren(props.children) ;

        if (isMountRenderPass) {
          updatePageloadTransaction(location, routes);
          isMountRenderPass = false;
        } else {
          handleNavigation(location, routes, navigationType);
        }
      },
      // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
      // when the children change. We only want to start transactions when the location or navigation type change.
      [location, navigationType],
    );

    // @ts-ignore Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return react.createElement(Routes, { ...props, __self: this, __source: {fileName: reactrouterv6_jsxFileName, lineNumber: 205}} );
  };

  hoist_non_react_statics_cjs_default()(SentryRoutes, Routes);

  // @ts-ignore Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params
  return SentryRoutes;
}

function wrapUseRoutes(origUseRoutes) {
  if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes || !_customStartTransaction) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        'reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.',
      );

    return origUseRoutes;
  }

  let isMountRenderPass = true;

  // eslint-disable-next-line react/display-name
  return (routes, locationArg) => {
    const SentryRoutes = () => {
      const Routes = origUseRoutes(routes, locationArg);

      const location = _useLocation();
      const navigationType = _useNavigationType();

      // A value with stable identity to either pick `locationArg` if available or `location` if not
      const stableLocationParam =
        typeof locationArg === 'string' || (locationArg && locationArg.pathname)
          ? (locationArg )
          : location;

      _useEffect(() => {
        const normalizedLocation =
          typeof stableLocationParam === 'string' ? { pathname: stableLocationParam } : stableLocationParam;

        if (isMountRenderPass) {
          updatePageloadTransaction(normalizedLocation, routes);
          isMountRenderPass = false;
        } else {
          handleNavigation(normalizedLocation, routes, navigationType);
        }
      }, [navigationType, stableLocationParam]);

      return Routes;
    };

    return react.createElement(SentryRoutes, {__self: this, __source: {fileName: reactrouterv6_jsxFileName, lineNumber: 256}} );
  };
}

function wrapCreateBrowserRouter

(createRouterFunction) {
  // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
  // `basename` is the only option that is relevant for us, and it is the same for all.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (routes, opts) {
    const router = createRouterFunction(routes, opts);
    const basename = opts && opts.basename;

    // The initial load ends when `createBrowserRouter` is called.
    // This is the earliest convenient time to update the transaction name.
    // Callbacks to `router.subscribe` are not called for the initial load.
    if (router.state.historyAction === 'POP' && reactrouterv6_activeTransaction) {
      updatePageloadTransaction(router.state.location, routes, undefined, basename);
    }

    router.subscribe((state) => {
      const location = state.location;

      if (
        _startTransactionOnLocationChange &&
        (state.historyAction === 'PUSH' || state.historyAction === 'POP') &&
        reactrouterv6_activeTransaction
      ) {
        handleNavigation(location, routes, state.historyAction, undefined, basename);
      }
    });

    return router;
  };
}


//# sourceMappingURL=reactrouterv6.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/index.js








//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var getVercelEnv_process = __webpack_require__(83454);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? "preview" : getVercelEnv_process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: version/* SDK_VERSION */.J,
      })),
      version: version/* SDK_VERSION */.J,
    } );
}


//# sourceMappingURL=metadata.js.map

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/performance.js





const globalObject = helpers/* WINDOW */.m9

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
    nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let performance_activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const performance_client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, params, sentryTrace, baggage } = extractNextDataTagInformation();
  const { traceparentData, dynamicSamplingContext, propagationContext } = (0,tracing/* tracingContextFromHeaders */.KA)(
    sentryTrace,
    baggage,
  );

  (0,esm_hub/* getCurrentHub */.Gd)().getScope().setPropagationContext(propagationContext);
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    performance_activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && performance_client && performance_client.getOptions().sendDefaultPii && { data: params }),
      ...traceparentData,
      metadata: {
        source,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const strippedNavigationTarget = (0,url/* stripUrlQueryAndFragment */.rt)(navigationTarget);
      const matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = strippedNavigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (performance_activeTransaction) {
        performance_activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=performance.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = (0,esm_dsn/* dsnFromString */.U4)(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/_error.js



/** Platform-agnostic version of `flush` */
function flush(timeout) {
  const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  return client ? client.flush(timeout) : Promise.resolve(false);
}

/**
 * Capture the exception passed by nextjs to the `_error` page, adding context data as appropriate.
 *
 * @param contextOrProps The data passed to either `getInitialProps` or `render` by nextjs
 */
async function captureUnderscoreErrorException(contextOrProps) {
  const { req, res, err } = contextOrProps;

  // 404s (and other 400-y friends) can trigger `_error`, but we don't want to send them to Sentry
  const statusCode = (res && res.statusCode) || contextOrProps.statusCode;
  if (statusCode && statusCode < 500) {
    return Promise.resolve();
  }

  // In previous versions of the suggested `_error.js` page in which this function is meant to be used, there was a
  // workaround for https://github.com/vercel/next.js/issues/8592 which involved an extra call to this function, in the
  // custom error component's `render` method, just in case it hadn't been called by `getInitialProps`. Now that that
  // issue has been fixed, the second call is unnecessary, but since it lives in user code rather than our code, users
  // have to be the ones to get rid of it, and guaraneteedly, not all of them will. So, rather than capture the error
  // twice, we just bail if we sense we're in that now-extraneous second call. (We can tell which function we're in
  // because Nextjs passes `pathname` to `getInitialProps` but not to `render`.)
  if (!contextOrProps.pathname) {
    return Promise.resolve();
  }

  (0,esm_exports/* withScope */.$e)(scope => {
    scope.addEventProcessor(event => {
      (0,misc/* addExceptionMechanism */.EG)(event, {
        type: 'instrument',
        handled: true,
        data: {
          function: '_error.getInitialProps',
        },
      });
      return event;
    });

    if (req) {
      scope.setSDKProcessingMetadata({ request: req });
    }

    // If third-party libraries (or users themselves) throw something falsy, we want to capture it as a message (which
    // is what passing a string to `captureException` will wind up doing)
    (0,esm_exports/* captureException */.Tb)(err || `_error.js called with falsy error (${err})`);
  });

  // In case this is being run as part of a serverless function (as is the case with the server half of nextjs apps
  // deployed to vercel), make sure the error gets sent to Sentry before the lambda exits.
  await flush(2000);
}


//# sourceMappingURL=_error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/wrapGetInitialPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapGetInitialPropsWithSentry(origGetInitialProps) {
  return new Proxy(origGetInitialProps, {
    apply: (wrappingTarget, thisArg, args) => {
      return wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideGetInitialProps = wrapGetInitialPropsWithSentry;


//# sourceMappingURL=wrapGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/wrapAppGetInitialPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapAppGetInitialPropsWithSentry(origAppGetInitialProps) {
  return new Proxy(origAppGetInitialProps, {
    apply: (wrappingTarget, thisArg, args) => {
      return wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapAppGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideAppGetInitialProps = wrapAppGetInitialPropsWithSentry;


//# sourceMappingURL=wrapAppGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/wrapDocumentGetInitialPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapDocumentGetInitialPropsWithSentry(
  origDocumentGetInitialProps,
) {
  return new Proxy(origDocumentGetInitialProps, {
    apply: (wrappingTarget, thisArg, args) => {
      return wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapDocumentGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideDocumentGetInitialProps = wrapDocumentGetInitialPropsWithSentry;


//# sourceMappingURL=wrapDocumentGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/wrapErrorGetInitialPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapErrorGetInitialPropsWithSentry(
  origErrorGetInitialProps,
) {
  return new Proxy(origErrorGetInitialProps, {
    apply: (wrappingTarget, thisArg, args) => {
      return wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapErrorGetInitialPropsWithSentry` instead.
 */
const withSentryServerSideErrorGetInitialProps = wrapErrorGetInitialPropsWithSentry;


//# sourceMappingURL=wrapErrorGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/wrapGetServerSidePropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapGetServerSidePropsWithSentry(origGetServerSideProps) {
  return new Proxy(origGetServerSideProps, {
    apply: (wrappingTarget, thisArg, args) => {
      return wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `withSentryGetServerSideProps` instead.
 */
const withSentryGetServerSideProps = wrapGetServerSidePropsWithSentry;


//# sourceMappingURL=wrapGetServerSidePropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/wrapGetStaticPropsWithSentry.js
/**
 * A passthrough function in case this function is used on the clientside. We need to make the returned function async
 * so we are consistent with the serverside implementation.
 */
function wrapGetStaticPropsWithSentry(origGetStaticProps) {
  return new Proxy(origGetStaticProps, {
    apply: (wrappingTarget, thisArg, args) => {
      return wrappingTarget.apply(thisArg, args);
    },
  });
}

/**
 * @deprecated Use `wrapGetStaticPropsWithSentry` instead.
 */
const withSentryGetStaticProps = wrapGetStaticPropsWithSentry;


//# sourceMappingURL=wrapGetStaticPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/index.js





















// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  applyTunnelRouteOption(options);
  buildMetadata(options, ['nextjs', 'react']);

  options.environment = options.environment || getVercelEnv(true) || "production";

  addClientIntegrations(options);

  init(options);

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);

    if (false) {}
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if ((0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
      const defaultBrowserTracingIntegration = new browsertracing/* BrowserTracing */.gE({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...request/* defaultRequestInstrumentationOptions.tracingOrigins */.k3.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 58946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Breadcrumbs": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Oo; },
/* harmony export */   "BrowserClient": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.RE; },
/* harmony export */   "BrowserProfilingIntegration": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__._p; },
/* harmony export */   "BrowserTracing": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.gE; },
/* harmony export */   "Dedupe": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Iq; },
/* harmony export */   "ErrorBoundary": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SV; },
/* harmony export */   "FunctionToString": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.cq; },
/* harmony export */   "GlobalHandlers": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.dJ; },
/* harmony export */   "HttpContext": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qT; },
/* harmony export */   "Hub": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Xb; },
/* harmony export */   "InboundFilters": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.QD; },
/* harmony export */   "Integrations": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.jK; },
/* harmony export */   "LinkedErrors": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.iP; },
/* harmony export */   "ModuleMetadata": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__._e; },
/* harmony export */   "Profiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Q1; },
/* harmony export */   "Replay": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.UH; },
/* harmony export */   "SDK_VERSION": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Jn; },
/* harmony export */   "Scope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sX; },
/* harmony export */   "TryCatch": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.pT; },
/* harmony export */   "WINDOW": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.m9; },
/* harmony export */   "addBreadcrumb": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.n_; },
/* harmony export */   "addGlobalEventProcessor": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.cc; },
/* harmony export */   "addTracingExtensions": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Ts; },
/* harmony export */   "captureEvent": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.eN; },
/* harmony export */   "captureException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Tb; },
/* harmony export */   "captureMessage": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "captureUnderscoreErrorException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ud; },
/* harmony export */   "captureUserFeedback": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Jd; },
/* harmony export */   "chromeStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$3; },
/* harmony export */   "close": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.xv; },
/* harmony export */   "configureScope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.e; },
/* harmony export */   "createReduxEnhancer": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.wS; },
/* harmony export */   "createTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qv; },
/* harmony export */   "createUserFeedbackEnvelope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rQ; },
/* harmony export */   "defaultIntegrations": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SS; },
/* harmony export */   "defaultRequestInstrumentationOptions": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.k3; },
/* harmony export */   "defaultStackLineParsers": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.d8; },
/* harmony export */   "defaultStackParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Dt; },
/* harmony export */   "eventFromException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.dr; },
/* harmony export */   "eventFromMessage": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.aB; },
/* harmony export */   "extractTraceparentData": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qG; },
/* harmony export */   "flush": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.yl; },
/* harmony export */   "forceLoad": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Eg; },
/* harmony export */   "geckoStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$Q; },
/* harmony export */   "getActiveTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.x1; },
/* harmony export */   "getCurrentHub": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Gd; },
/* harmony export */   "getHubFromCarrier": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vi; },
/* harmony export */   "init": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.S1; },
/* harmony export */   "instrumentOutgoingRequests": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.L7; },
/* harmony export */   "lastEventId": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.eW; },
/* harmony export */   "makeBrowserOfflineTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.O1; },
/* harmony export */   "makeFetchTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.fD; },
/* harmony export */   "makeMain": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.pj; },
/* harmony export */   "makeMultiplexedTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Wq; },
/* harmony export */   "makeXHRTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.KC; },
/* harmony export */   "nextRouterInstrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.q$; },
/* harmony export */   "onLoad": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.lA; },
/* harmony export */   "onProfilingStartRouteTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Uv; },
/* harmony export */   "opera10StackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.NP; },
/* harmony export */   "opera11StackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.HH; },
/* harmony export */   "reactRouterV3Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.XQ; },
/* harmony export */   "reactRouterV4Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qr; },
/* harmony export */   "reactRouterV5Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qp; },
/* harmony export */   "reactRouterV6Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.KO; },
/* harmony export */   "setContext": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.v; },
/* harmony export */   "setExtra": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sU; },
/* harmony export */   "setExtras": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rJ; },
/* harmony export */   "setTag": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.YA; },
/* harmony export */   "setTags": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.mG; },
/* harmony export */   "setUser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.av; },
/* harmony export */   "showReportDialog": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.jp; },
/* harmony export */   "spanStatusfromHttpCode": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Zd; },
/* harmony export */   "startTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Yr; },
/* harmony export */   "trace": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.g4; },
/* harmony export */   "useProfiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ED; },
/* harmony export */   "winjsStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.R2; },
/* harmony export */   "withErrorBoundary": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Pf; },
/* harmony export */   "withProfiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.zH; },
/* harmony export */   "withScope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$e; },
/* harmony export */   "withSentryConfig": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.wO; },
/* harmony export */   "withSentryGetServerSideProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sT; },
/* harmony export */   "withSentryGetStaticProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SF; },
/* harmony export */   "withSentryReactRouterV6Routing": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.H0; },
/* harmony export */   "withSentryRouting": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.gy; },
/* harmony export */   "withSentryServerSideAppGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Im; },
/* harmony export */   "withSentryServerSideDocumentGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.W9; },
/* harmony export */   "withSentryServerSideErrorGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vw; },
/* harmony export */   "withSentryServerSideGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.EC; },
/* harmony export */   "wrap": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.re; },
/* harmony export */   "wrapAppGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$l; },
/* harmony export */   "wrapCreateBrowserRouter": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vG; },
/* harmony export */   "wrapDocumentGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.B4; },
/* harmony export */   "wrapErrorGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rO; },
/* harmony export */   "wrapGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.O5; },
/* harmony export */   "wrapGetServerSidePropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rC; },
/* harmony export */   "wrapGetStaticPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ug; },
/* harmony export */   "wrapUseRoutes": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.M1; }
/* harmony export */ });
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59150);


/***/ }),

/***/ 24975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pf": function() { return /* binding */ withErrorBoundary; },
/* harmony export */   "SV": function() { return /* binding */ ErrorBoundary; }
/* harmony export */ });
/* unused harmony exports UNKNOWN_COMPONENT, isAtLeastReact17 */
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95659);
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79074);
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64487);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12343);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





const _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";

function isAtLeastReact17(version) {
  const major = version.match(/^([^.]+)/);
  return major !== null && parseInt(major[0]) >= 17;
}

const UNKNOWN_COMPONENT = 'unknown';

const INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null,
};

function setCause(error, cause) {
  const seenErrors = new WeakMap();

  function recurse(error, cause) {
    // If we've already seen the error, there is a recursive loop somewhere in the error's
    // cause chain. Let's just bail out then to prevent a stack overflow.
    if (seenErrors.has(error)) {
      return;
    }
    if (error.cause) {
      seenErrors.set(error, true);
      return recurse(error.cause, cause);
    }
    error.cause = cause;
  }

  recurse(error, cause);
}

/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
class ErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
   __init() {this.state = INITIAL_STATE;}

    __init2() {this._openFallbackReportDialog = true;}

   constructor(props) {
    super(props);ErrorBoundary.prototype.__init.call(this);ErrorBoundary.prototype.__init2.call(this);ErrorBoundary.prototype.__init3.call(this);
    const client = (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentHub */ .Gd)().getClient();
    if (client && client.on && props.showDialog) {
      this._openFallbackReportDialog = false;
      client.on('afterSendEvent', event => {
        if (!event.type && event.event_id === this._lastEventId) {
          (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_3__/* .showReportDialog */ .jp)({ ...props.dialogOptions, eventId: this._lastEventId });
        }
      });
    }
  }

   componentDidCatch(error, { componentStack }) {
    const { beforeCapture, onError, showDialog, dialogOptions } = this.props;
    (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_4__/* .withScope */ .$e)(scope => {
      // If on React version >= 17, create stack trace from componentStack param and links
      // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
      // Linking errors requires the `LinkedErrors` integration be enabled.
      // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
      //
      // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
      // with non-error objects. This is why we need to check if the error is an error-like object.
      // See: https://github.com/getsentry/sentry-javascript/issues/6167
      if (isAtLeastReact17(react__WEBPACK_IMPORTED_MODULE_1__.version) && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isError */ .VZ)(error)) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${errorBoundaryError.name}`;
        errorBoundaryError.stack = componentStack;

        // Using the `LinkedErrors` integration to link the errors together.
        setCause(error, errorBoundaryError);
      }

      if (beforeCapture) {
        beforeCapture(scope, error, componentStack);
      }
      const eventId = (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(error, { contexts: { react: { componentStack } } });
      if (onError) {
        onError(error, componentStack, eventId);
      }
      if (showDialog) {
        this._lastEventId = eventId;
        if (this._openFallbackReportDialog) {
          (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_3__/* .showReportDialog */ .jp)({ ...dialogOptions, eventId });
        }
      }

      // componentDidCatch is used over getDerivedStateFromError
      // so that componentStack is accessible through state.
      this.setState({ error, componentStack, eventId });
    });
  }

   componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }

   componentWillUnmount() {
    const { error, componentStack, eventId } = this.state;
    const { onUnmount } = this.props;
    if (onUnmount) {
      onUnmount(error, componentStack, eventId);
    }
  }

   __init3() {this.resetErrorBoundary = () => {
    const { onReset } = this.props;
    const { error, componentStack, eventId } = this.state;
    if (onReset) {
      onReset(error, componentStack, eventId);
    }
    this.setState(INITIAL_STATE);
  };}

   render() {
    const { fallback, children } = this.props;
    const state = this.state;

    if (state.error) {
      let element = undefined;
      if (typeof fallback === 'function') {
        element = fallback({
          error: state.error,
          componentStack: state.componentStack,
          resetError: this.resetErrorBoundary,
          eventId: state.eventId,
        });
      } else {
        element = fallback;
      }

      if (react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(element)) {
        return element;
      }

      if (fallback) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('fallback did not produce a valid ReactElement');
      }

      // Fail gracefully if no fallback provided or is not valid
      return null;
    }

    if (typeof children === 'function') {
      return (children )();
    }
    return children;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(
  WrappedComponent,
  errorBoundaryOptions,
) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;

  const Wrapped = (props) => (
    react__WEBPACK_IMPORTED_MODULE_1__.createElement(ErrorBoundary, { ...errorBoundaryOptions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}
      , react__WEBPACK_IMPORTED_MODULE_1__.createElement(WrappedComponent, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 225}} )
    )
  );

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  Wrapped.displayName = `errorBoundary(${componentDisplayName})`;

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_0___default()(Wrapped, WrappedComponent);
  return Wrapped;
}


//# sourceMappingURL=errorboundary.js.map


/***/ }),

/***/ 99181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ baggageHeaderToDynamicSamplingContext; },
/* harmony export */   "IQ": function() { return /* binding */ dynamicSamplingContextToSentryBaggageHeader; },
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  if (!dynamicSamplingContext) {
    return undefined;
  }

  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 30292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ dsnToString; },
/* harmony export */   "U4": function() { return /* binding */ dsnFromString; },
/* harmony export */   "vK": function() { return /* binding */ makeDsn; }
/* harmony export */ });
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12343);


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    // eslint-disable-next-line no-console
    console.error(`Invalid Sentry Dsn: ${str}`);
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!isValidProtocol(protocol)) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map


/***/ }),

/***/ 68518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-ignore "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map


/***/ }),

/***/ 58725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ addItemToEnvelope; },
/* harmony export */   "Cd": function() { return /* binding */ createEventEnvelopeHeaders; },
/* harmony export */   "HY": function() { return /* binding */ getSdkMetadataForEnvelopeHeader; },
/* harmony export */   "Jd": function() { return /* binding */ createEnvelope; },
/* harmony export */   "R": function() { return /* binding */ envelopeContainsItemType; },
/* harmony export */   "V$": function() { return /* binding */ serializeEnvelope; },
/* harmony export */   "f4": function() { return /* binding */ parseEnvelope; },
/* harmony export */   "gv": function() { return /* binding */ forEachEnvelopeItem; },
/* harmony export */   "mL": function() { return /* binding */ envelopeItemTypeToDataCategory; },
/* harmony export */   "zQ": function() { return /* binding */ createAttachmentEnvelopeItem; }
/* harmony export */ });
/* harmony import */ var _dsn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30292);
/* harmony import */ var _normalize_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34754);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify((0,_normalize_js__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .dropUndefinedKeys */ .Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: (0,_dsn_js__WEBPACK_IMPORTED_MODULE_2__/* .dsnToString */ .RA)(dsn) }),
    ...(dynamicSamplingContext && {
      trace: (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .dropUndefinedKeys */ .Jr)({ ...dynamicSamplingContext }),
    }),
  };
}


//# sourceMappingURL=envelope.js.map


/***/ }),

/***/ 80409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SentryError; }
/* harmony export */ });
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map


/***/ }),

/***/ 35648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xU": function() { return /* binding */ SENTRY_XHR_DATA_KEY; },
  "oq": function() { return /* binding */ addInstrumentationHandler; }
});

// UNUSED EXPORTS: parseFetchArgs

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files

// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supportsHistory.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument.js








// eslint-disable-next-line deprecation/deprecation
const instrument_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v2__';

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in instrument_WINDOW)) {
    return;
  }

  logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function (level) {
    if (!(level in instrument_WINDOW.console)) {
      return;
    }

    (0,object/* fill */.hl)(instrument_WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(instrument_WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,supports/* supportsNativeFetch */.t$)()) {
    return;
  }

  (0,object/* fill */.hl)(instrument_WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const { method, url } = parseFetchArgs(args);

      const handlerData = {
        args,
        fetchData: {
          method,
          url,
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(instrument_WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!(obj )[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: 'GET', url: '' };
  }

  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs ;

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET',
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg ),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
  };
}

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in instrument_WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,object/* fill */.hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const url = args[1];
      const xhrInfo = (this[SENTRY_XHR_DATA_KEY] = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,is/* isString */.HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
        request_headers: {},
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,is/* isString */.HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args: args ,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: this,
          } );
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        (0,object/* fill */.hl)(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      (0,object/* fill */.hl)(this, 'setRequestHeader', function (original) {
        return function ( ...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs ;

          const xhrInfo = this[SENTRY_XHR_DATA_KEY];

          if (xhrInfo) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }

          return original.apply(this, setRequestHeaderArgs);
        };
      });

      return originalOpen.apply(this, args);
    };
  });

  (0,object/* fill */.hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];
      if (sentryXhrData && args[0] !== undefined) {
        sentryXhrData.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = instrument_WINDOW.onpopstate;
  instrument_WINDOW.onpopstate = function ( ...args) {
    const to = instrument_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,object/* fill */.hl)(instrument_WINDOW.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(instrument_WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = instrument_WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in instrument_WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  instrument_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  instrument_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (instrument_WINDOW )[target] && (instrument_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,object/* fill */.hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,object/* fill */.hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = instrument_WINDOW.onerror;

  instrument_WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  instrument_WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = instrument_WINDOW.onunhandledrejection;

  instrument_WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };

  instrument_WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 61422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; },
/* harmony export */   "l$": function() { return /* binding */ dynamicRequire; }
/* harmony export */ });
/* unused harmony export loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68518);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(83454);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 34754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: walk

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (
    value == null || // this matches null and undefined -> eqeq not eqeqeq
    (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))
  ) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth =
    typeof (value )['__sentry_override_normalization_depth__'] === 'number'
      ? ((value )['__sentry_override_normalization_depth__'] )
      : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }

    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map


/***/ }),

/***/ 20535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58464);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 80228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JY": function() { return /* binding */ parseRetryAfterHeader; },
/* harmony export */   "Q": function() { return /* binding */ isRateLimited; },
/* harmony export */   "WG": function() { return /* binding */ updateRateLimits; }
/* harmony export */ });
/* unused harmony exports DEFAULT_RETRY_AFTER, disabledUntil */
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map


/***/ }),

/***/ 16547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VT": function() { return /* binding */ severityLevelFromString; }
/* harmony export */ });
/* unused harmony exports severityFromString, validSeverityLevels */
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map


/***/ }),

/***/ 30360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = stack.slice(0, STACKTRACE_FRAME_LIMIT);

  const lastFrameFunction = localStack[localStack.length - 1].function;
  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (lastFrameFunction && /sentryWrapped/.test(lastFrameFunction)) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  const firstFrameFunction = localStack[localStack.length - 1].function;
  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (firstFrameFunction && /captureMessage|captureException/.test(firstFrameFunction)) {
    localStack.pop();
  }

  return localStack.map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61422);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 77638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ generateSentryTraceHeader; },
/* harmony export */   "KA": function() { return /* binding */ tracingContextFromHeaders; },
/* harmony export */   "qG": function() { return /* binding */ extractTraceparentData; }
/* harmony export */ });
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99181);
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);



const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}

/**
 * Create tracing context from incoming headers.
 */
function tracingContextFromHeaders(
  sentryTrace,
  baggage,
)

 {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  const propagationContext = {
    traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
    sampled: parentSampled === undefined ? false : parentSampled,
  };

  if (parentSpanId) {
    propagationContext.parentSpanId = parentSpanId;
  }

  if (dynamicSamplingContext) {
    propagationContext.dsc = dynamicSamplingContext ;
  }

  return {
    traceparentData,
    dynamicSamplingContext,
    propagationContext,
  };
}

/**
 * Create sentry-trace header from span context values.
 */
function generateSentryTraceHeader(
  traceId = (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
  spanId = (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
  sampled,
) {
  let sampledString = '';
  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }
  return `${traceId}-${spanId}${sampledString}`;
}


//# sourceMappingURL=tracing.js.map


/***/ }),

/***/ 26956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ getNumberOfUrlSegments; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony export getSanitizedUrlString */
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        .replace(':80', '')
        .replace(':443', '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map


/***/ }),

/***/ 71235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 15497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgAdjustIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "adjust-icon_svg__h-6 adjust-icon_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgAdjustIcon);

/***/ }),

/***/ 68603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCoffee(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18 8h1a4 4 0 110 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zM6 1v3M10 1v3M14 1v3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgCoffee);

/***/ }),

/***/ 43553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCogIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgCogIcon);

/***/ }),

/***/ 84603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgGcalIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.316 5.684H5.684v12.632h12.632V5.684z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.316 24L24 18.316h-5.684V24z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24 5.684h-5.684v12.632H24V5.684z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.316 18.316H5.684V24h12.632v-5.684z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M0 18.316v3.79C0 23.151.848 24 1.895 24h3.79v-5.684H0z",
    fill: "#188038"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24 5.684v-3.79A1.894 1.894 0 0022.105 0h-3.79v5.684H24z",
    fill: "#1967D2"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.316 0H1.895A1.894 1.894 0 000 1.895v16.42h5.684V5.686h12.632V0z",
    fill: "#4285F4"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.275 15.483c-.472-.319-.799-.785-.977-1.4l1.096-.452c.1.379.273.673.52.881.247.208.547.311.898.311.358 0 .666-.109.923-.327.258-.218.387-.495.387-.832 0-.344-.136-.625-.407-.843-.272-.218-.613-.327-1.02-.327h-.633V11.41h.568c.35 0 .646-.094.886-.284.24-.19.36-.448.36-.778a.86.86 0 00-.322-.703c-.215-.175-.487-.263-.817-.263-.322 0-.578.085-.767.257a1.51 1.51 0 00-.414.633L7.472 9.82c.143-.407.407-.767.794-1.078.387-.311.88-.467 1.48-.467a2.7 2.7 0 011.198.257c.353.172.631.41.832.714.2.304.3.646.3 1.025 0 .386-.093.713-.28.982a1.925 1.925 0 01-.687.617v.065c.351.144.656.382.882.687.228.307.344.675.344 1.105 0 .43-.11.813-.327 1.15-.218.336-.52.6-.902.793a2.836 2.836 0 01-1.293.291 2.677 2.677 0 01-1.538-.477zm6.731-5.438l-1.203.87-.602-.912 2.159-1.557h.827v7.344h-1.18v-5.745z",
    fill: "#4285F4"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgGcalIcon);

/***/ }),

/***/ 80613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSlackIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "70 70 130 130"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M99.4 151.2c0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9v-32.3z",
    fill: "#e01e5a"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M118.8 99.4c-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v12.9h-12.9zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H86.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3z",
    fill: "#36c5f0"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M170.6 118.8c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9h-12.9v-12.9zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9V86.5c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9v32.3z",
    fill: "#2eb67d"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M151.2 170.6c7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9v-12.9h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9h-32.3z",
    fill: "#ecb22e"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgSlackIcon);

/***/ }),

/***/ 66175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgZoomIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0h56c6.627 0 12 5.373 12 12v56c0 6.627-5.373 12-12 12H12C5.373 80 0 74.627 0 68V12C0 5.373 5.373 0 12 0z",
    fill: "#0e71eb"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24.031 26C21.801 26 20 27.822 20 30.063v14.843C20 49.388 23.601 53 28.063 53h20.156c2.23 0 4.031-1.822 4.031-4.063v-4.03l7.531 5.656c1.317.998 3.219.048 3.219-1.626V30.064c0-1.674-1.902-2.624-3.219-1.625l-7.531 5.656c0-4.482-3.601-8.094-8.063-8.094H24.032z",
    fill: "#fff"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgZoomIcon);

/***/ }),

/***/ 73766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPuzzleIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 01-.657.643 48.39 48.39 0 01-4.163-.3 48.44 48.44 0 01.315 4.907.656.656 0 01-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 005.427-.63 48.05 48.05 0 00.582-4.717.532.532 0 00-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 00.658-.663 48.422 48.422 0 00-.37-5.36 48.14 48.14 0 01-5.766.689.578.578 0 01-.61-.58v0z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgPuzzleIcon);

/***/ }),

/***/ 94934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSendIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgSendIcon);

/***/ }),

/***/ 52976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSlackOutline(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5zM20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5zM3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14zM14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5zM15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zM10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5zM8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgSlackOutline);

/***/ }),

/***/ 40578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgUserAddIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgUserAddIcon);

/***/ }),

/***/ 38654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgUserGroupIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgUserGroupIcon);

/***/ }),

/***/ 59239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgUsersIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 1112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgUsersIcon);

/***/ }),

/***/ 13294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgWarningIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4m0 4h.01"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgWarningIcon);

/***/ }),

/***/ 12266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgWavingHand(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.912 9.471l-1.845-3.195a2.586 2.586 0 00-4.363-.178l-1.6-2.771a2.582 2.582 0 00-4.438-.059 2.583 2.583 0 00-3.969 3.209l.678 1.175a2.582 2.582 0 00-2.029 3.865l3.506 6.072a8.116 8.116 0 0013.47.883 8.118 8.118 0 00.59-9zm-.614 5.778A6.643 6.643 0 018.13 16.851l-3.505-6.072a1.107 1.107 0 011.917-1.107l1.66 2.877a.746.746 0 00.052.076l.015.019c.014.018.03.034.045.05l.017.018c.02.02.043.04.066.057l.003.002a.73.73 0 00.07.045l.021.012.06.029.02.009c.027.01.054.02.082.027l.005.001a.729.729 0 00.08.015c.007.002.015.002.023.003a.744.744 0 00.067.005h.021a.745.745 0 00.086-.005l.007-.002a.75.75 0 00.078-.015l.024-.007a.728.728 0 00.062-.02l.024-.01a.734.734 0 00.35-1.048L7.82 8.934 5.975 5.74a1.107 1.107 0 011.918-1.107l.736 1.275.001.003 2.399 4.154a.739.739 0 001.278-.738L9.91 5.172a1.107 1.107 0 011.917-1.107l2.767 4.793.585 1.012a4.43 4.43 0 00-1.013 5.627.737.737 0 101.279-.738 2.952 2.952 0 011.08-4.033.716.716 0 00.11-.077l.009-.008a.719.719 0 00.05-.048l.001-.002a.71.71 0 00.045-.053l.002-.002a.758.758 0 00.037-.053l.004-.006a.713.713 0 00.029-.052l.006-.011a.775.775 0 00.022-.05l.007-.017a.745.745 0 00.02-.06l.002-.009.002-.008a.783.783 0 00.013-.062l.003-.02a.766.766 0 00.006-.052v-.016-.056-.011c0-.02-.002-.041-.005-.062l-.001-.006a.744.744 0 00-.012-.064l-.002-.008a.719.719 0 00-.018-.062l-.006-.017-.02-.05a.763.763 0 00-.034-.066l-.922-1.598a1.107 1.107 0 011.917-1.106l1.845 3.195a6.6 6.6 0 01.664 5.04zM6.686 22.44a.74.74 0 01-1.027.186 10.972 10.972 0 01-3.271-3.56.738.738 0 111.278-.738A9.51 9.51 0 006.5 21.412a.738.738 0 01.186 1.027zm10.41-20.702A.738.738 0 0117.836 1a5.557 5.557 0 014.792 2.768.739.739 0 11-1.278.738 4.074 4.074 0 00-3.515-2.03.738.738 0 01-.737-.739z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgWavingHand);

/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var createError = __webpack_require__(85061);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65263);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 65263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 85061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(80481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45655);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 80481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(85061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var enhanceError = __webpack_require__(80481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(88593);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 63663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
/*! For license information please see index.js.LICENSE.txt */
!function(e,t){ true?module.exports=t():0}(this,(()=>(()=>{var e={599:(e,t,r)=>{"use strict";r.r(t),r.d(t,{default:()=>p,getControlKey:()=>d});var o=r(378),n=function(){return["WINDOWS","ANDROID","LINUX"].includes(function(){if("undefined"!=typeof window){var e=window.navigator.userAgent,t=window.navigator.platform,r="MAC";return-1!==["Macintosh","MacIntel","MacPPC","Mac68K"].indexOf(t)?r="MAC":-1!==["iPhone","iPad","iPod"].indexOf(t)?r="IOS":-1!==["Win32","Win64","Windows","WinCE"].indexOf(t)?r="WINDOWS":/Android/.test(e)?r="ANDROID":/Linux/.test(t)&&(r="LINUX"),r}}())?"Ctrl":"⌘"},i={color:void 0,size:void 0,className:void 0,style:void 0,attr:void 0},a=o.createContext&&o.createContext(i),s=function(){return s=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},s.apply(this,arguments)};function u(e){return e&&e.map((function(e,t){return o.createElement(e.tag,s({key:t},e.attr),u(e.child))}))}function c(e){return function(t){return o.createElement(l,s({attr:s({},e.attr)},t),u(e.child))}}function l(e){var t=function(t){var r,n=e.size||t.size||"1em";t.className&&(r=t.className),e.className&&(r=(r?r+" ":"")+e.className);var i=e.attr,a=e.title,u=function(e,t){var r={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(o=Object.getOwnPropertySymbols(e);n<o.length;n++)t.indexOf(o[n])<0&&(r[o[n]]=e[o[n]])}return r}(e,["attr","title"]);return o.createElement("svg",s({stroke:"currentColor",fill:"currentColor",strokeWidth:"0"},t.attr,i,u,{className:r,style:s({color:e.color||t.color},t.style,e.style),height:n,width:n,xmlns:"http://www.w3.org/2000/svg"}),a&&o.createElement("title",null,a),e.children)};return void 0!==a?o.createElement(a.Consumer,null,(function(e){return t(e)})):t(i)}function f(e){return c({tag:"svg",attr:{viewBox:"0 0 1024 1024"},child:[{tag:"path",attr:{d:"M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"}}]})(e)}var d=n;const p=function(e){var t=e.text,r=e.style;return o.createElement("div",{id:"commandbar-user-launcher-component",className:"commandbar-user-launcher",style:r||{},onClick:function(){var e,t;null===(e=window)||void 0===e||null===(t=e.CommandBar)||void 0===t||t.open()}},o.createElement("div",{className:"commandbar-user-launcher__content"},o.createElement("div",{className:"commandbar-user-launcher__prefix"},o.createElement(f,null),"  ",t||"Find anything"),!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)&&o.createElement("div",{className:"commandbar-user-launcher__suffix"},o.createElement("span",{style:{marginRight:3},className:"commandbar-user-launcher__tag"},n()),o.createElement("span",{style:{marginRight:3}},"+"),o.createElement("span",{className:"commandbar-user-launcher__tag "},"K"))))}},296:(e,t,r)=>{"use strict";var o=r(102),n=r(307),i=r(339),a=r(957),s=r(246);(e.exports=function(e,t){var r,n,u,c,l;return arguments.length<2||"string"!=typeof e?(c=t,t=e,e=null):c=arguments[2],o(e)?(r=s.call(e,"c"),n=s.call(e,"e"),u=s.call(e,"w")):(r=u=!0,n=!1),l={value:t,configurable:r,enumerable:n,writable:u},c?i(a(c),l):l}).gs=function(e,t,r){var u,c,l,f;return"string"!=typeof e?(l=r,r=t,t=e,e=null):l=arguments[3],o(t)?n(t)?o(r)?n(r)||(l=r,r=void 0):r=void 0:(l=t,t=r=void 0):t=void 0,o(e)?(u=s.call(e,"c"),c=s.call(e,"e")):(u=!0,c=!1),f={get:t,set:r,configurable:u,enumerable:c},l?i(a(l),f):f}},817:e=>{"use strict";e.exports=function(){}},339:(e,t,r)=>{"use strict";e.exports=r(994)()?Object.assign:r(963)},994:e=>{"use strict";e.exports=function(){var e,t=Object.assign;return"function"==typeof t&&(t(e={foo:"raz"},{bar:"dwa"},{trzy:"trzy"}),e.foo+e.bar+e.trzy==="razdwatrzy")}},963:(e,t,r)=>{"use strict";var o=r(450),n=r(836),i=Math.max;e.exports=function(e,t){var r,a,s,u=i(arguments.length,2);for(e=Object(n(e)),s=function(o){try{e[o]=t[o]}catch(e){r||(r=e)}},a=1;a<u;++a)o(t=arguments[a]).forEach(s);if(void 0!==r)throw r;return e}},349:(e,t,r)=>{"use strict";var o=r(817)();e.exports=function(e){return e!==o&&null!==e}},450:(e,t,r)=>{"use strict";e.exports=r(446)()?Object.keys:r(177)},446:e=>{"use strict";e.exports=function(){try{return Object.keys("primitive"),!0}catch(e){return!1}}},177:(e,t,r)=>{"use strict";var o=r(349),n=Object.keys;e.exports=function(e){return n(o(e)?Object(e):e)}},957:(e,t,r)=>{"use strict";var o=r(349),n=Array.prototype.forEach,i=Object.create,a=function(e,t){var r;for(r in e)t[r]=e[r]};e.exports=function(e){var t=i(null);return n.call(arguments,(function(e){o(e)&&a(Object(e),t)})),t}},836:(e,t,r)=>{"use strict";var o=r(349);e.exports=function(e){if(!o(e))throw new TypeError("Cannot use null or undefined");return e}},246:(e,t,r)=>{"use strict";e.exports=r(711)()?String.prototype.contains:r(370)},711:e=>{"use strict";var t="razdwatrzy";e.exports=function(){return"function"==typeof t.contains&&!0===t.contains("dwa")&&!1===t.contains("foo")}},370:e=>{"use strict";var t=String.prototype.indexOf;e.exports=function(e){return t.call(this,e,arguments[1])>-1}},992:(e,t,r)=>{"use strict";r(98).polyfill()},98:e=>{"use strict";function t(e,t){if(null==e)throw new TypeError("Cannot convert first argument to object");for(var r=Object(e),o=1;o<arguments.length;o++){var n=arguments[o];if(null!=n)for(var i=Object.keys(Object(n)),a=0,s=i.length;a<s;a++){var u=i[a],c=Object.getOwnPropertyDescriptor(n,u);void 0!==c&&c.enumerable&&(r[u]=n[u])}}return r}e.exports={assign:t,polyfill:function(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:t})}}},769:(e,t,r)=>{"use strict";r(614)()||Object.defineProperty(r(119),"Symbol",{value:r(798),configurable:!0,enumerable:!1,writable:!0})},614:(e,t,r)=>{"use strict";var o=r(119),n={object:!0,symbol:!0};e.exports=function(){var e,t=o.Symbol;if("function"!=typeof t)return!1;e=t("test symbol");try{String(e)}catch(e){return!1}return!!n[typeof t.iterator]&&!!n[typeof t.toPrimitive]&&!!n[typeof t.toStringTag]}},64:e=>{"use strict";e.exports=function(e){return!!e&&("symbol"==typeof e||!!e.constructor&&"Symbol"===e.constructor.name&&"Symbol"===e[e.constructor.toStringTag])}},573:(e,t,r)=>{"use strict";var o=r(296),n=Object.create,i=Object.defineProperty,a=Object.prototype,s=n(null);e.exports=function(e){for(var t,r,n=0;s[e+(n||"")];)++n;return s[e+=n||""]=!0,i(a,t="@@"+e,o.gs(null,(function(e){r||(r=!0,i(this,t,o(e)),r=!1)}))),t}},572:(e,t,r)=>{"use strict";var o=r(296),n=r(119).Symbol;e.exports=function(e){return Object.defineProperties(e,{hasInstance:o("",n&&n.hasInstance||e("hasInstance")),isConcatSpreadable:o("",n&&n.isConcatSpreadable||e("isConcatSpreadable")),iterator:o("",n&&n.iterator||e("iterator")),match:o("",n&&n.match||e("match")),replace:o("",n&&n.replace||e("replace")),search:o("",n&&n.search||e("search")),species:o("",n&&n.species||e("species")),split:o("",n&&n.split||e("split")),toPrimitive:o("",n&&n.toPrimitive||e("toPrimitive")),toStringTag:o("",n&&n.toStringTag||e("toStringTag")),unscopables:o("",n&&n.unscopables||e("unscopables"))})}},781:(e,t,r)=>{"use strict";var o=r(296),n=r(11),i=Object.create(null);e.exports=function(e){return Object.defineProperties(e,{for:o((function(t){return i[t]?i[t]:i[t]=e(String(t))})),keyFor:o((function(e){var t;for(t in n(e),i)if(i[t]===e)return t}))})}},798:(e,t,r)=>{"use strict";var o,n,i,a=r(296),s=r(11),u=r(119).Symbol,c=r(573),l=r(572),f=r(781),d=Object.create,p=Object.defineProperties,m=Object.defineProperty;if("function"==typeof u)try{String(u()),i=!0}catch(e){}else u=null;n=function(e){if(this instanceof n)throw new TypeError("Symbol is not a constructor");return o(e)},e.exports=o=function e(t){var r;if(this instanceof e)throw new TypeError("Symbol is not a constructor");return i?u(t):(r=d(n.prototype),t=void 0===t?"":String(t),p(r,{__description__:a("",t),__name__:a("",c(t))}))},l(o),f(o),p(n.prototype,{constructor:a(o),toString:a("",(function(){return this.__name__}))}),p(o.prototype,{toString:a((function(){return"Symbol ("+s(this).__description__+")"})),valueOf:a((function(){return s(this)}))}),m(o.prototype,o.toPrimitive,a("",(function(){var e=s(this);return"symbol"==typeof e?e:e.toString()}))),m(o.prototype,o.toStringTag,a("c","Symbol")),m(n.prototype,o.toStringTag,a("c",o.prototype[o.toStringTag])),m(n.prototype,o.toPrimitive,a("c",o.prototype[o.toPrimitive]))},11:(e,t,r)=>{"use strict";var o=r(64);e.exports=function(e){if(!o(e))throw new TypeError(e+" is not a symbol");return e}},308:e=>{var t=function(){if("object"==typeof self&&self)return self;if("object"==typeof window&&window)return window;throw new Error("Unable to resolve global `this`")};e.exports=function(){if(this)return this;try{Object.defineProperty(Object.prototype,"__global__",{get:function(){return this},configurable:!0})}catch(e){return t()}try{return __global__||t()}finally{delete Object.prototype.__global__}}()},119:(e,t,r)=>{"use strict";e.exports=r(801)()?globalThis:r(308)},801:e=>{"use strict";e.exports=function(){return"object"==typeof globalThis&&!!globalThis&&globalThis.Array===Array}},525:e=>{"use strict";var t=Object.getOwnPropertySymbols,r=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable;function n(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}e.exports=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},r=0;r<10;r++)t["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(t).map((function(e){return t[e]})).join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach((function(e){o[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}()?Object.assign:function(e,i){for(var a,s,u=n(e),c=1;c<arguments.length;c++){for(var l in a=Object(arguments[c]))r.call(a,l)&&(u[l]=a[l]);if(t){s=t(a);for(var f=0;f<s.length;f++)o.call(a,s[f])&&(u[s[f]]=a[s[f]])}}return u}},656:(e,t,r)=>{"use strict";var o;(o="undefined"!=typeof process&&"[object process]"==={}.toString.call(process)||"undefined"!=typeof navigator&&"ReactNative"===navigator.product?r.g:self).Proxy||(o.Proxy=r(659)(),o.Proxy.revocable=o.Proxy.revocable)},659:e=>{e.exports=function(){let e,t=null;function r(e){return!!e&&("object"==typeof e||"function"==typeof e)}function o(e){if(null!==e&&!r(e))throw new TypeError("Object prototype may only be an Object or null: "+e)}const n=Object,i=Boolean(n.create)||!({__proto__:null}instanceof n),a=n.create||(i?function(e){return o(e),{__proto__:e}}:function(e){if(o(e),null===e)throw new SyntaxError("Native Object.create is required to create objects with null prototype");var t=function(){};return t.prototype=e,new t}),s=function(){return null},u=n.getPrototypeOf||([].__proto__===Array.prototype?function(e){const t=e.__proto__;return r(t)?t:null}:s);return e=function(c,l){if(void 0===(this&&this instanceof e?this.constructor:void 0))throw new TypeError("Constructor Proxy requires 'new'");if(!r(c)||!r(l))throw new TypeError("Cannot create proxy with a non-object as target or handler");let f=function(){};t=function(){c=null,f=function(e){throw new TypeError(`Cannot perform '${e}' on a proxy that has been revoked`)}},setTimeout((function(){t=null}),0);const d=l;l={get:null,set:null,apply:null,construct:null};for(let e in d){if(!(e in l))throw new TypeError(`Proxy polyfill does not support trap '${e}'`);l[e]=d[e]}"function"==typeof d&&(l.apply=d.apply.bind(d));const p=u(c);let m,y=!1,b=!1;"function"==typeof c?(m=function(){const e=this&&this.constructor===m,t=Array.prototype.slice.call(arguments);return f(e?"construct":"apply"),e&&l.construct?l.construct.call(this,c,t):!e&&l.apply?l.apply(c,this,t):e?(t.unshift(c),new(c.bind.apply(c,t))):c.apply(this,t)},y=!0):c instanceof Array?(m=[],b=!0):m=i||null!==p?a(p):{};const _=l.get?function(e){return f("get"),l.get(this,e,m)}:function(e){return f("get"),this[e]},v=l.set?function(e,t){f("set"),l.set(this,e,t,m)}:function(e,t){f("set"),this[e]=t},h=n.getOwnPropertyNames(c),g={};h.forEach((function(e){if((y||b)&&e in m)return;const t=n.getOwnPropertyDescriptor(c,e),r={enumerable:Boolean(t.enumerable),get:_.bind(c,e),set:v.bind(c,e)};n.defineProperty(m,e,r),g[e]=!0}));let S=!0;if(y||b){const e=n.setPrototypeOf||([].__proto__===Array.prototype?function(e,t){return o(t),e.__proto__=t,e}:s);p&&e(m,p)||(S=!1)}if(l.get||!S)for(let e in c)g[e]||n.defineProperty(m,e,{get:_.bind(c,e)});return n.seal(c),n.seal(m),m},e.revocable=function(r,o){return{proxy:new e(r,o),revoke:t}},e}},535:(e,t,r)=>{"use strict";var o=r(525),n=60103,i=60106;t.Fragment=60107,t.StrictMode=60108,t.Profiler=60114;var a=60109,s=60110,u=60112;t.Suspense=60113;var c=60115,l=60116;if("function"==typeof Symbol&&Symbol.for){var f=Symbol.for;n=f("react.element"),i=f("react.portal"),t.Fragment=f("react.fragment"),t.StrictMode=f("react.strict_mode"),t.Profiler=f("react.profiler"),a=f("react.provider"),s=f("react.context"),u=f("react.forward_ref"),t.Suspense=f("react.suspense"),c=f("react.memo"),l=f("react.lazy")}var d="function"==typeof Symbol&&Symbol.iterator;function p(e){for(var t="https://reactjs.org/docs/error-decoder.html?invariant="+e,r=1;r<arguments.length;r++)t+="&args[]="+encodeURIComponent(arguments[r]);return"Minified React error #"+e+"; visit "+t+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var m={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},y={};function b(e,t,r){this.props=e,this.context=t,this.refs=y,this.updater=r||m}function _(){}function v(e,t,r){this.props=e,this.context=t,this.refs=y,this.updater=r||m}b.prototype.isReactComponent={},b.prototype.setState=function(e,t){if("object"!=typeof e&&"function"!=typeof e&&null!=e)throw Error(p(85));this.updater.enqueueSetState(this,e,t,"setState")},b.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate")},_.prototype=b.prototype;var h=v.prototype=new _;h.constructor=v,o(h,b.prototype),h.isPureReactComponent=!0;var g={current:null},S=Object.prototype.hasOwnProperty,C={key:!0,ref:!0,__self:!0,__source:!0};function w(e,t,r){var o,i={},a=null,s=null;if(null!=t)for(o in void 0!==t.ref&&(s=t.ref),void 0!==t.key&&(a=""+t.key),t)S.call(t,o)&&!C.hasOwnProperty(o)&&(i[o]=t[o]);var u=arguments.length-2;if(1===u)i.children=r;else if(1<u){for(var c=Array(u),l=0;l<u;l++)c[l]=arguments[l+2];i.children=c}if(e&&e.defaultProps)for(o in u=e.defaultProps)void 0===i[o]&&(i[o]=u[o]);return{$$typeof:n,type:e,key:a,ref:s,props:i,_owner:g.current}}function O(e){return"object"==typeof e&&null!==e&&e.$$typeof===n}var P=/\/+/g;function j(e,t){return"object"==typeof e&&null!==e&&null!=e.key?function(e){var t={"=":"=0",":":"=2"};return"$"+e.replace(/[=:]/g,(function(e){return t[e]}))}(""+e.key):t.toString(36)}function x(e,t,r,o,a){var s=typeof e;"undefined"!==s&&"boolean"!==s||(e=null);var u=!1;if(null===e)u=!0;else switch(s){case"string":case"number":u=!0;break;case"object":switch(e.$$typeof){case n:case i:u=!0}}if(u)return a=a(u=e),e=""===o?"."+j(u,0):o,Array.isArray(a)?(r="",null!=e&&(r=e.replace(P,"$&/")+"/"),x(a,t,r,"",(function(e){return e}))):null!=a&&(O(a)&&(a=function(e,t){return{$$typeof:n,type:e.type,key:t,ref:e.ref,props:e.props,_owner:e._owner}}(a,r+(!a.key||u&&u.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),t.push(a)),1;if(u=0,o=""===o?".":o+":",Array.isArray(e))for(var c=0;c<e.length;c++){var l=o+j(s=e[c],c);u+=x(s,t,r,l,a)}else if(l=function(e){return null===e||"object"!=typeof e?null:"function"==typeof(e=d&&e[d]||e["@@iterator"])?e:null}(e),"function"==typeof l)for(e=l.call(e),c=0;!(s=e.next()).done;)u+=x(s=s.value,t,r,l=o+j(s,c++),a);else if("object"===s)throw t=""+e,Error(p(31,"[object Object]"===t?"object with keys {"+Object.keys(e).join(", ")+"}":t));return u}function E(e,t,r){if(null==e)return e;var o=[],n=0;return x(e,o,"","",(function(e){return t.call(r,e,n++)})),o}function B(e){if(-1===e._status){var t=e._result;t=t(),e._status=0,e._result=t,t.then((function(t){0===e._status&&(t=t.default,e._status=1,e._result=t)}),(function(t){0===e._status&&(e._status=2,e._result=t)}))}if(1===e._status)return e._result;throw e._result}var T={current:null};function A(){var e=T.current;if(null===e)throw Error(p(321));return e}var k={ReactCurrentDispatcher:T,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:g,IsSomeRendererActing:{current:!1},assign:o};t.Children={map:E,forEach:function(e,t,r){E(e,(function(){t.apply(this,arguments)}),r)},count:function(e){var t=0;return E(e,(function(){t++})),t},toArray:function(e){return E(e,(function(e){return e}))||[]},only:function(e){if(!O(e))throw Error(p(143));return e}},t.Component=b,t.PureComponent=v,t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=k,t.cloneElement=function(e,t,r){if(null==e)throw Error(p(267,e));var i=o({},e.props),a=e.key,s=e.ref,u=e._owner;if(null!=t){if(void 0!==t.ref&&(s=t.ref,u=g.current),void 0!==t.key&&(a=""+t.key),e.type&&e.type.defaultProps)var c=e.type.defaultProps;for(l in t)S.call(t,l)&&!C.hasOwnProperty(l)&&(i[l]=void 0===t[l]&&void 0!==c?c[l]:t[l])}var l=arguments.length-2;if(1===l)i.children=r;else if(1<l){c=Array(l);for(var f=0;f<l;f++)c[f]=arguments[f+2];i.children=c}return{$$typeof:n,type:e.type,key:a,ref:s,props:i,_owner:u}},t.createContext=function(e,t){return void 0===t&&(t=null),(e={$$typeof:s,_calculateChangedBits:t,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null}).Provider={$$typeof:a,_context:e},e.Consumer=e},t.createElement=w,t.createFactory=function(e){var t=w.bind(null,e);return t.type=e,t},t.createRef=function(){return{current:null}},t.forwardRef=function(e){return{$$typeof:u,render:e}},t.isValidElement=O,t.lazy=function(e){return{$$typeof:l,_payload:{_status:-1,_result:e},_init:B}},t.memo=function(e,t){return{$$typeof:c,type:e,compare:void 0===t?null:t}},t.useCallback=function(e,t){return A().useCallback(e,t)},t.useContext=function(e,t){return A().useContext(e,t)},t.useDebugValue=function(){},t.useEffect=function(e,t){return A().useEffect(e,t)},t.useImperativeHandle=function(e,t,r){return A().useImperativeHandle(e,t,r)},t.useLayoutEffect=function(e,t){return A().useLayoutEffect(e,t)},t.useMemo=function(e,t){return A().useMemo(e,t)},t.useReducer=function(e,t,r){return A().useReducer(e,t,r)},t.useRef=function(e){return A().useRef(e)},t.useState=function(e){return A().useState(e)},t.version="17.0.2"},378:(e,t,r)=>{"use strict";e.exports=r(535)},14:function(e,t,r){"use strict";var o=this&&this.__createBinding||(Object.create?function(e,t,r,o){void 0===o&&(o=r);var n=Object.getOwnPropertyDescriptor(t,r);n&&!("get"in n?!t.__esModule:n.writable||n.configurable)||(n={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,o,n)}:function(e,t,r,o){void 0===o&&(o=r),e[o]=t[r]}),n=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),i=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)"default"!==r&&Object.prototype.hasOwnProperty.call(e,r)&&o(t,e,r);return n(t,e),t},a=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0}),t.getControlKey=t.Launcher=t.CommandBarClientSDK=t.snippet=t.initProxy=t.init=void 0;var s=i(r(599));t.Launcher=s.default,Object.defineProperty(t,"getControlKey",{enumerable:!0,get:function(){return s.getControlKey}});var u=r(343);Object.defineProperty(t,"CommandBarClientSDK",{enumerable:!0,get:function(){return u.CommandBarClientSDK}});var c=r(956);Object.defineProperty(t,"init",{enumerable:!0,get:function(){return a(c).default}});var l=r(737);Object.defineProperty(t,"initProxy",{enumerable:!0,get:function(){return l.initProxySDK}});var f=r(890);Object.defineProperty(t,"snippet",{enumerable:!0,get:function(){return f.snippet}})},956:function(e,t,r){"use strict";var o=this&&this.__assign||function(){return o=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},o.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),r(656),r(992),r(769);var n=r(737),i=r(207),a=function(e){if("complete"===document.readyState){var t=function(e){var t="https://api.commandbar.com",r=[],o=localStorage.getItem("commandbar.lc");o&&o.includes("local")&&(t="http://localhost:8000");var n=t+"/latest/"+e;return o&&r.push("lc="+o),r.push("version=2"),n+"?"+r.join("&")}(e),r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src=t,document.head.appendChild(r)}else window.addEventListener("load",a.bind(null,e),{capture:!1,once:!0})},s={debug:!1};t.default=function(e,t){var r;void 0===t&&(t=s);var u=o(o({},s),t);e?(null===(r=(0,n.getProxySDK)()[i._configuration])||void 0===r?void 0:r.uuid)?console.warn("CommandBar init was called more than once. Skipping the redundant initialization..."):(u.debug&&console.log("CommandBar init...",{environment:t.environment,version:t.version}),(0,n.getProxySDK)()[i._configuration]={uuid:e,environment:t.environment,version:t.version,config:t.config},a(e)):console.error("No org specified for CommandBar.init")}},890:(e,t,r)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.snippet=void 0;var o=r(207);t.snippet=function(e){var t=["Object.assign","Symbol","Symbol.for"].join("%2C"),r=window;function n(e,t){void 0===t&&(t=!1),"complete"!==document.readyState&&window.addEventListener("load",n.bind(null,e,t),{capture:!1,once:!0});var r=document.createElement("script");r.type="text/javascript",r.async=t,r.src=e,document.head.appendChild(r)}function i(){var t;if(void 0===r.CommandBar){delete r.__CommandBarBootstrap__;var i=Symbol.for("CommandBar::configuration"),a=Symbol.for("CommandBar::orgConfig"),s=Symbol.for("CommandBar::disposed"),u=Symbol.for("CommandBar::isProxy"),c=Symbol.for("CommandBar::queue"),l=Symbol.for("CommandBar::unwrap"),f=[],d=localStorage.getItem("commandbar.lc"),p=d&&d.includes("local")?"http://localhost:8000":"https://api.commandbar.com",m=Object.assign(((t={})[i]={uuid:e},t[a]={},t[s]=!1,t[u]=!0,t[c]=new Array,t[l]=function(){return m},t[o._eventSubscriptions]=void 0,t),r.CommandBar),y=["addCommand","boot","addEventSubscriber","addRecordAction","setFormFactor"],b=m;Object.assign(m,{shareCallbacks:function(){return{}},shareContext:function(){return{}}}),r.CommandBar=new Proxy(m,{get:function(e,t){return t in b?m[t]:"then"!==t?y.includes(t)?function(){var e=Array.prototype.slice.call(arguments);return new Promise((function(r,o){e.unshift(t,r,o),m[c].push(e)}))}:function(){var e=Array.prototype.slice.call(arguments);e.unshift(t),m[c].push(e)}:void 0}}),null!==d&&f.push("lc=".concat(d)),f.push("version=2"),n("".concat(p,"/latest/").concat(e,"?").concat(f.join("&")),!0)}}void 0===Object.assign||"undefined"==typeof Symbol||void 0===Symbol.for?(r.__CommandBarBootstrap__=i,n("https://polyfill.io/v3/polyfill.min.js?version=3.101.0&callback=__CommandBarBootstrap__&features="+t)):i()}},343:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.DEFAULT_META_ATTRIBUTES=t.DEFAULT_INSTANCE_ATTRIBUTES=t.ASYNC_METHODS=t.ASYNC_METHODS_SNIPPET=void 0,t.ASYNC_METHODS_SNIPPET=["addCommand","boot","addEventSubscriber","addRecordAction","setFormFactor"],t.ASYNC_METHODS=["addCommand","boot","addEventSubscriber","addEventHandler","addRecordAction","setFormFactor"],t.DEFAULT_INSTANCE_ATTRIBUTES={canOpenEditor:!0,formFactor:{type:"modal"},products:["bar","questlists","nudges","help_hub"]},t.DEFAULT_META_ATTRIBUTES={}},737:(e,t,r)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.initProxySDK=t.getProxySDK=void 0;var o=r(314),n=r(343),i=r(207);function a(){var e,t,r,o,a=window.CommandBar,s=window.CommandBar;Array.isArray(null==a?void 0:a.q)||"string"==typeof(null==a?void 0:a.uid)?(r=null==a?void 0:a.uid,o=null==a?void 0:a.q):(r=null===(t=null==s?void 0:s[i._configuration])||void 0===t?void 0:t.uuid,o=null==s?void 0:s[i._queue]);var u=((e={})[i._configuration]={uuid:"string"==typeof r?r:""},e[i._disposed]=!1,e[i._isProxy]=!0,e[i._queue]=Array.isArray(o)?o:[],e[i._unwrap]=function(){return u},e[i._eventSubscriptions]=void 0,e),c=u;Object.assign(u,{shareCallbacks:function(){return{}},shareContext:function(){return{}}}),window.CommandBar=new Proxy(u,{get:function(e,t){return t in c?c[t]:"then"!==t?n.ASYNC_METHODS_SNIPPET.includes(t)?function(){var e=Array.prototype.slice.call(arguments);return new Promise((function(r,o){e.unshift(t,r,o),u[i._queue].push(e)}))}:function(){var e=Array.prototype.slice.call(arguments);e.unshift(t),u[i._queue].push(e)}:void 0}})}t.getProxySDK=function(){var e=window.CommandBar;return((0,o.isDisposed)(e)||"boolean"!=typeof e[i._isProxy])&&a(),window.CommandBar[i._unwrap]()},t.initProxySDK=a},207:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t._updateEditorRoute=t._metaAttributes=t._eventSubscriptions=t._userAttributes=t._fingerprint=t._user=t._unwrap=t._state=t._showMessage=t._showGuide=t._shareProgrammaticCommands=t._shareContextSettings=t._shareConfig=t._setEditorVisible=t._setTestMode=t._setPreviewMode=t._setDashboard=t._search=t._reporter=t._report=t._reloadChecklists=t._previewChecklist=t._stopNudgePreview=t._stopChecklistPreview=t._previewNudge=t._reloadHelpHub=t._reloadNudges=t._reloadPlaceholders=t._reloadOrganization=t._reloadCommands=t._queue=t._programmaticTheme=t._perf=t._orgConfig=t._shareInitialEditorPath=t._shareEditorRouteWithBar=t._onEditorPathChange=t._loadEditor=t._isProxy=t._instanceAttributes=t._disposed=t._dispose=t._dispatch=t._configUser=t._configure=t._configuration=t._access=void 0,t._access=Symbol.for("CommandBar::access"),t._configuration=Symbol.for("CommandBar::configuration"),t._configure=Symbol.for("CommandBar::configure"),t._configUser=Symbol.for("CommandBar::configUser"),t._dispatch=Symbol.for("CommandBar::dispatch"),t._dispose=Symbol.for("CommandBar::dispose"),t._disposed=Symbol.for("CommandBar::disposed"),t._instanceAttributes=Symbol.for("CommandBar::instanceAttributes"),t._isProxy=Symbol.for("CommandBar::isProxy"),t._loadEditor=Symbol.for("CommandBar::loadEditor"),t._onEditorPathChange=Symbol.for("CommandBar::onEditorPathChange"),t._shareEditorRouteWithBar=Symbol.for("CommandBar::shareEditorRouteWithBar"),t._shareInitialEditorPath=Symbol.for("CommandBar::shareInitialEditorPath"),t._orgConfig=Symbol.for("CommandBar::orgConfig"),t._perf=Symbol.for("CommandBar::perf"),t._programmaticTheme=Symbol.for("CommandBar::programmaticTheme"),t._queue=Symbol.for("CommandBar::queue"),t._reloadCommands=Symbol.for("CommandBar::reloadCommands"),t._reloadOrganization=Symbol.for("CommandBar::reloadOrganization"),t._reloadPlaceholders=Symbol.for("CommandBar::reloadPlaceholders"),t._reloadNudges=Symbol.for("CommandBar::reloadNudges"),t._reloadHelpHub=Symbol.for("CommandBar::reloadHelpHub"),t._previewNudge=Symbol.for("CommandBar::previewNudge"),t._stopChecklistPreview=Symbol.for("CommandBar::stopChecklistPreview"),t._stopNudgePreview=Symbol.for("CommandBar::stopNudgePreview"),t._previewChecklist=Symbol.for("CommandBar::previewChecklist"),t._reloadChecklists=Symbol.for("CommandBar::reloadChecklists"),t._report=Symbol.for("CommandBar::report"),t._reporter=Symbol.for("CommandBar::reporter"),t._search=Symbol.for("CommandBar::search"),t._setDashboard=Symbol.for("CommandBar::setDashboard"),t._setPreviewMode=Symbol.for("CommandBar::setPreviewMode"),t._setTestMode=Symbol.for("CommandBar::setTestMode"),t._setEditorVisible=Symbol.for("CommandBar::setEditorVisible"),t._shareConfig=Symbol.for("CommandBar::shareConfig"),t._shareContextSettings=Symbol.for("CommandBar::shareContextSettings"),t._shareProgrammaticCommands=Symbol.for("CommandBar::shareProgrammaticCommands"),t._showGuide=Symbol.for("CommandBar::showGuide"),t._showMessage=Symbol.for("CommandBar::showMessage"),t._state=Symbol.for("CommandBar::state"),t._unwrap=Symbol.for("CommandBar::unwrap"),t._user=Symbol.for("CommandBar::user"),t._fingerprint=Symbol.for("CommandBar::fingerprint"),t._userAttributes=Symbol.for("CommandBar::userAttributes"),t._eventSubscriptions=Symbol.for("CommandBar::eventSubscriptions"),t._metaAttributes=Symbol.for("CommandBar::metaAttributes"),t._updateEditorRoute=Symbol.for("CommandBar::updateEditorRoute")},314:(e,t,r)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.dispose=t.isDisposed=t.isDisposable=void 0;var o=r(207),n=function(e){return void 0!==e&&void 0!==e.dispose},i=function(e){return void 0!==e&&void 0!==e[o._dispose]};t.isDisposable=function(e){return void 0===e||n(e)||i(e)},t.isDisposed=function(e){return void 0===e||n(e)&&!0===e._disposed||i(e)&&!0===e[o._disposed]},t.dispose=function(e){void 0!==e&&(i(e)?e[o._dispose]():e.dispose())}},111:(e,t,r)=>{"use strict";var o=r(666);e.exports=function(e){if("function"!=typeof e)return!1;if(!hasOwnProperty.call(e,"length"))return!1;try{if("number"!=typeof e.length)return!1;if("function"!=typeof e.call)return!1;if("function"!=typeof e.apply)return!1}catch(e){return!1}return!o(e)}},617:(e,t,r)=>{"use strict";var o=r(102),n={object:!0,function:!0,undefined:!0};e.exports=function(e){return!!o(e)&&hasOwnProperty.call(n,typeof e)}},307:(e,t,r)=>{"use strict";var o=r(111),n=/^\s*class[\s{/}]/,i=Function.prototype.toString;e.exports=function(e){return!!o(e)&&!n.test(i.call(e))}},666:(e,t,r)=>{"use strict";var o=r(617);e.exports=function(e){if(!o(e))return!1;try{return!!e.constructor&&e.constructor.prototype===e}catch(e){return!1}}},102:e=>{"use strict";e.exports=function(e){return null!=e}}},t={};function r(o){var n=t[o];if(void 0!==n)return n.exports;var i=t[o]={exports:{}};return e[o].call(i.exports,i,i.exports,r),i.exports}return r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]})},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r(14)})()));

/***/ }),

/***/ 87394:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addLeadingZeros;

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

module.exports = exports.default;

/***/ }),

/***/ 88609:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = assign;

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

module.exports = exports.default;

/***/ }),

/***/ 46420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = cloneObject;

var _index = _interopRequireDefault(__webpack_require__(88609));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneObject(dirtyObject) {
  return (0, _index.default)({}, dirtyObject);
}

module.exports = exports.default;

/***/ }),

/***/ 52084:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(62699));

var _index2 = _interopRequireDefault(__webpack_require__(21603));

var _index3 = _interopRequireDefault(__webpack_require__(91354));

var _index4 = _interopRequireDefault(__webpack_require__(81370));

var _index5 = _interopRequireDefault(__webpack_require__(60623));

var _index6 = _interopRequireDefault(__webpack_require__(66226));

var _index7 = _interopRequireDefault(__webpack_require__(87394));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return _index.default.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = (0, _index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0, _index7.default)(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return (0, _index7.default)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = (0, _index4.default)(date); // Padding

    return (0, _index7.default)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return (0, _index7.default)(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return (0, _index7.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return (0, _index7.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return _index.default.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return (0, _index7.default)(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = (0, _index5.default)(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return (0, _index7.default)(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = (0, _index3.default)(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return (0, _index7.default)(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return _index.default.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = (0, _index2.default)(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return (0, _index7.default)(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return (0, _index7.default)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return (0, _index7.default)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return (0, _index7.default)(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return _index.default.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return _index.default.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0, _index7.default)(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0, _index7.default)(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return _index.default.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return _index.default.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return _index.default.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0, _index7.default)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0, _index7.default)(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0, _index7.default)(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0, _index7.default)(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0, _index7.default)(Math.floor(absOffset / 60), 2);
  var minutes = (0, _index7.default)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 62699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(87394));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return (0, _index.default)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return (0, _index.default)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return (0, _index.default)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return (0, _index.default)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0, _index.default)(fractionalSeconds, token.length);
  }
};
var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 95209:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var _default = longFormatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 93561:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffsetInMilliseconds;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

module.exports = exports.default;

/***/ }),

/***/ 21603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCDayOfYear;

var _index = _interopRequireDefault(__webpack_require__(71171));

var _index2 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

module.exports = exports.default;

/***/ }),

/***/ 91354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeek;

var _index = _interopRequireDefault(__webpack_require__(71171));

var _index2 = _interopRequireDefault(__webpack_require__(80079));

var _index3 = _interopRequireDefault(__webpack_require__(94275));

var _index4 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

module.exports = exports.default;

/***/ }),

/***/ 81370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeekYear;

var _index = _interopRequireDefault(__webpack_require__(71171));

var _index2 = _interopRequireDefault(__webpack_require__(80079));

var _index3 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 60623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeek;

var _index = _interopRequireDefault(__webpack_require__(71171));

var _index2 = _interopRequireDefault(__webpack_require__(69209));

var _index3 = _interopRequireDefault(__webpack_require__(34118));

var _index4 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

module.exports = exports.default;

/***/ }),

/***/ 66226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeekYear;

var _index = _interopRequireDefault(__webpack_require__(82084));

var _index2 = _interopRequireDefault(__webpack_require__(71171));

var _index3 = _interopRequireDefault(__webpack_require__(69209));

var _index4 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeekYear(dirtyDate, dirtyOptions) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 56736:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];

function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}

function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}

function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

/***/ }),

/***/ 68734:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = requiredArgs;

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

module.exports = exports.default;

/***/ }),

/***/ 80079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeek;

var _index = _interopRequireDefault(__webpack_require__(71171));

var _index2 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var weekStartsOn = 1;
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 94275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeekYear;

var _index = _interopRequireDefault(__webpack_require__(81370));

var _index2 = _interopRequireDefault(__webpack_require__(80079));

var _index3 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var year = (0, _index.default)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0, _index2.default)(fourthOfJanuary);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 69209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeek;

var _index = _interopRequireDefault(__webpack_require__(82084));

var _index2 = _interopRequireDefault(__webpack_require__(71171));

var _index3 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeek(dirtyDate, dirtyOptions) {
  (0, _index3.default)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0, _index2.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 34118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeekYear;

var _index = _interopRequireDefault(__webpack_require__(82084));

var _index2 = _interopRequireDefault(__webpack_require__(66226));

var _index3 = _interopRequireDefault(__webpack_require__(69209));

var _index4 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  (0, _index4.default)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate);
  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0, _index3.default)(firstWeek, dirtyOptions);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 82084:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toInteger;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

module.exports = exports.default;

/***/ }),

/***/ 5065:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addMilliseconds;

var _index = _interopRequireDefault(__webpack_require__(82084));

var _index2 = _interopRequireDefault(__webpack_require__(71171));

var _index3 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var timestamp = (0, _index2.default)(dirtyDate).getTime();
  var amount = (0, _index.default)(dirtyAmount);
  return new Date(timestamp + amount);
}

module.exports = exports.default;

/***/ }),

/***/ 4810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addLeadingZeros; }
/* harmony export */ });
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/***/ }),

/***/ 97621:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["Z"] = (longFormatters);

/***/ }),

/***/ 24262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 33276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCISOWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCISOWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66979);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,toInteger/* default */.Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0,toInteger/* default */.Z)(options.firstWeekContainsDate);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, dirtyOptions);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCWeekYear; }
/* harmony export */ });
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59025);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ isProtectedWeekYearToken; },
/* harmony export */   "Iu": function() { return /* binding */ isProtectedDayOfYearToken; },
/* harmony export */   "qp": function() { return /* binding */ throwProtectedError; }
/* harmony export */ });
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 66979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCISOWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 59025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCWeek; }
/* harmony export */ });
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 83946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 29422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ add; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77349);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11640);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);






/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(dirtyDate, duration) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  if (!duration || typeof duration !== 'object') return new Date(NaN);
  var years = duration.years ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.years) : 0;
  var months = duration.months ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.weeks) : 0;
  var days = duration.days ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.days) : 0;
  var hours = duration.hours ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration.seconds) : 0; // Add years and months

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate);
  var dateWithMonths = months || years ? (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, months + years * 12) : date; // Add weeks and days

  var dateWithDays = days || weeks ? (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds

  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1000;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}

/***/ }),

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 78343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),

/***/ 51820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMilliseconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 58545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMinutes; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),

/***/ 11640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 61973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addSeconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */

function addSeconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * 1000);
}

/***/ }),

/***/ 63500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addWeeks; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  var days = amount * 7;
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, days);
}

/***/ }),

/***/ 21593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * 12);
}

/***/ }),

/***/ 49474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ compareAsc; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/***/ }),

/***/ 92300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ differenceInCalendarDays; }
/* harmony export */ });
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24262);
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfDayLeft = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var startOfDayRight = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ 67803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ differenceInDays; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92300);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


 // Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */


function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs((0,_differenceInCalendarDays_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/***/ }),

/***/ 76972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ differenceInHours; }
/* harmony export */ });
/* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59910);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var diff = (0,_differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}

/***/ }),

/***/ 59910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ differenceInMilliseconds; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeft.getTime() - dateRight.getTime();
}

/***/ }),

/***/ 69690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ differenceInMinutes; }
/* harmony export */ });
/* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59910);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are from 10:01:59 to 10:00:00
 * var result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */

function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var diff = (0,_differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}

/***/ }),

/***/ 62337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ differenceInMonths; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarMonths/index.js


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(49474);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfDay/index.js
var endOfDay = __webpack_require__(83894);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js
var endOfMonth = __webpack_require__(4135);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isLastDayOfMonth/index.js




/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */

function isLastDayOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return (0,endOfDay/* default */.Z)(date).getTime() === (0,endOfMonth/* default */.Z)(date).getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInMonths/index.js





/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = (0,compareAsc/* default */.Z)(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = (0,compareAsc/* default */.Z)(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth((0,toDate/* default */.Z)(dirtyDateLeft)) && difference === 1 && (0,compareAsc/* default */.Z)(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}

/***/ }),

/***/ 11699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ differenceInSeconds; }
/* harmony export */ });
/* harmony import */ var _differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59910);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var diff = (0,_differenceInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft, dirtyDateRight) / 1000;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}

/***/ }),

/***/ 31397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ differenceInYears; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarYears/index.js


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(49474);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInYears/index.js




/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */

function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = (0,compareAsc/* default */.Z)(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days

  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastYearNotFull = (0,compareAsc/* default */.Z)(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/***/ }),

/***/ 83894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ endOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 4135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ endOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 67090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ endOfWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 32912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 1 modules
var en_US = __webpack_require__(83975);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(91218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
var addLeadingZeros = __webpack_require__(4810);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0,addLeadingZeros/* default */.Z)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0,addLeadingZeros/* default */.Z)(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0,addLeadingZeros/* default */.Z)(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0,addLeadingZeros/* default */.Z)(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return (0,addLeadingZeros/* default */.Z)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date); // Padding

    return (0,addLeadingZeros/* default */.Z)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return (0,addLeadingZeros/* default */.Z)(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return (0,addLeadingZeros/* default */.Z)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return (0,addLeadingZeros/* default */.Z)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return (0,addLeadingZeros/* default */.Z)(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return (0,addLeadingZeros/* default */.Z)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return (0,addLeadingZeros/* default */.Z)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return (0,addLeadingZeros/* default */.Z)(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0,addLeadingZeros/* default */.Z)(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0,addLeadingZeros/* default */.Z)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0,addLeadingZeros/* default */.Z)(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0,addLeadingZeros/* default */.Z)(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0,addLeadingZeros/* default */.Z)(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0,addLeadingZeros/* default */.Z)(Math.floor(absOffset / 60), 2);
  var minutes = (0,addLeadingZeros/* default */.Z)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ var format_formatters = (formatters_formatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js









 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || en_US/* default */.Z;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,toInteger/* default */.Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0,toInteger/* default */.Z)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,toInteger/* default */.Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,toInteger/* default */.Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 33913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isPast; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */

function isPast(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime() < Date.now();
}

/***/ }),

/***/ 3151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isSameDay; }
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 49160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isSameMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),

/***/ 60792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isSameYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),

/***/ 51085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isToday; }
/* harmony export */ });
/* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3151);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */

function isToday(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate, Date.now());
}

/***/ }),

/***/ 49727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isTomorrow; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3151);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */

function isTomorrow(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate, (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Date.now(), 1));
}

/***/ }),

/***/ 12274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isValid; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  return !isNaN(date);
}

/***/ }),

/***/ 24257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isWithinInterval; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var time = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime();
  var startTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(interval.start).getTime();
  var endTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

/***/ }),

/***/ 49526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ buildFormatLongFn; }
/* harmony export */ });
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),

/***/ 81991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatDistance; }
/* harmony export */ });
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

/***/ }),

/***/ 21865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatRelative; }
/* harmony export */ });
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

/***/ }),

/***/ 27727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _lib_localize; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);

/***/ }),

/***/ 43754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _lib_match; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);

/***/ }),

/***/ 83975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ en_US; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistance = __webpack_require__(81991);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelative = __webpack_require__(21865);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js + 1 modules
var localize = __webpack_require__(27727);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js + 2 modules
var match = __webpack_require__(43754);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance/* default */.Z,
  formatLong: _lib_formatLong,
  formatRelative: formatRelative/* default */.Z,
  localize: localize/* default */.Z,
  match: match/* default */.Z,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);

/***/ }),

/***/ 24002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ parse; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 1 modules
var en_US = __webpack_require__(83975);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(91218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCDay/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,toInteger/* default */.Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,toInteger/* default */.Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISODay/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var day = (0,toInteger/* default */.Z)(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var isoWeek = (0,toInteger/* default */.Z)(dirtyISOWeek);
  var diff = (0,getUTCISOWeek/* default */.Z)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCWeek/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = (0,getUTCWeek/* default */.Z)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/index.js







var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = (0,getUTCWeekYear/* default */.Z)(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0,startOfUTCWeek/* default */.Z)(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCWeek/* default */.Z)(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCISOWeek/* default */.Z)(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return (0,startOfUTCWeek/* default */.Z)(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return (0,startOfUTCISOWeek/* default */.Z)(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
/* harmony default export */ var _lib_parsers = (parsers);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/index.js










var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || en_US/* default */.Z;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,toInteger/* default */.Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0,toInteger/* default */.Z)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,toInteger/* default */.Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,toInteger/* default */.Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return (0,toDate/* default */.Z)(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(token)) {
      (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(token)) {
      (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = _lib_parsers[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0,toDate/* default */.Z)(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign_assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 37042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var hours = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),

/***/ 4543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setMinutes; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var minutes = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),

/***/ 69119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 43703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 91218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subMilliseconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 15616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;

var _index = _interopRequireDefault(__webpack_require__(39989));

var _index2 = _interopRequireDefault(__webpack_require__(82512));

var _index3 = _interopRequireDefault(__webpack_require__(33239));

var _index4 = _interopRequireDefault(__webpack_require__(71171));

var _index5 = _interopRequireDefault(__webpack_require__(52084));

var _index6 = _interopRequireDefault(__webpack_require__(95209));

var _index7 = _interopRequireDefault(__webpack_require__(93561));

var _index8 = __webpack_require__(56736);

var _index9 = _interopRequireDefault(__webpack_require__(82084));

var _index10 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  (0, _index10.default)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || _index2.default;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0, _index4.default)(dirtyDate);

  if (!(0, _index.default)(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0, _index7.default)(originalDate);
  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = _index6.default[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = _index5.default[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

module.exports = exports.default;

/***/ }),

/***/ 39989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isValid;

var _index = _interopRequireDefault(__webpack_require__(71171));

var _index2 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  return !isNaN(date);
}

module.exports = exports.default;

/***/ }),

/***/ 20289:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildFormatLongFn;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

module.exports = exports.default;

/***/ }),

/***/ 16245:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildLocalizeFn;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!

    return valuesArray[index];
  };
}

module.exports = exports.default;

/***/ }),

/***/ 43421:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchFn;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

module.exports = exports.default;

/***/ }),

/***/ 78926:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchPatternFn;

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

module.exports = exports.default;

/***/ }),

/***/ 71924:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = formatDistance;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

module.exports = exports.default;

/***/ }),

/***/ 95062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(20289));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0, _index.default)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0, _index.default)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0, _index.default)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var _default = formatLong;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 5102:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = formatRelative;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

module.exports = exports.default;

/***/ }),

/***/ 87839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(16245));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: (0, _index.default)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0, _index.default)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: (0, _index.default)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0, _index.default)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0, _index.default)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var _default = localize;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 9796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(78926));

var _index2 = _interopRequireDefault(__webpack_require__(43421));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0, _index.default)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: (0, _index2.default)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0, _index2.default)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: (0, _index2.default)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0, _index2.default)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0, _index2.default)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var _default = match;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 82512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(71924));

var _index2 = _interopRequireDefault(__webpack_require__(95062));

var _index3 = _interopRequireDefault(__webpack_require__(5102));

var _index4 = _interopRequireDefault(__webpack_require__(87839));

var _index5 = _interopRequireDefault(__webpack_require__(9796));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _index.default,
  formatLong: _index2.default,
  formatRelative: _index3.default,
  localize: _index4.default,
  match: _index5.default,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var _default = locale;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 33239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subMilliseconds;

var _index = _interopRequireDefault(__webpack_require__(82084));

var _index2 = _interopRequireDefault(__webpack_require__(5065));

var _index3 = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;

/***/ }),

/***/ 71171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;

var _index = _interopRequireDefault(__webpack_require__(68734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0, _index.default)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

module.exports = exports.default;

/***/ }),

/***/ 27484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof b},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new b(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var b=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,f=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=O.p(f),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return O.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return O.s(e.$y,4,"0");case"M":return a+1;case"MM":return O.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return O.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return O.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return O.s(u,2,"0");case"s":return String(e.$s);case"ss":return O.s(e.$s,2,"0");case"SSS":return O.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=O.p(d),m=w(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return O.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:O.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),_=b.prototype;return w.prototype=_,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){_[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,b,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 96671:
/***/ (function(module) {

!function(t,n){ true?module.exports=n():0}(this,(function(){"use strict";var t="month",n="quarter";return function(e,i){var r=i.prototype;r.quarter=function(t){return this.$utils().u(t)?Math.ceil((this.month()+1)/3):this.month(this.month()%3+3*(t-1))};var s=r.add;r.add=function(e,i){return e=Number(e),this.$utils().p(i)===n?this.add(3*e,t):s.bind(this)(e,i)};var u=r.startOf;r.startOf=function(e,i){var r=this.$utils(),s=!!r.u(i)||i;if(r.p(e)===n){var o=this.quarter()-1;return s?this.month(3*o).startOf(t).startOf("day"):this.month(3*o+2).endOf(t).endOf("day")}return u.bind(this)(e,i)}}}));

/***/ }),

/***/ 64063:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 33827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["Z"] = (isBrowser);


/***/ }),

/***/ 16345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ jss_plugin_camel_case_esm; }
});

;// CONCATENATED MODULE: ./node_modules/hyphenate-style-name/index.js
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ var hyphenate_style_name = (hyphenateStyleName);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js


/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenate_style_name(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenate_style_name(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_camel_case_esm = (camelCase);


/***/ }),

/***/ 83961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33512);


var px = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.px : 'px';
var ms = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.ms : 'ms';
var percent = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (defaultUnit);


/***/ }),

/***/ 5019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33512);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new jss__WEBPACK_IMPORTED_MODULE_0__/* .RuleList */ .RB((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssGlobal);


/***/ }),

/***/ 63057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

       false ? 0 : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssNested);


/***/ }),

/***/ 26895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssPropsSort);


/***/ }),

/***/ 27202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33512);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = (0,jss__WEBPACK_IMPORTED_MODULE_0__/* .createRule */ .JH)(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) { var prop; }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (functionPlugin);


/***/ }),

/***/ 79368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ jss_plugin_vendor_prefixer_esm; }
});

// EXTERNAL MODULE: ./node_modules/is-in-browser/dist/module.js
var dist_module = __webpack_require__(33827);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: ./node_modules/css-vendor/dist/css-vendor.esm.js



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = dist_module/* default */.Z && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (dist_module/* default */.Z) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (dist_module/* default */.Z) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ( true && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (dist_module/* default */.Z) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ( true && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}



// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js + 5 modules
var jss_esm = __webpack_require__(33512);
;// CONCATENATED MODULE: ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js



/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, (0,jss_esm/* toCssValue */.EK)(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, (0,jss_esm/* toCssValue */.EK)(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_vendor_prefixer_esm = (jssVendorPrefixer);


/***/ }),

/***/ 33512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RB": function() { return /* binding */ RuleList; },
  "gq": function() { return /* binding */ SheetsManager; },
  "Ue": function() { return /* binding */ createJss; },
  "JH": function() { return /* binding */ createRule; },
  "_$": function() { return /* binding */ getDynamicStyles; },
  "HZ": function() { return /* binding */ hasCSSTOMSupport; },
  "EK": function() { return /* binding */ toCssValue; }
});

// UNUSED EXPORTS: SheetsRegistry, createGenerateId, default, sheets

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/is-in-browser/dist/module.js
var dist_module = __webpack_require__(33827);
;// CONCATENATED MODULE: ./node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (warning);

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
;// CONCATENATED MODULE: ./node_modules/jss/dist/jss.esm.js








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? 0 : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var jss_esm_escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? 0 : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,inheritsLoose/* default */.Z)(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), sheet);
      _this.selectorText = "." + jss_esm_escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,esm_extends/* default */.Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList((0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? 0 : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : jss_esm_escape(generateId(this, sheet));
    this.rules = new RuleList((0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], (0,esm_extends/* default */.Z)({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? 0 : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,inheritsLoose/* default */.Z)(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,esm_extends/* default */.Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = (0,esm_extends/* default */.Z)({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + jss_esm_escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = (0,esm_extends/* default */.Z)({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = (0,esm_extends/* default */.Z)({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? 0 : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? 0 : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? 0 : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? 0 : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? 0 : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
     false ? 0 : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: dist_module/* default */.Z ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = (0,esm_extends/* default */.Z)({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, (0,esm_extends/* default */.Z)({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = (0,esm_extends/* default */.Z)({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */

var SheetsManager =
/*#__PURE__*/
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    tiny_warning_esm(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      tiny_warning_esm(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  _createClass(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

/* harmony default export */ var jss_esm = ((/* unused pure expression or super */ null && (index)));



/***/ }),

/***/ 49090:
/***/ (function(module) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 40098:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 47445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(40098),
    isIterateeCall = __webpack_require__(16612),
    toFinite = __webpack_require__(18601);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 89179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639),
    toInteger = __webpack_require__(40554),
    toNumber = __webpack_require__(14841),
    toString = __webpack_require__(79833);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 16612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(87379);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 96486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 96026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(47445);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 59854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRound = __webpack_require__(89179);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 87379:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 40554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(18601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 57824:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 56566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Types;

(function (Types) {
  Types["SHOW"] = "SHOW";
  Types["HIDE"] = "HIDE";
  Types["UPDATE"] = "UPDATE";
  Types["DESTROY"] = "DESTROY";
  Types["DESTROY_BY_ROOT_ID"] = "DESTROY_BY_ROOT_ID";
  Types["UNKNOWN"] = "UNKNOWN";
})(Types || (Types = {}));

var initialState = {};
function reducer(state, action) {
  switch (action.type) {
    case Types.SHOW:
      {
        var _extends2;

        var _action$payload = action.payload,
            id = _action$payload.id,
            component = _action$payload.component,
            props = _action$payload.props,
            options = _action$payload.options;
        return _extends({}, state, (_extends2 = {}, _extends2[id] = {
          component: component,
          props: _extends({}, props, {
            open: true
          }),
          options: options
        }, _extends2));
      }

    case Types.HIDE:
      {
        var _extends3;

        var _id = action.payload.id;

        if (!state[_id]) {
          return state;
        }

        return _extends({}, state, (_extends3 = {}, _extends3[_id] = _extends({}, state[_id], {
          props: _extends({}, state[_id].props, {
            open: false
          })
        }), _extends3));
      }

    case Types.UPDATE:
      {
        var _extends4;

        var _action$payload2 = action.payload,
            _id2 = _action$payload2.id,
            _props = _action$payload2.props;

        if (!state[_id2]) {
          return state;
        }

        return _extends({}, state, (_extends4 = {}, _extends4[_id2] = _extends({}, state[_id2], {
          props: _extends({}, state[_id2].props, _props)
        }), _extends4));
      }

    case Types.DESTROY:
      {
        var _id3 = action.payload.id;

        var newState = _extends({}, state);

        delete newState[_id3];
        return newState;
      }

    case Types.DESTROY_BY_ROOT_ID:
      {
        var rootId = action.payload.rootId;
        return Object.keys(state).filter(function (key) {
          return key.split('.')[0] !== rootId;
        }).reduce(function (acc, key) {
          var _extends5;

          return _extends({}, acc, (_extends5 = {}, _extends5[key] = state[key], _extends5));
        }, {});
      }

    default:
      throw new Error('Unexpected action');
  }
}

var initialContextState = {
  state: initialState,
  hideModal: function hideModal() {},
  showModal: function showModal() {
    return {
      id: 'id',
      hide: function hide() {},
      destroy: function destroy() {},
      update: function update() {}
    };
  },
  destroyModal: function destroyModal() {},
  updateModal: function updateModal() {},
  destroyModalsByRootId: function destroyModalsByRootId() {}
};
var ModalContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialContextState);

var MISSED_MODAL_ID_ERROR_MESSAGE = '[ERROR]: Modal ID is missing';
var MISSED_MODAL_ROOT_ID_ERROR_MESSAGE = '[ERROR]: Modal root ID is missing';

var uid = function uid(len) {
  if (len === void 0) {
    len = 8;
  }

  var buf = [];
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charlen = chars.length;

  for (var i = 0; i < len; i++) {
    buf[i] = chars.charAt(Math.floor(Math.random() * charlen));
  }

  return buf.join('');
};

function ModalProvider(_ref) {
  var children = _ref.children,
      _ref$legacy = _ref.legacy,
      legacy = _ref$legacy === void 0 ? false : _ref$legacy;

  var _React$useReducer = react__WEBPACK_IMPORTED_MODULE_0__.useReducer(reducer, initialState),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var _update = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (id, _ref2) {
    var props = _objectWithoutPropertiesLoose(_ref2, ["open"]);

    if (!id) {
      console.error(MISSED_MODAL_ID_ERROR_MESSAGE);
      return;
    }

    dispatch({
      type: Types.UPDATE,
      payload: {
        id: id,
        props: props
      }
    });
  }, [dispatch]);

  var _hide = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (id) {
    if (!id) {
      console.error(MISSED_MODAL_ID_ERROR_MESSAGE);
      return;
    }

    dispatch({
      type: Types.HIDE,
      payload: {
        id: id
      }
    });
  }, [dispatch]);

  var _destroy = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (id) {
    if (!id) {
      console.error(MISSED_MODAL_ID_ERROR_MESSAGE);
      return;
    }

    dispatch({
      type: Types.DESTROY,
      payload: {
        id: id
      }
    });
  }, [dispatch]);

  var destroyByRootId = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (rootId) {
    if (!rootId) {
      console.error(MISSED_MODAL_ROOT_ID_ERROR_MESSAGE);
      return;
    }

    dispatch({
      type: Types.DESTROY_BY_ROOT_ID,
      payload: {
        rootId: rootId
      }
    });
  }, [dispatch]);
  var show = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (component, props, options) {
    var id = uid(8);

    if (options && options.rootId) {
      id = options.rootId + "." + id;
    }

    dispatch({
      type: Types.SHOW,
      payload: {
        id: id,
        component: component,
        props: props,
        options: options
      }
    });
    return {
      id: id,
      hide: function hide() {
        return _hide(id);
      },
      destroy: function destroy() {
        return _destroy(id);
      },
      update: function update(newProps) {
        return _update(id, newProps);
      }
    };
  }, [dispatch, _hide, _destroy, _update]);

  var renderState = function renderState() {
    return Object.keys(state).map(function (id) {
      var _state$id = state[id],
          Component = _state$id.component,
          props = _state$id.props,
          options = _state$id.options;

      var handleClose = function handleClose() {
        if (options && options.destroyOnClose) {
          _destroy(id);
        } else {
          _hide(id);
        }

        if (props && props.onClose) {
          props.onClose.apply(props, arguments);
        }
      };

      var handleExited = function handleExited() {
        var _props$TransitionProp;

        if (props === null || props === void 0 ? void 0 : props.onExited) {
          props.onExited.apply(props, arguments);
        }

        if (props === null || props === void 0 ? void 0 : (_props$TransitionProp = props.TransitionProps) === null || _props$TransitionProp === void 0 ? void 0 : _props$TransitionProp.onExited) {
          var _props$TransitionProp2;

          (_props$TransitionProp2 = props.TransitionProps).onExited.apply(_props$TransitionProp2, arguments);
        }

        _destroy(id);
      };

      var extraProps = {};

      if (!legacy) {
        extraProps = {
          TransitionProps: _extends({}, props === null || props === void 0 ? void 0 : props.TransitionProps, {
            onExited: handleExited
          })
        };
      } else {
        extraProps = {
          onExited: handleExited
        };
      }

      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, props, {
        key: id,
        onClose: handleClose
      }, options && !options.destroyOnClose && extraProps));
    });
  };

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalContext.Provider, {
    value: {
      state: state,
      updateModal: _update,
      hideModal: _hide,
      destroyModal: _destroy,
      showModal: show,
      destroyModalsByRootId: destroyByRootId
    }
  }, children, renderState());
}

var defaultOptions = {
  disableAutoDestroy: false
};
function useModal(options) {
  if (options === void 0) {
    options = defaultOptions;
  }

  var _defaultOptions$optio = _extends({}, defaultOptions, options),
      disableAutoDestroy = _defaultOptions$optio.disableAutoDestroy;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ModalContext),
      showModal = _useContext.showModal,
      destroy = _useContext.destroyModalsByRootId,
      otherContextProps = _objectWithoutPropertiesLoose(_useContext, ["showModal", "destroyModalsByRootId"]);

  var id = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(uid(6));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      if (!disableAutoDestroy) {
        destroy(id.current);
      }
    };
  }, [disableAutoDestroy, destroy]);
  return _extends({
    showModal: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (component, props, options) {
      return showModal(component, props, _extends({
        rootId: id.current
      }, options));
    }, [showModal])
  }, otherContextProps);
}

/* harmony default export */ __webpack_exports__["Z"] = (ModalProvider);

//# sourceMappingURL=mui-modal-provider.esm.js.map


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(86022);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17109:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/severity.js
var severity = __webpack_require__(16547);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/captureconsole.js


/** Send Console API calls as Sentry Events */
class CaptureConsole  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'CaptureConsole';}

  /**
   * @inheritDoc
   */
   __init() {this.name = CaptureConsole.id;}

  /**
   * @inheritDoc
   */
    __init2() {this._levels = logger/* CONSOLE_LEVELS */.RU;}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {CaptureConsole.prototype.__init.call(this);CaptureConsole.prototype.__init2.call(this);
    if (options.levels) {
      this._levels = options.levels;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
      return;
    }

    this._levels.forEach((level) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      if (!(level in worldwide/* GLOBAL_OBJ.console */.n2.console)) {
        return;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ.console */.n2.console, level, (originalConsoleMethod) => (...args) => {
        const hub = getCurrentHub();

        if (hub.getIntegration(CaptureConsole)) {
          hub.withScope(scope => {
            scope.setLevel((0,severity/* severityLevelFromString */.VT)(level));
            scope.setExtra('arguments', args);
            scope.addEventProcessor(event => {
              event.logger = 'console';
              return event;
            });

            let message = (0,string/* safeJoin */.nK)(args, ' ');
            if (level === 'assert') {
              if (args[0] === false) {
                message = `Assertion failed: ${(0,string/* safeJoin */.nK)(args.slice(1), ' ') || 'console.assert'}`;
                scope.setExtra('arguments', args.slice(1));
                hub.captureMessage(message);
              }
            } else if (level === 'error' && args[0] instanceof Error) {
              hub.captureException(args[0]);
            } else {
              hub.captureMessage(message);
            }
          });
        }

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(worldwide/* GLOBAL_OBJ.console */.n2.console, args);
        }
      });
    });
  }
} CaptureConsole.__initStatic();


//# sourceMappingURL=captureconsole.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(34754);
;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/extraerrordata.js


/** JSDoc */

/** Patch toString calls to return proper name for wrapped functions */
class ExtraErrorData  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'ExtraErrorData';}

  /**
   * @inheritDoc
   */
   __init() {this.name = ExtraErrorData.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {ExtraErrorData.prototype.__init.call(this);
    this._options = {
      depth: 3,
      ...options,
    };
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor((event, hint) => {
      const self = getCurrentHub().getIntegration(ExtraErrorData);
      if (!self) {
        return event;
      }
      return self.enhanceEventWithErrorData(event, hint);
    });
  }

  /**
   * Attaches extracted information from the Error object to extra field in the Event
   */
   enhanceEventWithErrorData(event, hint = {}) {
    if (!hint.originalException || !(0,is/* isError */.VZ)(hint.originalException)) {
      return event;
    }
    const exceptionName = (hint.originalException ).name || hint.originalException.constructor.name;

    const errorData = this._extractErrorData(hint.originalException );

    if (errorData) {
      const contexts = {
        ...event.contexts,
      };

      const normalizedErrorData = (0,normalize/* normalize */.Fv)(errorData, this._options.depth);

      if ((0,is/* isPlainObject */.PO)(normalizedErrorData)) {
        // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
        // potentially truncate the data we just already normalized, with a certain depth setting.
        (0,object/* addNonEnumerableProperty */.xp)(normalizedErrorData, '__sentry_skip_normalization__', true);
        contexts[exceptionName] = normalizedErrorData;
      }

      return {
        ...event,
        contexts,
      };
    }

    return event;
  }

  /**
   * Extract extra information from the Error object
   */
   _extractErrorData(error) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
      const nativeKeys = [
        'name',
        'message',
        'stack',
        'line',
        'column',
        'fileName',
        'lineNumber',
        'columnNumber',
        'toJSON',
      ];

      const extraErrorInfo = {};

      // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
      for (const key of Object.keys(error)) {
        if (nativeKeys.indexOf(key) !== -1) {
          continue;
        }
        const value = error[key];
        extraErrorInfo[key] = (0,is/* isError */.VZ)(value) ? value.toString() : value;
      }

      // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
      if (typeof error.toJSON === 'function') {
        const serializedError = error.toJSON() ;

        for (const key of Object.keys(serializedError)) {
          const value = serializedError[key];
          extraErrorInfo[key] = (0,is/* isError */.VZ)(value) ? value.toString() : value;
        }
      }

      return extraErrorInfo;
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.error */.kg.error('Unable to extract extra data from the Error object:', oO);
    }

    return null;
  }
} ExtraErrorData.__initStatic();


//# sourceMappingURL=extraerrordata.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/client/index.js + 36 modules
var client = __webpack_require__(59150);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js + 16 modules
var browsertracing = __webpack_require__(88025);
;// CONCATENATED MODULE: ./sentry.client.config.js
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "d33e8faf3536d1437e935e78809e25110c137f9d"
};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/



var NODE_ENV = "production";
var NEXT_ENV = "preview";
var SENTRY_DSN = "https://449dc37fe44b40b6b9f18e1b050d5278@o338527.ingest.sentry.io/4505364881997824";
if (!!SENTRY_DSN) {
    var integrations = [
        new CaptureConsole({
            levels: [
                "error"
            ]
        }),
        new ExtraErrorData({
            depth: 3
        }),
        new browsertracing/* BrowserTracing */.gE(), 
    ];
    client/* init */.S1({
        environment: NEXT_ENV || NODE_ENV,
        dsn: SENTRY_DSN,
        tracesSampleRate: 0,
        sampleRate: 1.0,
        integrations: integrations,
        // ...
        // Note: if you want to override the automatic release value, do not set a
        // `release` value here - use the environment variable `SENTRY_RELEASE`, so
        // that it will also get attached to your source maps
        ignoreErrors: [
            "Non-Error exception captured",
            "Non-Error promise rejection captured"
        ]
    });
}


/***/ }),

/***/ 71210:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 73916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SJ": function() { return /* binding */ AppTheme; },
  "bj": function() { return /* binding */ BORDER_RADIUS_MAXIMUS_ROUNDINUS; },
  "xQ": function() { return /* binding */ BREAKPPOINTS; },
  "lF": function() { return /* binding */ BUTTON_OUTLINE_BORDER_COLOR; },
  "J2": function() { return /* binding */ BUTTON_OUTLINE_PADDING; },
  "uT": function() { return /* binding */ FIRST_OF_SELECTOR_MIXIN; },
  "BE": function() { return /* binding */ LAST_OF_SELECTOR_MIXIN; },
  "zd": function() { return /* binding */ OPACITY_PULSE; },
  "fK": function() { return /* binding */ PULSE_ORB; },
  "_W": function() { return /* binding */ PULSE_RING; },
  "vP": function() { return /* binding */ RIPPLE; },
  "hP": function() { return /* binding */ SOFT_OUTLINED_TEXT_FIELD_MIXIN; },
  "nw": function() { return /* binding */ THEME_PALETTE_LOGO; },
  "h3": function() { return /* binding */ THEME_PALETTE_STATS; }
});

// UNUSED EXPORTS: MUI_BUTTON_LIKE, PRIORITIES_PALETTE, SOFT_OUTLINED_ROUND_TEXT_FIELD_MIXIN, THEME_PALETTE, THEME_SPACING, WAVE, WAVE_DELAY, base, createTheme, dark, default, light

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/cssUtils.js
var cssUtils = __webpack_require__(88606);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/responsiveFontSizes.js



function responsiveFontSizes(themeInput, options = {}) {
  const {
    breakpoints = ['sm', 'md', 'lg'],
    disableAlign = false,
    factor = 2,
    variants = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline']
  } = options;
  const theme = (0,esm_extends/* default */.Z)({}, themeInput);
  theme.typography = (0,esm_extends/* default */.Z)({}, theme.typography);
  const typography = theme.typography;

  // Convert between CSS lengths e.g. em->px or px->rem
  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
  const convert = (0,cssUtils/* convertLength */.vs)(typography.htmlFontSize);
  const breakpointValues = breakpoints.map(x => theme.breakpoints.values[x]);
  variants.forEach(variant => {
    const style = typography[variant];
    const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
    if (remFontSize <= 1) {
      return;
    }
    const maxFontSize = remFontSize;
    const minFontSize = 1 + (maxFontSize - 1) / factor;
    let {
      lineHeight
    } = style;
    if (!(0,cssUtils/* isUnitless */.dA)(lineHeight) && !disableAlign) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(6));
    }
    if (!(0,cssUtils/* isUnitless */.dA)(lineHeight)) {
      // make it unitless
      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
    }
    let transform = null;
    if (!disableAlign) {
      transform = value => (0,cssUtils/* alignProperty */.LV)({
        size: value,
        grid: (0,cssUtils/* fontGrid */.vY)({
          pixels: 4,
          lineHeight,
          htmlFontSize: typography.htmlFontSize
        })
      });
    }
    typography[variant] = (0,esm_extends/* default */.Z)({}, style, (0,cssUtils/* responsiveProperty */.ze)({
      cssProperty: 'fontSize',
      min: minFontSize,
      max: maxFontSize,
      unit: 'rem',
      breakpoints: breakpointValues,
      transform
    }));
  });
  return theme;
}
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./src/styles/theme.module.scss
var theme_module = __webpack_require__(38927);
var theme_module_default = /*#__PURE__*/__webpack_require__.n(theme_module);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
;// CONCATENATED MODULE: ./src/AppTheme.ts






function getFromScss(prefix, name, fallback) {
    var mutate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function(str) {
        return str;
    };
    var scssVal = (theme_module_default())["".concat(prefix, "__").concat(name)];
    return scssVal === undefined ? fallback : mutate(scssVal, name);
}
var getColorFromScss = function(name) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "#000";
    return getFromScss("colors", name, fallback);
};
var getBreakpointFromScss = function(name) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 960;
    return getFromScss("breakpoints", name, fallback, parseFloat);
};
var getDimsFromScss = function(name) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    return getFromScss("dims", name, fallback, parseFloat);
};
var getShapeFromScss = function(name) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    return getFromScss("shape", name, fallback, parseFloat);
};
var getTransitionsFromScss = function(name) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    return getFromScss("shape", name, fallback, function(value, name) {
        switch(name){
            case "duration":
                return parseFloat(value);
            default:
                return value;
        }
    });
};
var getFontWeightFromScss = function(name) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    return getFromScss("typography", name, fallback, parseFloat);
};
// please forward all questions to scott@reclaim.ai -SG
var BORDER_RADIUS_MAXIMUS_ROUNDINUS = 99999999999999;
var BUTTON_OUTLINE_BORDER_COLOR = "#dcddde";
var BUTTON_OUTLINE_PADDING = "11px 17px";
var THEME_SPACING = getDimsFromScss("spacing");
var WAVE_DELAY = {
    keyframes: {
        "@keyframes wave_delay_keyframes": {
            "0%": {
                transform: "translateY(0)"
            },
            "3%": {
                transform: "translateY(3px)"
            },
            "6%": {
                transform: "translateY(0)"
            },
            "100%": {
                transform: "translateY(0)"
            }
        }
    },
    elementStyles: {
        animation: "$wave_delay_keyframes 7s ease infinite"
    }
};
var WAVE = {
    keyframes: {
        "@keyframes wave_keyframes": {
            "0%": {
                transform: "translateY(0)"
            },
            "50%": {
                transform: "translateY(3px)"
            },
            "100%": {
                transform: "translateY(0)"
            }
        }
    },
    elementStyles: {
        animation: "$wave_keyframes .5s ease infinite"
    }
};
var OPACITY_PULSE = {
    keyframes: {
        "@keyframes opacity_pulse_keyframes": {
            from: {
                opacity: 0.5
            },
            to: {
                opacity: 0.15
            }
        }
    },
    elementStyles: {
        animation: "$opacity_pulse_keyframes 1s infinite alternate"
    }
};
var PULSE_RING = {
    keyframes: {
        "@keyframes pulse_ring_keyframes": {
            "0%": {
                transform: "scale(.25)"
            },
            "40%": {
                opacity: 0
            },
            "100%": {
                opacity: 0
            }
        }
    },
    elementStyles: {
        animation: "$pulse_ring_keyframes 1.75s cubic-bezier(0.215, 0.61, 0.355, 1) infinite"
    }
};
var PULSE_ORB = {
    keyframes: {
        "@keyframes pulse_orb_keyframes": {
            "0%": {
                transform: "scale(.9)",
                opacity: 0.15
            },
            "50%": {
                transform: "scale(1.2)",
                opacity: 1
            },
            "100%": {
                transform: "scale(.9)",
                opacity: 0.15
            }
        }
    },
    elementStyles: {
        animation: "$pulse_orb_keyframes 1.75s cubic-bezier(0.455, 0.03, 0.515, 0.955) -.4s infinite"
    }
};
var RIPPLE = {
    keyframes: {
        "@keyframes ripple_keyframes": {
            "0%": {
                transform: "scale(1)",
                opacity: 1
            },
            "100%": {
                transform: "scale(1000)",
                opacity: 0
            }
        }
    },
    elementStyles: {
        animation: "$ripple_keyframes .7s ease",
        borderRadius: "50%",
        height: 1,
        width: 1
    }
};
var BREAKPPOINTS = {
    xs: getBreakpointFromScss("xs"),
    sm: getBreakpointFromScss("sm"),
    md: getBreakpointFromScss("md"),
    lg: getBreakpointFromScss("lg"),
    xl: getBreakpointFromScss("xl")
};
var MUI_BUTTON_LIKE = function(theme) {
    return {
        fontSize: "1em",
        border: "1px solid ".concat(BUTTON_OUTLINE_BORDER_COLOR),
        height: "2em",
        display: "flex",
        alignItems: "center",
        padding: "0 1em",
        borderRadius: "1em",
        textAlign: "center",
        flex: "0 0 auto",
        boxSizing: "border-box",
        justifyContent: "center"
    };
};
// to be used with "outlined" variant
var SOFT_OUTLINED_TEXT_FIELD_MIXIN = function(theme) {
    return {
        "& .MuiInputBase-root": {
            border: theme.colors.borderGrey,
            borderRadius: theme.spacing(0.75),
            background: "white"
        }
    };
};
/**
 * Hacks in a `:last-of-selector` pseudo class
 * similar to `:last-of-type` but for any
 * selector instead of just element type.
 *
 * Works by applying `lastCSS` to all elements
 * matching `selector` then applying
 * `overrideCSS` to all but the last match.
 * @param selector The selector which should be searched for
 * @param lastCSS The CSS to be applied to the last match
 * @param overrideCSS The CSS to override `lastCSS` on all other matching elements
 * @returns `CSSProperties` which act as a `:last-of-selector`
 */ var LAST_OF_SELECTOR_MIXIN = function(selector, lastCSS, overrideCSS) {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& ".concat(selector), (0,src_object_spread/* default */.Z)({}, lastCSS)), // TODO: :has is not supported in FF yet, but I honestly
    // have no idea how else to isolate a last-of-selector
    // cleanly
    (0,_define_property/* default */.Z)(_obj, "& ".concat(selector, ":has(+ ").concat(selector, ")"), (0,src_object_spread/* default */.Z)({}, overrideCSS)), _obj;
};
/**
 * Hacks in a `:first-of-selector` pseudo class
 * similar to `:first-of-type` but for any
 * selector instead of just element type.
 * @param selector The selector which should be searched for
 * @param css The CSS to be applied to the first match
 * @returns `CSSProperties` which act as a `:first-of-selector`
 */ var FIRST_OF_SELECTOR_MIXIN = function(selector, css) {
    return (0,_define_property/* default */.Z)({}, "& :not(".concat(selector, ") + ").concat(selector), (0,src_object_spread/* default */.Z)({}, css));
};
// to be used with "outlined" variant
var SOFT_OUTLINED_ROUND_TEXT_FIELD_MIXIN = function(theme) {
    var base = SOFT_OUTLINED_TEXT_FIELD_MIXIN(theme);
    return _object_spread_props(_object_spread({}, base), {
        "& .MuiInputBase-root": _object_spread_props(_object_spread({}, base["& .MuiInputBase-root"]), {
            borderRadius: theme.spacing(2.5)
        })
    });
};
// console.log("=>", SCSSTheme, undefined);
/* Logo */ var THEME_PALETTE_LOGO = {
    yeti: "rgb(234, 237, 240)",
    darkness: getColorFromScss("darkness"),
    darkness100: getColorFromScss("darkness100"),
    shrimp: getColorFromScss("shrimp"),
    blurple: getColorFromScss("blurple"),
    blurple400: "rgb(82, 99, 243, .40)",
    corn: "rgb(255, 197, 80)",
    corn200: "rgba(255, 197, 80, .20)"
};
/* Palette */ var THEME_PALETTE = {
    primary: getColorFromScss("primary"),
    secondary: getColorFromScss("secondary"),
    dialog: "#2F2E41",
    red: "rgb(217, 3, 3)",
    orange: "rgb(241, 143, 1)",
    yellow: "rgb(241, 211, 1)",
    green: "rgb(153, 194, 77)",
    blue: "#5562eb",
    grey: "rgb(159, 162, 163)",
    textGrey: "#757575",
    softGrey: getColorFromScss("softGrey"),
    borderGrey: getColorFromScss("borderGrey"),
    bgGrey: "#EBECF0",
    white: "rgb(251, 252, 254)",
    black: getColorFromScss("black"),
    logo: THEME_PALETTE_LOGO,
    linkedin: "#0072B1",
    twitter: "#1DA1F2",
    warning: {
        light: getColorFromScss("warningLight"),
        main: getColorFromScss("warningMain"),
        dark: getColorFromScss("warningDark")
    },
    error: {
        light: getColorFromScss("errorLight"),
        main: getColorFromScss("errorMain"),
        dark: getColorFromScss("errorDark")
    }
};
/* Stats */ var THEME_PALETTE_STATS = {
    midnight: getColorFromScss("statsMidnight"),
    blurple: getColorFromScss("statsBlurple"),
    cornflower: getColorFromScss("statsCornflower"),
    cheese: getColorFromScss("statsCheese"),
    corn: getColorFromScss("statsCorn"),
    butter: getColorFromScss("statsButter"),
    pink: getColorFromScss("statsPink"),
    shrimp: getColorFromScss("statsShrimp"),
    salmon: getColorFromScss("statsSalmon"),
    grey: getColorFromScss("statsGrey")
};
// FIXME (IW): This has moved to user-configurable settings, reconcile all uses and delete
var PRIORITIES_PALETTE = {
    0: {
        main: "#FC9496",
        light: (0,colorManipulator/* lighten */.$n)("#FC9496", 0.5),
        dark: (0,colorManipulator/* darken */._j)("#FC9496", 0.15),
        contrastText: THEME_PALETTE.black
    },
    1: {
        main: "#FCE1A1",
        light: (0,colorManipulator/* lighten */.$n)("#FCE1A1", 0.5),
        dark: (0,colorManipulator/* darken */._j)("#FCE1A1", 0.15),
        contrastText: THEME_PALETTE.black
    },
    2: {
        main: "#8DDFAB",
        light: (0,colorManipulator/* lighten */.$n)("#8DDFAB", 0.5),
        dark: (0,colorManipulator/* darken */._j)("#8DDFAB", 0.15),
        contrastText: THEME_PALETTE.black
    },
    3: {
        main: "#6DBCFE",
        light: (0,colorManipulator/* lighten */.$n)("#6DBCFE", 0.5),
        dark: (0,colorManipulator/* darken */._j)("#6DBCFE", 0.15),
        contrastText: THEME_PALETTE.black
    },
    4: {
        main: "#BD82CC",
        light: (0,colorManipulator/* lighten */.$n)("#BD82CC", 0.5),
        dark: (0,colorManipulator/* darken */._j)("#BD82CC", 0.15),
        contrastText: THEME_PALETTE.black
    },
    other: {
        main: "#9AA0A8",
        light: (0,colorManipulator/* lighten */.$n)("#9AA0A8", 0.5),
        dark: (0,colorManipulator/* darken */._j)("#9AA0A8", 0.15),
        contrastText: THEME_PALETTE.black
    },
    default: {
        main: "#bdbdbd",
        light: "#f5f5f5",
        dark: "#212121",
        contrastText: THEME_PALETTE.black
    }
};
var shadows = [
    [
        [
            0,
            1,
            3,
            0
        ],
        [
            0,
            1,
            1,
            0
        ],
        [
            0,
            2,
            1,
            -1
        ], 
    ],
    [
        [
            0,
            1,
            5,
            0
        ],
        [
            0,
            2,
            2,
            0
        ],
        [
            0,
            3,
            1,
            -2
        ], 
    ],
    [
        [
            0,
            1,
            8,
            0
        ],
        [
            0,
            3,
            4,
            0
        ],
        [
            0,
            3,
            3,
            -2
        ], 
    ],
    [
        [
            0,
            2,
            4,
            -1
        ],
        [
            0,
            4,
            5,
            0
        ],
        [
            0,
            1,
            10,
            0
        ], 
    ],
    [
        [
            0,
            3,
            5,
            -1
        ],
        [
            0,
            5,
            8,
            0
        ],
        [
            0,
            1,
            14,
            0
        ], 
    ],
    [
        [
            0,
            3,
            5,
            -1
        ],
        [
            0,
            6,
            10,
            0
        ],
        [
            0,
            1,
            18,
            0
        ], 
    ],
    [
        [
            0,
            4,
            5,
            -2
        ],
        [
            0,
            7,
            10,
            1
        ],
        [
            0,
            2,
            16,
            1
        ], 
    ],
    [
        [
            0,
            5,
            5,
            -3
        ],
        [
            0,
            8,
            10,
            1
        ],
        [
            0,
            3,
            14,
            2
        ], 
    ],
    [
        [
            0,
            5,
            6,
            -3
        ],
        [
            0,
            9,
            12,
            1
        ],
        [
            0,
            3,
            16,
            2
        ], 
    ],
    [
        [
            0,
            4,
            16,
            -3
        ]
    ],
    [
        [
            0,
            6,
            7,
            -4
        ],
        [
            0,
            11,
            15,
            1
        ],
        [
            0,
            4,
            20,
            3
        ], 
    ],
    [
        [
            0,
            7,
            8,
            -4
        ],
        [
            0,
            12,
            17,
            2
        ],
        [
            0,
            5,
            22,
            4
        ], 
    ],
    [
        [
            0,
            7,
            8,
            -4
        ],
        [
            0,
            13,
            19,
            2
        ],
        [
            0,
            5,
            24,
            4
        ], 
    ],
    [
        [
            0,
            7,
            9,
            -4
        ],
        [
            0,
            14,
            21,
            2
        ],
        [
            0,
            5,
            26,
            4
        ], 
    ],
    [
        [
            0,
            8,
            9,
            -5
        ],
        [
            0,
            15,
            22,
            2
        ],
        [
            0,
            6,
            28,
            5
        ], 
    ],
    [
        [
            0,
            8,
            10,
            -5
        ],
        [
            0,
            16,
            24,
            2
        ],
        [
            0,
            6,
            30,
            5
        ], 
    ],
    [
        [
            0,
            8,
            11,
            -5
        ],
        [
            0,
            17,
            26,
            2
        ],
        [
            0,
            6,
            32,
            5
        ], 
    ],
    [
        [
            0,
            9,
            11,
            -5
        ],
        [
            0,
            18,
            28,
            2
        ],
        [
            0,
            7,
            34,
            6
        ], 
    ],
    [
        [
            0,
            9,
            12,
            -6
        ],
        [
            0,
            19,
            29,
            2
        ],
        [
            0,
            7,
            36,
            6
        ], 
    ],
    [
        [
            0,
            10,
            13,
            -6
        ],
        [
            0,
            20,
            31,
            3
        ],
        [
            0,
            8,
            38,
            7
        ], 
    ],
    [
        [
            0,
            10,
            13,
            -6
        ],
        [
            0,
            21,
            33,
            3
        ],
        [
            0,
            8,
            40,
            7
        ], 
    ],
    [
        [
            0,
            10,
            14,
            -6
        ],
        [
            0,
            22,
            35,
            3
        ],
        [
            0,
            8,
            42,
            7
        ], 
    ],
    [
        [
            0,
            11,
            14,
            -7
        ],
        [
            0,
            23,
            36,
            3
        ],
        [
            0,
            9,
            44,
            8
        ], 
    ],
    [
        [
            0,
            11,
            15,
            -7
        ],
        [
            0,
            24,
            38,
            3
        ],
        [
            0,
            9,
            46,
            8
        ], 
    ], 
];
var shadowKeyUmbraOpacity = 0.06;
var shadowKeyPenumbraOpacity = 0.03;
var shadowAmbientShadowOpacity = 0.05;
var shadowpacities = [
    shadowKeyUmbraOpacity,
    shadowKeyPenumbraOpacity,
    shadowAmbientShadowOpacity
];
function createShadow(color, args) {
    var data = Array.isArray(args) ? args : shadows[args];
    return data.map(function(part, i) {
        return "".concat(part[0], "px ").concat(part[1], "px ").concat(part[2], "px ").concat(part[3], "px ").concat((0,colorManipulator/* alpha */.Fq)(color, shadowpacities[i]));
    }).join(",");
}
var _obj;
var base = {
    transitions: {
        // typing is incorrect, this should be a string
        easing: getTransitionsFromScss("easing"),
        duration: {
            standard: getTransitionsFromScss("duration")
        }
    },
    breakpoints: {
        values: BREAKPPOINTS
    },
    colors: THEME_PALETTE,
    spacing: THEME_SPACING,
    shape: {
        borderRadius: getShapeFromScss("borderRadius")
    },
    components: {
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    borderRadius: "1em"
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontSize: "0.875rem",
                    lineHeight: 1.43,
                    letterSpacing: "0.01071em"
                }
            }
        },
        MuiListItemSecondaryAction: {
            styleOverrides: {
                root: {
                    right: 16
                }
            }
        },
        MuiPopper: {
            defaultProps: {
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            enabled: false
                        }
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            enabled: true
                        }
                    }, 
                ]
            }
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 12
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    borderBottomColor: THEME_PALETTE_LOGO.darkness100,
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1px",
                    maxWidth: "100vw"
                },
                indicator: {
                    borderRadius: "4px 4px 0 0",
                    height: "4px"
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    minHeight: "1.3334em",
                    "&:hover": {
                        backgroundColor: "rgba(46, 51, 59, 0.04)"
                    }
                },
                outlined: {},
                standard: {
                    borderRadius: 40,
                    paddingLeft: 14,
                    "&:focus": {
                        borderRadius: 40
                    }
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: (_obj = {
                    color: (0,colorManipulator/* lighten */.$n)(THEME_PALETTE.black, 0.1),
                    fontSize: "1.06em",
                    textTransform: "none",
                    marginBottom: "8px",
                    padding: "0px 24px",
                    backgroundColor: "transparent",
                    borderRadius: 8
                }, (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat(BREAKPPOINTS["sm"], "px)"), {
                    minWidth: 0
                }), (0,_define_property/* default */.Z)(_obj, "maxWidth", "none"), (0,_define_property/* default */.Z)(_obj, "transition", "background-color .2s ease-in"), (0,_define_property/* default */.Z)(_obj, "&:hover", {
                    backgroundColor: (0,colorManipulator/* lighten */.$n)(THEME_PALETTE_LOGO.darkness100, 0.5)
                }), (0,_define_property/* default */.Z)(_obj, "&.Mui-selected", {
                    fontWeight: 600,
                    color: THEME_PALETTE_LOGO.darkness
                }), _obj),
                textColorInherit: {
                    opacity: 1
                }
            }
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: "rgba(0, 0, 0, 0.1)"
                },
                bar: {
                    borderRadius: 4
                },
                colorPrimary: {
                    backgroundColor: "rgba(0, 0, 0, 0.1)"
                },
                colorSecondary: {
                    backgroundColor: "rgba(0, 0, 0, 0.1)"
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                adornedStart: {
                    paddingLeft: 12
                },
                adornedEnd: {
                    paddingRight: 12
                },
                input: {
                    height: "auto",
                    lineHeight: 1.3334
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    padding: 0
                },
                input: {
                    padding: 14
                },
                inputSizeSmall: {
                    padding: "9px 14px"
                },
                notchedOutline: {
                    borderColor: "rgba(0,0,0,.15)"
                },
                adornedStart: {
                    paddingLeft: 12
                },
                adornedEnd: {
                    paddingRight: 12
                }
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    background: "transparent",
                    border: "1px solid rgba(0,0,0,.15)",
                    borderRadius: 4,
                    padding: 0,
                    "&:not(.Mui-disabled, .Mui-error):before, &:hover:not(.Mui-disabled, .Mui-error):before, &:not(.Mui-disabled, .Mui-error):after": {
                        borderBottom: 0
                    },
                    "&:hover": {
                        backgroundColor: "rgba(46, 51, 59, 0.04)",
                        borderColor: "black"
                    },
                    "&.Mui-focused": {
                        backgroundColor: "transparent",
                        borderColor: THEME_PALETTE.primary,
                        boxShadow: "0 0 0 1px ".concat(THEME_PALETTE.primary)
                    }
                },
                input: {
                    padding: "24px 12px 8px"
                },
                inputSizeSmall: {
                    padding: "20px 12px 4px"
                }
            }
        },
        MuiButtonGroup: {
            styleOverrides: {
                root: {
                    borderRadius: "40px"
                },
                groupedHorizontal: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "40px",
                    lineHeight: 1.2,
                    textTransform: "none",
                    "&$disabled": {
                        "&:hover": {
                            border: "1px solid rgba(0,0,0,0.12)",
                            textDecoration: "none"
                        }
                    }
                },
                text: {
                    textTransform: "none"
                },
                contained: {
                    padding: "12px 18px"
                },
                containedSizeSmall: {
                    padding: "8px 14px"
                },
                containedSizeLarge: {
                    padding: "16px 24px"
                },
                outlined: {
                    borderColor: BUTTON_OUTLINE_BORDER_COLOR,
                    padding: BUTTON_OUTLINE_PADDING
                },
                outlinedSizeSmall: {
                    padding: "7px 13px"
                },
                outlinedSizeLarge: {
                    padding: "15px 23px"
                },
                endIcon: {
                    marginLeft: 4
                },
                startIcon: {
                    marginLeft: 0,
                    marginRight: 4
                },
                iconSizeMedium: {
                    "&> *:first-of-type": {
                        fontSize: 16
                    }
                },
                iconSizeLarge: {
                    "&> *:first-of-type": {
                        fontSize: 18
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                label: {
                    fontSize: 12,
                    fontWeight: 500
                }
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    cursor: "pointer",
                    fontWeight: 500
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    "&$disabled": {
                        opacity: 0.5
                    }
                },
                sizeSmall: {
                    padding: 3,
                    "& svg": {
                        width: 16,
                        height: 16
                    }
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    "&$focused": {
                        color: "inherit"
                    }
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: {
                    padding: 4.5
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    lineHeight: "normal"
                },
                contained: {
                    marginLeft: "0.25em",
                    marginRight: "0.25em"
                }
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    backgroundColor: (0,colorManipulator/* alpha */.Fq)("#fff", 0.25)
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                stickyHeader: {
                    backgroundColor: "#DFE0EB"
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    alignItems: "center"
                },
                standardWarning: {
                    backgroundColor: THEME_PALETTE.warning.light
                },
                filledError: {
                    backgroundColor: "#c43c3c"
                }
            }
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: {
                    lineHeight: 1.2
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: (0,colorManipulator/* alpha */.Fq)(THEME_PALETTE.black, 0.95),
                    fontSize: "0.8125rem",
                    maxWidth: 250,
                    "& .MuiLink-root": {
                        color: (0,colorManipulator/* lighten */.$n)(THEME_PALETTE.primary, 0.25),
                        "&:hover": {
                            color: (0,colorManipulator/* lighten */.$n)(THEME_PALETTE.primary, 0.45)
                        }
                    },
                    "& .MuiTypography-caption": {
                        fontWeight: 400,
                        lineHeight: 1.4
                    }
                },
                arrow: {
                    color: (0,colorManipulator/* alpha */.Fq)(THEME_PALETTE.black, 0.95)
                }
            }
        },
        MuiBadge: {
            defaultProps: {
                overlap: "rectangular"
            },
            styleOverrides: {
                badge: {
                    borderRadius: 4
                },
                colorSecondary: {
                    color: THEME_PALETTE.black
                }
            }
        },
        MuiTouchRipple: {},
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    "& .MuiListItemIcon-root": {
                        minWidth: 16
                    }
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    "&&&": {
                        marginTop: 0,
                        marginBottom: 0
                    }
                }
            }
        }
    },
    palette: {
        primary: {
            main: THEME_PALETTE.primary,
            contrastText: THEME_PALETTE.white
        },
        secondary: {
            main: THEME_PALETTE.secondary,
            contrastText: THEME_PALETTE.white
        },
        error: {
            main: THEME_PALETTE.red,
            contrastText: THEME_PALETTE.white
        },
        common: {
            white: THEME_PALETTE.white,
            black: THEME_PALETTE.black
        },
        info: {
            main: THEME_PALETTE.primary
        },
        warning: {
            main: THEME_PALETTE.warning.main,
            dark: THEME_PALETTE.warning.dark,
            light: THEME_PALETTE.warning.light
        }
    },
    typography: {
        fontWeightRegular: getFontWeightFromScss("fontWeightRegular"),
        fontWeightMedium: getFontWeightFromScss("fontWeightMedium"),
        fontWeightBold: getFontWeightFromScss("fontWeightBold"),
        fontFamily: [
            "Poppins",
            "-apple-system",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"', 
        ].join(","),
        body1: {
            fontSize: "0.9375rem"
        },
        body2: {
            fontSize: "0.8125rem",
            lineHeight: 1.5
        },
        subtitle1: {
            fontSize: "1.125rem",
            lineHeight: 1.4
        },
        subtitle2: {
            fontSize: "1.0625rem",
            lineHeight: 1.4
        },
        h1: {
            fontSize: "1.8125rem",
            fontWeight: 600,
            letterSpacing: "-.03em"
        },
        h2: {
            fontSize: "1.8125rem",
            fontWeight: 600,
            letterSpacing: "-.02em"
        },
        h3: {
            fontSize: "1.5625rem",
            fontWeight: 600,
            letterSpacing: "-.02em"
        },
        h4: {
            fontSize: "1.35rem",
            fontWeight: 600,
            letterSpacing: "-.02em",
            "@media (min-width:1280px)": {
                fontSize: "1.35rem"
            }
        },
        h5: {
            fontSize: "1.125rem",
            fontWeight: 600,
            letterSpacing: "-.02em"
        },
        h6: {
            fontSize: "0.9375rem",
            fontWeight: 600,
            letterSpacing: "-.02em",
            lineHeight: 1.4
        }
    },
    shadows: [
        "none"
    ].concat(shadows.map(function(data) {
        return createShadow(THEME_PALETTE.black, data);
    })),
    priorities: PRIORITIES_PALETTE,
    util: {
        createShadow: createShadow,
        shadowData: shadows
    }
};
var light = {
    palette: {
        mode: "light",
        text: {
            primary: (0,colorManipulator/* lighten */.$n)(THEME_PALETTE.black, 0.1),
            secondary: (0,colorManipulator/* lighten */.$n)(THEME_PALETTE.black, 0.4),
            disabled: "rgba(0, 0, 0, 0.35)"
        },
        divider: "rgba(0, 0, 0, 0.075)",
        background: {
            default: "#F7F8FC",
            paper: "#edf1f7"
        }
    }
};
var dark = {
    palette: {
        mode: "dark",
        text: {
            primary: (0,colorManipulator/* darken */._j)(THEME_PALETTE.white, 0.1),
            secondary: THEME_PALETTE.secondary,
            disabled: "rgba(0, 0, 0, 0.35)"
        },
        divider: "rgba(0, 0, 0, 0.075)",
        background: {
            default: THEME_PALETTE.black,
            paper: "#e4e4ea"
        },
        common: {
            white: THEME_PALETTE.black,
            black: THEME_PALETTE.white
        }
    }
};
var AppTheme_createTheme = function(options) {
    return responsiveFontSizes( false ? 0 : (0,createTheme/* default */.Z)((0,objects/* deepmerge */.vb)({}, base, options)));
};
var AppTheme = {
    Dark: AppTheme_createTheme(dark),
    Light: AppTheme_createTheme(light)
};
/* harmony default export */ var src_AppTheme = ((/* unused pure expression or super */ null && (AppTheme)));


/***/ }),

/***/ 70550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vi": function() { return /* binding */ ENV; },
/* harmony export */   "cp": function() { return /* binding */ Analytics; },
/* harmony export */   "sk": function() { return /* binding */ BUILD_ID; }
/* harmony export */ });
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58946);
/// <reference types="@sentry/types" />

var BUILD_ID =  false || "d33e8faf3536d1437e935e78809e25110c137f9d" || 0 || 0;
var ENV = "preview" || 0;
var SENTRY_DSN = "https://449dc37fe44b40b6b9f18e1b050d5278@o338527.ingest.sentry.io/4505364881997824";
var ready = {
    sentry: undefined
};
function initSentry() {
    if (undefined !== ready.sentry) return ready.sentry;
    if (!!SENTRY_DSN) {
        ready.sentry = false;
        console.debug("Initializing Sentry");
        // initialized automatically w/ configs in `src/sentry.*.js`
        ready.sentry = !!_sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__;
    }
    return true;
}
var Analytics = {
    ready: ready,
    /** Node and browser */ get sentry () {
        if (!ready.sentry) initSentry();
        return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__;
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Analytics)));


/***/ }),

/***/ 78086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ButtonWithLinkVariant; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11057);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34557);





var ButtonWithLinkVariant = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var variant = _param.variant, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "children"
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(variant === "link" ? _Link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r : _mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        variant: variant === "link" ? undefined : variant,
        ref: ref
    }, rest), children);
});


/***/ }),

/***/ 90047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CappedTextArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50135);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47310);









var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            display: "flex",
            flexDirection: "column"
        },
        textField: {
            flex: "1 1 auto",
            alignItems: "stretch",
            justifyContent: "stretch"
        },
        input: {
            flex: "1 1 auto",
            alignItems: "stretch"
        },
        count: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.typography.body2), {
            flex: "0 0 auto",
            color: theme.colors.textGrey,
            textAlign: "right",
            paddingTop: theme.spacing(0.5)
        }),
        countWarn: {
            color: theme.colors.warning.main
        },
        countError: {
            color: theme.colors.error.main
        }
    };
}, {
    classNamePrefix: "CappedTextArea"
});
var CappedTextArea = function(_param) {
    var className = _param.className, extClasses = _param.classes, style = _param.style, TextFieldProps = _param.TextFieldProps, _value = _param.value, value = _value === void 0 ? "" : _value, onChange = _param.onChange, maxLength = _param.maxLength, singleLine = _param.singleLine, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "style",
        "TextFieldProps",
        "value",
        "onChange",
        "maxLength",
        "singleLine"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ var handleChange = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackSafeRef */ .T)(function(e) {
        if (e.target.value.length <= maxLength) onChange(e.target.value);
    });
    var _obj;
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(classes.root, className),
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                variant: "standard",
                className: classes.textField,
                classes: TextFieldProps,
                multiline: !singleLine,
                onChange: handleChange,
                InputProps: {
                    className: classes.input
                },
                value: value
            }, rest)),
            !!value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(classes.count, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.countWarn, value.length > 0.75 * maxLength && value.length < maxLength), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.countError, value.length === maxLength), _obj)),
                children: [
                    value.length,
                    "/",
                    maxLength
                ]
            })
        ]
    });
};


/***/ }),

/***/ 23150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ CircularProgressWithBackground; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98456);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _CircularProgressWithBackground_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58077);
/* harmony import */ var _CircularProgressWithBackground_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_CircularProgressWithBackground_module_scss__WEBPACK_IMPORTED_MODULE_2__);





var CircularProgressWithBackground = function(param) {
    var className = param.className, extClasses = param.classes, fraction = param.fraction, _size = param.size, size = _size === void 0 ? 75 : _size, _thickness = param.thickness, thickness = _thickness === void 0 ? size / 15 : _thickness, children = param.children, _color = param.color, color = _color === void 0 ? "primary" : _color;
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__/* .mergeClassNames */ .E)((_CircularProgressWithBackground_module_scss__WEBPACK_IMPORTED_MODULE_2___default()), extClasses || {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: classes.foreground,
                thickness: thickness,
                size: size,
                variant: "determinate",
                value: fraction * 100,
                color: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: classes.background,
                thickness: thickness,
                size: size,
                variant: "determinate",
                value: 100,
                color: color
            }),
            children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: classes.children,
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 64218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ConfirmDialog; },
/* harmony export */   "W": function() { return /* binding */ useConfirmDialog; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11057);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50657);
/* harmony import */ var _mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31425);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6514);
/* harmony import */ var _mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(58951);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37645);
/* harmony import */ var _mui_styles_createStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73327);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var mui_modal_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56566);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);
/* harmony import */ var _forms_AsyncButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5062);



















var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_mui_styles_createStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        root: {},
        green: {
            color: "#8DDFAB"
        },
        red: {
            color: "#FF9797"
        },
        dialogPaper: {
            borderRadius: theme.shape.borderRadius * 2,
            padding: theme.spacing(2, 1, 3),
            color: theme.palette.getContrastText(theme.colors.dialog),
            backgroundColor: theme.colors.dialog
        },
        dialogContent: {
            color: theme.palette.getContrastText(theme.colors.dialog),
            paddingTop: 0,
            "&:first-child": {
                paddingTop: theme.spacing(1.5)
            }
        },
        dialogTitle: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, theme.typography.h3), {
            color: theme.palette.getContrastText(theme.colors.dialog)
        }),
        dialogText: {
            color: theme.palette.getContrastText(theme.colors.dialog)
        },
        whiteBtn: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            color: theme.palette.common.white,
            width: "100%"
        }, theme.breakpoints.up("sm"), {
            width: "auto"
        }),
        confirmDisabled: {
            "&.Mui-disabled": {
                color: theme.palette.common.white,
                borderColor: theme.palette.common.white,
                opacity: 0.25
            }
        },
        primaryBtn: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            width: "100%"
        }, theme.breakpoints.up("sm"), {
            minWidth: 120,
            width: "auto"
        })
    });
}, {
    classNamePrefix: "ConfirmDialog"
});
var ConfirmDialog = function(param) {
    var className = param.className, title = param.title, message = param.message, form = param.form, _confirmLabel = param.confirmLabel, confirmLabel = _confirmLabel === void 0 ? "Confirm" : _confirmLabel, _declineLabel = param.declineLabel, declineLabel = _declineLabel === void 0 ? "Cancel" : _declineLabel, _open = param.open, open = _open === void 0 ? false : _open, confirmDisabled = param.confirmDisabled, DialogProps = param.DialogProps, onConfirm = param.onConfirm, onCancel = param.onCancel, onClose = param.onClose, onSuccess = param.onSuccess, onError = param.onError;
    var classes = useStyles();
    var handleClose = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function(e) {
        return onClose === null || onClose === void 0 ? void 0 : onClose(!!e ? e : undefined);
    });
    var handleCancel = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function(e) {
        return onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
    });
    var handleConfirm = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(e) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onConfirm(e)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }());
    var handleSuccess = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function(e, value) {
        return onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(e, value);
    });
    var handleError = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function(e, error) {
        return onError === null || onError === void 0 ? void 0 : onError(e, error);
    });
    message = typeof message === "function" ? message(handleClose) : message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        fullWidth: true,
        maxWidth: "xs",
        classes: {
            paper: classes.dialogPaper
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(className, classes.root),
        open: open,
        onClose: handleClose,
        "aria-labelledby": "confirm-dialog-title",
        "aria-describedby": "confirm-dialog-description"
    }, DialogProps), {
        children: [
            !!title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                id: "confirm-dialog-title",
                classes: {
                    root: classes.dialogTitle
                },
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                classes: {
                    root: classes.dialogContent
                },
                children: !!message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    id: "confirm-dialog-description",
                    component: "div",
                    className: classes.dialogText,
                    children: message
                })
            }),
            !!form && form,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        className: classes.primaryBtn,
                        variant: "contained",
                        color: "primary",
                        autoFocus: true,
                        onClick: handleCancel,
                        children: declineLabel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_forms_AsyncButton__WEBPACK_IMPORTED_MODULE_3__/* .AsyncButton */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(classes.whiteBtn, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, classes.confirmDisabled, !!confirmDisabled)),
                        variant: "outlined",
                        color: "inherit",
                        disabled: !!confirmDisabled,
                        onClick: handleConfirm,
                        onSuccess: handleSuccess,
                        onError: handleError,
                        children: confirmLabel
                    })
                ]
            })
        ]
    }));
};
var useConfirmDialog = function() {
    var baseProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var showModal = (0,mui_modal_provider__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)({
        disableAutoDestroy: true
    }).showModal;
    return (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function(props) {
        var _ref = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, baseProps, props), onClose = _ref.onClose, onCancel = _ref.onCancel, onConfirm = _ref.onConfirm, combinedProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_ref, [
            "onClose",
            "onCancel",
            "onConfirm"
        ]);
        var ref = showModal(ConfirmDialog, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            onClose: function(e) {
                onClose === null || onClose === void 0 ? void 0 : onClose(e);
                hide();
                destroy();
            },
            onCancel: function(e) {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
                hide();
                destroy();
            },
            onConfirm: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(e) {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(e)
                                ];
                            case 1:
                                _state.sent();
                                hide();
                                destroy();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(e) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, combinedProps)), hide = ref.hide, destroy = ref.destroy;
    });
};


/***/ }),

/***/ 8137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ ContactSupportButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useIntercom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10428);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);
/* harmony import */ var _ButtonWithLinkVariant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78086);









var ContactSupportButton = function(_param) {
    var children = _param.children, onClick = _param.onClick, lead = _param.lead, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "onClick",
        "lead"
    ]);
    /********************/ /*   custom hooks   */ /********************/ var showIntercom = (0,_hooks_useIntercom__WEBPACK_IMPORTED_MODULE_1__/* .useIntercom */ .o)(lead).showIntercom;
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ var handleClick = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
                showIntercom();
                return [
                    2
                ];
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }());
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ButtonWithLinkVariant__WEBPACK_IMPORTED_MODULE_3__/* .ButtonWithLinkVariant */ .s, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        variant: "link",
        size: "small"
    }, rest), {
        onClick: handleClick,
        children: children || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: "Contact\xa0us"
        })
    }));
};


/***/ }),

/***/ 52126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useEasyConfirmDialog; },
/* harmony export */   "c": function() { return /* binding */ EasyConfirmDialog; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13665);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ConfirmDialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64218);









var propsAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)(undefined);
var propsWriteAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_3__/* .atom */ .cn)(null, function(get, set, newProps) {
    return set(propsAtom, newProps);
});
var EasyConfirmDialog = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_3__/* .useAtom */ .KO)(propsAtom), 1), props = ref[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref1[0], setOpen = ref1[1];
    var onClose = props === null || props === void 0 ? void 0 : props.onClose;
    var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        onClose
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props) setOpen(true);
    }, [
        props
    ]);
    return props ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ConfirmDialog__WEBPACK_IMPORTED_MODULE_2__/* .ConfirmDialog */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        open: open
    }, props), {
        onClose: handleClose,
        onCancel: handleClose,
        onSuccess: handleClose
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
var useEasyConfirmDialog = function(baseProps) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_3__/* .useAtom */ .KO)(propsWriteAtom), 2), setProps = ref[1];
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(props) {
        return new Promise(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(res) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                setProps((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, baseProps, props), {
                                    onClose: function() {
                                        var ref;
                                        (ref = props.onClose || baseProps.onClose) === null || ref === void 0 ? void 0 : ref();
                                        res();
                                    }
                                }))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        baseProps,
        setProps
    ]);
};


/***/ }),

/***/ 33806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ EasyLogWorkDialog; },
  "y": function() { return /* binding */ useEasyLogWorkDialog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(13665);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(50657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CloseRounded.js
var CloseRounded = __webpack_require__(36191);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/utils/scss.utils.ts
var scss_utils = __webpack_require__(91740);
// EXTERNAL MODULE: ./node_modules/chrono-node/dist/esm/index.js + 45 modules
var dist_esm = __webpack_require__(15880);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/hooks/useDateTimeFormatter.ts + 2 modules
var useDateTimeFormatter = __webpack_require__(62495);
// EXTERNAL MODULE: ./src/hooks/useMicroShortcuts.ts
var useMicroShortcuts = __webpack_require__(86830);
// EXTERNAL MODULE: ./src/utils/dates.ts + 3 modules
var dates = __webpack_require__(26958);
// EXTERNAL MODULE: ./src/utils/time.ts
var time = __webpack_require__(36832);
// EXTERNAL MODULE: ./src/components/CircularProgressWithBackground.tsx
var CircularProgressWithBackground = __webpack_require__(23150);
// EXTERNAL MODULE: ./src/components/forms/AsyncButton.tsx
var AsyncButton = __webpack_require__(5062);
// EXTERNAL MODULE: ./src/components/forms/LogWorkForm.module.scss
var LogWorkForm_module = __webpack_require__(71822);
var LogWorkForm_module_default = /*#__PURE__*/__webpack_require__.n(LogWorkForm_module);
// EXTERNAL MODULE: ./src/components/forms/rhf/DateControl.tsx + 2 modules
var DateControl = __webpack_require__(30869);
// EXTERNAL MODULE: ./src/components/forms/rhf/DurationControl.tsx
var DurationControl = __webpack_require__(68983);
// EXTERNAL MODULE: ./src/components/forms/rhf/RhfForm.tsx + 1 modules
var RhfForm = __webpack_require__(28681);
// EXTERNAL MODULE: ./src/components/forms/rhf/RhfRadioBox.tsx
var RhfRadioBox = __webpack_require__(28240);
// EXTERNAL MODULE: ./src/components/forms/rhf/RhfRadioBoxGroupControl.tsx
var RhfRadioBoxGroupControl = __webpack_require__(73576);
// EXTERNAL MODULE: ./src/components/forms/rhf/TimeControl.tsx
var TimeControl = __webpack_require__(5508);
;// CONCATENATED MODULE: ./src/components/forms/LogWorkForm.tsx
























var fieldToggleKeys = {
    duration: "duration",
    startEnd: "startEnd"
};
var defaultValues = function() {
    return {
        endTime: new Date(),
        duration: 60
    };
};
var dataToFormValues = function(param, format) {
    var endTime = param.endTime, duration = param.duration;
    var lastInterval = (0,dates/* getLatestMinuteInterval */.vD)(endTime, 15);
    return {
        duration: "1hr",
        date: (0,dates/* isDateToday */.Y3)(lastInterval) ? "" : (0,DateControl/* getDateControlDisplayDate */.z)(lastInterval, format, undefined, true),
        start: format(new Date(lastInterval.getTime() - duration * 60000), "TIME_DISPLAY_FORMAT"),
        end: format(lastInterval, "TIME_DISPLAY_FORMAT"),
        fieldToggle: "duration"
    };
};
var formValuesToData = function(values) {
    var endTime = values.date === "" ? (0,dist_esm/* parseDate */.sG)("today") : (0,dist_esm/* parseDate */.sG)(values.date);
    var start = (0,time/* parseTime */.T)(values.start);
    var end = (0,time/* parseTime */.T)(values.end);
    var duration = values.fieldToggle === "startEnd" ? (end.getTime() - start.getTime()) / 1000 / 60 : (0,DurationControl/* durationControlParseDuration */.Us)(values.duration) || 0;
    // Set the date to the configured end time.
    endTime.setHours(end.getHours(), end.getMinutes(), 0, 0);
    return {
        endTime: endTime,
        duration: duration
    };
};
var LogWorkForm = function(param) {
    var className = param.className, extClasses = param.classes, value = param.value, _submitLabel = param.submitLabel, submitLabel = _submitLabel === void 0 ? "Log work" : _submitLabel, onCancel = param.onCancel, onSubmit = param.onSubmit, secondsDone = param.secondsDone, secondsTotal = param.secondsTotal;
    var classes = (0,scss_utils/* mergeClassNames */.E)((LogWorkForm_module_default()), extClasses || {});
    /********************/ /*   custom hooks   */ /********************/ var format = (0,useDateTimeFormatter/* useDateTimeFormatter */.$0)().format;
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: (0,_object_spread/* default */.Z)({}, !!value ? dataToFormValues(value, format) : dataToFormValues(defaultValues(), format)),
        mode: "onBlur"
    });
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var watch = form.watch();
    var inputProps = (0,react.useMemo)(function() {
        return {
            inputProps: {
                className: classes.input,
                classes: {
                    input: classes.input__input
                }
            }
        };
    }, [
        classes.input,
        classes.input__input
    ]);
    var hasProgress = typeof secondsDone === "number" && typeof secondsTotal === "number";
    var loggedLabel = (0,react.useMemo)(function() {
        if (!hasProgress) return "0";
        return (0,dates/* durationStrDecimal */.TF)(secondsDone, {
            fallbackUnit: (0,dates/* getLargestContainedUnit */.Es)(secondsTotal),
            noDaysOrWeeks: true
        });
    }, [
        hasProgress,
        secondsDone,
        secondsTotal
    ]);
    var progress = (secondsDone || 0) / (secondsTotal || 1);
    /********************/ /*    useCallback   */ /********************/ var triggerEnd = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return form.trigger("end");
    });
    var triggerStart = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return form.trigger("start");
    });
    var hasError = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return Object.keys(form.formState.errors).length !== 0;
    });
    var handleSubmit = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, endTime, duration;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        form.trigger()
                    ];
                case 1:
                    _state.sent();
                    if (!!hasError()) return [
                        3,
                        3
                    ];
                    ref = formValuesToData(form.getValues()), endTime = ref.endTime, duration = ref.duration;
                    return [
                        4,
                        onSubmit(endTime, duration)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }));
    var validateEndTime = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(v) {
        var endTime = formValuesToData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form.getValues()), {
            end: v
        })).endTime;
        var now = new Date();
        return endTime.getTime() > now.getTime() ? "Must be in the past" : true;
    });
    (0,useMicroShortcuts/* useMicroShortcuts */.j)(handleSubmit, onCancel);
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircularProgressWithBackground/* CircularProgressWithBackground */.g, {
                className: classes.progress,
                size: 72,
                fraction: progress,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.focusProgressLabel,
                        variant: "h5",
                        children: loggedLabel.replace(" ", "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.focusProgressSubLabel,
                        variant: "h6",
                        children: "Done"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RhfForm/* RhfForm */.$, {
                form: form,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RhfRadioBoxGroupControl/* RhfRadioBoxGroupControl */.m, {
                        name: "fieldToggle",
                        orientation: "vertical",
                        defaultValue: fieldToggleKeys.duration,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RhfRadioBox/* RhfRadioBox */.S, {
                                styleless: true,
                                value: fieldToggleKeys.duration,
                                children: "Duration"
                            }),
                            watch.fieldToggle === "duration" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.flexFields,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationControl/* DurationControl */.u$, {
                                    className: classes.durationField,
                                    name: "duration",
                                    "aria-label": "Duration",
                                    size: "small",
                                    variant: "outlined",
                                    rules: {
                                        validate: {
                                            min: function(v) {
                                                var parsed = (0,DurationControl/* durationControlParseDuration */.Us)(v);
                                                return !!parsed && parsed < 15 ? "Minimum duration is 15 min" : true;
                                            }
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RhfRadioBox/* RhfRadioBox */.S, {
                                styleless: true,
                                value: fieldToggleKeys.startEnd,
                                children: "Specific date & time"
                            }),
                            watch.fieldToggle === "startEnd" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.flexFields,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                className: classes.flexFields__label,
                                                children: "Date"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateControl/* DateControl */.E, {
                                                name: "date",
                                                className: classes.dateControl,
                                                "aria-label": "Date",
                                                size: "small",
                                                variant: "outlined",
                                                disableFuture: true,
                                                disablePast: false,
                                                inlinePicker: true,
                                                InputProps: inputProps,
                                                placeholder: "Today",
                                                onBlur: triggerEnd,
                                                fullWidth: true,
                                                dayMode: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.flexFields,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                className: classes.flexFields__label,
                                                children: "Time"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeControl/* TimeControl */.O, {
                                                className: classes.timeControl,
                                                name: "start",
                                                "aria-label": "Start time",
                                                size: "small",
                                                variant: "outlined",
                                                InputProps: inputProps,
                                                required: "required",
                                                rules: {
                                                    validate: {
                                                        beforeEnd: function(v) {
                                                            return TimeControl/* TimeControlValidators.beforeTime */.T.beforeTime(v, form.getValues().end, "Must be less than end");
                                                        }
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                className: classes.flexFields__autoLabel,
                                                children: "to"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeControl/* TimeControl */.O, {
                                                className: classes.timeControl,
                                                name: "end",
                                                "aria-label": "End time",
                                                size: "small",
                                                variant: "outlined",
                                                required: "required",
                                                rules: {
                                                    validate: {
                                                        beforeNow: validateEndTime
                                                    }
                                                },
                                                onBlur: triggerStart,
                                                InputProps: inputProps
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                        onClick: handleSubmit,
                        className: classes.submitBtn,
                        variant: "contained",
                        color: "primary",
                        size: "small",
                        children: submitLabel
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/dialogs/LogWorkDialog.tsx








var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        paper: {
            borderRadius: theme.shape.borderRadius * 3,
            maxWidth: 460,
            padding: theme.spacing(3.5, 3),
            backgroundColor: theme.colors.white
        },
        closeBtn: {
            position: "absolute",
            zIndex: 1,
            top: theme.spacing(0.25),
            right: theme.spacing(0.25),
            margin: "0 0 0 auto",
            minWidth: 0
        },
        dialogTitle: {
            padding: theme.spacing(0, 0, 2),
            wordBreak: "break-word",
            overflowWrap: "anywhere"
        }
    };
}, {
    classNamePrefix: "LogWorkDialog"
});
var LogWorkDialog = function(_param) {
    var className = _param.className, extClasses = _param.classes, open = _param.open, taskTitle = _param.taskTitle, onCancel = _param.onCancel, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "classes",
        "open",
        "taskTitle",
        "onCancel"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        classes: {
            paper: classes.paper
        },
        open: open,
        onClose: onCancel,
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: onCancel,
                className: classes.closeBtn,
                color: "primary",
                variant: "text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseRounded/* default */.Z, {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                className: classes.dialogTitle,
                children: taskTitle ? "Log work for: ".concat(taskTitle) : "Log work"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogWorkForm, (0,_object_spread/* default */.Z)({
                onCancel: onCancel
            }, rest))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/EasyLogWork.tsx









var propsAtom = (0,esm/* atom */.cn)(undefined);
var propsWriteAtom = (0,esm/* atom */.cn)(null, function(get, set, newProps) {
    return set(propsAtom, newProps);
});
var EasyLogWorkDialog = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(propsAtom), 1), props = ref[0];
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var onCancel = props === null || props === void 0 ? void 0 : props.onCancel;
    var onSubmit = props === null || props === void 0 ? void 0 : props.onSubmit;
    var handleClose = (0,react.useCallback)(function() {
        setOpen(false);
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [
        onCancel
    ]);
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(endTime, duration) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(endTime, duration)
                        ];
                    case 1:
                        _state.sent();
                        handleClose();
                        return [
                            2
                        ];
                }
            });
        });
        return function(endTime, duration) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleClose,
        onSubmit
    ]);
    (0,react.useEffect)(function() {
        if (props) setOpen(true);
    }, [
        props
    ]);
    return props ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LogWorkDialog, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        open: open
    }, props), {
        onCancel: handleClose,
        onSubmit: handleSubmit
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var useEasyLogWorkDialog = function(baseProps) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(propsWriteAtom), 2), setProps = ref[1];
    return (0,react.useCallback)(function(props) {
        return setProps((0,_object_spread/* default */.Z)({}, baseProps, props));
    }, [
        baseProps,
        setProps
    ]);
};


/***/ }),

/***/ 95313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ EasyReschedulator; },
  "S": function() { return /* binding */ useEasyReschedulator; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(13665);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CloseRounded.js
var CloseRounded = __webpack_require__(36191);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Reschedulator.tsx
var Reschedulator = __webpack_require__(24517);
// EXTERNAL MODULE: ./src/components/Menu.tsx
var Menu = __webpack_require__(76698);
;// CONCATENATED MODULE: ./src/components/ReschedulatorPopper.tsx












var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        paper: {
            background: "white",
            padding: theme.spacing(2, 3),
            borderRadius: theme.spacing()
        },
        closeButton: {
            position: "absolute",
            top: theme.spacing(-1),
            right: theme.spacing(-2)
        },
        closeButtonIcon: {
            fontSize: "inherit"
        }
    };
}, {
    classNamePrefix: "ReschedulatorPopper"
});
function ReschedulatorPopper(param) {
    var className = param.className, extClasses = param.classes, open = param.open, onClose = param.onClose, onReschedule = param.onReschedule, anchorEl = param.anchorEl, reschedulatorProps = param.reschedulatorProps, snoozeOptions = param.snoozeOptions;
    var classes = useStyles({
        classes: extClasses
    });
    var handleReschedule = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(snooze) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onReschedule === null || onReschedule === void 0 ? void 0 : onReschedule(snooze)
                        ];
                    case 1:
                        _state.sent();
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        return [
                            2
                        ];
                }
            });
        });
        return function(snooze) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onClose,
        onReschedule
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        open: open,
        anchorEl: anchorEl,
        classes: {
            paper: classes.paper
        },
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reschedulator/* Reschedulator */.Y, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onReschedule: handleReschedule
            }, reschedulatorProps), {
                snoozeOptions: snoozeOptions
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                className: classes.closeButton,
                onClick: onClose,
                size: "small",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseRounded/* default */.Z, {
                    className: classes.closeButtonIcon
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/EasyReschedulator.tsx







var propsAtom = (0,esm/* atom */.cn)(undefined);
var propsWriteAtom = (0,esm/* atom */.cn)(null, function(get, set, newProps) {
    return set(propsAtom, newProps);
});
var EasyReschedulator = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(propsAtom), 1), props = ref[0];
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var onClose = props === null || props === void 0 ? void 0 : props.onClose;
    var handleClose = (0,react.useCallback)(function() {
        setOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        onClose
    ]);
    (0,react.useEffect)(function() {
        if (props) setOpen(true);
    }, [
        props
    ]);
    return props ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReschedulatorPopper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        open: open
    }, props), {
        onClose: handleClose
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var useEasyReschedulator = function(baseProps) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(propsWriteAtom), 2), setProps = ref[1];
    return (0,react.useCallback)(function(props) {
        return setProps((0,_object_spread/* default */.Z)({}, baseProps, props));
    }, [
        baseProps,
        setProps
    ]);
};


/***/ }),

/***/ 33249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ GenericInfoMessage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _GenericInfoMessage_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58476);
/* harmony import */ var _GenericInfoMessage_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_GenericInfoMessage_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _UIActionButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33578);










var GenericInfoMessage = function(param) {
    var className = param.className, extClasses = param.classes, icon = param.icon, title = param.title, message = param.message, _type = param.type, type = _type === void 0 ? "default" : _type, _size = param.size, size = _size === void 0 ? "small" : _size, _align = param.align, align = _align === void 0 ? "top," : _align, headerVariant = param.headerVariant, _messageVariant = param.messageVariant, messageVariant = _messageVariant === void 0 ? "subtitle1" : _messageVariant, messageWrapperIsDiv = param.messageWrapperIsDiv, titleWrapperIsDiv = param.titleWrapperIsDiv, headerImage = param.headerImage, uiActions = param.uiActions;
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__/* .mergeClassNames */ .E)((_GenericInfoMessage_module_scss__WEBPACK_IMPORTED_MODULE_4___default()), extClasses || {});
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, classes.centered, align === "center")),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes["root--small"], size === "small"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes["root--large"], size === "large"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes["root--extraSmall"], size === "extraSmall"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes["root--error"], type === "error"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes["root--corn"], type === "corn"), _obj)),
            children: [
                headerImage,
                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.iconWrap,
                    children: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(icon, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(icon.props.className, classes.iconWrap__icon)
                    })
                }),
                !!title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    className: classes.header
                }, titleWrapperIsDiv ? {
                    component: "div"
                } : {}), {
                    variant: headerVariant || "h1",
                    children: title
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    className: classes.subtitle
                }, messageWrapperIsDiv ? {
                    component: "div"
                } : {}), {
                    variant: messageVariant,
                    children: message
                })),
                uiActions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.actions,
                    children: uiActions.map(function(uiAction, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UIActionButton__WEBPACK_IMPORTED_MODULE_3__/* .UIActionButton */ ._, {
                            uiAction: uiAction,
                            color: "primary",
                            variant: i === 0 ? "contained" : "text",
                            size: size === "extraSmall" ? "small" : size
                        }, i);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 21405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ Helptip; },
  "Z": function() { return /* binding */ components_Helptip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ErrorOutlineRounded.js
var ErrorOutlineRounded = __webpack_require__(90008);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/HelpOutline.js
var HelpOutline = __webpack_require__(27608);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NewReleases.js
var NewReleases = __webpack_require__(13328);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./src/utils/scss.utils.ts
var scss_utils = __webpack_require__(91740);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Helptip.module.scss
var Helptip_module = __webpack_require__(38702);
var Helptip_module_default = /*#__PURE__*/__webpack_require__.n(Helptip_module);
// EXTERNAL MODULE: ./src/components/Tooltip.tsx
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/Warning.js
"use client";



/* harmony default export */ var Warning = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning'));
;// CONCATENATED MODULE: ./src/components/Helptip.tsx















var VARIANT_COLORS = {
    error: "error",
    warning: "warn"
};
var Helptip = function(_param) {
    var renderIcon = function renderIcon() {
        switch(variant){
            case "assist":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    role: "img",
                    "aria-label": "Reclaim Assist feature",
                    className: (0,clsx_m/* default */.Z)(classes.icon, classes["icon--emoji"]),
                    children: "⭐️"
                });
            case "beta":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "sup",
                    className: (0,clsx_m/* default */.Z)(classes.icon, classes["icon--superscript"]),
                    children: "β"
                });
            case "info":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                    fontSize: "small",
                    className: classes.icon
                });
            case "new":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewReleases/* default */.Z, {
                    className: classes.icon
                });
            case "error":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlineRounded/* default */.Z, {
                    className: classes.icon
                });
            case "warning":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning, {
                    color: "warning",
                    className: classes.icon
                });
            case "help":
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpOutline/* default */.Z, {
                    className: classes.icon,
                    color: "primary"
                });
        }
    };
    var _variant = _param.variant, variant = _variant === void 0 ? "help" : _variant, _placement = _param.placement, placement = _placement === void 0 ? "right" : _placement, _color = _param.color, color = _color === void 0 ? "auto" : _color, title = _param.title, className = _param.className, extClasses = _param.classes, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "placement",
        "color",
        "title",
        "className",
        "classes"
    ]);
    var classes = (0,scss_utils/* mergeClassNames */.E)((Helptip_module_default()), extClasses || {});
    color = color === "auto" ? VARIANT_COLORS[variant] || "grey" : color;
    return !title ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className, classes["root--".concat(color)]),
        classes: {
            tooltip: classes.tooltip
        },
        tabIndex: -1,
        placement: placement,
        title: title,
        enterTouchDelay: 0,
        leaveTouchDelay: 5000
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            size: "small",
            children: renderIcon()
        })
    }));
};
/* harmony default export */ var components_Helptip = (Helptip);


/***/ }),

/***/ 34557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23795);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61214);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65934);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useOurRouter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52581);












var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return {
        disabled: {
            opacity: 0.5,
            pointerEvents: "none"
        }
    };
}, {
    classNamePrefix: "Link"
});
var NextComposed = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function(_param, ref) {
    var href = _param.href, as = _param.as, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "href",
        "as"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        as: as,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            ref: ref
        }, rest))
    });
});
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/#with-link
var Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function(_param, ref) {
    var extClasses = _param.classes, href = _param.href, _activeClassName = _param.activeClassName, activeClassName = _activeClassName === void 0 ? "active" : _activeClassName, classNameProps = _param.className, target = _param.target, naked = _param.naked, rel = _param.rel, disabled = _param.disabled, _underline = _param.underline, underline = _underline === void 0 ? "none" : _underline, /**
       * props below here and above "...rest" aren't
       * used by Links, but are used by Button when
       * component is set to Link.  We need to include
       * them in LinkProps and remove them so they
       * don't get sent to MuiLink
       */ variant = _param.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "classes",
        "href",
        "activeClassName",
        "className",
        "target",
        "naked",
        "rel",
        "disabled",
        "underline",
        "variant"
    ]);
    var router = (0,_hooks_useOurRouter__WEBPACK_IMPORTED_MODULE_3__/* .useOurRouter */ .ED)();
    var classes = useStyles({
        classes: extClasses
    });
    // Jump link anchors don't work in Next
    // See here: https://github.com/vercel/next.js/issues/11109
    // useEffect to catch hash and scroll to section
    var locationHash =  true ? window.location.hash : 0;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!!locationHash) {
            setTimeout(function() {
                var _$ref;
                (_$ref = document.querySelector(locationHash)) === null || _$ref === void 0 ? void 0 : _$ref.scrollIntoView({
                    behavior: "smooth"
                });
            }, 100);
        }
    }, [
        locationHash
    ]);
    var pathname = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (!href || typeof href === "string" ? href : href.pathname) || "";
    }, [
        href
    ]);
    var sameDomain = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,_utils_url__WEBPACK_IMPORTED_MODULE_8__/* .isSameDomain */ .A4)(pathname);
    }, [
        pathname
    ]);
    var _obj;
    var className = (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(classNameProps, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, activeClassName, router.pathname === pathname && activeClassName), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.disabled, disabled), _obj));
    var muiLinkProps = {
        className: className,
        ref: ref,
        target: target || (sameDomain ? undefined : "_blank"),
        rel: rel || (sameDomain ? undefined : "noreferrer"),
        underline: underline
    };
    if (!!href && typeof href !== "string" && !!href.query) href.query = (0,_hooks_useOurRouter__WEBPACK_IMPORTED_MODULE_3__/* .flatten */ .xH)(typeof href.query === "string" ? JSON.parse(href.query) : href.query) || null;
    if (!href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, muiLinkProps, rest));
    }
    if (pathname.startsWith("http") || pathname.startsWith("//") || pathname.startsWith("mailto")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, muiLinkProps), {
            href: pathname
        }), rest));
    }
    if (!naked) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextComposed, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, muiLinkProps), {
            href: href
        }), rest));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, muiLinkProps), {
        component: NextComposed,
        href: pathname
    }), rest));
});


/***/ }),

/***/ 8080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87357);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_LoadingIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69921);






var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            height: "100%"
        }
    };
}, {
    classNamePrefix: "Loading"
});
var Loading = function(param) {
    var className = param.className, extClasses = param.classes, size = param.size;
    var classes = useStyles({
        classes: extClasses
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            role: "img",
            "aria-label": "Loading",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LoadingIcon__WEBPACK_IMPORTED_MODULE_2__/* .LoadingIcon */ .H, {
                size: size || 64
            })
        })
    });
};


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ LoadingIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98456);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);






var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            flexShrink: 0,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            align: "center",
            verticalAlign: "middle"
        },
        spinner: {},
        circle: {
            strokeLinecap: "round"
        }
    };
}, {
    classNamePrefix: "LoadingIcon"
});
var LoadingIcon = function(_param) {
    var className = _param.className, extClasses = _param.classes, _size = _param.size, size = _size === void 0 ? 18 : _size, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "size"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            size: size,
            className: classes.spinner,
            classes: {
                circle: classes.circle
            }
        }, rest))
    });
};


/***/ }),

/***/ 76698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Menu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25464);
// eslint-disable-next-line no-restricted-imports




var Menu = function(_param) {
    var rest = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        anchorOrigin: {
            vertical: "top",
            horizontal: "left"
        }
    }, rest));
};


/***/ }),

/***/ 55942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ MenuItemWithTooltip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18972);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15695);









var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            padding: 0
        },
        wrapper: {
            padding: theme.spacing(0.75, 2),
            flex: "1 1 100%",
            display: "flex"
        }
    };
}, {
    classNamePrefix: "MenuItemWithTooltip"
});
var MenuItemWithTooltip = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, MenuItemClasses = _param.MenuItemClasses, title = _param.title, children = _param.children, TooltipProps = _param.TooltipProps, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "MenuItemClasses",
        "title",
        "children",
        "TooltipProps"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(classes.root, className),
        classes: MenuItemClasses,
        ref: ref
    }, rest), {
        children: title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* .Tooltip */ .u, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            title: title,
            placement: "left"
        }, TooltipProps), {
            children: content
        })) : content
    }));
});


/***/ }),

/***/ 27165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ MiniRadioGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41796);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11057);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);







var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            border: "1px solid",
            borderColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* .lighten */ .$n)(theme.colors.logo.darkness, 0.85),
            borderRadius: theme.shape.borderRadius * 5,
            whiteSpace: "nowrap",
            alignSelf: "center",
            display: "flex"
        },
        button: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.typography.body2), {
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: 1.2,
            margin: theme.spacing(0.375),
            minWidth: 0,
            color: theme.colors.black,
            padding: theme.spacing(0.5, 1),
            width: "auto",
            flex: "1 1 auto"
        }),
        buttonSmall: {
            padding: theme.spacing(0.25, 0.5),
            fontSize: 12,
            margin: theme.spacing(0.25)
        },
        selected: {
            backgroundColor: theme.colors.logo.darkness100,
            color: theme.colors.black,
            cursor: "default",
            "&:hover": {
                backgroundColor: theme.colors.logo.darkness100,
                color: theme.colors.black
            }
        }
    };
}, {
    classNamePrefix: "MiniRadioGroup"
});
var MiniRadioGroup = function(param) {
    var className = param.className, extClasses = param.classes, tabs = param.tabs, selected = param.selected, disabled = param.disabled, onChange = param.onChange, ButtonProps = param.ButtonProps, small = param.small;
    var classes = useStyles({
        classes: extClasses
    });
    /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className),
        children: tabs.map(function(tab) {
            var ref = typeof tab === "object" ? tab : {
                key: tab,
                label: tab,
                disabled: false
            }, key = ref.key, label = ref.label, tabDisabled = ref.disabled;
            var _obj;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                onClick: function() {
                    return onChange(key);
                },
                disabled: disabled || tabDisabled,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.button, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, classes.selected, key === selected), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, classes.buttonSmall, small), _obj))
            }, ButtonProps), {
                children: label || key
            }), key);
        })
    });
};


/***/ }),

/***/ 51375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ evaluateReason; },
/* harmony export */   "u": function() { return /* binding */ ReasonTip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15695);






function evaluateReason(reasons) {
    var index = reasons.findIndex(function(param) {
        var test = param.test;
        return test;
    });
    if (index === -1) return [
        false,
        undefined
    ];
    else return [
        true,
        reasons[index].message
    ];
}
var ReasonTip = function(_param) {
    var reasons = _param.reasons, children = _param.children, childrenOverride = _param.childrenOverride, appendReasonToTitle = _param.appendReasonToTitle, title = _param.title, noSpan = _param.noSpan, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "reasons",
        "children",
        "childrenOverride",
        "appendReasonToTitle",
        "title",
        "noSpan"
    ]);
    if (!children && !childrenOverride) throw new Error("Must provide either children or childrenOverride");
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(evaluateReason(reasons), 2), hasReason = ref[0], message = ref[1];
    var tt;
    if (hasReason) tt = message;
    if (appendReasonToTitle && title && tt) tt = "".concat(title, " ").concat(message);
    if (!tt) tt = title;
    children = childrenOverride || children;
    children = typeof children === "function" ? children(hasReason, message) : children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        title: tt || false,
        disableHoverListener: !tt,
        disableTouchListener: !tt,
        disableFocusListener: !tt,
        enterDelay: 0,
        disabled: !hasReason && !title,
        withSpan: !noSpan
    }, rest), {
        children: children
    }));
};


/***/ }),

/***/ 55260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ ReclaimLocalizationProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js
var LocalizationProvider = __webpack_require__(50720);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addSeconds/index.js
var addSeconds = __webpack_require__(61973);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMinutes/index.js
var addMinutes = __webpack_require__(58545);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addHours/index.js
var addHours = __webpack_require__(78343);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addWeeks/index.js
var addWeeks = __webpack_require__(63500);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(11640);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addYears/index.js
var addYears = __webpack_require__(21593);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInYears/index.js + 1 modules
var differenceInYears = __webpack_require__(31397);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMonths/index.js + 2 modules
var differenceInMonths = __webpack_require__(62337);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInQuarters/index.js


/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */

function differenceInQuarters(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = (0,differenceInMonths/* default */.Z)(dirtyDateLeft, dirtyDateRight) / 3;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js
var differenceInDays = __webpack_require__(67803);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInWeeks/index.js


/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */

function differenceInWeeks(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = (0,differenceInDays/* default */.Z)(dirtyDateLeft, dirtyDateRight) / 7;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInHours/index.js
var differenceInHours = __webpack_require__(76972);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMinutes/index.js
var differenceInMinutes = __webpack_require__(69690);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(11699);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMilliseconds/index.js
var differenceInMilliseconds = __webpack_require__(59910);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/eachDayOfInterval/index.js


/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
 *
 *   // v2.0.0 onward
 *
 *   eachDayOfInterval(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
 *   )
 *   ```
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = (0,toDate/* default */.Z)(interval.start);
  var endDate = (0,toDate/* default */.Z)(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push((0,toDate/* default */.Z)(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfDay/index.js
var endOfDay = __webpack_require__(83894);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfWeek/index.js
var endOfWeek = __webpack_require__(67090);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/endOfYear/index.js


/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDate/index.js


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getHours/index.js


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var hours = date.getHours();
  return hours;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getMinutes/index.js


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getMonth/index.js


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  return month;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getSeconds/index.js


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getMilliseconds/index.js


/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */

function getMilliseconds(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var milliseconds = date.getMilliseconds();
  return milliseconds;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(584);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeekYear/index.js





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(dirtyDate, options) {
  var _options$locale, _options$locale$optio;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var localeFirstWeekContainsDate = options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,toInteger/* default */.Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = (options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) == null ? defaultFirstWeekContainsDate : (0,toInteger/* default */.Z)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = (0,startOfWeek/* default */.Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = (0,startOfWeek/* default */.Z)(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfWeekYear/index.js




/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * var result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * var result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfWeekYear(dirtyDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,toInteger/* default */.Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0,toInteger/* default */.Z)(options.firstWeekContainsDate);
  var year = getWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = (0,startOfWeek/* default */.Z)(firstWeek, dirtyOptions);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getISOWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfWeek/* default */.Z)(date, options).getTime() - startOfWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getYear/index.js


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  return year;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isBefore/index.js


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isEqual/index.js


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyLeftDate);
  var dateRight = (0,toDate/* default */.Z)(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameYear/index.js
var isSameYear = __webpack_require__(60792);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameMonth/index.js
var isSameMonth = __webpack_require__(49160);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfHour/index.js


/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */

function startOfHour(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isSameHour/index.js


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 */

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 6 modules
var parse = __webpack_require__(24002);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setDate/index.js



/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */

function setDate(dirtyDate, dirtyDayOfMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dayOfMonth = (0,toInteger/* default */.Z)(dirtyDayOfMonth);
  date.setDate(dayOfMonth);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setHours/index.js
var setHours = __webpack_require__(37042);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/setMinutes/index.js
var setMinutes = __webpack_require__(4543);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = (0,toInteger/* default */.Z)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setSeconds/index.js



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var seconds = (0,toInteger/* default */.Z)(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMilliseconds/index.js



/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */

function setMilliseconds(dirtyDate, dirtyMilliseconds) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var milliseconds = (0,toInteger/* default */.Z)(dirtyMilliseconds);
  date.setMilliseconds(milliseconds);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setYear/index.js



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = (0,toInteger/* default */.Z)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(69119);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js
var startOfMonth = __webpack_require__(43703);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js
var endOfMonth = __webpack_require__(4135);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfYear/index.js


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var cleanDate = (0,toDate/* default */.Z)(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parseISO/index.js


var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0,toInteger/* default */.Z)(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
var addLeadingZeros = __webpack_require__(4810);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatISO/index.js



/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (http://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with time zone, or both.
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */

function formatISO(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  var options = dirtyOptions || {};
  var format = options.format == null ? 'extended' : String(options.format);
  var representation = options.representation == null ? 'complete' : String(options.representation);

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = (0,addLeadingZeros/* default */.Z)(originalDate.getDate(), 2);
    var month = (0,addLeadingZeros/* default */.Z)(originalDate.getMonth() + 1, 2);
    var year = (0,addLeadingZeros/* default */.Z)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();

    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = (0,addLeadingZeros/* default */.Z)(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = (0,addLeadingZeros/* default */.Z)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }

    var hour = (0,addLeadingZeros/* default */.Z)(originalDate.getHours(), 2);
    var minute = (0,addLeadingZeros/* default */.Z)(originalDate.getMinutes(), 2);
    var second = (0,addLeadingZeros/* default */.Z)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }

  return result;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isWithinInterval/index.js
var isWithinInterval = __webpack_require__(24257);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 1 modules
var en_US = __webpack_require__(83975);
// EXTERNAL MODULE: ./node_modules/date-fns/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(95209);
var longFormatters_default = /*#__PURE__*/__webpack_require__.n(longFormatters);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/AdapterDateFns/AdapterDateFns.js

/* eslint-disable class-methods-use-this */























































// @ts-ignore

const formatTokenMap = {
  // Year
  y: {
    sectionType: 'year',
    contentType: 'digit',
    maxLength: 4
  },
  yy: 'year',
  yyy: {
    sectionType: 'year',
    contentType: 'digit',
    maxLength: 4
  },
  yyyy: 'year',
  // Month
  M: {
    sectionType: 'month',
    contentType: 'digit',
    maxLength: 2
  },
  MM: 'month',
  MMMM: {
    sectionType: 'month',
    contentType: 'letter'
  },
  MMM: {
    sectionType: 'month',
    contentType: 'letter'
  },
  L: {
    sectionType: 'month',
    contentType: 'digit',
    maxLength: 2
  },
  LL: 'month',
  LLL: {
    sectionType: 'month',
    contentType: 'letter'
  },
  LLLL: {
    sectionType: 'month',
    contentType: 'letter'
  },
  // Day of the month
  d: {
    sectionType: 'day',
    contentType: 'digit',
    maxLength: 2
  },
  dd: 'day',
  do: {
    sectionType: 'day',
    contentType: 'digit-with-letter'
  },
  // Day of the week
  E: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  EE: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  EEE: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  EEEE: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  EEEEE: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  i: {
    sectionType: 'weekDay',
    contentType: 'digit',
    maxLength: 1
  },
  ii: 'weekDay',
  iii: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  iiii: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  e: {
    sectionType: 'weekDay',
    contentType: 'digit',
    maxLength: 1
  },
  ee: 'weekDay',
  eee: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  eeee: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  eeeee: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  eeeeee: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  c: {
    sectionType: 'weekDay',
    contentType: 'digit',
    maxLength: 1
  },
  cc: 'weekDay',
  ccc: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  cccc: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  ccccc: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  cccccc: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  // Meridiem
  a: 'meridiem',
  aa: 'meridiem',
  aaa: 'meridiem',
  // Hours
  H: {
    sectionType: 'hours',
    contentType: 'digit',
    maxLength: 2
  },
  HH: 'hours',
  h: {
    sectionType: 'hours',
    contentType: 'digit',
    maxLength: 2
  },
  hh: 'hours',
  // Minutes
  m: {
    sectionType: 'minutes',
    contentType: 'digit',
    maxLength: 2
  },
  mm: 'minutes',
  // Seconds
  s: {
    sectionType: 'seconds',
    contentType: 'digit',
    maxLength: 2
  },
  ss: 'seconds'
};
const defaultFormats = {
  year: 'yyyy',
  month: 'LLLL',
  monthShort: 'MMM',
  dayOfMonth: 'd',
  weekday: 'EEEE',
  weekdayShort: 'EEE',
  hours24h: 'HH',
  hours12h: 'hh',
  meridiem: 'aa',
  minutes: 'mm',
  seconds: 'ss',
  fullDate: 'PP',
  fullDateWithWeekday: 'PPPP',
  keyboardDate: 'P',
  shortDate: 'MMM d',
  normalDate: 'd MMMM',
  normalDateWithWeekday: 'EEE, MMM d',
  monthAndYear: 'LLLL yyyy',
  monthAndDate: 'MMMM d',
  fullTime: 'p',
  fullTime12h: 'hh:mm aa',
  fullTime24h: 'HH:mm',
  fullDateTime: 'PP p',
  fullDateTime12h: 'PP hh:mm aa',
  fullDateTime24h: 'PP HH:mm',
  keyboardDateTime: 'P p',
  keyboardDateTime12h: 'P hh:mm aa',
  keyboardDateTime24h: 'P HH:mm'
};

/**
 * Based on `@date-io/date-fns`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
class AdapterDateFns {
  constructor({
    locale: _locale,
    formats
  } = {}) {
    this.isMUIAdapter = true;
    this.isTimezoneCompatible = false;
    this.lib = 'date-fns';
    this.locale = void 0;
    this.formats = void 0;
    this.formatTokenMap = formatTokenMap;
    this.escapedCharacters = {
      start: "'",
      end: "'"
    };
    this.date = value => {
      if (typeof value === 'undefined') {
        return new Date();
      }
      if (value === null) {
        return null;
      }
      return new Date(value);
    };
    this.dateWithTimezone = value => {
      return this.date(value);
    };
    this.getTimezone = () => {
      return 'default';
    };
    this.setTimezone = value => {
      return value;
    };
    this.toJsDate = value => {
      return value;
    };
    this.parseISO = isoString => {
      return parseISO(isoString);
    };
    this.toISO = value => {
      return formatISO(value, {
        format: 'extended'
      });
    };
    this.parse = (value, format) => {
      if (value === '') {
        return null;
      }
      return (0,parse/* default */.Z)(value, format, new Date(), {
        locale: this.locale
      });
    };
    this.getCurrentLocaleCode = () => {
      var _this$locale;
      return ((_this$locale = this.locale) == null ? void 0 : _this$locale.code) || 'en-US';
    };
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    this.is12HourCycleInCurrentLocale = () => {
      if (this.locale) {
        return /a/.test(this.locale.formatLong.time());
      }

      // By default, date-fns is using en-US locale with am/pm enabled
      return true;
    };
    this.expandFormat = format => {
      const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

      // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
      return format.match(longFormatRegexp).map(token => {
        const firstCharacter = token[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
          const longFormatter = (longFormatters_default())[firstCharacter];
          const locale = this.locale || en_US/* default */.Z;
          return longFormatter(token, locale.formatLong, {});
        }
        return token;
      }).join('');
    };
    this.getFormatHelperText = format => {
      return this.expandFormat(format).replace(/(aaa|aa|a)/g, '(a|p)m').toLocaleLowerCase();
    };
    this.isNull = value => {
      return value === null;
    };
    this.isValid = value => {
      return (0,isValid/* default */.Z)(this.date(value));
    };
    this.format = (value, formatKey) => {
      return this.formatByString(value, this.formats[formatKey]);
    };
    this.formatByString = (value, formatString) => {
      return (0,format/* default */.Z)(value, formatString, {
        locale: this.locale
      });
    };
    this.formatNumber = numberToFormat => {
      return numberToFormat;
    };
    this.getDiff = (value, comparing, unit) => {
      switch (unit) {
        case 'years':
          return (0,differenceInYears/* default */.Z)(value, this.date(comparing));
        case 'quarters':
          return differenceInQuarters(value, this.date(comparing));
        case 'months':
          return (0,differenceInMonths/* default */.Z)(value, this.date(comparing));
        case 'weeks':
          return differenceInWeeks(value, this.date(comparing));
        case 'days':
          return (0,differenceInDays/* default */.Z)(value, this.date(comparing));
        case 'hours':
          return (0,differenceInHours/* default */.Z)(value, this.date(comparing));
        case 'minutes':
          return (0,differenceInMinutes/* default */.Z)(value, this.date(comparing));
        case 'seconds':
          return (0,differenceInSeconds/* default */.Z)(value, this.date(comparing));
        default:
          {
            return (0,differenceInMilliseconds/* default */.Z)(value, this.date(comparing));
          }
      }
    };
    this.isEqual = (value, comparing) => {
      if (value === null && comparing === null) {
        return true;
      }
      return isEqual(value, comparing);
    };
    this.isSameYear = (value, comparing) => {
      return (0,isSameYear/* default */.Z)(value, comparing);
    };
    this.isSameMonth = (value, comparing) => {
      return (0,isSameMonth/* default */.Z)(value, comparing);
    };
    this.isSameDay = (value, comparing) => {
      return (0,isSameDay/* default */.Z)(value, comparing);
    };
    this.isSameHour = (value, comparing) => {
      return isSameHour(value, comparing);
    };
    this.isAfter = (value, comparing) => {
      return (0,isAfter/* default */.Z)(value, comparing);
    };
    this.isAfterYear = (value, comparing) => {
      return (0,isAfter/* default */.Z)(value, endOfYear(comparing));
    };
    this.isAfterDay = (value, comparing) => {
      return (0,isAfter/* default */.Z)(value, (0,endOfDay/* default */.Z)(comparing));
    };
    this.isBefore = (value, comparing) => {
      return isBefore(value, comparing);
    };
    this.isBeforeYear = (value, comparing) => {
      return isBefore(value, startOfYear(comparing));
    };
    this.isBeforeDay = (value, comparing) => {
      return isBefore(value, (0,startOfDay/* default */.Z)(comparing));
    };
    this.isWithinRange = (value, [start, end]) => {
      return (0,isWithinInterval/* default */.Z)(value, {
        start,
        end
      });
    };
    this.startOfYear = value => {
      return startOfYear(value);
    };
    this.startOfMonth = value => {
      return (0,startOfMonth/* default */.Z)(value);
    };
    this.startOfWeek = value => {
      return (0,startOfWeek/* default */.Z)(value, {
        locale: this.locale
      });
    };
    this.startOfDay = value => {
      return (0,startOfDay/* default */.Z)(value);
    };
    this.endOfYear = value => {
      return endOfYear(value);
    };
    this.endOfMonth = value => {
      return (0,endOfMonth/* default */.Z)(value);
    };
    this.endOfWeek = value => {
      return (0,endOfWeek/* default */.Z)(value, {
        locale: this.locale
      });
    };
    this.endOfDay = value => {
      return (0,endOfDay/* default */.Z)(value);
    };
    this.addYears = (value, amount) => {
      return (0,addYears/* default */.Z)(value, amount);
    };
    this.addMonths = (value, amount) => {
      return (0,addMonths/* default */.Z)(value, amount);
    };
    this.addWeeks = (value, amount) => {
      return (0,addWeeks/* default */.Z)(value, amount);
    };
    this.addDays = (value, amount) => {
      return (0,addDays/* default */.Z)(value, amount);
    };
    this.addHours = (value, amount) => {
      return (0,addHours/* default */.Z)(value, amount);
    };
    this.addMinutes = (value, amount) => {
      return (0,addMinutes/* default */.Z)(value, amount);
    };
    this.addSeconds = (value, amount) => {
      return (0,addSeconds/* default */.Z)(value, amount);
    };
    this.getYear = value => {
      return getYear(value);
    };
    this.getMonth = value => {
      return getMonth(value);
    };
    this.getDate = value => {
      return getDate(value);
    };
    this.getHours = value => {
      return getHours(value);
    };
    this.getMinutes = value => {
      return getMinutes(value);
    };
    this.getSeconds = value => {
      return getSeconds(value);
    };
    this.getMilliseconds = value => {
      return getMilliseconds(value);
    };
    this.setYear = (value, year) => {
      return setYear(value, year);
    };
    this.setMonth = (value, month) => {
      return setMonth(value, month);
    };
    this.setDate = (value, date) => {
      return setDate(value, date);
    };
    this.setHours = (value, hours) => {
      return (0,setHours/* default */.Z)(value, hours);
    };
    this.setMinutes = (value, minutes) => {
      return (0,setMinutes/* default */.Z)(value, minutes);
    };
    this.setSeconds = (value, seconds) => {
      return setSeconds(value, seconds);
    };
    this.setMilliseconds = (value, milliseconds) => {
      return setMilliseconds(value, milliseconds);
    };
    this.getDaysInMonth = value => {
      return getDaysInMonth(value);
    };
    this.getNextMonth = value => {
      return (0,addMonths/* default */.Z)(value, 1);
    };
    this.getPreviousMonth = value => {
      return (0,addMonths/* default */.Z)(value, -1);
    };
    this.getMonthArray = value => {
      const firstMonth = startOfYear(value);
      const monthArray = [firstMonth];
      while (monthArray.length < 12) {
        const prevMonth = monthArray[monthArray.length - 1];
        monthArray.push(this.getNextMonth(prevMonth));
      }
      return monthArray;
    };
    this.mergeDateAndTime = (dateParam, timeParam) => {
      return this.setSeconds(this.setMinutes(this.setHours(dateParam, this.getHours(timeParam)), this.getMinutes(timeParam)), this.getSeconds(timeParam));
    };
    this.getWeekdays = () => {
      const now = new Date();
      return eachDayOfInterval({
        start: (0,startOfWeek/* default */.Z)(now, {
          locale: this.locale
        }),
        end: (0,endOfWeek/* default */.Z)(now, {
          locale: this.locale
        })
      }).map(day => this.formatByString(day, 'EEEEEE'));
    };
    this.getWeekArray = value => {
      const start = (0,startOfWeek/* default */.Z)((0,startOfMonth/* default */.Z)(value), {
        locale: this.locale
      });
      const end = (0,endOfWeek/* default */.Z)((0,endOfMonth/* default */.Z)(value), {
        locale: this.locale
      });
      let count = 0;
      let current = start;
      const nestedWeeks = [];
      while (isBefore(current, end)) {
        const weekNumber = Math.floor(count / 7);
        nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
        nestedWeeks[weekNumber].push(current);
        current = (0,addDays/* default */.Z)(current, 1);
        count += 1;
      }
      return nestedWeeks;
    };
    this.getWeekNumber = value => {
      return getWeek(value, {
        locale: this.locale
      });
    };
    this.getYearRange = (start, end) => {
      const startDate = startOfYear(start);
      const endDate = endOfYear(end);
      const years = [];
      let current = startDate;
      while (isBefore(current, endDate)) {
        years.push(current);
        current = (0,addYears/* default */.Z)(current, 1);
      }
      return years;
    };
    this.getMeridiemText = ampm => {
      return ampm === 'am' ? 'AM' : 'PM';
    };
    this.locale = _locale;
    this.formats = (0,esm_extends/* default */.Z)({}, defaultFormats, formats);
  }
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/consts/date.consts.ts
var date_consts = __webpack_require__(76140);
;// CONCATENATED MODULE: ./src/components/ReclaimLocalizationProvider.tsx










var ReclaimLocalizationProvider = function(param) {
    var children = param.children;
    var ref;
    /********************/ /*   custom hooks   */ /********************/ var ref1 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), user = ref1[0].user;
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var adapterLocale = (0,react.useMemo)(function() {
        var ref;
        var locale = new Intl.Locale(date_consts/* BROWSER_LOCALE */.MT);
        var browserFirstDayOfWeek = 0;
        try {
            var ref1;
            var ref2;
            // @ts-ignore Locale.weekInfo is newish. Browser firstDay is 1 - 7 (Monday - Sunday)
            browserFirstDayOfWeek = ((ref2 = (ref1 = locale.weekInfo) === null || ref1 === void 0 ? void 0 : ref1.firstDay) !== null && ref2 !== void 0 ? ref2 : 0) % 7;
        } catch (e) {
            console.warn("Browser doesn't support Intl.Locale.weekInfo");
        }
        var ref3;
        var weekStartsOn = (ref3 = user === null || user === void 0 ? void 0 : (ref = user.settings) === null || ref === void 0 ? void 0 : ref.weekStart) !== null && ref3 !== void 0 ? ref3 : browserFirstDayOfWeek;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, en_US/* default */.Z), {
            options: {
                weekStartsOn: weekStartsOn
            }
        });
    }, [
        user === null || user === void 0 ? void 0 : (ref = user.settings) === null || ref === void 0 ? void 0 : ref.weekStart
    ]);
    /********************/ /*    useCallback   */ /********************/ /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
        dateAdapter: AdapterDateFns,
        adapterLocale: adapterLocale,
        children: children
    });
};


/***/ }),

/***/ 24517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Reschedulator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11057);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87357);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsMountedRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60128);
/* harmony import */ var _sharedLogic_sharedActionVisibilityLogic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72218);
/* harmony import */ var _forms_AsyncButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5062);













var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            maxWidth: 260,
            minWidth: 150,
            display: "flex",
            flexDirection: "column"
        },
        header: {
            fontSize: 15,
            fontWeight: 600,
            marginBottom: theme.spacing(1)
        },
        children: {
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(-0.5)
        },
        snoozeOptions: {
            display: "flex",
            gap: theme.spacing(),
            flexWrap: "wrap"
        },
        snoozeOptionsThinking: {
            pointerEvents: "none",
            opacity: 0.5
        },
        snoozeOption: {
            whiteSpace: "nowrap"
        },
        rescheduleButtonSelected: {
            backgroundColor: theme.palette.primary.main,
            color: "white"
        },
        rescheduleButton: {
            alignSelf: "end",
            marginTop: theme.spacing(2)
        }
    };
}, {
    classNamePrefix: "Reschedulator"
});
function ReschedulatorSnoozeButton(param) {
    var className = param.className, snoozeOption = param.snoozeOption, label = param.label, selectable = param.selectable, onClick = param.onClick;
    var handleReschedule = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return onClick(snoozeOption);
    }, [
        onClick,
        snoozeOption
    ]);
    return selectable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(className),
        onClick: handleReschedule,
        variant: "outlined",
        size: "small",
        children: label
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_forms_AsyncButton__WEBPACK_IMPORTED_MODULE_4__/* .AsyncButton */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(className),
        onClick: handleReschedule,
        variant: "outlined",
        size: "small",
        children: label
    });
}
var Reschedulator = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, snoozeOptions = _param.snoozeOptions, onReschedule = _param.onReschedule, hasRescheduleButton = _param.hasRescheduleButton, header = _param.header, children = _param.children, labelProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "snoozeOptions",
        "onReschedule",
        "hasRescheduleButton",
        "header",
        "children"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), selectedSnooze = _$ref[0], setSelectedSnooze = _$ref[1];
    var labelMap = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, _sharedLogic_sharedActionVisibilityLogic__WEBPACK_IMPORTED_MODULE_3__/* .SNOOZE_LABELS */ .x9, labelProps.labelOverrides, labelProps.labels);
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), thinking = _$ref1[0], setThinking = _$ref1[1];
    var isMountedRef = (0,_hooks_useIsMountedRef__WEBPACK_IMPORTED_MODULE_2__/* .useIsMountedRef */ .X)();
    var handleReschedule = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(snooze) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setThinking(true);
                        return [
                            4,
                            onReschedule(snooze)
                        ];
                    case 1:
                        _state.sent();
                        if (isMountedRef.current) setThinking(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(snooze) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isMountedRef,
        onReschedule
    ]);
    var handleRescheduleButtonClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!selectedSnooze) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handleReschedule(selectedSnooze)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        handleReschedule,
        selectedSnooze
    ]);
    var handleSnoozeButtonClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(snooze) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!hasRescheduleButton) return [
                            3,
                            1
                        ];
                        setSelectedSnooze(snooze);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            handleReschedule(snooze)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(snooze) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleReschedule,
        hasRescheduleButton
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                variant: "h4",
                className: classes.header,
                children: header || "Reschedule in"
            }),
            children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                className: classes.children,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.snoozeOptions, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, classes.snoozeOptionsThinking, thinking)),
                children: snoozeOptions.map(function(snoozeOption) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReschedulatorSnoozeButton, {
                        selectable: hasRescheduleButton,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.snoozeOption, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, classes.rescheduleButtonSelected, selectedSnooze === snoozeOption)),
                        onClick: handleSnoozeButtonClick,
                        snoozeOption: snoozeOption,
                        label: labelMap[snoozeOption] || snoozeOption
                    }, snoozeOption);
                })
            }),
            hasRescheduleButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_forms_AsyncButton__WEBPACK_IMPORTED_MODULE_4__/* .AsyncButton */ .Z, {
                className: classes.rescheduleButton,
                onClick: handleRescheduleButtonClick,
                disabled: !selectedSnooze,
                variant: "contained",
                color: "primary",
                children: "Reschedule"
            })
        ]
    });
});


/***/ }),

/***/ 17132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ TextSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61214);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18979);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _utils_loop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71233);





var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            display: "inline"
        },
        loading: {
            color: "transparent"
        }
    };
}, {
    classNamePrefix: "TextSkeleton"
});
var TextSkeleton = function(param) {
    var className = param.className, extClasses = param.classes, text = param.text, textLength = param.textLength, placeholderText = param.placeholderText;
    var classes = useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var loading = text === undefined;
    text = text === undefined ? placeholderText : text;
    if (text === undefined) text = (0,_utils_loop__WEBPACK_IMPORTED_MODULE_2__/* .mapTimes */ .n)(typeof textLength === "number" ? textLength : 10, function() {
        return "a";
    });
    /********************/ /*    useCallback   */ /********************/ /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, classes.loading),
        variant: "text",
        children: text
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
        children: text
    });
};


/***/ }),

/***/ 15695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87357);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34386);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47310);
/* harmony import */ var _Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30376);
/* harmony import */ var _Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_5__);












var Tooltip = function(_param) {
    var className = _param.className, extClasses = _param.classes, children = _param.children, disabled = _param.disabled, TooltipClasses = _param.TooltipClasses, title = _param.title, letEventsPropagate = _param.letEventsPropagate, closeOnClick = _param.closeOnClick, withSpan = _param.withSpan, interactive = _param.interactive, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "children",
        "disabled",
        "TooltipClasses",
        "title",
        "letEventsPropagate",
        "closeOnClick",
        "withSpan",
        "interactive"
    ]);
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__/* .mergeClassNames */ .E)((_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_5___default()), extClasses || {});
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref[0], setOpen = ref[1];
    var disableTooltip = disabled || !title;
    var openTooltip = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__/* .useCallbackSafeRef */ .T)(function() {
        return setOpen(true);
    });
    var closeTooltip = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__/* .useCallbackSafeRef */ .T)(function() {
        return setOpen(false);
    });
    var stopProp = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(e) {
        return !letEventsPropagate && e.stopPropagation();
    }, [
        letEventsPropagate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        window.addEventListener("blur", closeTooltip);
        return function() {
            return window.removeEventListener("blur", closeTooltip);
        };
    }, [
        closeTooltip
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(className, classes.root),
        disableInteractive: !interactive,
        open: open,
        // It's possible to trigger the open while disabled. This can result
        // in tooltips opening for no apparent reason on state changes.
        onOpen: !disableTooltip ? openTooltip : undefined,
        onClose: closeTooltip,
        PopperProps: {
            onClick: function(e) {
                e.stopPropagation();
                if (closeOnClick) closeTooltip();
            }
        },
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            className: classes.titleWrapper,
            onMouseDown: stopProp,
            onMouseUp: stopProp,
            children: typeof title === "function" ? title({
                closeTooltip: closeTooltip
            }) : title
        }),
        classes: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, TooltipClasses), {
            tooltip: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(classes.tooltip, TooltipClasses === null || TooltipClasses === void 0 ? void 0 : TooltipClasses.tooltip, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, classes["tooltip--disabled"], disabled))
        }),
        enterDelay: 200,
        arrow: true
    }, rest), {
        children: withSpan ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classes.innerSpan,
            children: children
        }) : children
    }));
};


/***/ }),

/***/ 33578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ UIActionButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11057);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_uiActions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74648);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34557);
/* harmony import */ var _quests_QuestStepWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60022);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15695);
/* harmony import */ var _UIActionButton_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95981);
/* harmony import */ var _UIActionButton_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_UIActionButton_module_scss__WEBPACK_IMPORTED_MODULE_8__);














var UIActionButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var className = _param.className, uiAction = _param.uiAction, extClasses = _param.classes, defaults = _param.defaults, onClick = _param.onClick, postAction = _param.postAction, disabled = _param.disabled, _iconPosition = _param.iconPosition, iconPosition = _iconPosition === void 0 ? "left" : _iconPosition, color = _param.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "className",
        "uiAction",
        "classes",
        "defaults",
        "onClick",
        "postAction",
        "disabled",
        "iconPosition",
        "color"
    ]);
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__/* .mergeClassNames */ .E)((_UIActionButton_module_scss__WEBPACK_IMPORTED_MODULE_8___default()), extClasses || {});
    return (0,_utils_uiActions__WEBPACK_IMPORTED_MODULE_3__/* .useRenderUIAction */ .W3)("button", uiAction, function(param) {
        var actionObject = param.actionObject, isLink = param.isLink, disabled = param.disabled, handleClick = param.handleClick, promiseState = param.promiseState, _$ref = param.ref, entitlementChip = param.entitlementChip, entitlementMessage = param.entitlementMessage, icon = param.icon;
        var muiColor = (actionObject.color === "destructive" ? undefined : actionObject.color) || color;
        var localIconPosition = iconPosition;
        if (actionObject.iconPosition === "reverse") localIconPosition = iconPosition === "left" ? "right" : "left";
        icon = icon && /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(icon, {
            className: classes.icon
        });
        var _obj;
        var output = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip__WEBPACK_IMPORTED_MODULE_6__/* .Tooltip */ .u, {
            title: entitlementMessage,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(className, classes.root, classes["root--".concat(promiseState)], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, classes["root--destructive"], actionObject.color === "destructive"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, classes["root--link"], isLink), _obj)),
                ref: _$ref,
                startIcon: localIconPosition === "left" && icon,
                endIcon: localIconPosition === "right" && icon,
                disabled: disabled
            }, rest), {
                variant: actionObject.variant,
                color: muiColor
            }), isLink ? {
                component: _Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r,
                href: actionObject.action,
                target: actionObject.target
            } : {
                onClick: handleClick
            }), {
                children: [
                    actionObject.label,
                    entitlementChip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            "\xa0",
                            entitlementChip
                        ]
                    })
                ]
            }))
        });
        if (actionObject.QuestStepWrapperProps) output = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_quests_QuestStepWrapper__WEBPACK_IMPORTED_MODULE_5__/* .QuestStepWrapper */ .T, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, actionObject.QuestStepWrapperProps), {
            children: output
        }));
        return output;
    }, {
        defaults: defaults,
        onClick: onClick,
        postAction: postAction,
        ref: ref,
        forceDisable: disabled
    });
});
UIActionButton.displayName = "UIActionButton";


/***/ }),

/***/ 66544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ YoutubeVideoPlayerModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_youtube__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(13913);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8080);
/* harmony import */ var _modal_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52127);
/* harmony import */ var _quests_quests_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32774);












var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            zIndex: 2000
        },
        loader: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            margin: "auto"
        },
        container: {
            position: "relative",
            width: "100%",
            height: 0,
            paddingBottom: "56.25%",
            overflow: "hidden"
        },
        iframe: {
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0
        }
    };
}, {
    classNamePrefix: "YoutubeVideoPlayerModal"
});
var YoutubeVideoPlayerModal = function(_param) {
    var className = _param.className, extClasses = _param.classes, videoId = _param.videoId, videoOptions = _param.videoOptions, onClose = _param.onClose, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "videoId",
        "videoOptions",
        "onClose"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), ready = ref[0], setReady = ref[1];
    var opts = videoOptions || _quests_quests_util__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_VIDEO_PLAYER_OPTIONS */ .Cc;
    var onReady = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function() {
        setReady(true);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_modal_Modal__WEBPACK_IMPORTED_MODULE_4__/* .Modal */ .u, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className)
    }, rest), {
        onClose: onClose,
        fullWidth: true,
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_youtube__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                className: classes.container,
                iframeClassName: classes.iframe,
                videoId: videoId,
                onReady: onReady,
                onEnd: onClose,
                opts: {
                    playerVars: opts
                }
            }),
            !ready && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
                className: classes.loader
            })
        ]
    }));
};


/***/ }),

/***/ 21429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useActionMenuPopper; },
/* harmony export */   "g": function() { return /* binding */ ActionMenuPopper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47310);
/* harmony import */ var _mui_icons_material_CloseRounded__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36191);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14564);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11057);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13665);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ActionMenuPopper_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56939);
/* harmony import */ var _ActionMenuPopper_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ActionMenuPopper_module_scss__WEBPACK_IMPORTED_MODULE_5__);












var actionMenuPopperAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .atom */ .cn)(undefined);
var ActionMenuPopper = function(param) {
    var className = param.className, extClasses = param.classes;
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_2__/* .mergeClassNames */ .E)((_ActionMenuPopper_module_scss__WEBPACK_IMPORTED_MODULE_5___default()), extClasses || {});
    /********************/ /*   custom hooks   */ /********************/ var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtom */ .KO)(actionMenuPopperAtom), 1), actionMenuPopper = ref[0];
    /********************/ /*     useState     */ /********************/ var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), open = ref1[0], setOpen = ref1[1];
    /********************/ /* useMemo & consts */ /********************/ var menuProps = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            open: open,
            placement: "left-start",
            classes: {
                paper: classes.paper
            },
            anchorOrigin: {
                vertical: "center",
                horizontal: "left"
            },
            transformOrigin: {
                vertical: "center",
                horizontal: "right"
            }
        }, (actionMenuPopper === null || actionMenuPopper === void 0 ? void 0 : actionMenuPopper.PopoverProps) || {});
    }, [
        open,
        actionMenuPopper,
        classes.paper
    ]);
    /********************/ /*    useCallback   */ /********************/ var handleClose = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackSafeRef */ .T)(function() {
        var ref, ref1;
        actionMenuPopper === null || actionMenuPopper === void 0 ? void 0 : (ref = actionMenuPopper.PopoverProps) === null || ref === void 0 ? void 0 : (ref1 = ref.onClose) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        setOpen(false);
    });
    var stopPropagation = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackSafeRef */ .T)(function(e) {
        e.stopPropagation();
        e.preventDefault();
    });
    /********************/ /*    useEffects    */ /********************/ (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (actionMenuPopper) setOpen(true);
    }, [
        actionMenuPopper
    ]);
    /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* .clsx */ .W)(classes.root, className)
    }, menuProps), {
        onClose: handleClose,
        onClick: stopPropagation,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes.content,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    onClick: handleClose,
                    className: classes.closeBtn,
                    color: "primary",
                    variant: "text",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_CloseRounded__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        fontSize: "small"
                    })
                }),
                (actionMenuPopper === null || actionMenuPopper === void 0 ? void 0 : actionMenuPopper.component) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(actionMenuPopper.component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    onClose: handleClose
                }, actionMenuPopper.props)) : null
            ]
        })
    }));
};
var useActionMenuPopper = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtom */ .KO)(actionMenuPopperAtom), 2), setActionMenuPopper = ref[1];
    return (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackSafeRef */ .T)(function(component, props, PopoverProps) {
        return setActionMenuPopper({
            component: component,
            props: props,
            PopoverProps: PopoverProps
        });
    });
};


/***/ }),

/***/ 64462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ EditionBadge; }
/* harmony export */ });
/* unused harmony export EditionBadgeContext */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _AppTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73916);
/* harmony import */ var _hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55004);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50084);
/* harmony import */ var _EditionBadgeBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55187);












var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .OPACITY_PULSE.keyframes */ .zd.keyframes), {
        root: {},
        loading: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .OPACITY_PULSE.elementStyles */ .zd.elementStyles), {
            width: 50
        })
    });
}, {
    classNamePrefix: "EditionBadge"
});
var EditionBadgeContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    tooltipOpen: false,
    setTooltipOpen: function() {
        return void 0;
    }
});
var EditionBadge = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var edition = _param.edition, className = _param.className, EditionBadgeBaseClasses = _param.EditionBadgeBaseClasses, showIfTrial = _param.showIfTrial, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "edition",
        "className",
        "EditionBadgeBaseClasses",
        "showIfTrial"
    ]);
    var classes = useStyles();
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(EditionBadgeContext), tooltipOpen = _$ref.tooltipOpen, setTooltipOpen = _$ref.setTooltipOpen;
    var userIsOnTrial = (0,_hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_3__/* .useSubscriptionLogic */ .Y)().userIsOnTrial;
    var handleTouchEndCapture = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (!tooltipOpen) {
            // preventDefault on touchEnd blocks click event
            e.preventDefault();
            e.stopPropagation();
            setTooltipOpen(true);
        } else setTooltipOpen(false);
    }, [
        setTooltipOpen,
        tooltipOpen
    ]);
    var loading = !edition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EditionBadgeBase__WEBPACK_IMPORTED_MODULE_5__/* .EditionBadgeBase */ .i, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        onTouchEndCapture: handleTouchEndCapture,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, classes.loading, loading)),
        paid: edition !== "LITE" && edition !== "ASSISTANT",
        classes: EditionBadgeBaseClasses,
        ref: ref
    }, rest), {
        children: edition ? function() {
            var _edition = _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_4__/* .EDITION_META */ .JZ[edition], label = _edition.label, isTrial = _edition.isTrial;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    label,
                    showIfTrial && (isTrial || userIsOnTrial) ? " trial" : ""
                ]
            });
        }() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: "\xa0"
        })
    }));
});
EditionBadge.displayName = "EditionBadge";


/***/ }),

/***/ 55187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ EditionBadgeBase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41796);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);









var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.typography.caption), {
            backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* .lighten */ .$n)(theme.colors.grey, 0.6),
            borderRadius: 4,
            color: theme.palette.text.primary,
            display: "inline-block",
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: "16px",
            padding: theme.spacing(0, 0.5),
            textTransform: "uppercase",
            pointerEvents: "auto",
            cursor: "default"
        }),
        paid: {
            backgroundColor: theme.colors.logo.corn
        },
        medium: {},
        small: {},
        slim: {}
    };
}, {
    classNamePrefix: "EditionBadgeBase"
});
var EditionBadgeBase = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, _size = _param.size, size = _size === void 0 ? "medium" : _size, paid = _param.paid, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "size",
        "paid",
        "children"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    var _obj;
    /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.paid, paid), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.medium, size === "medium"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.small, size === "small"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.slim, size === "slim"), _obj)),
        ref: ref
    }, rest), {
        children: children
    }));
});
EditionBadgeBase.displayName = "EditionBadgeBase";


/***/ }),

/***/ 56630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ EntitlementWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _api_team_Team__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72897);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34557);
/* harmony import */ var _components_ReasonTip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51375);
/* harmony import */ var _hooks_useEntitlementBadges__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43165);
/* harmony import */ var _hooks_useEntitlementContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69926);
/* harmony import */ var _hooks_useEntitlementLogic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37049);
/* harmony import */ var _utils_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63429);
/* harmony import */ var _PlanLockedMessage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76432);











var EntitlementWrapper = function(param) {
    var entitlement = param.entitlement, _mode = param.mode, mode = _mode === void 0 ? "usage" : _mode, children = param.children, _reasons = param.reasons, reasons = _reasons === void 0 ? [] : _reasons;
    /********************/ /*   custom hooks   */ /********************/ var ref = (0,_hooks_useEntitlementLogic__WEBPACK_IMPORTED_MODULE_6__/* .useEntitlementLogic */ .W)(entitlement), disableAdd = ref.disableAdd, disableUsage = ref.disableUsage, loading = ref.loading, entitlementIsInOverage = ref.entitlementIsInOverage, entitlementAddWouldBeOverage = ref.entitlementAddWouldBeOverage;
    var usageMessage = (0,_hooks_useEntitlementContent__WEBPACK_IMPORTED_MODULE_5__/* .useEntitlementContent */ .q)(entitlement, mode).usageMessage;
    var nextEditionBadge = (0,_hooks_useEntitlementBadges__WEBPACK_IMPORTED_MODULE_4__/* .useEntitlementBadges */ .y)(entitlement).nextEditionBadge;
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var chip = nextEditionBadge === null || nextEditionBadge === void 0 ? void 0 : nextEditionBadge();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_components_ReasonTip__WEBPACK_IMPORTED_MODULE_3__/* .evaluateReason */ .H)([
        {
            test: loading,
            message: "One moment..."
        },
        {
            test: entitlementAddWouldBeOverage && disableAdd && mode === "add",
            message: usageMessage ? usageMessage : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "You cannot do this because it would put you over the limit of your current plan.",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
                        href: (0,_utils_router__WEBPACK_IMPORTED_MODULE_7__/* .getBillingUrl */ .uN)(_api_team_Team__WEBPACK_IMPORTED_MODULE_1__/* .TeamRedirectAction.StartPurchase */ .Pt.StartPurchase),
                        children: "Upgrade now"
                    }),
                    " to unlock."
                ]
            })
        },
        {
            test: entitlementIsInOverage && disableUsage && mode === "usage",
            message: usageMessage ? usageMessage : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "We've limited access to this feature because you're over the limit on your current plan.",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
                        href: (0,_utils_router__WEBPACK_IMPORTED_MODULE_7__/* .getBillingUrl */ .uN)(_api_team_Team__WEBPACK_IMPORTED_MODULE_1__/* .TeamRedirectAction.StartPurchase */ .Pt.StartPurchase),
                        children: "Upgrade now"
                    }),
                    " to unlock."
                ]
            })
        },
        // If we don't trigger the first reason, but
        // `disableUsage` is still true, it's because
        // something else is in overage...
        {
            test: !!disableUsage,
            message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PlanLockedMessage__WEBPACK_IMPORTED_MODULE_8__/* .PlanLockedMessage */ .r, {})
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(reasons))), 2), disabled = ref1[0], message = ref1[1];
    /********************/ /*    useCallback   */ /********************/ /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children({
            chip: chip,
            disabled: disabled,
            message: message
        })
    });
};


/***/ }),

/***/ 76432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ PlanLockedMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11057);
/* harmony import */ var _modals_OverageModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(414);
/* harmony import */ var _PlanLockedMessage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72245);
/* harmony import */ var _PlanLockedMessage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PlanLockedMessage_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var PlanLockedMessage = function() {
    var openOverageModal = (0,_modals_OverageModal__WEBPACK_IMPORTED_MODULE_1__/* .useOverageModal */ .uL)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "You're using more features than your plan allows.",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                onClick: function() {
                    return openOverageModal();
                },
                className: (_PlanLockedMessage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fixButton),
                children: "fix it"
            })
        ]
    });
};


/***/ }),

/***/ 23878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ SeePlansButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18979);
/* harmony import */ var _hooks_atoms_useTeam__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10352);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);
/* harmony import */ var _hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55004);
/* harmony import */ var _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72897);
/* harmony import */ var _ButtonWithLinkVariant__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78086);
/* harmony import */ var _modals_PurchaseModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48566);













var SeePlansButton = function(_param) {
    var children = _param.children, onClick = _param.onClick, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "children",
        "onClick"
    ]);
    /********************/ /*   custom hooks   */ /********************/ var ref = (0,_hooks_atoms_useTeam__WEBPACK_IMPORTED_MODULE_1__/* .useTeamState */ .Oo)(), team = ref.team, userMembership = ref.userMembership;
    var hasActiveSubscription = (0,_hooks_useSubscriptionLogic__WEBPACK_IMPORTED_MODULE_3__/* .useSubscriptionLogic */ .Y)().hasActiveSubscription;
    var openPurchaseModal = (0,_modals_PurchaseModal__WEBPACK_IMPORTED_MODULE_6__/* .usePurchaseModal */ .u)();
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var isAdmin = userMembership.membershipRole === _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_4__/* .MembershipRole.Admin */ .nJ.Admin;
    /********************/ /*    useCallback   */ /********************/ var handleClick = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(e) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
                openPurchaseModal();
                return [
                    2
                ];
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }());
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ButtonWithLinkVariant__WEBPACK_IMPORTED_MODULE_5__/* .ButtonWithLinkVariant */ .s, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        variant: "contained",
        color: "primary",
        size: "small"
    }, rest), {
        onClick: handleClick,
        children: function() {
            if (children) return children;
            if (!team) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                variant: "rectangular",
                width: 50
            });
            if (isAdmin) {
                if (hasActiveSubscription) return "Change plan";
                else return "Purchase";
            } else return "See plans";
        }()
    }));
};


/***/ }),

/***/ 14108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ getPlanDetails; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);

var TEAM_FEATURES = [
    "Auto-schedule 1:1s",
    "Integrate your tasks & projects",
    "Manage your team's workload"
];
var getPlanDetails = function(edition, terminalEdition) {
    switch(edition){
        case "PRO":
            return [
                "Unlimited Habits",
                "Customize your time blocks",
                "Sync unlimited calendars"
            ];
        case "TRIAL":
            if (terminalEdition !== "TEAM") return [
                "Use Team features for a limited time"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES));
            else return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES);
        case "TRIAL_BUSINESS":
            if (terminalEdition !== "BUSINESS") return [
                "Use Business features for a limited time"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES));
            else return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES);
        case "REWARD":
            return [
                "Use Team features while on reward credits"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES));
        case "TEAM_REWARD":
            return [
                "Use Business features while on reward credits"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES));
        case "TEAM":
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES);
        case "STARTER":
            return [
                "Manage a small team"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES));
        case "BUSINESS":
            return [
                "Manage a large team",
                "Unlimited habits, calendars, scheduling links"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES));
        case "ENTERPRISE":
            return [
                "Unlimited team size",
                "Priority support",
                "Unlimited everything"
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(TEAM_FEATURES));
        case "LITE":
        case "ASSISTANT":
        default:
            return [
                "Block flexible time for anything",
                "Sync your personal + work calendar",
                "Manage your schedule via Slack", 
            ];
    }
};


/***/ }),

/***/ 414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uL": function() { return /* binding */ useOverageModal; }
});

// UNUSED EXPORTS: OverageModal, OverageModalError

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(25892);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/CloseRounded.js
"use client";



/* harmony default export */ var CloseRounded = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
}), 'CloseRounded'));
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/mui-modal-provider/dist/mui-modal-provider.esm.js
var mui_modal_provider_esm = __webpack_require__(56566);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/components/modal/Modal.tsx
var Modal = __webpack_require__(52127);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(53219);
// EXTERNAL MODULE: ./src/hooks/atoms/useTeam.ts
var useTeam = __webpack_require__(10352);
// EXTERNAL MODULE: ./src/hooks/useIntegrationsEnabledMap.ts
var useIntegrationsEnabledMap = __webpack_require__(74194);
// EXTERNAL MODULE: ./src/hooks/useRecommendedEdition.ts
var useRecommendedEdition = __webpack_require__(5061);
// EXTERNAL MODULE: ./src/hooks/useSubscriptionOptions.ts
var useSubscriptionOptions = __webpack_require__(53316);
// EXTERNAL MODULE: ./src/hooks/useUsageData.ts + 1 modules
var useUsageData = __webpack_require__(38539);
// EXTERNAL MODULE: ./src/img/send-icon.svg
var send_icon = __webpack_require__(94934);
// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 16 modules
var reclaim_api = __webpack_require__(54517);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.ts
var Team = __webpack_require__(72897);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.consts.ts
var Team_consts = __webpack_require__(50084);
// EXTERNAL MODULE: ./src/utils/router.ts
var router = __webpack_require__(63429);
// EXTERNAL MODULE: ./src/components/forms/AsyncButton.tsx
var AsyncButton = __webpack_require__(5062);
// EXTERNAL MODULE: ./src/components/forms/RadioBox.tsx
var RadioBox = __webpack_require__(37515);
// EXTERNAL MODULE: ./src/components/forms/RadioBoxGroupControl.tsx
var RadioBoxGroupControl = __webpack_require__(77478);
// EXTERNAL MODULE: ./src/components/TextSkeleton.tsx
var TextSkeleton = __webpack_require__(17132);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 1 modules
var ListItem = __webpack_require__(19294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(18979);
// EXTERNAL MODULE: ./src/hooks/useSubscriptionLogic.ts
var useSubscriptionLogic = __webpack_require__(55004);
// EXTERNAL MODULE: ./src/utils/strings.ts + 1 modules
var strings = __webpack_require__(84467);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
// EXTERNAL MODULE: ./src/reclaim-api/Integrations.consts.tsx + 10 modules
var Integrations_consts = __webpack_require__(57502);
// EXTERNAL MODULE: ./src/utils/arrays.ts
var arrays = __webpack_require__(92886);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
;// CONCATENATED MODULE: ./src/components/billing/OverageListIntegrationsSubList.tsx













var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        skeleton: {
            width: "60%",
            height: "1.5em"
        },
        list: {},
        listItem: {
            display: "list-item",
            marginLeft: theme.spacing(2),
            padding: theme.spacing(0.5, 0),
            "&::before": {
                content: "'• '"
            }
        }
    };
}, {
    classNamePrefix: "OverageListIntegrationsSubList"
});
var OverageListIntegrationsSubList = function(param) {
    var className = param.className, extClasses = param.classes;
    var classes = useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var usageData = (0,useUsageData/* useUsageData */.L)().usageData;
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), user = ref[0].user;
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var mustBeDisabled = (0,react.useMemo)(function() {
        return usageData && (0,arrays/* filterFalsy */.SY)((0,objects/* typedKeys */.Nw)(Integrations_consts/* INTEGRATIONS_META */.so).map(function(integration) {
            var integrationActuals = usageData.actuals[Integrations_consts/* INTEGRATIONS_META */.so[integration].entitlement];
            return !!integrationActuals && integrationActuals.actualValue && !integrationActuals.allowedValueForCurrentEdition && integration;
        }));
    }, [
        usageData
    ]);
    /********************/ /*    useCallback   */ /********************/ /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: !usageData || !user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: classes.skeleton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: classes.skeleton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: classes.skeleton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: classes.skeleton
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Disconnect the following integrations:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    className: classes.list,
                    children: mustBeDisabled === null || mustBeDisabled === void 0 ? void 0 : mustBeDisabled.map(function(integration) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            className: classes.listItem,
                            children: Integrations_consts/* INTEGRATIONS_META */.so[integration].label({
                                router: router,
                                user: user
                            })
                        }, integration);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useMemoizedPromise.ts
var useMemoizedPromise = __webpack_require__(61910);
// EXTERNAL MODULE: ./src/reclaim-api/CalendarSyncPolicy.ts
var CalendarSyncPolicy = __webpack_require__(6774);
// EXTERNAL MODULE: ./src/utils/typescript.ts
var typescript = __webpack_require__(66201);
;// CONCATENATED MODULE: ./src/components/billing/OverageListCustomBlockingSubList.tsx














var OverageListCustomBlockingSubList_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        skeleton: {
            width: "60%",
            height: "1.5em"
        },
        list: {
            listStyleType: "circle",
            margin: 0,
            padding: 0
        },
        listItem: {
            display: "list-item",
            marginLeft: theme.spacing(2),
            padding: theme.spacing(0.5, 0),
            "& .MuiMenuItem-root": {
                display: "list-item",
                marginLeft: theme.spacing(2),
                padding: 0
            }
        },
        subList: {
            marginTop: theme.spacing(0.5),
            padding: 0
        },
        subListItem: {
            padding: 0
        },
        subLink: {
            paddingRight: theme.spacing(2),
            wordBreak: "break-word"
        }
    };
}, {
    classNamePrefix: "OverageListCustomBlockingSubList"
});
var CUSTOM_BLOCKING_ENTITLEMENTS = (0,typescript/* satisfies */.L5)()([
    "CUSTOM_BLOCKING_DECOMPRESSION",
    "CUSTOM_BLOCKING_HABITS",
    "CUSTOM_BLOCKING_CALENDAR_SYNC", 
]);
var OVERAGE_LIST_CUSTOM_BLOCKING_SUB_LIST_META = {
    CUSTOM_BLOCKING_DECOMPRESSION: {
        SubComp: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Decompression in\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        href: (0,router/* getGeneralSettingsUrl */.Hg)("decompression"),
                        children: "General Settings"
                    })
                ]
            });
        }
    },
    CUSTOM_BLOCKING_HABITS: {
        SubComp: function() {
            var ref = (0,_sliced_to_array/* default */.Z)((0,useMemoizedPromise/* useMemoizedPromise */.Z)(function() {
                return reclaim_api/* reclaim.habits.list */.Tz.habits.list();
            }, []), 1), habits = ref[0];
            var classes = OverageListCustomBlockingSubList_useStyles();
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Visibility in the following Habits:",
                    habits ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        className: classes.subList,
                        children: habits.map(function(param) {
                            var alwaysPrivate = param.alwaysPrivate, id = param.id, title = param.title, enabled = param.enabled;
                            return enabled && alwaysPrivate && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                className: classes.subListItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    href: (0,router/* getHabitEditUrl */.L5)(id, "custom-visibility"),
                                    className: classes.subLink,
                                    children: title
                                })
                            }, id);
                        })
                    }) : "..."
                ]
            });
        }
    },
    CUSTOM_BLOCKING_CALENDAR_SYNC: {
        SubComp: function() {
            var ref = (0,_sliced_to_array/* default */.Z)((0,useMemoizedPromise/* useMemoizedPromise */.Z)(function() {
                return reclaim_api/* reclaim.calendarSyncPolicies.list */.Tz.calendarSyncPolicies.list();
            }, []), 1), syncs = ref[0];
            var classes = OverageListCustomBlockingSubList_useStyles();
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Visibility in the following Calendar Syncs:",
                    syncs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        className: classes.subList,
                        children: syncs.map(function(param) {
                            var targetCalendarId = param.targetCalendarId, sourceCalendarId = param.sourceCalendarId, sourceCalendar = param.sourceCalendar, targetCalendar = param.targetCalendar, transparency = param.transparency, enabled = param.enabled;
                            return enabled && sourceCalendar && targetCalendar && transparency !== CalendarSyncPolicy/* SyncTransparency.Default */.X3.Default && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                className: classes.subListItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                    className: classes.subLink,
                                    href: (0,router/* getSyncUrl */.YA)(sourceCalendarId, targetCalendarId, "custom-visibility"),
                                    children: [
                                        sourceCalendar.name,
                                        " → ",
                                        targetCalendar.name
                                    ]
                                })
                            }, (0,router/* getSyncUrlId */.em)(sourceCalendarId, targetCalendarId));
                        })
                    }) : "..."
                ]
            });
        }
    }
};
var OverageListCustomBlockingSubList = function(param) {
    var className = param.className, extClasses = param.classes;
    var classes = OverageListCustomBlockingSubList_useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var usageData = (0,useUsageData/* useUsageData */.L)().usageData;
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: !usageData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: classes.skeleton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: classes.skeleton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: classes.skeleton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    className: classes.skeleton
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You have custom blocking enabled in the following places:",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    className: classes.list,
                    children: CUSTOM_BLOCKING_ENTITLEMENTS.map(function(entitlement) {
                        var actuals = usageData.actuals[entitlement];
                        if (!actuals) return;
                        var actualValue = actuals.actualValue, allowedValueForCurrentEdition = actuals.allowedValueForCurrentEdition;
                        var comparator = Team_consts/* ENTITLEMENT_META */.mm[entitlement].comparator;
                        return comparator(actualValue, allowedValueForCurrentEdition) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            className: classes.listItem,
                            children: /*#__PURE__*/ (0,react.createElement)(OVERAGE_LIST_CUSTOM_BLOCKING_SUB_LIST_META[entitlement].SubComp, {})
                        }, entitlement);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/billing/OverageList.consts.tsx






var OVERAGE_LIST_ENTITLEMENT_ORDER = Object.freeze([
    "TEAM_SIZE",
    "MAX_SCHEDULING_LINKS",
    "MAX_HABITS",
    "MAX_SYNCS",
    "SCHEDULER_WEEKS",
    "MAX_CALENDARS",
    "MAX_TASKS",
    "MAX_CUSTOM_TIME_SCHEMES",
    "CUSTOM_BLOCKING",
    "MAX_1_ON_1_ORGANIZE",
    "MAX_1_ON_1_ATTEND",
    "INTEGRATIONS",
    "SUPPORT",
    "SSO", 
]);
var pluralizeEntitlementObject = function(param, noun, url) {
    var actualValue = param.actualValue, allowedValueForCurrentEdition = param.allowedValueForCurrentEdition;
    var pluralized = (0,strings/* pluralize */._6)(actualValue - allowedValueForCurrentEdition, noun);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                children: actualValue - allowedValueForCurrentEdition
            }),
            " ",
            url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: url,
                children: pluralized
            }) : pluralized
        ]
    });
};
var disableOrRemoveStr = function(noun, url) {
    return function(obj) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Disable or remove ",
                pluralizeEntitlementObject(obj, noun, url)
            ]
        });
    };
};
var removeStr = function(noun, url) {
    return function(obj) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Remove ",
                pluralizeEntitlementObject(obj, noun, url)
            ]
        });
    };
};
var OVERAGE_LIST_ENTITLEMENT_META = {
    MAX_SCHEDULING_LINKS: {
        render: disableOrRemoveStr("Scheduling Link", (0,router/* getSchedulingLinksUrl */.E5)())
    },
    MAX_HABITS: {
        render: disableOrRemoveStr("Habit", (0,router/* getHabitsPath */.MX)())
    },
    MAX_CUSTOM_TIME_SCHEMES: {
        render: removeStr("Custom Hour", (0,router/* getHoursUrl */.Lc)())
    },
    MAX_SYNCS: {
        render: disableOrRemoveStr("Calendar Sync", (0,router/* getSyncHomeUrl */.ug)())
    },
    MAX_CALENDARS: {
        render: removeStr("Connected Calendar", "/settings/accounts")
    },
    MAX_TASKS: {
        render: disableOrRemoveStr("Task", "/tasks")
    },
    CUSTOM_BLOCKING: {
        render: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OverageListCustomBlockingSubList, {});
        }
    },
    MAX_1_ON_1_ORGANIZE: {
        render: disableOrRemoveStr("Smart 1:1", "/one-on-ones")
    },
    MAX_1_ON_1_ATTEND: {
        render: disableOrRemoveStr("Smart 1:1", "/one-on-ones")
    },
    INTEGRATIONS: {
        render: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OverageListIntegrationsSubList, {});
        }
    }
};

;// CONCATENATED MODULE: ./src/components/billing/OverageList.tsx











var OverageList_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            listStyleType: "disc",
            margin: theme.spacing(0, 0, 0, 2)
        },
        listItem: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.body2), {
            display: "list-item",
            padding: theme.spacing(0.25, 0),
            "& em": {
                background: theme.palette.primary.main,
                color: theme.colors.white,
                fontWeight: "bold",
                fontSize: "0.8em"
            }
        }),
        listItemHighlighted: {
            fontWeight: theme.typography.fontWeightBold
        }
    };
}, {
    classNamePrefix: "OverageList"
});
var OverageList = function(param) {
    var className = param.className, extClasses = param.classes, highlightedEntitlement = param.highlightedEntitlement;
    var classes = OverageList_useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var usageData = (0,useUsageData/* useUsageData */.L)().usageData;
    var userCurrentEdition = (0,useSubscriptionLogic/* useSubscriptionLogic */.Y)().userCurrentEdition;
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: !usageData || !userCurrentEdition ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    className: classes.listItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 80,
                        variant: "text"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    className: classes.listItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 90,
                        variant: "text"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    className: classes.listItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 70,
                        variant: "text"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: OVERAGE_LIST_ENTITLEMENT_ORDER.map(function(entitlement) {
                var ref;
                var entObj = usageData.actuals[entitlement];
                var comparator = Team_consts/* ENTITLEMENT_META */.mm[entitlement].comparator;
                var meta = OVERAGE_LIST_ENTITLEMENT_META[entitlement];
                if (!meta) return;
                var render = (ref = OVERAGE_LIST_ENTITLEMENT_META[entitlement]) === null || ref === void 0 ? void 0 : ref.render;
                if (!render || entObj === undefined || comparator(entObj.allowedValueForCurrentEdition, entObj.actualValue) >= 0) return;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    className: (0,clsx_m/* default */.Z)(classes.listItem, (0,_define_property/* default */.Z)({}, classes.listItemHighlighted, entitlement === highlightedEntitlement)),
                    children: render(entObj, userCurrentEdition)
                }, entitlement);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/billing/SeePlansButton.tsx
var SeePlansButton = __webpack_require__(23878);
;// CONCATENATED MODULE: ./src/components/billing/OverageOMatic.tsx
























var OverageOMatic_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            textAlign: "center",
            "& > h1, & > h2, & > h3, & > h4, & > h5, & > h6": {
                marginBottom: theme.spacing()
            },
            "& > p": {
                marginBottom: theme.spacing(3)
            }
        },
        radioGroup: {
            textAlign: "left"
        },
        actionButton: {
            margin: theme.spacing(1, 0, 2)
        }
    };
}, {
    classNamePrefix: "OverageOMatic"
});
var OverageOMatic = function(param) {
    var className = param.className, extClasses = param.classes, onComplete = param.onComplete;
    var classes = OverageOMatic_useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var ref = (0,useTeam/* useTeamState */.Oo)(), team = ref.team, userMembership = ref.userMembership;
    var ref1 = (0,useSubscriptionOptions/* useSubscriptionOptions */.g)(team.membershipSummary.paidCount), subscriptionOptions = ref1.subscriptionOptions, editions = ref1.editions;
    var recommendedEdition = (0,useRecommendedEdition/* useRecommendedEdition */.y)(team.membershipSummary.paidCount, editions, subscriptionOptions).recommendedEdition;
    var reloadUsageData = (0,useUsageData/* useUsageData */.L)().reloadUsageData;
    var reloadIntegrationsEnabledMap = (0,useIntegrationsEnabledMap/* useIntegrationsEnabledMap */.X)().reloadIntegrationsEnabledMap;
    /********************/ /*     useState     */ /********************/ var ref2 = (0,react.useState)("request"), selection = ref2[0], setSelection = ref2[1];
    /********************/ /* useMemo & consts */ /********************/ var admins = (0,react.useMemo)(function() {
        return team.members.filter(function(param) {
            var membershipRole = param.membershipRole;
            return membershipRole === Team/* MembershipRole.Admin */.nJ.Admin;
        });
    }, [
        team.members
    ]);
    var userIsAdmin = userMembership.membershipRole === Team/* MembershipRole.Admin */.nJ.Admin;
    /********************/ /*    useCallback   */ /********************/ var handleChange = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(param) {
        var value = param.target.value;
        return setSelection(value);
    });
    var emailAdmins = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (!admins) return;
        var recipients = admins.map(function(param) {
            var email = param.email;
            return email;
        });
        window.open((0,router/* getMailtoUrl */.B$)(recipients));
    });
    var downgradeHardly = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reclaim_api/* reclaim.users.downgradeHardly */.Tz.users.downgradeHardly()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        reloadUsageData()
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        reloadIntegrationsEnabledMap()
                    ];
                case 3:
                    _state.sent();
                    onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                    window.location.reload();
                    return [
                        2
                    ];
            }
        });
    }));
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                children: "Fix your account"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "Your account is limited because you still have some features enabled that are outside of your plan limit.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Here are your options:"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioBoxGroupControl/* RadioBoxGroupControl */.e, {
                onChange: handleChange,
                value: selection,
                className: classes.radioGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioBox/* RadioBox */.X, {
                        value: "request",
                        header: "Upgrade your plan",
                        checkedContent: userIsAdmin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        "Move to the",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* TextSkeleton */.Q, {
                                            text: recommendedEdition && Team_consts/* EDITION_META */.JZ[recommendedEdition].label,
                                            placeholderText: "Starter"
                                        }),
                                        " ",
                                        "plan to unlock more scheduling power."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SeePlansButton/* SeePlansButton */.u, {
                                    className: classes.actionButton,
                                    onClick: onComplete,
                                    children: "See plans"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    children: "Reclaim can send your team admin a note letting them know that you'd like to keep your paid features by upgrading your account."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    className: classes.actionButton,
                                    color: "primary",
                                    onClick: emailAdmins,
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(send_icon/* default */.Z, {})
                                    }),
                                    size: "small",
                                    children: "Send note"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioBox/* RadioBox */.X, {
                        value: "disable",
                        header: "Manually disable feature overage",
                        checkedContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    children: "Here's what you'll need to do to fix your account:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OverageList, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioBox/* RadioBox */.X, {
                        value: "downgrade",
                        header: "Automatically disable feature overage",
                        checkedContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    children: "Reclaim can disable these features for you, though it may not choose exactly what you would want to disable."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                                    className: classes.actionButton,
                                    variant: "contained",
                                    color: "primary",
                                    onClick: downgradeHardly,
                                    size: "small",
                                    children: "Disable for me"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/billing/modals/OverageModal.tsx


















var OverageModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            zIndex: 10000
        },
        paper: (0,_define_property/* default */.Z)({
            padding: theme.spacing(5, 2)
        }, theme.breakpoints.up("sm"), {
            padding: theme.spacing(5)
        }),
        closeBtn: {
            position: "absolute",
            top: theme.spacing(),
            right: theme.spacing()
        }
    };
}, {
    classNamePrefix: "OverageModal"
});
var OverageModalError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(OverageModalError, Error1);
    var _super = (0,_create_super/* default */.Z)(OverageModalError);
    function OverageModalError() {
        (0,_class_call_check/* default */.Z)(this, OverageModalError);
        return _super.apply(this, arguments);
    }
    return OverageModalError;
}((0,_wrap_native_super/* default */.Z)(Error));
var OverageModal = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, ModalClasses = _param.ModalClasses, closeModal = _param.closeModal, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "classes",
        "ModalClasses",
        "closeModal"
    ]);
    var classes = OverageModal_useStyles({
        classes: extClasses
    });
    var theme = (0,useTheme/* default */.Z)();
    var small = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    /********************/ /*   custom hooks   */ /********************/ /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(className, classes.root),
        classes: {
            paper: classes.paper
        },
        ref: ref,
        fullWidth: true,
        fullScreen: small,
        maxWidth: "sm",
        onClose: closeModal
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                className: classes.closeBtn,
                onClick: closeModal,
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseRounded, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverageOMatic, {
                onComplete: closeModal
            })
        ]
    }));
});
var useOverageModal = function() {
    var showModal = (0,mui_modal_provider_esm/* useModal */.d)().showModal;
    return (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(props) {
        var closeModal = showModal(OverageModal, (0,_object_spread/* default */.Z)({
            closeModal: function() {
                return closeModal();
            }
        }, props)).hide;
    });
};


/***/ }),

/***/ 48566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ usePurchaseModal; }
});

// UNUSED EXPORTS: PurchaseModal

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/mui-modal-provider/dist/mui-modal-provider.esm.js
var mui_modal_provider_esm = __webpack_require__(56566);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/atoms/useTeam.ts
var useTeam = __webpack_require__(10352);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/components/modal/Modal.tsx
var Modal = __webpack_require__(52127);
// EXTERNAL MODULE: ./src/components/modal/ModalCloseButton.tsx
var ModalCloseButton = __webpack_require__(83501);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandLessRounded.js
var ExpandLessRounded = __webpack_require__(23241);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMoreRounded.js
var ExpandMoreRounded = __webpack_require__(40876);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Phone.js
var Phone = __webpack_require__(11145);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(18979);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./src/AppTheme.ts + 1 modules
var AppTheme = __webpack_require__(73916);
// EXTERNAL MODULE: ./src/consts/date.consts.ts
var date_consts = __webpack_require__(76140);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/hooks/useDateTimeFormatter.ts + 2 modules
var useDateTimeFormatter = __webpack_require__(62495);
// EXTERNAL MODULE: ./src/hooks/useElementRect.ts
var useElementRect = __webpack_require__(71360);
// EXTERNAL MODULE: ./src/hooks/useSubscriptionLogic.ts
var useSubscriptionLogic = __webpack_require__(55004);
// EXTERNAL MODULE: ./src/img/warning-icon.svg
var warning_icon = __webpack_require__(13294);
// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 16 modules
var reclaim_api = __webpack_require__(54517);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.consts.ts
var Team_consts = __webpack_require__(50084);
// EXTERNAL MODULE: ./node_modules/@depay/local-currency/dist/esm/index.js
var esm = __webpack_require__(38951);
;// CONCATENATED MODULE: ./src/utils/i18n.ts


/**
 * Formats a dollar amount - adding a dollar sign,
 * ensuring there are exactly 2 decimal places,
 * and adding commas
 * https://stackoverflow.com/questions/5340530/how-to-format-a-dollar
 * @param amount an amount of money as a number
 * @returns a formatted string
 */ function formatDollarAmount(amount) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var hidePenniesForEvenDollars = options.hidePenniesForEvenDollars, _currency = options.currency, currency = _currency === void 0 ? "USD" : _currency;
    return new Intl.NumberFormat(date_consts/* BROWSER_LOCALE */.MT, {
        style: "currency",
        currency: currency,
        maximumFractionDigits: hidePenniesForEvenDollars && amount === Math.floor(amount) ? 0 : 2
    }).format(amount);
}
var timeZoneToCurrency = function(timeZone) {
    return Currency.getCode(timeZone);
};

// EXTERNAL MODULE: ./src/utils/strings.ts + 1 modules
var strings = __webpack_require__(84467);
// EXTERNAL MODULE: ./src/utils/team.ts
var utils_team = __webpack_require__(10016);
// EXTERNAL MODULE: ./src/components/ConfirmDialog.tsx
var ConfirmDialog = __webpack_require__(64218);
// EXTERNAL MODULE: ./src/components/ContactSupportButton.tsx
var ContactSupportButton = __webpack_require__(8137);
// EXTERNAL MODULE: ./src/components/forms/StrongSelect.tsx
var StrongSelect = __webpack_require__(25973);
// EXTERNAL MODULE: ./src/components/GenericInfoMessage.tsx
var GenericInfoMessage = __webpack_require__(33249);
// EXTERNAL MODULE: ./src/components/Helptip.tsx + 1 modules
var Helptip = __webpack_require__(21405);
// EXTERNAL MODULE: ./src/components/MiniRadioGroup.tsx
var MiniRadioGroup = __webpack_require__(27165);
// EXTERNAL MODULE: ./src/components/quests/QuestStepWrapper.tsx + 3 modules
var QuestStepWrapper = __webpack_require__(60022);
// EXTERNAL MODULE: ./src/components/ReasonTip.tsx
var ReasonTip = __webpack_require__(51375);
// EXTERNAL MODULE: ./src/components/TextSkeleton.tsx
var TextSkeleton = __webpack_require__(17132);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(53184);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(53816);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(53252);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./src/hooks/useEntitlementTable.ts
var useEntitlementTable = __webpack_require__(12143);
// EXTERNAL MODULE: ./src/hooks/useUsageData.ts + 1 modules
var useUsageData = __webpack_require__(38539);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.utils.ts
var Team_utils = __webpack_require__(13811);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./src/components/Tooltip.tsx
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./src/utils/typescript.ts
var typescript = __webpack_require__(66201);
;// CONCATENATED MODULE: ./src/components/billing/EntitlementTable.consts.tsx



var numToStr = function(num) {
    return num === Infinity ? "Unlimited" : "".concat(num);
};
var renderNumValueWithNoun = function(value, noun) {
    return "".concat(numToStr(value), " ").concat((0,strings/* pluralize */._6)(value, noun));
};
var renderNumValueWithMax = function(param, noun) {
    var value = param.value;
    return "".concat(noun ? renderNumValueWithNoun(value, noun) : numToStr(value));
};
var ENTITLEMENT_TABLE_SHORT_LIST_LENGTH = 7;
var ENTITLEMENT_TABLE_ENTITLEMENT_ORDER = (0,typescript/* satisfies */.L5)()([
    "TEAM_SIZE",
    "TEAM_ANALYTICS",
    "MAX_SCHEDULING_LINKS",
    "MAX_HABITS",
    "MAX_SYNCS",
    "SCHEDULER_WEEKS",
    "MAX_CALENDARS",
    "MAX_TASKS",
    "MAX_CUSTOM_TIME_SCHEMES",
    "CUSTOM_BLOCKING",
    "MAX_1_ON_1_ORGANIZE",
    "MAX_1_ON_1_ATTEND",
    "INTEGRATIONS",
    "SUPPORT",
    "SSO", 
]);
var ENTITLEMENT_TABLE_ENTITLEMENT_META = {
    TEAM_SIZE: {
        microValueRenderer: function(param) {
            var _value = param.value, min = _value.min, max = _value.max;
            if (min === 1 && max === Infinity) return "Unlimited";
            if (min !== 1 && max === Infinity) return "".concat(min, "+");
            if (min === 1 && max !== Infinity) return "Up to ".concat(max);
            return "".concat(min, " - ").concat(max);
        },
        valueRenderer: function(param) {
            var _value = param.value, min = _value.min, max = _value.max;
            if (min === 1 && max === Infinity) return "Unlimited users";
            if (min !== 1 && max === Infinity) return "".concat(min, "+ ").concat((0,strings/* pluralize */._6)(min, "user"));
            if (min === 1 && max !== Infinity) return "Up to ".concat(max, " ").concat((0,strings/* pluralize */._6)(max, "user"));
            return "Between ".concat(min, " and ").concat(max, " ").concat((0,strings/* pluralize */._6)(max, "user"));
        },
        actualRenderer: function(param) {
            var max = param.max;
            return max && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You have ",
                    renderNumValueWithNoun(max, "Team Member")
                ]
            });
        }
    },
    SCHEDULER_WEEKS: {
        valueRenderer: function(param) {
            var value = param.value;
            return "".concat(renderNumValueWithNoun(value, "week"), " out");
        }
    },
    MAX_TASKS: {
        microValueRenderer: function(obj) {
            return renderNumValueWithMax(obj);
        },
        valueRenderer: function(param) {
            var value = param.value;
            return renderNumValueWithNoun(value, "Task");
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You have ",
                    renderNumValueWithNoun(value, "Task")
                ]
            });
        }
    },
    MAX_CALENDARS: {
        microValueRenderer: function(obj) {
            return renderNumValueWithMax(obj);
        },
        valueRenderer: function(param) {
            var value = param.value;
            return renderNumValueWithNoun(value, "Connected Calendar");
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You have ",
                    renderNumValueWithNoun(value, "Connected Calendar")
                ]
            });
        }
    },
    MAX_SYNCS: {
        microValueRenderer: function(obj) {
            return renderNumValueWithMax(obj);
        },
        valueRenderer: function(param) {
            var value = param.value;
            return renderNumValueWithNoun(value, "Calendar Sync");
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You have ",
                    renderNumValueWithNoun(value, "Calendar Sync")
                ]
            });
        }
    },
    MAX_HABITS: {
        microValueRenderer: function(obj) {
            return renderNumValueWithMax(obj);
        },
        valueRenderer: function(param) {
            var value = param.value;
            return renderNumValueWithNoun(value, "Habit");
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You have ",
                    renderNumValueWithNoun(value, "Habit")
                ]
            });
        }
    },
    MAX_CUSTOM_TIME_SCHEMES: {
        microValueRenderer: function(obj) {
            return renderNumValueWithMax(obj);
        },
        valueRenderer: function(param) {
            var value = param.value;
            return renderNumValueWithNoun(value, "Custom hours");
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You have ",
                    renderNumValueWithNoun(value, "Custom hours")
                ]
            });
        }
    },
    CUSTOM_BLOCKING: {
        valueRenderer: function(param) {
            var value = param.value;
            return value ? "Custom" : "Basic";
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "You're using Custom Blocking"
            });
        }
    },
    MAX_SCHEDULING_LINKS: {
        microValueRenderer: function(obj) {
            return renderNumValueWithMax(obj);
        },
        valueRenderer: function(param) {
            var value = param.value;
            return renderNumValueWithNoun(value, "Scheduling Link");
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You have ",
                    renderNumValueWithNoun(value, "Scheduling Link")
                ]
            });
        }
    },
    MAX_1_ON_1_ORGANIZE: {
        microValueRenderer: function(obj) {
            return renderNumValueWithMax(obj);
        },
        valueRenderer: function(obj) {
            return renderNumValueWithMax(obj, "Smart 1:1");
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You have ",
                    renderNumValueWithNoun(value, "Smart 1:1")
                ]
            });
        }
    },
    MAX_1_ON_1_ATTEND: {
        microValueRenderer: function(obj) {
            return renderNumValueWithMax(obj);
        },
        valueRenderer: function(obj) {
            return renderNumValueWithMax(obj, "Smart 1:1");
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "You're attending ",
                    renderNumValueWithNoun(value, "Smart 1:1")
                ]
            });
        }
    },
    INTEGRATIONS: {
        valueRenderer: function(param) {
            var value = param.value;
            return (0,strings/* ucfirst */.Ps)(value);
        }
    },
    TEAM_ANALYTICS: {
        microValueRenderer: function(param) {
            var value = param.value;
            return value ? "Included" : "–";
        },
        valueRenderer: function(param) {
            var value = param.value;
            return value ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Team\xa0Analytics ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "included"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Team\xa0Analytics ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "not\xa0included"
                    })
                ]
            });
        }
    },
    SUPPORT: {
        valueRenderer: function(param) {
            var value = param.value;
            return (0,strings/* ucfirst */.Ps)(value);
        }
    },
    SSO: {
        valueRenderer: function(param) {
            var value = param.value;
            return value ? "Included" : "–";
        },
        actualRenderer: function(value) {
            return value && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "You're using SSO"
            });
        }
    }
};

;// CONCATENATED MODULE: ./src/components/billing/EntitlementTable.tsx





















var BORDER_RADIUS_MULTIPLIER = 1;
var EVEN_ROW_BG_COLOR = function(theme) {
    return (0,colorManipulator/* alpha */.Fq)(theme.colors.bgGrey, 1);
};
var EVEN_ROW_SELECTED_BG_COLOR = function(theme) {
    return (0,colorManipulator/* lighten */.$n)(theme.palette.primary.light, 0.75);
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        table: {
            display: "flex",
            flexDirection: "column",
            "& thead": {
                "& tr": {
                    "&:first-child": (0,_object_spread/* default */.Z)({}, (0,AppTheme/* LAST_OF_SELECTOR_MIXIN */.BE)("$borderedCell", {
                        borderTopRightRadius: theme.spacing(BORDER_RADIUS_MULTIPLIER)
                    }, {
                        borderTopRightRadius: 0
                    }), (0,AppTheme/* FIRST_OF_SELECTOR_MIXIN */.uT)("$borderedCell", {
                        borderTopLeftRadius: theme.spacing(BORDER_RADIUS_MULTIPLIER)
                    }))
                }
            },
            "& tbody": {
                "& tr": {
                    "&:last-child": (0,_object_spread/* default */.Z)({}, (0,AppTheme/* LAST_OF_SELECTOR_MIXIN */.BE)("$borderedCell", {
                        borderBottomRightRadius: theme.spacing(BORDER_RADIUS_MULTIPLIER)
                    }, {
                        borderBottomRightRadius: 0
                    }), (0,AppTheme/* FIRST_OF_SELECTOR_MIXIN */.uT)("$borderedCell", {
                        borderBottomLeftRadius: theme.spacing(BORDER_RADIUS_MULTIPLIER)
                    })),
                    "&:nth-child(even)": {
                        "& $borderedCell": {
                            background: EVEN_ROW_BG_COLOR(theme),
                            borderLeftColor: EVEN_ROW_BG_COLOR(theme),
                            borderRightColor: EVEN_ROW_BG_COLOR(theme),
                            borderTopColor: EVEN_ROW_BG_COLOR(theme)
                        },
                        "& $cellEditionHighlighted": {
                            background: EVEN_ROW_SELECTED_BG_COLOR(theme),
                            borderLeftColor: EVEN_ROW_SELECTED_BG_COLOR(theme),
                            borderRightColor: EVEN_ROW_SELECTED_BG_COLOR(theme),
                            borderTopColor: EVEN_ROW_SELECTED_BG_COLOR(theme)
                        }
                    }
                }
            }
        },
        editionHeaderCell: {
            textAlign: "center",
            padding: theme.spacing(0, 2, 2, 2),
            "&::before": {
                content: "'placeholder'",
                visibility: "hidden",
                textTransform: "uppercase",
                padding: theme.spacing(0.5, 1),
                borderRadius: theme.spacing(0, 0, 0.75, 0.75),
                fontWeight: theme.typography.fontWeightBold,
                fontSize: 12,
                letterSpacing: 0.5,
                lineHeight: 1,
                marginBottom: theme.spacing()
            }
        },
        editionHeaderText: {
            textTransform: "uppercase",
            color: "#181D25",
            opacity: 0.6,
            fontSize: 14,
            fontWeight: theme.typography.fontWeightBold
        },
        editionHeaderTextLegacy: {
            "&::after": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.caption), {
                color: "#181D25",
                content: "'Legacy'",
                display: "inline-block",
                letterSpacing: 0.5,
                marginLeft: theme.spacing(0.5),
                opacity: 0.85,
                textTransform: "uppercase"
            })
        },
        editionHeaderCellCurrent: {
            "&::before": {
                content: "'Current'",
                visibility: "visible",
                color: theme.palette.grey[500],
                backgroundColor: theme.palette.grey[300]
            }
        },
        editionHeaderCellHighlighted: {
            "&::before": {
                content: "'Recommended'",
                visibility: "visible",
                color: theme.palette.primary.main,
                backgroundColor: "rgba(85,98,235,.2)"
            }
        },
        entitlementHeaderCell: {
            "&&": {
                cursor: "default",
                fontWeight: theme.typography.fontWeightMedium,
                borderBottom: "none",
                overflow: "hidden",
                alignItems: "flex-end",
                textAlign: "right",
                padding: theme.spacing(0, 1, 0, 0),
                flex: "0 0 0"
            }
        },
        cellCallout: {
            "&&": {
                padding: theme.spacing(0, 1, 0, 0),
                flex: "0 0 22px",
                boxSizing: "content-box"
            }
        },
        entitlementHeaderCellHighlighted: {},
        entitlementHeaderCellWithEnts: {
            "&&": {
                flex: "1 1 100%"
            }
        },
        row: {
            display: "flex",
            justifyContent: "stretch",
            alignItems: "stretch"
        },
        headerRow: {},
        bodyRow: {},
        cell: {
            display: "flex",
            flex: "1 1 100%",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: -1,
            marginLeft: -1,
            border: "1px solid transparent",
            overflow: "hidden"
        },
        gapCell: {
            flex: "0 0 auto",
            width: theme.spacing(1),
            padding: 0
        },
        borderedCell: {
            borderColor: (0,colorManipulator/* lighten */.$n)(theme.palette.primary.light, 0.75),
            borderTopColor: EVEN_ROW_BG_COLOR(theme)
        },
        bodyCell: {
            cursor: "default",
            lineHeight: 1.3,
            textAlign: "center",
            padding: theme.spacing(1.5, 2)
        },
        entitlementValue: {
            whiteSpace: "pre-line"
        },
        entitlementUsage: {
            "&::before": {
                background: theme.palette.primary.main,
                borderRadius: "50%",
                content: "''",
                display: "inline-block",
                height: theme.spacing(),
                marginRight: theme.spacing(0.75),
                width: theme.spacing()
            }
        },
        cellEntitlementHighlighted: {},
        cellEditionHighlighted: {}
    };
}, {
    classNamePrefix: "EntitlementTable"
});
var EntitlementTable = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var className = param.className, extClasses = param.classes, showAll = param.showAll, recommendedEdition = param.recommendedEdition, editions = param.editions, showEntitlementHeaders = param.showEntitlementHeaders, highlightedEntitlement = param.highlightedEntitlement, style = param.style, tableRef = param.tableRef, renderHeaderContent = param.renderHeaderContent;
    var classes = useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var team = (0,useTeam/* useTeamState */.Oo)().team;
    var entitlementTable = (0,useEntitlementTable/* useEntitlementTable */.Z)().entitlementTable;
    var usageData = (0,useUsageData/* useUsageData */.L)().usageData;
    /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var entitlements = (0,react.useMemo)(function() {
        var ents = (0,_to_consumable_array/* default */.Z)(ENTITLEMENT_TABLE_ENTITLEMENT_ORDER);
        if (!showAll) ents.splice(ENTITLEMENT_TABLE_SHORT_LIST_LENGTH);
        return ents;
    }, [
        showAll
    ]);
    var loading = !entitlementTable || !team;
    var overageMap = (0,react.useMemo)(function() {
        var overageMap = {};
        entitlements.forEach(function(entitlement) {
            editions.forEach(function(edition) {
                var entActuals = usageData === null || usageData === void 0 ? void 0 : usageData.actuals[entitlement];
                var entObj = (0,Team_utils/* entitlementValueObjectWithOverride */.ah)(entitlement, edition, entitlementTable === null || entitlementTable === void 0 ? void 0 : entitlementTable[edition][entitlement]);
                if (entActuals && entObj && !overageMap[edition]) {
                    overageMap[edition] = Team_consts/* ENTITLEMENT_META */.mm[entitlement].comparator(entActuals.actualValue, entObj.value) > 0;
                }
            });
        });
        return overageMap;
    }, [
        editions,
        entitlements,
        usageData === null || usageData === void 0 ? void 0 : usageData.actuals,
        entitlementTable
    ]);
    var calloutContentByEntitlement = (0,react.useMemo)(function() {
        return usageData ? (0,objects/* typedEntries */.FR)(ENTITLEMENT_TABLE_ENTITLEMENT_META).reduce(function(contentMap, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), entitlement = _param[0], entitlementCallout = _param[1].entitlementCallout;
            if (entitlementCallout) contentMap[entitlement] = entitlementCallout((0,_object_spread/* default */.Z)({
                currentEdition: usageData.currentEdition
            }, usageData.actuals[entitlement]));
            return contentMap;
        }, {}) : {};
    }, [
        usageData
    ]);
    var showCalloutColumn = (0,react.useMemo)(function() {
        return !!(0,objects/* typedValues */.NJ)(calloutContentByEntitlement).find(function(content) {
            return !!content;
        });
    }, [
        calloutContentByEntitlement
    ]);
    /********************/ /*    useCallback   */ /********************/ /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        style: style,
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: 500
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                className: classes.table,
                ref: tableRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)(classes.row, classes.headerRow),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)(classes.cell, classes.entitlementHeaderCell, (0,_define_property/* default */.Z)({}, classes.entitlementHeaderCellWithEnts, showEntitlementHeaders))
                                }),
                                showCalloutColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)(classes.cell, classes.cellCallout)
                                }),
                                editions.map(function(edition) {
                                    var _edition = Team_consts/* EDITION_META */.JZ[edition], label = _edition.label, isLegacy = _edition.isLegacy;
                                    var isRecommendedEdition = recommendedEdition === edition;
                                    var isCurrentEdition = (usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition) === edition;
                                    var _obj;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                                className: (0,clsx_m/* default */.Z)(classes.cell, classes.borderedCell, classes.editionHeaderCell, (_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.editionHeaderCellHighlighted, isRecommendedEdition), (0,_define_property/* default */.Z)(_obj, classes.editionHeaderCellCurrent, isCurrentEdition), _obj)),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)(classes.editionHeaderText, (0,_define_property/* default */.Z)({}, classes.editionHeaderTextLegacy, isLegacy)),
                                                        children: label
                                                    }),
                                                    renderHeaderContent === null || renderHeaderContent === void 0 ? void 0 : renderHeaderContent({
                                                        edition: edition,
                                                        hasOverage: !!overageMap[edition]
                                                    })
                                                ]
                                            }),
                                            isLegacy && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                className: (0,clsx_m/* default */.Z)(classes.cell, classes.gapCell)
                                            })
                                        ]
                                    }, edition);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                        children: entitlements.map(function(entitlement) {
                            var isHighlightedEntitlement = highlightedEntitlement === entitlement;
                            var _entitlement = ENTITLEMENT_TABLE_ENTITLEMENT_META[entitlement], valueRenderer = _entitlement.valueRenderer, actualRenderer = _entitlement.actualRenderer, microValueRenderer = _entitlement.microValueRenderer;
                            var _entitlement1 = Team_consts/* ENTITLEMENT_META */.mm[entitlement], entitlementLabel = _entitlement1.label, entitlementComparator = _entitlement1.comparator, entitlementDescription = _entitlement1.description;
                            var calloutContent = calloutContentByEntitlement[entitlement];
                            var _obj;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)(classes.row, classes.bodyRow),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                        title: entitlementDescription || "",
                                        disabled: !entitlementDescription,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)(classes.cell, classes.entitlementHeaderCell, (_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.entitlementHeaderCellHighlighted, isHighlightedEntitlement), (0,_define_property/* default */.Z)(_obj, classes.entitlementHeaderCellWithEnts, showEntitlementHeaders), _obj)),
                                            children: entitlementLabel
                                        })
                                    }),
                                    showCalloutColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)(classes.cell, classes.cellCallout),
                                        children: !!calloutContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Helptip/* default */.Z, {
                                            title: calloutContent,
                                            interactive: true,
                                            variant: "info"
                                        })
                                    }),
                                    editions.map(function(edition) {
                                        var _$ref, _$ref1;
                                        var isLegacy = Team_consts/* EDITION_META */.JZ[edition].isLegacy;
                                        var entValueObj = (0,Team_utils/* entitlementValueObjectWithOverride */.ah)(entitlement, edition, entitlementTable[edition][entitlement]);
                                        var isHighlightedEdition = recommendedEdition === edition;
                                        var entActualValue = (_$ref = usageData === null || usageData === void 0 ? void 0 : usageData.actuals[entitlement]) === null || _$ref === void 0 ? void 0 : _$ref.actualValue;
                                        var isRecommended = isHighlightedEdition;
                                        var recommendedOverage = !!usageData && isRecommended ? entitlementComparator(entActualValue, (_$ref1 = usageData.terminalActuals[entitlement]) === null || _$ref1 === void 0 ? void 0 : _$ref1.allowedValueForCurrentEdition) > 0 : false;
                                        var title = actualRenderer && entActualValue && isRecommended && (actualRenderer === null || actualRenderer === void 0 ? void 0 : actualRenderer(entActualValue)) || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                        var _obj;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    className: (0,clsx_m/* default */.Z)(classes.cell, classes.borderedCell, classes.bodyCell, (_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.cellEditionHighlighted, isHighlightedEdition), (0,_define_property/* default */.Z)(_obj, classes.cellEntitlementHighlighted, isHighlightedEntitlement), _obj)),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                                        disabled: !actualRenderer || !entActualValue || !isRecommended || !recommendedOverage,
                                                        title: title,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (0,clsx_m/* default */.Z)(classes.entitlementValue, (0,_define_property/* default */.Z)({}, classes.entitlementUsage, actualRenderer && entActualValue && isRecommended && recommendedOverage)),
                                                            children: showEntitlementHeaders && !!microValueRenderer ? microValueRenderer === null || microValueRenderer === void 0 ? void 0 : microValueRenderer(entValueObj) : valueRenderer(entValueObj)
                                                        })
                                                    })
                                                }),
                                                isLegacy && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    className: (0,clsx_m/* default */.Z)(classes.cell, classes.gapCell)
                                                })
                                            ]
                                        }, edition);
                                    })
                                ]
                            }, entitlement);
                        })
                    })
                ]
            })
        })
    });
});

// EXTERNAL MODULE: ./node_modules/@mui/material/AlertTitle/AlertTitle.js + 1 modules
var AlertTitle = __webpack_require__(92401);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isToday/index.js
var isToday = __webpack_require__(51085);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isFuture/index.js


/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */

function isFuture(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,toDate/* default */.Z)(dirtyDate).getTime() > Date.now();
}
// EXTERNAL MODULE: ./src/components/forms/AsyncButton.tsx
var AsyncButton = __webpack_require__(5062);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/components/CappedTextArea.tsx
var CappedTextArea = __webpack_require__(90047);
;// CONCATENATED MODULE: ./src/components/billing/modals/ConfirmSubChangeModal.tsx


















var ConfirmSubChangeModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        cancelReason: {
            height: 100
        },
        cancelReasonInput: {
            background: theme.colors.white
        }
    };
}, {
    classNamePrefix: "ConfirmSubChangeModal"
});
var ConfirmSubChangeModal = function(_param) {
    var className = _param.className, extClasses = _param.classes, ConfirmDialogClasses = _param.ConfirmDialogClasses, downgradeIssue = _param.downgradeIssue, newEdition = _param.newEdition, onConfirm = _param.onConfirm, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "classes",
        "ConfirmDialogClasses",
        "downgradeIssue",
        "newEdition",
        "onConfirm"
    ]);
    var classes = ConfirmSubChangeModal_useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var format = (0,useDateTimeFormatter/* useDateTimeFormatter */.$0)().format;
    var usageData = (0,useUsageData/* useUsageData */.L)().usageData;
    var team = (0,useTeam/* useTeamState */.Oo)().team;
    /********************/ /*     useState     */ /********************/ var ref = (0,react.useState)(""), cancelReason = ref[0], setCancelReason = ref[1];
    /********************/ /* useMemo & consts */ /********************/ var selectedPlanLabel = Team_consts/* EDITION_META */.JZ[newEdition].label;
    /********************/ /*    useCallback   */ /********************/ var handleConfirm = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(cancelReason);
    });
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* ConfirmDialog */.Q, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        classes: ConfirmDialogClasses,
        title: "Before you proceed..."
    }, rest), {
        onConfirm: handleConfirm,
        confirmLabel: "Continue with ".concat(selectedPlanLabel),
        message: function() {
            if (!usageData || !team) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 300,
                height: 200
            });
            var currenPlanLabel = Team_consts/* EDITION_META */.JZ[usageData.currentEdition].label;
            switch(downgradeIssue){
                case "YouWillEndTrial":
                    {
                        return "Are you sure that you want to end your trial?";
                    }
                case "YouWillBeOnSoftOverage":
                    {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "You have more features enabled than are allowed on the ",
                                selectedPlanLabel,
                                " plan. Your account may be impacted."
                            ]
                        });
                    }
                case "YouCanLoseFeaturesAfterTimeEnd":
                    {
                        var subEnding = new Date(team.pricingSummary.subscriptionEnd || "");
                        var dt = "".concat(format(subEnding, "DATE_CONTROL_FORMAT_DAY_MODE"));
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "You won't be charged again. You will continue to have access to ",
                                        currenPlanLabel,
                                        " features through",
                                        " ",
                                        dt,
                                        " & can opt to keep your subscription anytime before then. At the end of the subscription period your team will be automatically downgraded & lose access to ",
                                        currenPlanLabel,
                                        " features."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Tell us about why you want to cancel your plan:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CappedTextArea/* CappedTextArea */.w, {
                                    className: classes.cancelReason,
                                    classes: {
                                        input: classes.cancelReasonInput
                                    },
                                    variant: "outlined",
                                    value: cancelReason,
                                    onChange: setCancelReason,
                                    maxLength: 500
                                })
                            ]
                        });
                    }
                case "TeamWillBeOnSoftOverage":
                    {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Your team has more features enabled than are allowed on the ",
                                selectedPlanLabel,
                                " plan. Their accounts may be impacted."
                            ]
                        });
                    }
            }
        }()
    }));
};
var useConfirmSubChangeModal = function() {
    var baseProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var showModal = (0,mui_modal_provider_esm/* useModal */.d)().showModal;
    return (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(props) {
        var _ref = (0,_object_spread/* default */.Z)({}, baseProps, props), onClose = _ref.onClose, onCancel = _ref.onCancel, onConfirm = _ref.onConfirm, combinedProps = (0,_object_without_properties/* default */.Z)(_ref, [
            "onClose",
            "onCancel",
            "onConfirm"
        ]);
        var ref = showModal(ConfirmSubChangeModal, (0,_object_spread/* default */.Z)({
            onClose: function() {
                onClose === null || onClose === void 0 ? void 0 : onClose();
                hide();
                destroy();
            },
            onCancel: function(e) {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
                hide();
                destroy();
            },
            onConfirm: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(e)
                                ];
                            case 1:
                                _state.sent();
                                hide();
                                destroy();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(e) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, combinedProps)), hide = ref.hide, destroy = ref.destroy;
    });
};

;// CONCATENATED MODULE: ./src/components/billing/PurchaseOMatic/PurchaseOMatic.consts.ts
var DOWNGRADE_TO_NON_PAID_MESSAGE_IN_OVERAGE = "You're exceeding the feature usage for this plan. If you select this plan, you could lose functionality.";
var FREQUENCY_LABEL_MAP = {
    MONTH: "monthly",
    YEAR: "yearly"
};

;// CONCATENATED MODULE: ./src/components/billing/PurchaseOMatic/PurchaseCheckout.tsx




























var PurchaseCheckout_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            bottom: 0,
            left: 0,
            right: 0,
            overflow: "hidden",
            paddingTop: 25,
            pointerEvents: "none"
        },
        preview: {
            position: "relative",
            borderRadius: theme.shape.borderRadius * 3,
            boxShadow: "0px 0px 25px 2px rgba(0,0,0,0.2);",
            background: "white",
            marginBottom: 0,
            pointerEvents: "all",
            transition: theme.transitions.create([
                "transform",
                "margin-bottom"
            ]),
            zIndex: 1
        },
        previewOff: {
            transform: "translateY(100%)"
        },
        previewBox: {
            padding: theme.spacing(4),
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        invoiceContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        },
        downgrade: {
            maxWidth: "36rem",
            textAlign: "center",
            gap: theme.spacing(3)
        },
        containerButtonsInvoice: {
            display: "flex",
            gap: theme.spacing()
        },
        invoiceTable: {
            backgroundColor: theme.colors.borderGrey,
            borderRadius: theme.shape.borderRadius * 3,
            margin: theme.spacing(0, "auto", 2),
            maxWidth: "fit-content",
            padding: theme.spacing(2, 0.5, 2, 2),
            display: "flex",
            flexDirection: "column"
        },
        summary: {
            marginBottom: theme.spacing(2),
            maxWidth: 600,
            textAlign: "center"
        },
        alert: {
            margin: theme.spacing(1, 0)
        },
        table: {
            "& th": {
                fontWeight: theme.typography.fontWeightMedium,
                padding: theme.spacing(0, 1.5, 1.5, 0),
                textAlign: "left"
            },
            "& td": {
                padding: theme.spacing(0, 1.5, 1.5, 0)
            },
            "& > tfoot > tr > td": {
                fontWeight: theme.typography.fontWeightBold,
                paddingBottom: 0,
                textAlign: "right"
            }
        },
        money: {
            textAlign: "right"
        },
        freqPlan: {
            fontWeight: theme.typography.fontWeightMedium
        },
        chargeLine: (0,_object_spread/* default */.Z)({
            display: "flex",
            justifyContent: "end",
            padding: theme.spacing(0, 1.5),
            gap: theme.spacing(0, 1.5)
        }, theme.typography.body2),
        chargeLineSmall: {
            fontSize: "0.8em",
            "&::before": {
                content: "'('",
                marginRight: theme.spacing(-1.5)
            },
            "&::after": {
                content: "')'",
                marginLeft: theme.spacing(-1.5)
            }
        },
        chargeLineGreen: {
            color: theme.palette.success.main,
            fontWeight: theme.typography.fontWeightMedium
        },
        boldText: {
            fontWeight: theme.typography.fontWeightBold
        },
        skele: {
            margin: theme.spacing(2, 0)
        },
        promoCodeText: {
            margin: theme.spacing(1, 0)
        },
        promoCodeFields: {
            margin: theme.spacing(1, 0, 1, 3),
            display: "flex",
            alignItems: "center",
            gap: 10,
            paddingBottom: 16,
            justifyContent: "flex-start"
        }
    };
}, {
    classNamePrefix: "PurchaseCheckout"
});
var PurchaseCheckout = function(param) {
    var className = param.className, extClasses = param.classes, plan = param.plan, entitlementTable = param.entitlementTable, usageData = param.usageData, loading = param.loading, disableContinueReasons = param.disableContinueReasons, currency = param.currency, onClose = param.onClose;
    var classes = PurchaseCheckout_useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var team = (0,useTeam/* useTeamState */.Oo)().team;
    var ref = (0,useSubscriptionLogic/* useSubscriptionLogic */.Y)(), userCurrentEdition = ref.userCurrentEdition, userIsOnTrial = ref.userIsOnTrial, hasActiveSubscription = ref.hasActiveSubscription, subscriptionFrequency = ref.subscriptionFrequency;
    var format = (0,useDateTimeFormatter/* useDateTimeFormatter */.$0)().format;
    var openConfirmSubChangeModal = useConfirmSubChangeModal({});
    /********************/ /*     useState     */ /********************/ var ref1 = (0,react.useState)(false), submitting = ref1[0], setSubmitting = ref1[1];
    var ref2 = (0,react.useState)(""), promoCode = ref2[0], setPromoCode = ref2[1];
    var ref3 = (0,react.useState)(""), promoCodeInputValue = ref3[0], setPromoCodeInputValue = ref3[1];
    var ref4 = (0,react.useState)(false), showPromoCode = ref4[0], setShowPromoCode = ref4[1];
    var ref5 = (0,react.useState)(false), invoiceLoading = ref5[0], setInvoiceLoading = ref5[1];
    var ref6 = (0,react.useState)(), invoiceError = ref6[0], setInvoiceError = ref6[1];
    var ref7 = (0,react.useState)(undefined), invoice = ref7[0], setInvoice = ref7[1];
    /********************/ /* useMemo & consts */ /********************/ loading = loading || invoiceLoading;
    /********************/ /*    useCallback   */ /********************/ var formatPennies = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(pennies, options) {
        return formatDollarAmount(pennies / 100, (0,_object_spread/* default */.Z)({
            currency: currency
        }, options));
    });
    var fetchInvoicePreview = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var newPlan, preview, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    newPlan = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, plan), {
                        promoCode: promoCode || undefined
                    });
                    if (!(newPlan.edition && newPlan.edition !== "LITE" && newPlan.frequency && newPlan.seats && hasActiveSubscription)) return [
                        3,
                        6
                    ];
                    setInvoiceLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        reclaim_api/* reclaim.team.previewSubscriptionChange */.Tz.team.previewSubscriptionChange(newPlan)
                    ];
                case 2:
                    preview = _state.sent();
                    setInvoiceError(undefined);
                    setInvoice(preview);
                    return [
                        3,
                        5
                    ];
                case 3:
                    err = _state.sent();
                    setInvoiceError(err);
                    setInvoice(undefined);
                    return [
                        3,
                        5
                    ];
                case 4:
                    setInvoiceLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    setInvoice(undefined);
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    }));
    var getIssueWithSelectedPlan = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var selectedEdition = plan === null || plan === void 0 ? void 0 : plan.edition;
        if (!plan || !selectedEdition || !entitlementTable) return undefined;
        if (userIsOnTrial && Team_consts/* EDITION_META */.JZ[selectedEdition].isNonPaid) {
            return "YouWillEndTrial";
        }
        if (hasActiveSubscription && Team_consts/* EDITION_META */.JZ[selectedEdition].isNonPaid) {
            var subEnding = new Date(team.pricingSummary.subscriptionEnd || "");
            if (!(0,isToday/* default */.Z)(subEnding) && isFuture(subEnding)) {
                return "YouCanLoseFeaturesAfterTimeEnd";
            }
        }
        var willOverage = [];
        Object.keys((usageData === null || usageData === void 0 ? void 0 : usageData.terminalActuals) || {}).map(function(entitlement) {
            var entData = usageData === null || usageData === void 0 ? void 0 : usageData.terminalActuals[entitlement];
            if (entData) {
                if (Team_consts/* ENTITLEMENT_META */.mm[entitlement].comparator(entData.actualValue, entitlementTable[selectedEdition][entitlement].value) > 0) {
                    willOverage.push(entitlement);
                }
            }
        });
        if (willOverage.length > 0) {
            return "YouWillBeOnSoftOverage";
        }
        return undefined;
    });
    var proceedWithSub = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(plan, cancelReason) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(plan.edition === "LITE")) return [
                            3,
                            5
                        ];
                        if (!(userIsOnTrial && !hasActiveSubscription)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            reclaim_api/* reclaim.team.endTrial */.Tz.team.endTrial()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            reclaim_api/* reclaim.team.cancelSubscription */.Tz.team.cancelSubscription(cancelReason)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        window.location.reload();
                        return [
                            3,
                            9
                        ];
                    case 5:
                        if (!hasActiveSubscription) return [
                            3,
                            7
                        ];
                        // only call change w/ active subscription
                        return [
                            4,
                            reclaim_api/* reclaim.team.subscriptionChange */.Tz.team.subscriptionChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, plan), {
                                promoCode: promoCode || undefined
                            }))
                        ];
                    case 6:
                        _state.sent();
                        window.location.reload();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            reclaim_api/* reclaim.team.startSubscription */.Tz.team.startSubscription(plan, {
                                currency: currency
                            })
                        ];
                    case 8:
                        _state.sent();
                        _state.label = 9;
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function(plan, cancelReason) {
            return _ref.apply(this, arguments);
        };
    }());
    var handleDoSub = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var frequency, seats, edition, issue, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        5,
                        6
                    ]);
                    setSubmitting(true);
                    if (!(plan === null || plan === void 0 ? void 0 : plan.edition)) throw new Error("Problem while starting/changing sub: no plan");
                    frequency = plan.frequency, seats = plan.seats, edition = plan.edition;
                    if (!edition) throw new Error("Problem while starting/changing sub: no edition");
                    if (!team) throw new Error("Problem while starting/changing sub: team not ready");
                    if (!userCurrentEdition) throw new Error("User edition was not available");
                    issue = getIssueWithSelectedPlan();
                    if (!issue) return [
                        3,
                        1
                    ];
                    openConfirmSubChangeModal({
                        onConfirm: function(cancelReason) {
                            return proceedWithSub({
                                edition: edition,
                                frequency: frequency,
                                seats: seats,
                                promoCode: promoCode || undefined
                            }, cancelReason);
                        },
                        newEdition: plan.edition,
                        downgradeIssue: issue
                    });
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        proceedWithSub({
                            edition: edition,
                            frequency: frequency,
                            seats: seats,
                            promoCode: promoCode || undefined
                        })
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        6
                    ];
                case 4:
                    error = _state.sent();
                    throw error;
                case 5:
                    setSubmitting(false);
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    }));
    /********************/ /*    useEffects    */ /********************/ (0,react.useEffect)(function() {
        void fetchInvoicePreview();
    }, [
        fetchInvoicePreview,
        plan,
        promoCode
    ]);
    /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)(classes.preview, (0,_define_property/* default */.Z)({}, classes.previewOff, !(plan === null || plan === void 0 ? void 0 : plan.edition))),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCloseButton/* ModalCloseButton */.o, {
                    onClose: function() {
                        return onClose === null || onClose === void 0 ? void 0 : onClose();
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.previewBox,
                    children: function() {
                        var ref, // "--" will never be visible while the
                        // Collapse is open, this is just to keep
                        // `formatPennies` happy
                        ref1;
                        if (!plan || !team || !plan.edition) return;
                        if (Team_consts/* EDITION_META */.JZ[plan.edition].isNonPaid) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.invoiceContainer, classes.downgrade),
                                children: function() {
                                    var issues = getIssueWithSelectedPlan();
                                    var buttonText = Team_consts/* EDITION_META */.JZ[plan.edition].isNonPaid ? "Switch to ".concat(Team_consts/* EDITION_META */.JZ[plan.edition].label, " & cancel plan") : "Switch to ".concat(Team_consts/* EDITION_META */.JZ[plan.edition].label);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            issues === "YouWillBeOnSoftOverage" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: DOWNGRADE_TO_NON_PAID_MESSAGE_IN_OVERAGE
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                                                disabled: submitting,
                                                color: "primary",
                                                variant: "contained",
                                                onClick: handleDoSub,
                                                children: userIsOnTrial ? "End Trial" : buttonText
                                            })
                                        ]
                                    });
                                }()
                            });
                        }
                        if (!hasActiveSubscription) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestStepWrapper/* QuestStepWrapper */.T, {
                                config: {
                                    group: "INVITE_TEAM",
                                    quest: "SELECT_PLAN",
                                    step: "CLICK_FINISH_ON_STRIPE"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                                    disabled: submitting,
                                    color: "primary",
                                    variant: "contained",
                                    onClick: handleDoSub,
                                    children: "Continue on Stripe"
                                })
                            });
                        }
                        // Has an active subscription && has selected a paid plan.
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.invoiceContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h4",
                                    children: "Here's what comes next"
                                }),
                                function() {
                                    if (invoiceError) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                        className: classes.alert,
                                        severity: "warning",
                                        children: "Looks like we're having trouble gathering your purchase details; you can still proceed."
                                    });
                                    else if (!!invoice && !!(plan === null || plan === void 0 ? void 0 : plan.edition) && !!userCurrentEdition && !loading) {
                                        var ref, ref1;
                                        var nextBillingDate = (ref1 = (ref = invoice.upcomingInvoice) === null || ref === void 0 ? void 0 : ref.lines[invoice.upcomingInvoice.lines.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.periodEnd;
                                        nextBillingDate = !!nextBillingDate ? format(new Date(nextBillingDate), "DATE_CONTROL_FORMAT_DAY_MODE") : undefined;
                                        var previousEdition = userCurrentEdition;
                                        var newEdition = plan.edition;
                                        var previousFrequency = subscriptionFrequency === "MONTH" ? "monthly" : "yearly";
                                        var newFrequency = plan.frequency === "MONTH" ? "monthly" : "yearly";
                                        var changingQuantityOnly = previousEdition === newEdition && previousFrequency === newFrequency;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                changingQuantityOnly ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    className: classes.summary,
                                                    children: [
                                                        "We'll update your",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: classes.freqPlan,
                                                            children: [
                                                                newFrequency,
                                                                " ",
                                                                Team_consts/* EDITION_META */.JZ[newEdition].label
                                                            ]
                                                        }),
                                                        " ",
                                                        "plan to ",
                                                        plan.seats,
                                                        " ",
                                                        (0,strings/* pluralize */._6)(plan.seats, "seat"),
                                                        "."
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    className: classes.summary,
                                                    children: [
                                                        "We'll update your",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: classes.freqPlan,
                                                            children: [
                                                                previousEdition !== "LITE" ? previousFrequency + " " : "",
                                                                Team_consts/* EDITION_META */.JZ[previousEdition].label
                                                            ]
                                                        }),
                                                        " ",
                                                        "plan to a",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: classes.freqPlan,
                                                            children: [
                                                                newFrequency,
                                                                " ",
                                                                Team_consts/* EDITION_META */.JZ[newEdition].label
                                                            ]
                                                        }),
                                                        " ",
                                                        "plan."
                                                    ]
                                                }),
                                                function() {
                                                    var ref;
                                                    if (!invoice.upcomingInvoice) return;
                                                    var _upcomingInvoice = invoice.upcomingInvoice, lineItems = _upcomingInvoice.lines, total = _upcomingInvoice.total, totalDiscount = _upcomingInvoice.totalDiscount, totalExcludingTax = _upcomingInvoice.totalExcludingTax, subtotalExcludingTax = _upcomingInvoice.subtotalExcludingTax;
                                                    var nextAmountDue = ((ref = lineItems[lineItems.length - 1]) === null || ref === void 0 ? void 0 : ref.amount) || 0;
                                                    var tax = total - totalExcludingTax;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: classes.invoiceTable,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                                className: classes.table,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                    children: "Description"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                    children: "Qty"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                                    children: "Amount"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                        children: lineItems.map(function(param, i) {
                                                                            var description = param.description, quantity = param.quantity, amount = param.amount;
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                        children: description
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                        children: quantity
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                        className: classes.money,
                                                                                        children: formatPennies(amount)
                                                                                    })
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classes.chargeLine,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Sub-total:"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: formatPennies(subtotalExcludingTax)
                                                                    })
                                                                ]
                                                            }),
                                                            !!tax && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classes.chargeLine,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Tax:"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: formatPennies(tax)
                                                                    })
                                                                ]
                                                            }),
                                                            !!totalDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (0,clsx_m/* default */.Z)(classes.chargeLine, classes.chargeLineGreen),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Discount:"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: formatPennies(totalDiscount)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (0,clsx_m/* default */.Z)(classes.chargeLine, classes.boldText),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Due now:"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: formatPennies(total || 0)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (0,clsx_m/* default */.Z)(classes.chargeLine, classes.chargeLineSmall),
                                                                children: [
                                                                    formatPennies(nextAmountDue),
                                                                    " due ",
                                                                    nextBillingDate
                                                                ]
                                                            })
                                                        ]
                                                    });
                                                }()
                                            ]
                                        });
                                    } else {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.skele,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                variant: "rectangular",
                                                width: 500,
                                                height: 150
                                            })
                                        });
                                    }
                                }(),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                    in: ((invoice === null || invoice === void 0 ? void 0 : (ref = invoice.upcomingInvoice) === null || ref === void 0 ? void 0 : ref.total) || 0) < 0,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                                        className: classes.alert,
                                        color: "success",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertTitle/* default */.Z, {
                                                children: "You're getting credit!"
                                            }),
                                            (invoice === null || invoice === void 0 ? void 0 : (ref1 = invoice.upcomingInvoice) === null || ref1 === void 0 ? void 0 : ref1.total) ? formatPennies(-invoice.upcomingInvoice.total) : "--",
                                            " ",
                                            "will be applied to your account as credit for future invoices."
                                        ]
                                    })
                                }),
                                !showPromoCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    className: classes.promoCodeText,
                                    disabled: !invoice,
                                    onClick: function() {
                                        return setShowPromoCode(true);
                                    },
                                    children: "Apply promo code"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.promoCodeFields,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Your promo code:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                            variant: "outlined",
                                            size: "small",
                                            value: promoCodeInputValue,
                                            onChange: function(e) {
                                                return setPromoCodeInputValue(e.target.value);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            size: "small",
                                            color: "primary",
                                            disabled: promoCode === promoCodeInputValue,
                                            onClick: function() {
                                                setPromoCode(promoCodeInputValue);
                                            },
                                            children: "Apply"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: function() {
                                                setShowPromoCode(false);
                                            },
                                            variant: "outlined",
                                            size: "small",
                                            color: "primary",
                                            children: "Cancel"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.containerButtonsInvoice,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonTip/* ReasonTip */.u, {
                                        reasons: [
                                            {
                                                test: submitting,
                                                message: "Purchasing your plan..."
                                            },
                                            {
                                                test: loading || !invoice && !invoiceError,
                                                message: "Loading..."
                                            }, 
                                        ].concat((0,_to_consumable_array/* default */.Z)(disableContinueReasons || [])),
                                        children: function(disabled) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                                                disabled: disabled,
                                                color: "primary",
                                                variant: "contained",
                                                onClick: handleDoSub,
                                                children: "Confirm and purchase"
                                            });
                                        }
                                    })
                                })
                            ]
                        });
                    }()
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useRecommendedEdition.ts
var useRecommendedEdition = __webpack_require__(5061);
// EXTERNAL MODULE: ./src/hooks/useSubscriptionOptions.ts
var useSubscriptionOptions = __webpack_require__(53316);
;// CONCATENATED MODULE: ./src/components/billing/PurchaseOMatic/PurchaseOMatic.hooks.ts





var usePurchaseOMaticData = function(plan, currency) {
    var entitlementTable = (0,useEntitlementTable/* useEntitlementTable */.Z)().entitlementTable;
    var usageData = (0,useUsageData/* useUsageData */.L)().usageData;
    var ref = (0,useSubscriptionOptions/* useSubscriptionOptions */.g)((plan === null || plan === void 0 ? void 0 : plan.seats) || 1, currency), subscriptionOptions = ref.subscriptionOptions, editions = ref.editions, loadingSubscriptionOptions = ref.loading, loadingSubscriptionOptionsError = ref.error;
    var ref1 = (0,useRecommendedEdition/* useRecommendedEdition */.y)(plan.seats, editions, subscriptionOptions), recommendedEdition = ref1.recommendedEdition, loadingRecommendedEdition = ref1.loading;
    var subscriptionOptionsInitialLoadedRef = (0,react.useRef)(!loadingSubscriptionOptions);
    subscriptionOptionsInitialLoadedRef.current = subscriptionOptionsInitialLoadedRef.current || !loadingSubscriptionOptions;
    var initialized = subscriptionOptionsInitialLoadedRef.current;
    var loading = !initialized || loadingSubscriptionOptions || loadingRecommendedEdition;
    return {
        entitlementTable: entitlementTable,
        usageData: usageData,
        subscriptionOptions: subscriptionOptions,
        editions: editions,
        recommendedEdition: recommendedEdition,
        initialized: initialized,
        loading: loading,
        loadingError: loadingSubscriptionOptionsError
    };
};

;// CONCATENATED MODULE: ./src/components/billing/PurchaseOMatic/PurchaseOMatic.tsx









































var PurchaseOMatic_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        root: {
            padding: theme.spacing(2, 2, 0),
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            overflowY: "auto"
        },
        content: {
            flex: "1 1 auto",
            padding: theme.spacing(3),
            display: "flex",
            flexDirection: "column"
        },
        mobile: {
            padding: theme.spacing(4, 0, 0, 0),
            height: "100%"
        },
        header: {
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: theme.spacing(4)
        },
        headerContent: {
            marginTop: theme.spacing(),
            maxWidth: 500,
            textAlign: "center"
        },
        scrollWrapper: {
            flex: "1 1 auto"
        },
        scrollWrapperMobile: {
            overflow: "auto",
            position: "relative",
            scrollSnapType: "x mandatory",
            scrollbarWidth: "none" /* Firefox */ ,
            display: "flex",
            margin: theme.spacing(0, -2),
            padding: theme.spacing(0, 2),
            "-ms-overflow-style": "none" /* IE 10+ */ ,
            "&::-webkit-scrollbar": {
                background: "transparent" /* Chrome/Safari/Webkit */ ,
                width: 0
            },
            "&::after": {
                content: "''",
                width: theme.spacing(5)
            }
        },
        entitlementTable: {
            position: "relative",
            transition: theme.transitions.create("height"),
            flex: "0 0 auto"
        },
        tableMobile: {
            alignSelf: "start"
        },
        planControls: (0,_define_property/* default */.Z)({
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            gap: theme.spacing(),
            paddingBottom: theme.spacing(4)
        }, theme.breakpoints.up("sm"), {
            flexDirection: "row",
            position: "relative",
            width: "100%"
        }),
        currency: (0,_define_property/* default */.Z)({
            maxWidth: "fit-content"
        }, theme.breakpoints.up("sm"), {
            bottom: theme.spacing(),
            position: "absolute",
            right: 0
        }),
        currencySelect: {
            padding: theme.spacing(0.5)
        },
        selectorPill: {
            maxWidth: 316,
            display: "flex",
            background: "#EDEEF2",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing(1, 2),
            gap: theme.spacing(1.5),
            borderRadius: AppTheme/* BORDER_RADIUS_MAXIMUS_ROUNDINUS */.bj
        },
        freqSpacer: {
            backgroundColor: "#181D25",
            height: 36,
            opacity: 0.15,
            width: 1
        },
        freqSelector: {
            border: "none"
        },
        freqSelectorSelected: {
            backgroundColor: "#181D25",
            color: "white",
            "&:hover": {
                background: "#181D25",
                color: "white"
            },
            "&.Mui-disabled": {
                color: "white"
            }
        },
        showAllButton: {
            marginTop: theme.spacing(3),
            alignSelf: "center",
            flex: "0 0 auto"
        },
        showAllButtonMobile: {
            width: "100%",
            borderRadius: 0,
            margin: 0,
            background: theme.colors.white,
            zIndex: 1,
            height: theme.spacing(5),
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
            boxSizing: "content-box",
            borderTop: "1px solid ".concat(theme.colors.borderGrey)
        },
        seatsInputContainer: {
            alignItems: "center",
            display: "flex",
            gap: theme.spacing()
        },
        seatsInput: {
            padding: theme.spacing(1, 0.5, 1, 1),
            textAlign: "center",
            width: 60,
            backgroundColor: "white"
        },
        entitlementTableColumnMobile: {
            scrollSnapAlign: "center"
        },
        columnHeaderContent: {
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between"
        },
        editionHeaderPrice: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginBottom: theme.spacing()
        },
        editionHeaderContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        editionHeaderPriceCost: {
            fontSize: 24,
            fontWeight: theme.typography.fontWeightBold
        },
        editionHeaderPricesCaption: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        editionHeaderPriceFreq: {
            transform: "translateY(2px)"
        },
        editionButton: {
            width: 130
        },
        selectedEditionButton: {
            backgroundColor: "#181D25",
            border: "1px solid #181D25",
            color: "#FAFAEF",
            "&:hover, &:hover.Mui-disabled": {
                backgroundColor: "#181D25",
                border: "1px solid #181D25",
                color: "#FAFAEF"
            },
            "&.Mui-disabled": {
                color: "white"
            }
        },
        cancelButton: (_obj = {}, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            margin: 0,
            width: "100%"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            margin: 0,
            width: "100%"
        }), _obj),
        warningIcon: {
            color: "#FFD500",
            height: 16,
            width: 16
        },
        editionHeaderPriceCostLoading: {
            opacity: 0.5
        },
        skeletonContent: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: theme.spacing(1),
            padding: theme.spacing(1, 1, 6, 1)
        },
        supportMessage: {
            margin: theme.spacing(4, 0)
        },
        seatWarningAlert: {
            margin: theme.spacing(1, 0)
        },
        unavailableText: {
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: 1.2,
            margin: theme.spacing(0.25, 0, 1)
        },
        keepPlan: {
            padding: 0
        }
    };
}, {
    classNamePrefix: "PurchaseOMatic"
});
var PurchaseOMatic = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var className = param.className, extClasses = param.classes, highlightedEntitlement = param.highlightedEntitlement, mobileMode = param.mobileMode, disabled = param.disabled, onAvailableEditionsChange = param.onAvailableEditionsChange, onClose = param.onClose;
    var classes = PurchaseOMatic_useStyles({
        classes: extClasses
    });
    // needed for usePurchaseOMaticData
    var team = (0,useTeam/* useTeamState */.Oo)().team;
    var _$ref = (0,react.useState)(team.pricingSummary.currency || date_consts/* BROWSER_DEFAULT_CURRENCY_CODE */.Pv), currency = _$ref[0], setCurrency = _$ref[1];
    /********************/ /*   custom hooks   */ /********************/ var _$ref1 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), user = _$ref1[0].user;
    var _$ref2 = (0,useElementRect/* useElementRect */.X)(), tableRef = _$ref2.ref, tableHeight = _$ref2.height;
    var format = (0,useDateTimeFormatter/* useDateTimeFormatter */.$0)().format;
    var _$ref3 = (0,useSubscriptionLogic/* useSubscriptionLogic */.Y)(), userCurrentEdition = _$ref3.userCurrentEdition, planCancelStatus = _$ref3.planCancelStatus, userIsOnTrial = _$ref3.userIsOnTrial;
    // Initalize the plan state. Note: The team object will be defined
    // when this component is mounted. Do not re-sync the plan from the team
    // otherwise it will cause the user changed plan to reset.
    var _$ref4 = (0,react.useState)(function() {
        return {
            seats: team.membershipSummary.activeCount < team.membershipSummary.paidCount ? team.membershipSummary.paidCount : team.membershipSummary.activeCount,
            frequency: team.pricingSummary.subscriptionFrequency || "YEAR"
        };
    }), plan = _$ref4[0], setPlan = _$ref4[1];
    var _$ref5 = usePurchaseOMaticData(plan, currency), entitlementTable = _$ref5.entitlementTable, usageData = _$ref5.usageData, subscriptionOptions = _$ref5.subscriptionOptions, editions = _$ref5.editions, recommendedEdition = _$ref5.recommendedEdition, initialized = _$ref5.initialized, loading = _$ref5.loading, loadingError = _$ref5.loadingError;
    var openKeepPlanModal = (0,ConfirmDialog/* useConfirmDialog */.W)({
        title: "Keep your plan?",
        message: planCancelStatus.isCancelled ? "Your plan is currently set to cancel automatically on ".concat(format(planCancelStatus.terminalDate, "SHORT_DATE_YEAR_DISPLAY_FORMAT"), ".") : undefined,
        declineLabel: "Never mind",
        confirmLabel: "Keep plan",
        onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            reclaim_api/* reclaim.team.reinstateSubscription */.Tz.team.reinstateSubscription()
                        ];
                    case 1:
                        _state.sent();
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        return [
                            2
                        ];
                }
            });
        })
    });
    /********************/ /*     useState     */ /********************/ var _$ref6 = (0,react.useState)(false), showAllEntitlements = _$ref6[0], setShowAllEntitlements = _$ref6[1];
    var _$ref7 = (0,react.useState)(false), showMinSeatWarning = _$ref7[0], setShowMinSeatWarning = _$ref7[1];
    var _$ref8 = (0,react.useState)(plan.seats.toString()), displaySeats = _$ref8[0], setDisplaySeats = _$ref8[1];
    /********************/ /* useMemo & consts */ /********************/ var isTeamAdmin = (0,react.useMemo)(function() {
        return (0,utils_team/* userIsAdminOnTeam */.V)(user || undefined, team || undefined);
    }, [
        team,
        user
    ]);
    var edCount = editions.length;
    var showEntitlementHeaders = !mobileMode && showAllEntitlements;
    var seats = plan.seats, selectedEdition = plan.edition, frequency = plan.frequency;
    /********************/ /*    useCallback   */ /********************/ var reinstateSubscription = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return openKeepPlanModal();
    });
    var toggleShowAll = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return setShowAllEntitlements(!showAllEntitlements);
    });
    var updatePlan = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(newPlan) {
        setPlan((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, plan), {
            seats: seats,
            frequency: frequency,
            edition: selectedEdition
        }), newPlan));
    });
    var setSelectedEdition = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(edition) {
        return updatePlan((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, plan), {
            edition: edition
        }));
    });
    var setSeats = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(seats) {
        return updatePlan((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, plan), {
            seats: seats
        }));
    });
    var setFrequency = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(frequency) {
        return updatePlan((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, plan), {
            frequency: frequency
        }));
    });
    var handleCheckoutClose = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        setSelectedEdition(undefined);
    });
    var formatPennies = function(pennies, options) {
        return pennies === undefined ? "--" : formatDollarAmount(pennies / 100, (0,_object_spread/* default */.Z)({
            currency: currency
        }, options));
    };
    /********************/ /*    useEffects    */ /********************/ (0,react.useEffect)(function() {
        if (team.pricingSummary.currency && team.pricingSummary.currency !== currency) setCurrency(team.pricingSummary.currency);
    // we don't want to update when `currency` updates
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        team.pricingSummary.currency
    ]);
    (0,react.useEffect)(function() {
        onAvailableEditionsChange === null || onAvailableEditionsChange === void 0 ? void 0 : onAvailableEditionsChange(editions);
    }, [
        editions,
        onAvailableEditionsChange
    ]);
    (0,react.useEffect)(function() {
        if (!subscriptionOptions) return;
        var newCount = Number(displaySeats);
        var activeCount = team.membershipSummary.activeCount;
        if (!newCount || newCount === plan.seats) return;
        if (newCount < activeCount && team.pricingSummary.homogeneous) {
            setShowMinSeatWarning(true);
            setSeats(activeCount);
        } else {
            setShowMinSeatWarning(false);
            setSeats(newCount);
        }
    }, [
        displaySeats,
        plan.seats,
        setSeats,
        subscriptionOptions,
        team.membershipSummary.activeCount,
        team.pricingSummary.homogeneous, 
    ]);
    /**
     * This effect deselects the edition if the user is trying to sneak into selecting their current
     * plan or has hit a seat limit exception.
     */ (0,react.useEffect)(function() {
        if (!loading && subscriptionOptions && plan.edition && subscriptionOptions.options[plan.edition] && plan.edition !== "LITE") {
            var _$ref;
            var option = subscriptionOptions.options[plan.edition];
            var isCurrentPlan = !!((_$ref = option.prices[plan.frequency]) === null || _$ref === void 0 ? void 0 : _$ref.isCurrentPlan);
            var hasSeatException = option.minSeats > plan.seats || option.maxSeats < plan.seats;
            if (isCurrentPlan || hasSeatException) {
                setPlan((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, plan), {
                    edition: undefined
                }));
            }
        }
    }, [
        plan,
        plan.frequency,
        loading,
        subscriptionOptions
    ]);
    /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(classes.content, className, (0,_define_property/* default */.Z)({}, classes.mobile, mobileMode)),
                ref: ref,
                children: function() {
                    if (!initialized) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.skeletonContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: 150,
                                    height: 30
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: 400,
                                    height: 60
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: 250,
                                    height: 52,
                                    style: {
                                        marginTop: 16
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: 300,
                                    style: {
                                        marginTop: 8
                                    }
                                })
                            ]
                        });
                    }
                    if (loadingError || subscriptionOptions && editions.length === 0) {
                        /**
               * If subscription options results in an error or is empty display a contact support message
               */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.supportMessage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericInfoMessage/* GenericInfoMessage */.Q, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, {}),
                                align: "center",
                                title: "Custom Pricing",
                                message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "It looks like you will need assistance in order to make any changes to your plan. Please",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactSupportButton/* ContactSupportButton */.u, {
                                            variant: "link",
                                            lead: "I need help with my custom subscription...",
                                            children: "contact support"
                                        }),
                                        " ",
                                        "for help."
                                    ]
                                })
                            })
                        });
                    }
                    if (!loadingError && subscriptionOptions && !!editions.length) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.header,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h3",
                                            children: isTeamAdmin ? "Select a plan" : "Available plans"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestStepWrapper/* QuestStepWrapper */.T, {
                                            config: {
                                                group: "INVITE_TEAM",
                                                quest: "SELECT_PLAN",
                                                step: "PURCHASE_INFO"
                                            },
                                            QuestOrbProps: {
                                                offsetX: 90,
                                                offsetY: -15
                                            },
                                            popperPlacement: "bottom-start"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.headerContent,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: function() {
                                                    // is in a legacy plan
                                                    if (userCurrentEdition && Team_consts/* EDITION_META */.JZ[userCurrentEdition].isLegacy) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                "Check out our new plans! Based on your usage, the plan",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* TextSkeleton */.Q, {
                                                                    text: recommendedEdition && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: Team_consts/* EDITION_META */.JZ[recommendedEdition].label
                                                                    }),
                                                                    placeholderText: "Starter"
                                                                }),
                                                                " ",
                                                                "looks just right for you."
                                                            ]
                                                        });
                                                    }
                                                    if (isTeamAdmin) {
                                                        if (planCancelStatus.isCancelled) {
                                                            var dt = format(new Date(planCancelStatus.terminalDate), "DATE_CONTROL_FORMAT_DAY_MODE");
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    "Your old plan,",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* TextSkeleton */.Q, {
                                                                        text: recommendedEdition && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                            children: Team_consts/* EDITION_META */.JZ[recommendedEdition].label
                                                                        }),
                                                                        placeholderText: "Starter"
                                                                    }),
                                                                    ", will end on ",
                                                                    dt,
                                                                    ". You will continue to have access to",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* TextSkeleton */.Q, {
                                                                        text: recommendedEdition && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                            children: Team_consts/* EDITION_META */.JZ[recommendedEdition].label
                                                                        }),
                                                                        placeholderText: "Starter"
                                                                    }),
                                                                    " ",
                                                                    "features & can choose to",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        className: classes.keepPlan,
                                                                        variant: "text",
                                                                        color: "primary",
                                                                        onClick: reinstateSubscription,
                                                                        children: "keep your plan"
                                                                    }),
                                                                    " ",
                                                                    "anytime before then."
                                                                ]
                                                            });
                                                        }
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                "Based on your usage, the",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* TextSkeleton */.Q, {
                                                                    text: recommendedEdition && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: Team_consts/* EDITION_META */.JZ[recommendedEdition].label
                                                                    }),
                                                                    placeholderText: "Starter"
                                                                }),
                                                                " ",
                                                                "plan looks just right for you."
                                                            ]
                                                        });
                                                    }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: "Check out the features available under each plan. If you'd like to change plans, contact your team admin."
                                                    });
                                                }()
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.planControls,
                                    children: [
                                        isTeamAdmin && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.selectorPill,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniRadioGroup/* MiniRadioGroup */.x, {
                                                    className: classes.freqSelector,
                                                    classes: {
                                                        selected: classes.freqSelectorSelected
                                                    },
                                                    tabs: [
                                                        {
                                                            key: "MONTH",
                                                            label: "Monthly",
                                                            disabled: !!selectedEdition && !subscriptionOptions.options[selectedEdition].prices.MONTH
                                                        },
                                                        {
                                                            key: "YEAR",
                                                            label: "Yearly",
                                                            disabled: !!selectedEdition && !subscriptionOptions.options[selectedEdition].prices.YEAR
                                                        }, 
                                                    ],
                                                    selected: frequency,
                                                    disabled: disabled,
                                                    onChange: setFrequency
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.freqSpacer
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.seatsInputContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                            variant: "outlined",
                                                            size: "small",
                                                            onChange: function(e) {
                                                                return setDisplaySeats(e.target.value);
                                                            },
                                                            value: displaySeats,
                                                            type: "number",
                                                            disabled: disabled,
                                                            InputProps: {
                                                                classes: {
                                                                    input: classes.seatsInput
                                                                }
                                                            },
                                                            inputProps: {
                                                                min: 1
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: (0,strings/* pluralize */._6)(seats, "user")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !team.pricingSummary.currency && /*#__PURE__*/ (0,jsx_runtime.jsx)(StrongSelect/* StrongSelect */.z, {
                                            classes: {
                                                select: classes.currencySelect
                                            },
                                            className: classes.currency,
                                            value: currency,
                                            items: Team_consts/* SUPPORTED_CURRENCIES_LIST.map */.Th.map(function(code) {
                                                return {
                                                    label: code,
                                                    value: code
                                                };
                                            }),
                                            variant: "outlined",
                                            onChange: function(e) {
                                                setCurrency(e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                isTeamAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                    in: showMinSeatWarning,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                                        severity: "info",
                                        className: classes.seatWarningAlert,
                                        onClose: function() {
                                            return setShowMinSeatWarning(false);
                                        },
                                        children: [
                                            "You currently have ",
                                            team.membershipSummary.joinedCount,
                                            " team",
                                            " ",
                                            (0,strings/* pluralize */._6)(team.membershipSummary.joinedCount, "member"),
                                            ". You'll need to remove some before choosing a plan with fewer seats."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(classes.scrollWrapper, (0,_define_property/* default */.Z)({}, classes.scrollWrapperMobile, mobileMode)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntitlementTable, {
                                        className: (0,clsx_m/* default */.Z)(classes.entitlementTable, (0,_define_property/* default */.Z)({}, classes.tableMobile, mobileMode)),
                                        highlightedEntitlement: highlightedEntitlement,
                                        editions: editions,
                                        showEntitlementHeaders: showEntitlementHeaders,
                                        showAll: showAllEntitlements,
                                        recommendedEdition: recommendedEdition,
                                        style: {
                                            width: mobileMode ? "".concat(100 * edCount, "%") : undefined,
                                            height: tableHeight
                                        },
                                        tableRef: tableRef,
                                        classes: {
                                            editionHeaderCell: (0,clsx_m/* default */.Z)((0,_define_property/* default */.Z)({}, classes.entitlementTableColumnMobile, mobileMode))
                                        },
                                        renderHeaderContent: function(param) {
                                            var edition = param.edition, hasOverage = param.hasOverage;
                                            var _edition = Team_consts/* EDITION_META */.JZ[edition], isNonPaid = _edition.isNonPaid, editionLabel = _edition.label, isLegacy = _edition.isLegacy;
                                            if (!isTeamAdmin) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Helptip/* default */.Z, {
                                                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        "Contact your admin to change to a ",
                                                        editionLabel,
                                                        " plan."
                                                    ]
                                                }),
                                                variant: "info"
                                            });
                                            if (!subscriptionOptions) return;
                                            var _edition1 = subscriptionOptions.options[edition], prices = _edition1.prices, maxSeats = _edition1.maxSeats;
                                            var pricing = prices[frequency];
                                            var _$ref = pricing || {
                                                availability: "CALL_US",
                                                isCurrentPlan: false,
                                                monthlyPrice: undefined
                                            }, availability = _$ref.availability, isCurrentPlan = _$ref.isCurrentPlan, monthlyPrice = _$ref.monthlyPrice;
                                            var isSelected = selectedEdition === edition;
                                            var isCancelling = edition === "LITE" && !isCurrentPlan;
                                            var showPriceDisplayMonthlyBilled = !isNonPaid && (plan.seats !== 1 || frequency === "YEAR");
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.columnHeaderContent,
                                                children: [
                                                    monthlyPrice === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        className: classes.unavailableText,
                                                        children: [
                                                            "Unavailable on ",
                                                            FREQUENCY_LABEL_MAP[frequency],
                                                            "\xa0plans"
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)(classes.editionHeaderPrice),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classes.editionHeaderContainer,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (0,clsx_m/* default */.Z)(classes.editionHeaderPriceCost, (0,_define_property/* default */.Z)({}, classes.editionHeaderPriceCostLoading, !!loadingError)),
                                                                        children: function() {
                                                                            if (isNonPaid) return "Free";
                                                                            if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                                variant: "text",
                                                                                style: {
                                                                                    display: "inline",
                                                                                    padding: 0
                                                                                },
                                                                                children: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                                                                            });
                                                                            else return formatPennies(monthlyPrice, {
                                                                                hidePenniesForEvenDollars: true
                                                                            });
                                                                        }()
                                                                    }),
                                                                    !isNonPaid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        className: classes.editionHeaderPriceFreq,
                                                                        children: "/seat"
                                                                    })
                                                                ]
                                                            }),
                                                            showPriceDisplayMonthlyBilled && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: classes.editionHeaderPricesCaption,
                                                                children: [
                                                                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                        variant: "text",
                                                                        style: {
                                                                            display: "inline",
                                                                            padding: 0
                                                                        },
                                                                        children: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: "\xa0"
                                                                    }),
                                                                    "/mo ",
                                                                    frequency === "YEAR" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: "billed\xa0yearly"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    function() {
                                                        switch(availability){
                                                            case "CALL_US":
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    className: classes.editionButton,
                                                                    variant: "outlined",
                                                                    color: "primary",
                                                                    size: "small",
                                                                    href: "https://reclaim.ai/contact",
                                                                    target: "_blank",
                                                                    children: "Contact us"
                                                                });
                                                            default:
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonTip/* ReasonTip */.u, {
                                                                    // These are possible blocking issues that would cause the button to disable.
                                                                    reasons: [
                                                                        {
                                                                            test: availability === "TOO_MANY_USERS",
                                                                            message: "The ".concat(editionLabel, " plan allows only ").concat(maxSeats, " users.")
                                                                        },
                                                                        {
                                                                            test: !isLegacy && seats < team.membershipSummary.activeCount && edition !== "LITE",
                                                                            message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                children: [
                                                                                    "Your team has ",
                                                                                    team.membershipSummary.activeCount,
                                                                                    " ",
                                                                                    (0,strings/* pluralize */._6)(team.membershipSummary.activeCount, "user"),
                                                                                    " and you must purchase at least that many seats to use this plan."
                                                                                ]
                                                                            })
                                                                        },
                                                                        {
                                                                            test: seats > maxSeats && edition !== "LITE",
                                                                            message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                children: [
                                                                                    "You're allowed ",
                                                                                    maxSeats,
                                                                                    " ",
                                                                                    (0,strings/* pluralize */._6)(maxSeats, "user"),
                                                                                    " in",
                                                                                    " ",
                                                                                    (0,strings/* aOrAn */.Wu)(editionLabel),
                                                                                    " plan"
                                                                                ]
                                                                            })
                                                                        },
                                                                        {
                                                                            test: !pricing,
                                                                            message: "Can't purchase ".concat((0,strings/* aOrAn */.Wu)(editionLabel), " ").concat(editionLabel, " plan with ").concat(FREQUENCY_LABEL_MAP[frequency], " pricing.")
                                                                        }, 
                                                                    ],
                                                                    interactive: true,
                                                                    children: function(hasIssue) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonTip/* ReasonTip */.u, {
                                                                            // Possible non-blocking issues that we warn the user about but do not disable the button.
                                                                            reasons: [
                                                                                {
                                                                                    test: !!hasOverage,
                                                                                    message: DOWNGRADE_TO_NON_PAID_MESSAGE_IN_OVERAGE
                                                                                },
                                                                                {
                                                                                    test: seats > maxSeats && edition === "LITE",
                                                                                    message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                        children: [
                                                                                            "Your team is too large for the ",
                                                                                            editionLabel,
                                                                                            " plan. If you continue with this plan, you will lose the ability to add team members."
                                                                                        ]
                                                                                    })
                                                                                }, 
                                                                            ],
                                                                            disabled: hasIssue,
                                                                            interactive: true,
                                                                            noSpan: true,
                                                                            children: function(hasNonIssue) {
                                                                                var _obj;
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                    className: (0,clsx_m/* default */.Z)(classes.editionButton, (_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.selectedEditionButton, isSelected && !isCurrentPlan && !loadingError), (0,_define_property/* default */.Z)(_obj, classes.cancelButton, isCancelling && !userIsOnTrial), _obj)),
                                                                                    variant: "outlined",
                                                                                    color: "primary",
                                                                                    size: "small",
                                                                                    disabled: hasIssue || loading || !!loadingError || isCurrentPlan || isSelected,
                                                                                    onClick: function() {
                                                                                        return setSelectedEdition(edition);
                                                                                    },
                                                                                    startIcon: (hasIssue || hasNonIssue) && !loadingError && !isCurrentPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)(warning_icon/* default */.Z, {
                                                                                        className: classes.warningIcon
                                                                                    }),
                                                                                    children: function() {
                                                                                        if (isCurrentPlan) return "Current plan";
                                                                                        if (isCancelling && !userIsOnTrial) return "Cancel plan";
                                                                                        if (isCancelling && userIsOnTrial) return "Cancel trial";
                                                                                        if (isSelected && !isCancelling) return "Selected";
                                                                                        return "Select";
                                                                                    }()
                                                                                });
                                                                            }
                                                                        });
                                                                    }
                                                                });
                                                        }
                                                    }()
                                                ]
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)(classes.showAllButton, (0,_define_property/* default */.Z)({}, classes.showAllButtonMobile, mobileMode)),
                                    onClick: toggleShowAll,
                                    variant: "text",
                                    color: "primary",
                                    disabled: disabled,
                                    endIcon: showAllEntitlements ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLessRounded/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMoreRounded/* default */.Z, {}),
                                    children: showAllEntitlements ? "See fewer features" : "See all features"
                                })
                            ]
                        });
                    }
                }()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseCheckout, {
                plan: plan,
                currency: currency,
                entitlementTable: entitlementTable,
                usageData: usageData,
                loading: loading,
                onClose: handleCheckoutClose,
                disableContinueReasons: subscriptionOptions && selectedEdition && function() {
                    var dispSeatsNum = Number(displaySeats);
                    var _selectedEdition = subscriptionOptions.options[selectedEdition], minSeats = _selectedEdition.minSeats, maxSeats = _selectedEdition.maxSeats;
                    var label = Team_consts/* EDITION_META */.JZ[selectedEdition].label;
                    return [
                        {
                            // This shouldn't ever trigger, but it's good to have just in case
                            test: !dispSeatsNum || isNaN(dispSeatsNum),
                            message: "Invalid seat count.  Please try again..."
                        },
                        {
                            test: dispSeatsNum < minSeats,
                            message: "".concat(label, " plans have to have at least ").concat(minSeats, " ").concat((0,strings/* pluralize */._6)(minSeats, "seat"), ".")
                        },
                        {
                            test: dispSeatsNum > maxSeats,
                            message: "".concat(label, " plans can't have more than ").concat(maxSeats, " ").concat((0,strings/* pluralize */._6)(maxSeats, "seat"), ".")
                        },
                        {
                            test: displaySeats !== plan.seats.toString(),
                            message: function() {
                                return "You cannot continue with ".concat(dispSeatsNum, " ").concat((0,strings/* pluralize */._6)(dispSeatsNum, "seat"), ".  Please change the number of seats, or pick a different plan.");
                            }
                        }, 
                    ];
                }()
            })
        ]
    });
});

// EXTERNAL MODULE: ./src/components/modal/ModalContent.tsx
var ModalContent = __webpack_require__(84362);
// EXTERNAL MODULE: ./src/components/modal/ModalHeader.tsx
var ModalHeader = __webpack_require__(33977);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(90263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(27036);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./src/components/billing/index.ts
var billing = __webpack_require__(14108);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.ts
var Team = __webpack_require__(72897);
;// CONCATENATED MODULE: ./src/utils/billing.ts
var calculateCost = function() {
    var ADDITIONAL_ANNUAL_DISCOUNT = 0.2;
    var BREAKPOINTS = Object.freeze({
        1: {
            annually: {
                pro: 6.5,
                team: 9.5
            },
            monthly: {
                pro: 7.8,
                team: 11.4
            }
        },
        5: {
            annually: {
                pro: 7.47,
                team: 10.93
            },
            monthly: {
                pro: 8.97,
                team: 13.11
            }
        },
        10: {
            annually: {
                pro: 8.59,
                team: 12.56
            },
            monthly: {
                pro: 10.31,
                team: 15.08
            }
        },
        25: {
            annually: {
                pro: 9.88,
                team: 14.45
            },
            monthly: {
                pro: 11.86,
                team: 17.34
            }
        },
        50: {
            annually: {
                pro: 8.4,
                team: 12.28
            },
            monthly: {
                pro: 10.08,
                team: 14.74
            }
        },
        100: {
            annually: {
                pro: 7.14,
                team: 10.44
            },
            monthly: {
                pro: 8.57,
                team: 12.53
            }
        },
        1000: {
            annually: {
                pro: 6.07,
                team: 8.87
            },
            monthly: {
                pro: 7.28,
                team: 10.65
            }
        }
    });
    var LOWER_BOUNDS = Object.keys(BREAKPOINTS).map(function(k) {
        return parseInt(k);
    });
    /**
   * Dont type this so that it can easily stay in sync with website calc until we having a
   * better plan for where to put this. -SS
   *
   * I've been trying to figure out a way to force Next's pipeline to output an individual
   * script file without a page.  Would be nice to just host this from Vercel and ref it
   * in Webflow.  Having said that you can just dump the code here: https://www.typescriptlang.org/play
   * - SG
   */ return function(seats, period) {
        if (typeof seats !== "number" || seats < 1) throw new RangeError("seats must be a number, 1 or greater (received ".concat(seats, ")"));
        if (period !== "annually" && period !== "monthly") throw new Error('period must be either "monthly" or "annually" (received "'.concat(period, '")'));
        var lowerBoundIndex = LOWER_BOUNDS.findIndex(function(min, i) {
            return LOWER_BOUNDS[i + 1] > seats || !LOWER_BOUNDS[i + 1];
        });
        var lowerBound = LOWER_BOUNDS[lowerBoundIndex];
        var upperBound = LOWER_BOUNDS[lowerBoundIndex + 1] ? LOWER_BOUNDS[lowerBoundIndex + 1] - 1 : Infinity;
        var seatsInRange = seats - (lowerBound - 1);
        var _period = BREAKPOINTS[lowerBound][period], proRangePrice = _period.pro, teamRangePrice = _period.team;
        var proPrice = proRangePrice * seatsInRange;
        var teamPrice = teamRangePrice * seatsInRange;
        for(var i = 0; i < lowerBoundIndex; i++){
            var lowerBoundForRange = LOWER_BOUNDS[i];
            var upperBoundForRange = LOWER_BOUNDS[i + 1];
            var breakpointForRange = BREAKPOINTS[lowerBoundForRange][period];
            proPrice += (upperBoundForRange - lowerBoundForRange) * breakpointForRange.pro;
            teamPrice += (upperBoundForRange - lowerBoundForRange) * breakpointForRange.team;
        }
        var discount = period === "annually" ? ADDITIONAL_ANNUAL_DISCOUNT : 0;
        var proPricePerUser = proPrice / seats;
        var teamPricePerUser = teamPrice / seats;
        var proPricePerUserDiscountedAmount = proPricePerUser * discount;
        var teamPricePerUserDiscountedAmount = teamPricePerUser * discount;
        var proPriceDiscountedAmount = proPrice * discount;
        var teamPriceDiscountedAmount = teamPrice * discount;
        var proPricePerUserWithDiscount = proPricePerUser - proPricePerUserDiscountedAmount;
        var teamPricePerUserWithDiscount = teamPricePerUser - teamPricePerUserDiscountedAmount;
        var proPriceWithDiscount = proPrice - proPriceDiscountedAmount;
        var teamPriceWithDiscount = teamPrice - teamPriceDiscountedAmount;
        return {
            proPricePerUser: proPricePerUser,
            teamPricePerUser: teamPricePerUser,
            proPrice: proPrice,
            teamPrice: teamPrice,
            proPricePerUserDiscountedAmount: proPricePerUserDiscountedAmount,
            teamPricePerUserDiscountedAmount: teamPricePerUserDiscountedAmount,
            proPriceDiscountedAmount: proPriceDiscountedAmount,
            teamPriceDiscountedAmount: teamPriceDiscountedAmount,
            proPricePerUserWithDiscount: proPricePerUserWithDiscount,
            teamPricePerUserWithDiscount: teamPricePerUserWithDiscount,
            proPriceWithDiscount: proPriceWithDiscount,
            teamPriceWithDiscount: teamPriceWithDiscount,
            lowerBound: lowerBound,
            upperBound: upperBound,
            seatsInRange: seatsInRange,
            discount: discount
        };
    };
}();

// EXTERNAL MODULE: ./src/utils/form.ts
var utils_form = __webpack_require__(63237);
// EXTERNAL MODULE: ./src/components/forms/rhf/RhfForm.tsx + 1 modules
var RhfForm = __webpack_require__(28681);
// EXTERNAL MODULE: ./src/components/forms/rhf/RhfRadioGroupControl.tsx
var RhfRadioGroupControl = __webpack_require__(57693);
// EXTERNAL MODULE: ./src/components/forms/rhf/TextFieldControl.tsx
var TextFieldControl = __webpack_require__(22057);
;// CONCATENATED MODULE: ./src/components/billing/SubscriptionForm.tsx


























var SubscriptionForm_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        title: {
            padding: theme.spacing(0, 0.25, 0.5)
        },
        subtext: {
            marginTop: theme.spacing(-0.5),
            padding: theme.spacing(0, 0.25, 1)
        },
        sectionWrap: {
            display: "flex",
            alignItems: "baseline",
            marginBottom: theme.spacing(2.5)
        },
        seats: (0,_define_property/* default */.Z)({
            width: 80,
            marginRight: theme.spacing(2)
        }, theme.breakpoints.up("sm"), {
            width: 100
        }),
        seatsInput: {
            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                "-webkit-appearance": "none",
                margin: 0
            },
            "&[type=number]": {
                "-moz-appearance": "textfield"
            }
        },
        labeledButtonGroup: {
            border: "1px solid",
            borderColor: (0,colorManipulator/* lighten */.$n)(theme.colors.logo.darkness, 0.85),
            borderRadius: theme.shape.borderRadius * 5
        },
        groupButton: (0,_define_property/* default */.Z)({
            margin: theme.spacing(0.375),
            color: theme.colors.black,
            fontSize: "0.75rem"
        }, theme.breakpoints.up("sm"), {
            fontSize: "0.875rem"
        }),
        selected: {
            backgroundColor: theme.colors.logo.darkness100,
            color: theme.colors.black,
            cursor: "default",
            "&:hover": {
                backgroundColor: theme.colors.logo.darkness100,
                color: theme.colors.black
            }
        },
        editionGroup: {
            marginBottom: theme.spacing(2.5),
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%"
        },
        editionGroupRoot: (0,_define_property/* default */.Z)({
            display: "grid",
            gap: theme.spacing(1),
            gridTemplateColumns: "100%"
        }, theme.breakpoints.up("sm"), {
            gridTemplateColumns: "1fr 1fr"
        }),
        radio: (0,_define_property/* default */.Z)({
            alignItems: "flex-start",
            padding: theme.spacing(1.5),
            margin: 0,
            borderColor: (0,colorManipulator/* lighten */.$n)(theme.colors.logo.darkness, 0.85),
            border: "1px solid",
            borderRadius: 12
        }, theme.breakpoints.up("sm"), {
            maxWidth: 220
        }),
        radioRoot: {
            padding: 0,
            margin: theme.spacing(0, "5px", 0, 0)
        },
        radioSelected: {
            backgroundColor: theme.colors.logo.darkness100
        },
        editionDetails: {},
        footerButtons: {
            display: "flex",
            margin: theme.spacing(2, 0, 1)
        },
        detail: {
            display: "flex",
            margin: theme.spacing(0.5, 0, 0.5, "-26px"),
            "&:first-of-type": {
                marginTop: theme.spacing(1.5)
            }
        },
        check: {
            color: theme.palette.success.main,
            marginRight: theme.spacing(1),
            width: 18,
            height: 18
        },
        costs: {
            display: "flex",
            alignItems: "flex-start",
            fontWeight: theme.typography.fontWeightLight,
            gap: theme.spacing(0.5)
        },
        baseCost: {},
        notThisPrice: {
            textDecoration: "line-through",
            textDecorationColor: "rgba(0,0,0,.3)",
            fontSize: "0.5em",
            marginTop: theme.spacing(0.5),
            color: theme.colors.textGrey
        },
        discountedCost: {},
        savingsBadge: {
            background: theme.colors.logo.corn,
            margin: theme.spacing(0.5, 0),
            position: "static",
            transform: "none",
            whiteSpace: "nowrap"
        }
    };
}, {
    classNamePrefix: "SubscriptionForm"
});
var defaultValues = {
    seats: "0",
    paymentPeriod: Team/* SubscriptionFrequency.Year */.OF.Year,
    edition: "TEAM"
};
var SubscriptionForm = function(param) {
    var teamMembers = param.teamMembers, onSubmit = param.onSubmit;
    var classes = SubscriptionForm_useStyles();
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultValues), {
            seats: teamMembers.length.toString()
        })
    });
    var watch = form.watch();
    var isAnnual = watch.paymentPeriod === Team/* SubscriptionFrequency.Year */.OF.Year;
    var showWarning = (0,react.useMemo)(function() {
        return !!watch.seats && parseInt(watch.seats) > 0 && parseInt(watch.seats) < teamMembers.length;
    }, [
        watch,
        teamMembers
    ]);
    var showMessage = (0,react.useMemo)(function() {
        return !!watch.seats && parseInt(watch.seats) > 1;
    }, [
        watch
    ]);
    var annualSeatCosts = (0,react.useMemo)(function() {
        var seats = parseInt(watch.seats);
        if (!!seats && seats >= 1) {
            var ref = calculateCost(seats, "annually"), proPricePerUser = ref.proPricePerUser, teamPricePerUser = ref.teamPricePerUser;
            return {
                PRO: formatDollarAmount(proPricePerUser),
                TEAM: formatDollarAmount(teamPricePerUser)
            };
        } else {
            return {
                PRO: "-",
                TEAM: "-"
            };
        }
    }, [
        watch.seats
    ]);
    var monthlySeatCosts = (0,react.useMemo)(function() {
        var seats = parseInt(watch.seats);
        if (!!seats && seats >= 1) {
            var ref = calculateCost(seats, "monthly"), proPricePerUser = ref.proPricePerUser, teamPricePerUser = ref.teamPricePerUser;
            return {
                PRO: formatDollarAmount(proPricePerUser),
                TEAM: formatDollarAmount(teamPricePerUser)
            };
        } else {
            return {
                PRO: "-",
                TEAM: "-"
            };
        }
    }, [
        watch.seats
    ]);
    var handleSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var values, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        form.trigger()
                    ];
                case 1:
                    _state.sent();
                    if (!!(0,utils_form/* hasError */.x)(form)) return [
                        3,
                        3
                    ];
                    values = form.getValues();
                    data = {
                        frequency: values.paymentPeriod,
                        edition: values.edition,
                        seats: Number(values.seats)
                    };
                    return [
                        4,
                        onSubmit(data)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    throw new Error("Subscription validation failed.");
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        form,
        onSubmit
    ]);
    var handlePaymentPeriodChange = (0,react.useCallback)(function(period) {
        form.setValue("paymentPeriod", period);
    }, [
        form
    ]);
    var PlanRadioBox = function(param) {
        var edition = param.edition;
        var seatCostKey = edition === "TEAM" ? "TEAM" : "PRO";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
            value: edition,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.editionDetails,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h6",
                        children: edition === "TEAM" ? "Team" : Team_consts/* EDITION_META */.JZ[edition].label
                    }),
                    isAnnual && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                        badgeContent: "17% annual discount",
                        classes: {
                            badge: classes.savingsBadge
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: classes.costs,
                        variant: "h2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                variant: "inherit",
                                className: (0,clsx_m/* default */.Z)(classes.baseCost, (0,_define_property/* default */.Z)({}, classes.notThisPrice, isAnnual)),
                                children: monthlySeatCosts[seatCostKey]
                            }),
                            isAnnual && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                className: classes.discountedCost,
                                variant: "inherit",
                                children: annualSeatCosts[seatCostKey]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: "per user/month"
                    }),
                    (0,billing/* getPlanDetails */.b)(edition).map(function(deet, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            className: classes.detail,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                    className: classes.check
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    children: deet
                                })
                            ]
                        }, "plan-detail-".concat(i));
                    })
                ]
            }),
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                color: "primary",
                className: classes.radioRoot
            }),
            className: (0,clsx_m/* default */.Z)(classes.radio, (0,_define_property/* default */.Z)({}, classes.radioSelected, watch.edition === edition))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RhfForm/* RhfForm */.$, {
        form: form,
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: classes.title,
                variant: "h6",
                children: "Number of seats"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.sectionWrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextFieldControl/* TextFieldControl */.p, {
                        name: "seats",
                        className: classes.seats,
                        onWheel: function(e) {
                            return e.target.blur();
                        },
                        InputProps: {
                            classes: {
                                input: classes.seatsInput
                            }
                        },
                        type: "number",
                        variant: "outlined",
                        size: "small",
                        options: {
                            min: {
                                value: 1,
                                message: "minimum of 1 seat"
                            }
                        },
                        required: true,
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.labeledButtonGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    return handlePaymentPeriodChange(Team/* SubscriptionFrequency.Year */.OF.Year);
                                },
                                className: (0,clsx_m/* default */.Z)(classes.groupButton, (0,_define_property/* default */.Z)({}, classes.selected, watch.paymentPeriod === Team/* SubscriptionFrequency.Year */.OF.Year)),
                                children: "Annually"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    return handlePaymentPeriodChange(Team/* SubscriptionFrequency.Month */.OF.Month);
                                },
                                className: (0,clsx_m/* default */.Z)(classes.groupButton, (0,_define_property/* default */.Z)({}, classes.selected, watch.paymentPeriod === Team/* SubscriptionFrequency.Month */.OF.Month)),
                                children: "Monthly"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: classes.title,
                variant: "h6",
                children: "Plan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: classes.subtext,
                variant: "body2",
                children: [
                    "More details about each plan are available on our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        href: "//reclaim.ai/pricing",
                        target: "reclaim-pricing",
                        children: "Pricing"
                    }),
                    " ",
                    "page.",
                    " ",
                    showMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactSupportButton/* ContactSupportButton */.u, {
                                variant: "link",
                                lead: "I want to add Pro & Team seats to my plan...",
                                children: "Contact us"
                            }),
                            " ",
                            "for a plan of both Pro & Team seats."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RhfRadioGroupControl/* RhfRadioGroupControl */.y, {
                name: "edition",
                className: classes.editionGroup,
                classes: {
                    root: classes.editionGroup
                },
                RadioGroupProps: {
                    className: classes.editionGroupRoot
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanRadioBox, {
                        edition: "PRO"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanRadioBox, {
                        edition: "TEAM"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: showWarning,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "warning",
                    children: "You're purchasing ".concat(watch.seats, " seats for ").concat(teamMembers.length, " team members. We'll automatically switch some users to the Free plan, but you can adjust this later.")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.footerButtons,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestStepWrapper/* QuestStepWrapper */.T, {
                    config: {
                        group: "INVITE_TEAM",
                        quest: "SELECT_PLAN",
                        step: "CLICK_FINISH_ON_STRIPE"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                        onClick: handleSubmit,
                        variant: "contained",
                        color: "primary",
                        children: "Finish on Stripe"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/billing/SubscriptionModal.tsx












var SubscriptionModal = function(param) {
    var open = param.open, teamMembers = param.teamMembers, onClose = param.onClose;
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            reclaim_api/* reclaim.team.startSubscription */.Tz.team.startSubscription(data)
                        ];
                    case 1:
                        _state.sent();
                        onClose();
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        open: open,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader/* ModalHeader */.x, {
                onClose: onClose,
                children: [
                    "Reclaim subscription",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestStepWrapper/* QuestStepWrapper */.T, {
                        config: {
                            group: "INVITE_TEAM",
                            quest: "SELECT_PLAN",
                            step: "PURCHASE_INFO"
                        },
                        QuestOrbProps: {
                            offsetX: 10
                        },
                        popperPlacement: "bottom-start"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent/* ModalContent */.h, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionForm, {
                    teamMembers: teamMembers,
                    onSubmit: handleSubmit
                })
            })
        ]
    });
};
var useSubscriptionModal = function(teamMembers) {
    var showModal = (0,mui_modal_provider_esm/* useModal */.d)().showModal;
    return (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var closeModal = showModal(SubscriptionModal, {
            teamMembers: teamMembers,
            onClose: function() {
                return closeModal();
            }
        }).hide;
    });
};

;// CONCATENATED MODULE: ./src/components/billing/modals/PurchaseModal.tsx
















var PurchaseModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        modalPaper: {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        modalPaperMobile: {
            width: "100vw",
            height: "100vh",
            padding: 0,
            margin: 0,
            maxHeight: "none",
            borderRadius: 0,
            overflow: "hidden"
        },
        oMatic: {
            flex: "1 1 auto"
        },
        purchaseOMaticMobile: {
            height: "100%"
        }
    };
}, {
    classNamePrefix: "PurchaseModal"
});
var PurchaseModal = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, ModalClasses = _param.ModalClasses, closeModal = _param.closeModal, highlightedEntitlement = _param.highlightedEntitlement, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "classes",
        "ModalClasses",
        "closeModal",
        "highlightedEntitlement"
    ]);
    var classes = PurchaseModal_useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var theme = (0,useTheme/* default */.Z)();
    var mobileMode = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    /********************/ /*     useState     */ /********************/ var _$ref = (0,react.useState)([]), editions = _$ref[0], setEditions = _$ref[1];
    /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ var handleEditionsChange = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(editions) {
        return setEditions(editions);
    });
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(className, classes.root),
        ref: ref,
        fullWidth: true,
        maxWidth: editions.length <= 4 ? "md" : "lg",
        classes: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ModalClasses), {
            paper: (0,clsx_m/* default */.Z)(classes.modalPaper, ModalClasses === null || ModalClasses === void 0 ? void 0 : ModalClasses.paper, (0,_define_property/* default */.Z)({}, classes.modalPaperMobile, mobileMode))
        })
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCloseButton/* ModalCloseButton */.o, {
                onClose: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseOMatic, {
                className: (0,clsx_m/* default */.Z)(classes.oMatic, (0,_define_property/* default */.Z)({}, classes.purchaseOMaticMobile, mobileMode)),
                highlightedEntitlement: highlightedEntitlement,
                mobileMode: mobileMode,
                onAvailableEditionsChange: handleEditionsChange,
                onClose: closeModal
            })
        ]
    }));
});
var usePurchaseModal = function() {
    var team = (0,useTeam/* useTeamState */.Oo)().team;
    var showSubscriptionModal = useSubscriptionModal(team.members);
    // This modal was having trouble with
    // auto-destroy when launched from a
    // tooltip, so we'll do it manually.
    var showModal = (0,mui_modal_provider_esm/* useModal */.d)({
        disableAutoDestroy: true
    }).showModal;
    return (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(props) {
        if (team.newPricing) {
            var ref = showModal(PurchaseModal, (0,_object_spread/* default */.Z)({
                closeModal: function() {
                    hide();
                    destroy();
                }
            }, props)), hide = ref.hide, destroy = ref.destroy;
        } else showSubscriptionModal();
    });
};


/***/ }),

/***/ 51498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ DateCalendar_DateCalendar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useId/useId.js
var useId = __webpack_require__(92996);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js
var useEventCallback = __webpack_require__(59948);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/useCalendarState.js
var useCalendarState = __webpack_require__(80872);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/useUtils.js + 2 modules
var useUtils = __webpack_require__(48865);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/PickersFadeTransitionGroup.js + 1 modules
var PickersFadeTransitionGroup = __webpack_require__(70869);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/DayCalendar.js + 7 modules
var DayCalendar = __webpack_require__(47520);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(96682);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useControlled/useControlled.js
var useControlled = __webpack_require__(19032);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(73546);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/MonthCalendar/pickersMonthClasses.js

function getPickersMonthUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPickersMonth', slot);
}
const pickersMonthClasses = (0,generateUtilityClasses/* default */.Z)('MuiPickersMonth', ['root', 'monthButton', 'disabled', 'selected']);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/MonthCalendar/PickersMonth.js


const _excluded = ["autoFocus", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "monthsPerRow"];





const useUtilityClasses = ownerState => {
  const {
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    monthButton: ['monthButton', disabled && 'disabled', selected && 'selected']
  };
  return (0,composeClasses/* default */.Z)(slots, getPickersMonthUtilityClass, classes);
};
const PickersMonthRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPickersMonth',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})(({
  ownerState
}) => ({
  flexBasis: ownerState.monthsPerRow === 3 ? '33.3%' : '25%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
const PickersMonthButton = (0,styled/* default */.ZP)('button', {
  name: 'MuiPickersMonth',
  slot: 'MonthButton',
  overridesResolver: (_, styles) => [styles.monthButton, {
    [`&.${pickersMonthClasses.disabled}`]: styles.disabled
  }, {
    [`&.${pickersMonthClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => (0,esm_extends/* default */.Z)({
  color: 'unset',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: '8px 0',
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: 'pointer',
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:disabled': {
    cursor: 'auto',
    pointerEvents: 'none'
  },
  [`&.${pickersMonthClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${pickersMonthClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));

/**
 * @ignore - do not document.
 */
const PickersMonth = /*#__PURE__*/react.memo(function PickersMonth(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPickersMonth'
  });
  const {
      autoFocus,
      children,
      disabled,
      value,
      tabIndex,
      onClick,
      onKeyDown,
      onFocus,
      onBlur,
      'aria-current': ariaCurrent
      // We don't want to forward this prop to the root element
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ref = react.useRef(null);
  const classes = useUtilityClasses(props);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (autoFocus) {
      var _ref$current;
      (_ref$current = ref.current) == null ? void 0 : _ref$current.focus();
    }
  }, [autoFocus]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersMonthRoot, (0,esm_extends/* default */.Z)({
    className: classes.root,
    ownerState: props
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(PickersMonthButton, {
      ref: ref,
      disabled: disabled,
      type: "button",
      tabIndex: disabled ? -1 : tabIndex,
      "aria-current": ariaCurrent,
      onClick: event => onClick(event, value),
      onKeyDown: event => onKeyDown(event, value),
      onFocus: event => onFocus(event, value),
      onBlur: event => onBlur(event, value),
      className: classes.monthButton,
      ownerState: props,
      children: children
    })
  }));
});
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/MonthCalendar/monthCalendarClasses.js

function getMonthCalendarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiMonthCalendar', slot);
}
const monthCalendarClasses = (0,generateUtilityClasses/* default */.Z)('MuiMonthCalendar', ['root']);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/date-utils.js
var date_utils = __webpack_require__(5535);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/valueManagers.js
var valueManagers = __webpack_require__(55071);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/getDefaultReferenceDate.js + 1 modules
var getDefaultReferenceDate = __webpack_require__(95318);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/useValueWithTimezone.js
var useValueWithTimezone = __webpack_require__(57605);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/MonthCalendar/MonthCalendar.js


const MonthCalendar_excluded = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone"];














const MonthCalendar_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getMonthCalendarUtilityClass, classes);
};
function useMonthCalendarDefaultizedProps(props, name) {
  const utils = (0,useUtils/* useUtils */.nB)();
  const defaultDates = (0,useUtils/* useDefaultDates */.PP)();
  const themeProps = (0,useThemeProps/* default */.Z)({
    props,
    name
  });
  return (0,esm_extends/* default */.Z)({
    disableFuture: false,
    disablePast: false
  }, themeProps, {
    minDate: (0,date_utils/* applyDefaultDate */.US)(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: (0,date_utils/* applyDefaultDate */.US)(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const MonthCalendarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiMonthCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'stretch',
  padding: '0 4px',
  width: 320
});
const MonthCalendar = /*#__PURE__*/react.forwardRef(function MonthCalendar(inProps, ref) {
  const props = useMonthCalendarDefaultizedProps(inProps, 'MuiMonthCalendar');
  const {
      className,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disabled,
      disableFuture,
      disablePast,
      maxDate,
      minDate,
      onChange,
      shouldDisableMonth,
      readOnly,
      disableHighlightToday,
      autoFocus = false,
      onMonthFocus,
      hasFocus,
      onFocusedViewChange,
      monthsPerRow = 3,
      timezone: timezoneProp
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, MonthCalendar_excluded);
  const {
    value,
    handleValueChange,
    timezone
  } = (0,useValueWithTimezone/* useControlledValueWithTimezone */.m)({
    name: 'MonthCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange: onChange,
    valueManager: valueManagers/* singleItemValueManager */.h
  });
  const now = (0,useUtils/* useNow */.mX)(timezone);
  const theme = (0,useTheme/* default */.Z)();
  const utils = (0,useUtils/* useUtils */.nB)();
  const referenceDate = react.useMemo(() => valueManagers/* singleItemValueManager.getInitialReferenceValue */.h.getInitialReferenceValue({
    value,
    utils,
    props,
    timezone,
    referenceDate: referenceDateProp,
    granularity: getDefaultReferenceDate/* SECTION_TYPE_GRANULARITY.month */.Kn.month
  }), [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const ownerState = props;
  const classes = MonthCalendar_useUtilityClasses(ownerState);
  const todayMonth = react.useMemo(() => utils.getMonth(now), [utils, now]);
  const selectedMonth = react.useMemo(() => {
    if (value != null) {
      return utils.getMonth(value);
    }
    if (disableHighlightToday) {
      return null;
    }
    return utils.getMonth(referenceDate);
  }, [value, utils, disableHighlightToday, referenceDate]);
  const [focusedMonth, setFocusedMonth] = react.useState(() => selectedMonth || todayMonth);
  const [internalHasFocus, setInternalHasFocus] = (0,useControlled/* default */.Z)({
    name: 'MonthCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus != null ? autoFocus : false
  });
  const changeHasFocus = (0,useEventCallback/* default */.Z)(newHasFocus => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isMonthDisabled = react.useCallback(dateToValidate => {
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    const monthToValidate = utils.startOfMonth(dateToValidate);
    if (utils.isBefore(monthToValidate, firstEnabledMonth)) {
      return true;
    }
    if (utils.isAfter(monthToValidate, lastEnabledMonth)) {
      return true;
    }
    if (!shouldDisableMonth) {
      return false;
    }
    return shouldDisableMonth(monthToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableMonth, utils]);
  const handleMonthSelection = (0,useEventCallback/* default */.Z)((event, month) => {
    if (readOnly) {
      return;
    }
    const newDate = utils.setMonth(value != null ? value : referenceDate, month);
    handleValueChange(newDate);
  });
  const focusMonth = (0,useEventCallback/* default */.Z)(month => {
    if (!isMonthDisabled(utils.setMonth(value != null ? value : referenceDate, month))) {
      setFocusedMonth(month);
      changeHasFocus(true);
      if (onMonthFocus) {
        onMonthFocus(month);
      }
    }
  });
  react.useEffect(() => {
    setFocusedMonth(prevFocusedMonth => selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
  }, [selectedMonth]);
  const handleKeyDown = (0,useEventCallback/* default */.Z)((event, month) => {
    const monthsInYear = 12;
    const monthsInRow = 3;
    switch (event.key) {
      case 'ArrowUp':
        focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowLeft':
        focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? -1 : 1)) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowRight':
        focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? 1 : -1)) % monthsInYear);
        event.preventDefault();
        break;
      default:
        break;
    }
  });
  const handleMonthFocus = (0,useEventCallback/* default */.Z)((event, month) => {
    focusMonth(month);
  });
  const handleMonthBlur = (0,useEventCallback/* default */.Z)((event, month) => {
    if (focusedMonth === month) {
      changeHasFocus(false);
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MonthCalendarRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: (0,date_utils/* getMonthsInYear */.SV)(utils, value != null ? value : referenceDate).map(month => {
      const monthNumber = utils.getMonth(month);
      const monthText = utils.format(month, 'monthShort');
      const isSelected = monthNumber === selectedMonth;
      const isDisabled = disabled || isMonthDisabled(month);
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersMonth, {
        selected: isSelected,
        value: monthNumber,
        onClick: handleMonthSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && monthNumber === focusedMonth,
        disabled: isDisabled,
        tabIndex: monthNumber === focusedMonth ? 0 : -1,
        onFocus: handleMonthFocus,
        onBlur: handleMonthBlur,
        "aria-current": todayMonth === monthNumber ? 'date' : undefined,
        monthsPerRow: monthsPerRow,
        children: monthText
      }, monthText);
    })
  }));
});
 false ? 0 : void 0;
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef/useForkRef.js
var useForkRef = __webpack_require__(33703);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/YearCalendar/pickersYearClasses.js

function getPickersYearUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPickersYear', slot);
}
const pickersYearClasses = (0,generateUtilityClasses/* default */.Z)('MuiPickersYear', ['root', 'yearButton', 'selected', 'disabled']);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/YearCalendar/PickersYear.js


const PickersYear_excluded = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow"];






const PickersYear_useUtilityClasses = ownerState => {
  const {
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    yearButton: ['yearButton', disabled && 'disabled', selected && 'selected']
  };
  return (0,composeClasses/* default */.Z)(slots, getPickersYearUtilityClass, classes);
};
const PickersYearRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPickersYear',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})(({
  ownerState
}) => ({
  flexBasis: ownerState.yearsPerRow === 3 ? '33.3%' : '25%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
const PickersYearButton = (0,styled/* default */.ZP)('button', {
  name: 'MuiPickersYear',
  slot: 'YearButton',
  overridesResolver: (_, styles) => [styles.yearButton, {
    [`&.${pickersYearClasses.disabled}`]: styles.disabled
  }, {
    [`&.${pickersYearClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => (0,esm_extends/* default */.Z)({
  color: 'unset',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: '8px 0',
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: 'pointer',
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.action.active, theme.palette.action.focusOpacity)
  },
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:disabled': {
    cursor: 'auto',
    pointerEvents: 'none'
  },
  [`&.${pickersYearClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${pickersYearClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));

/**
 * @ignore - internal component.
 */
const PickersYear = /*#__PURE__*/react.memo(function PickersYear(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPickersYear'
  });
  const {
      autoFocus,
      className,
      children,
      disabled,
      value,
      tabIndex,
      onClick,
      onKeyDown,
      onFocus,
      onBlur,
      'aria-current': ariaCurrent
      // We don't want to forward this prop to the root element
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, PickersYear_excluded);
  const ref = react.useRef(null);
  const classes = PickersYear_useUtilityClasses(props);

  // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
  react.useEffect(() => {
    if (autoFocus) {
      // `ref.current` being `null` would be a bug in MUI.
      ref.current.focus();
    }
  }, [autoFocus]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersYearRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: props
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(PickersYearButton, {
      ref: ref,
      disabled: disabled,
      type: "button",
      tabIndex: disabled ? -1 : tabIndex,
      "aria-current": ariaCurrent,
      onClick: event => onClick(event, value),
      onKeyDown: event => onKeyDown(event, value),
      onFocus: event => onFocus(event, value),
      onBlur: event => onBlur(event, value),
      className: classes.yearButton,
      ownerState: props,
      children: children
    })
  }));
});
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/YearCalendar/yearCalendarClasses.js

function getYearCalendarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiYearCalendar', slot);
}
const yearCalendarClasses = (0,generateUtilityClasses/* default */.Z)('MuiYearCalendar', ['root']);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/YearCalendar/YearCalendar.js


const YearCalendar_excluded = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone"];














const YearCalendar_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getYearCalendarUtilityClass, classes);
};
function useYearCalendarDefaultizedProps(props, name) {
  const utils = (0,useUtils/* useUtils */.nB)();
  const defaultDates = (0,useUtils/* useDefaultDates */.PP)();
  const themeProps = (0,useThemeProps/* default */.Z)({
    props,
    name
  });
  return (0,esm_extends/* default */.Z)({
    disablePast: false,
    disableFuture: false
  }, themeProps, {
    minDate: (0,date_utils/* applyDefaultDate */.US)(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: (0,date_utils/* applyDefaultDate */.US)(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const YearCalendarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiYearCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  overflowY: 'auto',
  height: '100%',
  padding: '0 4px',
  width: 320,
  maxHeight: 304
});
const YearCalendar = /*#__PURE__*/react.forwardRef(function YearCalendar(inProps, ref) {
  const props = useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
  const {
      autoFocus,
      className,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disabled,
      disableFuture,
      disablePast,
      maxDate,
      minDate,
      onChange,
      readOnly,
      shouldDisableYear,
      disableHighlightToday,
      onYearFocus,
      hasFocus,
      onFocusedViewChange,
      yearsPerRow = 3,
      timezone: timezoneProp
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, YearCalendar_excluded);
  const {
    value,
    handleValueChange,
    timezone
  } = (0,useValueWithTimezone/* useControlledValueWithTimezone */.m)({
    name: 'YearCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange: onChange,
    valueManager: valueManagers/* singleItemValueManager */.h
  });
  const now = (0,useUtils/* useNow */.mX)(timezone);
  const theme = (0,useTheme/* default */.Z)();
  const utils = (0,useUtils/* useUtils */.nB)();
  const referenceDate = react.useMemo(() => valueManagers/* singleItemValueManager.getInitialReferenceValue */.h.getInitialReferenceValue({
    value,
    utils,
    props,
    timezone,
    referenceDate: referenceDateProp,
    granularity: getDefaultReferenceDate/* SECTION_TYPE_GRANULARITY.year */.Kn.year
  }), [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const ownerState = props;
  const classes = YearCalendar_useUtilityClasses(ownerState);
  const todayYear = react.useMemo(() => utils.getYear(now), [utils, now]);
  const selectedYear = react.useMemo(() => {
    if (value != null) {
      return utils.getYear(value);
    }
    if (disableHighlightToday) {
      return null;
    }
    return utils.getYear(referenceDate);
  }, [value, utils, disableHighlightToday, referenceDate]);
  const [focusedYear, setFocusedYear] = react.useState(() => selectedYear || todayYear);
  const [internalHasFocus, setInternalHasFocus] = (0,useControlled/* default */.Z)({
    name: 'YearCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus != null ? autoFocus : false
  });
  const changeHasFocus = (0,useEventCallback/* default */.Z)(newHasFocus => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isYearDisabled = react.useCallback(dateToValidate => {
    if (disablePast && utils.isBeforeYear(dateToValidate, now)) {
      return true;
    }
    if (disableFuture && utils.isAfterYear(dateToValidate, now)) {
      return true;
    }
    if (minDate && utils.isBeforeYear(dateToValidate, minDate)) {
      return true;
    }
    if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) {
      return true;
    }
    if (!shouldDisableYear) {
      return false;
    }
    const yearToValidate = utils.startOfYear(dateToValidate);
    return shouldDisableYear(yearToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableYear, utils]);
  const handleYearSelection = (0,useEventCallback/* default */.Z)((event, year) => {
    if (readOnly) {
      return;
    }
    const newDate = utils.setYear(value != null ? value : referenceDate, year);
    handleValueChange(newDate);
  });
  const focusYear = (0,useEventCallback/* default */.Z)(year => {
    if (!isYearDisabled(utils.setYear(value != null ? value : referenceDate, year))) {
      setFocusedYear(year);
      changeHasFocus(true);
      onYearFocus == null ? void 0 : onYearFocus(year);
    }
  });
  react.useEffect(() => {
    setFocusedYear(prevFocusedYear => selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
  }, [selectedYear]);
  const handleKeyDown = (0,useEventCallback/* default */.Z)((event, year) => {
    switch (event.key) {
      case 'ArrowUp':
        focusYear(year - yearsPerRow);
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusYear(year + yearsPerRow);
        event.preventDefault();
        break;
      case 'ArrowLeft':
        focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
        event.preventDefault();
        break;
      case 'ArrowRight':
        focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
        event.preventDefault();
        break;
      default:
        break;
    }
  });
  const handleYearFocus = (0,useEventCallback/* default */.Z)((event, year) => {
    focusYear(year);
  });
  const handleYearBlur = (0,useEventCallback/* default */.Z)((event, year) => {
    if (focusedYear === year) {
      changeHasFocus(false);
    }
  });
  const scrollerRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(ref, scrollerRef);
  react.useEffect(() => {
    if (autoFocus || scrollerRef.current === null) {
      return;
    }
    const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
    if (!tabbableButton) {
      return;
    }

    // Taken from useScroll in x-data-grid, but vertically centered
    const offsetHeight = tabbableButton.offsetHeight;
    const offsetTop = tabbableButton.offsetTop;
    const clientHeight = scrollerRef.current.clientHeight;
    const scrollTop = scrollerRef.current.scrollTop;
    const elementBottom = offsetTop + offsetHeight;
    if (offsetHeight > clientHeight || offsetTop < scrollTop) {
      // Button already visible
      return;
    }
    scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
  }, [autoFocus]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(YearCalendarRoot, (0,esm_extends/* default */.Z)({
    ref: handleRef,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: utils.getYearRange(minDate, maxDate).map(year => {
      const yearNumber = utils.getYear(year);
      const isSelected = yearNumber === selectedYear;
      const isDisabled = disabled || isYearDisabled(year);
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PickersYear, {
        selected: isSelected,
        value: yearNumber,
        onClick: handleYearSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && yearNumber === focusedYear,
        disabled: isDisabled,
        tabIndex: yearNumber === focusedYear ? 0 : -1,
        onFocus: handleYearFocus,
        onBlur: handleYearBlur,
        "aria-current": todayYear === yearNumber ? 'date' : undefined,
        yearsPerRow: yearsPerRow,
        children: utils.format(year, 'year')
      }, utils.format(year, 'year'));
    })
  }));
});
 false ? 0 : void 0;
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/internals/hooks/useViews.js



let warnedOnceNotValidView = false;
function useViews({
  onChange,
  onViewChange,
  openTo,
  view: inView,
  views,
  autoFocus,
  focusedView: inFocusedView,
  onFocusedViewChange
}) {
  var _views, _views2;
  if (false) {}
  const previousOpenTo = react.useRef(openTo);
  const previousViews = react.useRef(views);
  const defaultView = react.useRef(views.includes(openTo) ? openTo : views[0]);
  const [view, setView] = (0,useControlled/* default */.Z)({
    name: 'useViews',
    state: 'view',
    controlled: inView,
    default: defaultView.current
  });
  const defaultFocusedView = react.useRef(autoFocus ? view : null);
  const [focusedView, setFocusedView] = (0,useControlled/* default */.Z)({
    name: 'useViews',
    state: 'focusedView',
    controlled: inFocusedView,
    default: defaultFocusedView.current
  });
  react.useEffect(() => {
    // Update the current view when `openTo` or `views` props change
    if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some(previousView => !views.includes(previousView))) {
      setView(views.includes(openTo) ? openTo : views[0]);
      previousViews.current = views;
      previousOpenTo.current = openTo;
    }
  }, [openTo, setView, view, views]);
  const viewIndex = views.indexOf(view);
  const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
  const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
  const handleFocusedViewChange = (0,useEventCallback/* default */.Z)((viewToFocus, hasFocus) => {
    if (hasFocus) {
      // Focus event
      setFocusedView(viewToFocus);
    } else {
      // Blur event
      setFocusedView(prevFocusedView => viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
      );
    }

    onFocusedViewChange == null ? void 0 : onFocusedViewChange(viewToFocus, hasFocus);
  });
  const handleChangeView = (0,useEventCallback/* default */.Z)(newView => {
    if (newView === view) {
      return;
    }
    setView(newView);
    handleFocusedViewChange(newView, true);
    if (onViewChange) {
      onViewChange(newView);
    }
  });
  const goToNextView = (0,useEventCallback/* default */.Z)(() => {
    if (nextView) {
      handleChangeView(nextView);
    }
    handleFocusedViewChange(nextView, true);
  });
  const setValueAndGoToNextView = (0,useEventCallback/* default */.Z)((value, currentViewSelectionState, selectedView) => {
    const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
    const hasMoreViews = selectedView ?
    // handles case like `DateTimePicker`, where a view might return a `finish` selection state
    // but we it's not the final view given all `views` -> overall selection state should be `partial`.
    views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
    const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
    onChange(value, globalSelectionState);
    if (isSelectionFinishedOnCurrentView) {
      goToNextView();
    }
  });
  const setValueAndGoToView = (0,useEventCallback/* default */.Z)((value, newView, selectedView) => {
    onChange(value, newView ? 'partial' : 'finish', selectedView);
    if (newView) {
      handleChangeView(newView);
      handleFocusedViewChange(newView, true);
    }
  });
  return {
    view,
    setView: handleChangeView,
    focusedView,
    setFocusedView: handleFocusedViewChange,
    nextView,
    previousView,
    defaultView: defaultView.current,
    goToNextView,
    setValueAndGoToNextView,
    setValueAndGoToView
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/PickersCalendarHeader.js + 1 modules
var PickersCalendarHeader = __webpack_require__(92317);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/constants/dimensions.js
var dimensions = __webpack_require__(67542);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/internals/components/PickerViewRoot/PickerViewRoot.js


const PickerViewRoot = (0,styled/* default */.ZP)('div')({
  overflow: 'hidden',
  width: dimensions/* DIALOG_WIDTH */.Pl,
  maxHeight: dimensions/* VIEW_HEIGHT */.BR,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto'
});
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/internals/utils/defaultReduceAnimations.js
var defaultReduceAnimations = __webpack_require__(21783);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/dateCalendarClasses.js

const getDateCalendarUtilityClass = slot => (0,generateUtilityClass/* default */.Z)('MuiDateCalendar', slot);
const dateCalendarClasses = (0,generateUtilityClasses/* default */.Z)('MuiDateCalendar', ['root', 'viewTransitionContainer']);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/DateCalendar/DateCalendar.js


const DateCalendar_excluded = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "defaultCalendarMonth", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "components", "componentsProps", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsPerRow", "monthsPerRow", "timezone"];





















const DateCalendar_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    viewTransitionContainer: ['viewTransitionContainer']
  };
  return (0,composeClasses/* default */.Z)(slots, getDateCalendarUtilityClass, classes);
};
function useDateCalendarDefaultizedProps(props, name) {
  const utils = (0,useUtils/* useUtils */.nB)();
  const defaultDates = (0,useUtils/* useDefaultDates */.PP)();
  const themeProps = (0,useThemeProps/* default */.Z)({
    props,
    name
  });
  return (0,esm_extends/* default */.Z)({
    loading: false,
    disablePast: false,
    disableFuture: false,
    openTo: 'day',
    views: ['year', 'day'],
    reduceAnimations: defaultReduceAnimations/* defaultReduceAnimations */.x,
    renderLoading: () => /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "..."
    })
  }, themeProps, {
    minDate: (0,date_utils/* applyDefaultDate */.US)(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: (0,date_utils/* applyDefaultDate */.US)(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const DateCalendarRoot = (0,styled/* default */.ZP)(PickerViewRoot, {
  name: 'MuiDateCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'column'
});
const DateCalendarViewTransitionContainer = (0,styled/* default */.ZP)(PickersFadeTransitionGroup/* PickersFadeTransitionGroup */.s, {
  name: 'MuiDateCalendar',
  slot: 'ViewTransitionContainer',
  overridesResolver: (props, styles) => styles.viewTransitionContainer
})({});
/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/x/react-date-pickers/date-picker/)
 *
 * API:
 *
 * - [DateCalendar API](https://mui.com/x/api/date-pickers/date-calendar/)
 */
const DateCalendar = /*#__PURE__*/react.forwardRef(function DateCalendar(inProps, ref) {
  const utils = (0,useUtils/* useUtils */.nB)();
  const id = (0,useId/* default */.Z)();
  const props = useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
  const {
      autoFocus,
      onViewChange,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disableFuture,
      disablePast,
      defaultCalendarMonth,
      onChange,
      onYearChange,
      onMonthChange,
      reduceAnimations,
      shouldDisableDate,
      shouldDisableMonth,
      shouldDisableYear,
      view: inView,
      views,
      openTo,
      className,
      disabled,
      readOnly,
      minDate,
      maxDate,
      disableHighlightToday,
      focusedView: inFocusedView,
      onFocusedViewChange,
      showDaysOutsideCurrentMonth,
      fixedWeekNumber,
      dayOfWeekFormatter,
      components,
      componentsProps,
      slots,
      slotProps,
      loading,
      renderLoading,
      displayWeekNumber,
      yearsPerRow,
      monthsPerRow,
      timezone: timezoneProp
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, DateCalendar_excluded);
  const {
    value,
    handleValueChange,
    timezone
  } = (0,useValueWithTimezone/* useControlledValueWithTimezone */.m)({
    name: 'DateCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    onChange,
    valueManager: valueManagers/* singleItemValueManager */.h
  });
  const {
    view,
    setView,
    focusedView,
    setFocusedView,
    goToNextView,
    setValueAndGoToNextView
  } = useViews({
    view: inView,
    views,
    openTo,
    onChange: handleValueChange,
    onViewChange,
    autoFocus,
    focusedView: inFocusedView,
    onFocusedViewChange
  });
  const {
    referenceDate,
    calendarState,
    changeFocusedDay,
    changeMonth,
    handleChangeMonth,
    isDateDisabled,
    onMonthSwitchingAnimationEnd
  } = (0,useCalendarState/* useCalendarState */.F)({
    value,
    defaultCalendarMonth,
    referenceDate: referenceDateProp,
    reduceAnimations,
    onMonthChange,
    minDate,
    maxDate,
    shouldDisableDate,
    disablePast,
    disableFuture,
    timezone
  });
  const handleDateMonthChange = (0,useEventCallback/* default */.Z)(newDate => {
    const startOfMonth = utils.startOfMonth(newDate);
    const endOfMonth = utils.endOfMonth(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? (0,date_utils/* findClosestEnabledDate */.xP)({
      utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
      maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, 'finish');
      onMonthChange == null ? void 0 : onMonthChange(startOfMonth);
    } else {
      goToNextView();
      changeMonth(startOfMonth);
    }
    changeFocusedDay(closestEnabledDate, true);
  });
  const handleDateYearChange = (0,useEventCallback/* default */.Z)(newDate => {
    const startOfYear = utils.startOfYear(newDate);
    const endOfYear = utils.endOfYear(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? (0,date_utils/* findClosestEnabledDate */.xP)({
      utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
      maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, 'finish');
      onYearChange == null ? void 0 : onYearChange(closestEnabledDate);
    } else {
      goToNextView();
      changeMonth(startOfYear);
    }
    changeFocusedDay(closestEnabledDate, true);
  });
  const handleSelectedDayChange = (0,useEventCallback/* default */.Z)(day => {
    if (day) {
      // If there is a date already selected, then we want to keep its time
      return handleValueChange((0,date_utils/* mergeDateAndTime */.zu)(utils, day, value != null ? value : referenceDate), 'finish');
    }
    return handleValueChange(day, 'finish');
  });
  react.useEffect(() => {
    if (value != null && utils.isValid(value)) {
      changeMonth(value);
    }
  }, [value]); // eslint-disable-line

  const ownerState = props;
  const classes = DateCalendar_useUtilityClasses(ownerState);
  const baseDateValidationProps = {
    disablePast,
    disableFuture,
    maxDate,
    minDate
  };

  // When disabled, limit the view to the selected date
  const minDateWithDisabled = disabled && value || minDate;
  const maxDateWithDisabled = disabled && value || maxDate;
  const commonViewProps = {
    disableHighlightToday,
    readOnly,
    disabled,
    timezone
  };
  const gridLabelId = `${id}-grid-label`;
  const hasFocus = focusedView !== null;
  const prevOpenViewRef = react.useRef(view);
  react.useEffect(() => {
    // If the view change and the focus was on the previous view
    // Then we update the focus.
    if (prevOpenViewRef.current === view) {
      return;
    }
    if (focusedView === prevOpenViewRef.current) {
      setFocusedView(view, true);
    }
    prevOpenViewRef.current = view;
  }, [focusedView, setFocusedView, view]);
  const selectedDays = react.useMemo(() => [value], [value]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DateCalendarRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PickersCalendarHeader/* PickersCalendarHeader */.o, {
      views: views,
      view: view,
      currentMonth: calendarState.currentMonth,
      onViewChange: setView,
      onMonthChange: (newMonth, direction) => handleChangeMonth({
        newMonth,
        direction
      }),
      minDate: minDateWithDisabled,
      maxDate: maxDateWithDisabled,
      disabled: disabled,
      disablePast: disablePast,
      disableFuture: disableFuture,
      reduceAnimations: reduceAnimations,
      labelId: gridLabelId,
      slots: slots,
      slotProps: slotProps,
      timezone: timezone
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateCalendarViewTransitionContainer, {
      reduceAnimations: reduceAnimations,
      className: classes.viewTransitionContainer,
      transKey: view,
      ownerState: ownerState,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [view === 'year' && /*#__PURE__*/(0,jsx_runtime.jsx)(YearCalendar, (0,esm_extends/* default */.Z)({}, baseDateValidationProps, commonViewProps, {
          value: value,
          onChange: handleDateYearChange,
          shouldDisableYear: shouldDisableYear,
          hasFocus: hasFocus,
          onFocusedViewChange: isViewFocused => setFocusedView('year', isViewFocused),
          yearsPerRow: yearsPerRow,
          referenceDate: referenceDate
        })), view === 'month' && /*#__PURE__*/(0,jsx_runtime.jsx)(MonthCalendar, (0,esm_extends/* default */.Z)({}, baseDateValidationProps, commonViewProps, {
          hasFocus: hasFocus,
          className: className,
          value: value,
          onChange: handleDateMonthChange,
          shouldDisableMonth: shouldDisableMonth,
          onFocusedViewChange: isViewFocused => setFocusedView('month', isViewFocused),
          monthsPerRow: monthsPerRow,
          referenceDate: referenceDate
        })), view === 'day' && /*#__PURE__*/(0,jsx_runtime.jsx)(DayCalendar/* DayCalendar */.e, (0,esm_extends/* default */.Z)({}, calendarState, baseDateValidationProps, commonViewProps, {
          onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
          onFocusedDayChange: changeFocusedDay,
          reduceAnimations: reduceAnimations,
          selectedDays: selectedDays,
          onSelectedDaysChange: handleSelectedDayChange,
          shouldDisableDate: shouldDisableDate,
          shouldDisableMonth: shouldDisableMonth,
          shouldDisableYear: shouldDisableYear,
          hasFocus: hasFocus,
          onFocusedViewChange: isViewFocused => setFocusedView('day', isViewFocused),
          gridLabelId: gridLabelId,
          showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
          fixedWeekNumber: fixedWeekNumber,
          dayOfWeekFormatter: dayOfWeekFormatter,
          displayWeekNumber: displayWeekNumber,
          components: components,
          componentsProps: componentsProps,
          slots: slots,
          slotProps: slotProps,
          loading: loading,
          renderLoading: renderLoading
        }))]
      })
    })]
  }));
});
 false ? 0 : void 0;
// EXTERNAL MODULE: ./src/components/date-calendars/DateCalendarStylesWrapper.tsx
var DateCalendarStylesWrapper = __webpack_require__(24679);
;// CONCATENATED MODULE: ./src/components/date-calendars/DateCalendar.tsx
// eslint-disable-next-line no-restricted-imports





var DateCalendar_DateCalendar = function(_param) /*#__PURE__*/ {
    var _views = _param.views, views = _views === void 0 ? [
        "day"
    ] : _views, variant = _param.variant, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "views",
        "variant"
    ]);
    return (0,jsx_runtime.jsx)(DateCalendarStylesWrapper/* DateCalendarStylesWrapper */.a, {
        variant: variant,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateCalendar, (0,_object_spread/* default */.Z)({
            views: views
        }, rest))
    });
};


/***/ }),

/***/ 24679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ DateCalendarStylesWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _DateCalendarStylesWrapper_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63939);
/* harmony import */ var _DateCalendarStylesWrapper_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_DateCalendarStylesWrapper_module_scss__WEBPACK_IMPORTED_MODULE_2__);





var DateCalendarStylesWrapper = function(param) {
    var extClasses = param.classes, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, children = param.children;
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__/* .mergeClassNames */ .E)((_DateCalendarStylesWrapper_module_scss__WEBPACK_IMPORTED_MODULE_2___default()), extClasses || {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, classes["root--micro"], variant === "micro")),
        children: children
    });
};


/***/ }),

/***/ 5062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AsyncButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87357);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11057);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98456);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41796);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61214);
/* harmony import */ var _mui_icons_material_CheckCircleRounded__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(58442);
/* harmony import */ var _mui_icons_material_ErrorRounded__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(51182);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
















var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        button: {
            minWidth: 24,
            "&$success": {
                borderColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* .darken */ ._j)(theme.palette.success.main, 0.25)
            },
            "&$error": {
                borderColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* .darken */ ._j)(theme.palette.error.main, 0.25)
            },
            transition: theme.transitions.create([
                "color",
                "background-color",
                "opacity"
            ], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.standard
            })
        },
        spinner: {
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: -12,
            marginLeft: -12,
            borderRadius: theme.shape.borderRadius,
            backgroundColor: "transparent",
            "$success &": {
                color: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* .lighten */ .$n)(theme.palette.success.main, 0.75)
            },
            "$error &": {
                color: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* .lighten */ .$n)(theme.palette.error.main, 0.65)
            }
        },
        primarySpinner: {
            color: theme.colors.white
        },
        success: {
            backgroundColor: theme.palette.success.main,
            "&:hover": {
                backgroundColor: theme.palette.success.light
            }
        },
        error: {
            backgroundColor: theme.palette.error.main,
            "&:hover": {
                backgroundColor: theme.palette.error.light
            }
        },
        checkIcon: {
            height: 18,
            marginTop: -9,
            marginLeft: -9,
            width: 18
        },
        hidden: {
            opacity: 0
        }
    };
}, {
    classNamePrefix: "AsyncButton"
});
var AsyncButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var className = _param.className, _resetDelay = _param.resetDelay, resetDelay = _resetDelay === void 0 ? 3000 : _resetDelay, startIcon = _param.startIcon, children = _param.children, successColor = _param.successColor, onClick = _param.onClick, onSuccess = _param.onSuccess, onError = _param.onError, onReset = _param.onReset, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "resetDelay",
        "startIcon",
        "children",
        "successColor",
        "onClick",
        "onSuccess",
        "onError",
        "onReset"
    ]);
    var classes = useStyles();
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = _$ref[0], setLoading = _$ref[1];
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), success = _$ref1[0], setSuccess = _$ref1[1];
    var timer = react__WEBPACK_IMPORTED_MODULE_1__.useRef();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        if (success !== null) {
            timer.current = setTimeout(function() {
                setSuccess(null);
                if (onReset) onReset();
            }, resetDelay);
        }
        return function() {
            if (timer.current) {
                clearTimeout(timer.current);
                timer.current = undefined;
            }
        };
    }, [
        resetDelay,
        success,
        onReset
    ]);
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
            var res, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (loading) return [
                            2
                        ];
                        if (!onClick) return [
                            2
                        ];
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            onClick(e)
                        ];
                    case 2:
                        res = _state.sent();
                        setSuccess(true);
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(e, res);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        // eslint-disable-next-line no-console
                        console.error(err);
                        setSuccess(false);
                        onError === null || onError === void 0 ? void 0 : onError(e, err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loading,
        onClick,
        onError,
        onSuccess
    ]);
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.button, className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, classes.success, true === success), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, classes.error, false === success), _obj)),
        startIcon: !loading && !success && startIcon,
        disabled: loading,
        onClick: handleClick
    }, rest), {
        children: [
            !!loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                size: 24,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.spinner, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, classes.primarySpinner, rest.color === "primary" && rest.variant === "contained"))
            }),
            !loading && null === success ? // https://github.com/reclaim-ai/reclaim-worklifecalendar/pull/1502
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                className: classes.hidden,
                children: children
            }),
            !loading && false === success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ErrorRounded__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                height: 24,
                className: classes.spinner
            }),
            !loading && !!success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_CheckCircleRounded__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.spinner, classes.checkIcon),
                style: {
                    color: successColor || undefined
                }
            })
        ]
    }));
});


/***/ }),

/***/ 37515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ RadioBoxContext; },
/* harmony export */   "X": function() { return /* binding */ RadioBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41796);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50480);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57922);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36872);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);








var BORDER_RADIUS_MULTIPLIER = 2;
var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            display: "flex",
            alignItems: "flex-start",
            border: "1px solid",
            borderColor: theme.colors.logo.darkness100,
            color: theme.colors.logo.darkness,
            padding: theme.spacing(0.5, 1, 0.5, 0.5),
            width: "100%",
            margin: 0,
            "& em": {
                display: "inline-block",
                backgroundColor: (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* .alpha */ .Fq)(theme.colors.logo.darkness, 0.15),
                borderRadius: 4,
                padding: theme.spacing(0, 0.5),
                fontStyle: "normal",
                transform: "translateY(-1px)"
            }
        },
        rootChecked: {
            backgroundColor: theme.colors.softGrey
        },
        details: {},
        header: {
            marginTop: theme.spacing(1.25),
            fontWeight: theme.typography.fontWeightRegular
        },
        headerChecked: {
            fontWeight: theme.typography.fontWeightMedium
        },
        body: {
            opacity: 0.8,
            paddingBottom: theme.spacing(1)
        },
        radio: {},
        vertical: {
            "&:first-child": {
                borderRadius: theme.spacing(BORDER_RADIUS_MULTIPLIER, BORDER_RADIUS_MULTIPLIER, 0, 0)
            },
            "&:last-child": {
                borderRadius: theme.spacing(0, 0, BORDER_RADIUS_MULTIPLIER, BORDER_RADIUS_MULTIPLIER)
            },
            "&:not(:last-of-type)": {
                borderBottom: "none"
            }
        },
        horizontal: {
            borderRadius: theme.spacing(BORDER_RADIUS_MULTIPLIER)
        }
    };
}, {
    classNamePrefix: "RadioBox"
});
var RadioBoxContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var RadioBox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, children = _param.children, checked = _param.checked, header = _param.header, formControlLabelClasses = _param.formControlLabelClasses, styleless = _param.styleless, _orientation = _param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, checkedContent = _param.checkedContent, value = _param.value, disabled = _param.disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "children",
        "checked",
        "header",
        "formControlLabelClasses",
        "styleless",
        "orientation",
        "checkedContent",
        "value",
        "disabled"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    var ctxValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(RadioBoxContext);
    var realChecked = checked || ctxValue !== undefined && ctxValue === value;
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(className, !styleless && classes.root, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.vertical, orientation === "vertical" && !styleless), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.horizontal, orientation === "horizontal" && !styleless), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, classes.rootChecked, realChecked && !styleless), _obj)),
        classes: formControlLabelClasses,
        disabled: disabled,
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes.details,
            ref: ref,
            children: [
                !!header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.header, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, classes.headerChecked, realChecked)),
                    children: header
                }),
                children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(!styleless && classes.body),
                    children: children
                }),
                checkedContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    in: realChecked,
                    children: checkedContent
                })
            ]
        }),
        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            color: "primary",
            className: classes.radio,
            checked: checked,
            inputRef: inputRef,
            disabled: disabled
        }),
        value: value
    }, rest));
});


/***/ }),

/***/ 77478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ RadioBoxGroupControl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33841);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87357);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _RadioBox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37515);









var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            width: "100%"
        },
        content: {
            display: "flex"
        },
        vertical: {
            flexDirection: "column",
            gap: 0
        },
        horizontal: {
            flexDirection: "row",
            gap: theme.spacing(1),
            justifyContent: "center"
        }
    };
}, {
    classNamePrefix: "RadioBoxGroupControl"
});
var RadioBoxGroupControl = function(_param) {
    var className = _param.className, extClasses = _param.classes, label = _param.label, RadioGroupProps = _param.RadioGroupProps, _orientation = _param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, onChange = _param.onChange, children = _param.children, value = _param.value, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "label",
        "RadioGroupProps",
        "orientation",
        "onChange",
        "children",
        "value"
    ]);
    var classes = useStyles({
        classes: extClasses
    });
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: "standard",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className)
    }, rest), {
        children: [
            !!label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                value: value
            }, RadioGroupProps), {
                onChange: onChange,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.content, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, classes.vertical, orientation === "vertical"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, classes.horizontal, orientation === "horizontal"), _obj)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioBox__WEBPACK_IMPORTED_MODULE_1__/* .RadioBoxContext.Provider */ .G.Provider, {
                        value: value,
                        children: children
                    })
                })
            }))
        ]
    }));
};


/***/ }),

/***/ 25973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ StrongSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_KeyboardArrowDownRounded__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71496);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48885);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33841);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(18360);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(75438);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(56815);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41796);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _AppTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73916);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47310);
/* harmony import */ var _LoadingIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69921);
/* harmony import */ var _MenuItemWithTooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55942);















var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {},
        inputLabel: {
            transform: "translate(14px, -9px) scale(0.75)"
        },
        labelFilled: {
            transform: "translate(14px, 4px) scale(0.75)"
        },
        select: {
            letterSpacing: "normal"
        },
        selectButtonLike: {
            borderRadius: _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .BORDER_RADIUS_MAXIMUS_ROUNDINUS */ .bj,
            fontSize: "0.875rem",
            fontWeight: theme.typography.fontWeightMedium,
            lineHeight: 1.2,
            "&& .MuiOutlinedInput-notchedOutline": {
                borderColor: _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .BUTTON_OUTLINE_BORDER_COLOR */ .lF,
                borderWidth: 1
            },
            "&:focus .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.colors.primary
            },
            "&:hover": {
                backgroundColor: "rgba(82, 99, 243, 0.04)"
            }
        },
        selectPrimary: {
            color: theme.colors.primary,
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "".concat((0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_7__/* .alpha */ .Fq)(theme.colors.primary, 0.3)),
                transition: "border-color ease .2s"
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.colors.primary
            }
        },
        selectFullRadius: {
            borderRadius: _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .BORDER_RADIUS_MAXIMUS_ROUNDINUS */ .bj,
            "&:focus": {
                borderRadius: _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .BORDER_RADIUS_MAXIMUS_ROUNDINUS */ .bj
            }
        },
        innerSelect: {},
        innerSelectButtonLike: {
            padding: _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .BUTTON_OUTLINE_PADDING */ .J2,
            borderRadius: _AppTheme__WEBPACK_IMPORTED_MODULE_2__/* .BORDER_RADIUS_MAXIMUS_ROUNDINUS */ .bj,
            "&&&": {
                backgroundColor: "transparent"
            }
        },
        innerSelectTight: {
            "&&": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, theme.typography.body2), {
                fontWeight: theme.typography.fontWeightMedium,
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1)
            })
        },
        inputBase: {},
        defaultItem: {},
        defaultItemInner: {
            display: "flex",
            gap: theme.spacing(),
            alignItems: "center"
        },
        defaultItemInnerTight: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, theme.typography.body2),
        defaultItemIcon: {
            position: "relative",
            display: "flex",
            width: theme.spacing(2),
            height: theme.spacing(2),
            minWidth: "auto",
            flex: "0 0 auto",
            "& > *": {
                maxWidth: "100%",
                maxHeight: "100%",
                alignItems: "center",
                justifyContent: "middle"
            }
        },
        selectIcon: {
            height: 16,
            width: 16,
            right: theme.spacing(),
            top: 0,
            bottom: 0,
            margin: "auto 0"
        },
        selectIconPrimary: {
            color: theme.colors.primary
        },
        selectIconTight: {},
        thinkingIcon: {}
    };
}, {
    classNamePrefix: "StrongSelect"
});
var StrongSelect = function(_param) {
    var items = _param.items, name = _param.name, extClasses = _param.classes, className = _param.className, label = _param.label, labelId = _param.labelId, error = _param.error, helperText = _param.helperText, renderItem = _param.renderItem, renderGroupItem = _param.renderGroupItem, SelectClasses = _param.SelectClasses, children = _param.children, thinking = _param.thinking, color = _param.color, _variant = _param.variant, variant = _variant === void 0 ? "standard" : _variant, disabled = _param.disabled, fullRadius = _param.fullRadius, tight = _param.tight, buttonLike = _param.buttonLike, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "items",
        "name",
        "classes",
        "className",
        "label",
        "labelId",
        "error",
        "helperText",
        "renderItem",
        "renderGroupItem",
        "SelectClasses",
        "children",
        "thinking",
        "color",
        "variant",
        "disabled",
        "fullRadius",
        "tight",
        "buttonLike"
    ]);
    var ref;
    var classes = useStyles({
        classes: extClasses
    });
    var defaultItemRenderer = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_3__/* .useCallbackSafeRef */ .T)(function(param) {
        var label = param.label, value = param.value, description = param.description, key = param.key, icon = param.icon;
        return rest.native ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
            value: value,
            children: label
        }, key) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_MenuItemWithTooltip__WEBPACK_IMPORTED_MODULE_5__/* .MenuItemWithTooltip */ .v, {
            className: classes.defaultItem,
            classes: {
                wrapper: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.defaultItemInner, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, classes.defaultItemInnerTight, tight))
            },
            value: value,
            title: description,
            children: [
                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    className: classes.defaultItemIcon,
                    children: icon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    variant: "inherit",
                    children: label
                })
            ]
        }, key);
    });
    var colorIsPrimary = color === "primary";
    var variantIsFilled = variant === "filled";
    var _obj, _obj1, _obj2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        variant: "standard",
        error: !!error,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.root, className),
        fullWidth: rest.fullWidth,
        children: [
            !!label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                id: labelId,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.inputLabel, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, classes.labelFilled, variantIsFilled)),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                variant: variant,
                name: name,
                label: label,
                labelId: labelId,
                notched: label ? true : undefined,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.select, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, classes.selectPrimary, colorIsPrimary), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, classes.selectFullRadius, fullRadius), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, classes.selectButtonLike, buttonLike), _obj)),
                classes: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, SelectClasses), {
                    icon: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(SelectClasses === null || SelectClasses === void 0 ? void 0 : SelectClasses.icon, classes.selectIcon, (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj1, classes.selectIconPrimary, colorIsPrimary), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj1, classes.selectIconTight, tight), _obj1)),
                    select: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.innerSelect, (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj2, classes.innerSelectTight, tight), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj2, classes.innerSelectButtonLike, buttonLike), _obj2))
                }),
                IconComponent: thinking ? function(props) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingIcon__WEBPACK_IMPORTED_MODULE_4__/* .LoadingIcon */ .H, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.thinkingIcon, props.className)
                    }));
                } : _mui_icons_material_KeyboardArrowDownRounded__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z,
                color: color,
                disabled: disabled || thinking
            }, rest), {
                inputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, rest.inputProps), {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.inputBase, (ref = rest.inputProps) === null || ref === void 0 ? void 0 : ref.className)
                }),
                children: [
                    items.map(function(item, i) {
                        if (!item) return;
                        if (item === "divider") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {}, "divider-".concat(i));
                        if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(item)) return item;
                        var resolvedItem = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            key: "StrongSelect__item__".concat(item.value || i)
                        }, item);
                        if (resolvedItem.type === "group") {
                            return renderGroupItem ? renderGroupItem(resolvedItem, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                disableSticky: true,
                                children: resolvedItem.label
                            }, resolvedItem.key);
                        }
                        if (renderItem) return renderItem(resolvedItem, i);
                        else return defaultItemRenderer(resolvedItem, i);
                    }),
                    children
                ]
            })),
            !!helperText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                children: helperText
            })
        ]
    });
};


/***/ }),

/***/ 30869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ DateControl; },
  "z": function() { return /* binding */ getDateControlDisplayDate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useDateTimeFormatter.ts + 2 modules
var useDateTimeFormatter = __webpack_require__(62495);
// EXTERNAL MODULE: ./src/utils/dates.ts + 3 modules
var dates = __webpack_require__(26958);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(96514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(16078);
// EXTERNAL MODULE: ./src/utils/scss.utils.ts
var scss_utils = __webpack_require__(91740);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/utils/dom.ts
var dom = __webpack_require__(46734);
// EXTERNAL MODULE: ./src/components/date-calendars/DateCalendar.tsx + 12 modules
var DateCalendar = __webpack_require__(51498);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
;// CONCATENATED MODULE: ./src/components/SmartClickAwayListener.tsx









function smartClickAwayEventIsHandled(e) {
    return e.smartClickAwayListenerEventHandled || false;
}
var SmartClickAwayListener = function(_param) {
    var children = _param.children, onClickAway = _param.onClickAway, estrangedChildren = _param.estrangedChildren, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "onClickAway",
        "estrangedChildren"
    ]);
    var expectedEstrangedChildrenCount = (0,react.useRef)(estrangedChildren === null || estrangedChildren === void 0 ? void 0 : estrangedChildren.length).current;
    if (expectedEstrangedChildrenCount !== (estrangedChildren === null || estrangedChildren === void 0 ? void 0 : estrangedChildren.length)) throw new Error("estrangedChildren length must not change (expected ".concat(expectedEstrangedChildrenCount || 0, ", got ").concat((estrangedChildren === null || estrangedChildren === void 0 ? void 0 : estrangedChildren.length) || 0, ")"));
    var handleClickAway = (0,react.useCallback)(function(e) {
        if (smartClickAwayEventIsHandled(e)) return;
        if ((0,_instanceof/* default */.Z)(e.target, Node) && !(estrangedChildren || []).every(function(child) {
            return (0,dom/* isDescendantOfEl */.C1)(child, e.target);
        })) return;
        onClickAway(e, function() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            e.smartClickAwayListenerEventHandled = true;
        });
    }, /* eslint-disable-next-line react-hooks/exhaustive-deps */ [
        onClickAway
    ].concat((0,_to_consumable_array/* default */.Z)(estrangedChildren || [])));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClickAway: handleClickAway
    }, rest), {
        children: children
    }));
};

// EXTERNAL MODULE: ./src/components/forms/DateTimePicker.module.scss
var DateTimePicker_module = __webpack_require__(81094);
var DateTimePicker_module_default = /*#__PURE__*/__webpack_require__.n(DateTimePicker_module);
;// CONCATENATED MODULE: ./src/components/forms/DateTimePicker.tsx
















var DateTimePicker = function(param) {
    var extClasses = param.classes, anchorEl = param.anchorEl, _value = param.value, value = _value === void 0 ? new Date() : _value, onChange = param.onChange, _placement = param.placement, placement = _placement === void 0 ? "bottom-end" : _placement, inlinePicker = param.inlinePicker, staticPicker = param.staticPicker, _disablePast = param.disablePast, disablePast = _disablePast === void 0 ? true : _disablePast, _disableFuture = param.disableFuture, disableFuture = _disableFuture === void 0 ? false : _disableFuture;
    var classes = (0,scss_utils/* mergeClassNames */.E)((DateTimePicker_module_default()), extClasses || {});
    /********************/ /*   custom hooks   */ /********************/ /********************/ /*     useState     */ /********************/ var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ var handleClickOutside = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(e, clickAwayHandled) {
        if (document.activeElement !== anchorEl.current && e.target !== anchorEl.current && "relatedTarget" in e && !(0,dom/* isDescendant */.SG)("reclaim-datetime-picker-ui", e.relatedTarget)) setOpen(false);
        else clickAwayHandled();
    });
    var handleChange = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(date) {
        var ref;
        var name = (ref = anchorEl.current) === null || ref === void 0 ? void 0 : ref.getAttribute("name");
        if (!!name && onChange && (0,dates/* isValid */.JY)(date)) {
            onChange(name, date);
            setOpen(false);
        }
    });
    /**
   * This prevents the blur event from triggering early when the date picker is used in safari. This is an
   * issue in safari because the relatedTarget is not attached to the blur event (see toggleOpen function)
   */ var handleMouseDown = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(e) {
        e.stopPropagation();
        e.preventDefault();
    });
    /********************/ /*    useEffects    */ /********************/ /**
   * Register event listeners to show/hide calendar dialog
   */ (0,react.useEffect)(function() {
        var el = anchorEl.current;
        if (!el) return;
        var toggleOpen = function(e) {
            if (open && e.relatedTarget === el || // Note: e.relatedTarget is null in safari here. see handleMonthNavigation.
            (0,dom/* isDescendant */.SG)("reclaim-datetime-picker-ui", e.relatedTarget) || (0,dom/* isDescendant */.SG)("reclaim-datetime-picker-ui", e.target)) {
                return;
            }
            setOpen(document.activeElement === el);
            // TODO (SS): This prevents cases where DatePicker fires onChange right when
            // the popper opens initially (past dates). When this happens the date picker does
            // not show on focus. Need to consider another option here but right now we have no control
            // when this event is fired. Other option would be to remove the setOpen(false) from handleChange
            // which would have some UX to consider.
            setTimeout(function() {
                if (!open) setOpen(document.activeElement === el);
            }, 50);
        };
        el.autocomplete = "off";
        el.addEventListener("focus", toggleOpen);
        el.addEventListener("blur", toggleOpen);
        return function() {
            el.removeEventListener("focus", toggleOpen);
            el.removeEventListener("blur", toggleOpen);
        };
    }, [
        anchorEl,
        open
    ]);
    /********************/ /*       JSX        */ /********************/ var datePicker = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DateCalendar/* DateCalendar */.W, {
            slotProps: {
                rightArrowIcon: {
                    onMouseDown: handleMouseDown
                },
                leftArrowIcon: {
                    onMouseDown: handleMouseDown
                }
            },
            openTo: "day",
            disablePast: disablePast,
            disableFuture: disableFuture,
            value: value,
            onChange: handleChange,
            variant: "micro"
        });
    }, [
        value,
        disablePast,
        disableFuture,
        handleMouseDown,
        handleChange
    ]);
    var inlinePickerNode = (0,react.useMemo)(function() {
        return !staticPicker ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: "reclaim-datetime-picker-ui",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: open,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (0,clsx_m/* default */.Z)(classes.picker, classes.inlinePicker),
                    children: datePicker
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (0,clsx_m/* default */.Z)(classes.picker, classes.inlinePicker),
            children: datePicker
        });
    }, [
        staticPicker,
        open,
        datePicker,
        classes
    ]);
    return !inlinePicker ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartClickAwayListener, {
        onClickAway: handleClickOutside,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
            className: (0,clsx_m/* default */.Z)("reclaim-datetime-picker-ui", classes.popper),
            onMouseDown: handleMouseDown,
            open: open,
            anchorEl: anchorEl.current,
            placement: placement,
            role: undefined,
            transition: true,
            children: function(param) {
                var TransitionProps = param.TransitionProps, placement = param.placement;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grow/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TransitionProps), {
                    style: {
                        transformOrigin: /^bottom/i.test(placement) ? "right top" : "right bottom"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)("reclaim-datetime-picker-ui", classes.paper, classes.picker),
                        children: datePicker
                    })
                }));
            }
        })
    }) : inlinePickerNode;
};

// EXTERNAL MODULE: ./src/components/forms/rhf/RhfControlled.tsx
var RhfControlled = __webpack_require__(91990);
;// CONCATENATED MODULE: ./src/components/forms/rhf/DateControl.tsx











var getDateControlDisplayDate = function(date, format) {
    var timeFormat = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "DATE_CONTROL_FORMAT", dayMode = arguments.length > 3 ? arguments[3] : void 0, dayModeFormat = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "DATE_CONTROL_FORMAT_DAY_MODE";
    // clear out seconds and millis
    date.setSeconds(0);
    date.setMilliseconds(0);
    return format(date, !!dayMode ? dayModeFormat : timeFormat);
};
var DateControl = function(_param) {
    var rules = _param.rules, format = _param.format, _formatOnBlur = _param.formatOnBlur, formatOnBlur = _formatOnBlur === void 0 ? true : _formatOnBlur, chronoOptions = _param.chronoOptions, required = _param.required, className = _param.className, helperText = _param.helperText, defaultDatePickerValue = _param.defaultDatePickerValue, defaultDatePickerHour = _param.defaultDatePickerHour, _disablePast = _param.disablePast, disablePast = _disablePast === void 0 ? true : _disablePast, disableFuture = _param.disableFuture, inlinePicker = _param.inlinePicker, staticPicker = _param.staticPicker, dayMode = _param.dayMode, dayModeFormat = _param.dayModeFormat, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "rules",
        "format",
        "formatOnBlur",
        "chronoOptions",
        "required",
        "className",
        "helperText",
        "defaultDatePickerValue",
        "defaultDatePickerHour",
        "disablePast",
        "disableFuture",
        "inlinePicker",
        "staticPicker",
        "dayMode",
        "dayModeFormat"
    ]);
    var anchorElRef = (0,react.useRef)();
    var ref = (0,useDateTimeFormatter/* useDateTimeFormatter */.$0)(), timeFormatFn = ref.format;
    var parseFn = (0,react.useCallback)(function(value) {
        return !!(chronoOptions === null || chronoOptions === void 0 ? void 0 : chronoOptions.forwardDate) && !!disablePast ? (0,dates/* parseDateStringWithDisabledPast */.LG)(value, undefined, chronoOptions) : (0,dates/* parseDateStringToDate */.YS)(value, undefined, chronoOptions);
    }, [
        chronoOptions,
        disablePast
    ]);
    var merged = (0,react.useMemo)(function() {
        return (0,objects/* deepmerge */.vb)({}, rules, {
            required: required,
            validate: {
                parseable: function(v) {
                    return !v || !!parseFn(v) || "invalid date";
                }
            }
        });
    }, [
        rules,
        required,
        parseFn
    ]);
    var formatFn = (0,react.useCallback)(function(date, dayMode) {
        return getDateControlDisplayDate(date, timeFormatFn, format, dayMode, dayModeFormat);
    }, [
        format,
        dayModeFormat,
        timeFormatFn
    ]);
    var getDisplayDate = (0,react.useCallback)(function(date) {
        if (!!dayMode) {
            return (0,dates/* isDateToday */.Y3)(date) ? "Today" : formatFn(date, true);
        } else {
            return (0,dates/* isDateNowish */.x5)(date) ? "now" : formatFn((0,dates/* roundTimeToChunk */.QX)(date), false);
        }
    }, [
        dayMode,
        formatFn
    ]);
    var render = (0,react.useCallback)(function(_param) {
        var field = _param.field, fieldState = _param.fieldState, formState = _param.formState, rest = (0,_object_without_properties/* default */.Z)(_param, [
            "field",
            "fieldState",
            "formState"
        ]);
        var ref, ref1;
        var name = field.name, value = field.value, inputRef = field.ref, onChange = field.onChange, onBlur = field.onBlur;
        if (rest.value !== undefined && value === undefined) value = rest.value;
        var handleChange = function(e) {
            var ref;
            onChange(e);
            (ref = rest.onChange) === null || ref === void 0 ? void 0 : ref.call(rest, e);
        };
        var handleBlur = function(e) {
            var ref;
            var parsed = parseFn(e.target.value);
            // RAI-4082: The rhf onBlur triggers an onChange event that will prematurely set the
            // value in the date picker. If the parsed is undefined and the current value is "", this
            // can cause the month to jump on the user before the click finishes. This is essentially a no
            // op so it is fine if rhf doesn't get the change here.
            if (parsed === undefined && value === "") return;
            // input is a valid date
            if (!!parsed && formatOnBlur) {
                var display = getDisplayDate(parsed);
                // Per comment above also return if value hasn't changed.
                if (display === value) return;
                onChange(display);
            }
            onBlur();
            (ref = rest.onBlur) === null || ref === void 0 ? void 0 : ref.call(rest, e);
        };
        var handlePickerChange = function(name, date) {
            var ref, ref1, ref2;
            if (!!defaultDatePickerHour) {
                if (typeof defaultDatePickerHour === "function") {
                    date = defaultDatePickerHour(date);
                } else {
                    date.setHours(defaultDatePickerHour);
                    date.setMinutes(0);
                    date.setSeconds(0);
                }
            }
            var pickerValue = getDisplayDate(date);
            /**
         * The date picker selection is triggered after the native input events are triggered. This causes
         * validation timing issues with the new input value. The following synthetically triggers the value
         * being set in the input (triggers handleChange above). Blur is called before rhf knows of the change so we
         * need the blur event to trigger again for rhf to have the correct value before triggering blur logic.
         */ var valueSetter = (ref = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) === null || ref === void 0 ? void 0 : ref.set;
            valueSetter === null || valueSetter === void 0 ? void 0 : valueSetter.call(anchorElRef.current, pickerValue);
            var syntheticChange = new Event("input", {
                bubbles: true
            });
            (ref1 = anchorElRef.current) === null || ref1 === void 0 ? void 0 : ref1.dispatchEvent(syntheticChange);
            (ref2 = anchorElRef.current) === null || ref2 === void 0 ? void 0 : ref2.focus();
            setTimeout(function() {
                var ref;
                return (ref = anchorElRef.current) === null || ref === void 0 ? void 0 : ref.blur();
            }, 10);
        };
        var datePickerValue = parseFn(!value && defaultDatePickerValue ? defaultDatePickerValue : value);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    variant: "standard"
                }, rest), {
                    inputRef: function(el) {
                        // Set the anchor ref and then trigger the inputRef
                        // callback. RHF needs this el and the DateTimePicker.
                        if (!anchorElRef.current) {
                            anchorElRef.current = el;
                        }
                        inputRef(anchorElRef.current);
                    },
                    name: name,
                    value: value,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    error: !!fieldState.error,
                    helperText: !!((ref = fieldState.error) === null || ref === void 0 ? void 0 : ref.message) ? (ref1 = fieldState.error) === null || ref1 === void 0 ? void 0 : ref1.message : helperText
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimePicker, {
                    anchorEl: anchorElRef,
                    value: datePickerValue,
                    onChange: handlePickerChange,
                    inlinePicker: inlinePicker,
                    staticPicker: staticPicker,
                    disablePast: disablePast,
                    disableFuture: disableFuture
                })
            ]
        });
    }, [
        defaultDatePickerValue,
        className,
        helperText,
        inlinePicker,
        staticPicker,
        disablePast,
        disableFuture,
        formatOnBlur,
        getDisplayDate,
        defaultDatePickerHour,
        parseFn, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RhfControlled/* RhfControlled */.e, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        rules: merged,
        render: render
    }));
};
DateControl.isControl = true;
DateControl.isController = true;


/***/ }),

/***/ 68983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Us": function() { return /* binding */ durationControlParseDuration; },
/* harmony export */   "VD": function() { return /* binding */ DurationControlValidators; },
/* harmony export */   "u$": function() { return /* binding */ DurationControl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50135);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26958);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45110);
/* harmony import */ var _RhfControlled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91990);









/**
 * takes a string duration and returns the duration in minutes
 * @param value duration string
 * @returns a number of minutes
 */ var durationControlParseDuration = function(value) {
    if (!value) return;
    var stringToParse = value.toLowerCase();
    // If user does not add min/hr to input assume:
    if (/^\d+$/.test(value)) {
        // 9 or less they mean hours
        if (parseInt(value) <= 9) {
            stringToParse = value + " hr";
        } else {
            // 10 or more they mean minutes
            stringToParse = value + " min";
        }
    }
    var ms = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .parseDuration */ .RA)(stringToParse);
    return ms && ms / _utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .MILLISECONDS_PER_MINUTE */ .df;
};
var DurationControlValidators = {
    min: function(value, min, error) {
        var parsed = durationControlParseDuration(value);
        var minParsed = durationControlParseDuration(min);
        return !!parsed && !!minParsed && parsed < minParsed ? error || "Minimum duration is ".concat(min) : true;
    },
    max: function(value, max, error) {
        var parsed = durationControlParseDuration(value);
        var maxParsed = durationControlParseDuration(max);
        return !!parsed && !!maxParsed && parsed > maxParsed ? error || "Maximum duration is ".concat(max) : true;
    },
    interval: function(value, interval) {
        var parsed = durationControlParseDuration(value);
        var intervalParsed = durationControlParseDuration(interval);
        return !!parsed && !!intervalParsed && parsed % intervalParsed !== 0 ? "Must be an interval of ".concat(interval) : true;
    }
};
/**
 * Controlled field for entry of duration.
 * @param props
 * @deprecated use `DurationField`, `RhfDurationField` instead
 */ var DurationControl = function(_param) {
    var rules = _param.rules, required = _param.required, helperText = _param.helperText, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "rules",
        "required",
        "helperText"
    ]);
    var merged = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_objects__WEBPACK_IMPORTED_MODULE_3__/* .deepmerge */ .vb)({}, rules, {
            required: required,
            validate: {
                parseable: function(v) {
                    return !!v ? !!durationControlParseDuration(v) || "invalid duration" : true;
                }
            }
        });
    }, [
        rules,
        required
    ]);
    var render = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(_param) {
        var field = _param.field, fieldState = _param.fieldState, formState = _param.formState, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
            "field",
            "fieldState",
            "formState"
        ]);
        var ref, ref1;
        var name = field.name, value = field.value, inputRef = field.ref, onChange = field.onChange, onBlur = field.onBlur;
        var handleChange = function(e) {
            var ref;
            onChange(e);
            (ref = rest.onChange) === null || ref === void 0 ? void 0 : ref.call(rest, e);
        };
        var handleBlur = function(e) {
            var ref;
            var parsed = durationControlParseDuration(e.target.value);
            if (!!parsed) {
                onChange((0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .durationStr */ .wi)(parsed * 60, true));
            }
            onBlur();
            (ref = rest.onBlur) === null || ref === void 0 ? void 0 : ref.call(rest, e);
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            autoComplete: "off",
            variant: "outlined"
        }, rest), {
            inputRef: inputRef,
            name: name,
            value: value,
            onChange: handleChange,
            onBlur: handleBlur,
            error: !!fieldState.error,
            helperText: !!((ref = fieldState.error) === null || ref === void 0 ? void 0 : ref.message) ? (ref1 = fieldState.error) === null || ref1 === void 0 ? void 0 : ref1.message : helperText
        }));
    }, [
        helperText
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RhfControlled__WEBPACK_IMPORTED_MODULE_4__/* .RhfControlled */ .e, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest), {
        rules: merged,
        render: render
    }));
};
DurationControl.isControl = true;
DurationControl.isController = true;


/***/ }),

/***/ 91990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ RhfControlled; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42283);
/* eslint-disable @typescript-eslint/no-explicit-any */ 





var RhfControlled = function(_param) {
    var name = _param.name, control = _param.control, rules = _param.rules, transform = _param.transform, defaultValue = _param.defaultValue, hasChildControl = _param.hasChildControl, render = _param.render, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "name",
        "control",
        "rules",
        "transform",
        "defaultValue",
        "hasChildControl",
        "render"
    ]);
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useController */ .bc)({
        control: control,
        name: name,
        defaultValue: defaultValue,
        rules: rules
    }), field = ref.field, fieldState = ref.fieldState, formState = ref.formState;
    /**
   * Transform input if `transform.input` prop provided
   */ var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return !!(transform === null || transform === void 0 ? void 0 : transform.input) ? transform.input(field.value) : field.value;
    }, [
        field.value,
        transform
    ]);
    /**
   * Transform output if `transform.output` prop provided
   */ var onChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
            e[_key] = arguments[_key];
        }
        var _transform, _field;
        return !!(transform === null || transform === void 0 ? void 0 : transform.output) ? field.onChange((_transform = transform).output.apply(_transform, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e))) : (_field = field).onChange.apply(_field, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e));
    }, [
        field,
        transform
    ]);
    return render((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        name: name,
        field: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, field), {
            onChange: onChange,
            value: value
        }),
        fieldState: fieldState,
        formState: formState
    })));
};
RhfControlled.isControl = true;
RhfControlled.isController = true;


/***/ }),

/***/ 28681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ RhfForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@hookform/devtools/dist/index.js
var dist = __webpack_require__(90438);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./src/types/index.ts
var types = __webpack_require__(3620);
;// CONCATENATED MODULE: ./src/components/forms/rhf/index.ts

function isRhfControl(c) {
    return (0,types/* isType */.P9)(c, function(c) {
        return c["isControl"];
    });
}
function isRhfControlElement(e) {
    return typeof e.type !== "string" && isRhfControl(e.type);
}

// EXTERNAL MODULE: ./src/hooks/useShortcut.ts
var useShortcut = __webpack_require__(80236);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./src/utils/react.tsx
var utils_react = __webpack_require__(56501);
;// CONCATENATED MODULE: ./src/components/forms/rhf/RhfForm.tsx
















var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            flex: 1
        },
        disabled: {
            pointerEvents: "none",
            opacity: 0.5
        }
    };
}, {
    classNamePrefix: "RhfForm"
});
/**
 * react-hook-form instrumented form component
 *
 * @param props props
 * @returns react-hook-form instrumented form with nested RhfControl components receiving injected props
 */ var RhfForm = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var className = _param.className, form = _param.form, children = _param.children, debug = _param.debug, onSubmit = _param.onSubmit, onError = _param.onError, _submitOnShortcut = _param.submitOnShortcut, submitOnShortcut = _submitOnShortcut === void 0 ? false : _submitOnShortcut, disabled = _param.disabled, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "form",
        "children",
        "debug",
        "onSubmit",
        "onError",
        "submitOnShortcut",
        "disabled"
    ]);
    var classes = useStyles();
    var _$ref = (0,react.useMemo)(function() {
        return form;
    }, [
        form
    ]), formHandleSubmit = _$ref.handleSubmit;
    var doSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!onSubmit) return [
                        2
                    ];
                    return [
                        4,
                        formHandleSubmit(onSubmit, onError)
                    ];
                case 1:
                    return [
                        4,
                        _state.sent()()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        formHandleSubmit,
        onError,
        onSubmit
    ]);
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        return [
                            4,
                            doSubmit()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        doSubmit
    ]);
    (0,useShortcut/* useShortcut */.b)([
        "Meta",
        "Enter"
    ], doSubmit, {
        enabled: submitOnShortcut
    });
    /**
     * Loop through children recursively to inject form field components with
     * required props, unless the props already exist.
     *
     * Uncontrolled props are injected with `register` and `errors`
     * Controlled props are injected with `control`
     *
     */ var inject = (0,react.useCallback)(function(children) {
        var processChild = function(child) {
            if (/*#__PURE__*/ (0,react.isValidElement)(child)) {
                var isControl = isRhfControlElement(child);
                var isController = typeof child.type !== "string" && !!child.type["isController"];
                var props = child.props;
                var hasChildControl = props.hasChildControl;
                // stop recursion if this child is a control, or when there are no more nested children. Also, if the control
                // has the prop hasChildControl set then proceed and process children.
                var _$children = (0,utils_react/* hasChildren */.g8)(child) && (!isControl || hasChildControl ? inject(child.props.children) : child.props.children);
                var newProps = (0,_object_spread/* default */.Z)({}, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    children: _$children
                }));
                // if this node isn't a form control, skip the augmented props
                if (!isControl) return /*#__PURE__*/ (0,react.createElement)(child.type, newProps);
                // compose augmented props to send to control (uncontrolled or controlled) components
                var controlProps = {
                    key: props.name
                };
                if (!!isController) {
                    // inject controlled component props
                    if (!props.control) controlProps["control"] = form.control;
                } else {
                    // inject uncontrolled component props
                    var errors = (0,objects/* walk */._p)(props.name, form.formState.errors);
                    if (!props.register) controlProps["register"] = form.register;
                    if (!props.errors && !!errors) controlProps["errors"] = errors;
                }
                // return a copy of the original element with props injected
                return /*#__PURE__*/ (0,react.createElement)(child.type, (0,_object_spread/* default */.Z)({}, newProps, controlProps));
            }
            return child;
        };
        // Important: Only map the children if there are multiple. If a single node is mapped then it
        // is updated on the dom as [ReactNone] which can break things like transitions within the form.
        // e.g. <Grow in> withing MicroTaskForm
        return !!children && children.length ? react.Children.map(children, processChild) : processChild(children);
    }, [
        form.control,
        form.formState.errors,
        form.register
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!debug && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DevTool, {
                control: form.control,
                placement: "top-left"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: (0,clsx_m/* default */.Z)(classes.root, className, (0,_define_property/* default */.Z)({}, classes.disabled, disabled)),
                    ref: ref
                }, rest), {
                    onSubmit: handleSubmit,
                    children: inject(children)
                }))
            }))
        ]
    });
});


/***/ }),

/***/ 28240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ RhfRadioBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42283);
/* harmony import */ var _RadioBox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37515);
/* harmony import */ var _RhfRadioBoxGroupControl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73576);







var RhfRadioBox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(radioBoxProps, ref) {
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_RhfRadioBoxGroupControl__WEBPACK_IMPORTED_MODULE_4__/* .RadioBoxGroupControlContext */ .o), orientation = _$ref.orientation, fieldName = _$ref.fieldName;
    var form = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)();
    var val = form.watch(fieldName);
    var checked = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return val === radioBoxProps.value;
    }, [
        radioBoxProps.value,
        val
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioBox__WEBPACK_IMPORTED_MODULE_3__/* .RadioBox */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, radioBoxProps), {
        ref: ref,
        checked: checked,
        orientation: orientation
    }));
});


/***/ }),

/***/ 73576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ RhfRadioBoxGroupControl; },
/* harmony export */   "o": function() { return /* binding */ RadioBoxGroupControlContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87357);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _RhfRadioBoxGroupControl_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50658);
/* harmony import */ var _RhfRadioBoxGroupControl_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_RhfRadioBoxGroupControl_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _RhfRadioGroupControl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57693);











var RadioBoxGroupControlContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    orientation: "vertical",
    fieldName: ""
});
var RhfRadioBoxGroupControl = function(_param) {
    var className = _param.className, extClasses = _param.classes, _orientation = _param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "classes",
        "orientation",
        "children"
    ]);
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__/* .mergeClassNames */ .E)((_RhfRadioBoxGroupControl_module_scss__WEBPACK_IMPORTED_MODULE_5___default()), extClasses || {});
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RadioBoxGroupControlContext.Provider, {
        value: {
            orientation: orientation,
            fieldName: rest.name
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RhfRadioGroupControl__WEBPACK_IMPORTED_MODULE_3__/* .RhfRadioGroupControl */ .y, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(classes.root, className),
            "aria-label": rest.name
        }, rest), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(classes.content, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.vertical, orientation === "vertical"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.horizontal, orientation === "horizontal"), _obj)),
                children: children
            })
        }))
    });
};
RhfRadioBoxGroupControl.isControl = _RhfRadioGroupControl__WEBPACK_IMPORTED_MODULE_3__/* .RhfRadioGroupControl.isControl */ .y.isControl;
RhfRadioBoxGroupControl.isController = _RhfRadioGroupControl__WEBPACK_IMPORTED_MODULE_3__/* .RhfRadioGroupControl.isController */ .y.isController;


/***/ }),

/***/ 57693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ RhfRadioGroupControl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33841);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_numbers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63139);
/* harmony import */ var _RhfControlled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91990);








var RhfRadioGroupControl = function(_param) {
    var name = _param.name, label = _param.label, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "name",
        "label"
    ]);
    var render = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(_param) {
        var name = _param.name, field = _param.field, fieldState = _param.fieldState, formState = _param.formState, _RadioGroupProps = _param.RadioGroupProps, RadioGroupProps = _RadioGroupProps === void 0 ? {} : _RadioGroupProps, error = _param.error, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
            "name",
            "field",
            "fieldState",
            "formState",
            "RadioGroupProps",
            "error",
            "children"
        ]);
        var onChange = field.onChange, inputProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(field, [
            "onChange"
        ]);
        var handleChange = function(e) {
            // Handle booleans set on control value.
            if (e.target.value === "true" || e.target.value === "false") {
                void onChange(e.target.value === "true");
            } else if ((0,_utils_numbers__WEBPACK_IMPORTED_MODULE_2__/* .isNumeric */ .kE)(e.target.value)) {
                void onChange(+e.target.value);
            } else {
                void onChange(e);
            }
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            variant: "standard"
        }, rest), {
            error: !!fieldState.error,
            children: [
                !!label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: label
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, RadioGroupProps, inputProps), {
                    onChange: handleChange,
                    children: children
                })),
                !!fieldState.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    error: true,
                    children: fieldState.error.message
                })
            ]
        }));
    }, [
        label
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RhfControlled__WEBPACK_IMPORTED_MODULE_3__/* .RhfControlled */ .e, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        name: name
    }, rest), {
        render: render
    }));
};
RhfRadioGroupControl.isControl = true;
RhfRadioGroupControl.isController = true;


/***/ }),

/***/ 22057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TextFieldControl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82222);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50135);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);







/**
 * Controlled field for text entry
 * @param props
 * @deprecated use `RhfTextField` instead
 */ var TextFieldControl = function(_param) {
    var name = _param.name, value = _param.value, errors = _param.errors, register = _param.register, _options = _param.options, options = _options === void 0 ? {} : _options, extInputRef = _param.inputRef, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "name",
        "value",
        "errors",
        "register",
        "options",
        "inputRef"
    ]);
    var opts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var merged = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
            required: !!(rest === null || rest === void 0 ? void 0 : rest.required) ? "Required" : options.required
        });
        if (undefined !== value) merged.value = value;
        return merged;
    }, [
        options,
        rest === null || rest === void 0 ? void 0 : rest.required,
        value
    ]);
    var helperText = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (errors === null || errors === void 0 ? void 0 : errors.message) || rest.helperText;
    }, [
        errors === null || errors === void 0 ? void 0 : errors.message,
        rest.helperText
    ]);
    var _ref = register(name, opts), inputRef = _ref.ref, onChange = _ref.onChange, onBlur = _ref.onBlur, inputProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "ref",
        "onChange",
        "onBlur"
    ]);
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        var ref;
        void onChange(e);
        void ((ref = rest.onChange) === null || ref === void 0 ? void 0 : ref.call(rest, e));
    }, [
        onChange,
        rest
    ]);
    var handleBlur = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        var ref;
        void onBlur(e);
        void ((ref = rest.onBlur) === null || ref === void 0 ? void 0 : ref.call(rest, e));
    }, [
        onBlur,
        rest
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        variant: "standard"
    }, rest, inputProps), {
        inputRef: function(ref) {
            inputRef(ref);
            if (!extInputRef) return;
            switch(typeof extInputRef === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(extInputRef)){
                case "object":
                    extInputRef.current = ref;
                    break;
                case "function":
                    extInputRef(ref);
                    break;
            }
        },
        onChange: handleChange,
        onBlur: handleBlur,
        error: !!errors,
        helperText: helperText
    }));
};
TextFieldControl.isControl = true;


/***/ }),

/***/ 5508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ TimeControl; },
/* harmony export */   "T": function() { return /* binding */ TimeControlValidators; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50135);
/* harmony import */ var chrono_node__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15880);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58545);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42699);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDateTimeFormatter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62495);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26958);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45110);
/* harmony import */ var _utils_time__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36832);
/* harmony import */ var _DurationControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68983);
/* harmony import */ var _RhfControlled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91990);














var TimeControlValidators = {
    afterTime: function(value, time, error) {
        var timeParsed = (0,chrono_node__WEBPACK_IMPORTED_MODULE_7__/* .parseDate */ .sG)(time);
        var valueParsed = (0,_utils_time__WEBPACK_IMPORTED_MODULE_8__/* .parseTime */ .T)(value);
        return !valueParsed || !timeParsed || timeParsed <= valueParsed || error;
    },
    beforeTime: function(value, time, error) {
        var timeParsed = (0,chrono_node__WEBPACK_IMPORTED_MODULE_7__/* .parseDate */ .sG)(time);
        var valueParsed = (0,_utils_time__WEBPACK_IMPORTED_MODULE_8__/* .parseTime */ .T)(value);
        return !valueParsed || !timeParsed || timeParsed >= valueParsed || error;
    },
    lessThanDuration: function(start, end, duration, error) {
        var startParsed = (0,chrono_node__WEBPACK_IMPORTED_MODULE_7__/* .parseDate */ .sG)(start);
        var endParsed = (0,_utils_time__WEBPACK_IMPORTED_MODULE_8__/* .parseTime */ .T)(end);
        var durationParsed = (0,_DurationControl__WEBPACK_IMPORTED_MODULE_5__/* .durationControlParseDuration */ .Us)(duration || "15 min");
        return !end || !start || (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(startParsed, durationParsed) <= endParsed || error || "Not enough time (".concat(duration, ")");
    }
};
var TimeControl = function(_param) {
    var rules = _param.rules, _format = _param.format, format = _format === void 0 ? "TIME_DISPLAY_FORMAT" : _format, chronoOptions = _param.chronoOptions, required = _param.required, shiftMeridiemLimit = _param.shiftMeridiemLimit, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "rules",
        "format",
        "chronoOptions",
        "required",
        "shiftMeridiemLimit"
    ]);
    var ref = (0,_hooks_useDateTimeFormatter__WEBPACK_IMPORTED_MODULE_2__/* .useDateTimeFormatter */ .$0)(), formatFn = ref.format;
    var merged = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_objects__WEBPACK_IMPORTED_MODULE_4__/* .deepmerge */ .vb)({}, rules, {
            required: required,
            validate: {
                // unambiguous: (v: string) => !!v && /^\d(\:(\d){0,2})?$/.test(v.trim()) || "am or pm",
                parseable: function(v) {
                    return !v || !!(0,_utils_time__WEBPACK_IMPORTED_MODULE_8__/* .parseTime */ .T)(v, chronoOptions) || "invalid time";
                }
            }
        });
    }, [
        chronoOptions,
        rules,
        required
    ]);
    var render = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(_param) {
        var field = _param.field, fieldState = _param.fieldState, formState = _param.formState, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
            "field",
            "fieldState",
            "formState"
        ]);
        var ref;
        var name = field.name, value = field.value, inputRef = field.ref, onChange = field.onChange, onBlur = field.onBlur;
        var handleChange = function(e) {
            var ref;
            onChange(e);
            (ref = rest.onChange) === null || ref === void 0 ? void 0 : ref.call(rest, e);
        };
        var handleBlur = function(e) {
            var ref;
            var parsed = (0,_utils_time__WEBPACK_IMPORTED_MODULE_8__/* .parseTime */ .T)(e.target.value, chronoOptions);
            // input is a valid time format
            if (!!parsed) {
                if (!!shiftMeridiemLimit && (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(shiftMeridiemLimit, parsed)) {
                    var timeShift = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .addTime */ .yG)(formatFn, parsed, {
                        hour: 12
                    });
                    onChange(formatFn(timeShift, format));
                } else {
                    onChange(formatFn(parsed, format));
                }
            }
            onBlur();
            (ref = rest.onBlur) === null || ref === void 0 ? void 0 : ref.call(rest, e);
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
            variant: "standard"
        }, rest), {
            inputRef: inputRef,
            name: name,
            value: value,
            onChange: handleChange,
            onBlur: handleBlur,
            error: !!fieldState.error,
            helperText: (ref = fieldState.error) === null || ref === void 0 ? void 0 : ref.message
        }));
    }, [
        chronoOptions,
        format,
        shiftMeridiemLimit,
        formatFn
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RhfControlled__WEBPACK_IMPORTED_MODULE_6__/* .RhfControlled */ .e, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
        rules: merged,
        render: render
    }));
};
TimeControl.isControl = true;
TimeControl.isController = true;


/***/ }),

/***/ 52127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82222);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16628);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50657);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);








var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {},
        paper: {
            borderRadius: theme.shape.borderRadius * 4,
            backgroundColor: theme.colors.white
        }
    };
});
var Transition = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};
var Modal = function(_param) {
    var open = _param.open, children = _param.children, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "open",
        "children",
        "className"
    ]);
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        open: !!open,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className),
        PaperProps: {
            className: classes.paper
        },
        TransitionComponent: Transition,
        closeAfterTransition: true
    }, rest), {
        children: function() {
            switch(typeof children === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(children)){
                case "function":
                    return !!open && children();
                default:
                    return children;
            }
        }()
    }));
};


/***/ }),

/***/ 83501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ModalCloseButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_CloseRounded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36191);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93946);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);





var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            position: "absolute",
            zIndex: 1,
            top: theme.spacing(1),
            right: theme.spacing(1)
        },
        icon: {}
    };
}, {
    classNamePrefix: "ModalCloseButton"
});
var ModalCloseButton = function(param) {
    var className = param.className, extClasses = param.classes, onClose = param.onClose;
    var classes = useStyles({
        classes: extClasses
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        "aria-label": "close",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className),
        onClick: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_CloseRounded__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: classes.icon
        })
    });
};


/***/ }),

/***/ 84362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ModalContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6514);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);







var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            padding: theme.spacing(0, 4, 4)
        }
    };
});
var ModalContent = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var ref;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(classes.root, (ref = rest.classes) === null || ref === void 0 ? void 0 : ref.root)
    }, rest), {
        children: children
    }));
};


/***/ }),

/***/ 33977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ModalHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61214);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _ModalCloseButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83501);





var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            padding: theme.spacing(4, 4, 2)
        }
    };
}, {
    classNamePrefix: "ModalHeader"
});
var ModalHeader = function(param) {
    var className = param.className, description = param.description, extClasses = param.classes, children = param.children, onClose = param.onClose;
    var classes = useStyles({
        classes: extClasses
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "h5",
                children: children
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalCloseButton__WEBPACK_IMPORTED_MODULE_1__/* .ModalCloseButton */ .o, {
                onClose: onClose
            })
        ]
    });
};


/***/ }),

/***/ 8309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Snackbar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47310);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50594);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11057);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20377);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _forms_AsyncButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5062);
/* harmony import */ var _UIActionButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33578);
/* harmony import */ var _Snackbar_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64779);
/* harmony import */ var _Snackbar_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Snackbar_module_scss__WEBPACK_IMPORTED_MODULE_7__);














function useResolvedFactory(factory, helpers) {
    return (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        if (typeof factory === "function") return factory(helpers);
        else return factory;
    }, [
        factory,
        helpers
    ]);
}
var Snackbar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.forwardRef)(function(param, ref) {
    var className = param.className, extClasses = param.classes, _type = param.type, type = _type === void 0 ? "default" : _type, message = param.message, dismissible = param.dismissible, header = param.header, uiActions = param.uiActions, onUndo = param.onUndo, onView = param.onView, onClose = param.onClose;
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_2__/* .mergeClassNames */ .E)((_Snackbar_module_scss__WEBPACK_IMPORTED_MODULE_7___default()), extClasses || {});
    /********************/ /*   custom hooks   */ /********************/ /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var helpers = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return Object.freeze({
            close: onClose
        });
    }, [
        onClose
    ]);
    header = useResolvedFactory(header, helpers);
    message = useResolvedFactory(message, helpers);
    uiActions = useResolvedFactory(uiActions, helpers);
    /********************/ /*    useCallback   */ /********************/ var handleUndoClick = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackSafeRef */ .T)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onUndo === null || onUndo === void 0 ? void 0 : onUndo()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        onClose()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }));
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(notistack__WEBPACK_IMPORTED_MODULE_3__/* .SnackbarContent */ .No, {
        ref: ref,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.root, className, classes["colors--".concat(type)]),
        children: [
            !!dismissible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                "aria-label": "close",
                className: classes.close,
                onClick: onClose,
                size: "large",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.closeIcon, classes["colors--".concat(type)])
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.content, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, classes["content--dismissible"], !!dismissible)),
                children: [
                    header !== null && header !== void 0 ? header : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "h3",
                        children: header
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classes.message,
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.actionsWrap,
                children: [
                    !!onUndo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_forms_AsyncButton__WEBPACK_IMPORTED_MODULE_5__/* .AsyncButton */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.actionBtn, classes["colors--".concat(type)]),
                        onClick: handleUndoClick,
                        size: "small",
                        color: "primary",
                        children: "Undo"
                    }),
                    !!onView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.actionBtn, classes["colors--".concat(type)]),
                        onClick: onUndo,
                        size: "small",
                        color: "primary",
                        children: "View"
                    }),
                    (uiActions || []).map(function(uiAction, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UIActionButton__WEBPACK_IMPORTED_MODULE_6__/* .UIActionButton */ ._, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.actionBtn, classes["colors--".concat(type)]),
                            uiAction: uiAction
                        }, i);
                    })
                ]
            })
        ]
    });
});


/***/ }),

/***/ 40647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ V16PriorityIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _priority_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54226);





var V16PriorityIcon = function(_param) {
    var className = _param.className, priority = _param.priority, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "priority"
    ]);
    var pMap = {
        P1: (0,_priority_utils__WEBPACK_IMPORTED_MODULE_1__/* .hasPriority */ .ZX)("P1", priority),
        P2: (0,_priority_utils__WEBPACK_IMPORTED_MODULE_1__/* .hasPriority */ .ZX)("P2", priority),
        P3: (0,_priority_utils__WEBPACK_IMPORTED_MODULE_1__/* .hasPriority */ .ZX)("P3", priority),
        P4: (0,_priority_utils__WEBPACK_IMPORTED_MODULE_1__/* .hasPriority */ .ZX)("P4", priority)
    };
    var color = "currentColor";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "2",
                y: "10",
                width: "2",
                height: "4",
                rx: "1",
                opacity: pMap["P4"] ? 1 : 0.25,
                fill: pMap["P4"] ? color : "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "5.33333",
                y: "7.33333",
                width: "2",
                height: "6.66667",
                rx: "1",
                opacity: pMap["P3"] ? 1 : 0.25,
                fill: pMap["P3"] ? color : "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "8.66667",
                y: "4.66667",
                width: "2",
                height: "9.33333",
                rx: "1",
                opacity: pMap["P2"] ? 1 : 0.25,
                fill: pMap["P2"] ? color : "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "12",
                y: "2",
                width: "2",
                height: "12",
                rx: "1",
                opacity: pMap["P1"] ? 1 : 0.25,
                fill: pMap["P1"] ? color : "currentColor"
            })
        ]
    }));
};


/***/ }),

/***/ 86426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ PRIOTIZATION_GETTING_STARTED_VIDEO; },
/* harmony export */   "GU": function() { return /* binding */ PRIORITY_META; },
/* harmony export */   "Kc": function() { return /* binding */ PRIORITY_ORDERING; },
/* harmony export */   "Q5": function() { return /* binding */ PRIORITY_COLUMN_WIDTH_DEFAULT; },
/* harmony export */   "mS": function() { return /* binding */ PRIORITY_RESOURCES_ORDERING; },
/* harmony export */   "pW": function() { return /* binding */ PRIORITY_COLUMN_WIDTH_MIN; },
/* harmony export */   "se": function() { return /* binding */ PRIORITY_RESOURCES_META; },
/* harmony export */   "wy": function() { return /* binding */ DEFAULT_PRIORITY_ACCORDION_STATE; },
/* harmony export */   "yD": function() { return /* binding */ PRIORITY_TYPE_FILTERS; },
/* harmony export */   "yz": function() { return /* binding */ PRIORITY_COLUMN_WIDTH_MAX; }
/* harmony export */ });
/* unused harmony exports LEGACY_PRIORITY_ORDERING, DEFAULT_PRIORITY_ACCORDION_SECTION_STATE */
var PRIOTIZATION_GETTING_STARTED_VIDEO = "oy11k1V7sHM";
var PRIORITY_ORDERING = [
    "P1",
    "P2",
    "P3",
    "P4"
];
var LEGACY_PRIORITY_ORDERING = (/* unused pure expression or super */ null && ([
    "HIGH",
    "DEFAULT"
]));
var PRIORITY_RESOURCES_ORDERING = [
    "SCHEDULING_LINKS",
    "ONE_ON_ONES",
    "HABITS",
    "TASKS", 
];
var PRIORITY_TYPE_FILTERS = [
    "scheduling-link",
    "one-on-one",
    "habit",
    "task"
];
var PRIORITY_META = {
    P1: {
        label: "Critical",
        empty: "No critical items"
    },
    P2: {
        label: "High priority",
        empty: "No high priority items"
    },
    P3: {
        label: "Medium priority",
        empty: "No medium priority items"
    },
    P4: {
        label: "Low priority",
        empty: "No low priority items"
    },
    DEFAULT: {
        label: "Default"
    },
    PRIORITIZE: {
        label: "Prioritize"
    },
    HIGH: {
        label: "High"
    }
};
var PRIORITY_RESOURCES_META = {
    HABITS: {
        label: "Habits",
        assignment: "habit"
    },
    SCHEDULING_LINKS: {
        label: "Scheduling Links",
        assignment: "scheduling-link"
    },
    ONE_ON_ONES: {
        label: "Smart 1:1s",
        assignment: "one-on-one"
    },
    TASKS: {
        label: "Tasks",
        assignment: "task"
    }
};
var DEFAULT_PRIORITY_ACCORDION_SECTION_STATE = {
    ONE_ON_ONES: true,
    TASKS: true,
    HABITS: true,
    SCHEDULING_LINKS: true
};
var DEFAULT_PRIORITY_ACCORDION_STATE = {
    DISABLED: DEFAULT_PRIORITY_ACCORDION_SECTION_STATE,
    P1: DEFAULT_PRIORITY_ACCORDION_SECTION_STATE,
    P2: DEFAULT_PRIORITY_ACCORDION_SECTION_STATE,
    P3: DEFAULT_PRIORITY_ACCORDION_SECTION_STATE,
    P4: DEFAULT_PRIORITY_ACCORDION_SECTION_STATE
};
var PRIORITY_COLUMN_WIDTH_MIN = 280;
var PRIORITY_COLUMN_WIDTH_MAX = 1200;
var PRIORITY_COLUMN_WIDTH_DEFAULT = 440;


/***/ }),

/***/ 54226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JH": function() { return /* binding */ queryTypeToResourceType; },
/* harmony export */   "VJ": function() { return /* binding */ priorityIsV16; },
/* harmony export */   "W5": function() { return /* binding */ priorityComparator; },
/* harmony export */   "ZX": function() { return /* binding */ hasPriority; },
/* harmony export */   "aT": function() { return /* binding */ toV14Priority; },
/* harmony export */   "pD": function() { return /* binding */ toV16Priority; }
/* harmony export */ });
/* unused harmony export getPriorityVersion */
/* harmony import */ var _hooks_useV16User__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3512);
/* harmony import */ var _utils_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14023);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45110);
/* harmony import */ var _priority_consts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86426);




var PRIORITY_INDEX_MAP = (0,_utils_objects__WEBPACK_IMPORTED_MODULE_2__/* .evalOnce */ ._B)(function() {
    return (0,_utils_objects__WEBPACK_IMPORTED_MODULE_2__/* .indexMap */ .Db)(_priority_consts__WEBPACK_IMPORTED_MODULE_3__/* .PRIORITY_ORDERING */ .Kc);
});
var PRIORITY_VERSION_MAP = {
    DEFAULT: 14,
    PRIORITIZE: 14,
    HIGH: 14,
    P1: 16,
    P2: 16,
    P3: 16,
    P4: 16
};
/**
 * Returns true if test is less than or equal to the provided priority
 */ var hasPriority = function(test, priority) {
    if (PRIORITY_INDEX_MAP()[priority] !== undefined && PRIORITY_INDEX_MAP()[priority] >= 0) {
        return (PRIORITY_INDEX_MAP()[test] || 0) >= (PRIORITY_INDEX_MAP()[priority] || 0);
    } else {
        return false;
    }
};
var priorityComparator = (0,_utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .makeOrderedListComparator */ .LU)(_priority_consts__WEBPACK_IMPORTED_MODULE_3__/* .PRIORITY_ORDERING */ .Kc);
var getPriorityVersion = function(priority) {
    return PRIORITY_VERSION_MAP[priority];
};
var priorityIsV16 = function(priority) {
    return (0,_hooks_useV16User__WEBPACK_IMPORTED_MODULE_0__/* .isSchedulerV16 */ .p)(getPriorityVersion(priority));
};
var toV14Priority = function(priority) {
    switch(priority){
        case "P1":
            return "HIGH";
        case "P2":
        case "P3":
        case "P4":
            return "DEFAULT";
        case "PRIORITIZE":
            return "HIGH";
        default:
            return priority;
    }
};
var toV16Priority = function(v14Priority) {
    switch(v14Priority){
        case "PRIORITIZE":
        case "HIGH":
            return "P1";
        case "DEFAULT":
            return "P3";
        default:
            return v14Priority;
    }
};
var QUERY_TO_RESOURCE = {
    "scheduling-link": "SCHEDULING_LINKS",
    "one-on-one": "ONE_ON_ONES",
    habit: "HABITS",
    task: "TASKS"
};
var queryTypeToResourceType = function(type) {
    return QUERY_TO_RESOURCE[type];
};


/***/ }),

/***/ 95858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ QuestGenericPopperContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/scss.utils.ts
var scss_utils = __webpack_require__(91740);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/GradientBackedVideo.module.scss
var GradientBackedVideo_module = __webpack_require__(37107);
var GradientBackedVideo_module_default = /*#__PURE__*/__webpack_require__.n(GradientBackedVideo_module);
;// CONCATENATED MODULE: ./src/components/GradientBackedVideo.tsx




var GradientBackedVideo = function(param) {
    var className = param.className, extClasses = param.classes, children = param.children;
    var classes = (0,scss_utils/* mergeClassNames */.E)((GradientBackedVideo_module_default()), extClasses || {});
    /********************/ /*   custom hooks   */ /********************/ /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.graphicContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                children: children
            })
        })
    });
};
GradientBackedVideo.displayName = "GradientBackedVideo;";

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardRounded.js
var ArrowForwardRounded = __webpack_require__(40075);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CloseRounded.js
var CloseRounded = __webpack_require__(36191);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(18979);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
// EXTERNAL MODULE: ./node_modules/mui-modal-provider/dist/mui-modal-provider.esm.js
var mui_modal_provider_esm = __webpack_require__(56566);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/atoms/useQuests.ts + 1 modules
var useQuests = __webpack_require__(1755);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/components/YoutubeVideoPlayerModal.tsx
var YoutubeVideoPlayerModal = __webpack_require__(66544);
// EXTERNAL MODULE: ./src/components/quests/quests.util.ts + 14 modules
var quests_util = __webpack_require__(32774);
;// CONCATENATED MODULE: ./src/components/quests/QuestGenericPopperContent.tsx















var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            maxWidth: 340,
            display: "flex",
            flexDirection: "column"
        },
        rootV2: {
            maxWidth: 422,
            display: "flex",
            flexDirection: "column"
        },
        textAndBtns: {
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(3)
        },
        description: {},
        btnCont: {
            paddingTop: theme.spacing(1),
            display: "flex",
            justifyContent: "space-between",
            "&:empty": {
                display: "none"
            }
        },
        stepper: {
            backgroundColor: theme.colors.white
        },
        backBtn: {
            marginLeft: theme.spacing(-1),
            minWidth: 0
        },
        nextBtn: {
            marginLeft: "auto",
            marginRight: theme.spacing(-1)
        },
        btn: {
            minWidth: 0
        },
        imgWrapper: {
            padding: theme.spacing(1, 1, 0),
            width: "100%",
            "& > span": {
                position: "unset !important"
            },
            "& > span > img": {
                borderRadius: theme.shape.borderRadius * 1.5,
                objectFit: "contain",
                width: "100% !important",
                position: "relative !important",
                height: "unset !important"
            }
        },
        notReady: {
            "& > span > img": {
                height: "0 !important"
            }
        },
        svg: {
            borderRadius: theme.shape.borderRadius * 1.5,
            display: "block",
            minWidth: 268
        },
        skeleton: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        noDisplay: {
            display: "none"
        },
        closeBtn: {
            margin: theme.spacing(-0.75, -1, -0.75, 0),
            minWidth: 0
        },
        progressAndClose: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingBottom: theme.spacing(1)
        },
        progressTxt: {
            opacity: 0.5
        },
        rightArrow: {
            height: 16,
            marginLeft: 4,
            width: 16
        }
    };
}, {
    classNamePrefix: "QuestGenericPopperContent"
});
var QuestGenericPopperContent = function(param) {
    var className = param.className, extClasses = param.classes, stepConfig = param.stepConfig, onClose = param.onClose, onBlur = param.onBlur, onBack = param.onBack;
    var ref, ref1, ref2;
    var classes = useStyles({
        classes: extClasses
    });
    var showModal = (0,mui_modal_provider_esm/* useModal */.d)().showModal;
    var activeQuest = (0,useQuests/* useQuestsState */.P_)().activeQuest;
    var ref3 = (0,react.useState)(false), imageReady = ref3[0], setImageReady = ref3[1];
    var config = (0,react.useMemo)(function() {
        return activeQuest ? (0,quests_util/* getQuestConfigFromActiveQuest */.N1)(activeQuest) : undefined;
    }, [
        activeQuest
    ]);
    var stepIndex = (0,react.useMemo)(function() {
        return config === null || config === void 0 ? void 0 : config.steps.findIndex(function(s) {
            return s.id === (activeQuest === null || activeQuest === void 0 ? void 0 : activeQuest.step);
        });
    }, [
        config,
        activeQuest
    ]);
    var isLastStep = (0,react.useMemo)(function() {
        if (!!(config === null || config === void 0 ? void 0 : config.steps.length)) return stepIndex === (config === null || config === void 0 ? void 0 : config.steps.length);
        else return false;
    }, [
        stepIndex,
        config === null || config === void 0 ? void 0 : config.steps.length
    ]);
    var isFirstStep = (0,react.useMemo)(function() {
        if (!!(config === null || config === void 0 ? void 0 : config.steps.length)) return stepIndex === 0;
        else return false;
    }, [
        stepIndex,
        config === null || config === void 0 ? void 0 : config.steps.length
    ]);
    var handleClose = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    var preventDefault = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(e) {
        e.preventDefault();
        e.stopPropagation();
    });
    var handleVideoClose = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(modal) {
        modal.hide();
    });
    var progressDisplay = (0,react.useMemo)(function() {
        if (!!(config === null || config === void 0 ? void 0 : config.steps.length) && stepIndex !== undefined && stepIndex >= 0) {
            return "".concat(stepIndex + 1, " of ").concat(config.steps.length);
        }
    }, [
        config === null || config === void 0 ? void 0 : config.steps.length,
        stepIndex
    ]);
    var handleWatchVideo = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var modal = showModal(YoutubeVideoPlayerModal/* YoutubeVideoPlayerModal */.N, {
            onClose: function() {
                return handleVideoClose(modal);
            },
            videoId: stepConfig.videoLink,
            videoOptions: stepConfig.videoOptions
        });
    });
    var getNextLabel = function() {
        var ref;
        if (isLastStep) {
            return "Finish";
        }
        if ((ref = stepConfig.popoverConfig) === null || ref === void 0 ? void 0 : ref.nextButtonLabel) {
            var ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (ref1 = stepConfig.popoverConfig) === null || ref1 === void 0 ? void 0 : ref1.nextButtonLabel,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardRounded/* default */.Z, {
                        className: classes.rightArrow
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Next",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardRounded/* default */.Z, {
                    className: classes.rightArrow
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((0,quests_util/* isQuestV2 */.XA)(activeQuest) ? classes.rootV2 : classes.root, className),
        onMouseOver: preventDefault,
        onClick: preventDefault,
        children: [
            function() {
                var ref, ref1, ref2;
                if (!!((ref = stepConfig.popoverConfig) === null || ref === void 0 ? void 0 : ref.img)) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)(classes.skeleton, (0,_define_property/* default */.Z)({}, classes.noDisplay, imageReady)),
                                variant: "rectangular",
                                height: 150,
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)(classes.imgWrapper, (0,_define_property/* default */.Z)({}, classes.notReady, !imageReady)),
                                onClick: stepConfig.type === "orb" ? onBlur : undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "fill",
                                    src: stepConfig.popoverConfig.img,
                                    onLoadingComplete: function() {
                                        return setImageReady(true);
                                    }
                                })
                            })
                        ]
                    });
                } else if (!!((ref1 = stepConfig.popoverConfig) === null || ref1 === void 0 ? void 0 : ref1.svg)) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.imgWrapper,
                        children: /*#__PURE__*/ (0,react.createElement)(stepConfig.popoverConfig.svg, {
                            className: classes.svg
                        })
                    });
                } else if (!!((ref2 = stepConfig.popoverConfig) === null || ref2 === void 0 ? void 0 : ref2.gif)) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientBackedVideo, {
                        children: stepConfig.popoverConfig.gif
                    });
                }
            }(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.textAndBtns,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.progressAndClose,
                        children: [
                            !!progressDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: classes.progressTxt,
                                children: progressDisplay
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "inherit",
                                onClick: onBlur,
                                className: classes.closeBtn,
                                variant: "text",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseRounded/* default */.Z, {
                                    fontSize: "small"
                                })
                            })
                        ]
                    }),
                    (stepConfig === null || stepConfig === void 0 ? void 0 : (ref = stepConfig.popoverConfig) === null || ref === void 0 ? void 0 : ref.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        children: stepConfig === null || stepConfig === void 0 ? void 0 : (ref1 = stepConfig.popoverConfig) === null || ref1 === void 0 ? void 0 : ref1.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.description,
                        children: (ref2 = stepConfig.popoverConfig) === null || ref2 === void 0 ? void 0 : ref2.description
                    }),
                    (!!stepConfig.videoLink || stepConfig.type === "orb") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.btnCont,
                        children: [
                            stepConfig.type === "orb" && (0,quests_util/* isQuestV2 */.XA)(activeQuest) && !isFirstStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "text",
                                color: "primary",
                                className: classes.backBtn,
                                onClick: onBack,
                                disabled: isFirstStep,
                                children: "Back"
                            }),
                            stepConfig.type === "orb" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "text",
                                color: "primary",
                                className: classes.nextBtn,
                                onClick: handleClose,
                                children: getNextLabel()
                            }),
                            !!stepConfig.videoLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: classes.btn,
                                onClick: handleWatchVideo,
                                children: "Watch video"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 60022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ QuestStepWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/atoms/useQuests.ts + 1 modules
var useQuests = __webpack_require__(1755);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/AppTheme.ts + 1 modules
var AppTheme = __webpack_require__(73916);
;// CONCATENATED MODULE: ./src/components/quests/QuestOrb.tsx









var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, AppTheme/* PULSE_ORB.keyframes */.fK.keyframes, AppTheme/* PULSE_RING.keyframes */._W.keyframes), {
        root: {
            position: "absolute",
            width: 12,
            height: 12,
            "&:before": (0,_object_spread/* default */.Z)({
                content: "''",
                position: "relative",
                display: "block",
                width: "400%",
                height: "400%",
                boxSizing: "border-box",
                marginLeft: "-150%",
                marginTop: "-150%",
                borderRadius: 45,
                opacity: 0.9,
                backgroundColor: theme.colors.logo.blurple
            }, AppTheme/* PULSE_RING.elementStyles */._W.elementStyles),
            "&:after": (0,_object_spread/* default */.Z)({
                content: "''",
                position: "absolute",
                left: 0,
                top: 0,
                display: "block",
                width: "100%",
                height: "100%",
                backgroundColor: theme.colors.logo.blurple,
                borderRadius: 15,
                boxShadow: "0 0 8px rgba(255,197,80,.3)"
            }, AppTheme/* PULSE_ORB.elementStyles */.fK.elementStyles)
        },
        middle: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            margin: "auto"
        },
        top: {
            top: 0,
            right: 0,
            left: 0,
            margin: "0 auto"
        },
        topLeft: {
            top: 0,
            left: 0
        },
        right: {
            top: 0,
            right: 0,
            bottom: 0,
            margin: "auto 0"
        },
        bottom: {
            right: 0,
            bottom: 0,
            left: 0,
            margin: "0 auto"
        },
        left: {
            top: 0,
            bottom: 0,
            left: 0,
            margin: "auto 0"
        },
        noEvents: {
            pointerEvents: "none"
        }
    });
}, {
    classNamePrefix: "QuestOrb"
});
var QuestOrb = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var className = param.className, extClasses = param.classes, type = param.type, disabled = param.disabled, _placement = param.placement, placement = _placement === void 0 ? "middle" : _placement, offsetX = param.offsetX, offsetY = param.offsetY, onMouseEnter = param.onMouseEnter;
    var classes = useStyles({
        classes: extClasses
    });
    var handleMouseOver = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(e) {
        e.preventDefault();
        e.stopPropagation();
    });
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (0,clsx_m/* default */.Z)(classes.root, className, (_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.noEvents, disabled || type === "action"), (0,_define_property/* default */.Z)(_obj, classes.middle, placement === "middle"), (0,_define_property/* default */.Z)(_obj, classes.top, placement === "top"), (0,_define_property/* default */.Z)(_obj, classes.topLeft, placement === "top-left"), (0,_define_property/* default */.Z)(_obj, classes.right, placement === "right"), (0,_define_property/* default */.Z)(_obj, classes.bottom, placement === "bottom"), (0,_define_property/* default */.Z)(_obj, classes.left, placement === "left"), _obj)),
        style: {
            transform: "translate(".concat(offsetX === undefined ? 0 : offsetX, "px, ").concat(offsetY === undefined ? 0 : offsetY, "px)")
        },
        onMouseEnter: onMouseEnter,
        onMouseOver: handleMouseOver
    });
});

// EXTERNAL MODULE: ./src/components/quests/quests.util.ts + 14 modules
var quests_util = __webpack_require__(32774);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(16078);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./src/components/quests/QuestGenericPopperContent.tsx + 1 modules
var QuestGenericPopperContent = __webpack_require__(95858);
;// CONCATENATED MODULE: ./src/components/quests/QuestStepPopper.tsx












var QuestStepPopper_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            boxShadow: theme.shadows[9],
            borderRadius: "12px",
            zIndex: 1300,
            '&[data-popper-placement*="bottom"] $arrow': {
                top: 0,
                left: 0,
                marginTop: "-0.71em",
                "&::before": {
                    transformOrigin: "0 100%"
                }
            },
            '&[data-popper-placement*="top"] $arrow': {
                bottom: 0,
                left: 0,
                marginBottom: "-0.71em",
                "&::before": {
                    transformOrigin: "100% 0"
                }
            },
            '&[data-popper-placement*="right"] $arrow': {
                left: 0,
                marginLeft: "-0.71em",
                height: "1em",
                width: "0.71em",
                "&::before": {
                    transformOrigin: "100% 100%"
                }
            },
            '&[data-popper-placement*="left"] $arrow': {
                right: 0,
                marginRight: "-0.71em",
                height: "1em",
                width: "0.71em",
                "&::before": {
                    transformOrigin: "0 0"
                }
            }
        },
        paperV2: {
            backgroundColor: theme.colors.white,
            boxShadow: "0px 4px 72px 0px rgba(104, 109, 167, 0.50)",
            borderRadius: theme.shape.borderRadius * 2.5,
            overflow: "hidden",
            maxWidth: 422
        },
        paper: {
            backgroundColor: theme.colors.white,
            boxShadow: "0px 4px 72px 0px rgba(104, 109, 167, 0.50)",
            borderRadius: theme.shape.borderRadius * 2.5,
            overflow: "hidden",
            maxWidth: 285
        },
        arrow: {
            overflow: "hidden",
            position: "absolute",
            width: "1em",
            height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
            boxSizing: "border-box",
            color: theme.colors.white,
            "&::before": {
                content: '""',
                margin: "auto",
                display: "block",
                width: "100%",
                height: "100%",
                boxShadow: theme.shadows[1],
                backgroundColor: "currentColor",
                transform: "rotate(45deg)"
            }
        }
    };
}, {
    classNamePrefix: "QuestStepPopper"
});
var QuestStepPopper = function(_param) {
    var className = _param.className, extClasses = _param.classes, stepConfig = _param.stepConfig, _placement = _param.placement, placement = _placement === void 0 ? "left" : _placement, type = _param.type, onClose = _param.onClose, onBlur = _param.onBlur, onBack = _param.onBack, _arrow = _param.arrow, arrow = _arrow === void 0 ? true : _arrow, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "classes",
        "stepConfig",
        "placement",
        "type",
        "onClose",
        "onBlur",
        "onBack",
        "arrow"
    ]);
    var classes = QuestStepPopper_useStyles({
        classes: extClasses
    });
    var popperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), arrowRef = ref[0], setArrowRef = ref[1];
    var activeQuest = (0,useQuests/* useQuestsState */.P_)().activeQuest;
    var component = (0,react.useMemo)(function() {
        return (stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.component) || QuestGenericPopperContent/* QuestGenericPopperContent */.F;
    }, [
        stepConfig
    ]);
    var handleClose = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    var handleClickAway = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (stepConfig.type !== "action") onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    });
    /**
   * Effect to reposition the popper every 750 ms when content changes
   */ (0,react.useEffect)(function() {
        var timer = setInterval(function() {
            if (popperRef.current) {
                // The current ref here is a popper js instance but it is not available via mui
                popperRef.current.update();
            }
        }, 750);
        return function() {
            return clearInterval(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
        onClickAway: handleClickAway,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            popperRef: popperRef,
            className: (0,clsx_m/* default */.Z)(classes.root, className),
            placement: placement,
            modifiers: [
                {
                    name: "flip",
                    enabled: true,
                    options: {
                        altBoundary: true
                    }
                },
                {
                    name: "offset",
                    enabled: true,
                    options: {
                        offset: type === "orb" ? [
                            12,
                            12
                        ] : [
                            24,
                            24
                        ]
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: true,
                    options: {
                        altAxis: true,
                        altBoundary: true,
                        tether: false,
                        rootBoundary: "viewport",
                        padding: 12
                    }
                },
                {
                    name: "arrow",
                    enabled: true,
                    options: {
                        element: arrowRef,
                        padding: 12
                    }
                }, 
            ],
            transition: true
        }, rest), {
            children: function(param) {
                var TransitionProps = param.TransitionProps;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TransitionProps), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            arrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classes.arrow,
                                ref: setArrowRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)((0,quests_util/* isQuestV2 */.XA)(activeQuest) ? classes.paperV2 : classes.paper),
                                elevation: 10,
                                children: /*#__PURE__*/ (0,react.createElement)(component, {
                                    onComplete: handleClose,
                                    onClose: handleClose,
                                    onBack: onBack,
                                    onBlur: onBlur,
                                    stepConfig: stepConfig
                                })
                            })
                        ]
                    })
                }));
            }
        }))
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(96514);
// EXTERNAL MODULE: ./src/components/modal/Modal.tsx
var Modal = __webpack_require__(52127);
// EXTERNAL MODULE: ./src/components/modal/ModalContent.tsx
var ModalContent = __webpack_require__(84362);
;// CONCATENATED MODULE: ./src/components/quests/QuestStepModal.tsx












var QuestStepModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        paper: {
            boxShadow: "0px 4px 72px 0px rgba(104, 109, 167, 0.50)"
        },
        content: {
            padding: 0
        }
    };
}, {
    classNamePrefix: "QuestStepModal"
});
var QuestStepModal = function(_param) {
    var className = _param.className, extClasses = _param.classes, stepConfig = _param.stepConfig, open = _param.open, type = _param.type, onClose = _param.onClose, onBlur = _param.onBlur, onBack = _param.onBack, _arrow = _param.arrow, arrow = _arrow === void 0 ? true : _arrow, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "classes",
        "stepConfig",
        "open",
        "type",
        "onClose",
        "onBlur",
        "onBack",
        "arrow"
    ]);
    var classes = QuestStepModal_useStyles({
        classes: extClasses
    });
    var component = (0,react.useMemo)(function() {
        return (stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.component) || QuestGenericPopperContent/* QuestGenericPopperContent */.F;
    }, [
        stepConfig
    ]);
    var handleClose = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (stepConfig.type !== "action") onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        open: open,
        hideBackdrop: true,
        classes: {
            paper: (0,clsx_m/* default */.Z)(classes.paper, className)
        },
        onClose: onBlur
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent/* ModalContent */.h, {
            className: classes.content,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grow/* default */.Z, {
                children: /*#__PURE__*/ (0,react.createElement)(component, {
                    onComplete: handleClose,
                    onClose: handleClose,
                    onBack: onBack,
                    onBlur: onBlur,
                    stepConfig: stepConfig
                })
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/hooks/useNotifications.tsx
var useNotifications = __webpack_require__(55973);
// EXTERNAL MODULE: ./src/hooks/useConfettiCannon.ts + 12 modules
var useConfettiCannon = __webpack_require__(68118);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/hooks/useUsageData.ts + 1 modules
var useUsageData = __webpack_require__(38539);
;// CONCATENATED MODULE: ./src/components/quests/QuestStepWrapper.tsx






















var QuestStepWrapper_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            position: "relative"
        },
        fullWidth: {
            width: "100%"
        },
        modal: {}
    };
}, {
    classNamePrefix: "QuestStepWrapper"
});
var QuestStepWrapper = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var className = _param.className, extClasses = _param.classes, config = _param.config, hidden = _param.hidden, hideOrb = _param.hideOrb, disabled = _param.disabled, QuestOrbProps = _param.QuestOrbProps, popperPlacement = _param.popperPlacement, fullWidth = _param.fullWidth, children = _param.children, arrow = _param.arrow, center = _param.center, onShow = _param.onShow, orbOnly = _param.orbOnly, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "classes",
        "config",
        "hidden",
        "hideOrb",
        "disabled",
        "QuestOrbProps",
        "popperPlacement",
        "fullWidth",
        "children",
        "arrow",
        "center",
        "onShow",
        "orbOnly"
    ]);
    var classes = QuestStepWrapper_useStyles({
        classes: extClasses
    });
    var orbRef = (0,react.useRef)(null);
    var innerRef = (0,react.useRef)(null);
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), user = _$ref[0].user;
    var usageData = (0,useUsageData/* useUsageData */.L)().usageData;
    var fireConfettiCannon = (0,useConfettiCannon/* useConfettiCannon */.u)().fireConfettiCannon;
    var sendNotification = (0,useNotifications/* useNotifications */.z)().sendNotification;
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    (0,react.useImperativeHandle)(ref, function() {
        return innerRef.current;
    });
    var theme = (0,useTheme/* default */.Z)();
    var xs = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    var activeQuest = (0,useQuests/* useQuestsState */.P_)().activeQuest;
    var activeConfig = (0,react.useMemo)(function() {
        if (activeQuest) {
            var cfg = Array.isArray(config) ? config : [
                config
            ];
            return cfg.find(function(param) {
                var group = param.group, quest = param.quest, step = param.step;
                return activeQuest.group === group && activeQuest.quest === quest && activeQuest.step === step;
            });
        }
    }, [
        config,
        activeQuest
    ]);
    var popperActive = (0,useQuests/* useQuestPopperState */.Iy)(activeConfig).popperActive;
    var _$ref1 = (0,useQuests/* useQuestsActions */.UW)(activeConfig), onStepComplete = _$ref1.onStepComplete, onBack = _$ref1.onBack, setActiveQuest = _$ref1.setActiveQuest, setPopperActive = _$ref1.setPopperActive, setPopperBackgrounded = _$ref1.setPopperBackgrounded;
    var _$ref2 = (0,react.useState)(false), popperWasDisplayed = _$ref2[0], setPopperWasDisplayed = _$ref2[1];
    var stepConfig = (0,react.useMemo)(function() {
        return !activeConfig || !activeQuest ? undefined : (0,quests_util/* getQuestsStepConfig */.wh)(activeQuest);
    }, [
        activeQuest,
        activeConfig
    ]);
    var lastStepId = (0,react.useMemo)(function() {
        // find the id of the last step of the active quest
        if (!!activeConfig) {
            var _$ref, _$ref1, _$ref2;
            return (_$ref2 = (_$ref = quests_util/* QUESTS_CONFIG */.t_[activeConfig.group].quests.find(function(quest) {
                return quest.id === activeConfig.quest;
            })) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.steps) === null || _$ref1 === void 0 ? void 0 : _$ref1.slice(-1).pop()) === null || _$ref2 === void 0 ? void 0 : _$ref2.id;
        } else return undefined;
    }, [
        activeConfig
    ]);
    var orbActive = !!(activeConfig && !hidden && stepConfig) && !!stepConfig;
    var handleClose = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (!activeConfig || !stepConfig) return;
        setPopperActive(false);
        if ([
            "orb",
            "confetti"
        ].includes(stepConfig.type)) {
            setPopperWasDisplayed(false);
            setTimeout(function() {
                return onStepComplete(user, usageData);
            }, 100);
        }
        // If they close the last step end the quest
        if (lastStepId === activeConfig.step) setActiveQuest(undefined);
    });
    var handleBlur = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (!activeConfig || !stepConfig) return;
        // If they close the last step end the quest
        if (lastStepId === activeConfig.step) setActiveQuest(undefined);
        setPopperActive(false);
        setPopperBackgrounded(true);
    });
    var handleBack = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (!activeConfig || !stepConfig) return;
        setPopperActive(false);
        if (stepConfig.type === "orb") {
            setPopperWasDisplayed(false);
            setImmediate(function() {
                return onBack();
            });
        }
    });
    var showStepPopover = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (!(stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.popoverConfig) || popperActive) return;
        onShow === null || onShow === void 0 ? void 0 : onShow();
        setPopperActive(true);
        setPopperBackgrounded(false);
        setPopperWasDisplayed(true);
    });
    var handleClick = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(e) {
        if (!stepConfig || !activeConfig || disabled) return;
        if (xs && stepConfig.type !== "action") {
            showStepPopover();
        } else if (stepConfig.type === "action") {
            onStepComplete(user, usageData);
        }
    });
    /**
     * Show popover if not shown yet and orb becomes active
     */ (0,react.useEffect)(function() {
        var timer;
        if (orbActive && !popperWasDisplayed) {
            timer = setTimeout(function() {
                showStepPopover();
            }, 750);
        }
        return function() {
            clearTimeout(timer);
        };
    }, [
        orbActive,
        popperWasDisplayed,
        showStepPopover
    ]);
    // Cancel on navigating away
    (0,react.useEffect)(function() {
        if (!activeConfig || !activeQuest || !(0,quests_util/* isQuestV2 */.XA)(activeQuest)) return;
        var routeChangeHandler = function(nextPath) {
            // Bail if not actually changing route
            var nextBasePath = nextPath.split("?")[0];
            if (nextBasePath === window.location.pathname) return;
            var nextStep = (0,quests_util/* getNextQuestStep */.Wh)(activeQuest, user, usageData);
            var curStep = (0,quests_util/* getQuestsStepConfig */.wh)(activeConfig);
            var prevStep = (0,quests_util/* getPreviousQuestStep */.u8)(activeQuest);
            // If we're going to a whitelisted route, bail
            if ((curStep === null || curStep === void 0 ? void 0 : curStep.allowedRoutes) && (curStep === null || curStep === void 0 ? void 0 : curStep.allowedRoutes.test(nextPath))) {
                onStepComplete(user, usageData);
                return;
            }
            // If navigating away and next quest path is not where your going, kill quest
            if (nextBasePath !== (nextStep === null || nextStep === void 0 ? void 0 : nextStep.redirect) && nextBasePath != (prevStep === null || prevStep === void 0 ? void 0 : prevStep.redirectBack)) {
                setActiveQuest(undefined);
            }
        };
        router.events.on("routeChangeStart", routeChangeHandler);
        return function() {
            router.events.off("routeChangeStart", routeChangeHandler);
        };
    }, [
        router,
        activeConfig,
        activeQuest,
        setActiveQuest
    ]);
    (0,react.useEffect)(function() {
        if ((stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.type) === "confetti") {
            var _$ref;
            if (stepConfig === null || stepConfig === void 0 ? void 0 : (_$ref = stepConfig.popoverConfig) === null || _$ref === void 0 ? void 0 : _$ref.description) {
                var _$ref1;
                sendNotification(stepConfig === null || stepConfig === void 0 ? void 0 : (_$ref1 = stepConfig.popoverConfig) === null || _$ref1 === void 0 ? void 0 : _$ref1.description);
            }
            setTimeout(function() {
                handleClose();
            }, 3000);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stepConfig,
        handleClose,
        sendNotification
    ]);
    (0,react.useEffect)(function() {
        if ((stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.type) === "confetti") {
            fireConfettiCannon();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stepConfig
    ]);
    if ((stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.type) === "confetti") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: innerRef,
                className: (0,clsx_m/* default */.Z)(classes.root, className, (0,_define_property/* default */.Z)({}, classes.fullWidth, fullWidth)),
                onClick: handleClick
            }, rest), {
                children: [
                    children,
                    orbActive && !hideOrb && stepConfig.type !== "action" && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestOrb, (0,_object_spread/* default */.Z)({
                        ref: orbRef,
                        type: stepConfig.type,
                        onMouseEnter: showStepPopover,
                        disabled: disabled
                    }, QuestOrbProps))
                ]
            })),
            !!stepConfig && !hidden && !orbOnly && popperPlacement !== "center" && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestStepPopper, {
                arrow: arrow,
                type: stepConfig.type,
                open: !!popperActive,
                stepConfig: stepConfig,
                onClose: handleClose,
                onBlur: handleBlur,
                onBack: handleBack,
                anchorEl: stepConfig.type === "action" ? innerRef.current : orbRef.current,
                placement: popperPlacement
            }),
            !!stepConfig && !hidden && !orbOnly && popperPlacement === "center" && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestStepModal, {
                arrow: arrow,
                type: stepConfig.type,
                open: !!popperActive,
                stepConfig: stepConfig,
                onClose: handleClose,
                onBlur: handleBlur,
                onBack: handleBack,
                className: classes.modal
            })
        ]
    });
});


/***/ }),

/***/ 33456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ QUESTS_DIRECTORY; }
/* harmony export */ });
var QUESTS_DIRECTORY = {
    GETTING_STARTED: [
        "WELCOME_TO_RECLAIM",
        "PRIORITIZATION",
        "SYNC_CALENDAR",
        "SET_AVAILABILITY",
        "SET_SCHEDULING_HOURS",
        "INSTALL_GCAL_ADDON",
        "INSTALL_SLACK_INTEGRATION", 
    ],
    HABITS: [
        "HABITS_OVERVIEW",
        "CREATE_AND_CUSTOMIZE_HABITS",
        "MANAGE_HABITS"
    ],
    SMART_MEETINGS: [
        "SCHEDULING_LINKS_OVERVIEW",
        "SETUP_SCHEDULING_LINKS",
        "SETUP_TEAM_LINKS",
        "SMART_ONE_ON_ONE_OVERVIEW",
        "SETUP_FIRST_SMART_ONE_ON_ONE",
        "MANAGE_SMART_ONE_ON_ONE", 
    ],
    TASKS: [
        "TASK_OVERVIEW",
        "ADD_FIRST_TASK",
        "ADD_TASK_INTEGRATION",
        "MANAGE_TASKS",
        "SET_TASK_DEFAULTS"
    ],
    CUSTOMIZE_CALENDAR: [
        "AUTO_SCHEDULE_BREAK_AND_TRAVEL_TIME",
        "SETUP_NO_MEETING_DAYS",
        "CUSTOMIZE_EVENT_COLOR_CODING",
        "TRACK_AND_ANALYZE_PRODUCTIVITY", 
    ],
    INVITE_TEAM: [
        "ADD_MEMBERS_TO_TEAM",
        "SELECT_PLAN"
    ]
};


/***/ }),

/***/ 32774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cc": function() { return /* binding */ quests_util_DEFAULT_VIDEO_PLAYER_OPTIONS; },
  "t_": function() { return /* binding */ QUESTS_CONFIG; },
  "I6": function() { return /* binding */ getGroupConfigFromQuestId; },
  "rw": function() { return /* binding */ getNextQuestFromGroup; },
  "Wh": function() { return /* binding */ getNextQuestStep; },
  "u8": function() { return /* binding */ getPreviousQuestStep; },
  "N1": function() { return /* binding */ getQuestConfigFromActiveQuest; },
  "b_": function() { return /* binding */ getQuestConfigFromQuestId; },
  "wh": function() { return /* binding */ getQuestsStepConfig; },
  "R2": function() { return /* binding */ initQuestSteps; },
  "XA": function() { return /* binding */ isQuestV2; }
});

// UNUSED EXPORTS: getActiveQuestFromQuestId, getNextQuestFromQuestId

// EXTERNAL MODULE: ./src/hooks/useV16User.tsx
var useV16User = __webpack_require__(3512);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AssignmentTurnedInOutlined.js
var AssignmentTurnedInOutlined = __webpack_require__(75237);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/BarChartRounded.js
var BarChartRounded = __webpack_require__(75652);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Cached.js
var Cached = __webpack_require__(53707);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CalendarTodayOutlined.js
var CalendarTodayOutlined = __webpack_require__(55813);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ColorLensOutlined.js
var ColorLensOutlined = __webpack_require__(6516);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DateRangeOutlined.js
var DateRangeOutlined = __webpack_require__(57959);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/EventAvailableOutlined.js
var EventAvailableOutlined = __webpack_require__(74151);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LinkRounded.js
var LinkRounded = __webpack_require__(38736);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/RepeatRounded.js
var RepeatRounded = __webpack_require__(57875);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/TodayOutlined.js
var TodayOutlined = __webpack_require__(51325);
// EXTERNAL MODULE: ./src/img/adjust-icon.svg
var adjust_icon = __webpack_require__(15497);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/img/calendar-sync.svg
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCalendarSync(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 286 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#calendar-sync_svg__clip0_1066_244)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h286v122H0z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M8.5 0v122M225.5 0v122M0 26.5h286M0 95.5h286"
  }), /*#__PURE__*/react.createElement("rect", {
    x: 10,
    y: 28,
    width: 191,
    height: 66,
    rx: 6,
    fill: "#E0A8B9"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20 49.91h13v-13H20v13z",
    fill: "url(#calendar-sync_svg__pattern0)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M40.167 39.926c.953 0 1.79.186 2.509.559a3.934 3.934 0 011.677 1.599c.398.685.598 1.482.598 2.392 0 .91-.2 1.707-.598 2.392a3.98 3.98 0 01-1.677 1.573c-.72.373-1.556.559-2.51.559h-3.171v-9.074h3.172zm-.065 7.527c.953 0 1.69-.26 2.21-.78s.78-1.252.78-2.197c0-.945-.26-1.681-.78-2.21-.52-.537-1.257-.806-2.21-.806h-1.287v5.993h1.287zm12.906-2.21c0 .26-.017.494-.052.702h-5.265c.043.52.225.927.546 1.222.32.295.715.442 1.183.442.676 0 1.157-.29 1.443-.871h1.963a3.314 3.314 0 01-1.196 1.716c-.59.442-1.313.663-2.171.663-.693 0-1.317-.152-1.872-.455a3.35 3.35 0 01-1.287-1.313c-.303-.563-.455-1.213-.455-1.95 0-.745.152-1.4.455-1.963a3.175 3.175 0 011.274-1.3c.546-.303 1.174-.455 1.885-.455.685 0 1.296.147 1.833.442a3.05 3.05 0 011.261 1.261c.303.537.455 1.157.455 1.859zm-1.885-.52c-.009-.468-.178-.84-.507-1.118-.33-.286-.732-.429-1.209-.429-.45 0-.832.139-1.144.416-.303.269-.49.646-.559 1.131h3.419zm7.205-3.029c.857 0 1.55.273 2.08.819.528.537.792 1.291.792 2.262V49h-1.82v-3.978c0-.572-.143-1.01-.428-1.313-.286-.312-.676-.468-1.17-.468-.503 0-.902.156-1.196.468-.286.303-.43.741-.43 1.313V49h-1.82v-7.202h1.82v.897c.243-.312.55-.555.924-.728a2.86 2.86 0 011.248-.273zm6.722 1.599v3.484c0 .243.056.42.17.533.12.104.32.156.597.156h.845V49h-1.144c-1.534 0-2.3-.745-2.3-2.236v-3.471h-.859v-1.495h.858v-1.781h1.833v1.781h1.612v1.495H65.05zm3.844-2.353c-.32 0-.59-.1-.806-.299a1.043 1.043 0 01-.312-.767 1 1 0 01.312-.754c.217-.208.486-.312.806-.312.32 0 .585.104.793.312.217.2.325.45.325.754 0 .303-.108.559-.325.767-.208.2-.472.299-.793.299zm.897.858V49h-1.82v-7.202h1.82zm4.554 7.319c-.589 0-1.118-.104-1.586-.312a2.91 2.91 0 01-1.118-.871 2.216 2.216 0 01-.442-1.209h1.833c.035.277.17.507.403.689.243.182.542.273.897.273.347 0 .616-.07.806-.208.2-.139.3-.316.3-.533 0-.234-.122-.407-.365-.52-.234-.121-.61-.251-1.13-.39a9.95 9.95 0 01-1.327-.403 2.357 2.357 0 01-.884-.637c-.242-.286-.364-.672-.364-1.157 0-.399.113-.763.338-1.092.234-.33.564-.59.988-.78.434-.19.94-.286 1.521-.286.858 0 1.543.217 2.054.65.512.425.793 1.001.845 1.729h-1.742a.914.914 0 00-.364-.676c-.208-.173-.49-.26-.845-.26-.329 0-.585.06-.767.182a.584.584 0 00-.26.507c0 .243.122.429.364.559.243.121.62.247 1.131.377.52.13.95.264 1.287.403.338.139.629.355.871.65.252.286.382.667.39 1.144 0 .416-.117.789-.35 1.118-.226.33-.555.59-.989.78-.424.182-.923.273-1.495.273zm6.447-5.824v3.484c0 .243.057.42.17.533.12.104.32.156.597.156h.845V49H81.26c-1.534 0-2.3-.745-2.3-2.236v-3.471H78.1v-1.495h.858v-1.781h1.833v1.781h1.612v1.495h-1.612zM20.494 56.68v-1.079h2.444V65h-1.196v-8.32h-1.248zm4.476 3.523c0-1.49.243-2.652.728-3.484.485-.84 1.335-1.261 2.548-1.261 1.205 0 2.05.42 2.535 1.261.485.832.728 1.993.728 3.484 0 1.517-.243 2.695-.728 3.536-.485.84-1.33 1.261-2.535 1.261-1.213 0-2.063-.42-2.548-1.261-.485-.84-.728-2.02-.728-3.536zm5.37 0c0-.754-.053-1.391-.157-1.911-.095-.529-.299-.953-.61-1.274-.304-.32-.746-.481-1.327-.481-.59 0-1.04.16-1.352.481-.303.32-.507.745-.61 1.274-.096.52-.144 1.157-.144 1.911 0 .78.048 1.434.143 1.963.104.529.308.953.611 1.274.312.32.763.481 1.352.481.58 0 1.023-.16 1.326-.481.312-.32.516-.745.611-1.274.104-.529.156-1.183.156-1.963zm7.928-.468v1.001h-5.187v-1.001h5.187zm1.713-3.055v-1.079h2.444V65H41.23v-8.32h-1.248zm4.164 0v-1.079h2.444V65h-1.196v-8.32h-1.248zm4.23 4.732c0-.728.147-1.365.441-1.911a3.21 3.21 0 011.21-1.287 3.37 3.37 0 011.728-.455c.624 0 1.166.134 1.625.403.46.269.802.607 1.027 1.014v-1.3h1.196V65h-1.196v-1.326c-.234.416-.585.763-1.053 1.04-.459.269-.996.403-1.612.403a3.23 3.23 0 01-1.716-.468 3.283 3.283 0 01-1.209-1.313c-.294-.563-.442-1.205-.442-1.924zm6.031.013c0-.537-.108-1.005-.325-1.404a2.237 2.237 0 00-.884-.91 2.319 2.319 0 00-1.209-.325c-.442 0-.845.104-1.209.312a2.263 2.263 0 00-.87.91c-.217.399-.326.867-.326 1.404 0 .546.109 1.023.325 1.43.217.399.507.706.871.923.364.208.767.312 1.21.312.441 0 .844-.104 1.208-.312.373-.217.668-.524.884-.923.217-.407.325-.88.325-1.417zm11.763-3.679c.554 0 1.048.117 1.482.351.433.225.775.568 1.027 1.027.25.46.377 1.018.377 1.677V65h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.82-.572-1.417-.572-.616 0-1.105.2-1.47.598-.363.39-.545.958-.545 1.703V65h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.82-.572-1.417-.572-.616 0-1.105.2-1.47.598-.363.39-.545.958-.545 1.703V65h-1.183v-7.124h1.183v1.027c.234-.373.546-.659.936-.858.398-.2.836-.299 1.313-.299.598 0 1.126.134 1.586.403.459.269.801.663 1.027 1.183.199-.503.528-.893.988-1.17a2.91 2.91 0 011.534-.416z",
    fill: "#000",
    fillOpacity: 0.7
  }), /*#__PURE__*/react.createElement("g", {
    filter: "url(#calendar-sync_svg__filter0_d_1066_244)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M97 0h189v122H97z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M105.5 0v122M97 26.5h189M97 95.5h189"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M107 34a6 6 0 016-6h173v66H113a6 6 0 01-6-6V34z",
    fill: "#7384D4"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M117 49.91h13v-13h-13v13z",
    fill: "url(#calendar-sync_svg__pattern1)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M140.612 42.734c0 .485-.117.94-.351 1.365-.226.425-.585.767-1.079 1.027-.486.26-1.101.39-1.846.39h-1.521V49h-1.82v-9.074h3.341c.702 0 1.3.121 1.794.364s.862.576 1.105 1.001c.251.425.377.906.377 1.443zm-3.354 1.313c.502 0 .875-.113 1.118-.338.242-.234.364-.559.364-.975 0-.884-.494-1.326-1.482-1.326h-1.443v2.639h1.443zm11.341 1.196c0 .26-.017.494-.052.702h-5.265c.043.52.225.927.546 1.222.321.295.715.442 1.183.442.676 0 1.157-.29 1.443-.871h1.963a3.316 3.316 0 01-1.196 1.716c-.589.442-1.313.663-2.171.663-.693 0-1.317-.152-1.872-.455a3.35 3.35 0 01-1.287-1.313c-.303-.563-.455-1.213-.455-1.95 0-.745.152-1.4.455-1.963a3.173 3.173 0 011.274-1.3c.546-.303 1.174-.455 1.885-.455.685 0 1.296.147 1.833.442.546.295.966.715 1.261 1.261.303.537.455 1.157.455 1.859zm-1.885-.52c-.009-.468-.178-.84-.507-1.118-.329-.286-.732-.429-1.209-.429-.451 0-.832.139-1.144.416-.303.269-.49.646-.559 1.131h3.419zm5.033-1.807c.234-.381.538-.68.91-.897a2.587 2.587 0 011.3-.325v1.911h-.481c-.572 0-1.005.134-1.3.403-.286.269-.429.737-.429 1.404V49h-1.82v-7.202h1.82v1.118zm6.192 6.201c-.589 0-1.118-.104-1.586-.312a2.907 2.907 0 01-1.118-.871 2.214 2.214 0 01-.442-1.209h1.833c.035.277.169.507.403.689.243.182.542.273.897.273.347 0 .615-.07.806-.208.199-.139.299-.316.299-.533 0-.234-.121-.407-.364-.52-.234-.121-.611-.251-1.131-.39a9.988 9.988 0 01-1.326-.403 2.355 2.355 0 01-.884-.637c-.243-.286-.364-.672-.364-1.157 0-.399.113-.763.338-1.092.234-.33.563-.59.988-.78.433-.19.94-.286 1.521-.286.858 0 1.543.217 2.054.65.511.425.793 1.001.845 1.729h-1.742a.913.913 0 00-.364-.676c-.208-.173-.49-.26-.845-.26-.329 0-.585.06-.767.182a.585.585 0 00-.26.507c0 .243.121.429.364.559.243.121.62.247 1.131.377.52.13.949.264 1.287.403.338.139.628.355.871.65.251.286.381.667.39 1.144 0 .416-.117.789-.351 1.118-.225.33-.555.59-.988.78-.425.182-.923.273-1.495.273zm7.526 0c-.693 0-1.317-.152-1.872-.455a3.413 3.413 0 01-1.313-1.313c-.312-.563-.468-1.213-.468-1.95 0-.737.16-1.387.481-1.95a3.387 3.387 0 011.339-1.3 3.824 3.824 0 011.885-.468c.693 0 1.322.156 1.885.468a3.304 3.304 0 011.326 1.3c.329.563.494 1.213.494 1.95 0 .737-.169 1.387-.507 1.95a3.452 3.452 0 01-1.352 1.313c-.563.303-1.196.455-1.898.455zm0-1.586c.329 0 .637-.078.923-.234.295-.165.529-.407.702-.728.173-.32.26-.71.26-1.17 0-.685-.182-1.209-.546-1.573a1.742 1.742 0 00-1.313-.559c-.52 0-.958.186-1.313.559-.347.364-.52.888-.52 1.573 0 .685.169 1.213.507 1.586.347.364.78.546 1.3.546zm9.083-5.837c.858 0 1.551.273 2.08.819.529.537.793 1.291.793 2.262V49h-1.82v-3.978c0-.572-.143-1.01-.429-1.313-.286-.312-.676-.468-1.17-.468-.503 0-.901.156-1.196.468-.286.303-.429.741-.429 1.313V49h-1.82v-7.202h1.82v.897c.243-.312.55-.555.923-.728a2.858 2.858 0 011.248-.273zm4.136 3.679c0-.728.143-1.374.429-1.937.295-.563.689-.997 1.183-1.3a3.185 3.185 0 011.677-.455c.537 0 1.005.108 1.404.325.407.217.732.49.975.819v-1.027h1.833V49h-1.833v-1.053a2.75 2.75 0 01-.975.845c-.407.217-.88.325-1.417.325a3.093 3.093 0 01-1.664-.468 3.352 3.352 0 01-1.183-1.313c-.286-.572-.429-1.226-.429-1.963zm5.668.026c0-.442-.087-.819-.26-1.131a1.775 1.775 0 00-.702-.728 1.841 1.841 0 00-.949-.26c-.338 0-.65.082-.936.247-.286.165-.52.407-.702.728-.173.312-.26.685-.26 1.118 0 .433.087.815.26 1.144.182.32.416.568.702.741.295.173.607.26.936.26.338 0 .654-.082.949-.247.295-.173.529-.416.702-.728.173-.32.26-.702.26-1.144zm5.43-6.019V49h-1.82v-9.62h1.82zm4.454 5.07c0-.893.2-1.69.598-2.392a4.323 4.323 0 011.651-1.651c.702-.399 1.487-.598 2.353-.598 1.014 0 1.903.26 2.665.78.763.52 1.296 1.24 1.599 2.158h-2.093a2.154 2.154 0 00-.884-.975c-.372-.217-.806-.325-1.3-.325-.528 0-1.001.126-1.417.377-.407.243-.728.59-.962 1.04-.225.45-.338.98-.338 1.586 0 .598.113 1.127.338 1.586.234.45.555.802.962 1.053.416.243.889.364 1.417.364.494 0 .928-.108 1.3-.325.382-.225.676-.555.884-.988h2.093c-.303.927-.836 1.651-1.599 2.171-.754.511-1.642.767-2.665.767-.866 0-1.651-.195-2.353-.585a4.446 4.446 0 01-1.651-1.651c-.398-.702-.598-1.5-.598-2.392zm13.619 4.667c-.694 0-1.318-.152-1.872-.455a3.407 3.407 0 01-1.313-1.313c-.312-.563-.468-1.213-.468-1.95 0-.737.16-1.387.481-1.95a3.38 3.38 0 011.339-1.3 3.822 3.822 0 011.885-.468c.693 0 1.321.156 1.885.468a3.304 3.304 0 011.326 1.3c.329.563.494 1.213.494 1.95 0 .737-.169 1.387-.507 1.95a3.46 3.46 0 01-1.352 1.313c-.564.303-1.196.455-1.898.455zm0-1.586c.329 0 .637-.078.923-.234.294-.165.528-.407.702-.728.173-.32.26-.71.26-1.17 0-.685-.182-1.209-.546-1.573a1.744 1.744 0 00-1.313-.559c-.52 0-.958.186-1.313.559-.347.364-.52.888-.52 1.573 0 .685.169 1.213.507 1.586.346.364.78.546 1.3.546zm14.036-5.837c.884 0 1.594.273 2.132.819.546.537.819 1.291.819 2.262V49h-1.82v-3.978c0-.563-.143-.992-.429-1.287-.286-.303-.676-.455-1.17-.455-.494 0-.889.152-1.183.455-.286.295-.429.724-.429 1.287V49h-1.82v-3.978c0-.563-.143-.992-.429-1.287-.286-.303-.676-.455-1.17-.455-.503 0-.902.152-1.196.455-.286.295-.429.724-.429 1.287V49h-1.82v-7.202h1.82v.871c.234-.303.533-.542.897-.715a2.86 2.86 0 011.222-.26c.563 0 1.066.121 1.508.364.442.234.784.572 1.027 1.014.234-.416.572-.75 1.014-1.001a2.94 2.94 0 011.456-.377zm13.622 0c.884 0 1.595.273 2.132.819.546.537.819 1.291.819 2.262V49h-1.82v-3.978c0-.563-.143-.992-.429-1.287-.286-.303-.676-.455-1.17-.455-.494 0-.888.152-1.183.455-.286.295-.429.724-.429 1.287V49h-1.82v-3.978c0-.563-.143-.992-.429-1.287-.286-.303-.676-.455-1.17-.455-.503 0-.901.152-1.196.455-.286.295-.429.724-.429 1.287V49h-1.82v-7.202h1.82v.871c.234-.303.533-.542.897-.715.373-.173.78-.26 1.222-.26.563 0 1.066.121 1.508.364.442.234.784.572 1.027 1.014.234-.416.572-.75 1.014-1.001a2.943 2.943 0 011.456-.377zm5.601-.754c-.321 0-.589-.1-.806-.299a1.043 1.043 0 01-.312-.767 1 1 0 01.312-.754c.217-.208.485-.312.806-.312.321 0 .585.104.793.312.217.2.325.45.325.754 0 .303-.108.559-.325.767-.208.2-.472.299-.793.299zm.897.858V49h-1.82v-7.202h1.82zm3.917 1.495v3.484c0 .243.056.42.169.533.121.104.321.156.598.156h.845V49h-1.144c-1.534 0-2.301-.745-2.301-2.236v-3.471h-.858v-1.495h.858v-1.781h1.833v1.781h1.612v1.495h-1.612zm11.865-1.599c.884 0 1.595.273 2.132.819.546.537.819 1.291.819 2.262V49h-1.82v-3.978c0-.563-.143-.992-.429-1.287-.286-.303-.676-.455-1.17-.455-.494 0-.888.152-1.183.455-.286.295-.429.724-.429 1.287V49h-1.82v-3.978c0-.563-.143-.992-.429-1.287-.286-.303-.676-.455-1.17-.455-.503 0-.901.152-1.196.455-.286.295-.429.724-.429 1.287V49h-1.82v-7.202h1.82v.871c.234-.303.533-.542.897-.715.373-.173.78-.26 1.222-.26.563 0 1.066.121 1.508.364.442.234.784.572 1.027 1.014.234-.416.572-.75 1.014-1.001a2.943 2.943 0 011.456-.377zm11.373 3.549c0 .26-.017.494-.052.702h-5.265c.044.52.226.927.546 1.222.321.295.715.442 1.183.442.676 0 1.157-.29 1.443-.871h1.963a3.31 3.31 0 01-1.196 1.716c-.589.442-1.313.663-2.171.663-.693 0-1.317-.152-1.872-.455a3.35 3.35 0 01-1.287-1.313c-.303-.563-.455-1.213-.455-1.95 0-.745.152-1.4.455-1.963a3.179 3.179 0 011.274-1.3c.546-.303 1.175-.455 1.885-.455.685 0 1.296.147 1.833.442.546.295.967.715 1.261 1.261.304.537.455 1.157.455 1.859zm-1.885-.52c-.008-.468-.177-.84-.507-1.118-.329-.286-.732-.429-1.209-.429-.45 0-.832.139-1.144.416-.303.269-.489.646-.559 1.131h3.419zm7.205-3.029c.858 0 1.551.273 2.08.819.528.537.793 1.291.793 2.262V49h-1.82v-3.978c0-.572-.143-1.01-.429-1.313-.286-.312-.676-.468-1.17-.468-.503 0-.902.156-1.196.468-.286.303-.429.741-.429 1.313V49h-1.82v-7.202h1.82v.897a2.46 2.46 0 01.923-.728 2.858 2.858 0 011.248-.273zm6.722 1.599v3.484c0 .243.057.42.169.533.122.104.321.156.598.156h.845V49h-1.144c-1.534 0-2.301-.745-2.301-2.236v-3.471h-.858v-1.495h.858v-1.781h1.833v1.781h1.612v1.495h-1.612zM117.494 56.68v-1.079h2.444V65h-1.196v-8.32h-1.248zm4.476 3.523c0-1.49.243-2.652.728-3.484.485-.84 1.335-1.261 2.548-1.261 1.205 0 2.05.42 2.535 1.261.485.832.728 1.993.728 3.484 0 1.517-.243 2.695-.728 3.536-.485.84-1.33 1.261-2.535 1.261-1.213 0-2.063-.42-2.548-1.261-.485-.84-.728-2.02-.728-3.536zm5.369 0c0-.754-.052-1.391-.156-1.911-.095-.529-.299-.953-.611-1.274-.303-.32-.745-.481-1.326-.481-.589 0-1.04.16-1.352.481-.303.32-.507.745-.611 1.274-.095.52-.143 1.157-.143 1.911 0 .78.048 1.434.143 1.963.104.529.308.953.611 1.274.312.32.763.481 1.352.481.581 0 1.023-.16 1.326-.481.312-.32.516-.745.611-1.274.104-.529.156-1.183.156-1.963zm7.929-.468v1.001h-5.187v-1.001h5.187zm1.713-3.055v-1.079h2.444V65h-1.196v-8.32h-1.248zm4.164 0v-1.079h2.444V65h-1.196v-8.32h-1.248zm4.229 4.732c0-.728.148-1.365.442-1.911a3.215 3.215 0 011.209-1.287 3.37 3.37 0 011.729-.455c.624 0 1.166.134 1.625.403.46.269.802.607 1.027 1.014v-1.3h1.196V65h-1.196v-1.326c-.234.416-.585.763-1.053 1.04-.459.269-.996.403-1.612.403a3.233 3.233 0 01-1.716-.468 3.287 3.287 0 01-1.209-1.313c-.294-.563-.442-1.205-.442-1.924zm6.032.013c0-.537-.108-1.005-.325-1.404a2.231 2.231 0 00-.884-.91 2.319 2.319 0 00-1.209-.325c-.442 0-.845.104-1.209.312a2.265 2.265 0 00-.871.91c-.216.399-.325.867-.325 1.404 0 .546.109 1.023.325 1.43.217.399.507.706.871.923.364.208.767.312 1.209.312.442 0 .845-.104 1.209-.312a2.32 2.32 0 00.884-.923c.217-.407.325-.88.325-1.417zm11.763-3.679c.554 0 1.048.117 1.482.351a2.45 2.45 0 011.027 1.027c.251.46.377 1.018.377 1.677V65h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.819-.572-1.417-.572-.616 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V65h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.819-.572-1.417-.572-.616 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V65h-1.183v-7.124h1.183v1.027c.234-.373.546-.659.936-.858.398-.2.836-.299 1.313-.299.598 0 1.126.134 1.586.403.459.269.801.663 1.027 1.183.199-.503.528-.893.988-1.17.459-.277.97-.416 1.534-.416z",
    fill: "#000",
    fillOpacity: 0.7
  })))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "calendar-sync_svg__pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#calendar-sync_svg__image0_1066_244",
    transform: "scale(.01563)"
  })), /*#__PURE__*/react.createElement("pattern", {
    id: "calendar-sync_svg__pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#calendar-sync_svg__image1_1066_244",
    transform: "scale(.01563)"
  })), /*#__PURE__*/react.createElement("image", {
    id: "calendar-sync_svg__image0_1066_244",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAASyUlEQVR4nOVbW8xtV1X+xphr7/8/nNOiiWBpEBqwYIXGeCsVQ5UHmzShifBQYzC+qIkPBh4sURJvUQoSQoNRm6BppAasRn3ymra2QFNbNAWptZzQtAewtKUceno7l3+tOcbnw5hzrrn2fzsHHp3J6t7/OmvPNcc3xvjGZc4KSfx/HkP98uA9f734ByGgKcWlCpGENAyX67B+exqGn9Q0vEZUjwokQXAWxNcB/ruI3AeRxwg5lURBEagAIgKIABVvAQJ7QiD9bZAEROK+EHBCgC0ILiHwQ6S/FcSVIriYxDbJie7PueeH3e1ud34Olk95TA+zDLOMXtlXXv2OJQD7jfiRXDust35ttbX948N6+5I0rKApQURDsHgQJG8g/TSdXyF4AuT9JO8D8SWAz0KQZzH3fSNIQiBrCL5bgB+WlK4TkR9T1ddA5NUiAoHGNBJCOgmaXWd5ujFPO/8zjfgH5OlPAXz9IPkOBoB8ZRpWH9o6cuzd6yNHt1brbQyrFUS1WIWGKAWEotGjdH8TyTeR/g53TqB/BfSnnPwSwYdAngDwIoCdIsI2gGMCvAqir02DvEFEXy2q36uqrxNVFVWoSLEkhVQQK5YECILuYnl687hz9s3juTPvGnfO/QHIT10gAAQgrx/WW3+5ffTit24dOYrVehtV8034tiCZfxY6DIuIzxXJy8t1Dd1BOgBMJKfywrWIDAIBVNq8IhrC1r8hgKDcRwOhM0KARBpW9XqjaPrEOX/hMrN80yEAEJ1jvnLY2v7k1rGXX70+cgyrrS0MwxqqMydAFKoCQNsC6irYzVkXFa7E+R6wArhaLkeKRkNYkZAu3KwHYP6OTUsAkEikNEBUISID6B8we/5sztPNIkv3awBIISSQktZbH9k+evHV6+2XYVitoalqPs2fxQr2Gg2CIimLNQirkTRTCdgXayqCd4KFsDMoLJ+zGyyFIokkAnINrh1+xJDH8SbL4xfc/Z4ehGHjl5CU3rHePvqLq63w95SGJnBEhfnvtuAmckgkoiG8oAmO3i7a1z4E9wJ392oEae/qBd8ArqwjnleoJqRhhdV6C+sjR7fHnbMf2jl75qchcu6O2/8IANBUWPzt2LDa+q3V1pHw9yq4KkSL5jvmj8UQzWTRWUXxYZUUpthdAaZ21jS/R/tnVIoZz5xTVL80/wJm87Iqk0qx2gGr9RqrrSNvEdV3u3t7RrufQ5L+xLC1fdWwWkHTANFU/WhBeALprTjYt3vz/Cxmn21kprM5Yya7+T3akZ9C0TH+rtG5Gjs8Cg/V+RsIqy0k0feQM/fMAJBQTTekYQ0pRFfDjjR/lw3MN5fDXWAUSMpiyhxFwMrwJVNaMn4XXXbPh0JXLPxS3s0Fw3QRQ0KZaYCu1ldO4841uwAQ4BJJw8+0BAed1nbpgIuPXd99XhxKFGgPVVk7XxcCQkKk2DBrKN0QfiH0PqDswTXVslQT0motdP9gfaYjQb9MVS9tWu6Ip/lbtfwNUot/lT0BYRF6/re9lr4J6G4Q5giy/6jP9whwXl1wQkpIq9WPAngZgDMNAHe8DpDVYq1duJjZvHzfI/mRmkZsumwTYi/2Xgow21oNoW0x2ISgzzd6DpgNjjU7moEQRRpWCcDVAO5uAJB+BRlZGouptZl6KyQ3a5r2CL37o5O1UlIIiOWPNyZiCZ/z+zohl9gsea8topun8lEHRCSbAgA/sgTA/bV0h9NB2vyj5ssE6RDowaZYV7ULu12xoqyn6L1/vjOj6o49jcTD0hRfgV1YRP3LHU5GsVRlihzmSqDjAHd7hVuGZwPN4AUMLT90EuqsKeMeBtkN74TpLaGx9Gzq7U6dcHeN05tBE3x5b44ELZ0vREknav1Rr2Kqr1oCYHnbc4bnCWaGZBluA1wdIg6KwKVEL0qhboCUpe/JxuI8vrtgoWViTkYWo/YBsBRaGuI9qW74RB8KCwhOh7sHCB6AeKzpyBIAN1qekPOElCf4sIK7wd3mBEgIKdqb4/RMbksWZme2BYSNkFaFIaXxrVRzr0VR+WzUIN33TVJsmi/v93BberXqDLcMdJngzAFmp80mWC6XZWieuqZHSYhIaOn01EqNCwftzJpLrWyGz4WON1Lb9s4KBBDv7JKd5bv7+Uuu4A5zh5nB3BAWnuGeQx8LAOhP0zIsj7BphJXytwLABIhHjk4hRLu0eGPM/QDMJIr574X4BGb7rmVurf8B9rX/RgUYfYXqf74BOIPHzBDcForNNoUVAM8vAHD3E24ZPo2w1YScR0gaAEmAKJSEpgQyQdUh1LbQhfBVC5WEukgyW8ZGqMCsZeksK+b25b3yLCqnCJaCl2hFBgBmGdW1cx5hU3AcgG9uWsCX3QKx+gPVsVgAQK5Ch8Lis7NrLOpxdhZQFxPzF1yqicbDUv8rEnn5ohZY1gZzMbbb5urcvfDuBrcJeRwxTSPyOMLzCMsTADy+AADE/5I2uk1ryyPStIJpVIQQIDGEoHpxDZsXuUFJLV/vFoTuXktQOhcQSDillrJau1qk/44l3k1+EkQVnnA3sGp/2kEed8K18wTPGQDu3wCAT9LtJN0uDX8ZW0lcTTuRoBKuHu0wUQis+W0THpgZuAru3feanRUvqBQgOmu+9R1VIS4bllDcoAu7TfPlXW7B+JYnTOMObNxBrgCYvQjgswsABP51Uh50t0ul/FDT1ACoKDCF/7trc49GXlW3vQVUwTcBIRFl4+zMolIaLgqmDoDSf1y4QMvHq3WhZbFBfFYAGGFTEb4QIJ23ANGi7y3AQf4T3a6nB2t6GmGagNaUiIVHo4QQ8Zm1G8t38bj4YsTiCoDDGRaCPhmSrnkhCvrcGRJRsLkBFjxA9EmPARa5i1n4v00j8jTB8wifRnieTg3iH5nKDF1TlABwH+hn6XaEJXSIJIgITCIF0mRz/d6K+y4nW/i7w1sysgTCfU5gpQGggDqoClKhTPGpCqFCxAtHzPlyvK/OayX2z/5vRXjLE+gZQvs3in8LSEsAiv6+DLd76elalqxJdILk2qYKc1UQoJYYXRKWOkcX/mpxVQuSOScnWsWJUloT0RAho/4oK9JmdfW5LhxuhL2wrohkDQAb4TaBNoFuBPxTPYnOLhCJ+ki3W2n5WqrCbYIkheSunVVDWCKEjOwMMhcje4SjKri7zxqbkY/iSCPmE1E+iIVtRPFWUvAu72D/n054uhfhM5iL4CE84PYIHHegGxv7AgCAO+l23M1+QCSDOcFFITY2c490IEHUSyToQ+ASgNn0azHiuwodAEEHCjgcEtNCHaA4CEWj/EWnqhY+3bs8yI+F8OpFN9D9NgBn9gSAs1mcAv1m9/xnYgqRqZBOISMQVrQffllMs1aBLJ/w2NXlLHg4fgmBLYYh0lqRUjKGYEIHmADVWdsaLkCNrGFuwNR3GMw7wT2Dpfih2+Mgb61CXvvz710CMOfoAIjbafZLRH6Ll66wSypmGq0xSRWAIElutHEWflkSk/7+DALCirzk/SW/cNXQClvl3fIBUIK0Wd8VBFirvTD7DOYcPOQZgH8YKs9iY8y1wLKyfEnov+me74JrEsstLSUAJSD0CIfipcNS0+ISkrzzzcrQRVPBAfFZc3uWmA9qvAA1SBbSrSlgAWD2/epmVsre2ey9gEL3u0C5dXcKvUiEdo1PO/1jcPt1uEJKb0BNgqRY3EAJFM2w+qd3kYBV+5UMCwD0JkQNgUQCNEG8qySrcSoC6FoANUtjmDit9C+6kBvXKRA3Bq0eAMDCBeZ7v++wq0TT29wd4g5KLUEVgEWIkuKnfTrc1wJlUWjmH4DUkBkcoMWsCdd67qAAkApQ7qVwmkmbKPPUd5i1d8Z3vB8qX9xL+AUAlL0MBC+A/qt0v4f0V/YbEtJUEUVImWQjFFbfDHZG7ce5BTmyzwQL7achyI8ANDU3EADaegOVPRi+W9e1TLudwB8L5OOQLp3fDwDRfQ+LPEL6R0l+mKjtsHnDctZ6WWgzWy8EVHyzCB4gGEhrC67dpkqM1eKBvvIrHNM01n3t43Dtj0COQ9JvS9vFPgSA3TXm4l13kv57AI5AYmdXujNCRDXJ2pSIGoFdGhzCx0Wvn7VDK0F+ZR1SEysRiAuoWhqxNSJIswJq3bCpz0UkEdcTULx4oPQ4jAPmYeU4yxEpW+UpDRBJJTcHlhUZARhcLAgxsjCQGdK+O0h/jPCXALlMyZfDa8u1ll8Ch0TSBcxb86Ukrs0UOlF35R0sEYpTt/V5OAC0fdrUFR5xD8LWOCSRBqgOgCraITdGG9pKwhN7nbP5h9lngP5NAn8I+u2gnwHkDQTeD9g7gYgoLgr1UmWkSJUl9dvoABBNUSpBE4g6xAANgt1ZZpyHAOD79ekBCDk5U67bVqoJOgxIadW1zACAEHeIZ2SzEq4Y5u8ZoMHp3xD4zwHymQANgOA/Sd4A94+K+HvoDoGF9tVKHaDzuUWpeUcJt1ZE9bIQHUDlaVwIAJz2DJNljRxVLAMeXKEKTSukoXaMSmCmR31ggKQcJOko4YsgmEG+F8BnNhMPgWQI30fa5aBeByrEDJRUaDF6BeF68ykV0uFwuACKDDLWB9Xn5GC3XgJwsAPgLNzP1camSj3CMkBSCp8k4VRo8W9R7Ri5tcH+HpC/qWnzTPBS9+tGEL9B+NsAPxYmXnMNhPl35xcadIiwLB73FQBFvrVPaF+MjiVs34uw50k76TZncFqalaqCpLJxpqc/VNH44XkAH2zpLKTbXClWFNd/w/gXtNJDwEbNINrIUGUOyXU9tbAi8DTab/e6NgComdReF9zP0P2piOul6UCW9GTuzkCkJCZF7zXnhwPgvRR5iHWBIqCm8NdS988XP0FyRE1qFlVkNZr5yE4txub6yEn6E8uMdHnVcehZ4QYQeaIWHG61+WDwptFYbIBji+ZHrAif5C6LlFbxbdx+GOQDIK9pVWXRHMlSukeZyHYcp1hnZJ3P0fnE+ch1fgBE7+14FBul0soZrsPcywNbO6pdcyf4q4TcvScp11p3OUaQf0f6Na3NVjVHB1xb/6I1WdxjA9Qy3Oyke37mggA4nC/5KM3oZuLl+LlaLmd7g0K978fPXRg4+aSQu2rxbu69bj1Uyjqduz0lvZYozwOAUEo9El++P8vo/Z8/AIdkggD4Dbq/RLOLmgWkDIiUs8ORTLlb6cpaSX8JkE8RvmeclX1fy+dInCF4rDVY3WCukR+qltLBQnDLMKtd4OmrdN+5IAAOjRjEE3R7wjxfUTccNQ0ABEyRqtJrR7YUQDXlhT8s+9hY1xjbHCfhPEX3Y0D4t+UcOYhIaa8BhMFynrf18wTL+f7zEX4BwOGDp+h+H/N0hVvsr9kwtRxARFr7KfbgrZ3LEfC/9nMyUuB7W983RPiYEN/XXMAMPk1g60CFC1TBfZpgeTxNs3vPV6rDq4U6RAD6nV4PUVjdZ4vLcvFBi12ZsAIH4M+CPC61t7dx9Wd3lpdl0h6uzO+142NTbHH5BLc4y1B3fSyP8DydoOfj9IyDrjoOaontGoR/3i0/5zZ9l+URqgkmAk2lgq9RoLTPovjhM+L85r5z+r6nhSDgF7U0UWgOaoYjSl5WizMD26mWCe72AGinz0+iC4oCACiP0+wOn8YbrO4c10pIUgBQmL+7TkH40n5TCuIk2p6vozxGd3c3reQqpSsNQdsHrATIaZrcp9vOS/JNADbbwvsg4G788x6A2guQFFN5tmYFhQSfADjuq5HSG9xrCPAtup1294vcM5C1nE3wmK7sA3qYPsym+0i7/3y1vwDgvCwgqr7Pep7ukGnnWit7egSgjFaGm4WfWfE12uc38+9+eD1lsufgU3B7xi1fZHmKrDH5HLIYR2ACgHFyn25CFDDnPRoAen4IAMDIbL/raXw7RFa1i5dY9rPMY0/eJ7iZg/7ggbOVTtI+/3gSbo8wT6/3dlBjiM0TIDZdczn2Mu38LeF3XYj2gcXGyIEF8eZ4gNP4MRDvizon2l4iGqmpTfDYmHyazMcPmsi9bnTsOUjx/xDN10ueoqxSq2d9o96wEZ7HJ93tdw5P5naPLgpckOUAhg8YcRXJn4pTGbl0doF6tgCenyL95IHzcL8Uqa3sC8wTXEqHUBK8tkTd4LH9fSOAxy5U+8DilNgF//YFWP4VI/+ZtO9Xn2JXh4gcILq+J0CePVA8HJKFUr7mwtPMOKo0AFpzkso1N8Pl9m9DdgDL/2Hi2/n9o3T/BZvsNpq+sf0PU61y46cPneHwHPxrIL9K8gfNrDXEoztlfwXI++e9sgsf558J7j8+R8vXe975F8vngpRsAj2foud/PSwj4+68YfN6Hm6fghtgObK/PGaz8RZ3/2VAxu9k8RdQCxw4HoX5OwH+LCHvEpHvgcotFDx26C+ph2qPgj8RtVfQcQ3BJwF+HMA/1nM+38n4PzqMsxvL2UNIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/react.createElement("image", {
    id: "calendar-sync_svg__image1_1066_244",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/react.createElement("clipPath", {
    id: "calendar-sync_svg__clip0_1066_244"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h286v122H0z"
  })), /*#__PURE__*/react.createElement("filter", {
    id: "calendar-sync_svg__filter0_d_1066_244",
    x: 77,
    y: -12,
    width: 213,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/react.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1066_244"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1066_244",
    result: "shape"
  })))));
}
/* harmony default export */ var calendar_sync = (SvgCalendarSync);
// EXTERNAL MODULE: ./src/img/coffee.svg
var coffee = __webpack_require__(68603);
// EXTERNAL MODULE: ./src/img/cog-icon.svg
var cog_icon = __webpack_require__(43553);
;// CONCATENATED MODULE: ./src/img/connected-calendars.svg
var connected_calendars_g, connected_calendars_defs;
function connected_calendars_extends() { connected_calendars_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return connected_calendars_extends.apply(this, arguments); }

function SvgConnectedCalendars(props) {
  return /*#__PURE__*/react.createElement("svg", connected_calendars_extends({
    viewBox: "0 0 286 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), connected_calendars_g || (connected_calendars_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#connected-calendars_svg__clip0_1065_288)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h95.33v122H0z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M8.5 0v122M0 12.5h95.33M0 81.5h95.33"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11 21a6 6 0 016-6h78v31H17a6 6 0 01-6-6V21zM11 108a6 6 0 016-6h78v18H17a6 6 0 01-6-6v-6zM11 54a6 6 0 016-6h78v31H17a6 6 0 01-6-6V54z",
    fill: "#E0A8B9"
  }), /*#__PURE__*/react.createElement("g", {
    filter: "url(#connected-calendars_svg__filter0_d_1065_288)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M95 0h96v122H95z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M103.5 0v122M95 26.5h95.33M95 95.5h95.33"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M106 35a6 6 0 016-6h78v64h-78a6 6 0 01-6-6V35z",
    fill: "#7384D4"
  })), /*#__PURE__*/react.createElement("g", {
    filter: "url(#connected-calendars_svg__filter1_d_1065_288)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M191 0h95.33v122H191z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M199.5 0v122M191 38.5h95.33M191 107.5h95.33"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M202 10a6 6 0 016-6h78v32h-78a6 6 0 01-6-6V10zM202 79a6 6 0 016-6h78v49h-84V79z",
    fill: "#E17958"
  })))), connected_calendars_defs || (connected_calendars_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("filter", {
    id: "connected-calendars_svg__filter0_d_1065_288",
    x: 75,
    y: -12,
    width: 120,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/react.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1065_288"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1065_288",
    result: "shape"
  })), /*#__PURE__*/react.createElement("filter", {
    id: "connected-calendars_svg__filter1_d_1065_288",
    x: 171,
    y: -12,
    width: 119.33,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/react.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1065_288"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1065_288",
    result: "shape"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "connected-calendars_svg__clip0_1065_288"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h286v122H0z"
  })))));
}
/* harmony default export */ var connected_calendars = (SvgConnectedCalendars);
;// CONCATENATED MODULE: ./src/img/gcal-outline.svg
var _path, _path2;
function gcal_outline_extends() { gcal_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return gcal_outline_extends.apply(this, arguments); }

function SvgGcalOutline(props) {
  return /*#__PURE__*/react.createElement("svg", gcal_outline_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M18 23l5-5h-5v5zM23 5h-5v13h5V5zM18 18H5v5h13v-5zM1 18v3.263C1 22.223 1.777 23 2.737 23H5v-5H1zM23 5V2.737C23 1.777 22.221 1 21.262 1H18v4h5zM18 1H2.737C1.777 1 1 1.777 1 2.737V18h4V5h13V1z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M8.325 14.28c-.399-.267-.674-.657-.825-1.172l.925-.377c.083.317.23.562.44.737.207.174.46.26.756.26.302 0 .562-.091.78-.274a.87.87 0 00.325-.696.86.86 0 00-.343-.705c-.23-.182-.517-.273-.86-.273h-.535v-.907h.48c.295 0 .544-.08.747-.238a.781.781 0 00.304-.651.717.717 0 00-.272-.588c-.181-.146-.41-.22-.689-.22-.272 0-.487.071-.647.215-.16.144-.28.327-.35.53l-.914-.378c.12-.34.343-.642.67-.902.326-.26.743-.391 1.25-.391.373 0 .71.071 1.009.215.298.144.533.344.702.597.17.255.253.54.253.857 0 .324-.079.597-.236.822a1.62 1.62 0 01-.58.516v.054c.297.121.554.32.744.575.193.257.29.565.29.924 0 .36-.091.68-.275.961a1.905 1.905 0 01-.76.665 2.415 2.415 0 01-1.092.243c-.467 0-.9-.133-1.297-.4zm5.679-4.548l-1.015.727-.508-.763 1.821-1.302H15v6.142h-.996V9.732z",
    fill: "currentColor"
  })));
}
/* harmony default export */ var gcal_outline = (SvgGcalOutline);
;// CONCATENATED MODULE: ./src/img/grid.svg
var grid_path;
function grid_extends() { grid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return grid_extends.apply(this, arguments); }

function SvgGrid(props) {
  return /*#__PURE__*/react.createElement("svg", grid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), grid_path || (grid_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z"
  })));
}
/* harmony default export */ var grid = (SvgGrid);
;// CONCATENATED MODULE: ./src/img/habits.svg
var habits_g, habits_defs;
function habits_extends() { habits_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return habits_extends.apply(this, arguments); }

function SvgHabits(props) {
  return /*#__PURE__*/react.createElement("svg", habits_extends({
    viewBox: "0 0 286 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), habits_g || (habits_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#habits_svg__clip0_1066_427)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h286v122H0z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M8.5 0v122M225.5 0v122M0 26.5h286M0 95.5h286"
  }), /*#__PURE__*/react.createElement("rect", {
    x: 10,
    y: 28,
    width: 191,
    height: 66,
    rx: 6,
    fill: "#E0A8B9"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20 49.91h13v-13H20v13z",
    fill: "url(#habits_svg__pattern0)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M38.815 47.557h2.99V49h-4.81v-9.074h1.82v7.631zm10.946-5.759V49h-1.834v-.91a2.448 2.448 0 01-.922.741c-.373.173-.78.26-1.223.26-.563 0-1.061-.117-1.494-.351a2.613 2.613 0 01-1.027-1.053c-.243-.468-.364-1.023-.364-1.664v-4.225h1.82v3.965c0 .572.142 1.014.428 1.326.286.303.676.455 1.17.455.503 0 .898-.152 1.184-.455.285-.312.428-.754.428-1.326v-3.965h1.834zm5.786-.104c.858 0 1.552.273 2.08.819.529.537.793 1.291.793 2.262V49H56.6v-3.978c0-.572-.143-1.01-.429-1.313-.286-.312-.676-.468-1.17-.468-.502 0-.901.156-1.196.468-.286.303-.429.741-.429 1.313V49h-1.82v-7.202h1.82v.897c.243-.312.55-.555.923-.728a2.86 2.86 0 011.248-.273zm4.136 3.705c0-.745.152-1.395.455-1.95a3.198 3.198 0 011.26-1.3c.538-.312 1.154-.468 1.847-.468.893 0 1.63.225 2.21.676.59.442.984 1.066 1.183 1.872h-1.963a1.389 1.389 0 00-.533-.728c-.243-.182-.546-.273-.91-.273-.52 0-.932.19-1.235.572-.303.373-.455.906-.455 1.599 0 .685.152 1.218.455 1.599.303.373.715.559 1.235.559.737 0 1.218-.33 1.443-.988h1.963c-.2.78-.594 1.4-1.183 1.859-.59.46-1.326.689-2.21.689-.693 0-1.309-.152-1.846-.455a3.308 3.308 0 01-1.261-1.3c-.303-.563-.455-1.218-.455-1.963zm12.344-3.705c.546 0 1.032.121 1.456.364.425.234.754.585.988 1.053.243.46.364 1.014.364 1.664V49h-1.82v-3.978c0-.572-.143-1.01-.429-1.313-.286-.312-.676-.468-1.17-.468-.502 0-.901.156-1.196.468-.286.303-.429.741-.429 1.313V49h-1.82v-9.62h1.82v3.315a2.32 2.32 0 01.936-.728c.39-.182.824-.273 1.3-.273zM20.494 56.68v-1.079h2.444V65h-1.196v-8.32h-1.248zm4.333 7.371a61.624 61.624 0 002.587-2.171 10.594 10.594 0 001.573-1.781c.433-.624.65-1.235.65-1.833 0-.563-.139-1.005-.416-1.326-.269-.33-.706-.494-1.313-.494-.59 0-1.049.186-1.378.559-.32.364-.494.854-.52 1.469h-1.144c.035-.97.33-1.72.884-2.249.555-.529 1.27-.793 2.145-.793.893 0 1.6.247 2.12.741.528.494.792 1.174.792 2.041 0 .72-.217 1.421-.65 2.106a9.279 9.279 0 01-1.456 1.794 38.214 38.214 0 01-2.093 1.794h4.472v.988h-6.253v-.845zm12.756-4.316v1.001h-5.187v-1.001h5.187zm1.713-3.055v-1.079h2.444V65h-1.196v-8.32h-1.248zm5.854 2.509c.234-.407.58-.745 1.04-1.014.468-.277 1.01-.416 1.625-.416a3.3 3.3 0 011.716.455c.52.303.927.732 1.222 1.287.294.546.442 1.183.442 1.911 0 .72-.148 1.36-.442 1.924a3.252 3.252 0 01-2.938 1.781c-.607 0-1.144-.134-1.612-.403-.46-.277-.81-.62-1.053-1.027v4.693h-1.183V57.876h1.183v1.313zm4.836 2.223c0-.537-.108-1.005-.325-1.404a2.237 2.237 0 00-.884-.91 2.394 2.394 0 00-1.21-.312c-.432 0-.836.108-1.208.325a2.331 2.331 0 00-.884.923c-.217.399-.325.862-.325 1.391 0 .537.108 1.01.325 1.417.225.399.52.706.884.923a2.44 2.44 0 001.209.312c.442 0 .845-.104 1.209-.312.373-.217.667-.524.884-.923.216-.407.325-.884.325-1.43zm11.333-3.666c.555 0 1.049.117 1.482.351.433.225.776.568 1.027 1.027.251.46.377 1.018.377 1.677V65h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.819-.572-1.417-.572-.615 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V65H57.9v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.819-.572-1.417-.572-.615 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V65h-1.183v-7.124h1.183v1.027c.234-.373.546-.659.936-.858.399-.2.836-.299 1.313-.299.598 0 1.127.134 1.586.403.46.269.802.663 1.027 1.183.2-.503.529-.893.988-1.17a2.91 2.91 0 011.534-.416z",
    fill: "#000",
    fillOpacity: 0.7
  }), /*#__PURE__*/react.createElement("g", {
    filter: "url(#habits_svg__filter0_d_1066_427)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M97 0h189v122H97z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M105.5 0v122M97 26.5h189M97 95.5h189"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M107 1a6 6 0 016-6h173v66H113a6 6 0 01-6-6V1z",
    fill: "#E17958"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M127.79 6.926V16h-1.82v-5.902L123.539 16h-1.378l-2.444-5.902V16h-1.82V6.926h2.067l2.886 6.747 2.886-6.747h2.054zm8.494 5.317c0 .26-.017.494-.052.702h-5.265c.044.52.226.927.546 1.222.321.295.715.442 1.183.442.676 0 1.157-.29 1.443-.871h1.963a3.31 3.31 0 01-1.196 1.716c-.589.442-1.313.663-2.171.663-.693 0-1.317-.152-1.872-.455a3.35 3.35 0 01-1.287-1.313c-.303-.563-.455-1.213-.455-1.95 0-.745.152-1.4.455-1.963a3.179 3.179 0 011.274-1.3c.546-.303 1.175-.455 1.885-.455.685 0 1.296.147 1.833.442.546.295.967.715 1.261 1.261.304.537.455 1.157.455 1.859zm-1.885-.52c-.008-.468-.177-.84-.507-1.118-.329-.286-.732-.429-1.209-.429-.45 0-.832.139-1.144.416-.303.269-.489.646-.559 1.131h3.419zm9.909.52c0 .26-.018.494-.052.702h-5.265c.043.52.225.927.546 1.222.32.295.715.442 1.183.442.676 0 1.157-.29 1.443-.871h1.963a3.316 3.316 0 01-1.196 1.716c-.59.442-1.313.663-2.171.663-.694 0-1.318-.152-1.872-.455a3.35 3.35 0 01-1.287-1.313c-.304-.563-.455-1.213-.455-1.95 0-.745.151-1.4.455-1.963a3.173 3.173 0 011.274-1.3c.546-.303 1.174-.455 1.885-.455.684 0 1.295.147 1.833.442.546.295.966.715 1.261 1.261.303.537.455 1.157.455 1.859zm-1.885-.52c-.009-.468-.178-.84-.507-1.118-.33-.286-.733-.429-1.209-.429-.451 0-.832.139-1.144.416-.304.269-.49.646-.559 1.131h3.419zm5.332-1.43v3.484c0 .243.057.42.169.533.122.104.321.156.598.156h.845V16h-1.144c-1.534 0-2.301-.745-2.301-2.236v-3.471h-.858V8.798h.858V7.017h1.833v1.781h1.612v1.495h-1.612zm3.844-2.353c-.32 0-.589-.1-.806-.299a1.043 1.043 0 01-.312-.767 1 1 0 01.312-.754 1.12 1.12 0 01.806-.312c.321 0 .585.104.793.312.217.2.325.45.325.754 0 .303-.108.559-.325.767-.208.2-.472.299-.793.299zm.897.858V16h-1.82V8.798h1.82zm5.789-.104c.858 0 1.552.273 2.08.819.529.537.793 1.291.793 2.262V16h-1.82v-3.978c0-.572-.143-1.01-.429-1.313-.286-.312-.676-.468-1.17-.468-.502 0-.901.156-1.196.468-.286.303-.429.741-.429 1.313V16h-1.82V8.798h1.82v.897c.243-.312.551-.555.923-.728a2.864 2.864 0 011.248-.273zm7.425-.013c.538 0 1.01.108 1.417.325.408.208.728.481.962.819V8.798h1.833v7.254c0 .667-.134 1.261-.403 1.781a2.935 2.935 0 01-1.209 1.248c-.537.312-1.187.468-1.95.468-1.022 0-1.863-.238-2.522-.715-.65-.477-1.018-1.127-1.105-1.95h1.807c.096.33.299.59.611.78.321.2.707.299 1.157.299.529 0 .958-.16 1.287-.481.33-.312.494-.789.494-1.43v-1.118a2.75 2.75 0 01-.975.845c-.407.225-.875.338-1.404.338a3.096 3.096 0 01-1.664-.468 3.322 3.322 0 01-1.196-1.313c-.286-.572-.429-1.226-.429-1.963 0-.728.143-1.374.429-1.937.295-.563.689-.997 1.183-1.3a3.185 3.185 0 011.677-.455zm2.379 3.718c0-.442-.086-.819-.26-1.131a1.775 1.775 0 00-.702-.728 1.839 1.839 0 00-.949-.26c-.338 0-.65.082-.936.247-.286.165-.52.407-.702.728-.173.312-.26.685-.26 1.118 0 .433.087.815.26 1.144.182.32.416.568.702.741.295.173.607.26.936.26.338 0 .655-.082.949-.247.295-.173.529-.416.702-.728.174-.32.26-.702.26-1.144zM117.494 23.68v-1.079h2.444V32h-1.196v-8.32h-1.248zm4.164 0v-1.079h2.444V32h-1.196v-8.32h-1.248zm5.048 8.398a.779.779 0 01-.572-.234.778.778 0 01-.234-.572c0-.225.078-.416.234-.572a.779.779 0 01.572-.234.72.72 0 01.546.234.778.778 0 01.234.572.778.778 0 01-.234.572.72.72 0 01-.546.234zm0-5.564a.779.779 0 01-.572-.234.778.778 0 01-.234-.572c0-.225.078-.416.234-.572a.779.779 0 01.572-.234.72.72 0 01.546.234.778.778 0 01.234.572.778.778 0 01-.234.572.72.72 0 01-.546.234zm2.17-1.547c.06-.797.368-1.421.923-1.872.554-.45 1.274-.676 2.158-.676.589 0 1.096.108 1.521.325.433.208.758.494.975.858.225.364.338.776.338 1.235 0 .537-.156 1.001-.468 1.391-.304.39-.702.641-1.196.754v.065c.563.139 1.009.412 1.339.819.329.407.494.94.494 1.599 0 .494-.113.94-.338 1.339-.226.39-.564.698-1.014.923-.451.225-.993.338-1.625.338-.919 0-1.673-.238-2.262-.715-.59-.485-.919-1.17-.988-2.054h1.144c.06.52.273.945.637 1.274.364.33.849.494 1.456.494.606 0 1.066-.156 1.378-.468.32-.32.481-.732.481-1.235 0-.65-.217-1.118-.65-1.404-.434-.286-1.088-.429-1.963-.429h-.299v-.988h.312c.797-.009 1.399-.139 1.807-.39.407-.26.611-.659.611-1.196 0-.46-.152-.828-.455-1.105-.295-.277-.72-.416-1.274-.416-.538 0-.971.139-1.3.416-.33.277-.525.65-.585 1.118h-1.157zm7.681 2.236c0-1.49.243-2.652.728-3.484.485-.84 1.335-1.261 2.548-1.261 1.205 0 2.05.42 2.535 1.261.485.832.728 1.993.728 3.484 0 1.517-.243 2.695-.728 3.536-.485.84-1.33 1.261-2.535 1.261-1.213 0-2.063-.42-2.548-1.261-.485-.84-.728-2.02-.728-3.536zm5.369 0c0-.754-.052-1.391-.156-1.911-.095-.529-.299-.953-.611-1.274-.303-.32-.745-.481-1.326-.481-.589 0-1.04.16-1.352.481-.303.32-.507.745-.611 1.274-.095.52-.143 1.157-.143 1.911 0 .78.048 1.434.143 1.963.104.529.308.953.611 1.274.312.32.763.481 1.352.481.581 0 1.023-.16 1.326-.481.312-.32.516-.745.611-1.274.104-.529.156-1.183.156-1.963zm2.547 1.209c0-.728.147-1.365.442-1.911a3.215 3.215 0 011.209-1.287 3.368 3.368 0 011.729-.455c.624 0 1.166.134 1.625.403.459.269.802.607 1.027 1.014v-1.3h1.196V32h-1.196v-1.326c-.234.416-.585.763-1.053 1.04-.459.269-.997.403-1.612.403a3.228 3.228 0 01-1.716-.468 3.287 3.287 0 01-1.209-1.313c-.295-.563-.442-1.205-.442-1.924zm6.032.013c0-.537-.108-1.005-.325-1.404a2.237 2.237 0 00-.884-.91 2.319 2.319 0 00-1.209-.325c-.442 0-.845.104-1.209.312a2.265 2.265 0 00-.871.91c-.217.399-.325.867-.325 1.404 0 .546.108 1.023.325 1.43.217.399.507.706.871.923.364.208.767.312 1.209.312.442 0 .845-.104 1.209-.312.373-.217.667-.524.884-.923.217-.407.325-.88.325-1.417zm11.762-3.679c.555 0 1.049.117 1.482.351a2.44 2.44 0 011.027 1.027c.252.46.377 1.018.377 1.677V32h-1.17v-4.03c0-.71-.177-1.252-.533-1.625-.346-.381-.819-.572-1.417-.572-.615 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V32h-1.17v-4.03c0-.71-.177-1.252-.533-1.625-.346-.381-.819-.572-1.417-.572-.615 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V32H153.7v-7.124h1.183v1.027c.234-.373.546-.659.936-.858.399-.2.837-.299 1.313-.299.598 0 1.127.134 1.586.403.46.269.802.663 1.027 1.183.2-.503.529-.893.988-1.17.46-.277.971-.416 1.534-.416zm9.767 1.989v1.001h-5.187v-1.001h5.187zm1.713-3.055v-1.079h2.444V32h-1.196v-8.32h-1.248zm4.333 7.371a61.363 61.363 0 002.587-2.171 10.607 10.607 0 001.573-1.781c.433-.624.65-1.235.65-1.833 0-.563-.139-1.005-.416-1.326-.269-.33-.706-.494-1.313-.494-.589 0-1.049.186-1.378.559-.321.364-.494.854-.52 1.469h-1.144c.035-.97.329-1.72.884-2.249.555-.529 1.27-.793 2.145-.793.893 0 1.599.247 2.119.741.529.494.793 1.174.793 2.041 0 .72-.217 1.421-.65 2.106a9.29 9.29 0 01-1.456 1.794 38.328 38.328 0 01-2.093 1.794h4.472v.988h-6.253v-.845zm8.193 1.027a.777.777 0 01-.572-.234.778.778 0 01-.234-.572c0-.225.078-.416.234-.572a.777.777 0 01.572-.234c.216 0 .398.078.546.234a.778.778 0 01.234.572.778.778 0 01-.234.572.723.723 0 01-.546.234zm0-5.564a.777.777 0 01-.572-.234.778.778 0 01-.234-.572c0-.225.078-.416.234-.572a.777.777 0 01.572-.234c.216 0 .398.078.546.234a.778.778 0 01.234.572.778.778 0 01-.234.572.723.723 0 01-.546.234zm2.169-1.547c.061-.797.368-1.421.923-1.872.555-.45 1.274-.676 2.158-.676.589 0 1.096.108 1.521.325.433.208.758.494.975.858.225.364.338.776.338 1.235 0 .537-.156 1.001-.468 1.391-.303.39-.702.641-1.196.754v.065c.563.139 1.01.412 1.339.819.329.407.494.94.494 1.599 0 .494-.113.94-.338 1.339-.225.39-.563.698-1.014.923-.451.225-.992.338-1.625.338-.919 0-1.673-.238-2.262-.715-.589-.485-.919-1.17-.988-2.054h1.144c.061.52.273.945.637 1.274.364.33.849.494 1.456.494s1.066-.156 1.378-.468c.321-.32.481-.732.481-1.235 0-.65-.217-1.118-.65-1.404-.433-.286-1.088-.429-1.963-.429h-.299v-.988h.312c.797-.009 1.4-.139 1.807-.39.407-.26.611-.659.611-1.196 0-.46-.152-.828-.455-1.105-.295-.277-.719-.416-1.274-.416-.537 0-.971.139-1.3.416-.329.277-.524.65-.585 1.118h-1.157zm7.681 2.236c0-1.49.243-2.652.728-3.484.486-.84 1.335-1.261 2.548-1.261 1.205 0 2.05.42 2.535 1.261.486.832.728 1.993.728 3.484 0 1.517-.242 2.695-.728 3.536-.485.84-1.33 1.261-2.535 1.261-1.213 0-2.062-.42-2.548-1.261-.485-.84-.728-2.02-.728-3.536zm5.369 0c0-.754-.052-1.391-.156-1.911-.095-.529-.299-.953-.611-1.274-.303-.32-.745-.481-1.326-.481-.589 0-1.04.16-1.352.481-.303.32-.507.745-.611 1.274-.095.52-.143 1.157-.143 1.911 0 .78.048 1.434.143 1.963.104.529.308.953.611 1.274.312.32.763.481 1.352.481.581 0 1.023-.16 1.326-.481.312-.32.516-.745.611-1.274.104-.529.156-1.183.156-1.963zm4.172-1.014c.234-.407.581-.745 1.04-1.014.468-.277 1.01-.416 1.625-.416.633 0 1.205.152 1.716.455.52.303.928.732 1.222 1.287.295.546.442 1.183.442 1.911 0 .72-.147 1.36-.442 1.924a3.248 3.248 0 01-1.222 1.313 3.228 3.228 0 01-1.716.468c-.606 0-1.144-.134-1.612-.403a3 3 0 01-1.053-1.027v4.693h-1.183V24.876h1.183v1.313zm4.836 2.223c0-.537-.108-1.005-.325-1.404a2.231 2.231 0 00-.884-.91 2.394 2.394 0 00-1.209-.312c-.433 0-.836.108-1.209.325a2.335 2.335 0 00-.884.923c-.216.399-.325.862-.325 1.391 0 .537.109 1.01.325 1.417.226.399.52.706.884.923.373.208.776.312 1.209.312.442 0 .845-.104 1.209-.312a2.32 2.32 0 00.884-.923c.217-.407.325-.884.325-1.43zm11.334-3.666c.554 0 1.048.117 1.482.351a2.45 2.45 0 011.027 1.027c.251.46.377 1.018.377 1.677V32h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.819-.572-1.417-.572-.616 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V32h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.819-.572-1.417-.572-.616 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V32h-1.183v-7.124h1.183v1.027c.234-.373.546-.659.936-.858.398-.2.836-.299 1.313-.299.598 0 1.126.134 1.586.403.459.269.801.663 1.027 1.183.199-.503.528-.893.988-1.17.459-.277.97-.416 1.534-.416z",
    fill: "#000",
    fillOpacity: 0.7
  }), /*#__PURE__*/react.createElement("rect", {
    x: 107,
    y: 63,
    width: 191,
    height: 66,
    rx: 6,
    fill: "#E0A8B9"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M117 84.91h13v-13h-13v13z",
    fill: "url(#habits_svg__pattern1)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M135.815 82.557h2.99V84h-4.81v-9.074h1.82v7.631zm10.945-5.759V84h-1.833v-.91a2.442 2.442 0 01-.923.741 2.86 2.86 0 01-1.222.26c-.563 0-1.061-.117-1.495-.351a2.62 2.62 0 01-1.027-1.053c-.242-.468-.364-1.023-.364-1.664v-4.225h1.82v3.965c0 .572.143 1.014.429 1.326.286.303.676.455 1.17.455.503 0 .897-.152 1.183-.455.286-.312.429-.754.429-1.326v-3.965h1.833zm5.787-.104c.858 0 1.552.273 2.08.819.529.537.793 1.291.793 2.262V84h-1.82v-3.978c0-.572-.143-1.01-.429-1.313-.286-.312-.676-.468-1.17-.468-.502 0-.901.156-1.196.468-.286.303-.429.741-.429 1.313V84h-1.82v-7.202h1.82v.897c.243-.312.551-.555.923-.728a2.864 2.864 0 011.248-.273zm4.136 3.705c0-.745.152-1.395.455-1.95a3.198 3.198 0 011.261-1.3c.537-.312 1.153-.468 1.846-.468.893 0 1.629.225 2.21.676.589.442.984 1.066 1.183 1.872h-1.963a1.39 1.39 0 00-.533-.728c-.243-.182-.546-.273-.91-.273-.52 0-.932.19-1.235.572-.303.373-.455.906-.455 1.599 0 .685.152 1.218.455 1.599.303.373.715.559 1.235.559.737 0 1.218-.33 1.443-.988h1.963c-.199.78-.594 1.4-1.183 1.859-.589.46-1.326.689-2.21.689-.693 0-1.309-.152-1.846-.455a3.308 3.308 0 01-1.261-1.3c-.303-.563-.455-1.218-.455-1.963zm12.344-3.705c.546 0 1.032.121 1.456.364.425.234.754.585.988 1.053.243.46.364 1.014.364 1.664V84h-1.82v-3.978c0-.572-.143-1.01-.429-1.313-.286-.312-.676-.468-1.17-.468-.502 0-.901.156-1.196.468-.286.303-.429.741-.429 1.313V84h-1.82v-9.62h1.82v3.315a2.32 2.32 0 01.936-.728c.39-.182.824-.273 1.3-.273zM117.494 91.68v-1.079h2.444V100h-1.196v-8.32h-1.248zm4.333 7.371a61.363 61.363 0 002.587-2.171 10.607 10.607 0 001.573-1.781c.433-.624.65-1.235.65-1.833 0-.563-.139-1.005-.416-1.326-.269-.33-.706-.494-1.313-.494-.589 0-1.049.186-1.378.559-.321.364-.494.854-.52 1.469h-1.144c.035-.97.329-1.72.884-2.249.555-.529 1.27-.793 2.145-.793.893 0 1.599.247 2.119.741.529.494.793 1.174.793 2.041 0 .72-.217 1.421-.65 2.106a9.29 9.29 0 01-1.456 1.794 38.328 38.328 0 01-2.093 1.794h4.472v.988h-6.253v-.845zm8.193 1.027a.777.777 0 01-.572-.234.778.778 0 01-.234-.572c0-.225.078-.416.234-.572a.777.777 0 01.572-.234c.216 0 .398.078.546.234a.778.778 0 01.234.572.778.778 0 01-.234.572.723.723 0 01-.546.234zm0-5.564a.777.777 0 01-.572-.234.778.778 0 01-.234-.572c0-.225.078-.416.234-.572a.777.777 0 01.572-.234c.216 0 .398.078.546.234a.778.778 0 01.234.572.778.778 0 01-.234.572.723.723 0 01-.546.234zm2.169-1.547c.061-.797.369-1.421.923-1.872.555-.45 1.274-.676 2.158-.676.59 0 1.097.108 1.521.325.434.208.759.494.975.858.226.364.338.776.338 1.235 0 .537-.156 1.001-.468 1.391-.303.39-.702.641-1.196.754v.065c.564.139 1.01.412 1.339.819.33.407.494.94.494 1.599 0 .494-.112.94-.338 1.339-.225.39-.563.698-1.014.923-.45.225-.992.338-1.625.338-.918 0-1.672-.238-2.262-.715-.589-.485-.918-1.17-.988-2.054h1.144c.061.52.273.945.637 1.274.364.33.85.494 1.456.494.607 0 1.066-.156 1.378-.468.321-.32.481-.732.481-1.235 0-.65-.216-1.118-.65-1.404-.433-.286-1.087-.429-1.963-.429h-.299v-.988h.312c.798-.009 1.4-.139 1.807-.39.408-.26.611-.659.611-1.196 0-.46-.151-.828-.455-1.105-.294-.277-.719-.416-1.274-.416-.537 0-.97.139-1.3.416-.329.277-.524.65-.585 1.118h-1.157zm7.681 2.236c0-1.49.243-2.652.728-3.484.486-.84 1.335-1.261 2.548-1.261 1.205 0 2.05.42 2.535 1.261.486.832.728 1.993.728 3.484 0 1.517-.242 2.695-.728 3.536-.485.84-1.33 1.261-2.535 1.261-1.213 0-2.062-.42-2.548-1.261-.485-.84-.728-2.02-.728-3.536zm5.369 0c0-.754-.052-1.391-.156-1.911-.095-.529-.299-.953-.611-1.274-.303-.32-.745-.481-1.326-.481-.589 0-1.04.16-1.352.481-.303.32-.507.745-.611 1.274-.095.52-.143 1.157-.143 1.911 0 .78.048 1.434.143 1.963.104.529.308.953.611 1.274.312.32.763.481 1.352.481.581 0 1.023-.16 1.326-.481.312-.32.516-.745.611-1.274.104-.529.156-1.183.156-1.963zm7.93-.468v1.001h-5.187v-1.001h5.187zm1.713-3.055v-1.079h2.444V100h-1.196v-8.32h-1.248zm5.048 8.398a.777.777 0 01-.572-.234.778.778 0 01-.234-.572c0-.225.078-.416.234-.572a.777.777 0 01.572-.234c.216 0 .398.078.546.234a.778.778 0 01.234.572.778.778 0 01-.234.572.723.723 0 01-.546.234zm0-5.564a.777.777 0 01-.572-.234.778.778 0 01-.234-.572c0-.225.078-.416.234-.572a.777.777 0 01.572-.234c.216 0 .398.078.546.234a.778.778 0 01.234.572.778.778 0 01-.234.572.723.723 0 01-.546.234zm2.169-1.547c.061-.797.369-1.421.923-1.872.555-.45 1.274-.676 2.158-.676.59 0 1.097.108 1.521.325.434.208.759.494.975.858.226.364.338.776.338 1.235 0 .537-.156 1.001-.468 1.391-.303.39-.702.641-1.196.754v.065c.564.139 1.01.412 1.339.819.33.407.494.94.494 1.599 0 .494-.112.94-.338 1.339-.225.39-.563.698-1.014.923-.45.225-.992.338-1.625.338-.918 0-1.672-.238-2.262-.715-.589-.485-.918-1.17-.988-2.054h1.144c.061.52.273.945.637 1.274.364.33.85.494 1.456.494.607 0 1.066-.156 1.378-.468.321-.32.481-.732.481-1.235 0-.65-.216-1.118-.65-1.404-.433-.286-1.087-.429-1.963-.429h-.299v-.988h.312c.798-.009 1.4-.139 1.807-.39.408-.26.611-.659.611-1.196 0-.46-.151-.828-.455-1.105-.294-.277-.719-.416-1.274-.416-.537 0-.97.139-1.3.416-.329.277-.524.65-.585 1.118h-1.157zm7.682 2.236c0-1.49.242-2.652.728-3.484.485-.84 1.334-1.261 2.548-1.261 1.204 0 2.049.42 2.535 1.261.485.832.728 1.993.728 3.484 0 1.517-.243 2.695-.728 3.536-.486.84-1.331 1.261-2.535 1.261-1.214 0-2.063-.42-2.548-1.261-.486-.84-.728-2.02-.728-3.536zm5.369 0c0-.754-.052-1.391-.156-1.911-.096-.529-.299-.953-.611-1.274-.304-.32-.746-.481-1.326-.481-.59 0-1.04.16-1.352.481-.304.32-.507.745-.611 1.274-.096.52-.143 1.157-.143 1.911 0 .78.047 1.434.143 1.963.104.529.307.953.611 1.274.312.32.762.481 1.352.481.58 0 1.022-.16 1.326-.481.312-.32.515-.745.611-1.274.104-.529.156-1.183.156-1.963zm4.172-1.014c.234-.407.58-.745 1.04-1.014.468-.277 1.009-.416 1.625-.416.632 0 1.204.152 1.716.455.52.303.927.732 1.222 1.287.294.546.442 1.183.442 1.911 0 .72-.148 1.36-.442 1.924a3.255 3.255 0 01-2.938 1.781c-.607 0-1.144-.134-1.612-.403-.46-.277-.811-.62-1.053-1.027v4.693h-1.183V92.876h1.183v1.313zm4.836 2.223c0-.537-.109-1.005-.325-1.404a2.243 2.243 0 00-.884-.91 2.394 2.394 0 00-1.209-.312 2.36 2.36 0 00-1.209.325 2.328 2.328 0 00-.884.923c-.217.399-.325.862-.325 1.391 0 .537.108 1.01.325 1.417.225.399.52.706.884.923.372.208.775.312 1.209.312.442 0 .845-.104 1.209-.312.372-.217.667-.524.884-.923.216-.407.325-.884.325-1.43zm11.333-3.666c.555 0 1.049.117 1.482.351.433.225.776.568 1.027 1.027.251.46.377 1.018.377 1.677V100h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.819-.572-1.417-.572-.615 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V100h-1.17v-4.03c0-.71-.178-1.252-.533-1.625-.347-.381-.819-.572-1.417-.572-.615 0-1.105.2-1.469.598-.364.39-.546.958-.546 1.703V100h-1.183v-7.124h1.183v1.027c.234-.373.546-.659.936-.858.399-.2.836-.299 1.313-.299.598 0 1.127.134 1.586.403a2.46 2.46 0 011.027 1.183c.199-.503.529-.893.988-1.17a2.91 2.91 0 011.534-.416z",
    fill: "#000",
    fillOpacity: 0.7
  })))), habits_defs || (habits_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("pattern", {
    id: "habits_svg__pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#habits_svg__image0_1066_427",
    transform: "scale(.01563)"
  })), /*#__PURE__*/react.createElement("pattern", {
    id: "habits_svg__pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#habits_svg__image0_1066_427",
    transform: "scale(.01563)"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "habits_svg__clip0_1066_427"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h286v122H0z"
  })), /*#__PURE__*/react.createElement("filter", {
    id: "habits_svg__filter0_d_1066_427",
    x: 77,
    y: -17,
    width: 225,
    height: 158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/react.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1066_427"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1066_427",
    result: "shape"
  })), /*#__PURE__*/react.createElement("image", {
    id: "habits_svg__image0_1066_427",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
/* harmony default export */ var habits = (SvgHabits);
;// CONCATENATED MODULE: ./src/img/hash.svg
var hash_path;
function hash_extends() { hash_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hash_extends.apply(this, arguments); }

function SvgHash(props) {
  return /*#__PURE__*/react.createElement("svg", hash_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "hash_svg__feather hash_svg__feather-hash"
  }, props), hash_path || (hash_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 9h16M4 15h16M10 3L8 21M16 3l-2 18"
  })));
}
/* harmony default export */ var hash = (SvgHash);
;// CONCATENATED MODULE: ./src/img/hourglass.svg
var hourglass_path, hourglass_path2, _path3;
function hourglass_extends() { hourglass_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hourglass_extends.apply(this, arguments); }

function SvgHourglass(props) {
  return /*#__PURE__*/react.createElement("svg", hourglass_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), hourglass_path || (hourglass_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 0h24v24H0z",
    stroke: "none"
  })), hourglass_path2 || (hourglass_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M6.5 7h11M6.5 17h11M6 20v-2a6 6 0 1112 0v2a1 1 0 01-1 1H7a1 1 0 01-1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M6 4v2a6 6 0 1012 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1z"
  })));
}
/* harmony default export */ var hourglass = (SvgHourglass);
;// CONCATENATED MODULE: ./src/img/hours.svg
var hours_path, hours_path2, hours_path3, _path4, _path5, _path6, hours_g, _path7, _path8, _g2, _path9, hours_defs;
function hours_extends() { hours_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hours_extends.apply(this, arguments); }

function SvgHours(props) {
  return /*#__PURE__*/react.createElement("svg", hours_extends({
    viewBox: "0 0 286 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#hours_svg__clip0_1066_245)"
  }, hours_path || (hours_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h286v257H0z"
  })), hours_path2 || (hours_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M8.5 0v257M0 8.5h286M0 112.5h286M0 77.5h286M0 43.5h286"
  })), hours_path3 || (hours_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M11 0h132v76H17a6 6 0 01-6-6V0z",
    fill: "#7384D4"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M33.74 11.965L31.062 21h-1.677l-1.898-6.838L25.472 21l-1.664.013-2.561-9.048h1.573l1.872 7.358 2.028-7.358h1.664l1.885 7.319 1.885-7.319h1.586zm4.33 9.152a3.71 3.71 0 01-1.834-.455 3.373 3.373 0 01-1.287-1.3c-.312-.563-.468-1.213-.468-1.95 0-.728.16-1.374.481-1.937.321-.563.759-.997 1.313-1.3a3.81 3.81 0 011.86-.455 3.81 3.81 0 011.858.455c.555.303.993.737 1.313 1.3.321.563.481 1.209.481 1.937s-.164 1.374-.494 1.937a3.454 3.454 0 01-1.352 1.313 3.885 3.885 0 01-1.872.455zm0-1.287c.38 0 .736-.091 1.065-.273.338-.182.611-.455.82-.819.207-.364.311-.806.311-1.326s-.1-.958-.299-1.313a2.01 2.01 0 00-.793-.819 2.169 2.169 0 00-1.066-.273c-.381 0-.736.091-1.066.273-.32.182-.576.455-.767.819-.19.355-.286.793-.286 1.313 0 .771.195 1.37.585 1.794.399.416.897.624 1.495.624zm6.664-4.953c.217-.364.503-.646.858-.845.364-.208.793-.312 1.287-.312v1.534h-.377c-.58 0-1.022.147-1.326.442-.294.295-.442.806-.442 1.534V21h-1.482v-7.163h1.482v1.04zm6.342 2.548L54.378 21h-2.002l-2.652-3.081V21h-1.482v-9.62h1.482v5.59l2.6-3.133h2.054l-3.302 3.588zm11.446-3.705c.546 0 1.031.117 1.456.351.433.234.771.58 1.014 1.04.251.46.377 1.014.377 1.664V21h-1.47v-4.004c0-.641-.16-1.131-.48-1.469-.32-.347-.758-.52-1.313-.52-.555 0-.997.173-1.326.52-.32.338-.481.828-.481 1.469V21h-1.482v-9.62h1.482v3.289c.251-.303.568-.537.949-.702.39-.165.815-.247 1.274-.247zm7.844 7.397a3.71 3.71 0 01-1.833-.455 3.373 3.373 0 01-1.287-1.3c-.312-.563-.468-1.213-.468-1.95 0-.728.16-1.374.481-1.937.32-.563.758-.997 1.313-1.3a3.81 3.81 0 011.86-.455 3.81 3.81 0 011.858.455c.555.303.992.737 1.313 1.3.32.563.481 1.209.481 1.937s-.165 1.374-.494 1.937a3.455 3.455 0 01-1.352 1.313 3.885 3.885 0 01-1.872.455zm0-1.287c.382 0 .737-.091 1.066-.273.338-.182.611-.455.82-.819.207-.364.311-.806.311-1.326s-.1-.958-.299-1.313a2.01 2.01 0 00-.793-.819 2.169 2.169 0 00-1.066-.273c-.381 0-.737.091-1.066.273-.32.182-.576.455-.767.819-.19.355-.286.793-.286 1.313 0 .771.195 1.37.585 1.794.399.416.897.624 1.495.624zm11.67-5.993V21h-1.482v-.845a2.445 2.445 0 01-.923.702 2.925 2.925 0 01-1.196.247c-.563 0-1.07-.117-1.52-.351a2.587 2.587 0 01-1.054-1.04c-.251-.46-.377-1.014-.377-1.664v-4.212h1.47v3.991c0 .641.16 1.135.48 1.482.32.338.759.507 1.313.507.555 0 .993-.169 1.313-.507.33-.347.494-.84.494-1.482v-3.991h1.482zm3.438 1.04c.216-.364.502-.646.858-.845.364-.208.793-.312 1.287-.312v1.534h-.377c-.581 0-1.023.147-1.326.442-.295.295-.442.806-.442 1.534V21h-1.482v-7.163h1.482v1.04zm6.107 6.24c-.564 0-1.07-.1-1.521-.299a2.747 2.747 0 01-1.053-.832 2.105 2.105 0 01-.416-1.183h1.534c.026.303.169.559.429.767.269.2.602.299 1 .299.417 0 .737-.078.963-.234.234-.165.35-.373.35-.624 0-.269-.13-.468-.39-.598-.25-.13-.654-.273-1.208-.429-.538-.147-.975-.29-1.313-.429a2.357 2.357 0 01-.884-.637c-.243-.286-.364-.663-.364-1.131 0-.381.112-.728.338-1.04.225-.32.546-.572.962-.754.425-.182.91-.273 1.456-.273.814 0 1.469.208 1.963.624.502.407.771.966.806 1.677H92.75a1.056 1.056 0 00-.39-.767c-.234-.19-.55-.286-.95-.286-.39 0-.688.074-.896.221a.684.684 0 00-.312.585c0 .19.07.351.208.481.138.13.308.234.507.312.2.07.494.16.884.273.52.139.944.282 1.274.429.338.139.628.347.87.624.243.277.37.646.378 1.105 0 .407-.113.771-.338 1.092-.226.32-.546.572-.962.754-.407.182-.889.273-1.443.273z",
    fill: "#000",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M11 85a6 6 0 016-6h126v43H11V85z",
    fill: "#E17958"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M31.491 90.965V100h-1.482v-6.188L27.253 100h-1.027l-2.769-6.188V100h-1.482v-9.035h1.599l3.172 7.085 3.159-7.085h1.586zm8.513 5.278c0 .269-.017.511-.052.728h-5.473c.043.572.255 1.031.637 1.378.381.347.85.52 1.404.52.797 0 1.36-.334 1.69-1.001h1.599a3.248 3.248 0 01-1.183 1.625c-.563.416-1.265.624-2.106.624-.685 0-1.3-.152-1.846-.455a3.4 3.4 0 01-1.274-1.3c-.303-.563-.455-1.213-.455-1.95 0-.737.147-1.382.442-1.937a3.197 3.197 0 011.26-1.3c.547-.303 1.17-.455 1.873-.455.676 0 1.278.147 1.807.442.529.295.94.71 1.235 1.248.294.529.442 1.14.442 1.833zm-1.547-.468c-.009-.546-.204-.984-.585-1.313-.382-.33-.854-.494-1.417-.494-.511 0-.95.165-1.313.494-.364.32-.58.758-.65 1.313h3.965zm9.57.468c0 .269-.017.511-.052.728h-5.473c.044.572.256 1.031.637 1.378.382.347.85.52 1.404.52.798 0 1.361-.334 1.69-1.001h1.6a3.248 3.248 0 01-1.184 1.625c-.563.416-1.265.624-2.106.624-.684 0-1.3-.152-1.846-.455a3.4 3.4 0 01-1.274-1.3c-.303-.563-.455-1.213-.455-1.95 0-.737.148-1.382.442-1.937a3.198 3.198 0 011.261-1.3c.546-.303 1.17-.455 1.872-.455.676 0 1.279.147 1.807.442.529.295.94.71 1.235 1.248.295.529.442 1.14.442 1.833zm-1.547-.468c-.008-.546-.203-.984-.585-1.313-.381-.33-.853-.494-1.417-.494a1.89 1.89 0 00-1.313.494c-.364.32-.58.758-.65 1.313h3.965zm4.735-1.729v3.965c0 .269.06.464.182.585.13.113.346.169.65.169h.91V100h-1.17c-.668 0-1.179-.156-1.534-.468-.356-.312-.533-.819-.533-1.521v-3.965h-.845v-1.209h.845v-1.781h1.495v1.781h1.742v1.209h-1.742zm3.862-2.158a.918.918 0 01-.676-.273.918.918 0 01-.273-.676c0-.269.09-.494.273-.676a.918.918 0 01.676-.273c.26 0 .48.091.663.273a.918.918 0 01.273.676.918.918 0 01-.273.676.903.903 0 01-.663.273zm.728.949V100h-1.482v-7.163h1.482zm5.56-.117c.563 0 1.065.117 1.507.351.451.234.802.58 1.053 1.04.252.46.377 1.014.377 1.664V100h-1.469v-4.004c0-.641-.16-1.131-.48-1.469-.321-.347-.759-.52-1.314-.52-.554 0-.996.173-1.326.52-.32.338-.48.828-.48 1.469V100H57.75v-7.163h1.482v.819c.243-.295.55-.524.923-.689a3.017 3.017 0 011.21-.247zm7.714 0c.554 0 1.044.113 1.469.338.433.217.771.49 1.014.819v-1.04h1.495v7.28c0 .659-.139 1.244-.416 1.755-.278.52-.68.927-1.21 1.222-.52.295-1.143.442-1.871.442-.97 0-1.777-.23-2.418-.689a2.498 2.498 0 01-1.092-1.846h1.469c.112.373.35.672.715.897.372.234.814.351 1.326.351.598 0 1.079-.182 1.443-.546.372-.364.559-.893.559-1.586v-1.196a3.07 3.07 0 01-1.027.858c-.425.225-.91.338-1.456.338a3.273 3.273 0 01-1.716-.468 3.473 3.473 0 01-1.222-1.326c-.295-.572-.442-1.218-.442-1.937 0-.72.147-1.356.442-1.911a3.3 3.3 0 012.938-1.755zm2.483 3.692c0-.494-.104-.923-.312-1.287a2.1 2.1 0 00-.793-.832 2.092 2.092 0 00-1.066-.286c-.382 0-.737.095-1.066.286-.33.182-.598.455-.806.819-.2.355-.3.78-.3 1.274s.1.927.3 1.3c.208.373.476.659.806.858a2.138 2.138 0 002.132 0 2.1 2.1 0 00.793-.832c.208-.373.312-.806.312-1.3zm10.523-3.692c.546 0 1.032.117 1.456.351.434.234.772.58 1.014 1.04.252.46.377 1.014.377 1.664V100h-1.469v-4.004c0-.641-.16-1.131-.48-1.469-.321-.347-.76-.52-1.314-.52s-.996.173-1.326.52c-.32.338-.48.828-.48 1.469V100H78.38v-9.62h1.482v3.289c.252-.303.568-.537.95-.702.39-.165.814-.247 1.273-.247zm7.845 7.397a3.71 3.71 0 01-1.833-.455 3.373 3.373 0 01-1.287-1.3c-.312-.563-.468-1.213-.468-1.95 0-.728.16-1.374.48-1.937.321-.563.759-.997 1.314-1.3a3.81 3.81 0 011.859-.455 3.81 3.81 0 011.859.455c.554.303.992.737 1.313 1.3.32.563.48 1.209.48 1.937s-.164 1.374-.493 1.937a3.455 3.455 0 01-1.352 1.313 3.885 3.885 0 01-1.872.455zm0-1.287c.381 0 .736-.091 1.066-.273.338-.182.61-.455.819-.819.208-.364.312-.806.312-1.326s-.1-.958-.3-1.313a2.01 2.01 0 00-.792-.819 2.169 2.169 0 00-1.066-.273c-.382 0-.737.091-1.066.273-.321.182-.577.455-.767.819-.191.355-.286.793-.286 1.313 0 .771.195 1.37.585 1.794.398.416.897.624 1.495.624zm11.67-5.993V100h-1.482v-.845a2.449 2.449 0 01-.923.702 2.92 2.92 0 01-1.196.247c-.564 0-1.07-.117-1.521-.351a2.587 2.587 0 01-1.053-1.04c-.252-.46-.377-1.014-.377-1.664v-4.212h1.469v3.991c0 .641.16 1.135.48 1.482.321.338.759.507 1.314.507.554 0 .992-.169 1.313-.507.329-.347.494-.84.494-1.482v-3.991h1.482zm3.437 1.04c.217-.364.503-.646.858-.845.364-.208.793-.312 1.287-.312v1.534h-.377c-.581 0-1.023.147-1.326.442-.295.295-.442.806-.442 1.534V100h-1.482v-7.163h1.482v1.04zm6.107 6.24c-.563 0-1.07-.1-1.521-.299a2.747 2.747 0 01-1.053-.832 2.11 2.11 0 01-.416-1.183h1.534c.026.303.169.559.429.767.269.2.603.299 1.001.299.416 0 .737-.078.962-.234.234-.165.351-.373.351-.624 0-.269-.13-.468-.39-.598-.251-.13-.654-.273-1.209-.429a11.74 11.74 0 01-1.313-.429 2.362 2.362 0 01-.884-.637c-.242-.286-.364-.663-.364-1.131 0-.381.113-.728.338-1.04.226-.32.546-.572.962-.754.425-.182.91-.273 1.456-.273.815 0 1.469.208 1.963.624.503.407.772.966.806 1.677h-1.482a1.056 1.056 0 00-.39-.767c-.234-.19-.55-.286-.949-.286-.39 0-.689.074-.897.221a.684.684 0 00-.312.585c0 .19.07.351.208.481.139.13.308.234.507.312.2.07.494.16.884.273.52.139.945.282 1.274.429.338.139.629.347.871.624.243.277.369.646.377 1.105 0 .407-.112.771-.338 1.092-.225.32-.546.572-.962.754-.407.182-.888.273-1.443.273z",
    fill: "#000",
    fillOpacity: 0.7
  })), hours_g || (hours_g = /*#__PURE__*/react.createElement("g", {
    filter: "url(#hours_svg__filter0_d_1066_245)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M143 0h143v257H143z"
  }))), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.05,
    d: "M151.5 0v257M143 8.5h143M143 112.5h143M143 77.5h143M143 43.5h143"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "hours_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 0,
    width: 134,
    height: 122
  }, _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M152 0h134v122H152z"
  }))), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#hours_svg__a)",
    stroke: "#EAEBEF",
    strokeWidth: 2
  }, /*#__PURE__*/react.createElement("path", {
    d: "M331.707-113.293l-192 192M331.707-118.293l-192 192M331.707-123.293l-192 192M331.707-128.293l-192 192M331.707-133.293l-192 192M331.707-138.293l-192 192M331.707-143.293l-192 192M331.707-148.293l-192 192M331.707-153.293l-192 192M331.707-158.293l-192 192M331.707-163.293l-192 192M331.707-168.293l-192 192M331.707-173.293l-192 192M331.707-178.293l-192 192M331.707-183.293l-192 192M331.707-108.293l-192 192M331.707-103.293l-192 192M331.707-98.293l-192 192M331.707-93.293l-192 192M331.707-88.293l-192 192M331.707-83.293l-192 192M331.707-78.293l-192 192M331.707-73.293l-192 192M331.707-68.293l-192 192M331.707-63.293l-192 192M331.707-58.293l-192 192M331.707-53.293l-192 192M331.707-48.293l-192 192M331.707-43.293l-192 192M331.707-38.293l-192 192M331.707-33.293l-192 192M331.707-28.293l-192 192M331.707-23.293l-192 192M331.707-18.293l-192 192M331.707-13.293l-192 192M331.707-8.293l-192 192M331.707-3.293l-192 192M331.707 1.707l-192 192M331.707 6.707l-192 192M331.707 11.707l-192 192M331.707 16.707l-192 192M331.707 21.707l-192 192M331.707 26.707l-192 192M331.707 31.707l-192 192M331.707 36.707l-192 192M331.707 41.707l-192 192M331.707 46.707l-192 192M331.707 51.707l-192 192M331.707 56.707l-192 192M331.707 61.707l-192 192M331.707 66.707l-192 192M331.707 71.707l-192 192M331.707 76.707l-192 192M331.707 81.707l-192 192"
  }))), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M171.293 14.656c0 .46-.108.893-.325 1.3-.217.407-.563.741-1.04 1.001-.477.251-1.088.377-1.833.377h-1.638V21h-1.482v-9.035h3.12c.693 0 1.278.121 1.755.364.485.234.845.555 1.079.962.243.407.364.862.364 1.365zm-3.198 1.469c.563 0 .984-.126 1.261-.377.277-.26.416-.624.416-1.092 0-.988-.559-1.482-1.677-1.482h-1.638v2.951h1.638zm11.176 1.118c0 .269-.017.511-.052.728h-5.473c.044.572.256 1.031.637 1.378.382.347.85.52 1.404.52.798 0 1.361-.334 1.69-1.001h1.599a3.244 3.244 0 01-1.183 1.625c-.563.416-1.265.624-2.106.624-.684 0-1.3-.152-1.846-.455a3.403 3.403 0 01-1.274-1.3c-.303-.563-.455-1.213-.455-1.95 0-.737.148-1.382.442-1.937a3.204 3.204 0 011.261-1.3c.546-.303 1.17-.455 1.872-.455.676 0 1.279.147 1.807.442.529.295.941.71 1.235 1.248.295.529.442 1.14.442 1.833zm-1.547-.468c-.008-.546-.203-.984-.585-1.313-.381-.33-.853-.494-1.417-.494a1.89 1.89 0 00-1.313.494c-.364.32-.58.758-.65 1.313h3.965zm4.488-1.898c.217-.364.503-.646.858-.845.364-.208.793-.312 1.287-.312v1.534h-.377c-.581 0-1.023.147-1.326.442-.295.295-.442.806-.442 1.534V21h-1.482v-7.163h1.482v1.04zm6.107 6.24c-.563 0-1.07-.1-1.521-.299a2.747 2.747 0 01-1.053-.832 2.102 2.102 0 01-.416-1.183h1.534c.026.303.169.559.429.767.269.2.602.299 1.001.299.416 0 .737-.078.962-.234.234-.165.351-.373.351-.624 0-.269-.13-.468-.39-.598-.251-.13-.654-.273-1.209-.429a11.74 11.74 0 01-1.313-.429 2.355 2.355 0 01-.884-.637c-.243-.286-.364-.663-.364-1.131 0-.381.113-.728.338-1.04.225-.32.546-.572.962-.754.425-.182.91-.273 1.456-.273.815 0 1.469.208 1.963.624.503.407.771.966.806 1.677h-1.482a1.056 1.056 0 00-.39-.767c-.234-.19-.55-.286-.949-.286-.39 0-.689.074-.897.221a.684.684 0 00-.312.585c0 .19.069.351.208.481.139.13.308.234.507.312.199.07.494.16.884.273.52.139.945.282 1.274.429.338.139.628.347.871.624s.368.646.377 1.105c0 .407-.113.771-.338 1.092-.225.32-.546.572-.962.754-.407.182-.888.273-1.443.273zm7.451 0a3.71 3.71 0 01-1.833-.455 3.373 3.373 0 01-1.287-1.3c-.312-.563-.468-1.213-.468-1.95 0-.728.161-1.374.481-1.937a3.329 3.329 0 011.313-1.3 3.813 3.813 0 011.859-.455c.685 0 1.305.152 1.859.455.555.303.993.737 1.313 1.3.321.563.481 1.209.481 1.937s-.164 1.374-.494 1.937a3.452 3.452 0 01-1.352 1.313 3.883 3.883 0 01-1.872.455zm0-1.287c.382 0 .737-.091 1.066-.273.338-.182.611-.455.819-.819.208-.364.312-.806.312-1.326s-.099-.958-.299-1.313a2.003 2.003 0 00-.793-.819 2.166 2.166 0 00-1.066-.273c-.381 0-.736.091-1.066.273a1.96 1.96 0 00-.767.819c-.19.355-.286.793-.286 1.313 0 .771.195 1.37.585 1.794.399.416.897.624 1.495.624zm8.798-6.11c.563 0 1.066.117 1.508.351.45.234.801.58 1.053 1.04.251.46.377 1.014.377 1.664V21h-1.469v-4.004c0-.641-.161-1.131-.481-1.469-.321-.347-.759-.52-1.313-.52-.555 0-.997.173-1.326.52-.321.338-.481.828-.481 1.469V21h-1.482v-7.163h1.482v.819c.242-.295.55-.524.923-.689a3.014 3.014 0 011.209-.247zm4.334 3.666c0-.72.147-1.356.442-1.911a3.3 3.3 0 012.938-1.755c.563 0 1.053.113 1.469.338.425.217.763.49 1.014.819v-1.04h1.495V21h-1.495v-1.066c-.251.338-.594.62-1.027.845-.433.225-.927.338-1.482.338a3.182 3.182 0 01-1.69-.468 3.474 3.474 0 01-1.222-1.326c-.295-.572-.442-1.218-.442-1.937zm5.863.026c0-.494-.104-.923-.312-1.287a2.1 2.1 0 00-.793-.832 2.091 2.091 0 00-1.066-.286c-.381 0-.737.095-1.066.286a2.096 2.096 0 00-.806.819c-.199.355-.299.78-.299 1.274s.1.927.299 1.3c.208.373.477.659.806.858a2.137 2.137 0 002.132 0 2.1 2.1 0 00.793-.832c.208-.373.312-.806.312-1.3zm4.923-6.032V21h-1.482v-9.62h1.482zm9.028 2.34c.546 0 1.031.117 1.456.351.433.234.771.58 1.014 1.04.251.46.377 1.014.377 1.664V21h-1.469v-4.004c0-.641-.16-1.131-.481-1.469-.321-.347-.758-.52-1.313-.52-.555 0-.997.173-1.326.52-.321.338-.481.828-.481 1.469V21h-1.482v-9.62h1.482v3.289c.251-.303.568-.537.949-.702.39-.165.815-.247 1.274-.247zm7.845 7.397a3.71 3.71 0 01-1.833-.455 3.373 3.373 0 01-1.287-1.3c-.312-.563-.468-1.213-.468-1.95 0-.728.16-1.374.481-1.937.32-.563.758-.997 1.313-1.3a3.808 3.808 0 011.859-.455c.684 0 1.304.152 1.859.455.554.303.992.737 1.313 1.3.32.563.481 1.209.481 1.937s-.165 1.374-.494 1.937a3.46 3.46 0 01-1.352 1.313 3.889 3.889 0 01-1.872.455zm0-1.287c.381 0 .736-.091 1.066-.273.338-.182.611-.455.819-.819.208-.364.312-.806.312-1.326s-.1-.958-.299-1.313a2.015 2.015 0 00-.793-.819 2.171 2.171 0 00-1.066-.273c-.382 0-.737.091-1.066.273a1.947 1.947 0 00-.767.819c-.191.355-.286.793-.286 1.313 0 .771.195 1.37.585 1.794.398.416.897.624 1.495.624zm11.67-5.993V21h-1.482v-.845a2.448 2.448 0 01-.923.702 2.929 2.929 0 01-1.196.247 3.247 3.247 0 01-1.521-.351 2.587 2.587 0 01-1.053-1.04c-.252-.46-.377-1.014-.377-1.664v-4.212h1.469v3.991c0 .641.16 1.135.481 1.482.32.338.758.507 1.313.507.554 0 .992-.169 1.313-.507.329-.347.494-.84.494-1.482v-3.991h1.482zm3.437 1.04c.217-.364.503-.646.858-.845.364-.208.793-.312 1.287-.312v1.534h-.377c-.581 0-1.023.147-1.326.442-.295.295-.442.806-.442 1.534V21h-1.482v-7.163h1.482v1.04zm6.107 6.24c-.563 0-1.07-.1-1.521-.299a2.747 2.747 0 01-1.053-.832 2.11 2.11 0 01-.416-1.183h1.534c.026.303.169.559.429.767.269.2.603.299 1.001.299.416 0 .737-.078.962-.234.234-.165.351-.373.351-.624 0-.269-.13-.468-.39-.598-.251-.13-.654-.273-1.209-.429a11.74 11.74 0 01-1.313-.429 2.362 2.362 0 01-.884-.637c-.242-.286-.364-.663-.364-1.131 0-.381.113-.728.338-1.04.226-.32.546-.572.962-.754.425-.182.91-.273 1.456-.273.815 0 1.469.208 1.963.624.503.407.772.966.806 1.677h-1.482a1.056 1.056 0 00-.39-.767c-.234-.19-.55-.286-.949-.286-.39 0-.689.074-.897.221a.684.684 0 00-.312.585c0 .19.07.351.208.481.139.13.308.234.507.312.2.07.494.16.884.273.52.139.945.282 1.274.429.338.139.629.347.871.624.243.277.369.646.377 1.105 0 .407-.112.771-.338 1.092-.225.32-.546.572-.962.754-.407.182-.888.273-1.443.273z",
    fill: "#000",
    fillOpacity: 0.7
  }))), hours_defs || (hours_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "hours_svg__clip0_1066_245"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h286v122H0z"
  })), /*#__PURE__*/react.createElement("filter", {
    id: "hours_svg__filter0_d_1066_245",
    x: 123,
    y: -12,
    width: 167,
    height: 281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/react.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1066_245"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1066_245",
    result: "shape"
  })))));
}
/* harmony default export */ var hours = (SvgHours);
// EXTERNAL MODULE: ./src/img/puzzle-icon.svg
var puzzle_icon = __webpack_require__(73766);
// EXTERNAL MODULE: ./src/img/slack-outline.svg
var slack_outline = __webpack_require__(52976);
// EXTERNAL MODULE: ./src/img/user-add-icon.svg
var user_add_icon = __webpack_require__(40578);
// EXTERNAL MODULE: ./src/img/user-group-icon.svg
var user_group_icon = __webpack_require__(38654);
// EXTERNAL MODULE: ./src/img/users-icon.svg
var users_icon = __webpack_require__(59239);
// EXTERNAL MODULE: ./src/img/waving-hand.svg
var waving_hand = __webpack_require__(12266);
// EXTERNAL MODULE: ./src/utils/router.ts
var router = __webpack_require__(63429);
// EXTERNAL MODULE: ./src/components/quests/QuestGenericPopperContent.tsx + 1 modules
var QuestGenericPopperContent = __webpack_require__(95858);
;// CONCATENATED MODULE: ./src/components/quests/questCollections/v14.quests.tsx





























var SLACK_APP_ID = "A01B0K9E80M";
var QUESTS_CONFIG_V14 = {
    /********************/ /*  GETTING STARTED */ /********************/ GETTING_STARTED: {
        id: "GETTING_STARTED",
        title: "Get started",
        quests: [
            {
                id: "WELCOME_TO_RECLAIM",
                groupId: "GETTING_STARTED",
                subType: "SYNCS",
                title: "Welcome to Reclaim",
                description: "Watch a 2-minute video to learn how Reclaim works.",
                shortDescription: "A quick video on core concepts",
                duration: "2min",
                icon: waving_hand/* default */.Z,
                steps: [
                    {
                        id: "WATCH_WELCOME_VIDEO",
                        type: "video",
                        videoLink: "Wy9dI7Nm180"
                    }
                ]
            },
            {
                id: "SET_AVAILABILITY",
                groupId: "GETTING_STARTED",
                subType: "SYNCS",
                title: "Set your availability",
                description: "Tell Reclaim which calendars to use to check your availability.",
                shortDescription: "Set availability from other calendars",
                duration: "4min",
                entryPathname: "/settings/accounts",
                indeterminant: true,
                icon: CalendarTodayOutlined/* default */.Z,
                steps: [
                    {
                        id: "ADD_AVAILABILITY_CALENDARS",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "Edit" to select which calendars you want Reclaim to check for your availability.',
                            svg: connected_calendars
                        }
                    },
                    {
                        id: "SELECT_A_CALENDAR",
                        type: "orb",
                        popoverConfig: {
                            description: "Select which calendar to connect below."
                        }
                    },
                    {
                        id: "SAVE_CONNECTED_CALENDAR",
                        type: "action",
                        popoverConfig: {
                            description: "Save to connect the calendar."
                        }
                    }, 
                ]
            },
            {
                id: "SYNC_CALENDAR",
                groupId: "GETTING_STARTED",
                subType: "SYNCS",
                title: "Sync your calendars",
                description: "Automatically sync & copy events across calendars to prevent overbookings.",
                shortDescription: "Sync events across calendars",
                duration: "4min",
                entryPathname: "/sync",
                indeterminant: true,
                icon: Cached/* default */.Z,
                steps: [
                    {
                        id: "CLICK_CREATE_NEW_SYNC",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "New Sync" to create a Calendar Sync policy.',
                            svg: calendar_sync
                        }
                    },
                    {
                        id: "CLICK_NEXT_PREFERENCES",
                        type: "action",
                        popoverConfig: {
                            description: "Set your preferences for how events get synced & copied to the destination calendar, including privacy options & colors."
                        }
                    },
                    {
                        id: "SYNC_PRIVACY",
                        type: "orb",
                        popoverConfig: {
                            description: "Set the events that Reclaim should sync, how they should appear, & more."
                        }
                    },
                    {
                        id: "CLICK_SYNC_CREATION",
                        type: "action",
                        popoverConfig: {
                            description: "Time to sync your events."
                        }
                    }, 
                ]
            },
            {
                id: "SET_SCHEDULING_HOURS",
                groupId: "GETTING_STARTED",
                subType: "HOURS",
                title: "Set your scheduling hours",
                description: "Set your preferred personal, working & meeting hours.",
                shortDescription: "Schedule around your hours",
                duration: "2min",
                entryPathname: "/settings/hours?policy=WORK",
                indeterminant: true,
                icon: hourglass,
                steps: [
                    {
                        id: "MEETING_HOURS",
                        component: QuestGenericPopperContent/* QuestGenericPopperContent */.F,
                        type: "orb",
                        popoverConfig: {
                            description: "Update the hours you're available for scheduling Reclaim smart events.",
                            svg: hours
                        }
                    },
                    {
                        id: "HINT_HOURS_INPUT",
                        component: QuestGenericPopperContent/* QuestGenericPopperContent */.F,
                        type: "orb",
                        popoverConfig: {
                            description: "Toggle the days of the week & update the range of hours for each day."
                        }
                    },
                    {
                        id: "HOURS_INPUT",
                        type: "action",
                        popoverConfig: {
                            description: "Begin editing your hours."
                        }
                    }, 
                ]
            },
            {
                id: "INSTALL_GCAL_ADDON",
                groupId: "GETTING_STARTED",
                title: "Install the Google Calendar Add-on",
                description: "Manage Reclaim from Google Calendar & share Scheduling Links from Gmail.",
                shortDescription: "Share scheduling links from Gmail",
                duration: "1min",
                icon: gcal_outline,
                indeterminant: true,
                steps: [
                    {
                        id: "GOTO_GOOGLE_ADDON",
                        type: "url",
                        url: "https://workspace.google.com/marketplace/app/reclaimai/950518663892"
                    }, 
                ]
            },
            {
                id: "INSTALL_SLACK_INTEGRATION",
                groupId: "GETTING_STARTED",
                title: "Install the Slack integration",
                description: "Auto-sync your Slack status to your calendar & manage Reclaim events in Slack.",
                shortDescription: "Auto-sync your Slack status",
                duration: "1min",
                icon: slack_outline/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "GOTO_SLACK_INTEGRATION_LISTING",
                        type: "url",
                        url: "https://slack.com/app_redirect?app=".concat(SLACK_APP_ID)
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*      HABITS      */ /********************/ HABITS: {
        id: "HABITS",
        title: "Set your Habits",
        quests: [
            {
                id: "HABITS_OVERVIEW",
                groupId: "HABITS",
                title: "Habits overview",
                description: "Watch a 1-minute video on how to auto-schedule time for your recurring routines.",
                shortDescription: "A quick video on core habit concepts",
                duration: "1min",
                icon: RepeatRounded/* default */.Z,
                steps: [
                    {
                        id: "WATCH_HABITS_OVERVIEW_VIDEO",
                        type: "video",
                        videoLink: "KEUG_NHtEsI"
                    }
                ]
            },
            {
                id: "CREATE_AND_CUSTOMIZE_HABITS",
                groupId: "HABITS",
                title: "Create & customize your Habits",
                description: "Set up & prioritize your Habits to keep your workweek focused & balanced.",
                shortDescription: "Add & customize your routines",
                duration: "4min",
                entryPathname: "/habits",
                indeterminant: true,
                icon: adjust_icon/* default */.Z,
                steps: [
                    {
                        id: "CREATE_NEW_HABIT",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to create a new Habit.",
                            svg: habits
                        }
                    },
                    {
                        id: "HABIT_FORM_INFORMATION",
                        type: "orb",
                        popoverConfig: {
                            description: "Set preferences for how you want the Habit to schedule, & how it will appear on your calendar."
                        }
                    },
                    {
                        id: "SAVE_HABIT",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "Save" to start automatically scheduling your Habit.'
                        }
                    }, 
                ]
            },
            {
                id: "MANAGE_HABITS",
                groupId: "HABITS",
                title: "Manage Habits on your calendar",
                description: "Learn how to adjust Habit events in your schedule.",
                shortDescription: "How to work with Habits on your schedule",
                duration: "3min",
                entryPathname: "/planner",
                icon: TodayOutlined/* default */.Z,
                steps: [
                    {
                        id: "PLANNER_HABIT_MANAGEMENT",
                        type: "orb",
                        popoverConfig: {
                            description: "Watch a quick overview on how to manage your Habit events.",
                            img: "/img/quests/habits-planner3.gif"
                        }
                    },
                    {
                        id: "VIDEO_HABIT_MANAGEMENT",
                        type: "video",
                        videoLink: "4PxE7M_eNTg"
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*  SMART MEETINGS  */ /********************/ SMART_MEETINGS: {
        id: "SMART_MEETINGS",
        title: "Set up your smart meetings",
        quests: [
            {
                id: "SCHEDULING_LINKS_OVERVIEW",
                groupId: "SMART_MEETINGS",
                subType: "SCHEDULING_LINKS",
                title: "Scheduling Links overview",
                description: "Learn how to share your availability & get the right meetings scheduled sooner with Scheduling Links.",
                shortDescription: "How to use Reclaim's scheduling links",
                duration: "2min",
                icon: LinkRounded/* default */.Z,
                steps: [
                    {
                        id: "WATCH_SCHEDULING_LINKS_VIDEO",
                        type: "video",
                        videoLink: "xty1wE0ZLyU"
                    }
                ]
            },
            {
                id: "SETUP_SCHEDULING_LINKS",
                groupId: "SMART_MEETINGS",
                title: "Set up your Scheduling Links ",
                description: "Create your Scheduling Links & share your Booking Pages.",
                shortDescription: "Allow others to book time with you",
                duration: "5min",
                entryPathname: (0,router/* getSchedulingLinksUrl */.E5)(),
                icon: DateRangeOutlined/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "CLICK_SL_ONBOARDING",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "Set it up" to begin the Scheduling Links onboarding.'
                        }
                    },
                    {
                        id: "CLICK_DONE_SL_ONBOARDING",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "Done" to complete Scheduling Links onboarding.'
                        }
                    }, 
                ]
            },
            {
                id: "SETUP_TEAM_LINKS",
                groupId: "SMART_MEETINGS",
                subType: "SCHEDULING_LINKS",
                title: "Set up your team links",
                description: "Create a team Scheduling Link with multiple team members to share your combined availability.",
                shortDescription: "Send links based on your team's availability",
                duration: "2min",
                entryPathname: (0,router/* getSchedulingLinkEditUrl */.Zm)("new"),
                icon: user_group_icon/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "SL_FORM_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Create your team Scheduling Link for multiple team members. You can assign your team link to a group, set multiple durations, add your team members, & more."
                        }
                    },
                    {
                        id: "CLICK_ADD_TEAM_MEMBERS",
                        type: "orb",
                        popoverConfig: {
                            description: "Add team members to be meeting organizers for this link."
                        }
                    },
                    {
                        id: "CLICK_CREATE_LINK",
                        type: "action",
                        popoverConfig: {
                            description: "Create your team link."
                        }
                    }, 
                ]
            },
            {
                id: "SMART_ONE_ON_ONE_OVERVIEW",
                groupId: "SMART_MEETINGS",
                subType: "SMART_11S",
                title: "Smart 1:1s overview",
                description: "Learn how Smart 1:1s automatically schedule & manage your recurring one-on-one meetings.",
                shortDescription: "Auto-schedule & reschedule your 1:1s",
                duration: "4min",
                icon: users_icon/* default */.Z,
                steps: [
                    {
                        id: "WATCH_SMART_11s_VIDEO",
                        type: "video",
                        videoLink: "b3gluXGDOPQ"
                    }
                ]
            },
            {
                id: "SETUP_FIRST_SMART_ONE_ON_ONE",
                groupId: "SMART_MEETINGS",
                subType: "SMART_11S",
                title: "Set up your first Smart 1:1",
                description: "Start converting your existing one-on-one meetings to Smart 1:1s.",
                shortDescription: "Convert existing 1:1 meetings",
                duration: "4min",
                entryPathname: "/one-on-ones",
                icon: EventAvailableOutlined/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "SMART_11_PAGE_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "You can create a new Smart 1:1, or convert your existing 1:1s that we detect into Reclaim Smart 1:1s."
                        }
                    },
                    {
                        id: "CLICK_NEW_SMART_11",
                        type: "action",
                        popoverConfig: {
                            description: "Create your Smart 1:1."
                        }
                    },
                    {
                        id: "SMART_11_FORM_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Enter the email of your invitee, set the duration & frequency of the recurring meeting, & add a location or videoconferencing link."
                        }
                    },
                    {
                        id: "CREATE_SMART_11",
                        type: "action",
                        popoverConfig: {
                            description: "Create your Smart 1:1."
                        }
                    }, 
                ]
            },
            {
                id: "MANAGE_SMART_ONE_ON_ONE",
                groupId: "SMART_MEETINGS",
                subType: "SMART_11S",
                title: "Manage Smart 1:1s on your calendar",
                description: "Learn how to manage your Smart 1:1s on your calendar during the week.",
                shortDescription: "How to manage your 1:1 meetings",
                duration: "2min",
                entryPathname: "/planner",
                icon: TodayOutlined/* default */.Z,
                steps: [
                    {
                        id: "PLANNER_MANAGE_SMART_11",
                        type: "orb",
                        popoverConfig: {
                            description: "Watch a quick video on managing your Smart 1:1s.",
                            img: "/img/quests/quests-one-on-ones.gif"
                        }
                    },
                    {
                        id: "VIDEO_MANAGE_SMART_11",
                        type: "video",
                        videoLink: "PRXsrSRuKRE"
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*      TASKS       */ /********************/ TASKS: {
        id: "TASKS",
        title: "Make time for your tasks",
        quests: [
            {
                id: "TASK_OVERVIEW",
                groupId: "TASKS",
                title: "Tasks overview",
                description: "Learn how to automatically block flexible time for your Tasks.",
                shortDescription: "Block flexible time for your to-dos",
                duration: "2min",
                icon: AssignmentTurnedInOutlined/* default */.Z,
                steps: [
                    {
                        id: "WATCH_TASKS_VIDEO",
                        type: "video",
                        videoLink: "3rZjNBbRm7g"
                    }
                ]
            },
            {
                id: "ADD_FIRST_TASK",
                groupId: "TASKS",
                title: "Create your first Task",
                description: "Create a Task to start defending time on your calendar to get stuff done.",
                shortDescription: "Start blocking time to get stuff done",
                duration: "2min",
                entryPathname: "/tasks",
                icon: TodayOutlined/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "CLICK_NEW_TASK",
                        type: "action",
                        popoverConfig: {
                            description: "Create a new Task here from anywhere in Reclaim.",
                            img: "/img/quests/tasks.png"
                        }
                    },
                    {
                        id: "TASK_FORM_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Give your Task a name, an estimated amount of time, & how you'd like to schedule (you can always add more time later)."
                        }
                    },
                    {
                        id: "SAVE_TASK",
                        type: "action",
                        popoverConfig: {
                            description: "Tap save to create & auto-schedule time for this Task in your calendar."
                        }
                    }, 
                ]
            },
            {
                id: "ADD_TASK_INTEGRATION",
                groupId: "TASKS",
                title: "Add Task integrations",
                description: "Integrate your project management app to automatically sync your Tasks.",
                shortDescription: "Auto-sync your tasks from other apps",
                duration: "4min",
                entryPathname: "/settings/integrations",
                icon: puzzle_icon/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "TASKS_INTEGRATIONS_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Integrate your project management app to automatically sync your Tasks to Reclaim & get them on the calendar (you may need to upgrade to a Pro or Team plan to integrate with some of these tools)."
                        }
                    }, 
                ]
            },
            {
                id: "MANAGE_TASKS",
                groupId: "TASKS",
                title: "Manage Tasks on your calendar",
                description: "Learn how to manage your Task events on your calendar during the week.",
                shortDescription: "How to manage your Tasks on your calendar",
                duration: "5min",
                entryPathname: "/planner",
                icon: DateRangeOutlined/* default */.Z,
                steps: [
                    {
                        id: "PLANNER_MANAGE_TASKS",
                        type: "orb",
                        popoverConfig: {
                            description: "Watch a quick video on managing your Tasks.",
                            img: "/img/quests/quests-tasks.gif"
                        }
                    },
                    {
                        id: "VIDEO_MANAGE_TASKS",
                        type: "video",
                        videoLink: "8ApgSiGKhoc"
                    }, 
                ]
            },
            {
                id: "SET_TASK_DEFAULTS",
                groupId: "TASKS",
                title: "Set your Task defaults",
                description: "Define your default settings for how Tasks are scheduled via Reclaim.",
                shortDescription: "Set defaults for how Tasks are scheduled",
                duration: "2min",
                entryPathname: "/settings/general#tasks",
                icon: cog_icon/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "TASK_DEFAULTS_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Edit your default Task duration, preferred hours, visibility to others, & auto-reopen/close settings."
                        }
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*     CUSTOMIZE    */ /********************/ CUSTOMIZE_CALENDAR: {
        id: "CUSTOMIZE_CALENDAR",
        title: "Customize your calendar",
        quests: [
            {
                id: "AUTO_SCHEDULE_BREAK_AND_TRAVEL_TIME",
                groupId: "CUSTOMIZE_CALENDAR",
                title: "Auto-schedule breaks & travel",
                description: "Make time for breaks around meetings & work sessions.",
                shortDescription: "Make time for breaks between meetings",
                duration: "2min",
                entryPathname: "/settings/general#buffer",
                indeterminant: true,
                icon: coffee/* default */.Z,
                steps: [
                    {
                        id: "TRAVEL_TIME_INFO",
                        type: "action",
                        popoverConfig: {
                            description: "Make sure you have time to travel between your events by automatically adding buffer time.",
                            img: "/img/quests/travel-time.png"
                        }
                    },
                    {
                        id: "CLICK_TRAVEL_TIME",
                        type: "action",
                        popoverConfig: {
                            description: "Toggle travel time."
                        }
                    },
                    {
                        id: "CONFERENCE_BUFFER_INFO",
                        type: "action",
                        popoverConfig: {
                            description: "Automatically schedule breaks after video calls so you have time to decompress.",
                            img: "/img/quests/buffer-time.png"
                        }
                    },
                    {
                        id: "CLICK_BUFFER",
                        type: "action",
                        popoverConfig: {
                            description: "Toggle buffer time."
                        }
                    }, 
                ]
            },
            {
                id: "SETUP_NO_MEETING_DAYS",
                groupId: "CUSTOMIZE_CALENDAR",
                title: "Set up No-Meetings Days",
                description: "Create No-Meetings Days for you & your team to prevent meetings, while still scheduling Habits, Tasks & breaks.",
                shortDescription: "Use hashtags to set no-meetings days",
                duration: "2min",
                icon: hash,
                steps: [
                    {
                        id: "VIDEO_NO_MEETING_DAYS",
                        type: "video",
                        videoLink: "MORi7KIYJkw"
                    }
                ]
            },
            {
                id: "CUSTOMIZE_EVENT_COLOR_CODING",
                groupId: "CUSTOMIZE_CALENDAR",
                title: "Customize event color-coding",
                description: "Automatically color-code your events by category to keep your schedule visually organized.",
                shortDescription: "Color-code your events by category",
                duration: "2min",
                entryPathname: "/settings/colors",
                icon: ColorLensOutlined/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "COLOR_SETTINGS_OVERVIEW",
                        type: "orb",
                        popoverConfig: {
                            description: "Reclaim-created events will use the default category colors you set up here.",
                            img: "/img/quests/colors.png"
                        }
                    },
                    {
                        id: "ENABLE_ALL_EVENTS",
                        type: "action",
                        popoverConfig: {
                            description: "We recommend allowing Reclaim to color all of your events based on these categories."
                        }
                    }, 
                ]
            },
            {
                id: "TRACK_AND_ANALYZE_PRODUCTIVITY",
                groupId: "CUSTOMIZE_CALENDAR",
                title: "Track & analyze your productivity",
                description: "Check out your calendar stats to keep tabs on your productivity & work-life balance.",
                shortDescription: "Keep tabs on your productivity & work-life balance",
                duration: "2min",
                entryPathname: "/stats",
                icon: BarChartRounded/* default */.Z,
                steps: [
                    {
                        id: "STATS_OVERVIEW",
                        type: "orb",
                        popoverConfig: {
                            description: "Use these stats to balance & budget where your time goes each week."
                        }
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*       TEAM       */ /********************/ INVITE_TEAM: {
        id: "INVITE_TEAM",
        title: "Invite your team",
        quests: [
            {
                id: "ADD_MEMBERS_TO_TEAM",
                groupId: "INVITE_TEAM",
                title: "Add members to your team",
                description: "Start building out your team to get the most out of Reclaim.",
                shortDescription: "Build your team & get the most out of Reclaim",
                duration: "3min",
                entryPathname: "/billing#team",
                icon: user_add_icon/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "CLICK_ADD_MEMBER",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to invite a team member."
                        }
                    },
                    {
                        id: "INVITE_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Enter a team member's email to send a free invite - you can add additional emails right below."
                        }
                    },
                    {
                        id: "CLICK_INVITE",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to send."
                        }
                    }, 
                ]
            },
            {
                id: "SELECT_PLAN",
                groupId: "INVITE_TEAM",
                title: "Select a plan",
                description: "Find the right Reclaim plan for your team's needs.",
                shortDescription: "Find the right plan for your needs",
                duration: "2min",
                entryPathname: "/billing",
                icon: grid,
                indeterminant: true,
                steps: [
                    {
                        id: "CLICK_PURCHASE",
                        type: "action",
                        popoverConfig: {
                            description: "Tap the purchase button to compare plans & select one for your account.",
                            img: "/img/quests/purchase.png"
                        }
                    },
                    {
                        id: "PURCHASE_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Learn more about our Starter, Business, & Enterprise plans & select what's right for you."
                        }
                    },
                    {
                        id: "CLICK_FINISH_ON_STRIPE",
                        type: "action",
                        popoverConfig: {
                            description: "Set up payment."
                        }
                    }, 
                ]
            }, 
        ]
    }
};

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/tasks/TaskUpNextIcon.tsx
var TaskUpNextIcon = __webpack_require__(31564);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/ShuffleRounded.js
"use client";



/* harmony default export */ var ShuffleRounded = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M10.59 9.17 6.12 4.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.46 4.46 1.42-1.4zm4.76-4.32 1.19 1.19L4.7 17.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L17.96 7.46l1.19 1.19c.31.31.85.09.85-.36V4.5c0-.28-.22-.5-.5-.5h-3.79c-.45 0-.67.54-.36.85zm-.52 8.56-1.41 1.41 3.13 3.13-1.2 1.2c-.31.31-.09.85.36.85h3.79c.28 0 .5-.22.5-.5v-3.79c0-.45-.54-.67-.85-.35l-1.19 1.19-3.13-3.14z"
}), 'ShuffleRounded'));
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/ImportExportRounded.js
"use client";



/* harmony default export */ var ImportExportRounded = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M8.65 3.35 5.86 6.14c-.32.31-.1.85.35.85H8V13c0 .55.45 1 1 1s1-.45 1-1V6.99h1.79c.45 0 .67-.54.35-.85L9.35 3.35c-.19-.19-.51-.19-.7 0zM16 17.01V11c0-.55-.45-1-1-1s-1 .45-1 1v6.01h-1.79c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H16z"
}), 'ImportExportRounded'));
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowOutwardRounded.js
var ArrowOutwardRounded = __webpack_require__(97090);
;// CONCATENATED MODULE: ./src/img/priority-icon.svg
var _rect, _rect2, _rect3, _rect4;
function priority_icon_extends() { priority_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return priority_icon_extends.apply(this, arguments); }

function SvgPriorityIcon(props) {
  return /*#__PURE__*/react.createElement("svg", priority_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    width: 2,
    height: 4,
    x: 2,
    y: 10,
    fill: "currentColor",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/react.createElement("rect", {
    width: 2,
    height: 6.667,
    x: 5.333,
    y: 7.333,
    fill: "currentColor",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/react.createElement("rect", {
    width: 2,
    height: 9.333,
    x: 8.667,
    y: 4.667,
    fill: "currentColor",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/react.createElement("rect", {
    width: 2,
    height: 12,
    x: 12,
    y: 2,
    fill: "currentColor",
    rx: 1
  })));
}
/* harmony default export */ var priority_icon = (SvgPriorityIcon);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/components/priority/V16PriorityIcon.tsx
var V16PriorityIcon = __webpack_require__(40647);
// EXTERNAL MODULE: ./src/components/quests/questCollections/V17.quests.module.scss
var V17_quests_module = __webpack_require__(79853);
var V17_quests_module_default = /*#__PURE__*/__webpack_require__.n(V17_quests_module);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(8080);
;// CONCATENATED MODULE: ./src/components/quests/content/habitsOverview.quest.tsx



var ref;
var habitsOverviewQuest = {
    version: 2,
    id: "HABITS_OVERVIEW_2",
    groupId: "HABITS",
    title: "Habits overview",
    description: "Learn about habits",
    shortDescription: "Learn about habits",
    duration: "5min",
    entryPathname: "/habits",
    icon: RepeatRounded/* default */.Z,
    steps: [
        {
            id: "WHAT_ARE_HABITS",
            type: "orb",
            popoverConfig: {
                gif: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {}),
                title: "What are Habits?",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Habits are smart, flexible routines for your calendar. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "You pick the things you want to get done regularly, roughly when you want them to happen, and how important they are, and Reclaim automatically finds the right spots for them on your busy schedule."
                    ]
                })
            }
        },
        {
            id: "NOT_RECURRING_EVENTS",
            type: "orb",
            popoverConfig: {
                gif: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {}),
                title: "What are Habits?",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Habits are not the same as recurring events. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "They don't always happen at the same time every day, and they're meant to have a little bit of room to wiggle as your schedule changes. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "They're intended to keep your schedule flexible, just like you!"
                    ]
                })
            }
        },
        // Start Branching based on if user has a habit or not
        {
            id: "FREE_BUSY",
            type: "orb",
            popoverConfig: {
                gif: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {}),
                title: "What are Habits?",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Just like all of Reclaim's smart calendar events, Habits automatically flip between Free and Busy to ensure that you get the time you need without completely blocking off your availability. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "As Reclaim's AI starts to see you running out of time for your routine, it'll block the time off to prevent you from getting overbooked."
                    ]
                })
            },
            getNextQuest: function(param) {
                var usage = param.usage;
                var ref1;
                return ((ref = (ref1 = usage === null || usage === void 0 ? void 0 : usage.actuals.MAX_HABITS) === null || ref1 === void 0 ? void 0 : ref1.actualValue) !== null && ref !== void 0 ? ref : 0) === 0 ? "CREATE_NEW" : "VIEW_EXISTING";
            }
        },
        {
            id: "CREATE_NEW",
            type: "action",
            popoverConfig: {
                title: "Lets Get Started",
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "let's create a new Habit or one from an existing template"
                })
            },
            getNextQuest: "FOCUS_TIME_STEP",
            allowedRoutes: /habits\/.*\/edit/
        },
        {
            id: "VIEW_EXISTING",
            type: "orb",
            popoverConfig: {
                title: "Lets Get Started",
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "To get started, let's check out a Habit you've already created"
                })
            }
        },
        {
            id: "EXISTING_REDIRECT",
            type: "redirect",
            redirect: "/habits/1/edit",
            getNextQuest: "PRIORITY"
        },
        // End Branching based on if user has a habit or not
        {
            id: "FOCUS_TIME_STEP",
            type: "orb",
            popoverConfig: {
                title: "Lets Get Started",
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: 'All great routines start with a great name. Let\'s call this one "Focus Time" just to keep things easy'
                })
            }
        },
        {
            id: "PRIORITY",
            type: "orb",
            popoverConfig: {
                title: "Habit Priorities",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Habits have a priority that you can change at any time. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Critical Habits schedule first, Low priority Habits schedule last.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " If Reclaim needs to make tradeoffs to get time for your routines, it'll prefer higher-priority Habits."
                    ]
                })
            }
        },
        {
            id: "CATEGORIZE",
            type: "orb",
            popoverConfig: {
                title: "Habit Categories",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "You can categorize your Habit as Personal or Work, which will define how it gets color-coded on your calendar and shows up in your Stats. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "You can also pick any old color you'd like for a specific Habit."
                    ]
                })
            }
        },
        {
            id: "DURATION",
            type: "orb",
            popoverConfig: {
                title: "Habit Duration",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Now to the fun part! Set the minimum amount of time you'd ever want to spend on the Habit, and the maximum amount of time you might want. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "This is the range that Reclaim will try to schedule on your calendar."
                    ]
                })
            }
        },
        {
            id: "HOURS",
            type: "orb",
            popoverConfig: {
                title: "Habit Hours",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Pick from your existing Hours, or set one-off Hours for a Habit that has specific days and times. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "For example, Lunch might only ever make sense to happen between 11am and 2pm M-F."
                    ]
                })
            }
        },
        {
            id: "FREQUENCY",
            type: "orb",
            popoverConfig: {
                title: "Habit Frequency",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Now tell Reclaim how often you want to do the Habit, and ideally what time you'd like to have it happen.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Reclaim will try to schedule as close to this ideal time as possible."
                    ]
                })
            }
        },
        {
            id: "NOTES",
            type: "orb",
            popoverConfig: {
                title: "Habit Notes",
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "Lastly, you can add some notes to the Habit -- for example, a link to a doc or a to-do list -- as well as decide how you'd like it to show up to people who view your calendar."
                })
            }
        },
        {
            id: "PRE_PLANNER",
            type: "orb",
            popoverConfig: {
                title: "Habits in the Planner",
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "Let's talk about how to manage Habits on your calendar now. "
                }),
                nextButtonLabel: "Go To Planner"
            }
        },
        {
            id: "GO_TO_PLANNER",
            type: "redirect",
            redirect: "/planner"
        },
        {
            id: "NOT_LIKE_THE_OTHER_GUYS",
            type: "orb",
            popoverConfig: {
                title: "Habits Hit Different",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "Habits can be worked with like any other event on your calendar, but there are some special smarts to them.",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Drag a Habit to any other time to Lock it in place and prevent Reclaim from rescheduling it."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Delete a Habit event to skip it for the day. Reclaim will reschedule it to the next best day, if it makes sense for the Habit."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Use the Reschedule option from our Gcal add-on or from the Planner to automatically reschedule a Habit to later in the day."
                                })
                            ]
                        })
                    ]
                })
            }
        },
        {
            id: "HOW_TO_START",
            type: "orb",
            popoverConfig: {
                title: "How to start habits",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "If you want to get started on a Habit right now, use the Start button. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "You can Stop or Restart it at any time if you change your mind."
                    ]
                })
            }
        },
        {
            id: "YOU_THE_EXPERT",
            type: "orb",
            popoverConfig: {
                title: "",
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "OK -- you're a Habits expert now! Click here to learn more about Habits, or explore on your own."
                })
            }
        },
        {
            id: "CONFETTI",
            type: "confetti",
            popoverConfig: {
                description: "Nice work completing the Habits overview  \uD83C\uDF89"
            }
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/components/quests/questCollections/v17.quests.tsx





































var v17_quests_SLACK_APP_ID = "A01B0K9E80M";
var DEFAULT_VIDEO_PLAYER_OPTIONS = {
    autoplay: 1
};
var V17_QUESTS = (/* unused pure expression or super */ null && ([
    "HABITS_OVERVIEW_2"
]));
var QUESTS_CONFIG_V17 = {
    /********************/ /*  GETTING STARTED */ /********************/ GETTING_STARTED: {
        id: "GETTING_STARTED",
        title: "Get started",
        quests: [
            {
                id: "WELCOME_TO_RECLAIM",
                groupId: "GETTING_STARTED",
                subType: "SYNCS",
                title: "Welcome to Reclaim",
                description: "Watch a 2-minute video to learn how Reclaim works.",
                shortDescription: "A quick video on core concepts",
                duration: "2min",
                icon: waving_hand/* default */.Z,
                steps: [
                    {
                        id: "WATCH_WELCOME_VIDEO",
                        type: "video",
                        videoLink: "Wy9dI7Nm180"
                    }
                ]
            },
            {
                id: "PRIORITIZATION",
                version: 2,
                groupId: "GETTING_STARTED",
                subType: "PRIORITIES",
                title: "View & set your Priorities",
                description: "Learn how to use Priorities to intelligently schedule your calendar.",
                shortDescription: "Prioritize Your Calendar",
                duration: "4min",
                entryPathname: "/priorities",
                icon: priority_icon,
                steps: [
                    {
                        id: "WELCOME",
                        type: "orb",
                        popoverConfig: {
                            gif: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "/img/priorities-169-fast.webm",
                                        type: "video/webm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/img/priorities-169-fast.gif",
                                        alt: "priorities demo"
                                    })
                                ]
                            }),
                            title: "Welcome to your new Priorities \uD83C\uDF89",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (V17_quests_module_default()).popperCopy,
                                children: [
                                    "You can now schedule all of your calendar events by priority, from Low priority",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (V17_quests_module_default()).count,
                                        children: "P4"
                                    }),
                                    " to Critical ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (V17_quests_module_default()).count,
                                        children: "P1"
                                    }),
                                    "."
                                ]
                            }),
                            nextButtonLabel: "Learn More"
                        }
                    },
                    {
                        id: "LEARN_MORE",
                        type: "orb",
                        popoverConfig: {
                            title: "Learn more any time",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (V17_quests_module_default()).popperCopy,
                                children: [
                                    "You can always find resources for Priorities here, but",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (V17_quests_module_default()).emphasize,
                                        children: "let's walk through some basics now to help you get started"
                                    }),
                                    "."
                                ]
                            }),
                            nextButtonLabel: "Priority levels"
                        }
                    },
                    {
                        id: "PLANNER_PRIORITIES",
                        type: "orb",
                        popoverConfig: {
                            title: "Priority levels",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (V17_quests_module_default()).popperCopy,
                                        children: [
                                            "Reclaim now schedules all your events using four priority levels — Critical",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (V17_quests_module_default()).count,
                                                children: "P1"
                                            }),
                                            " to Low ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (V17_quests_module_default()).count,
                                                children: "P4"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (V17_quests_module_default()).descriptionList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V16PriorityIcon/* V16PriorityIcon */.d, {
                                                        priority: "P2"
                                                    }),
                                                    "Critical Smart 1:1s and Habits always come first. Reclaim's AI takes care of the rest."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AssignmentTurnedInOutlined/* default */.Z, {
                                                        fontSize: "small"
                                                    }),
                                                    "Tasks intelligently schedule by due date and priority."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TaskUpNextIcon/* TaskUpNextIcon */.z, {
                                                        value: false
                                                    }),
                                                    "Introducing Up Next: a new way to tell Reclaim exactly which Tasks come next."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            nextButtonLabel: "Reprioritizing"
                        }
                    },
                    {
                        id: "REPRIORITIZING",
                        type: "orb",
                        popoverConfig: {
                            gif: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "/img/priorities-drag.webm",
                                        type: "video/webm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/img/priorities-drag.gif",
                                        alt: "priorities demo"
                                    })
                                ]
                            }),
                            title: "Reprioritizing",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (V17_quests_module_default()).popperCopy,
                                children: [
                                    "Use the ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V16PriorityIcon/* V16PriorityIcon */.d, {
                                        className: (V17_quests_module_default()).priorityIcon,
                                        priority: "P2"
                                    }),
                                    " priority icon or drag-&-drop events across priority levels to organize your most important work first."
                                ]
                            }),
                            nextButtonLabel: "Planner updates"
                        }
                    },
                    {
                        id: "GO_TO_PLANNER",
                        type: "redirect",
                        redirect: "/planner",
                        redirectBack: "/priorities"
                    },
                    {
                        id: "PLANNER_UPDATES",
                        type: "orb",
                        popoverConfig: {
                            gif: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "/img/planner-drag.webm",
                                        type: "video/webm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/img/planner-drag.gif",
                                        alt: "priorities demo"
                                    })
                                ]
                            }),
                            title: "Planner updates for Priorities",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (V17_quests_module_default()).popperCopy,
                                children: [
                                    "You can also view & manage all of your Priorities from the Planner. Use the",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V16PriorityIcon/* V16PriorityIcon */.d, {
                                        className: (V17_quests_module_default()).priorityIcon,
                                        priority: "P2"
                                    }),
                                    " icon to update the priority of an event, or drag-&-drop across priority levels."
                                ]
                            }),
                            nextButtonLabel: "Non-Reclaim events"
                        }
                    },
                    {
                        id: "NON_RECLAIM_EVENTS",
                        type: "orb",
                        popoverConfig: {
                            gif: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "/img/planner-gcal.webm",
                                        type: "video/webm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/img/planner-gcal.gif",
                                        alt: "priorities demo"
                                    })
                                ]
                            }),
                            title: "Prioritizing non-Reclaim events",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (V17_quests_module_default()).popperCopy,
                                        children: "You can now prioritize your non-Reclaim events to open up your availability for higher-priority Scheduling Links."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (V17_quests_module_default()).descriptionList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gcal_outline, {
                                                        className: (V17_quests_module_default()).gcalIcon
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            "Tap on any event to modify its ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V16PriorityIcon/* V16PriorityIcon */.d, {
                                                                className: (V17_quests_module_default()).inlineIcon,
                                                                priority: "P1"
                                                            }),
                                                            " ",
                                                            "priority."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V16PriorityIcon/* V16PriorityIcon */.d, {
                                                        className: (V17_quests_module_default()).priorityIcon,
                                                        priority: "P1"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            "Non-Reclaim events default to Critical ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (V17_quests_module_default()).count,
                                                                children: "P1"
                                                            }),
                                                            " priority."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRounded/* default */.Z, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (V17_quests_module_default()).emphasize,
                                                                children: "Only"
                                                            }),
                                                            " Scheduling Links can overbook lower-priority events, & will ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (V17_quests_module_default()).emphasize,
                                                                children: "never"
                                                            }),
                                                            " overbook lower-priority meetings created by other Scheduling Links."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            nextButtonLabel: "Tasks"
                        }
                    },
                    {
                        id: "PLANNER_TASKS",
                        type: "orb",
                        popoverConfig: {
                            gif: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "/img/planner-tabs.webm",
                                        type: "video/webm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/img/planner-tabs.gif",
                                        alt: "priorities demo"
                                    })
                                ]
                            }),
                            title: "Prioritizing Tasks",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "You can still view, manage, & prioritize your Task list from the Planner or from Tasks."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (V17_quests_module_default()).descriptionList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarTodayOutlined/* default */.Z, {}),
                                                    "Tasks now schedule by priority level, & due date within each priority level."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V16PriorityIcon/* V16PriorityIcon */.d, {
                                                        priority: "P2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            "All your existing & new Tasks will default to High priority",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (V17_quests_module_default()).count,
                                                                children: "P2"
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(puzzle_icon/* default */.Z, {}),
                                                    "Tasks synced from integrations will auto-sync their priority level from those sources."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            nextButtonLabel: "Up Next for Tasks"
                        }
                    },
                    {
                        id: "UP_NEXT",
                        type: "orb",
                        popoverConfig: {
                            gif: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: "/img/planner-upnext.webm",
                                        type: "video/webm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/img/planner-upnext.gif",
                                        alt: "priorities demo"
                                    })
                                ]
                            }),
                            title: "Up Next for Tasks",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Up Next is a powerful new way to tell Reclaim to schedule Tasks ASAP — ahead of all your other Tasks."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (V17_quests_module_default()).descriptionList,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShuffleRounded, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            "Tap ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowOutwardRounded/* default */.Z, {
                                                                className: (V17_quests_module_default()).inlineIcon
                                                            }),
                                                            " or drag a Task to move it into Up Next."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(V16PriorityIcon/* V16PriorityIcon */.d, {
                                                        priority: "P1"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            "Up Next Tasks schedule ahead of all Tasks, including ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (V17_quests_module_default()).count,
                                                                children: "P1"
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportExportRounded, {}),
                                                    "You can drag-&-drop Up Next Tasks to reorder how they schedule."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            nextButtonLabel: "Review"
                        }
                    },
                    {
                        id: "REVIEW",
                        type: "orb",
                        popoverConfig: {
                            title: "Review your Priorities",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "We've automatically mapped your priorities, but take a minute now to confirm that it looks good to you.",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        href: "https://help.reclaim.ai/en/articles/8291694-priorities-overview",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        underline: "none",
                                        children: "Learn more about the updates"
                                    })
                                ]
                            }),
                            nextButtonLabel: "Finish"
                        }
                    },
                    {
                        id: "CELEBRATION",
                        type: "confetti",
                        popoverConfig: {
                            description: "Nice work completing the Priorities overview  \uD83C\uDF89"
                        }
                    }, 
                ]
            },
            {
                id: "SET_AVAILABILITY",
                groupId: "GETTING_STARTED",
                subType: "SYNCS",
                title: "Set your availability",
                description: "Tell Reclaim which calendars to use to check your availability.",
                shortDescription: "Set availability from other calendars",
                duration: "4min",
                entryPathname: "/settings/accounts",
                indeterminant: true,
                icon: CalendarTodayOutlined/* default */.Z,
                steps: [
                    {
                        id: "ADD_AVAILABILITY_CALENDARS",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "Edit" to select which calendars you want Reclaim to check for your availability.',
                            svg: connected_calendars
                        }
                    },
                    {
                        id: "SELECT_A_CALENDAR",
                        type: "orb",
                        popoverConfig: {
                            description: "Select which calendar to connect below."
                        }
                    },
                    {
                        id: "SAVE_CONNECTED_CALENDAR",
                        type: "action",
                        popoverConfig: {
                            description: "Save to connect the calendar."
                        }
                    }, 
                ]
            },
            {
                id: "SYNC_CALENDAR",
                groupId: "GETTING_STARTED",
                subType: "SYNCS",
                title: "Sync your calendars",
                description: "Automatically sync & copy events across calendars to prevent overbookings.",
                shortDescription: "Sync events across calendars",
                duration: "4min",
                entryPathname: "/sync",
                indeterminant: true,
                icon: Cached/* default */.Z,
                steps: [
                    {
                        id: "CLICK_CREATE_NEW_SYNC",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "New Sync" to create a Calendar Sync policy.',
                            svg: calendar_sync
                        }
                    },
                    {
                        id: "CLICK_NEXT_PREFERENCES",
                        type: "action",
                        popoverConfig: {
                            description: "Set your preferences for how events get synced & copied to the destination calendar, including privacy options & colors."
                        }
                    },
                    {
                        id: "SYNC_PRIVACY",
                        type: "orb",
                        popoverConfig: {
                            description: "Set the events that Reclaim should sync, how they should appear, & more."
                        }
                    },
                    {
                        id: "CLICK_SYNC_CREATION",
                        type: "action",
                        popoverConfig: {
                            description: "Time to sync your events."
                        }
                    }, 
                ]
            },
            {
                id: "SET_SCHEDULING_HOURS",
                groupId: "GETTING_STARTED",
                subType: "HOURS",
                title: "Set your scheduling hours",
                description: "Set your preferred personal, working & meeting hours.",
                shortDescription: "Schedule around your hours",
                duration: "2min",
                entryPathname: "/settings/hours?policy=WORK",
                indeterminant: true,
                icon: hourglass,
                steps: [
                    {
                        id: "MEETING_HOURS",
                        component: QuestGenericPopperContent/* QuestGenericPopperContent */.F,
                        type: "orb",
                        popoverConfig: {
                            description: "Update the hours you're available for scheduling Reclaim smart events.",
                            svg: hours
                        }
                    },
                    {
                        id: "HINT_HOURS_INPUT",
                        component: QuestGenericPopperContent/* QuestGenericPopperContent */.F,
                        type: "orb",
                        popoverConfig: {
                            description: "Toggle the days of the week & update the range of hours for each day."
                        }
                    },
                    {
                        id: "HOURS_INPUT",
                        type: "action",
                        popoverConfig: {
                            description: "Begin editing your hours."
                        }
                    }, 
                ]
            },
            {
                id: "INSTALL_GCAL_ADDON",
                groupId: "GETTING_STARTED",
                title: "Install the Google Calendar Add-on",
                description: "Manage Reclaim from Google Calendar & share Scheduling Links from Gmail.",
                shortDescription: "Share scheduling links from Gmail",
                duration: "1min",
                icon: gcal_outline,
                indeterminant: true,
                steps: [
                    {
                        id: "GOTO_GOOGLE_ADDON",
                        type: "url",
                        url: "https://workspace.google.com/marketplace/app/reclaimai/950518663892"
                    }, 
                ]
            },
            {
                id: "INSTALL_SLACK_INTEGRATION",
                groupId: "GETTING_STARTED",
                title: "Install the Slack integration",
                description: "Auto-sync your Slack status to your calendar & manage Reclaim events in Slack.",
                shortDescription: "Auto-sync your Slack status",
                duration: "1min",
                icon: slack_outline/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "GOTO_SLACK_INTEGRATION_LISTING",
                        type: "url",
                        url: "https://slack.com/app_redirect?app=".concat(v17_quests_SLACK_APP_ID)
                    }, 
                ]
            }, 
        ]
    },
    HABITS: {
        id: "HABITS",
        title: "Set your Habits",
        quests: [
            habitsOverviewQuest,
            {
                id: "CREATE_AND_CUSTOMIZE_HABITS",
                groupId: "HABITS",
                title: "Create & customize your Habits",
                description: "Set up & prioritize your Habits to keep your workweek focused & balanced.",
                shortDescription: "Add & customize your routines",
                duration: "4min",
                entryPathname: "/habits",
                indeterminant: true,
                icon: adjust_icon/* default */.Z,
                steps: [
                    {
                        id: "CREATE_NEW_HABIT",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to create a new Habit.",
                            svg: habits
                        }
                    },
                    {
                        id: "HABIT_FORM_INFORMATION",
                        type: "orb",
                        popoverConfig: {
                            description: "Set preferences for how you want the Habit to schedule, & how it will appear on your calendar."
                        }
                    },
                    {
                        id: "SET_HABIT_PRIORITY",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to set a priority"
                        }
                    },
                    {
                        id: "SAVE_HABIT",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "Save" to start automatically scheduling your Habit.'
                        }
                    }, 
                ]
            },
            {
                id: "MANAGE_HABITS",
                groupId: "HABITS",
                title: "Manage Habits on your calendar",
                description: "Learn how to adjust Habit events in your schedule.",
                shortDescription: "How to work with Habits on your schedule",
                duration: "3min",
                entryPathname: "/planner",
                icon: TodayOutlined/* default */.Z,
                steps: [
                    {
                        id: "PLANNER_HABIT_MANAGEMENT",
                        type: "orb",
                        popoverConfig: {
                            description: "Watch a quick overview on how to manage your Habit events.",
                            img: "/img/quests/habits-planner3.gif"
                        }
                    },
                    {
                        id: "VIDEO_HABIT_MANAGEMENT",
                        type: "video",
                        videoLink: "4PxE7M_eNTg"
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*  SMART MEETINGS  */ /********************/ SMART_MEETINGS: {
        id: "SMART_MEETINGS",
        title: "Set up your smart meetings",
        quests: [
            {
                id: "SCHEDULING_LINKS_OVERVIEW",
                groupId: "SMART_MEETINGS",
                subType: "SCHEDULING_LINKS",
                title: "Scheduling Links overview",
                description: "Learn how to share your availability & get the right meetings scheduled sooner with Scheduling Links.",
                shortDescription: "How to use Reclaim's scheduling links",
                duration: "2min",
                icon: LinkRounded/* default */.Z,
                steps: [
                    {
                        id: "WATCH_SCHEDULING_LINKS_VIDEO",
                        type: "video",
                        videoLink: "xty1wE0ZLyU"
                    }
                ]
            },
            {
                id: "SETUP_SCHEDULING_LINKS",
                groupId: "SMART_MEETINGS",
                title: "Set up your Scheduling Links ",
                description: "Create your Scheduling Links & share your Booking Pages.",
                shortDescription: "Allow others to book time with you",
                duration: "5min",
                entryPathname: (0,router/* getSchedulingLinksUrl */.E5)(),
                icon: DateRangeOutlined/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "CLICK_SL_ONBOARDING",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "Set it up" to begin the Scheduling Links onboarding.'
                        }
                    },
                    {
                        id: "CLICK_DONE_SL_ONBOARDING",
                        type: "action",
                        popoverConfig: {
                            description: 'Tap "Done" to complete Scheduling Links onboarding.'
                        }
                    }, 
                ]
            },
            {
                id: "SETUP_TEAM_LINKS",
                groupId: "SMART_MEETINGS",
                subType: "SCHEDULING_LINKS",
                title: "Set up your team links",
                description: "Create a team Scheduling Link with multiple team members to share your combined availability.",
                shortDescription: "Send links based on your team's availability",
                duration: "2min",
                entryPathname: (0,router/* getSchedulingLinkEditUrl */.Zm)("new"),
                icon: user_group_icon/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "SL_FORM_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Create your team Scheduling Link for multiple team members. You can assign your team link to a group, set multiple durations, add your team members, & more."
                        }
                    },
                    {
                        id: "CLICK_ADD_TEAM_MEMBERS",
                        type: "orb",
                        popoverConfig: {
                            description: "Add team members to be meeting organizers for this link."
                        }
                    },
                    {
                        id: "SET_LINK_PRIORITY",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to set a priority"
                        }
                    },
                    {
                        id: "CLICK_CREATE_LINK",
                        type: "action",
                        popoverConfig: {
                            description: "Create your team link."
                        }
                    }, 
                ]
            },
            {
                id: "SMART_ONE_ON_ONE_OVERVIEW",
                groupId: "SMART_MEETINGS",
                subType: "SMART_11S",
                title: "Smart 1:1s overview",
                description: "Learn how Smart 1:1s automatically schedule & manage your recurring one-on-one meetings.",
                shortDescription: "Auto-schedule & reschedule your 1:1s",
                duration: "4min",
                icon: users_icon/* default */.Z,
                steps: [
                    {
                        id: "WATCH_SMART_11s_VIDEO",
                        type: "video",
                        videoLink: "b3gluXGDOPQ"
                    }
                ]
            },
            {
                id: "SETUP_FIRST_SMART_ONE_ON_ONE",
                groupId: "SMART_MEETINGS",
                subType: "SMART_11S",
                title: "Set up your first Smart 1:1",
                description: "Start converting your existing one-on-one meetings to Smart 1:1s.",
                shortDescription: "Convert existing 1:1 meetings",
                duration: "4min",
                entryPathname: "/one-on-ones",
                icon: EventAvailableOutlined/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "SMART_11_PAGE_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "You can create a new Smart 1:1, or convert your existing 1:1s that we detect into Reclaim Smart 1:1s."
                        }
                    },
                    {
                        id: "CLICK_NEW_SMART_11",
                        type: "action",
                        popoverConfig: {
                            description: "Create your Smart 1:1."
                        }
                    },
                    {
                        id: "SMART_11_FORM_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Enter the email of your invitee, set the duration & frequency of the recurring meeting, & add a location or videoconferencing link."
                        }
                    },
                    {
                        id: "SET_SMART_11_PRIORITY",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to set a priority"
                        }
                    },
                    {
                        id: "CREATE_SMART_11",
                        type: "action",
                        popoverConfig: {
                            description: "Create your Smart 1:1."
                        }
                    }, 
                ]
            },
            {
                id: "MANAGE_SMART_ONE_ON_ONE",
                groupId: "SMART_MEETINGS",
                subType: "SMART_11S",
                title: "Manage Smart 1:1s on your calendar",
                description: "Learn how to manage your Smart 1:1s on your calendar during the week.",
                shortDescription: "How to manage your 1:1 meetings",
                duration: "2min",
                entryPathname: "/planner",
                icon: TodayOutlined/* default */.Z,
                steps: [
                    {
                        id: "PLANNER_MANAGE_SMART_11",
                        type: "orb",
                        popoverConfig: {
                            description: "Watch a quick video on managing your Smart 1:1s.",
                            img: "/img/quests/quests-one-on-ones.gif"
                        }
                    },
                    {
                        id: "VIDEO_MANAGE_SMART_11",
                        type: "video",
                        videoLink: "PRXsrSRuKRE"
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*      TASKS       */ /********************/ TASKS: {
        id: "TASKS",
        title: "Make time for your tasks",
        quests: [
            {
                id: "TASK_OVERVIEW",
                groupId: "TASKS",
                title: "Tasks overview",
                description: "Learn how to automatically block flexible time for your Tasks.",
                shortDescription: "Block flexible time for your to-dos",
                duration: "2min",
                icon: AssignmentTurnedInOutlined/* default */.Z,
                steps: [
                    {
                        id: "WATCH_TASKS_VIDEO",
                        type: "video",
                        videoLink: "3rZjNBbRm7g"
                    }
                ]
            },
            {
                id: "ADD_FIRST_TASK",
                groupId: "TASKS",
                title: "Create your first Task",
                description: "Create a Task to start defending time on your calendar to get stuff done.",
                shortDescription: "Start blocking time to get stuff done",
                duration: "2min",
                entryPathname: "/tasks",
                icon: TodayOutlined/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "CLICK_NEW_TASK",
                        type: "action",
                        popoverConfig: {
                            description: "Create a new Task here from anywhere in Reclaim.",
                            img: "/img/quests/tasks.png"
                        }
                    },
                    {
                        id: "TASK_FORM_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Give your Task a name, an estimated amount of time, & how you'd like to schedule (you can always add more time later)."
                        }
                    },
                    {
                        id: "SET_TASK_PRIORITY",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to set a priority"
                        }
                    },
                    {
                        id: "SAVE_TASK",
                        type: "action",
                        popoverConfig: {
                            description: "Tap save to create & auto-schedule time for this Task in your calendar."
                        }
                    }, 
                ]
            },
            {
                id: "ADD_TASK_INTEGRATION",
                groupId: "TASKS",
                title: "Add Task integrations",
                description: "Integrate your project management app to automatically sync your Tasks.",
                shortDescription: "Auto-sync your tasks from other apps",
                duration: "4min",
                entryPathname: "/settings/integrations",
                icon: puzzle_icon/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "TASKS_INTEGRATIONS_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Integrate your project management app to automatically sync your Tasks to Reclaim & get them on the calendar (you may need to upgrade to a Pro or Team plan to integrate with some of these tools)."
                        }
                    }, 
                ]
            },
            {
                id: "MANAGE_TASKS",
                groupId: "TASKS",
                title: "Manage Tasks on your calendar",
                description: "Learn how to manage your Task events on your calendar during the week.",
                shortDescription: "How to manage your Tasks on your calendar",
                duration: "5min",
                entryPathname: "/planner",
                icon: DateRangeOutlined/* default */.Z,
                steps: [
                    {
                        id: "PLANNER_MANAGE_TASKS",
                        type: "orb",
                        popoverConfig: {
                            description: "Watch a quick video on managing your Tasks.",
                            img: "/img/quests/quests-tasks.gif"
                        }
                    },
                    {
                        id: "VIDEO_MANAGE_TASKS",
                        type: "video",
                        videoLink: "8ApgSiGKhoc"
                    }, 
                ]
            },
            {
                id: "SET_TASK_DEFAULTS",
                groupId: "TASKS",
                title: "Set your Task defaults",
                description: "Define your default settings for how Tasks are scheduled via Reclaim.",
                shortDescription: "Set defaults for how Tasks are scheduled",
                duration: "2min",
                entryPathname: "/settings/general#tasks",
                icon: cog_icon/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "TASK_DEFAULTS_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Edit your default Task duration, preferred hours, visibility to others, & auto-reopen/close settings."
                        }
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*     CUSTOMIZE    */ /********************/ CUSTOMIZE_CALENDAR: {
        id: "CUSTOMIZE_CALENDAR",
        title: "Customize your calendar",
        quests: [
            {
                id: "AUTO_SCHEDULE_BREAK_AND_TRAVEL_TIME",
                groupId: "CUSTOMIZE_CALENDAR",
                title: "Auto-schedule breaks & travel",
                description: "Make time for breaks around meetings & work sessions.",
                shortDescription: "Make time for breaks between meetings",
                duration: "2min",
                entryPathname: "/settings/general#buffer",
                indeterminant: true,
                icon: coffee/* default */.Z,
                steps: [
                    {
                        id: "TRAVEL_TIME_INFO",
                        type: "action",
                        popoverConfig: {
                            description: "Make sure you have time to travel between your events by automatically adding buffer time.",
                            img: "/img/quests/travel-time.png"
                        }
                    },
                    {
                        id: "CLICK_TRAVEL_TIME",
                        type: "action",
                        popoverConfig: {
                            description: "Toggle travel time."
                        }
                    },
                    {
                        id: "CONFERENCE_BUFFER_INFO",
                        type: "action",
                        popoverConfig: {
                            description: "Automatically schedule breaks after video calls so you have time to decompress.",
                            img: "/img/quests/buffer-time.png"
                        }
                    },
                    {
                        id: "CLICK_BUFFER",
                        type: "action",
                        popoverConfig: {
                            description: "Toggle buffer time."
                        }
                    }, 
                ]
            },
            {
                id: "SETUP_NO_MEETING_DAYS",
                groupId: "CUSTOMIZE_CALENDAR",
                title: "Set up No-Meetings Days",
                description: "Create No-Meetings Days for you & your team to prevent meetings, while still scheduling Habits, Tasks & breaks.",
                shortDescription: "Use hashtags to set no-meetings days",
                duration: "2min",
                icon: hash,
                steps: [
                    {
                        id: "VIDEO_NO_MEETING_DAYS",
                        type: "video",
                        videoLink: "MORi7KIYJkw"
                    }
                ]
            },
            {
                id: "CUSTOMIZE_EVENT_COLOR_CODING",
                groupId: "CUSTOMIZE_CALENDAR",
                title: "Customize event color-coding",
                description: "Automatically color-code your events by category to keep your schedule visually organized.",
                shortDescription: "Color-code your events by category",
                duration: "2min",
                entryPathname: "/settings/colors",
                icon: ColorLensOutlined/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "COLOR_SETTINGS_OVERVIEW",
                        type: "orb",
                        popoverConfig: {
                            description: "Reclaim-created events will use the default category colors you set up here.",
                            img: "/img/quests/colors.png"
                        }
                    },
                    {
                        id: "ENABLE_ALL_EVENTS",
                        type: "action",
                        popoverConfig: {
                            description: "We recommend allowing Reclaim to color all of your events based on these categories."
                        }
                    }, 
                ]
            },
            {
                id: "TRACK_AND_ANALYZE_PRODUCTIVITY",
                groupId: "CUSTOMIZE_CALENDAR",
                title: "Track & analyze your productivity",
                description: "Check out your calendar stats to keep tabs on your productivity & work-life balance.",
                shortDescription: "Keep tabs on your productivity & work-life balance",
                duration: "2min",
                entryPathname: "/stats",
                icon: BarChartRounded/* default */.Z,
                steps: [
                    {
                        id: "STATS_OVERVIEW",
                        type: "orb",
                        popoverConfig: {
                            description: "Use these stats to balance & budget where your time goes each week."
                        }
                    }, 
                ]
            }, 
        ]
    },
    /********************/ /*       TEAM       */ /********************/ INVITE_TEAM: {
        id: "INVITE_TEAM",
        title: "Invite your team",
        quests: [
            {
                id: "ADD_MEMBERS_TO_TEAM",
                groupId: "INVITE_TEAM",
                title: "Add members to your team",
                description: "Start building out your team to get the most out of Reclaim.",
                shortDescription: "Build your team & get the most out of Reclaim",
                duration: "3min",
                entryPathname: "/billing#team",
                icon: user_add_icon/* default */.Z,
                indeterminant: true,
                steps: [
                    {
                        id: "CLICK_ADD_MEMBER",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to invite a team member."
                        }
                    },
                    {
                        id: "INVITE_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Enter a team member's email to send a free invite - you can add additional emails right below."
                        }
                    },
                    {
                        id: "CLICK_INVITE",
                        type: "action",
                        popoverConfig: {
                            description: "Tap to send."
                        }
                    }, 
                ]
            },
            {
                id: "SELECT_PLAN",
                groupId: "INVITE_TEAM",
                title: "Select a plan",
                description: "Find the right Reclaim plan for your team's needs.",
                shortDescription: "Find the right plan for your needs",
                duration: "2min",
                entryPathname: "/billing",
                icon: grid,
                indeterminant: true,
                steps: [
                    {
                        id: "CLICK_PURCHASE",
                        type: "action",
                        popoverConfig: {
                            description: "Tap the purchase button to compare plans & select one for your account.",
                            img: "/img/quests/purchase.png"
                        }
                    },
                    {
                        id: "PURCHASE_INFO",
                        type: "orb",
                        popoverConfig: {
                            description: "Learn more about our Starter, Business, & Enterprise plans & select what's right for you."
                        }
                    },
                    {
                        id: "CLICK_FINISH_ON_STRIPE",
                        type: "action",
                        popoverConfig: {
                            description: "Set up payment."
                        }
                    }, 
                ]
            }, 
        ]
    }
};

;// CONCATENATED MODULE: ./src/components/quests/quests.util.ts



var QUESTS_CONFIG;
var quests_util_DEFAULT_VIDEO_PLAYER_OPTIONS = {
    autoplay: 1
};
var initQuestSteps = function(user) {
    var ref;
    if ((0,useV16User/* isSchedulerV16 */.p)(user === null || user === void 0 ? void 0 : (ref = user.features) === null || ref === void 0 ? void 0 : ref.scheduler)) {
        QUESTS_CONFIG = QUESTS_CONFIG_V17;
    } else {
        QUESTS_CONFIG = QUESTS_CONFIG_V14;
    }
};
var getActiveQuestFromQuestId = function(quest) {
    var active;
    Object.keys(QUESTS_CONFIG).find(function(g) {
        var match = QUESTS_CONFIG[g].quests.find(function(q) {
            return q.id === quest;
        });
        if (match) {
            active = {
                group: match.groupId,
                quest: match.id,
                step: match.steps[0].id
            };
        }
        return !!match;
    });
    return active;
};
var getQuestConfigFromActiveQuest = function(quest) {
    var questCfg = QUESTS_CONFIG[quest.group];
    if (questCfg) {
        var cfg = questCfg.quests.find(function(s) {
            return s.id === quest.quest;
        });
        return cfg || undefined;
    }
};
var isQuestV2 = function(quest) {
    if (!quest) return false;
    var questConfig = getQuestConfigFromActiveQuest(quest);
    return (questConfig === null || questConfig === void 0 ? void 0 : questConfig.version) && questConfig.version > 1;
};
var getQuestsStepConfig = function(activeQuest) {
    var quest = getQuestConfigFromActiveQuest(activeQuest);
    if (quest) {
        var step = quest === null || quest === void 0 ? void 0 : quest.steps.find(function(ss) {
            return ss.id === activeQuest.step;
        });
        return step || undefined;
    }
};
var getPreviousQuestStep = function(activeQuest) {
    var quest = getQuestConfigFromActiveQuest(activeQuest);
    if (quest) {
        var i = quest.steps.findIndex(function(s) {
            return s.id === activeQuest.step;
        });
        return i === 0 ? undefined : quest.steps[i - 1];
    }
};
var getNextQuestStep = function(activeQuest, user, productUsage) {
    var quest = getQuestConfigFromActiveQuest(activeQuest);
    if (!quest) return;
    var stepConfig = getQuestsStepConfig(activeQuest);
    // Support nextQuest callback
    if (stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.getNextQuest) {
        var questStepId = typeof (stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.getNextQuest) === "function" ? stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.getNextQuest({
            user: user,
            usage: productUsage
        }) : stepConfig === null || stepConfig === void 0 ? void 0 : stepConfig.getNextQuest;
        return quest.steps.find(function(step) {
            return step.id === questStepId;
        });
    }
    // Get natural next step
    var i = quest.steps.findIndex(function(s) {
        return s.id === activeQuest.step;
    });
    return i === quest.steps.length - 1 ? undefined : quest.steps[i + 1];
};
var getQuestConfigFromQuestId = function(quest) {
    var tempActive = getActiveQuestFromQuestId(quest);
    return tempActive ? getQuestConfigFromActiveQuest(tempActive) : undefined;
};
var getNextQuestFromQuestId = function(quest) {
    var tempActive = getActiveQuestFromQuestId(quest);
    if (tempActive) {
        var qIndex = QUESTS_CONFIG[tempActive.group].quests.findIndex(function(q) {
            return q.id === tempActive.quest;
        });
        if (QUESTS_CONFIG[tempActive.group].quests[qIndex + 1]) {
            return QUESTS_CONFIG[tempActive.group].quests[qIndex + 1];
        }
    }
};
var getGroupConfigFromQuestId = function(quest) {
    var tempActive = getActiveQuestFromQuestId(quest);
    return tempActive ? QUESTS_CONFIG[tempActive.group] : undefined;
};
var getNextQuestFromGroup = function(progress, quest) {
    var group = getGroupConfigFromQuestId(quest);
    return group === null || group === void 0 ? void 0 : group.quests.find(function(q) {
        return !progress[group.id].quests[q.id].complete && q.id !== quest;
    });
};


/***/ }),

/***/ 31564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TaskUpNextIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_ArrowOutwardRounded__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97090);
/* harmony import */ var _utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91740);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _TaskUpNextIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50957);
/* harmony import */ var _TaskUpNextIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_TaskUpNextIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__);






var TaskUpNextIcon = function(param) {
    var className = param.className, extClasses = param.classes, value = param.value;
    var classes = (0,_utils_scss_utils__WEBPACK_IMPORTED_MODULE_1__/* .mergeClassNames */ .E)((_TaskUpNextIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default()), extClasses || {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowOutwardRounded__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, classes["root--active"], value))
    });
};


/***/ }),

/***/ 76140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MT": function() { return /* binding */ BROWSER_LOCALE; },
/* harmony export */   "Pv": function() { return /* binding */ BROWSER_DEFAULT_CURRENCY_CODE; },
/* harmony export */   "Ws": function() { return /* binding */ BROWSER_TIME_TYPE; },
/* harmony export */   "h": function() { return /* binding */ BROWSER_TZ; },
/* harmony export */   "iZ": function() { return /* binding */ SUPPORTED_TZS; }
/* harmony export */ });
/* harmony import */ var _depay_local_currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38951);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50084);
var ref;


var ref1 = Intl.DateTimeFormat().resolvedOptions(), timeZone = ref1.timeZone, hour12 = ref1.hour12, locale = ref1.locale;
var BROWSER_LOCALE = locale;
var BROWSER_DEFAULT_CURRENCY_CODE = function() {
    if (false) {}
    var code = _depay_local_currency__WEBPACK_IMPORTED_MODULE_0__/* .Currency.getCode */ .F.getCode(timeZone);
    if (_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORTED_CURRENCY_MAP */ .B7[code]) return code;
    return "USD";
}();
var BROWSER_TZ = timeZone;
var SUPPORTED_TZS = (ref = Intl.supportedValuesOf) === null || ref === void 0 ? void 0 : ref.call(Intl, "timeZone");
// hour12 has low support.  Must do a strict equality check on false.
var BROWSER_TIME_TYPE = hour12 === false ? "24h" : "12h";


/***/ }),

/***/ 8846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SUPPORT_EMAIL; }
/* harmony export */ });
var SUPPORT_EMAIL = "support@reclaim.ai";


/***/ }),

/***/ 54137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M$": function() { return /* binding */ shadowTrackingCode; },
/* harmony export */   "rZ": function() { return /* binding */ shadowApiKey; },
/* harmony export */   "sQ": function() { return /* binding */ isImpersonating; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45110);


var STORAGE_KEY_USED_IN_THIS_CONTEXT = "RECLAIM_USED_IN_THIS_CONTEXT";
var STORAGE_KEY_WARNED_OF_USAGE = "RECLAIM_WARNED_OF_USAGE";
var SHADOW_STORAGE_KEY_API_KEY = "RECLAIM_SHADOW_API_KEY";
var SHADOW_STORAGE_KEY_TRACKING_CODE = "RECLAIM_SHADOW_TRACKING_CODE";
var SHADOW_QS_NAME_TRACKING_CODE = "shadowTrackingCode";
var SHADOW_QS_NAME_API_KEY = "shadowApiKey";
var shadowApiKey;
var shadowTrackingCode;
var isImpersonating = false;
/**
 * This is all to remove the shadow/impersonation stuff
 * from the query string.  Dropping it in an anonymous
 * function to make it easier to visually parse out, and
 * to avoid collision with the many common variable
 * names it uses.
 */ (function() {
    if (false) {}
    var warnedOfUsage = !!sessionStorage.getItem(STORAGE_KEY_WARNED_OF_USAGE);
    var usedInThisContext = !!localStorage.getItem(STORAGE_KEY_USED_IN_THIS_CONTEXT);
    if (!usedInThisContext) localStorage.setItem(STORAGE_KEY_USED_IN_THIS_CONTEXT, JSON.stringify(true));
    var url = new URL(window.location.href);
    // get the query string as an object
    var qObj = (0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .mapToObject */ .GA)(url.search.replace(/^\?/, "").split("&"), function(pair) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(pair.split("="), 2), key = ref[0], val = ref[1];
        return [
            key,
            decodeURIComponent(val)
        ];
    });
    if (qObj[SHADOW_QS_NAME_TRACKING_CODE]) {
        shadowApiKey = qObj[SHADOW_QS_NAME_API_KEY];
        shadowTrackingCode = qObj[SHADOW_QS_NAME_TRACKING_CODE];
    } else {
        shadowApiKey = sessionStorage.getItem(SHADOW_STORAGE_KEY_API_KEY) || undefined;
        shadowTrackingCode = sessionStorage.getItem(SHADOW_STORAGE_KEY_TRACKING_CODE) || undefined;
    }
    // remove the shadow props from the URL
    delete qObj[SHADOW_QS_NAME_TRACKING_CODE];
    delete qObj[SHADOW_QS_NAME_API_KEY];
    // get the remaining query string
    var qArr = (0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .typedEntries */ .FR)(qObj).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], val = _param[1];
        return key && val && "".concat(key, "=").concat(val);
    }).filter(function(i) {
        return !!i;
    });
    // reattach it to the URL
    url.search = qArr.length ? "?" + qArr.join("&") : "";
    //set the URL back in the browser
    void window.history.replaceState(null, "", url);
    if (shadowTrackingCode) {
        if (usedInThisContext && !warnedOfUsage) {
            var confirmed = confirm('It looks like you\'ve logged into Reclaim in this browser scope before.  We HIGHLY recommend that you only impersonate in a private or incognito window.\n\nClick "OK" to continue with impersonation.  Click "Cancel" to continue without impersonation.');
            sessionStorage.setItem(STORAGE_KEY_WARNED_OF_USAGE, JSON.stringify(true));
            if (!confirmed) return;
        }
        if (!shadowApiKey) {
            shadowApiKey = prompt("Paste in your API Key") || undefined;
        }
    }
    // store the props
    if (shadowApiKey && shadowTrackingCode) {
        isImpersonating = true;
        sessionStorage.setItem(SHADOW_STORAGE_KEY_API_KEY, shadowApiKey);
        sessionStorage.setItem(SHADOW_STORAGE_KEY_TRACKING_CODE, shadowTrackingCode);
    }
})();



/***/ }),

/***/ 14101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ LOCAL_STORAGE_AUTH_UTM; },
/* harmony export */   "$X": function() { return /* binding */ LOCAL_STORAGE_TASKS_LIST_SORT; },
/* harmony export */   "EW": function() { return /* binding */ LOCAL_STORAGE_TASKS_SPLIT_UP_CHUNKS; },
/* harmony export */   "I7": function() { return /* binding */ LOCAL_STORAGE_AUTH_REDIRECT; },
/* harmony export */   "K5": function() { return /* binding */ LOCAL_STORAGE_AUTH_ADMIN; },
/* harmony export */   "Ml": function() { return /* binding */ LOCAL_STORAGE_PLANNER_RANGE; },
/* harmony export */   "Sz": function() { return /* binding */ LOCAL_STORAGE_PRIORITY_COLUMN_WIDTH; },
/* harmony export */   "UD": function() { return /* binding */ LOCAL_STORAGE_PLANNER_SIDEBAR_TAB; },
/* harmony export */   "Vt": function() { return /* binding */ LOCAL_STORAGE_AUTH_REAUTH; },
/* harmony export */   "WP": function() { return /* binding */ LOCAL_STORAGE_PRIORITY_ACTIVE_ACCORDION; },
/* harmony export */   "ZB": function() { return /* binding */ LOCAL_STORAGE_AUTH_REF; },
/* harmony export */   "aJ": function() { return /* binding */ LOCAL_STORAGE_AUTH_ATTEMPTS; },
/* harmony export */   "d": function() { return /* binding */ LOCAL_STORAGE_TASKS_QUICK_ADD_DATA; },
/* harmony export */   "du": function() { return /* binding */ LOCAL_STORAGE_TASKS_QUICK_ADD_SECTIONS; },
/* harmony export */   "go": function() { return /* binding */ LOCAL_STORAGE_AUTH_IMPERSONATE_ERROR; },
/* harmony export */   "jM": function() { return /* binding */ LOCAL_STORAGE_BOOKING_PAGE_SHOW_AVAILABILITY; },
/* harmony export */   "kG": function() { return /* binding */ LOCAL_STORAGE_AUTH_USER; },
/* harmony export */   "pZ": function() { return /* binding */ LOCAL_STORAGE_ACTIVE_QUESTS; },
/* harmony export */   "uJ": function() { return /* binding */ LOCAL_STORAGE_AUTH_IMPERSONATE; }
/* harmony export */ });
/**
 * Auth
 */ var LOCAL_STORAGE_AUTH_USER = "auth.user";
var LOCAL_STORAGE_AUTH_REAUTH = "auth.reauth";
var LOCAL_STORAGE_AUTH_ATTEMPTS = "auth.attempts";
var LOCAL_STORAGE_AUTH_REDIRECT = "auth.redirect";
var LOCAL_STORAGE_AUTH_REF = "auth.ref";
var LOCAL_STORAGE_AUTH_UTM = "auth.utm";
var LOCAL_STORAGE_AUTH_ADMIN = "auth.admin";
var LOCAL_STORAGE_AUTH_IMPERSONATE = "auth.impersonate";
var LOCAL_STORAGE_AUTH_IMPERSONATE_ERROR = "auth.impersonate.error";
/**
 * Quests
 */ var LOCAL_STORAGE_ACTIVE_QUESTS = "Quests.active";
/**
 * Tasks
 */ var LOCAL_STORAGE_TASKS_QUICK_ADD_SECTIONS = "Reclaim.Tasks.QuickAddSections";
var LOCAL_STORAGE_TASKS_QUICK_ADD_DATA = "Reclaim.Tasks.QuickAddData";
var LOCAL_STORAGE_TASKS_SPLIT_UP_CHUNKS = "Reclaim.Tasks.SplitUp";
var LOCAL_STORAGE_TASKS_LIST_SORT = "Tasks.Sort";
/**
 * Priority
 */ var LOCAL_STORAGE_PRIORITY_ACTIVE_ACCORDION = "Priority.AccordionState";
var LOCAL_STORAGE_PRIORITY_COLUMN_WIDTH = "Priority.ColumnWidth";
/**
 * Planner
 */ var LOCAL_STORAGE_PLANNER_SIDEBAR_TAB = "Planner.Sidebar.Tab";
var LOCAL_STORAGE_PLANNER_RANGE = "Planner.Range";
/**
 * Scheduling Link Booking Page
 */ var LOCAL_STORAGE_BOOKING_PAGE_SHOW_AVAILABILITY = "Booking.ShowAvailability";


/***/ }),

/***/ 89495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Os": function() { return /* binding */ useAnalyticsContext; },
/* harmony export */   "nx": function() { return /* binding */ AnalyticsContextProvider; }
/* harmony export */ });
/* unused harmony exports defaultState, AnalyticsContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70550);




var defaultState = _analytics__WEBPACK_IMPORTED_MODULE_2__/* .Analytics */ .cp;
var AnalyticsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    state: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, defaultState)
});
function useAnalyticsContext() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AnalyticsContext);
}
var AnalyticsContextProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnalyticsContext.Provider, {
        value: {
            state: _analytics__WEBPACK_IMPORTED_MODULE_2__/* .Analytics */ .cp
        },
        children: children
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (AnalyticsContext)));


/***/ }),

/***/ 64574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ useAppContext; },
/* harmony export */   "cX": function() { return /* binding */ AppContextActionType; },
/* harmony export */   "iz": function() { return /* binding */ AppContextProvider; }
/* harmony export */ });
/* unused harmony exports AppContextNavState, defaultState, appContextReducer, AppContext */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_local_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91325);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45110);








var AppContextActionType;
(function(AppContextActionType) {
    AppContextActionType["Theme"] = "THEME";
    AppContextActionType["Title"] = "TITLE";
    AppContextActionType["Crumbs"] = "CRUMBS";
    AppContextActionType["Nav"] = "NAV";
})(AppContextActionType || (AppContextActionType = {}));
var AppContextNavState = /*#__PURE__*/ function() {
    "use strict";
    function AppContextNavState(pin, expand, hover) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, AppContextNavState);
        this.pin = pin;
        this.expand = expand;
        this.hover = hover;
    }
    var _proto = AppContextNavState.prototype;
    _proto.toJSON = function toJSON() {
        return {
            pin: this.pin,
            expand: this.expand,
            hover: this.hover
        };
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(AppContextNavState, [
        {
            key: "open",
            get: function get() {
                return this.pin || this.expand || this.hover;
            }
        }
    ]);
    return AppContextNavState;
}();
var defaultState = {
    title: "Reclaim – A smart friend for your calendar",
    crumbs: [
        "Reclaim"
    ],
    theme: "light",
    nav: new AppContextNavState(true, false, false)
};
var appContextReducer = function(state, action) {
    switch(action.type){
        case AppContextActionType.Theme:
            var theme = action.payload;
            return theme !== state.theme ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                theme: theme
            }) : state;
        case AppContextActionType.Title:
            var title = action.payload ? action.payload : defaultState.title;
            return title !== state.title ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                title: title
            }) : state;
        case AppContextActionType.Crumbs:
            var ref;
            var crumbs = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.length) ? action.payload : defaultState.crumbs;
            return crumbs !== state.crumbs ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                crumbs: crumbs
            }) : state;
        case AppContextActionType.Nav:
            var next = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state.nav.toJSON(), action.payload);
            return !(0,_utils_objects__WEBPACK_IMPORTED_MODULE_2__/* .same */ .i$)(next, state.nav) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                nav: new AppContextNavState(next.pin, next.expand, next.hover)
            }) : state;
        default:
            console.warn("Unhandled action type: ".concat(action.type));
            return state;
    }
};
var loadReducerState = function() {
    var persisted = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .getSessionStorage */ .G)("app", defaultState);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, persisted), {
        nav: new AppContextNavState(persisted.nav.pin, persisted.nav.expand, persisted.nav.hover),
        title: defaultState.title,
        crumbs: defaultState.crumbs
    });
};
var defaultContext = {
    state: loadReducerState(),
    dispatch: function(action) {
        return console.error("Dispatch called before initialized", action);
    }
};
var AppContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(defaultContext);
function useAppContext() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AppContext);
}
var AppContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(appContextReducer, defaultState, loadReducerState), state = ref[0], dispatch = ref[1];
    /**
   * Update session storage when app state changes
   */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .setSessionStorage */ .t_)("app", {
            theme: state.theme,
            nav: state.nav
        });
    }, [
        state.theme,
        state.nav
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (AppContext)));


/***/ }),

/***/ 58793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qZ": function() { return /* binding */ CommandBarContextProvider; },
  "_g": function() { return /* binding */ useCommandBarContext; }
});

// UNUSED EXPORTS: CommandBarContext, default, defaultState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/commandbar/build/commandbar-js/src/index.js
var src = __webpack_require__(63663);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/hooks/useIntercom.tsx
var useIntercom = __webpack_require__(10428);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(63496);
// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 16 modules
var reclaim_api = __webpack_require__(54517);
// EXTERNAL MODULE: ./src/utils/arrays.ts
var arrays = __webpack_require__(92886);
;// CONCATENATED MODULE: ./src/utils/commandbar.ts







/**
 * Tasks
 */ var initTaskData = function(cb) {
    (0,wonka/* pipe */.zG)(reclaim_api/* reclaim.tasks.listAndWatch$$ */.Tz.tasks.listAndWatch$$({
        instances: true
    }), (0,wonka/* subscribe */.Ld)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tasks) {
            var filteredAndMapped;
            return (0,tslib_es6.__generator)(this, function(_state) {
                filteredAndMapped = tasks === null || tasks === void 0 ? void 0 : tasks.map(function(t) {
                    var instances = (t.instances || []).filter(function(instance) {
                        var ref;
                        return (((ref = instance.end) === null || ref === void 0 ? void 0 : ref.getTime()) || 0) > new Date().getTime();
                    }).sort((0,arrays/* byKey */.uy)("start"));
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, t), {
                        label: t.title,
                        nextEvent: instances[0]
                    });
                });
                cb === null || cb === void 0 ? void 0 : cb.addRecords("tasks", filteredAndMapped || []);
                return [
                    2
                ];
            });
        });
        return function(tasks) {
            return _ref.apply(this, arguments);
        };
    }()));
};
/**
 * Habits
 */ var initHabitData = function(cb) {
    (0,wonka/* pipe */.zG)(reclaim_api/* reclaim.habits.listAndWatch$$ */.Tz.habits.listAndWatch$$(), (0,wonka/* subscribe */.Ld)(function(habits) {
        cb === null || cb === void 0 ? void 0 : cb.addRecords("habits", habits);
    }));
};

// EXTERNAL MODULE: ./src/utils/platform.ts
var platform = __webpack_require__(94423);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
;// CONCATENATED MODULE: ./src/context/CommandBarContext.tsx
/* provided dependency */ var process = __webpack_require__(83454);










var defaultState = {
    get CommandBar () {
        return platform/* Browser.isBrowser */.AR.isBrowser() ? window === null || window === void 0 ? void 0 : window.CommandBar : undefined;
    },
    status: "init"
};
var CommandBarContext = /*#__PURE__*/ (0,react.createContext)({
    state: defaultState
});
function useCommandBarContext() {
    return (0,react.useContext)(CommandBarContext);
}
var CommandBarContextProvider = function(param) {
    var children = param.children;
    var ref, ref1;
    var ref2 = (0,react.useState)(defaultState), state = ref2[0], setState = ref2[1];
    var showIntercom = (0,useIntercom/* useIntercom */.o)("I need help...").showIntercom;
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var dataInitialized = (0,react.useRef)(false);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), userState = ref3[0];
    var isBrowser = (0,react.useMemo)(function() {
        return platform/* Browser.isBrowser */.AR.isBrowser();
    }, []);
    var handleLaunchSupport = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        showIntercom();
    });
    (0,react.useEffect)(function() {
        if (!isBrowser || "init" !== state.status) return;
        // console.log("[CommandBar] init");
        // Init CommandBar
        (0,src.init)("84721cdb");
    }, [
        isBrowser,
        state.status
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ("init" !== state.status) return;
        if (!isBrowser) {
            // console.warn("[CommandBar] Abort boot, no window");
            return;
        }
        if (!window.CommandBar) {
            // console.warn("[CommandBar] Abort boot, no window.CommandBar");
            return;
        }
        if (!((ref = userState.user) === null || ref === void 0 ? void 0 : ref.trackingCode)) {
            // console.warn("[CommandBar] Abort boot, no user id");
            return;
        }
        if (!((ref1 = userState.user) === null || ref1 === void 0 ? void 0 : ref1.onboarded)) {
            // console.warn("[CommandBar] Abort boot, user not onboarded");
            return;
        }
        void window.CommandBar.boot(userState.user.trackingCode);
        setState(function(prev) {
            prev.status = "boot";
            return prev;
        });
    }, [
        state.status,
        (ref = userState.user) === null || ref === void 0 ? void 0 : ref.onboarded,
        (ref1 = userState.user) === null || ref1 === void 0 ? void 0 : ref1.trackingCode,
        isBrowser
    ]);
    /* Handle status changes */ (0,react.useEffect)(function() {
        if (!state.CommandBar) {
            // console.log("[CommandBar] not loaded");
            return;
        }
        switch(state.status){
            case "boot":
                // console.log("[CommandBar] boot");
                // Set default context
                state.CommandBar.setContext({
                    user: userState.user
                });
                setState(function(prev) {
                    prev.status = "context";
                    return prev;
                });
                break;
            case "context":
                break;
            case "ok":
                break;
        }
    }, [
        state.CommandBar,
        state.status,
        userState.user
    ]);
    (0,react.useEffect)(function() {
        var ref;
        // Load context when everything is available
        if (!state.CommandBar || "context" !== state.status || !router.isReady || !userState.isAuthenticated || !((ref = userState.user) === null || ref === void 0 ? void 0 : ref.onboarded) || !!process.env.TEST_ENV) return;
        // Register router
        state.CommandBar.addRouter(function(url) {
            return router.push(url);
        });
        void state.CommandBar.addEventSubscriber(function(name) {
            /**
       * On the first open event load habit and task data for search
       */ if (name === "opened" && !dataInitialized.current) {
                dataInitialized.current = true;
                initTaskData(state.CommandBar);
                initHabitData(state.CommandBar);
            }
        });
        // Add callback
        state.CommandBar.addCallback("launchSupport", handleLaunchSupport);
        /**
     * TODO (SS): This is not being used but would show up in commadbar search if we added an action
     * like jump to page. If this is removed, remove the record type in CB editor.
     */ state.CommandBar.addRecords("pages", [
            "planner",
            "stats",
            "tasks",
            "habits",
            "settings"
        ]);
        state.CommandBar.addMetadata("route", {
            route: router.route,
            pathname: router.pathname,
            asPath: router.asPath,
            params: router.params,
            query: router.query
        });
        setState(function(prev) {
            prev.status = "ok";
            return prev;
        });
    }, [
        router,
        state,
        userState.isAuthenticated,
        userState.user,
        handleLaunchSupport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommandBarContext.Provider, {
        value: {
            state: state
        },
        children: children
    });
};
/* harmony default export */ var context_CommandBarContext = ((/* unused pure expression or super */ null && (CommandBarContext)));


/***/ }),

/***/ 59484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SE": function() { return /* binding */ useUserContext; },
/* harmony export */   "fS": function() { return /* binding */ UserContextProvider; }
/* harmony export */ });
/* unused harmony export UserContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14101);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54517);
/* harmony import */ var _utils_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40673);
/* harmony import */ var _utils_local_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91325);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45110);
/* harmony import */ var _utils_platform__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94423);
/* harmony import */ var _AnalyticsContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89495);














var defaultState = {
    status: "init",
    isAuthenticated: false,
    user: (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .getLocalStorage */ .$o)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG, null)
};
function useUserState() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultState;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialState), state = ref[0], setState = ref[1];
    var ref1 = (0,_AnalyticsContext__WEBPACK_IMPORTED_MODULE_6__/* .useAnalyticsContext */ .Os)(), sentry = ref1.state.sentry;
    var actions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            load: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(refresh) {
                    var user, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log("Loading user", refresh);
                                setState(function(prevState) {
                                    if (!!refresh) return prevState;
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                        status: "loading"
                                    });
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.users.getCurrentUser */ .Tz.users.getCurrentUser()
                                ];
                            case 2:
                                user = _state.sent();
                                if (!user) {
                                    console.warn("Current user is null");
                                    setState(function(prevState) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                            user: null,
                                            isAuthenticated: false,
                                            status: "failed"
                                        });
                                    });
                                    (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG);
                                    (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt);
                                    return [
                                        2,
                                        state.user
                                    ];
                                }
                                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .setLocalStorage */ .qQ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG, user);
                                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt);
                                // Update user id in analytics
                                sentry === null || sentry === void 0 ? void 0 : sentry.setUser({
                                    id: user.trackingCode
                                });
                                setState(function(prevState) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                        user: user,
                                        isAuthenticated: true,
                                        status: "ok"
                                    });
                                });
                                return [
                                    2,
                                    user
                                ];
                            case 3:
                                err = _state.sent();
                                console.warn("Auth error", err);
                                setState(function(prevState) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                        isAuthenticated: false,
                                        status: "failed"
                                    });
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    state.user
                                ];
                        }
                    });
                });
                return function(refresh) {
                    return _ref.apply(this, arguments);
                };
            }(),
            logout: function() {
                setState(function(prevState) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                        status: "loading"
                    });
                });
                // clear user data
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG);
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_ACTIVE_QUESTS */ .pZ);
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REDIRECT */ .I7);
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt);
                // clear Sentry
                sentry === null || sentry === void 0 ? void 0 : sentry.configureScope(function(scope) {
                    scope.setUser({});
                });
                try {
                    setState(function(prevState) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                            user: null,
                            isAuthenticated: false,
                            status: "ok"
                        });
                    });
                    _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.users.logout */ .Tz.users.logout();
                } catch (err) {
                    console.error("Logout failed", err);
                    setState(function(prevState) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                            user: null,
                            isAuthenticated: false,
                            status: "error"
                        });
                    });
                }
            },
            delete: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                var err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setState(function(prevState) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                    status: "loading"
                                });
                            });
                            // clear user data
                            (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG);
                            (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REDIRECT */ .I7);
                            (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt);
                            (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)("onboarding.data");
                            // clear impersonation data
                            (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_ADMIN */ .K5);
                            (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_IMPERSONATE */ .uJ);
                            (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_IMPERSONATE_ERROR */ .go);
                            // clear Sentry
                            sentry === null || sentry === void 0 ? void 0 : sentry.configureScope(function(scope) {
                                scope.setUser({});
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.users.deleteCurrentUser */ .Tz.users.deleteCurrentUser()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.error("Delete failed", err);
                            setState(function(prevState) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                    user: null,
                                    isAuthenticated: false,
                                    status: "error"
                                });
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }),
            reset: function() {
                // clear user data
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG);
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REDIRECT */ .I7);
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt);
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)("onboarding.data");
                // clear impersonation data
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeLocalStorage */ .dZ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_ADMIN */ .K5);
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_IMPERSONATE */ .uJ);
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .removeSessionStorage */ .VV)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_IMPERSONATE_ERROR */ .go);
                // clear Sentry
                sentry === null || sentry === void 0 ? void 0 : sentry.configureScope(function(scope) {
                    scope.setUser({});
                });
                // reset state
                setState(initialState);
            },
            setStatus: function(status, isAuthenticated) {
                if (status === state.status && isAuthenticated === state.isAuthenticated) return;
                setState(function(prevState) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                        status: status,
                        isAuthenticated: isAuthenticated !== undefined ? isAuthenticated : prevState.isAuthenticated
                    });
                });
            },
            updateUser: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(id, user) {
                    var res, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!state.user) {
                                    console.warn("Cannot save user, user is not loaded");
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.users.updateCurrentUser */ .Tz.users.updateCurrentUser((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                        id: id
                                    }, user))
                                ];
                            case 2:
                                res = _state.sent();
                                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .setLocalStorage */ .qQ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG, res);
                                setState(function(prevState) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                        user: res
                                    });
                                });
                                return [
                                    2,
                                    res
                                ];
                            case 3:
                                err = _state.sent();
                                console.error("Failed to update user", (0,_utils_error__WEBPACK_IMPORTED_MODULE_3__/* .findErrorMessage */ .dR)(err));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    state.user
                                ];
                        }
                    });
                });
                return function(id, user) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // TODO (IW): Figure out how to handle nested settings
            setFeature: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(feature, val) {
                    var payload, res, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!state.user) {
                                    console.warn("Cannot set feature, user is not loaded", feature);
                                    return [
                                        2
                                    ];
                                }
                                payload = {
                                    features: (0,_utils_objects__WEBPACK_IMPORTED_MODULE_4__/* .patch */ .r$)(feature, val)
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.users.updateCurrentUser */ .Tz.users.updateCurrentUser(payload)
                                ];
                            case 2:
                                res = _state.sent();
                                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .setLocalStorage */ .qQ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG, res);
                                setState(function(prevState) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                        user: res
                                    });
                                });
                                return [
                                    2,
                                    res
                                ];
                            case 3:
                                err = _state.sent();
                                console.error("Failed to set feature", feature, val, state.user, err);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    state.user
                                ];
                        }
                    });
                });
                return function(feature, val) {
                    return _ref.apply(this, arguments);
                };
            }(),
            toggleFeature: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(feature, enabled) {
                    var payload, res, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!state.user) {
                                    console.warn("Cannot toggle feature, user is not loaded", feature);
                                    return [
                                        2
                                    ];
                                }
                                payload = {
                                    features: (0,_utils_objects__WEBPACK_IMPORTED_MODULE_4__/* .patch */ .r$)(feature, undefined !== enabled ? enabled : !(0,_utils_objects__WEBPACK_IMPORTED_MODULE_4__/* .walk */ ._p)(feature, state.user.features))
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.users.updateCurrentUser */ .Tz.users.updateCurrentUser(payload)
                                ];
                            case 2:
                                res = _state.sent();
                                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .setLocalStorage */ .qQ)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG, res);
                                setState(function(prevState) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                        user: res
                                    });
                                });
                                return [
                                    2,
                                    res
                                ];
                            case 3:
                                err = _state.sent();
                                console.error("Failed to toggle feature", feature, enabled, state.user, err);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    state.user
                                ];
                        }
                    });
                });
                return function(feature, enabled) {
                    return _ref.apply(this, arguments);
                };
            }(),
            addTrait: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(trait) {
                    var res, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.users.addInterest */ .Tz.users.addInterest(trait)
                                ];
                            case 1:
                                res = _state.sent();
                                setState(function(prevState) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                                        user: res
                                    });
                                });
                                return [
                                    2,
                                    res
                                ];
                            case 2:
                                err = _state.sent();
                                console.error("Failed to add trait", trait, state.user, err);
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(trait) {
                    return _ref.apply(this, arguments);
                };
            }(),
            upsertUser: function(user) {
                return setState(function(prevState) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, prevState), {
                        user: user
                    });
                });
            }
        };
    }, [
        initialState,
        sentry,
        state.isAuthenticated,
        state.status,
        state.user
    ]);
    return [
        state,
        actions
    ];
}
// Takes the default state in case there is no provider higher in the tree
var UserContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)([
    defaultState
]);
var UserContextProvider = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(useUserState(), 2), state = ref[0], actions = ref[1];
    var ref1 = (0,_AnalyticsContext__WEBPACK_IMPORTED_MODULE_6__/* .useAnalyticsContext */ .Os)(), sentry = ref1.state.sentry;
    /**
   * Handle 401 responses:
   * 1. Attempt "silent" reauthentication (one time)
   * 2. Set status "failed" to force new login if silent reauth didn't work
   */ var notAuthenticated = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(res) {
        if (/^401$/.test("".concat(res.status))) {
            console.warn("Request failed, user not authenticated");
            var user = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .getLocalStorage */ .$o)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_USER */ .kG, null);
            var attemptedReAuth = (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .getSessionStorage */ .G)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt);
            if (!!user && !attemptedReAuth) {
                console.log("Attempting reauth");
                actions === null || actions === void 0 ? void 0 : actions.setStatus("loading", false);
                var redirect = (0,_utils_platform__WEBPACK_IMPORTED_MODULE_5__/* .browser */ .Xh)().isBrowser ? "".concat(window.location.pathname).concat(window.location.search) : undefined;
                var urlParams = new URLSearchParams((0,_utils_platform__WEBPACK_IMPORTED_MODULE_5__/* .browser */ .Xh)().isBrowser ? window.location.search : "");
                var slackTeamId = urlParams.get("slackTeamId");
                var slackUserId = urlParams.get("slackUserId");
                var oauthState = {
                    redirect: redirect,
                    slackTeamId: slackTeamId,
                    slackUserId: slackUserId
                };
                (0,_utils_local_storage__WEBPACK_IMPORTED_MODULE_7__/* .setSessionStorage */ .t_)(_consts_storageKeys__WEBPACK_IMPORTED_MODULE_8__/* .LOCAL_STORAGE_AUTH_REAUTH */ .Vt, true);
                _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.users.authRedirect */ .Tz.users.authRedirect(user.provider || "google", user.email, oauthState);
            } else {
                actions === null || actions === void 0 ? void 0 : actions.setStatus("failed", false);
            }
        }
        return res;
    }, [
        actions
    ]);
    /**
   * Log server errors in Sentry
   */ var serverError = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(res) {
        if (/^5\d+$/.test("".concat(res.status))) {
            if (!!sentry) {
                var errorScope = new sentry.Scope().setLevel("error").setContext("request_config", res.config);
                sentry.captureMessage("[SERVER ERROR] ".concat(res.status, " ").concat(res.statusText), errorScope);
            }
        }
        return res;
    }, [
        sentry
    ]);
    // FIXME (IW): We have `reclaim.client.registerRequestHook`/`reclaim.client.registerRequestHook`,
    // but they stopped working at some point. The client config sets
    // `validateStatus` to always return true, so the `registerResponseHook` only
    // fires on errors. This really needs to get fixed.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // register interceptors
        var nextIds = {
            401: _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.client.client.interceptors.response.use */ .Tz.client.client.interceptors.response.use(notAuthenticated),
            500: _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.client.client.interceptors.response.use */ .Tz.client.client.interceptors.response.use(serverError)
        };
        // clear interceptors
        return function() {
            Object.values(nextIds).forEach(function(id) {
                return _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.client.client.interceptors.response.eject */ .Tz.client.client.interceptors.response.eject(id);
            });
        };
    }, [
        notAuthenticated,
        serverError
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserContext.Provider, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        value: [
            state,
            actions
        ]
    }, props));
};
// Sub-components can use this component. It will pick up the
// `state` and `actions` given by useUserState() higher in the
// component tree.
function useUserContext() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(UserContext);
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UserContext)));


/***/ }),

/***/ 85614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useAccountsActions; },
/* harmony export */   "v": function() { return /* binding */ useAccountsState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13665);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54517);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45110);
/* harmony import */ var _useCaptureError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59546);
/* harmony import */ var _useNotifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55973);
/* harmony import */ var _useOurRouter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52581);










var accountsAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)({
    accounts: undefined,
    connectedCalendars: undefined,
    accountsMap: undefined,
    connectedCalendarsMap: undefined
});
var setAccountsAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)(undefined, function(get, set, accountsData) {
    return set(accountsAtom, accountsData);
});
var initAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)(false);
var setInitAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)(undefined, function(get, set, initialized) {
    return set(initAtom, initialized);
});
var loadingAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)(false);
var setLoadingAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)(undefined, function(get, set, loading) {
    return set(loadingAtom, loading);
});
var loadingErrorAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)(undefined);
var setLoadingErrorAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .atom */ .cn)(undefined, function(get, set, loadingError) {
    return set(loadingErrorAtom, loadingError);
});
var useAccountsActions = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(setAccountsAtom), 2), setAccounts = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(setInitAtom), 2), setInit = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(setLoadingAtom), 2), setLoading = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(setLoadingErrorAtom), 2), setLoadingError = ref3[1];
    var router = (0,_useOurRouter__WEBPACK_IMPORTED_MODULE_5__/* .useOurRouter */ .ED)();
    var captureError = (0,_useCaptureError__WEBPACK_IMPORTED_MODULE_3__/* .useCaptureError */ .e)().captureError;
    var sendNotification = (0,_useNotifications__WEBPACK_IMPORTED_MODULE_4__/* .useNotifications */ .z)().sendNotification;
    var load = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var accounts, cause, connectedCalendars, accountsMap, connectedCalendarsMap;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    accounts = undefined;
                    void setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        _reclaim_api__WEBPACK_IMPORTED_MODULE_1__/* .reclaim.accounts.list */ .Tz.accounts.list()
                    ];
                case 2:
                    accounts = _state.sent();
                    void setLoadingError(undefined);
                    return [
                        3,
                        5
                    ];
                case 3:
                    cause = _state.sent();
                    void setLoadingError(new Error("Failed to load account info", {
                        cause: cause
                    }));
                    captureError(new Error("Failed to load account info", {
                        cause: cause
                    }), {
                        severity: "error",
                        statusCode: 5000
                    });
                    void router.push("/500");
                    return [
                        3,
                        5
                    ];
                case 4:
                    void setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    connectedCalendars = accounts === null || accounts === void 0 ? void 0 : accounts.flatMap(function(param) {
                        var connectedCalendars = param.connectedCalendars;
                        return connectedCalendars;
                    }).filter(function(i) {
                        return !!i;
                    });
                    accountsMap = accounts && (0,_utils_objects__WEBPACK_IMPORTED_MODULE_2__/* .normalize */ .Fv)(accounts, "id");
                    connectedCalendarsMap = connectedCalendars && (0,_utils_objects__WEBPACK_IMPORTED_MODULE_2__/* .normalize */ .Fv)(connectedCalendars, "id");
                    if (!!!accounts) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        setAccounts({
                            accounts: accounts,
                            connectedCalendars: connectedCalendars,
                            accountsMap: accountsMap,
                            connectedCalendarsMap: connectedCalendarsMap
                        })
                    ];
                case 6:
                    _state.sent();
                    return [
                        4,
                        setInit(true)
                    ];
                case 7:
                    _state.sent();
                    return [
                        2,
                        accounts
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    }), [
        setAccounts,
        setInit,
        setLoading,
        setLoadingError,
        captureError,
        router
    ]);
    var setNewMainAccount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(account) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!account.switchToMainURI) {
                            sendNotification({
                                message: "Cannot set account to main. Please contact support if this issue persists.",
                                type: "error"
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            _reclaim_api__WEBPACK_IMPORTED_MODULE_1__/* .reclaim.accounts.authRedirect */ .Tz.accounts.authRedirect(account.switchToMainURI, {
                                redirect: router.asPath,
                                accountId: account.id
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(account) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router.asPath,
        sendNotification
    ]);
    var deleteAccount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(accountId) {
            var cause;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _reclaim_api__WEBPACK_IMPORTED_MODULE_1__/* .reclaim.accounts["delete"] */ .Tz.accounts["delete"](accountId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            load()
                        ];
                    case 2:
                        _state.sent();
                        sendNotification({
                            message: "Account deleted."
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        cause = _state.sent();
                        sendNotification({
                            message: "Could not delete account. Please contact support if this problem persists.",
                            type: "error"
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(accountId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        load,
        sendNotification
    ]);
    var actions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            load: load,
            setNewMainAccount: setNewMainAccount,
            deleteAccount: deleteAccount
        };
    }, [
        load,
        setNewMainAccount,
        deleteAccount
    ]);
    return actions;
};
var useAccountsState = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(accountsAtom), 1), ref1 = ref[0], accounts = ref1.accounts, connectedCalendars = ref1.connectedCalendars, accountsMap = ref1.accountsMap, connectedCalendarsMap = ref1.connectedCalendarsMap;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(initAtom), 1), initialized = ref2[0];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(loadingAtom), 1), loading = ref3[0];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(loadingErrorAtom), 1), loadingError = ref4[0];
    var mainAccount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return accounts === null || accounts === void 0 ? void 0 : accounts.find(function(param) {
            var main = param.main;
            return main;
        });
    }, [
        accounts
    ]);
    var getCalendarColor = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(calendarId) {
        if (typeof calendarId !== "number" || !connectedCalendarsMap || !connectedCalendarsMap[calendarId]) return;
        return connectedCalendarsMap[calendarId].colorHex;
    }, [
        connectedCalendarsMap
    ]);
    var state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            accounts: accounts,
            initialized: initialized,
            loading: loading,
            loadingError: loadingError,
            connectedCalendars: connectedCalendars,
            mainAccount: mainAccount,
            accountsMap: accountsMap,
            connectedCalendarsMap: connectedCalendarsMap,
            getCalendarColor: getCalendarColor
        };
    }, [
        accounts,
        initialized,
        loading,
        loadingError,
        connectedCalendars,
        mainAccount,
        accountsMap,
        connectedCalendarsMap,
        getCalendarColor, 
    ]);
    return state;
};


/***/ }),

/***/ 43265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useMoment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13665);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63496);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54517);






var momentAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)(null);
var timer;
/**
 * Create a single global subcription for components to connect to. Onmount
 * will be called after the first component uses this hook. If no components
 * are actively using hook the unmount will unsubscibe. Additionally, set up
 * interval polling.
 */ momentAtom.onMount = function(setMomentAtom) {
    var unsubscribe = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .pipe */ .zG)(_reclaim_api__WEBPACK_IMPORTED_MODULE_0__/* .reclaim.moment.listAndWatch$$ */ .Tz.moment.listAndWatch$$(), (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .subscribe */ .Ld)(function(moment) {
        void setMomentAtom(moment);
    })).unsubscribe;
    var now = new Date();
    var updateTimer = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var moment;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _reclaim_api__WEBPACK_IMPORTED_MODULE_0__/* .reclaim.moment.list */ .Tz.moment.list()
                        ];
                    case 1:
                        moment = _state.sent();
                        void setMomentAtom(moment);
                        clearTimeout(timer);
                        timer = setTimeout(updateTimer, 1000 * 60); // 1min
                        return [
                            2
                        ];
                }
            });
        });
        return function updateTimer() {
            return _ref.apply(this, arguments);
        };
    }();
    // We want the update to trigger 1 second after every new minute.
    // HH:MM:01
    var secondsUntilStart = (61 - now.getSeconds()) * 1000;
    setTimeout(function() {
        return updateTimer();
    }, secondsUntilStart);
    return function() {
        clearTimeout(timer);
        unsubscribe();
    };
};
var useMoment = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .useAtom */ .KO)(momentAtom), 1), moment = ref[0];
    return moment;
};


/***/ }),

/***/ 1607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useNow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13665);


/**
 * Global interval that sets a new Date() every TIMEOUT ms.
 */ var TIMEOUT = 1000 * 60; // 1min
var nowAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(new Date());
nowAtom.onMount = function(setNowAtom) {
    var now = new Date();
    var timer;
    var updateTimer = function() {
        void setNowAtom(new Date());
        timer = setTimeout(updateTimer, TIMEOUT); // 1min
    };
    // We want the update to trigger 1 second after every new minute.
    // HH:MM:01
    var secondsUntilStart = (61 - now.getSeconds()) * 1000;
    setTimeout(function() {
        return updateTimer();
    }, secondsUntilStart);
    return function() {
        return clearTimeout(timer);
    };
};
var useNow = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .useAtom */ .KO)(nowAtom), 1), now = ref[0];
    return now;
};


/***/ }),

/***/ 1755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Iy": function() { return /* binding */ useQuestPopperState; },
  "UW": function() { return /* binding */ useQuestsActions; },
  "P_": function() { return /* binding */ useQuestsState; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(13665);
// EXTERNAL MODULE: ./node_modules/mui-modal-provider/dist/mui-modal-provider.esm.js
var mui_modal_provider_esm = __webpack_require__(56566);
// EXTERNAL MODULE: ./src/components/quests/quests.util.ts + 14 modules
var quests_util = __webpack_require__(32774);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/components/YoutubeVideoPlayerModal.tsx
var YoutubeVideoPlayerModal = __webpack_require__(66544);
;// CONCATENATED MODULE: ./src/components/quests/QuestVideoPlayerModal.tsx






var QuestVideoPlayerModal = function(_param) {
    var step = _param.step, onClose = _param.onClose, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "step",
        "onClose"
    ]);
    var onStepComplete = useQuestsActions().onStepComplete;
    var handleClose = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        onStepComplete();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeVideoPlayerModal/* YoutubeVideoPlayerModal */.N, (0,_object_spread/* default */.Z)({
        onClose: handleClose,
        videoId: step.videoLink,
        videoOptions: step.videoOptions
    }, rest));
};

// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 16 modules
var reclaim_api = __webpack_require__(54517);
// EXTERNAL MODULE: ./src/hooks/useNotifications.tsx
var useNotifications = __webpack_require__(55973);
// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
;// CONCATENATED MODULE: ./src/hooks/atoms/useQuests.ts













var activeQuestAtom = (0,esm/* atom */.cn)(undefined);
var questsAtom = (0,esm/* atom */.cn)(undefined);
var loadingQuestsAtom = (0,esm/* atom */.cn)(false);
var popperBackgroundedAtom = (0,esm/* atom */.cn)(false);
var popperActiveConfigAtom = (0,esm/* atom */.cn)(undefined);
var loadingErrorAtom = (0,esm/* atom */.cn)(undefined);
var useQuestsState = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(questsAtom), 1), quests = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(activeQuestAtom), 1), activeQuest = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(loadingQuestsAtom), 1), questsLoading = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(loadingErrorAtom), 1), loadingError = ref3[0];
    return {
        activeQuest: activeQuest,
        quests: quests,
        questsLoading: questsLoading,
        loadingError: loadingError
    };
};
var useQuestsActions = function(config) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(activeQuestAtom), 2), activeQuest = ref[0], _setActiveQuest = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(questsAtom), 2), quests = ref1[0], setQuests = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(popperActiveConfigAtom), 2), setPopperActiveConfig = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(popperBackgroundedAtom), 2), setPopperBackgrounded = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(loadingQuestsAtom), 2), setQuestsLoading = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(loadingErrorAtom), 2), setLoadingError = ref5[1];
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var sendNotification = (0,useNotifications/* useNotifications */.z)().sendNotification;
    var showModal = (0,mui_modal_provider_esm/* useModal */.d)({
        disableAutoDestroy: true
    }).showModal;
    var loadQuests = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var quests, cause, message;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setQuestsLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        reclaim_api/* reclaim.users.getCompletedQuests */.Tz.users.getCompletedQuests()
                    ];
                case 2:
                    quests = _state.sent();
                    setQuests(quests);
                    void setLoadingError(undefined);
                    return [
                        2,
                        quests
                    ];
                case 3:
                    cause = _state.sent();
                    message = "Failed to get setup guide progress.";
                    void setLoadingError(new Error(message, {
                        cause: cause
                    }));
                    sendNotification({
                        message: "".concat(message, " Please contact support if this problem persists."),
                        type: "error"
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    setQuestsLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }));
    var updateQuests = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(quests) {
        setQuests(quests);
    });
    var completeQuest = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(activeQuest) {
            var ref, ref1, ref2, quest, questComplete, newQuests, cause;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _setActiveQuest(undefined);
                        quest = (0,quests_util/* getQuestConfigFromActiveQuest */.N1)(activeQuest);
                        questComplete = !!(quests === null || quests === void 0 ? void 0 : (ref = quests[activeQuest.group]) === null || ref === void 0 ? void 0 : (ref1 = ref.quests) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[activeQuest.quest]) === null || ref2 === void 0 ? void 0 : ref2.complete);
                        // TODO: Update backend to accept new quests
                        if (activeQuest.quest === "HABITS_OVERVIEW_2") return [
                            2
                        ];
                        if (!(!(quest === null || quest === void 0 ? void 0 : quest.indeterminant) && !questComplete)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            reclaim_api/* reclaim.users.completeQuest */.Tz.users.completeQuest(activeQuest.quest)
                        ];
                    case 2:
                        newQuests = _state.sent();
                        setQuests(newQuests);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        cause = _state.sent();
                        sendNotification({
                            message: "Failed to save setup guide progress. Please contact support if this problem persists.",
                            type: "error"
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(activeQuest) {
            return _ref.apply(this, arguments);
        };
    }());
    var setNextStepAsActive = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(quest) {
        var next = (0,quests_util/* getNextQuestStep */.Wh)(quest);
        !!next ? _setActiveQuest((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, quest), {
            step: next.id
        })) : void completeQuest(quest);
    });
    var setPreviousStepAsActive = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(quest) {
        var previous = (0,quests_util/* getPreviousQuestStep */.u8)(quest);
        if (previous) {
            _setActiveQuest((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, quest), {
                step: previous.id
            }));
        }
    });
    var setActiveQuest = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(quest) {
        var goingBack = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (quest) {
            var step = (0,quests_util/* getQuestsStepConfig */.wh)(quest);
            if (!step) {
                _setActiveQuest(undefined);
                throw new Error("Must provide a quest step");
            } else {
                switch(step.type){
                    case "url":
                        {
                            if (!step.url) {
                                throw new Error("Must provide a url for url quest step");
                            }
                            window.open(step.url, "reclaim_slackintegration");
                            setNextStepAsActive(quest);
                            break;
                        }
                    case "redirect":
                        {
                            if (!step.redirect) {
                                throw new Error("Must provide a redirect path for redirect quest step");
                            }
                            if (goingBack) {
                                void router.push(step.redirectBack);
                                setPreviousStepAsActive(quest);
                                break;
                            } else {
                                void router.push(step.redirect);
                                setNextStepAsActive(quest);
                                break;
                            }
                        }
                    case "video":
                        {
                            _setActiveQuest(quest);
                            if (!step.videoLink) {
                                throw new Error("Must provide a video embed link to play video");
                            }
                            showModal(QuestVideoPlayerModal, {
                                step: step
                            });
                            break;
                        }
                    case "action":
                    case "confetti":
                    case "orb":
                        {
                            _setActiveQuest(quest);
                        }
                }
            }
        } else {
            _setActiveQuest(undefined);
            setPopperBackgrounded(false);
        }
    });
    var onStepComplete = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(user, usage) {
        if (!activeQuest) return;
        var next = (0,quests_util/* getNextQuestStep */.Wh)(activeQuest, user, usage);
        if (next) {
            setActiveQuest((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activeQuest), {
                step: next.id
            }));
        } else {
            void completeQuest(activeQuest);
        }
        return next;
    });
    var onBack = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (!activeQuest) return;
        var prev = (0,quests_util/* getPreviousQuestStep */.u8)(activeQuest);
        if (prev) {
            setActiveQuest((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activeQuest), {
                step: prev.id
            }), true);
        }
        return prev;
    });
    var setPopperActive = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(active) {
        if (active) {
            setPopperActiveConfig(config);
        } else {
            setPopperActiveConfig(undefined);
        }
    });
    var openActiveQuestPopper = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        setImmediate(function() {
            setPopperBackgrounded(false);
            setPopperActiveConfig(activeQuest);
        });
    });
    return {
        setActiveQuest: setActiveQuest,
        completeQuest: completeQuest,
        onStepComplete: onStepComplete,
        loadQuests: loadQuests,
        updateQuests: updateQuests,
        onBack: onBack,
        openActiveQuestPopper: openActiveQuestPopper,
        setPopperActive: setPopperActive,
        setPopperBackgrounded: setPopperBackgrounded
    };
};
var useQuestPopperState = function(config) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(popperActiveConfigAtom), 1), popperActiveConfig = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(popperBackgroundedAtom), 1), popperBackgrounded = ref1[0];
    var popperActive = (popperActiveConfig === null || popperActiveConfig === void 0 ? void 0 : popperActiveConfig.group) === (config === null || config === void 0 ? void 0 : config.group) && (popperActiveConfig === null || popperActiveConfig === void 0 ? void 0 : popperActiveConfig.quest) == (config === null || config === void 0 ? void 0 : config.quest) && (popperActiveConfig === null || popperActiveConfig === void 0 ? void 0 : popperActiveConfig.step) === (config === null || config === void 0 ? void 0 : config.step);
    return {
        anyPopperActive: !!popperActiveConfig,
        popperActive: popperActive,
        popperBackgrounded: popperBackgrounded
    };
};


/***/ }),

/***/ 10352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hd": function() { return /* binding */ useTeamActions; },
/* harmony export */   "Oo": function() { return /* binding */ useTeamState; },
/* harmony export */   "ZC": function() { return /* binding */ useTeamInitializer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13665);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59484);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54517);
/* harmony import */ var _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72897);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47310);
/* harmony import */ var _useCaptureError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59546);
/* harmony import */ var _useOurRouter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52581);
/* harmony import */ var _useSubscription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39123);













var DEFAULT_STATE = {
    team: undefined,
    userMembership: undefined,
    userIsSoleAdmin: undefined
};
var stateAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_8__/* .atom */ .cn)(DEFAULT_STATE);
// keep the initial state in an atom so the
// normal state isn't defined without it when
// navigating.  Don't want to read normal state
// in the initializer since it would trigger
// updates at root
var initialStateAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_8__/* .atom */ .cn)(undefined);
var teamToUseTeamState = function(team, user) {
    var userMembership = team.members.find(function(param) {
        var userId = param.teamMemberId.userId;
        return userId === user.id;
    });
    if (!userMembership) throw new Error("Could not find team member for user (".concat(user.id, ") on team (").concat(team.id, ")"));
    return Object.freeze({
        team: team,
        userMembership: userMembership,
        userIsSoleAdmin: (team === null || team === void 0 ? void 0 : team.adminCount) === 1 && (userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole) === _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_3__/* .MembershipRole.Admin */ .nJ.Admin
    });
};
var useTeamInitializer = function() {
    var setState = (0,jotai__WEBPACK_IMPORTED_MODULE_8__/* .useSetAtom */ .b9)(stateAtom);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_8__/* .useAtom */ .KO)(initialStateAtom), 2), initialTeam = ref[0], setInitialTeam = ref[1];
    var router = (0,_useOurRouter__WEBPACK_IMPORTED_MODULE_6__/* .useOurRouter */ .ED)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_1__/* .useUserContext */ .SE)(), 1), user = ref1[0].user;
    var getStartedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var captureError = (0,_useCaptureError__WEBPACK_IMPORTED_MODULE_5__/* .useCaptureError */ .e)().captureError;
    var isReady = !!user && !!initialTeam;
    var lastStateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(initialTeam && user ? teamToUseTeamState(initialTeam, user) : undefined);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        void (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var team, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!user || getStartedRef.current || initialTeam) return [
                            2
                        ];
                        getStartedRef.current = true;
                        return [
                            4,
                            _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.team.get */ .Tz.team.get()
                        ];
                    case 1:
                        team = _state.sent();
                        lastStateRef.current = teamToUseTeamState(team, user);
                        setState(lastStateRef.current);
                        setInitialTeam(team);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        captureError(new Error("Error while fetching team ([GET] /team/current)"), {
                            severity: "error",
                            statusCode: 5000
                        });
                        void router.push("/500");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        initialTeam,
        setInitialTeam,
        setState,
        user,
        router,
        captureError
    ]);
    (0,_useSubscription__WEBPACK_IMPORTED_MODULE_7__/* .useSubscriptionWithCallback */ .t)(_reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.team.watchTeam$$ */ .Tz.team.watchTeam$$, // because `user` is part of the enabled clause,
    // we can gaurentee it's always defined here
    function(teamPartial) {
        if (!lastStateRef.current) return;
        lastStateRef.current = teamToUseTeamState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, lastStateRef.current.team, teamPartial), user);
        setState(lastStateRef.current);
    }, isReady);
    return initialTeam;
};
var useTeamState = function(allowUndefined) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_8__/* .useAtom */ .KO)(stateAtom), 1), state = ref[0];
    if (!allowUndefined && (!state.team || !state.userMembership)) throw new Error("useTeamInitializer must return a Team object before useTeam can be called");
    return state;
};
var useTeamActions = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_1__/* .useUserContext */ .SE)(), 2), user = ref[0].user, userActions = ref[1];
    return {
        invite: (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_4__/* .useCallbackSafeRef */ .T)(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(invites, source) {
                var invitations;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.team.invite */ .Tz.team.invite(invites, source)
                            ];
                        case 1:
                            invitations = _state.sent();
                            return [
                                2,
                                invitations
                            ];
                    }
                });
            });
            return function(invites, source) {
                return _ref.apply(this, arguments);
            };
        }()),
        uninvite: (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_4__/* .useCallbackSafeRef */ .T)(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(id) {
                var err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.team.deleteInvitation */ .Tz.team.deleteInvitation(id)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            throw new Error("Could not revoke team invitation.", {
                                cause: err
                            });
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(id) {
                return _ref.apply(this, arguments);
            };
        }()),
        removeMember: (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_4__/* .useCallbackSafeRef */ .T)(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(userId) {
                var err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.team.deleteMember */ .Tz.team.deleteMember(userId)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            throw new Error("Could not remove user from team.", {
                                cause: err
                            });
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(userId) {
                return _ref.apply(this, arguments);
            };
        }()),
        patchMember: (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_4__/* .useCallbackSafeRef */ .T)(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(userId, member) {
                var err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.team.patchMember */ .Tz.team.patchMember(userId, member)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            throw new Error("Could not patch team member.", {
                                cause: err
                            });
                        case 3:
                            if (!(userId === (user === null || user === void 0 ? void 0 : user.id))) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                userActions === null || userActions === void 0 ? void 0 : userActions.load()
                            ];
                        case 4:
                            _state.sent();
                            _state.label = 5;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(userId, member) {
                return _ref.apply(this, arguments);
            };
        }()),
        patchTeam: (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_4__/* .useCallbackSafeRef */ .T)(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(team) {
                var err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.team.patchTeam */ .Tz.team.patchTeam(team)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            throw new Error("Could not remove user from team.", {
                                cause: err
                            });
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(team) {
                return _ref.apply(this, arguments);
            };
        }()),
        leaveTeam: (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_4__/* .useCallbackSafeRef */ .T)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var cause;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.team.leaveTeam */ .Tz.team.leaveTeam()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        cause = _state.sent();
                        throw new Error("Could not leave team.", {
                            cause: cause
                        });
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }))
    };
};


/***/ }),

/***/ 55521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useEventsSource; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26958);
/* harmony import */ var _utils_events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43835);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69119);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77349);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83894);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63500);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13665);
/* harmony import */ var src_reclaim_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54517);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63496);








var toAssignmentMap = function(events) {
    var value = {
        task: {},
        habit: {},
        "one-on-one": {},
        "scheduling-link": {}
    };
    events.forEach(function(e) {
        var ref = (0,_utils_events__WEBPACK_IMPORTED_MODULE_1__/* .getAssignmentIdAndType */ .yG)(e), assignmentId = ref.assignmentId, type = ref.type;
        if (value[type]) {
            value[type][assignmentId] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(value[type][assignmentId] || []).concat([
                e
            ]);
        }
    });
    return value;
};
var dataAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .atom */ .cn)(undefined);
var assignmentAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .atom */ .cn)(undefined);
var loadingAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .atom */ .cn)(true);
var sourceAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .atom */ .cn)(function(get) {
    return {
        events: get(dataAtom),
        loading: get(loadingAtom),
        assignmentMap: get(assignmentAtom)
    };
}, function(_, set, payload) {
    set(dataAtom, payload.events);
    set(assignmentAtom, payload.events ? toAssignmentMap(payload.events) : undefined);
    set(loadingAtom, payload.loading);
});
sourceAtom.onMount = function(set) {
    var INTERVAL_MS = _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .MILLISECONDS_PER_MINUTE */ .df * 10; // 10 minutes
    var lastSync;
    var subscription;
    var intervalId;
    var updateSubscription = function() {
        lastSync = Date.now();
        if (subscription) {
            subscription.unsubscribe();
        }
        subscription = (0,wonka__WEBPACK_IMPORTED_MODULE_5__/* .pipe */ .zG)(src_reclaim_api__WEBPACK_IMPORTED_MODULE_2__/* .reclaim.events.listAndWatch$$ */ .Tz.events.listAndWatch$$({
            sourceDetails: true,
            start: (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(new Date(), -30)),
            end: (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Date(), 12))
        }), (0,wonka__WEBPACK_IMPORTED_MODULE_5__/* .subscribe */ .Ld)(function(events) {
            return set({
                events: events,
                loading: false
            });
        }));
    };
    updateSubscription();
    intervalId = setInterval(updateSubscription, INTERVAL_MS);
    // pause interval syncs when tab is not visible. When the tab becomes visible re-sync
    // the subscription if the last sync was longer than the interval.
    document.addEventListener("visibilitychange", function() {
        if (document.hidden) {
            clearInterval(intervalId);
        } else {
            if (!lastSync || Date.now() - INTERVAL_MS > lastSync) {
                updateSubscription();
            }
            intervalId = setInterval(updateSubscription, INTERVAL_MS);
        }
    });
    return function() {
        clearInterval(intervalId);
        subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
    };
};
/**
 * This hook loads all user events 30 days in the past to 12 weeks into the future and watches for
 * changes in those ranges.
 */ var useEventsSource = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtom */ .KO)(sourceAtom), 1), source = ref[0];
    return source;
};


/***/ }),

/***/ 12396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KU": function() { return /* binding */ timeSchemesPolicyComparator; },
/* harmony export */   "eb": function() { return /* binding */ useTimeSchemesState; },
/* harmony export */   "hp": function() { return /* binding */ useTimeSchemesActions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13665);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ContactSupportButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8137);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54517);
/* harmony import */ var _utils_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56501);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47310);
/* harmony import */ var _useCaptureError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59546);
/* harmony import */ var _useOurRouter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52581);
/* harmony import */ var _useNotifications__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55973);
/* harmony import */ var _reclaim_api_TimeSchemes_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25606);
/* harmony import */ var _utils_sort__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14023);















var timeSchemesPolicyComparator = (0,_utils_sort__WEBPACK_IMPORTED_MODULE_9__/* .makeOrderedListComparator */ .LU)([
    "WORK",
    "MEETING",
    "PERSONAL"
]);
var getTimeSchemes = function() {
    return _reclaim_api__WEBPACK_IMPORTED_MODULE_3__/* .reclaim.timeSchemes.list */ .Tz.timeSchemes.list();
};
var errorNotificationRefAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_10__/* .atom */ .cn)(false);
var ref = (0,_utils_react__WEBPACK_IMPORTED_MODULE_4__/* .makeReloadableHook */ .ff)(getTimeSchemes, {
    dataKey: "timeSchemes",
    errorizer: "Failed to get time schemes"
}), useHook = ref.useHook, dataAtom = ref.dataAtom;
var useTimeSchemesState = function(eventType) {
    var ref = useHook(), timeSchemes = ref.timeSchemes, loading = ref.loading, error = ref.error;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_10__/* .useAtom */ .KO)(errorNotificationRefAtom), 2), errorNotificationRef = ref1[0], setErrorNotificationRef = ref1[1];
    var sendNotification = (0,_useNotifications__WEBPACK_IMPORTED_MODULE_8__/* .useNotifications */ .z)().sendNotification;
    var processedTimeSchemes = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        return (ref = eventType ? (0,_reclaim_api_TimeSchemes_utils__WEBPACK_IMPORTED_MODULE_12__/* .filterTimeSchemesByEventType */ .r)(eventType, timeSchemes) : timeSchemes) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
            return timeSchemesPolicyComparator(a.policyType, b.policyType);
        });
    }, [
        timeSchemes,
        eventType
    ]);
    var derivedError;
    if (error) {
        derivedError = typeof error === "string" ? new Error(error) : error;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (error && !errorNotificationRef) {
            setErrorNotificationRef(true);
            sendNotification({
                message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "There was an unexpected error loading your hours. Please",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactSupportButton__WEBPACK_IMPORTED_MODULE_2__/* .ContactSupportButton */ .u, {
                            variant: "link",
                            lead: "I'm having trouble loading my hours",
                            children: "contact support"
                        }),
                        " ",
                        "if this problem persists."
                    ]
                }),
                type: "error"
            });
        }
    }, [
        error,
        errorNotificationRef,
        sendNotification,
        setErrorNotificationRef
    ]);
    return {
        timeSchemes: processedTimeSchemes,
        loading: loading,
        error: derivedError
    };
};
var useTimeSchemesActions = function() {
    var captureError = (0,_useCaptureError__WEBPACK_IMPORTED_MODULE_6__/* .useCaptureError */ .e)().captureError;
    var router = (0,_useOurRouter__WEBPACK_IMPORTED_MODULE_7__/* .useOurRouter */ .ED)();
    var setTimeSchemes = (0,jotai__WEBPACK_IMPORTED_MODULE_10__/* .useSetAtom */ .b9)(dataAtom);
    var ref = useHook(), reloadTimeSchemes = ref.reload;
    var syncTimeSchemes = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_5__/* .useCallbackSafeRef */ .T)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var schemes, cause;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _reclaim_api__WEBPACK_IMPORTED_MODULE_3__/* .reclaim.timeSchemes.list */ .Tz.timeSchemes.list()
                    ];
                case 1:
                    schemes = _state.sent();
                    return [
                        4,
                        setTimeSchemes(schemes)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    cause = _state.sent();
                    captureError(new Error("Failed to sync Time Scheme list", {
                        cause: cause
                    }), {
                        severity: "error",
                        statusCode: 5000
                    });
                    void router.push("/500");
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }));
    var createTimeScheme = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_5__/* .useCallbackSafeRef */ .T)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(scheme) {
            var timeScheme, schemes, cause;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            _reclaim_api__WEBPACK_IMPORTED_MODULE_3__/* .reclaim.timeSchemes.create */ .Tz.timeSchemes.create(scheme)
                        ];
                    case 1:
                        timeScheme = _state.sent();
                        return [
                            4,
                            getTimeSchemes()
                        ];
                    case 2:
                        schemes = _state.sent();
                        return [
                            4,
                            setTimeSchemes(schemes)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            timeScheme
                        ];
                    case 4:
                        cause = _state.sent();
                        captureError(new Error("Failed to create Time Scheme", {
                            cause: cause
                        }), {
                            severity: "error",
                            statusCode: 5000
                        });
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(scheme) {
            return _ref.apply(this, arguments);
        };
    }());
    var updateTimeScheme = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_5__/* .useCallbackSafeRef */ .T)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(schemeId, update) {
            var schemes, cause;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            _reclaim_api__WEBPACK_IMPORTED_MODULE_3__/* .reclaim.timeSchemes.update */ .Tz.timeSchemes.update(schemeId, update)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            getTimeSchemes()
                        ];
                    case 2:
                        schemes = _state.sent();
                        return [
                            4,
                            setTimeSchemes(schemes)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        cause = _state.sent();
                        captureError(new Error("Failed to update Time Scheme", {
                            cause: cause
                        }), {
                            severity: "error",
                            statusCode: 5000
                        });
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(schemeId, update) {
            return _ref.apply(this, arguments);
        };
    }());
    return {
        syncTimeSchemes: syncTimeSchemes,
        createTimeScheme: createTimeScheme,
        updateTimeScheme: updateTimeScheme,
        reloadTimeSchemes: reloadTimeSchemes
    };
};


/***/ }),

/***/ 47310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useCallbackSafeRef; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Returns a function that behaves identically to the one passed in, but whose reference never changes
 * @param callback The functional callback
 * @returns A function whose reference never changes
 */ var useCallbackSafeRef = function(callback) {
    var _outCb;
    var outCb = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    outCb.current = callback;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (_outCb = outCb).current.apply(_outCb, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(args));
    }, []);
};


/***/ }),

/***/ 59546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ rawCaptureError; },
/* harmony export */   "e": function() { return /* binding */ useCaptureError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13665);
/* harmony import */ var _context_AnalyticsContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89495);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26958);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);






var DEFAULT_ERROR_HANDLER_PROVIDER = "SENTRY";
var SentryErrorProviderImplementation = {
    implementation: function(sentry, error) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (!sentry) return;
        var tags = options.tags, _severity = options.severity, severity = _severity === void 0 ? "error" : _severity, statusCode = options.statusCode;
        var tagsMutated = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, tags);
        if (statusCode) {
            tagsMutated.statusCode = statusCode;
            tagsMutated.isStatusCoded = true;
        }
        // https://docs.sentry.io/platforms/javascript/usage/set-level/
        sentry.withScope(function(scope) {
            scope.setLevel(severity);
            sentry.captureException(error, {
                tags: tagsMutated
            });
        });
    }
};
var LocalErrorProviderImplementation = {
    implementation: function(sentry, error) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        switch(options.severity || "error"){
            case "error":
            case "fatal":
                // eslint-disable-next-line no-console
                console.error("CAPTURED ERROR", options.severity, error, options);
                break;
            case "warning":
                // eslint-disable-next-line no-console
                console.warn("CAPTURED ERROR", options.severity, error, options);
                break;
            default:
                // eslint-disable-next-line no-console
                console.log("CAPTURED ERROR", options.severity, error, options);
                break;
        }
    }
};
var ERROR_PROVIDER_IMPLEMENTATION = {
    SENTRY: SentryErrorProviderImplementation,
    UNKNOWN: LocalErrorProviderImplementation
};
var rawCaptureError = ERROR_PROVIDER_IMPLEMENTATION[ false ? 0 : DEFAULT_ERROR_HANDLER_PROVIDER].implementation;
/**
 * Map of recently captured errors and when they were captured (unix time)
 */ var capturedErrorMapAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .atom */ .cn)(new Map());
/**
 * To try and group `Error` objects that aren't memoized we hash them
 * @param error An `Error`
 * @returns A hash
 */ var hashError = function(error) {
    return "".concat(error.constructor.name, "|").concat(error.message);
};
/**
 * Hook for capturing errors
 * @param options
 * @returns A function to capture errors
 */ var useCaptureError = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _debounceSameErrorMs = options.debounceSameErrorMs, debounceSameErrorMs = _debounceSameErrorMs === void 0 ? _utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .MILLISECONDS_PER_HOUR */ .Dv : _debounceSameErrorMs;
    var ref = (0,_context_AnalyticsContext__WEBPACK_IMPORTED_MODULE_0__/* .useAnalyticsContext */ .Os)(), sentry = ref.state.sentry;
    // We don't want to manage this as updatable state.  We
    // want to make changes in it without triggering
    // re-renders.  Since `Map` objects are PBR this is no
    // biggie.
    var capturedErrorMap = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtomValue */ .Dv)(capturedErrorMapAtom);
    var captureError = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function(error) {
        var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tags = ref.tags, severity = ref.severity, statusCode = ref.statusCode;
        var ms = new Date().getTime();
        var errorKey = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(error, Error) ? hashError(error) : error;
        Array.from(capturedErrorMap.keys()).forEach(function(key) {
            var capturedErrorMs = capturedErrorMap.get(key);
            if (capturedErrorMs && ms - capturedErrorMs > debounceSameErrorMs) capturedErrorMap.delete(key);
        });
        var capturedErrorMs = capturedErrorMap.get(errorKey);
        if (!capturedErrorMs) {
            capturedErrorMap.set(errorKey, ms);
            rawCaptureError(sentry, error, {
                tags: tags,
                severity: severity,
                statusCode: statusCode
            });
        }
    });
    return {
        captureError: captureError
    };
};


/***/ }),

/***/ 68118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ useConfettiCannon; }
});

// EXTERNAL MODULE: ./node_modules/mui-modal-provider/dist/mui-modal-provider.esm.js
var mui_modal_provider_esm = __webpack_require__(56566);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(96026);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-display-name/lib/getDisplayName.js
var getDisplayName = __webpack_require__(11914);
;// CONCATENATED MODULE: ./node_modules/theming/dist/theming.esm.js






function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function theming_esm_extends() {
  theming_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return theming_esm_extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function isObject(obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}

function createThemeProvider(context) {
  var ThemeProvider =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(ThemeProvider, _React$Component);

    function ThemeProvider() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cachedTheme", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastOuterTheme", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastTheme", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderProvider", function (outerTheme) {
        var children = _this.props.children;
        return react.createElement(context.Provider, {
          value: _this.getTheme(outerTheme)
        }, children);
      });

      return _this;
    }

    var _proto = ThemeProvider.prototype;

    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    _proto.getTheme = function getTheme(outerTheme) {
      if (this.props.theme !== this.lastTheme || outerTheme !== this.lastOuterTheme || !this.cachedTheme) {
        this.lastOuterTheme = outerTheme;
        this.lastTheme = this.props.theme;

        if (typeof this.lastTheme === 'function') {
          var theme = this.props.theme;
          this.cachedTheme = theme(outerTheme);
           false ? 0 : void 0;
        } else {
          var _theme = this.props.theme;
           false ? 0 : void 0;
          this.cachedTheme = outerTheme ? theming_esm_extends({}, outerTheme, _theme) : _theme;
        }
      }

      return this.cachedTheme;
    };

    _proto.render = function render() {
      var children = this.props.children;

      if (!children) {
        return null;
      }

      return react.createElement(context.Consumer, null, this.renderProvider);
    };

    return ThemeProvider;
  }(react.Component);

  if (false) {}

  return ThemeProvider;
}

function createWithTheme(context) {
  return function hoc(Component) {
    var withTheme = react.forwardRef(function (props, ref) {
      return react.createElement(context.Consumer, null, function (theme) {
         false ? 0 : void 0;
        return react.createElement(Component, theming_esm_extends({
          theme: theme,
          ref: ref
        }, props));
      });
    });

    if (false) {}

    hoist_non_react_statics_cjs_default()(withTheme, Component);
    return withTheme;
  };
}

function createUseTheme(context) {
  var useTheme = function useTheme() {
    var theme = react.useContext(context);
     false ? 0 : void 0;
    return theme;
  };

  return useTheme;
}

function createTheming(context) {
  return {
    context: context,
    withTheme: createWithTheme(context),
    useTheme: createUseTheme(context),
    ThemeProvider: createThemeProvider(context)
  };
}

var theming_esm_ThemeContext = (0,react.createContext)();

var _createTheming = createTheming(theming_esm_ThemeContext),
    withTheme = _createTheming.withTheme,
    ThemeProvider = _createTheming.ThemeProvider,
    useTheme = _createTheming.useTheme;



// EXTERNAL MODULE: ./node_modules/is-in-browser/dist/module.js
var dist_module = __webpack_require__(33827);
// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js + 5 modules
var jss_esm = __webpack_require__(33512);
// EXTERNAL MODULE: ./node_modules/jss-plugin-rule-value-function/dist/jss-plugin-rule-value-function.esm.js
var jss_plugin_rule_value_function_esm = __webpack_require__(27202);
// EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js + 1 modules
var es = __webpack_require__(98123);
;// CONCATENATED MODULE: ./node_modules/jss-plugin-rule-value-observable/dist/jss-plugin-rule-value-observable.esm.js



var isObservable = function isObservable(value) {
  return value && value[es/* default */.Z] && value === value[es/* default */.Z]();
};

var observablePlugin = function observablePlugin(updateOptions) {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (!isObservable(decl)) return null;
      var style$ = decl;
      var rule = (0,jss_esm/* createRule */.JH)(name, {}, options); // TODO
      // Call `stream.subscribe()` returns a subscription, which should be explicitly
      // unsubscribed from when we know this sheet is no longer needed.

      style$.subscribe(function (style) {
        for (var prop in style) {
          rule.prop(prop, style[prop], updateOptions);
        }
      });
      return rule;
    },
    onProcessRule: function onProcessRule(rule) {
      if (rule && rule.type !== 'style') return;
      var styleRule = rule;
      var style = styleRule.style;

      var _loop = function _loop(prop) {
        var value = style[prop];
        if (!isObservable(value)) return "continue";
        delete style[prop];
        value.subscribe({
          next: function next(nextValue) {
            styleRule.prop(prop, nextValue, updateOptions);
          }
        });
      };

      for (var prop in style) {
        var _ret = _loop(prop);

        if (_ret === "continue") continue;
      }
    }
  };
};

/* harmony default export */ var jss_plugin_rule_value_observable_esm = (observablePlugin);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-template/dist/jss-plugin-template.esm.js


var semiWithNl = /;\n/;
/**
 * Naive CSS parser.
 * - Supports only rule body (no selectors)
 * - Requires semicolon and new line after the value (except of last line)
 * - No nested rules support
 */

var parse = function parse(cssText) {
  var style = {};
  var split = cssText.split(semiWithNl);

  for (var i = 0; i < split.length; i++) {
    var decl = (split[i] || '').trim();
    if (!decl) continue;
    var colonIndex = decl.indexOf(':');

    if (colonIndex === -1) {
       false ? 0 : void 0;
      continue;
    }

    var prop = decl.substr(0, colonIndex).trim();
    var value = decl.substr(colonIndex + 1).trim();
    style[prop] = value;
  }

  return style;
};

var onProcessRule = function onProcessRule(rule) {
  if (typeof rule.style === 'string') {
    rule.style = parse(rule.style);
  }
};

function templatePlugin() {
  return {
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ var jss_plugin_template_esm = (templatePlugin);

// EXTERNAL MODULE: ./node_modules/jss-plugin-global/dist/jss-plugin-global.esm.js
var jss_plugin_global_esm = __webpack_require__(5019);
;// CONCATENATED MODULE: ./node_modules/jss-plugin-extend/dist/jss-plugin-extend.esm.js



var jss_plugin_extend_esm_isObject = function isObject(obj) {
  return obj && typeof obj === 'object' && !Array.isArray(obj);
};

var valueNs = "extendCurrValue" + Date.now();

function mergeExtend(style, rule, sheet, newStyle) {
  var extendType = typeof style.extend; // Extend using a rule name.

  if (extendType === 'string') {
    if (!sheet) return;
    var refRule = sheet.getRule(style.extend);
    if (!refRule) return;

    if (refRule === rule) {
       false ? 0 : void 0;
      return;
    }

    var parent = refRule.options.parent;

    if (parent) {
      var originalStyle = parent.rules.raw[style.extend];
      extend(originalStyle, rule, sheet, newStyle);
    }

    return;
  } // Extend using an array.


  if (Array.isArray(style.extend)) {
    for (var index = 0; index < style.extend.length; index++) {
      var singleExtend = style.extend[index];
      var singleStyle = typeof singleExtend === 'string' ? (0,esm_extends/* default */.Z)({}, style, {
        extend: singleExtend
      }) : style.extend[index];
      extend(singleStyle, rule, sheet, newStyle);
    }

    return;
  } // Extend is a style object.


  for (var prop in style.extend) {
    if (prop === 'extend') {
      extend(style.extend.extend, rule, sheet, newStyle);
      continue;
    }

    if (jss_plugin_extend_esm_isObject(style.extend[prop])) {
      if (!(prop in newStyle)) newStyle[prop] = {};
      extend(style.extend[prop], rule, sheet, newStyle[prop]);
      continue;
    }

    newStyle[prop] = style.extend[prop];
  }
}

function mergeRest(style, rule, sheet, newStyle) {
  // Copy base style.
  for (var prop in style) {
    if (prop === 'extend') continue;

    if (jss_plugin_extend_esm_isObject(newStyle[prop]) && jss_plugin_extend_esm_isObject(style[prop])) {
      extend(style[prop], rule, sheet, newStyle[prop]);
      continue;
    }

    if (jss_plugin_extend_esm_isObject(style[prop])) {
      newStyle[prop] = extend(style[prop], rule, sheet);
      continue;
    }

    newStyle[prop] = style[prop];
  }
}
/**
 * Recursively extend styles.
 */


function extend(style, rule, sheet, newStyle) {
  if (newStyle === void 0) {
    newStyle = {};
  }

  mergeExtend(style, rule, sheet, newStyle);
  mergeRest(style, rule, sheet, newStyle);
  return newStyle;
}
/**
 * Handle `extend` property.
 */


function jssExtend() {
  function onProcessStyle(style, rule, sheet) {
    if ('extend' in style) return extend(style, rule, sheet);
    return style;
  }

  function onChangeValue(value, prop, rule) {
    if (prop !== 'extend') return value; // Value is empty, remove properties set previously.

    if (value == null || value === false) {
      for (var key in rule[valueNs]) {
        rule.prop(key, null);
      }

      rule[valueNs] = null;
      return null;
    }

    if (typeof value === 'object') {
      for (var _key in value) {
        rule.prop(_key, value[_key]);
      }

      rule[valueNs] = value;
    } // Make sure we don't set the value in the core.


    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_extend_esm = (jssExtend);

// EXTERNAL MODULE: ./node_modules/jss-plugin-nested/dist/jss-plugin-nested.esm.js
var jss_plugin_nested_esm = __webpack_require__(63057);
;// CONCATENATED MODULE: ./node_modules/jss-plugin-compose/dist/jss-plugin-compose.esm.js


/**
 * Set selector.
 *
 * @param original rule
 * @param className class string
 * @return flag indicating function was successfull or not
 */

function registerClass(rule, className) {
  // Skip falsy values
  if (!className) return true; // Support array of class names `{composes: ['foo', 'bar']}`

  if (Array.isArray(className)) {
    for (var index = 0; index < className.length; index++) {
      var isSetted = registerClass(rule, className[index]);
      if (!isSetted) return false;
    }

    return true;
  } // Support space separated class names `{composes: 'foo bar'}`


  if (className.indexOf(' ') > -1) {
    return registerClass(rule, className.split(' '));
  }

  var parent = rule.options.parent; // It is a ref to a local rule.

  if (className[0] === '$') {
    var refRule = parent.getRule(className.substr(1));

    if (!refRule) {
       false ? 0 : void 0;
      return false;
    }

    if (refRule === rule) {
       false ? 0 : void 0;
      return false;
    }

    parent.classes[rule.key] += " " + parent.classes[refRule.key];
    return true;
  }

  parent.classes[rule.key] += " " + className;
  return true;
}
/**
 * Convert compose property to additional class, remove property from original styles.
 */


function jssCompose() {
  function onProcessStyle(style, rule) {
    if (!('composes' in style)) return style;
    registerClass(rule, style.composes); // Remove composes property to prevent infinite loop.

    delete style.composes;
    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ var jss_plugin_compose_esm = (jssCompose);

// EXTERNAL MODULE: ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js + 1 modules
var jss_plugin_camel_case_esm = __webpack_require__(16345);
// EXTERNAL MODULE: ./node_modules/jss-plugin-default-unit/dist/jss-plugin-default-unit.esm.js
var jss_plugin_default_unit_esm = __webpack_require__(83961);
;// CONCATENATED MODULE: ./node_modules/jss-plugin-expand/dist/jss-plugin-expand.esm.js
/**
 * A scheme for converting properties from array to regular style.
 * All properties listed below will be transformed to a string separated by space.
 */
var propArray = {
  'background-size': true,
  'background-position': true,
  border: true,
  'border-bottom': true,
  'border-left': true,
  'border-top': true,
  'border-right': true,
  'border-radius': true,
  'border-image': true,
  'border-width': true,
  'border-style': true,
  'border-color': true,
  'box-shadow': true,
  flex: true,
  margin: true,
  padding: true,
  outline: true,
  'transform-origin': true,
  transform: true,
  transition: true
  /**
   * A scheme for converting arrays to regular styles inside of objects.
   * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
   */

};
var propArrayInObj = {
  position: true,
  // background-position
  size: true // background-size

  /**
   * A scheme for parsing and building correct styles from passed objects.
   */

};
var propObj = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  'border-top': {
    width: null,
    style: null,
    color: null
  },
  'border-right': {
    width: null,
    style: null,
    color: null
  },
  'border-bottom': {
    width: null,
    style: null,
    color: null
  },
  'border-left': {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  'list-style': {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    'timing-function': null,
    timingFunction: null,
    // Needed for avoiding comilation issues with jss-plugin-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    'timing-function': null,
    timingFunction: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    delay: null,
    'iteration-count': null,
    iterationCount: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    direction: null,
    'fill-mode': null,
    fillMode: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    'play-state': null,
    playState: null // Needed to avoid compilation issues with jss-plugin-camel-case

  },
  'box-shadow': {
    x: 0,
    y: 0,
    blur: 0,
    spread: 0,
    color: null,
    inset: null
  },
  'text-shadow': {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }
  /**
   * A scheme for converting non-standart properties inside object.
   * For e.g.: include 'border-radius' property inside 'border' object.
   */

};
var customPropObj = {
  border: {
    radius: 'border-radius',
    image: 'border-image',
    width: 'border-width',
    style: 'border-style',
    color: 'border-color'
  },
  'border-bottom': {
    width: 'border-bottom-width',
    style: 'border-bottom-style',
    color: 'border-bottom-color'
  },
  'border-top': {
    width: 'border-top-width',
    style: 'border-top-style',
    color: 'border-top-color'
  },
  'border-left': {
    width: 'border-left-width',
    style: 'border-left-style',
    color: 'border-left-color'
  },
  'border-right': {
    width: 'border-right-width',
    style: 'border-right-style',
    color: 'border-right-color'
  },
  background: {
    size: 'background-size',
    image: 'background-image'
  },
  font: {
    style: 'font-style',
    variant: 'font-variant',
    weight: 'font-weight',
    stretch: 'font-stretch',
    size: 'font-size',
    family: 'font-family',
    lineHeight: 'line-height',
    // Needed to avoid compilation issues with jss-plugin-camel-case
    'line-height': 'line-height'
  },
  flex: {
    grow: 'flex-grow',
    basis: 'flex-basis',
    direction: 'flex-direction',
    wrap: 'flex-wrap',
    flow: 'flex-flow',
    shrink: 'flex-shrink'
  },
  align: {
    self: 'align-self',
    items: 'align-items',
    content: 'align-content'
  },
  grid: {
    'template-columns': 'grid-template-columns',
    templateColumns: 'grid-template-columns',
    'template-rows': 'grid-template-rows',
    templateRows: 'grid-template-rows',
    'template-areas': 'grid-template-areas',
    templateAreas: 'grid-template-areas',
    template: 'grid-template',
    'auto-columns': 'grid-auto-columns',
    autoColumns: 'grid-auto-columns',
    'auto-rows': 'grid-auto-rows',
    autoRows: 'grid-auto-rows',
    'auto-flow': 'grid-auto-flow',
    autoFlow: 'grid-auto-flow',
    row: 'grid-row',
    column: 'grid-column',
    'row-start': 'grid-row-start',
    rowStart: 'grid-row-start',
    'row-end': 'grid-row-end',
    rowEnd: 'grid-row-end',
    'column-start': 'grid-column-start',
    columnStart: 'grid-column-start',
    'column-end': 'grid-column-end',
    columnEnd: 'grid-column-end',
    area: 'grid-area',
    gap: 'grid-gap',
    'row-gap': 'grid-row-gap',
    rowGap: 'grid-row-gap',
    'column-gap': 'grid-column-gap',
    columnGap: 'grid-column-gap'
  }
};

/* eslint-disable no-use-before-define */
/**
 * Map values by given prop.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {String} original rule
 * @return {String} mapped values
 */

function mapValuesByProp(value, prop, rule) {
  return value.map(function (item) {
    return objectToArray(item, prop, rule, false, true);
  });
}
/**
 * Convert array to nested array, if needed
 */


function processArray(value, prop, scheme, rule) {
  if (scheme[prop] == null) return value;
  if (value.length === 0) return [];
  if (Array.isArray(value[0])) return processArray(value[0], prop, scheme, rule);

  if (typeof value[0] === 'object') {
    return mapValuesByProp(value, prop, rule);
  }

  return [value];
}
/**
 * Convert object to array.
 */


function objectToArray(value, prop, rule, isFallback, isInArray) {
  if (!(propObj[prop] || customPropObj[prop])) return [];
  var result = []; // Check if exists any non-standard property

  if (customPropObj[prop]) {
    // eslint-disable-next-line no-param-reassign
    value = customPropsToStyle(value, rule, customPropObj[prop], isFallback);
  } // Pass throught all standart props


  if (Object.keys(value).length) {
    for (var baseProp in propObj[prop]) {
      if (value[baseProp]) {
        if (Array.isArray(value[baseProp])) {
          result.push(propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(' '));
        } else result.push(value[baseProp]);

        continue;
      } // Add default value from props config.


      if (propObj[prop][baseProp] != null) {
        result.push(propObj[prop][baseProp]);
      }
    }
  }

  if (!result.length || isInArray) return result;
  return [result];
}
/**
 * Convert custom properties values to styles adding them to rule directly
 */


function customPropsToStyle(value, rule, customProps, isFallback) {
  for (var prop in customProps) {
    var propName = customProps[prop]; // If current property doesn't exist already in rule - add new one

    if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
      var _styleDetector;

      var appendedValue = styleDetector((_styleDetector = {}, _styleDetector[propName] = value[prop], _styleDetector), rule)[propName]; // Add style directly in rule

      if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
    } // Delete converted property to avoid double converting


    delete value[prop];
  }

  return value;
}
/**
 * Detect if a style needs to be converted.
 */


function styleDetector(style, rule, isFallback) {
  for (var prop in style) {
    var value = style[prop];

    if (Array.isArray(value)) {
      // Check double arrays to avoid recursion.
      if (!Array.isArray(value[0])) {
        if (prop === 'fallbacks') {
          for (var index = 0; index < style.fallbacks.length; index++) {
            style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
          }

          continue;
        }

        style[prop] = processArray(value, prop, propArray, rule); // Avoid creating properties with empty values

        if (!style[prop].length) delete style[prop];
      }
    } else if (typeof value === 'object') {
      if (prop === 'fallbacks') {
        style.fallbacks = styleDetector(style.fallbacks, rule, true);
        continue;
      }

      style[prop] = objectToArray(value, prop, rule, isFallback); // Avoid creating properties with empty values

      if (!style[prop].length) delete style[prop];
    } // Maybe a computed value resulting in an empty string
    else if (style[prop] === '') delete style[prop];
  }

  return style;
}
/**
 * Adds possibility to write expanded styles.
 */


function jssExpand() {
  function onProcessStyle(style, rule) {
    if (!style || rule.type !== 'style') return style;

    if (Array.isArray(style)) {
      // Pass rules one by one and reformat them
      for (var index = 0; index < style.length; index++) {
        style[index] = styleDetector(style[index], rule);
      }

      return style;
    }

    return styleDetector(style, rule);
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ var jss_plugin_expand_esm = (jssExpand);

// EXTERNAL MODULE: ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js + 7 modules
var jss_plugin_vendor_prefixer_esm = __webpack_require__(79368);
// EXTERNAL MODULE: ./node_modules/jss-plugin-props-sort/dist/jss-plugin-props-sort.esm.js
var jss_plugin_props_sort_esm = __webpack_require__(26895);
;// CONCATENATED MODULE: ./node_modules/jss-preset-default/dist/jss-preset-default.esm.js













var create = function create(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    plugins: [(0,jss_plugin_rule_value_function_esm/* default */.Z)(), jss_plugin_rule_value_observable_esm(options.observable), jss_plugin_template_esm(), (0,jss_plugin_global_esm/* default */.Z)(), jss_plugin_extend_esm(), (0,jss_plugin_nested_esm/* default */.Z)(), jss_plugin_compose_esm(), (0,jss_plugin_camel_case_esm/* default */.Z)(), (0,jss_plugin_default_unit_esm/* default */.Z)(options.defaultUnit), jss_plugin_expand_esm(), (0,jss_plugin_vendor_prefixer_esm/* default */.Z)(), (0,jss_plugin_props_sort_esm/* default */.Z)()]
  };
};

/* harmony default export */ var jss_preset_default_esm = (create);

;// CONCATENATED MODULE: ./node_modules/react-jss/node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/react-jss/node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = ((/* unused pure expression or super */ null && (index)));

;// CONCATENATED MODULE: ./node_modules/css-jss/dist/css-jss.esm.js



// Since we are in a single sheet mode, user shouldn't care about this.

var MAX_RULES_PER_SHEET = 10000;
var defaultJss = (0,jss_esm/* create */.Ue)(jss_preset_default_esm());

var createCss = function createCss(jss) {
  if (jss === void 0) {
    jss = defaultJss;
  }

  var cache = new Map();
  var ruleIndex = 0;
  var sheet;

  var getSheet = function getSheet() {
    if (!sheet || sheet.rules.index.length > MAX_RULES_PER_SHEET) {
      sheet = jss.createStyleSheet().attach();
    }

    return sheet;
  };

  function css() {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments; // We can avoid the need for stringification with a babel plugin,
    // which could generate a hash at build time and add it to the object.

    var argsStr = JSON.stringify(args);
    var cached = cache.get(argsStr);
    if (cached) return cached.className;
    var flatArgs = []; // Flatten arguments which can be
    // - style objects
    // - array of style objects
    // - arrays of style objects

    for (var argIndex in args) {
      var arg = args[argIndex];

      if (!Array.isArray(arg)) {
        flatArgs.push(arg);
        continue;
      }

      for (var innerArgIndex = 0; innerArgIndex < arg.length; innerArgIndex++) {
        flatArgs.push(arg[innerArgIndex]);
      }
    }

    var mergedStyle = {};
    var labels = [];

    for (var i = 0; i < flatArgs.length; i++) {
      var style = flatArgs[i];
      if (!style) continue;
      var styleObject = style; // It can be a class name that css() has previously generated.

      if (typeof style === 'string') {
        // eslint-disable-next-line no-shadow
        var _cached = cache.get(style);

        if (_cached) {
          // eslint-disable-next-line prefer-spread
          if (_cached.labels.length) labels.push.apply(labels, _cached.labels);
          styleObject = _cached.style;
        }
      }

      if (styleObject.label && labels.indexOf(styleObject.label) === -1) labels.push(styleObject.label);
      Object.assign(mergedStyle, styleObject);
    }

    delete mergedStyle.label;
    var label = labels.length === 0 ? 'css' : labels.join('-');
    var key = label + "-" + ruleIndex++;
    getSheet().addRule(key, mergedStyle);
    var className = getSheet().classes[key];
    var cacheValue = {
      style: mergedStyle,
      labels: labels,
      className: className
    };
    cache.set(argsStr, cacheValue);
    cache.set(className, cacheValue);
    return className;
  } // For testing only.


  css.getSheet = getSheet;
  return css;
};

var css = createCss();

/* harmony default export */ var css_jss_esm = (css);


;// CONCATENATED MODULE: ./node_modules/react-jss/dist/react-jss.esm.js















var react_jss_esm_getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

var react_jss_esm_memoize = function memoize(fn) {
  var lastArgs;
  var lastResult;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (Array.isArray(lastArgs) && args.length === lastArgs.length) {
      var isSame = true;

      for (var i = 0; i < args.length; i++) {
        if (args[i] !== lastArgs[i]) {
          isSame = false;
        }
      }

      if (isSame) {
        return lastResult;
      }
    }

    lastArgs = args;
    lastResult = fn.apply(void 0, args);
    return lastResult;
  };
};

var mergeClasses = function mergeClasses(baseClasses, additionalClasses) {
  var combinedClasses = _extends({}, baseClasses);

  for (var name in additionalClasses) {
    combinedClasses[name] = name in combinedClasses ? combinedClasses[name] + " " + additionalClasses[name] : additionalClasses[name];
  }

  return combinedClasses;
};

/**
 * Global index counter to preserve source order.
 * As we create the style sheet during componentWillMount lifecycle,
 * children are handled after the parents, so the order of style elements would
 * be parent->child. It is a problem though when a parent passes a className
 * which needs to override any childs styles. StyleSheet of the child has a higher
 * specificity, because of the source order.
 * So our solution is to render sheets them in the reverse order child->sheet, so
 * that parent has a higher specificity.
 *
 * We start at [Number.MIN_SAFE_INTEGER] to always insert sheets from react-jss first before any
 * sheet which might be inserted manually by the user.
 */
var react_jss_esm_index = Number.MIN_SAFE_INTEGER || -1e9;

var getSheetIndex = function getSheetIndex() {
  return react_jss_esm_index++;
};

var JssContext = (0,react.createContext)({
  classNamePrefix: '',
  disableStylesGeneration: false,
  isSSR: !dist_module/* default */.Z
});

var defaultManagers = new Map();
var getManager = function getManager(context, managerId) {
  // If `managers` map is present in the context, we use it in order to
  // let JssProvider reset them when new response has to render server-side.
  var managers = context.managers;

  if (managers) {
    if (!managers[managerId]) {
      managers[managerId] = new jss_esm/* SheetsManager */.gq();
    }

    return managers[managerId];
  }

  var manager = defaultManagers.get(managerId);

  if (!manager) {
    manager = new jss_esm/* SheetsManager */.gq();
    defaultManagers.set(managerId, manager);
  }

  return manager;
};
var manageSheet = function manageSheet(options) {
  var sheet = options.sheet,
      context = options.context,
      index = options.index,
      theme = options.theme;

  if (!sheet) {
    return;
  }

  var manager = getManager(context, index);
  manager.manage(theme);

  if (context.registry) {
    context.registry.add(sheet);
  }
};
var unmanageSheet = function unmanageSheet(options) {
  if (!options.sheet) {
    return;
  }

  var manager = getManager(options.context, options.index);
  manager.unmanage(options.theme);
};

var react_jss_esm_defaultJss = (0,jss_esm/* create */.Ue)(jss_preset_default_esm());

var sheetsMeta = new WeakMap();
var getMeta = function getMeta(sheet) {
  return sheetsMeta.get(sheet);
};
var addMeta = function addMeta(sheet, meta) {
  sheetsMeta.set(sheet, meta);
};

var getStyles = function getStyles(options) {
  var styles = options.styles;

  if (typeof styles !== 'function') {
    return styles;
  }

   false ? 0 : void 0;
  return styles(options.theme);
};

function getSheetOptions(options, link) {
  var minify;

  if (options.context.id && options.context.id.minify != null) {
    minify = options.context.id.minify;
  }

  var classNamePrefix = options.context.classNamePrefix || '';

  if (options.name && !minify) {
    classNamePrefix += options.name.replace(/\s/g, '-') + "-";
  }

  var meta = '';
  if (options.name) meta = options.name + ", ";
  meta += typeof options.styles === 'function' ? 'Themed' : 'Unthemed';
  return (0,esm_extends/* default */.Z)({}, options.sheetOptions, {
    index: options.index,
    meta: meta,
    classNamePrefix: classNamePrefix,
    link: link,
    generateId: options.sheetOptions && options.sheetOptions.generateId ? options.sheetOptions.generateId : options.context.generateId
  });
}

var createStyleSheet = function createStyleSheet(options) {
  if (options.context.disableStylesGeneration) {
    return undefined;
  }

  var manager = getManager(options.context, options.index);
  var existingSheet = manager.get(options.theme);

  if (existingSheet) {
    return existingSheet;
  }

  var jss = options.context.jss || react_jss_esm_defaultJss;
  var styles = getStyles(options);
  var dynamicStyles = (0,jss_esm/* getDynamicStyles */._$)(styles);
  var sheet = jss.createStyleSheet(styles, getSheetOptions(options, dynamicStyles !== null));
  addMeta(sheet, {
    dynamicStyles: dynamicStyles,
    styles: styles
  });
  manager.add(options.theme, sheet);
  return sheet;
};
var removeDynamicRules = function removeDynamicRules(sheet, rules) {
  // Loop over each dynamic rule and remove the dynamic rule
  // We can't just remove the whole sheet as this has all of the rules for every component instance
  for (var key in rules) {
    sheet.deleteRule(rules[key]);
  }
};
var updateDynamicRules = function updateDynamicRules(data, sheet, rules) {
  // Loop over each dynamic rule and update it
  // We can't just update the whole sheet as this has all of the rules for every component instance
  for (var key in rules) {
    sheet.updateOne(rules[key], data);
  }
};
var addDynamicRules = function addDynamicRules(sheet, data) {
  var meta = getMeta(sheet);

  if (!meta) {
    return undefined;
  }

  var rules = {}; // Loop over each dynamic rule and add it to the stylesheet

  for (var key in meta.dynamicStyles) {
    var initialRuleCount = sheet.rules.index.length;
    var originalRule = sheet.addRule(key, meta.dynamicStyles[key]); // Loop through all created rules, fixes updating dynamic rules

    for (var i = initialRuleCount; i < sheet.rules.index.length; i++) {
      var rule = sheet.rules.index[i];
      sheet.updateOne(rule, data); // If it's the original rule, we need to add it by the correct key so the hook and hoc
      // can correctly concat the dynamic class with the static one

      rules[originalRule === rule ? key : rule.key] = rule;
    }
  }

  return rules;
};

var getSheetClasses = function getSheetClasses(sheet, dynamicRules) {
  if (!dynamicRules) {
    return sheet.classes;
  }

  var meta = getMeta(sheet);

  if (!meta) {
    return sheet.classes;
  }

  var classes = {};

  for (var key in meta.styles) {
    classes[key] = sheet.classes[key];

    if (key in dynamicRules) {
      classes[key] += " " + sheet.classes[dynamicRules[key].key];
    }
  }

  return classes;
};

function getUseInsertionEffect(isSSR) {
  return isSSR ? react.useEffect : react.useInsertionEffect || // React 18+ (https://github.com/reactwg/react-18/discussions/110)
  react.useLayoutEffect;
}

var noTheme = {};

var createUseStyles = function createUseStyles(styles, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$index = _options.index,
      index = _options$index === void 0 ? getSheetIndex() : _options$index,
      theming = _options.theming,
      name = _options.name,
      sheetOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_options, ["index", "theming", "name"]);

  var ThemeContext$1 = theming && theming.context || theming_esm_ThemeContext;

  var useTheme = function useTheme(theme) {
    if (typeof styles === 'function') {
      return theme || (0,react.useContext)(ThemeContext$1) || noTheme;
    }

    return noTheme;
  };

  var emptyObject = {};
  return function useStyles(data) {
    var isFirstMount = (0,react.useRef)(true);
    var context = (0,react.useContext)(JssContext);
    var theme = useTheme(data && data.theme);

    var _useMemo = (0,react.useMemo)(function () {
      var newSheet = createStyleSheet({
        context: context,
        styles: styles,
        name: name,
        theme: theme,
        index: index,
        sheetOptions: sheetOptions
      });

      if (newSheet && context.isSSR) {
        // manage immediately during SSRs. browsers will manage the sheet through useInsertionEffect below
        manageSheet({
          index: index,
          context: context,
          sheet: newSheet,
          theme: theme
        });
      }

      return [newSheet, newSheet ? addDynamicRules(newSheet, data) : null];
    }, [context, theme]),
        sheet = _useMemo[0],
        dynamicRules = _useMemo[1];

    getUseInsertionEffect(context.isSSR)(function () {
      // We only need to update the rules on a subsequent update and not in the first mount
      if (sheet && dynamicRules && !isFirstMount.current) {
        updateDynamicRules(data, sheet, dynamicRules);
      }
    }, [data]);
    getUseInsertionEffect(context.isSSR)(function () {
      if (sheet) {
        manageSheet({
          index: index,
          context: context,
          sheet: sheet,
          theme: theme
        });
      }

      return function () {
        if (sheet) {
          unmanageSheet({
            index: index,
            context: context,
            sheet: sheet,
            theme: theme
          }); // when sheet changes, remove related dynamic rules

          if (dynamicRules) {
            removeDynamicRules(sheet, dynamicRules);
          }
        }
      };
    }, [sheet]);
    var classes = (0,react.useMemo)(function () {
      return sheet && dynamicRules ? getSheetClasses(sheet, dynamicRules) : emptyObject;
    }, [sheet, dynamicRules]);
    (0,react.useDebugValue)(classes);
    (0,react.useDebugValue)(theme === noTheme ? 'No theme' : theme);
    (0,react.useEffect)(function () {
      isFirstMount.current = false;
    });
    return classes;
  };
};

var NoRenderer = function NoRenderer(props) {
  return props.children || null;
};
/**
 * HOC creator function that wrapps the user component.
 *
 * `withStyles(styles, [options])(Component)`
 */


var createWithStyles = function createWithStyles(styles, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$index = _options.index,
      index = _options$index === void 0 ? getSheetIndex() : _options$index,
      theming = _options.theming,
      injectTheme = _options.injectTheme,
      sheetOptions = _objectWithoutPropertiesLoose(_options, ["index", "theming", "injectTheme"]);

  var ThemeContext$1 = theming ? theming.context : ThemeContext;
  return function (InnerComponent) {
    if (InnerComponent === void 0) {
      InnerComponent = NoRenderer;
    }

    var displayName = react_jss_esm_getDisplayName(InnerComponent);
    var mergeClassesProp = react_jss_esm_memoize(function (sheetClasses, classesProp) {
      return classesProp ? mergeClasses(sheetClasses, classesProp) : sheetClasses;
    });
    var hookOptions = Object.assign(sheetOptions, {
      theming: theming,
      index: index,
      name: displayName
    });
    var useStyles = createUseStyles(styles, hookOptions);
    var WithStyles = forwardRef(function (props, ref) {
      var theme = useContext(ThemeContext$1);

      var newProps = _extends({}, props);

      if (injectTheme && newProps.theme == null) {
        newProps.theme = theme;
      }

      var sheetClasses = useStyles(newProps);
      var classes = mergeClassesProp(sheetClasses, props.classes);
      return createElement(InnerComponent, _extends({}, newProps, {
        classes: classes,
        ref: ref
      }));
    });
    WithStyles.displayName = "WithStyles(" + displayName + ")";
    WithStyles.defaultProps = _extends({}, InnerComponent.defaultProps);
    WithStyles.InnerComponent = InnerComponent;
    return hoistNonReactStatics(WithStyles, InnerComponent);
  };
};

var initialContext = {};
function JssProvider(props) {
  var managersRef = useRef({});
  var prevContextRef = useRef();
  var registryRef = useRef(null);

  var createContext = function createContext(parentContext, prevContext) {
    if (prevContext === void 0) {
      prevContext = initialContext;
    }

    var registry = props.registry,
        classNamePrefix = props.classNamePrefix,
        jss = props.jss,
        generateId = props.generateId,
        disableStylesGeneration = props.disableStylesGeneration,
        media = props.media,
        id = props.id,
        isSSR = props.isSSR;

    var context = _extends({}, parentContext);

    if (registry) {
      context.registry = registry; // This way we identify a new request on the server, because user will create
      // a new Registry instance for each.

      if (registry !== registryRef.current) {
        // We reset managers because we have to regenerate all sheets for the new request.
        managersRef.current = {};
        registryRef.current = registry;
      }
    }

    context.managers = managersRef.current;

    if (id !== undefined) {
      context.id = id;
    }

    if (generateId !== undefined) {
      context.generateId = generateId;
    } else if (!context.generateId || !prevContext || context.id !== prevContext.id) {
      context.generateId = createGenerateId(context.id);
    }

    if (classNamePrefix) {
      context.classNamePrefix = (context.classNamePrefix || '') + classNamePrefix;
    }

    if (media !== undefined) {
      context.media = media;
    }

    if (jss) {
      context.jss = jss;
    }

    if (disableStylesGeneration !== undefined) {
      context.disableStylesGeneration = disableStylesGeneration;
    }

    if (isSSR !== undefined) {
      context.isSSR = isSSR;
    }

    if (prevContext && shallowEqualObjects(prevContext, context)) {
      return prevContext;
    }

    return context;
  };

  var renderProvider = function renderProvider(parentContext) {
    var children = props.children;
    var context = createContext(parentContext, prevContextRef.current);
    prevContextRef.current = context;
    return createElement(JssContext.Provider, {
      value: context
    }, children);
  };

  return createElement(JssContext.Consumer, null, renderProvider);
}

var parseStyles = function parseStyles(args) {
  var dynamicStyles = [];
  var staticStyle;
  var labels = []; // Not using ...rest to optimize perf.

  for (var key in args) {
    var style = args[key];
    if (!style) continue;

    if (typeof style === 'function') {
      dynamicStyles.push(style);
    } else {
      if (!staticStyle) staticStyle = {};
      Object.assign(staticStyle, style);
      var _staticStyle = staticStyle,
          _label = _staticStyle.label;

      if (_label) {
        if (labels.indexOf(_label) === -1) labels.push(_label);
      }
    }
  }

  var styles = {};
  var label = labels.length === 0 ? 'sc' : labels.join('-');

  if (staticStyle) {
    // Label should not leak to the core.
    if ('label' in staticStyle) delete staticStyle.label;
    styles[label] = staticStyle;
  } // When there is only one function rule, we don't need to wrap it.


  if (dynamicStyles.length === 1) {
    styles.scd = dynamicStyles[0];
  } // We create a new function rule which will call all other function rules
  // and merge the styles they return.


  if (dynamicStyles.length > 1) {
    styles.scd = function (props) {
      var merged = {};

      for (var i = 0; i < dynamicStyles.length; i++) {
        var dynamicStyle = dynamicStyles[i](props);
        if (dynamicStyle) Object.assign(merged, dynamicStyle);
      }

      return merged;
    };
  }

  return {
    styles: styles,
    label: label
  };
};

var shouldForwardPropSymbol = Symbol('react-jss-styled');

var getShouldForwardProp = function getShouldForwardProp(tagOrComponent, options) {
  var shouldForwardProp = options.shouldForwardProp;
  var childShouldForwardProp = tagOrComponent[shouldForwardPropSymbol];
  var finalShouldForwardProp = shouldForwardProp || childShouldForwardProp;

  if (shouldForwardProp && childShouldForwardProp) {
    finalShouldForwardProp = function finalShouldForwardProp(prop) {
      return childShouldForwardProp(prop) && shouldForwardProp(prop);
    };
  }

  return finalShouldForwardProp;
};

var getChildProps = function getChildProps(props, shouldForwardProp, isTag) {
  var childProps = {};

  for (var prop in props) {
    if (shouldForwardProp) {
      if (shouldForwardProp(prop) === true) {
        childProps[prop] = props[prop];
      }

      continue;
    } // We don't want to pass non-dom props to the DOM.


    if (isTag) {
      if (isPropValid(prop)) {
        childProps[prop] = props[prop];
      }

      continue;
    }

    childProps[prop] = props[prop];
  }

  return childProps;
}; // eslint-disable-next-line no-unused-vars


var configureStyled = function configureStyled(tagOrComponent, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      theming = _options.theming;
  var isTag = typeof tagOrComponent === 'string';
  var ThemeContext$1 = theming ? theming.context : ThemeContext;
  var shouldForwardProp = getShouldForwardProp(tagOrComponent, options);

  var _options2 = options,
      _ = _options2.shouldForwardProp,
      hookOptions = _objectWithoutPropertiesLoose(_options2, ["shouldForwardProp"]);

  return function createStyledComponent() {
    // eslint-disable-next-line prefer-rest-params
    var _parseStyles = parseStyles(arguments),
        styles = _parseStyles.styles,
        label = _parseStyles.label;

    var useStyles = createUseStyles(styles, hookOptions);

    var Styled = function Styled(props) {
      var as = props.as,
          className = props.className;
      var theme = useContext(ThemeContext$1);
      var propsWithTheme = Object.assign({
        theme: theme
      }, props);
      var classes = useStyles(propsWithTheme);
      var childProps = getChildProps(props, shouldForwardProp, isTag);
      var classNames = ((classes[label] || classes.sc || '') + " " + (classes.scd || '')).trim();
      childProps.className = className ? className + " " + classNames : classNames;

      if (!isTag && shouldForwardProp) {
        tagOrComponent[shouldForwardPropSymbol] = shouldForwardProp;
      }

      if (isTag && as) {
        return createElement(as, childProps);
      }

      return createElement(tagOrComponent, childProps);
    };

    return Styled;
  };
};

/* eslint-disable prefer-rest-params, prefer-spread */
var react_jss_esm_create = function create(css) {
  if (css === void 0) {
    css = css_jss_esm;
  }

  return function createElement$1(type, props) {
    var args = arguments;

    if (props && props.css) {
      var className = css(props.css);
      var newProps = Object.assign({}, props);
      newProps.className = props.className ? props.className + " " + className : className;
      delete newProps.css;
      args[1] = newProps;
    }

    return react.createElement.apply(undefined, args);
  };
};
var jsx = react_jss_esm_create();

/* harmony default export */ var react_jss_esm = ((/* unused pure expression or super */ null && (createWithStyles)));


// EXTERNAL MODULE: ./node_modules/lodash/round.js
var round = __webpack_require__(59854);
var round_default = /*#__PURE__*/__webpack_require__.n(round);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
;// CONCATENATED MODULE: ./node_modules/react-confetti-explosion/lib/index.esm.js








/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var mapRange = function (value, x1, y1, x2, y2) {
    return ((value - x1) * (y2 - x2)) / (y1 - x1) + x2;
};
var rotate = function (degree, amount) {
    var result = degree + amount;
    return result > 360 ? result - 360 : result;
};
var coinFlip = function () { return Math.random() > 0.5; };
// avoid this for circles, as it will have no visual effect
var zAxisRotation = [0, 0, 1];
var rotationTransforms = [
    // dual axis rotations (a bit more realistic)
    [1, 1, 0],
    [1, 0, 1],
    [0, 1, 1],
    // single axis rotations (a bit dumber)
    [1, 0, 0],
    [0, 1, 0],
    zAxisRotation,
];
var shouldBeCircle = function (rotationIndex) {
    return !isEqual_default()(rotationTransforms[rotationIndex], zAxisRotation) && coinFlip();
};

var ROTATION_SPEED_MIN = 200; // minimum possible duration of single particle full rotation
var ROTATION_SPEED_MAX = 800; // maximum possible duration of single particle full rotation
var CRAZY_PARTICLES_FREQUENCY = 0.1; // 0-1 frequency of crazy curvy unpredictable particles
var CRAZY_PARTICLE_CRAZINESS = 0.25; // 0-1 how crazy these crazy particles are
var BEZIER_MEDIAN = 0.5; // utility for mid-point bezier curves, to ensure smooth motion paths
var rotationKeyframes = rotationTransforms.reduce(function (acc, xyz, i) {
    var _a;
    return __assign(__assign({}, acc), (_a = {}, _a["@keyframes rotation-".concat(i)] = {
        '50%': {
            transform: "rotate3d(".concat(xyz.map(function (v) { return v / 2; }).join(), ", 180deg)"),
        },
        '100%': {
            transform: "rotate3d(".concat(xyz.join(), ", 360deg)"),
        },
    }, _a));
}, {});
var confettiKeyframes = function (degrees, height, width) {
    var y = typeof height === 'string' ? height : "".concat(height, "px");
    var xLandingPoints = degrees.reduce(function (acc, degree, i) {
        var _a;
        var landingPoint = mapRange(Math.abs(rotate(degree, 90) - 180), 0, 180, -width / 2, width / 2);
        return __assign(__assign({}, acc), (_a = {}, _a["@keyframes x-axis-".concat(i)] = {
            to: {
                transform: "translateX(".concat(landingPoint, "px)"),
            },
        }, _a));
    }, {});
    return __assign({ '@keyframes y-axis': {
            to: {
                transform: "translateY(".concat(y, ")"),
            },
        } }, xLandingPoints);
};
var confettoStyle = function (particle, duration, force, size, i) {
    var _a;
    var rotation = Math.round(Math.random() * (ROTATION_SPEED_MAX - ROTATION_SPEED_MIN) + ROTATION_SPEED_MIN);
    var rotationIndex = Math.round(Math.random() * (rotationTransforms.length - 1));
    var durationChaos = duration - Math.round(Math.random() * 1000);
    var shouldBeCrazy = Math.random() < CRAZY_PARTICLES_FREQUENCY;
    var isCircle = shouldBeCircle(rotationIndex);
    // x-axis disturbance, roughly the distance the particle will initially deviate from its target
    var x1 = shouldBeCrazy ? round_default()(Math.random() * CRAZY_PARTICLE_CRAZINESS, 2) : 0;
    var x2 = x1 * -1;
    var x3 = x1;
    // x-axis arc of explosion, so 90deg and 270deg particles have curve of 1, 0deg and 180deg have 0
    var x4 = round_default()(Math.abs(mapRange(Math.abs(rotate(particle.degree, 90) - 180), 0, 180, -1, 1)), 4);
    // roughly how fast particle reaches end of its explosion curve
    var y1 = round_default()(Math.random() * BEZIER_MEDIAN, 4);
    // roughly maps to the distance particle goes before reaching free-fall
    var y2 = round_default()(Math.random() * force * (coinFlip() ? 1 : -1), 4);
    // roughly how soon the particle transitions from explosion to free-fall
    var y3 = BEZIER_MEDIAN;
    // roughly the ease of free-fall
    var y4 = round_default()(Math.max(mapRange(Math.abs(particle.degree - 180), 0, 180, force, -force), 0), 4);
    return _a = {},
        _a["&#confetti-particle-".concat(i)] = {
            animation: "$x-axis-".concat(i, " ").concat(durationChaos, "ms forwards cubic-bezier(").concat(x1, ", ").concat(x2, ", ").concat(x3, ", ").concat(x4, ")"),
            '& > div': {
                width: isCircle ? size : Math.round(Math.random() * 4) + size / 2,
                height: isCircle ? size : Math.round(Math.random() * 2) + size,
                animation: "$y-axis ".concat(durationChaos, "ms forwards cubic-bezier(").concat(y1, ", ").concat(y2, ", ").concat(y3, ", ").concat(y4, ")"),
                '&:after': __assign({ backgroundColor: particle.color, animation: "$rotation-".concat(rotationIndex, " ").concat(rotation, "ms infinite linear") }, (isCircle ? { borderRadius: '50%' } : {})),
            },
        },
        _a;
};
var useStyles = function (_a) {
    var particles = _a.particles, duration = _a.duration, height = _a.height, width = _a.width, force = _a.force, particleSize = _a.particleSize;
    var confettiStyles = particles.reduce(function (acc, particle, i) { return (__assign(__assign({}, acc), confettoStyle(particle, duration, force, particleSize, i))); }, {});
    return createUseStyles(__assign(__assign(__assign({}, rotationKeyframes), confettiKeyframes(particles.map(function (particle) { return particle.degree; }), height, width)), { container: {
            width: 0,
            height: 0,
            position: 'relative',
        }, screen: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: 'hidden',
            pointerEvents: 'none',
        }, particle: __assign(__assign({}, confettiStyles), { '& > div': {
                position: 'absolute',
                left: 0,
                top: 0,
                '&:after': {
                    content: "''",
                    display: 'block',
                    width: '100%',
                    height: '100%',
                },
            } }) }), { name: 'confetti-explosion' });
};

var FORCE = 0.5; // 0-1 roughly the vertical force at which particles initially explode
var SIZE = 12; // max height for particle rectangles, diameter for particle circles
var HEIGHT = '120vh'; // distance particles will fall from initial explosion point
var WIDTH = 1000; // horizontal spread of particles in pixels
var PARTICLE_COUNT = 100;
var DURATION = 2200;
var COLORS = ['#FFC700', '#FF0000', '#2E3191', '#41BBC7'];
var createParticles = function (count, colors) {
    var increment = 360 / count;
    return range_default()(count).map(function (index) { return ({
        color: colors[index % colors.length],
        degree: increment * index,
    }); });
};
function ConfettiExplosion(_a) {
    var _b = _a.particleCount, particleCount = _b === void 0 ? PARTICLE_COUNT : _b, _c = _a.duration, duration = _c === void 0 ? DURATION : _c, _d = _a.colors, colors = _d === void 0 ? COLORS : _d, _e = _a.particleSize, particleSize = _e === void 0 ? SIZE : _e, _f = _a.force, force = _f === void 0 ? FORCE : _f, _g = _a.height, height = _g === void 0 ? HEIGHT : _g, _h = _a.width, width = _h === void 0 ? WIDTH : _h, zIndex = _a.zIndex, onComplete = _a.onComplete, props = __rest(_a, ["particleCount", "duration", "colors", "particleSize", "force", "height", "width", "zIndex", "onComplete"]);
    var _j = react.useState(), origin = _j[0], setOrigin = _j[1];
    var particles = createParticles(particleCount, colors);
    var classes = useStyles({
        particles: particles,
        duration: duration,
        particleSize: particleSize,
        force: force,
        width: width,
        height: height,
    })();
    var originRef = react.useCallback(function (node) {
        if (node) {
            var _a = node.getBoundingClientRect(), top_1 = _a.top, left = _a.left;
            setOrigin({ top: top_1, left: left });
        }
    }, []);
    react.useEffect(function () {
        if (typeof onComplete === 'function') {
            var timeout_1 = setTimeout(onComplete, duration);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [duration, onComplete]);
    return ((0,jsx_runtime.jsx)("div", __assign({ ref: originRef, className: classes.container }, props, { children: origin &&
            (0,react_dom.createPortal)((0,jsx_runtime.jsx)("div", __assign({ className: classes.screen }, (zIndex ? { style: { zIndex: zIndex } } : null), { children: (0,jsx_runtime.jsx)("div", __assign({ style: { position: 'absolute', top: origin.top, left: origin.left } }, { children: particles.map(function (particle, i) { return ((0,jsx_runtime.jsx)("div", __assign({ id: "confetti-particle-".concat(i), className: classes.particle }, { children: (0,jsx_runtime.jsx)("div", {}) }), particle.degree)); }) })) })), document.body) })));
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./src/hooks/useConfettiCannon.ts


var useConfettiCannon = function() {
    var showModal = (0,mui_modal_provider_esm/* useModal */.d)().showModal;
    return {
        fireConfettiCannon: function() {
            var ref = showModal(ConfettiExplosion, {
                particleCount: 200,
                colors: [
                    "rgb(82, 99, 243)",
                    "rgb(238, 154, 178)",
                    "rgb(255, 197, 80)",
                    "white",
                    "black"
                ],
                width: 2000
            }), hide = ref.hide, destroy = ref.destroy;
            setTimeout(function() {
                hide();
                destroy();
            }, 5000);
        }
    };
};


/***/ }),

/***/ 62495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Lb": function() { return /* binding */ TIME_FORMAT_MAP; },
  "$0": function() { return /* binding */ useDateTimeFormatter; }
});

// UNUSED EXPORTS: TIME_FORMATE_WITHOUT_YEAR, TIME_FORMAT_MAP_BY_CLOCK

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(70722);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 1 modules
var en_US = __webpack_require__(83975);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistance = __webpack_require__(81991);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelative = __webpack_require__(21865);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js + 1 modules
var localize = __webpack_require__(27727);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js + 2 modules
var match = __webpack_require__(43754);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */

var locale = {
  code: 'en-GB',
  formatDistance: formatDistance/* default */.Z,
  formatLong: _lib_formatLong,
  formatRelative: formatRelative/* default */.Z,
  localize: localize/* default */.Z,
  match: match/* default */.Z,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var en_GB = (locale);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/utils/typescript.ts
var typescript = __webpack_require__(66201);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/hooks/useCaptureError.ts
var useCaptureError = __webpack_require__(59546);
;// CONCATENATED MODULE: ./src/hooks/useDateTimeFormatter.ts








var TIME_FORMAT_MAP = (0,typescript/* satisfies */.L5)()({
    TIME_FORMAT: {
        "12h": "HH:mm:ss"
    },
    TIME_DISPLAY_FORMAT: {
        "24h": "H:mm",
        "12h": "h:mmaaa"
    },
    SHORT_TIME_DISPLAY_FORMAT: {
        "24h": "H:mm",
        "12h": "h:mm"
    },
    DAY_OF_WEEK_FORMAT: {
        "12h": "EE"
    },
    DAY_OF_WEEK_TIME_FORMAT: {
        "24h": "EE H:mm",
        "12h": "EE h:mmaaa"
    },
    WEEKLESS_DATE_DISPLAY_FORMAT: {
        "12h": "PP"
    },
    WEEKLESS_DATE_TIME_DISPLAY_FORMAT: {
        "24h": "PP, H:mm",
        "12h": "PP, h:mmaaa"
    },
    MONTH_YEAR_DISPLAY_FORMAT: {
        "12h": "MMM yyyy"
    },
    FULL_MONTH_YEAR_DISPLAY_FORMAT: {
        "12h": "MMMM yyyy"
    },
    DATE_DISPLAY_FORMAT: {
        "12h": "EE, PP"
    },
    FULL_DAY_DATE_DISPLAY_FORMAT: {
        "12h": "EEEE, PP"
    },
    FULL_DAY_MONTH_DATE_DISPLAY_FORMAT: {
        "12h": "EEEE, PPP"
    },
    SHORT_DATE_DISPLAY_FORMAT: {
        "12h": "EE, P"
    },
    SHORT_DATE_YEAR_DISPLAY_FORMAT: {
        "12h": "EE, P"
    },
    DATE_YEAR_DISPLAY_FORMAT: {
        "12h": "EE, PP"
    },
    FULL_DAY_DATE_YEAR_DISPLAY_FORMAT: {
        "12h": "EEEE, PP"
    },
    DATE_CONTROL_FORMAT: {
        "24h": "PP H:mm",
        "12h": "PP h:mmaaa"
    },
    DATE_CONTROL_FORMAT_DAY_MODE: {
        "12h": "PP"
    },
    DATE_TIME_DISPLAY_FORMAT: {
        "24h": "EE, PP 'at' H:mm",
        "12h": "EE, PP 'at' h:mmaaa"
    },
    DATE_YEAR_TIME_DISPLAY_FORMAT: {
        "24h": "EE, PP 'at' H:mm",
        "12h": "EE, PP 'at' h:mmaaa"
    },
    SHORT_DATE_TIME_FORMAT: {
        "24h": "P H:mm",
        "12h": "P h:mmaaa"
    },
    SHORT_DATE_YEAR_TIME_FORMAT: {
        "24h": "P H:mm",
        "12h": "P h:mmaaa"
    },
    WEEKDAY_SHORT_DISPLAY_FORMAT: {
        "12h": "iii"
    },
    DAY_DISPLAY_FORMAT: {
        "12h": "d"
    },
    HOUR_DISPLAY_FORMAT: {
        "24h": "H:00",
        "12h": "h a"
    },
    YEAR_DISPLAY_FORMAT: {
        "12h": "yyyy"
    },
    ROUTER_DATE_FORMAT: {
        "12h": "yyyy-MM-dd"
    },
    DAY_MONTH_YEAR_FORMAT: {
        "12h": "P"
    },
    DAY_MONTH_FORMAT: {
        "12h": "P"
    }
});
var TIME_FORMAT_MAP_BY_CLOCK = {
    "12h": Object.entries(TIME_FORMAT_MAP).reduce(function(map, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), formatKey = _param[0], obj = _param[1];
        map[formatKey] = obj["12h"];
        return map;
    }, {}),
    "24h": Object.entries(TIME_FORMAT_MAP).reduce(function(map, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), formatKey = _param[0], obj = _param[1];
        map[formatKey] = (obj === null || obj === void 0 ? void 0 : obj["24h"]) || obj["12h"];
        return map;
    }, {})
};
// TODO: use extantMap with improvements
var TIME_FORMATE_WITHOUT_YEAR = {
    WEEKLESS_DATE_DISPLAY_FORMAT: true,
    WEEKLESS_DATE_TIME_DISPLAY_FORMAT: true,
    DATE_DISPLAY_FORMAT: true,
    FULL_DAY_DATE_DISPLAY_FORMAT: true,
    FULL_DAY_MONTH_DATE_DISPLAY_FORMAT: true,
    SHORT_DATE_DISPLAY_FORMAT: true,
    DATE_TIME_DISPLAY_FORMAT: true,
    SHORT_DATE_TIME_FORMAT: true,
    DAY_MONTH_FORMAT: true
};
var useDateTimeFormatter = function() {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), user = ref1[0].user;
    var timeType = !!(user === null || user === void 0 ? void 0 : (ref = user.settings) === null || ref === void 0 ? void 0 : ref.format24HourTime) ? "24h" : "12h";
    var formatMap = TIME_FORMAT_MAP_BY_CLOCK[timeType];
    var captureError = (0,useCaptureError/* useCaptureError */.e)().captureError;
    var format = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(date, timeFormat) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var ref, ref1;
        var timeZone = options.timeZone, timeTypeOverride = options.timeTypeOverride;
        var userTimeFormat = TIME_FORMAT_MAP_BY_CLOCK[timeTypeOverride || timeType][timeFormat];
        var isFormatWithNoYear = TIME_FORMATE_WITHOUT_YEAR[timeFormat];
        var locale = (user === null || user === void 0 ? void 0 : (ref = user.settings) === null || ref === void 0 ? void 0 : ref.dateFieldOrder) === "DMY" ? "other" : "us";
        if (timeFormat === "SHORT_DATE_YEAR_DISPLAY_FORMAT" && (user === null || user === void 0 ? void 0 : (ref1 = user.settings) === null || ref1 === void 0 ? void 0 : ref1.dateFieldOrder) === "YMD") {
            userTimeFormat = "EE, yyyy-MM-dd";
        }
        if (!userTimeFormat) {
            throw new Error("Unknown formatting. Please provide a valid TimeFormat");
        }
        var formatOptions = {
            locale: locale === "us" ? en_US/* default */.Z : en_GB,
            timeZone: timeZone
        };
        var formatted = "";
        // Protect against bad dates attempting to be parsed
        try {
            formatted = timeZone ? (0,date_fns_tz.formatInTimeZone)(date, timeZone, userTimeFormat, formatOptions) : (0,date_fns_tz.format)(date, userTimeFormat, formatOptions);
        } catch (error) {
            captureError(error);
        }
        /**
     * For "DMY" formatting with date-fns we need to strip the year off the "Long localized date" formating (P, PP). After crawling the
     * API and interwebs this seems to be an open issue with date-fns: https://github.com/date-fns/date-fns/issues/1946
     */ if (timeFormat === "WEEKLESS_DATE_TIME_DISPLAY_FORMAT" && locale === "other") {
            formatted = formatted.replace(",", "");
        }
        // Strip the possible year displays "/****", ****" , " ****"
        return isFormatWithNoYear ? formatted.replace(/([A-Z])|\b(\/|\, | )[0-9]{4}\b/g, "$1") : formatted;
    });
    var shortenTime = (0,react.useCallback)(function(time) {
        return timeType === "12h" ? time.replace(":00", "") : time;
    }, [
        timeType
    ]);
    return {
        format: format,
        shortenTime: shortenTime,
        formatMap: formatMap
    };
};


/***/ }),

/***/ 11259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useDebounce; },
  "o": function() { return /* binding */ usePromisedDebounce; }
});

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./src/utils/debounce.ts


/**
 * Similar to _.debounce, only all debounced functions return a promise which resolves to the value (promise or otherwise) returned by `cb`
 * @param cb The callback to debounce.  Also comes attached with a `cancel` function
 * @param waitMs The amount of time to wait before running the callback
 * @returns A new debounced function
 */ var promisedDebounce = function(cb, waitMs) {
    var promise;
    var res;
    var timer;
    var awaitingCb = false;
    var fn = function() {
        if (!promise) promise = new Promise(function(innerRes) {
            return res = innerRes;
        });
        // if the CB is already running don't start
        // a new timer, just glob on future calls to
        // the existing promise
        if (!awaitingCb) {
            clearTimeout(timer);
            timer = setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var val;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            awaitingCb = true;
                            return [
                                4,
                                cb()
                            ];
                        case 1:
                            val = _state.sent();
                            awaitingCb = false;
                            res === null || res === void 0 ? void 0 : res(val);
                            promise = undefined;
                            return [
                                2
                            ];
                    }
                });
            }), waitMs);
        }
        return promise;
    };
    fn.cancel = function() {
        clearTimeout(timer);
        res = undefined;
    };
    return Object.freeze(fn);
};

// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
;// CONCATENATED MODULE: ./src/hooks/useDebounce.ts




// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useDebounce = function(callback, waitMs, options) {
    // Break the options down to its primitive parts.
    // This way options passed in directly as `{}`
    // don't trigger the `useMemo` on every frame.
    // const staticOptions = useMemo<DebounceSettings>(
    //   () => ({
    //     leading: options?.leading,
    //     maxWait: options?.maxWait,
    //     trailing: options?.trailing,
    //   }),
    //   [options?.leading, options?.maxWait, options?.trailing]
    // );
    // use useMemo instead of useCallback so we can evaluate debounce ONLY when deps change
    var debounced = (0,react.useMemo)(function() {
        return (0,lodash.debounce)(callback, waitMs, options);
    }, [
        callback,
        waitMs,
        options
    ]);
    // Kill callbacks on unmount
    (0,react.useEffect)(function() {
        return function() {
            return debounced.cancel();
        };
    }, [
        debounced
    ]);
    return debounced;
};
var usePromisedDebounce = function(callback, waitMs) {
    var safe = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(callback);
    // use useMemo instead of useCallback so we can evaluate debounce ONLY when deps change
    var debounced = (0,react.useMemo)(function() {
        return promisedDebounce(safe, waitMs);
    }, [
        safe,
        waitMs
    ]);
    (0,react.useEffect)(function() {
        return function() {
            return debounced.cancel();
        };
    }, [
        debounced
    ]);
    return debounced;
};


/***/ }),

/***/ 71360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useElementRect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useResizeObserver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93103);



var useElementRect = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var callback = options.callback, ref = options.ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), rect = ref1[0], setRect = ref1[1];
    ref = (0,_useResizeObserver__WEBPACK_IMPORTED_MODULE_1__/* .useResizeObserver */ .y)(function(rect) {
        setRect(rect);
        callback === null || callback === void 0 ? void 0 : callback(rect);
    }, ref);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        ref: ref
    }, rect);
};


/***/ }),

/***/ 43165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useEntitlementBadges; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_billing_EditionBadgeBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55187);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50084);
/* harmony import */ var _useEntitlementTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12143);
/* harmony import */ var _useUsageData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38539);






var useEntitlementBadges = function(entitlement) {
    var hookData = (0,_useUsageData__WEBPACK_IMPORTED_MODULE_5__/* .useUsageData */ .L)();
    var usageDataLoading = hookData.loading, usageData = hookData.usageData;
    var ref = (0,_useEntitlementTable__WEBPACK_IMPORTED_MODULE_4__/* .useEntitlementTable */ .Z)(), entitlementTable = ref.entitlementTable, entitlementTableLoading = ref.loading;
    var userCurrentEdition = usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition;
    var loading = entitlementTableLoading || usageDataLoading;
    var entitlementObj = userCurrentEdition && (entitlementTable ? entitlementTable[userCurrentEdition][entitlement] : undefined);
    var currentEditionMeta = userCurrentEdition && _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_3__/* .EDITION_META */ .JZ[userCurrentEdition];
    var nextEditionMeta = (entitlementObj === null || entitlementObj === void 0 ? void 0 : entitlementObj.nextEdition) && _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_3__/* .EDITION_META */ .JZ[entitlementObj.nextEdition];
    var currentEditionBadge = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return function() {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_billing_EditionBadgeBase__WEBPACK_IMPORTED_MODULE_2__/* .EditionBadgeBase */ .i, {
                size: "slim",
                children: loading ? "--" : (currentEditionMeta === null || currentEditionMeta === void 0 ? void 0 : currentEditionMeta.label) || (currentEditionMeta === null || currentEditionMeta === void 0 ? void 0 : currentEditionMeta.label)
            });
        };
    }, [
        loading,
        currentEditionMeta
    ]);
    var nextEditionBadge = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return !nextEditionMeta ? undefined : function() {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_billing_EditionBadgeBase__WEBPACK_IMPORTED_MODULE_2__/* .EditionBadgeBase */ .i, {
                paid: (entitlementObj === null || entitlementObj === void 0 ? void 0 : entitlementObj.nextEdition) !== "LITE",
                size: "slim",
                children: loading ? "--" : nextEditionMeta.label || nextEditionMeta.label
            });
        };
    }, [
        loading,
        nextEditionMeta,
        entitlementObj === null || entitlementObj === void 0 ? void 0 : entitlementObj.nextEdition
    ]);
    return {
        currentEditionMeta: currentEditionMeta,
        nextEditionMeta: nextEditionMeta,
        nextEditionBadge: nextEditionBadge,
        currentEditionBadge: currentEditionBadge,
        loading: loading
    };
};


/***/ }),

/***/ 69926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ useEntitlementContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.ts
var Team = __webpack_require__(72897);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.consts.ts
var Team_consts = __webpack_require__(50084);
// EXTERNAL MODULE: ./src/utils/router.ts
var router = __webpack_require__(63429);
// EXTERNAL MODULE: ./src/utils/strings.ts + 1 modules
var strings = __webpack_require__(84467);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/components/billing/EditionBadge.tsx
var EditionBadge = __webpack_require__(64462);
;// CONCATENATED MODULE: ./src/components/billing/Entitletip.consts.tsx







var numToStr = function(num) {
    return num === Infinity ? "unlimited" : "".concat(num);
};
var makeIntegrationTitleFn = function(entitlement) {
    return function(param) {
        var nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can't use the ",
                Team_consts/* ENTITLEMENT_META */.mm[entitlement].label,
                " on your current plan.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to keep access to it!"
            ]
        });
    };
};
// Keeping these as separate functions so we can break
// them out separately if we want later without hassle.
var makeCustomBlockingTitleFn = makeIntegrationTitleFn;
var pluralizeUpTo = function(count, noun) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return "".concat(!!count ? options.upToText || "up to ".concat(count) : "no", " ").concat((0,strings/* pluralize */._6)(count, noun, options.plural));
};
var ENTITLETIP_TITLES = {
    TEAM_SIZE: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can have ",
                pluralizeUpTo(value.max, "member"),
                " on your team.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to increase your time size to ",
                numToStr(nextValue.max),
                " people!"
            ]
        });
    },
    SCHEDULER_WEEKS: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can currently schedule links ",
                pluralizeUpTo(value, "week"),
                " in advance.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to schedule ",
                nextValue,
                " weeks out!"
            ]
        });
    },
    MAX_TASKS: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can create ",
                pluralizeUpTo(value, "Task"),
                ".",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to get ",
                numToStr(nextValue),
                " Tasks."
            ]
        });
    },
    MAX_CALENDARS: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can connect ",
                pluralizeUpTo(value, "calendar"),
                ".",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to connect ",
                numToStr(nextValue),
                " calendars."
            ]
        });
    },
    MAX_SYNCS: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can ",
                value === 1 && "only ",
                " sync",
                " ",
                value === 1 ? "".concat(value, " calendar") : pluralizeUpTo(value, "calendar", {
                    upToText: "up across"
                }),
                ".",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to add ",
                numToStr(nextValue),
                " syncs."
            ]
        });
    },
    MAX_HABITS: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can create ",
                pluralizeUpTo(value, "Habit"),
                ".",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to get ",
                numToStr(nextValue),
                " Habits."
            ]
        });
    },
    MAX_CUSTOM_TIME_SCHEMES: function(param) {
        var nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You cannot create custom hours.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to get unlimited."
            ]
        });
    },
    MAX_SCHEDULING_LINKS: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can ",
                value === 1 && "only ",
                " create",
                " ",
                value === 1 ? "".concat(value, " Scheduling Link") : pluralizeUpTo(value, "Scheduling Link"),
                ".",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to get ",
                numToStr(nextValue),
                " Scheduling Links."
            ]
        });
    },
    MAX_1_ON_1_ORGANIZE: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can ",
                value === 1 && "only ",
                " organize ",
                value === 1 ? "".concat(value, " Smart 1:1") : pluralizeUpTo(value, "Smart 1:1"),
                ". ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to organize ",
                pluralizeUpTo(nextValue, "Smart 1:1"),
                "."
            ]
        });
    },
    MAX_1_ON_1_ATTEND: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You can join ",
                pluralizeUpTo(value, "Smart 1:1"),
                ".",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to join ",
                numToStr(nextValue),
                " Smart 1:1s."
            ]
        });
    },
    TEAM_ANALYTICS: function(param) {
        var nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to get Team Analytics."
            ]
        });
    },
    SUPPORT: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You have access to ",
                value.toLowerCase(),
                " support.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to get",
                nextValue.toLocaleLowerCase(),
                " support."
            ]
        });
    },
    SSO: function(param) {
        var nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Your team cannot log in via SSO.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to allow you and your team mates to log in with SSO!"
            ]
        });
    },
    DERIVATIVE_SCHEDULING_LINKS: function(param) {
        var nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Custom links are only available with a ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditionBadge/* EditionBadge */.M, {
                    edition: nextEdition
                }),
                " plan."
            ]
        });
    },
    CUSTOM_SLACK_STATUS: makeIntegrationTitleFn("CUSTOM_SLACK_STATUS"),
    // custom blocking
    CUSTOM_BLOCKING: function(param) {
        var nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Customize how this time gets displayed on your calendar.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                })
            ]
        });
    },
    CUSTOM_BLOCKING_CALENDAR_SYNC: makeCustomBlockingTitleFn("CUSTOM_BLOCKING_CALENDAR_SYNC"),
    CUSTOM_BLOCKING_DECOMPRESSION: makeCustomBlockingTitleFn("CUSTOM_BLOCKING_DECOMPRESSION"),
    CUSTOM_BLOCKING_HABITS: makeCustomBlockingTitleFn("CUSTOM_BLOCKING_HABITS"),
    // custom questions
    SCHEDULING_LINK_SURVEY: function(param) {
        var nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to add custom questions."
            ]
        });
    },
    SCHEDULING_LINK_REDIRECT: function(param) {
        var nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to add redirect URLs"
            ]
        });
    },
    // integrations
    INTEGRATIONS: function(param) {
        var value = param.value, nextValue = param.nextValue, nextEdition = param.nextEdition;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "You have access to ",
                value.toLowerCase(),
                " integrations but are using some from a higher plan.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                    href: (0,router/* getBillingUrl */.uN)(Team/* TeamRedirectAction.StartPurchase */.Pt.StartPurchase),
                    children: [
                        "Upgrade to ",
                        Team_consts/* EDITION_META */.JZ[nextEdition].label
                    ]
                }),
                " ",
                "to get ",
                nextValue.toLocaleLowerCase(),
                " integrations."
            ]
        });
    },
    INTEGRATION_SLACK: makeIntegrationTitleFn("INTEGRATION_SLACK"),
    INTEGRATION_RAYCAST: makeIntegrationTitleFn("INTEGRATION_RAYCAST"),
    INTEGRATION_CLICKUP: makeIntegrationTitleFn("INTEGRATION_CLICKUP"),
    INTEGRATION_ZOOM: makeIntegrationTitleFn("INTEGRATION_ZOOM"),
    INTEGRATION_GOOGLE_TASKS: makeIntegrationTitleFn("INTEGRATION_GOOGLE_TASKS"),
    INTEGRATION_JIRA: makeIntegrationTitleFn("INTEGRATION_JIRA"),
    INTEGRATION_ASANA: makeIntegrationTitleFn("INTEGRATION_ASANA"),
    INTEGRATION_TODOIST: makeIntegrationTitleFn("INTEGRATION_TODOIST"),
    INTEGRATION_LINEAR: makeIntegrationTitleFn("INTEGRATION_LINEAR"),
    INTEGRATION_GOOGLE_ADD_ON: makeIntegrationTitleFn("INTEGRATION_GOOGLE_ADD_ON"),
    INTEGRATION_MONDAY: makeIntegrationTitleFn("INTEGRATION_MONDAY"),
    INTEGRATION_OFFICE_365: makeIntegrationTitleFn("INTEGRATION_OFFICE_365"),
    INTEGRATION_TRELLO: makeIntegrationTitleFn("INTEGRATION_TRELLO")
};

// EXTERNAL MODULE: ./src/hooks/useEntitlementTable.ts
var useEntitlementTable = __webpack_require__(12143);
// EXTERNAL MODULE: ./src/hooks/useUsageData.ts + 1 modules
var useUsageData = __webpack_require__(38539);
;// CONCATENATED MODULE: ./src/hooks/useEntitlementContent.tsx



var useEntitlementContent = function(entitlement, mode) {
    var hookData = (0,useUsageData/* useUsageData */.L)();
    var usageDataLoading = hookData.loading, usageData = hookData.usageData;
    var ref = (0,useEntitlementTable/* useEntitlementTable */.Z)(), entitlementTable = ref.entitlementTable, entitlementTableLoading = ref.loading;
    var userCurrentEdition = usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition;
    var loading = entitlementTableLoading || usageDataLoading;
    var entitlementObj = userCurrentEdition && (entitlementTable ? entitlementTable[userCurrentEdition][entitlement] : undefined);
    var entitletipContent = ENTITLETIP_TITLES[entitlement];
    var entitletipContentCollection = typeof entitletipContent === "function" ? {
        add: entitletipContent,
        usage: entitletipContent
    } : entitletipContent;
    var usageMessage = mode !== "subtract" && (entitlementObj === null || entitlementObj === void 0 ? void 0 : entitlementObj.nextEdition) ? entitletipContentCollection[mode](entitlementObj) : undefined;
    return {
        usageMessage: usageMessage,
        loading: loading
    };
};


/***/ }),

/***/ 37049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useEntitlementLogic; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59484);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50084);
/* harmony import */ var _atoms_useTeam__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10352);
/* harmony import */ var _useUsageData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38539);






var useEntitlementLogic = function(entitlement) {
    var ref, ref1, ref2;
    var hookData = (0,_useUsageData__WEBPACK_IMPORTED_MODULE_3__/* .useUsageData */ .L)();
    var team = (0,_atoms_useTeam__WEBPACK_IMPORTED_MODULE_2__/* .useTeamState */ .Oo)(true).team;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_0__/* .useUserContext */ .SE)(), 1), user = ref3[0].user;
    /**
   * This is a temporary hack to disable the derivative scheduling links entitlement
   * if the user is on the lite plan.
   *
   * TODO: Remove this once we have a better way to handle this. We depend on the BE
   * to solve this and add the entitlement to the `actuals` object.
   *
   * See: RAI-8650
   */ var booleanEntitlements = [
        "DERIVATIVE_SCHEDULING_LINKS",
        "SCHEDULING_LINK_SURVEY",
        "SCHEDULING_LINK_REDIRECT", 
    ];
    var manuallyDisabled = booleanEntitlements.includes(entitlement) ? !(user === null || user === void 0 ? void 0 : (ref = user.editionEntitlements) === null || ref === void 0 ? void 0 : (ref1 = ref[entitlement]) === null || ref1 === void 0 ? void 0 : ref1.value) : false;
    var comparator = _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .ENTITLEMENT_META */ .mm[entitlement].comparator;
    var usageData = hookData.usageData, loading = hookData.loading;
    var ref4 = (usageData === null || usageData === void 0 ? void 0 : usageData.actuals[entitlement]) || {}, actualValue = ref4.actualValue, allowedValueForCurrentEdition = ref4.allowedValueForCurrentEdition;
    var hasUnlimitedUsage = typeof allowedValueForCurrentEdition === "number" && !isFinite(allowedValueForCurrentEdition) || typeof allowedValueForCurrentEdition === "boolean" && allowedValueForCurrentEdition;
    var usageLimit = typeof allowedValueForCurrentEdition === "number" ? allowedValueForCurrentEdition : undefined;
    // we only want to lock the whole account if we're in new pricing
    var inUsageOverage = !!(usageData === null || usageData === void 0 ? void 0 : usageData.overage) && !!(team === null || team === void 0 ? void 0 : team.newPricing);
    var missingActuals = (usageData === null || usageData === void 0 ? void 0 : usageData.actuals[entitlement]) === undefined;
    var disableSubtract = false;
    var disableUsage = loading || inUsageOverage || manuallyDisabled;
    // If the actuals do not exist then default to the overall overage for add
    var disableAdd = missingActuals ? disableUsage : loading || !((ref2 = usageData === null || usageData === void 0 ? void 0 : usageData.actuals[entitlement]) === null || ref2 === void 0 ? void 0 : ref2.moreUsageAllowed);
    var entitlementIsInOverage = disableUsage || (actualValue !== undefined ? comparator(actualValue, allowedValueForCurrentEdition) > 0 : false);
    var entitlementAddWouldBeOverage = disableAdd || typeof actualValue === "boolean" && comparator(!actualValue, allowedValueForCurrentEdition) > 0 || typeof actualValue === "number" && comparator(actualValue + 1, allowedValueForCurrentEdition) > 0;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        hasUnlimitedUsage: hasUnlimitedUsage,
        usageLimit: usageLimit,
        disableAdd: disableAdd,
        disableSubtract: disableSubtract,
        disableUsage: disableUsage,
        entitlementIsInOverage: entitlementIsInOverage,
        entitlementAddWouldBeOverage: entitlementAddWouldBeOverage
    }, hookData);
};


/***/ }),

/***/ 12143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEntitlementTable; }
/* harmony export */ });
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54517);
/* harmony import */ var _utils_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56501);


var useEntitlementTable = (0,_utils_react__WEBPACK_IMPORTED_MODULE_1__/* .makeLoadableHook */ .fc)(function() {
    return _reclaim_api__WEBPACK_IMPORTED_MODULE_0__/* .reclaim.team.getEntitlementTable */ .Tz.team.getEntitlementTable();
}, {
    dataKey: "entitlementTable",
    errorizer: "Failed to get entitlement table"
}).useHook;


/***/ }),

/***/ 30936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useErrorIfChanged; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useErrorIfChanged = function(thing) {
    var error = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "value must not change";
    var errorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(error);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var lastThing = thing;
        return function() {
            var error = errorRef.current;
            if (thing !== lastThing) {
                if (typeof error === "function") error = error(thing, lastThing);
                if (typeof error === "string") throw new Error(error);
                else throw error;
            }
        };
    }, [
        thing
    ]);
};


/***/ }),

/***/ 76231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useWindowEventListener; }
/* harmony export */ });
/* unused harmony export useDocumentEventListener */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47310);


var useWindowEventListener = function(type, listener) {
    var safeReffed = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackSafeRef */ .T)(listener);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener(type, safeReffed);
        return function() {
            return window.removeEventListener(type, safeReffed);
        };
    }, [
        safeReffed,
        type
    ]);
};
var useDocumentEventListener = function(type, listener) {
    var safeReffed = useCallbackSafeRef(listener);
    useEffect(function() {
        document.addEventListener(type, safeReffed);
        return function() {
            return document.removeEventListener(type, safeReffed);
        };
    }, [
        safeReffed,
        type
    ]);
};


/***/ }),

/***/ 74194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useIntegrationsEnabledMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13665);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54517);
/* harmony import */ var _utils_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56501);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);








var loadData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _reclaim_api__WEBPACK_IMPORTED_MODULE_0__/* .reclaim.integrations.getEnabledMap */ .Tz.integrations.getEnabledMap()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function loadData() {
        return _ref.apply(this, arguments);
    };
}();
var ref = (0,_utils_react__WEBPACK_IMPORTED_MODULE_1__/* .makeLoadableHook */ .fc)(loadData, {
    dataKey: "integrationsEnabledMap",
    errorizer: "Failed to get integrations enabled map"
}), useHook = ref.useHook, dataAtom = ref.dataAtom;
var useIntegrationsEnabledMap = function() {
    var hookData = useHook();
    var setData = (0,jotai__WEBPACK_IMPORTED_MODULE_5__/* .useSetAtom */ .b9)(dataAtom);
    var reloadIntegrationsEnabledMap = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var newData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        loadData()
                    ];
                case 1:
                    newData = _state.sent();
                    return [
                        4,
                        setData(newData)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }));
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, hookData), {
        reloadIntegrationsEnabledMap: reloadIntegrationsEnabledMap
    });
};


/***/ }),

/***/ 10428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ usePageSupportsIntercom; },
/* harmony export */   "o": function() { return /* binding */ useIntercom; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_use_intercom__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41608);
/* harmony import */ var _consts_shadow_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54137);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34557);
/* harmony import */ var _consts_emails__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8846);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59484);
/* harmony import */ var _useNotifications__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55973);
/* harmony import */ var _useOurRouter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52581);



// eslint-disable-next-line no-restricted-imports







var NO_INTERCOM_PATH_MATCHES = [
    /^\/websites\//i
];
var usePageSupportsIntercom = function() {
    var pathname = (0,_useOurRouter__WEBPACK_IMPORTED_MODULE_6__/* .useOurRouter */ .ED)().pathname;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return !_consts_shadow_consts__WEBPACK_IMPORTED_MODULE_2__/* .isImpersonating */ .sQ && NO_INTERCOM_PATH_MATCHES.every(function(rx) {
            return !pathname.match(new RegExp(rx));
        });
    }, [
        pathname
    ]);
};
var useIntercom = function(defaultMessage) {
    var ref = (0,react_use_intercom__WEBPACK_IMPORTED_MODULE_7__/* .useIntercom */ .o)(), boot = ref.boot, show = ref.show, showNewMessage = ref.showNewMessage;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_4__/* .useUserContext */ .SE)(), 1), user = ref1[0].user;
    var sendNotification = (0,_useNotifications__WEBPACK_IMPORTED_MODULE_5__/* .useNotifications */ .z)().sendNotification;
    var showIntercom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (_consts_shadow_consts__WEBPACK_IMPORTED_MODULE_2__/* .isImpersonating */ .sQ) {
            sendNotification({
                message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: "You're currently impersonating a user. Intercom is disabled while impersonating."
                }),
                type: "warning"
            });
        } else if (!window.Intercom.booted) {
            sendNotification({
                message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "Couldn't load Intercom. Try sending us an email at",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
                            href: "mailto:".concat(_consts_emails__WEBPACK_IMPORTED_MODULE_9__/* .SUPPORT_EMAIL */ .X),
                            children: _consts_emails__WEBPACK_IMPORTED_MODULE_9__/* .SUPPORT_EMAIL */ .X
                        }),
                        ". Want to know more? Check out our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
                            href: "https://help.reclaim.ai/en/articles/6338330",
                            children: "help docs"
                        }),
                        "."
                    ]
                }),
                type: "warning"
            });
        } else if (!!defaultMessage) {
            showNewMessage(defaultMessage);
        } else {
            show();
        }
    }, [
        showNewMessage,
        defaultMessage,
        show,
        sendNotification
    ]);
    var pageSupportsIntercom = usePageSupportsIntercom();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (user && pageSupportsIntercom) {
            boot({
                name: user.name,
                email: user.email,
                userId: user.trackingCode,
                hideDefaultLauncher: true,
                customLauncherSelector: "#IntercomHelpButton"
            });
        }
    }, [
        boot,
        user,
        pageSupportsIntercom
    ]);
    return {
        showIntercom: showIntercom
    };
};


/***/ }),

/***/ 60128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useIsMountedRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useIsMountedRef() {
    var isMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        isMountedRef.current = true;
        return function() {
            return void (isMountedRef.current = false);
        };
    }, []);
    return isMountedRef;
}


/***/ }),

/***/ 61910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMemoizedPromise; }
/* harmony export */ });
/* unused harmony export useDebouncedMemoizedPromise */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47310);
/* harmony import */ var _useCaptureError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59546);
/* harmony import */ var _useDebounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11259);
/* harmony import */ var _useIsMountedRef__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60128);







var useMemoizedPromise = function(factory, deps) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var allowRaceConditions = options.allowRaceConditions;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), val = ref[0], setVal = ref[1];
    var isMountedRef = (0,_useIsMountedRef__WEBPACK_IMPORTED_MODULE_4__/* .useIsMountedRef */ .X)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), error = ref2[0], setError = ref2[1];
    var captureError = (0,_useCaptureError__WEBPACK_IMPORTED_MODULE_2__/* .useCaptureError */ .e)().captureError;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (error) captureError(error, {
            severity: "error"
        });
    }, [
        error,
        captureError
    ]);
    var forceReload = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackSafeRef */ .T)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var r, cause, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        factory()
                    ];
                case 1:
                    r = _state.sent();
                    if (!isMountedRef.current) return [
                        2
                    ];
                    setVal(r);
                    return [
                        2,
                        r
                    ];
                case 2:
                    cause = _state.sent();
                    e = new Error("Problem while re-running promise", {
                        cause: cause
                    });
                    setError(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }));
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer = undefined;
        var mostRecentRequest = true;
        void (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var p, r, cause;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        p = factory();
                        // offset starting loading by a frame so
                        // already-resolved promises don't get
                        // picked up
                        timer = setTimeout(function() {
                            return setLoading(true);
                        });
                        return [
                            4,
                            p
                        ];
                    case 1:
                        r = _state.sent();
                        if (!isMountedRef.current || !allowRaceConditions && !mostRecentRequest) return [
                            2
                        ];
                        setVal(r);
                        setError(undefined);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        cause = _state.sent();
                        setError(new Error("Problem while running promise", {
                            cause: cause
                        }));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (!isMountedRef.current || !allowRaceConditions && !mostRecentRequest) return [
                            2
                        ];
                        if (timer) clearTimeout(timer);
                        setLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            mostRecentRequest = false;
            timer && clearTimeout(timer);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return [
        val,
        loading,
        error,
        forceReload
    ];
};
var useDebouncedMemoizedPromise = function(factory, deps, debounceMs) {
    var cb = usePromisedDebounce(factory, debounceMs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemoizedPromise(cb, deps);
};


/***/ }),

/***/ 86830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useMicroShortcuts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useShortcut__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80236);


var useMicroShortcuts = function(submitCallback, cancelCallback) {
    (0,_useShortcut__WEBPACK_IMPORTED_MODULE_1__/* .useShortcut */ .b)("Escape", (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        // Prevent other key listeners from hijacking
        e.stopPropagation();
        cancelCallback();
    }, [
        cancelCallback
    ]));
    (0,_useShortcut__WEBPACK_IMPORTED_MODULE_1__/* .useShortcut */ .b)("Enter", (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        // Prevent other key listeners from hijacking
        e.stopPropagation();
        submitCallback();
    }, [
        submitCallback
    ]));
};


/***/ }),

/***/ 55973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useNotifications; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20377);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_notifications_Snackbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8309);
// eslint-disable-next-line no-restricted-imports





var useNotifications = function() {
    // useNotifications returns undefined in SSR
    var ref = (notistack__WEBPACK_IMPORTED_MODULE_1__/* .useSnackbar */ .Ds === null || notistack__WEBPACK_IMPORTED_MODULE_1__/* .useSnackbar */ .Ds === void 0 ? void 0 : (0,notistack__WEBPACK_IMPORTED_MODULE_1__/* .useSnackbar */ .Ds)()) || {}, enqueueSnackbar = ref.enqueueSnackbar, closeSnackbar = ref.closeSnackbar;
    var sendNotification = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(snackbarOptions, notistackOptions) {
        var id;
        var handleClose = function() {
            return closeSnackbar === null || closeSnackbar === void 0 ? void 0 : closeSnackbar(id);
        };
        id = (enqueueSnackbar === null || enqueueSnackbar === void 0 ? void 0 : enqueueSnackbar("", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            content: function() {
                if (typeof snackbarOptions === "function") return snackbarOptions(handleClose);
                else if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(snackbarOptions)) return snackbarOptions;
                else if (typeof snackbarOptions === "object") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_notifications_Snackbar__WEBPACK_IMPORTED_MODULE_3__/* .Snackbar */ .A, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    onClose: handleClose
                }, snackbarOptions));
                else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_notifications_Snackbar__WEBPACK_IMPORTED_MODULE_3__/* .Snackbar */ .A, {
                    onClose: handleClose,
                    message: snackbarOptions
                });
            }()
        }, notistackOptions))) || "";
        return handleClose;
    }, [
        closeSnackbar,
        enqueueSnackbar
    ]);
    return {
        sendNotification: sendNotification
    };
};


/***/ }),

/***/ 52581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ED": function() { return /* binding */ useOurRouter; },
/* harmony export */   "xH": function() { return /* binding */ flatten; }
/* harmony export */ });
/* unused harmony exports unflatten, getRouteParams, stripQueryFromPathname, processUrlObject */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45110);
/* harmony import */ var _utils_platform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94423);






function flatten(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!obj) return;
    return Object.keys(obj).reduce(function(acc, k) {
        if (k === "" || obj[k] === undefined || obj[k] === null) return acc;
        var pre = prefix.length ? prefix + "." : "";
        if (typeof obj[k] === "object") Object.assign(acc, flatten(obj[k], pre + k));
        else acc[pre + k] = obj[k];
        return acc;
    }, {});
}
function unflatten(obj) {
    var _loop = function(i) {
        var keys = i.split(".");
        keys.reduce(function(acc, k, j) {
            return acc[k] || (acc[k] = isNaN(Number(keys[j + 1])) ? keys.length - 1 == j ? obj[i] : {} : []);
        }, result);
    };
    if (!obj) return {};
    var simpleObj = Object.keys(obj).reduce(function(acc, k) {
        acc[k] = Array.isArray(obj[k]) && obj[k].length === 1 ? obj[k][0] : obj[k];
        return acc;
    }, {});
    var result = {};
    for(var i in simpleObj)_loop(i);
    return result;
}
// this isn't importing the escape-string-regex module
// to reduce bytes
function escapeRegex(str) {
    return str.replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&");
}
function parseParameter(param) {
    var optional = param.startsWith("[") && param.endsWith("]");
    if (optional) {
        param = param.slice(1, -1);
    }
    var repeat = param.startsWith("...");
    if (repeat) {
        param = param.slice(3);
    }
    return {
        key: param,
        repeat: repeat,
        optional: optional
    };
}
function getRouteParams(normalizedRoute) {
    var segments = (normalizedRoute.replace(/\/$/, "") || "/").slice(1).split("/");
    var groups = {};
    segments.map(function(segment) {
        if (segment.startsWith("[") && segment.endsWith("]")) {
            var ref = parseParameter(segment.slice(1, -1)), key = ref.key, optional = ref.optional, repeat = ref.repeat;
            groups[key] = {
                repeat: repeat,
                optional: optional
            };
        } else {
            return "/".concat(escapeRegex(segment));
        }
    });
    return groups;
}
var stripQueryFromPathname = function(pathname) {
    if (pathname.includes("://")) throw new Error("Invalid pathname provided.");
    var pathnameSplit = pathname.split("?");
    var query = {};
    if (!!pathnameSplit[1]) {
        var searchParams = new URLSearchParams(pathnameSplit[1]);
        searchParams.forEach(function(value, key) {
            query[key] = value;
        });
    }
    return {
        pathname: pathnameSplit[0],
        query: query
    };
};
/**
 * The purpose of this function is to strip any extra query that is included in the pathname
 * and add it to the query object. The next router will ignore the query object if the pathname contains
 * a query. For example: 
 * 
 * { pathname: "/path/page?id=someid", query: { type: "bananas" } }
 * 
 * Will lose the query "type=bananas" on route change.
 */ var processUrlObject = function(urlObject) {
    if (!urlObject.pathname || typeof urlObject.query === "string") return urlObject;
    var processed = stripQueryFromPathname(urlObject.pathname);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, urlObject), {
        pathname: processed.pathname,
        query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, urlObject.query, processed.query)
    });
};
function useOurRouter() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var params = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return getRouteParams(router.pathname);
    }, [
        router.pathname
    ]);
    var parsedQuery = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return unflatten(router.query);
    }, [
        router.query
    ]);
    var setQuery = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(values) {
        var url = "".concat(router.asPath.replace(/\?.*/, "")).concat(!!values ? "?".concat(new URLSearchParams(flatten(values))) : "");
        return router.replace(url);
    }, [
        router
    ]);
    var push = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(url, as, options) {
        if (!(0,_utils_platform__WEBPACK_IMPORTED_MODULE_3__/* .browser */ .Xh)().isBrowser) {
            console.warn("tried calling push to ".concat(typeof url !== "string" ? url.pathname : url, " durring SSR"));
            return Promise.resolve(false);
        }
        var query = typeof url !== "string" ? flatten((0,_utils_objects__WEBPACK_IMPORTED_MODULE_2__/* .omit */ .CE)(Object.keys(params), url.query || {})) : {};
        if (typeof url !== "string" && !url.pathname) {
            return setQuery(query);
        }
        return router.push(typeof url === "string" ? url : processUrlObject({
            pathname: url.pathname,
            query: query
        }), as, options);
    }, [
        params,
        router,
        setQuery
    ]);
    var replace = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(url, as, options) {
        if (!(0,_utils_platform__WEBPACK_IMPORTED_MODULE_3__/* .browser */ .Xh)().isBrowser) {
            console.warn("tried calling replace to ".concat(typeof url !== "string" ? url.pathname : url, " durring SSR"));
            return Promise.resolve(false);
        }
        var query = typeof url !== "string" ? flatten((0,_utils_objects__WEBPACK_IMPORTED_MODULE_2__/* .omit */ .CE)(Object.keys(params), url.query || {})) : {};
        if (typeof url !== "string" && !url.pathname) {
            return setQuery(query);
        }
        return router.replace(typeof url === "string" ? url : processUrlObject({
            pathname: url.pathname,
            query: query
        }), as, options);
    }, [
        params,
        router,
        setQuery
    ]);
    var wrapped = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, router), {
            query: parsedQuery,
            search: router.query,
            params: params,
            push: push,
            replace: replace
        });
    }, [
        params,
        parsedQuery,
        push,
        replace,
        router
    ]);
    return wrapped;
}


/***/ }),

/***/ 5061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useRecommendedEdition; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50084);
/* harmony import */ var _reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13811);
/* harmony import */ var _utils_arrays__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92886);
/* harmony import */ var _utils_sort__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14023);
/* harmony import */ var _useUsageData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38539);







var useRecommendedEdition = function(seats, editions, subscriptionOptions) {
    var ref = (0,_useUsageData__WEBPACK_IMPORTED_MODULE_5__/* .useUsageData */ .L)(), usageData = ref.usageData, usageDataLoading = ref.loading, usageDataError = ref.error;
    var hasSeats = typeof seats === "number";
    var loading = usageDataLoading || !hasSeats;
    var error = usageDataError;
    var dataReady = !!usageData && !!subscriptionOptions;
    if (!!error) loading = false;
    var recommendedEdition = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!dataReady || loading || !!error || !hasSeats) return;
        var isValidEdition = function(edition) {
            return !!edition && !!dataReady && !!subscriptionOptions.options[edition] && !_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[edition].isTrial && !_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[edition].isNonPaid && !_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[edition].isLegacy;
        };
        var filteredEditions = editions.filter(isValidEdition);
        var minMembershipEdition = filteredEditions.find(function(edition) {
            var _edition = subscriptionOptions.options[edition], minSeats = _edition.minSeats, maxSeats = _edition.maxSeats;
            return !_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[edition].isLegacy && seats >= minSeats && seats <= maxSeats;
        });
        var edition = _utils_sort__WEBPACK_IMPORTED_MODULE_4__/* .sortMax.apply */ .Vk.apply(void 0, [
            _reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__/* .reclaimEditionComparator */ .Wg
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_utils_arrays__WEBPACK_IMPORTED_MODULE_3__/* .filterFalsy */ .SY)([
            usageData.recommendedEdition,
            minMembershipEdition
        ].filter(isValidEdition)))));
        if (!!usageData && !edition) {
            // See if there is a legacy plan to recommend if nothing else is recommended
            var legacy = editions.find(function(e) {
                return _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[e].isLegacy;
            });
            return legacy || edition;
        } else {
            return edition;
        }
    }, [
        dataReady,
        editions,
        error,
        hasSeats,
        loading,
        seats,
        subscriptionOptions === null || subscriptionOptions === void 0 ? void 0 : subscriptionOptions.options,
        usageData
    ]);
    var state = "hasData";
    if (error) state = "hasError";
    else if (loading) state = "loading";
    return {
        recommendedEdition: recommendedEdition,
        loading: loading,
        error: error,
        state: state
    };
};


/***/ }),

/***/ 93103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useResizeObserver; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47310);
/* harmony import */ var _useErrorIfChanged__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30936);



var useResizeObserver = function(callback, ref) {
    (0,_useErrorIfChanged__WEBPACK_IMPORTED_MODULE_2__/* .useErrorIfChanged */ .O)(ref, "'ref' argument may not change");
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (!ref) ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var safeCallback = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackSafeRef */ .T)(callback);
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return typeof ResizeObserver !== "undefined" ? new ResizeObserver(function() {
            return (ref === null || ref === void 0 ? void 0 : ref.current) && safeCallback(ref.current.getBoundingClientRect().toJSON());
        }) : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var el = ref.current;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (el) observer === null || observer === void 0 ? void 0 : observer.observe(el);
        return function() {
            if (el) observer === null || observer === void 0 ? void 0 : observer.unobserve(el);
        };
    }, [
        el,
        observer
    ]);
    // ResizeObserver is not firing on first run
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) safeCallback(ref.current.getBoundingClientRect().toJSON());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref.current
    ]);
    return ref;
};


/***/ }),

/***/ 80236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useShortcut; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45110);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);







function useShortcut(keys, handler) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _enabled = options.enabled, enabled = _enabled === void 0 ? true : _enabled, target = options.target;
    var timers = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({});
    var pressedKeys = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({});
    var handleShortcutTrigger = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (enabled) handler.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
    });
    var targetKeys = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!keys) return {};
        var arrKeys = Array.isArray(keys) ? keys : [
            keys
        ];
        return (0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .extantMap */ .jG)(Array.isArray(arrKeys) ? arrKeys : [
            arrKeys
        ]);
    }, [
        keys
    ]);
    var onKeyDown = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function(event) {
        var key = event.key;
        if (!key) return;
        if (targetKeys[key]) {
            pressedKeys.current = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, pressedKeys.current), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, key, true));
        }
        var timer = timers.current[key];
        if (timer) clearTimeout(timer);
        if ((0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .typedKeys */ .Nw)(targetKeys).every(function(k) {
            return pressedKeys.current[k];
        })) {
            var ref, ref1;
            // in case only some keys are released
            Object.keys(timers.current).forEach(function(k) {
                clearTimeout(timers.current[k]);
            });
            handleShortcutTrigger(event, pressedKeys.current, ((ref = document.activeElement) === null || ref === void 0 ? void 0 : ref.tagName) === "INPUT" || ((ref1 = document.activeElement) === null || ref1 === void 0 ? void 0 : ref1.tagName) === "TEXTAREA");
            // Clear the pressed keys are executing the shortcut
            pressedKeys.current = {};
        } else {
            timers.current[key] = setTimeout(function() {
                pressedKeys.current = {};
            }, 2500);
        }
    });
    var onKeyUp = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(function(event) {
        if (event.type === "commandbar-shortcut-executed") return pressedKeys.current = {};
        var key = event.key;
        if (!key) return;
        var timer = timers.current[key];
        if (timer) clearTimeout(timer);
        // Key-ups don't fire while meta is held down.  It's a
        // little strange but because of the general use-case
        // of the meta key we can just clear all down keys when
        // it comes up.
        if (key === "Meta") {
            pressedKeys.current = {};
        } else {
            pressedKeys.current = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, pressedKeys.current), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, key, false));
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var resolvedTarget = target || document;
        resolvedTarget.addEventListener("keydown", onKeyDown);
        resolvedTarget.addEventListener("keyup", onKeyUp);
        resolvedTarget.addEventListener("commandbar-shortcut-executed", onKeyUp);
        return function() {
            resolvedTarget.removeEventListener("keydown", onKeyDown);
            resolvedTarget.removeEventListener("keyup", onKeyUp);
            resolvedTarget.removeEventListener("commandbar-shortcut-executed", onKeyUp);
        };
    }, [
        onKeyDown,
        onKeyUp,
        target
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useShortcut);


/***/ }),

/***/ 39123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useSubscription; },
/* harmony export */   "t": function() { return /* binding */ useSubscriptionWithCallback; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63496);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45110);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);





/**
 * Generate an observable from source arguments and subscribe, with the result
 * being the most recently emitted value.
 *
 * @param source function that generates the source observable
 * @param sourceArguments args provided to the source function
 * @param enabled when true, source is called with sourceArguments and subscribed to
 * @returns current value of the generated observable
 */ var useSubscription = function(source) {
    var sourceArguments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], enabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), currentValue = ref[0], setCurrentValue = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(sourceArguments), currentArguments = ref1[0], setCurrentArguments = ref1[1];
    /**
   * Only update arguments if they've actually changed. This prevents
   * accidental infinite loops when source args aren't properly memoized
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setCurrentArguments(function(prev) {
            return (0,_utils_objects__WEBPACK_IMPORTED_MODULE_1__/* .hash */ .vp)(prev) === (0,_utils_objects__WEBPACK_IMPORTED_MODULE_1__/* .hash */ .vp)(sourceArguments) ? prev : sourceArguments;
        });
    }, [
        sourceArguments
    ]);
    /**
   * Call source function and subscribe, resubscribe any time source arguments change.
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!enabled) return;
        var ignore = false;
        // On mount, subscribe to the operator using the subject and schedule a teardown using scheduler (1)
        // Start the subscription using the subject and operator
        var unsubscribe = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(source.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(currentArguments)), (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)(function(value) {
            if (!ignore) setCurrentValue(function(prev) {
                return value !== prev ? value : prev;
            });
        })).unsubscribe;
        return function() {
            ignore = true;
            if (!!unsubscribe) unsubscribe();
        };
    }, [
        currentArguments,
        enabled,
        source
    ]);
    return currentValue;
};
/**
 * Generate an observable from source arguments and subscribe.
 *
 * @param source function that generates the source observable
 * @param callback callback to be called every time the socket produces data
 * @param enabled when true, source is called with sourceArguments and subscribed to
 */ var useSubscriptionWithCallback = function(source, cb) {
    var enabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var safeCb = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(cb);
    /**
   * Call source function and subscribe, resubscribe any time source arguments change.
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!enabled) return;
        var effectUnmounted = false;
        // On mount, subscribe to the operator using the subject and schedule a teardown using scheduler (1)
        // Start the subscription using the subject and operator
        var unsubscribe = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zG)(source(), (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)(function(value) {
            if (!effectUnmounted) safeCb(value);
        })).unsubscribe;
        return function() {
            effectUnmounted = true;
            if (!!unsubscribe) unsubscribe();
        };
    }, [
        safeCb,
        enabled,
        source
    ]);
};


/***/ }),

/***/ 55004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useSubscriptionLogic; }
/* harmony export */ });
/* harmony import */ var _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72897);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50084);
/* harmony import */ var _reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13811);
/* harmony import */ var _atoms_useTeam__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10352);
/* harmony import */ var _useUsageData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38539);





var useSubscriptionLogic = function() {
    var usageData = (0,_useUsageData__WEBPACK_IMPORTED_MODULE_4__/* .useUsageData */ .L)().usageData;
    var ref = (0,_atoms_useTeam__WEBPACK_IMPORTED_MODULE_3__/* .useTeamState */ .Oo)(true), team = ref.team, userMembership = ref.userMembership;
    /**
   * Member subscription
   */ var userCurrentEdition = usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition;
    var userTerminalEdition = usageData === null || usageData === void 0 ? void 0 : usageData.terminalEdition;
    var userUsageEdition = usageData === null || usageData === void 0 ? void 0 : usageData.usageEdition;
    var userIsAdmin = (userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole) === _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__/* .MembershipRole.Admin */ .nJ.Admin;
    var userIsOnRewards = !!userCurrentEdition && !!_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[userCurrentEdition].isReward;
    var userIsOnTrial = !!(userMembership === null || userMembership === void 0 ? void 0 : userMembership.trial) && !userIsOnRewards;
    var userDaysLeftInTrial = userMembership === null || userMembership === void 0 ? void 0 : userMembership.daysLeftInTrial;
    var userTrialEnd = userMembership === null || userMembership === void 0 ? void 0 : userMembership.trialEnd;
    var userIsOnPaidSeat = !!(userMembership === null || userMembership === void 0 ? void 0 : userMembership.paidSeat);
    var userCanRedeemRewards = (team === null || team === void 0 ? void 0 : team.members.length) === 1;
    /**
   * Team subscription
   */ var seats = team ? {
        used: team.pricingSummary.homogeneous ? team.membershipSummary.activeCount : team.totalSeatsUsed,
        purchased: team === null || team === void 0 ? void 0 : team.membershipSummary.paidCount
    } : {
        used: 1,
        purchased: 1
    };
    var subscriptionFrequency = team === null || team === void 0 ? void 0 : team.pricingSummary.subscriptionFrequency;
    var hasActiveSubscription = !!(team === null || team === void 0 ? void 0 : team.hasSubId);
    var teamHasAutoRenew = !!(team === null || team === void 0 ? void 0 : team.pricingSummary.autoRenew);
    var planCancelStatus = !!userCurrentEdition && !teamHasAutoRenew && !_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_1__/* .EDITION_META */ .JZ[userCurrentEdition].isNonPaid && !!(team === null || team === void 0 ? void 0 : team.pricingSummary.subscriptionEnd) ? {
        isCancelled: true,
        terminalDate: new Date(team === null || team === void 0 ? void 0 : team.pricingSummary.subscriptionEnd)
    } : {
        isCancelled: false
    };
    /**
   * Legacy plan support
   */ var userCanInvite = (0,_reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__/* .canInvite */ .AE)(userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole, team === null || team === void 0 ? void 0 : team.userInviteLevel);
    var userCanChangeSettings = (0,_reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_2__/* .canChangeSettings */ .M9)(userMembership === null || userMembership === void 0 ? void 0 : userMembership.membershipRole);
    var userCanSetInviteLevels = !(team === null || team === void 0 ? void 0 : team.pricingSummary.homogeneous) && userIsAdmin && (team === null || team === void 0 ? void 0 : team.userInviteLevel) !== "NONE";
    var pendingClawback = (userMembership === null || userMembership === void 0 ? void 0 : userMembership.edition) === "ASSISTANT" && (usageData === null || usageData === void 0 ? void 0 : usageData.currentEdition) !== "ASSISTANT";
    // TODO (RAI-7793)
    if (!(team === null || team === void 0 ? void 0 : team.newPricing) && userIsOnTrial) {
        userIsOnTrial = userIsOnTrial && (userMembership === null || userMembership === void 0 ? void 0 : userMembership.editionAfterTrial) !== "TEAM";
    }
    return {
        userCurrentEdition: userCurrentEdition,
        userTerminalEdition: userTerminalEdition,
        userUsageEdition: userUsageEdition,
        userIsAdmin: userIsAdmin,
        userIsOnTrial: userIsOnTrial,
        userDaysLeftInTrial: userDaysLeftInTrial,
        userTrialEnd: userTrialEnd,
        userIsOnPaidSeat: userIsOnPaidSeat,
        userIsOnRewards: userIsOnRewards,
        userCanRedeemRewards: userCanRedeemRewards,
        subscriptionFrequency: subscriptionFrequency,
        hasActiveSubscription: hasActiveSubscription,
        seats: seats,
        userCanInvite: userCanInvite,
        userCanChangeSettings: userCanChangeSettings,
        userCanSetInviteLevels: userCanSetInviteLevels,
        pendingClawback: pendingClawback,
        teamHasAutoRenew: teamHasAutoRenew,
        planCancelStatus: planCancelStatus
    };
};


/***/ }),

/***/ 53316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useSubscriptionOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _reclaim_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54517);
/* harmony import */ var _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50084);
/* harmony import */ var _reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13811);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45110);
/* harmony import */ var _atoms_useTeam__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10352);
/* harmony import */ var _useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47310);
/* harmony import */ var _useDebounce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11259);











var MILLISECONDS = 500;
var useSubscriptionOptions = function(quantity, currency) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), subscriptionOptions = ref2[0], setSubscriptionOptions = ref2[1];
    var teamCurrency = (0,_atoms_useTeam__WEBPACK_IMPORTED_MODULE_5__/* .useTeamState */ .Oo)().team.pricingSummary.currency;
    var fetchSubscriptionOptions = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_6__/* .useCallbackSafeRef */ .T)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(quantity, currency) {
            var options, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currency = currency || teamCurrency;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            _reclaim_api__WEBPACK_IMPORTED_MODULE_1__/* .reclaim.team.getSubscriptionOptions */ .Tz.team.getSubscriptionOptions(quantity, currency)
                        ];
                    case 2:
                        options = _state.sent();
                        setError(undefined);
                        setSubscriptionOptions(options);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(quantity, currency) {
            return _ref.apply(this, arguments);
        };
    }());
    var debouncedFetch = (0,_useDebounce__WEBPACK_IMPORTED_MODULE_7__/* .useDebounce */ .N)(fetchSubscriptionOptions, MILLISECONDS);
    var callFetch = (0,_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_6__/* .useCallbackSafeRef */ .T)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var _len, args, _key;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    setLoading(true);
                    return [
                        4,
                        debouncedFetch.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(args))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }));
    var editions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!subscriptionOptions) return [];
        var legacyEditions = (0,_utils_objects__WEBPACK_IMPORTED_MODULE_4__/* .typedKeys */ .Nw)(subscriptionOptions.options).filter(function(e) {
            return _reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_2__/* .EDITION_META */ .JZ[e].isLegacy;
        });
        var newEditions = (0,_utils_objects__WEBPACK_IMPORTED_MODULE_4__/* .typedKeys */ .Nw)(subscriptionOptions.options).filter(function(e) {
            return !_reclaim_api_team_Team_consts__WEBPACK_IMPORTED_MODULE_2__/* .EDITION_META */ .JZ[e].isLegacy;
        });
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(legacyEditions.sort(_reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_3__/* .reclaimEditionComparator */ .Wg)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(newEditions.sort(_reclaim_api_team_Team_utils__WEBPACK_IMPORTED_MODULE_3__/* .reclaimEditionComparator */ .Wg)));
    }, [
        subscriptionOptions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        void callFetch(quantity, currency);
    }, [
        quantity,
        callFetch,
        currency
    ]);
    return {
        subscriptionOptions: subscriptionOptions,
        editions: editions,
        loading: loading,
        error: error
    };
};


/***/ }),

/***/ 38539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ useUsageData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(13665);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(63496);
// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 16 modules
var reclaim_api = __webpack_require__(54517);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.utils.ts
var Team_utils = __webpack_require__(13811);
// EXTERNAL MODULE: ./src/reclaim-api/team/Team.consts.ts
var Team_consts = __webpack_require__(50084);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
;// CONCATENATED MODULE: ./src/utils/entitlements.ts



var getEntitlementActualObjectUsageEdition = function(entitlement, usage) {
    // if no actualValue is present assume no overage
    if (usage.actualValue === undefined) return undefined;
    var comparator = Team_consts/* ENTITLEMENT_META */.mm[entitlement].comparator;
    return comparator(usage.allowedValueForCurrentEdition, usage.actualValue) < 0 ? usage.requiredEdition : undefined;
};
var getProductUsageReportActualsUsageEdition = function(usage) {
    var usageEdition;
    (0,objects/* typedEntries */.FR)(usage).find(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), entitlement = _param[0], obj = _param[1];
        var foundEdition = obj && getEntitlementActualObjectUsageEdition(entitlement, obj);
        if (foundEdition) usageEdition = foundEdition;
        return !!usageEdition;
    });
    return usageEdition;
};

// EXTERNAL MODULE: ./src/utils/react.tsx
var utils_react = __webpack_require__(56501);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/hooks/useCaptureError.ts
var useCaptureError = __webpack_require__(59546);
;// CONCATENATED MODULE: ./src/hooks/useUsageData.ts
















var loadUsageData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reclaim_api/* reclaim.users.usage */.Tz.users.usage()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function loadUsageData() {
        return _ref.apply(this, arguments);
    };
}();
var ref = (0,utils_react/* makeLoadableHook */.fc)(loadUsageData, {
    dataKey: "usageData",
    errorizer: "Failed to get usage data"
}), useHook = ref.useHook, dataAtom = ref.dataAtom;
// we don't own the function that creates
// this atom.  Have to make sure we call
// onMount in case it already exists.
var onMount = dataAtom.onMount;
dataAtom.onMount = function(update) {
    var unMount = onMount === null || onMount === void 0 ? void 0 : onMount(update);
    var mounted = true;
    var unsubscribe = (0,wonka/* pipe */.zG)(reclaim_api/* reclaim.users.watchProductUsage$$ */.Tz.users.watchProductUsage$$(), (0,wonka/* subscribe */.Ld)(function(value) {
        if (mounted) update(value);
    })).unsubscribe;
    return function() {
        mounted = false;
        if (!!unsubscribe) unsubscribe();
        unMount === null || unMount === void 0 ? void 0 : unMount();
    };
};
var useUsageData = function() {
    var hookData = useHook();
    var setData = (0,esm/* useSetAtom */.b9)(dataAtom);
    var captureError = (0,useCaptureError/* useCaptureError */.e)().captureError;
    var reloadUsageData = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var newData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        loadUsageData()
                    ];
                case 1:
                    newData = _state.sent();
                    if (!(JSON.stringify(hookData.usageData) !== JSON.stringify(newData))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        setData(newData)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }));
    var patchUsageData = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(usage, reloadAfter) {
            var usageData, actuals, newActuals, detectedUsageEdition, usageEdition, newUsageData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        usageData = hookData.usageData;
                        if (!usageData) return [
                            2
                        ];
                        actuals = usageData.actuals;
                        newActuals = actuals;
                        (0,objects/* typedEntries */.FR)(actuals).forEach(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), entitlement = _param[0], data = _param[1];
                            if (usage[entitlement] !== undefined && (data === null || data === void 0 ? void 0 : data.actualValue) !== usage[entitlement]) newActuals = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newActuals), (0,_define_property/* default */.Z)({}, entitlement, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                actualValue: usage[entitlement]
                            })));
                        }, {});
                        if (!(newActuals !== actuals)) return [
                            3,
                            4
                        ];
                        detectedUsageEdition = getProductUsageReportActualsUsageEdition(newActuals);
                        usageEdition = detectedUsageEdition || usageData.usageEdition;
                        newUsageData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, usageData), {
                            usageEdition: usageEdition,
                            actuals: newActuals,
                            overage: (0,Team_utils/* reclaimEditionComparator */.Wg)(usageEdition, usageData.currentEdition) > 0
                        });
                        return [
                            4,
                            setData(newUsageData)
                        ];
                    case 1:
                        _state.sent();
                        if (!reloadAfter) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            reloadAfter
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            reloadUsageData()
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(usage, reloadAfter) {
            return _ref.apply(this, arguments);
        };
    }());
    (0,react.useEffect)(function() {
        if (hookData.error) {
            captureError(hookData.error, {
                severity: "error",
                statusCode: 5000
            });
        }
    }, [
        hookData.error,
        captureError
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hookData), {
        patchUsageData: patchUsageData,
        reloadUsageData: reloadUsageData
    });
};


/***/ }),

/***/ 3512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useV16User; },
/* harmony export */   "p": function() { return /* binding */ isSchedulerV16; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67803);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59484);




var isSchedulerV16 = function(version) {
    return !!version && version >= 16;
};
// TODO (RAI-10333)
var useV16User = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_context_UserContext__WEBPACK_IMPORTED_MODULE_1__/* .useUserContext */ .SE)(), 1), user = ref[0].user;
    var canMigrate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (user === null || user === void 0 ? void 0 : user.created) ? Math.abs((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(user.created, new Date())) >= 2 : true;
    }, [
        user === null || user === void 0 ? void 0 : user.created
    ]);
    return {
        isV16: isSchedulerV16(user === null || user === void 0 ? void 0 : user.features.scheduler),
        canMigrate: canMigrate
    };
};


/***/ }),

/***/ 86022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/x-license-pro/utils/licenseInfo.js + 1 modules
var licenseInfo = __webpack_require__(62814);
// EXTERNAL MODULE: ./node_modules/@webscopeio/react-textarea-autocomplete/style.css
var style = __webpack_require__(99513);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/@mui/material/AlertTitle/AlertTitle.js + 1 modules
var AlertTitle = __webpack_require__(92401);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/GlobalStyles/GlobalStyles.js + 2 modules
var GlobalStyles = __webpack_require__(17297);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CssBaseline/CssBaseline.js
'use client';








const html = (theme, enableColorScheme) => (0,esm_extends/* default */.Z)({
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box',
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: '100%'
}, enableColorScheme && !theme.vars && {
  colorScheme: theme.palette.mode
});
const body = theme => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.primary
}, theme.typography.body1, {
  backgroundColor: (theme.vars || theme).palette.background.default,
  '@media print': {
    // Save printer ink.
    backgroundColor: (theme.vars || theme).palette.common.white
  }
});
const styles = (theme, enableColorScheme = false) => {
  var _theme$components;
  const colorSchemeStyles = {};
  if (enableColorScheme && theme.colorSchemes) {
    Object.entries(theme.colorSchemes).forEach(([key, scheme]) => {
      var _scheme$palette;
      colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
        colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
      };
    });
  }
  let defaultStyles = (0,esm_extends/* default */.Z)({
    html: html(theme, enableColorScheme),
    '*, *::before, *::after': {
      boxSizing: 'inherit'
    },
    'strong, b': {
      fontWeight: theme.typography.fontWeightBold
    },
    body: (0,esm_extends/* default */.Z)({
      margin: 0
    }, body(theme), {
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      '&::backdrop': {
        backgroundColor: (theme.vars || theme).palette.background.default
      }
    })
  }, colorSchemeStyles);
  const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
  if (themeOverrides) {
    defaultStyles = [defaultStyles, themeOverrides];
  }
  return defaultStyles;
};

/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */
function CssBaseline(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCssBaseline'
  });
  const {
    children,
    enableColorScheme = false
  } = props;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
      styles: theme => styles(theme, enableColorScheme)
    }), children]
  });
}
 false ? 0 : void 0;
/* harmony default export */ var CssBaseline_CssBaseline = (CssBaseline);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js
var emotion_element_c39617d8_browser_esm = __webpack_require__(75260);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(8417);
;// CONCATENATED MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js





// prepend: true moves MUI styles to the top of the <head> so they're loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.

let cache;
if (typeof document === 'object') {
  cache = (0,emotion_cache_browser_esm/* default */.Z)({
    key: 'css',
    prepend: true
  });
}
function StyledEngineProvider(props) {
  const {
    injectFirst,
    children
  } = props;
  return injectFirst && cache ? /*#__PURE__*/(0,jsx_runtime.jsx)(emotion_element_c39617d8_browser_esm.C, {
    value: cache,
    children: children
  }) : children;
}
 false ? 0 : void 0;
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/private-theming/useTheme/useTheme.js
var useTheme = __webpack_require__(56760);
// EXTERNAL MODULE: ./node_modules/@mui/private-theming/useTheme/ThemeContext.js
var ThemeContext = __webpack_require__(44819);
// EXTERNAL MODULE: ./node_modules/@mui/private-theming/ThemeProvider/nested.js
var nested = __webpack_require__(51825);
;// CONCATENATED MODULE: ./node_modules/@mui/private-theming/ThemeProvider/ThemeProvider.js








// To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);
    if (false) {}
    return mergedTheme;
  }
  return (0,esm_extends/* default */.Z)({}, outerTheme, localTheme);
}

/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
function ThemeProvider(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = (0,useTheme/* default */.Z)();
  if (false) {}
  const theme = react.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[nested/* default */.Z] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ThemeContext/* default.Provider */.Z.Provider, {
    value: theme,
    children: children
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ var ThemeProvider_ThemeProvider = (ThemeProvider);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeWithoutDefault.js
var useThemeWithoutDefault = __webpack_require__(34168);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js
'use client';









const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
  return react.useMemo(() => {
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    if (typeof localTheme === 'function') {
      const mergedTheme = localTheme(resolvedTheme);
      const result = themeId ? (0,esm_extends/* default */.Z)({}, upperTheme, {
        [themeId]: mergedTheme
      }) : mergedTheme;
      // must return a function for the private theme to NOT merge with the upper theme.
      // see the test case "use provided theme from a callback" in ThemeProvider.test.js
      if (isPrivate) {
        return () => result;
      }
      return result;
    }
    return themeId ? (0,esm_extends/* default */.Z)({}, upperTheme, {
      [themeId]: localTheme
    }) : (0,esm_extends/* default */.Z)({}, upperTheme, localTheme);
  }, [themeId, upperTheme, localTheme, isPrivate]);
}

/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */
function ThemeProvider_ThemeProvider_ThemeProvider(props) {
  const {
    children,
    theme: localTheme,
    themeId
  } = props;
  const upperTheme = (0,useThemeWithoutDefault/* default */.Z)(EMPTY_THEME);
  const upperPrivateTheme = (0,useTheme/* default */.Z)() || EMPTY_THEME;
  if (false) {}
  const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
  const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ThemeProvider_ThemeProvider, {
    theme: privateTheme,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(emotion_element_c39617d8_browser_esm.T.Provider, {
      value: engineTheme,
      children: children
    })
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ var esm_ThemeProvider_ThemeProvider = (ThemeProvider_ThemeProvider_ThemeProvider);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/identifier.js
var identifier = __webpack_require__(10606);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js
'use client';



const _excluded = ["theme"];





function styles_ThemeProvider_ThemeProvider(_ref) {
  let {
      theme: themeInput
    } = _ref,
    props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);
  const scopedTheme = themeInput[identifier/* default */.Z];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ThemeProvider_ThemeProvider, (0,esm_extends/* default */.Z)({}, props, {
    themeId: scopedTheme ? identifier/* default */.Z : undefined,
    theme: scopedTheme || themeInput
  }));
}
 false ? 0 : void 0;
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 1 modules
var en_US = __webpack_require__(83975);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(13665);
// EXTERNAL MODULE: ./node_modules/mui-modal-provider/dist/mui-modal-provider.esm.js
var mui_modal_provider_esm = __webpack_require__(56566);
// EXTERNAL MODULE: ./node_modules/notistack/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(20377);
// EXTERNAL MODULE: ./src/consts/shadow.consts.ts
var shadow_consts = __webpack_require__(54137);
// EXTERNAL MODULE: ./src/AppTheme.ts + 1 modules
var AppTheme = __webpack_require__(73916);
// EXTERNAL MODULE: ./src/consts/storageKeys.ts
var storageKeys = __webpack_require__(14101);
// EXTERNAL MODULE: ./src/context/AppContext.tsx
var AppContext = __webpack_require__(64574);
// EXTERNAL MODULE: ./src/context/CommandBarContext.tsx + 1 modules
var CommandBarContext = __webpack_require__(58793);
// EXTERNAL MODULE: ./src/context/UserContext.tsx
var UserContext = __webpack_require__(59484);
// EXTERNAL MODULE: ./src/hooks/useEventListener.ts
var useEventListener = __webpack_require__(76231);
;// CONCATENATED MODULE: ./src/hooks/useHubspotIdentify.tsx



var useHubspotIdentify = function() {
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), userState = ref2[0];
    (0,react.useEffect)(function() {
        if (!!userState.isAuthenticated) {
            var ref, ref1;
            var _hsq = window._hsq = window._hsq || [];
            _hsq.push([
                "identify",
                {
                    email: (ref = userState.user) === null || ref === void 0 ? void 0 : ref.email,
                    id: (ref1 = userState.user) === null || ref1 === void 0 ? void 0 : ref1.trackingCode
                }, 
            ]);
            _hsq.push([
                "trackEvent",
                {
                    id: "authed_login"
                }, 
            ]);
        }
    }, [
        userState.isAuthenticated,
        (ref = userState.user) === null || ref === void 0 ? void 0 : ref.email,
        (ref1 = userState.user) === null || ref1 === void 0 ? void 0 : ref1.trackingCode
    ]);
};

// EXTERNAL MODULE: ./src/hooks/useOurRouter.ts
var useOurRouter = __webpack_require__(52581);
;// CONCATENATED MODULE: ./src/hooks/useWindowActive.ts

var windowActiveAtom = (0,esm/* atom */.cn)(false);
var useWindowActive = function() {
    return useAtom(windowActiveAtom)[0];
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/subpages/status.tsx
var subpages_status = __webpack_require__(45759);
;// CONCATENATED MODULE: ./src/layouts/ReclaimErrorBoundary.tsx







var ReclaimErrorBoundary = function(_param) {
    var children = _param.children, _statusMessage = _param.statusMessage, statusMessage = _statusMessage === void 0 ? "We are so sorry, but there seems to be an issue. Our engineers have been notified and are working on a fix." : _statusMessage, _failureCode = _param.failureCode, failureCode = _failureCode === void 0 ? 5000 : _failureCode, supressExceptionCapture = _param.supressExceptionCapture, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "statusMessage",
        "failureCode",
        "supressExceptionCapture"
    ]);
    var handleFallback = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(data) {
        var callFn = function(fn) {
            return typeof fn === "function" ? fn(data) : fn;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(subpages_status/* Status */.q, {
            code: callFn(failureCode),
            message: callFn(statusMessage),
            captureStatus: !callFn(supressExceptionCapture),
            associatedError: data.error
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fallback: handleFallback,
        showDialog: true
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var layouts_ReclaimErrorBoundary = (ReclaimErrorBoundary);

// EXTERNAL MODULE: ./src/utils/local-storage.ts
var local_storage = __webpack_require__(91325);
// EXTERNAL MODULE: ./src/utils/platform.ts
var platform = __webpack_require__(94423);
// EXTERNAL MODULE: ./src/utils/router.ts
var utils_router = __webpack_require__(63429);
// EXTERNAL MODULE: ./src/components/App.module.scss
var App_module = __webpack_require__(54865);
var App_module_default = /*#__PURE__*/__webpack_require__.n(App_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonGroup/ButtonGroup.js + 1 modules
var ButtonGroup = __webpack_require__(56863);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CodeRounded.js
var CodeRounded = __webpack_require__(82553);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 1 modules
var ListItem = __webpack_require__(19294);
// EXTERNAL MODULE: ./node_modules/jotai/esm/utils.mjs + 1 modules
var utils = __webpack_require__(99079);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(8080);
// EXTERNAL MODULE: ./src/hooks/atoms/useTeam.ts
var useTeam = __webpack_require__(10352);
// EXTERNAL MODULE: ./src/hooks/useMemoizedPromise.ts
var useMemoizedPromise = __webpack_require__(61910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./src/dev/dev.client.utils.ts








var fetchDevApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(action) {
        var options, _method, method, data, url, body, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _method = options.method, method = _method === void 0 ? "GET" : _method, data = options.data;
                    url = "/api/dev/".concat(action);
                    switch(method){
                        case "GET":
                            url += "?".concat(Object.entries(data || {}).map(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                                return "".concat(key, "=").concat(value);
                            }).join("&"));
                            break;
                        case "POST":
                            switch(typeof data === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(data)){
                                case "undefined":
                                    break;
                                case "string":
                                    body = data;
                                    break;
                                default:
                                    body = JSON.stringify(data);
                                    break;
                            }
                            break;
                    }
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            body: body
                        })
                    ];
                case 1:
                    response = _state.sent();
                    try {
                        return [
                            2,
                            response.json()
                        ];
                    } catch (e) {
                        return [
                            2,
                            response.text()
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDevApi(action) {
        return _ref.apply(this, arguments);
    };
}();
function devReconcile(type, id) {
    return _devReconcile.apply(this, arguments);
}
function _devReconcile() {
    _devReconcile = (0,_async_to_generator/* default */.Z)(function(type, id) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchDevApi("reconcile", {
                            method: "POST",
                            data: {
                                type: type,
                                id: id
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _devReconcile.apply(this, arguments);
}
var runDevAction = function(key, user, team, args) {
    return fetchDevApi("runDevAction", {
        method: "POST",
        data: {
            key: key,
            args: (0,_object_spread/* default */.Z)({
                user_id: user.id,
                team_id: team.id
            }, args)
        }
    });
};
var useDevApi = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), user = ref[0].user;
    var team = (0,useTeam/* useTeamState */.Oo)(true).team;
    var reconcileTeam = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return team && devReconcile("team", team.id + "");
    });
    var reconcileUser = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return user && devReconcile("user", user.id + "");
    });
    var reconcilePlans = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return devReconcile("plans");
    });
    var runAction = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(key, args) {
        return user && team && runDevAction(key, user, team, args) || undefined;
    });
    return {
        runAction: runAction,
        reconcile: devReconcile,
        reconcileTeam: reconcileTeam,
        reconcileUser: reconcileUser,
        reconcilePlans: reconcilePlans
    };
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(18360);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./src/components/forms/AsyncButton.tsx
var AsyncButton = __webpack_require__(5062);
// EXTERNAL MODULE: ./src/components/ReasonTip.tsx
var ReasonTip = __webpack_require__(51375);
;// CONCATENATED MODULE: ./src/dev/components/DevActionListItem.tsx












var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            flexDirection: "column",
            alignItems: "stretch",
            background: theme.colors.white,
            borderRadius: theme.spacing(2),
            margin: theme.spacing(),
            width: "auto"
        },
        header: {
            cursor: "pointer"
        },
        collapseInner: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch"
        },
        formControl: {
            width: "100%"
        },
        arg: {
            gap: theme.spacing(),
            justifyContent: "start",
            minWidth: 200
        },
        argInput: {
            width: "100%"
        },
        argInputNoStretch: {
            alignSelf: "start"
        },
        runWrapper: {
            alignSelf: "center"
        },
        run: {}
    };
}, {
    classNamePrefix: "DevActionListItem"
});
var DevActionListItem = function(param) {
    var className = param.className, extClasses = param.classes, _action = param.action, label = _action.label, args = _action.args, key = _action.key, reloadAfter = _action.reloadAfter, data = param.data, allowReload = param.allowReload, onDataChange = param.onDataChange, open = param.open, onOpenChange = param.onOpenChange, onRun = param.onRun;
    var classes = useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ /********************/ /*     useState     */ /********************/ /********************/ /* useMemo & consts */ /********************/ var allArgsSet = (0,react.useMemo)(function() {
        if (!args) return true;
        return args.every(function(arg) {
            return data[arg.key] !== undefined;
        });
    }, [
        args,
        data
    ]);
    /********************/ /*    useCallback   */ /********************/ var toggleOpen = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(key, !open);
    });
    var setDataKey = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(argKey, value) {
        return onDataChange(key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, argKey, value)));
    });
    var run = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return onRun(key);
    });
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.header,
                onClick: toggleOpen,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse/* default */.Z, {
                in: open,
                classes: {
                    wrapperInner: classes.collapseInner
                },
                children: [
                    args && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        children: args.map(function(param) {
                            var key = param.key, label = param.label, type = param.type;
                            var wrapInFormControlLabel = function(control) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    className: classes.formControl,
                                    label: label,
                                    control: control
                                });
                            };
                            var wrapInFormControl = function(control) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                    variant: "standard",
                                    className: classes.formControl,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                            children: label
                                        }),
                                        control
                                    ]
                                });
                            };
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                className: classes.arg,
                                children: function() {
                                    var value = data[key];
                                    var handleSelectChange = function(e) {
                                        return setDataKey(key, e.target.value);
                                    };
                                    var handleTextFieldChange = function(e) {
                                        return setDataKey(key, e.target.value);
                                    };
                                    switch(typeof type === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(type)){
                                        case "object":
                                            switch(type.specialType){
                                                case "select":
                                                    return wrapInFormControl(/*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        variant: "standard",
                                                        className: classes.argInput,
                                                        value: value || "",
                                                        onChange: handleSelectChange,
                                                        placeholder: "Select one...",
                                                        children: type.values.map(function(argValue) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                                value: argValue,
                                                                children: argValue
                                                            }, argValue);
                                                        })
                                                    }));
                                                default:
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            "special type ",
                                                            type.specialType,
                                                            " not yet supported"
                                                        ]
                                                    });
                                            }
                                        case "string":
                                            switch(type){
                                                case "string":
                                                    return wrapInFormControl(/*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        variant: "standard",
                                                        className: classes.argInput,
                                                        value: value,
                                                        onChange: handleTextFieldChange,
                                                        label: label
                                                    }));
                                                case "integer":
                                                    return wrapInFormControl(/*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                        variant: "standard",
                                                        className: classes.argInput,
                                                        type: "number",
                                                        value: value,
                                                        onChange: handleTextFieldChange
                                                    }));
                                                case "boolean":
                                                    return wrapInFormControlLabel(/*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        className: classes.argInputNoStretch,
                                                        checked: value,
                                                        onChange: function(e) {
                                                            return setDataKey(key, e.target.checked);
                                                        }
                                                    }));
                                                default:
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            "type ",
                                                            type,
                                                            " not yet supported"
                                                        ]
                                                    });
                                            }
                                        default:
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "found an unexpected action of type ",
                                                    typeof type === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(type)
                                                ]
                                            });
                                    }
                                }()
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonTip/* ReasonTip */.u, {
                        className: classes.runWrapper,
                        reasons: [
                            {
                                test: !allArgsSet,
                                message: "Please set all arguments"
                            }
                        ],
                        children: function(disabled) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                                className: classes.run,
                                disabled: disabled,
                                variant: "contained",
                                onClick: run,
                                size: "small",
                                children: "run"
                            });
                        }
                    }),
                    !!allowReload && !!reloadAfter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        align: "center",
                        variant: "caption",
                        children: "(page will reload after)"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/dev/components/DevActionList.tsx




















var DevActionList_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            minWidth: 400,
            maxWidth: 600,
            padding: theme.spacing(3)
        }
    };
}, {
    classNamePrefix: "DevActionList"
});
var allowReloadAtom = (0,utils/* atomWithStorage */.O4)("dev.actionList.allowReload", true);
var openActionsAtom = (0,utils/* atomWithStorage */.O4)("dev.actionList.openActions", {});
var DevActionList = function(param) {
    var className = param.className, extClasses = param.classes;
    var classes = DevActionList_useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var runAction = useDevApi().runAction;
    var ref = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), user = ref[0].user;
    var team = (0,useTeam/* useTeamState */.Oo)(true).team;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMemoizedPromise/* useMemoizedPromise */.Z)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = (user === null || user === void 0 ? void 0 : user.id) && (team === null || team === void 0 ? void 0 : team.id);
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetch("/api/dev/getConfig?userId=".concat(user.id, "&teamId=").concat(team.id)).then(function(r) {
                            return r.json();
                        })
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        _tmp || undefined
                    ];
            }
        });
    }), [
        team === null || team === void 0 ? void 0 : team.id,
        user === null || user === void 0 ? void 0 : user.id
    ]), 3), config = ref1[0], loading = ref1[1], error = ref1[2];
    /********************/ /*     useState     */ /********************/ var ref2 = (0,react.useState)({}), data = ref2[0], setData = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(allowReloadAtom), 2), allowReload = ref3[0], setAllowReload = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(openActionsAtom), 2), openActions = ref4[0], setOpenActions = ref4[1];
    /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ var handleItemDataChange = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(key, itemData) {
        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, key, itemData)));
    });
    var handleRun = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(key) {
            var regetData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            runAction(key, data[key])
                        ];
                    case 1:
                        regetData = _state.sent();
                        setData((0,_object_spread/* default */.Z)({}, data, regetData));
                        if (allowReload && (config === null || config === void 0 ? void 0 : config.actions[key].reloadAfter)) window.location.reload();
                        return [
                            2
                        ];
                }
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }());
    var toggleAllowReload = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        setAllowReload(!allowReload);
    });
    var actionOpenChangeHandler = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(key, open) {
        return setOpenActions((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, openActions), (0,_define_property/* default */.Z)({}, key, open)));
    });
    /********************/ /*    useEffects    */ /********************/ (0,react.useEffect)(function() {
        if (!config) return;
        setData(config.actionOrder.reduce(function(actionData, actionKey) {
            actionData[actionKey] = {};
            var args = config.actions[actionKey].args;
            (args || []).forEach(function(arg) {
                if (arg.default !== undefined) actionData[actionKey][arg.key] = arg.default;
            });
            return actionData;
        }, {}));
    }, [
        config
    ]);
    /********************/ /*       JSX        */ /********************/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    onChange: toggleAllowReload,
                    checked: allowReload
                }),
                label: "Allow reloads"
            }),
            function() {
                if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                    children: error.message
                });
                else if (loading || !config) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {});
                else {
                    if (config.hasMissingEnvVars) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                children: [
                                    "Could not load dev tools, the following variables were missing from the environment (hint: you can add them to ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                        children: "/.env.development.local"
                                    }),
                                    ")."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                children: config.missingEnvVars.map(function(varName) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            children: varName
                                        })
                                    }, varName);
                                })
                            })
                        ]
                    });
                    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        children: config.actionOrder.map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DevActionListItem, {
                                allowReload: allowReload,
                                action: config.actions[key],
                                data: data[key],
                                open: openActions[key],
                                onOpenChange: actionOpenChangeHandler,
                                onDataChange: handleItemDataChange,
                                onRun: handleRun
                            }, key);
                        })
                    });
                }
            }()
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DevDrawer.tsx
/* eslint-disable no-restricted-imports */ 










var DevDrawer_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {},
        paper: {
            display: "flex",
            flexDirection: "column"
        },
        actions: {
            flex: "0 0 auto"
        },
        btnWrapper: {
            position: "fixed",
            top: theme.spacing(),
            left: theme.spacing(),
            transition: theme.transitions.create("transform"),
            zIndex: 999999
        },
        btnWrapperOpen: {
            transform: "translateY(-100%)"
        },
        btn: {
            padding: "".concat(theme.spacing(), "px !important"),
            minWidth: "auto !important",
            opacity: 0.5,
            transition: theme.transitions.create("opacity"),
            "&:hover": {
                opacity: 1
            }
        },
        reconciles: {
            alignSelf: "center",
            flex: "1 1 auto"
        }
    };
}, {
    classNamePrefix: "DevDrawer"
});
var DevDrawer = function(param) {
    var className = param.className, extClasses = param.classes;
    var classes = DevDrawer_useStyles({
        classes: extClasses
    });
    /********************/ /*   custom hooks   */ /********************/ var ref = useDevApi(), reconcileTeam = ref.reconcileTeam, reconcileUser = ref.reconcileUser, reconcilePlans = ref.reconcilePlans;
    /********************/ /*     useState     */ /********************/ var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    /********************/ /* useMemo & consts */ /********************/ /********************/ /*    useCallback   */ /********************/ var closeMe = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return setOpen(false);
    });
    var openMe = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        return setOpen(true);
    });
    /********************/ /*    useEffects    */ /********************/ /********************/ /*       JSX        */ /********************/ if (true) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                className: (0,clsx_m/* default */.Z)(classes.root, className),
                anchor: "left",
                open: open,
                onClose: closeMe,
                classes: {
                    paper: classes.paper
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DevActionList, {
                        className: classes.actions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.reconciles,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                children: "Reconcile:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                                        onClick: reconcileTeam,
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                                        onClick: reconcileUser,
                                        children: "User"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncButton/* AsyncButton */.Z, {
                                        onClick: reconcilePlans,
                                        children: "Plans"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(classes.btnWrapper, (0,_define_property/* default */.Z)({}, classes.btnWrapperOpen, open)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: classes.btn,
                    onClick: openMe,
                    color: "primary",
                    variant: "contained",
                    size: "small",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeRounded/* default */.Z, {})
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/actions/ActionMenuPopper.tsx
var ActionMenuPopper = __webpack_require__(21429);
// EXTERNAL MODULE: ./src/components/EasyConfirmDialog.tsx
var EasyConfirmDialog = __webpack_require__(52126);
// EXTERNAL MODULE: ./src/components/EasyLogWork.tsx + 2 modules
var EasyLogWork = __webpack_require__(33806);
// EXTERNAL MODULE: ./src/components/EasyReschedulator.tsx + 1 modules
var EasyReschedulator = __webpack_require__(95313);
// EXTERNAL MODULE: ./node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(63496);
// EXTERNAL MODULE: ./src/components/quests/quests.util.ts + 14 modules
var quests_util = __webpack_require__(32774);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./src/hooks/atoms/useQuests.ts + 1 modules
var useQuests = __webpack_require__(1755);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
;// CONCATENATED MODULE: ./src/components/quests/QuestSnackbar.tsx













var QuestSnackbar_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            backgroundColor: theme.colors.white,
            boxShadow: "0px 4px 72px 0px rgba(104, 109, 167, 0.50)",
            borderRadius: theme.shape.borderRadius * 2.5,
            width: 300,
            padding: theme.spacing(1.5)
        },
        title: {
            paddingRight: theme.spacing(4)
        },
        close: {
            position: "absolute",
            top: theme.spacing(0.25),
            right: theme.spacing(0.5),
            padding: theme.spacing(1)
        },
        closeIcon: {
            color: theme.palette.common.black,
            width: 16,
            height: 16
        },
        content: {
            display: "flex",
            flexDirection: "column"
        },
        nextUp: {
            marginTop: theme.spacing(1)
        },
        nextTitle: {
            fontWeight: theme.typography.fontWeightMedium
        },
        nextUpItem: {
            backgroundColor: "rgba(255, 255, 255, .2)",
            padding: theme.spacing(),
            marginTop: theme.spacing(0.5),
            display: "flex",
            alignItems: "start",
            borderRadius: theme.shape.borderRadius * 2,
            gap: theme.spacing(),
            "&:hover": {
                cursor: "pointer",
                backgroundColor: "rgba(255, 255, 255, .3)"
            }
        },
        nextUpIcon: {
            flexShrink: 0,
            height: 24,
            opacity: 0.7,
            width: 24
        },
        nextUpItemText: {},
        groupMessage: {}
    };
}, {
    classNamePrefix: "QuestNotification"
});
var QuestNotification = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var className = param.className, extClasses = param.classes, quest = param.quest, onClose = param.onClose;
    var classes = QuestSnackbar_useStyles({
        classes: extClasses
    });
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var setActiveQuest = (0,useQuests/* useQuestsActions */.UW)().setActiveQuest;
    var quests = (0,useQuests/* useQuestsState */.P_)().quests;
    var nextQuest = (0,react.useMemo)(function() {
        return quests ? (0,quests_util/* getNextQuestFromGroup */.rw)(quests, quest.id) : undefined;
    }, [
        quests,
        quest.id
    ]);
    var questGroup = (0,react.useMemo)(function() {
        return (0,quests_util/* getGroupConfigFromQuestId */.I6)(quest.id);
    }, [
        quest.id
    ]);
    var handleStartNextQuest = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        if (!nextQuest) return;
        setActiveQuest({
            group: nextQuest.groupId,
            quest: nextQuest.id,
            step: nextQuest.steps[0].id
        });
        if (nextQuest.entryPathname) {
            void router.push(nextQuest.entryPathname);
        }
        onClose();
    });
    var handleGroupCompleteClick = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        void router.push((0,utils_router/* getQuestsUrl */.qT)());
        onClose();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(notistack_esm/* SnackbarContent */.No, {
        ref: ref,
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                className: classes.close,
                onClick: onClose,
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                    className: classes.closeIcon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.content,
                children: [
                    !!nextQuest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: classes.title,
                                variant: "body2",
                                children: [
                                    "You've completed \"",
                                    quest.title,
                                    '"'
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.nextUp,
                                onClick: handleStartNextQuest,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "Next up"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.nextUpItem,
                                        children: [
                                            /*#__PURE__*/ (0,react.createElement)(nextQuest.icon, {
                                                className: classes.nextUpIcon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.nextUpItemText,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        className: classes.nextTitle,
                                                        children: nextQuest.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: nextQuest.description
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !nextQuest && !!questGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "body2",
                        className: classes.groupMessage,
                        children: [
                            "You've completed everything in \"",
                            questGroup.title,
                            '."',
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                color: "inherit",
                                onClick: handleGroupCompleteClick,
                                children: "Keep exploring"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 16 modules
var reclaim_api = __webpack_require__(54517);
// EXTERNAL MODULE: ./src/reclaim-api/Users.mutators.ts + 1 modules
var Users_mutators = __webpack_require__(45983);
// EXTERNAL MODULE: ./src/hooks/useNotifications.tsx
var useNotifications = __webpack_require__(55973);
;// CONCATENATED MODULE: ./src/hooks/atoms/useQuestsNotifications.tsx













var questsAtom = (0,esm/* atom */.cn)(undefined);
questsAtom.onMount = function(setQuestsAtom) {
    var unsubscribe = (0,wonka/* pipe */.zG)(reclaim_api/* reclaim.users.fetchAndWatchQuests$$ */.Tz.users.fetchAndWatchQuests$$(), (0,wonka/* subscribe */.Ld)(function(quests) {
        setQuestsAtom(quests);
    })).unsubscribe;
    return function() {
        return unsubscribe();
    };
};
var useQuestsNotifications = function() {
    var ref = (0,useQuests/* useQuestsActions */.UW)(), updateQuests = ref.updateQuests, setActiveQuest = ref.setActiveQuest;
    var activeQuest = (0,useQuests/* useQuestsState */.P_)().activeQuest;
    var sendNotification = (0,useNotifications/* useNotifications */.z)().sendNotification;
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(questsAtom), 1), quests = ref1[0];
    var ref2 = (0,react.useState)(undefined), currentQuests = ref2[0], setCurrentQuests = ref2[1];
    var handleNewQuests = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function(quests) {
        if (!currentQuests && !!quests) {
            setCurrentQuests(quests);
            updateQuests((0,Users_mutators/* dtoToQuests */.i1)(quests));
        } else {
            var newItems = quests.completedQuests.filter(function(q) {
                return !(currentQuests === null || currentQuests === void 0 ? void 0 : currentQuests.completedQuests.some(function(cq) {
                    return cq === q;
                }));
            });
            if (newItems.length) {
                var quest = (0,quests_util/* getQuestConfigFromQuestId */.b_)(newItems[0]);
                if (quest && router.pathname !== "/onboarding/user/[...step]") {
                    if ((activeQuest === null || activeQuest === void 0 ? void 0 : activeQuest.quest) === quest.id) {
                        setActiveQuest(undefined); // if websocket comes through for current quest, end the quest
                    }
                    var closeHandler = sendNotification(/*#__PURE__*/ (0,jsx_runtime.jsx)(QuestNotification, {
                        quest: quest,
                        onClose: function() {
                            return closeHandler();
                        }
                    }), {
                        anchorOrigin: {
                            horizontal: "right",
                            vertical: "bottom"
                        },
                        autoHideDuration: 8000
                    });
                }
                setCurrentQuests(quests);
                updateQuests((0,Users_mutators/* dtoToQuests */.i1)(quests));
            }
        }
    });
    (0,react.useEffect)(function() {
        if (quests) handleNewQuests(quests);
    }, [
        quests,
        handleNewQuests
    ]);
};

;// CONCATENATED MODULE: ./src/components/quests/QuestNotifications.tsx

/**
 * This component just attaches the quest notifications and should only be used
 * in App.tsx through EasyAccessElements.tsx. This hook needs to be global but within the 
 * context of the snackbar provider (notistack in App.tsx).
 */ var QuestsNotifications = function() {
    useQuestsNotifications();
    return null;
};

;// CONCATENATED MODULE: ./src/components/EasyAccessElements.tsx








// TODO: all of these components are 90% the same code.  There should be an easy way to make this fairly generic.
var EasyAccessElements = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), isAuthenticated = ref[0].isAuthenticated;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestsNotifications, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EasyReschedulator/* EasyReschedulator */.T, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EasyConfirmDialog/* EasyConfirmDialog */.c, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EasyLogWork/* EasyLogWorkDialog */.P, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionMenuPopper/* ActionMenuPopper */.g, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/components/ReclaimLocalizationProvider.tsx + 28 modules
var ReclaimLocalizationProvider = __webpack_require__(55260);
// EXTERNAL MODULE: ./src/hooks/events/useEventsSource.atom.ts
var useEventsSource_atom = __webpack_require__(55521);
// EXTERNAL MODULE: ./src/hooks/atoms/useAccounts.ts
var useAccounts = __webpack_require__(85614);
// EXTERNAL MODULE: ./src/hooks/atoms/useMoment.ts
var useMoment = __webpack_require__(43265);
// EXTERNAL MODULE: ./src/hooks/atoms/useNow.ts
var useNow = __webpack_require__(1607);
// EXTERNAL MODULE: ./src/hooks/time-schemes/useTimeSchemes.atom.tsx
var useTimeSchemes_atom = __webpack_require__(12396);
// EXTERNAL MODULE: ./src/hooks/useUsageData.ts + 1 modules
var useUsageData = __webpack_require__(38539);
;// CONCATENATED MODULE: ./src/components/GlobalStateInitializer.tsx












var LoadedGlobalState = function(param) {
    var children = param.children;
    var ref = (0,useAccounts/* useAccountsActions */.X)(), loadAccounts = ref.load;
    (0,useUsageData/* useUsageData */.L)();
    (0,useTimeSchemes_atom/* useTimeSchemesState */.eb)();
    (0,useEventsSource_atom/* useEventsSource */.B)();
    (0,useMoment/* useMoment */.w)();
    (0,useNow/* useNow */.m)();
    /**
   * Load accounts
   **/ (0,react.useEffect)(function() {
        void loadAccounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var GlobalStateInitializer = function(param) {
    var children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 1), isAuthenticated = ref[0].isAuthenticated;
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    var validRoutesWithoutAuth = (0,utils_router/* hasValidRoutesWithoutAuth */.D8)(router);
    if (!isAuthenticated && validRoutesWithoutAuth) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    } else if (isAuthenticated) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadedGlobalState, {
            children: children
        });
    } else {
        return null;
    }
};


;// CONCATENATED MODULE: ./src/components/App.tsx


































en_US/* default.options */.Z.options = {
    weekStartsOn: 1
};
var REF_PARAM = "utm_term";
var UTM_PARAM_RE = /^utm_*/;
var App = function(param) {
    var children = param.children;
    var router = (0,useOurRouter/* useOurRouter */.ED)();
    (0,utils_router/* useRecordHistory */.YN)(router);
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(windowActiveAtom), 2), setWindowActive = ref[1];
    (0,useEventListener/* useWindowEventListener */.F)("focus", function() {
        return setWindowActive(true);
    });
    (0,useEventListener/* useWindowEventListener */.F)("blur", function() {
        return setWindowActive(false);
    });
    // FIXME (IW): Without this, OAuth params are borked
    // move state to new format for legacy api
    if (typeof router.query.state === "string") {
        router.query.state = JSON.parse(router.query.state || "{}");
    }
    var state = (0,AppContext/* useAppContext */.bp)().state;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,UserContext/* useUserContext */.SE)(), 2), userState = ref1[0], userActions = ref1[1];
    // this sends the hubspot identify command when user is authenticated
    useHubspotIdentify();
    var ref2 = (0,react.useState)(state.theme === "dark" ? AppTheme/* AppTheme.Dark */.SJ.Dark : AppTheme/* AppTheme.Light */.SJ.Light), theme = ref2[0], setTheme = ref2[1];
    var medium = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    var resizeTimeout = (0,react.useRef)();
    (0,react.useEffect)(function() {
        // Select the correct set of quest steps
        (0,quests_util/* initQuestSteps */.R2)(userState === null || userState === void 0 ? void 0 : userState.user);
    }, [
        userState
    ]);
    /**
   * Set the current app theme (not currently used by anything)
   */ (0,react.useEffect)(function() {
        setTheme(state.theme === "dark" ? AppTheme/* AppTheme.Dark */.SJ.Dark : AppTheme/* AppTheme.Light */.SJ.Light);
    }, [
        state.theme
    ]);
    /**
   * Refresh current user on route changes
   */ (0,react.useEffect)(function() {
        var ref;
        // Wait for router to init
        if (!router.isReady) return;
        // Refresh user and team
        if (!!((ref = router.query) === null || ref === void 0 ? void 0 : ref.logout) || [
            "loading",
            "failed"
        ].includes(userState.status)) return;
        // This is where the app first initializes top-level data
        void (userActions === null || userActions === void 0 ? void 0 : userActions.load(userState.status === "ok"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.isReady,
        router.pathname
    ]);
    /**
   * Hack to fix vh on mobile browsers
   */ (0,react.useEffect)(function() {
        if (!(0,platform/* browser */.Xh)().isBrowser) return;
        var resizeListener = function() {
            if (resizeTimeout.current) {
                clearTimeout(resizeTimeout.current);
                resizeTimeout.current = undefined;
            }
            resizeTimeout.current = setTimeout(function() {
                if (!(0,platform/* browser */.Xh)().isBrowser) return;
                document.documentElement.style.setProperty("--vh", "".concat(window.innerHeight * 0.01, "px"));
                document.documentElement.style.setProperty("--vw", "".concat(window.innerWidth * 0.01, "px"));
            }, 25);
        };
        if ((0,platform/* browser */.Xh)().isBrowser) {
            document.documentElement.style.setProperty("--vh", "".concat(window.innerHeight * 0.01, "px"));
            document.documentElement.style.setProperty("--vw", "".concat(window.innerWidth * 0.01, "px"));
            window.addEventListener("resize", resizeListener);
        }
        return function() {
            if ((0,platform/* browser */.Xh)().isBrowser) window.removeEventListener("resize", resizeListener);
        };
    }, []);
    /**
   * Grab referral code to pass along in signup
   */ (0,react.useEffect)(function() {
        var ref;
        if (!(0,platform/* browser */.Xh)().isBrowser) return;
        // stash ref to add to auth state param
        var cookies = document.cookie.split(/;\s*/).reduce(function(acc, cookie) {
            var ref = (0,_sliced_to_array/* default */.Z)(cookie.split("="), 2), key = ref[0], val = ref[1];
            acc[key] = val;
            return acc;
        }, {});
        var ref1 = cookies["ref"] || ((ref = router.query) === null || ref === void 0 ? void 0 : ref[REF_PARAM]);
        var utm = Object.entries(router.query || {}).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), k = _param[0];
            return UTM_PARAM_RE.test(k);
        }).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
            var key = k.replace(/^utm_/, "");
            acc[key] = v;
            return acc;
        }, {});
        if (!!ref1) (0,local_storage/* setLocalStorage */.qQ)(storageKeys/* LOCAL_STORAGE_AUTH_REF */.ZB, ref1);
        if (!!Object.keys(utm).length) (0,local_storage/* setLocalStorage */.qQ)(storageKeys/* LOCAL_STORAGE_AUTH_UTM */.$K, utm);
    }, [
        router.query
    ]);
    /**
   * Main routing logic
   * FIXME (IW): This is wayy too complicated as it is
   */ (0,react.useEffect)(function() {
        var ref;
        // Dont do any redirect till we know what the heck is going on with the user... render will just show loading
        if (!router.isReady) return;
        // Hard reload the page after logout to make sure cookie is destroyed
        if (!!router.query.logout) {
            window.location.href = "/login";
            return;
        }
        // Wait for user to load
        if ([
            "init",
            "loading"
        ].includes(userState.status)) return;
        // TODO (IW): Move this to `protectedRoute`
        // Redirect to login if user is not authenticated
        if (!userState.isAuthenticated && userState.status === "failed" && !(0,utils_router/* hasValidRoutesWithoutAuth */.D8)(router)) {
            (0,local_storage/* setSessionStorage */.t_)(storageKeys/* LOCAL_STORAGE_AUTH_REDIRECT */.I7, router.asPath);
            void router.push({
                pathname: "/login"
            });
            return;
        }
        // legacy redirect from invite dialog to /share-reclaim
        if (!!router.query.invite) {
            void router.replace({
                pathname: "/share-reclaim",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    invite: undefined
                })
            });
            return;
        }
        // if we have a redirect in the state, use it, really the API should do this so its a little hacky
        // the check for "://" prevents arbitrary redirection (Open Redirect)
        var redirect = (ref = router.query.state) === null || ref === void 0 ? void 0 : ref.redirect;
        if (!!redirect && !redirect.includes("://")) {
            void router.replace({
                pathname: redirect.startsWith("/onboarding/user") ? "/onboarding/user/[...step]" : redirect,
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    state: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query.state), {
                        redirect: undefined
                    })
                })
            }, redirect);
            return;
        }
        // redirect old smart 1:1 email urls
        // FIXME (IW): Remove at a safe time in the future
        var matches = router.asPath.match(/^\/one-on-ones\/(\d{1,})\?/i);
        if (!!(matches === null || matches === void 0 ? void 0 : matches.length)) {
            var query = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                uid: matches[1]
            });
            void router.replace({
                pathname: "/smart-onboarding",
                query: query
            });
        }
        // if user isn't onboarded, force them back to onboarding
        if (!!userState.isAuthenticated && !!userState.user && !userState.user.onboarded && !/^\/(smart\-)?onboarding/.test(router.pathname) && !/^\/(book\-)?meeting/.test(router.pathname) && !/^\/quick-signup/.test(router.pathname) && !/^\/m/.test(router.pathname) && !router.pathname.startsWith("/e/") && !router.pathname.startsWith("/website/") && !router.pathname.startsWith("/team/accept")) {
            void router.push({
                pathname: (0,utils_router/* getUserOnboardingPath */.gi)("welcome"),
                query: router.query
            });
            return;
        }
        // TODO (IW): Merge w/ logic in LoginTemplate.tsx !!
        // route logged in user to default page
        if (router.pathname === "/") {
            var ref1;
            var pathname = "/planner";
            if (!((ref1 = userState.user) === null || ref1 === void 0 ? void 0 : ref1.onboarded)) {
                pathname = userState.isAuthenticated ? (0,utils_router/* getUserOnboardingPath */.gi)("welcome") : "/login";
            }
            void router.replace({
                pathname: pathname,
                query: router.query
            });
            return;
        }
    }, [
        medium,
        router,
        router.isReady,
        router.query,
        userState.isAuthenticated,
        userState.status,
        userState.user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEngineProvider, {
        injectFirst: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ThemeProvider_ThemeProvider, {
            theme: theme,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReclaimLocalizationProvider/* ReclaimLocalizationProvider */.B, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mui_modal_provider_esm/* default */.Z, {
                    legacy: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(notistack_esm/* SnackbarProvider */.wT, {
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(mui_modal_provider_esm/* default */.Z, {
                            legacy: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                            children: "Reclaim – A smart friend for your calendar"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                            name: "robots",
                                            content: "noindex"
                                        }, "robots")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline_CssBaseline, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (App_module_default()).root,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_ReclaimErrorBoundary, {
                                        failureCode: 4319,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStateInitializer, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommandBarContext/* CommandBarContextProvider */.qZ, {
                                                children: [
                                                    shadow_consts/* isImpersonating */.sQ && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                                                        severity: "error",
                                                        className: (App_module_default()).alert,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertTitle/* default */.Z, {
                                                                children: "Impersonation Active"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "YOU ARE IMPERSONATING ANOTHER USER!"
                                                            }),
                                                            " Any actions you take may affect their account. Please be discrete and ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "close this session when you are finished"
                                                            }),
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (App_module_default()).content,
                                                        children: children
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevDrawer, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EasyAccessElements, {})
                            ]
                        })
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/ClientOnly.tsx

// Solution to JSS classname mismatching in Next as discussed in this thread
// https://stackoverflow.com/questions/50685175/react-material-ui-warning-prop-classname-did-not-match/70461229#70461229
// CK 11/22
var ClientOnly = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    return mounted ? children : null;
};
/* harmony default export */ var components_ClientOnly = (ClientOnly);

// EXTERNAL MODULE: ./src/context/AnalyticsContext.tsx
var AnalyticsContext = __webpack_require__(89495);
;// CONCATENATED MODULE: ./src/context/DomainContext.ts


var DomainContext = (0,react.createContext)(reclaim_api/* reclaim */.Tz);
function useDomainContext() {
    return useContext(DomainContext);
}

// EXTERNAL MODULE: ./src/index.css
var src = __webpack_require__(54788);
;// CONCATENATED MODULE: ./src/lib/wdyr.ts
/// <reference types="@welldone-software/why-did-you-render" />

if (false) { var whyDidYouRender; }

// EXTERNAL MODULE: ./src/hooks/useIntercom.tsx
var useIntercom = __webpack_require__(10428);
// EXTERNAL MODULE: ./node_modules/react-use-intercom/dist/index.mjs
var dist = __webpack_require__(41608);
;// CONCATENATED MODULE: ./src/pages/_app.tsx
















// eslint-disable-next-line no-restricted-imports


licenseInfo/* LicenseInfo.setLicenseKey */.T.setLicenseKey("a92be851243d32eb9890e5d034815b5eTz03MDE3OCxFPTE3MjAyMTkyMDY5NzgsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=" || 0);
var HOST = "reclaim-worklifecalendar-kedmar88r-reclaim-ai.vercel.app" || 0;
var INTERCOM_APP_ID = "b0j779nc";
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps, err = param.err;
    var ogTitle = pageProps.ogTitle ? pageProps.ogTitle : "Reclaim | A smart friend for your calendar";
    var ogDescription = pageProps.ogDescription ? pageProps.ogDescription : "Reclaim automatically blocks flexible time on your calendar to keep you focused on the things that matter most.";
    var ogImage = pageProps.ogImage ? pageProps.ogImage : "https://".concat(HOST, "/img/opengraph/general.png");
    var twitterTitle = pageProps.twitterTitle ? pageProps.twitterTitle : "Reclaim | A smart friend for your calendar";
    var twitterDescription = pageProps.twitterDescription ? pageProps.twitterDescription : "Reclaim automatically blocks flexible time on your calendar to keep you focused on the things that matter most.";
    var twitterImage = pageProps.twitterImage ? pageProps.twitterImage : "https://".concat(HOST, "/img/opengraph/general.png");
    var reloadIfMobile = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        // Known issue with Intercom where closing the messenger on mobile breaks styles
        // Fix for now by forcing reload on close of mobile messenger
        // https://github.com/devrnt/react-use-intercom/issues/514
        // - CK 8/23
        if (true) {
            // this class name appears if Intercom is mobile mode
            if (!!document.querySelector(".intercom-w2ttxp")) {
                void window.location.reload();
            }
        }
    });
    var pageSupportsIntercom = (0,useIntercom/* usePageSupportsIntercom */.H)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Reclaim – A smart friend for your calendar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "minimum-scale=1, initial-scale=1.0, width=device-width"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: "Reclaim | A smart friend for your calendar"
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Reclaim automatically blocks flexible time on your calendar to keep you focused on the things that matter most."
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:type",
                        content: "website"
                    }, "ogType"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:url",
                        content: "https://".concat(HOST, "/")
                    }, "ogUrl"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:title",
                        property: "og:title",
                        content: ogTitle
                    }, "ogTitle"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        property: "og:description",
                        content: ogDescription
                    }, "ogDescription"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:image",
                        property: "og:image",
                        content: ogImage
                    }, "ogImage"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }, "twitterCard"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: "https://".concat(HOST, "/")
                    }, "twitterUrl"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: twitterTitle
                    }, "twitterTitle"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: twitterDescription
                    }, "twitterDescription"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: twitterImage
                    }, "twitterImage")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DomainContext.Provider, {
                value: reclaim_api/* reclaim */.Tz,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsContext/* AnalyticsContextProvider */.nx, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserContext/* UserContextProvider */.fS, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContext/* AppContextProvider */.iz, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IntercomProvider */.H, {
                                appId: "".concat(INTERCOM_APP_ID),
                                autoBoot: pageSupportsIntercom,
                                onHide: reloadIfMobile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(App, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClientOnly, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                                            err: err
                                        }))
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 36706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EL": function() { return /* binding */ connectedAccountToDto; },
/* harmony export */   "IJ": function() { return /* binding */ getAccountScopes; },
/* harmony export */   "ps": function() { return /* binding */ dtoToConnectedAccount; }
/* harmony export */ });
/* unused harmony export dtoScopesToPermissions */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26958);
/* harmony import */ var _Calendars__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48410);





function getAccountScopes() {
    var expanded = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var openIdScopes = [
        "openid",
        "https://www.googleapis.com/auth/userinfo.profile",
        "https://www.googleapis.com/auth/userinfo.email", 
    ];
    return expanded ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(openIdScopes).concat([
        "https://www.googleapis.com/auth/calendar"
    ]) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(openIdScopes).concat([
        "https://www.googleapis.com/auth/calendar.events",
        "https://www.googleapis.com/auth/calendar.readonly", 
    ]);
}
function dtoScopesToPermissions(scopes) {
    var splitScopes = (scopes === null || scopes === void 0 ? void 0 : scopes.split(/\s+/)) || [];
    var expanded = getAccountScopes(true);
    var restricted = getAccountScopes();
    if (!expanded.some(function(s) {
        return !splitScopes.includes(s);
    })) {
        return "Expanded";
    } else if (restricted.some(function(s) {
        return splitScopes.includes(s);
    })) {
        return "Restricted";
    } else {
        return "NotEnough";
    }
}
var dtoToConnectedAccountType = function(dto) {
    return dto;
};
var dtoToCalendarAccess = function(dto) {
    return dto;
};
function dtoToConnectedAccount(dto) {
    var ref, ref1;
    var connectedCalendars = ((ref = dto.connectedCalendars) === null || ref === void 0 ? void 0 : ref.map(function(cal) {
        return (0,_Calendars__WEBPACK_IMPORTED_MODULE_1__/* .dtoToCalendarView */ .$O)(cal);
    })) || [];
    var primaryCalendar = (ref1 = dto.connectedCalendars) === null || ref1 === void 0 ? void 0 : ref1.find(function(c) {
        return c.id === dto.primaryCalendarId;
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dto), {
        id: dto.id,
        type: dtoToConnectedAccountType(dto.type),
        calendarAccess: dtoToCalendarAccess(dto.calendarAccess),
        lastSynced: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .strToDate */ .z8)(dto.lastSynced),
        main: !!dto.main,
        connectedCalendars: connectedCalendars,
        primaryCalendar: primaryCalendar,
        permissions: dtoScopesToPermissions(dto.scopes),
        avatar: dto.avatar || undefined
    });
}
function connectedAccountToDto(data) {
    var ref;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, data), {
        type: data.type,
        calendarAccess: data.calendarAccess,
        lastSynced: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .dateToStr */ .dx)(data.lastSynced),
        connectedCalendars: (ref = data.connectedCalendars) === null || ref === void 0 ? void 0 : ref.map(_Calendars__WEBPACK_IMPORTED_MODULE_1__/* .calendarViewtoDto */ .Gw)
    });
}


/***/ }),

/***/ 6774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S$": function() { return /* binding */ CalendarSyncPolicyDomain; },
/* harmony export */   "X3": function() { return /* binding */ SyncTransparency; }
/* harmony export */ });
/* unused harmony exports dtoToCalendarSyncPolicy, calendarSyncPolicyToDto */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71418);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _Calendars__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48410);
/* harmony import */ var _EventMetaTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90109);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42230);











var SyncTransparency;
(function(SyncTransparency) {
    SyncTransparency["Default"] = "DEFAULT";
    SyncTransparency["SemiPrivate"] = "SEMI_PRIVATE";
    SyncTransparency["Private"] = "PRIVATE";
    SyncTransparency["Public"] = "PUBLIC";
    SyncTransparency["SemiPrivateAlt"] = "SEMI_PRIVATE_ALT";
})(SyncTransparency || (SyncTransparency = {}));
function dtoToCalendarSyncPolicy(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dto), {
        sourceCalendar: !!dto.sourceCalendar ? (0,_Calendars__WEBPACK_IMPORTED_MODULE_0__/* .dtoToCalendar */ .nr)(dto.sourceCalendar) : undefined,
        targetCalendar: !!dto.targetCalendar ? (0,_Calendars__WEBPACK_IMPORTED_MODULE_0__/* .dtoToCalendar */ .nr)(dto.targetCalendar) : undefined,
        color: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_1__/* .EventColor.get */ .dr.get(dto.color)
    });
}
function calendarSyncPolicyToDto(policy) {
    var ref;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, policy), {
        sourceCalendar: !!policy.sourceCalendar ? (0,_Calendars__WEBPACK_IMPORTED_MODULE_0__/* .calendarToDto */ .XP)(policy.sourceCalendar) : undefined,
        targetCalendar: !!policy.targetCalendar ? (0,_Calendars__WEBPACK_IMPORTED_MODULE_0__/* .calendarToDto */ .XP)(policy.targetCalendar) : undefined,
        color: (ref = policy.color) === null || ref === void 0 ? void 0 : ref.toJSON()
    });
}
var CalendarSyncPolicyDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(CalendarSyncPolicyDomain, TransformDomain);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(CalendarSyncPolicyDomain);
    function CalendarSyncPolicyDomain() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, CalendarSyncPolicyDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "CalendarSyncPolicy";
        _this.cacheKey = "calendarSyncPolicies";
        _this.pk = [
            "sourceCalendarId",
            "targetCalendarId"
        ];
        _this.deserialize = dtoToCalendarSyncPolicy;
        _this.serialize = calendarSyncPolicyToDto;
        _this.list = _this.deserializeResponse(_this.api.calendars.getSyncPolicies);
        _this.patch = _this.deserializeResponse(function(sourceId, targetId, data) {
            return _this.api.calendars.patchSyncPolicy(sourceId, targetId, _this.serialize(data));
        });
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this);
        // FIXME (IW): Insane gymnastics going on in here with no error handling
        _this.create = _this.deserializeResponse(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(syncPolicy) {
                var ref, ref1, ref2, ref3, payload, sourceCalendar, targetCalendar;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            payload = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, syncPolicy);
                            if (!!((ref = payload.sourceCalendar) === null || ref === void 0 ? void 0 : ref.id)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.client.calendars.createSync({
                                    calendar: (0,_Calendars__WEBPACK_IMPORTED_MODULE_0__/* .calendarToDto */ .XP)(payload.sourceCalendar)
                                })
                            ];
                        case 1:
                            sourceCalendar = _state.sent();
                            if (!!sourceCalendar) payload.sourceCalendar = sourceCalendar;
                            _state.label = 2;
                        case 2:
                            if (!!((ref1 = payload.targetCalendar) === null || ref1 === void 0 ? void 0 : ref1.id)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this1.client.calendars.createSync({
                                    calendar: (0,_Calendars__WEBPACK_IMPORTED_MODULE_0__/* .calendarToDto */ .XP)(payload.targetCalendar)
                                })
                            ];
                        case 3:
                            targetCalendar = _state.sent();
                            if (!!targetCalendar) payload.targetCalendar = targetCalendar;
                            _state.label = 4;
                        case 4:
                            // Prep the policy payload
                            if ((ref2 = payload.sourceCalendar) === null || ref2 === void 0 ? void 0 : ref2.id) payload.sourceCalendarId = payload.sourceCalendar.id;
                            if ((ref3 = payload.targetCalendar) === null || ref3 === void 0 ? void 0 : ref3.id) payload.targetCalendarId = payload.targetCalendar.id;
                            return [
                                4,
                                _this1.api.calendars.createSyncPolicy({
                                    calendarSyncPolicy: _this1.serialize(payload)
                                })
                            ];
                        case 5:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(syncPolicy) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this2 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this);
        _this.delete = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(sourceId, targetId) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.api.calendars.deleteSyncPolicy(sourceId, targetId)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(sourceId, targetId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.testSyncPolicy = function(policy) {
            return _this.api.calendars.testSyncPolicy(_this.serialize(policy));
        };
        return _this;
    }
    return CalendarSyncPolicyDomain;
}(_types__WEBPACK_IMPORTED_MODULE_2__/* .TransformDomain */ .Zs);


/***/ }),

/***/ 48410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ dtoToCalendarView; },
/* harmony export */   "DX": function() { return /* binding */ SyncCalendarType; },
/* harmony export */   "GY": function() { return /* binding */ dayOfWeekToDto; },
/* harmony export */   "Gw": function() { return /* binding */ calendarViewtoDto; },
/* harmony export */   "XP": function() { return /* binding */ calendarToDto; },
/* harmony export */   "eO": function() { return /* binding */ DayOfWeek; },
/* harmony export */   "f": function() { return /* binding */ Calendar; },
/* harmony export */   "g2": function() { return /* binding */ CalendarsDomain; },
/* harmony export */   "lK": function() { return /* binding */ AllDays; },
/* harmony export */   "nr": function() { return /* binding */ dtoToCalendar; },
/* harmony export */   "oN": function() { return /* binding */ Weekdays; }
/* harmony export */ });
/* unused harmony export CalendarType */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71418);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97582);
/* harmony import */ var _utils_arrays__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92886);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26958);
/* harmony import */ var _utils_promise__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53897);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98585);
/* harmony import */ var _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90109);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42230);

















var DayOfWeek;
(function(DayOfWeek) {
    DayOfWeek["Monday"] = "MONDAY";
    DayOfWeek["Tuesday"] = "TUESDAY";
    DayOfWeek["Wednesday"] = "WEDNESDAY";
    DayOfWeek["Thursday"] = "THURSDAY";
    DayOfWeek["Friday"] = "FRIDAY";
    DayOfWeek["Saturday"] = "SATURDAY";
    DayOfWeek["Sunday"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
var dayOfWeekToDto = function(dayOfWeek) {
    return dayOfWeek;
};
var Weekdays = [
    DayOfWeek.Monday,
    DayOfWeek.Tuesday,
    DayOfWeek.Wednesday,
    DayOfWeek.Thursday,
    DayOfWeek.Friday, 
];
var AllDays = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Weekdays).concat([
    DayOfWeek.Saturday,
    DayOfWeek.Sunday
]);
var CalendarType;
(function(CalendarType) {
    CalendarType["Primary"] = "PRIMARY";
    CalendarType["Shadow"] = "SHADOW";
    CalendarType["Personal"] = "PERSONAL";
    CalendarType["Priority"] = "PRIORITY";
})(CalendarType || (CalendarType = {}));
var SyncCalendarType;
(function(SyncCalendarType) {
    SyncCalendarType["Business"] = "BUSINESS";
    SyncCalendarType["Personal"] = "PERSONAL";
    SyncCalendarType["Travel"] = "TRAVEL";
})(SyncCalendarType || (SyncCalendarType = {}));
var dtoToCalendarView = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, dto), {
        // replace id=0 for CalendarViews without IDs
        id: dto.id || undefined,
        reason: dto.reason
    });
};
var calendarViewtoDto = function(calendarView) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, calendarView), {
        id: calendarView.id || 0,
        reason: calendarView
    });
};
var Calendar = /*#__PURE__*/ function() {
    "use strict";
    function Calendar(data) {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, Calendar);
        if (data) Object.entries(data).forEach(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
            return _this[k] = v;
        });
    }
    // TODO (IW): Find a better place for this (and Habit.getColor, Task.getColor)
    Calendar.getColor = function getColor(user, calendar) {
        return [
            _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventColor.Auto */ .dr.Auto,
            _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventColor.None */ .dr.None
        ].includes(calendar === null || calendar === void 0 ? void 0 : calendar.syncSettings.color) ? Calendar.getDefaultColor(user, calendar) : calendar === null || calendar === void 0 ? void 0 : calendar.syncSettings.color;
    };
    Calendar.getDefaultColor = function getDefaultColor(user, calendar) {
        return !!(calendar === null || calendar === void 0 ? void 0 : calendar.colorHex) ? new _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventColor */ .dr(_EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventColor.None.key */ .dr.None.key, null, calendar.colorHex, "Calendar default") : _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventColor.None */ .dr.None;
    };
    return Calendar;
}();
function dtoToCalendar(dto) {
    var ref, ref1;
    var syncSettings = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, dto.syncSettings), {
        transparency: dto.syncSettings.transparency,
        workingHours: !!dto.syncSettings.workingHours,
        defaultType: !!((ref = dto.syncSettings) === null || ref === void 0 ? void 0 : ref.defaultType) ? _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventType.get */ .tw.get(dto.syncSettings.defaultType) : _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventType.Personal */ .tw.Personal,
        color: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventColor.get */ .dr.get((ref1 = dto.syncSettings) === null || ref1 === void 0 ? void 0 : ref1.color) || _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventColor.Auto */ .dr.Auto,
        type: dto.syncSettings.type
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, dto), {
        id: dto.id,
        userId: dto.userId,
        calendarId: dto.calendarId,
        name: dto.name,
        authorized: !!dto.authorized,
        lastSynced: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .strToDate */ .z8)(dto.lastSynced),
        created: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .strToDate */ .z8)(dto.created),
        deleted: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .strToDate */ .z8)(dto.deleted),
        syncSettings: syncSettings
    });
}
function calendarToDto(calendar) {
    var ref, ref1;
    var syncSettings = !!calendar.syncSettings ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, calendar.syncSettings), {
        transparency: calendar.syncSettings.transparency,
        color: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_3__/* .EventColor.Auto */ .dr.Auto === calendar.syncSettings.color ? null : (ref = calendar.syncSettings.color) === null || ref === void 0 ? void 0 : ref.toJSON(),
        defaultType: (ref1 = calendar.syncSettings.defaultType) === null || ref1 === void 0 ? void 0 : ref1.toJSON(),
        type: calendar.syncSettings.type ? _client__WEBPACK_IMPORTED_MODULE_2__/* .SyncCalendarType */ .DX[calendar.syncSettings.type] : undefined
    }) : {};
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, calendar), {
        syncSettings: syncSettings,
        lastSynced: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .dateToStr */ .dx)(calendar.lastSynced),
        created: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .dateToStr */ .dx)(calendar.created),
        deleted: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .dateToStr */ .dx)(calendar.deleted)
    });
}
var CalendarsDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(CalendarsDomain, TransformDomain);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(CalendarsDomain);
    function CalendarsDomain() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, CalendarsDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "Calendar";
        _this.cacheKey = "calendars";
        _this.pk = "id";
        _this.serialize = calendarToDto;
        _this.deserialize = dtoToCalendar;
        _this.getPrimary = function() {
            return _this.api.calendars.getPrimary().catch(function(err) {
                switch(err.status){
                    case "NetworkError":
                        console.warn("Network error", err);
                    // TODO retry logic
                    case 500:
                        return err;
                    case 401:
                        return null;
                    default:
                        throw err;
                }
            }).then(function(res) {
                return (0,_utils_promise__WEBPACK_IMPORTED_MODULE_12__/* .createReturnFormatArray */ .ft)(res && !(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(res, Error) ? _this.deserialize(res) : null, (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(res, Error) ? res : null);
            });
        };
        _this.listPersonal = function() {
            return _this.api.calendars.getAllPersonal().catch(function(err) {
                switch(err.status){
                    case "NetworkError":
                    // TODO retry logic
                    case 500:
                        return err;
                    case 401:
                        return null;
                    default:
                        throw err;
                }
            }).then(function(res) {
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(res, Error)) {
                    return (0,_utils_promise__WEBPACK_IMPORTED_MODULE_12__/* .createReturnFormatArray */ .ft)(null, res);
                }
                return (0,_utils_promise__WEBPACK_IMPORTED_MODULE_12__/* .createReturnFormatArray */ .ft)(res ? (0,_utils_arrays__WEBPACK_IMPORTED_MODULE_0__/* .transformMap */ .gQ)(res, _this.deserialize) : null, null);
            });
        };
        _this.getPersonal = _this.deserializeResponse(_this.api.calendars.getPersonal);
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_this);
        _this.listAll = /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
            var ref, primary, ref1, personal, personalCandidates, checked, candidates, nonPrimary, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            _this1.getPrimary()
                        ];
                    case 1:
                        ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), primary = ref[0];
                        return [
                            4,
                            _this1.listPersonal()
                        ];
                    case 2:
                        ref1 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), personal = ref1[0];
                        return [
                            4,
                            _this1.getPersonalCandidates()
                        ];
                    case 3:
                        personalCandidates = _state.sent();
                        checked = (personal || []).map(function(c) {
                            return c.calendarId;
                        });
                        candidates = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(personal || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((personalCandidates || []).filter(function(c) {
                            return !checked.includes(c.calendarId);
                        })));
                        nonPrimary = candidates.sort((0,_utils_arrays__WEBPACK_IMPORTED_MODULE_0__/* .byKey */ .uy)("name")).filter(function(c) {
                            return !!c && !c.data.primary || c.credentialId !== (primary === null || primary === void 0 ? void 0 : primary.credentialId);
                        });
                        if (!primary) return [
                            2,
                            nonPrimary
                        ];
                        // Sort results by name, but primary is always first if it exists
                        return [
                            2,
                            [
                                primary
                            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(nonPrimary))
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            2,
                            []
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        _this.deletePersonal = function(calendar) {
            return _this.api.calendars.deletePersonal(calendar.id);
        };
        _this.getPersonalCandidates = _this.deserializeResponse(function(credentialId) {
            return _this.api.calendars.getPersonalCandidates({
                credentialId: credentialId
            });
        });
        _this.getSourceCandidates = _this.deserializeResponse(function(credentialId) {
            return _this.api.calendars.getSourceCandidates(credentialId);
        });
        _this.getTargetCandidates = _this.deserializeResponse(function(credentialId) {
            return _this.api.calendars.getTargetCandidates(credentialId);
        });
        _this.createSync = _this.deserializeResponse(_this.api.calendars.createSync);
        _this.share = function(credentialId) {
            return _this.api.calendars.share({
                credentialId: credentialId
            }, {});
        };
        _this.getCalendarUrl = function(calendar, pathname) {
            if (!calendar) return undefined;
            var url = new URL("https://calendar.google.com/calendar/r?authuser=".concat(calendar.calendarId));
            if (pathname) url.pathname = pathname;
            return url.toString();
        };
        return _this;
    }
    return CalendarsDomain;
}(_types__WEBPACK_IMPORTED_MODULE_4__/* .TransformDomain */ .Zs);


/***/ }),

/***/ 41849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vB": function() { return /* binding */ AuthMode; },
/* harmony export */   "y9": function() { return /* binding */ CredentialsDomain; }
/* harmony export */ });
/* unused harmony exports dtoToCredential, credentialToDto */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71418);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var _utils_platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94423);
/* harmony import */ var _Accounts_mutators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36706);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42230);










var AuthMode;
(function(AuthMode) {
    AuthMode["Primary"] = "PRIMARY";
    AuthMode["Secondary"] = "SECONDARY";
    AuthMode["Expand"] = "EXPAND";
    AuthMode["Repair"] = "REPAIR";
    AuthMode["Tasks"] = "TASKS";
    AuthMode["ConnectCalendar"] = "DIRECT_CONNECT_PRIMARY";
})(AuthMode || (AuthMode = {}));
function dtoToCredential(dto) {
    var ref;
    var c = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto);
    var scopes = ((ref = c.scopes) === null || ref === void 0 ? void 0 : ref.split(/\s+/)) || [];
    var expanded = (0,_Accounts_mutators__WEBPACK_IMPORTED_MODULE_1__/* .getAccountScopes */ .IJ)(true);
    var restricted = (0,_Accounts_mutators__WEBPACK_IMPORTED_MODULE_1__/* .getAccountScopes */ .IJ)();
    // for ui dev, flip cred logic ....
    // c.permissions = !expanded.some((s) => !scopes.includes(s)) ? PermissionLevel.Restricted : PermissionLevel.Expanded;
    c.permissions = !expanded.some(function(s) {
        return !scopes.includes(s);
    }) ? "Expanded" : restricted.some(function(s) {
        return scopes.includes(s);
    }) ? "Restricted" : "NotEnough";
    return c;
}
function credentialToDto(credential) {
    delete credential.permissions;
    return credential;
}
var CredentialsDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CredentialsDomain, TransformDomain);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(CredentialsDomain);
    function CredentialsDomain() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, CredentialsDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "Credential";
        _this.cacheKey = "credentials";
        _this.pk = "id";
        _this.deserialize = dtoToCredential;
        _this.serialize = credentialToDto;
        _this.list = _this.deserializeResponse(_this.api.credentials.list1);
        _this.listWithPrimary = _this.deserializeResponse(function(includeInvalid) {
            return _this.api.credentials.list1({
                includeInvalid: includeInvalid
            });
        });
        _this.get = _this.deserializeResponse(_this.api.credentials.get);
        _this.getPrimary = _this.deserializeResponse(_this.api.credentials.getPrimary1);
        _this.getPersonal = _this.deserializeResponse(_this.api.credentials.listPersonal);
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this);
        _this.delete = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(credential) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    return [
                        2,
                        _this1.api.credentials.delete2(credential.id)
                    ];
                });
            });
            return function(credential) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    var _proto = CredentialsDomain.prototype;
    _proto.save = function save(mode, state) {
        // FIXME: (IW) Doesn't work when base uri is just a path (eg. '/oauth/login'),
        // but window.location is no bueno
        this.redirect("new", mode.toLowerCase(), undefined, state);
    };
    _proto.expand = function expand(credentialId) {
        var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : AuthMode.Expand, state = arguments.length > 2 ? arguments[2] : void 0;
        // FIXME: (IW) Doesn't work when base uri is just a path (eg. '/oauth/login'),
        // but window.location is no bueno
        this.redirect("expand", credentialId, mode, state);
    };
    _proto.redirect = function redirect(action, context, mode, state) {
        if (!(0,_utils_platform__WEBPACK_IMPORTED_MODULE_0__/* .browser */ .Xh)().isBrowser) return;
        // FIXME: (IW) Doesn't work when base uri is just a path (eg. '/oauth/login'),
        // but window.location is no bueno
        var authUrl = new URL("".concat(this.api.baseUrl, "/credentials/auth/").concat(action, "/").concat(context), window.location.href);
        if (mode) authUrl.searchParams.append("mode", mode);
        authUrl.searchParams.append("state", JSON.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            redirect: window.location.pathname
        }, state || {})));
        window.location.href = authUrl.toString();
    };
    return CredentialsDomain;
}(_types__WEBPACK_IMPORTED_MODULE_2__/* .TransformDomain */ .Zs);


/***/ }),

/***/ 90109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CU": function() { return /* binding */ PrimaryCategory; },
/* harmony export */   "ME": function() { return /* binding */ AssistType; },
/* harmony export */   "PI": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.PI; },
/* harmony export */   "WD": function() { return /* binding */ Category; },
/* harmony export */   "dr": function() { return /* binding */ EventColor; },
/* harmony export */   "iN": function() { return /* binding */ EventSubType; },
/* harmony export */   "tw": function() { return /* binding */ EventType; }
/* harmony export */ });
/* unused harmony exports AssistStatus, Subcategory */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45785);
/* harmony import */ var _swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82662);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41796);
/* harmony import */ var _types_enums__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41390);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98585);














var AssistStatus;
(function(AssistStatus) {
    AssistStatus["Controlled"] = "CONTROLLED";
    AssistStatus["Released"] = "RELEASED";
    AssistStatus["Archived"] = "ARCHIVED";
})(AssistStatus || (AssistStatus = {}));
var AssistType = /*#__PURE__*/ function(ObjectEnum) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(AssistType, ObjectEnum);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AssistType);
    function AssistType(key) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, AssistType);
        var _this;
        _this = _super.call(this, key);
        _this.key = key;
        return _this;
    }
    var _proto = AssistType.prototype;
    _proto.isTravel = function isTravel() {
        return this === AssistType.PreTravel || this === AssistType.PostTravel;
    };
    _proto.isTask = function isTask() {
        return this == AssistType.Task;
    };
    _proto.isHabit = function isHabit() {
        return !this.isTravel() && !this.isTask();
    };
    return AssistType;
}(_types_enums__WEBPACK_IMPORTED_MODULE_4__/* .ObjectEnum */ .W);
AssistType.CatchupAm = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.CATCHUPAM */ .ME.CATCHUPAM);
AssistType.CatchupPm = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.CATCHUPPM */ .ME.CATCHUPPM);
AssistType.Lunch = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.LUNCH */ .ME.LUNCH);
AssistType.Focus = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.FOCUS */ .ME.FOCUS);
AssistType.PreTravel = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.TRAVELPRE */ .ME.TRAVELPRE);
AssistType.PostTravel = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.TRAVELPOST */ .ME.TRAVELPOST);
AssistType.CustomHabit = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.CUSTOMDAILY */ .ME.CUSTOMDAILY);
AssistType.Task = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.TASK */ .ME.TASK);
AssistType.Buffer = new AssistType(_client__WEBPACK_IMPORTED_MODULE_0__/* .AssistType.CONBUF */ .ME.CONBUF);
var EventColor = /*#__PURE__*/ function(ObjectEnum) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(EventColor, ObjectEnum);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EventColor);
    function EventColor(key, id, hex, label, builtin) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EventColor);
        var _this;
        _this = _super.call(this, key);
        _this.key = key;
        _this.id = id;
        _this.hex = hex;
        _this.label = label;
        _this.builtin = builtin;
        if (builtin) EventColor._all.push((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
        return _this;
    }
    var _proto = EventColor.prototype;
    _proto.toJSON = function toJSON() {
        return this.key === "AUTO" ? null : (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(EventColor.prototype), "toJSON", this).call(this);
    };
    EventColor.get = function get(key) {
        if (!key) return EventColor.Auto;
        return Object.values(this).filter(function(val) {
            return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(val, EventColor);
        }).find(function(val) {
            return val.key === key;
        }) || EventColor.Auto;
    };
    EventColor.getColor = function getColor(user, category) {
        var ref, ref1;
        if (!category) return EventColor.Auto;
        if (!user) return ((ref = category.typeOrSubtype) === null || ref === void 0 ? void 0 : ref.getColor()) || EventColor.Auto;
        return user.features.colors.categories[((ref1 = category.parent) === null || ref1 === void 0 ? void 0 : ref1.key) || category.key] || EventColor.Auto;
    };
    /**
   * Gets background and text colors for an event's color.
   * @param theme The MUI theme
   * @param color The color (as a string) from the event
   * @param rsvpStatus The RSVP status of the event
   * @param isPast Should the event be displayed as a past event
   * @returns A tuple containing [backgroundColor, textColor]
   */ EventColor.getColorShades = function getColorShades(theme, color, rsvpStatus) {
        var isPast = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        if (rsvpStatus === "Declined" || rsvpStatus === "TentativelyAccepted" || rsvpStatus === "NotResponded") return [
            (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* .lighten */ .$n)(color, 0.8),
            (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* .darken */ ._j)(color, 0.2)
        ];
        else if (isPast) return [
            (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* .lighten */ .$n)(color, 0.75),
            (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* .darken */ ._j)(color, 0.9)
        ];
        else return [
            (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* .lighten */ .$n)(color, 0.3),
            (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* .alpha */ .Fq)(theme.palette.getContrastText(color), 0.8)
        ];
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(EventColor, null, [
        {
            key: "all",
            get: function get() {
                return this._all;
            }
        }
    ]);
    return EventColor;
}(_types_enums__WEBPACK_IMPORTED_MODULE_4__/* .ObjectEnum */ .W);
EventColor._all = [];
EventColor.Auto = new EventColor("AUTO", undefined, "rgba(255,255,255,0.25)", "Category Color", true);
EventColor.None = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.NONE */ .dr.NONE, null, "#AAA", "Calendar Default", true);
EventColor.Lavender = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.LAVENDER */ .dr.LAVENDER, "1", "#6E7BC4", "Lavender", true);
EventColor.Sage = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.SAGE */ .dr.SAGE, "2", "#2DAD6E", "Sage", true);
EventColor.Grape = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.GRAPE */ .dr.GRAPE, "3", "#8321A0", "Grape", true);
EventColor.Flamingo = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.FLAMINGO */ .dr.FLAMINGO, "4", "#E27068", "Flamingo", true);
EventColor.Banana = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.BANANA */ .dr.BANANA, "5", "#F5B623", "Banana", true);
EventColor.Tangerine = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.TANGERINE */ .dr.TANGERINE, "6", "#F2471C", "Tangerine", true);
EventColor.Peacock = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.PEACOCK */ .dr.PEACOCK, "7", "#0191E1", "Peacock", true);
EventColor.Graphite = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.GRAPHITE */ .dr.GRAPHITE, "8", "#565656", "Graphite", true);
EventColor.Blueberry = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.BLUEBERRY */ .dr.BLUEBERRY, "9", "#3748AC", "Blueberry", true);
EventColor.Basil = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.BASIL */ .dr.BASIL, "10", "#0E753B", "Basil", true);
EventColor.Tomato = new EventColor(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventColor.TOMATO */ .dr.TOMATO, "11", "#CF0003", "Tomato", true);
var EventCategory = /*#__PURE__*/ function(ObjectEnum) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(EventCategory, ObjectEnum);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EventCategory);
    function EventCategory() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EventCategory);
        return _super.apply(this, arguments);
    }
    EventCategory.parse = function parse(key) {
        if (!key) return EventType.Meeting;
        return EventSubType.get(key) || EventType.get(key);
    };
    return EventCategory;
}(_types_enums__WEBPACK_IMPORTED_MODULE_4__/* .ObjectEnum */ .W);
var ScoredType = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(EventCategory) {
    "use strict";
    _inherits(ScoredType, EventCategory);
    var _super = _create_super(ScoredType);
    function ScoredType() {
        _class_call_check(this, ScoredType);
        return _super.apply(this, arguments);
    }
    return ScoredType;
}(EventCategory)));
var EventType = /*#__PURE__*/ function(EventCategory) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(EventType, EventCategory);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EventType);
    function EventType(key, color, label) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EventType);
        var _this;
        _this = _super.call(this, key);
        _this.key = key;
        _this.color = color;
        _this.label = label;
        return _this;
    }
    var _proto = EventType.prototype;
    _proto.getColor = function getColor() {
        return this.color;
    };
    EventType.get = function get(key) {
        if (!key) return EventType.Meeting;
        return Object.values(this).filter(function(val) {
            return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(val, EventType);
        }).find(function(val) {
            return val.key === key;
        });
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(EventType, [
        {
            key: "type",
            get: function get() {
                return this;
            }
        },
        {
            key: "subType",
            get: function get() {
                switch(this.key){
                    case _client__WEBPACK_IMPORTED_MODULE_0__/* .EventType.WORK */ .tw.WORK:
                        return EventSubType.Focus;
                    case _client__WEBPACK_IMPORTED_MODULE_0__/* .EventType.LOGISTICS */ .tw.LOGISTICS:
                        return EventSubType.Travel;
                    case _client__WEBPACK_IMPORTED_MODULE_0__/* .EventType.PERSONAL */ .tw.PERSONAL:
                        return EventSubType.PersonalOther;
                    case _client__WEBPACK_IMPORTED_MODULE_0__/* .EventType.MEETING */ .tw.MEETING:
                    default:
                        return EventSubType.Unknown;
                }
            }
        }
    ]);
    return EventType;
}(EventCategory);
EventType.Personal = new EventType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventType.PERSONAL */ .tw.PERSONAL, EventColor.Flamingo, "Personal");
EventType.Work = new EventType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventType.WORK */ .tw.WORK, EventColor.Blueberry, "Solo Work");
EventType.Meeting = new EventType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventType.MEETING */ .tw.MEETING, EventColor.Graphite, "Meeting");
EventType.Logistics = new EventType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventType.LOGISTICS */ .tw.LOGISTICS, EventColor.Tangerine, "Logistics");
var EventSubType = /*#__PURE__*/ function(EventCategory) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(EventSubType, EventCategory);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EventSubType);
    function EventSubType(key, type, label) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EventSubType);
        var _this;
        _this = _super.call(this, key);
        _this.key = key;
        _this.type = type;
        _this.label = label;
        return _this;
    }
    var _proto = EventSubType.prototype;
    _proto.getColor = function getColor() {
        return this.type.color;
    };
    EventSubType.get = function get(key) {
        return Object.values(this).filter(function(val) {
            return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(val, EventSubType);
        }).find(function(val) {
            return val.key === key;
        });
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(EventSubType, [
        {
            key: "subType",
            get: function get() {
                return this;
            }
        }
    ]);
    return EventSubType;
}(EventCategory);
EventSubType.Unknown = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.UNKNOWN */ .iN.UNKNOWN, EventType.Meeting, "Unknown");
EventSubType.OneOnOne = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.ONEONONE */ .iN.ONEONONE, EventType.Meeting, "1:1");
EventSubType.StaffMeeting = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.STAFFMEETING */ .iN.STAFFMEETING, EventType.Meeting, "Staff Meeting");
EventSubType.OpReview = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.OPREVIEW */ .iN.OPREVIEW, EventType.Meeting, "Operations Review");
EventSubType.External = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.EXTERNAL */ .iN.EXTERNAL, EventType.Meeting, "External Meeting");
EventSubType.Ideation = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.IDEATION */ .iN.IDEATION, EventType.Meeting, "Ideation Meeting");
EventSubType.Focus = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.FOCUS */ .iN.FOCUS, EventType.Work, "Deep Solo Work");
EventSubType.Productivity = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.PRODUCTIVITY */ .iN.PRODUCTIVITY, EventType.Work, "Shallow Solo Work");
EventSubType.Travel = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.TRAVEL */ .iN.TRAVEL, EventType.Logistics, "Travel");
EventSubType.Flight = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.FLIGHT */ .iN.FLIGHT, EventType.Logistics, "Flight");
EventSubType.Reclaim = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.RECLAIM */ .iN.RECLAIM, EventType.Logistics, "Reclaim");
EventSubType.Vacation = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.VACATION */ .iN.VACATION, EventType.Personal, "Vacation");
EventSubType.Health = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.HEALTH */ .iN.HEALTH, EventType.Personal, "Health");
EventSubType.Errand = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.ERRAND */ .iN.ERRAND, EventType.Personal, "Errand");
EventSubType.PersonalOther = new EventSubType(_client__WEBPACK_IMPORTED_MODULE_0__/* .EventSubType.OTHERPERSONAL */ .iN.OTHERPERSONAL, EventType.Personal, "Personal");
var Category = /*#__PURE__*/ function(ObjectEnum) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Category, ObjectEnum);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Category);
    function Category(typeOrSubtype, label, description) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, Category);
        var _this;
        _this = _super.call(this, typeOrSubtype.key);
        _this.typeOrSubtype = typeOrSubtype;
        _this.label = label;
        _this.description = description;
        return _this;
    }
    Category.get = function get(key) {
        return Category.All.find(function(val) {
            return val.key === key;
        });
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Category, null, [
        {
            key: "All",
            get: function get() {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Object.values(PrimaryCategory)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Object.values(Subcategory))).filter(function(val) {
                    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(val, Category);
                });
            }
        },
        {
            key: "Primary",
            get: function get() {
                return Object.values(PrimaryCategory).filter(function(c) {
                    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(c, PrimaryCategory);
                });
            }
        }
    ]);
    return Category;
}(_types_enums__WEBPACK_IMPORTED_MODULE_4__/* .ObjectEnum */ .W);
var PrimaryCategory = /*#__PURE__*/ function(Category) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(PrimaryCategory, Category);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PrimaryCategory);
    function PrimaryCategory(typeOrSubtype, label, description) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, PrimaryCategory);
        var _this;
        _this = _super.call(this, typeOrSubtype, label, description);
        _this.typeOrSubtype = typeOrSubtype;
        _this.label = label;
        _this.description = description;
        _this.parent = undefined;
        return _this;
    }
    PrimaryCategory.get = function get(key) {
        return Object.values(PrimaryCategory).filter(function(c) {
            return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(c, PrimaryCategory);
        }).find(function(val) {
            return val.key === key;
        });
    };
    return PrimaryCategory;
}(Category);
PrimaryCategory.TeamMeeting = new PrimaryCategory(EventType.Meeting, "Team Meeting", "Meetings with people within your organization");
PrimaryCategory.SoloWork = new PrimaryCategory(EventType.Work, "Solo Work", "Focused work, including work Habits and Tasks");
PrimaryCategory.Personal = new PrimaryCategory(EventType.Personal, "Personal", "Personal events, including personal Habits and Tasks");
PrimaryCategory.Logistics = new PrimaryCategory(EventType.Logistics, "Travel & Logistics", "Flights, travel time before and after events");
PrimaryCategory.ExternalMeeting = new PrimaryCategory(EventSubType.External, "External Meeting", "Meetings with people outside your organization");
PrimaryCategory.OneOnOne = new PrimaryCategory(EventSubType.OneOnOne, "One-on-One", "1:1s with people within your organization");
PrimaryCategory.TaskOption = [
    PrimaryCategory.SoloWork,
    PrimaryCategory.Personal
];
PrimaryCategory.HabitOption = [
    PrimaryCategory.SoloWork,
    PrimaryCategory.Personal,
    PrimaryCategory.Logistics
];
var Subcategory = /*#__PURE__*/ function(Category) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Subcategory, Category);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Subcategory);
    function Subcategory(typeOrSubtype, label, description, parent) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, Subcategory);
        var _this;
        _this = _super.call(this, typeOrSubtype, label, description);
        _this.typeOrSubtype = typeOrSubtype;
        _this.label = label;
        _this.description = description;
        _this.parent = parent;
        return _this;
    }
    Subcategory.get = function get(key) {
        return Object.values(Subcategory).filter(function(c) {
            return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(c, PrimaryCategory);
        }).find(function(val) {
            return val.key === key;
        });
    };
    return Subcategory;
}(Category);
Subcategory.Focus = new Subcategory(EventSubType.Focus, "Focus Work", "", PrimaryCategory.SoloWork);
Subcategory.Productivity = new Subcategory(EventSubType.Productivity, "Productivity", "", PrimaryCategory.SoloWork);
Subcategory.Travel = new Subcategory(EventSubType.Travel, "Travel", "", PrimaryCategory.Logistics);
Subcategory.Flight = new Subcategory(EventSubType.Flight, "Flight", "", PrimaryCategory.Logistics);
Subcategory.Decompress = new Subcategory(EventSubType.Reclaim, "Decompression", "", PrimaryCategory.Logistics);
Subcategory.Vacation = new Subcategory(EventSubType.Vacation, "Vacation", "", PrimaryCategory.Personal);
Subcategory.PersonalOther = new Subcategory(EventSubType.PersonalOther, "Other Personal", "", PrimaryCategory.Personal);
Subcategory.Unknown = new Subcategory(EventSubType.Unknown, "Unknown", "", PrimaryCategory.TeamMeeting);


/***/ }),

/***/ 91500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PI": function() { return /* binding */ EventResponseStatus; },
  "N3": function() { return /* binding */ EventStatus; },
  "Vq": function() { return /* binding */ EventsDomain; },
  "$q": function() { return /* binding */ ReclaimEventType; },
  "Ks": function() { return /* binding */ calendarEventToEvent; },
  "K2": function() { return /* binding */ dtoToCalendarEvent; },
  "k_": function() { return /* binding */ dtoToEvent; },
  "Us": function() { return /* binding */ findNextUpcomingEvent; }
});

// UNUSED EXPORTS: SnoozeOption, calendarEventToDto, eventToDto, findNextTemporalThing, findNextUpcomingCalendarEvent

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/utils/events.ts
var utils_events = __webpack_require__(43835);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(63496);
// EXTERNAL MODULE: ./src/utils/dates.ts + 3 modules
var dates = __webpack_require__(26958);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./src/utils/wonka.ts
var utils_wonka = __webpack_require__(60811);
// EXTERNAL MODULE: ./src/reclaim-api/adaptors/ws.ts + 1 modules
var ws = __webpack_require__(77856);
// EXTERNAL MODULE: ./src/reclaim-api/client.ts
var client = __webpack_require__(98585);
// EXTERNAL MODULE: ./src/reclaim-api/EventMetaTypes.ts
var EventMetaTypes = __webpack_require__(90109);
;// CONCATENATED MODULE: ./src/reclaim-api/Events.mutators.ts
var dtoToRecurringEventUpdatePeriod = function(dto) {
    return dto;
};
var recurringEventUpdatePeriodToDto = function(value) {
    return value;
};

// EXTERNAL MODULE: ./src/reclaim-api/Events.utils.ts
var Events_utils = __webpack_require__(28465);
// EXTERNAL MODULE: ./src/reclaim-api/types.ts + 2 modules
var types = __webpack_require__(42230);
;// CONCATENATED MODULE: ./src/reclaim-api/Events.ts



















var EventResponseStatus;
(function(EventResponseStatus) {
    EventResponseStatus["None"] = "None";
    EventResponseStatus["Organizer"] = "Organizer";
    EventResponseStatus["Accepted"] = "Accepted";
    EventResponseStatus["Declined"] = "Declined";
    EventResponseStatus["TentativelyAccepted"] = "TentativelyAccepted";
    EventResponseStatus["NotResponded"] = "NotResponded";
})(EventResponseStatus || (EventResponseStatus = {}));
var ReclaimEventType;
(function(ReclaimEventType) {
    ReclaimEventType[ReclaimEventType["User"] = client/* ReclaimEventType.USER */.$q.USER] = "User";
    ReclaimEventType[ReclaimEventType["Sync"] = client/* ReclaimEventType.SYNC */.$q.SYNC] = "Sync";
    ReclaimEventType[ReclaimEventType["HabitAssignment"] = client/* ReclaimEventType.HABITASSIGNMENT */.$q.HABITASSIGNMENT] = "HabitAssignment";
    ReclaimEventType[ReclaimEventType["OneOnOneAssignment"] = client/* ReclaimEventType.ONEONONEASSIGNMENT */.$q.ONEONONEASSIGNMENT] = "OneOnOneAssignment";
    ReclaimEventType[ReclaimEventType["TaskAssignment"] = client/* ReclaimEventType.TASKASSIGNMENT */.$q.TASKASSIGNMENT] = "TaskAssignment";
    ReclaimEventType[ReclaimEventType["SchedulingLinkAssignment"] = client/* ReclaimEventType.SCHEDULINGLINKMEETING */.$q.SCHEDULINGLINKMEETING] = "SchedulingLinkAssignment";
    ReclaimEventType[ReclaimEventType["ConfBuffer"] = client/* ReclaimEventType.CONFBUFFER */.$q.CONFBUFFER] = "ConfBuffer";
    ReclaimEventType[ReclaimEventType["TravelBuffer"] = client/* ReclaimEventType.TRAVELBUFFER */.$q.TRAVELBUFFER] = "TravelBuffer";
    ReclaimEventType[ReclaimEventType["Unknown"] = client/* ReclaimEventType.UNKNOWN */.$q.UNKNOWN] = "Unknown";
})(ReclaimEventType || (ReclaimEventType = {}));
var EventStatus;
(function(EventStatus) {
    EventStatus["Draft"] = "DRAFT";
    EventStatus["Published"] = "PUBLISHED";
    EventStatus["Cancelled"] = "CANCELLED";
    EventStatus["Rescheduling"] = "RESCHEDULING";
})(EventStatus || (EventStatus = {}));

var calendarEventToDto = function(data) {
    return _object_spread_props(_object_spread({}, data), {
        startTime: data.startTime.toISOString(),
        endTime: data.endTime.toISOString(),
        color: EventColorDto[data.color],
        rsvpStatus: EventResponseStatusDto[data.rsvpStatus]
    });
};
var dtoToCalendarEvent = function(dto) {
    var eventId = dto.eventId, title = dto.title, startTime = dto.startTime, endTime = dto.endTime;
    if (typeof eventId !== "string") throw new Error("CalendarEvent must have an eventId");
    if (typeof startTime !== "string") throw new Error("CalendarEvent must have an startTime");
    if (typeof endTime !== "string") throw new Error("CalendarEvent must have an endTime");
    var startTimeDate = new Date(startTime);
    var endTimeDate = new Date(endTime);
    if (isNaN(startTimeDate.getTime())) throw new Error("startTime was not a valid ISO date");
    if (isNaN(endTimeDate.getTime())) throw new Error("endTime was not a valid ISO date");
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dto), {
        title: title || "",
        eventId: eventId,
        startTime: startTimeDate,
        endTime: endTimeDate,
        color: EventMetaTypes/* EventColor.get */.dr.get(dto.color).key,
        rsvpStatus: "Accepted",
        // I believe this should always be defined
        displayColorHex: dto.displayColorHex
    });
};
// TODO: CalendarEvent is an eventual replacement for Event.  This function is to bridge the gap -SG
var calendarEventToEvent = function(calendarEvent) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, calendarEvent), {
        category: EventMetaTypes/* PrimaryCategory.SoloWork */.CU.SoloWork,
        key: calendarEvent.eventId,
        reclaimEventType: ReclaimEventType.Unknown,
        rsvpStatus: EventResponseStatus[calendarEvent.rsvpStatus || "Accepted"],
        eventStart: calendarEvent.startTime,
        eventEnd: calendarEvent.endTime,
        color: EventMetaTypes/* EventColor.get */.dr.get(calendarEvent.color),
        onlineMeetingUrl: calendarEvent.onlineMeetingUrl || undefined,
        status: calendarEvent.status
    });
};
var eventsQueryFilter = function(options) {
    var statuses = options.statuses, start = options.start, end = options.end, habitIds = options.habitIds, type = options.type, oneOnOneIds = options.oneOnOneIds, calendarIds = options.calendarIds;
    return function(events) {
        return events.filter(function(e) {
            return (!start || !(e.eventStart <= start && e.eventEnd <= start)) && (!end || !(e.eventStart > end && e.eventEnd > end));
        }).filter(function(e) {
            return !calendarIds || !!e.calendarId && calendarIds.includes(e.calendarId);
        }).filter(function(e) {
            return !statuses || !!e.status && statuses.includes(e.status);
        }).filter(function(e) {
            return !type || !!e.type && type.includes(e.type);
        }).filter(function(e) {
            var ref;
            return !habitIds || !!((ref = e.assist) === null || ref === void 0 ? void 0 : ref.dailyHabitId) && (habitIds === null || habitIds === void 0 ? void 0 : habitIds.includes(e.assist.dailyHabitId));
        }).filter(function(e) {
            var ref;
            return !oneOnOneIds || !!((ref = e.assist) === null || ref === void 0 ? void 0 : ref.dailyHabitId) && (oneOnOneIds === null || oneOnOneIds === void 0 ? void 0 : oneOnOneIds.includes(e.assist.dailyHabitId));
        });
    };
};
function dtoToEvent(dto) {
    var assist = !!dto.assist ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dto.assist), {
        type: !!dto.assist.type ? EventMetaTypes/* AssistType.get */.ME.get(dto.assist.type) : undefined,
        status: dto.assist.status,
        dailyHabitId: dto.assist.dailyHabitId || undefined,
        taskId: dto.assist.taskId || undefined,
        taskIndex: dto.assist.taskIndex || undefined
    }) : undefined;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dto), {
        assist: assist,
        key: dto.key,
        eventId: dto.eventId || "-",
        reclaimEventType: dto.reclaimEventType,
        status: dto.status,
        eventStart: (0,dates/* strToDate */.z8)(dto.eventStart),
        eventEnd: (0,dates/* strToDate */.z8)(dto.eventEnd),
        updated: (0,dates/* strToDate */.z8)(dto.updated),
        meetingType: null,
        category: EventMetaTypes/* Category.get */.WD.get(dto.category) || EventMetaTypes/* PrimaryCategory.TeamMeeting */.CU.TeamMeeting,
        categoryOverride: EventMetaTypes/* Category.get */.WD.get(dto.categoryOverride),
        color: !!dto.color ? EventMetaTypes/* EventColor.get */.dr.get(dto.color) : EventMetaTypes/* EventColor.Auto */.dr.Auto
    });
}
function eventToDto(event) {
    var ref, ref1, ref2;
    return (0,objects/* removeEmpty */.HO)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event), {
        eventStart: (0,dates/* dateToStr */.dx)(event.eventStart),
        eventEnd: (0,dates/* dateToStr */.dx)(event.eventEnd),
        updated: (0,dates/* dateToStr */.dx)(event.updated),
        category: (ref = event.category) === null || ref === void 0 ? void 0 : ref.toJSON(),
        categoryOverride: (ref1 = event.categoryOverride) === null || ref1 === void 0 ? void 0 : ref1.toJSON(),
        color: EventMetaTypes/* EventColor.Auto */.dr.Auto === event.color ? null : (ref2 = event.color) === null || ref2 === void 0 ? void 0 : ref2.toJSON()
    }));
}
var EventsSubscription = {
    subscriptionType: ws/* SubscriptionType.Events */.Qe.Events
};
var EventsDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(EventsDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(EventsDomain);
    function EventsDomain() {
        (0,_class_call_check/* default */.Z)(this, EventsDomain);
        var _this;
        var ref, // Events can be included in assist payloads
        ref1, ref2;
        _this = _super.apply(this, arguments);
        _this.resource = "Event";
        _this.cacheKey = "events";
        _this.pk = "key";
        _this.deserialize = dtoToEvent;
        _this.serialize = eventToDto;
        _this.watchWs$ = (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
            ((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$(EventsSubscription)) || (0,wonka/* fromArray */.nI)([]),
            ((ref1 = _this.ws) === null || ref1 === void 0 ? void 0 : ref1.subscription$$({
                subscriptionType: ws/* SubscriptionType.AssistPlanned */.Qe.AssistPlanned
            })) || (0,wonka/* fromArray */.nI)([]),
            ((ref2 = _this.ws) === null || ref2 === void 0 ? void 0 : ref2.subscription$$({
                subscriptionType: ws/* SubscriptionType.AssistCompleted */.Qe.AssistCompleted
            })) || (0,wonka/* fromArray */.nI)([]), 
        ]), (0,wonka/* filter */.hX)(function(envelope) {
            return !!envelope.data;
        }), (0,wonka/* map */.UI)(function(envelope) {
            return envelope.type === ws/* SubscriptionType.Events */.Qe.Events ? envelope.data : envelope.data.events;
        }), (0,wonka/* buffer */.f3)((0,wonka/* interval */.FG)(10)), (0,wonka/* map */.UI)(function(buffered) {
            return buffered.flat();
        }), (0,utils_wonka/* deserialize */.vB)(_this.deserialize));
        _this.watchAll$ = (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka/* map */.UI)(function(items) {
            return _this.patchExpectedChanges(items);
        }));
        _this.watch$$ = function(start, end) {
            var ref, // Events can be included in assist payloads
            ref1, ref2;
            var subscription = {
                subscriptionType: ws/* SubscriptionType.Events */.Qe.Events,
                startTime: start,
                endTime: end
            };
            return (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
                _this.upsert$,
                (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
                    ((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$(subscription)) || (0,wonka/* fromArray */.nI)([]),
                    ((ref1 = _this.ws) === null || ref1 === void 0 ? void 0 : ref1.subscription$$({
                        subscriptionType: ws/* SubscriptionType.AssistPlanned */.Qe.AssistPlanned
                    })) || (0,wonka/* fromArray */.nI)([]),
                    ((ref2 = _this.ws) === null || ref2 === void 0 ? void 0 : ref2.subscription$$({
                        subscriptionType: ws/* SubscriptionType.AssistCompleted */.Qe.AssistCompleted
                    })) || (0,wonka/* fromArray */.nI)([]), 
                ]), (0,wonka/* filter */.hX)(function(envelope) {
                    return !!envelope.data;
                }), (0,wonka/* map */.UI)(function(envelope) {
                    return envelope.type === ws/* SubscriptionType.Events */.Qe.Events ? envelope.data : envelope.data.events;
                }), (0,wonka/* buffer */.f3)((0,wonka/* interval */.FG)(10)), (0,wonka/* map */.UI)(function(buffered) {
                    return buffered.flat();
                }), (0,utils_wonka/* deserialize */.vB)(_this.deserialize)), 
            ]), (0,wonka/* map */.UI)(function(items) {
                return _this.patchExpectedChanges(items);
            }));
        };
        _this.list$$ = function(options) {
            return (0,wonka/* pipe */.zG)((0,wonka/* fromPromise */.p4)(_this.client.events.list(options)), (0,wonka/* map */.UI)(function(items) {
                return _this.patchExpectedChanges(items);
            }));
        };
        _this.listAndWatch$$ = function(options) {
            return (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
                _this.list$$(options),
                _this.watch$$(options.start, options.end)
            ]), (0,utils_wonka/* upsert */.H)(function(e) {
                return _this.getPk(e);
            }), (0,wonka/* map */.UI)(eventsQueryFilter(options)));
        };
        _this.watchId$$ = function(key) {
            return (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
                (0,wonka/* fromPromise */.p4)(_this.get(key).then(function(r) {
                    return !!r ? [
                        r
                    ] : [];
                })),
                _this.watchAll$
            ]), (0,wonka/* map */.UI)(function(items) {
                return items === null || items === void 0 ? void 0 : items.find(function(i) {
                    return i.key === key;
                });
            }));
        };
        _this.watchAssignmentEvents$$ = function(id, assignmentType) {
            return (0,wonka/* pipe */.zG)(_this.watchAll$, (0,wonka/* map */.UI)(function(events) {
                return events.filter(function(e) {
                    var assignment = (0,utils_events/* getAssignmentIdAndType */.yG)(e);
                    return assignment.assignmentId === id && assignment.type === assignmentType;
                }).sort(Events_utils/* eventStartDateComparator */.H);
            }));
        };
        _this.watchQuery$$ = function(_param) {
            var _statuses = _param.statuses, statuses = _statuses === void 0 ? [
                EventStatus.Published
            ] : _statuses, options = (0,_object_without_properties/* default */.Z)(_param, [
                "statuses"
            ]);
            return (0,wonka/* pipe */.zG)(_this.watch$$(options.start, options.end), (0,utils_wonka/* upsert */.H)(function(e) {
                return _this.getPk(e);
            }), (0,wonka/* map */.UI)(eventsQueryFilter((0,src_object_spread/* default */.Z)({
                statuses: statuses
            }, options))));
        };
        _this.list = _this.deserializeResponse(function(param) {
            var start = param.start, end = param.end, type = param.type, sourceDetails = param.sourceDetails, habitIds = param.habitIds, oneOnOneIds = param.oneOnOneIds, calendarIds = param.calendarIds;
            return _this.api.events.query({
                start: start ? (0,format/* default */.Z)(start, "yyyy-MM-dd") : undefined,
                end: end ? (0,format/* default */.Z)(end, "yyyy-MM-dd") : undefined,
                type: type || undefined,
                sourceDetails: sourceDetails,
                habitIds: habitIds,
                calendarIds: calendarIds,
                recurringOneOnOneIds: oneOnOneIds
            });
        });
        _this.listPersonal = _this.deserializeResponse(function(start, end, limit) {
            return _this.api.events.getPersonal1({
                start: start ? (0,format/* default */.Z)(start, "yyyy-MM-dd") : undefined,
                end: end ? (0,format/* default */.Z)(end, "yyyy-MM-dd") : undefined,
                limit: limit
            });
        });
        _this.get = _this.deserializeResponse(function(eventId, calendarId, sourceDetails) {
            var query = {
                sourceDetails: sourceDetails
            };
            return undefined !== calendarId ? _this.api.events.getForCalendar(calendarId, eventId, query) : _this.api.events.get1(eventId, query);
        });
        _this.adjustTravelTime = function(calendarId, eventId, type, duration) {
            var notificationKey = _this.generateUid("adjustTravelTime", "".concat(calendarId, "/").concat(eventId));
            _this.addNotificationKey(notificationKey);
            return _this.api.events.adjustTravelTime(calendarId, eventId, type.key, {
                duration: duration,
                notificationKey: notificationKey
            }, {}).then(function(res) {
                _this.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Requested */.$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Failed */.$K.Failed);
                throw reason;
            });
        };
        _this.adjustConfBuffer = function(calendarId, eventId, duration) {
            var notificationKey = _this.generateUid("adjustConfBuffer", "".concat(calendarId, "/").concat(eventId));
            _this.addNotificationKey(notificationKey);
            return _this.api.events.adjustConferenceBuffer(calendarId, eventId, {
                duration: duration,
                notificationKey: notificationKey
            }, {}).then(function(res) {
                _this.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Requested */.$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Failed */.$K.Failed);
                throw reason;
            });
        };
        _this.adjustPriority = function(calendarId, eventId, priority) {
            var period = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "SINGLE";
            var notificationKey = _this.generateUid("adjustPriority", "".concat(calendarId, "/").concat(eventId));
            _this.addNotificationKey(notificationKey);
            return _this.api.events.adjustPriority(calendarId, eventId, {
                priority: priority,
                period: recurringEventUpdatePeriodToDto(period),
                notificationKey: notificationKey
            }, {}).then(function(res) {
                _this.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Requested */.$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Failed */.$K.Failed);
                throw reason;
            });
        };
        return _this;
    }
    return EventsDomain;
}(types/* TransformDomain */.Zs);
var findNextTemporalThing = function(things) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date(), getBounds = arguments.length > 2 ? arguments[2] : void 0;
    var nextStart;
    return things.reduce(function(nextThing, thing) {
        var ref = (0,_sliced_to_array/* default */.Z)(getBounds(thing), 2), thingStart = ref[0], thingEnd = ref[1];
        if (!nextThing && thingEnd > now || !!thingEnd && thingEnd > now && !!thingStart && !!nextStart && thingStart < nextStart) {
            nextStart = thingStart;
            nextThing = thing;
        }
        return nextThing;
    }, undefined);
};
var findNextUpcomingCalendarEvent = function(events, now) {
    return findNextTemporalThing(events, now, function(param) {
        var startTime = param.startTime, endTime = param.endTime;
        return [
            startTime,
            endTime
        ];
    });
};
var findNextUpcomingEvent = function() {
    var events = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], now = arguments.length > 1 ? arguments[1] : void 0;
    return findNextTemporalThing(events, now, function(param) {
        var eventStart = param.eventStart, eventEnd = param.eventEnd;
        return [
            eventStart,
            eventEnd
        ];
    });
};


/***/ }),

/***/ 28465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ eventStartDateComparator; }
/* harmony export */ });
/* harmony import */ var _utils_sort__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14023);

var eventStartDateComparator = function(a, b) {
    return (0,_utils_sort__WEBPACK_IMPORTED_MODULE_0__/* .dateComparator */ .AG)(a === null || a === void 0 ? void 0 : a.eventStart, b === null || b === void 0 ? void 0 : b.eventStart);
};


/***/ }),

/***/ 77802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TK": function() { return /* binding */ dtoToHabit; },
/* harmony export */   "bk": function() { return /* binding */ habitToDto; }
/* harmony export */ });
/* unused harmony exports dtoToDefenseAggression, defenseAggressionToDto, dtoToTimePolicyType, timePolicyTypeToDto */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26958);
/* harmony import */ var _EventMetaTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90109);
/* harmony import */ var _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70282);
/* harmony import */ var _TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64825);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42230);
/* harmony import */ var _Users_mutators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45983);








var dtoToDefenseAggression = function(dto) {
    return dto;
};
var defenseAggressionToDto = function(value) {
    return value;
};
var dtoToTimePolicyType = function(type) {
    return type;
};
var timePolicyTypeToDto = function(type) {
    return type;
};
var dtoToHabit = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, dto), {
        eventCategory: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_1__/* .Category.get */ .WD.get(dto.eventCategory),
        eventColor: !!dto.eventColor ? _EventMetaTypes__WEBPACK_IMPORTED_MODULE_1__/* .EventColor.get */ .dr.get(dto.eventColor) : _EventMetaTypes__WEBPACK_IMPORTED_MODULE_1__/* .EventColor.Auto */ .dr.Auto,
        recurrence: !!dto.recurrence ? _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__/* .Recurrence.get */ .Vy.get(dto.recurrence) : null,
        idealDay: dto.idealDay,
        snoozeUntil: (0,_types__WEBPACK_IMPORTED_MODULE_3__/* .nullable */ .AG)(dto.snoozeUntil, _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .strToDate */ .z8),
        timesPerPeriod: dto.timesPerPeriod,
        defenseAggression: dtoToDefenseAggression(dto.defenseAggression),
        created: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .strToDate */ .z8)(dto.created),
        updated: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .strToDate */ .z8)(dto.updated),
        eventSubType: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_1__/* .EventSubType.get */ .iN.get(dto.eventSubType),
        timePolicyType: dto.timePolicyType ? dtoToTimePolicyType(dto.timePolicyType) : undefined,
        oneOffPolicy: dto.oneOffPolicy ? (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToTimePolicy */ .G3)(dto.oneOffPolicy) : null
    });
};
var habitToDto = function(habit) {
    var ref, ref1, ref2, ref3;
    var dto = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, habit), {
        eventCategory: (ref = habit.eventCategory) === null || ref === void 0 ? void 0 : ref.toJSON(),
        eventColor: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_1__/* .EventColor.Auto */ .dr.Auto === habit.eventColor ? null : (ref1 = habit.eventColor) === null || ref1 === void 0 ? void 0 : ref1.toJSON(),
        recurrence: habit.recurrence === null ? null : (ref2 = habit.recurrence) === null || ref2 === void 0 ? void 0 : ref2.key,
        idealDay: habit.idealDay,
        snoozeUntil: (0,_types__WEBPACK_IMPORTED_MODULE_3__/* .nullable */ .AG)(habit.snoozeUntil, _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .dateToStr */ .dx),
        timesPerPeriod: habit.timesPerPeriod,
        defenseAggression: defenseAggressionToDto(habit.defenseAggression || "DEFAULT"),
        created: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .dateToStr */ .dx)(habit.created),
        updated: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .dateToStr */ .dx)(habit.updated),
        eventSubType: (ref3 = habit.eventSubType) === null || ref3 === void 0 ? void 0 : ref3.key,
        timePolicyType: habit.timePolicyType ? timePolicyTypeToDto(habit.timePolicyType) : undefined,
        oneOffPolicy: habit.oneOffPolicy ? (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_7__/* .timePolicyToDto */ .aE)(habit.oneOffPolicy) : undefined,
        priority: habit.priority ? (0,_Users_mutators__WEBPACK_IMPORTED_MODULE_4__/* .priorityLevelToDto */ .Uv)(habit.priority) : undefined
    });
    if (habit.oneOffPolicy === null) dto.oneOffPolicy = null;
    return dto;
};


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CK": function() { return /* binding */ DEFENSE_AGGRESSION_ORDER; },
/* harmony export */   "PI": function() { return /* binding */ LEGACY_HABIT_DEFENSIVENESS_COPY; },
/* harmony export */   "T0": function() { return /* binding */ userDefaultHabit; },
/* harmony export */   "TZ": function() { return /* binding */ LEGACY_HABIT_DEFENSIVENESS_ORDER; },
/* harmony export */   "Xs": function() { return /* binding */ DefaultDefendedDescription; },
/* harmony export */   "g4": function() { return /* binding */ DefaultAutoDeclineText; },
/* harmony export */   "wO": function() { return /* binding */ HabitsDomain; },
/* harmony export */   "yd": function() { return /* binding */ DEFENSE_AGGRESSION_META; }
/* harmony export */ });
/* unused harmony exports dtoToHabitTemplate, isHabit, defaultHabit */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71418);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97582);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63496);
/* harmony import */ var _utils_wonka__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60811);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98585);
/* harmony import */ var _EventMetaTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90109);
/* harmony import */ var _Habits_mutators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77802);
/* harmony import */ var _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70282);
/* harmony import */ var _Planner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2399);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42230);


















var dtoToHabitTemplate = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, dto), {
        eventCategory: !!dto.eventCategory ? _EventMetaTypes__WEBPACK_IMPORTED_MODULE_2__/* .Category.get */ .WD.get(dto.eventCategory) : undefined,
        name: dto.name,
        recurrence: !!dto.recurrence ? _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_4__/* .Recurrence.get */ .Vy.get(dto.recurrence) : null
    });
};
var isHabit = function(item) {
    return isHabitPlanner(item);
};
// WARNING BEFORE EDITING: These values are copied from the server, this is what is set by the server when an undefined value is set
// Be careful changing these to make sure they are in sync with the server in /src/main/java/ai/reclaim/server/assist/TaskOrHabit.java
// TODO: Find a way to add this to OpenAPI (ma)
var DefaultAutoDeclineText = "Hi! This is Reclaim, {name}'s virtual assistant. I'm sorry, but {name} has a commitment at this time, and it's one of the last open slots available to get it done. Can you find another time to meet?";
var DefaultDefendedDescription = "Reclaim has blocked this time off for {name} to work on an important commitment. Reclaim defended this time because it's one of the last available in {name}'s schedule. Please find another time to meet with {name}.";
var LEGACY_HABIT_DEFENSIVENESS_COPY = {
    NONE: {
        label: "Always free",
        description: "Habits will always show as free and available time on your calendar."
    },
    LOW: {
        label: "Least defensive",
        description: "Marks the Habit as busy when one slot remains for its minimum duration, or 30m before the Habit is scheduled to begin."
    },
    DEFAULT: {
        label: "More defensive",
        description: "Marks the Habit as busy when two slots remain for its minimum duration, or 60m before the Habit is scheduled to begin."
    },
    HIGH: {
        label: "Most defensive",
        description: "Marks the Habit as busy when one slot remains for its maximum duration, or 24h before the Habit is scheduled to begin."
    },
    MAX: {
        label: "Always busy",
        description: "Habits will always show as busy and unavailable time on your calendar."
    }
};
var DEFENSE_AGGRESSION_META = {
    NONE: {
        label: "Most flexible",
        description: "Always free \uD83C\uDD93 and prefer ideal time over max duration."
    },
    DEFAULT: {
        label: "Let Reclaim decide",
        description: "Automatically choose free \uD83C\uDD93 or busy \uD83D\uDEE1️, duration, and time based on Habit's priority and your overall schedule."
    },
    MAX: {
        label: "Most defensive",
        description: "Always busy \uD83D\uDEE1️ and prefer the max duration over the ideal time."
    }
};
var LEGACY_HABIT_DEFENSIVENESS_ORDER = [
    "NONE",
    "LOW",
    "DEFAULT",
    "HIGH",
    "MAX"
];
var DEFENSE_AGGRESSION_ORDER = [
    "NONE",
    "DEFAULT",
    "MAX"
];
var DailyHabitSubscription = {
    subscriptionType: _client__WEBPACK_IMPORTED_MODULE_1__/* .SubscriptionType.DailyHabit */ .Qe.DailyHabit
};
var HabitsDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(HabitsDomain, TransformDomain);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(HabitsDomain);
    function HabitsDomain() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, HabitsDomain);
        var _this;
        var ref;
        _this = _super.apply(this, arguments);
        _this.resource = "Habit";
        _this.cacheKey = "habits";
        _this.pk = "id";
        _this.serialize = _Habits_mutators__WEBPACK_IMPORTED_MODULE_3__/* .habitToDto */ .bk;
        _this.deserialize = _Habits_mutators__WEBPACK_IMPORTED_MODULE_3__/* .dtoToHabit */ .TK;
        _this.watchWs$ = (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .pipe */ .zG)(((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$(DailyHabitSubscription)) || (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .fromArray */ .nI)([]), (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .filter */ .hX)(function(envelope) {
            return !!envelope.data;
        }), (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .map */ .UI)(function(envelope) {
            return envelope.data;
        }), (0,_utils_wonka__WEBPACK_IMPORTED_MODULE_0__/* .deserialize */ .vB)(_this.deserialize));
        _this.watchAll$ = (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .merge */ .TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .map */ .UI)(function(items) {
            return _this.patchExpectedChanges(items);
        }));
        _this.watchAllWithOptimisticUpdates$ = (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .merge */ .TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .map */ .UI)(function(items) {
            return items;
        }));
        _this.list$$ = function() {
            return (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .fromPromise */ .p4)(_this.list()), (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .map */ .UI)(function(items) {
                return _this.patchExpectedChanges(items);
            }));
        };
        _this.listAndWatch$$ = function() {
            return (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .concat */ .zo)([
                _this.list$$(),
                _this.watchAll$
            ]), (0,_utils_wonka__WEBPACK_IMPORTED_MODULE_0__/* .upsert */ .H)(function(h) {
                return _this.getPk(h);
            }), (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .map */ .UI)(function(items) {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(items);
            }));
        };
        _this.watchId$$ = function(id) {
            return (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .pipe */ .zG)(_this.watchAll$, (0,wonka__WEBPACK_IMPORTED_MODULE_12__/* .map */ .UI)(function(items) {
                return items === null || items === void 0 ? void 0 : items.find(function(i) {
                    return i.id === id;
                });
            }));
        };
        _this.list = _this.deserializeResponse(_this.api.assist.getDailyHabits);
        _this.get = _this.deserializeResponse(function(id) {
            return _this.api.assist.getDailyHabit(id);
        });
        _this.create = _this.deserializeResponse(function(habit) {
            var notificationKey = _this.generateUid("create");
            _this.addNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Pending */ .$K.Pending, true);
            return _this.api.assist.create(_this.serialize(habit), {
                notificationKey: notificationKey
            }).then(function(res) {
                _this.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Requested */ .$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Failed */ .$K.Failed);
                throw reason;
            });
        });
        _this.patch = _this.deserializeResponse(function(habit) {
            var id = habit.id, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(habit, [
                "id"
            ]);
            var notificationKey = _this.generateUid("patch", habit);
            _this.expectChange(notificationKey, id, rest, true);
            return _this.api.assist.patch(id, _this.serialize(rest), {
                notificationKey: notificationKey
            }).then(function(res) {
                _this.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Requested */ .$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.clearExpectedChange(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Failed */ .$K.Failed);
                throw reason;
            });
        });
        _this.delete = function(id) {
            var notificationKey = _this.generateUid("delete", id);
            _this.expectChange(notificationKey, id, {
                deleted: true
            });
            return _this.api.assist.delete1(id, {
                notificationKey: notificationKey
            }).then(function(res) {
                _this.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Requested */ .$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.clearExpectedChange(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Failed */ .$K.Failed);
                throw reason;
            });
        };
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_this);
        _this.getHabitTemplate = _this.typedManageErrors(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(templateKey) {
                var template;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.api.assist.getHabitTemplate({
                                    templateKey: templateKey
                                })
                            ];
                        case 1:
                            template = _state.sent();
                            return [
                                2,
                                dtoToHabitTemplate(template)
                            ];
                    }
                });
            });
            return function(templateKey) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this2 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_this);
        _this.getHabitTemplates = _this.typedManageErrors(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(role, department) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.api.assist.getHabitTemplates({
                                    role: role ? role : null,
                                    department: department || undefined
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent().map(dtoToHabitTemplate)
                            ];
                    }
                });
            });
            return function(role, department) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_this);
        _this.createHabitTemplates = _this.typedManageErrors(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(templates) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this3.api.assist.createHabitTemplates({
                                    templates: templates
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(templates) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    return HabitsDomain;
}(_types__WEBPACK_IMPORTED_MODULE_6__/* .TransformDomain */ .Zs);
var defaultHabit = {
    title: "",
    eventCategory: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_2__/* .PrimaryCategory.SoloWork */ .CU.SoloWork,
    eventColor: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_2__/* .EventColor.Auto */ .dr.Auto,
    enabled: true,
    defenseAggression: "DEFAULT",
    durationMin: 15,
    durationMax: 120,
    idealTime: "09:00:00",
    recurrence: _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_4__/* .Recurrence.Weekly */ .Vy.Weekly,
    alwaysPrivate: false,
    invitees: [],
    index: 0
};
function userDefaultHabit(user) {
    var overrides = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // additionalDescription gets used in google cal, and that requires no line breaks or extra spaces, so ensure its clean here
    if (overrides.additionalDescription) {
        overrides.additionalDescription = overrides.additionalDescription.replace(/(\r\n|\n|\r)/gm, "").replace(/[\t ]+\</g, "<").replace(/\>[\t ]+\</g, "><").replace(/\>[\t ]+$/g, ">");
    }
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, defaultHabit, overrides);
}


/***/ }),

/***/ 57502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C7": function() { return /* binding */ DEFAULT_CLICKUP_RULE; },
  "WD": function() { return /* binding */ DEFAULT_TODOIST_RULE; },
  "so": function() { return /* binding */ INTEGRATIONS_META; },
  "kb": function() { return /* binding */ INTEGRATION_EDITIONS; },
  "Ux": function() { return /* binding */ INTEGRATION_LABELS_META; },
  "Dd": function() { return /* binding */ JIRA_MARKETPLACE_URL; },
  "l3": function() { return /* binding */ LEGACY_INTEGRATION_EDITIONS; },
  "LV": function() { return /* binding */ integrationMetaComparator; }
});

// UNUSED EXPORTS: OAUTH_BASE_URI, SLACK_APP_ID

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/reclaim-api/index.ts + 16 modules
var reclaim_api = __webpack_require__(54517);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/img/gcal-icon.svg
var gcal_icon = __webpack_require__(84603);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/img/integrations/asana-logo.svg
var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgAsanaLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 97 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M75.733 47.358c-11.626 0-21.049 9.423-21.049 21.047 0 11.626 9.423 21.05 21.049 21.05 11.624 0 21.047-9.424 21.047-21.05 0-11.624-9.423-21.047-21.047-21.047zm-54.685.001C9.424 47.36 0 56.781 0 68.406 0 80.03 9.424 89.454 21.048 89.454c11.625 0 21.049-9.423 21.049-21.048 0-11.625-9.424-21.047-21.05-21.047zm48.39-26.312c0 11.625-9.423 21.05-21.047 21.05-11.626 0-21.049-9.425-21.049-21.05C27.342 9.425 36.765 0 48.391 0c11.624 0 21.046 9.424 21.046 21.047z",
    fill: "url(#asana-logo_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("radialGradient", {
    id: "asana-logo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(64.1297 0 0 59.2754 48.39 48.889)"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.6,
    stopColor: "#F95D8F"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.999,
    stopColor: "#F95353"
  })))));
}
/* harmony default export */ var asana_logo = (SvgAsanaLogo);
;// CONCATENATED MODULE: ./src/img/integrations/clickup-icon.svg
var _linearGradient, _linearGradient2, clickup_icon_path, _path2;
function clickup_icon_extends() { clickup_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clickup_icon_extends.apply(this, arguments); }

function SvgClickupIcon(props) {
  return /*#__PURE__*/react.createElement("svg", clickup_icon_extends({
    fill: "none",
    height: 155,
    viewBox: "0 0 130 155",
    width: 130,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/react.createElement("linearGradient", {
    id: "clickup-icon_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4,
    x2: 129.43,
    y1: 137.687,
    y2: 137.687
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#8930fd"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#49ccf9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "clickup-icon_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 3.21,
    x2: 126.84,
    y1: 51.984,
    y2: 51.984
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#ff02f0"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#ffc800"
  }))), clickup_icon_path || (clickup_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M.4 119.12l23.81-18.24C36.86 117.39 50.3 125 65.26 125c14.88 0 27.94-7.52 40.02-23.9l24.15 17.8C112 142.52 90.34 155 65.26 155c-25 0-46.87-12.4-64.86-35.88z",
    fill: "url(#clickup-icon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M65.18 39.84L22.8 76.36 3.21 53.64 65.27.16l61.57 53.52-19.68 22.64z",
    fill: "url(#clickup-icon_svg__b)"
  })));
}
/* harmony default export */ var clickup_icon = (SvgClickupIcon);
;// CONCATENATED MODULE: ./src/img/integrations/google-tasks-icon.svg
var google_tasks_icon_path, _circle, google_tasks_icon_linearGradient, google_tasks_icon_path2, _path3, google_tasks_icon_linearGradient2, _path4, _image, _circle2, _image2, _path5, _path6, _path7, _path8, _path9, _path10, _radialGradient, _circle3;
function google_tasks_icon_extends() { google_tasks_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return google_tasks_icon_extends.apply(this, arguments); }

function SvgGoogleTasksIcon(props) {
  return /*#__PURE__*/react.createElement("svg", google_tasks_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 192 192"
  }, props), google_tasks_icon_path || (google_tasks_icon_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h192v192H0z"
  })), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    fill: "#4285F4",
    cx: 96,
    cy: 96,
    r: 88
  })), google_tasks_icon_linearGradient || (google_tasks_icon_linearGradient = /*#__PURE__*/react.createElement("linearGradient", {
    id: "google-tasks-icon_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 50,
    y1: 98,
    x2: 82,
    y2: 130
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0.02
  }))), google_tasks_icon_path2 || (google_tasks_icon_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#google-tasks-icon_svg__a)",
    d: "M94.73 117.27l-25.46 25.46-32-32 25.46-25.46z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M25.66 122.34l48.68-48.68"
  })), google_tasks_icon_linearGradient2 || (google_tasks_icon_linearGradient2 = /*#__PURE__*/react.createElement("linearGradient", {
    id: "google-tasks-icon_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 110,
    y1: 102,
    x2: 162.13,
    y2: 154.13
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0.02
  }))), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#google-tasks-icon_svg__b)",
    d: "M68.14 143.86l39.39 39.39C150.68 177.6 184 140.69 184 96c0-1.27-.03-2.54-.09-3.8l-32.06-32.06-83.71 83.72z"
  })), _image || (_image = /*#__PURE__*/react.createElement("image", {
    overflow: "visible",
    opacity: 0.2,
    width: 251,
    height: 250,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQIAAAD6CAYAAABK+UmQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAkrdJREFUeNrsve2SI8lxLRgeiarq r5khObyUiXa1v6RdM85PvgBfgs+jq+eZl6AeYH6Oflyu2a6Z1iiTyKE4019VhczwDf+K8IjMBBLV Vd3V3QCJAZAAqqsyw4+fc9wjIoTz7Xw738638+18O9/Ot/PtfDvfzrfz7Xw738638+18O9/Ot/Pt fDvfzje6wfkUnK/xCTc8n87zIDnfztfuDBjnwXS+na/RGSDOg+x8+0SuBz624XEGhzMQnM//pxVD 9zKczsBwBoLzOX/32PiX93hN/xkfeKidQeEMBOfAfxzB/lAgcQaGMxCcz+vG8f0QAf/9CT/zmwcI vDWAgDMgnIHgczuf9x343z+C63hX0HhnYDiDwhkIPvbgPzXwDwX8749899/e4Vr/5kCwfXvPALEE DGdQOAPBR33u3iX414L+96cF+O/u8S/+w6mA8e07gsOdQeEMCGcg+NDn7K7BvxT4vz8e8H2gv/zT +7umX/watwGFB4hv7wgMPSicAeEMBB8FABwL/jsE/u8OBftv25fX/1E+8809/PHf+xdP/r77Y79b B4k/nAoMDwIKZ0A4A8FjAoA++A8E/mrQ/3ZzoN/c/HDv1/fq6mvcDhTfbQQHA4ZT2cIZEM5A8EHP zX0E/5bAb4P+m6OB/k/l2Tj+9cGu7W73Cz0BfzwKFN8fAgcChj9sZQvHmIIHhTMgnIHgUQLAgeDf GPht0P/TwWAfxx9Xfq9/uMPp+PcVMPgKt4KEB4cWGBYYwx+2MIWtLOEMCGcg+CAAsCH7LwV/F/hb gr4NdgnwlH46eD2n6dXJ13sYXhwMlhi/xB4sepDowWEGDJvYwhIonAHhDAQfBAS2AMD24F/O+P90 NOj7gJ8H+N/x/9P0+t6vbxyeY/hPevafBwGjBwgPDmvAsMoWvuuqEwwKW1nCZkDAcwCc//73AACH Mn8b/DXwDwX934X0yzbQcXzT/Z5fC1OY3sK7A8BTPSE/1JO3ezYLnviXDBQKEofAYQ4MG0DhnVjC GRDOQPDgANBp/9+64FfNfyj41wJ/LejbgP96FuiY/Oufl/+mdH3y9Y7xCf53eVWfQXyKc6BYBok1 cIjxR9wMCgdZwr0DAp4D4rP9m98RABay/6nBfzjw24Cvwf7z/PwafuZ+yzbgv3LHb+4ABFd6Yn6c AYQ9/5Gfz0HCg8MSMLSgIGzhZFC4EyCc2cHnDATvwALeBQCWaP88+FN6AeFXy4Hvg/4rF+Q14L9q ghxf+ID/QoHj9s7XGuKlnqCX5QHgCluw+HEVIDx7iMMb9MCwxBaWQeEHPAgIjWy4V0DAMxB89izg dABYz/7rwW9UP03PuoxfA1+CvgY8Yn78QgLdB3mb9fN7uA4AS+BQg37hJAK993KBLdD3biTAX3mA uEYPDj0wGGPoQeGQfDCWcDeGcEwufL7sAM4gcAwEFkzA364DwDh+fST7C+3vg/9o4HOWr0FfAeEK 5oH9PB/ft77BAiA8Xzgrr1cBwL++xR44PEgYQPTgMAeGt2hS4hgo9Cyhlw3HAeHMDj5XILh/FrAB AEz7p/TVLPh72r8U/Ck9mQV+H/QW8IiX4AP9Of+MfOyZHfNg8FTBYtx8zSHu8sl624HChZzANxSc t/i6AwoDCQIIA4cKDPLaA8M2UHiF7x8QPi8wgDMIrLGA+wOAefDnXJ+eLgY/pquS8dvAlyxvmf2p BrwFO6YLBwoGAE8JeTpmsN8OBBb05UAFBv8exD2WYxkg3sbbwhLkc68dc7hBzxjWQKHKhze4zhJ+ xE2AcNA/OLODTxUIjoDACTKg+ACnAYDX/p76Yw7+n60Ev8/6feA/z8/TE3reBj2/Rvdcgx81+Pnx if2NV/nAdPr1hrEG/M3OZX4X/A4k7LUHh3hdmUPLGOagYMYjgYL3FDxL2AIIBQwYEP6EZ3bweQEB 3DsLuP51aQLyVYBTAICyv9f8S5mfgt+oPgX/0yeXGvhPmc7bc8rw5Tg/12DHHX/3slD/q/y+C3zs JUF+P8yBAcI4H9zgAaC+fxv1eD5mINEAhHtOwOAZQ88WDBS8fFhiCXcGhE1y4fMFA/i0Ae0QCKx4 AasyoK0CHAIAr/0t+4vLXzV/H/zPcvAnDX7K+H3gI140QU/gcMWgIQDAnws7Jw808O39S3dsszTQ QL9t2YEdL6Bhr/P7a+BgwOAZAz1/e30IFJZYwlw2eECYewi17NgAwkns4KhUwDMQfPRSYJ0F/OOi DJAqQO8BrAJAQ/2lnGcAsBj8eFECn/+Kqxy8OZgvmRW0Qe+DHS9MDhgYTA4UhvL8YqM8ABjwtnk9 6QkdGnbAoHCrge8BogcHBQZwYGDAMAeFW+xZAry6bbyEuwDCu7GDTxsM4AwCHgSWWcAxABAJ8ATW AMBnf6b9KT8+XQ5+Du4ryfiXS4E/C/oJLNBLkOvrQv13gwOF7UDQHBgnDXI9rsCwz5/zIGHSAfYa /BkQDBgqKOTP3UzyHtT3qEpBj/H6At80IFGrD/A6swSosmFZMvgqwwa5cH9SAc9A8OhBYMUQ3MAC GhnwyxezKoB5AEcBoMn+OYhzYKcUogV/yfoLgV+DngL5UoI+B7wP9hrkCgQdMDTgsOkEOzDQYK8A 4V57kMifq+AwFFawBAz7IaQKCq18OMoSDgAC7N42ZcfT2cHn5xvApwMCW/yAu7OA6gPkoD8BAIz+ p4kCvsv+mfZjPn55NPgHaAK/BL0+YsrPLyTI9fmOjl+0siB0IID8WeYSlNuVCcRuEFvg7+W9/LER JOB98FeQoKAWcFgChiVQgBjSknyg46cAwk8ZEKAAwpJcmLOD/9vWRjiZHXxaYABnEKggsMwCnkPv A1AZ8EtnAuLzJQC4gOnqTfT0f5b96fUs+HO0HQ18PZ4fdzuTBhNUP6CTCI0cEKAQFrFwdkd7QsAQ sZUKe3L5XKa3rC8gMY4S+AYAa8Aw5gDvQSECsYMqH+A2/6KOJeRMn+i9HhCGgcBCPAQChhhvuOwI 1sVYAGHODt5dKnw6YACfHQgsSoGtLMB8AA38F5cwjS/jKQBwkRlAyf50XDM/Yogl+HMoIOv6NvB3 9PkdBXIERAto+44CxVDlwa7J+vSokV+OHTrTBgJjAQQOdn4NGtwCFlAYgs/8+TEDw9gBA1DAr4HC SMHfsYSbkah/Ei9hGRDi8CJRl2OtMvRy4Rg7kMoCs4M7g8HH7RvApwECG03BI1JgyQswFrAsA4jy v4reA/ASgAHA0X8KdgaEix2/FzS4LdBxoGMS1PTZmvFDLJl+FvRDDi8K7HynvMpnJUIJ9kEAAIML /gIEByiBkwjAQJCPT/kR5Dkf0+cEBhMkZICYjAUkfp8DX4GBGAO/XgCFPckAPp5/uY4lsJdwBBAi MYNZ2XFNLqyzgyoV+iakTxsM4NMDgbtLgbYiMGcB0/RTbGUABfvruBUAcEePNftzsDPtp+M1+Ich hwVn/Rz8OUSQQkLlwY6BIufRfAwt+HOwc/DzabHjKX/WA0BlBBiPMILJewWOEeTHkQNewSE/t0ch Col0fw58eiT2MFVgiBUQCABaUKAgHpgReJYQ6XG/BAj5jyuSIX/37QVeMxBU/2DYfZFELqyzg2F4 3VQWjkuFTxcM4HMDAV8VmEmBDSxgooBXGfCEnj/dMwh4CYAXSwCg2p99Acn+Fvj02GR+AwZlCJzx 6Zhl+iEyGNjrgUFAM38U6RAMALBjBAfZwDIrKIyggAOBQc72iV4LGIwOFPhxSuiBYbLnowcFYQHj RL/coMcJPOh4SHtlDccAwUzF4eZZkrLjslx4uftZIu+gVBb+i0DA2EErFR4ADM5A8LhAYMUPWASB OQuQzH8LT65AfIAkTCDlIWYewCoA7Grm5+DnYwIEXB2g1zmqm6xP7w2S5fk7lvGJMcSRmQMFd5UD O87+sQACnzOSEM4vKOdy4fxCN+WYgn3S4xTgJOSjPPeMICgoFHCg4M9/IcjzkMjcIHAIaTLJoKBg 8mFSACgsQQFir5/xgADxKt3GqZqK/JkLZggkF2J8rhWHLeygSoXd7qeNYEC3b081EPEMBB8KBFZM wXlVoEqBL8a/xcMsYEefjQICGQwuM9VXEzChBbxKgAIAFQR2g72ujIAAYOiDn1lAIisutoEvjICe R2UIFNRI4UPBzY8S6Dny5Hm0oB9CCBvMwmAAwB+XgDdAcOAA9FvSscwAUgl8A4f8TQWGiYI3KCtI wYFC/tpEx/OZAgl4GEUegL3uAYGxiI6pqUiy4GYnUmJBLhR28DqDwvBlksrCib7BQRPx4weDTwAI lkAgA8BvpTKwZgpaVQB/sSYFakVgiQWYD3DJIKFlQDquQd8AQNozjfcAYNmfCbHR/shMgt8fOPCD Br7JgMxkIwX9FNugp89WSUBvhuDAwAFDAYNDPkFyIKAMoQR86UCg54gCEvqefkYyfAaG5BgBBXQy maABzkyBKwX8etKgr75BSOPUAQIdMw/BAIFkhJcLUYzEyg6kxCilxnWpcMg3+NTBAD4HEFgyBY9L gVoROMQCLKgJAKwKYBm+SIBDAOA+OxhLGKL6BJr1ox7XwCcenkeqJEU9XoAh6mORAvKcAUJi2J2/ nh14AJDoT81xxwCYrNgxCkyKwMTgAGnggA/8Ww0KCkEyvgMFQq2JpUAqvkBlCTXIDwECVxkyIPRy wbMD8w58ZSG+oc+0UmG4yt9Z8A0+BzCAMwgICIxjHsmdFKCsXyoCSeh+uryOxgKqDIC4DQDy+LJg jy74KYroSDEEKfObdDBZMOVDAOU1TtGCHpUVxFJCzGk6OlbQMIQ1b2DNK1AQgMoGICkbYKAwFqAA wRmeng8pFXlAnx1SZQqhyAB5X9mAC/JFQMgBP8Vh8q+9fyB9CFkqcKMSHcNUvIObkDZLhb9mqXAS GNy56QjPQHAvvsBWEPgSlk3B1g+YCAw6KdBUBBZYwFwG5OBO0+BfCwPIMIC7BQBIgwV8jBbkCgoU /Bz4AAYeBgICCmQcKiCUYHfsgKy+6AJfJQJuAAIwIOCglicp1eeVGQggUDBXyaBgoMzAAjsxiHgQ yD8y7TTwRwGEoEEe4yQywQNCBgF6bezAAGGapjk7kIYkYwf0+pBU2O1CWvcNHgwMzkBwvyBQjcG7 gUDrB/RSgCoCXBI8xALSwAE9MAvIQOAkQA4PqgXwZ+mDov1rxpfsnz+Nwgz64BdZQMdRfQPoJAHJ hwwILBtafyAUUOAWg42soFYOOJs3oKDBz8rBaL9nBRS8Hhi4R0CkQpLApWNiGFZQqCwhA4C+NxE4 OEBI7jnAPk0pTl4ujAoUnh2Qd9BLhesbwqvahDRkEKhgIO3JnxsYPGIgOFYh+OYOICCVgZQzv80V SM8o0G+Aa1rkB1yF2EoBrFIgZ/qeBdAxkwF5NOdgvmAAiPzcMv6OGUDKzw0A+P1hF2v2T0PsZIME P71HcmFS8OBgzuCBWnZ0pmG00iJKgc6BAjJjoHus5zsuGYV+YFrAV1nAzMBMwdSZhBzYOfg9E2DG IPS/gEKqsoBKBpUl5BeOMUAO9ClUMDCmwIwgPyzKhTV24KQCdyW+HbmqUMGglhirifgQYPA4JQI8 bjawce7ACSDw5UgB60FATMHeD1iTAjsN/JYF6LEcAcNwwY+owZ01QmYRFPQKAEBgsJPPBJUDLBsq AESsnkEBDn6tRmEQYOAMT+9pwKPJgxjkEV35UBlA9F4BLrACqGwgBScF7HmpFgQxBvU1Z3kDB3uu GT8V34C/xdk+aeB7lkCBHwgY+Dv5vcIQRsLpycBBKgzT1MqFvQAGMYJpmPpSY8yfozJjvIUkax/k 541vgMmbiA8DBo/XL4DHCwIbzMGuWWgrCEyU/Z+3puCiHzCOQyMFpqFof2ICwgIGzvw0+swHMN0/ 0PDS54UBJJEG1GUk1f2BpQNFdygAIMDQBL8DhxgcG6CgZ79BGEA0AIhVEnh50LGCTiL4ZqLkXlvW t54CbxQSGMRk4GAsgAM7cJgLI2hAQbM+swQK3klZAqGAygbAyQCBwEA8BKIBlOUJHNJU5YKCgGcH kzCGUUFgSSqYb3B98yjA4AwE9wECi30CR0FA5goYCJgfcHlRqwIph7tJgVQyf078xQtwLEBlgPgA JA12EuRUL0ANeGocDgP150qwU9BzgDtAkO6d2HoGQeYcZMixwBfw0KDPY1hkgBmGhR1UFqAMAGdg MNcH1SyUx1S8ghSMBQhAVCZQWIFJAuoxUpMw5FMMzgfIcVyrBqgAwM8JAOR1ZQgkGQgwxvz9OEUG BAEGlgr0PMOBsIPqHRgAjAOBgkqFDOdLYGAmolUU7hcMHr9fAI8fBBbMwQcHgavGD2A5oFKgVATy c2EB5C1I5h9IHJMFxZ+NGQAo2AkEctq3TE+zawoA5LhHBYSo8oDjtoKCSAaQgC+eQTULzTeI0eSB AYJEcfDegHYXYpEEyyYBOHnAGd3YgQOAwgp6o9CCHrVKoEyggIIyAWEJQv9VOvBzpI6CBhAo+0/0 SzEzyD9GJUKiyzk17ICBYVKpMJTnJhViHCfzDW4JBPYhX7TdZHMVyES8KxhcXf1V25H7WYvf48fg F+weHxvZDgLsC6yCAFUHwioIPM2BP3kQuMwgMAkA5LHW+QEU4yQF8nEYqCk+A8NISKAAkVN8vqdI 7IECOLMB6olNEuz0mp9nEMg0g2oJ1I1D/44AROB5RdEkA/37QN3DyKGb8QT5PeDXzMkzcCSVDfkA 8O8AYgBCKR9GiVjQUw2MB/wmlChfrBig8wugSgSK0yTPkQVJkp8YuO9IwCFHNBF+AQP6MkjJkI9r z0D+BSYxCnXOtfgFUQGBGA9PXwzEdXJ05/cSdUawECDhxf7BLp+iRKIkI0T+TJJGiywdgKnbQGoi v86sIL8MO365y2c6/+bTEC7TTYCLEG73oyBp/jdzUgjXvEvbq3x/kcKzDBdvniSqLhEYJIbON7Rn pX7mK+pP0ZP1Q/iG5iZQS7uBQWGx3+o47sEAl8IAPgQYwONmA9vMwbVmob460ILAGwcCT+LFqEGv lQAuDSoAsN6PZAEQSAya6Yn+x9YLKCyAqoZUBYiDlA5pQgFNpaMSITgGAFpZQK0Y8ETC2EqGEGvW t2qCgICYixQxqCaiVQ8QKhuIQeYceDmAcFgYmF/gJELjE1RZAFpOTOYVFLNQXidXIeDPM1NQBlBY AkzCEpQFmEeAygiopoNZJoT8FhIzsM8llgaVHaSJfQT2DSaWCqQcqCuRZULxDfLxUY/Fm66iIOXF o8xgsenIT1TKYPAR+QXwqYKA7xNoQeB1ywQuLgarDKSc5b0pKOyA/ADxAnC4YNPPpEAe9jvUwOfj eWQx/Y/M7VUGUJALCIhE6AFAgEFXChXqn7/nqwVFMqDM/Y3BqgfqDbBUUG8gCDCUnoKoAIC9WbjW R2CB78xCUHnARqEAQiqVBJEIQQKZ/kGRBGr6KXiUXgGuFDTlRPL+1QdwgEALFxBbYEmQgzspGBAo JJUDBAIMBsz9YgMM4kOYVBimKRE+SIVBSowCBqCSYTsY8FwGBoPhb/8j0dyEftbix+gXDI/XF/jz siQYX8FXrkKQ0q943cBpuox4tQwCVCKky0qewLABBMQURHoywCBgkMMto0PMwwBpJjC5gPkx8OsY aX2tId+pdTATTnoP5DM014g3HgB5zPGXv2efy8cg5PfwgnYczUFGry8AeKeS/Bz1Z9Hnw8Cfpe9E knQ0KTHtMgYw2+DiJvFl+jf45+THnBLpGiP/HpFmMNDvMYDseiJroWVCk/9dvWO950gCXiSAQiPR +zEoXaeFCYDlT2Rjkxg6LTPEn+HvcvvOYMsYAYgK559pvgcrGqA2SRAZEEk8kLCh16pvtCQKbFsA SsMjfY5fJ9ZF3NjEnyOfJCb5CUGaOQJZNoFWiKHonmRbuKzuso6bskIguGGMhR0vlVBF08UFhD0v y3AbWGM8eZazD4Rn+bJd8/6Pz7Lu3Ifw+nn+91/ly/Rl/jdu8v1/hl9M/x/8ldTP7v8M4df/G8J/ fKHj+c/6+Cs3zn9n4/+DJml43GzgmyPmoJUJZSrxdEMBXucO9H0CjTHo5MAMBNQUTIPQfZ4jQI95 NCVuHiDqP+6YCZA8kJLgrrKAHFw47YIxAl7UTz0CNQ8DBw4di2wi8mhUI5FfKxMAZQKhzEXgFQIi zyUoDUUpWh9BjL5/wGf/ts34+FVyJqGTCr1RqMZi8lUEqyAQO2CZYL0DYj3KMTISOOtzpWGibmN+ zQwh8SOSfFApIGVEkwu8asso7IDWPKGKQRiFASRmBAl2o7EG0gTkGxA7MBPRpAKXF0cpOR5mBvnC a9ORtSMPF79IMmvxiHn4EUiE4XFLgj/L81+/zJIAWBJM0/+Eag6CSgLQCsHLWCcQEQCQD7A/HQTy I5uCOavRLWcgAYE0cvbnzJuSZPucofOA5OxOk+qFBVDGHuQ4ZWdURiCZmbYAUobAZq09p/XI+bvM DOjfAHkUdkFMACXjA1+3HQNLYCYwSCamR5Yd7EsIayCGQOUJztgZgJBBiNkCfZ7vxD4449f3mRlw BqefIYAk349iMaBk+sAMgRkESn1TWAIzCGILBHaon6dHRihmF1xoZCqA8hiECSA/5UZlye4JhBEw SUD+M1HsCaA/k0ExEQhSEQb1OEUvfZZc4l3gSiTZNQPhDJ2+SZjBNMJEZ3CBGdBkpcvLIScdOk10 +d4ATUWF2+fhaf7EW3yZf/6XIbzI3339KtBzxB+lQIs/hL/fPQt/Hr+A8H/8KVRWQAzg30LLCv5V j384VrD78OxjaeHRuST4JvyH+gJhsUw47f8a/SzCabyh3LAAAnAcBCjpZ0YwsFk40ooX+QkFVw4+ pEnCieTBQHSYApFURE5UO/ECgOQCfYYqATv2AYJ8lj1HqhrwSJbA5fIiVQUoqNn9J4+BnXOtEtRH CkAAazJKUdQ6RH5XKwhsHAKXF0ErBEzQa8mwdBquJB8oXgGabQiyQFItIzJfF4NQXyMtiED/Kq9O xI1CiQ9nNARnFNoSxxLJSRYxZBnBDCAqMESOZQKPJK8TywpkJURdRvyZrFgSJJUKQY8Hfo3Sf5lx KDKtormPUxyBFBRVFDIzyL9UHhS7y7CbJhx3+flIx3bh8mIMt3sQB4aS+lUmozcEp1dcNqGp6jRh CjMcUHmaKwm/fBHCX15lGPwHHMd/5w1wqJIQeDHUzGZ/+x0IM/g3rQpsriJ8coxghQ386wIbgJkk 6H2BcfwhVnMQ4KvpIvIy48/fRJtFSJW8p08Gqvlzww/3CcAVT/A5BgKs+1nPBzUFKcCT+AH8mtsE L2TDP8y6fsigmi40i19UFpCfg2Z5QM30quNN/+dfIyiTQO5CiuotCFMQXW+vyWfgwOG9w/RnCbBE yeRyXdGyPQXUwAsYiC8Q+fuBgU3Zgd7tOH1Osjp5CPx96WGMUX6+YwRonkGQwA0ggCUOZfEEVKMY S6BHUNzioDYGANY1ycei+gLkHxjAobID+jVk0TRmDWSTyLMgnkJk8ON/mH1GslFIRFHxEoHngycB A/EMsHgGpFyIJQR+rp7B3raAyT/+Kr95uwtPwnW4gRfyD2YwiNe/QvILAH614Be8FGbLzMBYgfcL jBX8r54ZwKcEBKdLAjontyIJzBdIWf+bL4D4c0iXP0YzBy/ZB6Cw2EWKV55F6CYQZQU6ULNQopW/ djLb7zAI+MoAKcRALYM7yfI5sBPNR6THTOkZHPAi8tK6FNzhIjKlp8AOF2YUErDkoU0BzKDAwa1y gI5FNQ/5zpKBH1kG8OcKoHDg7yTw2Q0TPyII+1CgGLRjSCRBqEHO042Y1of++CASIdh7+v1YXwMD CoMEBz6HWnBSgQ29iAI8ymJAM72AhMoQmAGCshlZVAGEnTu5wKgA5TPFQJTTkZjP8wxNzrnceCE1 CzYRRSpQwFNXuO270sgEBgNaX4ZQOEsEWgrewCCLvKvpAvdBZAlvRZ3B4BmMnXn4iu0Vkwgxvq0S gcDgbhLhk24oCgclwUtXKuT5A+YLBJUEOR/c2MIi1Iley4Q2lbiZQKRtwzaLcGYMQgcCMGY0iYNU BgI1/jAT4OAjcMiXNRIoAFN7DloyATnoWRezw59HWeIMLvpdDENQw5C/S8HLFUH+ThRzMcpaBagZ VMuGoXQVarZkHysUKSAfFZddwVeaiWT6MpReQuSDK9eg+FZMi/mDvGWBvkF0Xz6E1kPAPcvsVVbT UKYiSPkQtXyoWoNLhaQl1P+npiFZ6FAZBncx2d/o5IKyA56OLVMeBChYEhC0JPk7yTfgVqkkHCax XzAGahWduPMrZ3yaIpL/lUYm5GM7mu+4I6AIeJl/2/0l7WTP7gFy78mNNHLQvw8vvoDx1W38avc0 /ZjBAMdf0LhkiVCbje5FIjx4k9HwuNgArJYKl9uH5+Zgpu80ByDuniRtFc469DLEy4mkwW6QjkEc eGYwi/uYAYHKgh0IYAEBlQOTBnu4EPNOwCCPSZEFLAXye2waRtrmiCVB/nlSHuTPa3lPGQJtccTP +XMqEcBnf2EGwhCAy4FS+uMMv3OZXpgDkqkZ1BgM0TMAaI/F43ej98og9HvMBmSqk0gMgZ3+e1AN xsByXr4rZcJiNur7WpZkk0MdCak0iluocgGloikZX8qLDIbKElDgj6GJcFV6EdnWiKLomdhQki/M gNsSdq2BmCZxRljpJaZrE1m+001XVgROUWYe3vA/PrJECG+eB8KZVYnwf2VW8P+GRyURPhAjWDUI 5Rzkc+VbiEP4a6Clx0P4KfCCo9o+jLrOIL74acUcfBvx8oKnEvMEImsbto5BkgLECqagxmBQOeBB QGSBgsBOMj3Ko9Dv/DztVAoMUhEQp16oPQ4SwMm0vTACZgOgwcWfkcVJZNVBfo4WYBwMosFFbov7 zoaizD5ULS1NwaWJHYNOSTYWcMqAQrcTsqK3uIMojYyFJWjjMpcJUb8oHYdkFLJhyOQiyWdkLTVZ 5pjmFXAL8YRqDlrvgVUn+BiKBLGeAsGKQYBCPAU+QeYbEAgkMQ1DBQNqhxi50FqZQQ7yOPH8MGYG 9NvtLpHNQ2TXhlqaMI+fzAzyL3RLf/oFPn0S4PqG3VT6y3ip+y+zQHiZfsZ91MOvAk5/eWVL5Emg 5Z9F45lbkMOfqBSmrOD3rqT44W67D8MG+rkEoZUEi1UCkQThVy+CSYIv+ZoHXmcQpQEW6CIJSOy1 QkBSYNSJQn4NQesYJDAIpTogngCBAE8SmIOA0+9ogKA+Am1oKHqem3JYKpD2l8CP3ABEI9hajUvA o5TlGgCQLK50OUQNbgkKC37+vEoAC3ossoB5My4DwBYwQPdM5xTwwbJCkc03EHAIqJMXeDsWkHdQ Sw3SRyCli1SrBiQPciTKRKmpliDFUJSKiYKABL0CgjYYMQsQIsCBL3s/qFcg/+gcDFKRCSS2WCbE ifXjQPtPJScRuAqcB9C0C5f5N75NrpKQweHazs+zfH/zJNGOWKdLBB8HJhEoUf4zvk+JsPuwbKBp I26qBDdNlaCVBJj+Kk1DhMalcxAzS9u3MwmnurQYyQLPBvKtziBMmSkWEGAGUD2BAgLUFzAxbW+A IXENnsxDkwrsE+TBTZ8bhObz5oZSu5cmIvUJpNY/BwCeS8hBUeYaiH3fBr/QczHVatD7+p9wilU2 gNAewtBvcGIDDyXoCwsQeNDZDfIvUHOwFDIdKKA0EBlLSOI4KCtgQODeg4l3RqHmIcaApIZikI1b pIdJ2FDC8rcqNWCpEFG6ltRhDOIRroABUmM2LbFGs7d23Cgx8eTMCQfqIkrM3YgJ4MgTOrWXOkuE TCr4R+HTPeINCiNgvyA/vvkSviLeaiXF9IIlgrFZMry/yez2+zy+wxML6MfBCuKHZQOdQRiqJAgs CWT1YXnj74JIgrdOEtyALDP2ituHafsxXl6sMweJdl4kW1WoTiBSENA+AekcRG4amtQTyI+Y7yD+ QI7hHfkBOeXRxnsXkHi/LSoVXjAIlHZhKifSypniEwC1JgduF77gzRFRP0ObGgX5XvEEQBqOZNhB ZSAY5Li+1mNWKqT3tBGoeAa7YEDkfQTxCnagHkNtNQ7aZly8id5/2C39fLDPYWVLVuXwvy9C9Tuk WkJgSX9jkPOk54iOgTEvO19UocnnCvQ9+V4+9/pv0PtcnaFHqD+DDV0H2EXuKZBH7RTlNSW4n0PG RWGKO9mNiiQlJZRLXbCGd7aaRILKBrhXuvr1TzzTlapYVM0i2S/7Z/zErJYMb0pwMr5/W3fmLuP/ e5gnTHwvTUa7D88G9Ha0cahWCdYkwTTuiy9wOdH4GNUX0FWGJisTkhcwcJMQxnFI3CXIMwm1ZRjn coAGekgXxhKK+ccDPOqxpKU9HtxsPJIbJU00ygKk3CfGHuiCpdJcVJcv554AtuHrMV2JSD2AGGyK sRpsRR5olmffDDXjQ2gWLcVtY6n1CJIumRpMHgSbrlwYAtcPZKahzIEM2toj7Ugx+OqBzFxMUDqX ZElm6R0UP8CqINwNoP6ASIQovYihmISyUgJ3FaGmbDEODjAD/n157jOxAZq7xSwhcEMpvUfMkWQC 78U20OTHIRBL2Cf5o8gvoOqUSYTh+VVKbwIsSQRqNDJWcHPzR7kAT8LCdOVPixHcmQ0ExwaEUoVg jUN1IxK/3mAtFcoyY1DXGbQlxU0OoCwtxvP5k2SCZPMFUDOFNA9pec+BgAJDBQiYvUdrmAQ0FkDA IdUC0NdNJSAYuITaT2BGI+hEIZxndgSXrbFkeMnM/FoqCcIQoLQL1wzf9RRsuUt1gH8meqaAjhFU RiIMQJlK/zcgtgwBjd0oW0BlAsYOQhC2Jf0VdEyZlp1n/Q6WcwyS/ZU59MxAqkF0vYnljZTraUDo scimsXSV6oxT3m+SG9TKeOLFa1D3vXxKROUWZMm7G2WpV8Jaib3mccs7bDtWwDMN3o0VfMyM4C5s IPCEohBeB6ZaGUJT+ls+2UBrDeQTfct6GZ/SXIMLrhhI05C0DxdfgOf6ECD0FQKCfhnckYOPqwZl IAF6Y3AJBIi6KniAlfMiz0PQqcQ7CFG9APag+d+wcp4GVrROvrofonoF4ExCyf7VE1A5jN4bgNYj qB4AVHBmu6n3BhbIALgFSupIdI9o+6CVhUq4j6YyBMm9YiTGYJONgP9r2zVPymqSrYGmf1+SEmJw pcLgqgPyaF5aeV9XT2iZgU7QZmZAi0lNaAyBvErU3446zsg8ZD+A+5N4CToyD8k2mPsFl/m+JwX5 liRCuLkl3OqrCLQmy7MAv3wNi8ahsQKqlP3hJFZw76ZhfExswPYoNDYgkuC1GoRvmXLxPgQsCa54 U9Ky8nDWbazfDvkCUiEo6wva2oK8yIh6AZwxNINwqc9JhEUQQA8alCZqNrKMx/5A8BpZOgkdK2BG ErDtKMReo1vm99kZ1zO5TAsur2NlEeB7BoZ5bwFoGzIO/jMQPLuA2DANdGyhege78vtB0yFpf0Nh RTpZaoEdKHPgz8Vy3u18C3swoBaPYM4M7DpN5ZiuAyHgrv6Q+US8IRWtQ4myQC2Pl84v4JL05bWO twswVsrGNfW05HFK7JUjgLyt9GKGvMwKqJz48sOzgt2jYgNdB6EYhH/mcuBXxSDMKDu+pKUo4Rk+ h5FWo2NJMHb9AioNkiw3zgxgGKh7SJiAlJGJ/pWuwMjUO4MBfQbSrDrQyIEeBIpvQEFNnoF1FFaj DTnzg/QLGAswVuCacrAGpTbiBO2/1x4B9J2D9a5polCAuijejAFsLB9CWznQYoRVFyRJl0qDrya4 7kP9AmoWM18DC2Mgz2DSGQNJPBAuL/Z/X/+3Ba0YaPHEiIyss27MgBoRrJqgHkaQiYzchJwvRWYI mSVQU2LiyYvEDphMqF9ASeJC/AIUH8T6C6ikuCe1whJBqgjEUoOgIvdL4qy3YKmcqL1FH5AVxIcF gLuxgWoQvuZZXMQGZC+CG5Dtya+4MkAtn+zgapWAZ85eyHbkvl/A9iWovkC+89JiVCHgeay8aIe1 BSNXC/oSYXIggBczEICaxRgETL+qgWiLfwTV/o4FCCi0mbNmYMu0sJTxQ51gJADSZ/Ga4Q1swOYa HL277+OcMZR/DxyzwP53jNj/rqjMAJq/W86JeA4yscqmWjtPBaUpSxmCeAfgWERlBvXaWBcol3AV 8IUlqE8Qeb1Ivv40DobiIUQuNdOGNWXfikE3tqFGJ2OeropA7LRUEXgj3SfMYmn8tqzgH4J5YY+F FeweVhbcjQ0QavZsgHoGmHKpN6CSgBuHpIWYqgQ3POFIlh6XOQXWL0BNQ9j7AtIwNEiZMAwyGcj6 B3hegE4truW7OpiwBQEsxqKtJFSMPZ3TP6jZN4AFSGUBtlyZeQC6LFlp33WZEcsqxTVDgvMGwLwA vwGqH0dwOpJD9Q1C6SBwTMCeg+80rCxAJyAsMAQof4P+T9iBsgYIk72B0j5pXoHYCfpTJfsHXQNF fj8s/oFOxkbpbuL6A09zmFjSS68j5frMChJtpR6ZEUizEW8jQ54CkkSYZAk73JFfQFdaug65ijBw FzrvmYltbwF1fvw8v3cNSx2Hj4UVxMfMBmy3Yq7N0nJk48soW5UTK9iDbVF+mUZoqgQ7vxux9Qss +QKo6A8yGYgnEAVe/osCO5ongDXTl9r1AghgKxGoVj5wvbwsQKIZ0PQ+Og8ASi//0Pf3t1kWlrU9 tPJCDTqdKVjvYeNd0UW/p7MBsS6m2jCMxnNA9S7Q/x2FMaCb+9BVG7Tpqh6rlQWsvoF0ZHaNXdSx mRp/oVZyAr8nss58gYmvDTMFaiQjf4jXk4yyIlVMg/lIvFw9T2HX3avcndgnWYjhSntX8pjsewtm rOCXK6yAKgibWMHjZwSn/aIb2AD1bhY28DzwyvdNzwAbhBcRR6VpUQzCBGrwUP8+G4VQLyBf5B2z Abq4MUy0tgAtPsrz+3lx0QRGLwell8wAeAXiMtiU5juWICWy2kvAq/04aowCAoV2Y2gm81jXYHRZ H5xXML+Dm0eAfs1yKAIfayLeer2wNwh6ZLepi4iuigB9bwHYa/MGkih3mxuB4udD9Tyc/zHJzELu KyiGA3/UJiZKqpe1mj0z4NYD9QJk6iN3X8gcySCdGagVDl5qfaLeRvILkvgFJO0jih8QuceQl5hN ssFtrSLcZgi45HYCZgVXI4Y9lxThWU5Ob9PrZVawo7aEBVawuYLwMIuXPLBZuCQL1voG/hqWmod4 jQEtF6LsoJfvz3jArBqE3C5Ouw/t80UE3V9gx5IgsSTgfQZy5mdTcKAVTJA1JEgWkXms4mrzCkSx ZhrOPHFXAcLq7KpfCwjUuj7UTFgzPNTsCqHubBRsdWIohtoyADTBX8009KXCKhes6Rg2DKJWj2KZ wwRuNpKGnXXzckihEx8298AbiCCTjYIR+WQFTfASAUsRFAK6CqHe52AQtJYockTxQQxBhpoUdJkD xhNaT5HBQgNfQIICXgCBrMKYJQJPDicm0EsEei6Ajco+2TjESczFCHucrnKSur105UTfZITECsLw 3771WCoI3zMr+A5kQtLSHISHkwfx/csC1ULMBmxZcmMDtZWYnlnz0Lxc+JZ3KiZKxtTMGYS2D4Hc LyLNN6Ytyes2ZNrXz01DKg9KiUnXCygVArC5AC7AafZgYjrK8wmYASyCgBpbaK221RD0ZT9omnQK MNiCpovUH42uC2OQWYnNZ0E/b6yhzGIsACJLmcX53d6zJdKbnwlB1x30FQ7daLXKD3S/c2iqIcp+ 2rImlr8XB2dU2spJ3JxkUgJt+jWf/yoTXCPTrjaDJWZxoGYk7zfJUoBeTyoBkReaLQvLgjYXpbpv pexdoQahk5/FOCRuQJbR1QC+nNg2GV3nX+Pn2g/Ttx5/LfK4JMYyB2ElseKjZQRwEhvgRUdCwwak b+BPzAbCSJWCvwobQGsnFjaQpkstF15nNrATNpBP/gUtZms9A+4xTYzqvKMQyYWYmYFIAt6FSPYj CLrSMPKy4ToLEWXmoDjUvFSYLipizUJSGtQAR1cmlCkrXQUAayCYF+BYQFnlJ/g9C3oG4LKny/za RqzZHsuk4VD3LlgrHcKha9mONkSXuC1f23QkQM8UbLnkwhJahhBcE5L9XF1pMPh3NM2XJiL3tpcJ ugm8mZRSNURy7IKWCW2hFC0rCnPgliNaClFMQ9pjjlZBJO3oJQKhQYojrXjCe1SZ9zRNvJpEZDag j5fTjZQTSbI+zT/09hJWWUGZkNT2FXy/ODPxo2wx3sIG5ObZAKGjn1hU2MDzlg3wSV5hA7JPYTUI ZVMSQnPuHSMQEDAAWykoyRwAXeYLlOpXc1DWDNAGIWIQpWPQlbyqMVhBYNeVAT0IDFA7CqM7FjvT rWMAllVdRvYZ37J9QL86ETSAIuXx7jP9vcRUDPXfsp9TXxf2ABDa6kbHEmwGJc4Ygi7H7l8P9VzU 8wKuxbkyAy3HGkMLcpd1H3RFZ+325PewVHsG32DExwpDRN3BSp4Ht7W9POLQG4cXRCj6cuIWVlAm JH3VttXPWMEm0xAeqTQ4cCvrDfibzSlo+wYKtHDvwK0AQGEDobIB6yBE10SE3iCMKgPoIusyYUUS 2BZlUDYstV2JxHVOSkV1IRKSAwF1OrFOJZb1B2qv/zII+Nct5Z8fAy8B9P0akLrYZ205RmcsQhf0 YQEY4AAQwIHPYV0UxQODgUL93ct7tgeJTlmCGRjUasbgJQQ44MRFMEB7Xvo0ZPl2V1XQpeKkfwMG bfKS48BbUvO1M4nAr0U6xLorFc1Hkl2u+T7I+hDGOq3jEC9Gnl4iFawLSVg8G3ZeQbBuQ0p8ahp2 MxN9wvz9iQn3w0mD02RBVzIcx/+nLjoSXgSbZhzCVZAuQl8pIG8gv3dF8kHZAKFumMAoW1JQ4Lnx guYDdYeJNNClxWmJ8QQmCXiqcSz7BwgLiAoGTP95QZHIewRoCWrw7b6a4bVngL8vG3hiAwKxZQZY dXvJtOyAlRmFoIFUJYLRf3DzCIIzAL0ZCCt6AE/IHtAtUAArDjb049NK/74VEcFmKFa5YObjbGSj 615wnYSF/8saifbDZMtnISIsC8pMSJCZCIkbGGUiY5JmQ17hMOmshMRLqdIjb9sSeV8sbjSiR8IC mZhEvcacgIJjoXmokJyIsr77LuFVBoNb6gO5wKUKAi+bNnyNSecg+JmJIpOXTMOPShpsNwmDlgzt E7YEGbGBn/Fr6yK0+/44G0DHBlgS7KJtJNrSvyFKf2ndgUi37Comky4VPsjqwFCyv5QJdSMRXxGo un+whUgaExDr58JMBhgTkFp9ZQHYGnWoC5c2TUS9FPCpHEtqb/wEsRxg7d5NVNKfUd1DmDcy+XsM tQzoGQLY3wO1OlABMcwNRmx7H6qnUqZuSw+DsQE577b6E5RNYFjSaa/InPXh/Di5TbJmpWx5LztZ xaRb2HOiWWMFNDtx0tmJecxK92vPCvzMxBD69Qo+hDyI718WhNBoIp1cRJpJHNWsoagBQxcd4Y1L yRtIcmJn3oBjA/4i8cXjlYDTIG3EA28wSl0FhO7aVhxnqwqjTkEOAgaiN20lIXOZUXYECmXdQR6U ViJ0IFCpL0BHhUuvgAYLmhfgWIArI2IffLgQ/BKsPuit7IbQ3sNhl6D9fPmdPDj0oBB6YOoAofZG oK8ugKtMhDrzsgODtrFKvRiZyYnuGJTmsBBMrslO1CIfBCSiLhVXqwj6Otbjspu1+ATkLQVuT5Wt 54bCBvZuxqh6BTiyhCVWwHPQeNzWacoS+NJgJHJ4ZTJSM0X54eXB7r3JAmIDL4NbhizMJhdJA9E1 L02OSReHZHOQ7k/5NWkw6gDuKwWFDURlA1RRkB0sIq03wqVDrgQkyRyQbKfi6KoEK5IgSNeh+AqD 7Kypg1CnFZdmoVbvqyeApfsO+klFpa3YpABaH0EI8wlGjv6DK+6jy/TtMiSt63/Xqwxtk5HuRlpp A4a6wqkdx7YAYb8idtRfjESUZUM0MWFY/qzvUagNTOa983pmZek06UQuskCXRqN1EnnhVFICyL0E ROh5hcSkXQaJV0trjidZTEVZQdQKgjQZyZZ6uKO+lSwRdiNXEKjjgFdCgz1SIrvmZY4vs9ylhY6v +Ay2DUZf6Z+q8qBZzuyjkgZHZEFoZYG/9SZhZQO33KXFqMorD9VpxkGZQK0ULLEBXoiGTULboBQW KaF7rjIgAM4lQXGqnTmIpScgdhODXNBDN7OwBHsMNdXGCgLYsQDfIFQYQKjZH0KT6Ut7jd0XEvcp d90+rdw9a6gehbEERxQ6FoNNL4LujDSrSBxiBrEvyyobM+mgczqsJ0HZm11Tvb58bTHGsl/kzDgM yh718QArEB+TupJuta+AmOoIsjiOsgJOZLcNMzhmGobGNHx4eRA/pCywTkJ+XkxCQsYvgpUM0xNj BDqngEzfrMUo+MNOdvBGfWwrBaYlh2g7C0ceSEP0FNBcYhkU6IIcdIBVSWADDL0vAF3fP4SFzI+x Lcd5ECjNQE4KmBlYTMRmqrEBAGt6A4Am+PvADyG8ExKEdWBwoLAMCJ2PwRUGMOOz+AZdO/UyGIAv O5rk0ioD2J4KthEsST4LdjZlVSKoVLASo/SIyN6UDP69nwRaaVJ/IDo/agA3p2UAk6l+DoLMicny lhfYbUuJIg++1kTo5x+EhfkHv//Y+giOVwvWOgm9SSjjupYMi/biR1BN5i+KBv7AiwKqN6BojuIF SHb3F7QyAxlIkeHdtvUSMNApvpxRonyG989hEPCTaJpB2hiD0JTjYgsCy41DzvUvsqFnAG3298G/ GPjvKgGXgcEAISwDwjI7wNp/MJ9TMQeDbiJVw66qgz+U7eULQCgbKNd53SDkcRJki/p1ViD/LntM cSQ3EZol8geVqyxHt5QSxTT0nYbrPQWnMvH3BwRH/IH1asFWWSAoOjYmobR4DlAXHdmLg+tBoakU JF0qzF3MwgZ4lUzJ8potzCA0wwnRWIJsS2YGlJpVdSDOne/lwbwJBOYsYCYBZgAwC9hjAwjW75uB YR0QyqqpPTsIYSYV+opD08jULtLSgG7PwhYkgrVrR93AFdCzPlTjUPdyZFYAM1YQglSZAncpt0vK lW5DBwgsW00mLJiGzVVIdV3DVXmwWj14dIwA700W+HkFgqKdLMgnl1AX6U7T1VmfKSUb6Mr5gG9R vXaR1eec/UFXDkZfgkLHEsDc6RLwRRJAW/aCPvD7RqEy0+4YCLRZ1Zz/IwBwQsDfBSQOMYUOEFQy 1L+jQQ0nFTwYYG0+aiUDgJNZTVkRtROxkQjBNmQtu0dJmTjaTkoK9rbHpGcFChwNm1SPyYB/qIln MHaq8pTkKg8lLSXKznYyjsk0DOF5aDsN6eblwUL1YLW56P58gvjYZEE1uW8ZRRlNr1QWHDAJs2SI Mw1Xng9M7Su1EzZg3gCzgVipJsZYB5H4AZb5yxx77LNTWzEoS4w1wYLY0981EHBSYEEGHAWAteC9 oz1w9OeGsAgIDTvopcISGAA0BiKUDkk1UmvJFaFWXTqJUNZcFBanW7mLozcEt8X7KiuIfdLQa6ul aFQGyHKUf6yVEum+ZBpeONNwf0QedC3Hs0T6MPLgHoHgkCwIp8sCRk8aT3sQVLWGDUHd3iQsbCAs sYFUpIFoQwUIaSSSDILYsgGmlrHVm9D0xK9JgpL90ZuEULV+CYJ1ECglwSMsYCVQ79MmWPsZBwGh AQPPDraBgVZSZEuzvuW57vvoS7ANKzP2pgYvLUFUvJ6ozV06l6BhBTZu1COIai7bztTRSYLGNBwZ EHa7CGYaUsLi9VRIzl4NMpZX5MHB6sHR5qIPKw22/yI6tyB0cwu8LKAmor5aUNHTViASViBoe1ub OQbX7hlqRrAAbZgBXVW+oCCswAEAs0LPBupqO1EdZi8J4gFJAG5Cjc2sAysTYtsotB0EDrIAH5T3 5Q9usAfWAcFtyR4a72AdDBTooEohnbDUTKUGN1MTOykGHpybygIW+QB23SE4z8eCHkvZuQa6TF1v TUOZcS2lxNY0NHng5x8Elq67VXkwrx708mDL3IMPzgg20BK3AEmdaRjcugN1YVKTBSE8DV4WyGpV k5ZoBkZfkQljRKNn+aIUetiUDCtLCIb+hfJZpUAHifcGqvZ03+3c602SoJQJ65yBBU9gIwgcAYCT U/xWXXDgx6zOYZixg2UwMBvBVxOcj1IlFWDXlYn96s+tcVgZG0ZbPVpZAb2nj6D63xKDSxT8+UZu 6r+LVRbwGDBvoOk0FHlwSWvfUDkxj2kvDyjxiS/WygNfRgyzMuIxJn43n+ABPIIFfyDUKcf1yN8V 19TWJFysFhi96mUByiIQA++hOcadbqLLaO1kQcC5Z1DAwbYcs7kAMXQGUzER19hAs9nIuiTozMHa J9BsUXY6CGwCgHfRBxu/C8fYwREwCP26CXPzEPoZkrWF2VURYAm8wfs5NjaCk45aNjTvoAQzcDZo ZWbo5EFpKBL/arfzRvaksnbS6oGBgSY87Sv4WSMPZO7BzCd44DLiA5mF2/2BcvsiqDTI1OlZCIvV gkSSwFjBPspkP7sYztThfQNdKTH4Cw8li6BlFKyGYHGd0Q0o6NhAQ/+7luG5JIgzX6AZ9BDCSSDQ s4DNHP4hdMHKW6eAwQLgzPwCnJUaoZYZI7qpz3odYZkV1GtqRmBJBI4xcqKIoOsqtElE2OCkDHOM tdMwqTyo1QOTBwwAVj3I47lpLkIvD2qCPO4TPMry4aEVVg/7A+1yZLfOIGybiEQWCPXirkKe/TnB XBZMctEjX0nN/DoAXP0XDOmLdnTB7jJK7ClobGfVwXwx0V4SHPAFvJu+FQSOsr+HNAg2AsJGMJj1 SfR+gRzHhVmO2LQuY5yxAtsstrCC1FR5opWMgxsbFvSeBTSy0sZabS2WxwRVHoRSPSjyoGsukkR3 KdLgC3+KtvoE928YxjsOgndoK279gba5wvqxl2YarlULeF9zJwtAACBM9cJaVpCukpodonsPfJlo rv0jluCOwZb2XmQDPSj4uUHdYHebENQJPcdAYDUG3wcAbPw3N4JBLRYDtCwJFiVCaxw6VgAwYwVa XoRoe0RC4yOodwsW9NB5SZ4JFKZASSZKcuCEowkIjZXiKPIA2+pBk9AMDEqJfLmMuOgThJP6Cd4n I9hmFC71Dyz5A3SMaFP7L2g9FlvtRc8LQofROro0MFWzRdOSWNgBdugfoGb9ogc5e6emR6DZlkwX 8NzOBlYlQQ0W2AoCjwIANiSHY2BQ3p2XEkNBx7IYCy7MXcBuQhP0DUhYwb0AOF//VOcu+CqD6xkw GUlbnWh5EYwJhK56wIlooJVuIiw1F5nP5eceGPtdLiOu+ARH+wnubhjes0fQTTu+D38ArWqgu3+b Uchlw8SL+WKURX15S5so8iBq1jbzUILfjqUmCwjt10U5oi0eWrRnNQnRadi2UrDIBgqlnVUJViTB 3UDgsdwWAOkQGBzyC3DWYdmyAui8gmBOvjNsdT1k13wEocv+Cgj8SL2IfA1TrQ5YUijzDIQJlLEU 7PnoqgiTq25NksCsjOhu3ieojHjZJ2grbw9jGD6AWXiozrncP3DIH5Dv1RNLriy7seoXsD6zXbb5 4qJsKF6qBZNqOuaGdXkwu7AhNZmDswU09L9svAHLJUJbWGTGBppB3w7ysCwJjmXXRwsCB36vQ+VF 6NZJmEmE4IzDZhPU1isojUUtKGMj66w3BLxpaOXBygx4SlkjDxhK0FccUBMONImIVzobnGFYEpeM 42WfID8eaTden3fwqMzCU4zC9mb9A2UYWP8A3Z5cheq2tmVD8QeS0jFxbwWxdWqrNAaVqbyRAx9s FyEwqtfKAs8SAKAdXGwS+kGHvj8eHUXtvQHb56ctkcEBSRCWzcGPAgROAYOG6bh5CQusIIQVr2Bp glYBA6UZzfLw6hVxSUc8Apk1zQkhaIJAHTdBx410KWqJUFhjRAUHTUTIGznbmJuXEdd9gtpPICsc v128tg9tGD7cNOQ7GIXP+dH6Byb57MUBf0CZgF0AKxsK6lOJp27SwZk+1osZNTvYa5MFMmBSRF1C C3DBCAztdOFm+3HEfnty6Ad3YQPztYS2SILHDgKng8FiFaFnBUtewXztRKz7JBmTE1mgi6EY1Tcm WORB8Q8qcyhjBavXRAmmAEJAYQ9BDWvtMqwJK819gidFHMz6Cb5yK3efbhi+XyA4bRCqrtlqFKay b0HbP+DQwrGDJFQsKiXDzhi0C84UDm05bQUHQfhQDEWsYGHrfWo3m5MFS7q0lQTQLvpZKwW9B+CC ARG6LcU+BRA4cfj0fy7CulegEIphgTHMrlXsgVsAXsdDLIu1SvWAxo69LpIAy74RMnamAhKoY6f4 BFZORJOvF/yLXWpCkz+t9hM8VxC4H8Pw3SoH78AIthkTvb5ZNgqrXmr+BbSTJ3prxyfW2EFlBLbb VvEHdCNftOYbLhvaBU5F84mUT2oG6iDgakFH81dlQVlccKHGHRZXDzzABu4XhB915B9lBSGssoJG dh3eowHr5CVsZoCah5SqLxTaBFEThiYS8wmkIqlgoga1S0iVBaTiawkwXAXrJzD5m7RCdswwfB8X 6gGkweGKQWsUWrXgapNRGMgopK2KgzCCHSbXP5AqALAEmBytUwBwHoLoPBsAphPts748CHPHH/ug xxWTMIT5JiN3ZgOfCA3YwgqWKgj1zYWdmlsg7uVBbKs5oOtCxkLvJSFYVUkkZHJBL5Wkklhs/Lgk ZBKVvQJUNtAYhhNYYpPxLYYhTUCaG4btbbnD8H6Txz0CwTHjolYMBPmutaPQTzTS25PQGYVT1V35 BKMahbIFQNKLYLpuqi2+xS8QplD9AbmgJfCDMQm0CbMu4Nv6dtc7UA+1lT9nEs7HLG6a0PMpSYLT WMEyIPbVhcPyYAm47doh2h6TaHtFQBkXEVRm2iQoZZQloQAnmgIIefxFTUhWzpbFqxfmHfCfaAmu TkDq2gvDWofhfTL1B2YEv99cMfjZ0p9gHYV6soquYpUVwiGjUBbFLvqer1xhAJr1o2o+ex3cZ3Rr zNZ48vQSyiACl5pgVRbMszzMuwRga5Xgs2IFXV/BomnYyYPQAnPdhGGRyUFY8AmwGM1RKwgS9AYU WOSAvVde0w4ZgfYG2PEGAVzRQpEH7eXdFUYQTPaWJHhq5eDfPniL8Z1uWyoGLa7JSWsrBnRTozDI qa9GoQCC/EFK9Rnd3UXEWhkQ1xiKecTlwug2CMHOHyivaxQ3mR0R5uK2n2rby4JN2R4+TTDYwgpW 5UHPqiT4sQZ/AWxY8AmK5MPCBgQUsEpESyYmGUoySQ4YaPJq0rFlcw6iBruTB1Y5CMp0D1QO8Gjl 4FQm/l6AYMWpXNzRaA0gbPeXSycbxo5G1YoBTTSS1+QFJJA9WlBMwwh6IbAahY3Ow0r3TB9aZjDG afsGxBnNDGFxw5F+TgG6asG9yILPgyQclA8zIK3GigOOpuEolr1XWp8A3RTo0k+AgIUROpZYesjQ JZRYxhRn/OgBQcGgZIuawNYqB1uY8vsoIb4XRnCodFg+5FqLr5qxoIaLVgzkgtsJtzu3c4EBQtV4 Qfr+0MkElQSeORS5IPSwrqwzawl2gQ9NEaAd4IDrIv80WfAZoAIuygYMy0AacJFtHfIJGgAXgHdy UAM/yryU2kBaSoeupCimomMuNqaslJ1q5SAMjvqbpK1M1253KiF+HFUDvW1xOLeUDvW2wwnmAyeK UVMqBryAVRkUxeApEkEKwnUPDmUOETuj0Gf1mTMduvcW/IGDHXKnyILPjQbUIDs4w6LrxIR5uaGv Q3TVmbKs+qJhiMIAMHQJpWGaQ5DKgY1J2z1wp/lrqk1F5bKrR+CYwFIJ8ejtAXoJHpQR9KsSbXVC F0uHFyIPduoL7FSLhWFXwKFhAo0MQKgzV9EBhtA+PxB6/e+MwlCNQoQD4xSWae29Vns+N3lwyCdo pRri0qpKPbiDgxqZklTGglWQYjeGAq9jXo1CzwzouFWvzMC220WwEqIdueKv1TbjOu5vwBizZ9Dv o5cgvv9R+vUiLfA9BOvf1dLhrvoGJg26RTt8BaAOKNTgb7Rg7E9FHTyxrwLAstZH9P0Dq6dvgTF8 5rLgnUBj8Zyt9XB1hqFfGyI0/pECQCzJRVrXZUy57B4dMyglxH5P4Ql2R5iu7yUQZnD9Qa57/LAX 94swm5dtjupSa3G9CuoRKA3zYMBur68+uNIhv64X3AwgkwdorazYjSZ7HddGqCWfQ0bhObQ3Vg9C a/4dBs1D66YhrnZ4VjaALWvEiH7XaWgvui8jDqFhBsxMq0ewM49gN4EHhsoJPDgoM/jikM92ynTk Dw4Ex2ub7fLlxySCUaqLYrosDiLuITAwqBcMm1JUKw282xz1NMR+oC0DAoTFXoH1YQlnHXCPkqEH ah/IIax0HcpD3LIvhI2NGOYS024mBebgtPOsQBlEW/5eG8dzFEjp2HTkx8wIficP32xRf2l5lRbf bKEY4E9PqRjgTBakTg54FK9/Mtrr2OtAMxwXgx22ZLGlikGHbmdc2IoCR10WhIMLNDXMsMn0jZrA 0Ae+jpGOXZZeghkIdMCwWx28nUR4GnqfoJHQv3r00uD0NsZ5e3G/DsHRnwDdWT7kL8HsL7OJI80f vxyUcVOUbvECEc4RfscbntplCaFvQ15ndjalGd04sc/Hxd8FfYKJK8kANTmxlDU20HUXellw0A97 L/Tqw3oEy00TT1tv4PLYT1F/oJxo6w1w3sCqgRcXLnzcfuJgrkcPn3f8HGYaPuQ4Xfna6nIOy15P d036K1+lZA8o8QBQWTPRWpLqWMGiLPBtxh/mdk9AcP97seFJaDms/nmzrL8508BJGR5DgDPXf5TU Ao6P+njgu/EOwL57x9/55+/6Nz8Cj+Cuv3paD3xvtJxOJ+OG07Z1SbBzbD8e6nAHQMcPdAFn8iDU 6tjs9tUH+RXjeXydb+fb+fZogADiDtcxfdjGdXj9iP6WNuQMwG0cC88j5gOSxu6q4clfgw90AXn9 0+52vfbhHz9mIPjm3k8wwO6EnzmtHE/5f92AgTsMoHbw4QoBxXBGjceoKPB4bkgHvpu2/czmNr7j 7/zf96uiHisj+Nvi0bf6N4xykm+P/ZRR49rQlvagbMAf1y9Ychcz9YMBT8SIDhzwDgNnEwp9Hon+ pK+tYi+qfYuHAKK/8lCShL9eK2BQPjvpFglrALDvvrfMbgEu8/GXH5s0OB1xhuEFVqb0BGO8wvYk HP0JuBltqbk0LVy41AZkWgnQtGm04oZxvM4gzre7yLxjyNAH8Iok4J8tyx3Vi90nhvbzklj6AdKz TdlRjx81QcFMFty4z+/ex9jABwSCA7c/yMP3m6TTCgD4E7Sf/coIdUdzFFlgF4Re44KW9BcsVU8g pfq+DA65eKnJ8niSRsUjA3h1gJ/xYnYijmKtBPTqJ9KSD2TfKf8IQpP15TnomEgNLtDsBeTdz9vf YdKx1yuD/RHp+zY/Xqz88j+E8F8fnUdgt98cHc1xeIqigY6bIgBTPvH5ricUFmmVoLog79QEP0AL AMHLBfde0kGQjmaSMupWwAFPCfFz5N8pifWU30Bcrtu6V8Pxja18WJFw0AOD/Rvek4qL7GP0jLWw ggG94b08jueyIMbnzeeurr7GjwQITr29nMsCc1PNKzDKxYBgr5OyAfUJPDPoUBwMxZMNFBs0STUh SEZI+rikLe11WhuZ2FJTCHhITZyjfJuHAmHpPLafPQCyPDdcX62BA+ratnVMpIY5dP6AfU5YAK+L bYAwjQIOIPcx6HgdfdDb85su4SkrOGAR7Ha/kM88+Xv80EBwT7/AD4tIyCcD9ni4WrCXzD96xO3l QaVwrUywC57EQ3CAsGIWEtNAaLJ/fdpkHh4RxzSt/w5uCYQzbBw+HYvnDFc+p6ZAvZ6yPAS28sDG AxmJmjjIH0g6lpzeF8BQWcCrEdTE5AN/XJQE7vaG/vPasYAnH+S6PygjICpTkIz+sb883/RHQmED QqmYSu0l8Jl60WO+OhWJ7aL54PeUzi5wlQZyIdUjAGw8ghDqgEHJJ2VQKDfFA/K1c57x/WPtJyEB GpDE1nhFxxg6uVauUS/hPFuTRSgKdiRLBDpeEtax4WRB4oTDi5xXJgDeI4g6sy1haEwuk7iVDwAn vdYfABADHeJTPf6fyga+wo8XCLZQmJd2Am4xHEHOseiqRvcLEkN0Rl/Vi0mBgRAdysXUgFdWYLKg XHScDZqGbi74B2XQLWR87AZybxieI3/pfXBhumrI4jzndyIA5w/YSwPoEkHSwIdSKUCThXW8GBNI iNVXGhunEKZB5KxnEZrgfPNcjDL2fRXt6O2LX6989p/x8QFBo2++ahCOEI8okCGgUSRCSELKRkEx kpphOKjOT6VyYNIglcwfsWEGKThWoGierIaMZRBY3wFAU4Nu7ugDH92A6lXrQuUA15985vIAFg3X ZX/A+zcGsBg6oEXVYS0j0NeYQhkLdVyQr6SJxHyBVNlkCjWhlMBuxpSWDFP1CEKYGnPQDEIIY/NH vQ7L1TPYPVOA+FLf++NjZgQrCNQg1uE/wJDQkNEjJiwYhoS0xTBMpst0azq+UKlDbqwXclYqNC2o MV4BRAfM+oDqsst8QMLyQIajwf25kAQ8ASSwB42a3p2bD/66JCzXC9TvqdcPZfnCPF6wJADA1jtC ZxZaBYrlZBlTDABJjUNOSJagUiNt6Rn1x8FemUAe15z0Ftrq/3b0nHznnn/78VUNDNkM6ZrLnRHx 9cwxFhDYK5rW8ounW6MCBOrJbzN9lQQGAKj6j1cpSfwZRNP8SbQEtABghmF5XVP63DBc9AlwYSCf Ig/w0418wEVZMKcBa/5AI9vQybXi50ike6PQromrGGjQJxkjoO9xpQlka6PSQyAbH9XKAQc+YKlk qXclDGAvjHacatWLJG+ZZ/C2VM0oBigpgjMLpQnv34+c1vtp779nIPh2BbnmtyXkg6gGimkpQ9DS b2wUK6khY8aM9RJgucApOermS4gmA1QiNDTRMYIS6DoKVAzUARZ0G8xOPsBijwF4aXGqPPgEQeDw HC9xCHDeyS2LCvkmIr0ujT9g53rm4RQwRycPEnpZmCSZ5CShMlLkgC8bpiox7fUkwc9G9khraUU2 B2ddhTauCQycB1bbi6m35r+112Z+K016f6D//OZex8o9AsExZPr3hTbjazR91PQTXCtyMoUiRB30 xIpXwCd4UhAAc2vlImagSAXh9cKaEywXWg2hUM0gCOYUe8PQBk7jQvumATfwZn0q8t79yYNPECCO sYFVWaAaDpxMW/UHmtdY+gsgrRqFCZ3HVMZOKsYzg4MxTPKerXSoY5EZAY3TAcfRs9mhk7tv1RO7 WJhj8MPmCtvCeX0s0iAj1R86BOv/0dJdKKUDgBs9SbWXYLGEyICgzRpcQpQLkFJylYPEF8oAoV7A mKq5QzKA3hPk13FVgYEHig0cXB1YlQFUOYGhp/x9OauXB7jEHj6l2D+JDXTm/5IswJXuwXpNsGb+ xh9AAwRkZpHMJxITUCQAiEQEHRvVX6L1yBwAJGs1TnqXxMTlQy8LtHQohuGuMAIe666HAF5d4VoP AZXguavw9GYifA9AsA15+rZIQTrXVLSlhKgndNTKgaBslQd2MVKpASsg2IUjrAgOEJJcTLnwMUkl WQcG5tcmD7DzCbQZoQy02sCyLA/WulvEqvocZiTiqWwAFmdyelnQSIFGys3usOAPKBvg68/Bbo96 TANdwEGXy7YJa4VRVlkgvWRUMUi1YjCKLLAEJsBww77XbZQ5Bmulww/RQ3AXIDjtl1IEI0Q7VEIs lYPrW7QSIp0wOnFLlQM60aGUbBJWw1ADWi8YX8ikF1Jf1wtckV0HpgyI6jOkmU/Q6s++0QXrmPQN LmFmdL0DK/jIacIWNuBZlH/0zQKHZYG7PqlncWYOt/4AL1OcmlKhMgMFqCQeE42LIZmfAKl6CxB2 CTQhSeAPZY7MWsXgTqXDB+gheNiqwUIJcUvlgE6QSIShGIZt5WDdMITiAwBfMLlwWIM8gfMJQqoG kQ6IwiZikgEj/4gOpLQsD9BRVRk4GGZdbw3NPcAKPiUwWJEER9kA4iobwKVuwtbg7WWBXjdS9oHn m1oiINDPr5UVCBukcSIswI+N5JIMJR47LrKCnmuna9qliR7NzyrsYBID/EjF4MejFYOHKR3eExAc QqLDlYMfF9cl0AVKrm86w3ByJ3jCSQ3DiQ2bXZILUj0AZgqa6ZOUDZOBhNA9ufCSAfIjysBARX/r SVZ6n9blAWjZqpMTM9Ow73CDOt4B8MQFTfCTAYGuUjAvGUIDpEb1Ay6zMqxAnbACQrLrw89L/4CW j0HLydJunIwFpKDjRv2BAgDsL5lUqP0DpYK1YBSa7yUVg9peLP7YqRWD+y0dPhAj+HZT5cBPR4Z4 gwUdjxiG42i0a1JKFotZIwivPgEoumdmAMmzAAn0kIwJCADIRVbmgFVadPLAWEFq6Cd2EmFmGs4G ePUK5o751mmL+BGDgDsdfTVgiQ2Eng2Ezo9JDQh3LC4JEJdMz8fRXot8ND9AJEB9XSVCUAahPyNp MuHGtiTVApKo3ORqcwsseck4ZrlrIPCm+mKtUTivGMynH//m3q/9PQOBIdThysGyYfhSToxrNZYT p4DQnNiJT7iVa+xCgAY4BX8qnkCqoFCO+ewve6d5eVAGiLIBnZaSSmZvBlY3+HzPQWEJgMsty0p3 cWmOwqYqAj4yANgKAuhBoOsbWPEGPBvAJb8m6bTj1FUL9PoqkLvrXmQBy0be3iSxLDT9D8GNIx0j lFhsLAV7vtNEUv0BS1wsa/fid/kT8DbeokmCQ0bhadOP4UMBwYZ/OP8BNgtxi2H4NrbVAzEMD/gE zYUYNDhTKRE2BqIGPXi0b+SBDpBSPSgAID/XAAF9eTF0kqBlBdC+H+b9RqsS4RQwwMfFAo6BQPOX oVvLYd7OvegNgGMD6E3C5ACiYXrm+IsPEFMBiMIEmCOWzycZP0nKipL9hVmmyg6SmIPsD7BMVX9A ZezMH7gxo3CPa8vz3c0ofHf5GO/not+fYUgnqHQY3ugJ3Hc+wWg+Qb5Qk01Jtn4C1KrBUIIdLHtz GdENjOTeQy8PbODUrJ/AZ/4iGwq9XGMFTUUAZtoXlyXCMTB4NICAdwMBbGYYLkiCritw5g04INbm IHTMoIJ2mTMCMlGwXmtfLfAsoZMFJhsEHAYeM0mZgVSldjrGKPnsEvsDzE6nDf4AjfUbbqz7Mb5F 8wdONwr/+Z2v+z1Jg1MMw9Yn4BPAHYbrPoH0ExAbEF9gjJr1J+0n0AsS1BMQcy8VFpCwBroFOZbs L++hBwGsWcLYAhgbSN4XOIUVoLy/RSIcBYODePw+AOHAv7ERBGZVgg4koXZuwkKvQMsGoLK3ygaw ZHpO4+L92OeE/bHeTKFjiQYOZfwUMLCxps+tXKj+lDAA+hkX+X6ZzB+w/oG5P/Cyaypc7ih8aKPw AcuH3za/+Dv7BNpPsI+XyeQBnWzxDBSNg8voWkasF62lexbUUOghTDZozA9ADwg4YwoYwow1pIYx SANbda8DHJIIRQ9vA4NN3YcPAQhHAOAEEJj5Al1pFmtpFiswdN4AeC+nsgFovR3wLBBLk9DUmIQ+ 8yt7NLYIpR9FP8OlaalWTcosqYrF+6VDlQWUsLh/oFS/pH/A+wMii7M8XvEH5h2Fv3kQkH8AIHCG Yed8+tWK1nwCOkFyonZ1AhIxAzJcujIinfhJ67etPLCgrzrRX8xk2Z4sx6IRdWDoIKmsgP4hoZXF NKyPM8NKjCoaoHrvjUOJ9pkhhieBwSap0EfoXYBh43dxAaS2gEDvC2BYlATGptq+gdR5A5UNOEan FZ7KBorzX8cI/5+uMzPHVJkjOt+ofLYCAo8nZQbqUc3nFzAA5Nc3NtFo3j/wty3+wAMahfcEBNsM Q/vDCOl6n8D6CdoJSG8Dy4MbqxqMzo3NaDsm019pLg+q8ZNCT+/Y+JkKwjMemDwgYNABEVJaGlQ1 K3gTqqkgJFxsdYVUjcO+igAuO54KBpsBYS24D903/pjVnocNIOB9AZ0E1IOndnmWPgD1BRrJ1noD C2wgCcDzd5IyAX3MCcHYJI8BnmQkn7XyYk0m1qDmTOkiCyas8nMqsvY2TuiXL5d77R+ALf7AaR2F +L6A4ETD8LtN/QQ2AYnkQT1hbRlxz/TrUnVYfj65rF8uENYasWMCOVNPJg/sQvOFp4FggyIlN4BM MhA4rLKCmnVmsqGRCPxi3S+QZqiNYLABEB7KJuh/9ioLqCs9HQSB3heoFQECz84gNJBlMID2vNdy 8IwNVC8A7bqjHRdWKIlCrnczZiBOZiynrlogskC6CUUWCAB4WcBlQ654iTR4e03ewGueX2D9AyIL tvoD3z7IVb1HadAj03afoMiDV04eXN8643AUpO3lQVM90AsTavYvdI4uZukZwKmgOz1HlwlQNIdt qNCyApEL+nOmpqwYOnBYlQiIM7/gFDCALevy94biuwLD2s8A3MoCAh4DgSVfwPcM+Hv1Ylz3ZwfK mvn5ka5n4qxf2QAFvMpCygnGEosMQAcOU5UDqZMFNo6mHbMDYqm+WlBk7c2kUmCvVbG1+QVb/YFv HntD0QGfYKWfwOTB30I3C0vLiF4eQBQdZhdgjKGwApYI/QUqzyceCCmZNjT6p1mfLnyqmaSwApCB VDKMAMDkTUTfa3BcIkBlDL7SsAwGbTWhMPBj7MAH6dJ6gKfet/zcjgV0UgCa6sgxEIDU+gKg2R+W JAE20g0qI6RrJS0iKQUNetTraV6AsIE8LtQryj+MwEBlIyUMcBJS2EEeNFNhn5OrJDBDlWqBsFbt fxno+b6UDU0WrJUNY/zxDv0D8FiAAO7QT/AjenlAOqm2G6s8eHuxOBuxbS5KOtUzVFYAS6ygv7jy PMicMjMFW1ZgXoEe95pTJcJ0QCLM7y7oG/NwGQyCDx7wS3Avs4MDU36X7gev59bv4CIAaI+Amz/Q Lvy6CAKdOagVgaZBqJcEys6clzOVqo/1DRTjFyZmA9JDwNe3ZQMqEVQK+vEDmAEA1EfgcRa4WkCv mY0uNBEJe6XPjwUAlmTB8bLhdwdkwf34A+8KBHiaPPjudHngqwfaXASjlGj4kaoG0wVfnKmrDkh2 oKCPk5lEFSBwMlZgWQI02OsgQT2ukoGzi2lKHjSTNw4XJELRtQ0wCP1U8/AYGPR1dmEHGwBhSzsq 3g0keuDpAKBhAWglkr46sAACnilB6o4lV5XxPQNTmBuExOAmkwVoga3MoEjANTZAcrGUFzVZ5Awj FaWxjjG77lPHTrV6AMYKbrSJaEUW0LhflQXN7eFkwQNKg3eTB756IBWDtrkIDIV98E/1wkyFxnlU F9Sn41U2KEPI79Xsb7RRAAOLthStyZ+RTdVo4PGgW5EIUw3+TuNuAgPfXeelQliWCxD6DUHvwyA4 8LNWAKBhAf2S4wHn1QHs1w5YB1FoX3eSQADalQsFDHCq1xkmf835sWEDSUFDPYKZSWjSMk69SWhj kNhqpGNdE5Gw29sjsqArGz7w/AJ/2723ZlSSBy/tt6Y/9Osgeugr5nt0QjD9NV++a+AdCkEWCo3X zzFdBJUHF3iRRqZd425KwzjFDGXEDhCHwLJgyDrcAh3VH8AEpZTIrI91HtLskgg0AylrCxDtGEEX QaT3MwhEYgg5DCN9VIETQO9oG7BD3X1VuoUlAsDtqtmCLy+VlXgJXGSqy+ux654IqgzAggf8xUb9 sRBsSUSw9jtoZvIhQjdY8N2xwPsU4H8hBw48Ja/rmILgfBKsez94T2AFBHx50PUCFPBtJAFKZpfl haX/A1XiEagzaKsE5OuNKgGFDQQrIyobyKNAGCKNlxjZPGZmEM0jyCNrgDTmT0QqEYZLkQP7nLyi zi0YZG7B23ylB+4byP/Kq4BxFwhEtFrwPzAMr4OUDb9qZUGR1d8+aHjeIyOAw12G4W7y4I3Rqvg0 wa3IgUOmIWeHfFWsDCRBrxoPJcPPs4J7HjRDYH1umYOyCw00V3aqdxmUk9LVkpl0Lnybxcz0KszA uuLseJn2urC4CaLj1jiTDA1LsHvAuxmFlvUDNj8Pa/Z3G5FgKwN6FuCkgC4S0hiDx0Cg+i9Td56n JUnAd/N77Jrq9ZWAV6lAYEDrEANOh9nASBOQptpJ6HoJ2KdaMgl3ziS8LNLAL0JyVBb8YU0W3J8/ cB9AcMQnmE9L7uWB0KH/7JqLbO7BjXNax8Y0JPrFpuHkqFkU84blAWQ9l6QGzFUD9QpYGnCWiFPt K0jiGZB3gPLIAR/iyNmjSIRKLwNgHZBo1HTmF0xYyljVTJz5CdpzIPkdqrHY+gap9Q5WAEEn4DTA gD0wnHivrsUs+NcBAFq/A9ruQFciTM4TOAQC01L/hgdjDE7/MzNA8XrsmCUCZnlxbORBcgki9cer nIz2XJMOeVQQ8917V2oSskRQk9DmFsCrW6yLkLxZrxY80K7HH14arMgDaS76CtN/Zbz9xZsciW9z Qn+KiejTM4qOPZ/IJ1e0TJSahjudkThQV+EQKdCJng1RL1BUVkDkjr2CRJ8hCZAvJlWABsoIMeeE gQcF8f4sBYDIGj3me6AHGve0CiVLBl7MhiUC03CVAGAL2xln9+zet9wxCwaHnvQ8/zvSYyCPwN+P oAhQpYJb58jUQmFg7i095oQEgJ/m3CI4HOB2R2cUYv16v2pzayZWFlDKhmCl1dInAG0j1hoIhAK8 ZtYqQCsoA5pno70g9piY+qMGN4F9vqoTGU1ASUAlALNHPR65UpCYWRIboPFE2oBWLsiCNH8l1Ka2 0kmIqXhZZBIOe6b/wgQCywKpmD1RWfAms+FX+XMvlqsF3x2TBfAYpcEGedBVD5qdkuMrdk9JHnjT sFAqnZGYT2Ii2kUXgllBrM7tMivwFQRD+qmahUFlAQ0UcY5HzhZBWQDiXCKgyASRCjBBlQI6ELmr xI5rxaJ+LnRyoTEVZbOGVKWCZwfoehFwXoqrLAHdpIbOta9dz2v3dhsHt82PThfGhbUCZ84/tLM0 g2M7bkpxcmXCWVNWUyaUc+vMQdb+k/kCIfjSLwrlp71zOevn6wk4MwjXjEMqFwYCAR4jif2BZTag UnVUeaolw1vtHaAxO9w8S2smoZ9bcFoT0f3KgvsCgu3yoKse+LkHiz0FmUbRks90IokV5PdYg7Xr FNCAEb9gnDqvIJGmS1OtIIBowQROE4YxwDCSzZvH9XhYIhBICDBUv0AeQTZhNFpazCyYewb62rre PBjAglRwrjpqh2IDCHU9vjkotCv5VHDYeu82dOl+Zi9TVgCg9l74KkA/R6C7OyYwGQig+gNiDuI0 9wXkelTfB+o1yuBeAEKPM/ijJAPUqhJysCceL8wOULpSpVKgyQX2eu/YgCsZipe1V49LZxoutBS3 cwv+uGFuwacgDYo8+A6+D78O/+jmHpBbSidm+tmfc9w+YxrF3f9BFywhcqmlxCwdMisYmSNkKKO+ rbSjsFZ0hkFYQa0gpPxuJK5Pto9Qf+b4RMYj7WeS/zWi/SoNikSgYR3ln1Y/jr8mjrwoaNAdVxHc 5kn0cz1xbwvoEOaNwrXCwKEUlSYDT6iuVYrgdluGKhk8TUetMljhYg2zYSOuN2sKti3EtShS93HA ts8AhObUbeUw9D0CzexBK732TKABAQVSZm2BAbwwMAGJPAq4yV9BnIYDy4hIe+KMBgIpCgiQQZgv a5YEqFJBmo5EKpAcyIkkjqVSEKKwgTgoGyCGSmwgSskwlpJhvhi7W9kdiaUBZjbws/yrXjuT8IUz CQNun1sA9xqWD9BHsEUeyG3NNGwWLHldOw3fln0PFlhBU0EYppiGSX0CmTPOKC9ajzUiDx4yDlOX FUhLEqWk7G+Vg/xajMYRlHLynVsd5bPFPBTjavTONrZ9BRMaze1MxVYugDfECkUGr6fRTcgBXNii bZbBk2saWisR2D21jT3Y7ROgE4LMBMQmkK0/IunEofbvaXoE0L+eQgcCuAgCQUFAsz1dlyD3jKGj lQQDChjwe3SdiiQI8hqHcW4QxtpIVFjlqI9SRowxlvkqe88G6F4qW3u8JqDo2EAxCf9ri0n4fmTB fQLBafKAWIGbmmysgE9MX0p06xSQV0AovOgVuArC1Gi4fOFANB6DQEpiGHFnYerLRiIRShWBV5yU gQUl8ygYGM1EbU3GCgDmZHsw6DyDQnvB+waljXlqAgSrNq6AUBdZLX0J6Aw3sGCFtKDh6/fC4qSe FJbmSVjgexDC2gpsAIB15uB8MpaXAlj+5kk3EErunEjAL4KAZnvK8KUL1GQcN4eN1RcIxe9hcBfg VvBP/Fm6dlZeJoNQWoxFIrC0tOqTdRHyuMJk3a1WKbgdrtLhBiKRBZzs4qv1luLvfv3e16B8IGkA KyBFrOAbYQW/JdPw1+Eb9gp+we/e3tIXiRW84HAiVvAFMXEi60kajN5eB3xy9SzRkpGzCgIR/TiQ 7gfRbvsk5QHSeLuJ9zECkgbcXhyljyipRKDvUKEAIwuHxPybDkTeDVFbdrg6x0UGtdeNs9t8GICq BzTDcnAgL6bglh1woVQNvVgcfaHRsZQIsJQKwEsGNeGgqQSUkkNTWlDDHlZo/wq2Y191aJddX2gl bv620C4vlmxetp9LINQfPGg0fRneL2hBQIKeAVhZGns1kvlH8QUSrx7KIF+rBPlzw5gTP0sCYhH5 K1I9oLIyhfoQpD091jkF0UlPepREJJWCWyoX3uS/ZTA2cJE/3zYQCRugv/1Z6STc5eO73Q/OJPyT YwNrcwvg3iM2PizOHDcNlyYiESsg+rTUYOTbjrPmqqzAnNsyB2GvJUSje4ruLBHoAtNASE4igGaS fC815TAarRRGEIR6BnttTrQMzAxD44wZiI6tZS10JbDeRCyZENuAmE9ealpu0c3Td0wB28wfjDXY fe1/+j6U1Zp7ptBSf5f9VxhAMzmoMJ/6N3pT0M3wrCVCF+RLIIDKCEAZG1+nYu7G8pn8fo5WrSRg kuvLMoCeD+U5tQnSxKLE4yZLAmKVJDWz5PRzCviubIAAwPoGlisFjg38xdjAv8/ZwMwkPDq3AB8b I8CToIroz2+raWilxFVW8DqH6lPPCmg3gwtgTbbTtt/8kX3O5jvrLgQxEFvjMF/kSP4hfz5SjyhN V08g36erH0F9ecmhzA6C/nzxDXV/I/mfEgGUtY0hCqsHmy9Ye3BBF8N3Fh86EzFWdlCMvhgqU4DZ vRbzwexJZQolbUDlLH3/AB7hdLPFRmY7tkDwJuFCB2TZTMTNKwBbFQgR5msJqh8gwAENK5jmIMCP EtBYwZn2HmcwkAqCSDl6JECRXgGWfAz+UdkAA4NKgjhSo9lE/ec5EeRUMqlBmLP8MPBrWj9ziNJX wF2Erm/gDdHIzWxATMLCBt6zSfgeqgaH5MHv8xv/BqWUmB9ubv4Ifv5B+MvzgD/7cw6pZ0ErCDjs LpOMyFvh6oTAuAeeg4CMzhm0eRgQQoM0GQ0sCaYYeItTCnje3oQDn/xh3iM16s6akeoFvL0d6GdR VhiRdhhSFcWbr5394FSB9gIxBJTd0rWer/JAg2zAOvtu0B6iiHUCUtRAi20XETch+WCfg4JBg7b9 3WUk4axJCNvqQH2crTQEgke9PCjbzak2mDEcF/jJfIGg5UHUpqGWCRgIRAGBTAolwPk9YXfM3ijY k36eJMOQv0/RncGBpUJmAyG/zowgVklAvlJmAyQJyCCUVuZm9qGbUxBZml7g9c1tkpJ3VykgUMiB XxuIbF7BHzMb+LpjA8Sav99iEj5aabDRNHSsoGsw6mclNhUE7Ssgw5ArCDwHQZxa1mhw1TQZkV8g huFEKC4UUCWCVBF48dkJ2T2GkllYCqi5lMQIlIEGOsCs8UhpaKgDc/TUFNDkBH0HhN7KMek7qFKB /02tRBSKDJ2EcIbi1Nbf0ckIrMFVzbh29t7We/PzdYUmC1T/c8tzbBYLDW0fwNTIAGiP67kY9bXp fgYAMQHl3Ho50DCBILIN9Fz698BdP+kbSXLNuWwYGAzo+se4GwkE5pLADEIqIIgEJSlKkpSlaUQx sLmR6BKPVwq6BqLNJcOHkQXvoY/g3VmB7ysI4Uqsu/Qyv4aUtVjAiz1Q8OM+/2O7PK6ccchZn6s+ IhFI+1E6jcoKEv0QZgRJdq4Tbyy/ZBPRsj9II7Awd8n64CbRddt0cuaPwnb5C5HXyJAGfdIb0aYV D0Uq6H5rvcGG2iugrcvWnVDuWJ6XXoOAAXz/sXUzQEf24bRB1m9eWlqFEft1B8OaQeiWe8fScFRZ AHhGAFJFaCst5NfIHA8OdqH8FQRCAQEGawcCCVQG5OdaQmQwIMMQKS9EWtIm/zyqEuR/K48NYQQT zUCkzHEx8by1SZJMnJULLzII7Dk5sRwgNvA6D9WhYwNcKVhgA0/+hNvYAHw0jOAE0/AwK1juK7hR VlBnJtZy4opxyGVEMXqkp2ASVhCFHVBGEBqJXEqk2jL3mHt6Sc+jZhbLSKHNOsYKhFGk5nM2WEGb X7QLkamqZkHPDqaSFX0W9RkU2tl3vl/B9eS73gXoWEU7S3Lh2DRnGr6sCfrvof/ZjeG3xgAKwzEG VFgACFsKwrhywDfVgHL+vHFYQCCNlLTtvDu/QEGgu5bK1sgXkFIhMULK/lpqpjJzlIqB9AzsmV32 BmFpJaax9vZCy9sv0rD7ItX9Cq6x7xsQNvDDo2EDD8UIOtPwbqzAJiMRK0i/fJ2HWwaD8CR8Ef+2 UE48YBzSkBuofSzDQZS1hWDgvoLOLxBFzksXyHtsCLIyLhJZJg2jfgHVUaz9fLJFOpR9DG2mHjSL j9DWOKXjTnwBYwcEzDzJKfBnSiZVisGfBU37oGm5LS06NoChKRfWGUnYlxEXLiHo192gw2Ztgfm6 g2qNyt9YJxH5hiPbaq52EJZNZbBMMUbnEZRmIs703CEqVQIOdFDwRX0f9h4EBLyr7CKQxziNJvlI rjFAcFIgP0DYAG1jyKsTxotppKoigYF1EI7at0LPb5/kz7yt5UKWCbdiEHKlgE7001D7BhYmFz0C NvCeW4zpD/oXqKzge1iqIPi+gnH8Mv/3J124ZD4zMYTLxMYhtXJe5YtAVYcsES52NHM8/2nDmEfA Luw00IGYQSSbKDO+qF3iUaQCSwMQdaxzAsUQ9EZgMlDwYKALTKAtV564K1mDQlfQ5q5k3ZWJ/ikc sFJn0woMAiDA0ACCan5rO1Zjs5qEBRSwVg+cZKjSoPQYwHFJhwEXsk8ngnh6Yx/87eQj3+SU6nOs EqH4HbZQiG5BV9gDchUAZaqxBPZkDEz8GKkSrIGAsQRiehEHZQkTSwFmWbTaZU4ZUCRBfpmTBZWg 43ChVYIlSTDy/JfrmzedQfgl/qSzDWnc0sIjwxDmbGBzpeBh2cBDAsGdWUG4/g/wU5RlDsIrTL98 wcrxx/A2UDkxvHmSwrPbfF1DuqavDjRixC/IaA0XTDa1ipAvacxXgjpL6Ppyv2vxC0YuJUY2GqiX QZSrMgRN7gUMwEChgkEFCi0bWtaX3iPgZiJjCm2wCC2I/DYwnEQZSjjQ2knIFQIOfFqJicFAV+mJ pWToQQFKi5NOiVYAAL9CEsJphQOFG6mIOmZQdm7tl1qzXgPtL0AsnoBSa3bf6wYkE1aDUVkAyPqB OpUYimwSHV+qBKhdhGENBDJvLyCgj5r9qY+E5RvLRGICLBPzSCEDkU1mAQUQ3QFwkyXBwCCQk00e PiQJLrIkIE+qTjOWcuENyqYlv2BvgCRujL8u5ULqnJ13EX44NvAePYLTvIJ2DsK8yeinsjNSOw+B XVtdyUiqCH2jUb6+5hekaRK/ILJbHLmlVFuQY6cpi96PhDR79G40VwFImyL1lu6rV5Bpatasgekq 3ZNq21TmKdBxNb72NIBznEmW4wGMOvBL5jPnvMx1ME0d1FUXTQ1j9RXAqhBj1fBcT5+O3RvNj7bw R2nuaXW+/T7gfA3U3wvV/YfiixRvIGODtnDz770vVQFMksn1XPG503NL5wzpNaoUgDU5MAcBfi+R FDB/gCcY5Wsv8iAl8wXYYBZfgIYJlaDzuPFVAj+fgMbdQGPvdd889JbLhf0Mw/lU45PYwEcnDe7M Cr7PrOAflRUQGPgmo5g1F61tyImbyjMqEThBvc3j4kpWhqEqAlxYPlzyC4Yg/QVTGBLtrq5+Qdzx 4obR9QUVRcxmdtDyAjUjU++dzKqzlYWZBTDVTzIpkdO9Pgf+NLfTSmZPA8t8ZgLiHeR/NI+3PNTI qaB2Z5UMyAdl4ZJQ/YGoVF8tjdYjkM6EEPoeA1xlBxhW9y5UVtAsn1YLJ7KOQnIrKslKTahrOiK4 lYWQ23LdUuM8/TclW/MhlTkHwGXc/DfQsvM8uUinGTOIyNJyFOAg1YEIC3JgCQTkMwT6OQkIE8ha QQDA2ACVCofGF7glkHBVgusbbCTBMHyZ2NAuBuGzMFzMm4fekQ3gJ8AI1ljBtw0rqMuZ/YBt6/Er RllCW+stiG/UoHHoLKiO6uoKG4hxnEZFeN9fQHXiKUabfio1Zc4OMmgqM5hcDbutJkgmypkpUIbi TMiZShes2wd9tExW2AG/h3v5ufJ9yZRJsmKoznn+t/ZoLjuUSkPJxl3Pfe1NwIYRjD078Bnd2MTC ZxvTrRwHx0pQXzdufvmd8t9Gvz/9Pah/t2RyZj9BmZOyAMnyuLdzxcyJz09+HuW86jTjfF5xD111 4CAIJGkzj8oEpa9kEmlAICDlxFIqbGYW7rWN2FUJ2p6Bm2bRkTqxqLKB75vW+rU5BZ8WI9jICsw4 /I2wArdewdw4zClFlzSjjkMyZL7k3oKf+ioCZ6CMD2F/ETIxyFl+pPVHtDqg/QWZF4RhmHh5kDgI E6Ce0cg+vSxuHbmtsWMGhSGoHxC5vUGW9zEDjf0BXYqLGUDSRUl1gw46QFNUuGGB3qQeNBz0fX4u GV86CdVUjEGcx6i5mTsh2SeYVw+kqzA2E5FOEZyNR8AvSsa3JgqtFkgdIhXD1KYk89/NPRMynwJk roOtRizrCCZbbSjVVYWNBYBWDZKsKyArEuk0Y7BVh0bzCaQxLE0HQYClwG6k8rFWCEaZsh4YBEwO UNKg5BGn3WSlwjgJKFCy8ZJAktG16xmokmC5XLg0w/DDsYEPxAjW2iW79QpIIrgJSYaqtqSZrWQk vQVXSLXbOMgMMaZszi9o+wsqK5COw0HNIes81LXqusHT1qFF99fsQ76BZCbO3JTBzDcoz40dmJeg WY8zp7AFyZSW3ZUhlOwnOlq8q7BXT4B+h71NygnmXZRZeK7zMZx6d2zBdU9K0w4zlb3+XPr39/7f 0MlB4p0E5L+1eBrKlJg1sQcAyohQGZGcF2EBqCyrnh/pzKT3p3quC0ujY0hNJftlENh5ENBHGQfi HRF7vFVzsPYLSKmw+gK2GGmdVHTFvtW8Z6B2EK6XCz88GwhButrex81B27/k+//K99/l+7/q8V/l +59BjuXH//gihF//73x5v4C/39EKpj/k4z/Pjz/mcZSZwetXIbygTH0B1+FteJZzPl5nuXi5y9ef 1iMd4OI2P3KDoQxPMnx3lKimmGMfga2fSEQiwkAJh+o7mQJEzrBDkPUtQXYboKknxAyQa4xowjjq 7KPaTwCoFQWUpgPQ5Qd55nJZpQdQJ+TE/5+9a1uS3DiuVQV0zwyXu2RQdihCYb3ZfjAf9QP6CX0P g9/Dn+Cbn/QoRdjmmxVUWAzTWu51ZoAqV+bJrAtQ6Mbcdm6ATTUGjZnZ6e5z6uTJrExsyXXBpdg6 cIdUlxuE8P02T1V2Nk0DghixIY9ot2Xbr9yMRFQL3eckdrepgcjCf1bnQuRNQKaxo1DjfpkPKL0c bZobiRxMQF8BeR4hhrZqk01ByPFQWAVDNKQWcUxKTMb0TjpsHuKQDOEV1AH8gRFmoYNv4FFCzJ4A 1QZ4V5AAFxANiQScLA5kbLI5OMAc7B0vJq47oS0J4gsYXnS4cOitjSv/GM7jotT1r+IiFX/7h7e0 6Sj+OX+jRqXxv7+YH5JB+Fdj/v3lpIroftXAJ64jWHMUxiGz5o/mTx9/Y8vdiRoilJuStNAIKUU8 rSlFr7t2CvMwvuHxUzSafiRtRztOY4jALek6yibFN468x57ChIAwAaM0xUAMqc6Ay52R1AtcPiBo 5VCBfUOPEMHyLD6623GzTU6reSvbgpkJ6DnUDaS0IdcUBAkJuH0apw8dswyZis6iL0HwDnlLWrTs pJ6gGn1i6yrj0AgTkuzPRcl58GpBZOi2atlyhScqRUjot0gbO6VhirWZLBAC6BARnigVgceBnWwj lpmEnDoMg5XrHk1mabGWJiJWdiHGa5wKpDcOpOJZGXQDSoe50nOslYBDNqAzNQloSDAxB530IqTt xU5UAVKFF2QCevIFplmC4yFByyBcrAC/80Yln4oIFryCVpFR2bwEIcIP8eGfpeKw738JRAbj+KNF FuE9wM6bO7JfQAz+8Tx++4mQQfzMXkShud91vIOEGhoNXUEG4hdUZOCdeAZgAc+RPCJgqmnm/UoO KLAc4o9B4mBCAtqKQT/g3IEMLAgC5EANL/hjFc8dewP8Nc5Zj3QWdQBMCGR9SAGDNEwBCXApgkPl kpRBpYIi1Dy5BPygFQDTwNAXSQKbu7F7aZ+IYkVvtAcheyQ8VJgtCpoFx9kRI3+jbIqmOxIJ6Ejx mgB41Jx0EeLGsTyZKFUROjQUkbmF0nGoo92G8APMiH4CgUkiVRp6qUgkL0DShKOSAK0FdkYCmiEY RiaBoR/VHHTnxr/vQAAtX6AuHHo1rxmgkOCoQfhNuK8l+B4VwQrjUCoOzenvuPyYXtRh+JXN5cdv DRUaUUrxtf85fCEpxe7zcz8O525mHsbfd9Gdm13oufLQU+XhATJAtOB5Seg81l1erhlT5BxZXvlZ GtDnOuh2Y+6E6kX303U1ByPIRREQOThRBHyLKAJRCKwzkDYcxRwUlWB19XeYeEAYB+iZCySeEIsP 2VOWKl4I19rFjgRl2RGDXT0/C4vPeFUHDHgGPtq6igKQ0eY8Kch5KaDKA0NFDcQXR9KGQgDeyoBS mUJETUWDSz0kWQU4aTtO+pwd/rHYF2KxjTggnUghAYcIForAUIpQ9pdwONBUAgT8bqwyBJqBmpiD XC/QBalngS+gzUipcKjcVPRDWUE4m1Nw/yHBp/YIFjTP1Csw4hX82Uz9gp+SX/CVJPFrv4DOP4Q3 Fn5Bb+0pxQjn/Csv49qx20mpfTwfd3vTcVbfGW5SQs5CJAFDJOBBBiaRQY9o3GEKpuMdAARtbT7i ZKoWGhk7xPG8eFsOMRgOslIGJAd0NYXE9sk/QBcCD09ApwyhtbhL1QZ5b3+Q9stGiSU1PQ2sPthH 4JXZMYfJSDWJ8Z2vG5RyzF48HzBKHH/9KENGsVJLq3cdMoqp0dIH0HIHJ90cpTsEi81SKGjCuWOv wCLe59p/zgKwXxDECwiDqICBuxOTCqBQgP0CmjVC+wfQq8BxiEAKgolkoK7ETioRQQL9OPMEyBzs XCIBVgOXSD+7rgMJnAspWCKAMXQj1QvY2heQkIB8gTIk+ImX2/+chAR/boQEv/8kFYQrgXkfv1Nf j2+L67oP4Ws8/u5Hy3ECFRqd/288/5eoDH62MUSIePwlEvoL6//hnR3P6eP/wX7hz+Jz8WPyGan6 ffwovCV176IycKT6CSZ+f+p2w0g9Y1xUBsQLcd2I73xkhBB5v/NjPPeUh+hC/D/6SET67zw9SeuB Hfq4CnbOkW0U73Omd5zyi0FHvB5xQtufOkoDUnNE3l9A253oHkobWriaFFPwCFes9vzv4a8lNLC5 xBglyNjITHGJtD0nNhKPgP4IZ2XqmYYHGhKkaanr3nOrisAWA5vE+BQ/gGIBC/fBlx2JSAvxBGr2 D3L3IS+DTGFucvuX0WrPhCBfS1NZ9ghUIVhpLS5diHWXKLcV07FknBlwo5Vdpd72UhPipE6gm5PA RAmUJJCUwMwczL5At/vKt30BKhz6OaSQ4I+tLMHDUQP3oQgWVIGZqIKFLEL/r+bnuJB8Nf4lvsef xff4PH78XsXPZAwR3sSHF+8NtYL6aE7NaXhrzUWMfPa00JzF67uoDC4KZTCYse8IoaapDAilvicv IT7fwysgj17UgZPWouxRiUoI3OkUew4CximLOigUAK3wDm5/kJ6AAJaTHXpBOi9pd2LsU3A6/Qi/ l+NwJAPoGv/jQl7x9dFhEhArBDc6yQKQu5g77Tg0ZLCI64sOPCObnCinRPaAf54+Eli4H6AMBpFm K6QQuP1XLku2eQehKAeD1vAmdRYmwA4IA7g4i7MH2B2oWQNRCo4NRJAAhwL0XFz9OWwYmRRAFDzD gEMKx88xCxDAb4UEuJ/mfggYUmLFF7DiC/yX+Y+oXlOW4K/XyhI8eUVwRVXwB5PKj0kZfPyN/ZpE f1QG5BcMw+tICl/E9/VtVAWfR0H5Pn5EPosf6VP7cvh7VAKnlpTByEpgZ8/8OzeWymC363YjVt9S GYSeW1JAHbBKiKt+t3OOHkkRxLsj/Hp6ZGXAqiB+fGjFd7LyqyIIZE1CCcQPGhQBVnU8h2xBx3ue 6DptlZLdhy6ZhqIIaLsUlmsxCSOLYUyjNEnk3UvSWzFYk3KgodiJ6BYyBmVioVADqg48ZrkYTpKk aS4IYTxmK1i2VuET6DWTJlNLWbEYhl7LjNnjs8gGeBlhrm3K+ZrUdgSZQiTNaHN7et6eLPtE5Dn+ 2oEcpGIw9RQosgPHSeBzrlxVc/BNT/ecsS/Q/f0f46fjnZDAL/xaUUiQfYFpluC7Rkhw/2rgvmno zsnAx/Xjlf9o52QQz0/eN8MEJYCe1liKEDyudzFgjJ9LJgbH4Afw+TkhBgojnBBDBGwEueP76CdZ IQMjwJ8TAq/pHdUKipNA4YYzuteAjMBECp774CB8APBBDCAANQ8Bfum7lAgAZHCokswXoYAtQwMr /Ut9EQZIBgHgp3LMEHRkG30N8OdeBJxnMJg7SbsTYCxmAkADUZlLyWEAwM/zCA21FcwzC0vgE+Kd FISl9CBXB0bQj8UGIouiMmQHSA2c+/Uk8KXXoiH7M0qIW6nCxxQSPMA6gkNZhMkhG5PqEuTXcGpT JoHDhCj9Th1VFVAX5O7FScT+pftgdv7sPEq3E0k9Xnw0l3sbo4iTQKnFiGUzUPqHmYPW+KgJ4nf2 Hettjo0J0pRJoGielkCHjgEBkcOATAKnFzvv8B2cLXAs00kw4JpjsHOGgSIP6pUp5MDOulOVwHQh nkD8ofEQMgAinYCeSYByFgC7S91F0OfEJGUQkjqYK4I8ksEVPgGSAx6/jjfaEKyld7OXX0z6hMmA SIDvQK0FVn/JGjgpUvKcNeEyYc8jxzh7EGSOgYXp52UisYXsdw5+AYUnLPMx39KjvVh8x3j/iOEa ATvEdy2ADKinwCCKgHcSRgKI0clDJIEnXVl4gywC+QXfN/2Cn4a3lvwC5/6pkUl4Yag7zMcYVp6G 3nLvivP4OTjp2bu6jH967RlEMonA73tauHa8cXbskEuiykPLqcQO5z1BV30DYI3MAa5QBB45I8h9 FoOU3TgZdOJQigj/oJOaA/4w5owAeZLIGUomATMDCZXwJtLMAcwORLwgtfxBqwbHPGZMWoq5IPMF gjQodaP0bCr+AyhlWhNRXG5PRquzdBXmR6cTiWVKtLQZ43jf6LgxcvexZZs3Fbk888HxNmuro825 AAgZAy0eor3ktOPQF14AlwyP3IKc/ybyAHCNCMKRWnCB29NFTcXnBPyBmJP3DhD/jFws5C8pHdiP yA74sIoEqLz9Q8sctKGqFzjoCxzMEoQHAMRHFiI0MwnTMOEsCsYP9hVlEWKYQIIxvDixGiZ4/67O JtC0up2cs2/Qs5Tf0dedhA/sG5Ash3fQdTuHzAGFBT0tMHweNQWt/OILdDin8MCQNeC7OgSQ59GW TKoJWSVAEXB4QCu+z9kDvidgXKtUF6aBClJDYPADJ2qgDBPawYGdDDj1Gg4YDISo5hbwAClkCvhc QoMk/WGGFiPqCY5jChkQAui5yH6dQWHFP+B+EQOTlyvmESIrMHgeZMMr/iUVHeR+AtxijEKCILtQ +5HnEFzknYTaFXsVCTQyBHW9wOPxBR44EVyfDFBsxGXIklZcQwYXtkwtmrDjr8M+gn8YOi++QWki srFIPgKHBR1LeVp2Ok4NRvA7X3sHBHiWE70QBgiAwW0LAhDgs+EoRqEMVCme4zEPVsMEmX7gNF3o xBtgcqhShlOzML3Wdm4UTszCyh8o0odiFloUTGA+kpAA0ocUJqiXABJInkEyDAm0IxuLSgBGPQK+ H5OqTBpESqEFfAHMtiY/QKZaRaCPToqCkh+QCUE3EE1JgOoEaBMRNq2d3DIJPFxf4KERwQEy+HZy fZ15uIYM1EAs6wzOTulclYGQgWQU+FokgV7MQ/IGuKSAAJ+UQqEOGLh0Q++o9sB0kgWw1IxECMEo 2AF8rR1wBejL7EEiBe59OjooARCD1hEkcjBlPUEGvDNFHUFoeAR5bAsasiffIJT7DtB8TNOiplAD ySzEMJMM/jQ8FTUFKWMgGYVKAYAAVD1YP5ArOOqkKswiHLkrtZW4P424Ew/gUkaT5cxAN/JW4gvL +wa0bJgnFt8/CWxEcLUQoVFsdA0ymGYTvD+3POok7O3piUlhQlzdrd8Ht0/kMFJpgdNQIaUYad4N qwMKB3ZMEqwAhAxIJXSsGnxOC6pCCLrae8kcZEIwmk50AL5mD/i6K1RByhbwRggogzDZbxCCnagB 24wOfPmBBPhtIgeEAx6dGwH6pBYU+GSDdh6NHyVEqNKFnTdFJoHT/ilkQMZAexuyAjCD1/H2VkbZ paE1slU4qYCUGpSGIjKEJPcZVFPwjHsNpkY29jxoncDdkYASwcMjgQdOBMfIoFAFVyKDeZ1B+Hxv x+FNBNkJK4JTAv5ZT6SRfIOwM24vvkEKFbyohUodqHeA61Q6iBRiL6s9QgMlBJNqBUJXewLWzkmB JL/WDyBdCGJwPP091Q6UKqAICxAutEKCpVoCLlIOuZ5Az5UgAHj1D9Kqz0MkixBB7itXfz43GfS+ 8A+sPMexv5BADgP0vuwFWBlZnrICru4loKGATiMiUxAzCJQE4uPbEykWyn0Fbp8EHl5I8BCJ4IZk EImAditemwzOIxmYRAbUJr3pG0xChVId6HUqTy6/BiHAP1Bgd5IaVA9BCQEpB1UJ44wU8Pzo4AWQ AhiloCgURmFWA84VoA+2MAuPvREl+HECwEuoUJJCBXwrBUQUPhTKQExDW6z4nIn1vXgGAyuD0eSV X0FP2xPrMEDvOaICXB+WTEFqMcYbiKSxTVUx+MxI4CESwc3Mw4NksFSBmPcmEBkEX5uIpW+AUOFj DhWW1IFI/L44ByHEz9VE/mdC0L0EzpqyojAI+J2CP5OBcSXwHeOC65+56rhQBqFUCcfUwFQVOAwr KsIDrsWuDMOCGJIf0HkeJGew98BEVQDwk4IoyQBhw1is7EocmQByx6AqDBi0r2CtAqiDtS1CARpO WvsByAzQLkJtOFqRQLNO4NZJYCOCh0oGnkngF84oqInIvsEkVAhRIbTUAaXW1xECQgYT6nsTSXQg gxAGB9mfehPYZBg6BX4ZIvAMJVEDnWw9xjlvcpwZhLievxbQF8ahr66XSoBaI+g13s0YAHwiCgkF +F/V1eDn6wT+XuQ/Xad6wQMEoENIJ2QxVwEnUQWMYRoKUEOR92lIKVqLqSlIfSyUBLqT+D1/Qzu8 9SRwrTThgyKBh0wEt04GzToDH8ngqykZwESc+gYaKlDtQcoqnAxW1UEwvV0OFy55pT9ICFwVCPAz KbAK0AzBUCgFWvFHl4AvagDtAKAGXKh9ghDqzAETgPPL770vCcGKH1B4BSkEQHWhNRPTMK38PUBe gJ+up9U/+QYID0YBObcmOEIANFVeMwLqBfB4clYBZ5wZOBQK1KagdheiDUTvUufs50ICT4QIlsgg G4h02io6ouu6hVkzClPfoAwVjqkDKo7L4UJvZ4TA1bS1QqAGRKoKOlIAQTyCDo+EtC6FB4MQAz0n aoFW/c7V3kAB/JQ+dAUJGL/ifS/IgMGeVQFKjycKYaTqIQU+lTVoWMBlygA/+wW9GIUgB6z+dH2X swXDGAY3IYAI/GlKkAoV2QsggJ/3oVQB1G58dShQ+QGvuLHIcyKBh04Et0cGCxWIxvzWtE3EVqgQ SWFBHVBTXcosmJPepnCBdsuKf0ATzDIhgAyYEPhaJ2nA0apK6E0HoJekgMJ+1wdNEZbEQEE7HrF9 hLw2VQiqBLqiS9Ehr6AecGIL0DM5jIxCnFegB+AV+JbBXygCDgUU/A6qYRiDrui0wo8pPBBFMCUA AvolJliVYUCaSExeQFIBL7i34DQ1WIYCLRIodxHmvQMtT4COp0ECj4EI7ogMjNFdi8fJQEOFJXVw aavMAhEApRpFETQJgUDf1Yqg75UgOvEHcA8NSu6Ct9lIhAIIKVzwvGURq3xvyhABL5Vcr77mj/qB l3yQV94FKTiQbupOtyijA1MCvWMtZEtyGD3OrYYDci7gJ+BjxY+rvwAe18fkF1xa3FMSgLF9qMKA CH5tM65eQKUCDoQCLT9gHQkcMwYfdobgsRLBrZPBIRPRmF+baajwBZPBXB3oXoWUWaA2/EoIJzQc qUUIEjKIMjCiCFQpEDF03aVkBogULrHHgO+La2ypFjRL0IkikGIBXKf27QUBGFULRsjiwDGqElBS yIQwQPIbO1UEA4oOFPj0/QN2bnGf0gx+rPbD0IVq9edusvg6eQBHCKAVBpAXsE4FLPsBd0ACGxHc DxksEEKDDNq+wTp1UGYWKFxYSwhm1/NzmmVgVWCyAihJoVIK3MAHz/N9HR67IOMIgpM6AQ0TyBKY KIKjqqBWA5UioH1+1skks3xusF8YRqECH4Pmg8p+Xvkr8Hc5PEjyn67Hf9xlH4xtEcApm4AgABiC GDayrzICpQrA4JEr+gFMArKL8BmQwGMjgiNksFIdMBkgo9AyEatQwX9uaRd0Sx2wKigyCxoufBYJ gJqesH9QEgIRgHgI3K5fsgxhRzt0s0oA0C/YO1BSUKKApyD+AIN5Z9rkwAxge/H3p4rAhBVmYUsR 8Co/iEkYAT9cwoXkfm7UlQyAT48R+IMF0FvgL1d/rv/nOoA+JBPQRUI4QgBLYcCSCqBOw61QgB6P m4JPkwQeIxHcDhmsDBXqrEJWByGqA92rEEIkhCpcWEcIe5rtqWlHnogeH5kUxEsoCEDDgikxZMUg aoGBn88NnxuD7025QSGQw4IAU9UKVcDdHS+FIDohhlHOL0ESgwC+AD7UAZHGAvgnqz9d04pANgFT CDAngJwS3AeEATqIFGXCLPtXqIDlUOBGxUKPhgQeKxHcKRmsVwdL4cKUEC6sn4QMGJMYH4uwIamE ihR6BvVxYgC4g8nnPV3fKTGk4L96XbJa2AnwS29Ajy4oMfBzl9R9RBWAMQruTBZz4MP0U6WQwT9b /enaeR+UANQEpPMpAaQw4F1UAfZQGLCkAqahwPMlgcdMBAf+7WtMRHMkVDCmrQ6yd0BTl65CCOoh MAmwSgD4ZyrhKCkQmPemIgb+ZCs5ICyolEBBBmFCBodf4K6YkFaCnV+N/PVQk0IJfNwzB3+K/ene 8zGUqz9IYD0B1GGAZARIDTRUwGJWYLUf8PRI4LETwTXI4HbUQc4sIFxA2K3+wQpC8PHxTAlhohKE FGj4LysF/uFzYgDQs2LgdX0C/JIksgpYRwQZ8BoyFGAviCGDHuqBY3l6ugF8lf0Z/Limz1mHR/dx F95XhLCPP/ONOUYANAmrDAPKjECpAq4fCjzeOoGnTgR3QAaH1cEhQiB1QFOblwjBmJeGiGAaNmSV UJMC/xUnAH9SC1Ni4K+n5FCHAWV4sLsCEVxUX2ew52sAuqEb9ZzfEIBb72nJfvyAlau/eAAAdk0A tQ9QhgFXVQHPwxR8ykSwggwOhQoLWYUFddAMF5J/cIAQQiSCl5EIeFdjrRLo5zRJwZwB9KVaOBXg R2I4KYEv5JDBn0mCH/fFtbUvqoDZKCPoal8Cnk8moJd7Cfi4Xst+JCWm4Kfr70xNAJoFOInPvTbX JQB6XK8Cnh8JPCUiuKaJuF4dtMMFarGzTAgIGbKHQO3WkXaESsD3z0mh9BOIDIIfZsTA18NQkQPj 3SvYT+owYEYCJ02/IIG7uthXKkDPl0CPRwBfzxX41GX+gzsEfoQBZRqQfkY7BMgEsDoMuJIKeJp+ wHMgglsIFQoj8ffxvzct72AaLqwjBEo7fsn3QiXw9Sp0IBIAKRjzwkAJXNgX8dyfXgoB0M+SsEFC iXTOx1la+RNJCPBNGK/+fhfAV7DPAJ/I4oMpV3x93sVV/x2fQ/bj+Qx+fN1a/YkE/s/ciACYBKbF QWtUwPMhgadKBNcMFVaogysSQukhlFkGep5UglkghVIpAPg1MTDcfVQPn2UCUHKYksJUCeTn1oQG uzBXBh9mz5Wg1xXfJODnVR/X5uAvY/9y9S/lP7IAxwmgGQa8jATwfUkAdKxRAc+DBJ4yEdwCGdw+ IUChT0kBXkKLFNhcFE9B1UImBvp6X4CflAP9DBDEHPRnuObX+wTWZeDPyOE9ATGv9Pn5csXPbr9e U9nfAj/uqVd/EECZBZh6AAcIYFMBGxHcrjowVyaEaZahrRKoRU8OHaakoJ7ClBhUMZTkUBKEqoda CVzM/sYXjVflXVMZ7Cdbky8KNbAP+Z43BmDNKz4/FsDH4xrwT1f/T0UAz48EngsR3I06SP5BmxCm WYY5IRCYs5dQksIqYuAsBJ29LAggEwSOl00CmBNHqQL2YTlUyGAvAd8CfRv4OeaH7D8MfpX/AP7c A+B36CgBHAsDVqmAJ00Cz4kIjvytt08IxszTjmtIYRo+ZFKgIxNDJgd2HCoCgHrIZLAE+vUhgpLD m/RART01Ibw2JehbwNeYH3ZDDX46llZ/EEBOAzYJ4KAPsKmAjQhuTR3clBBaKoGOOSmUnkKLGKbk ECIhfFn8K31BFjwhuqkW1h151X89uT4HfCaOesUvgb+88rfAX8v/qyuAGxHAsyGB50oEN1QHRwhh 6iHQcQ1SOE4MetQEUZMEiEL/tyaItURwGjLE52DPK30G/RLwy1W/JftXg//aBLCpgI0IPgkhmKMq gT+iB0jhEDEcIoc5QYAk4D18uPH7DKDT0Qb7MdCXq/5q8B+U/3dCAM+SBDYiuBdCmIcOh0ihJoZj 5KDHr/n//fju1t9f10WgM87/p7p+CPRt4NOxAvyz1V8J4LvJv2wjgI0IPikZrCWEq5FCWymAGEAG h8kBHsAvB9/POWEcP6YAn4cONeCnoD8E/Fr2M+LzN91o9b8SATx7EtiI4M4IYYVKWCIF8RRKYlhL Dm2SKI/fXuPl+O/m1SnYl0DfBH5r1V8N/o0ANiJ49IRwhBTMemKYk0MmiEMkcRtHC+wt0M+Bf2zV L8F/ldV/I4CNCO79NboNUlhLDHNyaBHEMlHc/JgCfQb4JdAr8OlYBP93jZ+8dvXfCGAjgkdHCC1S OEIMB8mhIAg9VhDFVY420PX44/wbFkF/aNVfs/JvBLARwaMkhDWkcE1iKMnBHCKJOzpeTtz875du PAT8OwP/RgAbETyU1+66pLBEDFNyOEAQS0Rxk+P7Yzf82+QP/m7hvq9XAvSbcM2P7EYAGxE81Nfw JqRwjBxaBGGuRhhXAvgasF8V9DcG/0YAGxE8BVK4DjGsIYhPdXx9TRB+E2740dzAvxHBU3ldb5sY bos0vr4DkN0Y+Bv4NyJ4Lq/xsc/5t4/gffsm3MFHbyOAjQg2Ylh3fEqS+Cbc8UdtA/5GBNvr//hw cisfpw38GxFs78fd/4rw0D4eG/A3ItiOZ/YebaDfPmTb8Yzeuw3w24dpO57we7wBfDu2Yzu2Yzu2 Yzu2Yzu2Yzu2Yzu2Yzu2Yzu2Yzu2Yzu2Yzu240kf/y/AAEBsWH+TasNVAAAAAElFTkSuQmCC",
    transform: "matrix(.24 0 0 .24 19.92 72)"
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    fill: "#FBBC04",
    cx: 50,
    cy: 98,
    r: 18
  })), _image2 || (_image2 = /*#__PURE__*/react.createElement("image", {
    overflow: "visible",
    opacity: 0.2,
    width: 484,
    height: 484,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAegAAAHoCAYAAACCUHwMAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAArkZJREFUeNrsvdmWY8lxpe3u5yAi M2uiqiRxievnXfO/UF3yBeol+Dxaeh6+BPsBeEldtPpOvaSlFlliDZmRETjHrd0Gn86AQAw5RMa2 KuQZAMQAIPBhm20zdw6BQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBDvLzwe AgQCgXj27+mEhw6ARiAQCMTTfa8GyAFoBAKBwHvyEwqAGy8GBAKBwHvww9j5Xt72AWwAGoFAIJ7T ey49zR8bwAagEQgE4tN4jz2XZ//8jt7D/4ne6a8HYAPQCAQC8fG/r97Gqn/+yN6nb4P3nX9cwBqA RiAQiI/l/ZSeCIwfA9r+oQ8KXlAIBAKBeFfvoY8J5D+95/ftb+8Bzj1gA9YANAKBQHzw9056IJDP AfHvTlz3L7fc/x9vgeDvHxHcW8A+66EgvMgQCAQC8QjvmQ+B8h6Qf3cH6L6rWML89w8A9r1gTXix IRAIBOIRwHwOlLeAfAaMv2v2f/r3d/Me/sWv6i/0h3OgfV9gL2ENUAPQCAQC8UHAvITy786D8SaI f9sfvv2P7jbf3vbxYHnixT8sfpk/7sP7VmjfFdgANQCNQCAQjw7mR4LyLox/2wH4FHivr/9yr/f0 y8tv6FaQF4D/cVtt/+FchX2bsr4TrOkZvwgRCAQCYL47mO8A5Q7IFcbfng3g38i/0/T9g97Px/Fr ++X+9SyA/2kP2psKe09ZP5qqpmf4YkQgEAiA+Twwnwnl394O5DWIf3MSwNP0w6O8l4/jV3Qa4P+6 C+7zgX1XWLegfl6pbwAagUAAzo8G5jOhvEhX90DehnEP4V/LvzH++E7ew0P40n7xfzsJ7yW0M7D7 tHgD6z/+im5X1g8GNT2DFyYCgUAAzPcG83euSV+fgvIayEsYL0E8zz8vfqZfGrBfe/f3d3wU/i8D +TP7hf+zu2oYPqdT4F5CuwX2SVifpaoBagAagUAAzo8J5g21fBuUK5B7GPcg/qWLf/u6+5loerPz M36jwJ6vNq8Pw0v7Rf+y/eCMr3ow/5kB/p+b4FZor4G9C+uzVPWjgZo+wRcpAoFAQDWfBvNptXwu lGP8agPIPYx7EH+zAi/Fq53f6292ftf/3n5wwktag/wvm+Buod0D+we6F6w3VfVtoP601TQAjUAg oJrfIZin6ZszoLwN5Di/8msI/03af+t/sfgpYzq3/ft9tTj+YfNWIbxYQewHOfffK3hncG8Be0td b8H6A4CaPpEXLAKBQDwn1XxbOvtUKruCeUstnwPlJZBbGH/VgLdC+Ku0f13hTWn/i+XP/kWjsG+8 QvaigdRP/c3TofeXi5rzW1oCfAvaS2Bvw7pX1ktVvQJ1l/pe1qhvS3t/GpAGoBEIBFTzXVTzncBc a8rbUK7paoVyBXIs2xd+CWGKlw20r/0SzEQ3Z723e8/A/mmhpCukFeg/dfDW639YAftcWC9V9d1B /XzUNACNQCCeKZwfD8zrNLaCOdeU499+vgvlr+LLBshVGdPnvP2iqN9yni79UhlrfJauO97rPd37 Q3pQXrsezPm6a2rBnaHtf94D9hXtw/pn2VZY/0B9+vsvdHdQf7qQBqARCATg3MH57mBeprFbtbyV vqYE5V8soKwKuQdyhnE+R3TRpLVv/GdyOzv3Kp+/G6QVzineZAV9Q6+Lus63uaEW3AztfWC/JYb1 X+W6FtZv9PYJ1mtVXdPfJxV1V58+J+39tFPeADQCgXhGYN6C8xmq+e2vSg+zwllT2beDWdVym77u oJxUck5Xr4GsirgD8asKYIqHBtYLKNPhvPd2f6RNWAtcj1TOvenBnRX3NrCviWHdKus2Dd6q6i1Q L1PfBdIC6n+n+6vppwdpABqBQEA1n62a+xpzC+YYP5chIQzmVi23KWyuJ7dKeQllVsgFyC94v4ex Hr/kb+JbMNMCyGTXuxc7j9TbDORxAegGyg3E83EL7fC2BfYNLWHdKuusqvn6Hxaq+s6g3kx731ab vjXlTU/oBY1AIBDPGc518tf/2ExntzXmqpiXYM5QlnOmlveg/LJRyAzkooqp7pPsJ/gyeGksP/NF nBo1Pd4xxT0VON2EBth8/q1CvAO3QP1K9hnYWWFfJYW9D2tV1QpfhfVtoF6bybQ+/b/z/O/HV9P0 RF7UCAQC8ZThfI+U9o5qfgiYt9TyEsr0UlUxJcgKiA3IWRXTZYKvQfdCbmMAzirajb5TzeUhuAXU DZhbNe2dnc/H6XbXop7Tcdr31/m8wdm2cj2D++pAS1h3qvqnn8QRfh9Q76rpTxTSADQCgXiGcD5H NZ9IZ//t56sa8xLM9NllB+VcU36VwBtfHH2nlBsoC2gvR6+q+DLdZ/YM4w7EBl865FR3hvG8ejzk /u4ia+QEx2EDQgO1alpgfVMhLiqawd1A+6YB9has+Tbh7YHelHPHXlW/Tqp6A9R9jfpn2k5736am z015f9yQBqARCMQnCOf7pbRvU821XSrB+EwwF7VsNeVNKJtKLgrZgJxh3IN4tv0hYc+A3ECYlpCm xfEC0N7l45ty3TFtvZ8pw7uA+2hQboB9O6x1e/V2R1XvglrVtC7moaB+XDX98UMagEYgEJ84nG9J aZtDe081b6Wzc6vUl3cFc3RhSymvoHzQbQZygXHaFgCPab/AtwH0EsgU14+VD00LVQPooqTTdpqp ADzBukK7BfacYHoZV7C+NogXSLt4DqiH4csYwnXXolXT3vtq+lOFNACNQCCeOJjPgfPtqrlvnepV c19nfuG1XcqA/PmFn6efwhaY46xA7tTyhQsrKDO4DyeAXGDcQLmFddoXWPF1B3tEBMyHnYfxmCBs kD6mDyMZ0r6HcgV4ArFBew/YrK4FxAtY+5t0rlHVYXgZ+bolqIeBIZ6Of77ZTHv78Wqlpsfxx3XK e7dn+ulBGoBGIBDPHs5tSvuUau7S2cWVzSD+OeyDeeT7hKKWGcamlGnk2zVQjjfpumEN5AzjtGUI 05jhy/er+1Uxr8HMX2ddfz42apqvy+Cu+9OkQM5gXgM7wTp95OhgPTGUNQ3O0M6qOoT0w+2AOjCg F65vBvWPCdR7anor5X1eXfppQBqARiAQzwPOJ1Lap1TzKp29aJdSGOdU9si16cBgjpLO1jT2Id2G 1XIk3mpNmRJyslImPm9Qlv0WyKPCO0Pc2fmipLtUd+KXGxsFfeIBNTBP6b90tE5t+6yiW6U8bwCb wWqwTvtZWfv0KC1V9TFBeA1qF3PqOwRT0Qbq8MZF2SZg/7CC9GcJ0q+7lPe6Lv20IQ1AIxCIJwjn Ozq1GzhvpbSrQ/szf1o1r9PZLxjQL48C6qVi7sB8GAXaDNgxGoRFQfdQ5uto7IFMcr/oaQg+Q1gB nI4NxMT7RUGzIM6AHheP3aSbOTQ9zyEBN1Led7Y/80+e4O1n3qbb8HHS+QXYCcqTALiHNStoPubr +HZBjhOYPW/XoM416uH6VVTXd5v2PqGmv0+gLinvc+vSTwfSADQCgXgGcL5LSjs7tF/4L6a/hr10 NrdLzZdvQmv+igknSzDnNDZDuFfL6Xw8BgZrD2WDNaXrEpBHSXNXGFOGcrqOmI1yXQK2i1aH7o/3 H1gGcdLPpqTzscI67TOUM7gN2pLy5vT2zPuHmKHcwTpDms93qprVcDp37EFdatRBlTQr6q20t6rp bad3m/Ju69JPHdIANAKB+ITgvFi3+SScv/R7Ke191cyp69ehrTMrnNX8tQtmqTsn+A58LgPYhWE4 BgZve46GmXEWCpD5ugJj3Y62FVUdTDk7g3h5qG5R0I2T27mqmtMvqGo5Xfg3EVjnrYCZ4aq3Z23v Z4NxUdAuchpc9kVBM9D1fAF1o6hzjZpBLQDPae+rA70VQN+k488jzwLPanocXfzhrLr0o0MagEYg EIDzPpz3epz3zWB3qTcrnC/TdT+G3DoVZx+20tlSZ76c/AWfT/u5xhxHBfESzHzJalmhnFQywzZd n6FMrEPtXAbywLfl60KGcIW1owrmIMp6NFifE/zjsaMrwzqrZoVyBrePGcj8hQ3YM8OUgZ1+owJr BmpOgzs5nhpwZ1C3qW9vqvtGnOAM6Zr2zmo6hM+sTeua0q8Xc8r7p/EX6fzbVV368SD9YVU0AI1A IJ4wnG93av+PW+vN+yntWcB7IyCuqpnboq5Cm87WdHUCtID5JhyKGm7A3OyLWrbjQc71UJZzbgqq jllJT0FT2wrnEAzSAvQodekEPFPNZI/DsJvm1nT2nI+s9kxaby416PQrmZpWBc3gVRizyvZujLM3 SBt4eZ+r6BnGLoO5S3/3oBYzWQL1Mu3dqulcm95Keee69HD4OnIr1uNB+sOnugFoBALx6cF5x6md 68288hR9vZ3Sjq8SaBuHdq41d6p5M53tVR2fALOkw7NaFggnLIUG1AXKpp5JzWEJVqHAWM5Roqr3 kolmMIsG5n1f3Nz1cRoWj+fcPtz24PJXrvucOfdOga2QVWin3z2qWUxhLN9YYO1iBjP/l0E8L0E9 27kM6wTmo+2Lg3tSx/cN72c13dSm317nlDfFvbr0cJnObTq8nx6kAWgEAvGJwDmBOYnm1qm9ZQa7 PaVdjWCc0o6XtdbMqpkOLlxYbbmqZktn236M8zA2xyswNxAXMAuAs7oOCchJWzphbgVyEPiGCmLy cj3DOFQw67ny+O28x/tmkhhRORezijY4V3DHnOZW2PL1LLDH2MPaANyoZCegTkCNw5xBPdt1FdQ3 cRqGuVXTy9p0n/LWdixxeTcTyO4G6b0WrI+nHg1AIxCIpw/njTaqc+E8TQmMp1LaAmZVzRdxSLe7 Dp1qnueBxosKYjF/SfvUsALzIHnjQW7jDMxUFfYwZMOY5KDTtQnWNAfDaMgwLvvSzVxVNDWKuj6M C0h7vzCHJW6yOdz2FcgZ1KyHm30B9pDOqWrOwFVlXQxk8x6oE0XnqqiPcY7puLndJGAe5rY2vZXy fnvNClrr0rkVa3jTQ5rr0sNf/y6eTncvIf0nWqvoDwdpABqBQHzCcN5zarf15urS1hrzwb+wlPbS od2pZlbJi3T2EBi+BwFsYs+wDeaxAXMcQsjKuYWy9Evr+QLkBtbBVPRKTWfVzMVs9nPtPOJR/ncZ xFVJG5wN0gpug3IGcKTcWhWjV9WcQc1fOcYKZB8n9tfNBdQJ0Jr2Psp+TnPPCcpFTc/zvKxNL1Pe Wpem+MZasdp+6dbh3Srpk5D+SFPdADQCgXjicF63UW07tdUMFpNi/nJRb+5d2joNLKe0Lw7VoV1V c2Jvk74e4twcD8PQADnDWcGs5xjGCmYanKW4FcoGa7kup7Sd1qUNzlqL1v3AoOaEtNuoP3ep7q1H vkltF6nNNWcFdRQQK5gV2gxcpqaCuId1eqi9n1tYK6jDvAK1qGY+9rNCe5Dzc5yLmk6fbeZSm56u E5gV4DcJxOGmQjq3YmXzWHZ4n4J02yfdze6+P6QBaAQCATjfHc7VqT0fvw9rM1hTb750YZnSXju0 uU0qwTirZgbvcLB9PZ/+UTAbjIdEbAqjqGUFMxmkB7lNoBbKCulANf2t6pjvp/XoAuO+Ni1EDrkm 3eSztx/63sUdG1j7WM1hFdoM3KqcxbnNie4O1gpkVdVzuo2fe1BPAudYQB1n/bp8bIo6gVlNZDfc Xz2r03uR8h7T8c3bdKyzvMO1i/eBdDe7exfSHzbVDUAjEIhPGs7zNcNzbQZr680vLn2ZCLaEcxym oXdoD0OnmhOjGcxBFHOCcIJxlJMKaUejpbK3wCyNVfJ1g5zPUJYadijp7wzkQFIsriDmxLQBO7iq oq3uTDuAVoe2a+rR7Nx2mtZuatAMbqk1xwbYvklj5zq0wTrdd84ubgFxB+p0zB+B0n04/z+n/Zr2 noua5sNpdqqam5S3HE/rurSo6Q1ItzXp2oLVjwW9P6TfT6p7xPsEAoF42nD+mo1eTY/zj+48OHPL 1I3AWZXzsbq0p5rSTmQZDvHC9tn4NYchDEP0CahsEEsAH+LIKjspZZf2RQ0nPidgp/OBIZ2ozIwW MCeOuJiOAzM6HUdTz05NZRnK0kTFHwqC15q0HqcDL83KTF8BcPov8DaSDi4JzHN9jL0x15VidFyY xLhVmhkrX4qi5rL5DnIsKWtnXnJNY5tSJsrKOXJ1ORu9Ik8AZ7U8s0JOPylPPyXGaIKtlJPT45pU dPqBAxM70Tid9AOjfUhkno/pS4S0O8g+w5sddyM/v2xm46L+PLr04ckdL9IPcKO/Wbx07sV1eknw J5vhMvLjNL/6MbgE6a/SuR+O3yd2fx3j36aDP/+c/vmKzYMKwfE39K373v0pvZ7ciy3I8mtwCWl6 L/oWChqBQDxxON/e47x0ai/7m1f15jgOq5R2VAPYMMyWwh6GtWoOg6S2IyvmnNZmGPtGMQ9ynlfC cGLj0uPgzSS2WZNmIJt6NnOYqu2qpHNquzWLhR2TWIyazjYR3dSic3qbFM4CbVPRXvqjqxmsNYjx saxn6VQxR1PQCdQKZ05tRznPTreowJ7Z8V3UtKS6uRDNLVlcsmZgc+1Za9O5Lh3CJEo6Pb7zKSVd W7Ao8jCTMPL55VjQnfarj6QeDQWNQCCeHJx5AMn1mQNIMpznSWAnTm02g80vE4Pml0Gmgl28CIdp HiS9bfVmAXOb0h7YtuxECYtDW/ZVNYdobmyn5xI8BNLEeeuk+5woYeIln4b0TQev8zIVymTHsq/n 9PZe4ZyELMtOBrJ0KDtR05x/NpOY1KItnc0Z6qiKmTEbTzwRooqjgTkPJnHqD4vZLMbU91GB7UvN WdW1tEhLzdnS2oNn6Zx+/3R7VczRFLRnA3b66BI4kT3Iz+j9KF9C1TR3ekkSXdUze9bTZ5uBW6eT emaXN7dRH+bBHR0/ORMP/HaHtL+npDmGzy5jfOP8l+nMT/EXnn/4JKvTp4fP097P6dPOr4kzLur6 /4tzspZ0eo399o9eIc2vvd81kP7gfzAIBALxccPZ3QnOfRtVGT6yZQYbmyEjg5q9+JhT2rmveRBg M3zDoKpZ91U1py0rZgGtbp3UnrkEnW5n56qD2w9ZLau69qXdqjeKqatbJoqZku7arEIdWqKi2VsN mnZq0M0EMaOyV4Xct1kZjGOT1u5qzk4q1wxnqS2n30HT3QxqMgUtippB7mdZuJpPMsBZRYuaHiZv CpqL1kFq10lJi2ksnbK6dFHTsxnHtpT0MCaWX0kL1lXTJ50njv3ES31t9EivTWNtf/SHU9ED3jcQ CMSnDmdpo0r8FKd2WMM5xmmgMQpctYUqwVfqzUkKpyOBLqe0eTVH4sWkaByiHwXpbuDrx8Tm9Paf bpu2vGJGYu9I4hAbRtHkci7JxrRN3DwkhSy3Sw9Fuj4ceNB1EpNjerQOsl6k5+/lxqSo0309q+x0 W9b26fuz0HRp3/Pt5euN6TccE8I5bc735br36GQeit+4RE2vs+qVqnZkxLHyTZf0vbhmLtl0J+qf K8Q82YxvK01OfB9Xt1H2RZPzbcS4xtVxL9PQWITLSa9n2W2ePpvISpZOzrBk95K852wBa28SZg/s 9hJfmarpyOX89JMNMv57dNIFNssT4eaDY6ntZLWu9AgepxsnnxsSxd1FethvRvfKH5KWvkq3eZVk 9dG51z/LZxGiH+Q1GcKV+4fxlfuv6Yv0KP7k3H98kc7/V3o6vuPXY7r8ffNa/Z92/p/f2R8OUtwI BOITgjMPIHkbJk7KtnDea6OapqGawcaBx3VGrjHPLJMHXvqRBfKwTmknRrARjHghSIHvwGYyWe7C 1LXUmX0wsxiv7Oy1Hs12KEeW9ubr03WR08AKRZK1MBqjGP98nCJ22RzGtOO5m95br7OAj0/YylYK P7kqTxRrTGKmmOVfUcxqHGOJLOYwyWc7XRyDQrTDGMXpHUoNWg1isbi0M1sdN34JtHm1DlHMbGtL vyJvndxCStmR7W+DpLmDYF0HicbAgjrIb8y1cr4uRjaPHQTSSUmnr5zwPM8JxZruTrqdxDh2SJ/K jvpbvrj07u11NnNdR/95QvXPl+Gr8WX8IUGaJuL++IVp7Bt3S6r7HMOYfywVjRQ3AoH4hOCs08Ha ASRbYzvjOA0XNnwkDuPQm8E4ic31aM5e87kUXUo7G8GSuuX0Na8GGdj5xSlsJ2o7cOq6pLMt1e15 CSs/aCpbU+GSxhZ1qinuahRjkIsf20CsTm8dShLNKCbYa4xiDGFa7J98eroadNmXerOCWQ1iwQxi 1RBGVneuBjExfSms0z45S3XzCtI5ne3dFC3FzeBOD8XEprB0m6mmvNO+GMTGidPcYiyjUW7HWW9x dafb5HR3axwL8zhrn3Tat2Emw3iYeYGNvv1qYRr7/hUdDvw1dlLdXyRA/4Efr/ef6oaCRiAQTxPO O6M7T8F5nhOYy2SwS1HLrRlM683HtD3I4BFl8zRyE+4QJwUrT+qYpX9K1HXizejMEOYFxJyCVqUs qWIBeLouAZ3ESMYTQTWVLBD3smzVYJYvAbWozqYGLQpZFHdsjGJRIc1N2jLExNSzPPZL5dwNLzEY k4pv16joqINJSNeCjtpuJetBl5qzjE0h620uNWhRzVGW4BRTmBsM1GwUE+WsaW9V0/wzilFMerok 5c3fQrS5Kmb50VlJyyxQztbzpxVOdyclTVlJZ+PYxD/7kNRzeiouEv5veFns9DSI5+AyvYyua/sV f4xQ0xgb1V+54e/Tp4k//5zntisYR0fcJfAnWRXt39PehzGMAdAIBOITgzMD+SbkASTzdNxpo5rD Gs5iDDMntlfXNqvjBNc2pc3XJZJJHVhuz/sxEYGBy8p6mc52el0QhzMrbYaxAt2T1YKJDM7BoMzD T5y5t6NA2oaFcSFYlbUUdxV+oqRDdXDnx31pFLM0th2oNM7msHZICae4I2etSWxpMbdaqUGMbHUO 7YEmJ+Y2BbWXD0aS6tafV4At9WhxdGvztrf2ay5/W8qbK9q8RpbzCmNtQlNI868SDNJH16a7o6S7 E6TTViQ//wKHdLuJ76EfRZJGpitJradv/eomuDcv4lfpWFPdX/t1f/Reqrt93WYVza9pVtGP3xsN QCMQiE8Mzj8XOC97nBnMXRuVgTkPHxGntpjBpiS/Qqk3p206HodgqW25Dc1s+uLWqdFL/diNRTUT G7a4vYpyPVqORVmrw5vhZWlvPqfAZqAJqHnNKoO0Ga9KetuS0DJVLA8rCU6VqKW7mxWsgtq3csRW Qecnx1vZOfc863cgXRPaxn3yQyguL0lvZ/c2iUmMQc2mM1bMnFiWPqpZy+KkdWedF96qadtyZ1aU +rlAOJqNTJR0kJFlCuko1vFGSfNnKE5luJm97EnxjonPE1vu0j8XbuL2K5L2K3+k+fIY4nV+HZLU o+ObLz0PMflxvvK59WrgYazu13zW8WtvPcDkTir6wbVo1KARCMQzg3Nto1I4a825mMFI26iScBv7 ejOntBOUg5d0Nae7vR2XejQppINsncJY68lamzZIi1OatBdanNMkK2AMmtIO2lblrdVKEGW1Zu2f lrkdpc0qtKta5XT2XWvQcj9tr4q1zYpEknNKW+vNufUqUh71aQqatLXK5TYqEdm57sxbtnElgHvJ RnO71aRtV3zspnT/SevS6VjODXouPcC85dp0esynXJPWOvQso0NjPExSj+ZRoDIWdJjDPM25/Soc j/OyHr3VeqXzuncGmKzGgG4tS7lZi34QoKGgEQjEJw7nSxvRaXC2lag24cxp6jAN0dLavM9Kmluc kprjlidWxQrhdJz4K9Dm66XWnLbeVLPn9ilvw0nE6a0GMVHZsg1iBrPby5ATVcukDu68iAYj2HlL cccgiphEuLJXTGvQue9ZWp1MRd8qwMjUM6+4oUo6Uk5zSzVYe6NJU9sCa/Ze26IZ2uvMP1vMcA7i MpeaOvdAa292Tntr3Vkq2PzryDrWmro21SzX209ONhtN09pUlXSQYaF8zI4vrhbw8zenjwQkn33k U4Uoav5IcJGuv+Gu6VyPnusQE/cqXbpUd3V15wEm/Dq8vv5XfRy7MaD82n33KhoKGoFAfBJwfskm sBbOFz4cJnVolwEkzGAb1TnIIhcZzumGktIOYgrTgSNcS+bt3KhiPdaeZO1NJgMxA5nEve3Hqppt YAnD2cWRx047GfEp60cOltYWF7c3g5jmpa3NykZ/upBXr6ouboWxPPbLy+I58TXlrcp464mi7mLQ LmM+8+pWZEYxS3E7a7mi7OJ25uJmxZzd2i4PKMku7jClrzGJ0zspaQpZNZuSlu3QnVN3d1bSkWd5 T+kDVJLJNLHTj8/POtskqeeLaeJhZJMOM+G1pNPTy+7vGMZjUtEkHVxi8dtwddcBJh9eRUNBIxCI JwNnXcv5r2W5SF30gvwazjq6s6xGFXUN52hA5pWo4nAciJdiGBxbiDWlzYXNINDllqdsAGPgar1Z a8kJzkHc2zWl7WUICaevEwPHqpo1ze3FVBUG63WWY2m9IjdkMHMdWgZ/kK56peYxGePB1yuURToL ZQ3YBumQtbDzWYA2dG6eJep2smC15a1IM97iK4uU69GaK4/qJmOBWuFMZhRTF3dIijoGHYBCmgGw n7e6uIMa2vSX8JK1l3Zr/i6DqWanbG+VtNSkNbcu08sjWwRkmkp6Cmf5RmN6NOf5gsSZzz3S6bOZ ExUtC2sQHY+iol++uKC319I45peubjd8Q7zISjaM8U9QxoBmFf1d2v7h/ahoTBJDIBBPCM5vF3A+ JDi/Pg1n2oKzzNcubVQ81WsQSKd9XmZKUtZOziucOXXtDjLFS1zadCCZBmbnvT94ngLm/IGFT/pl DtxanbhxELXNUE8MSUTSyV+8LxPCbOJXUuYyYczlKWDs9ubZ1jJFTJW3y7fXVHpw9Xb2Xh6cpsl1 P6g73CaG9RcbH6poL5chH3ub991cp/s6T0RS1E5da94+HtgUsSAw1hS8s+4rGfPts5VNr7AxpCRd Y6XdSm4XvJXDl+nu9NWClduDlcqj1gRI+rJGMY1J89lw0H3Oc6Snjx1888y3PciXPByThOd9f+X8 i1fOXXudMsaDv90bF97+ffpeR5kwFsKLOmFs/P+du/lfvk4Y+y/b5gljjztdDAoagUA8HzjzABKt GxucGcJNG5WavbSeLPCN4tiWHmZWzFHByspZXdqqnDWlTeU8K20SwPKoTW3FMqf3YH3Ogy2EMTB2 yAaTCDgttU0uG8QstS03dKqiyWUVrcilRjH7oqaLHO6fOLu3PmM1xW33cJrXlnqu04ZqIk1vSz2a H1pzds9y3smQMSbzTObQdjp4JX8g8PIreXWda8bd1LSzNbRUYutPSlZFp3Kd1paDKnxW0qQrj4iK 5v+ys1trz9zGpvVonu7G+Q7PL4XDFKT1yh+JXia2X98EHy6J1wR3dC3TVsh6o32joru2q7NV9OO0 XAW8zyAQiE8CzofD0MKZXdsrONt0sKTERoVzNDOYKuZgCtmrMjblHA/pbVsUc+KqzMgWSPukknlu tuzzdd7UMqvmwK1XSU2nfQqjKGHS6/k6nr/N6jrhgvujRXXLTG5yvM8yT7byvVRIjVLjFoVd1LT8 fHI/VdBjOa8ucv7ao6nocpEPErl23tyHv463lH5R8vl72m29b74H//z55/P5Z6FDvr0+BnpOfm/S 2+ltgn2Ycc3j6fV3LB+A9Hc1R/wYKFjLGlnWI+r0Nl72SnrZdUnQYTjoOtrpmNfxlslxdB0uOIFx YWts8+vHBtjI6+mzS3l98Qx3zWu/Sdtfrl7l3+oL2Lmf/n3ndb71N7D3NwMFjUAgPnk4v0xwnoa8 IlWGc5mr3cH5yItacL03gWgag/Y6G5xVQasjm9p2qQIm4iElVm/2FBWW3PPszCDm9Ly2WAWpQ/eq WUxgUneWVHRusVK1XFLM1mLlicroT0slO110wgxhmm7uzGJFRZfq8nZQc01R0VQc3aJMtYFLbxud DgGJTkeWEVGZDRpL9VpHntiSGFrn1S5r/Zm5i1pHci/T142SZiUcynWyhBav1UlJsPODETXVLXNI +VEaoiv1aH6KecY5lzFyf7QAubi6JzryZyYZAJOUtIxgkZHkkmY/paLH8Te0dnSf6ot+uIoGoBEI xBODs7snnF0D56zIFM4KZVdc2QplEvXYngvm0lY1G+y+0dzbZCoxSBuV1JYpVIOYtlbZSlGNk7um soc8oEQNVlbfVVBmKAdtU2pc20162zfPE7UIXq6V4axqnMGcn0zqXd1lJqi2e+kATrJZ3L60TWU3 t7c53Z3DXD9/UGkDUxA3zqkMaUt321rTmsiXtin+qMLGcF21I7AglrT2TNJwxW1YuqwHySAy7hXL YGaZn7aTt8Hi/DvtGcY+4+ElznPb1Y/8kUhVdLrLa3lA+LVaRoBuThc76+/nTmYxABqBQDwxOL+5 I5wVvnUKWNqnadQ1nCuAg6jeQWrN3uc0bQPskvKmJg3LCjqncquilvYpdnKretYUtI72FOMWueze dqWtytPCvFWPC5yd6+Gs6tS0tdanfR3juaGRfffsUaP0tAYdi2rNLVf2laUGLZMz5UNEniTmrM1K F8bQySfmA8sXnQDqrfZsNfJdSEdn7dPizI5ym5lURhusiRW2fFluHxdYDzTxaqI8bExT3TrwXNY4 4Ra7MmVMV72iI88q9bJKaPpmb85S0fpT/iZtvpfXca+ieX9r/OfDAoBGIBBPDM4vreascNa1nHVS 2CgO7XZFKobz0MA57MFZ0teqmLNT25zcBc7ybq7jPEudliz17QdT24Mes4quc7p9cVzzbEsxfQ1m exrKkpIbYLbjCucMZVOoVFPc9jz5FsH+VIa7ThArjjGyvquc4qYCayosVTjn72s/h8+pbOfm/AFC h42pQ9s8YE63/Ckg7EBabmYLdvCqmVEGj4hTm3iU90yyiFfaj2Em1ctO1iIbdAlQTXXLx4lBpquQ Pp7ydRyN6ZrJu8v0VB7T0zpfna2i+fWqj9df3LfcF82v6e/+452axQBoBALxROBMt8I5LxcZwnGM OopiAWdLVfObeQfnakwqcM5GJTIDk7RKNaqaB4/IPG2nUsxzGjuaqlZzls9tT0U1+9DWoamtPa/B bHC23ucWyt2AkgLiXHs2SvuuA7p/Uj1lJmt7dU1rlye5UdJZ9BbieOvD1tqzzeVOcNZvOjsVzOXD BFluu26XkNbVtEhBqn3ZpCNHVXjzFLNZGMpw1nq0QnuV6iZZKyywmh4GXV6Un4VDnOM0DqGq6Lfp 09LhpIpu+6Lb6WKiojnELLa3iMbD09zog0YgEE8Ezu4WOLNiDryihSrXTThPUntewjk7jJdwpgLn Rcpbep2lt9n6n0XsHMQsVo+t/znf1muqW7/OYG7nwXUKu+9pLmrbdf3KzUXh7dpeZbfqX966lPat 9j6+ptCDodPXrcttUn3926tCdr4k1vXYNZl2W8hD3WHelDTl5aedC/YhQX8AvSpo77NIeuns8gpt SXWrTU1br9hRJ6lvJ9BOu0OUkTGimUtvtKTMQxLb6VZxonihnXPOXbmLiwuaJlkp1IWXr2jdF03a 7UU/6Mca+ktCdPo8Mv7kak/0d/zad4/ZEw0FjUAgPgE4S0/zUFakEjjrilS66IUT17bP/c466KPA mTo4U26dspQ3KZxdk/ImbQHy0ialc7YltS19z1SHijCASZemdOrOHpaObdf2O1MZFOJNXTdAXQHT uTxVrH/Otp4736WzV0+spryrrLY0syaeqSi/agbz5u62dHZR9bOpfKG0urdN2BcF7fJWjWi+XKX1 Z/WHkYzq1uQ6q2XOdUdZKjrKhBMmZtRUN5+RYjPbwdgEyGnv9NmMa9CNYUzarpKKjoOkvHsVffTZ 0c2XMiMlXkmzGb9Wh//ule/5ZrH7p7kBaAQC8QnAeT4B5zCUOjL3OfPazdTAOb1Xt/XoAucmxe1d n/K2fl4b/2m1Z/macfAF1qaMfVHDg6WFh2wK6+rONsHLyLhUxL6M+Mxqtk1t532/8fwR9dYwv4J0 nmWydHC7pgGKt9ZKpblnV41hrZp2uSZu80Zmyon0POBb1tQgRw23yNLbnKT2ts8LbBrSo61HrfAO Cu+0icJnAXLaBoX0QNOwNIwxuudc6+fvc0hnplyLTnCWvmjnuRYd47XX5SjZDvc3FOe33P1O/Lq9 u1nsYYFBJQgE4hnAecpw5qlfBx4Okt72DwLnFsQtnAXcOmxEVbXez9lwjTycox224fNAD3Fw+yGn tDOw7X5ynvJwEarpbaqjOvM5Hbup7ViLVLevoztbBd5crMepuyxv0znHy9eyRTsk0Vy29mHDl5Gi lL9mvX9N1ZPV3V3+fe0xkbY0Wygkn5PavS7Dmeeb63xyXWSE8kIkwc7J0pz5NtEGmDB8eX/MIOYn P1gftJ5jFU2z1+ElLlzEyVPui04qWj+SXKbjPLjk7WpwCb+W+TV9La9vi+/yzu8WfzsPG1oCBY1A ID5aOMc5AfkivameA+e0De42OPctU900K015H2Retg4eWYA72u2prGRVzGB1Ape2VingWge3qug9 1ewag5ipZhvwEcwgXVWzN9Vch3Pmku9yoYy9WSWL0Z+md8nT4m65L7peKC9vURu3qK1N00LN+7Ko ZfliqqTlRrbmtKuqWVqsoq6gxSlu+VYypluSz22qW7Z8HHgb9Tj4qGCOCxXNTVXcTT2rq9vx+pQ8 U2YKuS+aX3uvEqyv4ms1i5mKbs1imub+tVOzWJPm/umPC7PY46S5AWgEAvFpwDk+AM688EUZQLIJ bl5EQ4aSFJOX1aE11W1Kudab67QwqmnuZa05LyvpZMaGL0YtyyuHCuYGgAXKlEdu5z6ptq3qHBrQ AuhlhSttqS515wbUPvM22veL5bs1henuO2SntkBYMgFKevlcYm5xcW9HqXGr6ZuXipaVp3nwWNSW aE11y+QyuW7gVwbDl/3b7P1LWx71yvp4jMLvrKJNPTtuxkrP2sirUh6myCuHsoqW6WJJQccX6Ztf X3QrXUnL1XzVpLndiTT34wYAjUAgPgE4u1M151048wztQM0c6AWcZW50rTO39eg2PV3c2Dk1rQNK KpgNxsO+avYF0gpAqnAWMKsL2tU5H54a1eyyZPXk75BFrfO7qHwtW7LCZ4Vrk0UzqEstOuRv1tag qRrI+leXlJx53GlW1FbXzmVpUhXtBMJRF+VQUW/7ooVlG2RSiWOxPKiKjo2KlsWyQ6ei2XImcC41 aD7BS1OnfV6iOj31l5N3R4a0tlw5d9H/NcSr9PqlzZ5od/lN8+ueXYc+q90KNWgEAnD+BOAcezgz fMN8DzhrrZkXvGA4u+zqloUtDM7tAhOuOrhtsYu23jxQXshC4Ey5Jp1T4GWZR9/Ve9ulIMlWt7Jl Hp2usez6yWJ1aUgZLeJNafN9T11cvm3+fszNouTVRZ6/r/4celhbvGij9cvq0nX5y7YmTeVDijnc raYs9WjSsahcPuD+8iC/t9xGECtS2ZzwMhjG7itAHhS+YSgQplCBrM1Zx/RqOabX29Fq0gMXK4IM LhEws1lsSq/FpKDjjZjF6PPrtH1rr/tvnPREL6IsoPFdPnNWHRoKGoFAPB8426pUNk/7FJw5nZ2v W8I5K2czgVGzmpSmqK0H2tZldjRu9DBnl3a7RnM1dbUwtoEftHBsa4+SOra9a5zSnVL2zSKRq6lh /gwV3ag4y0PXgSd5eInPrVYmr0NV01lJr5UglVS5q7Vsa6uyx4m0/1sEOtngFHFn51S3tllxBTjo hwESbTyImpY0tpuDLms5VBXtVF2Lo9ulfxTUA0083aQ8lun1IatBT8STWyc2i8Wc5ualKOnmtjT3 ws3NsRpasvOoANAIBOK5wTm9Ld8C54FryBtwbpzcDZz9YjlGMkDXNqpYndq+d1+bGawbOEJt7Vll qq6ZXA1goYC5js5s4exqHdovoLwc8Xlbmns5nNs3wM6w7kDtaupb25zU6NamvBffwbu6LlbPJrIP O0RNtkAeM1HLbLCO/BhyR7LUovnDQPA5xZ0gHGQxaZnqSTy5LGSVzC5uvb0cl/PbLVfFLMYwzmlu tqPRjWzdsEh174z+lHgH7VZIcSMQgPPzhPOyzWoB5z6Vre0+tY2KZ2r7rTWZ2xaqoYNzfxlolc62 1ihNYbep7Drdq7iku37o0MjfPGFzb4LYidusvq4vc8Br6ttGa7tlytsvU92rFq7a5qUreOWMQ0l1 k2QeNHUdQt531pJFztLVXlPb+XsEMerJ8pwC5GDfN9j3HuSYe7K4s5rT2oM+faMsOubpwCnumubm lzinuXnbprllaMnJNLdr0tyPEwA0AgE4fyJwdjtw9odNOPulIWwHzmXutk0Pq+M8+ftKi5WqZxrd clwn2dKS+eKXoPZ17nZJZ/sKSk/hBJhrytvONTM5fX9xfn2OvF9Bew/Uvhvxmc1gtgzlPqR90yft mhYzZ6t3yXFSwy7kmruuj11q0nx9MLB7q0XzjRXwUme2NHeuOZfvw7eWTMakDm5nx3TkTLimucU4 xi+Hpida0tw8WYzT3JfpW/MoT05p/42L85X8HWia+9eLv6PfNvuP0w8NQCMQgPMnAud5AefB4NyC u4GzPxPOMtKzhXNpo8qmJ4Oyb53aes57qzf7vr0qw8xWq1qo5lBXivIbwOyB2sLXtXXqZqEpc337 ZuGpktau9y8F7m1Ql15nCrdAuhjaXDWNrdrLBNI+D2GRNbM1Fe3JxqLasd2PfANjn1WyqedQv7am thXGMjQ0ZDBzmnuWeS1jdnQ7Pp5NPZubmz2B/JdBN7o1w1g/tITV9Y/2N/Kb+mcjdejHC9SgEQjA +ROFczwNZ2rgzO/KUWHcwllXpoq5H3pYwXlhDFOntu8GkSwuDchIXNdr1VzmWjvXLyG5KDi3teZm 5aozENGtclXanrLrzDnX/QjtTM6MX/nZuYYci3lM14z26u7O/jP5usHq0aEYxfISkApfUqXN4A3p 68Wc6mcVHbUWTemkNwNYCNZPPTszgeXHOthxMCCHMPFu4H679Mrx6f8gi0mP8tPKxzOpOXOamxfK LG7ug//MHVweWhLcpf76Nptbp4qdqkOfeOTvYBSDgkYgAOdPCM7DHeGsozzzghk9nPnrZzj7Cmfr le6MYXkoSYVzSXP7jbRvTm+vHNrdNK4Cct8qU9+ktm09Rl2KMt9KeqbPvLjyHfTrFPFLvtI/G9Lc IuVNy3S3t1GgrfJuausla+DXKnqxYIhv1HCjnF2Txtaasy+15tpaJSPA7evZkBJOc1NOcx/ZHOZL mptmVc9Oh5ZQGVrC9ejP9K/l7HYrZ3Vo+9spf0/3CwAagQCcPyE4uzWceRnIXTjX1azafmb9+lIz buE8lhS31kINwmW/9ve6xUCSvt5cVqiqKe221rxUzTmV3YK5gbJroez8SW/Y8kJuG9bN9/Sr9LoB W7Lqbbqbut/NuQJl3/RMl77rkrp2uRfbzGe+zgwPvoVxrVu3fc4Z6jnNHbo0t/xYkuaWlTlZkEtt mkd/yjwZNYwJrCcBtT6gL52ucHW8Yx26jd89+I8XgEYgAGf39A1hJ+BMtd6c26qWcCZaKmffwrnt g7aWKl+HcDgfvOvWcV4vIyktVH29uU9pe79Sqa37qx3ruQJzC+Um533eZQ3rDOoGxn71de1MKO1Z NU3v689P+nu3dezQwduGsUjeQVaVpM5Mlh+/nMamAuMMddL6MtvK7Nipsk7SebY69WTKWVX0KFBO KnpUBa11aP41Fc5ah55O1qFz1Dp0jt+eqEPffWAJAI1AAM5PFM7zneBMBucyeIS64SVDD+fYwnlo 4UztalM2NWuzZaqDswLFu7z4xVZK228YwBrVvAvmFZTv+jrpYZ1BbWq6MZOt4U+uSa5TYxpr0tzU meLa+xdF3SrhnGmgPJvc90pbV5rcSnN7g7UZxLTVnBcXZeCGwfaJVTSpij7VbqV1aIXz6i/JjGIc Wof+zSP+ndaASQyBAJyfKJyHppXqkeAsJrF9OHfTwfbgvHJqZzi3ZrAWzhnItIAhVTC7BsxrtXxL tOtBezrjdWPjwGXlLPu32MNssYylcczGdpfFsVY91sFlIxrJB5aYp6jJlGxzadsDpPOyxSxWO8eq AUxc6VprDjK21LtGWfOMbZkVIwtozEGfNv4i/OWj1wy607S2rv4hU8Vm+VW0Dj1JivsqvaYv0s1v pB+af7YY8+pW1SimkP7en28Ug4JGIABnwPk8OPsGznQaznRXOJdZ2o0ZzFPo4ew24Ox6OJc68Uox b8B4ebnL9e1ryCDtXPMhIae7W+MY+RbIvo4L3eqxrsNNqKtJe7N+W1qbcvtW4PUvNM2twNY0d7Sa c4a1JMeLApf0tj7sCmypQ8emDj1XBW11aF0oI6e2dete8b4OLZEydIlto1gf/7Jz/fn8BqARCMD5 idWcHxnO2SR2PpyHW+BcF7rondrB2pOKuaqFc+vQLrXmtWq+Bcx72eud8vPuffcg3YLZL2/auLpp 4wNI37vt2p5p6rML8tiG0rPtpRstw1nFcK6X84QTPtZ6tNWk9TYz92PJ/QbpBlMFrZ+XSBT02NWh Z4Ozgdrc3HouG8U4qlFsGdsTxe7v5AagEQjA+YlOCHsInJvBJOroHk7DmfZHd67hbADOcC5O7cYM 1sK2rBjV15q3VfMJMO8B+NRLxu+kwncgbWBurliOBXUNvBsV3f6OmlZ2xclu63GJSczUtBnIc080 r4OhMCatTxdYk6SyVTXnti5W06QObisdiLpOcOZ+aMf90KKkJQ3ua/VAB5ZYmrqpKrRGsRedUex2 JzdS3AgE4Pys4BwPD4ezTgc7H84+rOFMw3lwtp7hCueOpJv15ltV8xaYH/Ly8Xtquod0cXe3qe5t FV1/jw7ufp3+3khzy/XRlDCZkqbi1A52ndahs5rWxzgE39T0Q7mvpLmdpbkzkN3BZaOYrAHNa2Ms jGJ3fzxPjfwEoBEIwPmThnOuGX8oOOfZ2vtwdqXHedlG1U0F268376rme4H5TGm9q6b9erOoQa9U dOmf7j9k+O5372Z7a5q7cYc7A29RwgprTXXrdaHUpVsok0HYq0IOsniWoybNrfXp6NcDS6bV43Ob k/tuIz/v1moFQCMQgPOzhXN6Lx/vDudm8EgH5/YcLcZ27sO5TAI7C84nnvrzgXziOn/6tbaZ6l6q 6NqzvVTLvkmDU50qqm3QoYezLG9Z6tCWsu4+6LTHpK1TIZ+TmZ7ltgJqNocF3cpl5Hb4uAavObnz cWxWtnrff+AANAIBOD9bOOdZ2o8DZ7cD57aNag3n+vSdA+ddEfyQPuidU7R/nV+eJL8hsbdeofV2 wW4syrkxlQX93iGrZHs8QzAQZ2Ud1BQm1zlvijifs+cgyGolLqe79TajqOkuxd04uevTYSaxV83P T+3Skxy/lH/rTG4AGoEAnAHnJwTnZRuVGaW24byA7DKlfe7r4c6vJ38GpDsVvf7gYMfLNDd1Tu76 /Whb6feN3qakq2FOgV1MYMG+J5nRbHClNl1+ntIG5jKc6wiQ2S+HgWylubdbrfrQXmgnf1cANAIB OAPOjw5n9x7gvOxvdn5bdd6a0n6oO+xBQV2r1ZbCXv74xdldVLffygDYY1c/wLRGscz90H14yTXo UFLW6uTOwBbYcXrb1RS3jPwUZm+3Wp3zGCx7oa/lb+ox/qYBaAQCcAacF3B2J+C82VrVrDq1D2e/ B+eHpbTf8etrL9XtT2S7+5+fturhtKJ4u/TlYj9/71C+bk5hh6ywydbDouXwlaGpMVNRzWM7QHOj Bt0raV00w23K52/e+R88AI1AAM6A81lw9r6Bcz9PejW6s4ezuzec30lK+15q7pY091YdevP+Ox83 squ7r1MXJ3cGb3AVxk0au/sQkVVzC2c+Z+pZKW3wPmz8Wc3Nh4SpqUnf3ONx/xcsN4lAAM6A8zOA 8wdIad/n25E/487twJKGSFtzxkODq4WiJhtt0vI/gTeEpZJvBpK0oJYvMSx+zkvdvNj6sauKvnWa GBQ0AgE4A87vF87+w8H5owtaF5pv/cFpp3BN5fGiVW2b3NqYls8Fe1xpKc6pprprjIttvi1DezZn 922h60I/+JEDoBEIwBlwflw406cP50f+fm2K+kwCtSn0QL5/jFolnc+HPRV/8lwFck51X5z+TeLN e30uAGgEAnAGnAHn2yH7vni+q5zvg7FhcxjJZhwuPro3AQAagQCcAWfAGfERBgCNQADOgDPg/JH+ MfgzirVx6552v1m6o8/6ZscbABqBQADOgPNHDWfaB96ZN9+878bXiHt3aW4bl/ePi6/F+/GcPy9a f5vBzh2drplyGtI+XND7fCIAaAQCcAacAef7vmhvBRYtgLtxH6rnvV3ohJL21J6L9vXZibYN+bk5 OS22hbzUA/tU/JAu//34f+4ANAIBOAPOgPODxPSttz0nLZ25vfgGkdrvSb3MjgsVbRDuxDN3VqeX c1zCPDQfEAK5Ju3t/bz4ea9183brx/6pwnN4ufl7/gkKGoEAnAFnwPkjeQnT+sVLe3RvZS41e0Sd ki5fh3SRyqysM6dFZTep73ybrJj5utBcz+caME/OatPHjV+nUdGyGmkG+X3S2//4oJQ4AI1AAM6A M+B8rmSmolxpeX6jxlthW6Hrt1Pcq+t8+zVj4bs3IMd87GmR/t4yiPG5ydjcpLdPGMi8wPkqbQ+0 VM8af3nnTwYAjUAAzoAz4HyuQl4wnLaJTos6Mq3uQCZzqbmFKWHdrx8BSJZvLjVmAXLsYOyjfCke 8lmA7GNWznq/GAMVFZ0uk7PUdnqpc+3Z68vGUu/TWco3/Pmz7naXl9/cRzETAI1AAM6AM+D8aGLa bxKYGhWcIV3E8wLG3X5JjcfuC5piLmnuBGE+ZmC3oNZadAGyXhdq6ruo7Ehaj84qeqBpUzkvz93Q pohuYhy/1tu8+IdHc3oD0AgE4Aw4A847RN6oL/uVo5o20txG5L5+7Le0tO+26SXjLIWt9efoGjA7 U9I+7+frKpB9UdYz89hS4dKKZd97EqOYOra5vYqVdLqkbaucvT+SpLfftKBOfzThBfmQDWL/aXD+ 6p20XwHQCATgDDgDznSeeu49YLQFctoye+WUdlHSZA5usnmepoCdpbhNOUey1HYCL5EpYTOIxfaY FXVSx+VceqmXDwasqDWt7WNNcbvpuDnExLuJbkJV0SGoeg7hkt73kwJAIxCAM+CMtLY7Sz2fnd52 1MCcaoq7KG5q899kYC5Qzy7tJrWda9EM4KyiYwyxHLsKay5KFzBHVc+a2q5bfZlo7ZnV9JHr0Bvp 7ddue0CJH18ZuL+06/61XvnFr3Zg/k93gjwAjUAAzoDz84bz+eq5c2976qHrqa01U2P4WqS+m/P9 JRaDmKjgmJVyUdGei86c9tbrpNYcmzR6uj7GFtbR7hsE2t62mq5uUtwTp7fT9sZpa5WfJL3tA6e5 79pe9cdm//dQ0AgE4Aw4A86PCef92rM3dUybqW9vYngbwCW9TRXUvgG21Z+j1p/5wWaFnKDrGchp m9Pecp3CWqHNDu4KZh/reQF6VMU8MZznQDNvpea8SHHnGvTGkBJW0SG8pR/Ci3KfYfg87f8bUtwI BOAMOAPO7xLOZ9x0pZ5X7VHO+qDs/1pzdsuUttWfjfZRgGtQFTBHltF9/bncJmajmFOYR4rZIFbA HK0OLcc1ve0lve0lvT3ttFhJqjubxOTcNVUL93/fPkXsD+3Zb+9duwagEQjAGXBGzfmEeqYz1bOp 4E5x+6VhbJnejsvzqoxlZGcBNt/Ot/XmdF2MFdqeZ3HHCvjoh6h15mwQi2YQi2oWmwdNaS8c3LkG zdvs4N5usfrLqgd6HXtTxM5/SQDQCATgDDg/Pzifn9qu1xicT6nnbAgTw7ZdT50hrKS3nahm0tZn 9l/7WNPbfJ0I6D6FHVkxa7qbzyuUVUmX+rPBWa+3fYF1axCbVwYxfcKyg/tKAdk4uE+1WHEPtAwp ecQeaAAagQCcAWfAeQvO9bp137Pru6d69Vx7n/M5H1u1TMt9ebipOLVreltS01GwnBSzpreJZEyJ qWodUJJerTk1nuCc/hia+nOkeWbVnF7tDOY5iqKWlqysoM0g5o+c1u4NYvdycD9imQGARiAAZ8D5 2cL51O2a1DZ1qe3eua1Tupra8kI9NyltTV+L2s1pbTkm2zbXx1KXdlkp1zp1JNsWJZ2VdqRoNWpJ c/N1Cc6qqEe5rYz49Ie4qj+bQcxfG6hdXSBDDWKXnUFsO/74aC1WADQCATgDzs8azvdObTuX68ZL 5/ZSPdNKPVtaWyFsx3IbUc1k6lnc23o7ha4CuU1ve1+BHksN2s6LkiarP8em/hxX9WdeYlLrznmS mC6SoZdsENN1oLNB7HYH9+8f/IQB0AgE4Aw4A85umbPe6Hlu2bxa5IIKsHO6Wl1aG+o5NuqZsnou IPcVvJ565Szp7Q7aVCCu6W3e8vceTH0PCnM3xqywE3TjekAJH2v9OY/4DG+5/vxaf/uftf6sv/K2 Qax3cGeD2LdYbhKBAJwBZ8D5keHsqvt6O7VdV6aymrApYTV7+YVTe0c9K4SFnFRhTGtIq6pO+rdJ dy+VdFHaopZNVafztf+Zv8dMfjq//tyO+GSDmNaf72sQu9vLBIBGIABnwBlwdis4r+rOi1YpyjOz szFss9c5nqmeE1v9zFsmpgC7BTML5QWUcw16O71tStrS295UObdX8Zeegh039Wdps7qu/c+31Z/v NuITChqBAJwBZ8D5fnDeNIVVxbzt2m6Gklhqu5rDMpwLZBvVfLt6Vkh7Rq/P8ObqsaSpmdaz+MF8 EsUbSlq+zkwb6W2+zSGW9LaAeqKQzrfp7dz/fLf686kRn5sGsVthDkAjEIAz4Aw4b8K5TATLK0gt XNslte01rV3gKPsG6Qxl104Lky1DmAE79+o5mnqW6SEC5uLyTsc+HSto9T7RbpvksaW3e4PZzNuE 9nPT2/wYXIUEZ1POuf6s/c/n1J9zfPtgNQ1AIxCAM+D8rOHsFr3OLsPZ9SraN67t0vMca7p7mdr2 cZHatnR1VcrlXFHJcUM98+wSJinJea0zx7maw8Kc1XOrpPv9pKJn3S/pbbn/Rnr7xAIZ59Wf//HR 0twANAIBOAPOzxnO/arOO6awrbpzORfLcpC+qOU2tb00hs1Ei75nATCXlL1el2Bc1bMBW9atSkLY m4KOORU+N+awviZd1bO4vG2aWOveXqe3/RXXnzW97cO1LZBxRW16O4Qf7lF/vvvLBoBGIABnwPk5 w7lLbbdw3jKFLevO5Vxc9Dx39eaS2s7KldPb1oycvsxMppJtOUlJY/P16dvOVT17Vc1x1hp0Oicg JlPRfPuoW7dU0va95/kQPSvoic9xupvPt+7tkbbS2/qQnEpv/7FJbz9O/RmARiAAZ8AZcD4BZ3LL FHZRyFZzblLbdky9a9vL4OsM6qKeicSEXerKek7BS5buJp3JrXXnop79nNWzz0o7mormLqyowOZi Nl8jsJ7btHZeHINNZOPCvT2t3Nt/dbe0V3XxOP3PADQCATgDzoDzXjuVa8xh5Xw1ha2AXedtk99z bWc4V2OYjvFSQxixSk7AJYOzqeveuc215149OzOPuViVcquel+YwvqXUoY/jxnCSmt7O7m2/Sm8v 2qseeYEMABqBAJwBZ8D5xBjPxrFNPmY4N6aw4sxu6s4lje2Wrm1W0V1q2+rOAmkSJVwd2qTpbVbM znfnvZ2nRj3zcfSqmhPFJU0u6jmEuVXPm+YwPncjrVdiDnsjJrHb3Nv/tk5vl/rz789/KwGgEQjA GXAGnM+DczvGs8B5sUrVwhRW+58bpUxL17b2KpOba2qbIRzF9NUbw6zm7BTSka9ntWx9z+QN2mRp 7672PJt65v1JwMzq2Tdg5nNsDgvpXGcOCwppeVw6c5jWn29Nb/+hTW+3cf/6MwCNQADOgPMzhnM/ iGTR66xwjo1jO9ZhJLnv2fdq2dLVTmGcL7IAs92mpLblUlLbbqLGGJae9ikrZiKqtWYZVhIU3gnO pd1Kas8K7NlNa/U818lhoqCPk/Y+X9fRnldvbyS93ZvDeDjJm3339mZ6+1u0WSEQgDPgDDg/DM79 IJJlr3PXTmVw9j2MGzjvTQsrsCanylhc27RObefrbJ8oQZpcAjVvKe+n28eimG2pSTOPWT90gvOu em4mhx2HpKLDi9iO9uT0drv+s6a304vvzz/vu7f/+G7S2wA0AgE4A86A806vs499O1V1bVMLaCpw FhBTnhKmdefZJoaV+nMFcpiKa1vaqNKxs5S2nV8bw9JfBdea018QIzdavTpGVswTk3teOreX6rm0 Vl3bgJIE56yexRz200+u7X3W9LbO3r59OEmrnv/pwUp6xHsyAgE4A86A8y6cF+1UrnVsW9+y601h c5mnrelrUcw+q2hfQK5bVsrpr4KkVq37fN4bpH3ulfZZWUcdVMIw57Q2p7M5rc2qOlTndsj9zkNV z6FRz37W1qowHNLtWDk7rk0zxHXLr0Ixh/1d+nNzNnv7K0tvf+N6c9hDnkMAGoEAnAFnwPkMOHeD SLzPqeq2nao6tqubWwBMCmfdTyR1pebc1KQF0n7yDNokewXCCdJOwWupbUokdZzWthq0QlqgzSls ihOr7BDYua01Z3ZuB4X0nP4GZDulq0MzrETUc1D1HIYxZvWsYCaDNCX1zC+il4057PPGHOZoPXv7 8dPbSHEjEIAz4Aw4d3B2NmzE4Ey9Wm4WurCe5uWcbVdNYQpqZyYw26YneBL3NjWTxCRVzSluN/Wp bT5O8pgslc23k/NB6tec8mY4M5iDnONpYXlqGNeYh3np3G5rz4GVtNWel61VbA7j1qrbzWHvJr0N QCMAZ8AZcAacT8F5Sy337VS9Y3veNoVpzVlT1AxbBa9ex+qZXdyl5UoVdNfz7MwkZv3QDOZiDEt/ Sn6KLnINOu36Y9TLYtRn59xmBf0ytrXndu62PHYbrVXyTiBnWnPYu0lvA9AIwBlwBpwB5wbO7nY4 u2z6yu1UVAxi2RxWL74MF5EpYdJaFRTGAt8EXZfB2+5zOruqbW/zuPkcp7a9pLbZMJaEcnF1q3tb 0t25Hj3pgJL0EaBRzxTbsZ576tn933Vr1bY5bG/29sNfWgA0AnAGnAHnZwtnt4CzOwlnv05xy0Sw 5lxV0aZ6KatlpxetKQdrn3Kmqu22Mneb7D4kk8Ekxc3H0a9S29xWJaltBnaoUM6qWduqrN2qmRrG qe1OPb9eq+cQTrRWrcxht/Y+3yvlDUAjAGfAGXB+tnB2d4Kz1papzNY2EBdzmCnpyeXUts+9zdb3 bDVoPacQ1rozQ1jq0QpjslR30AEm3oaVLFPb2m7Fqe3J2qqGeea6sxjCbooxjLc3w2UsU8OutO85 DJ/HYfwind+vPWt6+y99a9Uf8sP/bsxhADQCcAacAWfA+Y5wLm1VJY3Nzmsb41kGkHBPM6eydanI rJatz5lMUfNKFeze9qaqi3ObNN3th0mHkGjaO738ErBl8YxpndrmtPec4qhKmbE9DHMZ6SkrVs0K 53Ckt5zqlnR3UtA/39C67/k/3e3q+d2ZwwBoBOAMOAPOgPMazov52j2cm1ozOWuLck2vcwKuLYDh MmibenMZRkI51d0COV10sYtJU95xTq/7yRbDECjncZ7FtV1S20k1TzZFjIeTeEtt21ASf3TaF+0P NFy/ir0x7JJ+XCyK8cjq+d7QBqARgDPgDDg/XzjTCs5VJe/AWVPcLZzTl5l8BrPVmjNoe8c215zD VIDMNWkb5ZmBzUpZW6247swtVQZpqTszxJN6DlHS3eLa5g23VZXUNoPagL0whrFqXq9YxaDu1XM7 NaxTz398f+oZgEYAzoAz4PzM4Ox7OMc1nDfma9cRnmIK00Ekba+zb3qdaa7tVJbSNrOYb8CdDWTV FMYObVXK1mo1kwGZU9whjJPWnbX+rP3PCuWZIV1S23Of2mZjWHgZV8awZsUqVs9+TJD+88+inuuS klvO7fejngFoBOAMOAPOzwzOdCucBcDdfG1ZLrKdEqYque7bAhgCYAF1rjGrEaz2Mdu53GJVTGHD VE1hVn+WlDeJau7rzlEWzODQgSSmnNPxJCqaTEVfxpraTqC+OiQgfxaLMay0Vb2lfsWqfub2h1LP ADQCcAacAednDee8rvNpOFMP53kFZ2+pa6kxq0FMZ2ybUqY+5U2a8p6i9TbbfO1qCkvH2u88TDHq Clbpj2VetlRxyzPDOeT0duvaDjO1qW02hrFBbGkMk8eS26rKilVVPQucb+17fjfqmQOzuBGAM+AM OD9bOLcqegnnpER50Yw1nKcywlMXv5jUHEbNAhje4MygjgrnRlV74lFeVFS1fE1W0WE2U5gXJW51 Z50WJjO2uf5MOmubW6pmJ+5tPw3pr8oGkgRbDONGF8rIqe3lvG02hvE5bavSBTFWxrCVes7x7tUz AI0AnAFnwBlw3oPzvK+czYmtBi+tNedBJGXedqOYOziT1Z4X9WhdHENS3l7XhZ7UFJbOFXPYaAth zFJ3Tn8azUpV/UCS6to+pP3XCdRkqe0E69GZMYwaY9ivEpjrc6Pq+d8/mHpGihsBOAPOgDPgfBc4 lzYpX+DcTAlrB5H4tg5d4ew34Nw7tgerQedhJLoVk9g8W78z9zjzQhhadw5hmsM8Spr75ujKQJJw vXRt19S2GsNerYxhrJ7/d2sMK+r59+9VPQPQCMAZcAacAed7wNnXRS9yW1WBMwPZH92i9pxbq5b1 6OgbBW0GsEhRVq1amsKkfYpNYVZ7Xtadc0uVwNnqzrwdOOVt4zx/Gn8R9yeGfb2T2t4yhr1b9QxA IwBnwBlwBpzvAOdgcO7na2s/c4aztVVlEDt/9Lmdys7FXlXPOZWdHdtym7Qf5BwPKNFhJGwKm7Mp LKvnZiEMbalymy1Vw/BlbF3by55nfcy3jGGtem7j3apnABoBOAPOgDPgfAc4053g7Ov6zx2cSztV hri0U+kYT1HQ4tiO5tgeJ1XMR22pElNYs0pVmOabpu7My0i+vX5l+5/HdiBJO87zdGr73Laqd6ee 5WfC+zsCcAacAefnDGd3O5x9KKtO3QXO6TXbtFklwnZw5jrzXPqfYySZtR3imP7Ssilsro7ttGUF HRKkdRjJMBdT2FFVsy6Ekb4tv7Kl7nxD4Q2Dm+vO1Awk+Wzh2ubUtttJbf/+g714oKARgDPgDDg/ azi72+FMSzjL4hbzNpz9MYM7/bTHUmvuBpHkOjQvgMG9zrwdJ4ZzGeMZaNJJYQxnA/LcLCGZ+52P 96k7v6Z+nOdtqe33r54BaATgDDgDzoDzCTjrUo/ViW2jPGlPObdwriM8s0rOKW1xbrMRzNLZvkCZ B5K4Sbeazq5wro7tYgob+Ti3Vx3p7bWL59SdNepAkvNT2+/3pQdAIwBnwBlwBpx34OwayNaRnboy lT9up7UznKlzctfZ29UIVsDd9DrrjG2tO7djPFvHdgjjLI7tm7dVOV+TwLn2O+/XnW8fSLKX2t41 hr0Twxhq0AjAGXAGnAFnXalKJoMt4ExbcN6qOXPDcZ2v7TevOwVn7nVO8jhFAu6cDWGinmmOop7n JK5bx/bAi2BcCZyrKUxHeY6ji7Xf+WoDzlp3LgNJvtiC84dJbUNBIwBnwBlwBpw7OKdvN50HZ+tz 9kt1nOFMx7OVs/Q6M5zdpL3OsfQ6d6ltHk4iae1xro5tFwdxbH8W16YwhXPf73yi7vyH/NRswfnD vPwAaATgDDgDzoDzBpx1yciTcC5jOv1xF87tCM90CQXOUaeE0Ti1g0iCWLcXcJZe5+vYtlNlx7ZO CjuyKztmOLemMP/9q8YU9mPpd75b3fn9prYBaATgDDgDzoDzCTj3CtjlZSRPwnlRc+7mayuco00H i3400xgbxbjFiuEs+e0515rbXmepNU/jnOHMYzy3HNs/LkxhIfSrVN2/7vz+Uts5UINGAM6AM+AM OJ8F57aWvA1nOm7DOSnxSHPklamSYpZztlKVTPRMf1EyJYwstZ17nafa68ztVMPgdtup1LF9zQth xALnHVNYqTv/8d515/cSADQCcAacAWfA+Sw451nb23AORx48sqWcE5ztXAdnXes5yeOQHdsbcJZJ YQLnca6ObRtMIu1UrsCZ687D8DW/8m83hXVx57ozvY8XGFLcCMAZcAacAeez4Ez3hvO4A2e3DefQ w7kbRNL0Og9JLbftVMPh67jn2F6Zwj7SujMUNAJwBpwBZ8D5fnDebKW6Dc5u4pWpdC3nDGcGsVvB OU8JY0jfHKcOzrwARroPtWs7n9NOddoUdqe683uNATxAAM6AM+AMOJ8NZ+eOPZzpeCacpwWcpy04 53Wdj9NxoZxn0taqbTgPl+k6aafy5tjWxzyE/3MGnM+uO9P7fLEhxY0AnAFnwBlwviecww6chw04 52Uj13DO87ULnHkkdwfnPIjkNjj37VSnV6j6uOEMQCMAZ8AZcAacHwDneQ1nP5RzPZzzspFxXsKZ a80VzsMcbrbhrEtH9nBeLoBxt3aqb+n+z/8HeWNEIABnwBlwBpzvCWc6Bech7bvpNJzfbsBZR3jW QSTUDSI5HPi8wvl+7VQn1TN9qBceFDQCcAacAWfA+eFp7TPgPEvP81yWjbwfnPspYe0gktNwbuNs OH/QgIsbATgDzoAz4HxHOM8NnIcyX9vJkpGuwpnr0G5u1nRmOA8xLxtZ4LxYmWo4Cee3HZxPDyJp n6Ksnu8EZ/qQL0AAGgE4A86AM+D8KHDmVakUzmFmeczl5gpnnq3t5k04H49zC+erx4CzxDK1/XTg jBQ3AnAGnAFnwPkdwNltwHkucOY+5wrncQHnz+4B568bOG8NInl6cIaCRgDOgDPgDDi/dziHMM4V zlcdnHllKhlGcic4f9/A+cGDSOhjeTEC0AjAGXAGnAHnMw1hgxnC3h2c18tG9itT3Q/OH2+vM1Lc CMAZcAacAecHwHn+8HC+db72XeB87msAChoBOAPOgDPg/FHBuV0y8l3AOdecX4kh7L5wvtuUsJMv R3oib54IBOAMOAPOzxvOXAhe9jk/JpyvduH8Y3hxy5rO94Xz00ltA9AIwBlwBpwB5w8AZ1bOHnAG oBGAM+AMOAPOgPPTgzMAjQCcAWfAGXAGnD/SgIsbATgDzoAz4PxO4OxvXAScoaARgDPgDDgDzh8Z nMMwzoAzAI0AnAFnwBlwBpw/GTgD0AjAGXAGnAFnwBmARgDOgDPgDDgDzoAzAI0AnAFnwBlwBpyf KJwBaATgDDgDzoAz4AxAIwBnwBlwBpwBZ8AZgEYAzoAz4Aw4A84ANAJwBpwBZ8AZcAacAWgE4Aw4 A86AM+D8CcMZgEYAzoAz4Aw4A84ANAJwBpwBZ8AZcAacAWgE4Aw4A86AM+AMQCMAZ8AZcAacAWfA GYBGAM6AM+AMOAPOz+/NGAE4A86AM+AMOAPOADQCcAacAWfAGXAGnAFoBOAMOAPOgDPgDEAjAGfA GXAGnAFnwBmARgDOgDPgDDgDzgA0AnAGnAFnwBlwBpwBaATgDDgDzoAz4AxAIwBnwBlwBpwBZ8AZ gEYAzoAz4Aw4A86AMwCN5xpwBpwBZ8AZcAagEYAz4Aw4A86AM+AMQCMAZ8AZcAacAWcAGgE4A86A M+AMOAPOADQCcAacAWfAGXAGoBGAM+AMOAPOgDPgDEAjAGfAGXAGnAFnBAANOAPOgDPgDDgDzgA0 AnAGnAFnwBlwBpwBaDyPgDPgDDgDzoAzAI0AnAFnwBlwBpwBZwAaATgDzoAz4Aw4A9AIwBlwBpwB Z8AZcAagEYAz4Aw4A86AMwKABpwBZ8AZcAacAWcAGgE4A86AM+AMOCMAaMAZcAacAWfAGXAGoBGA M+AMOAPOgDPgDEDjOQKcAWfAGXAGnAFoBOAMOAPOgDPgDDgD0AjAGXAGnAFnwBkBQAPOgDPgDDgD zoAzAI0AnAFnwBlwBpwRADTgDDgDzoAz4Aw4A9AIwBlwBpwBZ8AZAUADzoAz4Aw4A86AMwCNAJwB Z8AZcAacAWcAGo8/4Aw4A86AM+CMAKABZ8AZcAacAWfAGYBGAM6AM+AMOAPOCAAacAacAWfAGXAG nAFoBOAMOAPOgDPgjACgAWfAGXAGnAFnwBmARgDOgDPgDDgDzggAGnAGnAFnwBlwBpwBDzwEgDPg DDgDzoAz3q4BaMAZcAacAWfAGXBGANCAM+AMOAPOgDPgDEAjAGfAGXAGnAFnBAANOAPOgDPgDDgD zgA0AnAGnAFnwBlwRgDQgDPgDDgDzoAz4AywIABnwBlwBpwBZwQADTgDzoAz4Aw4A84IABpwBpwB Z8AZcEYA0IAz4Aw4A86AM+CMAKABZ8AZcAacAWfAGYBGAM6AM+AMOAPOCAAacAacAWfAGXAGnAEd BOAMOAPOgDPgjACgAWfAGXAGnAFnwBkBQAPOgDPgDDgDzggAGnAGnAFnwBlwBpwRADTgDDgDzoAz 4IwAoAFnwBlwBpwBZ8AZAUADzoAz4Aw4A86AM4CEAJwBZ8AZcAacEQA04Aw4A86AM+AMOCMAaMAZ cAacAWfAGQFAA86AM+AMOAPOgDMCgAacAWfAGXAGnBEANOAMOAPOgDPgDDgjAGjAGXAGnAFnwBkB QAPOgDPgDDgDzoAzAoAGnAFnwBlwBpwBZ8QzBzTgDDgDzoAz4IwAoAFnwBlwBpwBZ8AZAUADzoAz 4Aw4A84IABpwBpwBZ8AZcAacEQA04Aw4A86AM+CMAKABZ8AZcAacAWfAGQFAA86AM+AMOAPOCMQz ADTgDDgDzoAz4IwAoAFnwBlwBpwBZ8AZAUADzoAz4Aw4A84IABpwBpwBZ8AZcAacER82AuD8eHCm tA84A86AM+AMOCOes4L+KOEcD9MAOAPOgDPgDDgjniugAWfAGXAGnAFnBFLcgPMenN8AzoAz4Aw4 A84IAPr0e+Hjw5kSlE/D+eU7gPMMOAPOgDPgjEBIjE9XPe/9DTwOnL+Y/hrWcH6d4OzfkXJmOA8G 5wpZwBlwBpwBZ8TzDP80f872b6BVz6fh/G06vL7+2j8czi/fMZzTNwScAWfAGXBGQEE/3Q8RTx3O 86LmDDgDzoAz4IxAPA1An2kKuyec4z6cY7xI5+g9wXkAnAFnwBlwRiCeDKDv4Ni+Dc5/SWB2azh/ vQ/nOP8c1BC2hnN6owmAM+AMOAPOgDPiXcbw9OHM6nkJ5xRvfQPnbx4IZzaE+QLnOExDhfOc9t0C zlOCswOcAWfAGXBGID4pBX1/OLsM5189CM5xCeeLF+EwzRtw5vsMFc5pP73vJDgHgTPTOr1hGZzn RZ8z4Aw4A86AMwLxtBS0Px/OcvN6/rc/+S04O/fr9B50nd4DLsI5cH6xhvPQwvnAM7cTnkngHMYC 57CAc4HsvDGEJADOgDPgDDgjELvxsQ0quSOcf1dPcWp7B84x/pjeAz5rlPOV/6oZQnJXOMchA/l4 TzgPgDPgDDgDzgjEkwH0zpvz+VPCWjjrbSqc51/8V6hwfsmmsUCfJzDH6x04+5NwHnjLIN6DcwSc AWfAGXBGIJ4+oP15fwun26laOE/Tlz7DOf7ta78F53n6KQHZr+EcGc5jgXNiTljCOYpLm+EchzWc E7AD4Aw4A86AMwLxtAH9KL3OeYTnFpznawbvPpxfvuAUd4XzxeEytHAe52HYh7Mb13D2G3CGIQxw BpwBZwTi/Bg/3vfE83ud1/O1nU0J47enl0k5f9/A+TrB+VrgTHThX75wCzjzdpYhJBS34DwwlAuc 0ztDOuHOgPOQIBub63y6jgBnwBlwBpwRiM340C7uO5jC9geRzPP/tzPC86Wfj98HhnOMlz5+9ibM DGm6TNAewotL16S1aVA4j4Mc+3nYgfPYwllhOyXYxtvgfFjA+QA4A86AM+CMQHyMCvrMN+g/bd/u 1JSwMl/b+Qzn+dWPCcSX/I4pirmFc3rb6OE87sH5OIpgXsHZnYCz24WzAhdwBpwBZ8AZgfh4AP2w uvOpQSTN4hdxYui+TeevBc68+IXAeW6Vs5O0Nu9vwjkmOHuG8jwInG34SKCpgjhI/Tmdow04+104 e8AZcAacAWcEYifCx/W+eKYpzK17nTmWi198ab3O9NkCzpcVzodxUtWc1LPAOeqcbTaJCZyHDOek kM0IJnAWBc2wzue2lPMwnoKz4y3gDDgDzoAzAvGRAPrMfucdOC8c29uDSLaXjXyVxGoLZ7rI+wxn FwTOeeGLOGzAeapwZvd268hewZn34+EUnNMb6GENZz8AzoAz4Aw4IxAfwiS2Ywz7nxvq2a8WwFg7 tn3tdT4erJ2Kz42hLht5FV7GY5gvJ051p3NxYDgfpmmI3E41hn5VKq43S4qbRq5AJyaNCmdWzJ4X whDAMlAT5Wq62rtDhbOvcG6vc7fBuZ4DnAFnwBlwRkBBf2A476W2m7C6M8fasf3a2qn2p4S1i18I nDnVLb3O/ZKRZHBOtxU4R2mdipbOdgLn7LwOi1pyTU83ae2N69gYdg6c05vpADgDzoAz4IwAoD/q 1PbtprCr4tjWXuedKWG2pnMC75BrzeUiS1NlSHN6Ow45nX0Szl3tmM+xMewUnOmwgjOt4Uxanwac AWfAGXBGPMMYP6r3x6KeT4/xVFPYj50prDi2X12Xdiq+2CCSpK6PNl/bYDxq7blLbQ+cIud1nDnN 7XV8p47xtOEktvU8mCRWOBu4naWwK5x7cLtsDLNadXrD4KUoFc6aFk/7EXAGnAFnwBmBeG8K+gGp 7eUYzx/8limsOLbbdqpuEIkPF7ML62UjDc62prPBWSeE2YxtitMYeLZ2VtB5uEiBMx0qZMOhwpkO KziTgZjT186gXuE8As6AM+AMOCMQ70tB3z+1nfud3VbdOSnj67wAhvPTyrGdzs3HRa/zZbrMgUK3 +EUocPY8U3vQPucE5Whp7WDGsPSeaFO/BoVqtFR3hexp5WzXuXzJ9yOG9W1wZhB7wBlwBpwBZwQU 9EeQ2nan685bpjCKN2n7OsyXb3huiO/bqeZha0qYrOkchkHhHIeYrojc35xOBt5GP/jgB2oXtnhM OHvAGXAGnAFnBOL9Avruqe3vtlPb28NI2BT29oQp7Kp3bOde53YQSVQzWGBDWLrEBrzBQJwNYhnO juYVnGllCNO092k4E+AMOAPOgDMC8cFS3GdEk9r+aS+1rStUub//3OXU9pfRW93ZnTSFFce2jPOU VLY6tdN7CM39CM/Bar1iBOP9hPVs6grEIKWioK0eXXuf412UM2lbFeAMOAPOgDMCsRHvclDJHdSz 71Pb08/+q93UdlLN80+yQlU/jCSEFzOnppvVqTwr5QTeMQ7FsT0eBoYj41lT3GGsg0h4OcioK1N5 kksgHtdJh1DT24cyYzuv6ewLeA88WMSGkcj1bgFnNYPRCDgDzoAz4IxAfMgU95nquQlbpWo/td33 O9dhJK8DvTz6MsazWQCDSE1hCW+hOLZ5lGeYrdc51rnaZb62t9WqZp0g1i4NWba+a6+qjmytLfsW zgxjTwm+sYXzADgDzoAz4IxAvE8FfW/1/G1Sz2oM880oz589/d1FGeV5kd4r5vkmQfiSxW7QtZ3j IHXnJKXpYhguWE2XMZ40RFPMbNNOCnpMtzLHth+1rYqd2l4d25QUc+5njkkJ+zCmt+kD6VjPg6a8 Q1bOshqVpbkPuR7ttc+ZQSxbctFmcDO4+Vge+xFwBpwBZ8AZgfjACnqvrcp1xrB2IMkytZ1d21sr VHFrlahnrjtvjPHsTWFyonFss0Gs9joHb4q5qOV5LAtdyBzuXjlTp5xjc10UMPdwdifgLPA9AWdh MeAMOAPOgDMCgH5M9dzGoq2qMYbl0GUkOX7pcmqbFqltbqkiSpeXo9dU9sHnYSTrMZ6DGcXYFJaA zOXlaGM82bGd26mk13kuS0tKqrpZtcpZO5UzELcpb2e31YEjUVuunKazF3Du0tpU4Fyu24Gz7QPO gDPgDDgjAOh3rp5v7Xl+bS1VVzYt7NrrKE++XHhtqbqSnufc77xZdx4M0pLijmXpSNbZopjzYhjs 1PY2lMRarlgNB1bc3mvtuKtH69KQrri3GdJcX9ZpYd4mhnU1Z9/D2W/CeSOlDTgDzoAz4IwAoN/Z e+ZSPVtq+5QxjPdzaju7ttep7bfb/c5Sd2Zg2xjPpJzTtaEzhQmwqxmM26lcVtU7g0gE5K5ZPtK3 LVS9e5vrytyeVeBMAmcGbWjgHHo4Z/XcwblAGHAGnAFnwBkBQD8gvb0Xe+o59zz/aD3P6V3NZm3n gSTZta2p7ePJ1LYsHylbrjs7pm/IdWcKOpgkQ1h6nAXSZAqZJ4fNZdqXtlTFftWqdCzq2IDew5mV s4A5q+gWznz7Iatmg/Nwi3JmHGQoA86AM+AMOCMA6Ie+b245t89Qz904z7oQRk5tv3yhKprouJva FmPYMDMMeZCnquXIPVbtGE9OcRuULb2tqjrXli21XVefErOXy6Yv650mATrXmmlQ9RvHmuKWr6tw phbOtA1nDzgDzoAz4IwAoD+wev52Tz07Vc/O/Y1r1TMbw14l9cxw5mWVeZWq06ntdL7rd7YtH7d1 Z1POagqby+Sw6ti2vmbKjuy6MpWoaulvjmMGd1mtiuHruUBuYPYGZ4XwNpypOwacAWfAGXBGANCP HberZ7dQz+vFMNbqeb70opx5IIm7HNNbZnqvOnCrcu/cznO2c0vVIJBWFa3DSBjY1NSdaViZwsSd TYMvs7e9rAWda9CS4hZFzWpa3do25jODmE1koYFzhvDaEHYrnAlwBpwBZ8AZAUA/8vtnq56/q2eW 6jmfr4th9G1VrTGMLidf1HM6Xrq2NbV9CNJSlS66QlWUNiuBsSngWndWQ5dC2FeF3Di2aztVn8L2 OcWtM7ZrKptaxSzQzedCs77zDpxpAWcPOAPOgDPgjACgH5rePqGef6rp7Rrr2vMv+HjRViXGMK47 bxnDxhvZtq7tNrXNv2/wObVtaW0Gb9lvYEw6mlPT17I6laa4WSGXlHcdREKW4hZgVyi3RrAM7qbO fBucPeAMOAPOgDMCgH5P6rlJb/d9z33tea2eD716ZmMY5QElZgzrBpOYazsfi2vb2qq8zd5mkxdD WPqd1eCldWc35GlgbCBzlNPWNks7Dy9pe511hGc3X9uVFiprmSI7thQ34Aw4A86AMwLxLgF9tzf1 326pZ3erei6LYdCo6jlOWnM+TL4aw3zIxjCyFLfUnotrO6e2a/2ZYRtCVcp5GInWnc0Axuls29c0 d7TlIrNjW9upNhe/aMZ3bgK57vsWzg14AWfAGXAGnBEA9GPF7eYwVs/ZHJanhmX1vOXcfilLSrJ6 vgrLtiouG6tSPoQYY2MMCzKYhATMfD1ZanuZ5k7bYFsS0FqaW4xidj6qGWzLFFYnhuUpYaEZ4Vnr zPKBYNnrXMAbWjgnMgTAGXAGnAFnBAD9ftLb34mELuo5m8P0SGdu896Wc3ulnlnwduqZDWGmmosx jFusogwrCQZgUc3pHUpq0uLaXqa2dcCIt1qzDCPxagITVZ0V89IUZqnrptc5Twkri1+kr1PA7Fsw M4yVuYAz4Aw4A84IxLtU0Dsh5rAcy9aqOnN73fd8OEM958shSeP0e6X/OmNY5FQ2X89zSaKuzSwz s2mwASVDm9qWLeXasqbC+7qzpriLKaw6tkM1h9HGCM/VSM8gXFagMz0srU0GZwKcAWfAGYF4hjE+ 8P53c2836e0pvXWpOYy/Bqvn/0rbVzJze0rnKMo7q1zmyzeB+O3O1HPM6nn2qp5nVc9ZRXPLVXRR gRwTpL0MJElg1tqzE2OYL0o4veUy02X6V2LdWM4T5fWZ9VzbQlVqzSW1ndummlqzX8O4O2YQL+HM 92U4+1qDBpwBZ8AZgYCCfmfp7ZPmsNfpum9cUc/UTw1j9cxTw7jvWdPcvN1Sz3rh/0RFS8/zKGlv 7XXujWGuSXmLO9upq1tT2zSU1Haep72oO6/g7Ju0ttWaqWunyus5+2z+alemsiEkSziXNy/AGXAG nBEIAPodxWJyWG8OuxJzmHNfOffFF2n7hePac3xx4cvUMLJpYdL3nFhZas/HdN2xzN/WxTAysGNv ANswhnlRxiF4a6nS45zarqlwrTHruXYAidWdtf7druHcOrbX7VQGZwoNnMMaznqdB5wBZ8AZgQCg 31l62/WTw/TM0hymyllWq5LLUdUz6dQwVc+j177nm6DvkUHAPeyq51yTVkgGS19nYxiZSqb0tiPD SdJNnDm4RSmTpJ21pswg5+t9UcqW0iZLb/tqCttup1osG+mb8Z01nd3DWXcBZ8AZcEYgAOhHim33 9sn09lZrFUN6OXM7vT+yuK19zwzpyYaS3KKend1mwxgWBL5mEGtc2zW1nevSy2EkvkC71p1p6djW SzfCs7uuSWe3cJbEN+AMOAPOCAQA/Qjvr21suLeX6W2eHCbpbUltb4z1tNYqmblNs8/p7HZqWFHP 7NwO7nb1zPf1DcB9O/KTDOYhaL3ZVHAzAcz6nbfqzgZfUcQNrPt2qv3FLwBnwBlwRiAA6HcSp9zb 2+ntOjnsxiuLePvSLc1hTpQz/9xJPYtJbPBlahgpNPV6X9zSqqr31HOGOdXWKVLVHHyw8wLYUocW xZxBTYvlIlkd02pdZ792bJ/qdd6Ac//GBjgDzoAzAgFAuzPf9P/Z76e33T3T25PVoDW9nc1hbhx0 BreBeXSNmztkWA8CXjVsUwNiVtNZPUsvtannYCYvrS9TNnxlYxinqm3QiPeLBS+a1LaKY0tdb9Sd uZK87nXuBpEYnKl/PIk84Aw4A84IBAD9eGErV/Whw0lyeru4t29Jb4s5jNPbfNH3S75Nmb09MCMb ELtSh87pcB7DLXO3Q3Zo59su1bPWpFU5axo7lPQ2Uf36krZepbYpp71XdefGFOaqKawbROJOtFMB zoAz4IxAANAPeK9dRtNe1a77vOXerult16e3uc3K0tuypGTszWHMxAriahSzNLRBm/ugbU42K2Zn 87kNxq16dl1rVCjtU74dRNIoZt8qZu9rX3OuMS/rzr0pzJ3R6ww4A86AMwIBQD8kTrdX1TO/1L/S jeEkn7nPXHFv5/T2YfI5vS2matuKOWzgAnM2h02Wxp6rOczlla1qnVpUs7fUt3PdbYOlu6t6rstF lvv2xjDfuLYZJd6t+p3bMZ57prCTvc6AM+AMOCMQAPRD4/z6c4kvnKvDSc5Pb+ce6PRetmMOq/Vk dXT7AmLue+YzVJQ0FSNZO1gkfz2rPXtzcFcIUzO6s7i2S2rb+p3bSWF7prBzep0BZ8AZcEYgAOjt OMMgZnFG/Znbq+rKVTnFXYeTtO5tmbhZ3NvL9DYLXT5mjCq0Q5fe1lS09kPXNLbXlHejnl11bpcW KnVfk6Wxm1WqvC8pbFfd2idT297t153zWxjgDDgDzggEAP3eIvc/9/XnXyz/gvPsbY4Xl06Gkwik Gco3QRS0jPZMoOZOKemfmhSuNDW9z95qwqawDcrBYJvNYdSkv4ta9lU1kzi30zcJeSGLXj03s7Z9 TnG7pre5d23n1PYtdedN6ALOgDPgjEAA0A95713GTv+z3Dtelb/ktr2qqui5rPss6e1xsB7ooKlu BvIgIlhAzfvq15qb9PZs8Nb0dklbS5tV7OvKpV3K+wLp5va53typZ2rXdfarunLv2r5Tavtc6ALO gDPgjEAA0LfFtkFsGW39Ofc/K5sSnF8pnHP9Wc+Plt7mNHdszGLNeM8y5pPhbL3IJF7tJr0dO3d3 bw7zOgubmA4K7mBwLSq5qmhfoF3Vs1+r504qL/qYi1zO9en7mMIAZ8AZcEYgAOg7xnf2p9ydPN3/ XJXzRv1Z4sKN0mKczWKmnodoylky0V6hSwZp7yuUc3o715RtG6Klt2NjDvM+p7lDVr7UDSDZrz0X 9bxpDHMLFb1Vbj4ntQ04A86AMwIBQN8lftfs//bkLXf7nzle5D/xsTi3ZTtGX+vP0Suw2Zod5Nja o7w6szNkxfrls1LWNaOpg7Rvp4EFU9EGY6tL+6bX2ftVn3M7lGSpnlvwnkptA86AM+CMQCAeDdCn HNw5tg1i3V9zhvRG/zMr59z/7NzBaf05eq0/R60/p631IpuTO4/cJC890TqP22rYQm4BcaC4SG8r uC29nc1h1cVtMKYGyp7WsN5Xz34B31Op7ScXgDPgDDgjEB99insRS4NYG6yieZsNYvWvfJTjZf+z LbescG62sjZVV38mX9PVDOD0ntWcc1KTFrHrS3pbe5k91XnarbErtCq5T2WTXohs4Mgd1POmMn5y 6hlwBpwBZwTiAwL6bnCwEZ/9BLGsmOsEMT3z2f9j78yS5DiuNe3HI7IGDCRFqdV2adb9pNttJj5q A9rEXQ9b69Em2AvQI/Vw9ag2XdNAihCGGjLCT/uZ3D2mzKxCAQRQ59CSMWRkVmUA8C//M4bjCWI2 vWpUdzbVP+uWjpl9WfSKIhVFzKoZyyCKCmxVzuzyTnqugXcLX3NZC/yn7u22vnkShjbX9cnq2eHs cHY4u7m5PYSCPu3fIpVYTdTyagcxTQ6b/wQcmnNnoeetJIxhq5x1y2COCSzOjKZquXenKWUAiT+3 qlpUc9QJU1BLo2QbFdRr7u0K13lyWJOoPSfsqnp2t7bD2eHs5ub2Ll3cfzwRPD8rhN7K4A4KZEsQ C73AuSaIJYZzZBVdFTTGqpgjgipnLG5oi1HHoqqxxp8DtK7ouTs7rLu3VfUu3NtFDc+mVi3Uc/hI 1bPD2eHscHZz+3gAHQ724GYVPVqDks9LctjEmgzuqaJO6uZOWlrVBwGzNSjBxtXdhTYuLK5ugXUs 5y3erKra4s8AizhzVcwNROv/p15ve37ZNawg6o7wdTg7nB3Obm4O6Pvad0cgUmug+V+1llhV+M5A jRaDrhOsLINbLuiDuLh7XSVShTIniCUFMDRKFlVJg0K7UcwIk+fCPP4c5jAuAA9hkb0N4gjfcG+v ljt/8Dx2ODucHc5ubh+xgj69BvqLtX/tbYkVHe+G2apgcLb4c2oyuFVhz4EsKz4DWGLNdGxgtmtb 9/ZkNQLtHlbiyYg1OexAc+zV7O2le3v+eoSPgNYOZ4ezw9nN7aN1cT+gTUusgq69Zn11fSuQowLX +IlN7NlgXF3QpSxLbkU0eE/UccDW3R0rNyeu6vpGYQncTyUfzOHscHY4u7l9QoCeNilZ/de+Eoe2 GugVZEvcmXtyW3IYWTdXpsFqnCeqld3a0UAcYjSwq2vcbkkMcze2/WKwonphEnsu1y1DzXiU1h8s zB3ODmeHs5vbp6yg17qIkT2lOuhjryUY982JrqroUGLQS1dxDCug5o+OsLwNaHVTsELNlXPzUwin 8Xcre/uDpLXD2eHscHZz+9QB/Xa2a/b7JdxihTRO3NpF1M6UbyzA3ohBH4HlGlTXu3Z+xE5uh7PD 2eHs5vYYAW2Z3CnVRiWTLmJleUh6bpytHnI+zo5b+TxV4Ti9HrcU76QByWE5DKeA+7Cedjg7nB3O bm5u7x7Qk0EZd7XLlXMjTNXzMetmy0sLzMMfGfEYNOcjIu8BW8SPQVA7nB3ODmc3t8esoI9jYjwN ZneC3gnXHn4/+MT/XjicHc4OZzc3B/QRgy4vEt3xhQLgDosJvMX7FdB8qouZw9nh7HB2c/tkAf38 q7f4x30VblbP7w++Kk2OxukTE9imletbLjfQkcZgeCrGTv9+UN7zQ1sEHc4OZ4ezm5sraP0F4jnK dlcWBYi9LPgw1IUCop6bq+l45DhM4AxzWMtQK1yHEB5Zq3B9OcMl1D+CFc/h7HB2OLu5OaDva1lF D7Y/NFsFSIpo6hkW6jfpubACHXuu6GpMJy1cgCt0PhGDuPJeP9li+V7hHBzODmc3N7cPAdB/UqX8 mSzmebFZu+p1/m+CqzAsrgOIE0UNqVXLCmeYgxkzbLE5Z4qZfd/5uTmAFDqpgUtduNpjnELaHvp+ EFbhDacT/H2B+b3DOTicHc5ubm4fh4KGeLa5OJBLe+rWzmvzHNRgyhmq8qUu2wmnipmgkgTaUI4N 1MjHScG9/EV0AVsNXst74Qbs33Lte1cLJx7m9UPCGedwThXO84fD2eHs5ub2DgD9+2b/D/cAdZ9h 28Siocfbwsc2m3ugqRUo63gIBueqpLGoW5goapw8V2PSIMBOurXxGDzFUlqSKZixJpHp+ePwwwqt BnqriWKbQH/IBfSIat6Ccxm+OYEzngRnmMO5Ucytep7DGR3ODmc3Nwf0+7YfV89e6Tqi7u3bdUXd JoIJqEUZs4hVN3dKFcrA6hgxaUa3qGdkIKuLGk11TyDT0gnm0JUp0mHq326hvUFZPBCHfudKGg+f XmStY4VzPQ/qssZyr94VnMHh7HB2c3NAv719feQf+58DLThVLecFKZ6jubcBZm5usEzuvC4P5NbO azXtl+cTj6airXqgsQJGVTQYeKF5zmLSlkjWwllVNgZV1RMwo0nwAqKWuFPoynOTOHTzq9vB3VT0 2yyo+BAu7Smc2zeA6sZ2ODuc3dzcPlQFnReMb2Xvu60f2l3mxeGfee9FfrycwjmDGW56nCjpCbhH HCnmPNDqqy7uMRUws4pOY1GDSeFB8WiABuLJAA6isBMUqIgbW4ZZzhVy2EwUk/NNHHr63NzNfVBF H4X0KYsrHr72mEt7CmeeJrIKZ/1Sw16JNTjjg8EZOLbhcHY4u7k5oI/Y23S7/H52/FIFJcWfr3Tf 4NwhxZ/JtT0MFoMei3KmtT0RsMHUNAG3SwJjhUOy2Km4uyWfK6akMen8eqqzyi+mbc36bjO5oQVz wrAC7qVCxm0391RF48qieTTBDI88ThDTq41YDiSDHYIzFjgD5cAXOMMGnGG8K5zz24wOZ4ezm5sD +rjsOsnO8+IiC43+wH88xRU253X3dqWsypQ0r9MoW4E1ubeZqSVZLIOa9lkZp5L4JZncBl0CsKrn kslNsyZbJY1YXN9NophmREmceQrV1uXdxGRDU241f8jrAY8VUQPeTTTfxcu9CubqwV/P1J595hbO UOCM9twczlDBHCQ7+yeEc9w7nN3c3B6Zi7sxXljEaNGRvb/K8hEv82J0kWF3jqWb2PWOs7gB9nhL Gd0M46mbu8akRTVDSlhLrZK6tWNVz5rJDQwIShQT9QxFXZtrW13eoK5ZBQsQZEDjqDUOnVaSybbc 3IvuZNgCEicq+gCk7wNq3ADzEdW8CWfEKchbOBNwj8C5Ka16Ozi3Cvi+cM77Dmc3N7dHCegD/bjX mpVQsti8WUkIN6yi92CquS210iSxoqQTNy4R1zZBu0upxJmDKmeOLydR1JG3cpyBzQCJDA49LzBO OI07Q21VOVWSUxUNdg7nKhqaOO6qq3sD0mugPtXL3SbJbcnqtXjzpIxqluFe4GzAxfvBmSB8DM5x mMIZx4eB8+hwdnNz+5QB/c0J//in3cTMfly4tM+QFjSORZNyJhf37TKTO6//kig25m0QBT2OSRW0 xJ9ZWWuiUuLEMRQIS3a2xKgzkFGBnFpXeDnPcClu7kZZT7O5JeaKcxUNU2jPxLYp7cbVfRDSB0Eb 7nFtA+aA6/HmA2VUDF353AXOcn+nTUjW4TxWOPM3rSNwFnf2w8O5czi7ubk9JgV9qFlJLbWiTG4p tbrO2xucZnLvZ5ncs0Qx6RzGseassGXhpy25sMnLmrqijiUObarZoEHADkUtE0SAEsX4ffT5iZs7 tG7uFBYx53UVPYlTT2qsAY9DGo/4tFsArz2O+bynsWb9rTbizSs1zljrvgucEdv7cwjOrJ7xGJyx gTM8FJxHh7Obm9tjBHSzeHwrm+82r6VM7n82xy+DxJ/bTmIDriWKMXjHTuAM4toWWHcKA5LLCl+0 OHQoceeUJGtb2nvGpA1AF25u5M6hXKBVlCFUSKsiNyAdUtEoE65gmSimju4KaYtJL9X02yy2U1f2 SqwZQm0+gvMvHIsa5+rGxwJitHtwTDkXOMMxOMO7gHNwOLu5uT1WBW2LSrVDmdycKPbqXI9frySK DZwotoxDmwCLurU4tCpngjVDWGCRVAVzJBoEGKAQMciIm1uPGcYxWQIZaGwVGwWNcxVtXwr4i4F8 GcBWgWJYgzROlHQo9cYK0bAG6kPlVBvXbIB5tYRq5tKelVGFMpEKUh16AWminqdwVgBjjTsv4TxU OIcJnPm5GZzzZ9gDu1ruCmePObu5uT0KQJ9QC72RyU2LFWVyV1BLVzFKFCs9uTUODfseF3HovBiW ODTDt8+ApW2n7ujErm2ORzMk8vmEKbUKz9zcBOxUwc1wgar8GEZYFTmEWYw1lOe0Brgoblx1i68r 6UnMF5rI9RTUCy5vALv9ERpj3gTzXDWvxptnNc7tRCrE9l4192Y0tSz7ILHndTiPFc4wgXN+/3EO 52BANjhHAvYpcO4czm5ubp8soE9fACaZ3OuJYi9WW35erXQUmzcsERUtUE0YSpJYkkSvRKq5a2Cc VFnLMSqEGdhJFXYGiCltU9FNspjCHOo5BZqAScCFG13HYB6j3oS0IrRV0xNQ2yMsoQ2hnm+vDeWn rIE5hEWsGdfizbMyqsOZ2QrhCmrU5wzOMk90OA7nVjlnMG/BGXFYwnl0OLu5uT12F/c8k/v0RLFp y88brHFo6Sh2q3ForoeexKHzYwzJEsUMvtCqYYWIKOso8KXwdIk5c21tA98wjUdDKq0oq4puwdRA GWbJUQGrq1f84+k4pAV+OFfTpFwVrhNgz6E9W6rb10BJPJ+DGVdquSHNXdoab24ztScznDGsZm4X IAfroy1wJghbzHlkUDN047CAcxAAC5ztulPhHBzObm5ujx3QrZ2WKCZx6O9VVUscWhqWUBz6tsSh weLQe62HHkatXeakMBwpUWzFzZ0aF7bAeizgJsEsMWfO2FYXbFIAJw5oZySNVUVL5yvJ9kYBEExd 3IBrrm4F3EmQXrqXm+4pk8xrU9YHH22mdvM+GDZ/XpqqZqtvti8hkGaZ2jMXv315IQdGUdG2L1vY gjOOAl0qq5rBWaEc2gYlDmeHs5vbI7D+3b01LTZ/lNUkL0TnvPOlqOJbWmUoDv2MVLDgywRhPMM3 GQ/nVA+dspK+ycq57zkezR3B4IwgG8exywsiQYGADezmhhQZrqAualAXNiiMSTHnH9Gxck6hK8oZ +XzMMIo0vxIowh3y8s/XpxhKopN08VbgtFuQfiScTQW2YoLhlL4IyaeMlBGeGRjRPnLJxwIMuLb6 1k4n88UZjsYgYHaq/DB7rqpnaCd0YZnmtdJ8ZD6hqngSpKa5xKirW1s+e2lGInAGTQhTOIdIgzDG o3CGLThnMIOUUHmHMDc3N1fQBzGxZofi0NN6aEkS2xf3tmxJva65ubUOOiS00iepfVY3dpMAln/I yMliBN+8midU9bxQ0frVIcgWW9c2NKqwZidPr9HjJnFqoqRDaOqwUeG32bd7pda6KOzlI4SN+uxp e9KqmM2d3cSay+dZuLShfqZDMegmY5vLpEg9I2h5FAqcg2VeR04EOwnO9JdiE85r7Ts7h7Obm9uj AvTKwrDRUYwTxf4wc3O3ceg3WOqhX8r/aHDGarmVubnHJt7M2dyM2TQqnMV1HYqbOxGUmboElVGg nWEMqqqp1SSwlpd96fucuD80Z22DnLOs5HrO4tcwVpcvTty+WNuCptbdbYCFtn4aSwz7FMCe+NgA /ATMNTO7xJptWAjOXNgZvPNksMm8ZvU2lIxtuwYlG5vArPdrkH0B8slwFld4A2d0OLu5uTmgT7ev 66Lz7YEfnhcycWtPB2fUcitt+3mjbT9ZSXPJ1CSbG8Z+NUEsL8I1/kzwBYGDgnusKlq2HGvmzlUy cUlaTeJY1XRRxPkaFBDNMr1NcTeQHquShqnyNFd8QJwp7QpqmDRASXMVffiB0xIvAIN/WoJ5Utu8 bNk5mUaFk2QwbZdqn1Vc2QLckhgWmlrnFsYQajY3bsK51jxXOOe/HAzncBDOfM7h7Obm9hFa/27f fjsOPQyfhXF8BTw4I2OQ3NzPY15y478yNp7zsAoeWAECacrm3qm7O6/K2EOX2rIp6S6WVXReRGOJ OYuKBi2jAlXRQMoNKN6MEm+G1LGSZc93HPk8DZkGiUOjJFFHkNZg8ptJshOoqq7LJjSIhDCN/qqk LbGB/GkpZC2dyoLO55CeoPK8vkzKqSBYuBtPjCtAM66ytj+ZNASH1jUOay1MyyCMhZsbsc3a5s8w auZ8VdXQZnKTG7u6s+WaqJ3CgJuTVDjnP/iinC1z2+CM+blx2IRz6sq5MdPY4ezm5vaIAQ2H1w1y c7/8Q77oqyBx6J+rm/tz7qVJC9yYrgRAL/PjktzcmY7XGZm7M8nm7i4SCWDY9xH6MS+5Y4Suy8ts 4GSxIa/1HSWLMZAHijWLGzo/m09Hgy5vg8IXuQE3J41lchOM6TwBmJ+na5EuZziTAldAMzRBhCdU h7Gh9BCkyzW2+qK9H0+mhhVQK5AtD61ZpCXPa7aKN1OmsTnXJIhZhnfJ6l4HM+ogC8S2jaeUomHj 5q5KG5sBGNN66FEV8VjgLIlbEp8uyV+wHCfZwDn/mexhkSw2hzOuwJlc3NHh7Obm9mhc3CfEoadu 7u1yq3U39xubbhUvE9yMkizGmdudJoOtJIuRiubksKyYOBY9aiyaXNuRY8mZxeyGlgxvHAW+4gKX OLTMHxZXtyYvsatbso5DsG3g63GiEktJkWYwowIM28zmZdetmdsbS/IVtqMtJw1Sipt68pi4tsvP glriVd8fmp+9FWu2RLnms2CTCAY19jyUMqrGhZ1fo4q4llCVrGrepgpb3IJz2hOcw0lw7lfg3Duc 3dzc3MVdjRaf7+C4m/svQOVW1c39I7JeJdzAM4SrvD0fNFlsh7uU1+ChT/uuy0vqyElitMBCR0li mFhFx0iZ21FKrgjZoo45/EwObw5Dc7xZ1HRWyLSPIbJnHUuZFfcNI6FN9V3aNVQVL8vOBOp0BnNA LxW0XAqiVu0LkewDq91Y31OVeABR4zKxAxo3hbzV0XGT9gsAzppxT8upcCtuza1K676pZoBZIxL+ cjJpSqJu77F2B8vKNaCWWE0HYAR1a+c/tgbYy4Qwfi7cE84pnwunwTnu+5H+Hjmc3dzcPjFAn+Lm ttVn5ub+W6bkl+LmjllJp1d5KX9CcNrjVbzFCwb2vCa6z2vzGGkoxpAX0k7Vc4iqomFI7AtPiePI RG2gMVYSV47m0uZjyr2GyGXWlPIN7N6WWDNN4+BhWJRiBbUFl3iGASRQDDJ7agppLE7skrEtUzcE ynxGb1r+eeIz1weCeq7N/V0d2qfGn0vEu7T6bLfTzmEVzLOpXCXWjLhQ+2j141IjjjWzW0qooLb0 VNc3mpvbEsGQQVzAy9OpYlXXBc5zcE/gjONBOMc7wDk6nN3c3D4NF/eJ1rq5a7nVZLpVfIU2POPH UAdnUE20PKQmOsaLxIspSNx5H89SKbkarOQKtfyKVPTArm6JSyfJ4ua6aN2WjF/N8NZMbwEJlP7Q krhEyg/F/a3lQqzquBUo1/dSKVF1d9fxiaX8CLXT1qwMKbVDJJrniqu5uKDXsqrnj4mbWjPKsTlu noPQ/q7t71Mzr0usGeafB8ylPWgyWJ08ZVnZ1m+7TJxKFGfe2z3FBryT6xZwhj3ENpP7hJizw9nN ze0jt+6BpLPa/8mP3+bH/9Vzv8yPv4Ocy9uvXkLo/1f4t7yej+P/y+d/lnn1GYu8dEkS8jIfv4Tz dAN4fQu4uwUKc+73I+x2T/Jyldfh/QBd11PDqKxtIxVbRdoSMWKUnGHSwNx2hEQxjJEd35TwxVlg 1MqLtiwm2YstfmRuU8bu6iDKGFSAkhecvdsAJZ9LJbIoa3N4l+dg/e4Ul3do8qnh2CIMs5QvWBkH ufpIa/ulOcr665P67dtWplpWBZMJVWE2BEPALbF7Az5oxzB+HmCQLzB0zC4QPl6Hc9hLVjdIdnds xklO4JxGgXPP5yJ98crHKWUYT+Cc9/NfOYezm5vbI3Vxn2Cazf1d+Cr8qpz8c358zsli4xd/z+TM C2CkgqfAW7Te0jwsQ0quaGHdcdx3iKSie1qLSyy6o3IaYJ8xITrFMUQuhc4g7ykEnc9hPtPx89XV HaR3CbnCxZXNPEYORTMP5Zz6gQW1kfOyoOnq0TbQBOn60akXnH7jznzj1jkMgrYLgSYOPX9oD1F9 6+YbAMJycW/beZYyqlK0hVsNT+TbStKpGrO5zlDjzli6hjVwthryONZ4c9NrWwBO7Tmzck5cWsU1 0BGmLuysmqGJNScMSzijKPQo9c2jwZk9JAznqHAmFd0Nka4ZKQzicHZzc3vUgN6KQ9Mi9bW4uX8j Z85pQdtMFrvC5yRaS7IY4NV1wPPdGUE7jTd5je77zOeBksM4NkxwGWkRlspkqYdOPMGKnsq7cYzS slsTxhIlgEXV2zIwikuvePAxvydVRUtpFUrLEGgGQ+o6CqXNNnCrbe1bbVOpWLpn9nUNw6Mmhlls uhRnQbA66xmgcdpAu26nm1LZ3BxhKH2+l3FnkC8/ZWTWLFu8qX+ezHjGeY/tUGLMtdc2X0du8Axk 1D7bDGMQEJdksVjhDEs413i0noMC5wxlajazhHP+OzKM405Anf8uHIbzVYbzE4ezm5vbJ+nivpeb +5fDKyA3d0pP8uNvmWOfhfD6aQhPXuRrn4QL7AGvewhneZs5lxkHux0RY8+ucGoe1qPkiQ0xL8EU me4ygtnFTXpvn7Uwd9IEHqERO0CBM2dcL1zd/N1CEsVU+jKd0SRrSYyee7CbJ6zEeO6+hgnT2/fA 2cJsbmjp7AXhHq0917Kxi1u7jtYMi3h2iT83vbZLoxFo4upyjXRfm7q0rTwtSEMSBrZlakeGM72n ZGXDYL25Od4cNX4dLVmsG8zNTdcliv9beVYUKOe/ARtwFhd3zNssoakEOu/3+bmYKpyvMngHh7Ob m9tjcnEfyeamRew31c1tyWLthKv1kquqonkQ0iSjmyZcjaBp1SSWxxQin6F+YyO5vLm1dlK1bK5u wjcWtRzNtc1e4Ag6ZMpc2+WjYaOk9TBgmxktnb/oW0FE6b/Nrm0QiU3qOX8/CDI5KxTlqpnj1YVu ShraDO4YwmmdxKwSzDqfaAI6zgZqYJlKVWLViCXpDM2dPZmFbaoZNYN76tLWeLO4sgMn1pErOzG0 BbpW48z15CXJa1ofLf2187cuU9UMdmjhLMejwDmwO7uF854UssKZ/l5M4Rwczm5ubo9NQW+p6G83 k8VIRSO+CKSiEzURe/qG3/Kwis4k6LuioscOgR3cHVU5Y0kYi3nl5XYkoO5qBK5qFnCR67qTcHHU omOWr6qsLWkMKpRbwSx+aW0lBtXdDNbZ2sqsipqWLl+loKoCMoTaD7uB/MrkqdNVdB0JOW9ywoFz lEzuNhlM4avZ5FVBm2tbWqQOmjg2miIWlzZlvQOrZIZ35GQwSQpDgTYrZFBgG6SjKOSSEIby+grs qK5uSQDLv/mQVJFLnHkcSW3Tl7K7wRkznM8czm5ubp+8gsZwl7mTMxXdGpVcpf5ZmKjo13nZvqwq +uKc5kLugLo+QS8Kk2CbF2XoR1qwydHa8XYkSMdBplulQC7Q/GI6l1V0oj6gSZR3Qm23KYxN4gbn DiOlozVWR7aBFiW5irdcNi2NMVEqmRmEnahpVs+dxno5Ds2KGlQ9C9ejxnslpWzewGSqnuHIn0co 7vVJ/JmT1VHD2oimnlVJc6JY0vM2upNAy9O91AWOnEymdc46/9MGjiCVs0XtHEZp9/lLQEkGQ41L o/bVBgExqlu7ZGhL5jZyVvZIWdmslAXOiRPDBM75feJuvB+cnzqc3dzcHpuL+5CbW5PFzEpnse8D NS4ZhheBMrqtcQmTKy+ai4xu7i5G3a32cNtdpB0JO9JubcIYF0ftU+AaG2BXN4M7MegIzuLa1ng0 Rp0bJVldLHITkxqt/KqkRENVypr4BSXhSgBYSpI6TsISYEfhPnbSRczc3SAlYFjhTPDmVik1WSxY ZvkJcJ4s/NaZG5vEMK6sbvpv8xAR+f1lAAb//qjubQJwSjZiU9qEaktUgjm7rjn+TAqYa8Hp9nNi GGd0o9aRc+tUzdSWBDF5DT3XKZzTaF3CQjL3NapbO+iwi36scO4WcB66vAVMBc59vub2mmDscHZz c3uULu4T3dxNstj/fh7C7X/C34fn8OV4pcliN3n9vsjXvArh2VN2ol6Hq3BBHs2bvN6ey/eJW7yF 3S7J+9I04F3+pjFxdXesVanZdmTwcncT6l/BGdmRi5qxqmaGdMffAqTgWd3Q3OML9FwLaZ2ZwbBO GoWmt07Ffy2vt4C1dfMixMY6sEJBGNpSpxi26pMF4QuX9WT2c5qc1zjybPxlSRQDqM1LoKltlmYs NvsaNVFM3dkUX7ZOYQHVpc1baeDC6tnc08CdwgB11CRnaiuozaXNs6IpDk0F7TSFClkpS+IXKeie R0UmPp8o0Sufp8SwDF5ic5jCGVbhHBzObm5uj1pBz9zcJ5Zcbajo8I8M6C/+npH3hCCb3+g8r87U lvMlkl+6u3kScEeZ2lJ2BTsRvHNXN6mrGInilEgUGVmUNNZR++1YQZy47IolrmZ2TyHN2V4RUIc9 cg1VZH82qDtbnpfk8IRarUWqM3GZFbIWp46k9IOTuLNTlLeBWOq0sLi0WUVHLDOrYOne1ola0zW/ zRgvWeRQS6mwJIpJZbTNg7ZOZ7W0iu9WnW/NLVPJn8FztEUtV9UsQ0MYwhGk61oUF7fEmZHrlgM/ 3ylkdYJVlJadCSgxrJNOYJoAFnlumXUIoz/VscI5Opzd3NxcQb83FR3jRaC4MeI/gVQ0lVRd4Uu4 JLpcjyVh7DYr5jZhbOh3QL5jroylDmMUGqYEsfx810X+qNQElDqAQpQBxhoyLkljDGwVvQbpkrFt 50BSo1XpcpMx9XdjaX2N8sZGeJ5eKbqaa6SN8docRJW0xqyxDK/UmG/TG1szrfm7hc3ABmgeoZ2R XZO+1sqqrIc2T6SKtTOYtC6V8imOK9sQDOQYspU9mXqmrSSCoXQIQ5tsJQp5Gm825Sxwxgxjfk92 b1tnsVhKqqgzGAWTaUu+bGQm0/lM5Y6/AKTi1mZoxyRwzky/HWZwpv3z1HX5+4LC+WX/BZVaocPZ zc3tU1fQKyp6y7ZV9DD8HGiBNBVt3cVehIuwVnbFCWP0Q28D7M9CoA5jhIehzyqa49KktbpAKrrG oyPVN+UXZlFGEhzZFR4KpJPQK86Sw+RcEshK8bTGl1GUNbu+OW5LEE2sprkUSd6VVHO+tFMQW5mV xKI5w4x6oDHVo3i7pQ1p6TKmQzO0xAsOrPfTidPiTpcvDfJNQhupaLw8JflCQMpeJDSrZIIdKWaw qWCcHJa3UWPQ+Tlk8DaqmevdNOsatYMYb1GAzO3SYUiUEc79WrOaJmAH7qstrTvzF4LE9c49u7VH cn+nQJOmqCsYSWbprT2ExHAeOmk6ks/d7m9S/hQFztcZzpH3n+Xt7QTOkLcOZzc3tw/V4N2/p61J v2vO0xjK/whlDOVv/gLh+iv41c33+fjfM6R/gGH4DPb7v8T0i2dZg72BcQ/x83SZz2c8PDuDMW+p E/NlCnHY7TvM2zFrqbNdPp/6LnVDR9s+Za3VdXl/zEK6y9fte1rJO+pzkrd54c/HQ59f32dY0/vk 86EH2kI+h7TN53HsMzj6/HF6YjzyecjPY0fXZY52mb5ZxFOqWoYw0jVIaWsdubilLyhldHP7FCqQ LjXRVJ9NSWIyf5KvA518CbVvCc+mhKiMLne3qYmGSV9vioinAGGSg46ad66xbLQxmOrSlnnRnDSm SWFBn2MQc7KYzM4mqkPJ3JbBI5IIppBm1SzqGLjyTUusRC1rGRW9ttN4c+LkL8rQ5qEXnBDGrcCy LhZXdkkGK4MvMmwLnIcMZ9o6nN3c3FxBP4yKNlMVfXPzJ2hHUYZ/vAoZ0tzp+UW4CtQCNL3KFHsi 2dFv8uOiC6yiKfnrNutTUtFxzB8tC7Yhf8R+zKKvy/JrZHc3Lfghy66spEPgeHSiIOTAdVikqFsl jcRT6rmhGdzRVDO3Isu7MSaZ6oyimKlfmchQglriaR/ESnojqcgmp3iBM5dakZedVTPnlXNknOu1 haQak5YsdIkys8NdveIL2Vw6dvIQzGQYBzQgJ3n3xBFngzIdS2w9oSaQEYATq2eCMSeIiYJmCFNM PyXUCWDATUiwZnFLuZRMB1OFLfFmpFSCIctcmkPGE6eaMqpRhl7QeyicNRZNV3FM2uHs5ubmCvqn UdFfM6S/BFPRKf0rr8dPYfzi73lJfwIpK+fP0jXk3SgqmjAR4sU5pRYRJvO53a7b0YiMlFV0N1XR mPJOJ9uMwiy1k26pW+hSSWeYZIU8iqKm4Vn8PJqC7kRhh44VdFHT2OX3iKygSUlzchjPle4U1KKg Y+nLna/N/GD6B01dE9UsOeYgvcLV7V3vKsL6zReOJ4W1xL4JvboNBuvIqrl0CRM9ntjpbW5tkeFc bgWaIAaqlGWcJbm5o6njkVVzEkWdiprW5iLtPilnLpdKnKkt3cGaGmceFzobF8kzv3Vk5CBgJiA7 nN3c3FxBP7jRgvcfWCCdF8Xvrv8LfpUXSVPRHIvWFqAxvCE9mreXIato7J6dZai85IUxL8ohQzrT 5DLA7TCLR3dFRSfuXtZldT5yKtSYz3XcwSSFoqSRK65IPucfN2KUTG6JO0cs8ecgSlmTu2guVkxy TWBtTYo6cu1Vo6CDKmiFMytnjkVz9Rd5l7VpiShomWiJOgLT/NWqoDdafvJLQiqFYObW1gpvZN0L Em821zYP9gKJmVP8HATnAmoGLfKM7ZQY5JrFTTHjyHFiyeLWmdpZJackDUoorlwSxPLrEsr8bI0z U2Y9K+aRFbTVOI9c6jWf5UyAXoNz19WpVFfXt+hwdnNzcwX9LlR0+E34OkP65uZ7oISxYXiR1//P 8/r8CigePd6QSr6C51SMky4gPSFfaGD1fEHbc1XR9OiH7ixpTLofs5KmcmeNR7OC3mfFHFldT5V0 YoUcNfZclLKq6ciqWJ6LGmNu1bSAV5QzK2iKL4M2KGGVzY70aA1LqNxKASzJYjFFiT83SjpIxjlF qmOrnHGmosHUM/0P5YuEXlhi0OTODuKiTzxpU5SzqWVOdGuPKeac2D0/BnV9S7OSwC7spLCWWLMo 5TY2LSVUoPXNcbR4c6BpY9RDGxTy0nVknDYgqaqZ+6yPw8gZ7Pn8fqABGCEt4UwK+tzh7Obm5gr6 dF7jYRW9MUiDxlGyNbXRL/uL9Hz4MVIb0O7pOfPomkR4F0rvTNwHqo/mIqg4dCGv56HXjmNjHLNi 3lEPSG7JYUo68SxqiUVL12oreI7IjbSIkxR35lkQ7B/mEieubWYmdTTpkuDMMWnyXedfRiPW9LYc w2Voy3lGLieHkZubkc0iW5R0NAUdRVOLq7tR0avfg8ytbU1S5DchpUzfUSSbW+PnSd3a/EE0k1tn P1uMmZ+SGDJ5Bkgpc0yamocQPkXtWu0zgTgDOTTQ5hIqjllnOA8MYukMFmnYFO+PFJsmRwZlag9Z N2PburNLZVwkl1FlxXwbUgvn6xs+pq9QqeufJ3hFsJ7B+QeaNe5wdnNz+zise8fvf2Jd9B9pX87p II0fMjW/bMZRUoexWhtdh2kAZGifvREvLPRhn3lL9dFitNbT6GhGNmlcqtMJ3GksSg0UubVJA1Nu Fg9FospjWvGJnORhjknnUknlMrL0TeryjijjqiKHZCOYQpXh0pxyFQlq5JYPSZp7l1pmQqZNiOIu Yfl/KQbLpObkMxrKJQ1DkFUvuaWpP5p2AGPpLV3BrNEIPyI/B9oljF3SMRS3dLCkriADKKTeWbt+ xTqTOcjwC+ssNugQjUHbd4qrOqLUOwfUQReRx0FGen9+b+Qsboons4qOEqMuAy8yp6neqs3UxqbG 2fpql1nOfb4vK3AGuJ3Aue9D+lcGscPZzc3NFfS6ndBdjBY/cnX/eqKiM6nDOS2ciw5jktVNcegX 6QekCHV6dY7ds5s0DjexqY9GkaEYLLObkBP7rKQzq/qROliMgZQ0akw6ZljnY/JFc+9v7gGOLMfz fuYNT4+kuHTKcCVyj5yinZlT1DTnh3GVEk+fJghHiU9zaxOegIlY659FVSNIshj9OP4mQIpZsrpR 66HVrS2l09W1javfhnhcpvKaZ3DwlwVuSsodv6PO9uB+LRwzl7i09OJmt7IlinF/bq2JFrc2g19q pCVRjKHLHcMsHh014ctUM7krKMxP0QjKxObrksSbe3Znc6Y2ZW+T17utcbbuYFGGXkzgnMF83Qmk Kb7ewvlFvOLP6nB2c3NzBX1vFR0aFf1b2f+v5yH8z78E6jD2bz3VU30ZZJCxjKQMr6lXN3Fvx726 n8Au0FhKuHiSr7vhH7kfSElrZ4+8P2ZCd9x/Kx83Shq4y9iYadOFSIlj4uZmckq5lShpYRxwsFtC wqKieYaHwJmc4CgvlBagUQZLEHpNRUvGdGTHeRJVLZDUGDEnmfGILZnkXLuJ6bEoYbTxj4njydyk VEZIkotZu3/RL2g9tVNVwtylSzt5af2yKuky4pEVtw62AB5eQY1JRAmLK5s7hYnbOytousOihqmt J2V2j3LtKElh5vamhqsKcymz4iQxPkc9RKUb2MAdzgaKIw8ULtDuYDqRiirXKb9tCuebDOe8fQUN nC8dzm5ubh+1wU/zc7YSxnhRnCSMBcrqnjUwmZdezZPGUjrL2uzVsvzqDOJu6FnBYk/XTRPH6Dw3 M0Epw4qcLJYfXHaVOiq5CnyOKrFoS0ljScqrELrA5VcdVfxIgpiUZnfRJlfRdVFLrDgGzXqWlXLU BiWS3W3JYUEzu3m+dbByK7mDFoNeu9moJdGaMJZQp2w1iWKaLCaJYtq0hGujMdmM6KQlV1RVznli SUuv+DyOVopFSjmwGpZEMkkqE/VM7xO5Gxip5sjJYVSvZS5tUsrWU5uKukoy2CCdwSDepFsC8S02 rTufpDewR94nQMcbhFfnJ8P5/PwH/I5ujMPZzc3tkSvoDRUdZip61qebVPRX/3liPPpJuIFn4QJf QbjtQzgbuV83CcmDSppqe2j6FVX5dh1jMhHNOcRLbM4iNEszfp6bb3YccxYvNDZqGrioKpa4M/2v S3KtwE+UManaTmLI3DNUVTRK3JlzxaRRCM3JKDFodUWnooZ5G+145dFeC+w+1hrkMr+Z4tQgsWnu gR05Bq2jHnV2cywxaXNlm2IOqrBlzCQ1Fwk8a1vi0fQ8A5dq1DgmTcMuSD0z5SkLWzO2sxRue2rn Gy9znGlQNzUmGaXGOeGsr/YZ5dqjwbl78xn32G7h3P3431LfZ4jHs+BwdnNzcwX9YCp6q4HJeukV tQJtm5i05VfkBk/p9UJJn41SfsXHWU33qqBJTdM5amaSyO+NOwqdkqxm5YyknE1Nk2amfVLYaApZ FTQrZFPUgV8XTDkHzjnTbmJE+zGKstY+3KilVTE0TUqKqg5tsxK5lQitYmbVbCqaY9CtouZeYQl0 P3E/tYSilK2rWFC13Iyn5Ji0xJ6DKmVR2KqoSUFTzJnPMZ3LfmY/HXAiGF1LbB5GVcil+Qi/ZyrJ YLN4M02hsgYk+U9P4Pw6w7n7LJ+7KXDuzvNr/vE0n3+d4fwZUi29wPl7pJwGh7Obm5sD+qSfdaqr O9uiy9hbQpqW+Z3tZxj35wxP6Tom4MUMZ+46xo08qVhaz5ubm93fQYp7kEAdtHsYAbkFtSaDodZC Q9B2ni2sxaVt7m2MXBZN4rL24i41z1DHTs693KmFxrIOOqmb28qrBOACZ4GyALvtKCbQjpRs3bi+ DcykdwduYiLubPZbK5hDEqW8TzJGLCSubebz4tJum48wiGElGexAA5IYLxjO3e7LBP0VOpzd3Nw+ FXufncRWenSfmtWdId10Gev7f9f66HlmN7u7UxwuIlVFW430GPbcYbt2G2MShtt91pa7EM7I0z8O mbk0QzGF3XiW90koZ5qQUzpyBhlNOyR4c5Z3sJooiluT1zejXZzb5J7VWc+U1c3KuLOs7VFgTd5g RnsBNSdrS6wZJNeauSnZ21iBLOAut3RJDolVyyhMm+7MNdE6PRN1NjTnloO41mUCZuK5m6SdQYZl BM3mFiVNid5QSrqk4cjA57WuWXzSUSBNr5VYM7mzd0U11yztLu0VyNx8RGFc4s3dJZVP47zGuYWz zXLuui/R4ezm5uYK+qd0da8mjc2V9GVW0lfwGUU+F0r6FixxjFS1dRzDsxCpdzeHlbuBEr5iL1XL 1eXN+6amszLudnKO9+XajhV1L4lfRVEHTQQTJV0TxMS9zbCWOVQRo7i7a2C7dhKLUWGssN7qwy03 uLq6rfc2FYaxK1vKr7AM0EjyTSCJ0hYYa8mVqOVOE8XouZFrsYv7GwTMNB2DuoGJ61vc2ayOGcBd /l6jwzcmqrlxaefjWzqe9dRuk8EkU3ujAcmkO9hnGcr/4s/vcHZzc3NAv1NX9zakKR6tSnoV0nN3 d5vdfXlB+7UtaAtpi0vT/o72DczIZdTRYtME5phqbNlc49wGhVV0r3XONhBjFFirci6wDjJe0vYF 2FEUdJRtsLj0Qjm3eX5je5ura7txc3PqGceeDcia2Z1svxO3Nulliz9rTNr2+XULMMsxNO5sBnEb a84wLqr5gEu7xpuf8v4yU/sC7wbnv8jndzi7ubk5oO8L6d/Nzp+WNCaQtvKrY5C+ofSlDMYzuDiX Ht6IPZVqleQxBrSWYk3VNJVfnYla7qo6liQyLZkyUKOq7gJnuTYW5UzHlBwmiWHRgNwAu6po9l2L Z1k5W+GcZvdMPOlyl3lSR7D4c1HPRU0rnKUJCVWM1fgzP0dquVe1rO7uoCAuyWIKZ1bG+yRJYFHc 2frclmqeuLRhh/N4c0kG00ztNhlsq6+2w9nNzc0B/eA/e01Ft5D+up4/GdLLxDF8dgbj8DID8xxs wAZe7ouaRtzBITWNfT0/dXsLmNdA3aP22mZVPWi3sBbWyTqJ1eQwHXwlAG5BTXAmjZ62/+xSA+kC 5jFYDXQq2dyWIGbApmIpSvHOX0kg4UQt6/MVzL0q5lAB3oCas9tYNZ8dVM352gJmuNrhdVfbdrYD LywZ7JQGJBM4/4F2HM5ubm4O6AdQ0SdAepHZfRzSmOFMwzUE0jdAs6QN0oi3sBaXPksDbKtp3XJ6 2BTcoe+gw/p8iIPsh8jnGcoMZ1XM3IpsyKo8TmPPJQbdSYfNqHBuVHObxJ1WlbT2JAuqnmEeiyav fNJzAmaBMrm4BcIM6wbElPxFc6sqmHepxpl127qzqf57P+BUNV9wEtiaS3seb7ZksNhdTpLB+FOe 1B3M4ezm5uaAfseQnsejtyC9XoJFHcc+T5f5ukylDGlM59Amj5W4NO7BSrHCeQ9zNU19OLZB3UFJ DOPnM3hRFDOf7wTGU1gnkHpoU9epllh1fTAVzaDGtBKHXtzWApUKYka4JotR87IkPbql6yi1KhGF nPfHVkGPAm52UYcRa/IXZ3bjOO4WYKbR0HN3doAel6r5MqvmoVHNUkJ1ON68lqntcHZzc3NA/4SQ 3koaux+kE8P5XxGfZhXdxKWf4A7G8zccmw64Y3Dj+QAWm8bQw8TtTa2lG1AHFEBLjHovAFZVrSVZ opgJxNGAzOMlFdhNYlhQOPN0RxuSYYC2Crm1GDTfAR2YYerZjlVBWxw6Hw8Ma1XQYxJ40z7D2tTy zjK50ZK/8rcH3ATzvsfWnR1uaNhIjTWbagY4K1naB13as2Sw08qoWjhvgdnh7Obm5oD+ACG9jEtb U5O5mm5j04GRlre7XgA+A3VWuvqafez7qHXOXQbtnsqfocJalDIqtEOnIG6A3Cu8K4z7gIfiz2aj qeeBoc0gVkhDq6BHcXtDqGAWpWxQHjUW3bF6HvRYQH12EMzkwiZ3Ntz00ubUSqaaWHObCEaq2Vza cCTezPfmrcuoHM5ubm4O6LeA9ImZ3Qpp2mzVSYfw30P6xeuS4U1x6c8zpFuXt5VitWraYtME69bt vQT1bQa1urgVwqjgJmXd92OFdRhFWRPMOxqzTHFrc3UnhXIvirmLWvucGhV9qMdMVc9FQdNvSqwu MK6xaAYy6fdBty2UB4WvquVgbu58LDFmurYBc5C48m3Mx407m5SzZWjPVfNay865S5t9A5vJYA5n Nzc3B/QHoKLvD2kWlndS0xqbztC2TG9ye2+CGjOoNUZNEOasb9o3Vb2AtYJat+IeH1Vhjxx37kkx Y2pc3qFxcx+7o1VB86HCmPdHSRAzIDOMeUsJYTtRyqHCugI8pD10aAqZFHRW3XgIzFzLfIPpTQbz Wqz5bi7tJt7McL5PGZXD2c3NzQH9fiFdQL3ecSyE/xHWM7xJTV9CLcUyNZ23TaY3ub2pZjqrbwU1 KefrCagtRo27gZ839zfDdwZrO7cObP46wc/xXWBgkxGcd5XV5bzeQAKpiugQ9g2cDcRkBmO6dh9g kDg0q2uD8URVG5TlNZaVzWA2V/YEzJeaoZ33Z+7saayZ4NyqZsnSDn8jtbzu0qbtO0gGczi7ubk5 oN83pA/FpavLe0tNL93eBmqLT88VNZdmKZgxY49UtcAa2LXdwroq5Rmw+SNnaNO5HUG4AXYIqqh3 B27hXuPPZgpiOjd0OIiEbhSyAFlOi/uazrdQnqtly8oOdP6GQH0amA/GmhvVTL/L6fFmh7Obm5sD +gOGNC/MByF9isubf5LGppOqaOtAZm7vFtRTRb0HTiY7z0DOAD/LzxVVPYF1X5TyOrAZqnXfVHQY Z2MmzdW9K2AOEzDTjVRFrepZYHyrKloVcnPNAspNbDmwYha1TFnZBGtL/jJXNoH5igZaNDXNczBP 3dlrqnnp0j7cGYzMy6jc3Nwc0B8gpDfU9JG4NJ07WU1jBvTT6vZegnrPGeCmqiVpLEP5nFzeA2zB WhTxDNgK5aqmSUmfye7MpX30JhaXtwJ6BmOCtVxTgcyquFHKBcqtWs6/aQtmG2xxSDELmKWumRXy CaqZthOX9gLOW2B2OLu5uTmgPw5IH3F5z9V0CD8Pkul9B1BrMlkL6qKqG1ifG5RnwOZPVxQ2/0YK 8K581t0dAb1XQEMTf5bjQbYNkOWGnw5lzsy+vkVL/loHs8WZL/L7/zPMM7RD+Gs4rprv6tJ2OLu5 uTmgf2JIr4H69Lj0qWqaf+IGqOV1Auhjqpq34TIQkMkNzip6Bmz5dAptPlBYn4VQztldKCBvFfOw gA9DmHcUyjMY2+sEyBng1zdBEsDmUKZrr4K5seEEMP9I7z2LM7fu7IOqmeE8d2kfg7Nnaru5uTmg P4Df8z7JY6G4vNfUdJvpfQqo+dyzMy3Jmqpqeu5JhnWaw1qkclHXAltR2Mzi1Lq+7aNWOBPAT7tp DawbENOWYWzQvg5TIAvVi1Lmw1Uon+XnXoY1V/YqmAnGm+7su6rmQ3D2ZDA3NzcH9EcA6bupaQN1 6/Y+BuoQPg8M56Y8K4TnoVXVAtyqrOU9psCWa6rKLuC+oL1ziUW3n1xBfq7HNwzFfgkhU9XXjXoG Be8MyLxb3Nc7fB1ehxbK8hpTy/n45ct8PI0xz13ZSzBXd7ap5gLme6lmh7Obm5sD+iOD9Alq+p6g bmPUVEP9RSBXd6uq12EdwtMgyvkWntJrLs4KmAnYFdL20XZVObfnJ3ap26vlDTMAlxNTMBeFTMdv 8juoSpZzG1DOqtnc2CG8CG1WNgN4BmbazuPMBmb+gjFXzc8zmL+9q2p2OLu5uTmgP2JIH1bTdCiZ 3mTL+PQxUNPzVVXTa6awlnPiBhcFXIFtCpuhnTK0n8yBfFkU851vmEJ4AmyFsZxbA3Lrvt6CclXL a2DeVswb7ux7q+bNvxYOZjc3Nwf0hwXph1LTpKLb+PQ6qPknz9zfIfwsSC31EtasqBnOAmxT2BXa BOezWULYbTl+qv9PaamoYxQAk2t6qqTPZpB+rfCuCllef67KOh+/DOq+rlBuY8sCZdp+H+ZZ2SeB meF8zJ19DM6umt3c3BzQj0RNHwZ1hbUkkxmsU3oG4ZcCagbvCqwFyDVmXYFN152X97fnWnCXT5Zu T/4zM/hOQX2DFeYG46qQ63Naq7yqlCuURS3PwfxCgXwIzGvu7AdRzQ5nNzc3B/Sno6bDyaCex6jn oGbA/uJZUdVLWJPNgU3WQBvz9rn9Ms8PQrnCfArddVi/lANVxtPXiEKmY1PJ8rpToTxVywLmGmPm O96C+d2oZoezm5ubA/rj+Rz3VNO/JZDdBdRkK7BWZV2BLTHrqoivFN6SaFbBW8G9BuK7mkG4Hl8U kJlCXgMyn9uA8iG1bGBeKOa3ArOrZjc3Nwf0JwrphwN1uAes25h1q7C3oG1qmzFdgH13E0VsQJ6C uID2AJDJDkF5E8wtlO8FZlfNbm5uDuhH8pkOqekjoGY+T0HNWNkA9RasF8BOr4vCnkJ7Ce63NYEw 2ff1ZimMDwNZ3NfHoMx3cA7mgzHmU8DscHZzc3NAPzJI3wXUIazHqA/B+nRgT6G9VNqrn2IC8pUb 0IB3AWoGMdlfy7ktIN8NyiyTV9Syg9nNzc3NAf0+Qf3b0Li/K6y/bt5hS11PgS3QJpuDewnv+1kL 4AmsD8B4DuQFlI+q5fuC+eAfnYPZzc3NAf04PuNdQW2wnrm/N2BtyjqsqGuB9A+LnzkFd4W32RrE 18Hb2p8X18xhfAjIm0p5Uy2TnQJmV81ubm5ujxXQDwjqE1T1FqzJZsBeQvswuB/SBMRkf5qcXwB5 rpIPKuU5lB3Mbm5ubg7oB/nMcw6cCuojsA6nA3sb3EuIH7c/rZ5tIbwO45lCfmdQPumvoMPZzc3N Ae2f/T6gPgTrU4HdQNtM4b0F8PvYd+1BAfEKjDeBfF8oO5jd3NzcHNAP/vnfFtYH1PUc2qvgPgDx k+0P20891/jxt1sX/Lq5AXeFsoPZzc3NzQH93kF9CqyPAfsAtLcAvmYG9edfHYbbt8d+0K9nr//9 yjXvBMoOZjc3NzcH9E8J6y1gz6Ed7gbwO9mvV3753x+4/usTwfkN3vOvl4PZzc3NzQH9Lu7N28D6 GLRPhfgx+/2J1319R1g6lN3c3Nwc0B/FPdrizu8e4D5/95bv8fUDQPEbfMtb5GB2c3Nzc0B/qLB+ KGC/a/sGH+ivjUPZzc3NzQH9Id+7Uzn1vuH9Db6jvyYOZjc3NzcH9Md8H/FT+SgOZDc3NzcH9GO5 r/ih/7E7lN3c3Nwc0H6fPwBzILu5ubk5OPzeO4zd3NzcHBJuj+/PxgHs5ubm5ubm5ubm5ubm5ubm 5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm5ubm 5ubm5ubm5ubm5ubm5ub2qdv/F2AApm76kWX5vj0AAAAASUVORK5CYII=",
    transform: "matrix(.24 0 0 .24 51.84 48)"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFF",
    d: "M151.86 80.14c5.52-5.52 5.52-14.48 0-20s-14.48-5.52-20 0l-63.72 63.72c-5.52 5.52-5.52 14.48 0 20s14.48 5.52 20 0l63.72-63.72z"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.2,
    fill: "#FFF",
    d: "M50 81c9.77 0 17.71 7.79 17.97 17.5 0-.17.03-.33.03-.5 0-9.94-8.06-18-18-18s-18 8.06-18 18c0 .17.02.33.03.5C32.29 88.79 40.23 81 50 81z"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.2,
    fill: "#FFF",
    d: "M96 9c48.44 0 87.73 39.14 87.99 87.51 0-.17.01-.34.01-.51 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .16.01.32.01.49C8.28 48.12 47.57 9 96 9z"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.2,
    fill: "#FFF",
    d: "M68.14 124.87l63.72-63.73c5.52-5.52 14.48-5.52 20 0 2.63 2.63 4.01 6.06 4.13 9.51.13-3.78-1.24-7.62-4.13-10.51-5.52-5.52-14.48-5.52-20 0l-63.72 63.73c-2.89 2.89-4.25 6.72-4.12 10.5.13-3.45 1.49-6.86 4.12-9.5z"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.2,
    fill: "#1A237E",
    d: "M96 183c-48.44 0-87.73-39.14-87.99-87.51 0 .17-.01.34-.01.51 0 48.6 39.4 88 88 88s88-39.4 88-88c0-.16-.01-.32-.01-.49C183.72 143.88 144.43 183 96 183z"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.2,
    fill: "#1A237E",
    d: "M50 116c-9.77 0-17.71-7.79-17.97-17.5 0 .17-.03.33-.03.5 0 9.94 8.06 18 18 18s18-8.06 18-18c0-.17-.02-.33-.03-.5-.26 9.71-8.2 17.5-17.97 17.5zm101.87-35.87l-63.73 63.73c-5.52 5.52-14.48 5.52-20 0-2.63-2.63-4-6.05-4.12-9.5-.13 3.78 1.23 7.61 4.12 10.5 5.52 5.52 14.48 5.52 20 0l63.73-63.73c2.89-2.89 4.25-6.72 4.12-10.5-.12 3.45-1.48 6.86-4.12 9.5z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/react.createElement("radialGradient", {
    id: "google-tasks-icon_svg__c",
    cx: 33.78,
    cy: 33.777,
    r: 175.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _circle3 || (_circle3 = /*#__PURE__*/react.createElement("circle", {
    fill: "url(#google-tasks-icon_svg__c)",
    cx: 96,
    cy: 96,
    r: 88
  })));
}
/* harmony default export */ var google_tasks_icon = (SvgGoogleTasksIcon);
;// CONCATENATED MODULE: ./src/img/integrations/jira-software-icon.svg
var jira_software_icon_path, jira_software_icon_path2, jira_software_icon_path3, jira_software_icon_defs;
function jira_software_icon_extends() { jira_software_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return jira_software_icon_extends.apply(this, arguments); }

function SvgJiraSoftwareIcon(props) {
  return /*#__PURE__*/react.createElement("svg", jira_software_icon_extends({
    width: 32,
    height: 32,
    viewBox: "4 4 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jira_software_icon_path || (jira_software_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M26.914 15.337L16.572 4.994 15.577 4 7.82 11.757l-3.547 3.547c-.364.364-.364.961 0 1.359l7.094 7.094L15.577 28l7.757-7.757.133-.133 3.447-3.447a.94.94 0 000-1.326zm-11.337 4.21L12.03 16l3.547-3.547L19.124 16l-3.547 3.547z",
    fill: "#2684FF"
  })), jira_software_icon_path2 || (jira_software_icon_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15.577 12.453c-2.32-2.32-2.32-6.1-.033-8.42L7.787 11.79l4.21 4.21 3.58-3.547z",
    fill: "url(#jira-software-icon_svg__paint0_linear)"
  })), jira_software_icon_path3 || (jira_software_icon_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M19.124 16l-3.547 3.547c2.32 2.32 2.32 6.1 0 8.453l7.79-7.79L19.124 16z",
    fill: "url(#jira-software-icon_svg__paint1_linear)"
  })), jira_software_icon_defs || (jira_software_icon_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "jira-software-icon_svg__paint0_linear",
    x1: 14.945,
    y1: 8.86,
    x2: 9.991,
    y2: 13.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "jira-software-icon_svg__paint1_linear",
    x1: 16.256,
    y1: 23.089,
    x2: 21.2,
    y2: 18.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
/* harmony default export */ var jira_software_icon = (SvgJiraSoftwareIcon);
;// CONCATENATED MODULE: ./src/img/integrations/linear-icon.svg
var linear_icon_path;
function linear_icon_extends() { linear_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linear_icon_extends.apply(this, arguments); }

function SvgLinearIcon(props) {
  return /*#__PURE__*/react.createElement("svg", linear_icon_extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), linear_icon_path || (linear_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M.403 37.4l26.198 26.197C13.223 61.336 2.664 50.777.403 37.399v.001zM0 30.287L33.713 64a31.992 31.992 0 005.852-.858L.858 24.435c-.46 1.89-.75 3.847-.858 5.852zm2.536-10.883l42.06 42.06a31.944 31.944 0 004.4-2.31l-44.15-44.15a31.933 31.933 0 00-2.31 4.4zm5.159-8.259C13.568 4.32 22.268 0 31.977 0 49.663 0 64 14.337 64 32.023c0 9.71-4.32 18.41-11.145 24.282l-45.16-45.16z",
    fill: "#5E6AD2"
  })));
}
/* harmony default export */ var linear_icon = (SvgLinearIcon);
;// CONCATENATED MODULE: ./src/img/integrations/monday-com-logo.svg
var monday_com_logo_path, monday_com_logo_path2, _ellipse;
function monday_com_logo_extends() { monday_com_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return monday_com_logo_extends.apply(this, arguments); }

function SvgMondayComLogo(props) {
  return /*#__PURE__*/react.createElement("svg", monday_com_logo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20.5 275 101 101"
  }, props), monday_com_logo_path || (monday_com_logo_path = /*#__PURE__*/react.createElement("path", {
    d: "M33.6 352.7c-4.5 0-8.7-2.4-10.9-6.3s-2.1-8.7.3-12.4l22.4-35.2c2.3-3.9 6.6-6.1 11.1-6s8.6 2.6 10.7 6.6 1.8 8.7-.7 12.4L44.2 347c-2.3 3.6-6.3 5.7-10.6 5.7z",
    fill: "#f62b54"
  })), monday_com_logo_path2 || (monday_com_logo_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M72.1 352.7c-4.5 0-8.7-2.4-10.9-6.3s-2.1-8.6.3-12.4l22.4-35.1c2.3-3.9 6.5-6.3 11.1-6.1 4.6.1 8.7 2.6 10.8 6.6 2.1 4 1.8 8.8-.8 12.5L82.6 347c-2.3 3.6-6.3 5.7-10.5 5.7z",
    fill: "#fc0"
  })), _ellipse || (_ellipse = /*#__PURE__*/react.createElement("ellipse", {
    cx: 109.6,
    cy: 341.7,
    rx: 11.5,
    ry: 11.3,
    fill: "#00ca72"
  })));
}
/* harmony default export */ var monday_com_logo = (SvgMondayComLogo);
;// CONCATENATED MODULE: ./src/img/integrations/office-365.svg
var office_365_path;
function office_365_extends() { office_365_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return office_365_extends.apply(this, arguments); }

function SvgOffice365(props) {
  return /*#__PURE__*/react.createElement("svg", office_365_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 278050 333334",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), office_365_path || (office_365_path = /*#__PURE__*/react.createElement("path", {
    fill: "#ea3e23",
    d: "M278050 305556l-29-16V28627L178807 0 448 66971l-448 87 22 200227 60865-23821V80555l117920-28193-17 239519L122 267285l178668 65976v73l99231-27462v-316z"
  })));
}
/* harmony default export */ var office_365 = (SvgOffice365);
;// CONCATENATED MODULE: ./src/img/integrations/raycast.svg
var raycast_path;
function raycast_extends() { raycast_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return raycast_extends.apply(this, arguments); }

function SvgRaycast(props) {
  return /*#__PURE__*/react.createElement("svg", raycast_extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), raycast_path || (raycast_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19.073v2.92l-7-7 1.46-1.46L7 19.076v-.002zm2.921 2.92H7l7 7 1.46-1.46-5.539-5.54zm16.614-5.537l1.461-1.462-14-14-1.458 1.466 5.539 5.538H14.73L10.864 4.14 9.404 5.6l2.405 2.404h-1.68V18.87h10.865v-1.68l2.405 2.404 1.46-1.46-3.865-3.866V10.92l5.541 5.535zM7.73 7.27L6.265 8.732l1.568 1.566 1.461-1.46L7.73 7.27zm12.432 12.432l-1.46 1.462 1.566 1.568 1.462-1.462-1.568-1.568zM4.596 10.404l-1.462 1.462L7 15.732v-2.923l-2.404-2.405zM16.192 22h-2.924l3.866 3.866 1.462-1.462L16.192 22z",
    fill: "#FF6363"
  })));
}
/* harmony default export */ var raycast = (SvgRaycast);
// EXTERNAL MODULE: ./src/img/integrations/slack-icon.svg
var slack_icon = __webpack_require__(80613);
;// CONCATENATED MODULE: ./src/img/integrations/todoist-logo.svg
var todoist_logo_defs, _g;
function todoist_logo_extends() { todoist_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return todoist_logo_extends.apply(this, arguments); }

function SvgTodoistLogo(props) {
  return /*#__PURE__*/react.createElement("svg", todoist_logo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "500 500 1450 1450",
    height: 2458,
    width: 2458
  }, props), todoist_logo_defs || (todoist_logo_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "todoist-logo_svg__a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 0h1844v1844H0z"
  })))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#todoist-logo_svg__a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 2458.667)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M1304.5 1434h-768c-70.4 0-128-57.6-128-128V538c0-70.4 57.6-128 128-128h768c70.4 0 128 57.6 128 128v768c0 70.4-57.6 128-128 128",
    fill: "#e44332"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M627.257 954.226c18.088 10.425 405.501 233.359 414.391 238.495 8.872 5.12 9.317 20.833-.609 26.498-9.937 5.665-28.799 16.381-35.819 20.488-7.144 4.168-19.996 6.486-31.914-.379-4.948-2.854-336.042-193.231-347.109-199.521-13.246-7.53-29.638-7.627-42.84.013-10.423 6.034-174.857 101.584-174.857 101.584v-86.356c42.564-24.786 148.39-86.421 174.038-100.9 15.307-8.643 29.96-8.43 44.72.078",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M627.257 781.688c18.088 10.425 405.501 233.359 414.391 238.495 8.872 5.121 9.317 20.834-.609 26.499-9.937 5.665-28.799 16.381-35.819 20.488-7.144 4.168-19.996 6.486-31.914-.379-4.948-2.855-336.042-193.232-347.109-199.522-13.246-7.529-29.638-7.627-42.84.013C572.934 873.316 408.5 968.866 408.5 968.866V882.51c42.564-24.786 148.39-86.421 174.038-100.9 15.307-8.643 29.96-8.429 44.72.078",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M627.257 609.15c18.088 10.425 405.501 233.36 414.391 238.495 8.872 5.121 9.317 20.834-.609 26.5-9.937 5.664-28.799 16.38-35.819 20.487-7.144 4.168-19.996 6.486-31.914-.379-4.948-2.856-336.042-193.232-347.109-199.522-13.246-7.529-29.638-7.627-42.84.013C572.934 700.778 408.5 796.328 408.5 796.328v-86.356c42.564-24.786 148.39-86.42 174.038-100.9 15.307-8.643 29.96-8.429 44.72.078",
    fill: "#fff"
  }))));
}
/* harmony default export */ var todoist_logo = (SvgTodoistLogo);
;// CONCATENATED MODULE: ./src/img/integrations/trello-icon.svg
var trello_icon_g;
function trello_icon_extends() { trello_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trello_icon_extends.apply(this, arguments); }

function SvgTrelloIcon(props) {
  return /*#__PURE__*/react.createElement("svg", trello_icon_extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), trello_icon_g || (trello_icon_g = /*#__PURE__*/react.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("rect", {
    fill: "#0079BF",
    width: 200,
    height: 200,
    rx: 25
  }), /*#__PURE__*/react.createElement("rect", {
    fill: "#FFF",
    x: 113,
    y: 26,
    width: 61,
    height: 87.5,
    rx: 12
  }), /*#__PURE__*/react.createElement("rect", {
    fill: "#FFF",
    x: 26,
    y: 26,
    width: 61,
    height: 137.5,
    rx: 12
  }))));
}
/* harmony default export */ var trello_icon = (SvgTrelloIcon);
// EXTERNAL MODULE: ./src/img/integrations/zoom-icon.svg
var zoom_icon = __webpack_require__(66175);
// EXTERNAL MODULE: ./src/utils/oauth.ts
var oauth = __webpack_require__(55748);
// EXTERNAL MODULE: ./src/reclaim-api/Credentials.ts
var Credentials = __webpack_require__(41849);
// EXTERNAL MODULE: ./src/reclaim-api/Users.ts
var Users = __webpack_require__(91669);
;// CONCATENATED MODULE: ./src/reclaim-api/Integrations.consts.tsx






















var SLACK_APP_ID = "A01B0K9E80M";
var OAUTH_BASE_URI = "https://api.app.reclaim-staging.com/oauth";
var JIRA_MARKETPLACE_URL = "https://marketplace.atlassian.com/apps/1227309/task-planner-for-google-calendar-reclaim-ai?tab=overview&hosting=cloud";
var INTEGRATIONS_META = {
    ADD_ON: {
        label: function() {
            return "Google Add-On";
        },
        description: function() {
            return "Install Reclaim's Google Calendar Add-on to manage your Tasks, Habits, & Smart 1:1s directly from Google Calendar.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(gcal_icon/* default */.Z, {});
        },
        entitlement: "INTEGRATION_GOOGLE_TASKS",
        unconnectedActions: function() {
            return {
                label: "Connect Google Add-On",
                action: "//workspace.google.com/marketplace/app/reclaimai/950518663892",
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return {
                label: "Add-on Help",
                action: "https://help.reclaim.ai/en/collections/3755450-google-calendar-add-on"
            };
        }
    },
    RAYCAST: {
        label: function() {
            return "Raycast";
        },
        description: function() {
            return "AI extension for Mac — quickly create Tasks & Scheduling Links, view your calendar, start Tasks & Habits, & join meetings.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(raycast, {});
        },
        entitlement: "INTEGRATION_RAYCAST",
        unconnectedActions: function() {
            return {
                label: "Connect Raycast",
                action: "/settings/integrations/raycast"
            };
        },
        connectedActions: function() {
            return [];
        }
    },
    GOOGLE_TASKS: {
        label: function() {
            return "Google Tasks";
        },
        description: function() {
            return "Sync tasks both ways between Google Tasks and Reclaim.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(google_tasks_icon, {});
        },
        entitlement: "INTEGRATION_GOOGLE_TASKS",
        unconnectedActions: function(param) {
            var router = param.router;
            return {
                label: "Connect Google Tasks",
                action: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var res;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    reclaim_api/* reclaim.credentials.getPrimary */.Tz.credentials.getPrimary()
                                ];
                            case 1:
                                res = _state.sent();
                                if (!(res === null || res === void 0 ? void 0 : res.id)) return [
                                    2
                                ];
                                return [
                                    2,
                                    reclaim_api/* reclaim.credentials.expand */.Tz.credentials.expand(res.id, Credentials/* AuthMode.Tasks */.vB.Tasks, {
                                        redirect: "".concat(router.asPath, "/google-tasks")
                                    })
                                ];
                        }
                    });
                }),
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return {
                label: "Integration Help",
                action: "https://help.reclaim.ai/en/articles/4293077-google-tasks-integration-overview"
            };
        }
    },
    SLACK: {
        label: function() {
            return "Slack";
        },
        description: function() {
            return "Receive notifications and sync your Slack status to your calendar automatically.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(slack_icon/* default */.Z, {});
        },
        entitlement: "INTEGRATION_SLACK",
        unconnectedActions: function() {
            return {
                label: "Add to Slack",
                action: "".concat(reclaim_api/* reclaim.client.baseUrl */.Tz.client.baseUrl, "/slack/add"),
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return [
                {
                    label: "Open In Slack",
                    action: "https://slack.com/app_redirect?app=".concat(SLACK_APP_ID)
                },
                {
                    label: "Uninstall",
                    action: "https://help.reclaim.ai/en/articles/6935794-how-to-uninstall-the-slack-integration",
                    changesConnectedStatus: true,
                    undisableable: true
                }, 
            ];
        }
    },
    ZOOM: {
        label: function() {
            return "Zoom";
        },
        description: function() {
            return "Automatically update events and Slack status when you join/leave Zoom meetings.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(zoom_icon/* default */.Z, {});
        },
        entitlement: "INTEGRATION_ZOOM",
        unconnectedActions: function() {
            return {
                label: "Connect Zoom",
                action: "".concat(OAUTH_BASE_URI, "/zoom/init"),
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return {
                label: "Integration Help",
                action: "https://help.reclaim.ai/en/articles/5413550-zoom-integration-overview"
            };
        }
    },
    OFFICE365: {
        label: function() {
            return "Office365";
        },
        description: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        color: "primary",
                        href: "https://help.reclaim.ai/en/articles/3640324-sharing-your-calendar-including-non-google-calendars-with-your-work-calendar-to-block-events",
                        target: "reclaim-help",
                        children: "Read our guide"
                    }),
                    " ",
                    "on syncing an O365 calendar to your Reclaim calendar."
                ]
            });
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(office_365, {});
        },
        entitlement: "INTEGRATION_OFFICE_365",
        isFuture: true,
        interestTrait: Users/* InterestTrait.Office365 */.u1.Office365
    },
    TODOIST: {
        label: function() {
            return "Todoist";
        },
        description: function() {
            return "Sync your Todoist items to Reclaim and get them scheduled as tasks.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(todoist_logo, {});
        },
        entitlement: "INTEGRATION_TODOIST",
        unconnectedActions: function() {
            return {
                label: "Connect Todoist",
                action: function() {
                    return (0,oauth/* initiateOauth */.N)("todoist");
                },
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return {
                label: "Settings",
                action: "./integrations/todoist",
                undisableable: true
            };
        }
    },
    TRELLO: {
        label: function() {
            return "Trello";
        },
        description: function() {
            return "We're working on integrating Trello with Reclaim.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(trello_icon, {});
        },
        entitlement: "INTEGRATION_TRELLO",
        isFuture: true,
        interestTrait: Users/* InterestTrait.Trello */.u1.Trello
    },
    LINEAR: {
        label: function() {
            return "Linear";
        },
        description: function() {
            return "Sync your Linear issues to Reclaim and get them scheduled as tasks.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(linear_icon, {});
        },
        entitlement: "INTEGRATION_LINEAR",
        unconnectedActions: function() {
            return {
                label: "Connect Linear",
                action: function() {
                    return (0,oauth/* initiateOauth */.N)("linear");
                },
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return {
                label: "Settings",
                action: "./integrations/linear",
                undisableable: true
            };
        }
    },
    JIRA: {
        label: function() {
            return "Jira";
        },
        description: function() {
            return "Sync your Jira issues to Reclaim and get them scheduled as tasks.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jira_software_icon, {});
        },
        entitlement: "INTEGRATION_JIRA",
        unconnectedActions: function() {
            return {
                label: "Connect Jira",
                action: JIRA_MARKETPLACE_URL,
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return {
                label: "Settings",
                action: "./integrations/jira",
                undisableable: true
            };
        }
    },
    ASANA: {
        label: function() {
            return "Asana";
        },
        description: function() {
            return "Sync your Asana work to Reclaim and get them scheduled as tasks.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(asana_logo, {});
        },
        entitlement: "INTEGRATION_ASANA",
        unconnectedActions: function() {
            return {
                label: "Connect Asana",
                action: function() {
                    return (0,oauth/* initiateOauth */.N)("asana", "asana/install");
                },
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return {
                label: "Settings",
                action: "./integrations/asana",
                undisableable: true
            };
        },
        helpText: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    children: [
                        "For a complete walk-through of the Asana integration, check out our",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            color: "primary",
                            underline: "none",
                            href: "https://help.reclaim.ai/en/articles/6064146-asana-integration-overview",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Overview"
                        }),
                        ".",
                        " ",
                        "If you're unable to connect Asana, talk to your admin. You may need more permissions enabled in Asana."
                    ]
                })
            });
        }
    },
    CLICKUP: {
        label: function() {
            return "ClickUp";
        },
        description: function() {
            return "Sync your ClickUp items to Reclaim and get them scheduled as tasks.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(clickup_icon, {});
        },
        entitlement: "INTEGRATION_CLICKUP",
        unconnectedActions: function() {
            return {
                label: "Connect ClickUp",
                action: function() {
                    return (0,oauth/* initiateOauth */.N)("clickup");
                },
                changesConnectedStatus: true
            };
        },
        connectedActions: function() {
            return {
                label: "Settings",
                action: "./integrations/clickup",
                undisableable: true
            };
        }
    },
    MONDAY: {
        label: function() {
            return "Monday.com";
        },
        description: function() {
            return "We're working on integrating Monday.com with Reclaim.";
        },
        icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_com_logo, {});
        },
        entitlement: "INTEGRATION_MONDAY",
        isFuture: true,
        interestTrait: Users/* InterestTrait.Monday */.u1.Monday
    }
};
var integrationMetaComparator = function(a, b) {
    if (INTEGRATIONS_META[a].isBeta) return -1;
    if (INTEGRATIONS_META[b].isBeta) return 1;
    if (INTEGRATIONS_META[a].isFuture) return 1;
    if (INTEGRATIONS_META[b].isFuture) return -1;
    return 0;
};
var LEGACY_INTEGRATION_EDITIONS = [
    "ASSISTANT",
    "PRO",
    "TEAM"
];
var INTEGRATION_EDITIONS = [
    "LITE",
    "STARTER",
    "BUSINESS",
    "ENTERPRISE"
];
var DEFAULT_TODOIST_RULE = {
    labels: [],
    projectIds: [
        "ROOT"
    ],
    action: "SYNC_TO",
    serviceType: "TODOIST",
    ruleType: "CASE",
    timeSchemeId: null
};
var DEFAULT_CLICKUP_RULE = {
    labels: [],
    projectIds: [],
    action: "SYNC_TO",
    serviceType: "CLICK_UP",
    ruleType: "CASE",
    timeSchemeId: null
};
var INTEGRATION_LABELS_META = {
    TODOIST: {
        integrationName: "Todoist",
        labelOrTag: "label",
        projectOrSpace: "project"
    },
    CLICK_UP: {
        integrationName: "ClickUp",
        labelOrTag: "tag",
        projectOrSpace: "space"
    }
};


/***/ }),

/***/ 89502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Db": function() { return /* binding */ integrationRuleCreateRequestToDto; },
/* harmony export */   "JQ": function() { return /* binding */ integrationRuleUpdateRequestToDto; },
/* harmony export */   "Pf": function() { return /* binding */ integrationRuleReindexRequestToDto; },
/* harmony export */   "W2": function() { return /* binding */ dtoToIntegrationsEnabledMap; },
/* harmony export */   "eb": function() { return /* binding */ dtoToClickUpIntegrationDetails; },
/* harmony export */   "f7": function() { return /* binding */ dtoToTodoistIntegrationDetails; },
/* harmony export */   "gS": function() { return /* binding */ integrationRuleToIntegrationRuleUpdateRequest; },
/* harmony export */   "jZ": function() { return /* binding */ dtoToIntegrationRule; }
/* harmony export */ });
/* unused harmony exports dtoToIntegrationRuleAction, integrationRuleActionToDto, dtoToIntegrationRuleServiceType, integrationRuleServiceTypeToDto, dtoToIntegrationRuleType, integrationRuleTypeToDto, integrationRuleToDto, dtoToTodoistProject, dtoToClickUpWorkspace, dtoToClickUpSpaceWithEligibility */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);


// incoming object doesn't include future
// integrations.  To be sure everything gets
// a boolean we're filling everything with a
// false.
var DEFAULT_ENABLED_MAP = {
    ADD_ON: false,
    ASANA: false,
    CLICKUP: false,
    GOOGLE_TASKS: false,
    JIRA: false,
    LINEAR: false,
    RAYCAST: false,
    MONDAY: false,
    OFFICE365: false,
    SLACK: false,
    TODOIST: false,
    TRELLO: false,
    ZOOM: false
};
var dtoToIntegrationsEnabledMap = function(dto) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, DEFAULT_ENABLED_MAP, dto);
};
// Todoist / Clickup Rules
var dtoToIntegrationRuleAction = function(dto) {
    return dto;
};
var integrationRuleActionToDto = function(action) {
    return action;
};
var dtoToIntegrationRuleServiceType = function(dto) {
    return dto;
};
var integrationRuleServiceTypeToDto = function(serviceType) {
    return serviceType;
};
var dtoToIntegrationRuleType = function(dto) {
    return dto;
};
var integrationRuleTypeToDto = function(ruleType) {
    return ruleType;
};
var dtoToIntegrationRule = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, dto), {
        labels: !!dto.labels ? dto.labels : undefined,
        projectIds: !!dto.projectIds ? dto.projectIds : undefined,
        action: dtoToIntegrationRuleAction(dto.action),
        serviceType: dtoToIntegrationRuleServiceType(dto.serviceType),
        ruleType: dtoToIntegrationRuleType(dto.ruleType),
        timeSchemeId: !!dto.timeSchemeId ? dto.timeSchemeId : undefined
    });
};
var integrationRuleToDto = function(rule) {
    var ref, ref1;
    return _object_spread_props(_object_spread({}, rule), {
        labels: !!((ref = rule.labels) === null || ref === void 0 ? void 0 : ref.length) ? rule.labels : null,
        projectIds: !!((ref1 = rule.projectIds) === null || ref1 === void 0 ? void 0 : ref1.length) ? rule.projectIds : null,
        action: integrationRuleActionToDto(rule.action),
        serviceType: integrationRuleServiceTypeToDto(rule.serviceType),
        ruleType: integrationRuleTypeToDto(rule.ruleType)
    });
};
var integrationRuleCreateRequestToDto = function(request) {
    var ref, ref1;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, request), {
        labels: !!((ref = request.labels) === null || ref === void 0 ? void 0 : ref.length) ? request.labels : [],
        projectIds: !!((ref1 = request.projectIds) === null || ref1 === void 0 ? void 0 : ref1.length) ? request.projectIds : [],
        action: integrationRuleActionToDto(request.action),
        serviceType: integrationRuleServiceTypeToDto(request.serviceType),
        ruleType: integrationRuleTypeToDto(request.ruleType)
    });
};
var integrationRuleToIntegrationRuleUpdateRequest = function(rule) {
    return {
        labels: rule.labels,
        projectIds: rule.projectIds,
        action: rule.action,
        timeSchemeId: rule.timeSchemeId
    };
};
var integrationRuleUpdateRequestToDto = function(request) {
    var ref, ref1;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, request), {
        labels: ((ref = request.labels) === null || ref === void 0 ? void 0 : ref.length) !== 0 ? request.labels : [],
        // If the projectIds contain All only send ROOT instead of all project Ids
        projectIds: ((ref1 = request.projectIds) === null || ref1 === void 0 ? void 0 : ref1.includes("ROOT")) ? [
            "ROOT"
        ] : request.projectIds,
        action: request.action
    });
};
var integrationRuleReindexRequestToDto = function(request) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, request), {
        serviceType: integrationRuleServiceTypeToDto(request.serviceType)
    });
};
// Todoist
var dtoToTodoistProject = function(dto) {
    return {
        id: dto.id,
        name: dto.name,
        // give all Todoist Projects a fake isEligible true to make consistent with ClickUp
        isEligible: true
    };
};
var dtoToTodoistIntegrationDetails = function(dto) {
    var ref, ref1, ref2, ref3;
    return {
        id: dto.id,
        availableProjects: !!((ref = dto.availableProjects) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = dto.availableProjects) === null || ref1 === void 0 ? void 0 : ref1.map(dtoToTodoistProject) : [],
        labelNames: !!((ref2 = dto.labelNames) === null || ref2 === void 0 ? void 0 : ref2.length) ? (ref3 = dto.labelNames) === null || ref3 === void 0 ? void 0 : ref3.map(function(label) {
            return label;
        }) : [],
        lastSyncedAt: dto.lastSyncedAt
    };
};
// Clickup
var dtoToClickUpWorkspace = function(dto) {
    return dto;
};
var dtoToClickUpSpaceWithEligibility = function(dto) {
    return dto;
};
var dtoToClickUpIntegrationDetails = function(dto) {
    var ref, ref1, ref2;
    return {
        workspace: dto.workspace ? dtoToClickUpWorkspace(dto.workspace) : {
            id: "",
            name: ""
        },
        availableSpaces: !!((ref = dto.availableSpaces) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = dto.availableSpaces) === null || ref1 === void 0 ? void 0 : ref1.map(dtoToClickUpSpaceWithEligibility) : [],
        tags: !!((ref2 = dto.tags) === null || ref2 === void 0 ? void 0 : ref2.length) ? dto.tags.map(function(tag) {
            return tag;
        }) : [],
        lastSynced: dto.lastSynced
    };
};


/***/ }),

/***/ 90483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lm": function() { return /* binding */ queryDataToOneOnOne; },
/* harmony export */   "R7": function() { return /* binding */ OneOnOneToDto; },
/* harmony export */   "rM": function() { return /* binding */ dtoToZoomUser; },
/* harmony export */   "z2": function() { return /* binding */ dtoToOneOnOne; }
/* harmony export */ });
/* unused harmony exports attendeeTimePolicyToDto, dtoToAttendeeTimePolicy, dtoToRecurringAssignmentInstance */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26958);
/* harmony import */ var _TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64825);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42230);
/* harmony import */ var _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70282);
/* harmony import */ var _Users_mutators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45983);







var dtoToZoomUser = function(dto) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dto);
};
var attendeeTimePolicyToDto = function(tp) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, tp), {
        timePolicy: (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .timePolicyToDto */ .aE)(tp.timePolicy),
        timePolicyInViewerTimezone: (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .timePolicyToDto */ .aE)(tp.timePolicyInViewerTimezone)
    });
};
var dtoToAttendeeTimePolicy = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dto), {
        timePolicy: (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .dtoToTimePolicy */ .G3)(dto.timePolicy),
        timePolicyInViewerTimezone: (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .dtoToTimePolicy */ .G3)(dto.timePolicyInViewerTimezone),
        // swagger incorrectly types this object
        timezone: dto.timezone
    });
};
function dtoToRecurringAssignmentInstance(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dto), {
        eventKey: dto.eventKey,
        eventStatus: dto.eventStatus,
        start: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .strToDate */ .z8)(dto.start),
        end: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .strToDate */ .z8)(dto.end)
    });
}
function dtoToOneOnOne(dto) {
    var ref;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dto), {
        id: !!dto.id ? dto.id : undefined,
        idealDay: dto.idealDay,
        snoozeUntil: (0,_types__WEBPACK_IMPORTED_MODULE_1__/* .nullable */ .AG)(dto.snoozeUntil, _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .strToDate */ .z8),
        status: dto.status,
        instances: (ref = dto.instances) === null || ref === void 0 ? void 0 : ref.map(dtoToRecurringAssignmentInstance),
        updated: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .strToDate */ .z8)(dto.updated),
        recurrence: _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__/* .Recurrence.get */ .Vy.get(dto.recurrence) || _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__/* .Recurrence.Weekly */ .Vy.Weekly,
        conferenceType: dto.conferenceType || _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__/* .ConferenceType.None */ .YI.None,
        organizersTimeZone: dto.organizersTimeZone,
        inviteeTimePolicy: dtoToAttendeeTimePolicy(dto.inviteeTimePolicy),
        organizerTimePolicy: dtoToAttendeeTimePolicy(dto.organizerTimePolicy),
        effectiveTimePolicy: (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .dtoToTimePolicy */ .G3)(dto.effectiveTimePolicy),
        organizer: dto.organizer || undefined,
        organizerTimeSchemeId: dto.organizerTimeSchemeId || undefined,
        organizerTimePolicyType: dto.organizerTimePolicyType || undefined,
        organizerOneOffPolicy: dto.organizerOneOffPolicy && (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .dtoToTimePolicy */ .G3)(dto.organizerOneOffPolicy),
        inviteeTimePolicyType: dto.inviteeTimePolicyType || undefined,
        inviteeOneOffPolicy: dto.inviteeOneOffPolicy && (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .dtoToTimePolicy */ .G3)(dto.inviteeOneOffPolicy),
        priority: (0,_Users_mutators__WEBPACK_IMPORTED_MODULE_3__/* .dtoToPriorityLevel */ .Bn)(dto.priority)
    });
}
function OneOnOneToDto(oneOnOne) {
    var ref;
    var dto = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, oneOnOne), {
        idealDay: oneOnOne.idealDay,
        snoozeUntil: (0,_types__WEBPACK_IMPORTED_MODULE_1__/* .nullable */ .AG)(oneOnOne.snoozeUntil, _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .dateToStr */ .dx),
        recurrence: (ref = oneOnOne.recurrence) === null || ref === void 0 ? void 0 : ref.toJSON(),
        invitee: oneOnOne.invitee,
        status: oneOnOne.status,
        instances: oneOnOne.instances,
        updated: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .dateToStr */ .dx)(oneOnOne.updated),
        conferenceType: oneOnOne.conferenceType === _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__/* .ConferenceType.None */ .YI.None ? null : oneOnOne.conferenceType,
        organizersTimeZone: oneOnOne.organizersTimeZone,
        organizerTimePolicy: oneOnOne.organizerTimePolicy && attendeeTimePolicyToDto(oneOnOne.organizerTimePolicy),
        inviteeTimePolicy: oneOnOne.inviteeTimePolicy && attendeeTimePolicyToDto(oneOnOne.inviteeTimePolicy),
        effectiveTimePolicy: oneOnOne.effectiveTimePolicy && (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .timePolicyToDto */ .aE)(oneOnOne.effectiveTimePolicy),
        organizerTimePolicyType: oneOnOne.organizerTimePolicyType,
        organizerOneOffPolicy: oneOnOne.organizerOneOffPolicy && (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .timePolicyToDto */ .aE)(oneOnOne.organizerOneOffPolicy),
        inviteeTimePolicyType: oneOnOne.inviteeTimePolicyType,
        inviteeOneOffPolicy: oneOnOne.inviteeOneOffPolicy && (0,_TimeSchemes_mutators__WEBPACK_IMPORTED_MODULE_6__/* .timePolicyToDto */ .aE)(oneOnOne.inviteeOneOffPolicy),
        title: oneOnOne.title === "" ? null : oneOnOne.title,
        priority: oneOnOne.priority ? (0,_Users_mutators__WEBPACK_IMPORTED_MODULE_3__/* .priorityLevelToDto */ .Uv)(oneOnOne.priority) : undefined
    });
    // TODO: (SS) This can be removed when we only send changed values in the patch.
    if (dto.conferenceType === _OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__/* .ConferenceType.Custom */ .YI.Custom) {
        delete dto.conferenceType;
    }
    return dto;
}
/**
 * Safely deserialize 1:1 dto object from router query object.
 */ var queryDataToOneOnOne = function(data) {
    var oneOnOne = {};
    try {
        var dto = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, data);
        // RAI-10067: If day hours is an empty object it will be removed from the query.
        if (dto.effectiveTimePolicy && !dto.effectiveTimePolicy.dayHours) {
            dto.effectiveTimePolicy.dayHours = {};
        }
        oneOnOne = dtoToOneOnOne(dto);
    } catch (err) {
    // Do nothing and just return the empty partial if serialization fails.
    }
    return oneOnOne;
};


/***/ }),

/***/ 70282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N_": function() { return /* binding */ RecurringAssignmentAttendeeStatus; },
/* harmony export */   "TN": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.TN; },
/* harmony export */   "Vy": function() { return /* binding */ Recurrence; },
/* harmony export */   "YI": function() { return /* binding */ ConferenceType; },
/* harmony export */   "uH": function() { return /* binding */ RecurringOneOnOneStatus; }
/* harmony export */ });
/* unused harmony export RedirectActions */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98585);
/* harmony import */ var _types_enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41390);







var RecurringOneOnOneStatus;
(function(RecurringOneOnOneStatus) {
    RecurringOneOnOneStatus["New"] = "NEW";
    RecurringOneOnOneStatus["Accepted"] = "ACCEPTED";
    RecurringOneOnOneStatus["Declined"] = "DECLINED";
    RecurringOneOnOneStatus["Scheduled"] = "SCHEDULED";
    RecurringOneOnOneStatus["InviteeError"] = "INVITEE_ERROR";
})(RecurringOneOnOneStatus || (RecurringOneOnOneStatus = {}));
var RecurringAssignmentAttendeeStatus;
(function(RecurringAssignmentAttendeeStatus) {
    RecurringAssignmentAttendeeStatus["Inviting"] = "INVITING";
    RecurringAssignmentAttendeeStatus["Pending"] = "PENDING";
    RecurringAssignmentAttendeeStatus["Accepted"] = "ACCEPTED";
    RecurringAssignmentAttendeeStatus["Declined"] = "DECLINED";
    RecurringAssignmentAttendeeStatus["AssumedAccepted"] = "ASSUMED_ACCEPTED";
})(RecurringAssignmentAttendeeStatus || (RecurringAssignmentAttendeeStatus = {}));
var ConferenceType;
(function(ConferenceType) {
    ConferenceType["None"] = "NONE";
    ConferenceType["GoogleMeet"] = "GOOGLE_MEET";
    ConferenceType["Zoom"] = "ZOOM";
    ConferenceType["Custom"] = "CUSTOM";
})(ConferenceType || (ConferenceType = {}));
var RedirectActions;
(function(RedirectActions) {
    RedirectActions["ResumeEdit"] = "ResumeEdit";
})(RedirectActions || (RedirectActions = {}));
var Recurrence = /*#__PURE__*/ function(ObjectEnum) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Recurrence, ObjectEnum);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Recurrence);
    function Recurrence(key, label) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, Recurrence);
        var _this;
        _this = _super.call(this, key);
        _this.key = key;
        _this.label = label;
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Recurrence, [
        {
            key: "dto",
            get: function get() {
                return _client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence */ .Vy[this.key];
            }
        }
    ], [
        {
            key: "Options",
            get: function get() {
                return Object.values(Recurrence);
            }
        }
    ]);
    return Recurrence;
}(_types_enums__WEBPACK_IMPORTED_MODULE_5__/* .ObjectEnum */ .W);
Recurrence.Daily = new Recurrence(_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Daily */ .Vy.Daily, "Daily");
Recurrence.Weekly = new Recurrence(_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Weekly */ .Vy.Weekly, "Weekly");
Recurrence.Biweekly = new Recurrence(_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Biweekly */ .Vy.Biweekly, "Every other week");
Recurrence.Monthly = new Recurrence(_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Monthly */ .Vy.Monthly, "Monthly");
Recurrence.Quarterly = new Recurrence(_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Quarterly */ .Vy.Quarterly, "Quarterly");


/***/ }),

/***/ 2399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kl": function() { return /* binding */ PlannerDomain; },
/* harmony export */   "N2": function() { return /* binding */ isTask; },
/* harmony export */   "Y_": function() { return /* binding */ RsvpResponsePeriod; },
/* harmony export */   "o0": function() { return /* binding */ isHabit; }
/* harmony export */ });
/* unused harmony exports getTaskOrHabitAssignmentType, isOneOnOne, fromDto */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71418);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26958);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98585);
/* harmony import */ var _Events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91500);
/* harmony import */ var _Habits_mutators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77802);
/* harmony import */ var _OneOnOnes_mutators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90483);
/* harmony import */ var _Tasks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76388);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42230);












/**
 * Gets the type of a TaskOrHabit
 * @param taskOrHabit the task or habit object
 * @returns a type if task, habit, or one-on-one, undefined otherwise
 */ var getTaskOrHabitAssignmentType = function(taskOrHabit) {
    switch(taskOrHabit.type){
        case _client__WEBPACK_IMPORTED_MODULE_1__/* .AssistType.TASK */ .ME.TASK:
            return "task";
        default:
            // I THINK we can determine all of this
            // from this one property but I don't want
            // to change the logic of these low-level
            // functions right now -SG
            switch(taskOrHabit.recurringAssignmentType){
                case _client__WEBPACK_IMPORTED_MODULE_1__/* .RecurringAssignmentType.ONEONONE */ .Kw.ONEONONE:
                    return "one-on-one";
                default:
                    return "habit";
            }
    }
};
var isTask = function(taskOrHabit) {
    return !!taskOrHabit && getTaskOrHabitAssignmentType(taskOrHabit) === "task";
};
var isHabit = function(taskOrHabit) {
    return !!taskOrHabit && getTaskOrHabitAssignmentType(taskOrHabit) === "habit";
};
var isOneOnOne = function(taskOrHabit) {
    return !!taskOrHabit && getTaskOrHabitAssignmentType(taskOrHabit) === "one-on-one";
};
var RsvpResponsePeriod;
(function(RsvpResponsePeriod) {
    RsvpResponsePeriod["Single"] = "SINGLE";
    RsvpResponsePeriod["Forward"] = "FORWARD";
    RsvpResponsePeriod["All"] = "ALL";
})(RsvpResponsePeriod || (RsvpResponsePeriod = {}));
var fromDto = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, dto), {
        events: dto.events.map(function(event) {
            return (0,_Events__WEBPACK_IMPORTED_MODULE_2__/* .dtoToEvent */ .k_)(event);
        }),
        task: isTask(dto.taskOrHabit) ? (0,_Tasks__WEBPACK_IMPORTED_MODULE_5__/* .dtoToTask */ .uH)(dto.taskOrHabit) : undefined,
        habit: isHabit(dto.taskOrHabit) ? (0,_Habits_mutators__WEBPACK_IMPORTED_MODULE_3__/* .dtoToHabit */ .TK)(dto.taskOrHabit) : undefined,
        oneOnOne: isOneOnOne(dto.taskOrHabit) ? (0,_OneOnOnes_mutators__WEBPACK_IMPORTED_MODULE_4__/* .dtoToOneOnOne */ .z2)(dto.taskOrHabit) : undefined
    });
};
var PlannerDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(PlannerDomain, TransformDomain);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(PlannerDomain);
    function PlannerDomain() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, PlannerDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "Planner";
        _this.cacheKey = "planner";
        _this.deserialize = fromDto;
        _this.handleResult = function(notificationKey) {
            return function(res) {
                if (!!notificationKey) _this.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Requested */ .$K.Requested);
                var result = _this.deserialize(res);
                if (!!(result === null || result === void 0 ? void 0 : result.task)) _this.client.tasks.upsert(result.task);
                if (!!(result === null || result === void 0 ? void 0 : result.habit)) _this.client.habits.upsert(result.habit);
                if (!!(result === null || result === void 0 ? void 0 : result.oneOnOne)) _this.client.oneOnOnes.upsert(result.oneOnOne);
                if (!!(result === null || result === void 0 ? void 0 : result.events)) _this.client.events.upsert(result.events);
                return res;
            };
        };
        _this.handleError = function(reason, message, notificationKey) {
            console.warn("Request failed", message);
            if (!!notificationKey) {
                _this.clearExpectedChange(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Failed */ .$K.Failed);
            }
            throw new Error(message);
        };
        _this.setupNotification = function(id) {
            var notificationKey = _this.generateUid("planner", id);
            _this.expectChange(notificationKey, id, {}, true);
            return notificationKey;
        };
        /**
   * Event Actions
   */ _this.moveEvent = _this.manageErrors(_this.deserializeResponse(function(eventId, start, end) {
            var notificationKey = _this.setupNotification(eventId);
            return _this.api.planner.moveEvent(eventId, {
                start: start,
                end: end,
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not move event", notificationKey);
            });
        }));
        _this.pinEvent = _this.manageErrors(_this.deserializeResponse(function(eventId) {
            var notificationKey = _this.setupNotification(eventId);
            return _this.api.planner.pinEvent(eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult()).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not pin event", notificationKey);
            });
        }));
        _this.unpinEvent = _this.manageErrors(_this.deserializeResponse(function(eventId) {
            var notificationKey = _this.setupNotification(eventId);
            return _this.api.planner.unpinEvent(eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult()).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not unpin event", notificationKey);
            });
        }));
        _this.rsvp = _this.manageErrors(_this.deserializeResponse(function(eventId, calendarId, rsvp) {
            var notificationKey = _this.setupNotification(eventId);
            var rsvpDto = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rsvp), {
                period: rsvp.period
            });
            return _this.api.planner.rsvp(calendarId, eventId, rsvpDto, {
                notificationKey: notificationKey
            }).then(_this.handleResult()).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not rsvp to event", notificationKey);
            });
        }));
        _this.changeCategory = _this.manageErrors(_this.deserializeResponse(function(eventId, calendarId, category) {
            var notificationKey = _this.setupNotification(eventId);
            return _this.api.planner.changeCategory(calendarId, eventId, {
                categoryIn: category.key,
                notificationKey: notificationKey
            }).then(_this.handleResult()).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not update the category for event", notificationKey);
            });
        }));
        /**
   * Task Actions
   */ // Adds time to the task policy
        _this.addTime = _this.manageErrors(_this.deserializeResponse(function(id, minutes) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.addTime(id, {
                minutes: minutes,
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not extend task", notificationKey);
            });
        }));
        _this.logWork = _this.manageErrors(_this.deserializeResponse(function(id, query) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.logWork(id, {
                minutes: query === null || query === void 0 ? void 0 : query.minutes,
                end: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .dateToStr */ .dx)(query === null || query === void 0 ? void 0 : query.end),
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not log work for task", notificationKey);
            });
        }));
        _this.restartTask = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.restartTask(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not restart task", notificationKey);
            });
        }));
        _this.startTask = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.startTask(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not start task now", notificationKey);
            });
        }));
        _this.stopTask = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.stopTask(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not stop task", notificationKey);
            });
        }));
        _this.doneTask = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.doneTask(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not mark task as done", notificationKey);
            });
        }));
        _this.unarchiveTask = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.unarchiveTask(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not unarchive task", notificationKey);
            });
        }));
        _this.rescheduleTaskInstance = _this.manageErrors(_this.deserializeResponse(function(id, eventId) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.rescheduleTaskEvent(eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not reschedule task instance", notificationKey);
            });
        }));
        _this.deleteTask = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.deleteTaskPolicy(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not delete task", notificationKey);
            });
        }));
        _this.rescheduleTaskEvent = _this.manageErrors(_this.deserializeResponse(function(taskId, calendarId, eventId, snoozeOption, isEventNotificationResource) {
            var notificationKey = _this.setupNotification(!!isEventNotificationResource ? eventId : taskId);
            return _this.api.planner.taskDeleteInstanceAndReschedule(calendarId, eventId, {
                notificationKey: notificationKey,
                snoozeOption: snoozeOption
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not reschedule habit instance", notificationKey);
            });
        }));
        _this.rescheduleMultipleTaskEvents = _this.manageErrors(_this.deserializeResponse(function(taskId, eventKeys) {
            // TODO: our only use-case right now applies to a single task, this endpoint doesn't necessarily have the same restriction
            var notificationKey = _this.setupNotification(taskId);
            return _this.api.planner.taskDeleteMultipleInstanceAndReschedule({
                eventKeys: eventKeys
            }, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not reschedule habit instance(s)", notificationKey);
            });
        }));
        _this.prioritizeTask = _this.manageErrors(_this.deserializeResponse(function(id) {
            return _this.api.planner.prioritizeTask(id).then(_this.handleResult()).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not delete task");
            });
        }));
        _this.clearTaskSnooze = _this.manageErrors(_this.deserializeResponse(function(taskId) {
            var notificationKey = _this.setupNotification(taskId);
            return _this.api.planner.taskClearSnooze(taskId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not clear snooze for task", notificationKey);
            });
        }));
        _this.clearTaskTPE = _this.manageErrors(_this.deserializeResponse(function(taskId) {
            var notificationKey = _this.setupNotification(taskId);
            return _this.api.planner.clearTaskTimePolicyExceptions(taskId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not clear TPE for task", notificationKey);
            });
        }));
        /**
   * One on One Actions
   */ _this.oneOnOneReschedule = _this.manageErrors(_this.deserializeResponse(function(oneOnOneId, eventId, isEventNotificationResource) {
            var notificationKey = _this.setupNotification(!!isEventNotificationResource ? eventId : oneOnOneId);
            return _this.api.planner.oneOnOneReschedule(oneOnOneId, eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not delete task", notificationKey);
            });
        }));
        _this.oneOnOneSkipDay = _this.manageErrors(_this.deserializeResponse(function(oneOnOneId, eventId, isEventNotificationResource) {
            var notificationKey = _this.setupNotification(!!isEventNotificationResource ? eventId : oneOnOneId);
            return _this.api.planner.oneOnOneSkipDay(oneOnOneId, eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not delete task", notificationKey);
            });
        }));
        _this.oneOnOneSkipUntil = _this.manageErrors(_this.deserializeResponse(function(oneOnOneId, eventId, isEventNotificationResource) {
            var notificationKey = _this.setupNotification(!!isEventNotificationResource ? eventId : oneOnOneId);
            return _this.api.planner.oneOnOneSkipUntil(oneOnOneId, eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not delete task", notificationKey);
            });
        }));
        _this.oneOnOneSkipWeek = _this.manageErrors(_this.deserializeResponse(function(oneOnOneId, eventId, isEventNotificationResource) {
            var notificationKey = _this.setupNotification(!!isEventNotificationResource ? eventId : oneOnOneId);
            return _this.api.planner.oneOnOneSkipWeek(oneOnOneId, eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not delete task", notificationKey);
            });
        }));
        _this.clearOneOnOneTPE = _this.manageErrors(_this.deserializeResponse(function(oneOnOneId) {
            var notificationKey = _this.setupNotification(oneOnOneId);
            return _this.api.planner.clearOneOnOneTimePolicyExceptions(oneOnOneId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not clear TPE for 1:1", notificationKey);
            });
        }));
        /**
   * Habit Actions
   */ _this.restartHabit = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.restartHabit(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not restart habit", notificationKey);
            });
        }));
        _this.startHabit = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.startHabit(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not start habit now", notificationKey);
            });
        }));
        _this.stopHabit = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.stopHabit(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not stop habit", notificationKey);
            });
        }));
        _this.doneHabit = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.doneHabit(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not mark habit as done", notificationKey);
            });
        }));
        _this.deleteHabit = _this.manageErrors(_this.deserializeResponse(function(id) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.deleteHabitPolicy(id, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not delete habit", notificationKey);
            });
        }));
        _this.toggleHabit = _this.manageErrors(_this.deserializeResponse(function(id, enable) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.toggleHabit(id, {
                enable: enable,
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not delete habit", notificationKey);
            });
        }));
        _this.rescheduleHabitInstance = _this.manageErrors(_this.deserializeResponse(function(id, eventId) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.rescheduleHabitEvent(eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not reschedule habit instance", notificationKey);
            });
        }));
        _this.rescheduleHabitEvent = _this.manageErrors(_this.deserializeResponse(function(habitId, calendarId, eventId, snoozeOption, isEventNotificationResource) {
            var notificationKey = _this.setupNotification(!!isEventNotificationResource ? eventId : habitId);
            return _this.api.planner.habitDeleteInstanceAndReschedule(calendarId, eventId, {
                notificationKey: notificationKey,
                snoozeOption: snoozeOption
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not reschedule habit instance", notificationKey);
            });
        }));
        _this.skipHabitInstance = _this.manageErrors(_this.deserializeResponse(function(id, eventId) {
            var notificationKey = _this.setupNotification(id);
            return _this.api.planner.skipHabitEvent(eventId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not skip habit instance", notificationKey);
            });
        }));
        _this.clearHabitTPE = _this.manageErrors(_this.deserializeResponse(function(taskId) {
            var notificationKey = _this.setupNotification(taskId);
            return _this.api.planner.clearHabitTimePolicyExceptions(taskId, {
                notificationKey: notificationKey
            }).then(_this.handleResult(notificationKey)).catch(function(reason) {
                return _this.handleError(reason, "Request failed: Could not clear TPE for habit", notificationKey);
            });
        }));
        _this.migrateToPrioritySystem = _this.typedManageErrors(function() {
            return _this.api.planner.migrateToPrioritySystem();
        });
        return _this;
    }
    return PlannerDomain;
}(_types__WEBPACK_IMPORTED_MODULE_6__/* .TransformDomain */ .Zs);


/***/ }),

/***/ 76388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ upsertTaskReindex; },
/* harmony export */   "H": function() { return /* binding */ DELAYED_TASK_START_OPTIONS; },
/* harmony export */   "MQ": function() { return /* binding */ makeDefaultTask; },
/* harmony export */   "O1": function() { return /* binding */ TaskInstanceStatus; },
/* harmony export */   "R1": function() { return /* binding */ getNextUpcomingTaskInstance; },
/* harmony export */   "Y4": function() { return /* binding */ TasksDomain; },
/* harmony export */   "cP": function() { return /* binding */ DUE_IN_DAYS_OPTIONS; },
/* harmony export */   "eD": function() { return /* binding */ ReindexDirection; },
/* harmony export */   "h8": function() { return /* binding */ taskToDto; },
/* harmony export */   "hY": function() { return /* binding */ TaskStatus; },
/* harmony export */   "ok": function() { return /* binding */ getUserDefaultDueDate; },
/* harmony export */   "uH": function() { return /* binding */ dtoToTask; }
/* harmony export */ });
/* unused harmony exports isTask, byTitle, byDue, byIndex, byFinished, byScheduled, byTimeChunksRequired, byStatus, byTimeChunksRemaining, getTaskColor, getUserDefaultSnoozeUntil, defaultTask */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71418);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97582);
/* harmony import */ var _hooks_useV16User__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3512);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(58545);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(29422);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(77349);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(4543);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(37042);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(63496);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54517);
/* harmony import */ var _types_enums__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41390);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26958);
/* harmony import */ var _utils_events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43835);
/* harmony import */ var _utils_time_policy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52515);
/* harmony import */ var _utils_wonka__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60811);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98585);
/* harmony import */ var _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90109);
/* harmony import */ var _Planner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2399);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42230);






















var isTask = function(item) {
    return isTaskPlanner(item);
};
var TaskStatus = /*#__PURE__*/ function(ObjectEnum) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(TaskStatus, ObjectEnum);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(TaskStatus);
    function TaskStatus(status, done, label) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(this, TaskStatus);
        var _this;
        _this = _super.call(this, status);
        _this.status = status;
        _this.done = done;
        _this.label = label;
        return _this;
    }
    return TaskStatus;
}(_types_enums__WEBPACK_IMPORTED_MODULE_13__/* .ObjectEnum */ .W);
/**
   * Task is new, not yet scheduled
   */ TaskStatus.New = new TaskStatus(_client__WEBPACK_IMPORTED_MODULE_6__/* .TaskStatus.NEW */ .hY.NEW, false, "Active");
/**
   * Task instances have been scheduled
   */ TaskStatus.Scheduled = new TaskStatus(_client__WEBPACK_IMPORTED_MODULE_6__/* .TaskStatus.SCHEDULED */ .hY.SCHEDULED, false, "Scheduled");
/**
   * Task has an instance which is currently in-progress
   */ TaskStatus.InProgress = new TaskStatus(_client__WEBPACK_IMPORTED_MODULE_6__/* .TaskStatus.INPROGRESS */ .hY.INPROGRESS, false, "In-progress");
/**
   * All time chunks have been spent
   */ TaskStatus.Complete = new TaskStatus(_client__WEBPACK_IMPORTED_MODULE_6__/* .TaskStatus.COMPLETE */ .hY.COMPLETE, true, "Complete");
/**
   * Task deleted
   */ TaskStatus.Cancelled = new TaskStatus(_client__WEBPACK_IMPORTED_MODULE_6__/* .TaskStatus.CANCELLED */ .hY.CANCELLED, true, "Cancelled");
/**
   * Task has been marked "done".  Time chunks have been set equal to required chunks
   */ TaskStatus.Archived = new TaskStatus(_client__WEBPACK_IMPORTED_MODULE_6__/* .TaskStatus.ARCHIVED */ .hY.ARCHIVED, true, "Archived");
TaskStatus.Active = [
    TaskStatus.New,
    TaskStatus.Scheduled,
    TaskStatus.InProgress,
    TaskStatus.Complete
];
TaskStatus.Inactive = [
    TaskStatus.Cancelled,
    TaskStatus.Archived
];
var ReindexDirection;
(function(ReindexDirection) {
    ReindexDirection["Before"] = "before";
    ReindexDirection["After"] = "after";
})(ReindexDirection || (ReindexDirection = {}));
var TaskInstanceStatus;
(function(TaskInstanceStatus) {
    TaskInstanceStatus["Done"] = "DONE";
    TaskInstanceStatus["Active"] = "ACTIVE";
    TaskInstanceStatus["Pending"] = "PENDING";
    TaskInstanceStatus["Aborted"] = "ABORTED";
})(TaskInstanceStatus || (TaskInstanceStatus = {}));
/* Sorting functions */ var byTitle = function(a, b) {
    if (a.title === b.title) return 0;
    return a.title < b.title ? -1 : 1;
};
var byDue = function(a, b) {
    var ref, ref1;
    if (a.status !== b.status && (a.status === TaskStatus.Complete || b.status === TaskStatus.Complete)) {
        if (a.status === TaskStatus.Complete) return 1;
        if (b.status === TaskStatus.Complete) return -1;
    }
    if (((ref = a.due) === null || ref === void 0 ? void 0 : ref.getTime()) === ((ref1 = b.due) === null || ref1 === void 0 ? void 0 : ref1.getTime())) return byTitle(a, b);
    if (!a.due) return 1;
    if (!b.due) return -1;
    return a.due.getTime() - b.due.getTime();
};
var byIndex = function(a, b) {
    if (a.index === b.index) return byDue(a, b);
    if (undefined === a.index) return b.index;
    if (undefined === b.index) return a.index;
    return a.index - b.index;
};
var byFinished = function(a, b) {
    var ref, ref1;
    if (((ref = a.finished) === null || ref === void 0 ? void 0 : ref.getTime()) === ((ref1 = b.finished) === null || ref1 === void 0 ? void 0 : ref1.getTime())) return byDue(a, b);
    if (!a.finished) return 1;
    if (!b.finished) return -1;
    return a.finished.getTime() - b.finished.getTime();
};
var byScheduled = function(a, b) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var nextChunkA = (a === null || a === void 0 ? void 0 : (ref = a.instances) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.start) === null || ref2 === void 0 ? void 0 : ref2.getTime()) || Infinity;
    var nextChunkB = (b === null || b === void 0 ? void 0 : (ref3 = b.instances) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.start) === null || ref5 === void 0 ? void 0 : ref5.getTime()) || Infinity;
    if (nextChunkA === nextChunkB) return byFinished(a, b);
    return nextChunkA - nextChunkB;
};
var byTimeChunksRequired = function(a, b) {
    if (a.timeChunksRequired === b.timeChunksRequired) return byDue(a, b);
    if (undefined === a.timeChunksRequired) return 1;
    if (undefined === b.timeChunksRequired) return -1;
    return a.timeChunksRequired - b.timeChunksRequired;
};
var byStatus = function(a, b) {
    if (a.status === b.status) return byScheduled(a, b);
    if (!a.status || TaskStatus.Archived === a.status) return 1;
    if (!b.status || TaskStatus.Archived === b.status) return -1;
    return a.status.key < b.status.key ? -1 : 1;
};
var byTimeChunksRemaining = function(a, b) {
    if (a.timeChunksRemaining === b.timeChunksRemaining) return byScheduled(a, b);
    if (undefined === a.timeChunksRemaining) return 1;
    if (undefined === b.timeChunksRemaining) return -1;
    return a.timeChunksRemaining - b.timeChunksRemaining;
};
function getTaskColor(user, task) {
    return !!task.eventColor && task.eventColor !== EventColor.Auto ? task.eventColor : EventColor.getColor(user, task.eventCategory);
}
function dtoToTask(dto) {
    var ref;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, dto), {
        id: dto.id,
        title: dto.title || "",
        status: !!dto.status ? TaskStatus.get(dto.status) : undefined,
        eventCategory: !!dto.eventCategory ? _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .PrimaryCategory.get */ .CU.get(dto.eventCategory) : _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .PrimaryCategory.TeamMeeting */ .CU.TeamMeeting,
        eventColor: !!dto.eventColor ? _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .EventColor.get */ .dr.get(dto.eventColor) : _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .EventColor.Auto */ .dr.Auto,
        due: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .strToDate */ .z8)(dto.due),
        snoozeUntil: (0,_types__WEBPACK_IMPORTED_MODULE_9__/* .nullable */ .AG)(dto.snoozeUntil, _utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .strToDate */ .z8),
        finished: (0,_types__WEBPACK_IMPORTED_MODULE_9__/* .nullable */ .AG)(dto.finished, _utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .strToDate */ .z8),
        created: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .strToDate */ .z8)(dto.created),
        updated: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .strToDate */ .z8)(dto.updated),
        instances: (ref = dto.instances) === null || ref === void 0 ? void 0 : ref.map(function(i) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, i), {
                start: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .strToDate */ .z8)(i.start),
                end: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .strToDate */ .z8)(i.end),
                status: i.status,
                // Swagger types claim eventKey is an object, it's a string...
                eventKey: i.eventKey,
                calendarId: (0,_utils_events__WEBPACK_IMPORTED_MODULE_3__/* .parseEventKey */ .L0)(i.eventKey).calendarId
            });
        }).filter(function(i) {
            return i.status !== TaskInstanceStatus.Aborted;
        }).sort(function(a, b) {
            return !a.start || !b.start ? +1 : a.start.getTime() - b.start.getTime();
        })
    });
}
function taskToDto(task) {
    var ref, ref1, ref2;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, task), {
        status: (ref = task.status) === null || ref === void 0 ? void 0 : ref.toJSON(),
        eventCategory: (ref1 = task.eventCategory) === null || ref1 === void 0 ? void 0 : ref1.toJSON(),
        eventColor: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .EventColor.Auto */ .dr.Auto === task.eventColor ? null : (ref2 = task.eventColor) === null || ref2 === void 0 ? void 0 : ref2.toJSON(),
        due: (0,_types__WEBPACK_IMPORTED_MODULE_9__/* .nullable */ .AG)(task.due, _utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .dateToStr */ .dx),
        snoozeUntil: (0,_types__WEBPACK_IMPORTED_MODULE_9__/* .nullable */ .AG)(task.snoozeUntil, _utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .dateToStr */ .dx),
        finished: (0,_types__WEBPACK_IMPORTED_MODULE_9__/* .nullable */ .AG)(task.finished, _utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .dateToStr */ .dx),
        created: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .dateToStr */ .dx)(task.created),
        updated: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .dateToStr */ .dx)(task.updated),
        // TODO (ma) backend does not deal with this fully yet.
        // data is not yet usable by UI and re-sending brakes the server
        // @ts-ignore
        googleTask: undefined,
        instances: undefined
    });
}
var TaskSubscription = {
    subscriptionType: _client__WEBPACK_IMPORTED_MODULE_6__/* .SubscriptionType.Task */ .Qe.Task
};
var TasksDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(TasksDomain, TransformDomain);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(TasksDomain);
    function TasksDomain() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(this, TasksDomain);
        var _this;
        var ref;
        _this = _super.apply(this, arguments);
        _this.resource = "Task";
        _this.cacheKey = "tasks";
        _this.pk = "id";
        _this.serialize = taskToDto;
        _this.deserialize = dtoToTask;
        _this.watchWs$ = (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)(((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$(TaskSubscription)) || (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .fromArray */ .nI)([]), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .filter */ .hX)(function(envelope) {
            return !!envelope.data;
        }), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(envelope) {
            return envelope.data;
        }), (0,_utils_wonka__WEBPACK_IMPORTED_MODULE_5__/* .deserialize */ .vB)(_this.deserialize));
        _this.watchAll$ = (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .merge */ .TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(items) {
            return _this.patchExpectedChanges(items);
        }));
        _this.watchAllWithOptimisticUpdates$ = (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .merge */ .TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(items) {
            return items;
        }));
        _this.list$$ = function(query) {
            return (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .fromPromise */ .p4)(_this.list(query)), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(items) {
                return _this.patchExpectedChanges(items);
            }));
        };
        _this.listAndWatch$$ = function(query) {
            return (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .concat */ .zo)([
                _this.list$$(query),
                _this.watchAll$
            ]), (0,_utils_wonka__WEBPACK_IMPORTED_MODULE_5__/* .upsert */ .H)(function(e) {
                return _this.getPk(e);
            }), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(items) {
                return items.filter(function(i) {
                    return !(query === null || query === void 0 ? void 0 : query.id) || query.id.includes(i.id);
                }).filter(function(i) {
                    return !(query === null || query === void 0 ? void 0 : query.status) || !!i.status && query.status.includes(i.status);
                });
            }), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(items) {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(items);
            }));
        };
        _this.listAndWatchWithOptimisticUpdates$$ = function(query) {
            return (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .concat */ .zo)([
                _this.list$$(query),
                _this.watchAllWithOptimisticUpdates$
            ]), (0,_utils_wonka__WEBPACK_IMPORTED_MODULE_5__/* .upsert */ .H)(function(e) {
                return _this.getPk(e);
            }), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(items) {
                return items.filter(function(i) {
                    return !(query === null || query === void 0 ? void 0 : query.id) || query.id.includes(i.id);
                }).filter(function(i) {
                    return !(query === null || query === void 0 ? void 0 : query.status) || !!i.status && query.status.includes(i.status);
                });
            }), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(items) {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(items);
            }));
        };
        _this.watchId$$ = function(id) {
            return (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)(_this.watchAll$, (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(items) {
                return items === null || items === void 0 ? void 0 : items.find(function(i) {
                    return i.id === id;
                });
            }));
        };
        _this.list = _this.manageErrors(_this.deserializeResponse(_this.api.tasks.query2));
        _this.get = _this.deserializeResponse(function(id, instances) {
            return _this.api.tasks.getTask(id, {
                instances: instances
            });
        });
        _this.create = _this.manageErrors(_this.deserializeResponse(function(task) {
            var notificationKey = _this.generateUid("create");
            _this.addNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_9__/* .NotificationKeyStatus.Pending */ .$K.Pending, true);
            return _this.api.tasks.create2(_this.serialize(task), {
                notificationKey: notificationKey
            }).then(function(res) {
                _this.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_9__/* .NotificationKeyStatus.Requested */ .$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_9__/* .NotificationKeyStatus.Failed */ .$K.Failed);
                throw reason;
            });
        }));
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_this);
        _this.update = _this.manageErrors(_this.deserializeResponse(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(task) {
                var notificationKey;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                    notificationKey = _this1.generateUid("update", task.id);
                    _this1.addNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_9__/* .NotificationKeyStatus.Pending */ .$K.Pending, true);
                    return [
                        2,
                        _this1.api.tasks.put1(task.id, _this1.serialize(task), {
                            notificationKey: notificationKey
                        }).then(function(res) {
                            _this1.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_9__/* .NotificationKeyStatus.Requested */ .$K.Requested);
                            return res;
                        }).catch(function(reason) {
                            console.warn("Request failed, clearing notification key", notificationKey, reason);
                            _this1.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_9__/* .NotificationKeyStatus.Failed */ .$K.Failed);
                            throw reason;
                        })
                    ];
                });
            });
            return function(task) {
                return _ref.apply(this, arguments);
            };
        }()));
        var _this2 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_this);
        _this.patch = _this.typedManageErrors(_this.deserializeResponse(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(id, patch) {
                var notificationKey;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                    notificationKey = _this2.generateUid("patch", id);
                    _this2.expectChange(notificationKey, id, patch, true);
                    return [
                        2,
                        _this2.api.tasks.patch2(id, _this2.serialize(patch), {
                            notificationKey: notificationKey
                        }).then(function(res) {
                            _this2.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_9__/* .NotificationKeyStatus.Requested */ .$K.Requested);
                            return res;
                        }).catch(function(reason) {
                            console.warn("Request failed, clearing notification key", notificationKey, reason);
                            _this2.clearExpectedChange(notificationKey, _types__WEBPACK_IMPORTED_MODULE_9__/* .NotificationKeyStatus.Failed */ .$K.Failed);
                            throw reason;
                        })
                    ];
                });
            });
            return function(id, patch) {
                return _ref.apply(this, arguments);
            };
        }()));
        _this.reindex = _this.manageErrors(_this.deserializeResponse(function(task, relativeId, direction) {
            var payload = {
                relativeTaskId: relativeId,
                reindexDirection: direction
            };
            // FIXME (IW): Add when backend supports ws notifications for reindex
            // const notificationKey = this.generateUid("reindex", task.id);
            // this.addNotificationKey(notificationKey);
            return _this.api.tasks.reindex(task.id, payload).then(function(res) {
                var _$task = _this.deserialize(res);
                _this.upsert(_$task);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed", reason);
                // this.updateNotificationKey(notificationKey, NotificationKeyStatus.Failed);
                throw reason;
            });
        }));
        _this.reindexByDueDate = _this.manageErrors(_this.deserializeResponse(function() {
            return _this.api.tasks.reindexByDue().then(function(taskDtos) {
                var tasks = taskDtos.map(function(dto) {
                    return _this.deserialize(dto);
                });
                _this.upsert(tasks);
                return taskDtos;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", reason);
                throw reason;
            });
        }));
        return _this;
    }
    return TasksDomain;
}(_types__WEBPACK_IMPORTED_MODULE_9__/* .TransformDomain */ .Zs);
var DELAYED_TASK_START_OPTIONS = Object.freeze([
    {
        label: "No delay",
        value: 0
    },
    {
        label: "1 hr",
        value: 1 * 60
    },
    {
        label: "2 hr",
        value: 2 * 60
    },
    {
        label: "5 hr",
        value: 5 * 60
    },
    {
        label: "12 hr",
        value: 12 * 60
    },
    {
        label: "1 day",
        value: 24 * 60
    },
    {
        label: "2 days",
        value: 2 * 24 * 60
    },
    {
        label: "3 days",
        value: 3 * 24 * 60
    },
    {
        label: "1 week",
        value: 7 * 24 * 60
    },
    {
        label: "2 weeks",
        value: 2 * 7 * 24 * 60
    }, 
]);
var DUE_IN_DAYS_OPTIONS = Object.freeze([
    {
        label: "No due date",
        value: 0
    },
    {
        label: "1 day",
        value: 1
    },
    {
        label: "2 days",
        value: 2
    },
    {
        label: "3 days",
        value: 3
    },
    {
        label: "1 week",
        value: 7
    },
    {
        label: "2 weeks",
        value: 14
    },
    {
        label: "4 weeks",
        value: 28
    }, 
]);
var getUserDefaultSnoozeUntil = function(user) {
    var ref, ref1;
    var anchor = new Date();
    if (!!(user === null || user === void 0 ? void 0 : (ref = user.features) === null || ref === void 0 ? void 0 : (ref1 = ref.taskSettings) === null || ref1 === void 0 ? void 0 : ref1.defaults.delayedStartInMinutes)) {
        anchor = (0,date_fns__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(anchor, user.features.taskSettings.defaults.delayedStartInMinutes || 0);
    }
    return (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .roundTimeToNextChunk */ .qn)(anchor);
};
var getUserDefaultDueDate = function(user, policy, relativeDate) {
    var ref, ref1;
    if (policy && !!(user === null || user === void 0 ? void 0 : (ref = user.features) === null || ref === void 0 ? void 0 : (ref1 = ref.taskSettings) === null || ref1 === void 0 ? void 0 : ref1.defaults.dueInDays)) {
        var due = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .roundTimeToNextChunk */ .qn)((0,date_fns__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(relativeDate, {
            days: user.features.taskSettings.defaults.dueInDays
        }));
        // Reverse scan and find nearest endOfDay to apply to this due date hours
        // NOTE: This matches backend logic.
        var prevEnd = (0,_utils_time_policy__WEBPACK_IMPORTED_MODULE_4__/* .scanTimePolicyForNearestEndOfDay */ .xv)(policy, due, false);
        if (!!prevEnd) {
            due.setHours(prevEnd.getHours(), 0, 0);
        } else {
            // default to 6:00 PM if date doesn't fit day's time policy
            due.setHours(18);
        }
        return due;
    } else {
        return null;
    }
};
var defaultTask = {
    title: "",
    status: TaskStatus.New,
    timeChunksRequired: 4,
    due: (0,date_fns__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(new Date(), 18), 0), 3),
    eventCategory: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .PrimaryCategory.SoloWork */ .CU.SoloWork,
    eventColor: _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .EventColor.Auto */ .dr.Auto,
    minChunkSize: 4,
    maxChunkSize: 32,
    alwaysPrivate: false
};
function makeDefaultTask(user, timeSchemes) {
    var ref, ref1;
    // Return general defaults if no user set defaults
    if (!(user === null || user === void 0 ? void 0 : (ref = user.features) === null || ref === void 0 ? void 0 : (ref1 = ref.taskSettings) === null || ref1 === void 0 ? void 0 : ref1.defaults)) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, defaultTask);
    }
    var defaults = user.features.taskSettings.defaults;
    var timeScheme = (timeSchemes === null || timeSchemes === void 0 ? void 0 : timeSchemes.find(function(s) {
        return s.id === user.features.taskSettings.defaults.timeSchemeId;
    })) || (timeSchemes === null || timeSchemes === void 0 ? void 0 : timeSchemes.find(function(s) {
        return s.policyType === "WORK";
    })); // Try to fallback to work task
    var snoozeUntil = getUserDefaultSnoozeUntil(user);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, defaultTask), {
        snoozeUntil: defaults.delayedStartInMinutes ? snoozeUntil : null,
        timeChunksRequired: defaults.timeChunksRequired || 2,
        due: defaults.dueInDays && (timeScheme === null || timeScheme === void 0 ? void 0 : timeScheme.policy) ? getUserDefaultDueDate(user, timeScheme.policy, snoozeUntil) : null,
        eventCategory: defaults.category.key === _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .EventType.Work.key */ .tw.Work.key ? _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .PrimaryCategory.SoloWork */ .CU.SoloWork : _EventMetaTypes__WEBPACK_IMPORTED_MODULE_7__/* .PrimaryCategory.Personal */ .CU.Personal,
        minChunkSize: defaults.minChunkSize || 1,
        maxChunkSize: defaults.maxChunkSize || 4,
        alwaysPrivate: defaults.alwaysPrivate,
        timeSchemeId: timeScheme === null || timeScheme === void 0 ? void 0 : timeScheme.id,
        priority: (0,_hooks_useV16User__WEBPACK_IMPORTED_MODULE_0__/* .isSchedulerV16 */ .p)(user.features.scheduler) ? defaults.priority : undefined,
        onDeck: !!defaults.onDeck
    });
}
var getNextUpcomingTaskInstance = function(taskInstances) {
    var now = new Date();
    var upcoming = null;
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(taskInstances).forEach(function(i) {
        // If the instance hasn't ended yet and is earlier than the current upcoming replace.
        if (i.end >= now && i.status !== TaskInstanceStatus.Done && (!upcoming || i.start < upcoming.start)) {
            upcoming = i;
        }
    });
    return upcoming;
};
var upsertTaskReindex = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(tasks, insertingTask, existingTaskId, reindexDirection) {
        var ref, ref1, direction, existingIndex, relIndex, adjIndex, tmpIndex;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    direction = reindexDirection === ReindexDirection.Before ? -1 : 1;
                    existingIndex = tasks.findIndex(function(t) {
                        return existingTaskId === t.id;
                    });
                    if (existingIndex === -1) {
                        console.error("Failed to reindex task: Existing task is not in provided list.");
                        return [
                            2
                        ];
                    }
                    relIndex = ((ref = tasks[existingIndex]) === null || ref === void 0 ? void 0 : ref.index) || 0;
                    adjIndex = ((ref1 = tasks[existingIndex + direction]) === null || ref1 === void 0 ? void 0 : ref1.index) || relIndex + direction * 1000;
                    tmpIndex = adjIndex + (relIndex - adjIndex) / 2;
                    ___WEBPACK_IMPORTED_MODULE_1__/* .reclaim.tasks.upsert */ .Tz.tasks.upsert((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, insertingTask), {
                        index: tmpIndex
                    }));
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_1__/* .reclaim.tasks.reindex */ .Tz.tasks.reindex(insertingTask, existingTaskId, reindexDirection)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function upsertTaskReindex(tasks, insertingTask, existingTaskId, reindexDirection) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 64825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G3": function() { return /* binding */ dtoToTimePolicy; },
/* harmony export */   "TE": function() { return /* binding */ timeSchemeCreateRequestToDto; },
/* harmony export */   "Z8": function() { return /* binding */ timeSchemeToTimeSchemeUpdateRequest; },
/* harmony export */   "aE": function() { return /* binding */ timePolicyToDto; },
/* harmony export */   "ox": function() { return /* binding */ dtoToTimeScheme; },
/* harmony export */   "uq": function() { return /* binding */ timeSchemeUpdateRequestToDto; }
/* harmony export */ });
/* unused harmony exports dtoToTimePolicyType, timePolicyTypeToDto, dtoToTaskCategory, taskCategoryToDto, dtoToEventType, eventTypeToDto, timeSchemeToDto */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);




var dtoToTimePolicyType = function(dto) {
    return dto;
};
var timePolicyTypeToDto = function(type) {
    return type;
};
var dtoToTaskCategory = function(dto) {
    return dto;
};
var taskCategoryToDto = function(category) {
    return category;
};
var dtoToEventType = function(dto) {
    return dto;
};
var eventTypeToDto = function(event) {
    return event;
};
var timePolicyToDto = function(timePolicy) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, timePolicy), {
        dayHours: Object.entries(timePolicy.dayHours).reduce(function(dhs, param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), day = _param[0], dh = _param[1];
            var _tmp;
            _tmp = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, dh), {
                intervals: dh.intervals.map(function(_param) {
                    var duration = _param.duration, interval = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                        "duration"
                    ]);
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, interval), {
                        // swagger thinks this is an object, but the backend always uses numbers here.
                        duration: duration
                    });
                })
            }), dhs[day] = _tmp, _tmp;
            return dhs;
        }, {})
    });
};
var dtoToTimePolicy = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, dto), {
        dayHours: Object.entries(dto.dayHours).reduce(function(dhs, param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), day = _param[0], dh = _param[1];
            var _tmp;
            _tmp = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, dh), {
                intervals: dh.intervals.map(function(_param) {
                    var duration = _param.duration, interval = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                        "duration"
                    ]);
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, interval), {
                        // swagger thinks this is an object, but the backend always uses numbers here.
                        duration: duration
                    });
                })
            }), dhs[day] = _tmp, _tmp;
            return dhs;
        }, {})
    });
};
var dtoToTimeScheme = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, dto), {
        policy: dtoToTimePolicy(dto.policy),
        policyType: dtoToTimePolicyType(dto.policyType),
        taskCategory: dto.taskCategory ? dtoToTaskCategory(dto.taskCategory) : null,
        features: dto.features
    });
};
var timeSchemeToDto = function(scheme) {
    return _object_spread_props(_object_spread({}, scheme), {
        policy: timePolicyToDto(scheme.policy),
        policyType: timePolicyTypeToDto(scheme.policyType),
        taskCategory: scheme.taskCategory ? taskCategoryToDto(scheme.taskCategory) : null,
        features: scheme.features.map(function(feature) {
            return eventTypeToDto(feature);
        })
    });
};
var timeSchemeToTimeSchemeUpdateRequest = function(scheme) {
    return {
        title: scheme.title,
        description: scheme.description,
        policy: timePolicyToDto(scheme.policy),
        policyType: timePolicyTypeToDto(scheme.policyType),
        taskCategory: scheme.taskCategory ? taskCategoryToDto(scheme.taskCategory) : null
    };
};
var timeSchemeCreateRequestToDto = function(request) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, request), {
        policy: timePolicyToDto(request.policy),
        policyType: timePolicyTypeToDto(request.policyType),
        taskCategory: request.taskCategory ? taskCategoryToDto(request.taskCategory) : null,
        features: request.features.map(function(feature) {
            return eventTypeToDto(feature);
        })
    });
};
var timeSchemeUpdateRequestToDto = function(request) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, request), {
        policy: request.policy ? timePolicyToDto(request.policy) : undefined,
        policyType: request.policyType ? timePolicyTypeToDto(request.policyType) : undefined,
        taskCategory: request.taskCategory ? taskCategoryToDto(request.taskCategory) : null,
        features: request.features ? request.features.map(function(feature) {
            return eventTypeToDto(feature);
        }) : null
    });
};


/***/ }),

/***/ 25606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getEffectiveTimeScheme; },
/* harmony export */   "r": function() { return /* binding */ filterTimeSchemesByEventType; }
/* harmony export */ });
var getEffectiveTimeScheme = function(timeSchemes, schemeId, policyType) {
    return timeSchemes.find(function(s) {
        return schemeId ? s.id === schemeId : s.policyType === policyType;
    });
};
var filterTimeSchemesByEventType = function(eventType, timeSchemes) {
    return (timeSchemes === null || timeSchemes === void 0 ? void 0 : timeSchemes.filter(function(s) {
        return s.features.includes(eventType) && s.policyType !== "ONE_OFF" && s.policyType !== "INHERITED";
    })) || [];
};


/***/ }),

/***/ 45983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wU": function() { return /* binding */ dtoToAnonymousPartner; },
  "Bn": function() { return /* binding */ dtoToPriorityLevel; },
  "wD": function() { return /* binding */ dtoToProductUsageReport; },
  "i1": function() { return /* binding */ dtoToQuests; },
  "SR": function() { return /* binding */ dtoToUser; },
  "Uv": function() { return /* binding */ priorityLevelToDto; }
});

// UNUSED EXPORTS: dtoSchedulingLinksSettings, dtoToAssistSettings, dtoToCalendarSettings, dtoToColorsSettings, dtoToDetailedEntitlements, dtoToEntitlementActualObject, dtoToEntitlementDetails, dtoToEventColor, dtoToFocusSettings, dtoToNumberEntitlementActualObject, dtoToProductUsageReportActuals, dtoToSettings, dtoToSlackSettings, dtoToSyncSettings, dtoToTaskAutoWorkflowSettings, dtoToTaskSettings, dtoToThinCalendar, dtoToUserMetadata, dtoToUserSettings, dtoToUserTimezone, dtoToWeeklyReportSettings

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/components/quests/questCollections/directory.quests.tsx
var directory_quests = __webpack_require__(33456);
// EXTERNAL MODULE: ./src/components/quests/quests.util.ts + 14 modules
var quests_util = __webpack_require__(32774);
// EXTERNAL MODULE: ./src/utils/dates.ts + 3 modules
var dates = __webpack_require__(26958);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./src/reclaim-api/Calendars.ts
var Calendars = __webpack_require__(48410);
// EXTERNAL MODULE: ./src/reclaim-api/EventMetaTypes.ts
var EventMetaTypes = __webpack_require__(90109);
;// CONCATENATED MODULE: ./src/reclaim-api/Tasks.mutators.ts



var dtoToCategory = function(dto) {
    return EventMetaTypes/* PrimaryCategory.get */.CU.get(dto);
};
var dtoToTaskDefaults = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        category: dtoToCategory(dto.category),
        priority: dto.priority
    });
};

// EXTERNAL MODULE: ./src/reclaim-api/team/Team.mutators.ts
var Team_mutators = __webpack_require__(19009);
;// CONCATENATED MODULE: ./src/reclaim-api/Users.mutators.ts











var dtoToEntitlementActualObject = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        requiredEdition: (0,Team_mutators/* dtoToReclaimEdition */.Bx)(dto.requiredEdition),
        actualValue: dto.actualValue,
        allowedValueForCurrentEdition: dto.allowedValueForCurrentEdition,
        requiredEditionValue: dto.requiredEditionValue
    });
};
/**
 * Back-end passes `Infinity` as `"Infinity"`.
 * This function behaves exactly like
 * `dtoToEntitlementActualObject` only it can
 * also parse the string infinity values
 * @param dto The data transfer object
 * @returns a `EntitlementActualObject<number>` object
 */ var dtoToNumberEntitlementActualObject = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        requiredEdition: (0,Team_mutators/* dtoToReclaimEdition */.Bx)(dto.requiredEdition),
        actualValue: (0,Team_mutators/* dtoToNumberEntitlementValue */.FC)(dto.actualValue),
        allowedValueForCurrentEdition: (0,Team_mutators/* dtoToNumberEntitlementValue */.FC)(dto.allowedValueForCurrentEdition),
        requiredEditionValue: (0,Team_mutators/* dtoToNumberEntitlementValue */.FC)(dto.requiredEditionValue)
    });
};
var dtoToProductUsageReportActuals = function(dto) {
    return {
        TEAM_SIZE: dto.MAX_TEAM_SIZE && dtoToEntitlementActualObject((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto.MAX_TEAM_SIZE), {
            actualValue: {
                min: 1,
                max: (0,Team_mutators/* dtoToNumberEntitlementValue */.FC)(dto.MAX_TEAM_SIZE.actualValue)
            },
            allowedValueForCurrentEdition: {
                min: 1,
                max: (0,Team_mutators/* dtoToNumberEntitlementValue */.FC)(dto.MAX_TEAM_SIZE.allowedValueForCurrentEdition)
            },
            requiredEditionValue: {
                min: 1,
                max: (0,Team_mutators/* dtoToNumberEntitlementValue */.FC)(dto.MAX_TEAM_SIZE.requiredEditionValue)
            }
        })),
        SCHEDULER_WEEKS: dto.SCHEDULER_WEEKS && dtoToNumberEntitlementActualObject(dto.SCHEDULER_WEEKS),
        MAX_TASKS: dto.MAX_TASKS && dtoToNumberEntitlementActualObject(dto.MAX_TASKS),
        MAX_CALENDARS: dto.MAX_CALENDARS && dtoToNumberEntitlementActualObject(dto.MAX_CALENDARS),
        MAX_SYNCS: dto.MAX_SYNCS && dtoToNumberEntitlementActualObject(dto.MAX_SYNCS),
        MAX_HABITS: dto.MAX_HABITS && dtoToNumberEntitlementActualObject(dto.MAX_HABITS),
        MAX_CUSTOM_TIME_SCHEMES: dto.MAX_CUSTOM_TIME_SCHEMES && dtoToNumberEntitlementActualObject(dto.MAX_CUSTOM_TIME_SCHEMES),
        MAX_SCHEDULING_LINKS: dto.MAX_SCHEDULING_LINKS && dtoToNumberEntitlementActualObject(dto.MAX_SCHEDULING_LINKS),
        MAX_1_ON_1_ORGANIZE: dto.MAX_1_ON_1_ORGANIZE && dtoToNumberEntitlementActualObject(dto.MAX_1_ON_1_ORGANIZE),
        MAX_1_ON_1_ATTEND: dto.MAX_1_ON_1_ATTEND && dtoToNumberEntitlementActualObject(dto.MAX_1_ON_1_ATTEND),
        TEAM_ANALYTICS: dto.TEAM_ANALYTICS && dtoToEntitlementActualObject(dto.TEAM_ANALYTICS),
        SUPPORT: dto.SUPPORT && dtoToEntitlementActualObject(dto.SUPPORT),
        SSO: dto.SSO && dtoToEntitlementActualObject(dto.SSO),
        DERIVATIVE_SCHEDULING_LINKS: dto.DERIVATIVE_SCHEDULING_LINKS && dtoToEntitlementActualObject(dto.DERIVATIVE_SCHEDULING_LINKS),
        CUSTOM_SLACK_STATUS: dto.CUSTOM_SLACK_STATUS && dtoToEntitlementActualObject(dto.CUSTOM_SLACK_STATUS),
        CUSTOM_BLOCKING: dto.CUSTOM_BLOCKING && dtoToEntitlementActualObject(dto.CUSTOM_BLOCKING),
        CUSTOM_BLOCKING_CALENDAR_SYNC: dto.CUSTOM_BLOCKING_CALENDAR_SYNC && dtoToEntitlementActualObject(dto.CUSTOM_BLOCKING_CALENDAR_SYNC),
        CUSTOM_BLOCKING_DECOMPRESSION: dto.CUSTOM_BLOCKING_DECOMPRESSION && dtoToEntitlementActualObject(dto.CUSTOM_BLOCKING_DECOMPRESSION),
        CUSTOM_BLOCKING_HABITS: dto.CUSTOM_BLOCKING_HABITS && dtoToEntitlementActualObject(dto.CUSTOM_BLOCKING_HABITS),
        INTEGRATIONS: dto.INTEGRATIONS && dtoToEntitlementActualObject(dto.INTEGRATIONS),
        INTEGRATION_SLACK: dto.INTEGRATION_SLACK && dtoToEntitlementActualObject(dto.INTEGRATION_SLACK),
        INTEGRATION_RAYCAST: dto.INTEGRATION_RAYCAST && dtoToEntitlementActualObject(dto.INTEGRATION_RAYCAST),
        INTEGRATION_ASANA: dto.INTEGRATION_ASANA && dtoToEntitlementActualObject(dto.INTEGRATION_ASANA),
        INTEGRATION_CLICKUP: dto.INTEGRATION_CLICKUP && dtoToEntitlementActualObject(dto.INTEGRATION_CLICKUP),
        INTEGRATION_GOOGLE_ADD_ON: dto.INTEGRATION_GOOGLE_ADD_ON && dtoToEntitlementActualObject(dto.INTEGRATION_GOOGLE_ADD_ON),
        INTEGRATION_GOOGLE_TASKS: dto.INTEGRATION_GOOGLE_TASKS && dtoToEntitlementActualObject(dto.INTEGRATION_GOOGLE_TASKS),
        INTEGRATION_JIRA: dto.INTEGRATION_JIRA && dtoToEntitlementActualObject(dto.INTEGRATION_JIRA),
        INTEGRATION_LINEAR: dto.INTEGRATION_LINEAR && dtoToEntitlementActualObject(dto.INTEGRATION_LINEAR),
        INTEGRATION_MONDAY: dto.INTEGRATION_MONDAY && dtoToEntitlementActualObject(dto.INTEGRATION_MONDAY),
        INTEGRATION_OFFICE_365: dto.INTEGRATION_OFFICE_365 && dtoToEntitlementActualObject(dto.INTEGRATION_OFFICE_365),
        INTEGRATION_TODOIST: dto.INTEGRATION_TODOIST && dtoToEntitlementActualObject(dto.INTEGRATION_TODOIST),
        INTEGRATION_TRELLO: dto.INTEGRATION_TRELLO && dtoToEntitlementActualObject(dto.INTEGRATION_TRELLO),
        INTEGRATION_ZOOM: dto.INTEGRATION_ZOOM && dtoToEntitlementActualObject(dto.INTEGRATION_ZOOM),
        SCHEDULING_LINK_SURVEY: dto.SCHEDULING_LINK_SURVEY && dtoToEntitlementActualObject(dto.SCHEDULING_LINK_SURVEY),
        SCHEDULING_LINK_REDIRECT: dto.SCHEDULING_LINK_SURVEY && dtoToEntitlementActualObject(dto.SCHEDULING_LINK_REDIRECT)
    };
};
var dtoToProductUsageReport = function(dto) {
    var usageEdition = (0,Team_mutators/* dtoToReclaimEdition */.Bx)(dto.usageEdition);
    var currentEdition = (0,Team_mutators/* dtoToReclaimEdition */.Bx)(dto.currentEdition);
    var terminalEdition = (0,Team_mutators/* dtoToReclaimEdition */.Bx)(dto.terminalEdition);
    var recommendedEdition = (0,Team_mutators/* dtoToReclaimEdition */.Bx)(dto.recommendedEdition);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        usageEdition: usageEdition,
        currentEdition: currentEdition,
        terminalEdition: terminalEdition,
        recommendedEdition: recommendedEdition,
        actuals: dtoToProductUsageReportActuals(dto.actuals),
        terminalActuals: dtoToProductUsageReportActuals(dto.terminalActuals)
    });
};
var dtoToEntitlementDetails = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        minimumEdition: (0,Team_mutators/* dtoToReclaimEdition */.Bx)(dto.minimumEdition),
        name: dto.name
    });
};
var dtoToDetailedEntitlements = function(dto) {
    return (0,objects/* typedEntries */.FR)(dto).reduce(function(acc, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], detailedEnt = _param[1];
        acc[key] = detailedEnt && dtoToEntitlementDetails(detailedEnt);
        return acc;
    }, {});
};
var dtoToQuests = function(dto) {
    var quests = dto.completedQuests;
    var config = {};
    Object.keys(directory_quests/* QUESTS_DIRECTORY */.Q).forEach(function(groupKey) {
        config[groupKey] = {
            quests: {}
        };
        directory_quests/* QUESTS_DIRECTORY */.Q[groupKey].forEach(function(questKey) {
            var complete = !!quests.find(function(q) {
                return q === questKey;
            });
            var qCfg = quests_util/* QUESTS_CONFIG */.t_[groupKey].quests.find(function(q) {
                return q.id === questKey;
            });
            if (qCfg) {
                var steps = qCfg.steps.map(function(s) {
                    return s.id;
                });
                config[groupKey].quests[questKey] = {
                    complete: complete,
                    steps: steps
                };
            }
        });
    });
    return config;
};
var priorityLevelToDto = function(priority) {
    return priority;
};
var dtoToPriorityLevel = function(dto) {
    return dto;
};
var dtoToUserTimezone = function(dto) {
    return dto;
};
var dtoToUserMetadata = function(dto) {
    return (0,_object_spread/* default */.Z)({}, dto);
};
var dtoToAssistSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        conferenceBufferType: dto.conferenceBufferType || "ALL_MEETINGS",
        autoLockForMeetings: dto.autoLockForMeetings || "OFF",
        autoLockForNonMeetings: dto.autoLockForNonMeetings || "OFF"
    });
};
var dtoToSlackSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        enabled: !!dto.enabled
    });
};
var dtoToTaskAutoWorkflowSettings = function(dto) {
    return (0,_object_spread/* default */.Z)({}, dto);
};
var dtoToTaskSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        enabled: !!dto.enabled,
        googleTasks: !!dto.googleTasks,
        defaults: dtoToTaskDefaults(dto.defaults),
        // cast is to remove erroneous undefined typing from server
        autoWorkflowSettings: dtoToTaskAutoWorkflowSettings(dto.autoWorkflowSettings)
    });
};
var dtoToEventColor = function(dto) {
    return EventMetaTypes/* EventColor.get */.dr.get(dto);
};
var dtoToColorsSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        enabled: !!dto.enabled,
        categoriesEnabled: !!dto.categoriesEnabled,
        // cast is to remove erroneous undefined typing from server
        categories: (0,objects/* typedEntries */.FR)(dto.categories).reduce(function(cats, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], val = _param[1];
            cats[key] = dtoToEventColor(val);
            return cats;
        }, {})
    });
};
var dtoToCalendarSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        enabled: !!dto.enabled
    });
};
var dtoToFocusSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        enabled: !!dto.enabled
    });
};
var dtoToSyncSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        enabled: !!dto.enabled
    });
};
var dtoToWeeklyReportSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        enabled: !!dto.enabled
    });
};
var dtoSchedulingLinksSettings = function(dto) {
    return (0,_object_spread/* default */.Z)({}, dto);
};
var dtoToUserSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        assistSettings: dtoToAssistSettings(dto.assistSettings),
        slackSettings: dtoToSlackSettings(dto.slackSettings),
        taskSettings: dtoToTaskSettings(dto.taskSettings),
        colors: dtoToColorsSettings(dto.colors),
        calendar: dtoToCalendarSettings(dto.calendar),
        focus: dtoToFocusSettings(dto.focus),
        sync: dtoToSyncSettings(dto.sync),
        weeklyReport: dtoToWeeklyReportSettings(dto.weeklyReport),
        schedulingLinks: dtoSchedulingLinksSettings(dto.schedulingLinks)
    });
};
var dtoToThinCalendar = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        timezone: dtoToUserTimezone(dto.timezone)
    });
};
var dtoToSettings = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        weekStart: dto.weekStart,
        timezone: dto.timezone
    });
};
var _startOfWeek;
var dtoToUser = function(dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        // cast is to remove erroneous undefined typing from server
        id: dto.id,
        name: dto.name || "",
        // cast is to remove erroneous undefined typing from server
        email: dto.email,
        // cast is to remove erroneous undefined typing from server
        timezone: dto.timezone && dtoToUserTimezone(dto.timezone),
        created: (0,dates/* strToDate */.z8)(dto.created),
        deleted: (0,dates/* strToDate */.z8)(dto.deleted),
        editionAfterTrial: (0,Team_mutators/* dtoToReclaimEdition */.Bx)(dto.edition),
        // cast is to remove erroneous undefined typing from server
        entitlements: dto.entitlements,
        // cast is to remove erroneous undefined typing from server
        detailedEntitlements: dto.detailedEntitlements && dtoToDetailedEntitlements(dto.detailedEntitlements),
        // cast is to remove erroneous undefined typing from server
        metadata: dto.metadata && dtoToUserMetadata(dto.metadata),
        // cast is to remove erroneous undefined typing from server
        features: dto.features && dtoToUserSettings(dto.features),
        // cast is to remove erroneous undefined typing from server
        primaryCalendar: dto.primaryCalendar && dtoToThinCalendar(dto.primaryCalendar),
        // cast is to remove erroneous undefined typing from server
        settings: dto.settings && dtoToSettings(dto.settings),
        editionEntitlements: dto.editionEntitlements && (0,Team_mutators/* dtoToEntitlementTableRow */.Jn)(dto.editionEntitlements),
        startOfWeek: (_startOfWeek = dto.startOfWeek) !== null && _startOfWeek !== void 0 ? _startOfWeek : Calendars/* DayOfWeek.Sunday */.eO.Sunday
    });
};
var dtoToAnonymousPartner = function(dto) {
    return (0,_object_spread/* default */.Z)({}, dto);
};


/***/ }),

/***/ 91669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BT": function() { return /* binding */ OnboardTrait; },
/* harmony export */   "FY": function() { return /* binding */ defaultTimePolicyWithLunch; },
/* harmony export */   "MT": function() { return /* binding */ dtoToThinPerson; },
/* harmony export */   "aA": function() { return /* binding */ UsersDomain; },
/* harmony export */   "fA": function() { return /* binding */ defaultTimeIntervalWithLunch; },
/* harmony export */   "q7": function() { return /* binding */ defaultTimePolicy; },
/* harmony export */   "rB": function() { return /* binding */ thinPersonToDto; },
/* harmony export */   "u1": function() { return /* binding */ InterestTrait; }
/* harmony export */ });
/* unused harmony exports dtoToSchedulingLinkSettings, schedulingLinkSettingsToDto, LOGIN_BASE_URI, LOGOUT_URI, UserTrait, dtoToTaskAutoWorkflowSettings */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45785);
/* harmony import */ var _swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82662);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71418);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(97582);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(46734);
/* harmony import */ var _utils_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63429);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(63496);
/* harmony import */ var _types_enums__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41390);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26958);
/* harmony import */ var _utils_strings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84467);
/* harmony import */ var _Calendars__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48410);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98585);
/* harmony import */ var _team_Team_mutators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19009);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42230);
/* harmony import */ var _Users_mutators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45983);






















var dtoToSchedulingLinkSettings = function(dto) {
    return _object_spread({}, dto);
};
var schedulingLinkSettingsToDto = function(settings) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, settings);
};
var LOGIN_BASE_URI = "https://api.app.reclaim-staging.com/oauth/login" || 0;
var LOGOUT_URI = "https://api.app.reclaim-staging.com/logout" || 0;
var UserTrait = /*#__PURE__*/ function(ObjectEnum) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(UserTrait, ObjectEnum);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(UserTrait);
    function UserTrait(group, feature, label) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, UserTrait);
        var _this;
        _this = _super.call(this, [
            group,
            feature
        ].join("_"));
        _this.group = group;
        _this.feature = feature;
        _this.label = label;
        return _this;
    }
    return UserTrait;
}(_types_enums__WEBPACK_IMPORTED_MODULE_12__/* .ObjectEnum */ .W);
var InterestTrait = /*#__PURE__*/ function(UserTrait) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(InterestTrait, UserTrait);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(InterestTrait);
    function InterestTrait(feature, label) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, InterestTrait);
        var _this;
        _this = _super.call(this, "INTEREST", feature, label);
        _this.feature = feature;
        _this.label = label;
        return _this;
    }
    InterestTrait.get = function get(feature) {
        if (!feature) return undefined;
        return (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(InterestTrait), "get", this).call(this, "INTEREST_".concat(feature.toUpperCase()));
    };
    return InterestTrait;
}(UserTrait);
InterestTrait.Tasks = new InterestTrait("TASKS", "Tasks");
InterestTrait.Priorities = new InterestTrait("PRIORITIES", "Priorities");
InterestTrait.Office365 = new InterestTrait("OFFICE365", "Office365");
InterestTrait.Calendar = new InterestTrait("CALENDAR", "Calendar");
InterestTrait.Asana = new InterestTrait("INTEGRATION_ASANA", "Asana");
InterestTrait.Trello = new InterestTrait("INTEGRATION_TRELLO", "Trello");
InterestTrait.Todoist = new InterestTrait("INTEGRATION_TODOIST", "Todoist");
InterestTrait.Jira = new InterestTrait("INTEGRATION_JIRA", "Jira");
InterestTrait.Linear = new InterestTrait("INTEGRATION_LINEAR", "Linear");
InterestTrait.ClickUp = new InterestTrait("INTEGRATION_CLICKUP", "ClickUp");
InterestTrait.Monday = new InterestTrait("INTEGRATION_MONDAY", "Monday");
var OnboardTrait = /*#__PURE__*/ function(UserTrait) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(OnboardTrait, UserTrait);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(OnboardTrait);
    function OnboardTrait(feature, label, dtoName) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, OnboardTrait);
        var _this;
        _this = _super.call(this, "ONBOARD", feature, label);
        _this.feature = feature;
        _this.label = label;
        _this.dtoName = dtoName;
        return _this;
    }
    OnboardTrait.get = function get(feature) {
        if (!feature) return undefined;
        return (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(OnboardTrait), "get", this).call(this, "ONBOARD_".concat(feature.toUpperCase()));
    };
    OnboardTrait.completed = function completed(user, feature) {
        var ref;
        return !!((ref = user === null || user === void 0 ? void 0 : user.features.onboard) === null || ref === void 0 ? void 0 : ref[feature.dtoName || (0,_utils_strings__WEBPACK_IMPORTED_MODULE_2__/* .camelcase */ .Hy)(feature.feature)]);
    };
    return OnboardTrait;
}(UserTrait);
OnboardTrait.Tasks = new OnboardTrait("TASKS", "Tasks");
OnboardTrait.GoogleTasks = new OnboardTrait("GOOGLE_TASKS", "Google Tasks");
OnboardTrait.PlanItemPrioritized = new OnboardTrait("PLAN_ITEM_PRIORITIZED", "Plan item prioritized");
OnboardTrait.SmartOneOnOne = new OnboardTrait("SMART_ONE_ON_ONES", "Smart 1:1s");
OnboardTrait.BufferTime = new OnboardTrait("BUFFER_TIME", "Buffer time");
OnboardTrait.TasksReindex = new OnboardTrait("TASKS_REINDEX", "Tasks reindex");
OnboardTrait.SchedulingLinks = new OnboardTrait("SCHEDULING_LINKS", "Scheduling Links", "ONBOARD_SCHEDULING_LINKS");
// This whole thing tries to be WAY too clever with concats and converting snake-case to camel case
// must specify dtoName here since the trait name is ONBOARD_GOOGLE_ADDON (no _ between ADD and ON)
// and the onboarding feature object name is googleAddOn (capital O)
OnboardTrait.GoogleAddon = new OnboardTrait("GOOGLE_ADDON", "Google calendar add-on", "googleAddOn");
OnboardTrait.V16Scheduler = new OnboardTrait("V16_SCHEDULER", "V16 Scheduler", "ONBOARD_V16_SCHEDULER");
var dtoToTaskAutoWorkflowSettings = function(dto) {
    return _object_spread({}, dto);
};
var dtoToThinPerson = function(dto) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, dto);
};
var thinPersonToDto = function(data) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, data);
};
var ProductUsageSubscription = {
    subscriptionType: _client__WEBPACK_IMPORTED_MODULE_4__/* .SubscriptionType.ProductUsage */ .Qe.ProductUsage
};
function userToDto(user) {
    var ref, ref1, ref2, ref3, ref4;
    // TODO (IW): Fix nested types so this doesn't have to be casted as `any`
    var dto = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, user), {
        features: user.features && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, user.features), {
            schedulingLinks: schedulingLinkSettingsToDto(user.features.schedulingLinks)
        }),
        created: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .dateToStr */ .dx)(user.created),
        deleted: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .dateToStr */ .dx)(user.deleted),
        // TODO (IW): Figure out readonly annotations, don't serialize readonly stuff
        locale: undefined,
        edition: user.edition && (0,_team_Team_mutators__WEBPACK_IMPORTED_MODULE_5__/* .reclaimEditionToDto */ .qQ)(user.edition),
        editionAfterTrial: user.editionAfterTrial && (0,_team_Team_mutators__WEBPACK_IMPORTED_MODULE_5__/* .reclaimEditionToDto */ .qQ)(user.editionAfterTrial),
        metadata: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, user.metadata), {
            companySize: (ref = user.metadata) === null || ref === void 0 ? void 0 : ref.companySize,
            usecase: (ref1 = user.metadata) === null || ref1 === void 0 ? void 0 : ref1.usecase,
            role: ((ref2 = user.metadata) === null || ref2 === void 0 ? void 0 : ref2.role) || undefined,
            department: (ref3 = user.metadata) === null || ref3 === void 0 ? void 0 : ref3.department,
            goals: (ref4 = user.metadata) === null || ref4 === void 0 ? void 0 : ref4.goals
        }),
        editionEntitlements: undefined,
        startOfWeek: (0,_Calendars__WEBPACK_IMPORTED_MODULE_3__/* .dayOfWeekToDto */ .GY)(user.startOfWeek)
    });
    return dto;
}
var QuestSubscription = {
    subscriptionType: _client__WEBPACK_IMPORTED_MODULE_4__/* .SubscriptionType.Quest */ .Qe.Quest
};
var UsersDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(UsersDomain, TransformDomain);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(UsersDomain);
    function UsersDomain() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, UsersDomain);
        var _this;
        var ref, ref1;
        _this = _super.apply(this, arguments);
        _this.resource = "User";
        _this.cacheKey = "users";
        _this.pk = "id";
        _this.deserialize = _Users_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToUser */ .SR;
        _this.serialize = userToDto;
        _this.watchQuestsWs$ = (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)(((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$(QuestSubscription)) || (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .fromArray */ .nI)([]), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .filter */ .hX)(function(envelope) {
            return !!envelope.data;
        }), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(envelope) {
            return envelope.data;
        }));
        _this.fetchAndWatchQuests$$ = function() {
            return (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)((0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .concat */ .zo)([
                (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .fromPromise */ .p4)(_this.api.users.getCompletedQuests()),
                _this.watchQuestsWs$
            ]), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(quests) {
                return quests;
            }));
        };
        _this.getCurrentUser = _this.manageErrors(_this.deserializeResponse(_this.api.users.current));
        _this.updateCurrentUser = _this.manageErrors(_this.deserializeResponse(function(user) {
            return _this.api.users.patch3(_this.serialize(user));
        }));
        _this.deleteCurrentUser = _this.manageErrors(_this.api.users.delete5);
        _this.addInterest = _this.manageErrors(_this.deserializeResponse(function(trait) {
            return _this.api.users.addTrait(trait.key, {});
        }));
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.listContacts = _this.typedManageErrors(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.api.users.getContacts()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().map(dtoToThinPerson)
                        ];
                }
            });
        }));
        _this.claimRewards = _this.manageErrors(function(tier) {
            return _this.api.users.claimRewards({
                claim: tier
            });
        });
        _this.inviteContacts = _this.manageErrors(_this.api.users.inviteContacts);
        var _this2 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.createAnonymousPartner = _this.typedManageErrors(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(email) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.api.partnerstack.createAnonymousPartner(email)
                            ];
                        case 1:
                            return [
                                2,
                                _Users_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToAnonymousPartner.apply */ .wU.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(email) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.hardDowngrade = _this.typedManageErrors(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this3.api.users.hardDowngrade()
                        ];
                    case 1:
                        return [
                            2,
                            _Users_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToProductUsageReport.apply */ .wD.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        }));
        _this.referrals = _this.manageErrors(_this.api.users.referrals);
        var _this4 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.insertHTMLIntoAddOnEmail = _this.typedManageErrors(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(html) {
                var options;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                            return [
                                4,
                                _this4.api.googleAddOn.addHtmlToEmail((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                    html: html,
                                    insertButtonLabel: "Insert into email",
                                    insertButtonAltText: "Insert the content into your email"
                                }, options))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(html) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.addonInsertAvailableTimes = function(html) {
            return _this.insertHTMLIntoAddOnEmail(html, {
                insertButtonLabel: "Insert times into email",
                insertButtonAltText: "Insert the times you selected into your email."
            });
        };
        var _this5 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.addonInsertLink = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(schedulingLink) {
                var options, durationMinutes, tz, user, note, url;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    durationMinutes = options.durationMinutes, tz = options.tz, user = options.user;
                    note = user === null || user === void 0 ? void 0 : user.features.schedulingLinks.note;
                    url = (0,_utils_router__WEBPACK_IMPORTED_MODULE_0__/* .getSchedulingLinkBookingPageLink */ .bV)(schedulingLink, {
                        absolute: true,
                        duration: durationMinutes,
                        tz: tz
                    });
                    note = note && (0,_utils_dom__WEBPACK_IMPORTED_MODULE_20__/* .escapeForHTML */ .q)(note).replace(/\n/g, "<br/>");
                    return [
                        2,
                        _this5.insertHTMLIntoAddOnEmail(note ? '<p style="white-space:break-space">'.concat(note, "</p><p>").concat(url, "</p>") : url, {
                            insertButtonLabel: "Add to email",
                            insertButtonAltText: 'Insert a link to the "'.concat(schedulingLink.title, '" booking page.')
                        })
                    ];
                });
            });
            return function(schedulingLink) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this6 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.getCompletedQuests = _this.typedManageErrors(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
            var response;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this6.api.users.getCompletedQuests()
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            (0,_Users_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToQuests */ .i1)(response)
                        ];
                }
            });
        }));
        var _this7 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.completeQuest = _this.typedManageErrors(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(quest) {
                var response;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this7.api.users.completeQuest({
                                    questType: quest
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                (0,_Users_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToQuests */ .i1)(response)
                            ];
                    }
                });
            });
            return function(quest) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.ssoLogin = _this.typedManageErrors(_this.api.sso.findProvider);
        var _this8 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.downgradeHardly = _this.typedManageErrors(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this8.api.users.hardDowngrade()
                        ];
                    case 1:
                        return [
                            2,
                            _Users_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToProductUsageReport.apply */ .wD.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        }));
        var _this9 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this);
        _this.usage = _this.typedManageErrors(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this9.api.users.productUsage()
                        ];
                    case 1:
                        return [
                            2,
                            _Users_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToProductUsageReport.apply */ .wD.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        }));
        _this.productUsageWs$ = (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .pipe */ .zG)(((ref1 = _this.ws) === null || ref1 === void 0 ? void 0 : ref1.subscription$$(ProductUsageSubscription)) || (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .fromArray */ .nI)([]), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .filter */ .hX)(function(envelope) {
            return !!envelope.data;
        }), (0,wonka__WEBPACK_IMPORTED_MODULE_16__/* .map */ .UI)(function(envelope) {
            return (0,_Users_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToProductUsageReport */ .wD)(envelope.data);
        }));
        _this.watchProductUsage$$ = function() {
            return _this.productUsageWs$;
        };
        _this.onboardUser = _this.typedManageErrors(function(habits, goals, hasTravelBuffer, hasDecompressionTime, userId) {
            var notificationKey = _this.generateUid("User", userId);
            _this.expectChange(notificationKey, userId, {}, true);
            return _this.api.users.onboarded({
                habitTemplateKeys: habits,
                goals: goals,
                hasTravelBuffer: hasTravelBuffer,
                hasDecompressionTime: hasDecompressionTime
            }, {
                notificationKey: notificationKey
            }).then(function(user) {
                _this.updateNotificationKey(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Requested */ .$K.Requested);
                return _this.deserialize(user);
            }).catch(function(error) {
                _this.clearExpectedChange(notificationKey, _types__WEBPACK_IMPORTED_MODULE_6__/* .NotificationKeyStatus.Failed */ .$K.Failed);
                throw new Error(error);
            });
        });
        return _this;
    }
    var _proto = UsersDomain.prototype;
    _proto.authRedirect = function authRedirect(provider, hint, state) {
        // FIXME: (IW) Doesn't work when base uri is just a path (eg. '/oauth/login'),
        // but window.location is no bueno
        var authUrl = new URL("".concat(LOGIN_BASE_URI, "/").concat(provider), window.location.href);
        if (state) authUrl.searchParams.append("state", JSON.stringify(state));
        if (false === hint) {
            authUrl.searchParams.append("prompt", "select_account");
        } else if (typeof hint === "string") {
            authUrl.searchParams.append("login_hint", hint);
        }
        window.location.href = authUrl.toString();
    };
    _proto.logout = function logout() {
        var url = new URL(LOGOUT_URI, window.location.href);
        window.location.href = url.toString();
    };
    return UsersDomain;
}(_types__WEBPACK_IMPORTED_MODULE_6__/* .TransformDomain */ .Zs);
var defaultTimePolicy = function() {
    return {
        dayHours: {
            MONDAY: {
                intervals: [
                    {
                        start: "09:00:00",
                        end: "17:00:00"
                    }
                ]
            },
            TUESDAY: {
                intervals: [
                    {
                        start: "09:00:00",
                        end: "17:00:00"
                    }
                ]
            },
            WEDNESDAY: {
                intervals: [
                    {
                        start: "09:00:00",
                        end: "17:00:00"
                    }
                ]
            },
            THURSDAY: {
                intervals: [
                    {
                        start: "09:00:00",
                        end: "17:00:00"
                    }
                ]
            },
            FRIDAY: {
                intervals: [
                    {
                        start: "09:00:00",
                        end: "17:00:00"
                    }
                ]
            }
        }
    };
};
var defaultTimeIntervalWithLunch = [
    {
        start: "09:00:00",
        end: "12:00:00"
    },
    {
        start: "13:00:00",
        end: "17:00:00"
    }, 
];
var defaultTimePolicyWithLunch = function() {
    return {
        dayHours: {
            MONDAY: {
                intervals: defaultTimeIntervalWithLunch
            },
            TUESDAY: {
                intervals: defaultTimeIntervalWithLunch
            },
            WEDNESDAY: {
                intervals: defaultTimeIntervalWithLunch
            },
            THURSDAY: {
                intervals: defaultTimeIntervalWithLunch
            },
            FRIDAY: {
                intervals: defaultTimeIntervalWithLunch
            }
        }
    };
};


/***/ }),

/***/ 77856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gH": function() { return /* binding */ ReclaimWS; },
  "Qe": function() { return /* reexport */ client/* SubscriptionType */.Qe; }
});

// UNUSED EXPORTS: SubscriptionStatus, WebsocketStatus

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./node_modules/fflate/esm/browser.js
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var ch2 = {};
var wk = (function (c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], { type: 'text/javascript' }))));
    w.onmessage = function (e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        }
        else
            cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
});

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function (eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return [b, r];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
    // reverse table algorithm from SO
    var x = ((i & 0xAAAA) >>> 1) | ((i & 0x5555) << 1);
    x = ((x & 0xCCCC) >>> 2) | ((x & 0x3333) << 2);
    x = ((x & 0xF0F0) >>> 4) | ((x & 0x0F0F) << 4);
    rev[i] = (((x & 0xFF00) >>> 8) | ((x & 0x00FF) << 8)) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = (function (cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i) {
        if (cd[i])
            ++l[cd[i] - 1];
    }
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 0; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = (i << 4) | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >>> rvb] = sv;
                }
            }
        }
    }
    else {
        co = new u16(s);
        for (i = 0; i < s; ++i) {
            if (cd[i]) {
                co[i] = rev[le[cd[i] - 1]++] >>> (15 - cd[i]);
            }
        }
    }
    return co;
});
// fixed length tree
var flt = new u8(288);
for (var i = 0; i < 144; ++i)
    flt[i] = 8;
for (var i = 144; i < 256; ++i)
    flt[i] = 9;
for (var i = 256; i < 280; ++i)
    flt[i] = 7;
for (var i = 280; i < 288; ++i)
    flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i = 0; i < 32; ++i)
    fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ (/* unused pure expression or super */ null && (hMap(flt, 9, 0))), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ (/* unused pure expression or super */ null && (hMap(fdt, 5, 0))), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function (a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m)
            m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function (d, p, m) {
    var o = (p / 8) | 0;
    return ((d[o] | (d[o + 1] << 8)) >> (p & 7)) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function (d, p) {
    var o = (p / 8) | 0;
    return ((d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >> (p & 7));
};
// get end of byte
var shft = function (p) { return ((p + 7) / 8) | 0; };
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function (v, s, e) {
    if (s == null || s < 0)
        s = 0;
    if (e == null || e > v.length)
        e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v.BYTES_PER_ELEMENT == 2 ? u16 : v.BYTES_PER_ELEMENT == 4 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
/**
 * Codes for errors generated within this library
 */
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
    // determined by unknown compression method
];
;
var err = function (ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace)
        Error.captureStackTrace(e, err);
    if (!nt)
        throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function (dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || (st && st.f && !st.l))
        return buf || new u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st)
        st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf)
        buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function (l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | (dat[s - 3] << 8), t = s + l;
                if (t > sl) {
                    if (noSt)
                        err(0);
                    break;
                }
                // ensure size
                if (noBuf)
                    cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            }
            else if (type == 1)
                lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl;) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    }
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16)
                            n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17)
                            n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18)
                            n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--)
                            ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            }
            else
                err(1);
            if (pos > tbts) {
                if (noSt)
                    err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf)
            cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for (;; lpos = pos) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt)
                    err(0);
                break;
            }
            if (!c)
                err(2);
            if (sym < 256)
                buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            }
            else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d)
                    err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & ((1 << b) - 1), pos += b;
                }
                if (pos > tbts) {
                    if (noSt)
                        err(0);
                    break;
                }
                if (noBuf)
                    cbuf(bt + 131072);
                var end = bt + add;
                for (; bt < end; bt += 4) {
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm)
            final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function (d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i])
            t.push({ s: i, f: d[i] });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s)
        return [et, 0];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [v, 1];
    }
    t.sort(function (a, b) { return a.f - b.f; });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({ s: -1, f: 25001 });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym)
            maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function (a, b) { return tr[b.s] - tr[a.s] || a.f - b.f; });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << (mbt - tr[i2_1]));
                tr[i2_1] = mb;
            }
            else
                break;
        }
        dt >>>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb)
                dt -= 1 << (mb - tr[i2_2]++ - 1);
            else
                ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [new u8(tr), mbt];
};
// get the max length and assign length codes
var ln = function (n, l, d) {
    return n.s == -1
        ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
        : (l[n.s] = d);
};
// length codes generation
var lc = function (c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s])
        ;
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function (v) { cl[cli++] = v; };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s)
            ++cls;
        else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138)
                    w(32754);
                if (cls > 2) {
                    w(cls > 10 ? ((cls - 11) << 5) | 28690 : ((cls - 3) << 5) | 12305);
                    cls = 0;
                }
            }
            else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6)
                    w(8304);
                if (cls > 2)
                    w(((cls - 3) << 5) | 8208), cls = 0;
            }
            while (cls--)
                w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return [cl.subarray(0, cli), s];
};
// calculate the length of output from tree, code lengths
var clen = function (cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i)
        l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function (out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i)
        out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i)
        lcfreq[lclt[i] & 31]++;
    for (var i = 0; i < lcdt.length; ++i)
        lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
        ;
    var flen = (bl + 5) << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen)
        return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i)
            wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15)
                    wbits(out, p, (clct[i] >>> 5) & 127), p += clct[i] >>> 12;
            }
        }
    }
    else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i = 0; i < li; ++i) {
        if (syms[i] > 255) {
            var len = (syms[i] >>> 18) & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7)
                wbits(out, p, (syms[i] >>> 23) & 31), p += fleb[len];
            var dst = syms[i] & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3)
                wbits16(out, p, (syms[i] >>> 5) & 8191), p += fdeb[dst];
        }
        else {
            wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function (dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) {
        for (var i = 0; i <= s; i += 65535) {
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos >> 3] = lst;
            }
            pos = wfblk(w, pos + 1, dat.subarray(i, e));
        }
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function (i) { return (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1; };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for (; i < s; ++i) {
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for (var j = 0; j < 286; ++j)
                        lf[j] = 0;
                    for (var j = 0; j < 30; ++j)
                        df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = (imod - pimod) & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl)
                                ;
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn)
                                    break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = (i - dif + j + 32768) & 32767;
                                    var pti = prev[ti];
                                    var cd = (ti - pti + 32768) & 32767;
                                    if (cd > md)
                                        md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += (imod - pimod + 32768) & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                }
                else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7)
            pos = wfblk(w, pos + 1, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ (/* unused pure expression or super */ null && ((function () {
    var t = new Int32Array(256);
    for (var i = 0; i < 256; ++i) {
        var c = i, k = 9;
        while (--k)
            c = ((c & 1) && -306674912) ^ (c >>> 1);
        t[i] = c;
    }
    return t;
})()));
// CRC32
var crc = function () {
    var c = -1;
    return {
        p: function (d) {
            // closures have awful performance
            var cr = c;
            for (var i = 0; i < d.length; ++i)
                cr = crct[(cr & 255) ^ d[i]] ^ (cr >>> 8);
            c = cr;
        },
        d: function () { return ~c; }
    };
};
// Alder32
var adler = function () {
    var a = 1, b = 0;
    return {
        p: function (d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for (var i = 0; i != l;) {
                var e = Math.min(i + 2655, l);
                for (; i < e; ++i)
                    m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function () {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a >>> 8) << 16 | (b & 255) << 8 | (b >>> 8);
        }
    };
};
;
// deflate with opts
var dopt = function (dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : (12 + opt.mem), pre, post, !st);
};
// Walmart object spread
var mrg = function (a, b) {
    var o = {};
    for (var k in a)
        o[k] = a[k];
    for (var k in b)
        o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function (fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for (var i = 0; i < dt.length; ++i) {
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                }
                else {
                    fnStr += st_1;
                    for (var t in v.prototype)
                        fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            }
            else
                fnStr += st_1;
        }
        else
            td[k] = v;
    }
    return [fnStr, td];
};
var ch = (/* unused pure expression or super */ null && ([]));
// clone bufs
var cbfs = function (v) {
    var tl = [];
    for (var k in v) {
        if (v[k].buffer) {
            tl.push((v[k] = new v[k].constructor(v[k])).buffer);
        }
    }
    return tl;
};
// use a worker to execute code
var wrkr = function (fns, init, id, cb) {
    var _a;
    if (!ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for (var i = 0; i < m; ++i)
            _a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        ch[id] = wcln(fns[m], fnStr, td_1);
    }
    var td = mrg({}, ch[id][1]);
    return wk(ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function () { return [u8, u16, u32, fleb, fdeb, clim, fl, fd, flrm, fdrm, rev, ec, hMap, max, bits, bits16, shft, slc, err, inflt, inflateSync, pbf, gu8]; };
var bDflt = function () { return [u8, u16, u32, fleb, fdeb, clim, revfl, revfd, flm, flt, fdm, fdt, rev, deo, et, hMap, wbits, wbits16, hTree, ln, lc, clen, wfblk, wblk, shft, slc, dflt, dopt, deflateSync, pbf]; };
// gzip extra
var gze = function () { return [gzh, gzhl, wbytes, crc, crct]; };
// gunzip extra
var guze = function () { return [gzs, gzl]; };
// zlib extra
var zle = function () { return [zlh, wbytes, adler]; };
// unzlib extra
var zule = function () { return [zlv]; };
// post buf
var pbf = function (msg) { return postMessage(msg, [msg.buffer]); };
// get u8
var gu8 = function (o) { return o && o.size && new u8(o.size); };
// async helper
var cbify = function (dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function (err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([dat, opts], opts.consume ? [dat.buffer] : []);
    return function () { w.terminate(); };
};
// auto stream
var astrm = function (strm) {
    strm.ondata = function (dat, final) { return postMessage([dat, final], [dat.buffer]); };
    return function (ev) { return strm.push(ev.data[0], ev.data[1]); };
};
// async stream attach
var astrmify = function (fns, strm, opts, init, id) {
    var t;
    var w = wrkr(fns, init, id, function (err, dat) {
        if (err)
            w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1])
                w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function (d, f) {
        if (!strm.ondata)
            err(5);
        if (t)
            strm.ondata(err(4, 0, 1), null, !!f);
        w.postMessage([d, t = f], [d.buffer]);
    };
    strm.terminate = function () { w.terminate(); };
};
// read 2 bytes
var b2 = function (d, b) { return d[b] | (d[b + 1] << 8); };
// read 4 bytes
var b4 = function (d, b) { return (d[b] | (d[b + 1] << 8) | (d[b + 2] << 16) | (d[b + 3] << 24)) >>> 0; };
var b8 = function (d, b) { return b4(d, b) + (b4(d, b + 4) * 4294967296); };
// write bytes
var wbytes = function (d, b, v) {
    for (; v; ++b)
        d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function (c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0)
        wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for (var i = 0; i <= fn.length; ++i)
            c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function (d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8)
        err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4)
        st += d[10] | (d[11] << 8) + 2;
    for (var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++])
        ;
    return st + (flg & 2);
};
// gzip length
var gzl = function (d) {
    var l = d.length;
    return ((d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16) | (d[l - 1] << 24)) >>> 0;
};
// gzip header length
var gzhl = function (o) { return 10 + ((o.filename && (o.filename.length + 1)) || 0); };
// zlib header
var zlh = function (c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = (fl << 6) | (fl ? (32 - 2 * fl) : 1);
};
// zlib valid
var zlv = function (d) {
    if ((d[0] & 15) != 8 || (d[0] >>> 4) > 7 || ((d[0] << 8 | d[1]) % 31))
        err(6, 'invalid zlib data');
    if (d[1] & 32)
        err(6, 'invalid zlib data: preset dictionaries not supported');
};
function AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function')
        cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */
var Deflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function')
            cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function (c, f) {
        this.ondata(dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Deflate.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (this.d)
            err(4);
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}())));

/**
 * Asynchronous streaming DEFLATE compression
 */
var AsyncDeflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function () { return [astrm, Deflate]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}())));

function deflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
    ], function (ev) { return pbf(deflateSync(ev.data[0], ev.data[1])); }, 0, cb);
}
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */
var Inflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */
    function Inflate(cb) {
        this.s = {};
        this.p = new u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function (c) {
        if (!this.ondata)
            err(5);
        if (this.d)
            err(4);
        var l = this.p.length;
        var n = new u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function (final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = inflt(this.p, this.o, this.s);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, (this.s.p / 8) | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */
    Inflate.prototype.push = function (chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}())));

/**
 * Asynchronous streaming DEFLATE decompression
 */
var AsyncInflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncInflate(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            function () { return [astrm, Inflate]; }
        ], this, 0, function () {
            var strm = new Inflate();
            onmessage = astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}())));

function inflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt
    ], function (ev) { return pbf(inflateSync(ev.data[0], gu8(ev.data[1]))); }, 1, cb);
}
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function inflateSync(data, out) {
    return inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */
var Gzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gzip.prototype.push = function (chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function (c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, !f);
        if (this.v)
            gzh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}())));

/**
 * Asynchronous streaming GZIP compression
 */
var AsyncGzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function () { return [astrm, Deflate, Gzip]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}())));

function gzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function () { return [gzipSync]; }
    ], function (ev) { return pbf(gzipSync(ev.data[0], ev.data[1])); }, 2, cb);
}
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */
function gzipSync(data, opts) {
    if (!opts)
        opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */
var Gunzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */
    function Gunzip(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gunzip.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? gzs(this.p) : 4;
            if (s >= this.p.length && !final)
                return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8)
                err(6, 'invalid gzip data');
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Gunzip;
}())));

/**
 * Asynchronous streaming GZIP decompression
 */
var AsyncGunzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncGunzip(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            guze,
            function () { return [astrm, Inflate, Gunzip]; }
        ], this, 0, function () {
            var strm = new Gunzip();
            onmessage = astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}())));

function gunzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function () { return [gunzipSync]; }
    ], function (ev) { return pbf(gunzipSync(ev.data[0])); }, 3, cb);
}
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
 * @returns The decompressed version of the data
 */
function gunzipSync(data, out) {
    return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
}
/**
 * Streaming Zlib compression
 */
var Zlib = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Zlib.prototype.push = function (chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function (c, f) {
        this.c.p(c);
        var raw = dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v)
            zlh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}())));

/**
 * Asynchronous streaming Zlib compression
 */
var AsyncZlib = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function () { return [astrm, Deflate, Zlib]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}())));

function zlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function () { return [zlibSync]; }
    ], function (ev) { return pbf(zlibSync(ev.data[0], ev.data[1])); }, 4, cb);
}
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (!opts)
        opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */
var Unzlib = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */
    function Unzlib(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzlib.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final)
                return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4)
                err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}())));

/**
 * Asynchronous streaming Zlib decompression
 */
var AsyncUnzlib = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncUnzlib(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            zule,
            function () { return [astrm, Inflate, Unzlib]; }
        ], this, 0, function () {
            var strm = new Unzlib();
            onmessage = astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}())));

function unzlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function () { return [unzlibSync]; }
    ], function (ev) { return pbf(unzlibSync(ev.data[0], gu8(ev.data[1]))); }, 5, cb);
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
// Default algorithm for compression (used because having a known output size allows faster decompression)

// Default algorithm for compression (used because having a known output size allows faster decompression)

/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var Decompress = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */
    function Decompress(cb) {
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Decompress.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            }
            else
                this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function () { _this_1.ondata.apply(_this_1, arguments); };
                this.s = (this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8)
                    ? new this.G(cb)
                    : ((this.p[0] & 15) != 8 || (this.p[0] >> 4) > 7 || ((this.p[0] << 8 | this.p[1]) % 31))
                        ? new this.I(cb)
                        : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        }
        else
            this.s.push(chunk, final);
    };
    return Decompress;
}())));

/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var AsyncDecompress = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */
    function AsyncDecompress(cb) {
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncDecompress.prototype.push = function (chunk, final) {
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}())));

function decompress(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzip(data, opts, cb)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflate(data, opts, cb)
            : unzlib(data, opts, cb);
}
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function decompressSync(data, out) {
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzipSync(data, out)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflateSync(data, out)
            : unzlibSync(data, out);
}
// flatten a directory structure
var fltn = function (d, p, t, o) {
    for (var k in d) {
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val))
            op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8)
            t[n] = [val, op];
        else {
            t[n += '/'] = [new u8(0), op];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, { stream: true });
    tds = 1;
}
catch (e) { }
// decode UTF8
var dutf8 = function (d) {
    for (var r = '', i = 0;;) {
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length)
            return [r, slc(d, i - 1)];
        if (!eb)
            r += String.fromCharCode(c);
        else if (eb == 3) {
            c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | (d[i++] & 63)) - 65536,
                r += String.fromCharCode(55296 | (c >> 10), 56320 | (c & 1023));
        }
        else if (eb & 1)
            r += String.fromCharCode((c & 31) << 6 | (d[i++] & 63));
        else
            r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | (d[i++] & 63));
    }
};
/**
 * Streaming UTF-8 decoding
 */
var DecodeUTF8 = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */
    function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds)
            this.t = new TextDecoder();
        else
            this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    DecodeUTF8.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, { stream: true }), final);
            if (final) {
                if (this.t.decode().length)
                    err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p)
            err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length)
                err(8);
            this.p = null;
        }
        else
            this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}())));

/**
 * Streaming UTF-8 encoding
 */
var EncodeUTF8 = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */
    function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */
    EncodeUTF8.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (this.d)
            err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}())));

/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for (var i = 0; i < str.length; ++i)
            ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te)
        return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function (v) { ar[ai++] = v; };
    for (var i = 0; i < l; ++i) {
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + ((l - i) << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1)
            w(c);
        else if (c < 2048)
            w(192 | (c >> 6)), w(128 | (c & 63));
        else if (c > 55295 && c < 57344)
            c = 65536 + (c & 1023 << 10) | (str.charCodeAt(++i) & 1023),
                w(240 | (c >> 18)), w(128 | ((c >> 12) & 63)), w(128 | ((c >> 6) & 63)), w(128 | (c & 63));
        else
            w(224 | (c >> 12)), w(128 | ((c >> 6) & 63)), w(128 | (c & 63));
    }
    return slc(ar, 0, ai);
}
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = '';
        for (var i = 0; i < dat.length; i += 16384)
            r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    }
    else if (td)
        return td.decode(dat);
    else {
        var _a = dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length)
            err(8);
        return out;
    }
}
;
// deflate bit flag
var dbf = function (l) { return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0; };
// skip local zip header
var slzh = function (d, b) { return b + 30 + b2(d, b + 26) + b2(d, b + 28); };
// read zip header
var zh = function (d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [bs, b4(d, b + 24), b4(d, b + 42)], sc = _a[0], su = _a[1], off = _a[2];
    return [b2(d, b + 10), sc, su, fn, es + b2(d, b + 30) + b2(d, b + 32), off];
};
// read zip64 extra field
var z64e = function (d, b) {
    for (; b2(d, b) != 1; b += 4 + b2(d, b + 2))
        ;
    return [b8(d, b + 12), b8(d, b + 4), b8(d, b + 20)];
};
// extra field length
var exfl = function (ex) {
    var le = 0;
    if (ex) {
        for (var k in ex) {
            var l = ex[k].length;
            if (l > 65535)
                err(9);
            le += l + 4;
        }
    }
    return le;
};
// write zip header
var wzh = function (d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null)
        d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = (f.flag << 1) | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119)
        err(10);
    wbytes(d, b, (y << 25) | ((dt.getMonth() + 1) << 21) | (dt.getDate() << 16) | (dt.getHours() << 11) | (dt.getMinutes() << 5) | (dt.getSeconds() >>> 1)), b += 4;
    if (c != -1) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) {
        for (var k in ex) {
            var exf = ex[k], l = exf.length;
            wbytes(d, b, +k);
            wbytes(d, b + 2, l);
            d.set(exf, b + 4), b += 4 + l;
        }
    }
    if (col)
        d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function (o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */
var ZipPassThrough = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */
    function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */
    ZipPassThrough.prototype.process = function (chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    ZipPassThrough.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final)
            this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}())));

// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */
var ZipDeflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */
    function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts)
            opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function (dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function (chunk, final) {
        try {
            this.d.push(chunk, final);
        }
        catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    ZipDeflate.prototype.push = function (chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}())));

/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */
var AsyncZipDeflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */
    function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts)
            opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function (err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function (chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncZipDeflate.prototype.push = function (chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}())));

// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */
var Zip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */
    function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */
    Zip.prototype.add = function (file) {
        var _this_1 = this;
        if (!this.ondata)
            err(5);
        // finishing or finished
        if (this.d & 2)
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || (o && (com.length != o.length));
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535)
                this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u, -1);
            var chks_1 = [header];
            var pAll_1 = function () {
                for (var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++) {
                    var chk = chks_2[_i];
                    _this_1.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function () {
                    if (file.terminate)
                        file.terminate();
                },
                r: function () {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this_1.u[ind_1 + 1];
                        if (nxt)
                            nxt.r();
                        else
                            _this_1.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function (err, dat, final) {
                if (err) {
                    _this_1.ondata(err, dat, final);
                    _this_1.terminate();
                }
                else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1)
                            uf_1.r();
                        tr_1 = 1;
                    }
                    else if (tr_1)
                        pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */
    Zip.prototype.end = function () {
        var _this_1 = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d)
            this.e();
        else
            this.u.push({
                r: function () {
                    if (!(_this_1.d & 1))
                        return;
                    _this_1.u.splice(-1, 1);
                    _this_1.e();
                },
                t: function () { }
            });
        this.d = 3;
    };
    Zip.prototype.e = function () {
        var bt = 0, l = 0, tl = 0;
        for (var _i = 0, _a = this.u; _i < _a.length; _i++) {
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for (var _b = 0, _c = this.u; _b < _c.length; _b++) {
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */
    Zip.prototype.terminate = function () {
        for (var _i = 0, _a = this.u; _i < _a.length; _i++) {
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}())));

function zip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    var r = {};
    fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var cbd = function (a, b) {
        mt(function () { cb(a, b); });
    };
    mt(function () { cbd = cb; });
    var cbf = function () {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for (var i = 0; i < slft; ++i) {
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            }
            catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft)
        cbf();
    var _loop_1 = function (i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function (e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            }
            else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || (m && (com.length != ms)),
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft)
                    cbf();
            }
        };
        if (s > 65535)
            cbl(err(11, 0, 1), null);
        if (!compression)
            cbl(null, file);
        else if (size < 160000) {
            try {
                cbl(null, deflateSync(file, p));
            }
            catch (e) {
                cbl(e, null);
            }
        }
        else
            term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for (var i = 0; i < slft; ++i) {
        _loop_1(i);
    }
    return tAll;
}
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */
function zipSync(data, opts) {
    if (!opts)
        opts = {};
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for (var fn in r) {
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535)
            err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || (m && (com.length != ms)),
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for (var i = 0; i < files.length; ++i) {
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */
var UnzipPassThrough = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    function UnzipPassThrough() {
    }
    UnzipPassThrough.prototype.push = function (data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}())));

/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */
var UnzipInflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */
    function UnzipInflate() {
        var _this_1 = this;
        this.i = new Inflate(function (dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function (data, final) {
        try {
            this.i.push(data, final);
        }
        catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}())));

/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */
var AsyncUnzipInflate = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */
    function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) {
            this.i = new Inflate(function (dat, final) {
                _this_1.ondata(null, dat, final);
            });
        }
        else {
            this.i = new AsyncInflate(function (err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function (data, final) {
        if (this.i.terminate)
            data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}())));

/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */
var Unzip = /*#__PURE__*/ ((/* unused pure expression or super */ null && (function () {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */
    function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzip.prototype.push = function (chunk, final) {
        var _this_1 = this;
        if (!this.onfile)
            err(5);
        if (!this.p)
            err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d)
                this.d.push(toAdd, !this.c);
            else
                this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length)
                return this.push(chunk, final);
        }
        else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length)
                buf = chunk;
            else if (!chunk.length)
                buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function () {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) {
                            _a = dd ? [-2] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        }
                        else if (dd)
                            sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function () {
                                if (!file_1.ondata)
                                    err(5);
                                if (!sc_1)
                                    file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr)
                                        file_1.ondata(err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function (err, dat, final) { file_1.ondata(err, dat, final); };
                                    for (var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++) {
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_3 && _this_1.c)
                                        _this_1.d = d_1;
                                    else
                                        d_1.push(et, true);
                                }
                            },
                            terminate: function () {
                                if (d_1 && d_1.terminate)
                                    d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0)
                            file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                }
                else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    }
                    else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for (; i < l - 4; ++i) {
                var state_1 = _loop_2();
                if (state_1 === "break")
                    break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add)
                    add.push(dat, !!f);
                else
                    this.k[+(f == 2)].push(dat);
            }
            if (f & 2)
                return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c)
                err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */
    Unzip.prototype.register = function (decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}())));

var mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function (fn) { fn(); };
function unzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var files = {};
    var cbd = function (a, b) {
        mt(function () { cb(a, b); });
    };
    mt(function () { cbd = cb; });
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558) {
            cbd(err(13, 0, 1), null);
            return tAll;
        }
    }
    ;
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = b4(data, e - 12);
            z = b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = b4(data, ze + 32);
                o = b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function (i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function (e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                }
                else {
                    if (d)
                        files[fn] = d;
                    if (!--lft)
                        cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1)
                    cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    if (sc < 320000) {
                        try {
                            cbl(null, inflateSync(infl, new u8(su)));
                        }
                        catch (e) {
                            cbl(e, null);
                        }
                    }
                    else
                        term.push(inflate(infl, { size: su }, cbl));
                }
                else
                    cbl(err(14, 'unknown compression type ' + c_1, 1), null);
            }
            else
                cbl(null, null);
        };
        for (var i = 0; i < c; ++i) {
            _loop_3(i);
        }
    }
    else
        cbd(null, {});
    return tAll;
}
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558)
            err(13);
    }
    ;
    var c = b2(data, e + 8);
    if (!c)
        return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = b4(data, e - 12);
        z = b4(data, ze) == 0x6064B50;
        if (z) {
            c = b4(data, ze + 32);
            o = b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for (var i = 0; i < c; ++i) {
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2)
                files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8)
                files[fn] = inflateSync(data.subarray(b, b + sc), new u8(su));
            else
                err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

// EXTERNAL MODULE: ./node_modules/ts-ws-machine/lib/index.js
var lib = __webpack_require__(87929);
// EXTERNAL MODULE: ./node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(63496);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./src/reclaim-api/client.ts
var client = __webpack_require__(98585);
;// CONCATENATED MODULE: ./src/reclaim-api/adaptors/ws.ts
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];











var WS_BASE_URL = "wss://ws.app.reclaim-staging.com";
var WebsocketStatus;
(function(WebsocketStatus) {
    WebsocketStatus["Initial"] = "INITIAL";
    WebsocketStatus["Connecting"] = "CONNECTING";
    WebsocketStatus["Open"] = "OPEN";
    WebsocketStatus["Closed"] = "CLOSED";
    WebsocketStatus["Reconnecting"] = "RECONNECTING";
})(WebsocketStatus || (WebsocketStatus = {}));
var SubscriptionStatus;
(function(SubscriptionStatus) {
    SubscriptionStatus["Pending"] = "PENDING";
    SubscriptionStatus["Subscribed"] = "SUBSCRIBED";
    SubscriptionStatus["Unsubscribed"] = "UNSUBSCRIBED";
    SubscriptionStatus["Disconnected"] = "DISCONNECTED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/**
 * Websockets won't start for paths listed here.
 * 
 * THIS IS ONLY CHECKED ONCE. IF A USER NAVIGATES
 * WITHOUT RELOADING THE PAGE, THE WEBSOCKET WILL
 * NOT BE STARTED.
 */ // const NO_WS_PATHS: RegExp[] = [/^\/websites\//i];
var ReclaimWS = /*#__PURE__*/ function() {
    "use strict";
    function ReclaimWS(types) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, ReclaimWS);
        this.reconnecting = false;
        this.disconnectStart = 0;
        this.subscriptions = new Map();
        this.messageSubject = (0,wonka/* makeSubject */.nN)();
        this.statusSubject = (0,wonka/* makeSubject */.nN)();
        try {
            this.client = (0,lib.wsMachine)({
                url: "".concat(WS_BASE_URL).concat(types ? "?".concat(types.map(function(t, i) {
                    return "type=".concat(t);
                }).join("&")) : ""),
                pingTimeoutMillis: 1000 * 10,
                pongTimeoutMillis: 1000 * 10,
                pingMsg: '{"action": "$default"}',
                pongMsg: "",
                backoffFn: function(attempt) {
                    return attempt === 0 ? 0 : 1000 * 5;
                },
                onMessage: function(msg) {
                    try {
                        // If there is no data, this is likely a ping pong message, so just throw it away
                        if (!msg.data) {
                            return;
                        }
                        var envelope = JSON.parse(msg.data);
                        // Decompress (base64, gzip)
                        if (!!(envelope === null || envelope === void 0 ? void 0 : envelope.compressed)) {
                            try {
                                var compressed = Uint8Array.from(Buffer.from(envelope.data, "base64"));
                                var decompressed = decompressSync(compressed);
                                var data = new TextDecoder().decode(decompressed);
                                envelope.data = JSON.parse(data);
                            } catch (err) {
                                console.error("Failed to decompress ws data", err);
                                throw err;
                            }
                        }
                        _this.messageSubject.next(envelope);
                    } catch (e) {
                        console.error("Unhandled websocket message", msg, e);
                    }
                },
                onStateChange: function(param) {
                    var previous = param.previous, current = param.current;
                    if (previous.tag !== current.tag) console.log("Websocket state changed: ".concat(previous.tag, " -> ").concat(current.tag));
                    // reflect disconnected status
                    if (WebsocketStatus.Closed !== previous.tag && WebsocketStatus.Closed === current.tag) {
                        console.info("Websocket disconnected");
                        _this.subscriptions.forEach(function(subscription) {
                            subscription.status = SubscriptionStatus.Disconnected;
                        });
                        // Start a timer to see how long we are disconnected for
                        if (!_this.disconnectStart) {
                            _this.disconnectStart = Date.now();
                        }
                    }
                    // resubscribe after reconnect
                    if (WebsocketStatus.Open === previous.tag && WebsocketStatus.Open !== current.tag) _this.reconnecting = true;
                    else if (_this.reconnecting && WebsocketStatus.Open === current.tag) {
                        console.info("Websocket reconnected");
                        _this.reconnecting = false;
                        _this.resubscribe();
                    }
                    _this.statusSubject.next(current.tag);
                }
            });
            // if (!NO_WS_PATHS.every((rx) => !window.location.pathname.match(new RegExp(rx))))
            this.client.connect();
        } catch (e) {
            console.error("Error connecting websocket", e);
        }
        if (this.client) {
            // watch for subscription confirmations
            (0,wonka/* pipe */.zG)(this.source$, (0,wonka/* filter */.hX)(function(envelope) {
                return [
                    client/* SubscriptionType.NewSubscription */.Qe.NewSubscription
                ].includes(envelope.type);
            }), (0,wonka/* forEach */.Ed)(function(envelope) {
                var subscriptionId = envelope.subscriptionId;
                var type = envelope.data;
                var record = _this.subscriptions.get(subscriptionId);
                if (!record) {
                    console.warn("Unexpected new subscription, maybe from another session?", subscriptionId, type, record);
                    return;
                }
                if (type !== record.type) {
                    console.warn("New subscription type mismatch", type, record.type);
                }
                _this.subscriptions.set(subscriptionId, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, record), {
                    status: SubscriptionStatus.Subscribed
                }));
            }));
        }
    }
    var _proto = ReclaimWS.prototype;
    _proto.subscription$$ = function subscription$$(subscription) {
        var _this = this;
        var subscriptionId = this.getUid(subscription);
        return (0,wonka/* pipe */.zG)(this.messageSubject.source, (0,wonka/* filter */.hX)(function(envelope) {
            return envelope.subscriptionId === subscriptionId && ![
                client/* SubscriptionType.NewSubscription */.Qe.NewSubscription
            ].includes(envelope.type);
        }), (0,wonka/* onStart */.Hr)(function() {
            _this.subscribe(subscription);
        }), (0,wonka/* onEnd */.ok)(function() {
            _this.unsubscribe(subscription);
        }));
    };
    _proto.subscribe = function subscribe(subscription) {
        var subscriptionId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getUid(subscription);
        var record = this.subscriptions.get(subscriptionId);
        console.info("subscribe", subscriptionId, subscription);
        // If an active subscription already exists, register a new watcher
        if (!!record && ![
            SubscriptionStatus.Unsubscribed
        ].includes(record.status)) {
            var count = record.watchers.get(subscription) || 0;
            record.watchers.set(subscription, count + 1);
            // If the subscription is pending or connected, return
            if ([
                SubscriptionStatus.Pending,
                SubscriptionStatus.Subscribed
            ].includes(record.status)) return;
        }
        // If subscription got disconnected, resend the subscription
        if (!!record && SubscriptionStatus.Disconnected === record.status) console.info("Subscription disconnected, resubscribing", subscriptionId);
        this.subscriptions.set(subscriptionId, {
            watchers: (record === null || record === void 0 ? void 0 : record.watchers) || new Map([
                [
                    subscription,
                    1
                ]
            ]),
            type: subscription.subscriptionType,
            status: SubscriptionStatus.Pending
        });
        var payload = {
            action: "subscribe",
            subscriptionId: subscriptionId,
            subscription: subscription
        };
        this.send(payload);
    };
    _proto.unsubscribe = function unsubscribe(subscription) {
        var subscriptionId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getUid(subscription);
        var record = this.subscriptions.get(subscriptionId);
        console.info("unsubscribe", subscriptionId, subscription);
        if (!record) {
            console.warn("No matching subscription to unsubscribe", subscriptionId, Array.from(this.subscriptions.values()));
            return;
        }
        if (!record.watchers.has(subscription)) {
            console.warn("No matching watcher to unsubscribe", subscription, Array.from(record.watchers.values()));
            return;
        }
        // Decrement the watcher count and remove when there are no more watchers
        var count = record.watchers.get(subscription) || 0;
        if (count > 1) record.watchers.set(subscription, count - 1);
        else record.watchers.delete(subscription);
        // Return if there are more watchers
        if (!!record.watchers.size) return;
        // When all watchers unsubscribe, send an unsubscribe message
        var payload = {
            action: "unsubscribe",
            subscriptionId: subscriptionId
        };
        this.send(payload);
        this.subscriptions.delete(subscriptionId);
    };
    _proto.pushMessage = function pushMessage(data, type, subscriptionId) {
        this.messageSubject.next({
            data: data,
            type: type,
            compressed: false,
            subscriptionId: subscriptionId,
            notificationKeys: []
        });
    };
    _proto.send = function send(payload) {
        var _this = this;
        // Wait for connection to open before sending
        // TODO (IW): This should really be smarter
        (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
            (0,wonka/* fromValue */._A)(this.client.currentState().tag),
            this.status$
        ]), (0,wonka/* skipWhile */.nF)(function(status) {
            return status !== "OPEN";
        }), (0,wonka/* take */.qn)(1), (0,wonka/* forEach */.Ed)(function() {
            return _this.client.send(JSON.stringify(payload));
        }));
    };
    _proto.resubscribe = function resubscribe() {
        var _this = this;
        Array.from(this.subscriptions.entries()).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), subscriptionId = _param[0], meta = _param[1];
            Array.from(meta.watchers.entries()).forEach(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), sub = _param[0];
                return _this.subscribe(sub, subscriptionId);
            });
        });
    };
    _proto.getUid = function getUid(subscription) {
        return [
            subscription.subscriptionType,
            (0,objects/* hash */.vp)(subscription)
        ].join("_");
    };
    (0,_create_class/* default */.Z)(ReclaimWS, [
        {
            key: "source$",
            get: function get() {
                return this.messageSubject.source;
            }
        },
        {
            key: "status$",
            get: function get() {
                return this.statusSubject.source;
            }
        }
    ]);
    return ReclaimWS;
}();


/***/ }),

/***/ 98585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$q": function() { return /* binding */ ReclaimEventType; },
/* harmony export */   "DX": function() { return /* binding */ SyncCalendarType; },
/* harmony export */   "F7": function() { return /* binding */ NetworkError; },
/* harmony export */   "Kw": function() { return /* binding */ RecurringAssignmentType; },
/* harmony export */   "ME": function() { return /* binding */ AssistType; },
/* harmony export */   "N_": function() { return /* binding */ RecurringAssignmentAttendeeStatus; },
/* harmony export */   "O1": function() { return /* binding */ TaskInstanceStatus; },
/* harmony export */   "PI": function() { return /* binding */ EventResponseStatus; },
/* harmony export */   "Qe": function() { return /* binding */ SubscriptionType; },
/* harmony export */   "TN": function() { return /* binding */ OneOnOneInviteeEligibility; },
/* harmony export */   "Vy": function() { return /* binding */ Recurrence; },
/* harmony export */   "dr": function() { return /* binding */ EventColor; },
/* harmony export */   "eZ": function() { return /* binding */ ReclaimApi; },
/* harmony export */   "gt": function() { return /* binding */ ReclaimApiError; },
/* harmony export */   "hY": function() { return /* binding */ TaskStatus; },
/* harmony export */   "iN": function() { return /* binding */ EventSubType; },
/* harmony export */   "nN": function() { return /* binding */ SyncAllDayEvents; },
/* harmony export */   "op": function() { return /* binding */ SnoozeOption; },
/* harmony export */   "tw": function() { return /* binding */ EventType; }
/* harmony export */ });
/* unused harmony exports AnalyticsBucket, AnalyticsCategory, AnalyticsGroupingInterval, AnalyticsMetricName, AnalyticsResultsProcessingStatus, AnalyticsType, AnalyticsUnit, AsanaFormFieldType, AsanaWidgetFieldType, AsanaWidgetPillColor, AssistStatus, AutoLock, CalendarType, CalendarAccess, ClickUpStatusType, ConferenceBufferType, ConferenceType, ConnectedAccountType, CustomTimePolicyCategory, DateFieldOrder, DayOfWeek, DefenseAggression, DelayStart, EventStatus, EventStorageSettingsReadMode, EventStorageSettingsWriteMode, GCalConstantsAccessRole, HabitTemplateKey, IconType, IneligibilityReason, LinkInvalidationReason, LockState, MeetingLimitMeetingLimitPeriod, MeetingType, Month, PriorityLevel, PrioritySource, ProjectInclude, QuestType, ReclaimEdition, RecurringAssignmentStatus, RecurringEventUpdatePeriod, ReindexDirection, ResourceType, RsvpResponsePeriod, SchedulingLinkMemberStatus, SchedulingLinkRole, SchedulingPriority, SkipReason, SlackSettingsStatusSync, SurveyQuestionType, SyncTransparency, TaskAutoWorkflowType, TaskCategory, TimePolicyType, TimeSchemeIntegrationRuleAction, TimeSchemeIntegrationRuleServiceType, TimeSchemeIntegrationRuleType, UserMetadataCompanySize, UserMetadataUsecase, UserProfileDepartment, UserProfileGoal, UserProfileRole, UserTrait, ZoneOffsetTransitionRuleTimeDefinition, HEADER_BUILD_ID */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25892);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* tslint:disable */ /* eslint-disable */ /*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ## A custom template from the reclaim-api/api-client         ##
 * ## repo was used.                                            ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ 








var AnalyticsBucket;
(function(AnalyticsBucket) {
    AnalyticsBucket["DAYOFWEEK"] = "DAY_OF_WEEK";
    AnalyticsBucket["DATE"] = "DATE";
    AnalyticsBucket["WEEKOF"] = "WEEK_OF";
    AnalyticsBucket["ANALYTICSCATEGORY"] = "ANALYTICS_CATEGORY";
    AnalyticsBucket["EMAIL"] = "EMAIL";
    AnalyticsBucket["NUMBERRANGESTART"] = "NUMBER_RANGE_START";
    AnalyticsBucket["NUMBERCUMULATIVESTART"] = "NUMBER_CUMULATIVE_START";
    AnalyticsBucket["STRING"] = "STRING";
    AnalyticsBucket["RECLAIMEVENTTYPE"] = "RECLAIM_EVENT_TYPE";
})(AnalyticsBucket || (AnalyticsBucket = {}));
var AnalyticsCategory;
(function(AnalyticsCategory) {
    AnalyticsCategory["TEAMMEETING"] = "TEAM_MEETING";
    AnalyticsCategory["EXTERNALMEETING"] = "EXTERNAL_MEETING";
    AnalyticsCategory["ONEONONE"] = "ONE_ON_ONE";
    AnalyticsCategory["TRAVEL"] = "TRAVEL";
    AnalyticsCategory["BREAK"] = "BREAK";
    AnalyticsCategory["PERSONAL"] = "PERSONAL";
    AnalyticsCategory["VACATION"] = "VACATION";
    AnalyticsCategory["DEEPWORK"] = "DEEP_WORK";
    AnalyticsCategory["SHALLOWWORK"] = "SHALLOW_WORK";
})(AnalyticsCategory || (AnalyticsCategory = {}));
var AnalyticsGroupingInterval;
(function(AnalyticsGroupingInterval) {
    AnalyticsGroupingInterval["DAILY"] = "DAILY";
    AnalyticsGroupingInterval["WEEKLY"] = "WEEKLY";
})(AnalyticsGroupingInterval || (AnalyticsGroupingInterval = {}));
var AnalyticsMetricName;
(function(AnalyticsMetricName) {
    AnalyticsMetricName["DIAGNOSTICSEVENTCOUNT"] = "DIAGNOSTICS_EVENT_COUNT";
    AnalyticsMetricName["DIAGNOSTICSEVENTCOUNTBYTEAMMEMBER"] = "DIAGNOSTICS_EVENT_COUNT_BY_TEAM_MEMBER";
    AnalyticsMetricName["DIAGNOSTICSEVENTBUSYCOUNTBYTEAMMEMBER"] = "DIAGNOSTICS_EVENT_BUSY_COUNT_BY_TEAM_MEMBER";
    AnalyticsMetricName["DIAGNOSTICSMEETINGCOUNTBYTEAMMEMBER"] = "DIAGNOSTICS_MEETING_COUNT_BY_TEAM_MEMBER";
    AnalyticsMetricName["TIMEWITHPEOPLEDURATIONBYDATEBYPERSON"] = "TIME_WITH_PEOPLE_DURATION_BY_DATE_BY_PERSON";
    AnalyticsMetricName["TIMEWITHPEOPLEDURATIONBYPERSON"] = "TIME_WITH_PEOPLE_DURATION_BY_PERSON";
    AnalyticsMetricName["FOCUSTIMEDURATIONBYDATEBYTEAMMEMBER"] = "FOCUS_TIME_DURATION_BY_DATE_BY_TEAM_MEMBER";
    AnalyticsMetricName["FREETIMEDURATIONBYDATEBYTEAMMEMBER"] = "FREE_TIME_DURATION_BY_DATE_BY_TEAM_MEMBER";
    AnalyticsMetricName["MEETINGTIMEDURATIONBYDATEBYTEAMMEMBER"] = "MEETING_TIME_DURATION_BY_DATE_BY_TEAM_MEMBER";
    AnalyticsMetricName["TASKTIMEDURATIONBYDATEBYTEAMMEMBER"] = "TASK_TIME_DURATION_BY_DATE_BY_TEAM_MEMBER";
    AnalyticsMetricName["HABITTIMEDURATIONBYDATEBYTEAMMEMBER"] = "HABIT_TIME_DURATION_BY_DATE_BY_TEAM_MEMBER";
    AnalyticsMetricName["MEETINGTIMEPERCENTAGEBYDATEBYDURATIONRANGE"] = "MEETING_TIME_PERCENTAGE_BY_DATE_BY_DURATION_RANGE";
    AnalyticsMetricName["FOCUSDURATIONBYCATEGORYBYEVENTNAME"] = "FOCUS_DURATION_BY_CATEGORY_BY_EVENT_NAME";
    AnalyticsMetricName["SCHEDULINGLINKEVENTCOUNT"] = "SCHEDULING_LINK_EVENT_COUNT";
    AnalyticsMetricName["RECLAIMSCHEDULEDEVENTCOUNT"] = "RECLAIM_SCHEDULED_EVENT_COUNT";
    AnalyticsMetricName["DURATIONBYCATEGORY"] = "DURATION_BY_CATEGORY";
    AnalyticsMetricName["RECLAIMWORKDURATIONBYDATEBYASSIGNMENTTYPE"] = "RECLAIM_WORK_DURATION_BY_DATE_BY_ASSIGNMENT_TYPE";
    AnalyticsMetricName["DURATIONBYDATEBYCATEGORY"] = "DURATION_BY_DATE_BY_CATEGORY";
    AnalyticsMetricName["PERSONALHABITTIMEDURATION"] = "PERSONAL_HABIT_TIME_DURATION";
    AnalyticsMetricName["VACATIONTIMEDURATION"] = "VACATION_TIME_DURATION";
    AnalyticsMetricName["OUTSIDEWORKTIMEDURATION"] = "OUTSIDE_WORK_TIME_DURATION";
    AnalyticsMetricName["RECLAIMEDTIMEDURATION"] = "RECLAIMED_TIME_DURATION";
    AnalyticsMetricName["DECOMPRESSIONTIMEDURATION"] = "DECOMPRESSION_TIME_DURATION";
    AnalyticsMetricName["TRAVELTIMEDURATION"] = "TRAVEL_TIME_DURATION";
    AnalyticsMetricName["MEETINGTIMEDURATIONBYDAYOFWEEK"] = "MEETING_TIME_DURATION_BY_DAY_OF_WEEK";
    AnalyticsMetricName["FOCUSTIMEDURATIONBYDAYOFWEEK"] = "FOCUS_TIME_DURATION_BY_DAY_OF_WEEK";
    AnalyticsMetricName["WORKHABITSANDTASKSDURATIONBYDATEBYNAME"] = "WORK_HABITS_AND_TASKS_DURATION_BY_DATE_BY_NAME";
    AnalyticsMetricName["PERSONALHABITSANDTASKSDURATIONBYDATEBYNAME"] = "PERSONAL_HABITS_AND_TASKS_DURATION_BY_DATE_BY_NAME";
    AnalyticsMetricName["PERSONALTIMEDURATION"] = "PERSONAL_TIME_DURATION";
    AnalyticsMetricName["LARGEMEETINGSCOUNT"] = "LARGE_MEETINGS_COUNT";
    AnalyticsMetricName["MEETINGSDECLINEDCOUNT"] = "MEETINGS_DECLINED_COUNT";
    AnalyticsMetricName["MEETINGCALLOUTGROUP"] = "MEETING_CALLOUT_GROUP";
    AnalyticsMetricName["WORKLIFECALLOUTGROUP"] = "WORK_LIFE_CALLOUT_GROUP";
    AnalyticsMetricName["ROICALLOUTGROUP"] = "ROI_CALLOUT_GROUP";
})(AnalyticsMetricName || (AnalyticsMetricName = {}));
var AnalyticsResultsProcessingStatus;
(function(AnalyticsResultsProcessingStatus) {
    AnalyticsResultsProcessingStatus["PENDING"] = "PENDING";
    AnalyticsResultsProcessingStatus["COMPLETED"] = "COMPLETED";
    AnalyticsResultsProcessingStatus["ERROR"] = "ERROR";
})(AnalyticsResultsProcessingStatus || (AnalyticsResultsProcessingStatus = {}));
var AnalyticsType;
(function(AnalyticsType) {
    AnalyticsType["IntegerValue"] = "integerValue";
    AnalyticsType["CountByString"] = "countByString";
    AnalyticsType["DurationSummary"] = "durationSummary";
    AnalyticsType["DurationByDateByCategory"] = "durationByDateByCategory";
    AnalyticsType["DurationByCategory"] = "durationByCategory";
    AnalyticsType["DurationByDate"] = "durationByDate";
    AnalyticsType["DurationByString"] = "durationByString";
    AnalyticsType["DurationByDayOfWeek"] = "durationByDayOfWeek";
    AnalyticsType["DurationByDateByString"] = "durationByDateByString";
    AnalyticsType["DurationByRangeByDate"] = "durationByRangeByDate";
    AnalyticsType["DurationByCategoryByString"] = "durationByCategoryByString";
    AnalyticsType["CalloutGroup"] = "calloutGroup";
})(AnalyticsType || (AnalyticsType = {}));
var AnalyticsUnit;
(function(AnalyticsUnit) {
    AnalyticsUnit["COUNT"] = "COUNT";
    AnalyticsUnit["DURATIONMINUTES"] = "DURATION_MINUTES";
    AnalyticsUnit["PERCENTAGE"] = "PERCENTAGE";
})(AnalyticsUnit || (AnalyticsUnit = {}));
var AsanaFormFieldType;
(function(AsanaFormFieldType) {
    AsanaFormFieldType["SingleLineText"] = "single_line_text";
    AsanaFormFieldType["RichText"] = "rich_text";
    AsanaFormFieldType["Typeahead"] = "typeahead";
    AsanaFormFieldType["Checkboxes"] = "checkboxes";
    AsanaFormFieldType["RadioButton"] = "radio_button";
    AsanaFormFieldType["Date"] = "date";
    AsanaFormFieldType["Datetime"] = "datetime";
    AsanaFormFieldType["StaticText"] = "static_text";
    AsanaFormFieldType["Dropdown"] = "dropdown";
})(AsanaFormFieldType || (AsanaFormFieldType = {}));
var AsanaWidgetFieldType;
(function(AsanaWidgetFieldType) {
    AsanaWidgetFieldType["DatetimeWithIcon"] = "datetime_with_icon";
    AsanaWidgetFieldType["Pill"] = "pill";
    AsanaWidgetFieldType["TextWithIcon"] = "text_with_icon";
})(AsanaWidgetFieldType || (AsanaWidgetFieldType = {}));
var AsanaWidgetPillColor;
(function(AsanaWidgetPillColor) {
    AsanaWidgetPillColor["None"] = "none";
    AsanaWidgetPillColor["Red"] = "red";
    AsanaWidgetPillColor["Orange"] = "orange";
    AsanaWidgetPillColor["YellowOrange"] = "yellow_orange";
    AsanaWidgetPillColor["Yellow"] = "yellow";
    AsanaWidgetPillColor["YellowGreen"] = "yellow_green";
    AsanaWidgetPillColor["Green"] = "green";
    AsanaWidgetPillColor["BlueGreen"] = "blue_green";
    AsanaWidgetPillColor["Aqua"] = "aqua";
    AsanaWidgetPillColor["Blue"] = "blue";
    AsanaWidgetPillColor["Indigo"] = "indigo";
    AsanaWidgetPillColor["Purple"] = "purple";
    AsanaWidgetPillColor["Magenta"] = "magenta";
    AsanaWidgetPillColor["HotPink"] = "hot_pink";
    AsanaWidgetPillColor["Pink"] = "pink";
    AsanaWidgetPillColor["CoolGray"] = "cool_gray";
})(AsanaWidgetPillColor || (AsanaWidgetPillColor = {}));
var AssistStatus;
(function(AssistStatus) {
    AssistStatus["CONTROLLED"] = "CONTROLLED";
    AssistStatus["RELEASED"] = "RELEASED";
    AssistStatus["ARCHIVED"] = "ARCHIVED";
})(AssistStatus || (AssistStatus = {}));
var AssistType;
(function(AssistType) {
    AssistType["TASK"] = "TASK";
    AssistType["CUSTOMDAILY"] = "CUSTOM_DAILY";
    AssistType["CATCHUPAM"] = "CATCHUP_AM";
    AssistType["CATCHUPPM"] = "CATCHUP_PM";
    AssistType["LUNCH"] = "LUNCH";
    AssistType["FOCUS"] = "FOCUS";
    AssistType["TRAVELPRE"] = "TRAVEL_PRE";
    AssistType["TRAVELPOST"] = "TRAVEL_POST";
    AssistType["CONBUF"] = "CONBUF";
    AssistType["SMARTHABIT"] = "SMART_HABIT";
    AssistType["SMARTMEETING"] = "SMART_MEETING";
})(AssistType || (AssistType = {}));
var AutoLock;
(function(AutoLock) {
    AutoLock["OFF"] = "OFF";
    AutoLock["SAMEDAY"] = "SAME_DAY";
    AutoLock["SAMEWEEK"] = "SAME_WEEK";
    AutoLock["TOMORROW"] = "TOMORROW";
    AutoLock["ROLLING3DAYS"] = "ROLLING_3_DAYS";
})(AutoLock || (AutoLock = {}));
var CalendarType;
(function(CalendarType) {
    CalendarType["PRIMARY"] = "PRIMARY";
    CalendarType["SHADOW"] = "SHADOW";
    CalendarType["PERSONAL"] = "PERSONAL";
    CalendarType["PRIORITY"] = "PRIORITY";
    CalendarType["PROJECT"] = "PROJECT";
})(CalendarType || (CalendarType = {}));
var CalendarAccess;
(function(CalendarAccess) {
    CalendarAccess["NONE"] = "NONE";
    CalendarAccess["SETTINGSONLY"] = "SETTINGS_ONLY";
    CalendarAccess["READ"] = "READ";
    CalendarAccess["WRITE"] = "WRITE";
    CalendarAccess["SUPER"] = "SUPER";
})(CalendarAccess || (CalendarAccess = {}));
var ClickUpStatusType;
(function(ClickUpStatusType) {
    ClickUpStatusType["Open"] = "open";
    ClickUpStatusType["Done"] = "done";
    ClickUpStatusType["Closed"] = "closed";
    ClickUpStatusType["Custom"] = "custom";
    ClickUpStatusType["Unstarted"] = "unstarted";
    ClickUpStatusType["Active"] = "active";
})(ClickUpStatusType || (ClickUpStatusType = {}));
var ConferenceBufferType;
(function(ConferenceBufferType) {
    ConferenceBufferType["ALLMEETINGS"] = "ALL_MEETINGS";
    ConferenceBufferType["CONFERENCEMEETINGS"] = "CONFERENCE_MEETINGS";
})(ConferenceBufferType || (ConferenceBufferType = {}));
var ConferenceType;
(function(ConferenceType) {
    ConferenceType["GOOGLEMEET"] = "GOOGLE_MEET";
    ConferenceType["ZOOM"] = "ZOOM";
    ConferenceType["CUSTOM"] = "CUSTOM";
    ConferenceType["GENERICLOCATION"] = "GENERIC_LOCATION";
    ConferenceType["PHYSICALADDRESS"] = "PHYSICAL_ADDRESS";
    ConferenceType["PHONENUMBER"] = "PHONE_NUMBER";
})(ConferenceType || (ConferenceType = {}));
var ConnectedAccountType;
(function(ConnectedAccountType) {
    ConnectedAccountType["GOOGLE"] = "GOOGLE";
})(ConnectedAccountType || (ConnectedAccountType = {}));
var CustomTimePolicyCategory;
(function(CustomTimePolicyCategory) {
    CustomTimePolicyCategory["WORK"] = "WORK";
    CustomTimePolicyCategory["PERSONAL"] = "PERSONAL";
})(CustomTimePolicyCategory || (CustomTimePolicyCategory = {}));
var DateFieldOrder;
(function(DateFieldOrder) {
    DateFieldOrder["MDY"] = "MDY";
    DateFieldOrder["DMY"] = "DMY";
    DateFieldOrder["YMD"] = "YMD";
})(DateFieldOrder || (DateFieldOrder = {}));
var DayOfWeek;
(function(DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
var DefenseAggression;
(function(DefenseAggression) {
    DefenseAggression["NONE"] = "NONE";
    DefenseAggression["LOW"] = "LOW";
    DefenseAggression["DEFAULT"] = "DEFAULT";
    DefenseAggression["HIGH"] = "HIGH";
    DefenseAggression["MAX"] = "MAX";
})(DefenseAggression || (DefenseAggression = {}));
var DelayStart;
(function(DelayStart) {
    DelayStart["NODELAY"] = "NO_DELAY";
    DelayStart["FROMNOWMINUTES"] = "FROM_NOW_MINUTES";
    DelayStart["FROMNOWHOURS"] = "FROM_NOW_HOURS";
    DelayStart["FROMNOWDAYS"] = "FROM_NOW_DAYS";
    DelayStart["FROMNOWSTARTOFNEXTDAY"] = "FROM_NOW_START_OF_NEXT_DAY";
    DelayStart["FROMNOWSTARTOFNEXTWEEK"] = "FROM_NOW_START_OF_NEXT_WEEK";
})(DelayStart || (DelayStart = {}));
var EventColor;
(function(EventColor) {
    EventColor["NONE"] = "NONE";
    EventColor["LAVENDER"] = "LAVENDER";
    EventColor["SAGE"] = "SAGE";
    EventColor["GRAPE"] = "GRAPE";
    EventColor["FLAMINGO"] = "FLAMINGO";
    EventColor["BANANA"] = "BANANA";
    EventColor["TANGERINE"] = "TANGERINE";
    EventColor["PEACOCK"] = "PEACOCK";
    EventColor["GRAPHITE"] = "GRAPHITE";
    EventColor["BLUEBERRY"] = "BLUEBERRY";
    EventColor["BASIL"] = "BASIL";
    EventColor["TOMATO"] = "TOMATO";
})(EventColor || (EventColor = {}));
var EventResponseStatus;
(function(EventResponseStatus) {
    EventResponseStatus["None"] = "None";
    EventResponseStatus["Organizer"] = "Organizer";
    EventResponseStatus["Accepted"] = "Accepted";
    EventResponseStatus["Declined"] = "Declined";
    EventResponseStatus["TentativelyAccepted"] = "TentativelyAccepted";
    EventResponseStatus["NotResponded"] = "NotResponded";
})(EventResponseStatus || (EventResponseStatus = {}));
var EventStatus;
(function(EventStatus) {
    EventStatus["PUBLISHED"] = "PUBLISHED";
    EventStatus["CANCELLED"] = "CANCELLED";
})(EventStatus || (EventStatus = {}));
var EventStorageSettingsReadMode;
(function(EventStorageSettingsReadMode) {
    EventStorageSettingsReadMode["LEGACY"] = "LEGACY";
    EventStorageSettingsReadMode["CURRENT"] = "CURRENT";
})(EventStorageSettingsReadMode || (EventStorageSettingsReadMode = {}));
var EventStorageSettingsWriteMode;
(function(EventStorageSettingsWriteMode) {
    EventStorageSettingsWriteMode["LEGACY"] = "LEGACY";
    EventStorageSettingsWriteMode["CURRENT"] = "CURRENT";
    EventStorageSettingsWriteMode["BOTH"] = "BOTH";
})(EventStorageSettingsWriteMode || (EventStorageSettingsWriteMode = {}));
var EventSubType;
(function(EventSubType) {
    EventSubType["ONEONONE"] = "ONE_ON_ONE";
    EventSubType["STAFFMEETING"] = "STAFF_MEETING";
    EventSubType["OPREVIEW"] = "OP_REVIEW";
    EventSubType["EXTERNAL"] = "EXTERNAL";
    EventSubType["IDEATION"] = "IDEATION";
    EventSubType["FOCUS"] = "FOCUS";
    EventSubType["PRODUCTIVITY"] = "PRODUCTIVITY";
    EventSubType["TRAVEL"] = "TRAVEL";
    EventSubType["FLIGHT"] = "FLIGHT";
    EventSubType["TRAIN"] = "TRAIN";
    EventSubType["RECLAIM"] = "RECLAIM";
    EventSubType["VACATION"] = "VACATION";
    EventSubType["HEALTH"] = "HEALTH";
    EventSubType["ERRAND"] = "ERRAND";
    EventSubType["OTHERPERSONAL"] = "OTHER_PERSONAL";
    EventSubType["UNKNOWN"] = "UNKNOWN";
})(EventSubType || (EventSubType = {}));
var EventType;
(function(EventType) {
    EventType["MEETING"] = "MEETING";
    EventType["WORK"] = "WORK";
    EventType["LOGISTICS"] = "LOGISTICS";
    EventType["PERSONAL"] = "PERSONAL";
})(EventType || (EventType = {}));
var GCalConstantsAccessRole;
(function(GCalConstantsAccessRole) {
    GCalConstantsAccessRole["FreeBusyReader"] = "freeBusyReader";
    GCalConstantsAccessRole["Reader"] = "reader";
    GCalConstantsAccessRole["Owner"] = "owner";
    GCalConstantsAccessRole["Writer"] = "writer";
    GCalConstantsAccessRole["None"] = "none";
})(GCalConstantsAccessRole || (GCalConstantsAccessRole = {}));
var HabitTemplateKey;
(function(HabitTemplateKey) {
    HabitTemplateKey["LUNCH"] = "LUNCH";
    HabitTemplateKey["MEDITATION"] = "MEDITATION";
    HabitTemplateKey["TAKEAWALK"] = "TAKE_A_WALK";
    HabitTemplateKey["READING"] = "READING";
    HabitTemplateKey["WRITING"] = "WRITING";
    HabitTemplateKey["MORNINGCATCHUP"] = "MORNING_CATCHUP";
    HabitTemplateKey["AFTERNOONCATCHUP"] = "AFTERNOON_CATCHUP";
    HabitTemplateKey["MONTHLYMETRICSREVIEW"] = "MONTHLY_METRICS_REVIEW";
    HabitTemplateKey["SPRINTPLANNING"] = "SPRINT_PLANNING";
    HabitTemplateKey["CUSTOMERFEEDBACKREVIEW"] = "CUSTOMER_FEEDBACK_REVIEW";
    HabitTemplateKey["WEEKLYSTATUSREPORT"] = "WEEKLY_STATUS_REPORT";
    HabitTemplateKey["PRODUCTBACKLOGREVIEW"] = "PRODUCT_BACKLOG_REVIEW";
    HabitTemplateKey["PRODUCTREQUIREMENTS"] = "PRODUCT_REQUIREMENTS";
    HabitTemplateKey["RETROSPECTIVEPLANNING"] = "RETROSPECTIVE_PLANNING";
    HabitTemplateKey["PRODUCTLAUNCHPLANNING"] = "PRODUCT_LAUNCH_PLANNING";
    HabitTemplateKey["FOCUSTIME"] = "FOCUS_TIME";
    HabitTemplateKey["DEBUGGING"] = "DEBUGGING";
    HabitTemplateKey["FEATUREBACKLOG"] = "FEATURE_BACKLOG";
    HabitTemplateKey["TESTING"] = "TESTING";
    HabitTemplateKey["CUSTOMERRESEARCH"] = "CUSTOMER_RESEARCH";
    HabitTemplateKey["RECRUITMENT"] = "RECRUITMENT";
    HabitTemplateKey["QUARTERLYRESEARCHREPORT"] = "QUARTERLY_RESEARCH_REPORT";
    HabitTemplateKey["STRATEGICPLANNING"] = "STRATEGIC_PLANNING";
    HabitTemplateKey["DEPLOY"] = "DEPLOY";
    HabitTemplateKey["PRODUCTDOCUMENTATION"] = "PRODUCT_DOCUMENTATION";
    HabitTemplateKey["CODING"] = "CODING";
    HabitTemplateKey["ARCHITECTUREDESIGNREVIEW"] = "ARCHITECTURE_DESIGN_REVIEW";
    HabitTemplateKey["CODEREVIEW"] = "CODE_REVIEW";
    HabitTemplateKey["TRAINING"] = "TRAINING";
    HabitTemplateKey["TROUBLESHOOTESCALATEDISSUES"] = "TROUBLESHOOT_ESCALATED_ISSUES";
    HabitTemplateKey["REVIEWPRODUCTUPDATES"] = "REVIEW_PRODUCT_UPDATES";
    HabitTemplateKey["COMMUNITYENGAGEMENT"] = "COMMUNITY_ENGAGEMENT";
    HabitTemplateKey["SUPPORTTIME"] = "SUPPORT_TIME";
    HabitTemplateKey["SHARECUSTOMERFEEDBACK"] = "SHARE_CUSTOMER_FEEDBACK";
    HabitTemplateKey["SNIPPETTEMPLATEUPDATES"] = "SNIPPET_TEMPLATE_UPDATES";
    HabitTemplateKey["ADVERTISINGREVIEW"] = "ADVERTISING_REVIEW";
    HabitTemplateKey["COMPETITORRESEARCH"] = "COMPETITOR_RESEARCH";
    HabitTemplateKey["PRPLANNING"] = "PR_PLANNING";
    HabitTemplateKey["SEOREVIEW"] = "SEO_REVIEW";
    HabitTemplateKey["SOCIALMEDIAUPDATES"] = "SOCIAL_MEDIA_UPDATES";
    HabitTemplateKey["NEWSLETTER"] = "NEWSLETTER";
    HabitTemplateKey["BLOGWRITING"] = "BLOG_WRITING";
    HabitTemplateKey["WEBINARPREP"] = "WEBINAR_PREP";
    HabitTemplateKey["EMAILINBOUNDLEADS"] = "EMAIL_INBOUND_LEADS";
    HabitTemplateKey["KEYACCOUNTCHECKINS"] = "KEY_ACCOUNT_CHECK_INS";
    HabitTemplateKey["SALESPIPELINEREVIEW"] = "SALES_PIPELINE_REVIEW";
    HabitTemplateKey["WRITEPROPOSAL"] = "WRITE_PROPOSAL";
    HabitTemplateKey["CRMUPDATES"] = "CRM_UPDATES";
    HabitTemplateKey["PROSPECTING"] = "PROSPECTING";
    HabitTemplateKey["UPDATESALESPRESENTATIONS"] = "UPDATE_SALES_PRESENTATIONS";
    HabitTemplateKey["OUTBOUNDCALLS"] = "OUTBOUND_CALLS";
    HabitTemplateKey["WEEKLYDESIGNREVIEW"] = "WEEKLY_DESIGN_REVIEW";
    HabitTemplateKey["FREEDESIGNHOUR"] = "FREE_DESIGN_HOUR";
    HabitTemplateKey["USERRESEARCH"] = "USER_RESEARCH";
    HabitTemplateKey["DESIGNUSERTESTS"] = "DESIGN_USER_TESTS";
    HabitTemplateKey["DAILYDESIGNTIME"] = "DAILY_DESIGN_TIME";
    HabitTemplateKey["WIREFRAMES"] = "WIREFRAMES";
    HabitTemplateKey["USERFLOWDESIGN"] = "USER_FLOW_DESIGN";
    HabitTemplateKey["EMPLOYEERELATIONSREVIEW"] = "EMPLOYEE_RELATIONS_REVIEW";
    HabitTemplateKey["PTOREVIEW"] = "PTO_REVIEW";
    HabitTemplateKey["PRODUCTIVITYREVIEW"] = "PRODUCTIVITY_REVIEW";
    HabitTemplateKey["DEIREVIEW"] = "DEI_REVIEW";
    HabitTemplateKey["PROCESSBACKGROUNDCHECKS"] = "PROCESS_BACKGROUND_CHECKS";
    HabitTemplateKey["QUARTERLYTRAININGPREP"] = "QUARTERLY_TRAINING_PREP";
    HabitTemplateKey["APPLICANTREVIEW"] = "APPLICANT_REVIEW";
    HabitTemplateKey["EMPLOYEERECOGNITION"] = "EMPLOYEE_RECOGNITION";
    HabitTemplateKey["PAYROLLUPDATES"] = "PAYROLL_UPDATES";
    HabitTemplateKey["INTERVIEWPREP"] = "INTERVIEW_PREP";
    HabitTemplateKey["EMPLOYEESURVEYS"] = "EMPLOYEE_SURVEYS";
    HabitTemplateKey["UPDATEJOBPOSTINGS"] = "UPDATE_JOB_POSTINGS";
    HabitTemplateKey["EMPLOYEENEWSLETTERPREP"] = "EMPLOYEE_NEWSLETTER_PREP";
    HabitTemplateKey["REVIEWDEPARTMENTREQUIREMENTS"] = "REVIEW_DEPARTMENT_REQUIREMENTS";
    HabitTemplateKey["SECURITYREVIEWS"] = "SECURITY_REVIEWS";
    HabitTemplateKey["TEAMMEETINGPREP"] = "TEAM_MEETING_PREP";
    HabitTemplateKey["LEGALCOMPLIANCEREVIEW"] = "LEGAL_COMPLIANCE_REVIEW";
    HabitTemplateKey["VENDORREVIEWS"] = "VENDOR_REVIEWS";
    HabitTemplateKey["BUSINESSPERFORMANCEREVIEW"] = "BUSINESS_PERFORMANCE_REVIEW";
    HabitTemplateKey["REVIEWPROCUREMENTREQUESTS"] = "REVIEW_PROCUREMENT_REQUESTS";
    HabitTemplateKey["REVIEWSUPPLIERAGREEMENTS"] = "REVIEW_SUPPLIER_AGREEMENTS";
    HabitTemplateKey["UPDATEINTERNALPOLICIES"] = "UPDATE_INTERNAL_POLICIES";
    HabitTemplateKey["ANALYZETECHNOLOGYUSAGE"] = "ANALYZE_TECHNOLOGY_USAGE";
    HabitTemplateKey["REVIEWTEAMWORKFLOWS"] = "REVIEW_TEAM_WORKFLOWS";
    HabitTemplateKey["UPDATEOPERATIONALPROCEDURES"] = "UPDATE_OPERATIONAL_PROCEDURES";
    HabitTemplateKey["REVIEWFINANCIALREPORTS"] = "REVIEW_FINANCIAL_REPORTS";
    HabitTemplateKey["INVESTORUPDATE"] = "INVESTOR_UPDATE";
    HabitTemplateKey["MONTHENDFINANCIALSTATEMENTS"] = "MONTH_END_FINANCIAL_STATEMENTS";
    HabitTemplateKey["REVIEWFORECASTREPORTS"] = "REVIEW_FORECAST_REPORTS";
    HabitTemplateKey["BUDGETPLANNING"] = "BUDGET_PLANNING";
    HabitTemplateKey["REVIEWMONTHLYREPORTS"] = "REVIEW_MONTHLY_REPORTS";
    HabitTemplateKey["REVIEWEXPENSEREPORT"] = "REVIEW_EXPENSE_REPORT";
    HabitTemplateKey["PREPAREMONTHLYREPORTS"] = "PREPARE_MONTHLY_REPORTS";
    HabitTemplateKey["UPDATEJOURNALENTRIES"] = "UPDATE_JOURNAL_ENTRIES";
    HabitTemplateKey["REVIEWTIMESHEETS"] = "REVIEW_TIME_SHEETS";
    HabitTemplateKey["PROCESSPAYMENTS"] = "PROCESS_PAYMENTS";
    HabitTemplateKey["REVIEWACCOUNTSPAYABLE"] = "REVIEW_ACCOUNTS_PAYABLE";
    HabitTemplateKey["TAXPLANNING"] = "TAX_PLANNING";
    HabitTemplateKey["WEEKDAYSTUDY"] = "WEEKDAY_STUDY";
    HabitTemplateKey["GROCERYSHOPPING"] = "GROCERY_SHOPPING";
    HabitTemplateKey["LAUNDRY"] = "LAUNDRY";
    HabitTemplateKey["INTERNSHIPAPPLICATIONS"] = "INTERNSHIP_APPLICATIONS";
    HabitTemplateKey["WEEKENDSTUDY"] = "WEEKEND_STUDY";
    HabitTemplateKey["EXERCISE"] = "EXERCISE";
    HabitTemplateKey["CLEANHOUSE"] = "CLEAN_HOUSE";
    HabitTemplateKey["CALLFAMILY"] = "CALL_FAMILY";
    HabitTemplateKey["WORKONTHESIS"] = "WORK_ON_THESIS";
})(HabitTemplateKey || (HabitTemplateKey = {}));
var IconType;
(function(IconType) {
    IconType["LIGHT"] = "LIGHT";
    IconType["COFFEE"] = "COFFEE";
    IconType["BOLT"] = "BOLT";
    IconType["COMMENT"] = "COMMENT";
    IconType["STAR"] = "STAR";
    IconType["AIRPLANE"] = "AIRPLANE";
    IconType["TWINKLE"] = "TWINKLE";
    IconType["COMPASS"] = "COMPASS";
    IconType["SUN"] = "SUN";
    IconType["SMILE"] = "SMILE";
})(IconType || (IconType = {}));
var IneligibilityReason;
(function(IneligibilityReason) {
    IneligibilityReason["MAINACCOUNTPRIMARY"] = "MAIN_ACCOUNT_PRIMARY";
    IneligibilityReason["SYNCEDALREADY"] = "SYNCED_ALREADY";
    IneligibilityReason["FREEBUSYONLY"] = "FREE_BUSY_ONLY";
})(IneligibilityReason || (IneligibilityReason = {}));
var LinkInvalidationReason;
(function(LinkInvalidationReason) {
    LinkInvalidationReason["ACCESSLOST"] = "ACCESS_LOST";
    LinkInvalidationReason["USERINITIATED"] = "USER_INITIATED";
})(LinkInvalidationReason || (LinkInvalidationReason = {}));
var LockState;
(function(LockState) {
    LockState["MANUALLYLOCKED"] = "MANUALLY_LOCKED";
    LockState["ADJUSTED"] = "ADJUSTED";
    LockState["UPCOMINGWINDOW"] = "UPCOMING_WINDOW";
    LockState["MANUALLYUNLOCKED"] = "MANUALLY_UNLOCKED";
    LockState["DELETED"] = "DELETED";
    LockState["DECLINED"] = "DECLINED";
    LockState["INTHEPAST"] = "IN_THE_PAST";
})(LockState || (LockState = {}));
var MeetingLimitMeetingLimitPeriod;
(function(MeetingLimitMeetingLimitPeriod) {
    MeetingLimitMeetingLimitPeriod["DAILY"] = "DAILY";
    MeetingLimitMeetingLimitPeriod["WEEKLY"] = "WEEKLY";
})(MeetingLimitMeetingLimitPeriod || (MeetingLimitMeetingLimitPeriod = {}));
var MeetingType;
(function(MeetingType) {
    MeetingType["DIRECT11"] = "DIRECT_11";
    MeetingType["PEER11"] = "PEER_11";
    MeetingType["SKIP11"] = "SKIP_11";
    MeetingType["XFUNC11"] = "XFUNC_11";
    MeetingType["OTHER11"] = "OTHER_11";
    MeetingType["TEAM"] = "TEAM";
    MeetingType["XFUNCTEAM"] = "XFUNC_TEAM";
    MeetingType["EXEC"] = "EXEC";
    MeetingType["SKIPTEAM"] = "SKIP_TEAM";
    MeetingType["ALLHANDS"] = "ALL_HANDS";
    MeetingType["ONBOARDINGTRAINING"] = "ONBOARDING_TRAINING";
    MeetingType["COMPANYEVENT"] = "COMPANY_EVENT";
    MeetingType["BOARDMEETING"] = "BOARD_MEETING";
    MeetingType["OTHERSTAFF"] = "OTHER_STAFF";
    MeetingType["DEALREVIEW"] = "DEAL_REVIEW";
    MeetingType["EXECUTIONREVIEW"] = "EXECUTION_REVIEW";
    MeetingType["DEMO"] = "DEMO";
    MeetingType["PLANNINGMEETING"] = "PLANNING_MEETING";
    MeetingType["RETRO"] = "RETRO";
    MeetingType["EMERGENCY"] = "EMERGENCY";
    MeetingType["PEOPLEREVIEW"] = "PEOPLE_REVIEW";
    MeetingType["OTHEROP"] = "OTHER_OP";
    MeetingType["ROADMAP"] = "ROADMAP";
    MeetingType["CUSTMEETING"] = "CUST_MEETING";
    MeetingType["CUSTRESEARCH"] = "CUST_RESEARCH";
    MeetingType["CUSTURGENT"] = "CUST_URGENT";
    MeetingType["RECRUITSCREEN"] = "RECRUIT_SCREEN";
    MeetingType["OTHEREXTERNAL"] = "OTHER_EXTERNAL";
    MeetingType["DESIGNBRAIN"] = "DESIGN_BRAIN";
    MeetingType["TECHREVIEW"] = "TECH_REVIEW";
    MeetingType["KICKOFF"] = "KICKOFF";
    MeetingType["REQBRAIN"] = "REQ_BRAIN";
    MeetingType["OTHERIDEATION"] = "OTHER_IDEATION";
    MeetingType["UNKNOWN"] = "UNKNOWN";
})(MeetingType || (MeetingType = {}));
var Month;
(function(Month) {
    Month["JANUARY"] = "JANUARY";
    Month["FEBRUARY"] = "FEBRUARY";
    Month["MARCH"] = "MARCH";
    Month["APRIL"] = "APRIL";
    Month["MAY"] = "MAY";
    Month["JUNE"] = "JUNE";
    Month["JULY"] = "JULY";
    Month["AUGUST"] = "AUGUST";
    Month["SEPTEMBER"] = "SEPTEMBER";
    Month["OCTOBER"] = "OCTOBER";
    Month["NOVEMBER"] = "NOVEMBER";
    Month["DECEMBER"] = "DECEMBER";
})(Month || (Month = {}));
var OneOnOneInviteeEligibility;
(function(OneOnOneInviteeEligibility) {
    OneOnOneInviteeEligibility["RECLAIMUSER"] = "RECLAIM_USER";
    OneOnOneInviteeEligibility["NONRECLAIMUSERWCALENDARACCESS"] = "NON_RECLAIM_USER_W_CALENDAR_ACCESS";
    OneOnOneInviteeEligibility["NONRECLAIMUSER"] = "NON_RECLAIM_USER";
})(OneOnOneInviteeEligibility || (OneOnOneInviteeEligibility = {}));
var PriorityLevel;
(function(PriorityLevel) {
    PriorityLevel["P1"] = "P1";
    PriorityLevel["P2"] = "P2";
    PriorityLevel["P3"] = "P3";
    PriorityLevel["P4"] = "P4";
    PriorityLevel["PRIORITIZE"] = "PRIORITIZE";
    PriorityLevel["DEFAULT"] = "DEFAULT";
})(PriorityLevel || (PriorityLevel = {}));
var PrioritySource;
(function(PrioritySource) {
    PrioritySource["MANUAL"] = "MANUAL";
    PrioritySource["AI"] = "AI";
    PrioritySource["RULES"] = "RULES";
})(PrioritySource || (PrioritySource = {}));
var ProjectInclude;
(function(ProjectInclude) {
    ProjectInclude["ID"] = "ID";
    ProjectInclude["FULL"] = "FULL";
})(ProjectInclude || (ProjectInclude = {}));
var QuestType;
(function(QuestType) {
    QuestType["WELCOMETORECLAIM"] = "WELCOME_TO_RECLAIM";
    QuestType["SETAVAILABILITY"] = "SET_AVAILABILITY";
    QuestType["PRIORITIZATION"] = "PRIORITIZATION";
    QuestType["SYNCCALENDAR"] = "SYNC_CALENDAR";
    QuestType["SETSCHEDULINGHOURS"] = "SET_SCHEDULING_HOURS";
    QuestType["INSTALLGCALADDON"] = "INSTALL_GCAL_ADDON";
    QuestType["INSTALLSLACKINTEGRATION"] = "INSTALL_SLACK_INTEGRATION";
    QuestType["HABITSOVERVIEW"] = "HABITS_OVERVIEW";
    QuestType["CREATEANDCUSTOMIZEHABITS"] = "CREATE_AND_CUSTOMIZE_HABITS";
    QuestType["MANAGEHABITS"] = "MANAGE_HABITS";
    QuestType["SCHEDULINGLINKSOVERVIEW"] = "SCHEDULING_LINKS_OVERVIEW";
    QuestType["SETUPSCHEDULINGLINKS"] = "SETUP_SCHEDULING_LINKS";
    QuestType["SETUPTEAMLINKS"] = "SETUP_TEAM_LINKS";
    QuestType["SMARTONEONONEOVERVIEW"] = "SMART_ONE_ON_ONE_OVERVIEW";
    QuestType["SETUPFIRSTSMARTONEONONE"] = "SETUP_FIRST_SMART_ONE_ON_ONE";
    QuestType["MANAGESMARTONEONONE"] = "MANAGE_SMART_ONE_ON_ONE";
    QuestType["TASKOVERVIEW"] = "TASK_OVERVIEW";
    QuestType["ADDFIRSTTASK"] = "ADD_FIRST_TASK";
    QuestType["ADDTASKINTEGRATION"] = "ADD_TASK_INTEGRATION";
    QuestType["MANAGETASKS"] = "MANAGE_TASKS";
    QuestType["SETTASKDEFAULTS"] = "SET_TASK_DEFAULTS";
    QuestType["AUTOSCHEDULEBREAKANDTRAVELTIME"] = "AUTO_SCHEDULE_BREAK_AND_TRAVEL_TIME";
    QuestType["SETUPNOMEETINGDAYS"] = "SETUP_NO_MEETING_DAYS";
    QuestType["CUSTOMIZEEVENTCOLORCODING"] = "CUSTOMIZE_EVENT_COLOR_CODING";
    QuestType["TRACKANDANALYZEPRODUCTIVITY"] = "TRACK_AND_ANALYZE_PRODUCTIVITY";
    QuestType["ADDMEMBERSTOTEAM"] = "ADD_MEMBERS_TO_TEAM";
    QuestType["SELECTPLAN"] = "SELECT_PLAN";
})(QuestType || (QuestType = {}));
var ReclaimEdition;
(function(ReclaimEdition) {
    ReclaimEdition["NONE"] = "NONE";
    ReclaimEdition["TRIAL"] = "TRIAL";
    ReclaimEdition["ASSISTANT"] = "ASSISTANT";
    ReclaimEdition["PRO"] = "PRO";
    ReclaimEdition["TEAM"] = "TEAM";
    ReclaimEdition["REWARD"] = "REWARD";
    ReclaimEdition["LEGACYPROTRIAL"] = "LEGACY_PRO_TRIAL";
    ReclaimEdition["LEGACYTEAMTRIAL"] = "LEGACY_TEAM_TRIAL";
    ReclaimEdition["LITE"] = "LITE";
    ReclaimEdition["STARTER"] = "STARTER";
    ReclaimEdition["BUSINESS"] = "BUSINESS";
    ReclaimEdition["TRIALBUSINESS"] = "TRIAL_BUSINESS";
    ReclaimEdition["TRIALBUSINESS12W"] = "TRIAL_BUSINESS_12W";
    ReclaimEdition["TRIALBUSINESSFORLEGACYPLANS"] = "TRIAL_BUSINESS_FOR_LEGACY_PLANS";
    ReclaimEdition["ENTERPRISE"] = "ENTERPRISE";
    ReclaimEdition["TEAMREWARD"] = "TEAM_REWARD";
})(ReclaimEdition || (ReclaimEdition = {}));
var ReclaimEventType;
(function(ReclaimEventType) {
    ReclaimEventType["USER"] = "USER";
    ReclaimEventType["SYNC"] = "SYNC";
    ReclaimEventType["HABITASSIGNMENT"] = "HABIT_ASSIGNMENT";
    ReclaimEventType["SMARTHABIT"] = "SMART_HABIT";
    ReclaimEventType["ONEONONEASSIGNMENT"] = "ONE_ON_ONE_ASSIGNMENT";
    ReclaimEventType["SMARTMEETING"] = "SMART_MEETING";
    ReclaimEventType["TASKASSIGNMENT"] = "TASK_ASSIGNMENT";
    ReclaimEventType["CONFBUFFER"] = "CONF_BUFFER";
    ReclaimEventType["TRAVELBUFFER"] = "TRAVEL_BUFFER";
    ReclaimEventType["SCHEDULINGLINKMEETING"] = "SCHEDULING_LINK_MEETING";
    ReclaimEventType["UNKNOWN"] = "UNKNOWN";
})(ReclaimEventType || (ReclaimEventType = {}));
var Recurrence;
(function(Recurrence) {
    Recurrence["Daily"] = "Daily";
    Recurrence["Weekly"] = "Weekly";
    Recurrence["Biweekly"] = "Biweekly";
    Recurrence["Monthly"] = "Monthly";
    Recurrence["Quarterly"] = "Quarterly";
})(Recurrence || (Recurrence = {}));
var RecurringAssignmentAttendeeStatus;
(function(RecurringAssignmentAttendeeStatus) {
    RecurringAssignmentAttendeeStatus["INVITING"] = "INVITING";
    RecurringAssignmentAttendeeStatus["PENDING"] = "PENDING";
    RecurringAssignmentAttendeeStatus["ACCEPTED"] = "ACCEPTED";
    RecurringAssignmentAttendeeStatus["DECLINED"] = "DECLINED";
    RecurringAssignmentAttendeeStatus["ASSUMEDACCEPTED"] = "ASSUMED_ACCEPTED";
})(RecurringAssignmentAttendeeStatus || (RecurringAssignmentAttendeeStatus = {}));
var RecurringAssignmentStatus;
(function(RecurringAssignmentStatus) {
    RecurringAssignmentStatus["NEW"] = "NEW";
    RecurringAssignmentStatus["ACCEPTED"] = "ACCEPTED";
    RecurringAssignmentStatus["DECLINED"] = "DECLINED";
    RecurringAssignmentStatus["SCHEDULED"] = "SCHEDULED";
    RecurringAssignmentStatus["INVITEEERROR"] = "INVITEE_ERROR";
})(RecurringAssignmentStatus || (RecurringAssignmentStatus = {}));
var RecurringAssignmentType;
(function(RecurringAssignmentType) {
    RecurringAssignmentType["ONEONONE"] = "ONE_ON_ONE";
    RecurringAssignmentType["DAILYHABIT"] = "DAILY_HABIT";
    RecurringAssignmentType["TASK"] = "TASK";
})(RecurringAssignmentType || (RecurringAssignmentType = {}));
var RecurringEventUpdatePeriod;
(function(RecurringEventUpdatePeriod) {
    RecurringEventUpdatePeriod["ALL"] = "ALL";
    RecurringEventUpdatePeriod["SINGLE"] = "SINGLE";
})(RecurringEventUpdatePeriod || (RecurringEventUpdatePeriod = {}));
var ReindexDirection;
(function(ReindexDirection) {
    ReindexDirection["Before"] = "before";
    ReindexDirection["After"] = "after";
})(ReindexDirection || (ReindexDirection = {}));
var ResourceType;
(function(ResourceType) {
    ResourceType["User"] = "user";
    ResourceType["Task"] = "task";
    ResourceType["Tag"] = "tag";
    ResourceType["Project"] = "project";
    ResourceType["Workspace"] = "workspace";
    ResourceType["Story"] = "story";
    ResourceType["Webhook"] = "webhook";
    ResourceType["UserTaskList"] = "user_task_list";
    ResourceType["CustomField"] = "custom_field";
    ResourceType["Attachment"] = "attachment";
    ResourceType["Team"] = "team";
})(ResourceType || (ResourceType = {}));
var RsvpResponsePeriod;
(function(RsvpResponsePeriod) {
    RsvpResponsePeriod["SINGLE"] = "SINGLE";
    RsvpResponsePeriod["FORWARD"] = "FORWARD";
    RsvpResponsePeriod["ALL"] = "ALL";
})(RsvpResponsePeriod || (RsvpResponsePeriod = {}));
var SchedulingLinkMemberStatus;
(function(SchedulingLinkMemberStatus) {
    SchedulingLinkMemberStatus["ACTIVE"] = "ACTIVE";
    SchedulingLinkMemberStatus["UNPAID"] = "UNPAID";
    SchedulingLinkMemberStatus["NOTINTEAM"] = "NOT_IN_TEAM";
    SchedulingLinkMemberStatus["ACCOUNTDELETED"] = "ACCOUNT_DELETED";
    SchedulingLinkMemberStatus["UNAUTHORIZED"] = "UNAUTHORIZED";
})(SchedulingLinkMemberStatus || (SchedulingLinkMemberStatus = {}));
var SchedulingLinkRole;
(function(SchedulingLinkRole) {
    SchedulingLinkRole["MAINORGANIZER"] = "MAIN_ORGANIZER";
    SchedulingLinkRole["COORGANIZER"] = "CO_ORGANIZER";
})(SchedulingLinkRole || (SchedulingLinkRole = {}));
var SchedulingPriority;
(function(SchedulingPriority) {
    SchedulingPriority["P1"] = "P1";
    SchedulingPriority["P2"] = "P2";
    SchedulingPriority["P3"] = "P3";
    SchedulingPriority["P4"] = "P4";
    SchedulingPriority["DEFAULT"] = "DEFAULT";
    SchedulingPriority["HIGH"] = "HIGH";
})(SchedulingPriority || (SchedulingPriority = {}));
var SkipReason;
(function(SkipReason) {
    SkipReason["ManagedByReclaim"] = "managed_by_reclaim";
    SkipReason["ReclaimClone"] = "reclaim_clone";
    SkipReason["CalendarBridge"] = "calendar_bridge";
    SkipReason["SyncThemCalendars"] = "sync_them_calendars";
    SkipReason["CancelledRecurring"] = "cancelled_recurring";
    SkipReason["SkipExisting"] = "skip_existing";
    SkipReason["AlreadyCancelled"] = "already_cancelled";
    SkipReason["AllDay"] = "all_day";
    SkipReason["Nosync"] = "nosync";
    SkipReason["WorkParticipating"] = "work_participating";
    SkipReason["Declined"] = "declined";
    SkipReason["PrivateFree"] = "private_free";
    SkipReason["WorkingHours"] = "working_hours";
    SkipReason["NotOooEvent"] = "not_ooo_event";
    SkipReason["InvalidId"] = "invalid_id";
})(SkipReason || (SkipReason = {}));
var SlackSettingsStatusSync;
(function(SlackSettingsStatusSync) {
    SlackSettingsStatusSync["OFF"] = "OFF";
    SlackSettingsStatusSync["DEFAULT"] = "DEFAULT";
    SlackSettingsStatusSync["BUSY"] = "BUSY";
    SlackSettingsStatusSync["CUSTOM"] = "CUSTOM";
    SlackSettingsStatusSync["TEAM"] = "TEAM";
})(SlackSettingsStatusSync || (SlackSettingsStatusSync = {}));
var SnoozeOption;
(function(SnoozeOption) {
    SnoozeOption["FROMNOW15M"] = "FROM_NOW_15M";
    SnoozeOption["FROMNOW30M"] = "FROM_NOW_30M";
    SnoozeOption["FROMNOW1H"] = "FROM_NOW_1H";
    SnoozeOption["FROMNOW2H"] = "FROM_NOW_2H";
    SnoozeOption["FROMNOW4H"] = "FROM_NOW_4H";
    SnoozeOption["TOMORROW"] = "TOMORROW";
    SnoozeOption["INTWODAYS"] = "IN_TWO_DAYS";
    SnoozeOption["NEXTWEEK"] = "NEXT_WEEK";
})(SnoozeOption || (SnoozeOption = {}));
var SubscriptionType;
(function(SubscriptionType) {
    SubscriptionType["Events"] = "Events";
    SubscriptionType["SyncStatus"] = "SyncStatus";
    SubscriptionType["DailyHabit"] = "DailyHabit";
    SubscriptionType["OneOnOne"] = "OneOnOne";
    SubscriptionType["Task"] = "Task";
    SubscriptionType["AssistCompleted"] = "AssistCompleted";
    SubscriptionType["AssistPlanned"] = "AssistPlanned";
    SubscriptionType["NewSubscription"] = "NewSubscription";
    SubscriptionType["Moment"] = "Moment";
    SubscriptionType["Quest"] = "Quest";
    SubscriptionType["ProductUsage"] = "ProductUsage";
    SubscriptionType["User"] = "User";
    SubscriptionType["Team"] = "Team";
    SubscriptionType["SchedulingLink"] = "SchedulingLink";
    SubscriptionType["Analytics"] = "Analytics";
})(SubscriptionType || (SubscriptionType = {}));
var SurveyQuestionType;
(function(SurveyQuestionType) {
    SurveyQuestionType["ONELINE"] = "ONE_LINE";
})(SurveyQuestionType || (SurveyQuestionType = {}));
var SyncAllDayEvents;
(function(SyncAllDayEvents) {
    SyncAllDayEvents["SKIPALL"] = "SKIP_ALL";
    SyncAllDayEvents["SYNCBUSY"] = "SYNC_BUSY";
    SyncAllDayEvents["SYNCALL"] = "SYNC_ALL";
})(SyncAllDayEvents || (SyncAllDayEvents = {}));
var SyncCalendarType;
(function(SyncCalendarType) {
    SyncCalendarType["BUSINESS"] = "BUSINESS";
    SyncCalendarType["PERSONAL"] = "PERSONAL";
    SyncCalendarType["TRAVEL"] = "TRAVEL";
    SyncCalendarType["OOO"] = "OOO";
})(SyncCalendarType || (SyncCalendarType = {}));
var SyncTransparency;
(function(SyncTransparency) {
    SyncTransparency["DEFAULT"] = "DEFAULT";
    SyncTransparency["SEMIPRIVATE"] = "SEMI_PRIVATE";
    SyncTransparency["PRIVATE"] = "PRIVATE";
    SyncTransparency["PUBLIC"] = "PUBLIC";
    SyncTransparency["SEMIPRIVATEALT"] = "SEMI_PRIVATE_ALT";
})(SyncTransparency || (SyncTransparency = {}));
var TaskAutoWorkflowType;
(function(TaskAutoWorkflowType) {
    TaskAutoWorkflowType["NOTHING"] = "NOTHING";
    TaskAutoWorkflowType["REOPEN"] = "REOPEN";
    TaskAutoWorkflowType["CLOSE"] = "CLOSE";
})(TaskAutoWorkflowType || (TaskAutoWorkflowType = {}));
var TaskCategory;
(function(TaskCategory) {
    TaskCategory["WORK"] = "WORK";
    TaskCategory["PERSONAL"] = "PERSONAL";
    TaskCategory["BOTH"] = "BOTH";
})(TaskCategory || (TaskCategory = {}));
var TaskInstanceStatus;
(function(TaskInstanceStatus) {
    TaskInstanceStatus["DONE"] = "DONE";
    TaskInstanceStatus["ACTIVE"] = "ACTIVE";
    TaskInstanceStatus["PENDING"] = "PENDING";
    TaskInstanceStatus["ABORTED"] = "ABORTED";
})(TaskInstanceStatus || (TaskInstanceStatus = {}));
var TaskStatus;
(function(TaskStatus) {
    TaskStatus["NEW"] = "NEW";
    TaskStatus["SCHEDULED"] = "SCHEDULED";
    TaskStatus["INPROGRESS"] = "IN_PROGRESS";
    TaskStatus["COMPLETE"] = "COMPLETE";
    TaskStatus["CANCELLED"] = "CANCELLED";
    TaskStatus["ARCHIVED"] = "ARCHIVED";
})(TaskStatus || (TaskStatus = {}));
var TimePolicyType;
(function(TimePolicyType) {
    TimePolicyType["WORK"] = "WORK";
    TimePolicyType["PERSONAL"] = "PERSONAL";
    TimePolicyType["MEETING"] = "MEETING";
    TimePolicyType["ONEOFF"] = "ONE_OFF";
    TimePolicyType["INHERITED"] = "INHERITED";
    TimePolicyType["CUSTOM"] = "CUSTOM";
})(TimePolicyType || (TimePolicyType = {}));
var TimeSchemeIntegrationRuleAction;
(function(TimeSchemeIntegrationRuleAction) {
    TimeSchemeIntegrationRuleAction["SYNCTO"] = "SYNC_TO";
    TimeSchemeIntegrationRuleAction["DONTSYNC"] = "DONT_SYNC";
})(TimeSchemeIntegrationRuleAction || (TimeSchemeIntegrationRuleAction = {}));
var TimeSchemeIntegrationRuleServiceType;
(function(TimeSchemeIntegrationRuleServiceType) {
    TimeSchemeIntegrationRuleServiceType["TODOIST"] = "TODOIST";
    TimeSchemeIntegrationRuleServiceType["CLICKUP"] = "CLICK_UP";
})(TimeSchemeIntegrationRuleServiceType || (TimeSchemeIntegrationRuleServiceType = {}));
var TimeSchemeIntegrationRuleType;
(function(TimeSchemeIntegrationRuleType) {
    TimeSchemeIntegrationRuleType["CASE"] = "CASE";
    TimeSchemeIntegrationRuleType["OTHERWISE"] = "OTHERWISE";
})(TimeSchemeIntegrationRuleType || (TimeSchemeIntegrationRuleType = {}));
var UserMetadataCompanySize;
(function(UserMetadataCompanySize) {
    UserMetadataCompanySize["SUB10"] = "SUB_10";
    UserMetadataCompanySize["SUB50"] = "SUB_50";
    UserMetadataCompanySize["SUB100"] = "SUB_100";
    UserMetadataCompanySize["SUB500"] = "SUB_500";
    UserMetadataCompanySize["SUB1000"] = "SUB_1000";
    UserMetadataCompanySize["THOUSANDPLUS"] = "THOUSAND_PLUS";
})(UserMetadataCompanySize || (UserMetadataCompanySize = {}));
var UserMetadataUsecase;
(function(UserMetadataUsecase) {
    UserMetadataUsecase["EDUCATION"] = "EDUCATION";
    UserMetadataUsecase["WORK"] = "WORK";
    UserMetadataUsecase["NONPROFIT"] = "NON_PROFIT";
    UserMetadataUsecase["TEAM"] = "TEAM";
    UserMetadataUsecase["SOLOWORK"] = "SOLO_WORK";
    UserMetadataUsecase["PERSONAL"] = "PERSONAL";
})(UserMetadataUsecase || (UserMetadataUsecase = {}));
var UserProfileDepartment;
(function(UserProfileDepartment) {
    UserProfileDepartment["PRODUCT"] = "PRODUCT";
    UserProfileDepartment["ENGINEERING"] = "ENGINEERING";
    UserProfileDepartment["SUPPORT"] = "SUPPORT";
    UserProfileDepartment["MARKETING"] = "MARKETING";
    UserProfileDepartment["SALES"] = "SALES";
    UserProfileDepartment["DESIGN"] = "DESIGN";
    UserProfileDepartment["HR"] = "HR";
    UserProfileDepartment["OPERATIONS"] = "OPERATIONS";
    UserProfileDepartment["ACCOUNTINGANDFINANCE"] = "ACCOUNTING_AND_FINANCE";
    UserProfileDepartment["FOUNDER"] = "FOUNDER";
    UserProfileDepartment["OTHER"] = "OTHER";
})(UserProfileDepartment || (UserProfileDepartment = {}));
var UserProfileGoal;
(function(UserProfileGoal) {
    UserProfileGoal["HEADSDOWNTIME"] = "HEADS_DOWN_TIME";
    UserProfileGoal["MEETINGS"] = "MEETINGS";
    UserProfileGoal["WORKLIFEBALANCE"] = "WORK_LIFE_BALANCE";
    UserProfileGoal["MULTIPLECALENDARS"] = "MULTIPLE_CALENDARS";
})(UserProfileGoal || (UserProfileGoal = {}));
var UserProfileRole;
(function(UserProfileRole) {
    UserProfileRole["EXEC"] = "EXEC";
    UserProfileRole["MANAGER"] = "MANAGER";
    UserProfileRole["NONMANAGER"] = "NON_MANAGER";
    UserProfileRole["CONSULTANT"] = "CONSULTANT";
    UserProfileRole["STUDENT"] = "STUDENT";
})(UserProfileRole || (UserProfileRole = {}));
var UserTrait;
(function(UserTrait) {
    UserTrait["EMAIL"] = "EMAIL";
    UserTrait["AUTHID"] = "AUTH_ID";
    UserTrait["FULLNAME"] = "FULL_NAME";
    UserTrait["FIRSTNAME"] = "FIRST_NAME";
    UserTrait["LASTNAME"] = "LAST_NAME";
    UserTrait["CREATEDAT"] = "CREATED_AT";
    UserTrait["SIGNEDUP"] = "SIGNED_UP";
    UserTrait["MAINTIMEZONE"] = "MAIN_TIMEZONE";
    UserTrait["REFERRALCODE"] = "REFERRAL_CODE";
    UserTrait["ONBOARDED"] = "ONBOARDED";
    UserTrait["LIKELYPERSONAL"] = "LIKELY_PERSONAL";
    UserTrait["CLUSTERDEX"] = "CLUSTERDEX";
    UserTrait["JOBTITLE"] = "JOB_TITLE";
    UserTrait["COMPANYNAME"] = "COMPANY_NAME";
    UserTrait["COMPANYSIZE"] = "COMPANY_SIZE";
    UserTrait["USECASE"] = "USECASE";
    UserTrait["ROLE"] = "ROLE";
    UserTrait["DEPARTMENT"] = "DEPARTMENT";
    UserTrait["GOALS"] = "GOALS";
    UserTrait["PRIMARYCALENDARLINKED"] = "PRIMARY_CALENDAR_LINKED";
    UserTrait["PRIMARYCALENDARID"] = "PRIMARY_CALENDAR_ID";
    UserTrait["EDITION"] = "EDITION";
    UserTrait["EDITIONHR"] = "EDITION_HR";
    UserTrait["EDITIONAFTERTRIAL"] = "EDITION_AFTER_TRIAL";
    UserTrait["EDITIONAFTERTRIALHR"] = "EDITION_AFTER_TRIAL_HR";
    UserTrait["PREDICTEDEDITION"] = "PREDICTED_EDITION";
    UserTrait["PREDICTEDEDITIONHR"] = "PREDICTED_EDITION_HR";
    UserTrait["PREDICTEDEDITIONBEFORELASTDOWNGRADE"] = "PREDICTED_EDITION_BEFORE_LAST_DOWNGRADE";
    UserTrait["PREDICTEDEDITIONAFTERLASTDOWNGRADE"] = "PREDICTED_EDITION_AFTER_LAST_DOWNGRADE";
    UserTrait["ACCOUNTID"] = "ACCOUNT_ID";
    UserTrait["ACCOUNTMEMBERS"] = "ACCOUNT_MEMBERS";
    UserTrait["ACCOUNTSUBSCRIPTIONCHANGE"] = "ACCOUNT_SUBSCRIPTION_CHANGE";
    UserTrait["ACCOUNTROLE"] = "ACCOUNT_ROLE";
    UserTrait["ACCOUNTPLANHR"] = "ACCOUNT_PLAN_HR";
    UserTrait["ACCOUNTTRIALENDDATE"] = "ACCOUNT_TRIAL_END_DATE";
    UserTrait["ACCOUNTTRIALDAYSREMAINING"] = "ACCOUNT_TRIAL_DAYS_REMAINING";
    UserTrait["ACCOUNTSUBSCRIPTIONSTATUS"] = "ACCOUNT_SUBSCRIPTION_STATUS";
    UserTrait["TRIALENDDATE"] = "TRIAL_END_DATE";
    UserTrait["TRIALDAYSREMAINING"] = "TRIAL_DAYS_REMAINING";
    UserTrait["USAGESYNCPOLICYCOUNT"] = "USAGE_SYNC_POLICY_COUNT";
    UserTrait["USAGESYNCPOLICYCUSTOMCOUNT"] = "USAGE_SYNC_POLICY_CUSTOM_COUNT";
    UserTrait["USAGECONNECTEDCALENDARCOUNT"] = "USAGE_CONNECTED_CALENDAR_COUNT";
    UserTrait["USAGEHABITACTIVECOUNT"] = "USAGE_HABIT_ACTIVE_COUNT";
    UserTrait["USAGESMART11ACTIVECOUNT"] = "USAGE_SMART_11_ACTIVE_COUNT";
    UserTrait["USAGECUSTOMDECOMPRESSION"] = "USAGE_CUSTOM_DECOMPRESSION";
    UserTrait["PERSONALCALENDARSCOUNT"] = "PERSONAL_CALENDARS_COUNT";
    UserTrait["PERSONALCALENDARLINKED"] = "PERSONAL_CALENDAR_LINKED";
    UserTrait["PERSONALCALENDARID"] = "PERSONAL_CALENDAR_ID";
    UserTrait["ONEONONESACTIVE"] = "ONE_ON_ONES_ACTIVE";
    UserTrait["ONEONONESPENDING"] = "ONE_ON_ONES_PENDING";
    UserTrait["ONEONONESORGANIZED"] = "ONE_ON_ONES_ORGANIZED";
    UserTrait["ONEONONESINVITEDTO"] = "ONE_ON_ONES_INVITED_TO";
    UserTrait["ONEONONESTOTAL"] = "ONE_ON_ONES_TOTAL";
    UserTrait["ONEONONESDETECTED"] = "ONE_ON_ONES_DETECTED";
    UserTrait["DAILYHABITSACTIVE"] = "DAILY_HABITS_ACTIVE";
    UserTrait["DAILYHABITSTOTAL"] = "DAILY_HABITS_TOTAL";
    UserTrait["DAILYHABITSACTIVATED"] = "DAILY_HABITS_ACTIVATED";
    UserTrait["TASKSTOTAL"] = "TASKS_TOTAL";
    UserTrait["TASKSRECENT"] = "TASKS_RECENT";
    UserTrait["SLACKACTIONTAKEN"] = "SLACK_ACTION_TAKEN";
    UserTrait["DOMAIN"] = "DOMAIN";
    UserTrait["DOMAINISGOOGLEWORKSPACE"] = "DOMAIN_IS_GOOGLE_WORKSPACE";
    UserTrait["DOMAINSLACKUSERS"] = "DOMAIN_SLACK_USERS";
    UserTrait["FEATUREASSISTTRAVEL"] = "FEATURE_ASSIST_TRAVEL";
    UserTrait["FEATUREASSISTCONFERENCEBUFFER"] = "FEATURE_ASSIST_CONFERENCE_BUFFER";
    UserTrait["FEATURESLACKENABLED"] = "FEATURE_SLACK_ENABLED";
    UserTrait["FEATURESLACKSTATUSSYNC"] = "FEATURE_SLACK_STATUS_SYNC";
    UserTrait["FEATURETASKSENABLED"] = "FEATURE_TASKS_ENABLED";
    UserTrait["FEATUREGOOGLETASKSENABLED"] = "FEATURE_GOOGLE_TASKS_ENABLED";
    UserTrait["FEATURECOLORSENABLED"] = "FEATURE_COLORS_ENABLED";
    UserTrait["INTERESTOFFICE365"] = "INTEREST_OFFICE365";
    UserTrait["INTERESTINTEGRATIONTRELLO"] = "INTEREST_INTEGRATION_TRELLO";
    UserTrait["INTERESTINTEGRATIONMONDAY"] = "INTEREST_INTEGRATION_MONDAY";
    UserTrait["ONBOARDHABITS"] = "ONBOARD_HABITS";
    UserTrait["ONBOARDTASKS"] = "ONBOARD_TASKS";
    UserTrait["ONBOARDGOOGLETASKS"] = "ONBOARD_GOOGLE_TASKS";
    UserTrait["ONBOARDPLANITEMPRIORITIZED"] = "ONBOARD_PLAN_ITEM_PRIORITIZED";
    UserTrait["ONBOARDSMARTONEONONES"] = "ONBOARD_SMART_ONE_ON_ONES";
    UserTrait["ONBOARDBUFFERTIME"] = "ONBOARD_BUFFER_TIME";
    UserTrait["ONBOARDTASKSREINDEX"] = "ONBOARD_TASKS_REINDEX";
    UserTrait["ONBOARDGOOGLEADDON"] = "ONBOARD_GOOGLE_ADDON";
    UserTrait["ONBOARDSCHEDULINGLINKS"] = "ONBOARD_SCHEDULING_LINKS";
    UserTrait["ONBOARDV16SCHEDULER"] = "ONBOARD_V16_SCHEDULER";
    UserTrait["SCHEDULERVERSION"] = "SCHEDULER_VERSION";
    UserTrait["PRIORITIZATIONENABLED"] = "PRIORITIZATION_ENABLED";
    UserTrait["REFERRALSSIGNEDUP"] = "REFERRALS_SIGNED_UP";
    UserTrait["REFERRALSACTIVE"] = "REFERRALS_ACTIVE";
    UserTrait["REFERRALSDELETED"] = "REFERRALS_DELETED";
    UserTrait["REFERRALCREDITSCLAIMED"] = "REFERRAL_CREDITS_CLAIMED";
    UserTrait["INVITESSENT"] = "INVITES_SENT";
    UserTrait["INVITEESSIGNEDUP"] = "INVITEES_SIGNED_UP";
    UserTrait["INVITEESACTIVE"] = "INVITEES_ACTIVE";
    UserTrait["INVITEESDELETED"] = "INVITEES_DELETED";
    UserTrait["WEEKLYREPORTSUBSCRIBED"] = "WEEKLY_REPORT_SUBSCRIBED";
    UserTrait["ZOOMENABLED"] = "ZOOM_ENABLED";
    UserTrait["LINEARENABLED"] = "LINEAR_ENABLED";
    UserTrait["JIRAENABLED"] = "JIRA_ENABLED";
    UserTrait["TODOISTENABLED"] = "TODOIST_ENABLED";
    UserTrait["ASANAENABLED"] = "ASANA_ENABLED";
    UserTrait["CLICKUPENABLED"] = "CLICKUP_ENABLED";
    UserTrait["ADDONINSTALLED"] = "ADD_ON_INSTALLED";
    UserTrait["SCHEDULINGLINKSLINKCOUNT"] = "SCHEDULING_LINKS_LINK_COUNT";
    UserTrait["SCHEDULINGLINKSMEETINGCOUNT"] = "SCHEDULING_LINKS_MEETING_COUNT";
    UserTrait["QUESTWELCOMETORECLAIM"] = "QUEST_WELCOME_TO_RECLAIM";
    UserTrait["QUESTSETAVAILABILITY"] = "QUEST_SET_AVAILABILITY";
    UserTrait["QUESTSYNCCALENDAR"] = "QUEST_SYNC_CALENDAR";
    UserTrait["QUESTPRIORITIZATION"] = "QUEST_PRIORITIZATION";
    UserTrait["QUESTSETSCHEDULINGHOURS"] = "QUEST_SET_SCHEDULING_HOURS";
    UserTrait["QUESTINSTALLGCALADDON"] = "QUEST_INSTALL_GCAL_ADDON";
    UserTrait["QUESTINSTALLSLACKINTEGRATION"] = "QUEST_INSTALL_SLACK_INTEGRATION";
    UserTrait["QUESTHABITSOVERVIEW"] = "QUEST_HABITS_OVERVIEW";
    UserTrait["QUESTCREATEANDCUSTOMIZEHABITS"] = "QUEST_CREATE_AND_CUSTOMIZE_HABITS";
    UserTrait["QUESTMANAGEHABITS"] = "QUEST_MANAGE_HABITS";
    UserTrait["QUESTSCHEDULINGLINKSOVERVIEW"] = "QUEST_SCHEDULING_LINKS_OVERVIEW";
    UserTrait["QUESTSETUPSCHEDULINGLINKS"] = "QUEST_SETUP_SCHEDULING_LINKS";
    UserTrait["QUESTSETUPTEAMLINKS"] = "QUEST_SETUP_TEAM_LINKS";
    UserTrait["QUESTSMARTONEONONEOVERVIEW"] = "QUEST_SMART_ONE_ON_ONE_OVERVIEW";
    UserTrait["QUESTSETUPFIRSTSMARTONEONONE"] = "QUEST_SETUP_FIRST_SMART_ONE_ON_ONE";
    UserTrait["QUESTMANAGESMARTONEONONE"] = "QUEST_MANAGE_SMART_ONE_ON_ONE";
    UserTrait["QUESTTASKOVERVIEW"] = "QUEST_TASK_OVERVIEW";
    UserTrait["QUESTADDFIRSTTASK"] = "QUEST_ADD_FIRST_TASK";
    UserTrait["QUESTADDTASKINTEGRATION"] = "QUEST_ADD_TASK_INTEGRATION";
    UserTrait["QUESTMANAGETASKS"] = "QUEST_MANAGE_TASKS";
    UserTrait["QUESTSETTASKDEFAULTS"] = "QUEST_SET_TASK_DEFAULTS";
    UserTrait["QUESTAUTOSCHEDULEBREAKANDTRAVELTIME"] = "QUEST_AUTO_SCHEDULE_BREAK_AND_TRAVEL_TIME";
    UserTrait["QUESTSETUPNOMEETINGDAYS"] = "QUEST_SETUP_NO_MEETING_DAYS";
    UserTrait["QUESTCUSTOMIZEEVENTCOLORCODING"] = "QUEST_CUSTOMIZE_EVENT_COLOR_CODING";
    UserTrait["QUESTTRACKANDANALYZEPRODUCTIVITY"] = "QUEST_TRACK_AND_ANALYZE_PRODUCTIVITY";
    UserTrait["QUESTADDMEMBERSTOTEAM"] = "QUEST_ADD_MEMBERS_TO_TEAM";
    UserTrait["QUESTSELECTPLAN"] = "QUEST_SELECT_PLAN";
})(UserTrait || (UserTrait = {}));
var ZoneOffsetTransitionRuleTimeDefinition;
(function(ZoneOffsetTransitionRuleTimeDefinition) {
    ZoneOffsetTransitionRuleTimeDefinition["UTC"] = "UTC";
    ZoneOffsetTransitionRuleTimeDefinition["WALL"] = "WALL";
    ZoneOffsetTransitionRuleTimeDefinition["STANDARD"] = "STANDARD";
})(ZoneOffsetTransitionRuleTimeDefinition || (ZoneOffsetTransitionRuleTimeDefinition = {}));
var HEADER_BUILD_ID = "X-Reclaim-Build-Id";
var // TODO: The need for this is hard codded into the codegen source... so dumb
BodyType;
(function(BodyType) {
    BodyType[BodyType["Json"] = 0] = "Json";
})(BodyType || (BodyType = {}));
var ReclaimApiError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReclaimApiError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ReclaimApiError);
    function ReclaimApiError(res, message) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ReclaimApiError);
        var _this;
        var ref;
        _this = _super.call(this, message);
        if (!res && !message) message = "No response object";
        _this.status = res === null || res === void 0 ? void 0 : res.status;
        _this.statusText = (res === null || res === void 0 ? void 0 : res.statusText) || ((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || message;
        _this.headers = res === null || res === void 0 ? void 0 : res.headers;
        _this.body = res === null || res === void 0 ? void 0 : res.data;
        return _this;
    }
    return ReclaimApiError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Error));
var NetworkError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(NetworkError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(NetworkError);
    function NetworkError(res, message) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, NetworkError);
        var _this;
        var ref;
        _this = _super.call(this, message);
        _this.status = "NetworkError";
        if (!res && !message) message = "No response object";
        _this.statusText = (res === null || res === void 0 ? void 0 : res.statusText) || ((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || message;
        _this.headers = res === null || res === void 0 ? void 0 : res.headers;
        _this.body = res === null || res === void 0 ? void 0 : res.data;
        return _this;
    }
    return NetworkError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Error));
var HttpClient = /*#__PURE__*/ function() {
    "use strict";
    function HttpClient() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            BUILD_ID: "unknown"
        }, baseUrl = ref.baseUrl, baseApiParams = ref.baseApiParams, securityWorker = ref.securityWorker, BUILD_ID = ref.BUILD_ID;
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, HttpClient);
        this.baseUrl = "https://api.app.reclaim.ai/api";
        this.securityData = null;
        this.securityWorker = function() {};
        this.baseApiParams = {
            headers: {
                "Content-Type": "application/json",
                Referrer: "no-referrer"
            }
        };
        this.requestHooks = {};
        this.responseHooks = {};
        this.setSecurityData = function(data) {
            _this.securityData = data;
        };
        this.request = function(path, method) {
            var _param = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, data = arguments.length > 3 ? arguments[3] : void 0, _dumbUnusedBodyType = arguments.length > 4 ? arguments[4] : void 0, secureByDefault = arguments.length > 5 ? arguments[5] : void 0;
            var secure = _param.secure, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
                "secure"
            ]);
            return _this.client.request((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                url: path
            }, params), {
                method: method,
                data: data,
                validateStatus: function validateStatus(status) {
                    return true;
                }
            })).then(function(r) {
                if (r.status >= 200 && r.status < 300) {
                    return !!r.data ? r.data : null;
                } else if (!r.status) {
                    throw new NetworkError(r);
                } else {
                    throw new ReclaimApiError(r);
                }
            });
        };
        if (!!baseUrl) this.baseUrl = baseUrl;
        if (!!baseApiParams) this.baseApiParams = baseApiParams;
        if (!!securityWorker) this.securityWorker = securityWorker;
        this.client = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
            baseURL: baseUrl || this.baseUrl,
            withCredentials: true,
            headers: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, HEADER_BUILD_ID, BUILD_ID), this.baseApiParams.headers || {}), {
                post: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            })
        });
        this.client.interceptors.request.use(function(config) {
            Object.keys(_this.requestHooks).forEach(function(name) {
                _this.requestHooks[name](config);
            });
            return config;
        });
        this.client.interceptors.response.use(function(r) {
            Object.keys(_this.responseHooks).forEach(function(name) {
                if (r.status) {
                    return _this.responseHooks["".concat(name, " - Status: ").concat(r.status)](new ReclaimApiError(r));
                }
                _this.responseHooks["".concat(name, " - Status: network")](new NetworkError(r));
            });
            return r;
        }, function(error) {
            Object.keys(_this.responseHooks).forEach(function(name) {
                _this.responseHooks[name](error);
            });
            return error;
        });
    }
    var _proto = HttpClient.prototype;
    _proto.addQueryParam = function addQueryParam(query, key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(Array.isArray(query[key]) ? query[key].join(",") : query[key]);
    };
    _proto.addQueryParams = function addQueryParams(rawQuery) {
        var _this = this;
        var query = rawQuery || {};
        var keys = Object.keys(query).filter(function(key) {
            return "undefined" !== typeof query[key];
        });
        return keys.length ? "?".concat(keys.map(function(key) {
            return typeof query[key] === "object" && !Array.isArray(query[key]) ? _this.addQueryParams(query[key]).substring(1) : _this.addQueryParam(query, key);
        }).join("&")) : "";
    };
    _proto.registerRequestHook = function registerRequestHook(name, fn) {
        this.requestHooks[name] = fn;
    };
    _proto.registerResponseHook = function registerResponseHook(name, status, fn) {
        this.responseHooks["".concat(name, " - Status: ").concat(status)] = fn;
    };
    return HttpClient;
}();
/**
 * @title Reclaim API
 * @version 0.1
 * @baseUrl https://api.app.reclaim.ai/api
 * Reclaim's awesome API
 */ var ReclaimApi = /*#__PURE__*/ function(HttpClient) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReclaimApi, HttpClient);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ReclaimApi);
    function ReclaimApi() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ReclaimApi);
        var _this;
        _this = _super.apply(this, arguments);
        _this.accounts = {
            /**
     * @tags accounts
     * @name list
     * @request GET:/accounts
     */ list: function(params) {
                return _this.request("/accounts", "GET", params);
            },
            /**
     * @tags accounts
     * @name validateAll
     * @request POST:/accounts/validate
     */ validateAll: function(params) {
                return _this.request("/accounts/validate", "POST", params);
            },
            /**
     * @tags accounts
     * @name getCalendars
     * @request GET:/accounts/{accountId}/calendars
     */ getCalendars: function(accountId, params) {
                return _this.request("/accounts/".concat(accountId, "/calendars"), "GET", params);
            },
            /**
     * @tags accounts
     * @name setAvailability
     * @request PUT:/accounts/{accountId}/calendars/connected
     */ setAvailability: function(accountId, data, params) {
                return _this.request("/accounts/".concat(accountId, "/calendars/connected"), "PUT", params, data);
            },
            /**
     * @tags accounts
     * @name delete
     * @request DELETE:/accounts/{id}
     */ delete: function(id, params) {
                return _this.request("/accounts/".concat(id), "DELETE", params);
            },
            /**
     * @tags accounts
     * @name validate
     * @request POST:/accounts/{id}/validate
     */ validate: function(id, params) {
                return _this.request("/accounts/".concat(id, "/validate"), "POST", params);
            }
        };
        _this.admin = {
            /**
     * @name admin_createUser
     * @request POST:/admin/users
     */ adminCreateUser: function(data, params) {
                return _this.request("/admin/users", "POST", params, data);
            },
            /**
     * @name admin_deleteUser
     * @request DELETE:/admin/users/{username}
     */ adminDeleteUser: function(username, params) {
                return _this.request("/admin/users/".concat(username), "DELETE", params);
            },
            /**
     * @name admin_listAccounts
     * @request GET:/admin/users/{username}/accounts
     */ adminListAccounts: function(username, params) {
                return _this.request("/admin/users/".concat(username, "/accounts"), "GET", params);
            },
            /**
     * @name admin_createAccount
     * @request POST:/admin/users/{username}/accounts
     */ adminCreateAccount: function(username, data, params) {
                return _this.request("/admin/users/".concat(username, "/accounts"), "POST", params, data);
            },
            /**
     * @name admin_switchMainAccount
     * @request POST:/admin/users/{username}/accounts/{accountId}/main
     */ adminSwitchMainAccount: function(username, accountId, params) {
                return _this.request("/admin/users/".concat(username, "/accounts/").concat(accountId, "/main"), "POST", params);
            },
            /**
     * @name admin_createCalendarSync
     * @request POST:/admin/users/{username}/calendar-syncs
     */ adminCreateCalendarSync: function(username, data, params) {
                return _this.request("/admin/users/".concat(username, "/calendar-syncs"), "POST", params, data);
            },
            /**
     * @name admin_getCalendarSyncs
     * @request GET:/admin/users/{username}/calendar-syncs/
     */ adminGetCalendarSyncs: function(username, params) {
                return _this.request("/admin/users/".concat(username, "/calendar-syncs/"), "GET", params);
            },
            /**
     * @name admin_deleteSync
     * @request DELETE:/admin/users/{username}/calendar-syncs/{sourceId}/to/{targetId}
     */ adminDeleteSync: function(username, sourceId, targetId, params) {
                return _this.request("/admin/users/".concat(username, "/calendar-syncs/").concat(sourceId, "/to/").concat(targetId), "DELETE", params);
            },
            /**
     * @name admin_patchSync
     * @request PATCH:/admin/users/{username}/calendar-syncs/{sourceId}/to/{targetId}
     */ adminPatchSync: function(username, sourceId, targetId, data, params) {
                return _this.request("/admin/users/".concat(username, "/calendar-syncs/").concat(sourceId, "/to/").concat(targetId), "PATCH", params, data);
            }
        };
        _this.analytics = {
            /**
     * @tags analytics
     * @name analytics_teamAnalytics
     * @request GET:/analytics/team
     */ analyticsTeamAnalytics: function(query, params) {
                return _this.request("/analytics/team".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags analytics
     * @name analytics_teamAnalyticsV3
     * @request GET:/analytics/team/V2
     */ analyticsTeamAnalyticsV3: function(query, params) {
                return _this.request("/analytics/team/V2".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags analytics
     * @name analytics_teamAnalyticsV2
     * @request GET:/analytics/team/V3
     */ analyticsTeamAnalyticsV2: function(query, params) {
                return _this.request("/analytics/team/V3".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags analytics
     * @name analytics_userAnalytics
     * @request GET:/analytics/user
     */ analyticsUserAnalytics: function(query, params) {
                return _this.request("/analytics/user".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags analytics
     * @name analytics_userAnalyticsV2
     * @request GET:/analytics/user/V2
     */ analyticsUserAnalyticsV2: function(query, params) {
                return _this.request("/analytics/user/V2".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags analytics
     * @name analytics_userAnalyticsV3
     * @request GET:/analytics/user/V3
     */ analyticsUserAnalyticsV3: function(query, params) {
                return _this.request("/analytics/user/V3".concat(_this.addQueryParams(query)), "GET", params);
            }
        };
        _this.apiManagement = {
            /**
     * @tags api-management
     * @name createApiKey
     * @request POST:/api-management/api-key
     */ createApiKey: function(data, params) {
                return _this.request("/api-management/api-key", "POST", params, data);
            },
            /**
     * @tags api-management
     * @name updateApiKey
     * @request PATCH:/api-management/api-key
     */ updateApiKey: function(data, params) {
                return _this.request("/api-management/api-key", "PATCH", params, data);
            },
            /**
     * @tags api-management
     * @name reissueApiKey
     * @request PATCH:/api-management/api-key/reissue/{id}
     */ reissueApiKey: function(id, params) {
                return _this.request("/api-management/api-key/reissue/".concat(id), "PATCH", params);
            },
            /**
     * @tags api-management
     * @name listApiKey
     * @request GET:/api-management/api-key/{id}
     */ listApiKey: function(id, params) {
                return _this.request("/api-management/api-key/".concat(id), "GET", params);
            },
            /**
     * @tags api-management
     * @name deleteApiKey
     * @request DELETE:/api-management/api-key/{id}
     */ deleteApiKey: function(id, params) {
                return _this.request("/api-management/api-key/".concat(id), "DELETE", params);
            },
            /**
     * @tags api-management
     * @name listApiKey_1
     * @request GET:/api-management/api-keys
     */ listApiKey1: function(params) {
                return _this.request("/api-management/api-keys", "GET", params);
            }
        };
        _this.asana = {
            /**
     * @tags asana, integration, private
     * @name integrations
     * @request GET:/asana/integrations
     */ integrations: function(params) {
                return _this.request("/asana/integrations", "GET", params);
            },
            /**
     * @tags asana, integration, private
     * @name deleteIntegration
     * @request DELETE:/asana/integrations
     */ deleteIntegration: function(params) {
                return _this.request("/asana/integrations", "DELETE", params);
            }
        };
        _this.assist = {
            /**
     * @tags assist
     * @name getDailyHabits
     * @request GET:/assist/habits/daily
     */ getDailyHabits: function(params) {
                return _this.request("/assist/habits/daily", "GET", params);
            },
            /**
     * @tags assist
     * @name create
     * @request POST:/assist/habits/daily
     */ create: function(data, query, params) {
                return _this.request("/assist/habits/daily".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags assist
     * @name getDailyHabit
     * @request GET:/assist/habits/daily/{id}
     */ getDailyHabit: function(id, params) {
                return _this.request("/assist/habits/daily/".concat(id), "GET", params);
            },
            /**
     * @tags assist
     * @name update
     * @request PUT:/assist/habits/daily/{id}
     */ update: function(id, data, query, params) {
                return _this.request("/assist/habits/daily/".concat(id).concat(_this.addQueryParams(query)), "PUT", params, data);
            },
            /**
     * @tags assist
     * @name delete_1
     * @request DELETE:/assist/habits/daily/{id}
     */ delete1: function(id, query, params) {
                return _this.request("/assist/habits/daily/".concat(id).concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags assist
     * @name patch
     * @request PATCH:/assist/habits/daily/{id}
     */ patch: function(id, data, query, params) {
                return _this.request("/assist/habits/daily/".concat(id).concat(_this.addQueryParams(query)), "PATCH", params, data);
            },
            /**
     * @tags assist
     * @name getHabitTemplate
     * @request GET:/assist/habits/template
     */ getHabitTemplate: function(query, params) {
                return _this.request("/assist/habits/template".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags assist
     * @name createHabitTemplates
     * @request POST:/assist/habits/template/create
     */ createHabitTemplates: function(data, query, params) {
                return _this.request("/assist/habits/template/create".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags assist
     * @name getHabitTemplates
     * @request GET:/assist/habits/templates
     */ getHabitTemplates: function(query, params) {
                return _this.request("/assist/habits/templates".concat(_this.addQueryParams(query)), "GET", params);
            }
        };
        _this.calendars = {
            /**
     * @tags calendars
     * @name getAllPersonal
     * @request GET:/calendars/personal
     */ getAllPersonal: function(params) {
                return _this.request("/calendars/personal", "GET", params);
            },
            /**
     * @tags calendars
     * @name getPersonalCandidates
     * @request GET:/calendars/personal/candidates
     */ getPersonalCandidates: function(query, params) {
                return _this.request("/calendars/personal/candidates".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags calendars
     * @name getPersonal
     * @request GET:/calendars/personal/{id}
     */ getPersonal: function(id, params) {
                return _this.request("/calendars/personal/".concat(id), "GET", params);
            },
            /**
     * @tags calendars
     * @name deletePersonal
     * @request DELETE:/calendars/personal/{id}
     */ deletePersonal: function(id, params) {
                return _this.request("/calendars/personal/".concat(id), "DELETE", params);
            },
            /**
     * @tags calendars
     * @name getPrimary
     * @request GET:/calendars/primary
     */ getPrimary: function(params) {
                return _this.request("/calendars/primary", "GET", params);
            },
            /**
     * @tags calendars
     * @name share
     * @request POST:/calendars/share
     */ share: function(query, params) {
                return _this.request("/calendars/share".concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags calendars
     * @name getAllSync
     * @request GET:/calendars/sync
     */ getAllSync: function(params) {
                return _this.request("/calendars/sync", "GET", params);
            },
            /**
     * @tags calendars
     * @name createSync
     * @request POST:/calendars/sync
     */ createSync: function(data, params) {
                return _this.request("/calendars/sync", "POST", params, data);
            },
            /**
     * @tags calendarSyncPolicy
     * @name getSyncPolicies
     * @request GET:/calendars/sync-policy
     */ getSyncPolicies: function(params) {
                return _this.request("/calendars/sync-policy", "GET", params);
            },
            /**
     * @tags calendarSyncPolicy
     * @name createSyncPolicy
     * @request POST:/calendars/sync-policy
     */ createSyncPolicy: function(data, params) {
                return _this.request("/calendars/sync-policy", "POST", params, data);
            },
            /**
     * @tags calendarSyncPolicy
     * @name testSyncPolicy
     * @request POST:/calendars/sync-policy/validate
     */ testSyncPolicy: function(data, params) {
                return _this.request("/calendars/sync-policy/validate", "POST", params, data);
            },
            /**
     * @tags calendarSyncPolicy
     * @name getSyncPolicy
     * @request GET:/calendars/sync-policy/{sourceId}/to/{targetId}
     */ getSyncPolicy: function(sourceId, targetId, params) {
                return _this.request("/calendars/sync-policy/".concat(sourceId, "/to/").concat(targetId), "GET", params);
            },
            /**
     * @tags calendarSyncPolicy
     * @name deleteSyncPolicy
     * @request DELETE:/calendars/sync-policy/{sourceId}/to/{targetId}
     */ deleteSyncPolicy: function(sourceId, targetId, params) {
                return _this.request("/calendars/sync-policy/".concat(sourceId, "/to/").concat(targetId), "DELETE", params);
            },
            /**
     * @tags calendarSyncPolicy
     * @name patchSyncPolicy
     * @request PATCH:/calendars/sync-policy/{sourceId}/to/{targetId}
     */ patchSyncPolicy: function(sourceId, targetId, data, params) {
                return _this.request("/calendars/sync-policy/".concat(sourceId, "/to/").concat(targetId), "PATCH", params, data);
            },
            /**
     * @tags calendarSyncPolicy
     * @name repairSync
     * @request POST:/calendars/sync-policy/{sourceId}/to/{targetId}/repair
     */ repairSync: function(sourceId, targetId, params) {
                return _this.request("/calendars/sync-policy/".concat(sourceId, "/to/").concat(targetId, "/repair"), "POST", params);
            },
            /**
     * @tags calendars
     * @name getSyncCandidates
     * @request GET:/calendars/sync/candidates
     */ getSyncCandidates: function(query, params) {
                return _this.request("/calendars/sync/candidates".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags calendarSyncEvents
     * @name getSyncEventsForUser
     * @request GET:/calendars/sync/events
     * @secure
     */ getSyncEventsForUser: function(query, params) {
                return _this.request("/calendars/sync/events".concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags calendarSyncEvents
     * @name getSyncEventsForCalendar
     * @request GET:/calendars/sync/events/{calendarId}
     * @secure
     */ getSyncEventsForCalendar: function(calendarId, query, params) {
                return _this.request("/calendars/sync/events/".concat(calendarId).concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags calendarSyncEvents
     * @name getSyncEventsForPolicy
     * @request GET:/calendars/sync/events/{sourceId}/to/{targetId}
     * @secure
     */ getSyncEventsForPolicy: function(sourceId, targetId, query, params) {
                return _this.request("/calendars/sync/events/".concat(sourceId, "/to/").concat(targetId).concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags calendars
     * @name interest
     * @request POST:/calendars/sync/interest
     */ interest: function(query, params) {
                return _this.request("/calendars/sync/interest".concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags calendars
     * @name getSourceCandidates
     * @request GET:/calendars/sync/{credentialId}/candidates/sources
     */ getSourceCandidates: function(credentialId, params) {
                return _this.request("/calendars/sync/".concat(credentialId, "/candidates/sources"), "GET", params);
            },
            /**
     * @tags calendars
     * @name getTargetCandidates
     * @request GET:/calendars/sync/{credentialId}/candidates/targets
     */ getTargetCandidates: function(credentialId, params) {
                return _this.request("/calendars/sync/".concat(credentialId, "/candidates/targets"), "GET", params);
            },
            /**
     * @tags calendars
     * @name getSync
     * @request GET:/calendars/sync/{id}
     */ getSync: function(id, params) {
                return _this.request("/calendars/sync/".concat(id), "GET", params);
            },
            /**
     * @tags calendars
     * @name deleteSync
     * @request DELETE:/calendars/sync/{id}
     */ deleteSync: function(id, params) {
                return _this.request("/calendars/sync/".concat(id), "DELETE", params);
            },
            /**
     * @tags calendars
     * @name watch
     * @request POST:/calendars/watch
     */ watch: function(params) {
                return _this.request("/calendars/watch", "POST", params);
            },
            /**
     * @tags calendars
     * @name listWatch
     * @summary Heads up! We have seen at least one case where Google can issue an excessive, unnatural amount of watch callbacks.
     * @request POST:/calendars/watchList
     * @description Heads up! We have seen at least one case where Google can issue an excessive, unnatural amount of watch callbacks. for more information. Specifically, BE CAREFUL adding any blocking IO code, such as web service calls or database queries, upstream of that job.
     */ listWatch: function(params) {
                return _this.request("/calendars/watchList", "POST", params);
            },
            /**
     * @tags calendars
     * @name settingsWatch
     * @request POST:/calendars/watchSettings
     */ settingsWatch: function(params) {
                return _this.request("/calendars/watchSettings", "POST", params);
            }
        };
        _this.clickup = {
            /**
     * @tags clickup, integration, private
     * @name integrations_1
     * @request GET:/clickup/integrations
     */ integrations1: function(params) {
                return _this.request("/clickup/integrations", "GET", params);
            },
            /**
     * @tags clickup, integration, private
     * @name deleteIntegration_1
     * @request DELETE:/clickup/integrations
     */ deleteIntegration1: function(params) {
                return _this.request("/clickup/integrations", "DELETE", params);
            },
            /**
     * @tags clickup, integration, private
     * @name clickUpIntegrationsDetails
     * @request GET:/clickup/integrations/details
     */ clickUpIntegrationsDetails: function(params) {
                return _this.request("/clickup/integrations/details", "GET", params);
            },
            /**
     * @tags clickup, integration, private
     * @name patchIntegration
     * @request PATCH:/clickup/integrations/{workspaceId}
     */ patchIntegration: function(workspaceId, data, params) {
                return _this.request("/clickup/integrations/".concat(workspaceId), "PATCH", params, data);
            }
        };
        _this.credentials = {
            /**
     * @tags credentials
     * @name list_1
     * @request GET:/credentials
     * @secure
     */ list1: function(query, params) {
                return _this.request("/credentials".concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags credentials
     * @name listPersonal
     * @request GET:/credentials/personal
     * @secure
     */ listPersonal: function(params) {
                return _this.request("/credentials/personal", "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags credentials
     * @name getPrimary_1
     * @request GET:/credentials/primary
     * @secure
     */ getPrimary1: function(params) {
                return _this.request("/credentials/primary", "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags credentials
     * @name get
     * @request GET:/credentials/{id}
     * @secure
     */ get: function(id, params) {
                return _this.request("/credentials/".concat(id), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags credentials
     * @name delete_2
     * @request DELETE:/credentials/{id}
     */ delete2: function(id, params) {
                return _this.request("/credentials/".concat(id), "DELETE", params);
            }
        };
        _this.events = {
            /**
     * @tags events
     * @name query
     * @request GET:/events
     */ query: function(query, params) {
                return _this.request("/events".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags events
     * @name getPersonal_1
     * @request GET:/events/personal
     */ getPersonal1: function(query, params) {
                return _this.request("/events/personal".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags events
     * @name queryGoogleRaw
     * @request GET:/events/raw-google/{credentialId}/{calendarId}
     */ queryGoogleRaw: function(credentialId, calendarId, query, params) {
                return _this.request("/events/raw-google/".concat(credentialId, "/").concat(calendarId).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags events
     * @name fetchGoogleRaw
     * @request GET:/events/raw-google/{credentialId}/{calendarId}/{eventId}
     */ fetchGoogleRaw: function(credentialId, calendarId, eventId, query, params) {
                return _this.request("/events/raw-google/".concat(credentialId, "/").concat(calendarId, "/").concat(eventId).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags events
     * @name gcalViewRedirect
     * @request GET:/events/view/{calendarId}/{eventId}
     */ gcalViewRedirect: function(calendarId, eventId, query, params) {
                return _this.request("/events/view/".concat(calendarId, "/").concat(eventId).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags events
     * @name getForCalendar
     * @request GET:/events/{calendarId}/{eventId}
     */ getForCalendar: function(calendarId, eventId, query, params) {
                return _this.request("/events/".concat(calendarId, "/").concat(eventId).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags events
     * @name adjustConferenceBuffer
     * @request POST:/events/{calendarId}/{eventId}/buffer
     */ adjustConferenceBuffer: function(calendarId, eventId, query, params) {
                return _this.request("/events/".concat(calendarId, "/").concat(eventId, "/buffer").concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags events
     * @name adjustPriority
     * @request POST:/events/{calendarId}/{eventId}/priority
     */ adjustPriority: function(calendarId, eventId, query, params) {
                return _this.request("/events/".concat(calendarId, "/").concat(eventId, "/priority").concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags events
     * @name adjustTravelTime
     * @request POST:/events/{calendarId}/{eventId}/travel/{type}
     */ adjustTravelTime: function(calendarId, eventId, type, query, params) {
                return _this.request("/events/".concat(calendarId, "/").concat(eventId, "/travel/").concat(type).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags events
     * @name get_1
     * @request GET:/events/{eventId}
     */ get1: function(eventId, query, params) {
                return _this.request("/events/".concat(eventId).concat(_this.addQueryParams(query)), "GET", params);
            }
        };
        _this.googleAddOn = {
            /**
     * @tags google-add-on, integration, private
     * @name addHtmlToEmail
     * @request POST:/google-add-on/add-html-to-email
     */ addHtmlToEmail: function(data, params) {
                return _this.request("/google-add-on/add-html-to-email", "POST", params, data);
            },
            /**
     * @tags google-add-on, integration, private
     * @name integrations_2
     * @request GET:/google-add-on/integrations
     */ integrations2: function(params) {
                return _this.request("/google-add-on/integrations", "GET", params);
            }
        };
        _this.integrations = {
            /**
     * @tags integration, private
     * @name enabled
     * @request GET:/integrations/enabled
     */ enabled: function(params) {
                return _this.request("/integrations/enabled", "GET", params);
            },
            /**
     * @name getZoomIntegration
     * @request GET:/integrations/zoom
     * @secure
     */ getZoomIntegration: function(params) {
                return _this.request("/integrations/zoom", "GET", params, null, BodyType.Json, true);
            },
            /**
     * @name deleteZoomToken
     * @request DELETE:/integrations/zoom
     */ deleteZoomToken: function(data, params) {
                return _this.request("/integrations/zoom", "DELETE", params, data);
            }
        };
        _this.interpreter = {
            /**
     * @name message
     * @request POST:/interpreter/message
     */ message: function(data, params) {
                return _this.request("/interpreter/message", "POST", params, data);
            },
            /**
     * @name fetchMessage
     * @request GET:/interpreter/plans/pending/{planId}
     * @secure
     */ fetchMessage: function(planId, params) {
                return _this.request("/interpreter/plans/pending/".concat(planId), "GET", params, null, BodyType.Json, true);
            }
        };
        _this.invite = {
            /**
     * @tags invite
     * @name resolve
     * @request GET:/invite/{trackingCode}
     */ resolve: function(trackingCode, params) {
                return _this.request("/invite/".concat(trackingCode), "GET", params);
            }
        };
        _this.jira = {
            /**
     * @tags integration, jira, private
     * @name integrations_3
     * @request GET:/jira/integrations
     */ integrations3: function(params) {
                return _this.request("/jira/integrations", "GET", params);
            },
            /**
     * @tags integration, jira, private
     * @name deleteIntegration_2
     * @request DELETE:/jira/integrations/{id}
     */ deleteIntegration2: function(id, params) {
                return _this.request("/jira/integrations/".concat(id), "DELETE", params);
            },
            /**
     * @tags integration, jira, private
     * @name patchIntegration_1
     * @request PATCH:/jira/integrations/{id}
     */ patchIntegration1: function(id, data, params) {
                return _this.request("/jira/integrations/".concat(id), "PATCH", params, data);
            }
        };
        _this.linear = {
            /**
     * @tags integration, linear, private
     * @name integrations_4
     * @request GET:/linear/integrations
     */ integrations4: function(params) {
                return _this.request("/linear/integrations", "GET", params);
            },
            /**
     * @tags integration, linear, private
     * @name deleteIntegration_3
     * @request DELETE:/linear/integrations/{id}
     */ deleteIntegration3: function(id, params) {
                return _this.request("/linear/integrations/".concat(id), "DELETE", params);
            },
            /**
     * @tags integration, linear, private
     * @name patchIntegration_2
     * @request PATCH:/linear/integrations/{id}
     */ patchIntegration2: function(id, data, params) {
                return _this.request("/linear/integrations/".concat(id), "PATCH", params, data);
            },
            /**
     * @tags integration, linear, private
     * @name issueDetails
     * @request GET:/linear/issue/{id}
     */ issueDetails: function(id, params) {
                return _this.request("/linear/issue/".concat(id), "GET", params);
            }
        };
        _this.moment = {
            /**
     * @tags moment
     * @name get_2
     * @request GET:/moment
     */ get2: function(params) {
                return _this.request("/moment", "GET", params);
            },
            /**
     * @tags moment
     * @name next
     * @request GET:/moment/next
     */ next: function(params) {
                return _this.request("/moment/next", "GET", params);
            }
        };
        _this.ok = {
            /**
     * @name ok
     * @request GET:/ok
     */ ok: function(query, params) {
                return _this.request("/ok".concat(_this.addQueryParams(query)), "GET", params);
            }
        };
        _this.oneOnOne = {
            /**
     * @tags oneOnOnes
     * @name getOneOnOnes
     * @request GET:/oneOnOne
     */ getOneOnOnes: function(query, params) {
                return _this.request("/oneOnOne".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags oneOnOnes
     * @name createOnOnOne
     * @request POST:/oneOnOne
     */ createOnOnOne: function(data, query, params) {
                return _this.request("/oneOnOne".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags oneOnOnes
     * @name convertPendingToAuto
     * @request POST:/oneOnOne/convert-auto/{id}
     */ convertPendingToAuto: function(id, query, params) {
                return _this.request("/oneOnOne/convert-auto/".concat(id).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags oneOnOnes
     * @name getDetected
     * @request GET:/oneOnOne/detected
     */ getDetected: function(params) {
                return _this.request("/oneOnOne/detected", "GET", params);
            },
            /**
     * @tags oneOnOnes
     * @name respond
     * @request POST:/oneOnOne/invite/{id}/respond
     */ respond: function(id, data, query, params) {
                return _this.request("/oneOnOne/invite/".concat(id, "/respond").concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags oneOnOnes
     * @name respondAnonymously
     * @request POST:/oneOnOne/invite/{id}/respond/{inviteKey}
     */ respondAnonymously: function(id, inviteKey, data, query, params) {
                return _this.request("/oneOnOne/invite/".concat(id, "/respond/").concat(inviteKey).concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags oneOnOnes
     * @name getInviteeEligibility
     * @request GET:/oneOnOne/invitee-eligibility
     */ getInviteeEligibility: function(query, params) {
                return _this.request("/oneOnOne/invitee-eligibility".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags oneOnOnes
     * @name getMeetingInvites
     * @request GET:/oneOnOne/invites
     */ getMeetingInvites: function(query, params) {
                return _this.request("/oneOnOne/invites".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags oneOnOnes
     * @name getMeetingInvite
     * @request GET:/oneOnOne/invites/{id}
     */ getMeetingInvite: function(id, query, params) {
                return _this.request("/oneOnOne/invites/".concat(id).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags oneOnOnes
     * @name getSuggestions
     * @request GET:/oneOnOne/suggestions
     */ getSuggestions: function(params) {
                return _this.request("/oneOnOne/suggestions", "GET", params);
            },
            /**
     * @tags oneOnOnes
     * @name zoomRedirect
     * @request GET:/oneOnOne/zoom/{trackingCode}/{oneOnOneId}
     */ zoomRedirect: function(trackingCode, oneOnOneId, params) {
                return _this.request("/oneOnOne/zoom/".concat(trackingCode, "/").concat(oneOnOneId), "GET", params);
            },
            /**
     * @tags oneOnOnes
     * @name getOneOnOne
     * @request GET:/oneOnOne/{id}
     */ getOneOnOne: function(id, query, params) {
                return _this.request("/oneOnOne/".concat(id).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags oneOnOnes
     * @name deleteOneOnOne
     * @request DELETE:/oneOnOne/{id}
     */ deleteOneOnOne: function(id, query, params) {
                return _this.request("/oneOnOne/".concat(id).concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags oneOnOnes
     * @name patchOneOnOne
     * @request PATCH:/oneOnOne/{id}
     */ patchOneOnOne: function(id, data, query, params) {
                return _this.request("/oneOnOne/".concat(id).concat(_this.addQueryParams(query)), "PATCH", params, data);
            },
            /**
     * @tags oneOnOnes
     * @name getInstances
     * @request GET:/oneOnOne/{oneOnOneId}/instances
     * @secure
     */ getInstances: function(oneOnOneId, params) {
                return _this.request("/oneOnOne/".concat(oneOnOneId, "/instances"), "GET", params, null, BodyType.Json, true);
            }
        };
        _this.partnerstack = {
            /**
     * @tags integration, partnerstack, private
     * @name createAnonymousPartner
     * @request POST:/partnerstack/anonymous/partners/{email}
     */ createAnonymousPartner: function(email, params) {
                return _this.request("/partnerstack/anonymous/partners/".concat(email), "POST", params);
            }
        };
        _this.people = {
            /**
     * @tags people
     * @name search
     * @request GET:/people
     * @secure
     */ search: function(query, params) {
                return _this.request("/people".concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags people, private
     * @name unsubscribe
     * @request DELETE:/people/subscriptions
     */ unsubscribe: function(query, params) {
                return _this.request("/people/subscriptions".concat(_this.addQueryParams(query)), "DELETE", params);
            }
        };
        _this.planner = {
            /**
     * @tags actions
     * @name addTime
     * @request POST:/planner/add-time/task/{taskId}
     */ addTime: function(taskId, query, params) {
                return _this.request("/planner/add-time/task/".concat(taskId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name clearHabitTimePolicyExceptions
     * @request POST:/planner/clear-exceptions/habit/{habitId}
     */ clearHabitTimePolicyExceptions: function(habitId, query, params) {
                return _this.request("/planner/clear-exceptions/habit/".concat(habitId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name clearOneOnOneTimePolicyExceptions
     * @request POST:/planner/clear-exceptions/one-on-one/{oneOnOneId}
     */ clearOneOnOneTimePolicyExceptions: function(oneOnOneId, query, params) {
                return _this.request("/planner/clear-exceptions/one-on-one/".concat(oneOnOneId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name clearTaskTimePolicyExceptions
     * @request POST:/planner/clear-exceptions/task/{taskId}
     */ clearTaskTimePolicyExceptions: function(taskId, query, params) {
                return _this.request("/planner/clear-exceptions/task/".concat(taskId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name doneHabit
     * @request POST:/planner/done/habit/{habitId}
     */ doneHabit: function(habitId, query, params) {
                return _this.request("/planner/done/habit/".concat(habitId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name doneTask
     * @request POST:/planner/done/task/{taskId}
     */ doneTask: function(taskId, query, params) {
                return _this.request("/planner/done/task/".concat(taskId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name changeCategory
     * @request PUT:/planner/event/category/{calendarId}/{eventId}
     */ changeCategory: function(calendarId, eventId, query, params) {
                return _this.request("/planner/event/category/".concat(calendarId, "/").concat(eventId).concat(_this.addQueryParams(query)), "PUT", params);
            },
            /**
     * @tags actions
     * @name moveEvent
     * @summary Event Actions
     * @request POST:/planner/event/move/{eventId}
     * @description Event Actions
     */ moveEvent: function(eventId, query, params) {
                return _this.request("/planner/event/move/".concat(eventId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name pinEvent
     * @request POST:/planner/event/pin/{eventId}
     */ pinEvent: function(eventId, query, params) {
                return _this.request("/planner/event/pin/".concat(eventId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name rsvp
     * @request PUT:/planner/event/rsvp/{calendarId}/{eventId}
     */ rsvp: function(calendarId, eventId, data, query, params) {
                return _this.request("/planner/event/rsvp/".concat(calendarId, "/").concat(eventId).concat(_this.addQueryParams(query)), "PUT", params, data);
            },
            /**
     * @tags actions
     * @name unpinEvent
     * @request POST:/planner/event/unpin/{eventId}
     */ unpinEvent: function(eventId, data, params) {
                return _this.request("/planner/event/unpin/".concat(eventId), "POST", params, data);
            },
            /**
     * @tags actions
     * @name habitDeleteInstanceAndReschedule
     * @request POST:/planner/habit/{calendarId}/{eventId}/reschedule
     */ habitDeleteInstanceAndReschedule: function(calendarId, eventId, query, params) {
                return _this.request("/planner/habit/".concat(calendarId, "/").concat(eventId, "/reschedule").concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name logWork
     * @request POST:/planner/log-work/task/{taskId}
     */ logWork: function(taskId, query, params) {
                return _this.request("/planner/log-work/task/".concat(taskId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name migrateToPrioritySystem
     * @request POST:/planner/migration/priorities
     */ migrateToPrioritySystem: function(params) {
                return _this.request("/planner/migration/priorities", "POST", params);
            },
            /**
     * @tags actions
     * @name oneOnOneReschedule
     * @request POST:/planner/one-on-one/reschedule/{oneOnOneId}/{eventId}
     */ oneOnOneReschedule: function(oneOnOneId, eventId, data, params) {
                return _this.request("/planner/one-on-one/reschedule/".concat(oneOnOneId, "/").concat(eventId), "POST", params, data);
            },
            /**
     * @tags actions
     * @name oneOnOneSkipDay
     * @request POST:/planner/one-on-one/skip-day/{oneOnOneId}/{eventId}
     */ oneOnOneSkipDay: function(oneOnOneId, eventId, data, params) {
                return _this.request("/planner/one-on-one/skip-day/".concat(oneOnOneId, "/").concat(eventId), "POST", params, data);
            },
            /**
     * @tags actions
     * @name oneOnOneSkipUntil
     * @request POST:/planner/one-on-one/skip-until/{oneOnOneId}/{eventId}
     */ oneOnOneSkipUntil: function(oneOnOneId, eventId, data, params) {
                return _this.request("/planner/one-on-one/skip-until/".concat(oneOnOneId, "/").concat(eventId), "POST", params, data);
            },
            /**
     * @tags actions
     * @name oneOnOneSkipWeek
     * @request POST:/planner/one-on-one/skip-week/{oneOnOneId}/{eventId}
     */ oneOnOneSkipWeek: function(oneOnOneId, eventId, data, params) {
                return _this.request("/planner/one-on-one/skip-week/".concat(oneOnOneId, "/").concat(eventId), "POST", params, data);
            },
            /**
     * @tags actions
     * @name deleteHabitPolicy
     * @request DELETE:/planner/policy/habit/{habitId}
     */ deleteHabitPolicy: function(habitId, query, params) {
                return _this.request("/planner/policy/habit/".concat(habitId).concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags actions
     * @name deleteTaskPolicy
     * @summary Task Actions
     * @request DELETE:/planner/policy/task/{taskId}
     * @description Task Actions
     */ deleteTaskPolicy: function(taskId, query, params) {
                return _this.request("/planner/policy/task/".concat(taskId).concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags actions
     * @name prioritizeTask
     * @request POST:/planner/prioritize/task/{taskId}
     */ prioritizeTask: function(taskId, params) {
                return _this.request("/planner/prioritize/task/".concat(taskId), "POST", params);
            },
            /**
     * @tags actions
     * @name rescheduleHabitEvent
     * @request POST:/planner/reschedule/habit/event/{eventId}
     */ rescheduleHabitEvent: function(eventId, query, params) {
                return _this.request("/planner/reschedule/habit/event/".concat(eventId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name rescheduleTaskEvent
     * @request POST:/planner/reschedule/task/event/{eventId}
     */ rescheduleTaskEvent: function(eventId, query, params) {
                return _this.request("/planner/reschedule/task/event/".concat(eventId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name restartHabit
     * @request POST:/planner/restart/habit/{habitId}
     */ restartHabit: function(habitId, query, params) {
                return _this.request("/planner/restart/habit/".concat(habitId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name restartTask
     * @request POST:/planner/restart/task/{taskId}
     */ restartTask: function(taskId, query, params) {
                return _this.request("/planner/restart/task/".concat(taskId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name skipHabitEvent
     * @request POST:/planner/skip/habit/event/{eventId}
     */ skipHabitEvent: function(eventId, query, params) {
                return _this.request("/planner/skip/habit/event/".concat(eventId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name startHabit
     * @summary Habit Actions
     * @request POST:/planner/start/habit/{habitId}
     * @description Habit Actions
     */ startHabit: function(habitId, query, params) {
                return _this.request("/planner/start/habit/".concat(habitId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name startTask
     * @request POST:/planner/start/task/{taskId}
     */ startTask: function(taskId, query, params) {
                return _this.request("/planner/start/task/".concat(taskId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name stopHabit
     * @request POST:/planner/stop/habit/{habitId}
     */ stopHabit: function(habitId, query, params) {
                return _this.request("/planner/stop/habit/".concat(habitId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name stopTask
     * @request POST:/planner/stop/task/{taskId}
     */ stopTask: function(taskId, query, params) {
                return _this.request("/planner/stop/task/".concat(taskId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name taskDeleteMultipleInstanceAndReschedule
     * @request POST:/planner/task/reschedule/bulk
     */ taskDeleteMultipleInstanceAndReschedule: function(data, query, params) {
                return _this.request("/planner/task/reschedule/bulk".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags actions
     * @name taskDeleteInstanceAndReschedule
     * @request POST:/planner/task/{calendarId}/{eventId}/reschedule
     */ taskDeleteInstanceAndReschedule: function(calendarId, eventId, query, params) {
                return _this.request("/planner/task/".concat(calendarId, "/").concat(eventId, "/reschedule").concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name taskClearSnooze
     * @request POST:/planner/task/{taskId}/clear-snooze
     */ taskClearSnooze: function(taskId, query, params) {
                return _this.request("/planner/task/".concat(taskId, "/clear-snooze").concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name toggleHabit
     * @request POST:/planner/toggle/habit/{habitId}
     */ toggleHabit: function(habitId, query, params) {
                return _this.request("/planner/toggle/habit/".concat(habitId).concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags actions
     * @name unarchiveTask
     * @request POST:/planner/unarchive/task/{taskId}
     */ unarchiveTask: function(taskId, query, params) {
                return _this.request("/planner/unarchive/task/".concat(taskId).concat(_this.addQueryParams(query)), "POST", params);
            }
        };
        _this.projects = {
            /**
     * @tags projects
     * @name query_1
     * @request GET:/projects
     */ query1: function(query, params) {
                return _this.request("/projects".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags projects
     * @name create_1
     * @request POST:/projects
     */ create1: function(data, params) {
                return _this.request("/projects", "POST", params, data);
            },
            /**
     * @tags projects
     * @name get_3
     * @request GET:/projects/{id}
     */ get3: function(id, params) {
                return _this.request("/projects/".concat(id), "GET", params);
            },
            /**
     * @tags projects
     * @name put
     * @request PUT:/projects/{id}
     */ put: function(id, data, params) {
                return _this.request("/projects/".concat(id), "PUT", params, data);
            },
            /**
     * @tags projects
     * @name delete_3
     * @request DELETE:/projects/{id}
     */ delete3: function(id, params) {
                return _this.request("/projects/".concat(id), "DELETE", params);
            },
            /**
     * @tags projects
     * @name patch_1
     * @request PATCH:/projects/{id}
     */ patch1: function(id, data, params) {
                return _this.request("/projects/".concat(id), "PATCH", params, data);
            },
            /**
     * @tags projects
     * @name getEvents
     * @request GET:/projects/{id}/events
     */ getEvents: function(id, params) {
                return _this.request("/projects/".concat(id, "/events"), "GET", params);
            },
            /**
     * @tags projects
     * @name getTasks
     * @request GET:/projects/{id}/tasks
     */ getTasks: function(id, params) {
                return _this.request("/projects/".concat(id, "/tasks"), "GET", params);
            },
            /**
     * @tags projects
     * @name associateEvent
     * @request POST:/projects/{projectId}/events/{calendarId}/{eventId}
     */ associateEvent: function(projectId, calendarId, eventId, params) {
                return _this.request("/projects/".concat(projectId, "/events/").concat(calendarId, "/").concat(eventId), "POST", params);
            },
            /**
     * @tags projects
     * @name disassociateEvent
     * @request DELETE:/projects/{projectId}/events/{calendarId}/{eventId}
     */ disassociateEvent: function(projectId, calendarId, eventId, params) {
                return _this.request("/projects/".concat(projectId, "/events/").concat(calendarId, "/").concat(eventId), "DELETE", params);
            },
            /**
     * @tags projects
     * @name associateTask
     * @request POST:/projects/{projectId}/tasks/{taskId}
     */ associateTask: function(projectId, taskId, params) {
                return _this.request("/projects/".concat(projectId, "/tasks/").concat(taskId), "POST", params);
            },
            /**
     * @tags projects
     * @name disassociateTask
     * @request DELETE:/projects/{projectId}/tasks/{taskId}
     */ disassociateTask: function(projectId, taskId, params) {
                return _this.request("/projects/".concat(projectId, "/tasks/").concat(taskId), "DELETE", params);
            }
        };
        _this.resources = {
            /**
     * @tags resources
     * @name getResources
     * @request GET:/resources
     * @secure
     */ getResources: function(params) {
                return _this.request("/resources", "GET", params, null, BodyType.Json, true);
            }
        };
        _this.scoring = {
            /**
     * @tags scoring
     * @name rescore
     * @request POST:/scoring/rescore
     */ rescore: function(params) {
                return _this.request("/scoring/rescore", "POST", params);
            }
        };
        _this.slack = {
            /**
     * @tags integration, private, slack
     * @name actionEndpoint
     * @request POST:/slack/action-endpoint
     */ actionEndpoint: function(params) {
                return _this.request("/slack/action-endpoint", "POST", params);
            },
            /**
     * @tags integration, private, slack
     * @name slackRedirect
     * @request GET:/slack/add
     */ slackRedirect: function(query, params) {
                return _this.request("/slack/add".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags integration, private, slack
     * @name command
     * @request POST:/slack/command
     */ command: function(params) {
                return _this.request("/slack/command", "POST", params);
            },
            /**
     * @tags integration, private, slack
     * @name connect
     * @request GET:/slack/connect
     */ connect: function(query, params) {
                return _this.request("/slack/connect".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags integration, private, slack
     * @name interactiveEndpoint
     * @request POST:/slack/interactive-endpoint
     */ interactiveEndpoint: function(params) {
                return _this.request("/slack/interactive-endpoint", "POST", params);
            },
            /**
     * @tags integration, private, slack
     * @name link
     * @request POST:/slack/link
     */ link: function(query, data, params) {
                return _this.request("/slack/link".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags integration, private, slack
     * @name optionsLoadEndpoint
     * @request POST:/slack/options-load-endpoint
     */ optionsLoadEndpoint: function(data, params) {
                return _this.request("/slack/options-load-endpoint", "POST", params, data);
            }
        };
        _this.sso = {
            /**
     * @tags actions
     * @name findProvider
     * @request GET:/sso/provider/{email}
     */ findProvider: function(email, params) {
                return _this.request("/sso/provider/".concat(email), "GET", params);
            }
        };
        _this.tasks = {
            /**
     * @tags tasks
     * @name query_2
     * @request GET:/tasks
     * @secure
     */ query2: function(query, params) {
                return _this.request("/tasks".concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags tasks
     * @name create_2
     * @request POST:/tasks
     */ create2: function(data, query, params) {
                return _this.request("/tasks".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags tasks
     * @name interest_1
     * @request POST:/tasks/interest
     */ interest1: function(data, params) {
                return _this.request("/tasks/interest", "POST", params, data);
            },
            /**
     * @tags tasks
     * @name findMinIndex
     * @request GET:/tasks/min-index
     * @secure
     */ findMinIndex: function(params) {
                return _this.request("/tasks/min-index", "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags tasks
     * @name reindexByDue
     * @request PATCH:/tasks/reindex-by-due
     */ reindexByDue: function(params) {
                return _this.request("/tasks/reindex-by-due", "PATCH", params);
            },
            /**
     * @tags tasks
     * @name getTask
     * @request GET:/tasks/{id}
     * @secure
     */ getTask: function(id, query, params) {
                return _this.request("/tasks/".concat(id).concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags tasks
     * @name delete_4
     * @request DELETE:/tasks/{id}
     */ delete4: function(id, query, params) {
                return _this.request("/tasks/".concat(id).concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags tasks
     * @name put_1
     * @request PUT:/tasks/{taskId}
     */ put1: function(taskId, data, query, params) {
                return _this.request("/tasks/".concat(taskId).concat(_this.addQueryParams(query)), "PUT", params, data);
            },
            /**
     * @tags tasks
     * @name patch_2
     * @request PATCH:/tasks/{taskId}
     */ patch2: function(taskId, data, query, params) {
                return _this.request("/tasks/".concat(taskId).concat(_this.addQueryParams(query)), "PATCH", params, data);
            },
            /**
     * @tags tasks
     * @name getInstances_1
     * @request GET:/tasks/{taskId}/instances
     * @secure
     */ getInstances1: function(taskId, params) {
                return _this.request("/tasks/".concat(taskId, "/instances"), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags tasks
     * @name updateInstance
     * @request PATCH:/tasks/{taskId}/instances/{index}
     */ updateInstance: function(taskId, index, data, query, params) {
                return _this.request("/tasks/".concat(taskId, "/instances/").concat(index).concat(_this.addQueryParams(query)), "PATCH", params, data);
            },
            /**
     * @tags tasks
     * @name reindex
     * @request PATCH:/tasks/{taskId}/reindex
     */ reindex: function(taskId, data, params) {
                return _this.request("/tasks/".concat(taskId, "/reindex"), "PATCH", params, data);
            }
        };
        _this.timescheme = {
            /**
     * @tags time-scheme-rules
     * @name listRules
     * @request GET:/timescheme/rules
     */ listRules: function(query, params) {
                return _this.request("/timescheme/rules".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags time-scheme-rules
     * @name createRule
     * @request POST:/timescheme/rules
     */ createRule: function(data, params) {
                return _this.request("/timescheme/rules", "POST", params, data);
            },
            /**
     * @tags time-scheme-rules
     * @name deleteRule
     * @request DELETE:/timescheme/rules/{ruleId}
     */ deleteRule: function(ruleId, params) {
                return _this.request("/timescheme/rules/".concat(ruleId), "DELETE", params);
            },
            /**
     * @tags time-scheme-rules
     * @name updateRule
     * @request PATCH:/timescheme/rules/{ruleId}
     */ updateRule: function(ruleId, data, params) {
                return _this.request("/timescheme/rules/".concat(ruleId), "PATCH", params, data);
            },
            /**
     * @tags time-scheme-rules
     * @name reindex_1
     * @request PATCH:/timescheme/rules/{ruleId}/reindex
     */ reindex1: function(ruleId, data, params) {
                return _this.request("/timescheme/rules/".concat(ruleId, "/reindex"), "PATCH", params, data);
            }
        };
        _this.timeschemes = {
            /**
     * @tags time-scheme
     * @name listTimePolicySchemes
     * @request GET:/timeschemes
     */ listTimePolicySchemes: function(query, params) {
                return _this.request("/timeschemes".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags time-scheme
     * @name createTimeScheme
     * @request POST:/timeschemes
     */ createTimeScheme: function(data, params) {
                return _this.request("/timeschemes", "POST", params, data);
            },
            /**
     * @tags time-scheme
     * @name queryTimePolicySchemesByUserIdAndFeature
     * @request GET:/timeschemes/filter-by-feature
     */ queryTimePolicySchemesByUserIdAndFeature: function(query, params) {
                return _this.request("/timeschemes/filter-by-feature".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags time-scheme
     * @name listTimePolicySchemesByUserIdAndFeature
     * @request GET:/timeschemes/filter-by-feature/{userId}
     */ listTimePolicySchemesByUserIdAndFeature: function(userId, query, params) {
                return _this.request("/timeschemes/filter-by-feature/".concat(userId).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags time-scheme
     * @name updateTimeScheme
     * @request GET:/timeschemes/{schemeId}
     */ updateTimeScheme: function(schemeId, params) {
                return _this.request("/timeschemes/".concat(schemeId), "GET", params);
            },
            /**
     * @tags time-scheme
     * @name deleteTimeScheme
     * @request DELETE:/timeschemes/{schemeId}
     */ deleteTimeScheme: function(schemeId, query, params) {
                return _this.request("/timeschemes/".concat(schemeId).concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags time-scheme
     * @name updateTimeScheme_1
     * @request PATCH:/timeschemes/{schemeId}
     */ updateTimeScheme1: function(schemeId, data, params) {
                return _this.request("/timeschemes/".concat(schemeId), "PATCH", params, data);
            }
        };
        _this.todoist = {
            /**
     * @tags integration, private, todoist
     * @name integrations_5
     * @request GET:/todoist/integrations
     */ integrations5: function(params) {
                return _this.request("/todoist/integrations", "GET", params);
            },
            /**
     * @tags integration, private, todoist
     * @name integrationsDetails
     * @request GET:/todoist/integrations/details
     */ integrationsDetails: function(params) {
                return _this.request("/todoist/integrations/details", "GET", params);
            },
            /**
     * @tags integration, private, todoist
     * @name deleteIntegration_4
     * @request DELETE:/todoist/integrations/{id}
     */ deleteIntegration4: function(id, params) {
                return _this.request("/todoist/integrations/".concat(id), "DELETE", params);
            },
            /**
     * @tags integration, private, todoist
     * @name patchIntegration_3
     * @request PATCH:/todoist/integrations/{id}
     */ patchIntegration3: function(id, data, params) {
                return _this.request("/todoist/integrations/".concat(id), "PATCH", params, data);
            }
        };
        _this.users = {
            /**
     * @tags users
     * @name current
     * @summary User details for the currently authenticated user
     * @request GET:/users/current
     * @description User details for the currently authenticated user
     */ current: function(params) {
                return _this.request("/users/current", "GET", params);
            },
            /**
     * @tags users
     * @name delete_5
     * @request DELETE:/users/current
     */ delete5: function(params) {
                return _this.request("/users/current", "DELETE", params);
            },
            /**
     * @tags users
     * @name patch_3
     * @request PATCH:/users/current
     */ patch3: function(data, params) {
                return _this.request("/users/current", "PATCH", params, data);
            },
            /**
     * @tags contacts
     * @name getContacts
     * @request GET:/users/current/contacts
     * @secure
     */ getContacts: function(params) {
                return _this.request("/users/current/contacts", "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags contacts
     * @name inviteContacts
     * @request POST:/users/current/contacts/invite
     */ inviteContacts: function(data, params) {
                return _this.request("/users/current/contacts/invite", "POST", params, data);
            },
            /**
     * @tags contacts
     * @name inviteContactsV2
     * @request POST:/users/current/contacts/invite/v2
     */ inviteContactsV2: function(data, params) {
                return _this.request("/users/current/contacts/invite/v2", "POST", params, data);
            },
            /**
     * @tags contacts
     * @name topContacts
     * @request GET:/users/current/contacts/top-contacts
     * @secure
     */ topContacts: function(query, params) {
                return _this.request("/users/current/contacts/top-contacts".concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags contacts
     * @name getContactsV2
     * @request GET:/users/current/contacts/v2
     * @secure
     */ getContactsV2: function(query, params) {
                return _this.request("/users/current/contacts/v2".concat(_this.addQueryParams(query)), "GET", params, null, BodyType.Json, true);
            },
            /**
     * @tags users
     * @name onboarded
     * @request POST:/users/current/onboarded
     */ onboarded: function(data, query, params) {
                return _this.request("/users/current/onboarded".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags users
     * @name productUsage
     * @request GET:/users/current/product-usage
     */ productUsage: function(params) {
                return _this.request("/users/current/product-usage", "GET", params);
            },
            /**
     * @tags users
     * @name hardDowngrade
     * @request POST:/users/current/product-usage/hard-downgrade
     */ hardDowngrade: function(params) {
                return _this.request("/users/current/product-usage/hard-downgrade", "POST", params);
            },
            /**
     * @tags quest
     * @name getCompletedQuests
     * @request GET:/users/current/quest
     */ getCompletedQuests: function(params) {
                return _this.request("/users/current/quest", "GET", params);
            },
            /**
     * @tags quest
     * @name completeQuest
     * @request PATCH:/users/current/quest
     */ completeQuest: function(data, params) {
                return _this.request("/users/current/quest", "PATCH", params, data);
            },
            /**
     * @tags users
     * @name referrals
     * @request GET:/users/current/referrals
     */ referrals: function(params) {
                return _this.request("/users/current/referrals", "GET", params);
            },
            /**
     * @tags users
     * @name claimRewards
     * @request POST:/users/current/rewards
     */ claimRewards: function(query, params) {
                return _this.request("/users/current/rewards".concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags timePolicies
     * @name get_4
     * @request GET:/users/current/timePolicies
     */ get4: function(params) {
                return _this.request("/users/current/timePolicies", "GET", params);
            },
            /**
     * @tags timePolicies
     * @name patch_4
     * @request PATCH:/users/current/timePolicies
     */ patch4: function(data, params) {
                return _this.request("/users/current/timePolicies", "PATCH", params, data);
            },
            /**
     * @tags users
     * @name interest_2
     * @request POST:/users/interest
     */ interest2: function(query, params) {
                return _this.request("/users/interest".concat(_this.addQueryParams(query)), "POST", params);
            },
            /**
     * @tags users
     * @name addTrait
     * @request POST:/users/trait/{trait}
     */ addTrait: function(trait, params) {
                return _this.request("/users/trait/".concat(trait), "POST", params);
            }
        };
        _this.weeklyReport = {
            /**
     * @tags weekly-report
     * @name social
     * @request GET:/weekly-report/social
     */ social: function(query, params) {
                return _this.request("/weekly-report/social".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags weekly-report
     * @name socialImage
     * @request GET:/weekly-report/social/{id}.png
     */ socialImage: function(id, params) {
                return _this.request("/weekly-report/social/".concat(id, ".png"), "GET", params);
            },
            /**
     * @tags weekly-report
     * @name socialImageAlt
     * @request GET:/weekly-report/social/{trackingCode}/{suffix}.png
     */ socialImageAlt: function(trackingCode, suffix, params) {
                return _this.request("/weekly-report/social/".concat(trackingCode, "/").concat(suffix, ".png"), "GET", params);
            },
            /**
     * @tags weekly-report
     * @name unsubscribe_1
     * @request POST:/weekly-report/unsubscribe
     */ unsubscribe1: function(data, params) {
                return _this.request("/weekly-report/unsubscribe", "POST", params, data);
            }
        };
        _this.avatar = {
            /**
     * @name credential
     * @request GET:/avatar/credential/{credentialId}
     */ credential: function(credentialId, params) {
                return _this.request("/avatar/credential/".concat(credentialId), "GET", params);
            },
            /**
     * @name avatar
     * @request GET:/avatar/lookup
     */ avatar: function(query, params) {
                return _this.request("/avatar/lookup".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @name me
     * @request GET:/avatar/me
     */ me: function(params) {
                return _this.request("/avatar/me", "GET", params);
            }
        };
        _this.aws = {
            /**
     * @tags aws-ses
     * @name sesEvent
     * @request POST:/aws/ses/events
     */ sesEvent: function(data, params) {
                return _this.request("/aws/ses/events", "POST", params, data);
            }
        };
        _this.oauth = {
            /**
     * @name accountInit
     * @request GET:/oauth/zoom/account/init
     */ accountInit: function(params) {
                return _this.request("/oauth/zoom/account/init", "GET", params);
            },
            /**
     * @name initZoom
     * @request GET:/oauth/zoom/init
     */ initZoom: function(query, params) {
                return _this.request("/oauth/zoom/init".concat(_this.addQueryParams(query)), "GET", params);
            }
        };
        _this.scim = {
            /**
     * @name getGroups
     * @request GET:/scim/v2/Groups
     */ getGroups: function(params) {
                return _this.request("/scim/v2/Groups", "GET", params);
            },
            /**
     * @name getResourceTypes
     * @request GET:/scim/v2/ResourceTypes
     */ getResourceTypes: function(params) {
                return _this.request("/scim/v2/ResourceTypes", "GET", params);
            },
            /**
     * @name getSchemas
     * @request GET:/scim/v2/Schemas
     */ getSchemas: function(params) {
                return _this.request("/scim/v2/Schemas", "GET", params);
            },
            /**
     * @name getServiceProvider
     * @request GET:/scim/v2/ServiceProvider
     */ getServiceProvider: function(params) {
                return _this.request("/scim/v2/ServiceProvider", "GET", params);
            },
            /**
     * @name getUsers
     * @request GET:/scim/v2/Users
     */ getUsers: function(query, params) {
                return _this.request("/scim/v2/Users".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @name putUser
     * @request PUT:/scim/v2/Users
     */ putUser: function(data, params) {
                return _this.request("/scim/v2/Users", "PUT", params, data);
            },
            /**
     * @name createUser
     * @request POST:/scim/v2/Users
     */ createUser: function(data, params) {
                return _this.request("/scim/v2/Users", "POST", params, data);
            },
            /**
     * @name getUser
     * @request GET:/scim/v2/Users/{id}
     */ getUser: function(id, params) {
                return _this.request("/scim/v2/Users/".concat(id), "GET", params);
            },
            /**
     * @name putUserId
     * @request PUT:/scim/v2/Users/{id}
     */ putUserId: function(id, data, params) {
                return _this.request("/scim/v2/Users/".concat(id), "PUT", params, data);
            },
            /**
     * @name deleteUser
     * @request DELETE:/scim/v2/Users/{id}
     */ deleteUser: function(id, params) {
                return _this.request("/scim/v2/Users/".concat(id), "DELETE", params);
            },
            /**
     * @name patchUser
     * @request PATCH:/scim/v2/Users/{id}
     */ patchUser: function(id, data, params) {
                return _this.request("/scim/v2/Users/".concat(id), "PATCH", params, data);
            }
        };
        _this.web = {
            /**
     * @tags asana, integration, private
     * @name fieldChangeCallback
     * @request POST:/web/asana/formfieldchange
     */ fieldChangeCallback: function(params) {
                return _this.request("/web/asana/formfieldchange", "POST", params);
            },
            /**
     * @tags asana, integration, private
     * @name fieldChangeCallbackPreflight
     * @request OPTIONS:/web/asana/formfieldchange
     */ fieldChangeCallbackPreflight: function(params) {
                return _this.request("/web/asana/formfieldchange", "OPTIONS", params);
            },
            /**
     * @tags asana, integration, private
     * @name formCallback
     * @summary Called on-submit of the "schedule via reclaim" widget.
     * @request POST:/web/asana/formsubmit
     * @description Called on-submit of the "schedule via reclaim" widget.
     */ formCallback: function(data, params) {
                return _this.request("/web/asana/formsubmit", "POST", params, data);
            },
            /**
     * @tags asana, integration, private
     * @name formCallbackPreflight
     * @request OPTIONS:/web/asana/formsubmit
     */ formCallbackPreflight: function(params) {
                return _this.request("/web/asana/formsubmit", "OPTIONS", params);
            },
            /**
     * @tags asana, integration, private
     * @name syncForm
     * @summary Called on-render of a task inside of Asana for tasks that have already been associated with / scheduled in Reclaim.
     * @request GET:/web/asana/syncform
     * @description Called on-render of a task inside of Asana for tasks that have already been associated with / scheduled in Reclaim.
     */ syncForm: function(query, params) {
                return _this.request("/web/asana/syncform".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags asana, integration, private
     * @name syncFormPreflight
     * @request OPTIONS:/web/asana/syncform
     */ syncFormPreflight: function(params) {
                return _this.request("/web/asana/syncform", "OPTIONS", params);
            },
            /**
     * @tags asana, integration, private
     * @name taskDetails
     * @request GET:/web/asana/task/{asanaTaskId}
     */ taskDetails: function(asanaTaskId, params) {
                return _this.request("/web/asana/task/".concat(asanaTaskId), "GET", params);
            },
            /**
     * @tags asana, integration, private
     * @name taskDetailsPreflight
     * @request OPTIONS:/web/asana/task/{asanaTaskId}
     */ taskDetailsPreflight: function(asanaTaskId, params) {
                return _this.request("/web/asana/task/".concat(asanaTaskId), "OPTIONS", params);
            },
            /**
     * @tags asana, integration, private
     * @name widget
     * @summary Called on-render of a task inside of Asana for tasks that have NOT already been associated with / scheduled in Reclaim.
     * @request GET:/web/asana/widget
     * @description Called on-render of a task inside of Asana for tasks that have NOT already been associated with / scheduled in Reclaim.
     */ widget: function(query, params) {
                return _this.request("/web/asana/widget".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags asana, integration, private
     * @name widgetPreflight
     * @request OPTIONS:/web/asana/widget
     */ widgetPreflight: function(params) {
                return _this.request("/web/asana/widget", "OPTIONS", params);
            },
            /**
     * @tags clickup, integration, private
     * @name taskDetails_1
     * @request GET:/web/clickup/task/{taskId}
     */ taskDetails1: function(taskId, params) {
                return _this.request("/web/clickup/task/".concat(taskId), "GET", params);
            },
            /**
     * @tags integration, jira, private
     * @name taskDetails_2
     * @request GET:/web/jira/task/{issueKey}/{issueId}
     */ taskDetails2: function(issueKey, issueId, params) {
                return _this.request("/web/jira/task/".concat(issueKey, "/").concat(issueId), "GET", params);
            },
            /**
     * @tags integration, linear, private
     * @name taskDetails_3
     * @request GET:/web/linear/task/{id}
     */ taskDetails3: function(id, params) {
                return _this.request("/web/linear/task/".concat(id), "GET", params);
            },
            /**
     * @tags integration, private, todoist
     * @name taskDetails_4
     * @request GET:/web/todoist/task/{itemId}
     */ taskDetails4: function(itemId, params) {
                return _this.request("/web/todoist/task/".concat(itemId), "GET", params);
            }
        };
        _this.ws = {
            /**
     * @tags websocket
     * @name swaggerHelper
     * @summary This is a bogus endpoint that gives us swagger generated objects for our websocket specific classes.
     * @request POST:/ws/bogus
     * @description This is a bogus endpoint that gives us swagger generated objects for our websocket specific classes.
     */ swaggerHelper: function(data, params) {
                return _this.request("/ws/bogus", "POST", params, data);
            },
            /**
     * @tags websocket
     * @name connect_1
     * @summary How do we get the connectionId? # List all integrations aws apigatewayv2 get-integrations --api-id xxxxxxxxx # Update all @connect integration aws apigatewayv2 update-integration --integration-id zzzzzzzz --api-id xxxxxxxxx --request-parameters 'integration.
     * @request POST:/ws/connect
     * @description How do we get the connectionId? # List all integrations aws apigatewayv2 get-integrations --api-id xxxxxxxxx # Update all @connect integration aws apigatewayv2 update-integration --integration-id zzzzzzzz --api-id xxxxxxxxx --request-parameters 'integration.request.header.connectionId'='context.connectionId'
     */ connect1: function(data, params) {
                return _this.request("/ws/connect", "POST", params, data);
            },
            /**
     * @tags websocket
     * @name defaultHandler
     * @request POST:/ws/default
     */ defaultHandler: function(params) {
                return _this.request("/ws/default", "POST", params);
            },
            /**
     * @tags websocket
     * @name disconnect
     * @request POST:/ws/disconnect
     */ disconnect: function(params) {
                return _this.request("/ws/disconnect", "POST", params);
            },
            /**
     * @tags websocket
     * @name subscribe
     * @request POST:/ws/subscribe
     */ subscribe: function(data, params) {
                return _this.request("/ws/subscribe", "POST", params, data);
            },
            /**
     * @tags websocket
     * @name unsubscribe_2
     * @request POST:/ws/unsubscribe
     */ unsubscribe2: function(data, params) {
                return _this.request("/ws/unsubscribe", "POST", params, data);
            }
        };
        return _this;
    }
    return ReclaimApi;
}(HttpClient);


/***/ }),

/***/ 13859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_1__.F7; },
/* harmony export */   "s": function() { return /* binding */ AppReclaimApiError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82222);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71418);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45110);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98585);








var AppReclaimApiError = /*#__PURE__*/ function(ReclaimApiError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AppReclaimApiError, ReclaimApiError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(AppReclaimApiError);
    function AppReclaimApiError(err) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, AppReclaimApiError);
        var _this;
        _this = _super.call(this, {
            status: err.status,
            statusText: err.statusText || "",
            headers: err.headers,
            data: err.body,
            config: {}
        }, err.message);
        (0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .movePropsOver */ .Gg)(err, (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
        var bodyObj;
        switch((0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(err.body)){
            case "string":
                try {
                    bodyObj = JSON.parse(err.body);
                } catch (e) {}
                break;
            case "object":
                bodyObj = err.body || undefined;
                break;
        }
        if ((bodyObj === null || bodyObj === void 0 ? void 0 : bodyObj.reclaimError) && bodyObj.errorCode) _this.reclaimErrorCode = bodyObj.errorCode;
        return _this;
    }
    return AppReclaimApiError;
}(_client__WEBPACK_IMPORTED_MODULE_1__/* .ReclaimApiError */ .gt);


/***/ }),

/***/ 54517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tz": function() { return /* binding */ reclaim; }
});

// UNUSED EXPORTS: Client, DomainsConstructor, LOCAL_TIME_FORMAT

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs
var _possible_constructor_return = __webpack_require__(41357);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/utils/strings.ts + 1 modules
var strings = __webpack_require__(84467);
// EXTERNAL MODULE: ./src/analytics.ts
var analytics = __webpack_require__(70550);
// EXTERNAL MODULE: ./src/consts/shadow.consts.ts
var shadow_consts = __webpack_require__(54137);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/reclaim-api/Accounts.mutators.ts
var Accounts_mutators = __webpack_require__(36706);
// EXTERNAL MODULE: ./src/reclaim-api/types.ts + 2 modules
var types = __webpack_require__(42230);
;// CONCATENATED MODULE: ./src/reclaim-api/Accounts.ts








var AccountsDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(AccountsDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(AccountsDomain);
    function AccountsDomain() {
        (0,_class_call_check/* default */.Z)(this, AccountsDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "ConnectedAccount";
        _this.cacheKey = "connectedAccount";
        _this.pk = "id";
        _this.serialize = Accounts_mutators/* connectedAccountToDto */.EL;
        _this.deserialize = Accounts_mutators/* dtoToConnectedAccount */.ps;
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.list = _this.typedManageErrors(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.api.accounts.list()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().map(Accounts_mutators/* dtoToConnectedAccount */.ps)
                        ];
                }
            });
        }));
        _this.delete = _this.typedManageErrors(function(id) {
            return _this.api.accounts.delete(id);
        });
        _this.authRedirect = function(baseUri) {
            var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var authUrl = new URL(baseUri, window.location.href);
            authUrl.searchParams.append("state", JSON.stringify(state));
            window.location.href = authUrl.toString();
        };
        _this.getCalendars = function(accountId) {
            return _this.api.accounts.getCalendars(accountId);
        };
        _this.setAvailability = function(accountId, calendarIds) {
            return _this.api.accounts.setAvailability(accountId, calendarIds);
        };
        return _this;
    }
    return AccountsDomain;
}(types/* TransformDomain */.Zs);

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/notifications/Snackbar.tsx
var notifications_Snackbar = __webpack_require__(8309);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ErrorOutlineOutlined.js
var ErrorOutlineOutlined = __webpack_require__(51161);
// EXTERNAL MODULE: ./node_modules/notistack/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(20377);
// EXTERNAL MODULE: ./src/reclaim-api/adaptors/notifications.module.scss
var notifications_module = __webpack_require__(1200);
var notifications_module_default = /*#__PURE__*/__webpack_require__.n(notifications_module);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(13665);
// EXTERNAL MODULE: ./node_modules/jotai/esm/vanilla.mjs
var vanilla = __webpack_require__(15103);
// EXTERNAL MODULE: ./src/utils/dates.ts + 3 modules
var dates = __webpack_require__(26958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 9 modules
var makeStyles = __webpack_require__(61214);
;// CONCATENATED MODULE: ./node_modules/@mui/styles/styled/styled.js


const _excluded = ["name"],
  _excluded2 = ["children", "className", "clone", "component"];







function omit(input, fields) {
  const output = {};
  Object.keys(input).forEach(prop => {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

// styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.
function styled(Component) {
  const componentCreator = (style, options = {}) => {
    const {
        name
      } = options,
      stylesOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(options, _excluded);
    if (false) {}
    let classNamePrefix = name;
    if (false) {}
    const stylesOrCreator = typeof style === 'function' ? theme => ({
      root: props => style((0,esm_extends/* default */.Z)({
        theme
      }, props))
    }) : {
      root: style
    };
    const useStyles = (0,makeStyles/* default */.Z)(stylesOrCreator, (0,esm_extends/* default */.Z)({
      Component,
      name: name || Component.displayName,
      classNamePrefix
    }, stylesOptions));
    let filterProps;
    let propTypes = {};
    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }

    /* eslint-disable react/forbid-foreign-prop-types */
    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */

    const StyledComponent = /*#__PURE__*/react.forwardRef(function StyledComponent(props, ref) {
      const {
          children,
          className: classNameProp,
          clone,
          component: ComponentProp
        } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);
      const classes = useStyles(props);
      const className = (0,clsx_m/* default */.Z)(classes.root, classNameProp);
      let spread = other;
      if (filterProps) {
        spread = omit(spread, filterProps);
      }
      if (clone) {
        return /*#__PURE__*/react.cloneElement(children, (0,esm_extends/* default */.Z)({
          className: (0,clsx_m/* default */.Z)(children.props.className, className)
        }, spread));
      }
      if (typeof children === 'function') {
        return children((0,esm_extends/* default */.Z)({
          className
        }, spread));
      }
      const FinalComponent = ComponentProp || Component;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FinalComponent, (0,esm_extends/* default */.Z)({
        ref: ref,
        className: className
      }, spread, {
        children: children
      }));
    });
     false ? 0 : void 0;
    if (false) {}
    hoist_non_react_statics_cjs_default()(StyledComponent, Component);
    return StyledComponent;
  };
  return componentCreator;
}
;// CONCATENATED MODULE: ./src/components/LinkButton.tsx





var LinkButton = styled(function(_param) /*#__PURE__*/ {
    var underline = _param.underline, props = (0,_object_without_properties/* default */.Z)(_param, [
        "underline"
    ]);
    return (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, (0,_object_spread/* default */.Z)({
        disableRipple: true,
        style: {
            textDecoration: underline
        }
    }, props));
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.primary.main,
        padding: 0,
        margin: 0,
        verticalAlign: "baseline",
        fontFamily: "Poppins",
        fontWeight: theme.typography.fontWeightMedium,
        "&:active": {
            color: theme.palette.primary.dark
        }
    };
}, {
    classNamePrefix: "LinkButton"
});

;// CONCATENATED MODULE: ./src/reclaim-api/adaptors/notifications.tsx










var notifificationStore = (0,vanilla/* createStore */.MT)();
var allowAppVersionAtom = (0,esm/* atom */.cn)(true);
notifificationStore.set(allowAppVersionAtom, true);
var NETWORK_NOTIFICATION_KEY = "network-refresh";
var APP_VERSION_NOTIFICATION_KEY = "app-version";
var showNetworkRefreshNotification = function() {
    closeSnackbar(NETWORK_NOTIFICATION_KEY);
    setTimeout(function() {
        enqueueSnackbar("", {
            key: NETWORK_NOTIFICATION_KEY,
            persist: true,
            content: /*#__PURE__*/ _jsx(Snackbar, {
                onClose: function() {
                    return closeSnackbar(NETWORK_NOTIFICATION_KEY);
                },
                message: /*#__PURE__*/ _jsx("span", {
                    className: classes.snackbarMessage,
                    children: "Network connection was lost."
                }),
                uiActions: [
                    {
                        label: " Refresh",
                        action: function() {
                            return window.location.reload();
                        }
                    }
                ],
                dismissible: true
            })
        });
    }, 1000);
};
var showAppVersionNotification = function() {
    if (notifificationStore.get(allowAppVersionAtom)) {
        (0,notistack_esm/* closeSnackbar */.sy)(APP_VERSION_NOTIFICATION_KEY);
        (0,notistack_esm/* enqueueSnackbar */.yv)("", {
            key: APP_VERSION_NOTIFICATION_KEY,
            persist: true,
            anchorOrigin: {
                horizontal: "center",
                vertical: "top"
            },
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_Snackbar/* Snackbar */.A, {
                type: "info",
                className: (notifications_module_default()).appVersionRoot,
                onClose: function() {
                    return (0,notistack_esm/* closeSnackbar */.sy)(APP_VERSION_NOTIFICATION_KEY);
                },
                message: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (notifications_module_default()).appVersionMessage,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutlineOutlined/* default */.Z, {
                            className: (notifications_module_default()).appVersionMessage__icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (notifications_module_default()).appVersionMessage__content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    children: "You are running an out-of-date version of Reclaim."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton, {
                                    onClick: function() {
                                        return window.location.reload();
                                    },
                                    children: "Get the latest"
                                })
                            ]
                        })
                    ]
                }),
                dismissible: true
            })
        });
        notifificationStore.set(allowAppVersionAtom, false);
        // After an hour allow the notification to be shown again
        setTimeout(function() {
            return notifificationStore.set(allowAppVersionAtom, true);
        }, dates/* MILLISECONDS_PER_HOUR */.Dv);
    }
};

// EXTERNAL MODULE: ./src/reclaim-api/adaptors/ws.ts + 1 modules
var ws = __webpack_require__(77856);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
// EXTERNAL MODULE: ./node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(63496);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./src/reclaim-api/Users.ts
var Users = __webpack_require__(91669);
;// CONCATENATED MODULE: ./src/reclaim-api/Analytics.mutators.ts





/** string union mutators */ var dtoToAnalyticsBucket = function(dto) {
    return dto;
};
// TODO: This cast sucks.  B.E. thinks this is EventCategory (see: AnalyticsRowEventCategoryLong).
var dtoToAnalyticsEventCategory = function(dto) {
    return dto;
};
var dtoToAnalyticsUnit = function(dto) {
    return dto;
};
var analyticssMetricToDto = function(metric) {
    return metric;
};
var analyticsGroupingIntervalToDto = function(interval) {
    return interval;
};
var dtoToAnalyticsWSResultsStatus = function(dto) {
    return dto;
};
/** Supporting mutators */ var dtoToBucketedValuesValue = function(dto) {
    return (0,_object_spread/* default */.Z)({}, dto);
};
var dtoToBucketOfBucketedValuesValue = function(dto) {
    return (0,_object_spread/* default */.Z)({}, dto);
};
/** AnalyticsValue mutators */ var dtoToAnalyticsValueBase = function(metricName, dto) {
    return {
        metric: metricName,
        description: dto.description
    };
};
var dtoToAnalyticsUnitedValueBase = function(metricName, dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dtoToAnalyticsValueBase(metricName, dto)), {
        unit: dtoToAnalyticsUnit(dto.unit),
        noData: dto.noData
    });
};
var dtoToAnalyticsSingleValue = function(metricName, dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dtoToAnalyticsUnitedValueBase(metricName, dto)), {
        value: dto.value || 0
    });
};
var dtoToAnalyticsBucketedValue = function(metricName, dto) {
    var ref;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dtoToAnalyticsUnitedValueBase(metricName, dto)), {
        values: ((ref = dto.values) === null || ref === void 0 ? void 0 : ref.map(function(value) {
            return dtoToBucketedValuesValue(value);
        })) || [],
        bucket: dtoToAnalyticsBucket(dto.bucket)
    });
};
var dtoToAnalyticsBucketOfBucketValues = function(metricName, dto) {
    var ref;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dtoToAnalyticsUnitedValueBase(metricName, dto)), {
        bucket: dtoToAnalyticsBucket(dto.bucket),
        subBucket: dtoToAnalyticsBucket(dto.subBucket),
        values: ((ref = dto.values) === null || ref === void 0 ? void 0 : ref.map(function(value) {
            return dtoToBucketOfBucketedValuesValue(value);
        })) || []
    });
};
var dtoToAnalyticsSingleValueGroup = function(metricName, dto) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dtoToAnalyticsValueBase(metricName, dto)), {
        metrics: dto.metrics.map(function(param) {
            var name = param.name, metric = param.metric;
            return dtoToAnalyticsSingleValue(name, metric);
        })
    });
};
var dtoToAnalyticsValues = function(metricName, dto) {
    if ("subBucket" in dto) return dtoToAnalyticsBucketOfBucketValues(metricName, dto);
    if ("bucket" in dto) return dtoToAnalyticsBucketedValue(metricName, dto);
    if ("value" in dto) return dtoToAnalyticsSingleValue(metricName, dto);
    if ("metrics" in dto) return dtoToAnalyticsSingleValueGroup(metricName, dto);
};
var dtoToAnalyticsResultsApendixEntry = function(dto, dtoTo) {
    return {
        missingScopes: dto.missingScopes,
        values: (0,objects/* mapObject */.Xc)(dto.values, function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            return [
                key,
                dtoTo(value)
            ];
        })
    };
};
var dtoToAnalyticsResultsApendix = function(dto) {
    return {
        people: dto.people && dtoToAnalyticsResultsApendixEntry(dto.people, Users/* dtoToThinPerson */.MT),
        teamSize: dto.teamSize
    };
};
/**
 * response mutators
 */ var dtoToAnalyticsMetrics = function(dto) {
    return {
        metrics: (0,objects/* mapToObject */.GA)(dto.metrics, function(param) {
            var metric = param.metric, name = param.name;
            return [
                name,
                dtoToAnalyticsValues(name, metric), 
            ];
        }),
        appendix: dtoToAnalyticsResultsApendix(dto.appendix)
    };
};
var dtoToAnalyticsWSMetrics = function(dto) {
    return {
        results: dtoToAnalyticsMetrics(dto.results),
        status: dtoToAnalyticsWSResultsStatus(dto.status)
    };
};

// EXTERNAL MODULE: ./src/reclaim-api/client.ts
var client = __webpack_require__(98585);
;// CONCATENATED MODULE: ./src/reclaim-api/Analytics.ts















var prepStatGetterRequest = function(metrics, options) {
    var groupingInterval = options.groupingInterval, start = options.start, _end = options.end, end = _end === void 0 ? new Date() : _end;
    if ((0,isAfter/* default */.Z)(start, end)) throw new Error("End cannot come after start");
    return {
        start: (0,dates/* dateToYyyyMmDd */.bc)(start),
        end: (0,dates/* dateToYyyyMmDd */.bc)(end),
        metricName: metrics.map(analyticssMetricToDto),
        groupingInterval: analyticsGroupingIntervalToDto(groupingInterval || "DAILY")
    };
};
var Subscription = {
    subscriptionType: client/* SubscriptionType.Analytics */.Qe.Analytics
};
var AnalyticsDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(AnalyticsDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(AnalyticsDomain);
    function AnalyticsDomain() {
        (0,_class_call_check/* default */.Z)(this, AnalyticsDomain);
        var _this;
        var ref, ref1;
        _this = _super.apply(this, arguments);
        _this.resource = "Analytics";
        _this.cacheKey = "analytics";
        _this.teamWs$ = (0,wonka/* pipe */.zG)(((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$(Subscription)) || (0,wonka/* fromArray */.nI)([]), (0,wonka/* map */.UI)(function(envelope) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, envelope), {
                data: dtoToAnalyticsWSMetrics(envelope.data)
            });
        }));
        _this.watchTeam$$ = function() {
            return _this.teamWs$;
        };
        _this.userWs$ = (0,wonka/* pipe */.zG)(((ref1 = _this.ws) === null || ref1 === void 0 ? void 0 : ref1.subscription$$(Subscription)) || (0,wonka/* fromArray */.nI)([]), (0,wonka/* filter */.hX)(function(envelope) {
            return !!envelope.data;
        }), (0,wonka/* map */.UI)(function(envelope) {
            return dtoToAnalyticsWSMetrics(envelope.data);
        }));
        _this.watchUser$$ = function() {
            return _this.userWs$;
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getTeamAnalytics = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(metrics, options) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.api.analytics.analyticsTeamAnalytics(prepStatGetterRequest(metrics, options))
                            ];
                        case 1:
                            return [
                                2,
                                dtoToAnalyticsMetrics.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(metrics, options) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getUserAnalytics = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(metrics, options) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.api.analytics.analyticsUserAnalytics(prepStatGetterRequest(metrics, options))
                            ];
                        case 1:
                            return [
                                2,
                                dtoToAnalyticsMetrics.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(metrics, options) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.connectToTeamAnalytics = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(metrics, options) {
                var _notificationKey, notificationKey, getterOptions;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _notificationKey = options.notificationKey, notificationKey = _notificationKey === void 0 ? _this3.generateUid("TeamAnalytics") : _notificationKey, getterOptions = (0,_object_without_properties/* default */.Z)(options, [
                                "notificationKey"
                            ]);
                            return [
                                4,
                                _this3.api.analytics.analyticsTeamAnalyticsV2((0,_object_spread/* default */.Z)({
                                    notificationKey: notificationKey
                                }, prepStatGetterRequest(metrics, getterOptions)))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                notificationKey
                            ];
                    }
                });
            });
            return function(metrics, options) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.connectToUserAnalytics = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(metrics, options) {
                var _notificationKey, notificationKey, getterOptions;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _notificationKey = options.notificationKey, notificationKey = _notificationKey === void 0 ? _this4.generateUid("UserAnalytics") : _notificationKey, getterOptions = (0,_object_without_properties/* default */.Z)(options, [
                                "notificationKey"
                            ]);
                            return [
                                4,
                                _this4.api.analytics.analyticsUserAnalyticsV2((0,_object_spread/* default */.Z)({
                                    notificationKey: notificationKey
                                }, prepStatGetterRequest(metrics, getterOptions)))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                notificationKey
                            ];
                    }
                });
            });
            return function(metrics, options) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    return AnalyticsDomain;
}(types/* TransformDomain */.Zs);

;// CONCATENATED MODULE: ./src/reclaim-api/ApiManagement.ts







// `undefined > 0` and `null > 0` both resolve to `false`.
// Typescript doesn't seem to know this so we have to do
// some typing leg work
var dtoToLifetimeMs = function(dto) {
    return dto > 0 ? dto : "forever";
};
var lifetimeMsToDto = function(lifetimeMs) {
    return lifetimeMs === "forever" ? -1 : lifetimeMs;
};
var dtoToApiKey = function(_param) {
    var lifetimeMs = _param.lifetimeMs, token = _param.token, dto = (0,_object_without_properties/* default */.Z)(_param, [
        "lifetimeMs",
        "token"
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dto), {
        token: token || undefined,
        lifetimeMs: dtoToLifetimeMs(lifetimeMs)
    });
};
var apiKeyToDto = function(_param) {
    var lifetimeMs = _param.lifetimeMs, apiKey = (0,_object_without_properties/* default */.Z)(_param, [
        "lifetimeMs"
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, apiKey), {
        lifetimeMs: lifetimeMsToDto(lifetimeMs)
    });
};
var ApiManagementDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(ApiManagementDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(ApiManagementDomain);
    function ApiManagementDomain() {
        (0,_class_call_check/* default */.Z)(this, ApiManagementDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "ApiKey";
        _this.cacheKey = "apiKey";
        _this.pk = "id";
        _this.serialize = apiKeyToDto;
        _this.deserialize = dtoToApiKey;
        _this.listApiKeys = _this.typedManageErrors(_this.deserializeResponse(_this.api.apiManagement.listApiKey1));
        _this.getApiKey = _this.typedManageErrors(_this.deserializeResponse(_this.api.apiManagement.listApiKey));
        _this.createApiKey = _this.typedManageErrors(_this.deserializeResponse(function(description, lifetimeMs) {
            return _this.api.apiManagement.createApiKey({
                description: description,
                lifetimeMs: lifetimeMs && lifetimeMsToDto(lifetimeMs)
            });
        }));
        _this.patchApiKey = _this.typedManageErrors(_this.deserializeResponse(function(id, patch) {
            return _this.api.apiManagement.updateApiKey((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, patch), {
                id: id
            }));
        }));
        _this.deleteApiKey = _this.typedManageErrors(_this.api.apiManagement.deleteApiKey);
        _this.reissueApiKey = _this.typedManageErrors(_this.deserializeResponse(_this.api.apiManagement.reissueApiKey));
        // simple api health check. Is everything ok... ok?
        _this.environmentCheck = _this.typedManageErrors(_this.api.ok.ok);
        return _this;
    }
    return ApiManagementDomain;
}(types/* TransformDomain */.Zs);

// EXTERNAL MODULE: ./src/reclaim-api/Calendars.ts
var Calendars = __webpack_require__(48410);
// EXTERNAL MODULE: ./src/reclaim-api/CalendarSyncPolicy.ts
var CalendarSyncPolicy = __webpack_require__(6774);
// EXTERNAL MODULE: ./src/reclaim-api/Credentials.ts
var Credentials = __webpack_require__(41849);
// EXTERNAL MODULE: ./src/reclaim-api/Events.ts + 1 modules
var Events = __webpack_require__(91500);
// EXTERNAL MODULE: ./src/reclaim-api/Habits.ts
var Habits = __webpack_require__(4090);
// EXTERNAL MODULE: ./src/reclaim-api/Integrations.mutators.ts
var Integrations_mutators = __webpack_require__(89502);
// EXTERNAL MODULE: ./src/reclaim-api/OneOnOnes.mutators.ts
var OneOnOnes_mutators = __webpack_require__(90483);
;// CONCATENATED MODULE: ./src/reclaim-api/Integrations.ts










var OAUTH_BASE_URI = "https://api.app.reclaim-staging.com/oauth";
var IntegrationsDomain = /*#__PURE__*/ function(Domain) {
    "use strict";
    (0,_inherits/* default */.Z)(IntegrationsDomain, Domain);
    var _super = (0,_create_super/* default */.Z)(IntegrationsDomain);
    function IntegrationsDomain() {
        (0,_class_call_check/* default */.Z)(this, IntegrationsDomain);
        var _this;
        _this = _super.apply(this, arguments);
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        /* Zoom */ _this.getZoomIntegration = _this.typedManageErrors(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.api.integrations.getZoomIntegration()
                        ];
                    case 1:
                        return [
                            2,
                            OneOnOnes_mutators/* dtoToZoomUser.apply */.rM.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        }));
        _this.getZoomEnabled = _this.manageErrors(function() {
            return _this.api.integrations.getZoomIntegration().then(function(zoom) {
                return !!zoom && !!zoom.id;
            }).catch(function(error) {
                if (error.status === 404) {
                    return false;
                } else {
                    throw error;
                }
            });
        });
        /* Linear */ _this.getLinearIntegrations = _this.manageErrors(_this.api.linear.integrations4);
        _this.patchLinearIntegration = function(id, data) {
            return _this.api.linear.patchIntegration2(id, data);
        };
        _this.deleteLinearIntegration = function(id) {
            return _this.api.linear.deleteIntegration3(id);
        };
        _this.getLinearEnabled = _this.manageErrors(function() {
            return _this.api.linear.integrations4().then(function(list) {
                return !!(list === null || list === void 0 ? void 0 : list.length) && list.some(function(i) {
                    return !!i.id;
                });
            }).catch(function() {
                return false;
            });
        });
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        // Rules for Todoist / Clickup
        _this.listRules = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(serviceType) {
                var dto;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.api.timescheme.listRules({
                                    type: serviceType
                                })
                            ];
                        case 1:
                            dto = _state.sent();
                            return [
                                2,
                                dto.map(Integrations_mutators/* dtoToIntegrationRule */.jZ)
                            ];
                    }
                });
            });
            return function(serviceType) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.createRule = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(rule) {
                var created;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this3.api.timescheme.createRule((0,Integrations_mutators/* integrationRuleCreateRequestToDto */.Db)(rule))
                            ];
                        case 1:
                            created = _state.sent();
                            return [
                                2,
                                (0,Integrations_mutators/* dtoToIntegrationRule */.jZ)(created)
                            ];
                    }
                });
            });
            return function(rule) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.updateRule = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(ruleId, rule) {
                var updated;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this4.api.timescheme.updateRule(ruleId, (0,Integrations_mutators/* integrationRuleUpdateRequestToDto */.JQ)(rule))
                            ];
                        case 1:
                            updated = _state.sent();
                            return [
                                2,
                                (0,Integrations_mutators/* dtoToIntegrationRule */.jZ)(updated)
                            ];
                    }
                });
            });
            return function(ruleId, rule) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this5 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.deleteRule = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(ruleId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this5.api.timescheme.deleteRule(ruleId)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(ruleId) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this6 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.reindexRule = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(ruleId, data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this6.api.timescheme.reindex1(ruleId, (0,Integrations_mutators/* integrationRuleReindexRequestToDto */.Pf)(data))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(ruleId, data) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this7 = (0,_assert_this_initialized/* default */.Z)(_this);
        /* Todoist */ _this.getTodoistIntegrationDetails = _this.typedManageErrors(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this7.api.todoist.integrationsDetails()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().map(Integrations_mutators/* dtoToTodoistIntegrationDetails */.f7)
                        ];
                }
            });
        }));
        _this.deleteTodoistIntegration = function(id) {
            return _this.api.todoist.deleteIntegration4(id);
        };
        _this.getTodoistEnabled = _this.typedManageErrors(function() {
            return _this.api.todoist.integrations5().then(function(list) {
                return !!(list === null || list === void 0 ? void 0 : list.length) && list.some(function(i) {
                    return !!i.id;
                });
            }).catch(function() {
                return false;
            });
        });
        /* Asana */ _this.getAsanaIntegrations = _this.manageErrors(_this.api.asana.integrations);
        _this.deleteAsanaIntegration = function() {
            return _this.api.asana.deleteIntegration();
        };
        _this.getAsanaEnabled = _this.manageErrors(function() {
            return _this.api.asana.integrations().then(function(list) {
                return !!(list === null || list === void 0 ? void 0 : list.length);
            });
        });
        var _this8 = (0,_assert_this_initialized/* default */.Z)(_this);
        /* ClickUp */ _this.getClickupIntegrationDetails = _this.typedManageErrors(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this8.api.clickup.clickUpIntegrationsDetails()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().map(Integrations_mutators/* dtoToClickUpIntegrationDetails */.eb)
                        ];
                }
            });
        }));
        _this.deleteClickUpIntegration = function() {
            return _this.api.clickup.deleteIntegration1();
        };
        _this.getClickUpEnabled = _this.manageErrors(function() {
            return _this.api.clickup.integrations1().then(function(list) {
                return !!(list === null || list === void 0 ? void 0 : list.length) && list.some(function(i) {
                    var ref;
                    return !!((ref = i.workspace) === null || ref === void 0 ? void 0 : ref.id);
                });
            }).catch(function() {
                return false;
            });
        });
        /* Jira */ _this.getJiraIntegrations = _this.manageErrors(_this.api.jira.integrations3);
        _this.patchJiraIntegration = function(id, patch) {
            return _this.api.jira.patchIntegration1(id, patch);
        };
        _this.deleteJiraIntegration = function(id) {
            return _this.api.jira.deleteIntegration2(id).then(function(response) {
                return response;
            });
        };
        _this.getJiraEnabled = function() {
            return _this.getJiraIntegrations().then(function(list) {
                return !!(list === null || list === void 0 ? void 0 : list.length) && list.some(function(i) {
                    return !!i.id;
                });
            }).catch(function() {
                return false;
            });
        };
        /* Google Add-on */ _this.getGoogleAddOnIntegrations = _this.manageErrors(_this.api.googleAddOn.integrations2);
        _this.getGoogleAddOnEnabled = function() {
            return _this.getGoogleAddOnIntegrations().then(function(list) {
                return !!(list === null || list === void 0 ? void 0 : list.length) && list.some(function(i) {
                    return !!i.enabled;
                });
            }).catch(function() {
                return false;
            });
        };
        var _this9 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getEnabledMap = _this.typedManageErrors(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this9.api.integrations.enabled()
                        ];
                    case 1:
                        return [
                            2,
                            Integrations_mutators/* dtoToIntegrationsEnabledMap.apply */.W2.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        }));
        return _this;
    }
    var _proto = IntegrationsDomain.prototype;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _proto.authRedirect = function authRedirect(redirectUri, state, newTab) {
        var url = new URL("".concat(OAUTH_BASE_URI).concat(redirectUri), window.location.href);
        url.searchParams.append("state", JSON.stringify((0,_object_spread/* default */.Z)({
            redirect: window.location.pathname
        }, state || {})));
        if (newTab) {
            return window.open(url.toString()) || undefined;
        } else {
            window.location.href = url.toString();
            return window;
        }
    };
    return IntegrationsDomain;
}(types/* Domain */.qp);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/utils/wonka.ts
var utils_wonka = __webpack_require__(60811);
// EXTERNAL MODULE: ./src/reclaim-api/Habits.mutators.ts
var Habits_mutators = __webpack_require__(77802);
// EXTERNAL MODULE: ./src/reclaim-api/Planner.ts
var Planner = __webpack_require__(2399);
// EXTERNAL MODULE: ./src/reclaim-api/Tasks.ts
var Tasks = __webpack_require__(76388);
;// CONCATENATED MODULE: ./src/reclaim-api/Moment.ts













var dtoToMoment = function(dto) {
    var moment = {
        now: (0,dates/* strToDate */.z8)(dto.now),
        allEvents: (0,_to_consumable_array/* default */.Z)(!!dto.event ? [
            dto.event
        ] : []).concat((0,_to_consumable_array/* default */.Z)(dto.additionalEvents)).map(Events/* dtoToEvent */.k_)
    };
    if (!!dto.event) {
        moment.event = (0,Events/* dtoToEvent */.k_)(dto.event);
    }
    if (!!dto.additionalEvents && !!dto.additionalEvents.length) {
        moment.additionalEvents = dto.additionalEvents.map(function(e) {
            return (0,Events/* dtoToEvent */.k_)(e);
        });
    }
    var taskOrHabit = dto.assignment;
    if (!!taskOrHabit) {
        if ((0,Planner/* isTask */.N2)(taskOrHabit)) {
            moment.task = (0,Tasks/* dtoToTask */.uH)(taskOrHabit);
        } else if ((0,Planner/* isHabit */.o0)(taskOrHabit)) {
            moment.habit = (0,Habits_mutators/* dtoToHabit */.TK)(taskOrHabit);
        } else {
            console.warn("Unidentified moment assignment", dto);
        }
    }
    return moment;
};
var MomentSubscription = {
    subscriptionType: client/* SubscriptionType.Moment */.Qe.Moment
};
var MomentDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(MomentDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(MomentDomain);
    function MomentDomain() {
        (0,_class_call_check/* default */.Z)(this, MomentDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "Moment";
        _this.cacheKey = "moments";
        _this.pk = [
            "assignment.id"
        ] // TODO: (SS) Not used but as moment evolves the upsert might be needed.
        ;
        _this.deserialize = dtoToMoment;
        _this.watch$$ = function() {
            var ref;
            return (0,wonka/* pipe */.zG)(((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$(MomentSubscription)) || (0,wonka/* fromArray */.nI)([]), (0,wonka/* filter */.hX)(function(envelope) {
                return !!envelope.data;
            }), (0,utils_wonka/* deserialize */.vB)(_this.deserialize));
        };
        _this.list$$ = function() {
            return (0,wonka/* pipe */.zG)((0,wonka/* fromPromise */.p4)(_this.list()), (0,wonka/* map */.UI)(function(moment) {
                return !!moment ? [
                    moment
                ] : null;
            }));
        };
        _this.listAndWatch$$ = function() {
            return (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
                _this.list$$(),
                _this.watch$$()
            ]), // only one item for moment
            (0,wonka/* map */.UI)(function(moments) {
                return !!(moments === null || moments === void 0 ? void 0 : moments.length) && !!Object.keys(moments[0]).length ? moments[0] : null;
            }));
        };
        _this.list = _this.manageErrors(_this.deserializeResponse(_this.api.moment.get2));
        return _this;
    }
    return MomentDomain;
}(types/* TransformDomain */.Zs);

// EXTERNAL MODULE: ./src/reclaim-api/OneOnOnes.types.ts
var OneOnOnes_types = __webpack_require__(70282);
;// CONCATENATED MODULE: ./src/reclaim-api/OneOnOnes.ts














var OneOnOnesDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(OneOnOnesDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(OneOnOnesDomain);
    function OneOnOnesDomain() {
        (0,_class_call_check/* default */.Z)(this, OneOnOnesDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "OneOnOne";
        _this.cacheKey = "oneOnOne";
        _this.pk = "id";
        _this.serialize = OneOnOnes_mutators/* OneOnOneToDto */.R7;
        _this.deserialize = OneOnOnes_mutators/* dtoToOneOnOne */.z2;
        _this.watchWs$$ = function(instances) {
            var ref;
            return (0,wonka/* pipe */.zG)(((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$({
                subscriptionType: client/* SubscriptionType.OneOnOne */.Qe.OneOnOne,
                instances: !!instances
            })) || (0,wonka/* fromArray */.nI)([]), (0,wonka/* filter */.hX)(function(envelope) {
                return !!envelope.data;
            }), (0,wonka/* map */.UI)(function(envelope) {
                return envelope.data;
            }), (0,utils_wonka/* deserialize */.vB)(_this.deserialize));
        };
        _this.watchWs$ = _this.watchWs$$();
        _this.watchAll$ = (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka/* map */.UI)(function(items) {
            return _this.patchExpectedChanges(items);
        }));
        _this.watchAllWithOptimisticUpdates$ = (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka/* map */.UI)(function(items) {
            return items;
        }));
        _this.watch$$ = function(instances) {
            return (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
                _this.upsert$,
                _this.watchWs$$(instances)
            ]), (0,wonka/* map */.UI)(function(items) {
                return _this.patchExpectedChanges(items);
            }));
        };
        _this.list$$ = function(instances) {
            return (0,wonka/* pipe */.zG)((0,wonka/* fromPromise */.p4)(Promise.all([
                _this.list(instances),
                _this.invites(instances)
            ])), (0,wonka/* map */.UI)(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), list = _param[0], invites = _param[1];
                return _this.patchExpectedChanges((0,_to_consumable_array/* default */.Z)(list).concat((0,_to_consumable_array/* default */.Z)(invites)));
            }));
        };
        _this.listAndWatch$$ = function(instances) {
            return (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
                _this.list$$(instances),
                _this.watch$$(instances)
            ]), (0,utils_wonka/* upsert */.H)(function(e) {
                return _this.getPk(e);
            }), (0,wonka/* map */.UI)(function(items) {
                return (0,_to_consumable_array/* default */.Z)(items);
            }));
        };
        _this.watchId$$ = function(id) {
            return (0,wonka/* pipe */.zG)(_this.watchAll$, (0,wonka/* map */.UI)(function(items) {
                return items === null || items === void 0 ? void 0 : items.find(function(i) {
                    return i.id === id;
                });
            }));
        };
        _this.list = _this.manageErrors(_this.deserializeResponse(function(instances) {
            return _this.api.oneOnOne.getOneOnOnes({
                instances: instances
            });
        }));
        _this.get = _this.deserializeResponse(function(id, instances) {
            return _this.api.oneOnOne.getOneOnOne(id, {
                instances: instances
            });
        });
        _this.create = _this.manageErrors(_this.deserializeResponse(function(oneOnOne, sendTeamInvite) {
            return _this.api.oneOnOne.createOnOnOne(_this.serialize(oneOnOne), {
                sendTeamInvite: sendTeamInvite
            });
        }));
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.patch = _this.manageErrors(_this.deserializeResponse(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(id, patch) {
                var notificationKey;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    notificationKey = _this1.generateUid("patch", id);
                    _this1.expectChange(notificationKey, id, patch, true);
                    return [
                        2,
                        _this1.api.oneOnOne.patchOneOnOne(id, _this1.serialize(patch), {
                            notificationKey: notificationKey
                        }).then(function(res) {
                            _this1.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Requested */.$K.Requested);
                            return res;
                        }).catch(function(reason) {
                            console.warn("Request failed, clearing notification key", notificationKey, reason);
                            _this1.clearExpectedChange(notificationKey, types/* NotificationKeyStatus.Failed */.$K.Failed);
                            throw reason;
                        })
                    ];
                });
            });
            return function(id, patch) {
                return _ref.apply(this, arguments);
            };
        }()));
        _this.delete = _this.manageErrors(function(id) {
            var notificationKey = _this.generateUid("delete", id);
            _this.expectChange(notificationKey, id, {
                deleted: true
            });
            return _this.api.oneOnOne.deleteOneOnOne(id, {
                notificationKey: notificationKey
            }).then(function(res) {
                _this.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Requested */.$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.clearExpectedChange(notificationKey, types/* NotificationKeyStatus.Failed */.$K.Failed);
                throw reason;
            });
        });
        _this.invites = _this.manageErrors(_this.deserializeResponse(function(instances) {
            return _this.api.oneOnOne.getMeetingInvites({
                instances: instances
            });
        }));
        _this.inviteWithErrors = _this.deserializeResponse(function(id, instances, inviteKey) {
            return _this.api.oneOnOne.getMeetingInvite(id, {
                instances: instances,
                inviteKey: inviteKey
            });
        });
        _this.respondAnonymously = _this.deserializeResponse(function(id, inviteKey, status) {
            return _this.api.oneOnOne.respondAnonymously(id, inviteKey, {
                status: status && client/* RecurringAssignmentAttendeeStatus */.N_[status]
            });
        });
        _this.invite = _this.manageErrors(_this.inviteWithErrors);
        _this.suggestions = _this.manageErrors(_this.deserializeResponse(_this.api.oneOnOne.getSuggestions));
        _this.respond = _this.manageErrors(function(id, accept) {
            var status = accept ? OneOnOnes_types/* RecurringAssignmentAttendeeStatus.Accepted */.N_.Accepted : OneOnOnes_types/* RecurringAssignmentAttendeeStatus.Declined */.N_.Declined;
            var notificationKey = _this.generateUid("respond", id);
            _this.expectChange(notificationKey, id, {
                status: accept ? OneOnOnes_types/* RecurringOneOnOneStatus.Accepted */.uH.Accepted : OneOnOnes_types/* RecurringOneOnOneStatus.Declined */.uH.Declined
            });
            return _this.api.oneOnOne.respond(id, {
                status: status
            }, {
                notificationKey: notificationKey
            }).then(function(res) {
                _this.updateNotificationKey(notificationKey, types/* NotificationKeyStatus.Requested */.$K.Requested);
                return res;
            }).catch(function(reason) {
                console.warn("Request failed, clearing notification key", notificationKey, reason);
                _this.clearExpectedChange(notificationKey, types/* NotificationKeyStatus.Failed */.$K.Failed);
                throw reason;
            });
        });
        _this.getInviteeEligibility = function(email) {
            return _this.api.oneOnOne.getInviteeEligibility({
                email: email
            }).catch(function(cause) {
                console.warn("Error: Invalid email address: " + email);
                throw cause;
            });
        };
        _this.convertPendingToAuto = _this.deserializeResponse(function(id, title) {
            return _this.api.oneOnOne.convertPendingToAuto(id, {
                title: title
            });
        });
        return _this;
    }
    return OneOnOnesDomain;
}(types/* TransformDomain */.Zs);

;// CONCATENATED MODULE: ./src/reclaim-api/People.ts




var LOGIN_BASE_URI = (/* unused pure expression or super */ null && ("https://api.app.reclaim-staging.com/oauth/login" || 0));
var LOGOUT_URI = (/* unused pure expression or super */ null && ("https://api.app.reclaim-staging.com/logout" || 0));
var PeopleDomain = /*#__PURE__*/ function(Domain) {
    "use strict";
    (0,_inherits/* default */.Z)(PeopleDomain, Domain);
    var _super = (0,_create_super/* default */.Z)(PeopleDomain);
    function PeopleDomain() {
        (0,_class_call_check/* default */.Z)(this, PeopleDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.unsubscribe = function(email, type) {
            return _this.api.people.unsubscribe({
                email: email,
                type: type
            });
        };
        _this.search = function(query) {
            var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
            return _this.api.people.search({
                q: query,
                limit: limit
            });
        };
        return _this;
    }
    return PeopleDomain;
}(types/* Domain */.qp);

// EXTERNAL MODULE: ./src/reclaim-api/scheduling-links/SchedulingLinks.ts + 1 modules
var SchedulingLinks = __webpack_require__(19331);
;// CONCATENATED MODULE: ./src/reclaim-api/Resources.mutators.ts




var dtoToResources = function(dto) {
    return {
        tasks: dto.taskList.map(Tasks/* dtoToTask */.uH),
        habits: dto.habitList.map(Habits_mutators/* dtoToHabit */.TK),
        oneOnOnes: dto.oneOnOneList.map(OneOnOnes_mutators/* dtoToOneOnOne */.z2),
        schedulingLinks: dto.schedulingLinkList.map(SchedulingLinks/* dtoToSchedulingLink */.EF)
    };
};

;// CONCATENATED MODULE: ./src/reclaim-api/Resources.ts





var ResourcesDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(ResourcesDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(ResourcesDomain);
    function ResourcesDomain() {
        (0,_class_call_check/* default */.Z)(this, ResourcesDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "Resources";
        _this.cacheKey = "resources";
        _this.deserialize = dtoToResources;
        _this.get = _this.typedManageErrors(_this.deserializeResponse(_this.api.resources.getResources));
        return _this;
    }
    return ResourcesDomain;
}(types/* TransformDomain */.Zs);

;// CONCATENATED MODULE: ./src/reclaim-api/Slack.ts




var SlackDomain = /*#__PURE__*/ function(Domain) {
    "use strict";
    (0,_inherits/* default */.Z)(SlackDomain, Domain);
    var _super = (0,_create_super/* default */.Z)(SlackDomain);
    function SlackDomain() {
        (0,_class_call_check/* default */.Z)(this, SlackDomain);
        return _super.apply(this, arguments);
    }
    var _proto = SlackDomain.prototype;
    _proto.link = function link(userId, teamId) {
        return this.api.slack.link({
            userId: userId,
            teamId: teamId
        }, {});
    };
    _proto.authRedirect = function authRedirect(teamId) {
        // FIXME: (IW) Doesn't work when base uri is just a path (eg. '/oauth/login'),
        // but window.location is no bueno
        var authUrl = new URL("".concat(this.api.baseUrl, "/slack/add"), window.location.href);
        if (teamId) authUrl.searchParams.append("teamId", teamId);
        window.location.href = authUrl.toString();
    };
    return SlackDomain;
}(types/* Domain */.qp);

// EXTERNAL MODULE: ./src/reclaim-api/team/Team.ts
var Team = __webpack_require__(72897);
// EXTERNAL MODULE: ./src/reclaim-api/TimeSchemes.mutators.ts
var TimeSchemes_mutators = __webpack_require__(64825);
;// CONCATENATED MODULE: ./src/reclaim-api/TimeSchemes.ts








var TimeSchemesDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(TimeSchemesDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(TimeSchemesDomain);
    function TimeSchemesDomain() {
        (0,_class_call_check/* default */.Z)(this, TimeSchemesDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "TimeScheme";
        _this.cacheKey = "time-schemes";
        _this.pk = "id";
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.list = _this.typedManageErrors(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var dto;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.api.timeschemes.listTimePolicySchemes()
                        ];
                    case 1:
                        dto = _state.sent();
                        return [
                            2,
                            dto.map(TimeSchemes_mutators/* dtoToTimeScheme */.ox)
                        ];
                }
            });
        }));
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.create = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(scheme) {
                var created;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.api.timeschemes.createTimeScheme((0,TimeSchemes_mutators/* timeSchemeCreateRequestToDto */.TE)(scheme))
                            ];
                        case 1:
                            created = _state.sent();
                            return [
                                2,
                                (0,TimeSchemes_mutators/* dtoToTimeScheme */.ox)(created)
                            ];
                    }
                });
            });
            return function(scheme) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.update = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(schemeId, scheme) {
                var updated;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this3.api.timeschemes.updateTimeScheme1(schemeId, (0,TimeSchemes_mutators/* timeSchemeUpdateRequestToDto */.uq)(scheme))
                            ];
                        case 1:
                            updated = _state.sent();
                            return [
                                2,
                                (0,TimeSchemes_mutators/* dtoToTimeScheme */.ox)(updated)
                            ];
                    }
                });
            });
            return function(schemeId, scheme) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.delete = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(schemeId, moveToTimeSchemeId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this4.api.timeschemes.deleteTimeScheme(schemeId, {
                                    moveToTimeSchemeId: moveToTimeSchemeId
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(schemeId, moveToTimeSchemeId) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this5 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.queryTimePolicySchemesByUserIdAndFeature = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(userId, feature) {
                var schemes;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this5.api.timeschemes.queryTimePolicySchemesByUserIdAndFeature({
                                    feature: feature,
                                    userId: userId
                                })
                            ];
                        case 1:
                            schemes = _state.sent();
                            return [
                                2,
                                schemes.map(TimeSchemes_mutators/* dtoToTimeScheme */.ox)
                            ];
                    }
                });
            });
            return function(userId, feature) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    return TimeSchemesDomain;
}(types/* TransformDomain */.Zs);

;// CONCATENATED MODULE: ./src/reclaim-api/WeeklyReports.ts





function dtoToWeeklyReportTemplateData(dto) {
    return (0,_object_spread/* default */.Z)({}, dto);
}
function weeklyReportTemplateDataToDto(data) {
    return (0,_object_spread/* default */.Z)({}, data);
}
var WeeklyReportsDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(WeeklyReportsDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(WeeklyReportsDomain);
    function WeeklyReportsDomain() {
        (0,_class_call_check/* default */.Z)(this, WeeklyReportsDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.resource = "WeeklyReport";
        _this.cacheKey = "weeklyReport";
        _this.pk = "id";
        _this.serialize = weeklyReportTemplateDataToDto;
        _this.deserialize = dtoToWeeklyReportTemplateData;
        _this.social = _this.manageErrors(_this.deserializeResponse(function(id, verificationKey) {
            return _this.api.weeklyReport.social({
                id: id,
                verificationKey: verificationKey
            });
        }));
        _this.unsubscribe = _this.manageErrors(_this.api.weeklyReport.unsubscribe1);
        return _this;
    }
    return WeeklyReportsDomain;
}(types/* TransformDomain */.Zs);

;// CONCATENATED MODULE: ./src/reclaim-api/index.ts

































var API_BASE_URI = "https://api.app.reclaim-staging.com/api";
var APP_VERSION = "1.0.0";
var LOCAL_TIME_FORMAT = "HH:mm:ss";
var DomainsConstructor = function DomainsConstructor() {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, DomainsConstructor);
};
var Client = /*#__PURE__*/ function(DomainsConstructor) {
    "use strict";
    (0,_inherits/* default */.Z)(Client, DomainsConstructor);
    var _super = (0,_create_super/* default */.Z)(Client);
    function Client(config) {
        (0,_class_call_check/* default */.Z)(this, Client);
        var _this;
        _this = _super.call(this);
        _this.domains = {};
        if ((0,_instanceof/* default */.Z)(config, client/* ReclaimApi */.eZ)) {
            _this.client = config;
        } else {
            _this.client = new client/* ReclaimApi */.eZ({
                baseUrl: config || API_BASE_URI,
                BUILD_ID: analytics/* BUILD_ID */.sk,
                baseApiParams: shadow_consts/* isImpersonating */.sQ ? {
                    headers: {
                        "Content-Type": "application/json",
                        Referrer: "no-referrer",
                        Authorization: "Bearer ".concat(shadow_consts/* shadowApiKey */.rZ),
                        "X-Reclaim-Shadow": shadow_consts/* shadowTrackingCode */.M$
                    }
                } : undefined
            });
        }
        /**
     * Versioning interceptor. The client.client is the AxiosInstance used by the ReclaimApi.
     * If the reported version from the BE is higher than the current version on this UI bundle
     * then launch a notification for the user to refresh.
     */ _this.client.client.interceptors.response.use(function(response) {
            var ref;
            var apiVersion = (ref = response.headers) === null || ref === void 0 ? void 0 : ref["x-reclaim-fe-version"]; // Keep "any" headers as conditional here
            if (apiVersion && APP_VERSION && (0,strings/* isVersionStringGreaterThan */.Fh)(apiVersion, APP_VERSION)) {
                showAppVersionNotification();
            }
            return response;
        });
        if (typeof WebSocket !== "undefined") _this.ws = new ws/* ReclaimWS */.gH();
        _this.proxy = new Proxy((0,_assert_this_initialized/* default */.Z)(_this), {
            get: function get(target, key) {
                if (key === "client") return target.client;
                if (Client.DomainClasses[key]) {
                    return target.getDomain(key);
                }
            }
        });
        return (0,_possible_constructor_return/* default */.Z)(_this, _this.proxy);
    }
    var _proto = Client.prototype;
    _proto.getDomain = function getDomain(key) {
        if (!this.domains[key] && !Client.DomainClasses[key]) return;
        if (!this.domains[key]) {
            var DomainClass = Client.DomainClasses[key];
            this.domains[key] = new DomainClass(key, this.client, this.proxy, this.ws);
        }
        return this.domains[key];
    };
    return Client;
}(DomainsConstructor);
Client.DomainClasses = {
    users: Users/* UsersDomain */.aA,
    accounts: AccountsDomain,
    credentials: Credentials/* CredentialsDomain */.y9,
    calendars: Calendars/* CalendarsDomain */.g2,
    calendarSyncPolicies: CalendarSyncPolicy/* CalendarSyncPolicyDomain */.S$,
    events: Events/* EventsDomain */.Vq,
    habits: Habits/* HabitsDomain */.wO,
    tasks: Tasks/* TasksDomain */.Y4,
    analytics: AnalyticsDomain,
    people: PeopleDomain,
    slack: SlackDomain,
    oneOnOnes: OneOnOnesDomain,
    weeklyReports: WeeklyReportsDomain,
    integrations: IntegrationsDomain,
    planner: Planner/* PlannerDomain */.Kl,
    moment: MomentDomain,
    team: Team/* TeamDomain */.OR,
    apiManagement: ApiManagementDomain,
    schedulingLinks: SchedulingLinks/* SchedulingLinksDomain */.sb,
    timeSchemes: TimeSchemesDomain,
    resources: ResourcesDomain
};
var reclaim = new Client();


/***/ }),

/***/ 19331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sx": function() { return /* binding */ DELAY_STARTS; },
  "sb": function() { return /* binding */ SchedulingLinksDomain; },
  "EF": function() { return /* binding */ dtoToSchedulingLink; },
  "s2": function() { return /* binding */ getSchedulingLinkDurationStrLessUnits; },
  "vk": function() { return /* binding */ zoneIdToUserTimeZone; }
});

// UNUSED EXPORTS: createMeetingLocationToDto, createMembershipRequestToDto, createSchedulingLinkDerivativeRequestToDto, createSchedulingLinkGroupRequestToDto, createSchedulingLinkRequestToDto, dtoToCreateSchedulingLinkGroupRequest, dtoToMeetingLocation, dtoToPatchSchedulingLinkGroupRequest, dtoToSchedulingLinkGroup, dtoToSchedulingLinkMeetingAvailability, dtoToSchedulingLinkMeetingAvailabilitySlot, dtoToSchedulingLinkMeetingEvent, dtoToSchedulingLinkMeetingRequest, dtoToSchedulingLinkMemberStatus, dtoToSchedulingLinkOrganizerView, dtoToSchedulingLinkPriority, dtoToUserSlug, getSchedulingLinkDurationStr, membershipRequestToDto, partialSchedulingLinkMeetingToDto, patchMeetingLocationToDto, patchMembershipRequestToDto, patchSchedulingLinkGroupRequestToDto, patchSchedulingLinkRequestToDto, schedulingLinkGroupToDto, schedulingLinkMeetingAvailabilitySlotToDto, schedulingLinkMeetingAvailabilityToDto, schedulingLinkMeetingRequestToDto, schedulingLinkMemberStatusToDto, schedulingLinkOrganizerViewToDto, schedulingLinkPriorityToDto, schedulingLinkRoleToDto, timePolicyTypeToDto, timeZoneToZoneId, userSlugtoDto, userTimeZoneToZoneId, zoneIdToTimeZone

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(63496);
// EXTERNAL MODULE: ./src/analytics.ts
var analytics = __webpack_require__(70550);
// EXTERNAL MODULE: ./src/utils/dates.ts + 3 modules
var dates = __webpack_require__(26958);
// EXTERNAL MODULE: ./src/utils/wonka.ts
var utils_wonka = __webpack_require__(60811);
// EXTERNAL MODULE: ./src/reclaim-api/client.ts
var client = __webpack_require__(98585);
// EXTERNAL MODULE: ./src/reclaim-api/Events.ts + 1 modules
var Events = __webpack_require__(91500);
// EXTERNAL MODULE: ./src/reclaim-api/TimeSchemes.mutators.ts
var TimeSchemes_mutators = __webpack_require__(64825);
// EXTERNAL MODULE: ./src/reclaim-api/types.ts + 2 modules
var types = __webpack_require__(42230);
// EXTERNAL MODULE: ./src/reclaim-api/Users.ts
var Users = __webpack_require__(91669);
// EXTERNAL MODULE: ./src/reclaim-api/scheduling-links/scheduling-links-client.ts
var scheduling_links_client = __webpack_require__(75007);
;// CONCATENATED MODULE: ./src/reclaim-api/scheduling-links/SchedulingLinks.mutators.ts


//  Survey Questions
var dtoToSurveyQuestion = function(dto) {
    return {
        questionValue: dto.questionValue,
        type: dto.type,
        isRequired: dto.isRequired
    };
};
var dtoToSurvey = function(dto) {
    var ref;
    return {
        questions: !!((ref = dto.questions) === null || ref === void 0 ? void 0 : ref.length) ? dto.questions.map(dtoToSurveyQuestion) : []
    };
};
var surveyQuestionToDto = function(surveyQuestion) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, surveyQuestion), {
        questionValue: surveyQuestion.questionValue,
        type: surveyQuestion.type,
        isRequired: surveyQuestion.isRequired
    });
};
var surveyToDto = function(survey) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, survey), {
        questions: survey.questions.map(surveyQuestionToDto)
    });
};
// Survey Answers / Response
var dtoToSurveyAnswer = function(dto) {
    return {
        value: dto.value ? dto.value : undefined
    };
};
var dtoToSurveyCompletedQuestion = function(dto) {
    return {
        question: dtoToSurveyQuestion(dto.question),
        answer: dtoToSurveyAnswer(dto.answer)
    };
};
var SchedulingLinks_mutators_dtoToSurveyResponse = function(dto) {
    return {
        responses: dto.responses.map(dtoToSurveyCompletedQuestion)
    };
};
var surveyAnswerToDto = function(surveyAnswer) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, surveyAnswer), {
        value: surveyAnswer.value
    });
};
var surveyCompletedQuestionToDto = function(surveyCompletedQuestion) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, surveyCompletedQuestion), {
        question: surveyQuestionToDto(surveyCompletedQuestion.question),
        answer: surveyAnswerToDto(surveyCompletedQuestion.answer)
    });
};
var surveyResponseToDto = function(surveyResponse) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, surveyResponse), {
        responses: surveyResponse.responses.map(surveyCompletedQuestionToDto)
    });
};

;// CONCATENATED MODULE: ./src/reclaim-api/scheduling-links/SchedulingLinks.ts





















var API_BASE_URI = "https://api.app.reclaim-staging.com/api";
var DELAY_STARTS = Object.values(scheduling_links_client/* DelayStart */.fO);
var dtoToMeetingLocation = function(dto) {
    return dto.conferenceType ? {
        conferenceType: dto.conferenceType,
        location: dto.location || undefined,
        disabled: dto.disabled || undefined
    } : {
        conferenceType: "GENERIC_LOCATION",
        location: dto.location || "",
        disabled: dto.disabled || undefined
    };
};
var createMeetingLocationToDto = function(meetingLocation) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, meetingLocation), {
        conferenceType: meetingLocation.conferenceType
    });
};
var patchMeetingLocationToDto = function(meetingLocation) {
    return _object_spread_props(_object_spread({}, meetingLocation), {
        conferenceType: meetingLocation.conferenceType
    });
};
// This IS just a simple cast,  but casting is
// dangerous in type-land so offloading that
// responsibility to a single entity is useful.
// This way we don't have to track a million
// hidden type errors if something breaks.
var timePolicyTypeToDto = function(timePolicyType) {
    return timePolicyType;
};
// ZoneIds are incorrectly identified by swagger, they're just strings
var zoneIdToTimeZone = function(zoneId) {
    return zoneId;
};
var zoneIdToUserTimeZone = function(zoneId) {
    return zoneId;
};
var timeZoneToZoneId = function(timeZone) {
    return timeZone;
};
var userTimeZoneToZoneId = function(userTimeZone) {
    return userTimeZone;
};
var dtoToSchedulingLinkMemberStatus = function(dto) {
    return dto;
};
var schedulingLinkMemberStatusToDto = function(status) {
    return status;
};
var schedulingLinkRoleToDto = function(role) {
    return role;
};
var schedulingLinkPriorityToDto = function(priority) {
    return priority;
};
var dtoToSchedulingLinkPriority = function(dto) {
    return dto;
};
var dtoToSchedulingLinkOrganizerView = function(dto) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dto), {
        organizer: (0,Users/* dtoToThinPerson */.MT)(dto.organizer),
        timezone: zoneIdToUserTimeZone(dto.timezone),
        oneOffPolicy: dto.oneOffPolicy ? (0,TimeSchemes_mutators/* dtoToTimePolicy */.G3)(dto.oneOffPolicy) : undefined,
        resolvedTimePolicy: dto.resolvedTimePolicy ? (0,TimeSchemes_mutators/* dtoToTimePolicy */.G3)(dto.resolvedTimePolicy) : {
            dayHours: {}
        },
        status: dto.status ? dtoToSchedulingLinkMemberStatus(dto.status) : undefined,
        timeSchemeId: dto.timeSchemeId ? dto.timeSchemeId : undefined
    });
};
var schedulingLinkOrganizerViewToDto = function(org) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, org), {
        organizer: (0,Users/* thinPersonToDto */.rB)(org.organizer),
        timezone: userTimeZoneToZoneId(org.timezone),
        oneOffPolicy: org.oneOffPolicy && (0,TimeSchemes_mutators/* timePolicyToDto */.aE)(org.oneOffPolicy),
        resolvedTimePolicy: (0,TimeSchemes_mutators/* timePolicyToDto */.aE)(org.resolvedTimePolicy),
        status: org.status && schedulingLinkMemberStatusToDto(org.status),
        role: schedulingLinkRoleToDto(org.role),
        timePolicyType: timePolicyTypeToDto(org.timePolicyType)
    });
};
var dtoToUserSlug = function(dto) {
    return (0,src_object_spread/* default */.Z)({}, dto);
};
var dtoToSchedulingLink = function(dto) {
    var ref;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dto), {
        startDate: dto.startDate ? (0,dates/* shiftDateToTz */.BH)(new Date(dto.startDate), "UTC") : undefined,
        endDate: dto.endDate ? (0,dates/* shiftDateToTz */.BH)(new Date(dto.endDate), "UTC") : undefined,
        effectiveTimePolicy: dto.effectiveTimePolicy,
        // null -> undefined conversions
        description: dto.description || undefined,
        daysIntoFuture: dto.daysIntoFuture || undefined,
        organizerRefCode: dto.organizerRefCode || undefined,
        delayStartUnits: dto.delayStartUnits || undefined,
        defaultDuration: dto.defaultDuration || undefined,
        mainOrganizerView: dtoToSchedulingLinkOrganizerView(dto.organizers.find(function(param) {
            var role = param.role;
            return role === scheduling_links_client/* SchedulingLinkRole.MAINORGANIZER */.Wk.MAINORGANIZER;
        })),
        organizers: dto.organizers.map(dtoToSchedulingLinkOrganizerView),
        linkGroupId: dto.linkGroupId || undefined,
        linkGroupName: dto.linkGroupName || undefined,
        // derivative
        derivativeContext: dto.derivativeContext || undefined,
        locationOptions: ((ref = dto.locationOptions) === null || ref === void 0 ? void 0 : ref.map(dtoToMeetingLocation)) || [],
        meetingLimit: dto.meetingLimit || null,
        priority: dto.priority ? dtoToSchedulingLinkPriority(dto.priority) : "DEFAULT",
        survey: !!dto.survey ? dtoToSurvey(dto.survey) : {
            questions: []
        },
        expires: dto.expires ? new Date(dto.expires) : undefined,
        isDerivative: !!dto.derivativeContext
    });
};
var membershipRequestToDto = function(data) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
        timePolicyType: timePolicyTypeToDto(data.timePolicyType),
        oneOffPolicy: data.oneOffPolicy && (0,TimeSchemes_mutators/* timePolicyToDto */.aE)(data.oneOffPolicy)
    });
};
var createMembershipRequestToDto = function(data) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
        timePolicyType: timePolicyTypeToDto(data.timePolicyType),
        oneOffPolicy: data.oneOffPolicy && (0,TimeSchemes_mutators/* timePolicyToDto */.aE)(data.oneOffPolicy)
    });
};
var patchMembershipRequestToDto = function(data) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
        // Currently timePolicyType is required, although I
        // believe for patches it should be able to be undefined.
        timePolicyType: data.timePolicyType && timePolicyTypeToDto(data.timePolicyType),
        oneOffPolicy: data.oneOffPolicy && (0,TimeSchemes_mutators/* timePolicyToDto */.aE)(data.oneOffPolicy)
    });
};
var createSchedulingLinkDerivativeRequestToDto = function(link) {
    var ref, ref1;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, link), {
        selectedAttendee: link.selectedAttendee && (0,Users/* thinPersonToDto */.rB)(link.selectedAttendee),
        toRecipients: (ref = link.toRecipients) === null || ref === void 0 ? void 0 : ref.map(Users/* thinPersonToDto */.rB),
        ccRecipients: (ref1 = link.ccRecipients) === null || ref1 === void 0 ? void 0 : ref1.map(Users/* thinPersonToDto */.rB),
        createdAt: (0,dates/* dateToStr */.dx)(link.createdAt)
    });
};
var createSchedulingLinkRequestToDto = function(link) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, link), {
        timePolicyType: timePolicyTypeToDto(link.timePolicyType),
        oneOffPolicy: link.oneOffPolicy && (0,TimeSchemes_mutators/* timePolicyToDto */.aE)(link.oneOffPolicy),
        startDate: link.startDate && (0,dates/* dateToYyyyMmDd */.bc)(link.startDate),
        endDate: link.endDate && (0,dates/* dateToYyyyMmDd */.bc)(link.endDate),
        priority: link.priority,
        iconType: link.iconType,
        delayStart: link.delayStart,
        members: (ref = link.members) === null || ref === void 0 ? void 0 : ref.map(createMembershipRequestToDto),
        locationOptions: !!((ref1 = link.locationOptions) === null || ref1 === void 0 ? void 0 : ref1.length) ? (ref2 = link.locationOptions) === null || ref2 === void 0 ? void 0 : ref2.map(createMeetingLocationToDto) : undefined,
        defaultLocationIndex: (!!link.defaultLocationIndex || link.defaultLocationIndex === 0) && !!((ref3 = link.locationOptions) === null || ref3 === void 0 ? void 0 : ref3[link.defaultLocationIndex]) ? link.defaultLocationIndex : undefined,
        meetingLimit: link.meetingLimit || null,
        survey: ((ref4 = link.survey) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.questions) === null || ref5 === void 0 ? void 0 : ref5.length) ? surveyToDto(link.survey) : null
    });
};
var patchSchedulingLinkRequestToDto = function(link) {
    var ref, ref1, ref2;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, link), {
        effectiveTimePolicy: link.effectiveTimePolicy,
        startDate: link.startDate && (0,dates/* dateToYyyyMmDd */.bc)(link.startDate),
        endDate: link.endDate && (0,dates/* dateToYyyyMmDd */.bc)(link.endDate),
        priority: link.priority,
        iconType: link.iconType,
        delayStart: link.delayStart,
        members: (ref = link.members) === null || ref === void 0 ? void 0 : ref.map(patchMembershipRequestToDto),
        organizers: (ref1 = link.organizers) === null || ref1 === void 0 ? void 0 : ref1.map(schedulingLinkOrganizerViewToDto),
        derivativeContext: link.derivativeContext,
        locationOptions: function() {
            if (!link.locationOptions) return link.locationOptions;
            if (!link.locationOptions.length) return null;
            return link.locationOptions.map(createMeetingLocationToDto);
        }(),
        defaultLocationIndex: (!!link.defaultLocationIndex || link.defaultLocationIndex === 0) && !!((ref2 = link.locationOptions) === null || ref2 === void 0 ? void 0 : ref2[link.defaultLocationIndex]) ? link.defaultLocationIndex : undefined,
        oneOffPolicy: link.oneOffPolicy && (0,TimeSchemes_mutators/* timePolicyToDto */.aE)(link.oneOffPolicy),
        timePolicyType: link.timePolicyType && timePolicyTypeToDto(link.timePolicyType),
        survey: function() {
            if (!link.survey) return link.survey;
            if (!link.survey.questions.length) return null;
            return surveyToDto(link.survey);
        }()
    });
};
var userSlugtoDto = function(dto) {
    return (0,src_object_spread/* default */.Z)({}, dto);
};
var dtoToSchedulingLinkMeetingAvailabilitySlot = function(dto) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dto), {
        startTime: new Date(dto.startTime),
        endTime: new Date(dto.endTime)
    });
};
var schedulingLinkMeetingAvailabilitySlotToDto = function(data) {
    return _object_spread_props(_object_spread({}, data), {
        startTime: data.startTime.toISOString(),
        endTime: data.endTime.toISOString()
    });
};
var dtoToSchedulingLinkMeetingAvailability = function(dto) {
    var ref;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dto), {
        inviteeEvents: (ref = dto.inviteeEvents) === null || ref === void 0 ? void 0 : ref.map(Events/* dtoToCalendarEvent */.K2),
        availableTimes: Object.entries(dto.availableTimes).reduce(function(map, param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), key = _param[0], slots = _param[1];
            map[key] = slots.map(dtoToSchedulingLinkMeetingAvailabilitySlot);
            return map;
        }, {})
    });
};
var schedulingLinkMeetingAvailabilityToDto = function(data) {
    var ref;
    return _object_spread_props(_object_spread({}, data), {
        inviteeEvents: (ref = data.inviteeEvents) === null || ref === void 0 ? void 0 : ref.map(calendarEventToDto),
        availableTimes: Object.entries(data.availableTimes).reduce(function(map, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], slots = _param[1];
            map[key] = slots.map(schedulingLinkMeetingAvailabilitySlotToDto);
            return map;
        }, {})
    });
};
var dtoToSchedulingLinkMeetingRequest = function(dto) {
    return _object_spread_props(_object_spread({}, dto), {
        start: new Date(dto.start),
        end: new Date(dto.end),
        meetingLocation: dto.meetingLocation,
        surveyResponse: dto.surveyResponse ? dtoToSurveyResponse(dto.surveyResponse) : undefined
    });
};
var schedulingLinkMeetingRequestToDto = function(data) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
        start: data.start.toISOString(),
        end: data.end.toISOString(),
        meetingLocation: data.meetingLocation,
        surveyResponse: data.surveyResponse ? surveyResponseToDto(data.surveyResponse) : null
    });
};
var dtoToSchedulingLinkMeetingEvent = function(dto) {
    if (typeof dto.meetingId !== "string") throw new Error("SchedulingLinkMeetingEvent must have a meetingId");
    var sl = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dto), {
        event: (0,Events/* dtoToCalendarEvent */.K2)(dto.event),
        schedulingLink: dto.schedulingLink && dtoToSchedulingLink(dto.schedulingLink),
        userSlug: dto.userSlug && dtoToUserSlug(dto.userSlug),
        meetingLocation: dto.meetingLocation,
        surveyResponse: dto.surveyResponse ? SchedulingLinks_mutators_dtoToSurveyResponse(dto.surveyResponse) : undefined
    });
    return sl;
};
var partialSchedulingLinkMeetingToDto = function(data) {
    var ref, ref1;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
        start: (ref = data.start) === null || ref === void 0 ? void 0 : ref.toISOString(),
        end: (ref1 = data.end) === null || ref1 === void 0 ? void 0 : ref1.toISOString(),
        meetingLocation: data.meetingLocation,
        surveyResponse: data.surveyResponse ? surveyResponseToDto(data.surveyResponse) : null
    });
};
var dtoToSchedulingLinkGroup = function(dto) {
    return (0,src_object_spread/* default */.Z)({}, dto);
};
var schedulingLinkGroupToDto = function(data) {
    return _object_spread({}, data);
};
var dtoToCreateSchedulingLinkGroupRequest = function(dto) {
    return _object_spread({}, dto);
};
var createSchedulingLinkGroupRequestToDto = function(data) {
    return (0,src_object_spread/* default */.Z)({}, data);
};
var dtoToPatchSchedulingLinkGroupRequest = function(dto) {
    return _object_spread({}, dto);
};
var patchSchedulingLinkGroupRequestToDto = function(data) {
    return (0,src_object_spread/* default */.Z)({}, data);
};
var SchedulingLinksDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(SchedulingLinksDomain, TransformDomain);
    var _super = (0,_create_super/* default */.Z)(SchedulingLinksDomain);
    function SchedulingLinksDomain() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SchedulingLinksDomain);
        var _this;
        var ref;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _this.resource = "SchedulingLink";
        _this.cacheKey = "scheduling_links";
        _this.pk = "id";
        _this.deserialize = dtoToSchedulingLink;
        // If we're rendering serverside, we don't have access to websockets, so don't even try
        _this.watchWs$ = (0,wonka/* pipe */.zG)(((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$({
            subscriptionType: client/* SubscriptionType.SchedulingLink */.Qe.SchedulingLink
        })) || (0,wonka/* fromArray */.nI)([]), (0,wonka/* filter */.hX)(function(envelope) {
            return !!envelope.data;
        }), (0,wonka/* map */.UI)(function(envelope) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, envelope.data), {
                deleted: envelope.delete
            });
        }), (0,utils_wonka/* deserialize */.vB)(_this.deserialize));
        _this.watchAll$ = (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka/* map */.UI)(function(items) {
            return _this.patchExpectedChanges(items);
        }));
        _this.watchAllWithOptimisticUpdates$ = (0,wonka/* pipe */.zG)((0,wonka/* merge */.TS)([
            _this.upsert$,
            _this.watchWs$
        ]), (0,wonka/* map */.UI)(function(items) {
            return items;
        }));
        _this.list$$ = function() {
            return (0,wonka/* pipe */.zG)((0,wonka/* fromPromise */.p4)(_this.list()), (0,wonka/* map */.UI)(function(items) {
                return _this.patchExpectedChanges(items);
            }));
        };
        _this.listAndWatch$$ = function() {
            return (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
                _this.list$$(),
                _this.watchAll$
            ]), (0,utils_wonka/* upsert */.H)(function(h) {
                return _this.getPk(h);
            }), (0,wonka/* map */.UI)(function(items) {
                return (0,_to_consumable_array/* default */.Z)(items);
            }));
        };
        _this.watchId$$ = function(id) {
            return (0,wonka/* pipe */.zG)(_this.watchAll$, (0,wonka/* map */.UI)(function(items) {
                return items === null || items === void 0 ? void 0 : items.find(function(i) {
                    return i.id === id;
                });
            }));
        };
        _this.list = _this.deserializeResponse(function(excludeDisabled) {
            return(// invert includeDisabled so it can syntactically default to false
            _this.domainApi.schedulingLink.getAllLinks({
                includeDisabled: !excludeDisabled
            }));
        });
        _this.getAllLinksForUserSlug = _this.deserializeResponse(function(userSlug, excludeDisabled) {
            return _this.domainApi.schedulingLink.getAllLinksForUserSlug(userSlug, {
                includeDisabled: !excludeDisabled
            });
        });
        _this.create = _this.deserializeResponse(function(payload) {
            return _this.domainApi.schedulingLink.createLink(createSchedulingLinkRequestToDto(payload));
        });
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.createDerivative = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.domainApi.schedulingLink.createDerivativeSchedulingLink(createSchedulingLinkDerivativeRequestToDto(payload))
                            ];
                        case 1:
                            return [
                                2,
                                dtoToSchedulingLink.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.patch = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(id, payload) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.domainApi.schedulingLink.updateLink(id, patchSchedulingLinkRequestToDto(payload))
                            ];
                        case 1:
                            return [
                                2,
                                dtoToSchedulingLink.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(id, payload) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getMeetingSlots = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(schedulingLinkId, date, tz, meetingId, conferenceType) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this3.domainApi.schedulingLink.getMeetingSlots(schedulingLinkId, {
                                    date: Array.isArray(date) ? date : [
                                        date
                                    ],
                                    zoneId: tz,
                                    meetingId: meetingId,
                                    conferenceType: conferenceType
                                })
                            ];
                        case 1:
                            return [
                                2,
                                dtoToSchedulingLinkMeetingAvailability.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(schedulingLinkId, date, tz, meetingId, conferenceType) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.delete = function(id) {
            return _this.domainApi.schedulingLink.deleteLink(id);
        };
        _this.getAvailabilityByDate = function(linkId, tz) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            var conferenceType = options.conferenceType, durationMinutes = options.durationMinutes, meetingId = options.meetingId, params = options.params;
            return _this.domainApi.schedulingLink.getAvailabilityForDates(linkId, {
                zoneId: tz,
                conferenceType: conferenceType,
                meetingId: meetingId,
                durationMinutes: durationMinutes
            }, params);
        };
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.requestMeeting = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(schedulingLInkId, request) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this4.domainApi.schedulingLink.createMeeting(schedulingLInkId, schedulingLinkMeetingRequestToDto(request))
                            ];
                        case 1:
                            return [
                                2,
                                dtoToSchedulingLinkMeetingEvent.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(schedulingLInkId, request) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this5 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getMeeting = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(meetingId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this5.domainApi.schedulingLink.findMeeting(meetingId)
                            ];
                        case 1:
                            return [
                                2,
                                dtoToSchedulingLinkMeetingEvent.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(meetingId) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this6 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.cancelMeeting = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(meetingId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        _this6.domainApi.schedulingLink.deleteMeeting(meetingId)
                    ];
                });
            });
            return function(meetingId) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this7 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.cancelMeetingWithMessage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(meetingId, cancelMessage) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        _this7.domainApi.schedulingLink.deleteMeetingWithMessage(meetingId, cancelMessage)
                    ];
                });
            });
            return function(meetingId, cancelMessage) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this8 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.updateMeeting = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(meetingId, patch) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        _this8.domainApi.schedulingLink.updateMeeting(meetingId, partialSchedulingLinkMeetingToDto(patch))
                    ];
                });
            });
            return function(meetingId, patch) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this9 = (0,_assert_this_initialized/* default */.Z)(_this);
        /**
   * Gets user slug
   * @param userInputSlug
   * @returns a promise which resolves to a `UserSlug`
   * @deprecated not *really* deprecated, **BUT DO NOT USE THIS** - use `useUserSlug` instead.
   */ _this.getMyUserSlug = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this9.domainApi.schedulingLink.getMyUserSlug()
                        ];
                    case 1:
                        return [
                            2,
                            dtoToUserSlug.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        });
        _this.userSlugExists = function(userInputSlug) {
            return _this.domainApi.schedulingLink.userSlugExists({
                slug: userInputSlug
            });
        };
        /**
   * Sets the user slug
   * @param payload
   * @returns
   * @deprecated not *really* deprecated, **BUT DO NOT USE THIS** - use `useUserSlug` instead.
   */ _this.updateMyUserSlug = function(payload) {
            return _this.domainApi.schedulingLink.updateMyUserSlug(userSlugtoDto(payload));
        };
        var _this10 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.schedulingLinkSlugExists = _this.typedManageErrors(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(slug) {
                var e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this10.domainApi.schedulingLink.schedulingLinkSlugExists({
                                    slug: slug
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                true
                            ];
                        case 2:
                            e = _state.sent();
                            return [
                                2,
                                false
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(slug) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this11 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.listMeetingsForSchedulingLink = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(schedulingLinkId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this11.domainApi.schedulingLink.listMeetingsForSchedulingLink(schedulingLinkId)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent().map(function(meeting) {
                                    return dtoToSchedulingLinkMeetingEvent(meeting);
                                })
                            ];
                    }
                });
            });
            return function(schedulingLinkId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.getSchedulingLinkGroups = function() {
            return _this.domainApi.schedulingLink.getAllLinkGroupsForUser();
        };
        var _this12 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.listGroups = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this12.domainApi.schedulingLink.getAllLinkGroupsForUser()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent().map(dtoToSchedulingLinkGroup)
                        ];
                }
            });
        });
        _this.createGroup = function(group) {
            return _this.domainApi.schedulingLink.createSchedulingLinkGroup(createSchedulingLinkGroupRequestToDto(group));
        };
        _this.updateGroup = function(groupId, group) {
            return _this.domainApi.schedulingLink.updateschedulingLinkGroup(groupId, patchSchedulingLinkGroupRequestToDto(group));
        };
        _this.deleteSchedulingLinkGroupAndLinks = function(id) {
            return _this.domainApi.schedulingLink.deleteLinkGroup(id);
        };
        _this.deleteSchedulingLinkGroupAndMoveLinks = function(id, moveLinksToGroupId) {
            return _this.domainApi.schedulingLink.deleteLinkGroupAndMoveLinks(id, {
                moveLinksToGroupId: moveLinksToGroupId
            });
        };
        _this.getEffectiveTimePolicy = function(organizer, coOrganizers) {
            return _this.domainApi.schedulingLink.effectiveTimePolicy({
                coOrganizers: coOrganizers.map(membershipRequestToDto),
                organizer: membershipRequestToDto(organizer)
            });
        };
        _this.domainApi = new scheduling_links_client/* ReclaimApi */.eZ({
            baseUrl: API_BASE_URI,
            BUILD_ID: analytics/* BUILD_ID */.sk,
            baseApiParams: args[1].baseApiParams
        });
        return _this;
    }
    var _proto = SchedulingLinksDomain.prototype;
    _proto.get = function get(id, skipMutation) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var dto;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.domainApi.schedulingLink.getLink(id)
                        ];
                    case 1:
                        dto = _state.sent();
                        return [
                            2,
                            skipMutation ? dto : dtoToSchedulingLink(dto)
                        ];
                }
            });
        })();
    };
    _proto.getLinkForSlugs = function getLinkForSlugs(userSlug, linkSlug) {
        var skipTransform = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var dto;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.domainApi.schedulingLink.getLinkForUserAndLinkSlugViaUrlParameters({
                                userSlug: userSlug,
                                linkSlug: linkSlug
                            })
                        ];
                    case 1:
                        dto = _state.sent();
                        return [
                            2,
                            skipTransform ? dto : dtoToSchedulingLink(dto)
                        ];
                }
            });
        })();
    };
    return SchedulingLinksDomain;
}(types/* TransformDomain */.Zs);
var getSchedulingLinkDurationStr = function(link) {
    if (!link.durations.length) return "No duration set";
    link.durations.sort(function(a, b) {
        return a - b;
    });
    if (link.durations.length === 1) {
        return getDurationString(link.durations[0] * MILLISECONDS_PER_MINUTE);
    } else if (link.durations.length === 2) {
        return "".concat(getDurationString(link.durations[0] * MILLISECONDS_PER_MINUTE), ", ").concat(getDurationString(link.durations[1] * MILLISECONDS_PER_MINUTE));
    } else {
        return "".concat(getDurationString(link.durations[0] * MILLISECONDS_PER_MINUTE), ", ").concat(getDurationString(link.durations[1] * MILLISECONDS_PER_MINUTE), ", ").concat(getDurationString(link.durations[2] * MILLISECONDS_PER_MINUTE));
    }
};
var getSchedulingLinkDurationStrLessUnits = function(link) {
    if (!link.durations.length) return "No duration set";
    link.durations.sort(function(a, b) {
        return a - b;
    });
    // if all durations are <1hr - return only last one with units (mins)
    // or if all durations are divisable by one hour - only return last one with units (hrs)
    if (link.durations.every(function(duration) {
        return duration * dates/* MILLISECONDS_PER_MINUTE */.df < dates/* MILLISECONDS_PER_HOUR */.Dv;
    }) || link.durations.every(function(duration) {
        return duration * dates/* MILLISECONDS_PER_MINUTE */.df % dates/* MILLISECONDS_PER_HOUR */.Dv === 0;
    })) {
        // map through array
        // only return the last duration string with the `unitDisplay: "normal"` option
        return link.durations.map(function(duration, index, param) {
            var length = param.length;
            return (0,dates/* getDurationString */.pI)(duration * dates/* MILLISECONDS_PER_MINUTE */.df, {
                unitDisplay: index + 1 !== length ? "none" : "normal"
            });
        }).join(", ");
    } else {
        // else return all with units
        return link.durations.map(function(duration) {
            return (0,dates/* getDurationString */.pI)(duration * dates/* MILLISECONDS_PER_MINUTE */.df);
        }).join(", ");
    }
};


/***/ }),

/***/ 75007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F7": function() { return /* binding */ NetworkError; },
/* harmony export */   "Wk": function() { return /* binding */ SchedulingLinkRole; },
/* harmony export */   "eZ": function() { return /* binding */ ReclaimApi; },
/* harmony export */   "fO": function() { return /* binding */ DelayStart; },
/* harmony export */   "gt": function() { return /* binding */ ReclaimApiError; }
/* harmony export */ });
/* unused harmony exports ConferenceType, DayOfWeek, EventColor, EventResponseStatus, EventStatus, IconType, LinkInvalidationReason, MeetingLimitMeetingLimitPeriod, Month, ReclaimEventType, SchedulingLinkMemberStatus, SchedulingPriority, SurveyQuestionType, TimePolicyType, ZoneOffsetTransitionRuleTimeDefinition, HEADER_BUILD_ID */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25892);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* tslint:disable */ /* eslint-disable */ /*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ## A custom template from the reclaim-api/api-client         ##
 * ## repo was used.                                            ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ 








var ConferenceType;
(function(ConferenceType) {
    ConferenceType["GOOGLEMEET"] = "GOOGLE_MEET";
    ConferenceType["ZOOM"] = "ZOOM";
    ConferenceType["CUSTOM"] = "CUSTOM";
    ConferenceType["GENERICLOCATION"] = "GENERIC_LOCATION";
    ConferenceType["PHYSICALADDRESS"] = "PHYSICAL_ADDRESS";
    ConferenceType["PHONENUMBER"] = "PHONE_NUMBER";
})(ConferenceType || (ConferenceType = {}));
var DayOfWeek;
(function(DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
var DelayStart;
(function(DelayStart) {
    DelayStart["NODELAY"] = "NO_DELAY";
    DelayStart["FROMNOWMINUTES"] = "FROM_NOW_MINUTES";
    DelayStart["FROMNOWHOURS"] = "FROM_NOW_HOURS";
    DelayStart["FROMNOWDAYS"] = "FROM_NOW_DAYS";
    DelayStart["FROMNOWSTARTOFNEXTDAY"] = "FROM_NOW_START_OF_NEXT_DAY";
    DelayStart["FROMNOWSTARTOFNEXTWEEK"] = "FROM_NOW_START_OF_NEXT_WEEK";
})(DelayStart || (DelayStart = {}));
var EventColor;
(function(EventColor) {
    EventColor["NONE"] = "NONE";
    EventColor["LAVENDER"] = "LAVENDER";
    EventColor["SAGE"] = "SAGE";
    EventColor["GRAPE"] = "GRAPE";
    EventColor["FLAMINGO"] = "FLAMINGO";
    EventColor["BANANA"] = "BANANA";
    EventColor["TANGERINE"] = "TANGERINE";
    EventColor["PEACOCK"] = "PEACOCK";
    EventColor["GRAPHITE"] = "GRAPHITE";
    EventColor["BLUEBERRY"] = "BLUEBERRY";
    EventColor["BASIL"] = "BASIL";
    EventColor["TOMATO"] = "TOMATO";
})(EventColor || (EventColor = {}));
var EventResponseStatus;
(function(EventResponseStatus) {
    EventResponseStatus["None"] = "None";
    EventResponseStatus["Organizer"] = "Organizer";
    EventResponseStatus["Accepted"] = "Accepted";
    EventResponseStatus["Declined"] = "Declined";
    EventResponseStatus["TentativelyAccepted"] = "TentativelyAccepted";
    EventResponseStatus["NotResponded"] = "NotResponded";
})(EventResponseStatus || (EventResponseStatus = {}));
var EventStatus;
(function(EventStatus) {
    EventStatus["PUBLISHED"] = "PUBLISHED";
    EventStatus["CANCELLED"] = "CANCELLED";
})(EventStatus || (EventStatus = {}));
var IconType;
(function(IconType) {
    IconType["LIGHT"] = "LIGHT";
    IconType["COFFEE"] = "COFFEE";
    IconType["BOLT"] = "BOLT";
    IconType["COMMENT"] = "COMMENT";
    IconType["STAR"] = "STAR";
    IconType["AIRPLANE"] = "AIRPLANE";
    IconType["TWINKLE"] = "TWINKLE";
    IconType["COMPASS"] = "COMPASS";
    IconType["SUN"] = "SUN";
    IconType["SMILE"] = "SMILE";
})(IconType || (IconType = {}));
var LinkInvalidationReason;
(function(LinkInvalidationReason) {
    LinkInvalidationReason["ACCESSLOST"] = "ACCESS_LOST";
    LinkInvalidationReason["USERINITIATED"] = "USER_INITIATED";
})(LinkInvalidationReason || (LinkInvalidationReason = {}));
var MeetingLimitMeetingLimitPeriod;
(function(MeetingLimitMeetingLimitPeriod) {
    MeetingLimitMeetingLimitPeriod["DAILY"] = "DAILY";
    MeetingLimitMeetingLimitPeriod["WEEKLY"] = "WEEKLY";
})(MeetingLimitMeetingLimitPeriod || (MeetingLimitMeetingLimitPeriod = {}));
var Month;
(function(Month) {
    Month["JANUARY"] = "JANUARY";
    Month["FEBRUARY"] = "FEBRUARY";
    Month["MARCH"] = "MARCH";
    Month["APRIL"] = "APRIL";
    Month["MAY"] = "MAY";
    Month["JUNE"] = "JUNE";
    Month["JULY"] = "JULY";
    Month["AUGUST"] = "AUGUST";
    Month["SEPTEMBER"] = "SEPTEMBER";
    Month["OCTOBER"] = "OCTOBER";
    Month["NOVEMBER"] = "NOVEMBER";
    Month["DECEMBER"] = "DECEMBER";
})(Month || (Month = {}));
var ReclaimEventType;
(function(ReclaimEventType) {
    ReclaimEventType["USER"] = "USER";
    ReclaimEventType["SYNC"] = "SYNC";
    ReclaimEventType["HABITASSIGNMENT"] = "HABIT_ASSIGNMENT";
    ReclaimEventType["SMARTHABIT"] = "SMART_HABIT";
    ReclaimEventType["ONEONONEASSIGNMENT"] = "ONE_ON_ONE_ASSIGNMENT";
    ReclaimEventType["SMARTMEETING"] = "SMART_MEETING";
    ReclaimEventType["TASKASSIGNMENT"] = "TASK_ASSIGNMENT";
    ReclaimEventType["CONFBUFFER"] = "CONF_BUFFER";
    ReclaimEventType["TRAVELBUFFER"] = "TRAVEL_BUFFER";
    ReclaimEventType["SCHEDULINGLINKMEETING"] = "SCHEDULING_LINK_MEETING";
    ReclaimEventType["UNKNOWN"] = "UNKNOWN";
})(ReclaimEventType || (ReclaimEventType = {}));
var SchedulingLinkMemberStatus;
(function(SchedulingLinkMemberStatus) {
    SchedulingLinkMemberStatus["ACTIVE"] = "ACTIVE";
    SchedulingLinkMemberStatus["UNPAID"] = "UNPAID";
    SchedulingLinkMemberStatus["NOTINTEAM"] = "NOT_IN_TEAM";
    SchedulingLinkMemberStatus["ACCOUNTDELETED"] = "ACCOUNT_DELETED";
    SchedulingLinkMemberStatus["UNAUTHORIZED"] = "UNAUTHORIZED";
})(SchedulingLinkMemberStatus || (SchedulingLinkMemberStatus = {}));
var SchedulingLinkRole;
(function(SchedulingLinkRole) {
    SchedulingLinkRole["MAINORGANIZER"] = "MAIN_ORGANIZER";
    SchedulingLinkRole["COORGANIZER"] = "CO_ORGANIZER";
})(SchedulingLinkRole || (SchedulingLinkRole = {}));
var SchedulingPriority;
(function(SchedulingPriority) {
    SchedulingPriority["P1"] = "P1";
    SchedulingPriority["P2"] = "P2";
    SchedulingPriority["P3"] = "P3";
    SchedulingPriority["P4"] = "P4";
    SchedulingPriority["DEFAULT"] = "DEFAULT";
    SchedulingPriority["HIGH"] = "HIGH";
})(SchedulingPriority || (SchedulingPriority = {}));
var SurveyQuestionType;
(function(SurveyQuestionType) {
    SurveyQuestionType["ONELINE"] = "ONE_LINE";
})(SurveyQuestionType || (SurveyQuestionType = {}));
var TimePolicyType;
(function(TimePolicyType) {
    TimePolicyType["WORK"] = "WORK";
    TimePolicyType["PERSONAL"] = "PERSONAL";
    TimePolicyType["MEETING"] = "MEETING";
    TimePolicyType["ONEOFF"] = "ONE_OFF";
    TimePolicyType["INHERITED"] = "INHERITED";
    TimePolicyType["CUSTOM"] = "CUSTOM";
})(TimePolicyType || (TimePolicyType = {}));
var ZoneOffsetTransitionRuleTimeDefinition;
(function(ZoneOffsetTransitionRuleTimeDefinition) {
    ZoneOffsetTransitionRuleTimeDefinition["UTC"] = "UTC";
    ZoneOffsetTransitionRuleTimeDefinition["WALL"] = "WALL";
    ZoneOffsetTransitionRuleTimeDefinition["STANDARD"] = "STANDARD";
})(ZoneOffsetTransitionRuleTimeDefinition || (ZoneOffsetTransitionRuleTimeDefinition = {}));
var HEADER_BUILD_ID = "X-Reclaim-Build-Id";
var // TODO: The need for this is hard codded into the codegen source... so dumb
BodyType;
(function(BodyType) {
    BodyType[BodyType["Json"] = 0] = "Json";
})(BodyType || (BodyType = {}));
var ReclaimApiError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReclaimApiError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ReclaimApiError);
    function ReclaimApiError(res, message) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ReclaimApiError);
        var _this;
        var ref;
        _this = _super.call(this, message);
        if (!res && !message) message = "No response object";
        _this.status = res === null || res === void 0 ? void 0 : res.status;
        _this.statusText = (res === null || res === void 0 ? void 0 : res.statusText) || ((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || message;
        _this.headers = res === null || res === void 0 ? void 0 : res.headers;
        _this.body = res === null || res === void 0 ? void 0 : res.data;
        return _this;
    }
    return ReclaimApiError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Error));
var NetworkError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(NetworkError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(NetworkError);
    function NetworkError(res, message) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, NetworkError);
        var _this;
        var ref;
        _this = _super.call(this, message);
        _this.status = "NetworkError";
        if (!res && !message) message = "No response object";
        _this.statusText = (res === null || res === void 0 ? void 0 : res.statusText) || ((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || message;
        _this.headers = res === null || res === void 0 ? void 0 : res.headers;
        _this.body = res === null || res === void 0 ? void 0 : res.data;
        return _this;
    }
    return NetworkError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Error));
var HttpClient = /*#__PURE__*/ function() {
    "use strict";
    function HttpClient() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            BUILD_ID: "unknown"
        }, baseUrl = ref.baseUrl, baseApiParams = ref.baseApiParams, securityWorker = ref.securityWorker, BUILD_ID = ref.BUILD_ID;
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, HttpClient);
        this.baseUrl = "https://api.app.reclaim.ai/api";
        this.securityData = null;
        this.securityWorker = function() {};
        this.baseApiParams = {
            headers: {
                "Content-Type": "application/json",
                Referrer: "no-referrer"
            }
        };
        this.requestHooks = {};
        this.responseHooks = {};
        this.setSecurityData = function(data) {
            _this.securityData = data;
        };
        this.request = function(path, method) {
            var _param = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, data = arguments.length > 3 ? arguments[3] : void 0, _dumbUnusedBodyType = arguments.length > 4 ? arguments[4] : void 0, secureByDefault = arguments.length > 5 ? arguments[5] : void 0;
            var secure = _param.secure, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
                "secure"
            ]);
            return _this.client.request((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                url: path
            }, params), {
                method: method,
                data: data,
                validateStatus: function validateStatus(status) {
                    return true;
                }
            })).then(function(r) {
                if (r.status >= 200 && r.status < 300) {
                    return !!r.data ? r.data : null;
                } else if (!r.status) {
                    throw new NetworkError(r);
                } else {
                    throw new ReclaimApiError(r);
                }
            });
        };
        if (!!baseUrl) this.baseUrl = baseUrl;
        if (!!baseApiParams) this.baseApiParams = baseApiParams;
        if (!!securityWorker) this.securityWorker = securityWorker;
        this.client = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
            baseURL: baseUrl || this.baseUrl,
            withCredentials: true,
            headers: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, HEADER_BUILD_ID, BUILD_ID), this.baseApiParams.headers || {}), {
                post: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            })
        });
        this.client.interceptors.request.use(function(config) {
            Object.keys(_this.requestHooks).forEach(function(name) {
                _this.requestHooks[name](config);
            });
            return config;
        });
        this.client.interceptors.response.use(function(r) {
            Object.keys(_this.responseHooks).forEach(function(name) {
                if (r.status) {
                    return _this.responseHooks["".concat(name, " - Status: ").concat(r.status)](new ReclaimApiError(r));
                }
                _this.responseHooks["".concat(name, " - Status: network")](new NetworkError(r));
            });
            return r;
        }, function(error) {
            Object.keys(_this.responseHooks).forEach(function(name) {
                _this.responseHooks[name](error);
            });
            return error;
        });
    }
    var _proto = HttpClient.prototype;
    _proto.addQueryParam = function addQueryParam(query, key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(Array.isArray(query[key]) ? query[key].join(",") : query[key]);
    };
    _proto.addQueryParams = function addQueryParams(rawQuery) {
        var _this = this;
        var query = rawQuery || {};
        var keys = Object.keys(query).filter(function(key) {
            return "undefined" !== typeof query[key];
        });
        return keys.length ? "?".concat(keys.map(function(key) {
            return typeof query[key] === "object" && !Array.isArray(query[key]) ? _this.addQueryParams(query[key]).substring(1) : _this.addQueryParam(query, key);
        }).join("&")) : "";
    };
    _proto.registerRequestHook = function registerRequestHook(name, fn) {
        this.requestHooks[name] = fn;
    };
    _proto.registerResponseHook = function registerResponseHook(name, status, fn) {
        this.responseHooks["".concat(name, " - Status: ").concat(status)] = fn;
    };
    return HttpClient;
}();
/**
 * @title Reclaim Scheduling Links API
 * @version 0.1
 * @baseUrl https://api.app.reclaim.ai/api
 * Reclaim's awesome scheduling links API
 */ var ReclaimApi = /*#__PURE__*/ function(HttpClient) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReclaimApi, HttpClient);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ReclaimApi);
    function ReclaimApi() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ReclaimApi);
        var _this;
        _this = _super.apply(this, arguments);
        _this.schedulingLink = {
            /**
     * @tags scheduling-link
     * @name getAllLinks
     * @request GET:/scheduling-link
     */ getAllLinks: function(query, params) {
                return _this.request("/scheduling-link".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name createLink
     * @request POST:/scheduling-link
     */ createLink: function(data, query, params) {
                return _this.request("/scheduling-link".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags scheduling-link
     * @name createDerivativeSchedulingLink
     * @request POST:/scheduling-link/derivative
     */ createDerivativeSchedulingLink: function(data, params) {
                return _this.request("/scheduling-link/derivative", "POST", params, data);
            },
            /**
     * @tags scheduling-link
     * @name effectiveTimePolicy
     * @request POST:/scheduling-link/effective-time-policy
     */ effectiveTimePolicy: function(data, params) {
                return _this.request("/scheduling-link/effective-time-policy", "POST", params, data);
            },
            /**
     * @tags scheduling-link
     * @name getLinkForUserAndLinkSlugViaURLParameters
     * @summary NOTE: this is a workaround for RAI-7751 where a customer configured a userSlug = 'admin', which AWS WAF blocked because it didn't like '/admin' in the path.
     * @request GET:/scheduling-link/for-user-link-slug
     * @description NOTE: this is a workaround for RAI-7751 where a customer configured a userSlug = 'admin', which AWS WAF blocked because it didn't like '/admin' in the path. It performs the exact same function as getLinkForUserAndLinkSlug, but uses request parameters rather than path variables.
     */ getLinkForUserAndLinkSlugViaUrlParameters: function(query, params) {
                return _this.request("/scheduling-link/for-user-link-slug".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name getLinkForUserAndLinkSlug
     * @request GET:/scheduling-link/for-user-link-slug/{userSlug}/{linkSlug}
     */ getLinkForUserAndLinkSlug: function(userSlug, linkSlug, params) {
                return _this.request("/scheduling-link/for-user-link-slug/".concat(userSlug, "/").concat(linkSlug), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name getAllLinksForUserSlug
     * @request GET:/scheduling-link/for-user-slug/{userSlug}
     */ getAllLinksForUserSlug: function(userSlug, query, params) {
                return _this.request("/scheduling-link/for-user-slug/".concat(userSlug).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name getAllLinkGroupsForUser
     * @request GET:/scheduling-link/group
     */ getAllLinkGroupsForUser: function(params) {
                return _this.request("/scheduling-link/group", "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name createSchedulingLinkGroup
     * @request POST:/scheduling-link/group
     */ createSchedulingLinkGroup: function(data, params) {
                return _this.request("/scheduling-link/group", "POST", params, data);
            },
            /**
     * @tags scheduling-link
     * @name deleteLinkGroup
     * @request DELETE:/scheduling-link/group/{id}
     */ deleteLinkGroup: function(id, params) {
                return _this.request("/scheduling-link/group/".concat(id), "DELETE", params);
            },
            /**
     * @tags scheduling-link
     * @name updateschedulingLinkGroup
     * @request PATCH:/scheduling-link/group/{id}
     */ updateschedulingLinkGroup: function(id, data, params) {
                return _this.request("/scheduling-link/group/".concat(id), "PATCH", params, data);
            },
            /**
     * @tags scheduling-link
     * @name deleteLinkGroupAndMoveLinks
     * @request DELETE:/scheduling-link/group/{id}/moveLinks
     */ deleteLinkGroupAndMoveLinks: function(id, query, params) {
                return _this.request("/scheduling-link/group/".concat(id, "/moveLinks").concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags scheduling-link
     * @name findMeeting
     * @request GET:/scheduling-link/meeting/{meetingId}
     */ findMeeting: function(meetingId, query, params) {
                return _this.request("/scheduling-link/meeting/".concat(meetingId).concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name deleteMeeting
     * @request DELETE:/scheduling-link/meeting/{meetingId}
     */ deleteMeeting: function(meetingId, params) {
                return _this.request("/scheduling-link/meeting/".concat(meetingId), "DELETE", params);
            },
            /**
     * @tags scheduling-link
     * @name updateMeeting
     * @request PATCH:/scheduling-link/meeting/{meetingId}
     */ updateMeeting: function(meetingId, data, params) {
                return _this.request("/scheduling-link/meeting/".concat(meetingId), "PATCH", params, data);
            },
            /**
     * @tags scheduling-link
     * @name deleteMeetingWithMessage
     * @request POST:/scheduling-link/meeting/{meetingId}/cancel
     */ deleteMeetingWithMessage: function(meetingId, data, params) {
                return _this.request("/scheduling-link/meeting/".concat(meetingId, "/cancel"), "POST", params, data);
            },
            /**
     * @tags scheduling-link
     * @name schedulingLinkSlugExists
     * @request GET:/scheduling-link/slug-exists
     */ schedulingLinkSlugExists: function(query, params) {
                return _this.request("/scheduling-link/slug-exists".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name getMyUserSlug
     * @request GET:/scheduling-link/user-slug
     */ getMyUserSlug: function(params) {
                return _this.request("/scheduling-link/user-slug", "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name updateMyUserSlug
     * @request POST:/scheduling-link/user-slug
     */ updateMyUserSlug: function(data, params) {
                return _this.request("/scheduling-link/user-slug", "POST", params, data);
            },
            /**
     * @tags scheduling-link
     * @name userSlugExists
     * @request GET:/scheduling-link/user-slug/exists
     */ userSlugExists: function(query, params) {
                return _this.request("/scheduling-link/user-slug/exists".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name getUserSlug
     * @request GET:/scheduling-link/user-slug/{userId}
     */ getUserSlug: function(userId, params) {
                return _this.request("/scheduling-link/user-slug/".concat(userId), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name getLink
     * @request GET:/scheduling-link/{id}
     */ getLink: function(id, params) {
                return _this.request("/scheduling-link/".concat(id), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name deleteLink
     * @request DELETE:/scheduling-link/{id}
     */ deleteLink: function(id, query, params) {
                return _this.request("/scheduling-link/".concat(id).concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags scheduling-link
     * @name updateLink
     * @request PATCH:/scheduling-link/{id}
     */ updateLink: function(id, data, params) {
                return _this.request("/scheduling-link/".concat(id), "PATCH", params, data);
            },
            /**
     * @tags scheduling-link
     * @name getAvailabilityForDates
     * @request GET:/scheduling-link/{schedulingLinkId}/availability/V2
     */ getAvailabilityForDates: function(schedulingLinkId, query, params) {
                return _this.request("/scheduling-link/".concat(schedulingLinkId, "/availability/V2").concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name createMeeting
     * @request POST:/scheduling-link/{schedulingLinkId}/meeting
     */ createMeeting: function(schedulingLinkId, data, params) {
                return _this.request("/scheduling-link/".concat(schedulingLinkId, "/meeting"), "POST", params, data);
            },
            /**
     * @tags scheduling-link
     * @name getMeetingSlots
     * @request GET:/scheduling-link/{schedulingLinkId}/meeting/availability/V2
     */ getMeetingSlots: function(schedulingLinkId, query, params) {
                return _this.request("/scheduling-link/".concat(schedulingLinkId, "/meeting/availability/V2").concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name availabilityDebugger
     * @request GET:/scheduling-link/{schedulingLinkId}/meeting/availability/debugger
     */ availabilityDebugger: function(schedulingLinkId, query, params) {
                return _this.request("/scheduling-link/".concat(schedulingLinkId, "/meeting/availability/debugger").concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags scheduling-link
     * @name listMeetingsForSchedulingLink
     * @request GET:/scheduling-link/{schedulingLinkId}/meetings
     */ listMeetingsForSchedulingLink: function(schedulingLinkId, params) {
                return _this.request("/scheduling-link/".concat(schedulingLinkId, "/meetings"), "GET", params);
            }
        };
        return _this;
    }
    return ReclaimApi;
}(HttpClient);


/***/ }),

/***/ 50084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B7": function() { return /* binding */ SUPPORTED_CURRENCY_MAP; },
/* harmony export */   "JZ": function() { return /* binding */ EDITION_META; },
/* harmony export */   "Th": function() { return /* binding */ SUPPORTED_CURRENCIES_LIST; },
/* harmony export */   "mm": function() { return /* binding */ ENTITLEMENT_META; },
/* harmony export */   "rE": function() { return /* binding */ EDITION_ORDER; }
/* harmony export */ });
/* unused harmony exports integrationEntitlementComparator, SUB_FREQUENCY_ORDER, SUB_FREQUENCY_META */
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45110);
/* harmony import */ var _utils_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14023);


var SUPPORTED_CURRENCIES_LIST = [
    "USD",
    "EUR"
];
var SUPPORTED_CURRENCY_MAP = (0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .extantMap */ .jG)(SUPPORTED_CURRENCIES_LIST);
var integrationEntitlementComparator = (0,_utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .makeOrderedListComparator */ .LU)([
    "ESSENTIALS",
    "LEGACY_PRO",
    "PREMIUM", 
]);
var EDITION_ORDER = Object.freeze([
    "NONE",
    "ASSISTANT",
    "LITE",
    "PRO",
    "STARTER",
    "TEAM",
    "BUSINESS",
    "REWARD",
    "ENTERPRISE",
    "TRIAL",
    "LEGACY_PRO_TRIAL",
    "LEGACY_TEAM_TRIAL",
    "TRIAL_BUSINESS",
    "TEAM_REWARD", 
]);
var EDITION_META = {
    ASSISTANT: {
        label: "Free",
        isLegacy: true,
        isNonPaid: true
    },
    LEGACY_PRO_TRIAL: {
        label: "Team",
        isTrial: true,
        isLegacy: true
    },
    LEGACY_TEAM_TRIAL: {
        label: "Team",
        isTrial: true,
        isLegacy: true
    },
    NONE: {
        label: "",
        isLegacy: true
    },
    PRO: {
        label: "Pro",
        isLegacy: true
    },
    REWARD: {
        label: "Team",
        isLegacy: true,
        isReward: true
    },
    TEAM: {
        label: "Team",
        isLegacy: true
    },
    TRIAL: {
        label: "Team",
        isTrial: true,
        isLegacy: true
    },
    TRIAL_BUSINESS: {
        label: "Business",
        isTrial: true
    },
    TRIAL_BUSINESS_12W: {
        label: "Business",
        isTrial: true
    },
    TRIAL_BUSINESS_FOR_LEGACY_PLANS: {
        label: "Business",
        isTrial: true
    },
    TEAM_REWARD: {
        label: "Business",
        isReward: true
    },
    LITE: {
        label: "Lite",
        description: "Lite plans are great for those who are new to Reclaim and want to learn the basics for free.",
        isNonPaid: true
    },
    STARTER: {
        label: "Starter",
        description: "Starter plans are great for those working alone or on a small team with moderate needs."
    },
    BUSINESS: {
        label: "Business",
        description: "Business plans are good for larger teams and companies who want to use Reclaim across the organization."
    },
    ENTERPRISE: {
        label: "Enterprise",
        description: "Enterprise plans are for the largest teams and companies.  Contact us to learn more."
    }
};
var ENTITLEMENT_META = {
    TEAM_SIZE: {
        label: "Max Users in Team",
        description: "The maximum number of users you can have in your Reclaim team.",
        comparator: function(a, b) {
            return (0,_utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .multiComparator */ .WD)([
                a === null || a === void 0 ? void 0 : a.max,
                b === null || b === void 0 ? void 0 : b.max,
                _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
            ], [
                a === null || a === void 0 ? void 0 : a.min,
                b === null || b === void 0 ? void 0 : b.min,
                _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
            ]);
        }
    },
    SCHEDULER_WEEKS: {
        label: "Scheduler range",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
    },
    MAX_TASKS: {
        label: "Tasks",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
    },
    MAX_CALENDARS: {
        label: "Connected Calendars",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
    },
    MAX_SYNCS: {
        label: "Calendar Syncs",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
    },
    MAX_HABITS: {
        label: "Habits",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
    },
    MAX_CUSTOM_TIME_SCHEMES: {
        label: "Custom hours",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
    },
    MAX_SCHEDULING_LINKS: {
        label: "Scheduling Links",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae,
        displayOverrideValues: {
            LITE: 1,
            PRO: 1,
            TEAM: 1,
            STARTER: 3,
            BUSINESS: Infinity,
            ENTERPRISE: Infinity
        }
    },
    MAX_1_ON_1_ORGANIZE: {
        label: "Organize Smart 1:1s",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
    },
    MAX_1_ON_1_ATTEND: {
        label: "Attend Smart 1:1s",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .numComparator */ .Ae
    },
    SUPPORT: {
        label: "Support",
        comparator: (0,_utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .makeOrderedListComparator */ .LU)([
            "COMMUNITY",
            "BASIC",
            "PRIORITY"
        ])
    },
    SSO: {
        label: "SSO/Domain capture",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    CUSTOM_SLACK_STATUS: {
        label: "Custom Slack Status Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    // custom blocking
    CUSTOM_BLOCKING: {
        label: "Time blocking",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    CUSTOM_BLOCKING_CALENDAR_SYNC: {
        label: "Calendar Sync blocking",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    CUSTOM_BLOCKING_DECOMPRESSION: {
        label: "Decompression",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    CUSTOM_BLOCKING_HABITS: {
        label: "Habit blocking",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    // integrations
    INTEGRATIONS: {
        label: "Integrations",
        comparator: integrationEntitlementComparator
    },
    INTEGRATION_SLACK: {
        label: "Slack Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_RAYCAST: {
        label: "Raycast Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_CLICKUP: {
        label: "Clickup Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_ZOOM: {
        label: "Zoom Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_GOOGLE_TASKS: {
        label: "Google Tasks Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_JIRA: {
        label: "Jira Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_ASANA: {
        label: "Asana Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_TODOIST: {
        label: "Todoist Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_LINEAR: {
        label: "Linear Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_GOOGLE_ADD_ON: {
        label: "Linear Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_MONDAY: {
        label: "Linear Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_OFFICE_365: {
        label: "Linear Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    INTEGRATION_TRELLO: {
        label: "Linear Integration",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    DERIVATIVE_SCHEDULING_LINKS: {
        label: "Scheduling Links custom links",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    TEAM_ANALYTICS: {
        label: "Team Analytics",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    // Custom Questions
    SCHEDULING_LINK_SURVEY: {
        label: "Scheduling Links custom questions",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    },
    SCHEDULING_LINK_REDIRECT: {
        label: "Scheduling Links redirect URLs",
        comparator: _utils_sort__WEBPACK_IMPORTED_MODULE_1__/* .boolComparator */ .Y
    }
};
var SUB_FREQUENCY_ORDER = Object.freeze([
    "MONTH",
    "YEAR"
]);
var SUB_FREQUENCY_META = Object.freeze({
    MONTH: {
        label: "month"
    },
    YEAR: {
        label: "year"
    }
});


/***/ }),

/***/ 19009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A2": function() { return /* binding */ dtoToEntitlementTable; },
/* harmony export */   "AC": function() { return /* binding */ dtoToSubscriptionOptions; },
/* harmony export */   "Bx": function() { return /* binding */ dtoToReclaimEdition; },
/* harmony export */   "C$": function() { return /* binding */ dtoToTeamPricingSummary; },
/* harmony export */   "FC": function() { return /* binding */ dtoToNumberEntitlementValue; },
/* harmony export */   "Jn": function() { return /* binding */ dtoToEntitlementTableRow; },
/* harmony export */   "Lz": function() { return /* binding */ dtoToTeamMembershipSummary; },
/* harmony export */   "OX": function() { return /* binding */ subscriptionChangeToDto; },
/* harmony export */   "aU": function() { return /* binding */ dtoToSubscriptionChangeResult; },
/* harmony export */   "dl": function() { return /* binding */ supportedCurrencyToDto; },
/* harmony export */   "qQ": function() { return /* binding */ reclaimEditionToDto; }
/* harmony export */ });
/* unused harmony exports dtoToSubscriptionFrequencyStr, subscriptionFrequencyStrToDto, dtoToEntitlementValueObject, dtoToNumberEntitlementValueObject, dtoToSubscriptionPrice, dtoToSubscriptionOption, dtoToInvoiceLineItemView, dtoToSupportedCurrency, dtoToInvoiceView */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _utils_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45110);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34629);





var dtoToReclaimEdition = function(dto) {
    return dto;
};
var reclaimEditionToDto = function(edition) {
    return edition;
};
var dtoToTeamMembershipSummary = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto), {
        maxUsageEdition: dto.maxUsageEdition ? dtoToReclaimEdition(dto.maxUsageEdition) : undefined
    });
};
var dtoToSubscriptionFrequencyStr = function(dto) {
    return dto;
};
var subscriptionFrequencyStrToDto = function(subFrequency) {
    return subFrequency;
};
var dtoToEntitlementValueObject = function(dto) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        value: dto.value
    }, !dto.nextEdition || dto.nextValue === undefined ? {
        isTop: true,
        nextEdition: void 0,
        nextValue: void 0
    } : {
        isTop: false,
        nextEdition: dtoToReclaimEdition(dto.nextEdition),
        nextValue: dto.nextValue
    });
};
var dtoToNumberEntitlementValue = function(dto) {
    var num = Number(dto);
    return num >= 10000 ? Infinity : num;
};
/**
 * Back-end passes `Infinity` as `"Infinity"`.
 * This function behaves exactly like
 * `dtoToEntitlementValueObject` only it can
 * also parse the string infinity values
 * @param dto The data transfer object
 * @returns a `EntitlementValueObject<number>` object
 */ var dtoToNumberEntitlementValueObject = function(dto) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        value: dtoToNumberEntitlementValue(dto.value)
    }, !!dto.nextEdition && dto.nextValue !== undefined ? {
        isTop: false,
        nextEdition: dtoToReclaimEdition(dto.nextEdition),
        nextValue: dtoToNumberEntitlementValue(dto.nextValue)
    } : {
        isTop: true
    });
};
var EDITION_MIN_TEAM_SIZE = {
    ENTERPRISE: 100
};
var dtoToEntitlementTableRow = function(dto, // TODO: we need to figure out support for min-team, this is a holdover until then -SG
edition) {
    return {
        TEAM_SIZE: dtoToEntitlementValueObject((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto.MAX_TEAM_SIZE), {
            value: {
                min: dtoToNumberEntitlementValue(edition && EDITION_MIN_TEAM_SIZE[edition] || 1),
                max: dtoToNumberEntitlementValue(dto.MAX_TEAM_SIZE.value)
            },
            nextValue: typeof dto.MAX_TEAM_SIZE.nextValue === "number" ? {
                min: 1,
                max: dtoToNumberEntitlementValue(dto.MAX_TEAM_SIZE.nextValue)
            } : null
        })),
        SCHEDULER_WEEKS: dtoToNumberEntitlementValueObject(dto.SCHEDULER_WEEKS),
        MAX_TASKS: dtoToNumberEntitlementValueObject(dto.MAX_TASKS),
        MAX_CALENDARS: dtoToNumberEntitlementValueObject(dto.MAX_CALENDARS),
        MAX_SYNCS: dtoToNumberEntitlementValueObject(dto.MAX_SYNCS),
        MAX_HABITS: dtoToNumberEntitlementValueObject(dto.MAX_HABITS),
        MAX_CUSTOM_TIME_SCHEMES: dtoToNumberEntitlementValueObject(dto.MAX_CUSTOM_TIME_SCHEMES),
        MAX_SCHEDULING_LINKS: dtoToNumberEntitlementValueObject(dto.MAX_SCHEDULING_LINKS),
        DERIVATIVE_SCHEDULING_LINKS: dtoToEntitlementValueObject(dto.DERIVATIVE_SCHEDULING_LINKS),
        MAX_1_ON_1_ORGANIZE: dtoToNumberEntitlementValueObject(dto.MAX_1_ON_1_ORGANIZE),
        MAX_1_ON_1_ATTEND: dtoToNumberEntitlementValueObject(dto.MAX_1_ON_1_ATTEND),
        TEAM_ANALYTICS: dtoToEntitlementValueObject(dto.TEAM_ANALYTICS),
        SUPPORT: dtoToEntitlementValueObject(dto.SUPPORT),
        SSO: dtoToEntitlementValueObject(dto.SSO),
        CUSTOM_SLACK_STATUS: dtoToEntitlementValueObject(dto.CUSTOM_SLACK_STATUS),
        CUSTOM_BLOCKING: dtoToEntitlementValueObject(dto.CUSTOM_BLOCKING),
        CUSTOM_BLOCKING_CALENDAR_SYNC: dtoToEntitlementValueObject(dto.CUSTOM_BLOCKING_CALENDAR_SYNC),
        CUSTOM_BLOCKING_DECOMPRESSION: dtoToEntitlementValueObject(dto.CUSTOM_BLOCKING_DECOMPRESSION),
        CUSTOM_BLOCKING_HABITS: dtoToEntitlementValueObject(dto.CUSTOM_BLOCKING_HABITS),
        INTEGRATIONS: dtoToEntitlementValueObject(dto.INTEGRATIONS),
        INTEGRATION_SLACK: dtoToEntitlementValueObject(dto.INTEGRATION_SLACK),
        INTEGRATION_RAYCAST: dtoToEntitlementValueObject(dto.INTEGRATION_RAYCAST),
        INTEGRATION_CLICKUP: dtoToEntitlementValueObject(dto.INTEGRATION_CLICKUP),
        INTEGRATION_ZOOM: dtoToEntitlementValueObject(dto.INTEGRATION_ZOOM),
        INTEGRATION_GOOGLE_TASKS: dtoToEntitlementValueObject(dto.INTEGRATION_GOOGLE_TASKS),
        INTEGRATION_JIRA: dtoToEntitlementValueObject(dto.INTEGRATION_JIRA),
        INTEGRATION_ASANA: dtoToEntitlementValueObject(dto.INTEGRATION_ASANA),
        INTEGRATION_TODOIST: dtoToEntitlementValueObject(dto.INTEGRATION_TODOIST),
        INTEGRATION_LINEAR: dtoToEntitlementValueObject(dto.INTEGRATION_LINEAR),
        INTEGRATION_GOOGLE_ADD_ON: dtoToEntitlementValueObject(dto.INTEGRATION_GOOGLE_ADD_ON),
        INTEGRATION_MONDAY: dtoToEntitlementValueObject(dto.INTEGRATION_MONDAY),
        INTEGRATION_OFFICE_365: dtoToEntitlementValueObject(dto.INTEGRATION_OFFICE_365),
        INTEGRATION_TRELLO: dtoToEntitlementValueObject(dto.INTEGRATION_TRELLO),
        SCHEDULING_LINK_SURVEY: dtoToEntitlementValueObject(dto.SCHEDULING_LINK_SURVEY),
        SCHEDULING_LINK_REDIRECT: dtoToEntitlementValueObject(dto.SCHEDULING_LINK_REDIRECT)
    };
};
var dtoToEntitlementTable = function(dto) {
    return (0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .typedEntries */ .FR)(dto).reduce(function(table, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), edition = _param[0], dtoRow = _param[1];
        table[edition] = dtoToEntitlementTableRow(dtoRow, dtoToReclaimEdition(edition));
        return table;
    }, {});
};
var dtoToSubscriptionPrice = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto), {
        isCurrentPlan: !!dto.selected
    });
};
var dtoToSubscriptionOption = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto), {
        // Backend isn't sending back Infinity for whatever reason
        maxSeats: dto.maxSeats > 1000 ? Infinity : dto.maxSeats,
        prices: dto.prices && (0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .typedEntries */ .FR)(dto.prices).reduce(function(prices, param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), freq = _param[0], price = _param[1];
            prices[freq] = dtoToSubscriptionPrice(price);
            return prices;
        }, {})
    });
};
var dtoToSubscriptionOptions = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto), {
        options: (0,_utils_objects__WEBPACK_IMPORTED_MODULE_0__/* .typedEntries */ .FR)(dto.options).reduce(function(options, param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), edition = _param[0], option = _param[1];
            options[edition] = dtoToSubscriptionOption(option);
            return options;
        }, {})
    });
};
var dtoToInvoiceLineItemView = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto), {
        periodStart: dto.periodStart || undefined,
        periodEnd: dto.periodEnd || undefined
    });
};
var dtoToSupportedCurrency = function(dto) {
    switch(dto){
        case _client__WEBPACK_IMPORTED_MODULE_1__/* .SupportedCurrency.Usd */ .xo.Usd:
            return "USD";
        case _client__WEBPACK_IMPORTED_MODULE_1__/* .SupportedCurrency.Eur */ .xo.Eur:
            return "EUR";
    }
};
var supportedCurrencyToDto = function(supportedCurrency) {
    switch(supportedCurrency){
        case "USD":
            return _client__WEBPACK_IMPORTED_MODULE_1__/* .SupportedCurrency.Usd */ .xo.Usd;
        case "EUR":
            return _client__WEBPACK_IMPORTED_MODULE_1__/* .SupportedCurrency.Eur */ .xo.Eur;
    }
};
var dtoToInvoiceView = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto), {
        dueDate: dto.dueDate || undefined,
        lines: dto.lines.map(dtoToInvoiceLineItemView),
        currency: dtoToSupportedCurrency(dto.currency)
    });
};
var subscriptionChangeToDto = function(data) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
        frequency: subscriptionFrequencyStrToDto(data.frequency),
        edition: reclaimEditionToDto(data.edition),
        promoCode: data.promoCode || null
    });
};
var dtoToTeamPricingSummary = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto), {
        trialEnd: dto.trialEnd || undefined,
        daysLeftInTrial: dto.daysLeftInTrial || undefined,
        subscriptionFrequency: dto.subscriptionFrequency || undefined,
        trial: dto.trial || undefined,
        edition: dto.edition ? dtoToReclaimEdition(dto.edition) : undefined,
        entitlements: dto.entitlements && dtoToEntitlementTableRow(dto.entitlements),
        currency: dto.currency ? dtoToSupportedCurrency(dto.currency) : undefined,
        subscriptionEnd: dto.subscriptionEnd ? new Date(dto.subscriptionEnd) : undefined
    });
};
var dtoToSubscriptionChangeResult = function(dto) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, dto), {
        upcomingInvoice: dto.upcomingInvoice ? dtoToInvoiceView(dto.upcomingInvoice) : undefined,
        membershipSummary: dtoToTeamMembershipSummary(dto.membershipSummary),
        pricingSummary: dtoToTeamPricingSummary(dto.pricingSummary)
    });
};


/***/ }),

/***/ 72897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O7": function() { return /* binding */ STRIPE_SESSION_URI; },
/* harmony export */   "OF": function() { return /* binding */ SubscriptionFrequency; },
/* harmony export */   "OR": function() { return /* binding */ TeamDomain; },
/* harmony export */   "Oy": function() { return /* binding */ MembershipRoleLabel; },
/* harmony export */   "Pt": function() { return /* binding */ TeamRedirectAction; },
/* harmony export */   "Zn": function() { return /* binding */ DomainSetting; },
/* harmony export */   "nJ": function() { return /* binding */ MembershipRole; },
/* harmony export */   "nV": function() { return /* binding */ RequestedTeamStatus; },
/* harmony export */   "qL": function() { return /* binding */ InviteSource; },
/* harmony export */   "xd": function() { return /* binding */ TeamMemberViewStatus; }
/* harmony export */ });
/* unused harmony exports STRIPE_NEW_SESSION_URI, InvitationStatus, SubscriptionStatus, dtoToTeamMember, dtoToTeamPartial, dtoToTeam, dtoToJoinableTeams, responsesToDto, dtoToTeamInvoice, invitesToDto, partialTeamMemberToDto, partialTeamToDto */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59637);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71418);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97582);
/* harmony import */ var _scheduling_links_SchedulingLinks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19331);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63496);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70550);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26958);
/* harmony import */ var _utils_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63429);
/* harmony import */ var _adaptors_ws__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77856);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42230);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34629);
/* harmony import */ var _Team_mutators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19009);



















var API_BASE_URI = "https://api.app.reclaim-staging.com/api";
var TeamSubscription = {
    subscriptionType: _adaptors_ws__WEBPACK_IMPORTED_MODULE_4__/* .SubscriptionType.Team */ .Qe.Team
};
var STRIPE_SESSION_URI = "".concat(API_BASE_URI, "/team/current/subscription/session");
var STRIPE_NEW_SESSION_URI = "".concat(API_BASE_URI, "/team/create/subscription/session");
var InvitationStatus;
(function(InvitationStatus) {
    InvitationStatus["Pending"] = "PENDING";
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Declined"] = "DECLINED";
    InvitationStatus["Deleted"] = "DELETED";
})(InvitationStatus || (InvitationStatus = {}));
var TeamMemberViewStatus;
(function(TeamMemberViewStatus) {
    TeamMemberViewStatus["Pending"] = "PENDING";
    TeamMemberViewStatus["Accepted"] = "ACCEPTED";
    TeamMemberViewStatus["Declined"] = "DECLINED";
})(TeamMemberViewStatus || (TeamMemberViewStatus = {}));
var MembershipRole;
(function(MembershipRole) {
    MembershipRole["User"] = "USER";
    MembershipRole["Admin"] = "ADMIN";
})(MembershipRole || (MembershipRole = {}));
var MembershipRoleLabel = {
    ADMIN: "Admin",
    USER: "User"
};
var SubscriptionStatus;
(function(SubscriptionStatus) {
    SubscriptionStatus["Trialing"] = "TRIALING";
    SubscriptionStatus["Active"] = "ACTIVE";
    SubscriptionStatus["Inactive"] = "INACTIVE";
})(SubscriptionStatus || (SubscriptionStatus = {}));
var DomainSetting;
(function(DomainSetting) {
    DomainSetting["InviteOnly"] = "INVITE_ONLY";
    DomainSetting["Request"] = "REQUEST";
    DomainSetting["Open"] = "OPEN";
    DomainSetting["AutoDomainCapture"] = "AUTO_DOMAIN_CAPTURE";
})(DomainSetting || (DomainSetting = {}));
var RequestedTeamStatus;
(function(RequestedTeamStatus) {
    RequestedTeamStatus["Pending"] = "PENDING";
    RequestedTeamStatus["Rejected"] = "REJECTED";
})(RequestedTeamStatus || (RequestedTeamStatus = {}));
var InviteSource;
(function(InviteSource) {
    InviteSource["Default"] = "invite";
    InviteSource["CreateTeam"] = "create-team";
})(InviteSource || (InviteSource = {}));
var SubscriptionFrequency;
(function(SubscriptionFrequency) {
    SubscriptionFrequency["Month"] = "MONTH";
    SubscriptionFrequency["Year"] = "YEAR";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
var TeamRedirectAction;
(function(TeamRedirectAction) {
    TeamRedirectAction["InviteAccepted"] = "accepted";
    TeamRedirectAction["PurchaseSuccess"] = "purchased";
    TeamRedirectAction["PurchaseCancelled"] = "purchaseCancelled";
    TeamRedirectAction["StartPurchase"] = "startPurchase";
    TeamRedirectAction["RequestJoin"] = "requestJoin";
    TeamRedirectAction["LeaveTeam"] = "leaveTeam";
})(TeamRedirectAction || (TeamRedirectAction = {}));
var dtoToTeamMember = function(dto) {
    var ref = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((dto.name || "").split(" ")), dtoFirstName = ref[0], otherNames = ref.slice(1);
    var dtoLastName = otherNames[otherNames.length - 1];
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dto), {
        edition: dto.edition ? (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToReclaimEdition */ .Bx)(dto.edition) : "ASSISTANT",
        editionAfterTrial: dto.editionAfterTrial ? (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToReclaimEdition */ .Bx)(dto.editionAfterTrial) : "ASSISTANT",
        status: dto.status,
        membershipRole: dto.membershipRole,
        editionUsage: dto.editionUsage || "ASSISTANT",
        requestedTeamStatus: !!dto.requestedTeamStatus ? dto.requestedTeamStatus : undefined,
        trialEnd: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .strToDate */ .z8)(dto.trialEnd),
        firstName: dto.firstName || dtoFirstName,
        lastName: dto.lastName || dtoLastName,
        timezone: !!dto.timezone ? (0,_scheduling_links_SchedulingLinks__WEBPACK_IMPORTED_MODULE_0__/* .zoneIdToUserTimeZone */ .vk)(dto.timezone) : undefined
    });
};
var dtoToTeamPartial = function(dto) {
    var ref, ref1;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dto), {
        paidProSeats: dto.paidProSeats || 0,
        paidTeamSeats: dto.paidTeamSeats || 0,
        proSeatsUsed: dto.proSeatsUsed || 0,
        teamSeatsUsed: dto.teamSeatsUsed || 0,
        userInviteLevel: dto.userInviteLevel ? (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToReclaimEdition */ .Bx)(dto.userInviteLevel) : "NONE",
        members: (ref = dto.members) === null || ref === void 0 ? void 0 : ref.map(dtoToTeamMember),
        domainSetting: dto.domainSetting,
        pricingSummary: dto.pricingSummary && (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToTeamPricingSummary */ .C$)(dto.pricingSummary),
        membershipSummary: dto.membershipSummary && (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToTeamMembershipSummary */ .Lz)(dto.membershipSummary),
        adminCount: (ref1 = dto.members) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(count, param) {
            var membershipRole = param.membershipRole;
            if (membershipRole === _client__WEBPACK_IMPORTED_MODULE_6__/* .MembershipRole.ADMIN */ .nJ.ADMIN) count++;
            return count;
        }, 0)
    });
};
// should always return a full Team as long as the TeamViewDto isn't partial
var dtoToTeam = function(dto) {
    return dtoToTeamPartial(dto);
};
var dtoToJoinableTeams = function(teams) {
    return teams.map(function(team) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, team), {
            domainSetting: team.domainSetting
        });
    });
};
var responsesToDto = function(responses) {
    return responses.map(function(r) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, r), {
            role: r.role,
            editionAfterTrial: r.editionAfterTrial && (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .reclaimEditionToDto */ .qQ)(r.editionAfterTrial)
        });
    });
};
var dtoToTeamInvoice = function(dto) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, dto);
};
var invitesToDto = function(invites) {
    return invites.map(function(i) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, i), {
            role: i.role,
            edition: i.edition && (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .reclaimEditionToDto */ .qQ)(i.edition)
        });
    });
};
var partialTeamMemberToDto = function(member) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, member), {
        role: member.role,
        edition: member.edition && (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .reclaimEditionToDto */ .qQ)(member.edition)
    });
};
var partialTeamToDto = function(team) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, team), {
        userInviteLevel: team.userInviteLevel && (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .reclaimEditionToDto */ .qQ)(team.userInviteLevel),
        domainSetting: team.domainSetting
    });
};
var TeamDomain = /*#__PURE__*/ function(TransformDomain) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(TeamDomain, TransformDomain);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(TeamDomain);
    function TeamDomain() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(this, TeamDomain);
        var _this;
        var ref;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(args)));
        _this.resource = "Team";
        _this.cacheKey = "team";
        _this.get = function() {
            return _this.domainApi.team.getCurrentTeam().then(dtoToTeam);
        };
        _this.teamWs$ = (0,wonka__WEBPACK_IMPORTED_MODULE_15__/* .pipe */ .zG)(((ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscription$$(TeamSubscription)) || (0,wonka__WEBPACK_IMPORTED_MODULE_15__/* .fromArray */ .nI)([]), (0,wonka__WEBPACK_IMPORTED_MODULE_15__/* .filter */ .hX)(function(envelope) {
            return !!envelope.data;
        }), (0,wonka__WEBPACK_IMPORTED_MODULE_15__/* .map */ .UI)(function(envelope) {
            return dtoToTeamPartial(envelope.data);
        }));
        _this.watchTeam$$ = function() {
            return _this.teamWs$;
        };
        _this.getMembers = function() {
            return _this.domainApi.team.getMembers().then(function(response) {
                return response.map(dtoToTeamMember);
            });
        };
        _this.getJoinableTeams = function() {
            return _this.domainApi.team.getJoinableTeams().then(dtoToJoinableTeams);
        };
        _this.respondToRequests = _this.manageErrorsAndNotificationKey(function(responses) {
            return _this.domainApi.team.joinResponses(responsesToDto(responses)).then(function(r) {
                return r.map(dtoToTeamMember);
            });
        }, "respondToRequest", {
            errorizer: function(cause, responses) {
                return Array.isArray(responses) ? "Failed to respond to requests: ".concat(responses.map(function(param) {
                    var userId = param.userId;
                    return userId;
                }).join(", ")) : "Failed to respond to requests: Invalid responses array";
            }
        });
        /**
   * request to join a team
   * @deprecated Not actually deprecated, but use useConfirmChangeTeamDialog instead
   */ _this.requestToJoinTeam = _this.manageErrorsAndNotificationKey(function(teamId) {
            return _this.domainApi.team.requestToJoinTeam(teamId);
        }, "requestToJoinTeam", {
            errorizer: function(cause, teamId) {
                return "Failed to request to join team: ".concat(teamId);
            }
        });
        _this.getRequests = function() {
            return _this.domainApi.team.getRequests().then(function(r) {
                return r.map(dtoToTeamMember);
            });
        };
        _this.cancelRequestToJoinTeam = _this.manageErrorsAndNotificationKey(function(teamId) {
            return _this.domainApi.team.cancelRequestToJoinTeam(teamId);
        }, "cancelRequestToJoinTeam", {
            errorizer: function(cause, teamId) {
                return "Failed to cancel request to join for team: ".concat(teamId);
            }
        });
        _this.getInviteableTeamMembers = function() {
            return _this.domainApi.team.getInviteableTeamMembers().then(function(r) {
                return r.map(dtoToTeamMember);
            });
        };
        _this.listInvoices = function() {
            return _this.domainApi.team.listInvoices().then(function(r) {
                return r.map(dtoToTeamInvoice);
            });
        };
        _this.deleteMember = _this.manageErrorsAndNotificationKey(function(userId) {
            return _this.domainApi.team.deleteMember({
                userId: userId
            });
        }, "deleteMember", {
            errorizer: function(cause, userId) {
                return "Failed to delete team member: ".concat(userId);
            }
        });
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this);
        _this.invite = _this.manageErrorsAndNotificationKey(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(invites, source) {
                var dtoinvites;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                    dtoinvites = invitesToDto(invites);
                    return [
                        2,
                        _this1.typedManageErrors(function() {
                            return _this1.domainApi.team.createInvitation(dtoinvites, {
                                source: source
                            });
                        })()
                    ];
                });
            });
            return function(invites, source) {
                return _ref.apply(this, arguments);
            };
        }(), "invite", {
            errorizer: function(cause, invites) {
                return Array.isArray(invites) ? "Failed to invite users: ".concat(invites.map(function(param) {
                    var email = param.email;
                    return email;
                }).join(", ")) : "Failed to invite users: Invalid invites array";
            }
        });
        /**
   * request to join a team
   * @deprecated Not actually deprecated, but use useConfirmChangeTeamDialog instead
   */ _this.leaveTeam = _this.manageErrorsAndNotificationKey(function() {
            return _this.domainApi.team.leaveTeam();
        }, "");
        _this.patchTeam = _this.manageErrorsAndNotificationKey(function(data, params) {
            return _this.domainApi.team.patchTeam(partialTeamToDto(data), params);
        }, "patchTeam", {
            errorizer: function(cause, param) {
                var name = param.name;
                return "Problem patching team: ".concat(name);
            }
        });
        _this.patchMember = _this.manageErrorsAndNotificationKey(function(userId, data, params) {
            return _this.domainApi.team.patchMember({
                userId: userId
            }, partialTeamMemberToDto(data), params);
        }, "patchMember", {
            errorizer: function(cause, userId) {
                return "Problem patching team member: ".concat(userId);
            }
        });
        _this.getInvitations = function() {
            return _this.domainApi.team.getInvitations();
        };
        _this.getDomains = function() {
            return _this.domainApi.team.getCurrentTeamDomains();
        };
        /**
   * request to join a team
   * @deprecated Not actually deprecated, but use useConfirmChangeTeamDialog instead
   */ _this.acceptInvitation = _this.manageErrorsAndNotificationKey(function(teamId, inviteId) {
            return _this.domainApi.team.acceptInvitation(teamId, inviteId, {
                accept: true
            });
        }, "acceptInvitation", {
            errorizer: function(cause, teamId, inviteId) {
                return "Failed to accept invitation with ID ".concat(inviteId, ' to team "').concat(teamId, '"');
            }
        });
        _this.deleteInvitation = _this.manageErrorsAndNotificationKey(function(id) {
            return _this.domainApi.team.deleteInvitation(id);
        }, "deleteInvitation", {
            errorizer: function(cause, id) {
                return "Failed to delete invitation: ".concat(id);
            }
        });
        var _this2 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this);
        _this.previewSubscriptionChange = _this.typedManageErrors(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(subChange) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.domainApi.team.previewSubscriptionChange((0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .subscriptionChangeToDto */ .OX)(subChange))
                            ];
                        case 1:
                            return [
                                2,
                                _Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToSubscriptionChangeResult.apply */ .aU.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(subChange) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this);
        _this.subscriptionChange = _this.manageErrorsAndNotificationKey(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(subChange) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this3.domainApi.team.subscriptionChange((0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .subscriptionChangeToDto */ .OX)(subChange))
                            ];
                        case 1:
                            return [
                                2,
                                _Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToSubscriptionChangeResult.apply */ .aU.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(subChange) {
                return _ref.apply(this, arguments);
            };
        }(), "subscriptionChange");
        var _this4 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this);
        _this.cancelSubscription = _this.manageErrorsAndNotificationKey(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(reason) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this4.domainApi.team.cancelSubscription({
                                    reason: reason
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(reason) {
                return _ref.apply(this, arguments);
            };
        }(), "cancelSubscription");
        var _this5 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this);
        _this.reinstateSubscription = _this.manageErrorsAndNotificationKey(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this5.domainApi.team.reinstateSubscription()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        }), "reinstateSubscription");
        var _this6 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this);
        _this.endTrial = _this.manageErrorsAndNotificationKey(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this6.domainApi.team.endTrial()
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        }), "endTrial");
        _this.startSubscription = _this.manageErrorsAndNotificationKey(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(param) {
                var frequency, seats, edition, options, _newTab, newTab, _currency, currency, baseRedirect, url;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                    frequency = param.frequency, seats = param.seats, edition = param.edition, options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _newTab = options.newTab, newTab = _newTab === void 0 ? false : _newTab, _currency = options.currency, currency = _currency === void 0 ? "USD" : _currency;
                    baseRedirect = "".concat(window.location.origin).concat((0,_utils_router__WEBPACK_IMPORTED_MODULE_3__/* .getBillingUrl */ .uN)());
                    url = new URL(STRIPE_NEW_SESSION_URI);
                    url.search = new URLSearchParams({
                        successUrl: "".concat(baseRedirect, "?action=").concat(TeamRedirectAction.PurchaseSuccess),
                        cancelUrl: "".concat(baseRedirect, "?action=").concat(TeamRedirectAction.PurchaseCancelled),
                        seats: seats.toString(),
                        edition: edition,
                        frequency: frequency,
                        currency: (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .supportedCurrencyToDto */ .dl)(currency)
                    }).toString();
                    if (!!newTab) {
                        window.open(url.toString(), "billing_subscription");
                    } else {
                        window.location.href = url.toString();
                    }
                    return [
                        2
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(), "startSubscription");
        var _this7 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this);
        _this.getEntitlementTable = _this.typedManageErrors(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this7.domainApi.team.editions()
                        ];
                    case 1:
                        return [
                            2,
                            _Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToEntitlementTable.apply */ .A2.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        }));
        var _this8 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this);
        _this.getSubscriptionOptions = _this.typedManageErrors(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(quantity, currency) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this8.domainApi.team.subscriptionOptions({
                                    quantity: quantity,
                                    currency: currency ? (0,_Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .supportedCurrencyToDto */ .dl)(currency) : null
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _Team_mutators__WEBPACK_IMPORTED_MODULE_7__/* .dtoToSubscriptionOptions.apply */ .AC.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            });
            return function(quantity, currency) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.domainApi = new _client__WEBPACK_IMPORTED_MODULE_6__/* .ReclaimApi */ .eZ({
            baseUrl: API_BASE_URI,
            BUILD_ID: _analytics__WEBPACK_IMPORTED_MODULE_1__/* .BUILD_ID */ .sk,
            baseApiParams: args[1].baseApiParams
        });
        return _this;
    }
    return TeamDomain;
}(_types__WEBPACK_IMPORTED_MODULE_5__/* .TransformDomain */ .Zs);


/***/ }),

/***/ 13811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ canInvite; },
/* harmony export */   "M9": function() { return /* binding */ canChangeSettings; },
/* harmony export */   "VJ": function() { return /* binding */ membershipRoleComparator; },
/* harmony export */   "Wg": function() { return /* binding */ reclaimEditionComparator; },
/* harmony export */   "ah": function() { return /* binding */ entitlementValueObjectWithOverride; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _utils_sort__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14023);
/* harmony import */ var _Team__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72897);
/* harmony import */ var _Team_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50084);





var reclaimEditionComparator = (0,_utils_sort__WEBPACK_IMPORTED_MODULE_0__/* .makeOrderedListComparator */ .LU)(_Team_consts__WEBPACK_IMPORTED_MODULE_2__/* .EDITION_ORDER */ .rE);
var membershipRoleComparator = (0,_utils_sort__WEBPACK_IMPORTED_MODULE_0__/* .makeOrderedListComparator */ .LU)([
    _Team__WEBPACK_IMPORTED_MODULE_1__/* .MembershipRole.Admin */ .nJ.Admin,
    _Team__WEBPACK_IMPORTED_MODULE_1__/* .MembershipRole.User */ .nJ.User
]);
var canChangeSettings = function(role) {
    return role === _Team__WEBPACK_IMPORTED_MODULE_1__/* .MembershipRole.Admin */ .nJ.Admin;
};
var canInvite = function(role, userInviteLevel) {
    return canChangeSettings(role) || userInviteLevel !== "NONE";
};
var entitlementValueObjectWithOverride = function(entitlement, edition, obj) {
    var ref, ref1;
    return obj && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, obj), {
        value: ((ref = _Team_consts__WEBPACK_IMPORTED_MODULE_2__/* .ENTITLEMENT_META */ .mm[entitlement].displayOverrideValues) === null || ref === void 0 ? void 0 : ref[edition]) === undefined ? obj.value : (ref1 = _Team_consts__WEBPACK_IMPORTED_MODULE_2__/* .ENTITLEMENT_META */ .mm[entitlement].displayOverrideValues) === null || ref1 === void 0 ? void 0 : ref1[edition]
    });
};


/***/ }),

/***/ 34629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F7": function() { return /* binding */ NetworkError; },
/* harmony export */   "eZ": function() { return /* binding */ ReclaimApi; },
/* harmony export */   "gt": function() { return /* binding */ ReclaimApiError; },
/* harmony export */   "nJ": function() { return /* binding */ MembershipRole; },
/* harmony export */   "xo": function() { return /* binding */ SupportedCurrency; }
/* harmony export */ });
/* unused harmony exports DayOfWeek, DomainSetting, InvitationStatus, Month, ReclaimEdition, RequestedTeamStatus, SlackSettingsStatusSync, SubscriptionAvailability, SubscriptionFrequency, SubscriptionStatus, TeamMemberViewStatus, ZoneOffsetTransitionRuleTimeDefinition, HEADER_BUILD_ID */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25892);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* tslint:disable */ /* eslint-disable */ /*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ## A custom template from the reclaim-api/api-client         ##
 * ## repo was used.                                            ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ 








var DayOfWeek;
(function(DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
var DomainSetting;
(function(DomainSetting) {
    DomainSetting["INVITEONLY"] = "INVITE_ONLY";
    DomainSetting["REQUEST"] = "REQUEST";
    DomainSetting["OPEN"] = "OPEN";
    DomainSetting["AUTODOMAINCAPTURE"] = "AUTO_DOMAIN_CAPTURE";
})(DomainSetting || (DomainSetting = {}));
var InvitationStatus;
(function(InvitationStatus) {
    InvitationStatus["ACCEPTED"] = "ACCEPTED";
    InvitationStatus["PENDING"] = "PENDING";
    InvitationStatus["DECLINED"] = "DECLINED";
})(InvitationStatus || (InvitationStatus = {}));
var MembershipRole;
(function(MembershipRole) {
    MembershipRole["USER"] = "USER";
    MembershipRole["ADMIN"] = "ADMIN";
})(MembershipRole || (MembershipRole = {}));
var Month;
(function(Month) {
    Month["JANUARY"] = "JANUARY";
    Month["FEBRUARY"] = "FEBRUARY";
    Month["MARCH"] = "MARCH";
    Month["APRIL"] = "APRIL";
    Month["MAY"] = "MAY";
    Month["JUNE"] = "JUNE";
    Month["JULY"] = "JULY";
    Month["AUGUST"] = "AUGUST";
    Month["SEPTEMBER"] = "SEPTEMBER";
    Month["OCTOBER"] = "OCTOBER";
    Month["NOVEMBER"] = "NOVEMBER";
    Month["DECEMBER"] = "DECEMBER";
})(Month || (Month = {}));
var ReclaimEdition;
(function(ReclaimEdition) {
    ReclaimEdition["NONE"] = "NONE";
    ReclaimEdition["TRIAL"] = "TRIAL";
    ReclaimEdition["ASSISTANT"] = "ASSISTANT";
    ReclaimEdition["PRO"] = "PRO";
    ReclaimEdition["TEAM"] = "TEAM";
    ReclaimEdition["REWARD"] = "REWARD";
    ReclaimEdition["LEGACYPROTRIAL"] = "LEGACY_PRO_TRIAL";
    ReclaimEdition["LEGACYTEAMTRIAL"] = "LEGACY_TEAM_TRIAL";
    ReclaimEdition["LITE"] = "LITE";
    ReclaimEdition["STARTER"] = "STARTER";
    ReclaimEdition["BUSINESS"] = "BUSINESS";
    ReclaimEdition["TRIALBUSINESS"] = "TRIAL_BUSINESS";
    ReclaimEdition["TRIALBUSINESS12W"] = "TRIAL_BUSINESS_12W";
    ReclaimEdition["TRIALBUSINESSFORLEGACYPLANS"] = "TRIAL_BUSINESS_FOR_LEGACY_PLANS";
    ReclaimEdition["ENTERPRISE"] = "ENTERPRISE";
    ReclaimEdition["TEAMREWARD"] = "TEAM_REWARD";
})(ReclaimEdition || (ReclaimEdition = {}));
var RequestedTeamStatus;
(function(RequestedTeamStatus) {
    RequestedTeamStatus["PENDING"] = "PENDING";
    RequestedTeamStatus["REJECTED"] = "REJECTED";
})(RequestedTeamStatus || (RequestedTeamStatus = {}));
var SlackSettingsStatusSync;
(function(SlackSettingsStatusSync) {
    SlackSettingsStatusSync["OFF"] = "OFF";
    SlackSettingsStatusSync["DEFAULT"] = "DEFAULT";
    SlackSettingsStatusSync["BUSY"] = "BUSY";
    SlackSettingsStatusSync["CUSTOM"] = "CUSTOM";
    SlackSettingsStatusSync["TEAM"] = "TEAM";
})(SlackSettingsStatusSync || (SlackSettingsStatusSync = {}));
var SubscriptionAvailability;
(function(SubscriptionAvailability) {
    SubscriptionAvailability["AVAILABLE"] = "AVAILABLE";
    SubscriptionAvailability["TOOMANYUSERS"] = "TOO_MANY_USERS";
    SubscriptionAvailability["CALLUS"] = "CALL_US";
})(SubscriptionAvailability || (SubscriptionAvailability = {}));
var SubscriptionFrequency;
(function(SubscriptionFrequency) {
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
var SubscriptionStatus;
(function(SubscriptionStatus) {
    SubscriptionStatus["TRIALING"] = "TRIALING";
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["INACTIVE"] = "INACTIVE";
})(SubscriptionStatus || (SubscriptionStatus = {}));
var SupportedCurrency;
(function(SupportedCurrency) {
    SupportedCurrency["Usd"] = "usd";
    SupportedCurrency["Eur"] = "eur";
})(SupportedCurrency || (SupportedCurrency = {}));
var TeamMemberViewStatus;
(function(TeamMemberViewStatus) {
    TeamMemberViewStatus["PENDING"] = "PENDING";
    TeamMemberViewStatus["ACCEPTED"] = "ACCEPTED";
    TeamMemberViewStatus["DECLINED"] = "DECLINED";
})(TeamMemberViewStatus || (TeamMemberViewStatus = {}));
var ZoneOffsetTransitionRuleTimeDefinition;
(function(ZoneOffsetTransitionRuleTimeDefinition) {
    ZoneOffsetTransitionRuleTimeDefinition["UTC"] = "UTC";
    ZoneOffsetTransitionRuleTimeDefinition["WALL"] = "WALL";
    ZoneOffsetTransitionRuleTimeDefinition["STANDARD"] = "STANDARD";
})(ZoneOffsetTransitionRuleTimeDefinition || (ZoneOffsetTransitionRuleTimeDefinition = {}));
var HEADER_BUILD_ID = "X-Reclaim-Build-Id";
var // TODO: The need for this is hard codded into the codegen source... so dumb
BodyType;
(function(BodyType) {
    BodyType[BodyType["Json"] = 0] = "Json";
})(BodyType || (BodyType = {}));
var ReclaimApiError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReclaimApiError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ReclaimApiError);
    function ReclaimApiError(res, message) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ReclaimApiError);
        var _this;
        var ref;
        _this = _super.call(this, message);
        if (!res && !message) message = "No response object";
        _this.status = res === null || res === void 0 ? void 0 : res.status;
        _this.statusText = (res === null || res === void 0 ? void 0 : res.statusText) || ((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || message;
        _this.headers = res === null || res === void 0 ? void 0 : res.headers;
        _this.body = res === null || res === void 0 ? void 0 : res.data;
        return _this;
    }
    return ReclaimApiError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Error));
var NetworkError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(NetworkError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(NetworkError);
    function NetworkError(res, message) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, NetworkError);
        var _this;
        var ref;
        _this = _super.call(this, message);
        _this.status = "NetworkError";
        if (!res && !message) message = "No response object";
        _this.statusText = (res === null || res === void 0 ? void 0 : res.statusText) || ((ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || message;
        _this.headers = res === null || res === void 0 ? void 0 : res.headers;
        _this.body = res === null || res === void 0 ? void 0 : res.data;
        return _this;
    }
    return NetworkError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Error));
var HttpClient = /*#__PURE__*/ function() {
    "use strict";
    function HttpClient() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            BUILD_ID: "unknown"
        }, baseUrl = ref.baseUrl, baseApiParams = ref.baseApiParams, securityWorker = ref.securityWorker, BUILD_ID = ref.BUILD_ID;
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, HttpClient);
        this.baseUrl = "https://api.app.reclaim.ai/api";
        this.securityData = null;
        this.securityWorker = function() {};
        this.baseApiParams = {
            headers: {
                "Content-Type": "application/json",
                Referrer: "no-referrer"
            }
        };
        this.requestHooks = {};
        this.responseHooks = {};
        this.setSecurityData = function(data) {
            _this.securityData = data;
        };
        this.request = function(path, method) {
            var _param = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, data = arguments.length > 3 ? arguments[3] : void 0, _dumbUnusedBodyType = arguments.length > 4 ? arguments[4] : void 0, secureByDefault = arguments.length > 5 ? arguments[5] : void 0;
            var secure = _param.secure, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
                "secure"
            ]);
            return _this.client.request((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                url: path
            }, params), {
                method: method,
                data: data,
                validateStatus: function validateStatus(status) {
                    return true;
                }
            })).then(function(r) {
                if (r.status >= 200 && r.status < 300) {
                    return !!r.data ? r.data : null;
                } else if (!r.status) {
                    throw new NetworkError(r);
                } else {
                    throw new ReclaimApiError(r);
                }
            });
        };
        if (!!baseUrl) this.baseUrl = baseUrl;
        if (!!baseApiParams) this.baseApiParams = baseApiParams;
        if (!!securityWorker) this.securityWorker = securityWorker;
        this.client = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
            baseURL: baseUrl || this.baseUrl,
            withCredentials: true,
            headers: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, HEADER_BUILD_ID, BUILD_ID), this.baseApiParams.headers || {}), {
                post: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            })
        });
        this.client.interceptors.request.use(function(config) {
            Object.keys(_this.requestHooks).forEach(function(name) {
                _this.requestHooks[name](config);
            });
            return config;
        });
        this.client.interceptors.response.use(function(r) {
            Object.keys(_this.responseHooks).forEach(function(name) {
                if (r.status) {
                    return _this.responseHooks["".concat(name, " - Status: ").concat(r.status)](new ReclaimApiError(r));
                }
                _this.responseHooks["".concat(name, " - Status: network")](new NetworkError(r));
            });
            return r;
        }, function(error) {
            Object.keys(_this.responseHooks).forEach(function(name) {
                _this.responseHooks[name](error);
            });
            return error;
        });
    }
    var _proto = HttpClient.prototype;
    _proto.addQueryParam = function addQueryParam(query, key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(Array.isArray(query[key]) ? query[key].join(",") : query[key]);
    };
    _proto.addQueryParams = function addQueryParams(rawQuery) {
        var _this = this;
        var query = rawQuery || {};
        var keys = Object.keys(query).filter(function(key) {
            return "undefined" !== typeof query[key];
        });
        return keys.length ? "?".concat(keys.map(function(key) {
            return typeof query[key] === "object" && !Array.isArray(query[key]) ? _this.addQueryParams(query[key]).substring(1) : _this.addQueryParam(query, key);
        }).join("&")) : "";
    };
    _proto.registerRequestHook = function registerRequestHook(name, fn) {
        this.requestHooks[name] = fn;
    };
    _proto.registerResponseHook = function registerResponseHook(name, status, fn) {
        this.responseHooks["".concat(name, " - Status: ").concat(status)] = fn;
    };
    return HttpClient;
}();
/**
 * @title Reclaim Billing API
 * @version 0.1
 * @baseUrl https://api.app.reclaim.ai/api
 * Reclaim's awesome API
 */ var ReclaimApi = /*#__PURE__*/ function(HttpClient) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReclaimApi, HttpClient);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ReclaimApi);
    function ReclaimApi() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, ReclaimApi);
        var _this;
        _this = _super.apply(this, arguments);
        _this.team = {
            /**
     * @tags team
     * @name newSession
     * @request GET:/team/create/subscription/session
     */ newSession: function(query, params) {
                return _this.request("/team/create/subscription/session".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags team
     * @name getCurrentTeam
     * @request GET:/team/current
     */ getCurrentTeam: function(params) {
                return _this.request("/team/current", "GET", params);
            },
            /**
     * @tags team
     * @name patchTeam
     * @request PATCH:/team/current
     */ patchTeam: function(data, params) {
                return _this.request("/team/current", "PATCH", params, data);
            },
            /**
     * @tags team
     * @name getCurrentTeamDomains
     * @request GET:/team/current/domains
     */ getCurrentTeamDomains: function(params) {
                return _this.request("/team/current/domains", "GET", params);
            },
            /**
     * @tags team
     * @name deleteInvitation
     * @request DELETE:/team/current/invitation/{id}
     */ deleteInvitation: function(id, params) {
                return _this.request("/team/current/invitation/".concat(id), "DELETE", params);
            },
            /**
     * @tags team
     * @name getInvitations
     * @request GET:/team/current/invitations
     */ getInvitations: function(params) {
                return _this.request("/team/current/invitations", "GET", params);
            },
            /**
     * @tags team
     * @name createInvitation
     * @request POST:/team/current/invitations
     */ createInvitation: function(data, query, params) {
                return _this.request("/team/current/invitations".concat(_this.addQueryParams(query)), "POST", params, data);
            },
            /**
     * @tags team
     * @name updateInvitation
     * @request PATCH:/team/current/invitations/{inviteId}
     */ updateInvitation: function(inviteId, data, params) {
                return _this.request("/team/current/invitations/".concat(inviteId), "PATCH", params, data);
            },
            /**
     * @tags team
     * @name getInviteableTeamMembers
     * @summary Returns team members that are not members of the user's team, overlap with domain(s) in the user's team, and do not belong to paying teams.
     * @request GET:/team/current/inviteable
     * @description Returns team members that are not members of the user's team, overlap with domain(s) in the user's team, and do not belong to paying teams.
     */ getInviteableTeamMembers: function(params) {
                return _this.request("/team/current/inviteable", "GET", params);
            },
            /**
     * @tags team
     * @name joinResponses
     * @request POST:/team/current/joinResponses
     */ joinResponses: function(data, params) {
                return _this.request("/team/current/joinResponses", "POST", params, data);
            },
            /**
     * @tags team
     * @name leaveTeam
     * @request POST:/team/current/leave
     */ leaveTeam: function(params) {
                return _this.request("/team/current/leave", "POST", params);
            },
            /**
     * @tags team
     * @name getMembers
     * @request GET:/team/current/members
     */ getMembers: function(params) {
                return _this.request("/team/current/members", "GET", params);
            },
            /**
     * @tags team
     * @name deleteMember
     * @request DELETE:/team/current/members
     */ deleteMember: function(query, params) {
                return _this.request("/team/current/members".concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags team
     * @name patchMember
     * @request PATCH:/team/current/members
     */ patchMember: function(query, data, params) {
                return _this.request("/team/current/members".concat(_this.addQueryParams(query)), "PATCH", params, data);
            },
            /**
     * @tags team
     * @name getMembership
     * @request GET:/team/current/membership
     */ getMembership: function(params) {
                return _this.request("/team/current/membership", "GET", params);
            },
            /**
     * @tags team
     * @name getRequests
     * @summary Returns team members that have requested to be part of the user's team (and currently are not).
     * @request GET:/team/current/requests
     * @description Returns team members that have requested to be part of the user's team (and currently are not).
     */ getRequests: function(params) {
                return _this.request("/team/current/requests", "GET", params);
            },
            /**
     * @tags team
     * @name cancelSubscription
     * @request DELETE:/team/current/subscription
     */ cancelSubscription: function(query, params) {
                return _this.request("/team/current/subscription".concat(_this.addQueryParams(query)), "DELETE", params);
            },
            /**
     * @tags team
     * @name subscriptionOptions
     * @request GET:/team/current/subscription-options
     */ subscriptionOptions: function(query, params) {
                return _this.request("/team/current/subscription-options".concat(_this.addQueryParams(query)), "GET", params);
            },
            /**
     * @tags team
     * @name subscriptionChange
     * @request POST:/team/current/subscription/change
     */ subscriptionChange: function(data, params) {
                return _this.request("/team/current/subscription/change", "POST", params, data);
            },
            /**
     * @tags team
     * @name previewSubscriptionChange
     * @request POST:/team/current/subscription/change-preview
     */ previewSubscriptionChange: function(data, params) {
                return _this.request("/team/current/subscription/change-preview", "POST", params, data);
            },
            /**
     * @tags team
     * @name reinstateSubscription
     * @request POST:/team/current/subscription/reinstate
     */ reinstateSubscription: function(params) {
                return _this.request("/team/current/subscription/reinstate", "POST", params);
            },
            /**
     * @tags team
     * @name manageSession
     * @request GET:/team/current/subscription/session
     */ manageSession: function(params) {
                return _this.request("/team/current/subscription/session", "GET", params);
            },
            /**
     * @tags team
     * @name endTrial
     * @request DELETE:/team/current/trial
     */ endTrial: function(params) {
                return _this.request("/team/current/trial", "DELETE", params);
            },
            /**
     * @tags team
     * @name editions
     * @request GET:/team/editions
     */ editions: function(params) {
                return _this.request("/team/editions", "GET", params);
            },
            /**
     * @tags team
     * @name listInvoices
     * @request GET:/team/invoices
     */ listInvoices: function(params) {
                return _this.request("/team/invoices", "GET", params);
            },
            /**
     * @tags team
     * @name getJoinableTeams
     * @request GET:/team/joinable
     */ getJoinableTeams: function(params) {
                return _this.request("/team/joinable", "GET", params);
            },
            /**
     * @tags team
     * @name acceptInvitation
     * @request POST:/team/{teamId}/invitations/{invitationId}
     */ acceptInvitation: function(teamId, invitationId, data, params) {
                return _this.request("/team/".concat(teamId, "/invitations/").concat(invitationId), "POST", params, data);
            },
            /**
     * @tags team
     * @name requestToJoinTeam
     * @summary A request from a user to join a team.
     * @request POST:/team/{teamId}/request
     * @description A request from a user to join a team.
     */ requestToJoinTeam: function(teamId, params) {
                return _this.request("/team/".concat(teamId, "/request"), "POST", params);
            },
            /**
     * @tags team
     * @name cancelRequestToJoinTeam
     * @request POST:/team/{teamId}/request/cancel
     */ cancelRequestToJoinTeam: function(teamId, params) {
                return _this.request("/team/".concat(teamId, "/request/cancel"), "POST", params);
            }
        };
        _this.webhook = {
            /**
     * @name post
     * @request POST:/webhook/stripe
     */ post: function(data, params) {
                return _this.request("/webhook/stripe", "POST", params, data);
            }
        };
        return _this;
    }
    return ReclaimApi;
}(HttpClient);


/***/ }),

/***/ 42230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qp": function() { return /* binding */ Domain; },
  "$K": function() { return /* binding */ NotificationKeyStatus; },
  "AA": function() { return /* binding */ NotificationSyncStatus; },
  "Zs": function() { return /* binding */ TransformDomain; },
  "au": function() { return /* binding */ getSyncStatus; },
  "AG": function() { return /* binding */ nullable; },
  "eL": function() { return /* binding */ parseNotificationUuid; }
});

// UNUSED EXPORTS: DefaultErrorManagment, ResourceDomain

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
;// CONCATENATED MODULE: ./node_modules/nanoid/index.browser.js

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)
  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)
let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    byte &= 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte > 62) {
      id += '-'
    } else {
      id += '_'
    }
    return id
  }, '')


// EXTERNAL MODULE: ./node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(63496);
;// CONCATENATED MODULE: ./src/types/https.ts
var HttpErrorStatusCode;
(function(HttpErrorStatusCode) {
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * Indicates multiple options for the resource from which the client may choose (via agent-driven content negotiation).
   * For example, this code could be used to present multiple video format options,
   * to list files with different filename extensions, or to suggest word-sense disambiguation.
   */ "MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * This and all future requests should be directed to the given URI.
   */ "MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * This is an example of industry practice contradicting the standard.
   * The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect
   * (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302
   * with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307
   * to distinguish between the two behaviours. However, some Web applications and frameworks
   * use the 302 status code as if it were the 303.
   */ "FOUND"] = 302] = "FOUND";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * SINCE HTTP/1.1
   * The response to the request can be found under another URI using a GET method.
   * When received in response to a POST (or PUT/DELETE), the client should presume that
   * the server has received the data and should issue a redirect with a separate GET message.
   */ "SEE_OTHER"] = 303] = "SEE_OTHER";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
   * In such case, there is no need to retransmit the resource since the client still has a previously-downloaded copy.
   */ "NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * SINCE HTTP/1.1
   * The requested resource is available only through a proxy, the address for which is provided in the response.
   * Many HTTP clients (such as Mozilla and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.
   */ "USE_PROXY"] = 305] = "USE_PROXY";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * No longer used. Originally meant "Subsequent requests should use the specified proxy."
   */ "SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * SINCE HTTP/1.1
   * In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
   * In contrast to how 302 was historically implemented, the request method is not allowed to be changed when reissuing the original request.
   * For example, a POST request should be repeated using another POST request.
   */ "TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The request and all future requests should be repeated using another URI.
   * 307 and 308 parallel the behaviors of 302 and 301, but do not allow the HTTP method to change.
   * So, for example, submitting a form to a permanently redirected resource may continue smoothly.
   */ "PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server cannot or will not process the request due to an apparent client error
   * (e.g., malformed request syntax, too large size, invalid request message framing, or deceptive request routing).
   */ "BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet
   * been provided. The response must include a WWW-Authenticate header field containing a challenge applicable to the
   * requested resource. See Basic access authentication and Digest access authentication. 401 semantically means
   * "unauthenticated",i.e. the user does not have the necessary credentials.
   */ "UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * Reserved for future use. The original intention was that this code might be used as part of some form of digital
   * cash or micro payment scheme, but that has not happened, and this code is not usually used.
   * Google Developers API uses this status if a particular developer has exceeded the daily limit on requests.
   */ "PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The request was valid, but the server is refusing action.
   * The user might not have the necessary permissions for a resource.
   */ "FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The requested resource could not be found but may be available in the future.
   * Subsequent requests by the client are permissible.
   */ "NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * A request method is not supported for the requested resource;
   * for example, a GET request on a form that requires data to be presented via POST, or a PUT request on a read-only resource.
   */ "METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
   */ "NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The client must first authenticate itself with the proxy.
   */ "PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server timed out waiting for the request.
   * According to HTTP specifications:
   * "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
   */ "REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * Indicates that the request could not be processed because of conflict in the request,
   * such as an edit conflict between multiple simultaneous updates.
   */ "CONFLICT"] = 409] = "CONFLICT";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * Indicates that the resource requested is no longer available and will not be available again.
   * This should be used when a resource has been intentionally removed and the resource should be purged.
   * Upon receiving a 410 status code, the client should not request the resource in the future.
   * Clients such as search engines should remove the resource from their indices.
   * Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
   */ "GONE"] = 410] = "GONE";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The request did not specify the length of its content, which is required by the requested resource.
   */ "LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server does not meet one of the preconditions that the requester put on the request.
   */ "PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
   */ "PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The URI provided was too long for the server to process. Often the result of too much data being encoded as a query-string of a GET request,
   * in which case it should be converted to a POST request.
   * Called "Request-URI Too Long" previously.
   */ "URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The request entity has a media type which the server or resource does not support.
   * For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
   */ "UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
   * For example, if the client asked for a part of the file that lies beyond the end of the file.
   * Called "Requested Range Not Satisfiable" previously.
   */ "RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server cannot meet the requirements of the Expect request-header field.
   */ "EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol,
   * and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by
   * teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
   */ "I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The request was directed at a server that is not able to produce a response (for example because a connection reuse).
   */ "MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The request was well-formed but was unable to be followed due to semantic errors.
   */ "UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The resource that is being accessed is locked.
   */ "LOCKED"] = 423] = "LOCKED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The request failed due to failure of a previous request (e.g., a PROPPATCH).
   */ "FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
   */ "UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The origin server requires the request to be conditional.
   * Intended to prevent "the 'lost update' problem, where a client
   * GETs a resource's state, modifies it, and PUTs it back to the server,
   * when meanwhile a third party has modified the state on the server, leading to a conflict."
   */ "PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The user has sent too many requests in a given amount of time. Intended for use with rate-limiting schemes.
   */ "TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server is unwilling to process the request because either an individual header field,
   * or all the header fields collectively, are too large.
   */ "REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * A server operator has received a legal demand to deny access to a resource or to a set of resources
   * that includes the requested resource. The code 451 was chosen as a reference to the novel Fahrenheit 451.
   */ "UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
   */ "INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server either does not recognize the request method, or it lacks the ability to fulfill the request.
   * Usually this implies future availability (e.g., a new feature of a web-service API).
   */ "NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server was acting as a gateway or proxy and received an invalid response from the upstream server.
   */ "BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server is currently unavailable (because it is overloaded or down for maintenance).
   * Generally, this is a temporary state.
   */ "SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
   */ "GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server does not support the HTTP protocol version used in the request
   */ "HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * Transparent content negotiation for the request results in a circular reference.
   */ "VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server is unable to store the representation needed to complete the request.
   */ "INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The server detected an infinite loop while processing the request.
   */ "LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * Further extensions to the request are required for the server to fulfill it.
   */ "NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
    HttpErrorStatusCode[HttpErrorStatusCode[/**
   * The client needs to authenticate to gain network access.
   * Intended for use by intercepting proxies used to control access to the network (e.g., "captive portals" used
   * to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).
   */ "NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpErrorStatusCode || (HttpErrorStatusCode = {}));

// EXTERNAL MODULE: ./src/utils/arrays.ts
var arrays = __webpack_require__(92886);
// EXTERNAL MODULE: ./src/utils/client.utils.ts
var client_utils = __webpack_require__(74150);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./src/utils/wonka.ts
var utils_wonka = __webpack_require__(60811);
// EXTERNAL MODULE: ./src/reclaim-api/client.ts
var client = __webpack_require__(98585);
;// CONCATENATED MODULE: ./src/reclaim-api/types.ts




















function nullable(val, fn) {
    if (val === null) return null;
    return !!fn ? fn(val) : "".concat(val);
}
var parseNotificationUuid = function(key) {
    var parts = key.split("_");
    var uuid = parts.pop();
    var action = parts.pop();
    var resource = parts.shift();
    var pk = parts.shift();
    return {
        resource: resource,
        pk: pk,
        action: action,
        uuid: uuid
    };
};
var NotificationSyncStatus;
(function(NotificationSyncStatus) {
    NotificationSyncStatus["SyncingServer"] = "SYNCING_SERVER";
    NotificationSyncStatus["SyncingCalendar"] = "SYNCING_CALENDAR";
    NotificationSyncStatus["Ready"] = "READY";
})(NotificationSyncStatus || (NotificationSyncStatus = {}));
var NotificationKeyStatus;
(function(NotificationKeyStatus) {
    NotificationKeyStatus["Pending"] = "PENDING";
    NotificationKeyStatus["Requested"] = "REQUESTED";
    NotificationKeyStatus["Received"] = "RECEIVED";
    NotificationKeyStatus["Planned"] = "PLANNED";
    NotificationKeyStatus["Timedout"] = "TIMEDOUT";
    NotificationKeyStatus["Failed"] = "FAILED";
    NotificationKeyStatus["Completed"] = "COMPLETED";
})(NotificationKeyStatus || (NotificationKeyStatus = {}));
var _obj;
var NotificationStatusIndex = (_obj = {}, // Syncing Reclaim
(0,_define_property/* default */.Z)(_obj, NotificationKeyStatus.Pending, 0), (0,_define_property/* default */.Z)(_obj, NotificationKeyStatus.Requested, 1), (0,_define_property/* default */.Z)(_obj, NotificationKeyStatus.Received, 2), // Syncing Calendar
(0,_define_property/* default */.Z)(_obj, NotificationKeyStatus.Planned, 3), // Clear
(0,_define_property/* default */.Z)(_obj, NotificationKeyStatus.Timedout, 4), (0,_define_property/* default */.Z)(_obj, NotificationKeyStatus.Failed, 5), (0,_define_property/* default */.Z)(_obj, NotificationKeyStatus.Completed, 5), _obj);
var _obj1;
var DefaultErrorManagment = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, HttpErrorStatusCode.UNAUTHORIZED, true), (0,_define_property/* default */.Z)(_obj1, HttpErrorStatusCode.NOT_FOUND, true), (0,_define_property/* default */.Z)(_obj1, HttpErrorStatusCode.SERVICE_UNAVAILABLE, false), (0,_define_property/* default */.Z)(_obj1, HttpErrorStatusCode.BAD_GATEWAY, false), _obj1);
var Domain = /*#__PURE__*/ function() {
    "use strict";
    function Domain(key, api, client, ws) {
        (0,_class_call_check/* default */.Z)(this, Domain);
        this.key = key;
        this.api = api;
        this.client = client;
        this.ws = ws;
    }
    var _proto = Domain.prototype;
    /**
   * manage 'yo errors
   * @deprecated use `typedManageErrors`
   */ _proto.manageErrors = function manageErrors(method) {
        var handledErrors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DefaultErrorManagment;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _len, args, _key;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        return [
                            4,
                            method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).catch(function(e) {
                                if ((0,client_utils/* isReclaimApiError */.gK)(e)) {
                                    e = (0,client_utils/* normalizeReclaimApiError */.Pd)(e);
                                } else if ((0,client_utils/* isClientNetworkError */.rZ)(e)) {
                                    e = (0,client_utils/* normalizeClientNetworkError */.WX)(e);
                                }
                                if (e.status === "NetworkError") {
                                    throw e;
                                }
                                if (!!handledErrors[e.status]) {
                                    e.handled = typeof handledErrors[e.status] === "boolean" ? !!handledErrors[e.status] : handledErrors[e.status](e) || false;
                                }
                                console.debug("Response error", e.handled, e.status, e.message, e);
                                if (!e.handled) throw e;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _proto.typedManageErrors = function typedManageErrors(method) {
        var handledErrors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DefaultErrorManagment;
        return this.manageErrors(method, handledErrors);
    };
    return Domain;
}();
var ResourceDomain = /*#__PURE__*/ function(Domain) {
    "use strict";
    (0,_inherits/* default */.Z)(ResourceDomain, Domain);
    var _super = (0,_create_super/* default */.Z)(ResourceDomain);
    function ResourceDomain() {
        (0,_class_call_check/* default */.Z)(this, ResourceDomain);
        var _this;
        _this = _super.apply(this, arguments);
        _this.pk = "id";
        _this.resourceType = {};
        _this.dtoType = {};
        return _this;
    }
    var _proto = ResourceDomain.prototype;
    _proto.getPk = function getPk(item) {
        if (!item) return;
        return Array.isArray(this.pk) ? this.pk.map(function(k) {
            var value = (0,objects/* walk */._p)(k, item);
            // FIXME (IW): Why was the type added here?
            // If it's needed, use other than ":" as the delimiter
            return "(".concat(value, ":").concat(typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value), ")");
        }).join("-") : item[this.pk];
    };
    return ResourceDomain;
}(Domain);
function getSyncStatus(statuses) {
    if (statuses.some(function(status) {
        return [
            NotificationKeyStatus.Pending,
            NotificationKeyStatus.Requested,
            NotificationKeyStatus.Received
        ].includes(status);
    })) {
        return NotificationSyncStatus.SyncingServer;
    } else if (statuses.some(function(status) {
        return NotificationKeyStatus.Planned === status;
    })) {
        return NotificationSyncStatus.SyncingCalendar;
    } else {
        return NotificationSyncStatus.Ready;
    }
}
var AssistPlannedSubscription = {
    subscriptionType: client/* SubscriptionType.AssistCompleted */.Qe.AssistCompleted
};
var AssistCompletedSubscription = {
    subscriptionType: client/* SubscriptionType.AssistCompleted */.Qe.AssistCompleted
};
var TransformDomain = /*#__PURE__*/ function(ResourceDomain) {
    "use strict";
    (0,_inherits/* default */.Z)(TransformDomain, ResourceDomain);
    var _super = (0,_create_super/* default */.Z)(TransformDomain);
    function TransformDomain() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, TransformDomain);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _this.upsertSubject = (0,wonka/* makeSubject */.nN)();
        _this.upsert = function(data) {
            if (!!data && (!Array.isArray(data) || !!data.length)) {
                var items = Array.isArray(data) ? data : [
                    data
                ];
                _this.upsertSubject.next(items);
            }
            return data;
        };
        /*** Transition from react-query and old cache to observables ***/ _this.expectedChanges = new Map();
        _this.expectedChangesSubject = (0,wonka/* makeSubject */.nN)();
        _this.onExpectedChangeError = function(errorType, change, other) {
            if (!!change.notificationKey && errorType === "timeout") {
                return console.error("Expected changes from ".concat(_this.resource, " api request but timed out waiting for notification to return via ws."));
            }
            if (!!change.notificationKey && errorType === "mismatch") {
                try {
                    return console.error("Expected changes to ".concat(_this.resource, "(").concat(change.pk, ") matching '").concat(JSON.stringify(change.patch), "', but received '").concat(JSON.stringify(other || ""), "' instead"));
                } catch (e) {
                    console.error("Failed to parse payload from server", e);
                }
            }
            if (!change.notificationKey && errorType === "timeout") {
                return console.error("Expected changes to ".concat(_this.resource, " but the server never responded with the expected payload"));
            }
        };
        // *** Global watchers ***
        if (!TransformDomain.watching && !!_this.ws) {
            TransformDomain.watching = true;
            // Track all received notification keys
            (0,wonka/* pipe */.zG)(_this.ws.source$, // FIXME (IW): Find a better place for this
            //
            // Subscribe to all assist events so we can properly show the status indicator
            (0,wonka/* onStart */.Hr)(function() {
                var ref, ref1;
                (ref = _this.ws) === null || ref === void 0 ? void 0 : ref.subscribe(AssistPlannedSubscription);
                (ref1 = _this.ws) === null || ref1 === void 0 ? void 0 : ref1.subscribe(AssistCompletedSubscription);
            }), (0,wonka/* onEnd */.ok)(function() {
                var ref, ref1;
                (ref = _this.ws) === null || ref === void 0 ? void 0 : ref.unsubscribe(AssistPlannedSubscription);
                (ref1 = _this.ws) === null || ref1 === void 0 ? void 0 : ref1.unsubscribe(AssistCompletedSubscription);
            }), (0,wonka/* forEach */.Ed)(function(envelope) {
                var ref, // Other notification types
                ref1;
                var type = envelope.type;
                if (!!((ref = envelope.data) === null || ref === void 0 ? void 0 : ref.notificationKeys)) {
                    console.info("Found envelope with notification keys in the data", type, envelope);
                }
                // Assist notifications
                if ([
                    client/* SubscriptionType.AssistPlanned */.Qe.AssistPlanned,
                    client/* SubscriptionType.AssistCompleted */.Qe.AssistCompleted
                ].includes(type)) {
                    var ref2, ref3, ref4;
                    var status = client/* SubscriptionType.AssistPlanned */.Qe.AssistPlanned === type ? NotificationKeyStatus.Planned : NotificationKeyStatus.Completed;
                    (ref2 = envelope.notificationKeys) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(key) {
                        return TransformDomain.updateNotificationKey(key, status);
                    });
                    (ref3 = envelope.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.notificationKeys) === null || ref4 === void 0 ? void 0 : ref4.forEach(function(key) {
                        return TransformDomain.updateNotificationKey(key, status);
                    });
                    return;
                }
                (ref1 = envelope.notificationKeys) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(key) {
                    var notificationKey = TransformDomain.notificationKeys.get(key);
                    if (!notificationKey) {
                        console.warn("Received unexpected notification key", key);
                    }
                    TransformDomain.updateNotificationKey(key, !(notificationKey === null || notificationKey === void 0 ? void 0 : notificationKey.assist) ? NotificationKeyStatus.Completed : NotificationKeyStatus.Received);
                });
            }));
            // clear out terminated notification keys
            (0,wonka/* pipe */.zG)((0,wonka/* interval */.FG)(1000 * 60), (0,wonka/* forEach */.Ed)(function() {
                var now = new Date();
                console.debug("checking for expired notification keys");
                TransformDomain.notificationKeys.forEach(function(record, key) {
                    if (NotificationStatusIndex[record.status] >= NotificationStatusIndex[NotificationKeyStatus.Timedout]) {
                        console.debug("clearing terminated notification key", key, record.status, record);
                        TransformDomain.deleteNotificationKey(key);
                    } else if (record.expires.getTime() < now.getTime()) {
                        console.warn("clearing expired notification key", key, record.expires, record);
                        TransformDomain.updateNotificationKey(key, NotificationKeyStatus.Timedout);
                    }
                });
            }));
        }
        // *** Instance watchers ***
        // Clear out terminated expected changes
        (0,wonka/* pipe */.zG)(_this.notificationKeys$, (0,wonka/* forEach */.Ed)(function(keys) {
            Array.from(keys.entries()).forEach(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], record = _param[1];
                switch(record.status){
                    case NotificationKeyStatus.Completed:
                    case NotificationKeyStatus.Failed:
                    case NotificationKeyStatus.Timedout:
                        _this.clearExpectedChange(key, record.status);
                        break;
                }
            });
        }));
        // Clear out expired expected changes
        (0,wonka/* pipe */.zG)((0,wonka/* interval */.FG)(1000 * 30), (0,wonka/* forEach */.Ed)(function() {
            _this.expireExpectedChanges();
        }));
        return _this;
    }
    var _proto = TransformDomain.prototype;
    _proto.generateUid = function generateUid(action, itemOrPk) {
        var pk = [
            "string",
            "number"
        ].includes(typeof itemOrPk === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(itemOrPk)) ? itemOrPk : this.getPk(itemOrPk);
        var uid = "".concat(this.resource, "_").concat(undefined !== pk ? pk + "_" : "").concat(!!action ? action.replace(/[\s_]/g, "-") + "_" : "").concat(nanoid().replace(/_/g, "-"));
        return uid;
    };
    _proto.parseUid = function parseUid(str) {
        return parseNotificationUuid(str);
    };
    _proto.addNotificationKey = function addNotificationKey(key, expectedChangesOrStatus, statusOrAssist, assist) {
        if (typeof expectedChangesOrStatus === "string") {
            return TransformDomain.addNotificationKey(key, undefined, expectedChangesOrStatus, statusOrAssist);
        } else {
            return TransformDomain.addNotificationKey(key, expectedChangesOrStatus, statusOrAssist, assist);
        }
    };
    _proto.updateNotificationKey = function updateNotificationKey(key, statusOrEnvelope) {
        return TransformDomain.updateNotificationKey(key, statusOrEnvelope);
    };
    _proto.manageNotificationKey = function manageNotificationKey(func, action) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var _this = this;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _len, args, _key, getPatch, getPk, optimistic, _errorizer, errorizer, pk, notificationKey, res, cause, error;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        getPatch = options.getPatch, getPk = options.getPk, optimistic = options.optimistic, _errorizer = options.errorizer, errorizer = _errorizer === void 0 ? function() {
                            return "Failed to run action: ".concat(action);
                        } : _errorizer;
                        pk = getPk === null || getPk === void 0 ? void 0 : getPk.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
                        notificationKey = _this.generateUid(action, pk);
                        if (pk) _this.expectChange(notificationKey, pk, (getPatch === null || getPatch === void 0 ? void 0 : getPatch.apply(void 0, (0,_to_consumable_array/* default */.Z)(args))) || {}, optimistic);
                        else _this.addNotificationKey(notificationKey, NotificationKeyStatus.Pending);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            func.apply(void 0, (0,_to_consumable_array/* default */.Z)(args))
                        ];
                    case 2:
                        res = _state.sent();
                        if (pk) _this.updateNotificationKey(notificationKey, NotificationKeyStatus.Requested);
                        else _this.updateNotificationKey(notificationKey, NotificationKeyStatus.Completed);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        cause = _state.sent();
                        _this.clearExpectedChange(notificationKey, NotificationKeyStatus.Failed);
                        switch(typeof errorizer === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(errorizer)){
                            case "string":
                                throw new Error(errorizer, {
                                    cause: cause
                                });
                            default:
                                error = errorizer.apply(void 0, [
                                    cause
                                ].concat((0,_to_consumable_array/* default */.Z)(args)));
                                switch(typeof error === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(error)){
                                    case "string":
                                        throw new Error(error, {
                                            cause: cause
                                        });
                                    default:
                                        throw error;
                                }
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2,
                            res
                        ];
                }
            });
        });
    };
    _proto.manageErrorsAndNotificationKey = function manageErrorsAndNotificationKey(method, action) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var handleHttpErrors = options.handleHttpErrors, manageNotificationKeyOptions = (0,_object_without_properties/* default */.Z)(options, [
            "handleHttpErrors"
        ]);
        return this.typedManageErrors(this.manageNotificationKey(method, action, manageNotificationKeyOptions), handleHttpErrors);
    };
    _proto.deserializeResponse = function deserializeResponse(method) {
        var _this = this;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _len, args, _key, returned;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        return [
                            4,
                            method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args))
                        ];
                    case 1:
                        returned = _state.sent();
                        if (!returned) return [
                            2,
                            null
                        ];
                        return [
                            2,
                            (0,arrays/* transformMap */.gQ)(returned, _this.deserialize)
                        ];
                }
            });
        });
    };
    _proto.expectChange = function expectChange(notificationKey, pk, patch) {
        var assist = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimistic = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, resource = arguments.length > 5 ? arguments[5] : void 0;
        var ref;
        if (this.expectedChanges.has(pk)) {
            console.debug("Already expecting change, merging", notificationKey, pk, this.expectedChanges.get(pk));
        }
        var mergedPatch = !!this.expectedChanges.has(pk) ? (0,objects/* deepmerge */.vb)(((ref = this.expectedChanges.get(pk)) === null || ref === void 0 ? void 0 : ref.patch) || {}, patch) : patch;
        var record = {
            notificationKey: notificationKey,
            pk: pk,
            expires: (0,add/* default */.Z)(new Date(), {
                seconds: 30
            }),
            patch: mergedPatch,
            assist: assist,
            optimistic: optimistic,
            resource: resource
        };
        console.debug("expect change", notificationKey, pk, patch, record);
        this.expectedChanges.set(pk, record);
        this.expectedChangesSubject.next(this.expectedChanges);
        this.addNotificationKey(notificationKey, NotificationKeyStatus.Pending, assist);
    };
    _proto.patchExpectedChanges = function patchExpectedChanges(data) {
        var _this = this;
        if (!data) return data;
        var updated = false;
        var patch = function(item) {
            var pk = _this.getPk(item);
            var expectedChange = !!pk && _this.expectedChanges.get(pk);
            // Clear expected changes not waiting on assist
            if (!!expectedChange && (0,objects/* partialEquals */.op)(item, expectedChange.patch) && !expectedChange.assist) {
                _this.expectedChanges.delete(pk);
                updated = true;
            }
            return !!expectedChange && !!expectedChange.patch ? (0,objects/* deepmerge */.vb)({}, item, expectedChange.patch) : item;
        };
        // Update expected changes subject
        if (updated) this.expectedChangesSubject.next(this.expectedChanges);
        var patched = Array.isArray(data) ? data.map(patch) : patch(data);
        return patched;
    };
    _proto.expireExpectedChanges = function expireExpectedChanges() {
        var _this = this;
        if (!this.expectedChanges.size) return;
        var now = new Date();
        var updated = false;
        this.expectedChanges.forEach(function(change) {
            if (change.expires.getTime() > now.getTime()) return;
            console.debug("expire expected change", change);
            _this.expectedChanges.delete(change.pk);
            _this.onExpectedChangeError("timeout", change);
            updated = true;
        });
        // Update expected changes subject
        if (updated) this.expectedChangesSubject.next(this.expectedChanges);
    };
    _proto.clearExpectedChange = function clearExpectedChange(notificationKey) {
        var status = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NotificationKeyStatus.Completed;
        var _this = this;
        var updated = false;
        console.debug("clear expected change", notificationKey, status);
        Array.from(this.expectedChanges.entries()).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), change = _param[1];
            return change.notificationKey === notificationKey;
        }).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], change = _param[1];
            _this.expectedChanges.delete(key);
            if (NotificationKeyStatus.Timedout === status) {
                _this.onExpectedChangeError("timeout", change);
            }
            updated = true;
        });
        // Update expected changes subject
        if (updated) this.expectedChangesSubject.next(this.expectedChanges);
    };
    TransformDomain.updateNotificationKey = function updateNotificationKey(key, statusOrEnvelope) {
        // No existing record
        if (!TransformDomain.notificationKeys.has(key)) {
            console.warn("Notification key doesn't exist, adding", key, statusOrEnvelope);
            return (0,utils_wonka/* isEnvelope */.AR)(statusOrEnvelope) ? this.addNotificationKey(key, undefined, NotificationKeyStatus.Received, undefined, undefined, statusOrEnvelope.data) : this.addNotificationKey(key, undefined, statusOrEnvelope);
        }
        var record = TransformDomain.notificationKeys.get(key);
        // Update record
        if (!(0,utils_wonka/* isEnvelope */.AR)(statusOrEnvelope)) {
            if (!!record && NotificationStatusIndex[record.status] > NotificationStatusIndex[statusOrEnvelope]) {
                console.warn("Notification key already '".concat(record.status, "', skipping"), key, statusOrEnvelope);
                return record;
            } else if (statusOrEnvelope === record.status) {
                console.debug("Updating notification key to same status '".concat(record.status, "'"), key, statusOrEnvelope);
            }
            record.status = statusOrEnvelope;
        } else {
            // TODO (IW): Need to handle passing in whole envelopes and auto-parsing expected changes
            console.warn("NOT YET IMPLEMENTED");
        }
        TransformDomain.notificationKeys.set(key, record);
        TransformDomain.notificationKeysSubject.next(TransformDomain.notificationKeys);
        return record;
    };
    (0,_create_class/* default */.Z)(TransformDomain, [
        {
            key: "upsert$",
            get: function get() {
                return this.upsertSubject.source;
            }
        },
        {
            key: "notificationKeys",
            get: // protected upsert = (data: DtoType | DtoType[] | null) => {
            //   if (!!data && !!this.deserialize) {
            //     const items: DtoType[] = Array.isArray(data) ? data : [data];
            //     const list = items.map((i: DtoType) => this.deserialize?.(i)).filter(notUndefined);
            //     if (!!list.length) this.upsertSubject.next(list);
            //   }
            //   return data;
            // }
            function get() {
                var _this = this;
                return new Map(Array.from(TransformDomain.notificationKeys.entries()).filter(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 1), k = _param[0];
                    return _this.parseUid(k).resource === _this.resource;
                }));
            }
        },
        {
            key: "notificationKeys$",
            get: function get() {
                var _this = this;
                return (0,wonka/* pipe */.zG)(TransformDomain.notificationKeys$, (0,wonka/* map */.UI)(function(keys) {
                    return new Map(Array.from(keys.entries()).filter(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), k = _param[0];
                        return _this.parseUid(k).resource === _this.resource;
                    }));
                }));
            }
        },
        {
            key: "expectedChanges$",
            get: function get() {
                return (0,wonka/* pipe */.zG)(this.expectedChangesSubject.source, (0,wonka/* debounce */.Ds)(function() {
                    return 50;
                }));
            }
        }
    ], [
        {
            key: "notificationKeys$",
            get: function get() {
                return TransformDomain.notificationKeysSubject.source;
            }
        }
    ]);
    return TransformDomain;
}(ResourceDomain);
TransformDomain.notificationKeysSubject = (0,wonka/* makeSubject */.nN)();
TransformDomain.notificationKeys = new Map();
// TODO (IW): There's some half-baked code included w/ notification keys in
// attempt to merge expected changes into notification keys. The structures
// are all there, but work is still needed to migrate from "expectChange" to
// adding a notification key w/ the changes listed.
TransformDomain.addNotificationKey = function(key) {
    var expectedChanges = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Map(), status = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : NotificationKeyStatus.Pending, assist = arguments.length > 3 ? arguments[3] : void 0, expires = arguments.length > 4 ? arguments[4] : void 0, receivedChanges = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : new Map();
    var record = {
        status: status,
        expectedChanges: expectedChanges,
        receivedChanges: receivedChanges,
        assist: !!assist,
        expires: !!expires ? expires : (0,add/* default */.Z)(new Date(), {
            minutes: 1
        })
    };
    TransformDomain.notificationKeys.set(key, record);
    TransformDomain.notificationKeysSubject.next(TransformDomain.notificationKeys);
    return record;
};
TransformDomain.deleteNotificationKey = function(key) {
    var success = TransformDomain.notificationKeys.delete(key);
    TransformDomain.notificationKeysSubject.next(TransformDomain.notificationKeys);
    return success;
};
TransformDomain.syncStatus$ = (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
    (0,wonka/* fromValue */._A)(TransformDomain.notificationKeys),
    TransformDomain.notificationKeys$
]), (0,wonka/* debounce */.Ds)(function() {
    return 50;
}), (0,wonka/* map */.UI)(function(keys) {
    // Grab status of all notification keys
    var statuses = Array.from(keys.entries()).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
        return v.status;
    });
    return getSyncStatus(statuses);
}));
TransformDomain.syncStatusKeys$ = (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
    (0,wonka/* fromValue */._A)(TransformDomain.notificationKeys),
    TransformDomain.notificationKeys$
]), (0,wonka/* debounce */.Ds)(function() {
    return 50;
}), (0,wonka/* map */.UI)(function(keys) {
    return keys;
}));
TransformDomain.assistStatus$ = (0,wonka/* pipe */.zG)((0,wonka/* concat */.zo)([
    (0,wonka/* fromValue */._A)(TransformDomain.notificationKeys),
    TransformDomain.notificationKeys$
]), (0,wonka/* debounce */.Ds)(function() {
    return 50;
}), (0,wonka/* map */.UI)(function(keys) {
    // Grab status of all notification keys expecting assist runs
    var statuses = Array.from(keys.entries()).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
        return !!v.assist;
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
        return v.status;
    });
    return getSyncStatus(statuses);
}));


/***/ }),

/***/ 72218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FX": function() { return /* binding */ getSnoozeScentenceEnder; },
/* harmony export */   "Oj": function() { return /* binding */ ACTION_VISIBILITY_LOGIC; },
/* harmony export */   "x9": function() { return /* binding */ SNOOZE_LABELS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98585);
// eslint-disable-next-line no-restricted-imports


var SNOOZE_INTERVALS = [
    _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW15M */ .op.FROMNOW15M,
    _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW30M */ .op.FROMNOW30M,
    _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW1H */ .op.FROMNOW1H,
    _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW2H */ .op.FROMNOW2H,
    _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW4H */ .op.FROMNOW4H,
    _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.TOMORROW */ .op.TOMORROW,
    _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.INTWODAYS */ .op.INTWODAYS,
    _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.NEXTWEEK */ .op.NEXTWEEK, 
];
var _obj;
var SNOOZE_LABELS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW15M */ .op.FROMNOW15M, "15min"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW30M */ .op.FROMNOW30M, "30min"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW1H */ .op.FROMNOW1H, "1hr"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW2H */ .op.FROMNOW2H, "2hrs"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW4H */ .op.FROMNOW4H, "4hrs"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.TOMORROW */ .op.TOMORROW, "1 day"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.INTWODAYS */ .op.INTWODAYS, "2 days"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.NEXTWEEK */ .op.NEXTWEEK, "1 week"), _obj);
function getStartOfDay(dt) {
    var dayStart = new Date(dt);
    dayStart.setUTCHours(0, 0, 0, 0);
    return dayStart;
}
function taskInstanceIsUpcoming(taskInstanceStatus) {
    return taskInstanceStatus === _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .TaskInstanceStatus.ACTIVE */ .O1.ACTIVE || taskInstanceStatus === _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .TaskInstanceStatus.PENDING */ .O1.PENDING;
}
function getSnoozeScentenceEnder(snoozeOption) {
    switch(snoozeOption){
        case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW15M */ .op.FROMNOW15M:
            return " to 15 minutes from now";
        case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW30M */ .op.FROMNOW30M:
            return " to 30 minutes from now";
        case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW1H */ .op.FROMNOW1H:
            return " to 1 hour from now";
        case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW2H */ .op.FROMNOW2H:
            return " to 2 hours from now";
        case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW4H */ .op.FROMNOW4H:
            return " to 4 hours from now";
        case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.TOMORROW */ .op.TOMORROW:
            return " until tomorrow";
        case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.INTWODAYS */ .op.INTWODAYS:
            return " to 2 days from";
        case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.NEXTWEEK */ .op.NEXTWEEK:
            return " until next week";
        default:
            return "";
    }
}
var ACTION_VISIBILITY_LOGIC = {
    Habits: {
        assignment: {
            start: function start(habitId, currentAssignmentId) {
                return !ACTION_VISIBILITY_LOGIC.Habits.assignment.stop(habitId, currentAssignmentId);
            },
            restart: function restart(habitId, currentAssignmentId) {
                return ACTION_VISIBILITY_LOGIC.Habits.assignment.stop(habitId, currentAssignmentId);
            },
            stop: function stop(habitId, currentAssignmentId) {
                return habitId === currentAssignmentId;
            },
            edit: function edit() {
                return true;
            },
            reset: function reset(exceptions) {
                return !!(exceptions === null || exceptions === void 0 ? void 0 : exceptions.length);
            }
        },
        instances: {
            lockOrUnlock: function lockOrUnlock(eventStart, now) {
                return eventStart > now;
            },
            skip: function skip() {
                return true;
            },
            // TODO: this really needs to check if that habit
            // is daily too, but recurrence is not easily
            // accessible from where this function is used
            reschedule: function reschedule(eventStart, now) {
                var nowDayStart = getStartOfDay(now);
                return eventStart >= nowDayStart;
            },
            rescheduleType: function rescheduleType(eventStart, recurrence, now) {
                var nowDayStart = getStartOfDay(now);
                if (eventStart >= nowDayStart) return "snoozeOptions";
                else return recurrence === _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Daily */ .Vy.Daily ? "none" : "quick";
            },
            snoozeOptions: function snoozeOptions(recurrence) {
                switch(recurrence){
                    case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Daily */ .Vy.Daily:
                        return [
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW15M */ .op.FROMNOW15M,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW30M */ .op.FROMNOW30M,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW1H */ .op.FROMNOW1H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW2H */ .op.FROMNOW2H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW4H */ .op.FROMNOW4H, 
                        ];
                    case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Weekly */ .Vy.Weekly:
                        return [
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW15M */ .op.FROMNOW15M,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW30M */ .op.FROMNOW30M,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW1H */ .op.FROMNOW1H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW2H */ .op.FROMNOW2H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW4H */ .op.FROMNOW4H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.TOMORROW */ .op.TOMORROW, 
                        ];
                    case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Biweekly */ .Vy.Biweekly:
                        return [
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW15M */ .op.FROMNOW15M,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW30M */ .op.FROMNOW30M,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW1H */ .op.FROMNOW1H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW2H */ .op.FROMNOW2H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW4H */ .op.FROMNOW4H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.TOMORROW */ .op.TOMORROW,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.INTWODAYS */ .op.INTWODAYS, 
                        ];
                    case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Monthly */ .Vy.Monthly:
                    case _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .Recurrence.Quarterly */ .Vy.Quarterly:
                        return [
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW15M */ .op.FROMNOW15M,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW30M */ .op.FROMNOW30M,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW1H */ .op.FROMNOW1H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW2H */ .op.FROMNOW2H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.FROMNOW4H */ .op.FROMNOW4H,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.TOMORROW */ .op.TOMORROW,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.INTWODAYS */ .op.INTWODAYS,
                            _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .SnoozeOption.NEXTWEEK */ .op.NEXTWEEK, 
                        ];
                }
            },
            markDone: function markDone(habitId, eventStart, eventEnd, now, currentAssignmentId) {
                // Happening now can mark done.
                if (habitId === currentAssignmentId) return true;
                var eventDayStart = getStartOfDay(eventStart);
                var nowDayStart = getStartOfDay(now);
                return eventDayStart === nowDayStart && eventEnd > now;
            }
        }
    },
    Tasks: {
        assignment: {
            start: function start(taskId, currentAssignmentId) {
                // alternative: task.getInstances().stream().map(TaskInstance::getStatus).anyMatch(status -> status.equals(TaskInstanceStatus.ACTIVE));
                return !ACTION_VISIBILITY_LOGIC.Tasks.assignment.stop(taskId, currentAssignmentId);
            },
            restart: function restart(taskId, currentAssignmentId) {
                return ACTION_VISIBILITY_LOGIC.Tasks.assignment.stop(taskId, currentAssignmentId);
            },
            stop: function stop(taskId, currentAssignmentId) {
                return taskId === currentAssignmentId;
            },
            edit: function edit() {
                return true;
            },
            markDone: function markDone(taskStatus) {
                return taskStatus !== _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .TaskStatus.COMPLETE */ .hY.COMPLETE;
            },
            markIncomplete: function markIncomplete(taskStatus) {
                return taskStatus === _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .TaskStatus.COMPLETE */ .hY.COMPLETE;
            },
            logWork: function logWork() {
                return true;
            },
            addTime: function addTime() {
                return true;
            },
            reset: function reset(exceptions) {
                return !!(exceptions === null || exceptions === void 0 ? void 0 : exceptions.length);
            },
            moveToTop: function moveToTop(taskIndex, minIndex) {
                return typeof taskIndex !== "number" || taskIndex !== minIndex;
            },
            delete: function _delete() {
                return true;
            }
        },
        instances: {
            lockOrUnlock: function lockOrUnlock(taskInstanceStatus) {
                return taskInstanceIsUpcoming(taskInstanceStatus);
            },
            rescheduleType: function rescheduleType(eventEnd, now) {
                return eventEnd >= now ? "snoozeOptions" : "quick";
            },
            rescheduleWithSnooze: function rescheduleWithSnooze(taskInstanceEnd, now) {
                return taskInstanceEnd > now;
            },
            snoozeOptions: function snoozeOptions() {
                return SNOOZE_INTERVALS;
            }
        }
    },
    OneOnOnes: {
        assignment: {
            reset: function reset(exceptions) {
                return !!(exceptions === null || exceptions === void 0 ? void 0 : exceptions.length);
            }
        },
        instances: {
            lockOrUnlock: function lockOrUnlock(eventStart, now) {
                return eventStart > now;
            },
            reschedule: function reschedule() {
                return true;
            },
            skipOptions: function skipOptions() {
                return [
                    "ANOTHER_TIME",
                    "ANOTHER_DAY",
                    "ANOTHER_WEEK"
                ];
            }
        }
    }
};


/***/ }),

/***/ 45759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Status; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11057);
/* harmony import */ var _mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61214);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_ContactSupportButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8137);
/* harmony import */ var _hooks_useCaptureError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59546);









var useStyles = (0,_mui_styles_makeStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "center"
        },
        errorText: {
            margin: theme.spacing(4, "auto", 0)
        },
        heading: {
            fontWeight: theme.typography.fontWeightBold,
            marginBottom: theme.spacing()
        },
        content: {
            maxWidth: 720,
            padding: theme.spacing(0, 2),
            position: "relative",
            textAlign: "center",
            width: "100%"
        },
        supportLink: {
            marginTop: theme.spacing(2)
        },
        goBtn: {
            marginTop: theme.spacing(3)
        }
    };
}, {
    classNamePrefix: "Status"
});
var Status = function(param) {
    var code = param.code, _heading = param.heading, heading = _heading === void 0 ? "Oops, something went wrong." : _heading, _message = param.message, message = _message === void 0 ? "This page doesn't exist. Try going back to our homepage." : _message, hideGoHome = param.hideGoHome, hideSupportLink = param.hideSupportLink, className = param.className, captureStatus = param.captureStatus, associatedError = param.associatedError;
    var classes = useStyles();
    var captureError = (0,_hooks_useCaptureError__WEBPACK_IMPORTED_MODULE_4__/* .useCaptureError */ .e)().captureError;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (captureStatus) captureError(associatedError !== undefined ? associatedError : "Status component captured a status", {
            statusCode: code
        });
    }, [
        associatedError,
        captureError,
        captureStatus,
        code
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(classes.root, className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
            className: classes.content,
            children: [
                function() {
                    switch(code){
                        case 404:
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: "/img/404.svg",
                                layout: "responsive",
                                width: "480",
                                height: "173"
                            });
                        case 5000:
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: "/img/5000.svg",
                                layout: "responsive",
                                width: "595",
                                height: "173"
                            });
                    }
                }(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: classes.errorText,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: "h1",
                            className: classes.heading,
                            children: heading
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: message
                        }),
                        !hideGoHome && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            className: classes.goBtn,
                            color: "primary",
                            variant: "contained",
                            href: "/",
                            children: "Go back home"
                        })
                    ]
                }),
                !hideSupportLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.supportLink,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactSupportButton__WEBPACK_IMPORTED_MODULE_3__/* .ContactSupportButton */ .u, {})
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Status);


/***/ }),

/***/ 41390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ObjectEnum; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);


var ObjectEnum = /*#__PURE__*/ function() {
    "use strict";
    function ObjectEnum(key) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ObjectEnum);
        this.key = key;
    }
    var _proto = ObjectEnum.prototype;
    _proto.toString = function toString() {
        return this.key;
    };
    _proto.toJSON = function toJSON() {
        return this.key;
    };
    ObjectEnum.get = function get(key) {
        var _this = this;
        if (!key) return undefined;
        return Object.values(this).filter(function(k) {
            return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(k, _this);
        }).find(function(val) {
            return val.key === key;
        });
    };
    return ObjectEnum;
}();


/***/ }),

/***/ 3620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ notUndefined; },
/* harmony export */   "Nf": function() { return /* binding */ notNull; },
/* harmony export */   "P9": function() { return /* binding */ isType; }
/* harmony export */ });
/* unused harmony exports notEmpty, notFalsy, isSub, enumKeys */
// Guards
function notUndefined(x) {
    return undefined !== x;
}
function notNull(x) {
    return null !== x;
}
function notEmpty(x) {
    return notUndefined(x) && notNull(x) && (!Array.isArray(x) || !!x.length);
}
function notFalsy(x) {
    return !!x;
}
function isType(x, fn) {
    return notUndefined(x) && fn(x);
}
function isSub(x, fn) {
    return notNull(x) && notUndefined(x) && fn(x);
}
function enumKeys(obj) {
    return Object.keys(obj).filter(function(k) {
        return Number.isNaN(+k);
    });
}


/***/ }),

/***/ 92886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ makeValidItemFilter; },
/* harmony export */   "RC": function() { return /* binding */ rotateAroundFirstInstance; },
/* harmony export */   "SA": function() { return /* binding */ randomInArray; },
/* harmony export */   "SY": function() { return /* binding */ filterFalsy; },
/* harmony export */   "TC": function() { return /* binding */ findAndPunch; },
/* harmony export */   "gQ": function() { return /* binding */ transformMap; },
/* harmony export */   "no": function() { return /* binding */ arrequal; },
/* harmony export */   "uy": function() { return /* binding */ byKey; },
/* harmony export */   "vD": function() { return /* binding */ makeExclusive; },
/* harmony export */   "xQ": function() { return /* binding */ moveToFront; }
/* harmony export */ });
/* unused harmony exports narrowToArray, range, arrdupes, arrdiff, findLastIndex, rotateArrayAtIndex, rotateAroundFind */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45110);



var randomInArray = function(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
};
var narrowToArray = function(thing) {
    if (!thing) return [];
    return Array.isArray(thing) ? thing : [
        thing
    ];
};
/**
 * Equivilant of [].filter(i => !!i) but correctly removes falsy values from from the type
 * @param items An array of items
 * @returns The same array without falsy values
 */ var filterFalsy = function(items) {
    return (items === null || items === void 0 ? void 0 : items.filter(function(i) {
        return !!i;
    })) || [];
};
/**
 * Generates a list of values between two numbers
 *
 * @param from starting index (inclusive)
 * @param to ending index (exclusive)
 * @param step defaults to 1
 */ function range(from, to) {
    var step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var ref = _sliced_to_array(undefined !== to ? [
        from,
        to / step
    ] : [
        0,
        from / step
    ], 2), start = ref[0], end = ref[1];
    return Array.from(Array(end - start), function(_, i) {
        return i * step + start;
    });
}
/**
 * Check if two arrays contain all the same elements (regardless of order)
 *
 * @param a
 * @param b
 */ function arrequal(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    return !a.some(function(o, idx) {
        return !b[idx] || b[idx] !== o;
    });
}
function arrdupes(a) {
    return new Set(a).size !== a.length;
}
function arrdiff(a, b) {
    var diff = function(a, b) {
        return a.filter(function(item) {
            return !b.includes(item);
        });
    };
    return _to_consumable_array(diff(a, b)).concat(_to_consumable_array(diff(b, a)));
}
function findLastIndex(array, predicate) {
    var l = array.length;
    while(l--){
        if (predicate(array[l], l, array)) return l;
    }
    return -1;
}
function byKey(key) {
    return function(a, b) {
        if ((0,_objects__WEBPACK_IMPORTED_MODULE_0__/* .walk */ ._p)(key, a) === (0,_objects__WEBPACK_IMPORTED_MODULE_0__/* .walk */ ._p)(key, b)) return 0;
        return (typeof (0,_objects__WEBPACK_IMPORTED_MODULE_0__/* .walk */ ._p)(key, a) === "string" ? (0,_objects__WEBPACK_IMPORTED_MODULE_0__/* .walk */ ._p)(key, a).toLowerCase() < (0,_objects__WEBPACK_IMPORTED_MODULE_0__/* .walk */ ._p)(key, b).toLowerCase() : (0,_objects__WEBPACK_IMPORTED_MODULE_0__/* .walk */ ._p)(key, a) < (0,_objects__WEBPACK_IMPORTED_MODULE_0__/* .walk */ ._p)(key, b)) ? -1 : 1;
    };
}
/**
 * Modifes `arr` in place, removing the found item and returning it
 * @param arr The array to search
 * @param find The function used to search the array
 */ function findAndPunch(arr, find) {
    var index = arr.findIndex(find);
    if (index === -1) return;
    return arr.splice(index, 1)[0];
}
/**
 * Modifies `arr` in place.  Sends the found item to the front of the array
 * @param arr
 * @param find
 * @returns The moved item
 */ function moveToFront(arr, find) {
    var item = findAndPunch(arr, find);
    if (item) arr.unshift(item);
    return item;
}
function transformMap(thing, transform) {
    if (!thing) return null;
    if (!transform) return thing;
    if (Array.isArray(thing)) {
        return thing.map(transform);
    } else {
        return transform(thing);
    }
}
/**
 * Rotates array around index, putting everything before index after everything after.
 * @param arr The array to rotate
 * @param index The index to rotate around
 * @returns A copy of `arr` rotated.
 */ var rotateArrayAtIndex = function(arr, index) {
    var second = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr);
    var first = second.splice(0, index);
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(second).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(first));
};
/**
 * Rotates array around an index found using `predicate`, putting everything before index after everything after.
 * @param arr The array to rotate
 * @param predicate A finding function
 * @returns A copy of `arr` rotated.  If predicate does not find any items, an unmodified copy of the array will be returned
 */ var rotateAroundFind = function(arr, predicate) {
    var index = arr.findIndex(predicate);
    if (index < 0) return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr);
    return rotateArrayAtIndex(arr, index);
};
/**
 * Rotates array around the first instance of `item`, putting everything before index after everything after.
 * @param arr The array to rotate
 * @param item An item in the array
 * @returns A copy of `arr` rotated.  If no matching item is found, an unmodified copy of the array will be returned
 */ var rotateAroundFirstInstance = function(arr, item) {
    return rotateAroundFind(arr, function(itItem) {
        return itItem === item;
    });
};
/**
 * Removes duplicates from array
 * @param arr An array
 * @returns The same array without duplicate values
 */ var makeExclusive = function(arr) {
    return Array.from(new Set(arr));
};
var makeValidItemFilter = function(validItems) {
    var itemMap = (0,_objects__WEBPACK_IMPORTED_MODULE_0__/* .extantNativeMap */ .mt)(validItems);
    return function(item) {
        return !!itemMap.get(item);
    };
};


/***/ }),

/***/ 74150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pd": function() { return /* binding */ normalizeReclaimApiError; },
/* harmony export */   "WX": function() { return /* binding */ normalizeClientNetworkError; },
/* harmony export */   "gK": function() { return /* binding */ isReclaimApiError; },
/* harmony export */   "rZ": function() { return /* binding */ isClientNetworkError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82670);
/* harmony import */ var _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98585);
/* harmony import */ var _reclaim_api_clientPassthrough__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13859);
/* harmony import */ var _reclaim_api_scheduling_links_scheduling_links_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75007);
/* harmony import */ var _reclaim_api_team_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34629);
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45110);
// eslint-disable-next-line no-restricted-imports




// eslint-disable-next-line no-restricted-imports


var isReclaimApiError = function(err) {
    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(err, _reclaim_api_clientPassthrough__WEBPACK_IMPORTED_MODULE_1__/* .AppReclaimApiError */ .s) || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(err, _reclaim_api_client__WEBPACK_IMPORTED_MODULE_0__/* .ReclaimApiError */ .gt) || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(err, _reclaim_api_team_client__WEBPACK_IMPORTED_MODULE_3__/* .ReclaimApiError */ .gt) || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(err, _reclaim_api_scheduling_links_scheduling_links_client__WEBPACK_IMPORTED_MODULE_2__/* .ReclaimApiError */ .gt);
};
var isClientNetworkError = function(err) {
    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(err, _reclaim_api_clientPassthrough__WEBPACK_IMPORTED_MODULE_1__/* .AppNetworkError */ .g) || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(err, _reclaim_api_team_client__WEBPACK_IMPORTED_MODULE_3__/* .NetworkError */ .F7) || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(err, _reclaim_api_scheduling_links_scheduling_links_client__WEBPACK_IMPORTED_MODULE_2__/* .NetworkError */ .F7);
};
/**
 * Takes any of the ReclaimApiError classes from any of the three
 * client files and returns an identical one from the main client
 * file
 * @param err The error to normalize
 * @returns An identical error made from the class in the main client file
 */ var normalizeReclaimApiError = function(err) {
    return new _reclaim_api_clientPassthrough__WEBPACK_IMPORTED_MODULE_1__/* .AppReclaimApiError */ .s(err);
};
/**
 * Takes any of the NetworkError classes from any of the three
 * client files and returns an identical one from the main client
 * file
 * @param err The error to normalize
 * @returns An identical error made from the class in the main client file
 */ var normalizeClientNetworkError = function(err) {
    var out = new _reclaim_api_clientPassthrough__WEBPACK_IMPORTED_MODULE_1__/* .AppNetworkError */ .g({
        // status is unused by NetworkError
        status: NaN,
        statusText: err.statusText || "",
        headers: err.headers,
        data: err.body,
        config: {}
    }, err.message);
    (0,_objects__WEBPACK_IMPORTED_MODULE_4__/* .movePropsOver */ .Gg)(err, out);
    return out;
};


/***/ }),

/***/ 61373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ DAYS_OF_WEEK_META; },
/* harmony export */   "s": function() { return /* binding */ DAYS_OF_WEEK; }
/* harmony export */ });
var DAYS_OF_WEEK = [
    "SUNDAY",
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY", 
];
var DAYS_OF_WEEK_META = {
    SUNDAY: {
        label: "Sunday"
    },
    MONDAY: {
        label: "Monday"
    },
    TUESDAY: {
        label: "Tuesday"
    },
    WEDNESDAY: {
        label: "Wednesday"
    },
    THURSDAY: {
        label: "Thursday"
    },
    FRIDAY: {
        label: "Friday"
    },
    SATURDAY: {
        label: "Saturday"
    }
};


/***/ }),

/***/ 26958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oz": function() { return /* binding */ CHUNKS_PER_HOUR; },
  "ux": function() { return /* binding */ HOURS_PER_DAY; },
  "Jg": function() { return /* binding */ MILLISECONDS_PER_DAY; },
  "Dv": function() { return /* binding */ MILLISECONDS_PER_HOUR; },
  "df": function() { return /* binding */ MILLISECONDS_PER_MINUTE; },
  "s9": function() { return /* binding */ MILLISECONDS_PER_SECOND; },
  "zE": function() { return /* binding */ MILLISECONDS_PER_WEEK; },
  "rf": function() { return /* binding */ MILLISECONDS_PER_YEAR; },
  "Xl": function() { return /* binding */ MINUTES_PER_CHUNK; },
  "rE": function() { return /* binding */ MINUTES_PER_DAY; },
  "RH": function() { return /* binding */ MONTH_ORDER; },
  "TJ": function() { return /* binding */ OffsetDayOfWeekIndex; },
  "HA": function() { return /* binding */ SECONDS_PER_CHUNK; },
  "Qq": function() { return /* binding */ TIME_UNIT_META; },
  "yG": function() { return /* binding */ addTime; },
  "Xe": function() { return /* binding */ convertTimeUnit; },
  "ho": function() { return /* binding */ dateToHHMM; },
  "dx": function() { return /* binding */ dateToStr; },
  "bc": function() { return /* binding */ dateToYyyyMmDd; },
  "D7": function() { return /* binding */ daysStr; },
  "pg": function() { return /* binding */ distanceToPrevStartOfWeek; },
  "wi": function() { return /* binding */ durationStr; },
  "TF": function() { return /* binding */ durationStrDecimal; },
  "yQ": function() { return /* binding */ formatTz; },
  "qX": function() { return /* binding */ getApparentMsSinceStartOfDay; },
  "hm": function() { return /* binding */ getAutoTimestamp; },
  "lu": function() { return /* binding */ getDateSpanMinimalDisplay; },
  "OH": function() { return /* binding */ getDayOfWeekDisplay; },
  "xh": function() { return /* binding */ getDayOfWeekFromDate; },
  "_b": function() { return /* binding */ getDaysOfWeekFromDateSpan; },
  "pI": function() { return /* binding */ getDurationString; },
  "Es": function() { return /* binding */ getLargestContainedUnit; },
  "sy": function() { return /* binding */ getLargestUnitDate; },
  "vD": function() { return /* binding */ getLatestMinuteInterval; },
  "Im": function() { return /* binding */ getShortenedTimeSpanDisplay; },
  "Rp": function() { return /* binding */ getSmartDateDisplay; },
  "yj": function() { return /* binding */ getTemporalPosition; },
  "ZW": function() { return /* binding */ getTotalHoursInTimePolicy; },
  "K4": function() { return /* binding */ getWeekdaysStartingAtIndex; },
  "C6": function() { return /* binding */ getWeeksAgo; },
  "Zn": function() { return /* binding */ isDateNowOrEarlier; },
  "x5": function() { return /* binding */ isDateNowish; },
  "Y3": function() { return /* binding */ isDateToday; },
  "p2": function() { return /* binding */ isHHMMSS; },
  "bo": function() { return /* binding */ isRangeAllDay; },
  "Vi": function() { return /* binding */ isRangeNow; },
  "fq": function() { return /* binding */ isSameDayInTz; },
  "JY": function() { return /* binding */ isValid; },
  "n_": function() { return /* binding */ isYYYYMMSS; },
  "vt": function() { return /* binding */ msInHHMMSS; },
  "YS": function() { return /* binding */ parseDateStringToDate; },
  "LG": function() { return /* binding */ parseDateStringWithDisabledPast; },
  "RA": function() { return /* binding */ parseDuration; },
  "PE": function() { return /* binding */ parseRouteDate; },
  "Sj": function() { return /* binding */ relativeStr; },
  "QX": function() { return /* binding */ roundTimeToChunk; },
  "qn": function() { return /* binding */ roundTimeToNextChunk; },
  "BH": function() { return /* binding */ shiftDateToTz; },
  "En": function() { return /* binding */ shortenMonthDayString; },
  "uZ": function() { return /* binding */ snap; },
  "Su": function() { return /* binding */ startOfDayInTz; },
  "z8": function() { return /* binding */ strToDate; },
  "Ji": function() { return /* binding */ timePolicyToHourDetailDays; },
  "yq": function() { return /* binding */ unShiftDateToTz; },
  "k8": function() { return /* binding */ yyyyMmDdHhMmSsToDate; },
  "TN": function() { return /* binding */ yyyyMmDdToDate; }
});

// UNUSED EXPORTS: DayOfWeekIndex, HOURS_PER_WEEK, MINUTES_PER_HOUR, MONTH_INDEX_MAP, MONTH_META, SECONDS_PER_DAY, SECONDS_PER_HOUR, SECONDS_PER_MINUTE, SECONDS_PER_WEEK, SECONDS_PER_YEAR, TIME_UNITS, TIME_UNITS_REV, TimeFormatHours, byDayOfWeek, containsWeekdayMatch, countPerDay, dayOfWeekToNumber, daysAgo, default, destructureYyyMmDd, durationBetweenStr, durationFn, endOfDayInTz, getDatesArray, getDatesBetween, getDayOfWeekIndex, getDayOfWeekStrFromDate, getHours, getRelativeTimestamp, getSeconds, getTomorrowAtHour, isDateNowOrEarlierThisWeek, localTimeToMin, localTimeToMinute, makeYyyyMmDd, minTolocalTime, parseHHMMSS, timeGreaterThan, yearsAgo

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/chrono-node/dist/esm/index.js + 45 modules
var esm = __webpack_require__(15880);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isToday/index.js
var isToday = __webpack_require__(51085);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(7069);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isYesterday/index.js



/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */

function isYesterday(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameDay/* default */.Z)(dirtyDate, (0,subDays/* default */.Z)(Date.now(), 1));
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isTomorrow/index.js
var isTomorrow = __webpack_require__(49727);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js
var differenceInDays = __webpack_require__(67803);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isPast/index.js
var isPast = __webpack_require__(33913);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameYear/index.js
var isSameYear = __webpack_require__(60792);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isThisYear/index.js


/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */

function isThisYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,isSameYear/* default */.Z)(dirtyDate, Date.now());
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 6 modules
var parse = __webpack_require__(24002);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addHours/index.js
var addHours = __webpack_require__(78343);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMinutes/index.js
var esm_addMinutes = __webpack_require__(58545);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addSeconds/index.js
var addSeconds = __webpack_require__(61973);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(69119);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var esm_add = __webpack_require__(29422);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfDay/index.js
var esm_endOfDay = __webpack_require__(83894);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(584);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfWeek/index.js
var endOfWeek = __webpack_require__(67090);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js
var startOfMonth = __webpack_require__(43703);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js
var endOfMonth = __webpack_require__(4135);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDay/index.js


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay_getDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  return day;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInHours/index.js
var differenceInHours = __webpack_require__(76972);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isWithinInterval/index.js
var isWithinInterval = __webpack_require__(24257);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameMonth/index.js
var isSameMonth = __webpack_require__(49160);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var esm_addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(70722);
// EXTERNAL MODULE: ./src/hooks/useDateTimeFormatter.ts + 2 modules
var useDateTimeFormatter = __webpack_require__(62495);
// EXTERNAL MODULE: ./src/reclaim-api/Calendars.ts
var Calendars = __webpack_require__(48410);
// EXTERNAL MODULE: ./src/utils/dates.consts.ts
var dates_consts = __webpack_require__(61373);
// EXTERNAL MODULE: ./src/utils/numbers.ts
var numbers = __webpack_require__(63139);
// EXTERNAL MODULE: ./src/utils/objects.ts
var objects = __webpack_require__(45110);
// EXTERNAL MODULE: ./src/utils/strings.ts + 1 modules
var strings = __webpack_require__(84467);
;// CONCATENATED MODULE: ./src/utils/dates.ts















var TimeFormatHours = "HH:mm:ss";
var MONTH_META = {
    JANUARY: {
        label: "January"
    },
    FEBRUARY: {
        label: "February"
    },
    MARCH: {
        label: "March"
    },
    APRIL: {
        label: "April"
    },
    MAY: {
        label: "May"
    },
    JUNE: {
        label: "June"
    },
    JULY: {
        label: "July"
    },
    AUGUST: {
        label: "August"
    },
    SEPTEMBER: {
        label: "September"
    },
    OCTOBER: {
        label: "October"
    },
    NOVEMBER: {
        label: "November"
    },
    DECEMBER: {
        label: "December"
    }
};
var MONTH_ORDER = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER", 
];
var MONTH_INDEX_MAP = (0,objects/* indexMap */.Db)(MONTH_ORDER);
var getSmartDateDisplay = function(date, format, options) {
    var ref = options || {}, lowercase = ref.lowercase, trimMinutes = ref.trimMinutes, trimTime = ref.trimTime, neverTomorrow = ref.neverTomorrow, forceShowDate = ref.forceShowDate, shorten = ref.shorten;
    var str = "";
    if ((0,isToday/* default */.Z)(date)) str = "".concat(lowercase ? "t" : "T", "oday").concat(trimTime ? "" : " ".concat(format(date, "TIME_DISPLAY_FORMAT"))).concat(forceShowDate ? ", ".concat(format(date, "WEEKLESS_DATE_DISPLAY_FORMAT")) : "");
    else if (isYesterday(date)) str = "".concat(lowercase ? "y" : "Y", "esterday").concat(trimTime ? "" : " ".concat(format(date, "TIME_DISPLAY_FORMAT"))).concat(forceShowDate ? ", ".concat(format(date, "WEEKLESS_DATE_DISPLAY_FORMAT")) : "");
    else if (!neverTomorrow && (0,isTomorrow/* default */.Z)(date)) str = "".concat(lowercase ? "t" : "T", "omorrow").concat(trimTime ? "" : " ".concat(format(date, "TIME_DISPLAY_FORMAT"))).concat(forceShowDate ? ", ".concat(format(date, "WEEKLESS_DATE_DISPLAY_FORMAT")) : "");
    else if ((0,differenceInDays/* default */.Z)(date, new Date()) <= 6 && !(0,isPast/* default */.Z)(date)) if (!forceShowDate) {
        str = format(date, trimTime ? "DAY_OF_WEEK_FORMAT" : "DAY_OF_WEEK_TIME_FORMAT");
    } else {
        str = format(date, "DATE_DISPLAY_FORMAT");
    }
    else if (isThisYear(date)) {
        if (shorten) {
            str = format(date, trimTime ? "DAY_MONTH_FORMAT" : "SHORT_DATE_TIME_FORMAT");
        } else {
            str = format(date, trimTime ? "DATE_DISPLAY_FORMAT" : "DATE_TIME_DISPLAY_FORMAT");
        }
    } else {
        if (shorten) {
            str = format(date, trimTime ? "DAY_MONTH_YEAR_FORMAT" : "SHORT_DATE_YEAR_TIME_FORMAT");
        } else {
            str = format(date, "DATE_YEAR_DISPLAY_FORMAT");
        }
    }
    if (trimMinutes) str = str.replace(":00", "");
    return str;
};
var getLargestUnitDate = function(date, format, options) {
    var ref = options || {}, lowercase = ref.lowercase, keepDayMonth = ref.keepDayMonth, neverTomorrow = ref.neverTomorrow;
    if ((0,isToday/* default */.Z)(date)) return "".concat(lowercase ? "t" : "T", "oday");
    else if (!neverTomorrow && (0,isTomorrow/* default */.Z)(date)) return "".concat(lowercase ? "t" : "T", "omorrow");
    else if (isThisYear(date)) return format(date, "WEEKLESS_DATE_DISPLAY_FORMAT");
    else return format(date, keepDayMonth ? "DATE_CONTROL_FORMAT_DAY_MODE" : "YEAR_DISPLAY_FORMAT");
};
// 2/24 10am - 1:15pm, 2/24 10am - 2/25 1:15pm
var getDateSpanMinimalDisplay = function(start, end, format) {
    return "".concat(format(start, "SHORT_DATE_TIME_FORMAT"), " - ").concat((0,isSameDay/* default */.Z)(start, end) ? format(end, "TIME_DISPLAY_FORMAT") : format(end, "SHORT_DATE_TIME_FORMAT"));
};
var SECONDS_PER_MINUTE = 60;
var SECONDS_PER_HOUR = SECONDS_PER_MINUTE * 60;
var SECONDS_PER_DAY = SECONDS_PER_HOUR * 24;
var SECONDS_PER_WEEK = SECONDS_PER_DAY * 7;
// eh, close enough
var SECONDS_PER_YEAR = SECONDS_PER_DAY * 365.25;
var MILLISECONDS_PER_SECOND = 1000;
var MILLISECONDS_PER_MINUTE = SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
var MILLISECONDS_PER_HOUR = SECONDS_PER_HOUR * MILLISECONDS_PER_SECOND;
var MILLISECONDS_PER_DAY = SECONDS_PER_DAY * MILLISECONDS_PER_SECOND;
var MILLISECONDS_PER_WEEK = SECONDS_PER_WEEK * MILLISECONDS_PER_SECOND;
var MILLISECONDS_PER_YEAR = SECONDS_PER_YEAR * MILLISECONDS_PER_SECOND;
var MINUTES_PER_HOUR = 60;
var MINUTES_PER_CHUNK = 15;
var SECONDS_PER_CHUNK = MINUTES_PER_CHUNK * SECONDS_PER_MINUTE;
var CHUNKS_PER_HOUR = MINUTES_PER_HOUR / MINUTES_PER_CHUNK;
var HOURS_PER_DAY = 24;
var HOURS_PER_WEEK = HOURS_PER_DAY * 7;
var MINUTES_PER_DAY = MINUTES_PER_HOUR * HOURS_PER_DAY;
var durationFn = function(seconds) {
    var dur = {
        seconds: 0,
        minutes: 0,
        hours: 0,
        days: 0,
        weeks: 0
    };
    dur.weeks = Math.floor(seconds / SECONDS_PER_WEEK);
    seconds = seconds % SECONDS_PER_WEEK;
    dur.days = Math.floor(seconds / SECONDS_PER_DAY);
    seconds = seconds % SECONDS_PER_DAY;
    dur.hours = Math.floor(seconds / SECONDS_PER_HOUR);
    seconds = seconds % SECONDS_PER_HOUR;
    dur.minutes = Math.floor(seconds / SECONDS_PER_MINUTE);
    seconds = seconds % SECONDS_PER_MINUTE;
    dur.seconds = Math.round(seconds);
    return dur;
};
var getSeconds = function(duration) {
    var seconds = duration.seconds || 0;
    seconds += (duration.minutes || 0) * SECONDS_PER_MINUTE;
    seconds += (duration.hours || 0) * SECONDS_PER_HOUR;
    seconds += (duration.days || 0) * SECONDS_PER_DAY;
    seconds += (duration.weeks || 0) * SECONDS_PER_WEEK;
    return seconds;
};
var getHours = function(duration) {
    return getSeconds(duration) / SECONDS_PER_HOUR;
};
var TIME_UNITS = [
    "ms",
    "sec",
    "min",
    "hr",
    "day",
    "week",
    "year"
];
var TIME_UNITS_REV = (0,_to_consumable_array/* default */.Z)(TIME_UNITS).reverse();
// TODO: I think I added this, but I can't
// remember why.  It doesn't really seem to
// do anything that the string union doesn't
// do already.
var UNITS = {
    year: "year",
    week: "week",
    day: "day",
    hr: "hr",
    min: "min",
    sec: "sec",
    ms: "ms"
};
var TIME_UNIT_META = {
    ms: {
        msPer: 1,
        label: "milliseconds",
        shortLabel: "ms"
    },
    sec: {
        msPer: MILLISECONDS_PER_SECOND,
        label: "seconds",
        shortLabel: "sec"
    },
    min: {
        msPer: MILLISECONDS_PER_MINUTE,
        label: "minute",
        shortLabel: "min"
    },
    hr: {
        msPer: MILLISECONDS_PER_HOUR,
        label: "hour",
        shortLabel: "hr"
    },
    day: {
        msPer: MILLISECONDS_PER_DAY,
        label: "day",
        shortLabel: "day"
    },
    week: {
        msPer: MILLISECONDS_PER_WEEK,
        label: "week",
        shortLabel: "wk"
    },
    year: {
        msPer: MILLISECONDS_PER_YEAR,
        label: "year",
        shortLabel: "yr"
    }
};
var convertTimeUnit = function(value, fromUnit, toUnit) {
    var ms = TIME_UNIT_META[fromUnit].msPer * value;
    return ms / TIME_UNIT_META[toUnit].msPer;
};
/**
 * gets the largest unit that fits into a duration of time
 * @param durationOrSeconds the duration of time
 * @returns a unit of time
 */ function getLargestContainedUnit(durationOrSeconds) {
    var noDaysOrWeeks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref = typeof durationOrSeconds === "number" ? durationFn(durationOrSeconds) : durationOrSeconds, minutes = ref.minutes, hours = ref.hours, days = ref.days, weeks = ref.weeks;
    if (!noDaysOrWeeks && weeks) return UNITS.week;
    if (!noDaysOrWeeks && days) return UNITS.day;
    if (hours) return UNITS.hr;
    if (minutes) return UNITS.min;
    return UNITS.sec;
}
var durationStrDecimal = function(durationOrSeconds, options) {
    var ref = options || {}, _fallbackUnit = ref.fallbackUnit, fallbackUnit = _fallbackUnit === void 0 ? "hours" : _fallbackUnit, _noDaysOrWeeks = ref.noDaysOrWeeks, noDaysOrWeeks = _noDaysOrWeeks === void 0 ? false : _noDaysOrWeeks;
    var ref1 = typeof durationOrSeconds === "number" ? durationFn(durationOrSeconds) : durationOrSeconds, seconds = ref1.seconds, minutes = ref1.minutes, hours = ref1.hours, days = ref1.days, weeks = ref1.weeks;
    if (noDaysOrWeeks) {
        hours += getHours({
            days: days,
            weeks: weeks
        });
        days = 0;
        weeks = 0;
    }
    if (weeks) {
        var num = weeks + getSeconds({
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        }) / SECONDS_PER_WEEK;
        return "".concat((0,numbers/* formatFloat */.$1)(num, 2), " ").concat((0,strings/* pluralize */._6)(num, UNITS.week));
    }
    if (days) {
        var num1 = days + getSeconds({
            hours: hours,
            minutes: minutes,
            seconds: seconds
        }) / SECONDS_PER_DAY;
        return "".concat((0,numbers/* formatFloat */.$1)(num1, 2), " ").concat((0,strings/* pluralize */._6)(num1, UNITS.day));
    }
    if (hours) {
        var num2 = hours + getSeconds({
            minutes: minutes,
            seconds: seconds
        }) / SECONDS_PER_HOUR;
        return "".concat((0,numbers/* formatFloat */.$1)(num2, 2), " ").concat((0,strings/* pluralize */._6)(num2, UNITS.hr));
    }
    if (minutes) {
        var num3 = minutes + getSeconds({
            seconds: seconds
        }) / SECONDS_PER_MINUTE;
        return "".concat((0,numbers/* formatFloat */.$1)(num3, 2), " ").concat((0,strings/* pluralize */._6)(num3, UNITS.min));
    }
    if (seconds) return "".concat(seconds, " ").concat((0,strings/* pluralize */._6)(seconds, UNITS.sec));
    return "0 ".concat(UNITS[fallbackUnit], "s");
};
/**
 * Breaks down seconds into durations
 * (eg. 3d 4h 29m)
 * @param seconds duration in seconds
 * @deprecated use getDurationString instead
 */ var durationStr = function(durationOrSeconds) {
    var noDaysOrWeeks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref = typeof durationOrSeconds === "number" ? durationFn(durationOrSeconds) : durationOrSeconds, seconds = ref.seconds, minutes = ref.minutes, hours = ref.hours, days = ref.days, weeks = ref.weeks;
    if (noDaysOrWeeks) {
        hours += HOURS_PER_DAY * days + HOURS_PER_WEEK * weeks;
        weeks = 0;
        days = 0;
    }
    var parts = [];
    // weeks
    if (weeks) parts.push("".concat(Math.floor(weeks), " ").concat((0,strings/* pluralize */._6)(weeks, UNITS.week)));
    // days
    if (days) parts.push("".concat(Math.floor(days), " ").concat((0,strings/* pluralize */._6)(days, UNITS.day)));
    // hours
    if (hours) parts.push("".concat(Math.floor(hours), " ").concat((0,strings/* pluralize */._6)(hours, UNITS.hr)));
    // minutes
    if (minutes) parts.push("".concat(Math.floor(minutes), " ").concat(UNITS.min));
    // seconds
    if (seconds) parts.push("".concat(Math.floor(seconds), " ").concat((0,strings/* pluralize */._6)(seconds, UNITS.sec)));
    // join
    return parts.join(" ");
};
/**
 * Intended as a replacement for `durationStr` with better features for picking units.  Returns a string detailing the amount of time in a duration.
 * @param durationMs The number of milliseconds in the duration
 * @param options Options
 * @returns A string representing the duration.  IE: `"1hr 2mins"`
 */ var getDurationString = function(durationMs) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _validUnits = options.validUnits, validUnits = _validUnits === void 0 ? [
        "ms",
        "sec",
        "min",
        "hr",
        "day",
        "week",
        "year"
    ] : _validUnits, _unitCount = options.unitCount, unitCount = _unitCount === void 0 ? 7 : _unitCount, emptyValue = options.emptyValue, _unitDisplay = options.unitDisplay, unitDisplay = _unitDisplay === void 0 ? "normal" : _unitDisplay, noPlural = options.noPlural;
    // this allows us to loop in order
    var mappedValid = (0,objects/* extantMap */.jG)(validUnits);
    var parts = [];
    var unitsAdded = 0;
    TIME_UNITS_REV.every(function(unit, i) {
        if (!mappedValid[unit]) return true;
        var msPer = TIME_UNIT_META[unit].msPer;
        var wholeUnits = Math.floor(durationMs / msPer);
        if (!wholeUnits) return true;
        durationMs -= wholeUnits * msPer;
        switch(unitDisplay){
            case "none":
                parts.push("".concat(wholeUnits));
                break;
            case "short":
                parts.push("".concat(wholeUnits).concat(unit.slice(0, 1)));
                break;
            case "normal":
                parts.push("".concat(wholeUnits, " ").concat(noPlural ? unit : (0,strings/* pluralize */._6)(wholeUnits, unit)));
                break;
            case "long":
                parts.push("".concat(wholeUnits, " ").concat(noPlural ? TIME_UNIT_META[unit].label : (0,strings/* pluralize */._6)(wholeUnits, TIME_UNIT_META[unit].label)));
                break;
        }
        unitsAdded++;
        return unitsAdded < unitCount;
    });
    if (!parts.length) return emptyValue || "< 1 ".concat(TIME_UNITS.find(function(unit) {
        return mappedValid[unit];
    }));
    if (unitDisplay !== "short") {
        return parts.join(" ");
    } else {
        return parts.join("");
    }
};
/**
 * Human readable string representation of time duration between two dates
 * (eg. "3d 4h 29m")
 * @param start start Date
 * @param end end Date
 */ var durationBetweenStr = function(start, end) {
    var diff = (end.getTime() - start.getTime()) / 1000;
    var duration = durationStr(Math.abs(diff));
    return diff >= 0 ? duration : "".concat(duration, " ago");
};
var daysAgo = function(start, end) {
    var diff = (end.getTime() - start.getTime()) / 1000;
    var duration = Math.floor(diff / (60 * 60 * 24));
    return duration;
};
var yearsAgo = function(start) {
    var end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    return daysAgo(start, end) / 360;
};
/**
 * Simple human readable representation of relative distance
 * @param num count
 * @param unit defaults to "days"
 * @param plural suffix to pluralize unit
 * @returns a string such as "n units ago", "in n units"
 */ var relativeStr = function(num) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "day", plural = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "s";
    if (num >= 0) return "in ".concat(num, " ").concat((0,strings/* pluralize */._6)(num, unit, plural));
    return "".concat(Math.abs(num), " ").concat((0,strings/* pluralize */._6)(num, unit, plural), " ago");
};
var containsWeekdayMatch = function(str) {
    return !!/mon|tue|wed|thu|fri|sat|sun/.test(str.toLowerCase().replace(/month/g, ""));
};
// FIXME (IW): Using eg `[DayOfWeek.Monday]` causes errors in tests
var DayOfWeekIndex = {
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    SUNDAY: 7
};
var getDayOfWeekDisplay = function(day) {
    return day.charAt(0).toUpperCase() + day.slice(1).toLowerCase();
};
var getTemporalPosition = function(now, start, end) {
    if (start < now && end > now) return "current";
    else if (end <= now) {
        if ((0,isSameDay/* default */.Z)(end, now)) return "earlierToday";
        else return "past";
    } else if (start > now) {
        if ((0,isSameDay/* default */.Z)(end, now)) return "laterToday";
        else return "future";
    } else return "current"; // this shouldn't ever be reached
};
var OffsetDayOfWeekIndex = function() {
    var startOfWeek = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Calendars/* DayOfWeek.Monday */.eO.Monday;
    var offset = DayOfWeekIndex[startOfWeek]; // offset in 1-indexed list
    return Object.entries(DayOfWeekIndex).reduce(function(acc, param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), d = _param[0], i = _param[1];
        acc[d] = (7 + (i - offset)) % 7 + 1;
        return acc;
    }, {});
};
/**
 * Sort by days of the week (eg. "[Sunday, Tuesday, Friday, ...]" )
 */ var byDayOfWeek = function(a, b) {
    var order = DayOfWeekIndex;
    var aIdx = order[a.toUpperCase()];
    var bIdx = order[b.toUpperCase()];
    if (aIdx === bIdx) return 0;
    else return aIdx > bIdx ? 1 : -1;
};
/**
 * Changes an array of DayOfWeek values into a range string
 * @param orderedDays
 * @param userOrderedDaysOfWeek
 * @returns returns a range of days (ie: Mon - Fri; Mon - Wed, Fri, Sun) as a string
 */ var daysStr = function(days, userOrderedDaysOfWeek) {
    if (days.length === 1) return (0,strings/* ucfirst */.Ps)(days[0].substring(0, 3));
    var buckets = [];
    var daysIndex = (0,objects/* extantMap */.jG)(days);
    var usersDayIndex = (0,objects/* indexMap */.Db)(userOrderedDaysOfWeek);
    // break into logical buckets of single or linked days
    // [[MONDAY], [WEDNESDAY, THURSDAY, FRIDAY]] => "Mon, Wed - Fri"
    userOrderedDaysOfWeek.forEach(function(day) {
        if (!daysIndex[day]) return;
        if (buckets.length === 0) {
            buckets.push([
                day
            ]);
        } else {
            var lastBucket = buckets[buckets.length - 1];
            var lastItem = lastBucket[lastBucket.length - 1];
            if (usersDayIndex[lastItem] + 1 === usersDayIndex[day]) {
                buckets[buckets.length - 1] = (0,_to_consumable_array/* default */.Z)(lastBucket).concat([
                    day
                ]);
            } else {
                buckets.push([
                    day
                ]);
            }
        }
    });
    // Construct the string from the buckets
    return buckets.reduce(function(acc, bucket, i) {
        var newString = bucket.length > 1 ? "".concat((0,strings/* ucfirst */.Ps)(bucket[0].substring(0, 3)), " - ").concat((0,strings/* ucfirst */.Ps)(bucket[bucket.length - 1].substring(0, 3))) : (0,strings/* ucfirst */.Ps)(bucket[0].substring(0, 3));
        return "".concat(acc).concat(acc ? ", " : "").concat(newString);
    }, "");
};
/**
 * Gets a string from `getDurationString`, adding text depending on if the  duration is positive or negative.
 * @param ms The time to represent (in milliseconds)
 * @param options Options
 * @returns A string representing a relative timestamp
 */ var getRelativeTimestamp = function(ms) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _pastPrefix = options.pastPrefix, pastPrefix = _pastPrefix === void 0 ? "" : _pastPrefix, _futurePrefix = options.futurePrefix, futurePrefix = _futurePrefix === void 0 ? "" : _futurePrefix, durationOptions = (0,_object_without_properties/* default */.Z)(options, [
        "pastPrefix",
        "futurePrefix"
    ]);
    var str = getDurationString(Math.abs(ms), durationOptions);
    if (pastPrefix) pastPrefix += " ";
    if (futurePrefix) futurePrefix += " ";
    return ms > 0 ? "".concat(futurePrefix, "in ").concat(str) : "".concat(pastPrefix).concat(str, " ago");
};
/**
 * Gets a timestamp that is relative when near, or absolute when far
 * @param date The date to represent in the timestamp
 * @param options Options
 * @returns A timestamp
 */ var getAutoTimestamp = function(date) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _absoluteFormat = options.absoluteFormat, absoluteFormat = _absoluteFormat === void 0 ? useDateTimeFormatter/* TIME_FORMAT_MAP.DATE_TIME_DISPLAY_FORMAT.12h */.Lb.DATE_TIME_DISPLAY_FORMAT["12h"] : _absoluteFormat, _cutoffMs = options.cutoffMs, cutoffMs = _cutoffMs === void 0 ? 3 * MILLISECONDS_PER_DAY : _cutoffMs, _rel = options.rel, rel = _rel === void 0 ? new Date() : _rel, relativeOptions = options.relativeOptions, absoluteOptions = options.absoluteOptions, _absolutePrefix = options.absolutePrefix, absolutePrefix = _absolutePrefix === void 0 ? "" : _absolutePrefix;
    var diffMs = date.getTime() - rel.getTime();
    if (absolutePrefix) absolutePrefix += " ";
    if (Math.abs(diffMs) < cutoffMs) return getRelativeTimestamp(diffMs, relativeOptions);
    else return "".concat(absolutePrefix, "on ").concat((0,format/* default */.Z)(date, absoluteFormat, absoluteOptions));
};
var today = new Date();
today.setHours(0, 0, 0, 0);
function addTime(format, time, adjustments, timeFormat) {
    var timeAsDate = typeof time === "string" ? (0,parse/* default */.Z)(time, timeFormat, today) : time;
    if (adjustments.hour) {
        timeAsDate = (0,addHours/* default */.Z)(timeAsDate, adjustments.hour);
    }
    if (adjustments.min) {
        timeAsDate = (0,esm_addMinutes/* default */.Z)(timeAsDate, adjustments.min);
    }
    if (adjustments.sec) {
        timeAsDate = (0,addSeconds/* default */.Z)(timeAsDate, adjustments.sec);
    }
    return typeof time === "string" ? format(timeAsDate, timeFormat) : timeAsDate;
}
function timeGreaterThan(format, time, timeThatShouldBeLessThen, byAtLeast) {
    var timeFormat = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "TIME_FORMAT";
    if (!time) return false;
    if (!timeThatShouldBeLessThen) return true;
    var timeAsDate = typeof time === "string" ? (0,parse/* default */.Z)(time, timeFormat, today) : time;
    var timeThatShouldBeLessThenAsDate = typeof timeThatShouldBeLessThen === "string" ? (0,parse/* default */.Z)(timeThatShouldBeLessThen, timeFormat, today) : timeThatShouldBeLessThen;
    var adjustedTimeThatShouldBeLessThenAsDate = timeThatShouldBeLessThenAsDate;
    if (byAtLeast) adjustedTimeThatShouldBeLessThenAsDate = addTime(format, timeThatShouldBeLessThenAsDate, byAtLeast, timeFormat);
    return timeAsDate >= adjustedTimeThatShouldBeLessThenAsDate;
}
function isValid(d) {
    if (!d) return false;
    return Object.prototype.toString.call(d) === "[object Date]" && (0,_instanceof/* default */.Z)(d, Date) && !isNaN(d.getTime());
}
function getDatesArray(start, end) {
    for(var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)){
        arr.push(new Date(dt));
    }
    return arr;
}
function localTimeToMin(localtimeString) {
    var parts = localtimeString.split(":"); // split it at the colons
    // Hours are worth 60 minutes.
    return +parts[0] * 60 + +parts[1];
}
function minTolocalTime(mins) {
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    return "".concat(h < 10 ? "0" + h : h, ":").concat(m < 10 ? "0" + m : m, ":00");
}
/**
 * Parse a formatted date used in route params (yyyy-MM-dd)
 *
 * @param str formatted date
 * @returns date if parsable, otherwise undefined
 */ function parseRouteDate(str) {
    if (!str) return undefined;
    switch(str.trim()){
        case "today":
            return (0,startOfDay/* default */.Z)(new Date());
        case "yesterday":
            return (0,startOfDay/* default */.Z)((0,esm_add/* default */.Z)(new Date(), {
                days: -1
            }));
        case "tomorrow":
            return (0,startOfDay/* default */.Z)((0,esm_add/* default */.Z)(new Date(), {
                days: 1
            }));
    }
    // Try newer date format first
    try {
        var parsedDate = (0,parse/* default */.Z)(str, "yyyy-MM-dd", new Date());
        if (!isNaN(parsedDate.getTime())) return parsedDate;
    } catch (err) {
        console.warn("Failed to parse query param date", str);
    }
    // Fallback to legacy date format
    try {
        var parsedDate1 = (0,parse/* default */.Z)(str, "MM-dd-yyyy", new Date());
        if (!isNaN(parsedDate1.getTime())) return parsedDate1;
    } catch (err1) {
        console.warn("Failed to parse legacy query param date", str);
    }
    // Give up, record an error and return undefined
    console.error("Failed to parse query param date", str);
}
function snap(date, range, weekStartsOn) {
    switch(range){
        case "CHUNK":
            throw Error("Not implemented");
        case "DAY":
            return {
                start: (0,startOfDay/* default */.Z)(date),
                end: (0,esm_endOfDay/* default */.Z)(date)
            };
        case "WEEK":
            return {
                start: (0,startOfDay/* default */.Z)((0,startOfWeek/* default */.Z)(date, {
                    weekStartsOn: weekStartsOn
                })),
                end: (0,esm_endOfDay/* default */.Z)((0,endOfWeek/* default */.Z)(date, {
                    weekStartsOn: weekStartsOn
                }))
            };
        case "MONTH":
            return {
                start: (0,startOfDay/* default */.Z)((0,startOfMonth/* default */.Z)(date)),
                end: (0,esm_endOfDay/* default */.Z)((0,endOfMonth/* default */.Z)(date))
            };
    }
}
function roundTimeToChunk(time) {
    var timeToReturn = new Date(time);
    timeToReturn.setMilliseconds(Math.round(timeToReturn.getMilliseconds() / 1000) * 1000);
    timeToReturn.setSeconds(Math.round(timeToReturn.getSeconds() / 60) * 60);
    timeToReturn.setMinutes(Math.round(timeToReturn.getMinutes() / 15) * 15);
    return timeToReturn;
}
function roundTimeToNextChunk(time) {
    var timeToReturn = new Date(time);
    // If 8:00:xx pick 8:00:00 to match backend.
    timeToReturn.setSeconds(0, 0);
    timeToReturn.setMinutes(Math.ceil(timeToReturn.getMinutes() / 15) * 15);
    return timeToReturn;
}
// TODO (IW): This is a dup, remove in favor of `DayOfWeekIndex`
function dayOfWeekToNumber(day) {
    return DAYS_OF_WEEK.indexOf(day);
}
/**
 * Shifts date using `utcToZonedTime` into current timezone, but also makes `tz` optional so it's easy to make it optional in other utility functions
 * @param date The date to shift
 * @param tz The timezone
 * @returns A shifted date
 */ var shiftDateToTz = function(date, tz) {
    return tz ? (0,date_fns_tz.utcToZonedTime)(date, tz) : date;
};
/**
 * Shifts date using `zonedTimeToUtc` into current timezone, but also makes `tz` optional so it's easy to make it optional in other utility functions
 * @param date The date to shift
 * @param tz The timezone
 * @returns A shifted date
 */ var unShiftDateToTz = function(date, tz) {
    return tz ? (0,date_fns_tz.zonedTimeToUtc)(date, tz) : date;
};
/**
 * Gets the milliseconds since day start of the day as indicated by the hour of the day (on daylight savings day you'll lose an hour at 2AM using this function - that's by design).
 * @param date The date to read from
 * @returns milliseconds into the day
 */ var getApparentMsSinceStartOfDay = function(date, tz) {
    var tzDate = shiftDateToTz(date, tz);
    return tzDate.getHours() * MILLISECONDS_PER_HOUR + tzDate.getMinutes() * MILLISECONDS_PER_MINUTE + tzDate.getSeconds() * MILLISECONDS_PER_SECOND + tzDate.getMilliseconds();
};
var getDayOfWeekFromDate = function(date, tz) {
    return [
        Calendars/* DayOfWeek.Sunday */.eO.Sunday,
        Calendars/* DayOfWeek.Monday */.eO.Monday,
        Calendars/* DayOfWeek.Tuesday */.eO.Tuesday,
        Calendars/* DayOfWeek.Wednesday */.eO.Wednesday,
        Calendars/* DayOfWeek.Thursday */.eO.Thursday,
        Calendars/* DayOfWeek.Friday */.eO.Friday,
        Calendars/* DayOfWeek.Saturday */.eO.Saturday, 
    ][getDay_getDay(shiftDateToTz(date, tz))];
};
var getDayOfWeekStrFromDate = function(date, tz) {
    return DAYS_OF_WEEK[getDay(shiftDateToTz(date, tz))];
};
var localTimeToMinute = function(localTime) {
    var ref = _sliced_to_array(localTime.trim().split(":").map(function(s) {
        return Number.parseInt(s);
    }), 2), hrs = ref[0], mins = ref[1];
    return 60 * hrs + mins;
};
function strToDate(dateString) {
    if (!dateString) return;
    // Default JS parsing
    var parsedDate = new Date(dateString);
    if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
    }
    // Time
    parsedDate = (0,parse/* default */.Z)(dateString, "HH:mm:ss", new Date());
    if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
    }
    // US date
    parsedDate = (0,parse/* default */.Z)(dateString, "MM/dd/yyyy", new Date());
    if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
    }
    // SQL date
    parsedDate = (0,parse/* default */.Z)(dateString, "yyyy-MM-dd", new Date());
    if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
    }
    console.error("Error parsing string to a valid date", dateString);
    return;
}
/**
 * Convenient inverse of `strToDate` so we don't have to think about serializing dates
 *
 * @param date
 * @returns ISO date string the backend expects
 */ var dateToStr = function(date) {
    if (!date) return;
    return date.toISOString();
};
function isRangeNow(start, end) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Date();
    return !!start && !!end && (typeof start === "string" ? strToDate(start) : start) <= now && (typeof end === "string" ? strToDate(end) : end) >= now;
}
function isRangeAllDay(start, end) {
    return (0,differenceInHours/* default */.Z)(end, start) >= 24;
}
function getDatesBetween(start, end) {
    var dates = [];
    var currentDate = start;
    while(currentDate <= end){
        dates.push(currentDate);
        currentDate = add(currentDate, {
            days: 1
        });
    }
    return dates;
}
var startOfDayInTz = function(date, tz) {
    return unShiftDateToTz((0,startOfDay/* default */.Z)(date), tz);
};
var endOfDayInTz = function(date, tz) {
    return unShiftDateToTz(endOfDay(date), tz);
};
var isSameDayInTz = function(d1, d2, tz) {
    return startOfDayInTz(d1, tz).getTime() === startOfDayInTz(d2, tz).getTime();
};
function countPerDay(items) {
    return items.reduce(function(acc, item) {
        var days = getDatesBetween(item.start, item.end);
        days.forEach(function(day) {
            if (!acc[day.toDateString()]) {
                acc[day.toDateString()] = 0;
            }
            ++acc[day.toDateString()];
        });
        return acc;
    }, {});
}
/**
 * Returns true if date is within 15 minutes from now or earlier.
 */ var isDateNowOrEarlier = function(date) {
    return date < (0,esm_addMinutes/* default */.Z)(new Date(), 15);
};
var isDateNowOrEarlierThisWeek = function(date) {
    return date.getTime() < addMinutes(new Date(), 15).getTime() && date.getTime() > addDays(new Date(), -7).getTime();
};
var isDateNowish = function(date) {
    var now = new Date();
    return date < (0,esm_addMinutes/* default */.Z)(now, 15) && date > (0,esm_addMinutes/* default */.Z)(now, -15);
};
var isDateToday = function(date) {
    var today = new Date();
    return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear();
};
var getDaysOfWeekFromDateSpan = function(start, end, tz, bounds) {
    var _start = startOfDayInTz(start, tz);
    var _end = startOfDayInTz(end, tz);
    var days = [];
    while(_start.getTime() <= _end.getTime()){
        if (!bounds || (0,isWithinInterval/* default */.Z)(_start, bounds)) {
            days.push(getDayOfWeekFromDate(_start));
        }
        _start = (0,esm_add/* default */.Z)(_start, {
            days: 1
        });
    }
    return days;
};
var getLatestMinuteInterval = function(date) {
    var interval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 15;
    var lastInterval = new Date(date.getTime());
    lastInterval.setMinutes(0, 0, 0); // Start of the hour for provided date
    var getLastInterval = function() {
        if (lastInterval.getTime() + interval * 60000 < date.getTime()) {
            lastInterval = new Date(lastInterval.getTime() + interval * 60000);
            getLastInterval();
        }
    };
    // increase by interval until closest time is reached
    getLastInterval();
    return lastInterval;
};
var HHMMSS_REGEX = /(\d+):(\d+)(?::(\d+))?/;
var YYYYMMDD_REGEX = /(\d\d\d\d)-(\d\d)-(\d\d)/;
/**
 * Gets a `YYYYMMDD` from primitives
 * @param year The year
 * @param month The month
 * @param day The day
 * @returns A `YYYYMMDD`
 */ var makeYyyyMmDd = function(year, month, day) {
    return "".concat((0,numbers/* addLeadingZeroes */.Ni)(year, 4), "-").concat((0,numbers/* addLeadingZeroes */.Ni)(month, 2), "-").concat((0,numbers/* addLeadingZeroes */.Ni)(day, 2));
};
/**
 * Gets a `YYYYMMDD` from a `Date`
 * @param date The date
 * @returns A `YYYYMMDD`
 */ var dateToYyyyMmDd = function(date) {
    return makeYyyyMmDd(date.getFullYear(), date.getMonth() + 1, date.getDate());
};
/**
 * Gets the year, day, month as a number from a `YYYMMDD` date
 * @param yyyyMmDd The date to get the month from
 * @returns A tuple of year, month, day - month and day are 1-indexed (January = 1, frist day of month = 1)
 */ var destructureYyyMmDd = function(yyyyMmDd) {
    var ref = (0,src_sliced_to_array/* default */.Z)(yyyyMmDd.match(YYYYMMDD_REGEX) || [], 4), yearStr = ref[1], monthStr = ref[2], dayStr = ref[3];
    if (!yearStr) throw new Error("Could not find year in date: ".concat(yyyyMmDd));
    if (!monthStr) throw new Error("Could not find month in date: ".concat(yyyyMmDd));
    if (!dayStr) throw new Error("Could not find day in date: ".concat(yyyyMmDd));
    var yearNum = Number(yearStr);
    var monthNum = Number(monthStr);
    var dayNum = Number(dayStr);
    if (isNaN(yearNum)) throw new Error("Could not parse year in date: ".concat(yyyyMmDd));
    if (isNaN(monthNum)) throw new Error("Could not parse month in date: ".concat(yyyyMmDd));
    if (isNaN(dayNum)) throw new Error("Could not parse day in date: ".concat(yyyyMmDd));
    return [
        yearNum,
        monthNum,
        dayNum
    ];
};
/**
 * Gets a date object from a `YYYYMMDD`
 * @param yyyyMmDd The date represented in `YYYYMMDD` format
 * @returns A new date object
 */ var yyyyMmDdToDate = function(yyyyMmDd) {
    var ref = (0,src_sliced_to_array/* default */.Z)(destructureYyyMmDd(yyyyMmDd), 3), year = ref[0], month = ref[1], day = ref[2];
    return new Date(year, month - 1, day);
};
var getTomorrowAtHour = function(hour) {
    var tomorrow = startOfTomorrow();
    tomorrow.setHours(hour, 0, 0, 0);
    return tomorrow;
};
var formatTz = function(timeZone, format) {
    return (0,date_fns_tz.format)(new Date(), format, {
        timeZone: timeZone
    });
};
/**
 * Get Weekdays Starting At Index
 * @param weekday The weekday number.
 *
 * accordingly to google's settings:
 * zero = sunday
 * one = monday
 * six = saturday
 *
 * @return DayOfWeek[]
 */ var getWeekdaysStartingAtIndex = function(weekday) {
    var days = [
        Calendars/* DayOfWeek.Sunday */.eO.Sunday
    ].concat((0,_to_consumable_array/* default */.Z)(Calendars/* Weekdays */.oN), [
        Calendars/* DayOfWeek.Saturday */.eO.Saturday
    ]);
    var weekSplit = days.splice(0, weekday);
    return (0,_to_consumable_array/* default */.Z)(days).concat((0,_to_consumable_array/* default */.Z)(weekSplit));
};
/**
 *  Get the total hours in the provided time policy
 */ var getTotalHoursInTimePolicy = function(timePolicy) {
    var hours = 0;
    var ref = (0,startOfDay/* default */.Z)(new Date());
    Calendars/* AllDays.forEach */.lK.forEach(function(day) {
        var ref1, ref2;
        (ref1 = timePolicy.dayHours[day]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.intervals) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(i) {
            var start = (0,parse/* default */.Z)(i.start, TimeFormatHours, ref);
            var end = (0,parse/* default */.Z)(i.end, TimeFormatHours, ref);
            if (!!start && !!end) {
                hours += (0,differenceInHours/* default */.Z)(end, start);
            }
        });
    });
    return hours;
};
/**
 * Returns a formatted map of a TimePolicy:
 * { MONDAY: ["9am - 9:30am", "10:30am - 1pm", ...], ... }
 */ var timePolicyToHourDetailDays = function(days, timePolicy, format, shortenTime) {
    var data = {};
    var ref = (0,startOfDay/* default */.Z)(new Date());
    days.forEach(function(day) {
        var ref1, ref2;
        if (!!((ref1 = timePolicy.dayHours[day]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.intervals) === null || ref2 === void 0 ? void 0 : ref2.length)) {
            var ref3;
            (ref3 = timePolicy.dayHours[day]) === null || ref3 === void 0 ? void 0 : ref3.intervals.forEach(function(i) {
                var start = (0,parse/* default */.Z)(i.start, TimeFormatHours, ref);
                var end = (0,parse/* default */.Z)(i.end, TimeFormatHours, ref);
                if (!!start && !!end) {
                    var ref1;
                    if (!data[day]) {
                        data[day] = [];
                    }
                    var startFormatted = format(start, "TIME_DISPLAY_FORMAT");
                    var endFormatted = format(end, "TIME_DISPLAY_FORMAT");
                    (ref1 = data[day]) === null || ref1 === void 0 ? void 0 : ref1.push(!!shortenTime ? "".concat(shortenTime(startFormatted), " - ").concat(shortenTime(endFormatted)) : "".concat(startFormatted, " - ").concat(endFormatted));
                }
            });
        }
    });
    return data;
};
var PARSE_DURATION_REGEX = /\[?(\d*[.,]?\d+)\s?(minute(?:s)?|min|mn|m|second(?:s)?|sec|s|h(?:ou)?r(?:s)?|h|day(?:s)?|d|w(?:ee)?k(?:s)?|w)]?/gi;
/**
 * Parses a string into milliseconds.
 * @param value The string duration
 * @returns the duration in ms
 */ function parseDuration(value, defaults) {
    var stringToParse = value.toLowerCase();
    if (!!(defaults === null || defaults === void 0 ? void 0 : defaults.length)) {
        stringToParse = stringToParse.trim();
        if (/^\d+$/.test(stringToParse)) {
            var def = defaults.find(function(d) {
                return parseInt(stringToParse) <= d[0];
            });
            if (!!def) {
                stringToParse = "".concat(stringToParse, " ").concat(def[1]);
            }
        }
    }
    var matches = stringToParse.matchAll(PARSE_DURATION_REGEX);
    var match = matches.next();
    var duration = 0;
    while(!match.done){
        var num = parseFloat(match.value[1].replace(/,/g, "."));
        if (typeof num !== "number" || isNaN(num)) return;
        if (typeof num === "number" && num <= 0) return;
        var unit = match.value[2];
        switch(unit[0]){
            case "w":
                duration += num * MILLISECONDS_PER_WEEK;
                break;
            case "d":
                duration += num * MILLISECONDS_PER_DAY;
                break;
            case "m":
                duration += num * MILLISECONDS_PER_MINUTE;
                break;
            case "s":
                duration += num * MILLISECONDS_PER_SECOND;
                break;
            case "h":
            default:
                // Assume unit is a hour
                duration += num * MILLISECONDS_PER_HOUR;
                break;
        }
        match = matches.next();
    }
    return duration > 0 ? duration : undefined;
}
/* harmony default export */ var dates = ({
    isValid: isValid,
    durationStr: durationStr,
    durationBetweenStr: durationBetweenStr,
    byDayOfWeek: byDayOfWeek,
    timeGreaterThan: timeGreaterThan,
    addTime: addTime
});
var parseDateStringToDate = function(value, refDate, options) {
    if (!value) return undefined;
    return (0,esm/* parseDate */.sG)(value, refDate, options);
};
var parseDateStringWithDisabledPast = function(value, refDate, options) {
    var parsed = parseDateStringToDate(value);
    // If the non-forwarded date is in the past and within the current month return now.
    if (parsed && parsed.getTime() < Date.now() && (0,isSameMonth/* default */.Z)(new Date(), parsed)) {
        return new Date();
    } else {
        // Otherwise continue with the jump forward in time.
        return parseDateStringToDate(value, refDate, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
            forwardDate: true
        }));
    }
};
var isHHMMSS = function(str) {
    return !!str.match(HHMMSS_REGEX);
};
var isYYYYMMSS = function(str) {
    return !!str.match(YYYYMMDD_REGEX);
};
function parseHHMMSS(timeString) {
    var match = timeString.match(HHMMSS_REGEX);
    if (!match) throw new Error('Failed to parse TimeString string "'.concat(timeString, '"'));
    var _match = (0,src_sliced_to_array/* default */.Z)(match, 4), h = _match[1], m = _match[2], s = _match[3];
    return s ? [
        parseInt(h),
        parseInt(m),
        parseInt(s)
    ] : [
        parseInt(h),
        parseInt(m),
        0
    ];
}
function dateToHHMM(date, seconds) {
    var hhmm = "".concat((0,numbers/* addLeadingZeroes */.Ni)(date.getHours(), 2), ":").concat((0,numbers/* addLeadingZeroes */.Ni)(date.getMinutes(), 2));
    return seconds ? "".concat(hhmm, ":").concat((0,numbers/* addLeadingZeroes */.Ni)(date.getSeconds(), 2)) : hhmm;
}
var msInHHMMSS = function(timeString) {
    var ref = (0,src_sliced_to_array/* default */.Z)(parseHHMMSS(timeString), 3), h = ref[0], m = ref[1], s = ref[2];
    return h * MILLISECONDS_PER_HOUR + m * MILLISECONDS_PER_MINUTE + (typeof s === "number" ? s * MILLISECONDS_PER_SECOND : 0);
};
var yyyyMmDdHhMmSsToDate = function(date, time) {
    var ref = (0,src_sliced_to_array/* default */.Z)(parseHHMMSS(time), 3), hours = ref[0], minutes = ref[1], seconds = ref[2];
    var d = yyyyMmDdToDate(date);
    d.setHours(hours);
    d.setMinutes(minutes);
    d.setSeconds(seconds);
    return d;
};
/**
 * Determines the index of the startOfWeek parameter using Sunday as index 0 in order to align with the native Date object's toDay fn
 * @param startOfWeek the user's startOfWeek
 * @returns the index of the startOfWeek parameter
 */ var getDayOfWeekIndex = function() {
    var startOfWeek = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "SUNDAY";
    var daysOfWeek = [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY"
    ];
    return daysOfWeek.indexOf(startOfWeek);
};
var distanceToPrevStartOfWeek = function(param) {
    var _startOfWeek = param.startOfWeek, startOfWeek = _startOfWeek === void 0 ? "SUNDAY" : _startOfWeek, _now = param.now, now = _now === void 0 ? new Date() : _now;
    var startOfWeekAsDayOfWeek = getDayOfWeekIndex(startOfWeek);
    var currentDayOfWeek = now.getDay();
    return (7 + currentDayOfWeek - startOfWeekAsDayOfWeek) % 7;
};
var getWeeksAgo = function(n) {
    var startOfWeek = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "SUNDAY", now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Date();
    var diff = distanceToPrevStartOfWeek({
        startOfWeek: startOfWeek
    });
    return (0,esm_addDays/* default */.Z)(now, -(diff + 7 * n));
};
/**
 * Strips leading zeroes off the short date format (eg 01/09 -> 1/9)
 * @param value mm/dd or dd/mm string
 * @returns shortened date string
 */ var shortenMonthDayString = function(value) {
    return value.replace(/\b0/g, "");
};
/**
 * if am-am or pm-pm, show am/pm once Ex: 8-8:30am, 2-2:30pm
 */ var getShortenedTimeSpanDisplay = function(start, end, format, trimCallback) {
    var startHour = start.getHours();
    var endHour = end.getHours();
    var startDisplay = format(start, (0,isSameDay/* default */.Z)(start, end) && (endHour < 12 || startHour >= 12) ? "SHORT_TIME_DISPLAY_FORMAT" : "TIME_DISPLAY_FORMAT");
    var endDisplay = format(end, "TIME_DISPLAY_FORMAT");
    if (trimCallback) {
        startDisplay = trimCallback(startDisplay);
        endDisplay = trimCallback(endDisplay);
    }
    return "".concat(startDisplay, " - ").concat(endDisplay);
};


/***/ }),

/***/ 46734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ isDescendantOfEl; },
/* harmony export */   "RX": function() { return /* binding */ getActiveScrollParent; },
/* harmony export */   "SG": function() { return /* binding */ isDescendant; },
/* harmony export */   "aX": function() { return /* binding */ onChildWindowClose; },
/* harmony export */   "m8": function() { return /* binding */ findNearestParent; },
/* harmony export */   "q": function() { return /* binding */ escapeForHTML; }
/* harmony export */ });
/* unused harmony exports preventPropagation, getOffsetRelativeToElemeent, getLocalOffset */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var escapeForHTML = function(str) {
    var d = document.createElement("div");
    d.textContent = str;
    return d.innerHTML;
};
function isDescendant(parent, child) {
    if (!child) return false;
    // @ts-ignore
    var node = child.parentNode;
    while(node != null && node.tagName !== "document"){
        var ref;
        if ((ref = node.className) === null || ref === void 0 ? void 0 : ref.split(" ").includes(parent)) {
            return true;
        }
        // @ts-ignore
        node = node.parentNode;
    }
    return false;
}
function isDescendantOfEl(parent, child) {
    var node = child.parentNode;
    while(node !== null){
        if (node === parent) return true;
        node = node.parentNode;
    }
    return false;
}
function findNearestParent(element, selector) {
    if (element.matches(selector)) return element;
    if (element.parentElement) return findNearestParent(element.parentElement, selector);
    return undefined;
}
function getActiveScrollParent(node) {
    if (node === null) {
        return null;
    }
    if (node.scrollHeight > node.clientHeight && node.offsetHeight && node.scrollTop !== 0) {
        return node;
    } else {
        return !!node.parentNode ? getActiveScrollParent(node.parentNode) : null;
    }
}
var preventPropagation = function(e) {
    e.preventDefault();
    e.stopPropagation();
};
/**
 * Waits for a child window to close via polling.
 * @param w The window to poll for
 * @param onClose A callback to call on close
 * @param pollInterval the time between pollings
 * @returns A function to stop polling
 */ var onChildWindowClose = function(w, onClose) {
    var pollInterval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 500;
    var timer;
    var stopPolling = function() {
        return clearTimeout(timer);
    };
    var continuePolling = function() {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        timer = setTimeout(timerCb, pollInterval);
    };
    var timerCb = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!w) return [
                            3,
                            1
                        ];
                        stopPolling();
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!w.closed) return [
                            3,
                            3
                        ];
                        stopPolling();
                        return [
                            4,
                            onClose()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        continuePolling();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function timerCb() {
            return _ref.apply(this, arguments);
        };
    }();
    continuePolling();
    return stopPolling;
};
/**
 * Gets a text offset in one element relative to a parent element.
 * @param relativeElement The element to find the cursor position relative to
 * @param immediateParentNode The immediate parent of the cursor
 * @param offsetInParentNode The offset of the cursor in `immediateParentNode`
 * @param totalOffset USED ONLY FOR RECURSION.  DO NOT USE THIS PROPERTY.
 * @returns A number representing the offset relative to the parent element or `undefined` if the cursor position could not be found.
 */ function getOffsetRelativeToElemeent(relativeElement, immediateParentNode, offsetInParentNode) {
    var totalOffset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var foundOffset = !Array.from(relativeElement.childNodes).every(function(n) {
        if (n === immediateParentNode) {
            totalOffset += offsetInParentNode;
            return false;
        } else {
            var ref;
            var textLength = ((ref = n.textContent) === null || ref === void 0 ? void 0 : ref.length) || 0;
            switch(n.nodeType){
                case 1:
                    var newTotalOffset = getOffsetRelativeToElemeent(n, immediateParentNode, offsetInParentNode, totalOffset);
                    if (newTotalOffset === undefined) {
                        totalOffset += textLength;
                        return true;
                    } else {
                        totalOffset = newTotalOffset;
                        return false;
                    }
                case 3:
                    totalOffset += textLength;
                    return true;
            }
        }
    });
    return foundOffset ? totalOffset : undefined;
}
/**
 * Gets the immediate parent node, and local text-offset given a parent node, and an offset from that parent node.
 * @param parentElement The enclosing parent element
 * @param totalOffset The total text-offset in `parentElement`
 * @returns The immediate parent node in which the offset ends, as well as the local offset in that node, or undefined if none can be found.
 */ function getLocalOffset(parentElement, totalOffset) {
    var ret;
    Array.from(parentElement.childNodes).every(function(n) {
        var ref;
        var textLength = ((ref = n.textContent) === null || ref === void 0 ? void 0 : ref.length) || 0;
        if (totalOffset < textLength) {
            ret = {
                node: n,
                offset: totalOffset
            };
            return false;
        } else {
            switch(n.nodeType){
                case 1:
                    var result = getLocalOffset(n, totalOffset);
                    if (result) {
                        ret = result;
                        return false;
                    } else {
                        totalOffset -= textLength;
                        return true;
                    }
                case 3:
                    totalOffset -= textLength;
                    return true;
            }
        }
    });
    return ret;
}


/***/ }),

/***/ 40673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ getGenericContactSupportErrorMessage; },
/* harmony export */   "dR": function() { return /* binding */ findErrorMessage; }
/* harmony export */ });
/* unused harmony exports getCallStack, stringFromError, catchWithMessage, catchWithMessageAsync */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ContactSupportButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8137);






/**
 * Gets the current call stack as an array of strings
 * @param options Options
 * @returns A call stack as an array of strings
 */ var getCallStack = function(options) {
    var ref;
    var trimMe = !(options === null || options === void 0 ? void 0 : options.error);
    var ref1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        includeJS: false,
        detail: "local",
        trimFrames: 0,
        error: new Error()
    }, options), includeJS = ref1.includeJS, detail = ref1.detail, trimFrames = ref1.trimFrames, error = ref1.error;
    var stack = ((ref = error.stack) === null || ref === void 0 ? void 0 : ref.split("\n")) || [];
    if (!includeJS) stack = stack.filter(function(l) {
        return /\.tsx?:\d+:\d+$/.test(l);
    });
    switch(detail){
        case "local":
            stack = stack.map(function(l) {
                return l.replace(/.+\/\/\//, "");
            });
            break;
        case "file":
            stack = stack.map(function(l) {
                return l.replace(/.+(?=\/)/, "");
            });
            break;
    }
    stack === null || stack === void 0 ? void 0 : stack.splice(0, trimMe ? trimFrames + 1 : trimFrames);
    return stack;
};
/**
 * Does its darndest an error message in an object of unkown type
 * @param error The error object
 * @param foundErrors **DO NOT USE** - only for recursion
 * @returns A string message representing the error object
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var findErrorMessage = function(error) {
    var foundErrors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set();
    try {
        var stack = getCallStack({
            trimFrames: foundErrors.size * 2 + 1
        }).join("\n");
        if (typeof error === "object" && foundErrors.has(error)) return "\n\n**** Found recursive object ****";
        foundErrors.add(error);
        if (!error) return "Empty error:\n".concat(stack);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(error, Error)) return stringFromError(error, foundErrors);
        if (typeof error === "string") return "".concat(error, ":\n").concat(stack);
        if (error.message) return findErrorMessage(error.message, foundErrors);
        if (error.error) return findErrorMessage(error.error, foundErrors);
        try {
            return JSON.stringify(error);
        } catch (e1) {
            try {
                return error.toString();
            } catch (e) {
                return "".concat(error);
            }
        }
    } catch (e2) {
        return "\n\n**** Failed to find error message: ".concat(e2, " ****");
    }
};
/**
 * Turns an error into a string with a call stack and "caused by" details
 * @param error The error
 * @param foundErrors **DO NOT USE** - only for recursion
 * @returns A string message
 */ var stringFromError = function(error, foundErrors) {
    return error.toString() + "\n".concat(getCallStack({
        error: error
    }).join("\n")) + (error.cause ? "\n\n--------------\n| caused by: |\n--------------\n\n".concat(findErrorMessage(error.cause, foundErrors)) : "");
};
var catchWithMessage = function(doTry, doCatch) {
    try {
        doTry();
    } catch (e) {
        doCatch(e, findErrorMessage(e));
    }
};
var catchWithMessageAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(doTry, doCatch) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        doTry()
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    doCatch(e, findErrorMessage(e));
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function catchWithMessageAsync(doTry, doCatch) {
        return _ref.apply(this, arguments);
    };
}();
var getGenericContactSupportErrorMessage = function(message, lead) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            message,
            ". Please",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactSupportButton__WEBPACK_IMPORTED_MODULE_1__/* .ContactSupportButton */ .u, {
                variant: "link",
                lead: lead,
                children: "contact support"
            }),
            " ",
            "if this problem persists."
        ]
    });
};


/***/ }),

/***/ 43835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L0": function() { return /* binding */ parseEventKey; },
/* harmony export */   "RZ": function() { return /* binding */ getUpcomingFakeEvent; },
/* harmony export */   "bQ": function() { return /* binding */ getEffectiveRecurrence; },
/* harmony export */   "yG": function() { return /* binding */ getAssignmentIdAndType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58545);
/* harmony import */ var _reclaim_api_EventMetaTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90109);
/* harmony import */ var _reclaim_api_Events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91500);
/* harmony import */ var _reclaim_api_OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70282);
/* harmony import */ var _dates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26958);






function parseEventKey(eventKey) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(eventKey.match(/^(\d+)\/(.+)$/) || [], 3), calendarIdStr = ref[1], eventId = ref[2];
    var calendarId = parseInt(calendarIdStr);
    if (!calendarIdStr || isNaN(calendarId) || !eventId) throw new Error("Invalid eventKey format: ".concat(eventKey));
    return {
        calendarId: calendarId,
        eventId: eventId
    };
}
function getEffectiveRecurrence(recurrence, timesPerPeriod) {
    if (!recurrence) {
        if (timesPerPeriod === 7) return _reclaim_api_OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__/* .Recurrence.Daily */ .Vy.Daily;
        else return _reclaim_api_OneOnOnes_types__WEBPACK_IMPORTED_MODULE_2__/* .Recurrence.Weekly */ .Vy.Weekly;
    }
    return recurrence;
}
var getAssignmentIdAndType = function(event) {
    var ref, ref1;
    if (!!((ref = event.assist) === null || ref === void 0 ? void 0 : ref.dailyHabitId)) {
        if ((event === null || event === void 0 ? void 0 : event.reclaimEventType) === _reclaim_api_Events__WEBPACK_IMPORTED_MODULE_1__/* .ReclaimEventType.OneOnOneAssignment */ .$q.OneOnOneAssignment) {
            var ref2;
            return {
                assignmentId: (ref2 = event.assist) === null || ref2 === void 0 ? void 0 : ref2.dailyHabitId,
                type: "one-on-one"
            };
        } else {
            return {
                assignmentId: event.assist.dailyHabitId,
                type: "habit"
            };
        }
    } else if (event.reclaimEventType === _reclaim_api_Events__WEBPACK_IMPORTED_MODULE_1__/* .ReclaimEventType.SchedulingLinkAssignment */ .$q.SchedulingLinkAssignment) {
        return {
            assignmentId: event.schedulingLinkMeetingId,
            type: "scheduling-link-meeting"
        };
    } else if (!!(event === null || event === void 0 ? void 0 : (ref1 = event.assist) === null || ref1 === void 0 ? void 0 : ref1.taskId)) {
        return {
            assignmentId: event.assist.taskId,
            type: "task"
        };
    } else {
        return {
            assignmentId: event.key,
            type: "event"
        };
    }
};
var getUpcomingFakeEvent = function(title, color) {
    return {
        title: title,
        color: color,
        eventStart: (0,_dates__WEBPACK_IMPORTED_MODULE_3__/* .roundTimeToNextChunk */ .qn)(new Date()),
        eventEnd: (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_dates__WEBPACK_IMPORTED_MODULE_3__/* .roundTimeToNextChunk */ .qn)(new Date()), 60),
        rsvpStatus: _reclaim_api_EventMetaTypes__WEBPACK_IMPORTED_MODULE_0__/* .EventResponseStatus.Accepted */ .PI.Accepted,
        status: _reclaim_api_Events__WEBPACK_IMPORTED_MODULE_1__/* .EventStatus.Published */ .N3.Published,
        key: "fakeKey",
        reclaimEventType: _reclaim_api_Events__WEBPACK_IMPORTED_MODULE_1__/* .ReclaimEventType.Sync */ .$q.Sync,
        category: _reclaim_api_EventMetaTypes__WEBPACK_IMPORTED_MODULE_0__/* .PrimaryCategory.ExternalMeeting */ .CU.ExternalMeeting,
        eventId: "fakeEventId"
    };
};


/***/ }),

/***/ 63237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ hasError; }
/* harmony export */ });
/* unused harmony export hasErrorDescriptive */
function hasError(form) {
    return Object.keys(form.formState.errors).length !== 0;
}
function hasErrorDescriptive(form) {
    return Object.keys(form.formState.errors).length === 0 ? false : form.formState.errors;
}


/***/ }),

/***/ 91325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ getLocalStorage; },
/* harmony export */   "G": function() { return /* binding */ getSessionStorage; },
/* harmony export */   "VV": function() { return /* binding */ removeSessionStorage; },
/* harmony export */   "dZ": function() { return /* binding */ removeLocalStorage; },
/* harmony export */   "qQ": function() { return /* binding */ setLocalStorage; },
/* harmony export */   "t_": function() { return /* binding */ setSessionStorage; }
/* harmony export */ });
function getLocalStorage(key, defaultValue) {
    if (typeof localStorage === "undefined") return defaultValue;
    var value = localStorage.getItem(key);
    if (null === value) return defaultValue;
    try {
        return JSON.parse(value);
    } catch (error) {
        console.warn("Unexpected localStorage value", key, value);
        return value;
    }
}
function removeLocalStorage(key) {
    return localStorage.removeItem(key);
}
function setLocalStorage(key, value) {
    return undefined !== value && null !== value ? localStorage.setItem(key, JSON.stringify(value)) : removeLocalStorage(key);
}
function getSessionStorage(key, defaultValue) {
    if (typeof sessionStorage === "undefined") return defaultValue;
    var value = sessionStorage.getItem(key);
    if (null === value) return defaultValue;
    try {
        return JSON.parse(value);
    } catch (error) {
        console.warn("Unexpected sessionStorage value", key, value);
        return value;
    }
}
function removeSessionStorage(key) {
    return sessionStorage.removeItem(key);
}
function setSessionStorage(key, value) {
    return undefined !== value && null !== value ? sessionStorage.setItem(key, JSON.stringify(value)) : removeSessionStorage(key);
}


/***/ }),

/***/ 71233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ mapTimes; }
/* harmony export */ });
/* unused harmony export forTimes */
var forTimes = function(times, cb) {
    for(var i = 0; i < times; i++)cb(i);
};
var mapTimes = function(times, cb) {
    var arr = [];
    forTimes(times, function(i) {
        return arr.push(cb(i));
    });
    return arr;
};


/***/ }),

/***/ 63139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ formatFloat; },
/* harmony export */   "Ni": function() { return /* binding */ addLeadingZeroes; },
/* harmony export */   "T7": function() { return /* binding */ roundToDecimalPlaces; },
/* harmony export */   "Wv": function() { return /* binding */ roundToChunk; },
/* harmony export */   "kE": function() { return /* binding */ isNumeric; }
/* harmony export */ });
/* unused harmony exports randomInt, isEven, isOdd */
/* harmony import */ var _strings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84467);

function randomInt(arg1, arg2) {
    var min, max;
    if (typeof arg2 === "number") {
        min = Math.min(arg1, arg2);
        max = Math.max(arg1, arg2);
    } else {
        min = Math.min(arg1, 0);
        max = Math.max(arg1, 0);
    }
    min = Math.ceil(min);
    max = Math.floor(max);
    return min + Math.floor(Math.random() * (max - min + 1));
}
/**
 * Round a number to the nearest chunk
 * @param num The number to round
 * @param chunkSize The size of the chunk
 * @param options Options!
 * @returns A rounded number
 */ var roundToChunk = function(num, chunkSize) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _minChunkCutoff = options.minChunkCutoff, minChunkCutoff = _minChunkCutoff === void 0 ? 1 : _minChunkCutoff;
    if (num <= minChunkCutoff * chunkSize) return num;
    return Math.round(num / chunkSize) * chunkSize;
};
function formatFloat(decimal, places) {
    if (isNaN(decimal)) return 0;
    return Number.parseFloat("".concat(Math.round(Number.parseFloat("".concat(decimal, "e+").concat(places))), "e-").concat(places));
}
function isNumeric(str) {
    return /^-?\d+$/.test(str);
}
/**
 * Returns a string (or number if `numeric` is true) rounded to the specified number of decimals.
 * @param value The number to round
 * @param decimals The number of decimals to round to
 * @param options Additional options
 * @returns A string (or number) of `value` rounded to the specified decimal points
 */ var roundToDecimalPlaces = function(value, decimals) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var numeric = options.numeric, _lessThanOneDecimals = options.lessThanOneDecimals, lessThanOneDecimals = _lessThanOneDecimals === void 0 ? decimals : _lessThanOneDecimals;
    var useDecimals = value > -1 && value < 1 ? lessThanOneDecimals : decimals;
    var tensPlaces = Math.pow(10, useDecimals);
    var str = (Math.round(value * tensPlaces) / tensPlaces).toFixed(useDecimals);
    return numeric ? Number(str) : str;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ([
    formatFloat
]);
var addLeadingZeroes = function(num, minSize) {
    return (0,_strings__WEBPACK_IMPORTED_MODULE_0__/* .leftPadTo */ .Eb)("".concat(num), minSize, "0");
};
var isEven = function(num) {
    return Math.round(num / 2) === num / 2;
};
var isOdd = function(num) {
    return !isEven(num);
};


/***/ }),

/***/ 55748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ initiateOauth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82222);


var OAUTH_BASE_URI = "https://api.app.reclaim-staging.com/oauth";
function initiateOauth(integration, authPathOrState, state) {
    var authPath = "";
    switch(typeof authPathOrState === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(authPathOrState)){
        case "string":
            authPath = authPathOrState.replace(/^\//, "");
            break;
        case "object":
            state = authPathOrState;
    }
    authPath = authPath || "".concat(integration, "/init");
    state = state || {};
    var authUrl = new URL("".concat(OAUTH_BASE_URI, "/").concat(authPath, "/"));
    var redirect = "/settings/integrations/".concat(integration);
    authUrl.searchParams.append("state", JSON.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        redirect: redirect
    }, state)));
    window.location.href = authUrl.toString();
}


/***/ }),

/***/ 45110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ omit; },
/* harmony export */   "Db": function() { return /* binding */ indexMap; },
/* harmony export */   "FR": function() { return /* binding */ typedEntries; },
/* harmony export */   "Fv": function() { return /* binding */ normalize; },
/* harmony export */   "GA": function() { return /* binding */ mapToObject; },
/* harmony export */   "Gg": function() { return /* binding */ movePropsOver; },
/* harmony export */   "HO": function() { return /* binding */ removeEmpty; },
/* harmony export */   "NJ": function() { return /* binding */ typedValues; },
/* harmony export */   "Nw": function() { return /* binding */ typedKeys; },
/* harmony export */   "Xc": function() { return /* binding */ mapObject; },
/* harmony export */   "_B": function() { return /* binding */ evalOnce; },
/* harmony export */   "_p": function() { return /* binding */ walk; },
/* harmony export */   "hS": function() { return /* binding */ asyncMapObject; },
/* harmony export */   "i$": function() { return /* binding */ same; },
/* harmony export */   "jG": function() { return /* binding */ extantMap; },
/* harmony export */   "mt": function() { return /* binding */ extantNativeMap; },
/* harmony export */   "op": function() { return /* binding */ partialEquals; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "r$": function() { return /* binding */ patch; },
/* harmony export */   "vb": function() { return /* binding */ deepmerge; },
/* harmony export */   "vp": function() { return /* binding */ hash; }
/* harmony export */ });
/* unused harmony exports diff, resolveIdKeyOrFindId, intersection, pruneKeys, filterObject, filterObjectFalsy */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82222);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _arrays__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92886);









var deepmerge = lodash__WEBPACK_IMPORTED_MODULE_0__.merge;
function diff(a, b) {
    return Object.entries(b).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], val = _param[1];
        // include if types don't match
        if (!Object.prototype.hasOwnProperty.call(a, key) || (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(a[key]) !== (typeof val === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(val))) {
            acc[key] = val;
            return acc;
        }
        // include if array elements don't match
        if (Array.isArray(val)) {
            if (a[key].length !== val.length || !a[key].every(function(i) {
                return val.includes(i);
            }) || !val.every(function(i) {
                return a[key].includes(i);
            })) {
                acc[key] = val;
            }
            return acc;
        }
        // diff nested objects
        if (val !== null && typeof val === "object") {
            var obj = diff(a[key], val);
            if (Object.keys(obj).length) {
                acc[key] = obj;
            }
            return acc;
        }
        // include mismatched values
        if (a[key] !== val) acc[key] = val;
        return acc;
    }, {});
}
function same(a, b) {
    return !Object.keys(diff(a, b)).length;
}
function walk(path, obj) {
    if (!path || !obj) return undefined;
    return path.split(".").reduce(function(o, i) {
        return !!o && !!i ? o[i] : undefined;
    }, obj);
}
function patch(path, value) {
    return path.split(".").reverse().reduce(function(a, k) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, k, a);
    }, value);
}
function omit(keys, obj) {
    if (!(keys === null || keys === void 0 ? void 0 : keys.length)) return obj;
    return Object.entries(obj).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
        if (!keys.includes(k)) acc[k] = v;
        return acc;
    }, {});
}
var removeEmpty = function(obj) {
    Object.keys((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, obj)).forEach(function(key) {
        if (obj[key] && typeof obj[key] === "object") removeEmpty(obj[key]);
        else if (obj[key] === undefined) delete obj[key];
    });
    return obj;
};
function hash(obj) {
    if (!obj) return;
    return Array.from(JSON.stringify(obj)).reduce(function(s, c) {
        return Math.imul(31, s) + c.charCodeAt(0) | 0;
    }, 0);
}
function partialEquals(object, partialObject) {
    return Object.keys(partialObject).every(function(k1) {
        return partialObject[k1] === object[k1];
    });
}
function normalize(arr, idKeyOrFindId) {
    var findId = typeof idKeyOrFindId === "function" ? idKeyOrFindId : function(item) {
        return item[idKeyOrFindId];
    };
    return arr.reduce(function(acc, obj) {
        acc[findId(obj)] = obj;
        return acc;
    }, {});
}
function resolveIdKeyOrFindId(idKeyOrFindId) {
    if (!idKeyOrFindId) return function(item) {
        switch(typeof item === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(item)){
            case "string":
            case "number":
                return item;
            default:
                return "";
        }
    };
    else if (typeof idKeyOrFindId === "function") return idKeyOrFindId;
    else return function(item) {
        return item[idKeyOrFindId];
    };
}
function extantMap(arr, idKeyOrFindId) {
    var findId = resolveIdKeyOrFindId(idKeyOrFindId);
    return arr.reduce(function(acc, obj, i) {
        acc[findId(obj, i)] = true;
        return acc;
    }, {});
}
var extantNativeMap = function(arr) {
    return arr.reduce(function(map, obj, i) {
        map.set(obj, true);
        return map;
    }, new Map());
};
function indexMap(arr, idKeyOrFindId) {
    var findId = resolveIdKeyOrFindId(idKeyOrFindId);
    return arr.reduce(function(acc, obj, i) {
        acc[findId(obj, i)] = i;
        return acc;
    }, {});
}
function intersection(primary, intersector) {
    var newPrim = _object_spread({}, primary);
    Object.keys(primary).forEach(function(key) {
        if (!intersector[key]) delete newPrim[key];
    });
    return newPrim;
}
function pruneKeys(obj, keys) {
    return intersection(obj, extantMap(keys));
}
function movePropsOver(base, target) {
    // ehhhhhhh
    for(var prop in base)if (Object.prototype.hasOwnProperty.call(base, prop)) target[prop] = base[prop];
}
/**
 * The same as Object.keys but with strongly typed return
 * @param obj The object to get the keys of
 * @returns The keys of the object (strongly typed)
 */ var typedKeys = function(obj) {
    return Object.keys(obj);
};
/**
 * The same as Object.values but with strongly typed return
 * @param obj The object to get the values of
 * @returns The values of the object (strongly typed)
 */ var typedValues = function(obj) {
    return Object.values(obj);
};
/**
 * The same as Object.entries but with strongly typed return
 * @param obj The object to get the entries of
 * @returns The entries of the object (strongly typed)
 */ var typedEntries = function(obj) {
    return Object.entries(obj);
};
/**
 * Creates a function which returns a static value which is only evaulated on first call
 * @param factory A function which creates the object
 * @returns A function which returns the value
 */ var evalOnce = function(factory) {
    var val;
    return function() {
        if (val === undefined) val = factory();
        return val;
    };
};
/**
 * Creates an object by mapping over an array
 * @param arr The array to map over
 * @param cb A function which returns a [key, value] pair
 * @returns An object
 */ var mapToObject = function(arr, cb) {
    return arr.reduce(function(map, item, i) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(cb(item, i), 2), key = ref[0], value = ref[1];
        map[key] = value;
        return map;
    }, {});
};
function mapObject(obj, predicate) {
    return typedEntries(obj).reduce(function(acc, entry) {
        var res = predicate(entry);
        if (res) {
            var _res = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(res, 2), key = _res[0], value = _res[1];
            acc[key] = value;
        }
        return acc;
    }, {});
}
function filterObject(obj, predicate) {
    return typedEntries(obj).reduce(function(acc, entry) {
        if (predicate(entry)) {
            acc[entry[0]] = entry[1];
        }
        return acc;
    }, {});
}
function filterObjectFalsy(obj) {
    return filterObject(obj, function(param) {
        var _param = _sliced_to_array(param, 2), value = _param[1];
        return !!value;
    });
}
function asyncMapObject(obj, predicate) {
    return _asyncMapObject.apply(this, arguments);
}
function _asyncMapObject() {
    _asyncMapObject = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(obj, predicate) {
        var options, nonDeterminate, entries, promises, e, promise, out, e1, ret;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    nonDeterminate = options.nonDeterminate;
                    entries = typedEntries(obj);
                    if (!nonDeterminate) return [
                        3,
                        2
                    ];
                    promises = [];
                    for(e = 0; e < entries.length; e++){
                        promise = predicate(entries[e]);
                        promises.push(promise);
                    }
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    return [
                        2,
                        mapToObject.apply(void 0, [
                            _arrays__WEBPACK_IMPORTED_MODULE_1__/* .filterFalsy.apply */ .SY.apply(void 0, [
                                _state.sent()
                            ]),
                            function(param) {
                                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                                return [
                                    key,
                                    value
                                ];
                            }
                        ])
                    ];
                case 2:
                    out = {};
                    e1 = 0;
                    _state.label = 3;
                case 3:
                    if (!(e1 < entries.length)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        predicate(entries[e1])
                    ];
                case 4:
                    ret = _state.sent();
                    if (ret) out[ret[0]] = ret[1];
                    _state.label = 5;
                case 5:
                    e1++;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        2,
                        out
                    ];
            }
        });
    });
    return _asyncMapObject.apply(this, arguments);
}
var isPrimitive = function(thing) {
    switch(typeof thing === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(thing)){
        case "string":
        case "number":
        case "boolean":
        case "symbol":
        case "undefined":
            return true;
        case "object":
            return thing === null;
        default:
            return false;
    }
};


/***/ }),

/***/ 94423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ Browser; },
/* harmony export */   "Jv": function() { return /* binding */ platform; },
/* harmony export */   "Xh": function() { return /* binding */ browser; }
/* harmony export */ });
/* unused harmony exports OS, Platform */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52951);
// platform checks


var macos = [
    "Macintosh",
    "MacIntel",
    "MacPPC",
    "Mac68K"
];
var windows = [
    "Win32",
    "Win64",
    "Windows",
    "WinCE"
];
var ios = [
    "iPhone",
    "iPad",
    "iPod"
];
// user agent checks
var mobile = [
    "Mobile",
    "Mobile Safari",
    "IEMobile",
    "webOS",
    "Blackberry",
    "Opera Mini",
    "Opera Mobi"
];
var OS;
(function(OS) {
    OS[OS["MacOS"] = 0] = "MacOS";
    OS[OS["Windows"] = 1] = "Windows";
    OS[OS["Linux"] = 2] = "Linux";
    OS[OS["iOS"] = 3] = "iOS";
    OS[OS["Android"] = 4] = "Android";
    OS[OS["Unknown"] = 5] = "Unknown";
})(OS || (OS = {}));
var Browser = /*#__PURE__*/ function() {
    "use strict";
    function Browser() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Browser);
    }
    Browser.getInstance = function getInstance() {
        if (!Browser.instance) Browser.instance = new Browser();
        return Browser.instance;
    };
    Browser.isBrowser = function isBrowser() {
        return "object" !== "undefined";
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Browser, [
        {
            key: "isBrowser",
            get: function get() {
                return Browser.isBrowser();
            }
        },
        {
            key: "window",
            get: function get() {
                return window;
            }
        },
        {
            key: "userAgent",
            get: function get() {
                return window.navigator.userAgent;
            }
        },
        {
            key: "platform",
            get: function get() {
                return window.navigator.platform;
            }
        },
        {
            key: "orientation",
            get: function get() {
                return window.orientation;
            }
        },
        {
            key: "isDesktop",
            get: function get() {
                var _this = this;
                return this.isBrowser && !mobile.some(function(i) {
                    return _this.userAgent.includes(i);
                });
            }
        },
        {
            key: "isMobile",
            get: function get() {
                var _this = this;
                return this.isBrowser && mobile.some(function(i) {
                    return _this.userAgent.includes(i);
                });
            }
        }
    ]);
    return Browser;
}();
var Platform = /*#__PURE__*/ function() {
    "use strict";
    function Platform() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Platform);
        this.browser = new Browser();
    }
    Platform.getInstance = function getInstance() {
        if (!Platform.instance) Platform.instance = new Platform();
        return Platform.instance;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Platform, [
        {
            key: "isMac",
            get: function get() {
                return this.browser.isBrowser && macos.includes(this.browser.platform);
            }
        },
        {
            key: "isWin",
            get: function get() {
                return this.browser.isBrowser && windows.includes(this.browser.platform);
            }
        },
        {
            key: "isLinux",
            get: function get() {
                return this.browser.isBrowser && /Linux/.test(this.browser.platform);
            }
        },
        {
            key: "isIos",
            get: function get() {
                return this.browser.isBrowser && ios.includes(this.browser.platform);
            }
        },
        {
            key: "isAndroid",
            get: function get() {
                return this.browser.isBrowser && /Android/.test(this.browser.userAgent);
            }
        },
        {
            key: "os",
            get: function get() {
                if (this.isMac) return OS.MacOS;
                if (this.isWin) return OS.Windows;
                if (this.isIos) return OS.iOS;
                if (this.isAndroid) return OS.Android;
                if (this.isLinux) return OS.Linux;
                return OS.Unknown;
            }
        },
        {
            key: "controlKey",
            get: function get() {
                return [
                    OS.MacOS,
                    OS.iOS
                ].includes(this.os) ? "⌘" : "Ctrl";
            }
        }
    ]);
    return Platform;
}();
var browser = Browser.getInstance;
var platform = Platform.getInstance;


/***/ }),

/***/ 53897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HU": function() { return /* binding */ isReturnFormatArray; },
/* harmony export */   "ft": function() { return /* binding */ createReturnFormatArray; }
/* harmony export */ });
/* unused harmony export awaitInterval */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);



var isReturnFormatArray = function(arr) {
    if (Array.isArray(arr) && arr.length === 2 && !(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr[0], Error) && ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr[1], Error) || arr[1] === null)) return true;
    return false;
};
var createReturnFormatArray = function(okData, errorData) {
    var returned = [
        okData,
        errorData
    ];
    return returned;
};
/**
 * Like `setInterval` only the result of `cb` is
 * awaited before starting the next timer.
 * @param cb A callback which returns a promise
 * @param ms The number of milliseconds betwee intervals
 * @returns A function which stops the interval
 */ var awaitInterval = function(cb, ms) {
    var timer;
    var stop = function() {
        return clearTimeout(timer);
    };
    var run = function() {
        timer = setTimeout(/*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            cb()
                        ];
                    case 1:
                        _state.sent();
                        run();
                        return [
                            2
                        ];
                }
            });
        }), ms);
    };
    run();
    return stop;
};


/***/ }),

/***/ 56501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fc": function() { return /* binding */ makeLoadableHook; },
/* harmony export */   "ff": function() { return /* binding */ makeReloadableHook; },
/* harmony export */   "g8": function() { return /* binding */ hasChildren; },
/* harmony export */   "lq": function() { return /* binding */ mergeRefs; }
/* harmony export */ });
/* unused harmony exports retry, isTextInput, isAnchorElMissing, deepMapChildrenWithFrags, makeLoadableHookWithInterval */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82222);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13665);
/* harmony import */ var jotai_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99079);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47310);
/* harmony import */ var _hooks_useCaptureError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59546);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40673);















function retry(fn) {
    var retries = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5, interval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    return new Promise(function(resolve, reject) {
        fn().then(resolve).catch(function(err) {
            setTimeout(function() {
                if (retries <= 1) return reject(err);
                retry(fn, interval, retries - 1).then(resolve, reject);
            }, interval);
        });
    });
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    retry: retry
});
function isTextInput(el) {
    if ("TEXTAREA" === el.nodeName) return true;
    if ("INPUT" === el.nodeName && !!el.hasAttribute && el.hasAttribute("type") && [
        "text",
        "email",
        "month",
        "number",
        "password",
        "search",
        "tel",
        "time",
        "url",
        "week"
    ].includes(el.getAttribute("type") || "")) return true;
    return false;
}
function isAnchorElMissing(anchorEl) {
    var resolvedAnchorEl = typeof anchorEl === "function" ? anchorEl() : anchorEl;
    if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();
        if ( true && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
            return true;
        }
    }
    return false;
}
/**
 * merges refs
 * @param refs refs to merge
 * @returns a singular function ref
 */ function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(inst) {
        refs.forEach(function(ref) {
            if (!ref) return;
            switch(typeof ref === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref)){
                case "function":
                    ref(inst);
                    break;
                default:
                    ref.current = inst;
                    break;
            }
        });
    };
}
var hasChildren = function(element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(element) && Boolean(element.props.children);
};
/**
 * Maps through all children, deep mapping when a fragment is found
 * @param children The children to map over
 * @param cb The mapping callback
 * @param baseIterator Offsets the iterator number
 * @returns An array of ReactNodes
 */ var deepMapChildrenWithFrags = function(children, cb) {
    var baseIterator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return Children.map(children, function(child) {
        var i = baseIterator;
        if (!/*#__PURE__*/ isValidElement(child)) {
            baseIterator++;
            return cb(child, i);
        }
        if (child.type === Fragment) return /*#__PURE__*/ _jsx(_Fragment, {
            children: deepMapChildrenWithFrags(child.props.children, cb, baseIterator)
        });
        else {
            baseIterator++;
            return cb(child, i);
        }
    });
};
var useCaptureLoadableError = function(loadableState, errorizerFn) {
    var captureError = (0,_hooks_useCaptureError__WEBPACK_IMPORTED_MODULE_3__/* .useCaptureError */ .e)().captureError;
    var stateError = loadableState.state === "hasError" ? loadableState.error : undefined;
    var error = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return stateError ? errorizerFn(stateError) : undefined;
    }, [
        errorizerFn,
        stateError
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (error) captureError(error, {
            severity: "error"
        });
    }, [
        captureError,
        error
    ]);
    return error;
};
/**
 * Makes a hook which only loads the data from `getPromise` on first-use
 * @param getPromise A function which when called returns a promise which resolves to data
 * @param options Options for the hook
 * @returns A hook which returns a `LoadingErrorData`, as well as the atoms used internally
 */ function makeLoadableHook(getPromise) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _dataKey = options.dataKey, dataKey = _dataKey === void 0 ? "data" : _dataKey, _errorizer = options.errorizer, errorizer = _errorizer === void 0 ? "Failed to load data" : _errorizer;
    var dataAtom = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .atomWithDefault */ .qs)(getPromise);
    var loadableAtom = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .loadable */ .n7)(dataAtom);
    var errorizerFn = typeof errorizer === "string" ? function(cause) {
        return new Error(errorizer, {
            cause: (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(cause, Error) ? cause : new Error((0,_error__WEBPACK_IMPORTED_MODULE_4__/* .findErrorMessage */ .dR)(cause))
        });
    } : errorizer;
    return {
        useHook: function() {
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_9__/* .useAtom */ .KO)(loadableAtom), 1), loadableState = ref[0];
            var error = useCaptureLoadableError(loadableState, errorizerFn);
            var _obj;
            return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, dataKey, loadableState.state === "hasData" ? loadableState.data : undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, "loading", loadableState.state === "loading"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, "error", error), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, "state", loadableState.state), _obj;
        },
        dataAtom: dataAtom,
        loadableAtom: loadableAtom
    };
}
/**
 * Similar to `makeLoadableHook` but calls `getPromise` on an interval.  `getPromise` must complete before interval timer will start.
 * @param getPromise A function which when called returns a promise which resolves to data
 * @param ms The number of milliseconds between intervals
 * @param options Options for the hook
 * @returns A hook which returns a `LoadingErrorData`, as well as the atoms used internally
 */ function makeLoadableHookWithInterval(getPromise, ms) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var hasher = options.hasher, makeLoadableHookOptions = _object_without_properties(options, [
        "hasher"
    ]);
    var ref = makeLoadableHook(getPromise, makeLoadableHookOptions), dataAtom = ref.dataAtom, useHookInner = ref.useHook, loadableAtom = ref.loadableAtom;
    var lastHash;
    var intervalAtom = atom({
        stop: undefined,
        activeHooks: 0
    });
    var useHook = function() {
        var ref = _sliced_to_array(useAtom(intervalAtom), 2), intervalData = ref[0], setIntervalData = ref[1];
        var setData = useSetAtom(dataAtom);
        var hookData = useHookInner();
        useEffect(function() {
            // in general: NEVER FLIPPING DO THIS!!!
            // Data in React is not super happy to
            // be mutable, here we need to do it so
            // that the data is immediately available
            // to all callers.
            //
            // Importantly: this data NEVER leaves the
            // scope of `makeLoadableHookWithInterval`
            // and is fully controlled from within
            // -SG
            intervalData.activeHooks++;
            if (!intervalData.stop) {
                intervalData.stop = awaitInterval(/*#__PURE__*/ _async_to_generator(function() {
                    var newData, newHash;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getPromise()
                                ];
                            case 1:
                                newData = _state.sent();
                                newHash = hasher ? hasher(newData) : newData;
                                if (newHash !== lastHash) {
                                    setData(newData);
                                    lastHash = newHash;
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }), ms);
            }
            setIntervalData(intervalData);
            return function() {
                intervalData.activeHooks--;
                if (intervalData.activeHooks <= 0) {
                    var ref;
                    (ref = intervalData.stop) === null || ref === void 0 ? void 0 : ref.call(intervalData);
                    intervalData.stop = undefined;
                }
                setIntervalData(intervalData);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return hookData;
    };
    return {
        useHook: useHook,
        dataAtom: dataAtom,
        loadableAtom: loadableAtom
    };
}
function makeReloadableHook(getPromise) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _dataKey = options.dataKey, dataKey = _dataKey === void 0 ? "data" : _dataKey, _errorizer = options.errorizer, errorizer = _errorizer === void 0 ? "Failed to load data" : _errorizer;
    var sourceAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_9__/* .atom */ .cn)({
        state: "loading"
    });
    var dataAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_9__/* .atom */ .cn)(function(get) {
        var src = get(sourceAtom);
        return src.state === "hasData" ? src.data : null;
    }, function(_get, set, data) {
        set(sourceAtom, {
            state: "hasData",
            data: data
        });
    });
    sourceAtom.onMount = function(set) {
        void getPromise().then(function(data) {
            set({
                state: "hasData",
                data: data
            });
        }, function(error) {
            set({
                state: "hasError",
                error: error
            });
        });
    };
    var errorizerFn = typeof errorizer === "string" ? function(cause) {
        return new Error(errorizer, {
            cause: (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(cause, Error) ? cause : new Error((0,_error__WEBPACK_IMPORTED_MODULE_4__/* .findErrorMessage */ .dR)(cause))
        });
    } : errorizer;
    return {
        useHook: function() {
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_9__/* .useAtom */ .KO)(sourceAtom), 2), loadableState = ref[0], setLoadableState = ref[1];
            var error = useCaptureLoadableError(loadableState, errorizerFn);
            var reload = (0,_hooks_useCallbackSafeRef__WEBPACK_IMPORTED_MODULE_2__/* .useCallbackSafeRef */ .T)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
                var data, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                setLoadableState({
                                    state: "loading"
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                getPromise()
                            ];
                        case 3:
                            data = _state.sent();
                            setLoadableState({
                                state: "hasData",
                                data: data
                            });
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            setLoadableState({
                                state: "hasError",
                                error: error
                            });
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }));
            var _obj;
            return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, dataKey, loadableState.state === "hasData" ? loadableState.data : undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, "loading", loadableState.state === "loading"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, "error", error), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, "state", loadableState.state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, "reload", reload), _obj;
        },
        dataAtom: dataAtom
    };
}


/***/ }),

/***/ 63429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ getMeetingReschedulePageLink; },
/* harmony export */   "B$": function() { return /* binding */ getMailtoUrl; },
/* harmony export */   "BB": function() { return /* binding */ getEventViewUrl; },
/* harmony export */   "D4": function() { return /* binding */ pushHistoryBack; },
/* harmony export */   "D8": function() { return /* binding */ hasValidRoutesWithoutAuth; },
/* harmony export */   "E5": function() { return /* binding */ getSchedulingLinksUrl; },
/* harmony export */   "EG": function() { return /* binding */ getBookingPageLink; },
/* harmony export */   "F_": function() { return /* binding */ getHabitDetailsUrl; },
/* harmony export */   "H3": function() { return /* binding */ USER_ONBOARDING_BASE_PATH; },
/* harmony export */   "Hd": function() { return /* binding */ getPreviousPath; },
/* harmony export */   "Hg": function() { return /* binding */ getGeneralSettingsUrl; },
/* harmony export */   "L5": function() { return /* binding */ getHabitEditUrl; },
/* harmony export */   "LR": function() { return /* binding */ getTaskEditUrl; },
/* harmony export */   "Lc": function() { return /* binding */ getHoursUrl; },
/* harmony export */   "ME": function() { return /* binding */ getBookingLinkForTeamMember; },
/* harmony export */   "MX": function() { return /* binding */ getHabitsPath; },
/* harmony export */   "N6": function() { return /* binding */ getAuthUrl; },
/* harmony export */   "NK": function() { return /* binding */ getOneOnOneDetailsUrl; },
/* harmony export */   "Pd": function() { return /* binding */ getPrioritizationUrl; },
/* harmony export */   "WS": function() { return /* binding */ getTasksUrl; },
/* harmony export */   "YA": function() { return /* binding */ getSyncUrl; },
/* harmony export */   "YN": function() { return /* binding */ useRecordHistory; },
/* harmony export */   "Z0": function() { return /* binding */ getIntegrationsUrl; },
/* harmony export */   "Zm": function() { return /* binding */ getSchedulingLinkEditUrl; },
/* harmony export */   "Zx": function() { return /* binding */ getGroupLink; },
/* harmony export */   "b9": function() { return /* binding */ getSchedulingLinkMeetingLink; },
/* harmony export */   "bV": function() { return /* binding */ getSchedulingLinkBookingPageLink; },
/* harmony export */   "em": function() { return /* binding */ getSyncUrlId; },
/* harmony export */   "gi": function() { return /* binding */ getUserOnboardingPath; },
/* harmony export */   "j3": function() { return /* binding */ getMeetingPageLink; },
/* harmony export */   "lf": function() { return /* binding */ getBookingPathForTeamMember; },
/* harmony export */   "mD": function() { return /* binding */ getOneOnOneEditUrl; },
/* harmony export */   "oQ": function() { return /* binding */ getOneOnOneListUrl; },
/* harmony export */   "qT": function() { return /* binding */ getQuestsUrl; },
/* harmony export */   "qu": function() { return /* binding */ manuallyDecodeSearchString; },
/* harmony export */   "rK": function() { return /* binding */ getTaskDetailsUrl; },
/* harmony export */   "sr": function() { return /* binding */ getSchedulingLinkDetailsUrl; },
/* harmony export */   "uN": function() { return /* binding */ getBillingUrl; },
/* harmony export */   "uT": function() { return /* binding */ getShareTimesUrl; },
/* harmony export */   "ug": function() { return /* binding */ getSyncHomeUrl; }
/* harmony export */ });
/* unused harmony exports getHash, HOURS_BASE_PATH, ONE_ON_ONE_BASE_PATH, SCHEDULING_LINK_BASE_URL, QUESTS_PATH, HABITS_BASE_PATH, TASKS_BASE_PATH, INTEGRATIONS_BASE_PATH, PRIORITIZATION_BASE_PATH */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59637);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _local_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91325);
/* harmony import */ var _url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65934);









var removeQS = function(url) {
    return url.replace(/\?.*$/, "");
};
var ON_SITE_HISTORY_STORAGE_KEY = "router.onSiteHistory";
var ON_SITE_HISTORY_SIZE = 10;
var DONT_ADD_TO_HISTORY_PATTERNS = [
    /\[id\]/,
    /^\/\?login=/
];
var NEXT_PUBLIC_API_BASE_URI = "https://api.app.reclaim-staging.com/api";
/**
 * React hook to track history for pushHistoryBack.  Should be put at the root of the App.
 * @param router the current router
 */ function useRecordHistory(router) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!sessionStorage) return;
        var currentPath = router.asPath;
        if (DONT_ADD_TO_HISTORY_PATTERNS.every(function(rx) {
            return !rx.test(currentPath);
        })) {
            var onSiteHistory = (0,_local_storage__WEBPACK_IMPORTED_MODULE_1__/* .getSessionStorage */ .G)(ON_SITE_HISTORY_STORAGE_KEY, []).slice(0, ON_SITE_HISTORY_SIZE - 1);
            if (currentPath !== onSiteHistory[0]) onSiteHistory.unshift(currentPath);
            (0,_local_storage__WEBPACK_IMPORTED_MODULE_1__/* .setSessionStorage */ .t_)(ON_SITE_HISTORY_STORAGE_KEY, onSiteHistory);
        }
    }, [
        router.asPath
    ]);
}
var getPreviousPath = function(router) {
    var ignoreQSDiff = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!sessionStorage) return undefined;
    var currentPath = removeQS(router.asPath);
    // ignore first item, it should be the same as the current
    var ref = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_local_storage__WEBPACK_IMPORTED_MODULE_1__/* .getSessionStorage */ .G)(ON_SITE_HISTORY_STORAGE_KEY, [])), onSiteHistory = ref.slice(1);
    var prevPath;
    if (ignoreQSDiff) {
        prevPath = onSiteHistory.find(function(path) {
            return removeQS(path) !== currentPath;
        });
    } else if (currentPath !== onSiteHistory[0]) {
        prevPath = onSiteHistory[0];
    }
    return prevPath;
};
/**
 * Adds previous history state to end of stack if on-site.  If previous history state is not available falls back to fallbackUrl.  Similar to router.back but re-adds location to stack.
 * @param router the current router
 * @param fallbackUrl a fallback URL to navigate to if no previous state is available (likely case for off-site)
 * @param options options
 * @returns a promise which resolves when the router push operation completes
 */ function pushHistoryBack(router, fallbackPath) {
    return _pushHistoryBack.apply(this, arguments);
}
function _pushHistoryBack() {
    _pushHistoryBack = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(router, fallbackPath) {
        var options, _ignoreQSDiff, ignoreQSDiff, onlyIfPrevMatch, prevPath;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
            _ignoreQSDiff = options.ignoreQSDiff, ignoreQSDiff = _ignoreQSDiff === void 0 ? false : _ignoreQSDiff, onlyIfPrevMatch = options.onlyIfPrevMatch;
            if (!sessionStorage) return [
                2,
                router.push(fallbackPath)
            ];
            prevPath = getPreviousPath(router, ignoreQSDiff);
            if (!prevPath || onlyIfPrevMatch && !prevPath.match(onlyIfPrevMatch)) return [
                2,
                router.push(fallbackPath)
            ];
            return [
                2,
                router.push(prevPath)
            ];
        });
    });
    return _pushHistoryBack.apply(this, arguments);
}
var getHash = function(hash) {
    return hash ? "#".concat(hash) : "";
};
var getBillingUrl = function(action) {
    return "/billing".concat(!!action ? "?action=".concat(action) : "");
};
var HOURS_BASE_PATH = "/settings/hours";
var getHoursUrl = function(query) {
    return "".concat(HOURS_BASE_PATH).concat((0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)(query));
};
var getGeneralSettingsUrl = function(jumpTarget) {
    return "/settings/general".concat(jumpTarget ? "#".concat(jumpTarget) : "");
};
var ONE_ON_ONE_BASE_PATH = "/one-on-ones";
var getOneOnOneListUrl = function(filter) {
    return "".concat(ONE_ON_ONE_BASE_PATH).concat((0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)({
        filter: filter
    }));
};
var getOneOnOneEditUrl = function(oneOnOneId, hashTarget) {
    return "".concat(ONE_ON_ONE_BASE_PATH, "/").concat(oneOnOneId, "/edit").concat(getHash(hashTarget));
};
var getOneOnOneDetailsUrl = function(oneOnOneId, query) {
    return "".concat(ONE_ON_ONE_BASE_PATH, "/").concat(oneOnOneId, "/details").concat((0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)(query));
};
/**
 * Sync routing
 */ var SYNC_BASE_URL = "/sync";
var getSyncHomeUrl = function(credentialId) {
    return "".concat(SYNC_BASE_URL).concat(credentialId !== undefined ? "?credential=".concat(credentialId) : "");
};
var getSyncUrlId = function(sourceCalendarId, targetCalendarId) {
    return "".concat(sourceCalendarId, "-").concat(targetCalendarId);
};
var getSyncUrl = function(sourceCalendarId, targetCalendarId, jumpTarget) {
    return "".concat(SYNC_BASE_URL, "/").concat(getSyncUrlId(sourceCalendarId, targetCalendarId)).concat(getHash(jumpTarget));
};
/**
 * Scheduling link routing
 */ var SCHEDULING_LINK_BASE_URL = "/scheduling-links";
var getSchedulingLinksUrl = function() {
    return SCHEDULING_LINK_BASE_URL;
};
var getSchedulingLinkDetailsUrl = function(id) {
    return "".concat(SCHEDULING_LINK_BASE_URL, "/").concat(id);
};
var getSchedulingLinkEditUrl = function(id, jumpTarget) {
    return "".concat(SCHEDULING_LINK_BASE_URL, "/").concat(id, "/edit").concat(getHash(jumpTarget));
};
var getGroupLink = function(schedulingLink) {
    return "/m/".concat(schedulingLink.pageSlug);
};
var getBookingPageLink = function(userSlug, bookingSlug) {
    var _param = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var absolute = _param.absolute, options = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "absolute"
    ]);
    return "".concat(absolute ? window.location.origin : "", "/m/").concat(userSlug, "/").concat(bookingSlug) + (0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)(options);
};
var getSchedulingLinkBookingPageLink = function(schedulingLink, options) {
    return getBookingPageLink(schedulingLink.pageSlug, schedulingLink.slug, options);
};
var getSchedulingLinkMeetingLink = function(schedulingLink) {
    return new URL(getBookingPageLink(schedulingLink.pageSlug, schedulingLink.slug), window.location.href).toString();
};
var getMeetingPageLink = function(meetingId, tz, action) {
    return "/meeting/".concat(meetingId).concat((0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)({
        tz: tz,
        action: action
    }));
};
var getMeetingReschedulePageLink = function(meetingId, tz) {
    return "".concat(getMeetingPageLink(meetingId), "/reschedule") + (tz ? "?tz=".concat(tz) : "");
};
var getBookingPathForTeamMember = function(member) {
    return "/m/".concat(member.schedulingLinkSlug);
};
var getBookingLinkForTeamMember = function(member) {
    return new URL(getBookingPathForTeamMember(member), window.location.href).toString();
};
var getShareTimesUrl = function(linkId) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return "/quick-forms/scheduling-links/".concat(linkId, "/available-times").concat(options.action ? (0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)({
        action: options.action
    }) : "");
};
/**
 * Gets the search string as an object.  Next.js
 * seems to decode search parameters twice.
 * This means things like %2B go from "+" to " ".
 * @param search The search string
 * @returns
 */ var manuallyDecodeSearchString = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.search;
    return search.replace(/^\?/, "").split("&").reduce(function(obj, pair) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(pair.split("="), 2), key = ref[0], value = ref[1];
        obj[key] = decodeURIComponent(value);
        return obj;
    }, {});
};
var getAuthUrl = function(baseUri, router, state) {
    var authUrl = new URL(baseUri, window.location.href);
    authUrl.searchParams.append("state", JSON.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        redirect: router.asPath
    }, state || {})));
    return authUrl.toString();
};
var getEventViewUrl = function(eventKey) {
    return "".concat(NEXT_PUBLIC_API_BASE_URI, "/events/view/").concat(eventKey);
};
var hasValidRoutesWithoutAuth = function(router) {
    return [
        "",
        "/",
        "/signup",
        "/login",
        "/unauthorized",
        "/logout",
        "/offboarding",
        "/social",
        "/unsubscribe"
    ].includes(router.pathname) || router.pathname.startsWith("/404") || router.pathname.startsWith("/smart-onboarding") || router.pathname.startsWith("/landing") || router.pathname.startsWith("/quick-signup") || router.pathname.startsWith("/m") || router.pathname.startsWith("/e") || router.pathname.startsWith("/website") || /^\/one-on-ones\/(\d{1,})\?/i.test(router.asPath);
};
/**
 * Onboarding routing
 */ var USER_ONBOARDING_BASE_PATH = "/onboarding/user";
var getUserOnboardingPath = function() {
    var step = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "welcome";
    return "".concat(USER_ONBOARDING_BASE_PATH, "/").concat(step);
};
var getMailtoUrl = function(recipient, options) {
    return "mailto:".concat((Array.isArray(recipient) ? recipient : [
        recipient
    ]).join(",")) + (0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)(options);
};
/**
 * Quest routing
 */ var QUESTS_PATH = "/setup-guide";
var getQuestsUrl = function(action) {
    return "".concat(QUESTS_PATH).concat((0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)({
        action: action
    }));
};
var HABITS_BASE_PATH = "/habits";
var getHabitsPath = function(view) {
    return "".concat(HABITS_BASE_PATH).concat((0,_url__WEBPACK_IMPORTED_MODULE_5__/* .queryObjectToStrParams */ .uq)({
        view: view
    }));
};
var getHabitDetailsUrl = function(id) {
    return "".concat(HABITS_BASE_PATH, "/").concat(id);
};
var getHabitEditUrl = function(id, jumpTarget) {
    return "".concat(HABITS_BASE_PATH, "/").concat(id, "/edit").concat(getHash(jumpTarget));
};
/**
 * Tasks routing
 */ var TASKS_BASE_PATH = "/tasks";
var getTasksUrl = function() {
    return TASKS_BASE_PATH;
};
var getTaskEditUrl = function(id) {
    return "".concat(TASKS_BASE_PATH, "/").concat(id, "/edit");
};
var getTaskDetailsUrl = function(id) {
    return "".concat(TASKS_BASE_PATH, "/").concat(id);
};
/**
 * Integrations routing
 */ var INTEGRATIONS_BASE_PATH = "/settings/integrations";
var getIntegrationsUrl = function() {
    return INTEGRATIONS_BASE_PATH;
};
/**
 * Prioritization routing
 */ var PRIORITIZATION_BASE_PATH = "/priorities";
var getPrioritizationUrl = function() {
    return PRIORITIZATION_BASE_PATH;
};


/***/ }),

/***/ 91740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ mergeClassNames; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _arrays__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92886);
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45110);




var mergeClassNames = function(baseClasses) {
    for(var _len = arguments.length, classeses = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        classeses[_key - 1] = arguments[_key];
    }
    return classeses.reduce(function(map, classes) {
        (0,_objects__WEBPACK_IMPORTED_MODULE_1__/* .typedEntries */ .FR)(classes).forEach(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), jsName = _param[0], className = _param[1];
            return map[jsName] = (0,_arrays__WEBPACK_IMPORTED_MODULE_0__/* .filterFalsy */ .SY)([
                map[jsName],
                className
            ]).join(" ");
        });
        return map;
    }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, baseClasses));
};


/***/ }),

/***/ 14023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ dateComparator; },
/* harmony export */   "Ae": function() { return /* binding */ numComparator; },
/* harmony export */   "DI": function() { return /* binding */ yyyyMmDdComparator; },
/* harmony export */   "LU": function() { return /* binding */ makeOrderedListComparator; },
/* harmony export */   "Vk": function() { return /* binding */ sortMax; },
/* harmony export */   "WD": function() { return /* binding */ multiComparator; },
/* harmony export */   "Y": function() { return /* binding */ boolComparator; },
/* harmony export */   "ZO": function() { return /* binding */ useSort; },
/* harmony export */   "jd": function() { return /* binding */ sortOnDatePropComparator; },
/* harmony export */   "lX": function() { return /* binding */ reverseComparator; },
/* harmony export */   "pT": function() { return /* binding */ isSorted; },
/* harmony export */   "um": function() { return /* binding */ alphaComparator; }
/* harmony export */ });
/* unused harmony exports sortMin, copySortState, updateSortState, useSortState, sortOnPropComparator, sortOnNumPropComparator */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59637);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




function sortMin(comparator) {
    for(var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        items[_key - 1] = arguments[_key];
    }
    return items.sort(comparator)[0];
}
function sortMax(comparator) {
    for(var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        items[_key - 1] = arguments[_key];
    }
    var sorted = items.sort(comparator);
    return sorted[sorted.length - 1];
}
/**
 * Copies a SortState object, making new references for the object itself, as well as sortOrder and items.  Will NOT make copies of objects in items.
 * @param state The state to copy
 * @returns A new state object
 */ var copySortState = function(param) {
    var sortOrder = param.sortOrder, items = param.items;
    return {
        sortOrder: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(sortOrder),
        items: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(items)
    };
};
/**
 * Returns a new SortState with items ordered consistantly with the internal values of sortOrder and direction, and according to the functions in comparators
 * @param state The current SortState
 * @param comparators A map of comparators for sorting
 * @param update The properties in SortState to update
 * @returns A new SortState with items sorted
 */ function updateSortState(state, comparators, update) {
    var ref = update || {}, sortBy = ref.sortBy, _direction = ref.direction, direction = _direction === void 0 ? "asc" : _direction;
    state = copySortState(state);
    state.direction = direction;
    var revMult = direction === "asc" ? 1 : -1;
    if (typeof sortBy === "string") {
        var index = state.sortOrder.indexOf(sortBy);
        if (index !== -1) {
            state.sortOrder.splice(index, 1);
            state.sortOrder.unshift(sortBy);
        }
    }
    function compare(a, b) {
        var sortByIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        var sortBy = state.sortOrder[sortByIndex];
        if (typeof sortBy !== "string") return 0;
        var result = comparators[sortBy](a, b) * revMult;
        if (!result) return compare(a, b, sortByIndex + 1);
        return result;
    }
    state.items.sort(compare);
    return state;
}
/**
 * Hook for maintaining a SortState in React components with items ordered consistantly with the internal values of sortOrder and direction, and according to the functions in comparators
 * @param state The current SortState
 * @param comparators A map of comparators for sorting
 * @param update The properties in SortState to update
 * @returns A new SortState with items sorted
 */ function useSortState(state, comparators, update) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(state), internalState = ref[0], setInternalState = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setInternalState(updateSortState(state, comparators, update));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        update === null || update === void 0 ? void 0 : update.sortBy,
        update === null || update === void 0 ? void 0 : update.direction,
        state.items,
        state.direction,
        state.sortOrder
    ]);
    return internalState;
}
function useSort(items, initialSortOrder, comparators) {
    var initialDirection = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "asc";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialSortOrder[0]), sortBy = ref[0], setSortBy = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialDirection), direction = ref1[0], setDirection = ref1[1];
    var sortState = useSortState({
        items: items,
        sortOrder: initialSortOrder
    }, comparators, {
        sortBy: sortBy,
        direction: direction
    });
    return [
        sortState,
        setSortBy,
        setDirection
    ];
}
var reverseComparator = function(comparator) {
    return function(a, b) {
        return -1 * comparator(a, b);
    };
};
/**
 * Checks if array is sorted according to comparator.  O(n) compared to JS .sort which is O(n log n).
 * @param arr an array to check
 * @param comparator the comparator to use
 */ function isSorted(arr, comparator) {
    for(var i = 0; i < arr.length - 1; i++)if (comparator(arr[i], arr[i + 1]) > 0) return false;
    return true;
}
/**
 * comparator for number arrays
 */ var numComparator = function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Infinity, b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Infinity;
    return a === b ? 0 : a - b;
};
/**
 * comparator for string arrays
 */ var alphaComparator = function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    a = a.toLowerCase();
    b = b.toLowerCase();
    // eslint-disable-next-line no-nested-ternary
    return a === b ? 0 : a > b ? 1 : -1;
};
/**
 * comparator for boolean arrays
 */ var boolComparator = function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return(// eslint-disable-next-line no-nested-ternary
    a === b ? 0 : a && !b ? 1 : -1);
};
/**
 * comparator for date arrays
 */ var dateComparator = function(a, b) {
    if ((a === null || a === void 0 ? void 0 : a.getTime()) === (b === null || b === void 0 ? void 0 : b.getTime())) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a.getTime() - b.getTime();
};
/**
 * comparator for date arrays
 */ var yyyyMmDdComparator = function(a, b) {
    return alphaComparator(a || undefined, b || undefined);
};
function multiComparator() {
    for(var _len = arguments.length, comps = new Array(_len), _key = 0; _key < _len; _key++){
        comps[_key] = arguments[_key];
    }
    if (!comps[0]) return 0;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(comps[0], 3), a = ref[0], b = ref[1], comparator = ref[2];
    var result = comparator(a, b);
    if (!result) {
        var _comps = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(comps), newComp = _comps.slice(1);
        return multiComparator.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(newComp));
    }
    return result;
}
/**
 * Creates a comparator which orders objects in a list according to order
 * @param order The order in which to sort
 * @returns a comparator
 */ var makeOrderedListComparator = function(order) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _fallbackComparator = options.fallbackComparator, fallbackComparator = _fallbackComparator === void 0 ? function(a, b) {
        return alphaComparator("".concat(a), "".concat(b));
    } : _fallbackComparator;
    var indexLookup = Object.values(order).reduce(function(lookup, item, i) {
        lookup.set(item, i);
        return lookup;
    }, new Map());
    return function(a, b) {
        var iA = indexLookup.get(a);
        var iB = indexLookup.get(b);
        if (iA === undefined && iB === undefined) return fallbackComparator(a, b);
        if (iA === undefined) return 1;
        if (iB === undefined) return -1;
        return numComparator(iA === undefined ? Infinity : iA, iB === undefined ? Infinity : iB);
    };
};
/**
 * Creates a comparator for sorting objects
 * @param key the key to sort on
 * @param comparator the comparator
 * @returns
 */ var sortOnPropComparator = function(key, comparator) {
    return function(a, b) {
        return comparator(a[key], b[key]);
    };
};
/**
 * Creates a comparator for sorting objects by numeric keys
 * @param key the key to sort on
 * @returns
 */ var sortOnNumPropComparator = function(key) {
    return sortOnPropComparator(key, numComparator);
};
/**
 * Creates a comparator for sorting objects by Date keys
 * @param key the key to sort on
 * @returns
 */ var sortOnDatePropComparator = function(key) {
    return sortOnPropComparator(key, dateComparator);
};


/***/ }),

/***/ 84467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Wu": function() { return /* binding */ aOrAn; },
  "Yv": function() { return /* binding */ andList; },
  "Hy": function() { return /* binding */ camelcase; },
  "Jh": function() { return /* binding */ isEmail; },
  "DD": function() { return /* binding */ isEmailish; },
  "CB": function() { return /* binding */ isUrl; },
  "Fh": function() { return /* binding */ isVersionStringGreaterThan; },
  "aI": function() { return /* binding */ kebabcase; },
  "Eb": function() { return /* binding */ leftPadTo; },
  "Md": function() { return /* binding */ makeMailToUrl; },
  "qm": function() { return /* binding */ parseEmoji; },
  "_6": function() { return /* binding */ pluralize; },
  "Rx": function() { return /* binding */ stringIf; },
  "pP": function() { return /* binding */ titleWithEmoji; },
  "a5": function() { return /* binding */ titlecase; },
  "Ps": function() { return /* binding */ ucfirst; }
});

// UNUSED EXPORTS: Parser, default, escapeHtml, isJson, isVowel, isWorkEmail, labelize, list, repeatChar, rightPadTo, snakeToWords, testTextForEmoji

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/utils/arrays.ts
var arrays = __webpack_require__(92886);
;// CONCATENATED MODULE: ./src/utils/emoji-regex.const.ts
var emojiFindingRegex = function() {
    return new RegExp("/[#*0-9]️?⃣|[\xa9\xae‼⁉™ℹ↔-↙↩↪⌚⌛⌨⏏⏭-⏯⏱⏲⏸-⏺Ⓜ▪▫▶◀◻◼◾☀-☄☎☑☔☕☘☠☢☣☦☪☮☯☸-☺♀♂♈-♓♟♠♣♥♦♨♻♾♿⚒⚔-⚗⚙⚛⚜⚠⚧⚪⚰⚱⚽⚾⛄⛈⛏⛑⛩⛰-⛵⛷⛸⛺✂✈✉✏✒✔✖✝✡✳✴❄❇❗❣➡⤴⤵⬅-⬇⬛⬜⭕〰〽㊗㊙]️?|[☝✌✍](?:️|\uD83C[\uDFFB-\uDFFF])?|[✊✋](?:\uD83C[\uDFFB-\uDFFF])?|[⏩-⏬⏰⏳◽⚓⚡⚫⛅⛎⛔⛪⛽✅✨❌❎❓-❕➕-➗➰➿⭐]|⛓️?(?:‍\uD83D\uDCA5)?|⛹(?:️|\uD83C[\uDFFB-\uDFFF])?(?:‍[♀♂]️?)?|❤️?(?:‍(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]️?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:‍[♀♂]️?)?|[\uDFCB\uDFCC](?:️|\uD83C[\uDFFB-\uDFFF])?(?:‍[♀♂]️?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:‍\uD83D\uDFEB)?|\uDF4B(?:‍\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:‍(?:[♀♂]️?(?:‍➡️?)?|➡️?))?|\uDFF3️?(?:‍(?:⚧️?|\uD83C\uDF08))?|\uDFF4(?:‍☠️?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]️?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:‍[♀♂]️?)?|[\uDD74\uDD90](?:️|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:‍⬛)?|\uDC15(?:‍\uD83E\uDDBA)?|\uDC26(?:‍(?:⬛|\uD83D\uDD25))?|\uDC3B(?:‍❄️?)?|\uDC41️?(?:‍\uD83D\uDDE8️?)?|\uDC68(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:\uDC8B‍\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]‍\uD83D(?:\uDC66(?:‍\uD83D\uDC66)?|\uDC67(?:‍\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:‍\uD83D\uDC66)?|\uDC67(?:‍\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:\uDC8B‍\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:\uDC8B‍\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:\uDC8B‍\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:\uDC8B‍\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:\uDC8B‍\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:\uDC8B‍\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:‍\uD83D\uDC66)?|\uDC67(?:‍\uD83D[\uDC66\uDC67])?|\uDC69‍\uD83D(?:\uDC66(?:‍\uD83D\uDC66)?|\uDC67(?:‍\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:[\uDC68\uDC69]|\uDC8B‍\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:[\uDC68\uDC69]|\uDC8B‍\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:[\uDC68\uDC69]|\uDC8B‍\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:[\uDC68\uDC69]|\uDC8B‍\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:‍(?:[⚕⚖✈]️?|❤️?‍\uD83D(?:[\uDC68\uDC69]|\uDC8B‍\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:‍[♀♂]️?)?|\uDD75(?:️|\uD83C[\uDFFB-\uDFFF])?(?:‍[♀♂]️?)?|\uDE2E(?:‍\uD83D\uDCA8)?|\uDE35(?:‍\uD83D\uDCAB)?|\uDE36(?:‍\uD83C\uDF2B️?)?|\uDE42(?:‍[↔↕]️?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:‍(?:[♀♂]️?(?:‍➡️?)?|➡️?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:‍[♀♂]️?)?|[\uDDDE\uDDDF](?:‍[♀♂]️?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:‍[♀♂]️?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:‍(?:[♀♂]️?(?:‍➡️?)?|➡️?))?|\uDDD1(?:‍(?:[⚕⚖✈]️?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83E\uDDD1|\uDDD1‍\uD83E\uDDD2(?:‍\uD83E\uDDD2)?|\uDDD2(?:‍\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:‍(?:[⚕⚖✈]️?|❤️?‍(?:\uD83D\uDC8B‍)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:‍(?:[⚕⚖✈]️?|❤️?‍(?:\uD83D\uDC8B‍)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:‍(?:[⚕⚖✈]️?|❤️?‍(?:\uD83D\uDC8B‍)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:‍(?:[⚕⚖✈]️?|❤️?‍(?:\uD83D\uDC8B‍)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:‍(?:[⚕⚖✈]️?|❤️?‍(?:\uD83D\uDC8B‍)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:‍➡️?)?|[\uDDB0-\uDDB3]|\uDD1D‍\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:‍\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:‍\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:‍\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:‍\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:‍\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g");
};

// EXTERNAL MODULE: ./src/utils/loop.ts
var loop = __webpack_require__(71233);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js
var index_client = __webpack_require__(58946);
// EXTERNAL MODULE: ./src/hooks/useCaptureError.ts
var useCaptureError = __webpack_require__(59546);
;// CONCATENATED MODULE: ./src/utils/strings.ts







var escapeHtml = function(html) {
    var lookup = {
        "&": "&amp;",
        '"': "&quot;",
        "'": "&apos;",
        "<": "&lt;",
        ">": "&gt;"
    };
    return html.replace(/[&"'<>]/g, function(c) {
        return lookup[c];
    });
};
var stringIf = function(truthy, str) {
    var notStr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return !!truthy ? str : notStr;
};
/**
 * Returns a string with `char` repeated `times` times
 * @param times the times of the output string
 * @param char the char (or string) to repeat
 * @returns a string of `char` repeated `times` times
 */ var repeatChar = function(times, char) {
    return (0,loop/* mapTimes */.n)(times, function() {
        return char;
    }).join("");
};
/**
 * Adds `char` to the left side of `str` until it is at least `minSize` long.
 * @param str The string to pad
 * @param minSize The min size of the output
 * @param char The character to pad with
 * @returns A left-padded string
 */ var leftPadTo = function(str, minSize) {
    var char = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : " ";
    return repeatChar(minSize - str.length, char) + str;
};
/**
 * Adds `char` to the right side of `str` until it is at least `minSize` long.
 * @param str The string to pad
 * @param minSize The min size of the output
 * @param char The character to pad with
 * @returns A right-padded string
 */ var rightPadTo = function(str, minSize) {
    var char = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : " ";
    return str + repeatChar(minSize - str.length, char);
};
function makeMailToUrl(emails) {
    var contents = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    emails = Array.isArray(emails) ? emails : [
        emails
    ];
    return "mailto:".concat(emails.join(","), "?").concat(Object.keys(contents).map(function(key) {
        return "".concat(key, "=").concat(encodeURIComponent(contents[key]));
    }).join("&"));
}
function isEmailish(email) {
    return !email || /^[^@]+?(@([^@]+?(\.?[^@]+)?)?)?$/.test(email);
}
function isEmail(email) {
    if (!email) return false;
    return /.+\@(.{1,}\.)+.+/.test(email);
}
function isWorkEmail(email) {
    if (!email) return false;
    return !/@(gmail|googlemail|outlook|icloud|mac|live|hotmail|yahoo|fastmail)\.com$/i.test(email);
}
function ucfirst(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
/**
 * Changes snake case to words, replacing _ with space.
 * @param str The snake cased string to change to words
 * @param letterCase How to handle case change.  If blank case will remain unchanged else:
 * - `upper`: change all letters to upper-case
 * - `lower`: change all letters to lower-case
 * - `cap`: capitalize the first letter of each word
 * @returns A string with the words from the snake-cased string
 */ function snakeToWords(str, letterCase) {
    var words = str.split("_");
    switch(letterCase){
        case "cap":
            words = words.map(ucfirst);
            break;
        case "lower":
            words = words.map(function(s) {
                return s.toLowerCase();
            });
            break;
        case "upper":
            words = words.map(function(s) {
                return s.toUpperCase();
            });
            break;
    }
    return words.join(" ");
}
function titlecase(str) {
    var joiner = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    if (!str) return "";
    return str.split(/[^\w\d]+/).map(ucfirst).join(joiner);
}
function camelcase(str) {
    if (!str) return "";
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function(m, ch) {
        return ch.toUpperCase();
    });
}
/**
 * Tests if a string is a URL.  Will NOT test relative URLs.
 * @param str
 * @returns
 */ var isUrl = function(str) {
    try {
        var url = new URL(str);
        // Don't let weird protocols through.
        /**
     ***** USE EXTREME CAUTION CHANGING THIS LINE *****
     */ // Allowing all protocols could allow scripting
        // attacks by making `javascript:` (or other
        // scripting protocols) clickable
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (e) {
        return false;
    }
};
function kebabcase(str, allowTrailingDashes) {
    if (!str) return "";
    if (false) {}
    str = str.toLowerCase().replace(/\s/g, "-") // replace space with dash
    .replace(/_/g, "-") // replace underscore with dash
    .replace(/[àáâãäå]/g, "a").replace(/[ç]/g, "c").replace(/[Ð]/g, "d").replace(/[èéêë]/g, "e").replace(/[ìíîï]/g, "i").replace(/[ñ]/g, "n").replace(/[òóôõöøð]/g, "o").replace(/[š]/g, "s").replace(/[ùúûü]/g, "u").replace(/[ÿý]/g, "y").replace(/[ž]/g, "z").replace(/[æ]/g, "ae").replace(/[^a-zA-Z0-9-]/g, "") // anything other than these replace with nothing
    .replace(/-+/g, "-") // any multiple occurences of - replace with single -
    .replace(/-/g, "-") // any multiple occurences of - replace with single - sdfsdafasdfsfas
    .replace(/^-+/g, ""); // if first character is - replace with nothing
    // next line disabled user input of dashes
    if (!allowTrailingDashes) {
        str = str.replace(/-+$/g, ""); // if last character is - replace with nothing
    }
    return str;
}
function pluralize(count, root) {
    var plural = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "s";
    return "".concat(root).concat(Math.abs(count) !== 1 ? plural : "");
}
var isVowel = function(letter) {
    var sometimesY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return !!(letter[0] && ({
        a: true,
        e: true,
        i: true,
        o: true,
        u: true,
        y: sometimesY
    })[letter[0].toLowerCase()]);
};
var aOrAn = function(word) {
    return isVowel(word) ? "an ".concat(word) : "a ".concat(word);
};
var andList = function(list) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var mutableList = (0,arrays/* filterFalsy */.SY)((0,_to_consumable_array/* default */.Z)(list));
    if (mutableList.length > 1) {
        var lastTwoWords = mutableList.splice(mutableList.length - 2, 2);
        mutableList.push("".concat(lastTwoWords[0], " ").concat(options.andWord || "and", " ").concat(lastTwoWords[1]));
    }
    return mutableList.join(options.noCommas ? " " : ", ");
};
function labelize(count, root, plural) {
    return "".concat(count, " ").concat(pluralize(count, root, plural));
}
function testTextForEmoji(text) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(e) {
        return (0,useCaptureError/* rawCaptureError */.P)(index_client, e, {
            severity: "warning"
        });
    };
    var emoji;
    // try the simpler parser that will fail on Safari 14 lol
    // then complex emoji regex grabs flags but can fail some emojis
    try {
        emoji = RegExp("(\\p{EPres}|\\p{ExtPict})(\\u200d(\\p{EPres}|\\p{ExtPict}))*", "gu").exec(text);
    } catch (e) {
        emoji = emojiFindingRegex().exec(text);
        onError(e);
    }
    return emoji;
}
function parseEmoji(text, onError) {
    var emoji = testTextForEmoji(text, onError);
    var textWithoutLeadingEmoji = emoji && emoji.index === 0 ? text.replace(emoji[0], "").trimStart() : text;
    return {
        emoji: emoji && emoji.index === 0 ? emoji[0] : undefined,
        textWithoutLeadingEmoji: textWithoutLeadingEmoji
    };
}
function titleWithEmoji(emoji) {
    var text = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", onError = arguments.length > 2 ? arguments[2] : void 0;
    if (!emoji) return text;
    var foundEmoji = testTextForEmoji(text, onError);
    if (foundEmoji && foundEmoji.index === 0) {
        return "".concat(emoji).concat(text).trimStart();
    }
    return "".concat(emoji, " ").concat(text).trimStart();
}
function list(items) {
    var conjunction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "and";
    if (!conjunction || items.length < 2) return items.join(", ");
    if (items.length === 2) return items.join(" ".concat(conjunction, " "));
    return items.slice(0, -1).concat("".concat(conjunction, " ").concat(items[items.length - 1])).join(", ");
}
function isJson(str) {
    if (typeof str !== "string") return false;
    try {
        var result = JSON.parse(str);
        var type = Object.prototype.toString.call(result);
        return [
            "[object Object]",
            "[object Array]"
        ].includes(type);
    } catch (err) {
        return false;
    }
}
var Parser = /*#__PURE__*/ function() {
    "use strict";
    function Parser(name, test, parse) {
        (0,_class_call_check/* default */.Z)(this, Parser);
        this.name = name;
        this.test = test;
        this.parse = parse;
    }
    Parser.parse = function parse(str) {
        var parser = [
            Parser.Json,
            Parser.Array,
            Parser.Number,
            Parser.Boolean,
            Parser.Null,
            Parser.Undefined
        ].find(function(p) {
            return p.test(str);
        });
        return parser ? parser.parse(str) : str;
    };
    return Parser;
}();
Parser.Json = new Parser("json", function(str) {
    return isJson(str);
}, function(str) {
    return JSON.parse(str);
});
Parser.Array = new Parser("array", function(str) {
    return /(?:\[?([\w\d._\-+]+)[\s,]+?)\]?/g.test(str);
}, function(str) {
    var match = str.match(/(?:([\w\d._\-+]+)\s?[,]?)/g);
    if (!(match === null || match === void 0 ? void 0 : match.length)) return undefined;
    return Array.from(match);
});
Parser.Boolean = new Parser("boolean", function(str) {
    return /^(true|false)$/i.test(str);
}, function(str) {
    var match = str.match(/^(true|false)$/i);
    if (!(match === null || match === void 0 ? void 0 : match.length)) return undefined;
    if (match[0].toLowerCase() === "true") return true;
    if (match[0].toLowerCase() === "false") return false;
    return undefined;
});
Parser.Number = new Parser("number", function(str) {
    return /^(\d*\.?\d+)$/i.test(str);
}, function(str) {
    var match = str.match(/^(\d*\.?\d+)$/i);
    if (!(match === null || match === void 0 ? void 0 : match.length)) return undefined;
    var num = Number(match[0]);
    return !isNaN(num) ? num : undefined;
});
Parser.Null = new Parser("null", function(str) {
    return /^null$/i.test(str);
}, function(str) {
    var match = str.match(/^null$/i);
    return (match === null || match === void 0 ? void 0 : match.length) ? null : undefined;
});
Parser.Undefined = new Parser("undefined", function(str) {
    return /^undefined$/i.test(str);
}, function(str) {
    var match = str.match(/^undefined$/i);
    return (match === null || match === void 0 ? void 0 : match.length) ? null : undefined;
});
var isVersionStringGreaterThan = function(version, test) {
    var vs = version.split(".").map(function(s) {
        return Number(s);
    });
    var ts = test.split(".").map(function(s) {
        return Number(s);
    });
    // Dont throw error here. Currently used in response interceptors.
    if (vs.length !== 3 || ts.length !== 3) {
        console.error("Invalid app version passed into version check: ".concat(version, " - ").concat(test));
        return false;
    }
    for(var i = 0; i <= 2; i++){
        if (vs[i] > ts[i]) return true;
        if (vs[i] < ts[i]) return false;
    }
    // Otherwise versions are equal
    return false;
};
/* harmony default export */ var strings = ({
    isEmailish: isEmailish,
    isEmail: isEmail,
    isWorkEmail: isWorkEmail,
    ucfirst: ucfirst,
    titlecase: titlecase,
    pluralize: pluralize,
    labelize: labelize,
    isJson: isJson,
    Parser: Parser
});


/***/ }),

/***/ 10016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ userIsAdminOnTeam; },
/* harmony export */   "t": function() { return /* binding */ isOnlyAdminOnTeam; }
/* harmony export */ });
/* harmony import */ var _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72897);

var isOnlyAdminOnTeam = function(team, userMembership) {
    // The user is not on a team
    if (team.members.length === 1) return false;
    // The user is an admin, and there is another admin on the team.
    if (userMembership.membershipRole === _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__/* .MembershipRole.Admin */ .nJ.Admin) {
        var otherAdmin = team.members.find(function(m) {
            return m.teamMemberId.userId !== userMembership.teamMemberId.userId && m.membershipRole === _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__/* .MembershipRole.Admin */ .nJ.Admin;
        });
        return !otherAdmin;
    } else {
        // Normal user role.
        return false;
    }
};
var userIsAdminOnTeam = function(user, team) {
    var ref;
    return ((ref = user && team.members.find(function(param) {
        var userId = param.teamMemberId.userId;
        return userId === (user === null || user === void 0 ? void 0 : user.id);
    })) === null || ref === void 0 ? void 0 : ref.membershipRole) === _reclaim_api_team_Team__WEBPACK_IMPORTED_MODULE_0__/* .MembershipRole.Admin */ .nJ.Admin;
};


/***/ }),

/***/ 52515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ni": function() { return /* binding */ timeOfDayOverlapsTimePolicy; },
/* harmony export */   "QT": function() { return /* binding */ getTimePolicyStartOfDayforDate; },
/* harmony export */   "Vo": function() { return /* binding */ getTimePolicyEndOfDayforDate; },
/* harmony export */   "ZP": function() { return /* binding */ countMsInTimePolicy; },
/* harmony export */   "bc": function() { return /* binding */ timePolicyHasHomogenousHours; },
/* harmony export */   "lC": function() { return /* binding */ validateTimePolicy; },
/* harmony export */   "sR": function() { return /* binding */ dayCountOfDurationOverlapInTimePolicy; },
/* harmony export */   "xv": function() { return /* binding */ scanTimePolicyForNearestEndOfDay; }
/* harmony export */ });
/* unused harmony exports countMsInLocalTimeInterval, dateOverlapsTimePolicy */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69119);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24002);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29422);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59910);
/* harmony import */ var _dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26958);
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45110);
/* harmony import */ var _time__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36832);





var countMsInLocalTimeInterval = function(interval) {
    if (typeof interval.duration === "number") return interval.duration * _dates__WEBPACK_IMPORTED_MODULE_0__/* .MILLISECONDS_PER_SECOND */ .s9;
    var startMs = (0,_dates__WEBPACK_IMPORTED_MODULE_0__/* .msInHHMMSS */ .vt)(interval.start);
    var endMs = (0,_dates__WEBPACK_IMPORTED_MODULE_0__/* .msInHHMMSS */ .vt)(interval.end);
    return endMs - startMs;
};
var countMsInTimePolicy = function(timePolicy) {
    return Object.values(timePolicy.dayHours).reduce(function(totalMs, dayHours) {
        return totalMs + dayHours.intervals.reduce(function(dayMs, interval) {
            return dayMs + countMsInLocalTimeInterval(interval);
        }, 0);
    }, 0);
};
var testIntervalsForDateOverlap = function(intervals, date) {
    var relativeDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date);
    return !!intervals.find(function(interval) {
        var start = (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(interval.start, "HH:mm:ss", relativeDate);
        var end = (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(interval.end, "HH:mm:ss", relativeDate);
        return start.getTime() <= date.getTime() && end.getTime() >= date.getTime();
    });
};
var timeOfDayOverlapsTimePolicy = function(policy, time) {
    var timeAsDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(time, "HH:mm:ss", new Date());
    return !!Object.keys(policy.dayHours).find(function(day) {
        var ref;
        var intervals = (ref = policy.dayHours[day]) === null || ref === void 0 ? void 0 : ref.intervals;
        return !!intervals && testIntervalsForDateOverlap(intervals, timeAsDate);
    });
};
var dateOverlapsTimePolicy = function(policy, date) {
    var ref;
    var day = getDayOfWeekFromDate(date);
    var intervals = (ref = policy.dayHours[day]) === null || ref === void 0 ? void 0 : ref.intervals;
    return !!intervals && testIntervalsForDateOverlap(intervals, date);
};
var scanTimePolicyForNearestEndOfDay = function(policy, date) {
    var scanForward = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var endOfDay;
    var dayScanLimit = 0;
    var scanDate = date;
    var scanDay = (0,_dates__WEBPACK_IMPORTED_MODULE_0__/* .getDayOfWeekFromDate */ .xh)(scanDate);
    while(!endOfDay && dayScanLimit <= 6){
        var ref;
        var endCheck = (ref = policy.dayHours[scanDay]) === null || ref === void 0 ? void 0 : ref.endOfDay;
        var endDate = !!endCheck ? (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(endCheck, "HH:mm:ss", scanDate) : undefined;
        var reverseCheck = scanForward || endDate && (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) < date.getTime();
        if (endCheck && endDate && reverseCheck) {
            var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(endCheck.split(":"), 1), hours = ref1[0];
            scanDate.setHours(+hours);
            endOfDay = scanDate;
        } else {
            scanDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(scanDate, {
                days: scanForward ? 1 : -1
            }));
            scanDay = (0,_dates__WEBPACK_IMPORTED_MODULE_0__/* .getDayOfWeekFromDate */ .xh)(scanDate);
            dayScanLimit++;
        }
    }
    return endOfDay;
};
var getTimePolicyStartOfDayforDate = function(policy, date) {
    var ref, ref1, ref2;
    var day = (0,_dates__WEBPACK_IMPORTED_MODULE_0__/* .getDayOfWeekFromDate */ .xh)(date);
    var hourOfDay = (ref = policy.dayHours[day]) === null || ref === void 0 ? void 0 : (ref1 = ref.intervals) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.start;
    return !!hourOfDay ? (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(hourOfDay, "HH:mm:ss", (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date)) : undefined;
};
var getTimePolicyEndOfDayforDate = function(policy, date) {
    var ref;
    var day = (0,_dates__WEBPACK_IMPORTED_MODULE_0__/* .getDayOfWeekFromDate */ .xh)(date);
    var hourOfDay = (ref = policy.dayHours[day]) === null || ref === void 0 ? void 0 : ref.endOfDay;
    return !!hourOfDay ? (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(hourOfDay, "HH:mm:ss", (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date)) : undefined;
};
var timePolicyHasHomogenousHours = function(policy) {
    var isHomogeneous = true;
    var testInterval;
    (0,_objects__WEBPACK_IMPORTED_MODULE_1__/* .typedKeys */ .Nw)(policy.dayHours).find(function(day) {
        var ref;
        (ref = policy.dayHours[day]) === null || ref === void 0 ? void 0 : ref.intervals.find(function(interval) {
            if (!testInterval) {
                testInterval = interval;
            }
            if (testInterval.start !== interval.start || testInterval.end !== interval.end) {
                isHomogeneous = false;
            }
            return !isHomogeneous;
        });
        return !isHomogeneous;
    });
    return isHomogeneous;
};
var dayCountOfDurationOverlapInTimePolicy = function(policy, durationMs) {
    var relativeDate = new Date();
    var count = 0;
    (0,_objects__WEBPACK_IMPORTED_MODULE_1__/* .typedKeys */ .Nw)(policy.dayHours).forEach(function(day) {
        var ref;
        var intervalFit = (ref = policy.dayHours[day]) === null || ref === void 0 ? void 0 : ref.intervals.find(function(interval) {
            var start = (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(interval.start, "HH:mm:ss", relativeDate);
            var end = (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(interval.end, "HH:mm:ss", relativeDate);
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(end, start) >= durationMs;
        });
        if (intervalFit) count++;
    });
    return count;
};
var validateTimePolicy = function(value, format) {
    var errors = {};
    (0,_objects__WEBPACK_IMPORTED_MODULE_1__/* .typedKeys */ .Nw)(value.dayHours).forEach(function(day) {
        var ref;
        var intervals = (ref = value.dayHours[day]) === null || ref === void 0 ? void 0 : ref.intervals;
        intervals === null || intervals === void 0 ? void 0 : intervals.forEach(function(interval, i) {
            /**
       * Validate start interval
       */ if (!interval.start) {
                errors["dayHours.".concat(day, ".intervals.").concat(i, ".start")] = "invalid time";
            } else {
                var start = (0,_time__WEBPACK_IMPORTED_MODULE_7__/* .parseTime */ .T)(interval.start);
                if (!start) {
                    errors["dayHours.".concat(day, ".intervals.").concat(i, ".start")] = "invalid time";
                } else {
                    /**
           * Test if the start is before the end time of current interval
           */ var endBoundary = (0,_time__WEBPACK_IMPORTED_MODULE_7__/* .parseTime */ .T)((interval === null || interval === void 0 ? void 0 : interval.end) || "");
                    if (endBoundary && endBoundary.getTime() <= start.getTime()) {
                        errors["dayHours.".concat(day, ".intervals.").concat(i, ".start")] = "Must be before ".concat(format(endBoundary, "TIME_DISPLAY_FORMAT"));
                    } else {
                        var ref;
                        /**
             * Test if the start is after the previous interval's end
             */ var previousInterval = (ref = value.dayHours[day]) === null || ref === void 0 ? void 0 : ref.intervals[i - 1];
                        if (previousInterval === null || previousInterval === void 0 ? void 0 : previousInterval.end) {
                            var previousBoundary = (0,_time__WEBPACK_IMPORTED_MODULE_7__/* .parseTime */ .T)(previousInterval.end);
                            if (previousBoundary && previousBoundary.getTime() > start.getTime()) {
                                errors["dayHours.".concat(day, ".intervals.").concat(i, ".start")] = "Must be after ".concat(format(previousBoundary, "TIME_DISPLAY_FORMAT"));
                            }
                        }
                    }
                }
            }
            /**
       * Validate end interval
       */ if (!interval.end) {
                errors["dayHours.".concat(day, ".intervals.").concat(i, ".end")] = "invalid time";
            } else {
                var end = (0,_time__WEBPACK_IMPORTED_MODULE_7__/* .parseTime */ .T)(interval.end);
                if (!end) {
                    errors["dayHours.".concat(day, ".intervals.").concat(i, ".end")] = "invalid time";
                }
            }
        });
    });
    return Object.keys(errors).length === 0 ? undefined : errors;
};


/***/ }),

/***/ 36832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ awaitTime; },
/* harmony export */   "T": function() { return /* binding */ parseTime; }
/* harmony export */ });
/* harmony import */ var chrono_node__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15880);

/**
 * Returns a promise that resolves after ms milliseconds
 * @param ms the number of milliseconds to wait
 * @returns A valueless promise
 */ var awaitTime = function(ms) {
    return new Promise(function(res) {
        return setTimeout(res, ms);
    });
};
var parseTime = function(value, options) {
    if (!value) return undefined;
    // help lazy input look like something chrono can parse (eg. "1" => "1:00")
    var newValue = /^\d{0,2}$/.test(value.trim()) ? "".concat(value, ":00") : value;
    // 1:00a => 1:00 a
    newValue = newValue.replace(/(?![\d]+)([ap]m?)/i, function(m) {
        return " ".concat(m.toLowerCase());
    });
    // 2030 => 8:30 pm (note: limit length to eliminate conflicts with long dates)
    if (newValue.length <= 4) {
        newValue = newValue.replace(/([\d]{1,2}(?!:)[\d]{2})/i, function(m) {
            return "".concat(m.slice(0, -2), ":").concat(m.slice(-2));
        });
    }
    return (0,chrono_node__WEBPACK_IMPORTED_MODULE_0__/* .parseDate */ .sG)(newValue, undefined, options);
};


/***/ }),

/***/ 66201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$d": function() { return /* binding */ arrayOfAll; },
/* harmony export */   "L5": function() { return /* binding */ satisfies; }
/* harmony export */ });
/* unused harmony export enforceType */
/**
 * see: https://github.com/microsoft/TypeScript/issues/47920 and https://stackoverflow.com/questions/70956050
 *
 * use: `const dateMap = satisfies<Record<string, Date>>()({ "hello": new Date() });`.
 *
 * Allows type checking of const without widening of type.  Pass boundary type as generic, call without arguments, then call return type with the object you want to type-check as first argument.
 * @returns Function to pass value into which, in turn, returns exact same object.
 */ var satisfies = function() {
    return function(u) {
        return u;
    };
};
/**
 * see: https://stackoverflow.com/questions/60131681/make-sure-array-has-all-types-from-a-union
 *
 * use: `const dateMap = arrayOfAll<"a" | "b">()(["a", "b"]);`.
 *
 * Typechecks an array to make sure it has all values from a union.
 * @returns Function to pass array into which, in turn, returns exact same array.
 */ var arrayOfAll = function() {
    return function(array) {
        return array;
    };
};
var enforceType = function(thing) {
    return thing;
};


/***/ }),

/***/ 74648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OS": function() { return /* binding */ mapUIActionsReact; },
  "qU": function() { return /* binding */ mapUIActionsReactElement; },
  "$u": function() { return /* binding */ menuDivider; },
  "W3": function() { return /* binding */ useRenderUIAction; }
});

// UNUSED EXPORTS: mapUIActions

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/billing/EntitlementWrapper.tsx
var EntitlementWrapper = __webpack_require__(56630);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircleOutlineRounded.js
var CheckCircleOutlineRounded = __webpack_require__(97529);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircleRounded.js
var CheckCircleRounded = __webpack_require__(58442);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ErrorOutlineRounded.js
var ErrorOutlineRounded = __webpack_require__(90008);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ErrorRounded.js
var ErrorRounded = __webpack_require__(51182);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useCallbackSafeRef.ts
var useCallbackSafeRef = __webpack_require__(47310);
// EXTERNAL MODULE: ./src/hooks/useIsMountedRef.ts
var useIsMountedRef = __webpack_require__(60128);
;// CONCATENATED MODULE: ./src/hooks/useWaitFor.ts



function useWaitFor(ms) {
    var timerRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        return function() {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);
    var doTimeout = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(innerMS) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    new Promise(function(res) {
                        if (timerRef.current) clearTimeout(timerRef.current);
                        timerRef.current = setTimeout(res, typeof innerMS === "number" ? innerMS : ms);
                    })
                ];
            });
        });
        return function(innerMS) {
            return _ref.apply(this, arguments);
        };
    }(), [
        ms
    ]);
    return doTimeout;
}

;// CONCATENATED MODULE: ./src/hooks/usePromiseState.tsx










var DEFAULT_RESET_MS = 2000;
/**
 * Hook which provides a function which, when
 * passed a promise, indicates when the promise
 * is running, and (for a short while) when it
 * has errored or completed.
 *
 * If a promise is added before the previous one
 * completes, the state will remain in `running`
 * until all promises complete.
 * @param options options
 * @returns A tuple with the current proimse state, and a method to add more promises.
 */ var usePromiseState = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _resetMs = options.resetMs, resetMs = _resetMs === void 0 ? DEFAULT_RESET_MS : _resetMs, persistErrors = options.persistErrors;
    var ref = (0,react.useState)("idle"), state = ref[0], setState = ref[1];
    var promiseStackRef = (0,react.useRef)();
    var isMountedRef = (0,useIsMountedRef/* useIsMountedRef */.X)();
    var waitForReset = useWaitFor(resetMs);
    var addPromise = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(promise) {
            var currentPromise, isInvalid, beginReset, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (promiseStackRef.current) promiseStackRef.current = Promise.all([
                            promiseStackRef.current,
                            promise
                        ]);
                        else promiseStackRef.current = promise;
                        currentPromise = promiseStackRef.current;
                        isInvalid = function() {
                            return !isMountedRef.current || !(currentPromise === promiseStackRef.current);
                        };
                        beginReset = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                waitForReset()
                                            ];
                                        case 1:
                                            _state.sent();
                                            if (isInvalid()) return [
                                                2
                                            ];
                                            setState("idle");
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function beginReset() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        setState("running");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            7
                        ]);
                        return [
                            4,
                            currentPromise
                        ];
                    case 2:
                        _state.sent();
                        if (isInvalid()) return [
                            2
                        ];
                        setState("complete");
                        return [
                            4,
                            beginReset()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 4:
                        e = _state.sent();
                        if (isInvalid()) return [
                            2
                        ];
                        setState("error");
                        if (!!persistErrors) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            beginReset()
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            7
                        ];
                    case 7:
                        promiseStackRef.current = undefined;
                        return [
                            2
                        ];
                }
            });
        });
        return function(promise) {
            return _ref.apply(this, arguments);
        };
    }());
    return [
        state,
        addPromise
    ];
};
var ICON_MAP = {
    error: {
        onDark: ErrorRounded/* default */.Z,
        onLight: ErrorOutlineRounded/* default */.Z
    },
    complete: {
        onDark: CheckCircleRounded/* default */.Z,
        onLight: CheckCircleOutlineRounded/* default */.Z
    }
};
var getIconForPromiseState = function(state) {
    var variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "onDark";
    return ICON_MAP[state] ? /*#__PURE__*/ (0,react.createElement)(ICON_MAP[state][variant]) : undefined;
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./src/utils/arrays.ts
var arrays = __webpack_require__(92886);
;// CONCATENATED MODULE: ./src/utils/uiActions.tsx















function useRenderUIAction(wrapperType, uiAction, renderer) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var defaults = options.defaults, ref = options.ref, onClick = options.onClick, postAction = options.postAction, forceDisable = options.forceDisable;
    var objRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!ref) return;
        var passRef = function(ref) {
            switch(typeof ref === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(ref)){
                case "function":
                    ref(objRef.current);
                    break;
                case "object":
                    ref.current = objRef.current;
                    break;
            }
        };
        passRef(ref);
        if (typeof uiAction === "object" && !/*#__PURE__*/ (0,react.isValidElement)(uiAction) && uiAction.ref) passRef(uiAction.ref);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        objRef.current
    ]);
    var action = uiAction === null || uiAction === void 0 ? void 0 : uiAction.action;
    var ref1 = (0,_sliced_to_array/* default */.Z)(usePromiseState(), 2), promiseState = ref1[0], addPromise = ref1[1];
    var disabled = !!(uiAction === null || uiAction === void 0 ? void 0 : uiAction.disabled) || !!forceDisable || promiseState === "running";
    var handleClick = (0,useCallbackSafeRef/* useCallbackSafeRef */.T)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var promise;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.stopPropagation();
                        if (disabled) return [
                            2
                        ];
                        if (!action || typeof action === "string") return [
                            2
                        ];
                        promise = action(objRef);
                        addPromise(promise);
                        return [
                            4,
                            promise
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            onClick === null || onClick === void 0 ? void 0 : onClick(e, (0,_instanceof/* default */.Z)(promise, Promise) ? promise : Promise.resolve())
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            postAction === null || postAction === void 0 ? void 0 : postAction(e)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }());
    if (!uiAction) return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
    else if (typeof uiAction === "function") return uiAction(wrapperType);
    else if (/*#__PURE__*/ (0,react.isValidElement)(uiAction)) return uiAction;
    else {
        var actionObject = (0,_object_spread/* default */.Z)({}, defaults, uiAction);
        var entitlement = actionObject.entitlement, entitlementMode = actionObject.entitlementMode, action1 = actionObject.action, aoIcon = actionObject.icon;
        var isLink = typeof action1 === "string";
        var icon = getIconForPromiseState(promiseState) || aoIcon;
        if (entitlement) return /*#__PURE__*/ (0,jsx_runtime.jsx)(EntitlementWrapper/* EntitlementWrapper */.E, {
            entitlement: entitlement,
            mode: entitlementMode,
            children: function(param) {
                var chip = param.chip, entitlmentDisabled = param.disabled, message = param.message;
                return renderer({
                    actionObject: actionObject,
                    icon: icon,
                    isLink: isLink,
                    handleClick: handleClick,
                    ref: objRef,
                    disabled: disabled || entitlmentDisabled,
                    promiseState: promiseState,
                    entitlementChip: chip,
                    entitlementMessage: message
                });
            }
        });
        else return renderer({
            actionObject: actionObject,
            icon: icon,
            isLink: isLink,
            handleClick: handleClick,
            ref: objRef,
            disabled: disabled,
            promiseState: promiseState,
            entitlementChip: undefined,
            entitlementMessage: undefined
        });
    }
}
var menuDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {});
};
var mapUIActions = function(uiActions, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _keyPrefix = options.keyPrefix, keyPrefix = _keyPrefix === void 0 ? "" : _keyPrefix, separatorCb = options.separatorCb;
    if (keyPrefix) keyPrefix = "".concat(keyPrefix, "_");
    return uiActions.reduce(function(acc, uiAction, i) {
        var key = "".concat(i);
        if (typeof uiAction === "object" && !/*#__PURE__*/ (0,react.isValidElement)(uiAction) && uiAction.key) key = uiAction.key;
        key = "".concat(keyPrefix).concat(key);
        var data = {
            i: i,
            key: key
        };
        switch(uiAction){
            case "separator":
                if (separatorCb) acc.push(separatorCb(data));
                break;
            default:
                acc.push(cb(uiAction, data));
                break;
        }
        return acc;
    }, []);
};
var mapUIActionsReactElement = function(uiActions, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var separatorCb = options.separatorCb, restOptions = (0,_object_without_properties/* default */.Z)(options, [
        "separatorCb"
    ]);
    return (0,arrays/* filterFalsy */.SY)(mapUIActions(uiActions || [], function(uiAction, data) {
        return uiAction && /*#__PURE__*/ (0,react.cloneElement)(cb(uiAction, data), {
            key: data.key
        });
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restOptions), {
        separatorCb: separatorCb && function(data) {
            return /*#__PURE__*/ (0,react.cloneElement)(separatorCb(data), {
                key: data.key
            });
        }
    })));
};
var mapUIActionsReact = function(uiActions, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var separatorCb = options.separatorCb, restOptions = (0,_object_without_properties/* default */.Z)(options, [
        "separatorCb"
    ]);
    return mapUIActionsReactElement(uiActions, function(uiAction, data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: cb(uiAction, data)
        });
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restOptions), {
        separatorCb: separatorCb && function(data) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: separatorCb(data)
            });
        }
    }));
};


/***/ }),

/***/ 65934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ isSameDomain; },
/* harmony export */   "dx": function() { return /* binding */ urlWithQueryParams; },
/* harmony export */   "uq": function() { return /* binding */ queryObjectToStrParams; }
/* harmony export */ });
/* unused harmony export LOCAL_LINK_PATTERNS */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);


var LOCAL_LINK_PATTERNS = [
    /^(\w+\.)?api\.reclaim(\-test)?\.com/,
    /^api\.app\.reclaim\.ai/, 
];
function urlWithQueryParams(url, queryParams) {
    var urlWithProtocol = url.startsWith("https://") || url.startsWith("http://") ? url : "https://".concat(url);
    var patchedUrl = new URL(urlWithProtocol);
    Object.entries(queryParams).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (value) {
            patchedUrl.searchParams.append(key, value);
        }
    });
    return patchedUrl.toString();
}
var queryObjectToStrParams = function(params) {
    if (params === undefined) return "";
    var strQuery = Object.keys(params).reduce(function(values, k) {
        return !!params[k] ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(values).concat([
            "".concat(k, "=").concat(params[k])
        ]) : values;
    }, []);
    return strQuery.length ? "?" + strQuery.join("&") : "";
};
var isSameDomain = function(pathname) {
    if (false) {}
    if (!pathname) return true;
    // These pathnames can be from external sources so verify they are valid
    // with a try/catch.
    try {
        var hostname = new URL(pathname, window.location.href).hostname;
        if (hostname === window.location.hostname) return true;
        return !LOCAL_LINK_PATTERNS.every(function(regex) {
            return typeof regex === "string" ? regex !== hostname : !hostname.match(regex);
        });
    } catch (error) {
        return true;
    }
};


/***/ }),

/***/ 60811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ isEnvelope; },
/* harmony export */   "H": function() { return /* binding */ upsert; },
/* harmony export */   "T7": function() { return /* binding */ awaitSource; },
/* harmony export */   "vB": function() { return /* binding */ deserialize; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63496);



/**
 * Check to determine if a websocket payload is an Envelope
 *
 * @param object Either a deserialized websocket Envelope, or something else
 * @returns true if object is an Envelope, false otherwise
 */ function isEnvelope(object) {
    // TODO (IW): Check data matches D
    return object.data !== undefined && object.compressed !== undefined;
}
/**
 * Returns a promise with the value from the first update from observable$
 * @param observable$ The observable to watch
 * @param minWaitMS The minimum time to wait before reporting a value
 * @returns A promise with the value from observable$
 */ var awaitSource = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(observable$) {
        var options, _readResponse, readResponse, timeoutMS;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            _readResponse = options.readResponse, readResponse = _readResponse === void 0 ? function() {
                return true;
            } : _readResponse, timeoutMS = options.timeoutMS;
            return [
                2,
                new Promise(function(res) {
                    var timer;
                    var unsubscribe = (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .pipe */ .zG)(observable$, (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .subscribe */ .Ld)(function(value) {
                        if (readResponse(value)) {
                            clearTimeout(timer);
                            unsubscribe();
                            res(value);
                        }
                    })).unsubscribe;
                    if (typeof timeoutMS === "number") timer = setTimeout(function() {
                        unsubscribe();
                        res(undefined);
                    }, timeoutMS);
                })
            ];
        });
    });
    return function awaitSource(observable$) {
        return _ref.apply(this, arguments);
    };
}();
var deserialize = function(deser) {
    return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI)(function(val) {
        // If there's no value, return empty list
        if (!val) return [];
        // If val is an envelope, extract the data
        var data = isEnvelope(val) ? val.data : val;
        // Coerce data into a list
        var items = Array.isArray(data) ? data : [
            data
        ];
        // Deserialize items
        return items.map(deser);
    });
};
/**
 * Accumulate a list of items by adding, updating, and removing source data by pk
 *
 * @param getPk callback that takes an item and returns the primary key of the item
 * @returns Accumulated list after updating existing and adding new items
 */ var upsert = function(getPk) {
    return (0,wonka__WEBPACK_IMPORTED_MODULE_2__/* .scan */ .Kj)(function(acc, val) {
        // If there's no value, return empty list
        if (!val) return acc;
        // If val is an envelope, extract the data
        var data = isEnvelope(val) ? val.data : val;
        // Coerce data into a list
        var items = Array.isArray(data) ? data : [
            data
        ];
        // Add, update or delete each item based on pk
        items.forEach(function(i) {
            var pk = getPk(i);
            var deleted = !!i["deleted"]; // FIXME (IW): Assumes item uses a param for deleted state
            var index = undefined !== pk ? acc.findIndex(function(record) {
                return getPk(record) === pk;
            }) : -1;
            if (undefined === pk) console.warn("No PK for item", i);
            if (!!deleted) console.log("item deleted", pk, index, i);
            // If the item is deleted and not in the current accumulator do nothing
            if (!!deleted && index === -1) {
                return;
            }
            if (index === -1) acc.push(i);
            else !deleted ? acc.splice(index, 1, i) : acc.splice(index, 1);
        });
        return acc;
    }, []);
};


/***/ }),

/***/ 21876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 54865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__PBQjQ","alert":"App_alert__NED4D","content":"App_content__9bhON"};

/***/ }),

/***/ 58077:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"CircularProgressWithBackground_root__nGwct","foreground":"CircularProgressWithBackground_foreground__sLWPw","background":"CircularProgressWithBackground_background__8qqez","children":"CircularProgressWithBackground_children__E9D5h"};

/***/ }),

/***/ 58476:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"GenericInfoMessage_root__HaKR8","root--large":"GenericInfoMessage_root--large__paRQU","subtitle":"GenericInfoMessage_subtitle__Zivs_","root--small":"GenericInfoMessage_root--small__IvqoP","iconWrap":"GenericInfoMessage_iconWrap__FHqQG","iconWrap__icon":"GenericInfoMessage_iconWrap__icon__ry34y","root--extraSmall":"GenericInfoMessage_root--extraSmall__9YCwv","root--error":"GenericInfoMessage_root--error__rsC8J","root--corn":"GenericInfoMessage_root--corn__1S1_l","centered":"GenericInfoMessage_centered__Qhd35","actions":"GenericInfoMessage_actions__AUOjS"};

/***/ }),

/***/ 37107:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"GradientBackedVideo_root__M7WKz"};

/***/ }),

/***/ 38702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Helptip_root__fzDQH","root--grey":"Helptip_root--grey__ZK8kv","root--primary":"Helptip_root--primary__jUE5F","root--secondary":"Helptip_root--secondary__zgJRz","root--error":"Helptip_root--error__fFnVk","root--warn":"Helptip_root--warn__EoZSe","root--success":"Helptip_root--success__TPN6R","tooltip":"Helptip_tooltip__XbD_p","icon":"Helptip_icon__hVAFG","icon--superscript":"Helptip_icon--superscript__FxdtG","icon--emoji":"Helptip_icon--emoji__p9hld"};

/***/ }),

/***/ 30376:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__0m_RM","tooltip--disabled":"Tooltip_tooltip--disabled__D1LIw","titleWrapper":"Tooltip_titleWrapper__xkQtn","innerSpan":"Tooltip_innerSpan__91kW3"};

/***/ }),

/***/ 95981:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"UIActionButton_root__xiln0","root--link":"UIActionButton_root--link__d2Vl_","root--destructive":"UIActionButton_root--destructive__qMftK","root--running":"UIActionButton_root--running__0pB5h","opacity_pulse_keyframes__0_5__0_15":"UIActionButton_opacity_pulse_keyframes__0_5__0_15__T9Jwq","root--complete":"UIActionButton_root--complete__hNhha","root--error":"UIActionButton_root--error__bWUSj","icon":"UIActionButton_icon__SpVLD"};

/***/ }),

/***/ 56939:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionMenuPopper_root__9r6p5","paper":"ActionMenuPopper_paper__GpQbP","content":"ActionMenuPopper_content__G9Kqj","closeBtn":"ActionMenuPopper_closeBtn__bv0Qu"};

/***/ }),

/***/ 72245:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fixButton":"PlanLockedMessage_fixButton__JhAmg"};

/***/ }),

/***/ 63939:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"DateCalendarStylesWrapper_root__sF2rJ","MuiDateRangePickerDay-outsideCurrentMonth":"DateCalendarStylesWrapper_MuiDateRangePickerDay-outsideCurrentMonth__Ibu4w","MuiDateRangePickerDay-rangeIntervalDayPreview":"DateCalendarStylesWrapper_MuiDateRangePickerDay-rangeIntervalDayPreview__Du0SG","root--micro":"DateCalendarStylesWrapper_root--micro__AF1P2"};

/***/ }),

/***/ 81094:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popper":"DateTimePicker_popper__Vr_4C","paper":"DateTimePicker_paper__KaD1o","picker":"DateTimePicker_picker__2ei_p","picker--micro":"DateTimePicker_picker--micro__piMSe","timePickerBox":"DateTimePicker_timePickerBox__Gmo_5","timeDivider":"DateTimePicker_timeDivider__XgfAH","sectionTitle":"DateTimePicker_sectionTitle__Jw49X","divider":"DateTimePicker_divider__xdkaJ","inlinePicker":"DateTimePicker_inlinePicker__krx7g"};

/***/ }),

/***/ 71822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"LogWorkForm_root__gEXRM","input":"LogWorkForm_input__J2Jpf","input__input":"LogWorkForm_input__input__zH3l9","dateControl":"LogWorkForm_dateControl__hZ0kl","timeControl":"LogWorkForm_timeControl__6DKDA","progress":"LogWorkForm_progress__SREZm","focusProgressLabel":"LogWorkForm_focusProgressLabel__3XnGh","focusProgressSubLabel":"LogWorkForm_focusProgressSubLabel__TPKlX","flexFields":"LogWorkForm_flexFields__UqoJa","flexFields__label":"LogWorkForm_flexFields__label__oMsWg","flexFields__autoLabel":"LogWorkForm_flexFields__autoLabel__5L3GO","durationField":"LogWorkForm_durationField__r3uJu","submitBtn":"LogWorkForm_submitBtn__fKFY_"};

/***/ }),

/***/ 50658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"RhfRadioBoxGroupControl_root__nEoJO","content":"RhfRadioBoxGroupControl_content___IFCe","vertical":"RhfRadioBoxGroupControl_vertical__Jo5y5","horizontal":"RhfRadioBoxGroupControl_horizontal__Cpr1Y"};

/***/ }),

/***/ 64779:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Snackbar_root__1Efws","close":"Snackbar_close__3KcRx","closeIcon":"Snackbar_closeIcon__ssVyV","content":"Snackbar_content__LeAoW","content--dismissible":"Snackbar_content--dismissible__6Yvvl","colors--default":"Snackbar_colors--default__CFURN","colors--info":"Snackbar_colors--info__zmSc7","colors--error":"Snackbar_colors--error__iD7em","colors--warning":"Snackbar_colors--warning__D8D_Z","colors--success":"Snackbar_colors--success__deCsr","actionBtn":"Snackbar_actionBtn__5xejj","message":"Snackbar_message__GwY6Y"};

/***/ }),

/***/ 79853:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emphasize":"V17_quests_emphasize__vn9rg","descriptionList":"V17_quests_descriptionList__rf9Xb","inlineIcon":"V17_quests_inlineIcon__41XhQ","popperCopy":"V17_quests_popperCopy__CpzGX","priorityIcon":"V17_quests_priorityIcon__uNBo5","gcalIcon":"V17_quests_gcalIcon__u3q_w","count":"V17_quests_count___Llvf"};

/***/ }),

/***/ 50957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root--active":"TaskUpNextIcon_root--active__BdOKr"};

/***/ }),

/***/ 1200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"snackbarMessage":"notifications_snackbarMessage__gVO3W","appVersionRoot":"notifications_appVersionRoot__4h2H2","appVersionMessage":"notifications_appVersionMessage__0ltqQ","appVersionMessage__content":"notifications_appVersionMessage__content__SUoGf","appVersionMessage__icon":"notifications_appVersionMessage__icon__T7H4l"};

/***/ }),

/***/ 38927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breakpoints__xs":"0","breakpoints__sm":"600","breakpoints__md":"960","breakpoints__lg":"1280","breakpoints__xl":"1920","colors__black":"#000","colors__white":"#fff","colors__corn":"#ffc550","colors__cornLight":"#ffe7b6","colors__corn200":"rgba(255,197,80,.2)","colors__shrimp":"#ee9ab2","colors__blurple":"#5263f3","colors__blurple100":"#eeeffe","colors__blurple200":"#dce0fd","colors__blurple300":"#cbd0fb","colors__blurple400":"#bac1fa","colors__primary":"#5263f3","colors__primaryLight":"#7482f5","colors__secondary":"#ee9ab2","colors__primaryDark":"#1027e8","colors__error":"#d90303","colors__errorMain":"#b67777","colors__errorLight":"#f6d5d5","colors__errorDark":"#751919","colors__warningMain":"#f3cb64","colors__warningLight":"#f6efc8","colors__warningDark":"#7e590a","colors__successMain":"#02b345","colors__successLight":"#e6f3eb","colors__successDark":"#015c23","colors__softGrey":"#eaebf0","colors__divider":"rgba(0,0,0,.075)","colors__background":"#f7f8fc","colors__textPrimary":"rgba(0,0,0,.87)","colors__textSecondary":"rgba(0,0,0,.6)","colors__textDisabled":"rgba(0,0,0,.38)","colors__textLight":"#757575","colors__darkness":"#171d26","colors__darkness100":"#e8e8e9","colors__borderGrey":"rgba(23,29,38,.075)","colors__textGrey":"#757575","colors__grey":"#9e9e9e","colors__grey50":"#fafafa","colors__grey100":"#f5f5f5","colors__grey200":"#eaebf0","colors__grey300":"#e0e0e0","colors__grey400":"#bdbdbd","colors__grey500":"#9e9e9e","colors__grey600":"#757575","colors__grey700":"#616161","colors__grey800":"#424242","colors__grey900":"#212121","colors__statsMidnight":"#151f8b","colors__statsBlurple":"#5263f3","colors__statsCornflower":"#7d8aff","colors__statsCheese":"#e2b351","colors__statsCorn":"#ffc550","colors__statsButter":"#ffe583","colors__statsPink":"#f8c3d3","colors__statsShrimp":"#ee9ab2","colors__statsSalmon":"#ce7690","colors__statsGrey":"#eaebf0","colors__bg-grey":"#ebecf0","dims__spacing":"8","shape__borderRadius":"4","typography__fontWeightBold":"600","typography__fontWeightMedium":"500","typography__fontWeightRegular":"400","transitions__duration":"300","transitions__easing":"cubic-bezier(0.4, 0, 0.2, 1)"};

/***/ }),

/***/ 99513:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 54788:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 20377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "No": function() { return /* binding */ SnackbarContent; },
  "wT": function() { return /* binding */ SnackbarProvider; },
  "sy": function() { return /* binding */ closeSnackbar; },
  "yv": function() { return /* binding */ enqueueSnackbar; },
  "Ds": function() { return /* binding */ useSnackbar; }
});

// UNUSED EXPORTS: MaterialDesignContent, Transition

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./node_modules/goober/dist/goober.modern.js
let e={data:""},t=t=>"object"==typeof window?((t?t.querySelector("#_goober"):window._goober)||Object.assign((t||document.head).appendChild(document.createElement("style")),{innerHTML:" ",id:"_goober"})).firstChild:t||e,r=e=>{let r=t(e),l=r.data;return r.data="",l},l=/(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,a=/\/\*[^]*?\*\/|  +/g,n=/\n+/g,o=(e,t)=>{let r="",l="",a="";for(let n in e){let c=e[n];"@"==n[0]?"i"==n[1]?r=n+" "+c+";":l+="f"==n[1]?o(c,n):n+"{"+o(c,"k"==n[1]?"":t)+"}":"object"==typeof c?l+=o(c,t?t.replace(/([^,])+/g,e=>n.replace(/(^:.*)|([^,])+/g,t=>/&/.test(t)?t.replace(/&/g,e):e?e+" "+t:t)):n):null!=c&&(n=/^--/.test(n)?n:n.replace(/[A-Z]/g,"-$&").toLowerCase(),a+=o.p?o.p(n,c):n+":"+c+";")}return r+(t&&a?t+"{"+a+"}":a)+l},c={},s=e=>{if("object"==typeof e){let t="";for(let r in e)t+=r+s(e[r]);return t}return e},i=(e,t,r,i,p)=>{let u=s(e),d=c[u]||(c[u]=(e=>{let t=0,r=11;for(;t<e.length;)r=101*r+e.charCodeAt(t++)>>>0;return"go"+r})(u));if(!c[d]){let t=u!==e?e:(e=>{let t,r,o=[{}];for(;t=l.exec(e.replace(a,""));)t[4]?o.shift():t[3]?(r=t[3].replace(n," ").trim(),o.unshift(o[0][r]=o[0][r]||{})):o[0][t[1]]=t[2].replace(n," ").trim();return o[0]})(e);c[d]=o(p?{["@keyframes "+d]:t}:t,r?"":"."+d)}let f=r&&c.g?c.g:null;return r&&(c.g=c[d]),((e,t,r,l)=>{l?t.data=t.data.replace(l,e):-1===t.data.indexOf(e)&&(t.data=r?e+t.data:t.data+e)})(c[d],t,i,f),d},p=(e,t,r)=>e.reduce((e,l,a)=>{let n=t[a];if(n&&n.call){let e=n(r),t=e&&e.props&&e.props.className||/^go/.test(e)&&e;n=t?"."+t:e&&"object"==typeof e?e.props?"":o(e,""):!1===e?"":e}return e+l+(null==n?"":n)},"");function u(e){let r=this||{},l=e.call?e(r.p):e;return i(l.unshift?l.raw?p(l,[].slice.call(arguments,1),r.p):l.reduce((e,t)=>Object.assign(e,t&&t.call?t(r.p):t),{}):l,t(r.target),r.g,r.o,r.k)}let d,f,g,b=u.bind({g:1}),h=u.bind({k:1});function m(e,t,r,l){o.p=t,d=e,f=r,g=l}function j(e,t){let r=this||{};return function(){let l=arguments;function a(n,o){let c=Object.assign({},n),s=c.className||a.className;r.p=Object.assign({theme:f&&f()},c),r.o=/ *go\d+/.test(s),c.className=u.apply(r,l)+(s?" "+s:""),t&&(c.ref=o);let i=e;return e[0]&&(i=c.as||e,delete c.as),g&&i[0]&&g(c),d(i,c)}return t?t(a):a}}

;// CONCATENATED MODULE: ./node_modules/notistack/notistack.esm.js





function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var noOp = function noOp() {
  return '';
};

var SnackbarContext = /*#__PURE__*/react.createContext({
  enqueueSnackbar: noOp,
  closeSnackbar: noOp
});

var breakpoints = {
  downXs: '@media (max-width:599.95px)',
  upSm: '@media (min-width:600px)'
};

var capitalise = function capitalise(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

var originKeyExtractor = function originKeyExtractor(anchor) {
  return "" + capitalise(anchor.vertical) + capitalise(anchor.horizontal);
};
var isDefined = function isDefined(value) {
  return !!value || value === 0;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var appear = props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props["in"]) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else if (props.unmountOnExit || props.mountOnEnter) {
      initialStatus = UNMOUNTED;
    } else {
      initialStatus = EXITED;
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref["in"];

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  };

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props["in"]) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else if (status === ENTERING || status === ENTERED) {
        nextStatus = EXITING;
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var enter = timeout;
    var exit = timeout;

    if (timeout != null && typeof timeout !== 'number' && typeof timeout !== 'string') {
      exit = timeout.exit;
      enter = timeout.enter;
    }

    return {
      exit: exit,
      enter: enter
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var isAppearing = mounting;
    var timeouts = this.getTimeouts();

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        if (_this2.props.onEntered) {
          _this2.props.onEntered(_this2.node, isAppearing);
        }
      });
      return;
    }

    if (this.props.onEnter) {
      this.props.onEnter(this.node, isAppearing);
    }

    this.safeSetState({
      status: ENTERING
    }, function () {
      if (_this2.props.onEntering) {
        _this2.props.onEntering(_this2.node, isAppearing);
      }

      _this2.onTransitionEnd(timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          if (_this2.props.onEntered) {
            _this2.props.onEntered(_this2.node, isAppearing);
          }
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        if (_this3.props.onExited) {
          _this3.props.onExited(_this3.node);
        }
      });
      return;
    }

    if (this.props.onExit) {
      this.props.onExit(this.node);
    }

    this.safeSetState({
      status: EXITING
    }, function () {
      if (_this3.props.onExiting) {
        _this3.props.onExiting(_this3.node);
      }

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          if (_this3.props.onExited) {
            _this3.props.onExited(_this3.node);
          }
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null && this.nextCallback.cancel) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function () {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback();
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!this.node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(this.node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return children(status, childProps);
  };

  _createClass(Transition, [{
    key: "node",
    get: function get() {
      var _this$props$nodeRef;

      var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;

      if (!node) {
        throw new Error('notistack - Custom snackbar is not refForwarding');
      }

      return node;
    }
  }]);

  return Transition;
}(react.Component);

function noop() {//
}

Transition.defaultProps = {
  "in": false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};

/**
 * Credit to MUI team @ https://mui.com
 */
/**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return (0,react.useMemo)(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

function getTransitionProps(props) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      mode = props.mode;
  return {
    duration: typeof timeout === 'object' ? timeout[mode] || 0 : timeout,
    easing: style.transitionTimingFunction,
    delay: style.transitionDelay
  };
}

/**
 * Credit to MUI team @ https://mui.com
 */
var defaultEasing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * CSS hack to force a repaint
 */

var reflow = function reflow(node) {
  // We have to do something with node.scrollTop.
  // Otherwise it's removed from the compiled code by optimisers
  // eslint-disable-next-line no-self-assign
  node.scrollTop = node.scrollTop;
};

var formatMs = function formatMs(milliseconds) {
  return Math.round(milliseconds) + "ms";
};

function createTransition(props, options) {
  if (props === void 0) {
    props = ['all'];
  }

  var _ref = options || {},
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 300 : _ref$duration,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? defaultEasing.easeInOut : _ref$easing,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay;

  var properties = Array.isArray(props) ? props : [props];
  return properties.map(function (animatedProp) {
    var formattedDuration = typeof duration === 'string' ? duration : formatMs(duration);
    var formattedDelay = typeof delay === 'string' ? delay : formatMs(delay);
    return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
  }).join(',');
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */


function debounce(func, wait) {
  if (wait === void 0) {
    wait = 166;
  }

  var timeout;

  function debounced() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      // @ts-ignore
      func.apply(_this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */


function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var containerWindow = ownerWindow(node);
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  switch (direction) {
    case 'left':
      return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";

    case 'right':
      return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";

    case 'up':
      return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";

    default:
      // down
      return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
  }
}

function setTranslateValue(direction, node) {
  if (!node) return;
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}

var Slide = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props["in"],
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 0 : _props$timeout,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onExit = props.onExit,
      onExited = props.onExited,
      other = _objectWithoutPropertiesLoose(props, ["children", "direction", "in", "style", "timeout", "onEnter", "onEntered", "onExit", "onExited"]);

  var nodeRef = (0,react.useRef)(null);
  var handleRefIntermediary = useForkRef(children.ref, nodeRef);
  var handleRef = useForkRef(handleRefIntermediary, ref);

  var handleEnter = function handleEnter(node, isAppearing) {
    setTranslateValue(direction, node);
    reflow(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  var handleEntering = function handleEntering(node) {
    var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || defaultEasing.easeOut;
    var transitionProps = getTransitionProps({
      timeout: timeout,
      mode: 'enter',
      style: _extends({}, style, {
        transitionTimingFunction: easing
      })
    });
    node.style.webkitTransition = createTransition('-webkit-transform', transitionProps);
    node.style.transition = createTransition('transform', transitionProps);
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';
  };

  var handleExit = function handleExit(node) {
    var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || defaultEasing.sharp;
    var transitionProps = getTransitionProps({
      timeout: timeout,
      mode: 'exit',
      style: _extends({}, style, {
        transitionTimingFunction: easing
      })
    });
    node.style.webkitTransition = createTransition('-webkit-transform', transitionProps);
    node.style.transition = createTransition('transform', transitionProps);
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  };

  var handleExited = function handleExited(node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  };

  var updatePosition = (0,react.useCallback)(function () {
    if (nodeRef.current) {
      setTranslateValue(direction, nodeRef.current);
    }
  }, [direction]);
  (0,react.useEffect)(function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    var handleResize = debounce(function () {
      if (nodeRef.current) {
        setTranslateValue(direction, nodeRef.current);
      }
    });
    var containerWindow = ownerWindow(nodeRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp]);
  (0,react.useEffect)(function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return (0,react.createElement)(Transition, Object.assign({
    appear: true,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: onEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    "in": inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return (0,react.cloneElement)(children, _extends({
      ref: handleRef,
      style: _extends({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, {}, children.props.style)
    }, childProps));
  });
});
Slide.displayName = 'Slide';

var SvgIcon = function SvgIcon(props) {
  return react.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    focusable: "false",
    style: {
      fontSize: 20,
      marginInlineEnd: 8,
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0
    }
  }, props));
};

var CheckIcon = function CheckIcon() {
  return react.createElement(SvgIcon, null, react.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
  }));
};

var WarningIcon = function WarningIcon() {
  return react.createElement(SvgIcon, null, react.createElement("path", {
    d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
  }));
};

var ErrorIcon = function ErrorIcon() {
  return react.createElement(SvgIcon, null, react.createElement("path", {
    d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
  }));
};

var InfoIcon = function InfoIcon() {
  return react.createElement(SvgIcon, null, react.createElement("path", {
    d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
  }));
};

var defaultIconVariants = {
  "default": undefined,
  success: /*#__PURE__*/react.createElement(CheckIcon, null),
  warning: /*#__PURE__*/react.createElement(WarningIcon, null),
  error: /*#__PURE__*/react.createElement(ErrorIcon, null),
  info: /*#__PURE__*/react.createElement(InfoIcon, null)
};

var defaults = {
  maxSnack: 3,
  persist: false,
  hideIconVariant: false,
  disableWindowBlurListener: false,
  variant: 'default',
  autoHideDuration: 5000,
  iconVariant: defaultIconVariants,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  TransitionComponent: Slide,
  transitionDuration: {
    enter: 225,
    exit: 195
  }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */

var getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
  var isNumberOrNull = function isNumberOrNull(numberish) {
    return typeof numberish === 'number' || numberish === null;
  };

  if (isNumberOrNull(optionsDuration)) return optionsDuration;
  if (isNumberOrNull(propsDuration)) return propsDuration;
  return defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */


var getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
  var is = function is(item, types) {
    return types.some(function (t) {
      return typeof item === t;
    });
  };

  if (is(optionsDuration, ['string', 'number'])) {
    return optionsDuration;
  }

  if (is(optionsDuration, ['object'])) {
    return _extends({}, defaults.transitionDuration, {}, is(propsDuration, ['object']) && propsDuration, {}, optionsDuration);
  }

  if (is(propsDuration, ['string', 'number'])) {
    return propsDuration;
  }

  if (is(propsDuration, ['object'])) {
    return _extends({}, defaults.transitionDuration, {}, propsDuration);
  }

  return defaults.transitionDuration;
};

var merge = function merge(options, props) {
  return function (name, shouldObjectMerge) {
    if (shouldObjectMerge === void 0) {
      shouldObjectMerge = false;
    }

    if (shouldObjectMerge) {
      return _extends({}, defaults[name], {}, props[name], {}, options[name]);
    }

    if (name === 'autoHideDuration') {
      return getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
    }

    if (name === 'transitionDuration') {
      return getTransitionDuration(options.transitionDuration, props.transitionDuration);
    }

    return options[name] || props[name] || defaults[name];
  };
};

function makeStyles(styles) {
  return Object.entries(styles).reduce(function (acc, _ref) {
    var _extends2;

    var key = _ref[0],
        value = _ref[1];
    return _extends({}, acc, (_extends2 = {}, _extends2[key] = u(value), _extends2));
  }, {});
}
var ComponentClasses = {
  SnackbarContainer: 'notistack-SnackbarContainer',
  Snackbar: 'notistack-Snackbar',
  CollapseWrapper: 'notistack-CollapseWrapper',
  MuiContent: 'notistack-MuiContent',
  MuiContentVariant: function MuiContentVariant(variant) {
    return "notistack-MuiContent-" + variant;
  }
};

var classes = /*#__PURE__*/makeStyles({
  root: {
    height: 0
  },
  entered: {
    height: 'auto'
  }
});
var collapsedSize = '0px';
var timeout = 175;
var Collapse = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var children = props.children,
      inProp = props["in"],
      onExited = props.onExited;
  var wrapperRef = (0,react.useRef)(null);
  var nodeRef = (0,react.useRef)(null);
  var handleRef = useForkRef(ref, nodeRef);

  var getWrapperSize = function getWrapperSize() {
    return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
  };

  var handleEnter = function handleEnter(node) {
    node.style.height = collapsedSize;
  };

  var handleEntering = function handleEntering(node) {
    var wrapperSize = getWrapperSize();

    var _getTransitionProps = getTransitionProps({
      timeout: timeout,
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        easing = _getTransitionProps.easing;

    node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
    node.style.height = wrapperSize + "px";
    node.style.transitionTimingFunction = easing || '';
  };

  var handleEntered = function handleEntered(node) {
    node.style.height = 'auto';
  };

  var handleExit = function handleExit(node) {
    node.style.height = getWrapperSize() + "px";
  };

  var handleExiting = function handleExiting(node) {
    reflow(node);

    var _getTransitionProps2 = getTransitionProps({
      timeout: timeout,
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        easing = _getTransitionProps2.easing;

    node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
    node.style.height = collapsedSize;
    node.style.transitionTimingFunction = easing || '';
  };

  return (0,react.createElement)(Transition, {
    "in": inProp,
    unmountOnExit: true,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: onExited,
    onExiting: handleExiting,
    nodeRef: nodeRef,
    timeout: timeout
  }, function (state, childProps) {
    return (0,react.createElement)("div", Object.assign({
      ref: handleRef,
      className: (0,clsx_m/* default */.Z)(classes.root, state === 'entered' && classes.entered),
      style: _extends({
        pointerEvents: 'all',
        overflow: 'hidden',
        minHeight: collapsedSize,
        transition: createTransition('height')
      }, state === 'entered' && {
        overflow: 'visible'
      }, {}, state === 'exited' && !inProp && {
        visibility: 'hidden'
      })
    }, childProps), (0,react.createElement)("div", {
      ref: wrapperRef,
      className: ComponentClasses.CollapseWrapper,
      // Hack to get children with a negative margin to not falsify the height computation.
      style: {
        display: 'flex',
        width: '100%'
      }
    }, children));
  });
});
Collapse.displayName = 'Collapse';

var direction = {
  right: 'left',
  left: 'right',
  bottom: 'up',
  top: 'down'
};
var getSlideDirection = function getSlideDirection(anchorOrigin) {
  if (anchorOrigin.horizontal !== 'center') {
    return direction[anchorOrigin.horizontal];
  }

  return direction[anchorOrigin.vertical];
};
/** Tranforms classes name */

var toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
  return "anchorOrigin" + originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */

var keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
  if (classes === void 0) {
    classes = {};
  }

  var containerClasses = {
    containerRoot: true,
    containerAnchorOriginTopCenter: true,
    containerAnchorOriginBottomCenter: true,
    containerAnchorOriginTopRight: true,
    containerAnchorOriginBottomRight: true,
    containerAnchorOriginTopLeft: true,
    containerAnchorOriginBottomLeft: true
  };
  return Object.keys(classes).filter(function (key) {
    return !containerClasses[key];
  }).reduce(function (obj, key) {
    var _extends2;

    return _extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
  }, {});
};

var noOp$1 = function noOp() {
  /* */
};
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */


function createChainedFunction(funcs, snackbarId) {
  // @ts-ignore
  return funcs.reduce(function (acc, func) {
    if (func === null || func === undefined) {
      return acc;
    }

    return function chainedFunction() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var argums = [].concat(args);

      if (snackbarId && argums.indexOf(snackbarId) === -1) {
        argums.push(snackbarId);
      } // @ts-ignore


      acc.apply(this, argums);
      func.apply(this, argums);
    };
  }, noOp$1);
}

/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */
var useEnhancedEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
function useEventCallback(fn) {
  var ref = (0,react.useRef)(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return (0,react.useCallback)(function () {
    return (// @ts-expect-error hide `this`
      (ref.current).apply(void 0, arguments)
    );
  }, []);
}

/**
 * Credit to MUI team @ https://mui.com
 */
var Snackbar = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var children = props.children,
      className = props.className,
      autoHideDuration = props.autoHideDuration,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      onClose = props.onClose,
      id = props.id,
      open = props.open,
      _props$SnackbarProps = props.SnackbarProps,
      SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
  var timerAutoHide = (0,react.useRef)();
  var handleClose = useEventCallback(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = useEventCallback(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    if (timerAutoHide.current) {
      clearTimeout(timerAutoHide.current);
    }

    timerAutoHide.current = setTimeout(function () {
      handleClose(null, 'timeout', id);
    }, autoHideDurationParam);
  });
  (0,react.useEffect)(function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      if (timerAutoHide.current) {
        clearTimeout(timerAutoHide.current);
      }
    };
  }, [open, autoHideDuration, setAutoHideTimer]);
  /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */

  var handlePause = function handlePause() {
    if (timerAutoHide.current) {
      clearTimeout(timerAutoHide.current);
    }
  };
  /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */


  var handleResume = (0,react.useCallback)(function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(autoHideDuration * 0.5);
    }
  }, [autoHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (SnackbarProps.onMouseEnter) {
      SnackbarProps.onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (SnackbarProps.onMouseLeave) {
      SnackbarProps.onMouseLeave(event);
    }

    handleResume();
  };

  (0,react.useEffect)(function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]);
  return (0,react.createElement)("div", Object.assign({
    ref: ref
  }, SnackbarProps, {
    className: (0,clsx_m/* default */.Z)(ComponentClasses.Snackbar, className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }), children);
});
Snackbar.displayName = 'Snackbar';

var _root;
var classes$1 = /*#__PURE__*/makeStyles({
  root: (_root = {
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1
  }, _root[breakpoints.upSm] = {
    flexGrow: 'initial',
    minWidth: '288px'
  }, _root)
});
var SnackbarContent = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return react.createElement("div", Object.assign({
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes$1.root, className)
  }, props));
});
SnackbarContent.displayName = 'SnackbarContent';

var classes$2 = /*#__PURE__*/makeStyles({
  root: {
    backgroundColor: '#313131',
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: '0.01071em',
    color: '#fff',
    alignItems: 'center',
    padding: '6px 16px',
    borderRadius: '4px',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
  },
  lessPadding: {
    paddingLeft: 8 * 2.5 + "px"
  },
  "default": {
    backgroundColor: '#313131'
  },
  success: {
    backgroundColor: '#43a047'
  },
  error: {
    backgroundColor: '#d32f2f'
  },
  warning: {
    backgroundColor: '#ff9800'
  },
  info: {
    backgroundColor: '#2196f3'
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0'
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: '16px',
    marginRight: '-8px'
  }
});
var ariaDescribedby = 'notistack-snackbar';
var MaterialDesignContent = /*#__PURE__*/(0,react.forwardRef)(function (props, forwardedRef) {
  var id = props.id,
      message = props.message,
      componentOrFunctionAction = props.action,
      iconVariant = props.iconVariant,
      variant = props.variant,
      hideIconVariant = props.hideIconVariant,
      style = props.style,
      className = props.className;
  var icon = iconVariant[variant];
  var action = componentOrFunctionAction;

  if (typeof action === 'function') {
    action = action(id);
  }

  return react.createElement(SnackbarContent, {
    ref: forwardedRef,
    role: "alert",
    "aria-describedby": ariaDescribedby,
    style: style,
    className: (0,clsx_m/* default */.Z)(ComponentClasses.MuiContent, ComponentClasses.MuiContentVariant(variant), classes$2.root, classes$2[variant], className, !hideIconVariant && icon && classes$2.lessPadding)
  }, react.createElement("div", {
    id: ariaDescribedby,
    className: classes$2.message
  }, !hideIconVariant ? icon : null, message), action && react.createElement("div", {
    className: classes$2.action
  }, action));
});
MaterialDesignContent.displayName = 'MaterialDesignContent';
var MaterialDesignContent$1 = /*#__PURE__*/(0,react.memo)(MaterialDesignContent);

var styles = /*#__PURE__*/makeStyles({
  wrappedRoot: {
    width: '100%',
    position: 'relative',
    transform: 'translateX(0)',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    minWidth: '288px'
  }
});

var SnackbarItem = function SnackbarItem(props) {
  var timeout = (0,react.useRef)();

  var _useState = (0,react.useState)(true),
      collapsed = _useState[0],
      setCollapsed = _useState[1];

  var handleClose = createChainedFunction([props.snack.onClose, props.onClose]);

  var handleEntered = function handleEntered() {
    if (props.snack.requestClose) {
      handleClose(null, 'instructed', props.snack.id);
    }
  };

  var handleExitedScreen = (0,react.useCallback)(function () {
    timeout.current = setTimeout(function () {
      setCollapsed(function (col) {
        return !col;
      });
    }, 125);
  }, []);
  (0,react.useEffect)(function () {
    return function () {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);
  var snack = props.snack,
      allClasses = props.classes,
      _props$Component = props.Component,
      Component = _props$Component === void 0 ? MaterialDesignContent$1 : _props$Component;
  var classes = (0,react.useMemo)(function () {
    return keepSnackbarClassKeys(allClasses);
  }, [allClasses]);

  var open = snack.open,
      SnackbarProps = snack.SnackbarProps,
      TransitionComponent = snack.TransitionComponent,
      TransitionProps = snack.TransitionProps,
      transitionDuration = snack.transitionDuration,
      disableWindowBlurListener = snack.disableWindowBlurListener,
      componentOrFunctionContent = snack.content,
      otherSnack = _objectWithoutPropertiesLoose(snack, ["open", "SnackbarProps", "TransitionComponent", "TransitionProps", "transitionDuration", "disableWindowBlurListener", "content", "entered", "requestClose", "onEnter", "onEntered", "onExit", "onExited"]);

  var transitionProps = _extends({
    direction: getSlideDirection(otherSnack.anchorOrigin),
    timeout: transitionDuration
  }, TransitionProps);

  var content = componentOrFunctionContent;

  if (typeof content === 'function') {
    content = content(otherSnack.id, otherSnack.message);
  }

  var callbacks = ['onEnter', 'onEntered', 'onExit', 'onExited'].reduce(function (acc, cbName) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[cbName] = createChainedFunction([props.snack[cbName], props[cbName]], otherSnack.id), _extends2));
  }, {});
  return react.createElement(Collapse, {
    "in": collapsed,
    onExited: callbacks.onExited
  }, react.createElement(Snackbar, {
    open: open,
    id: otherSnack.id,
    disableWindowBlurListener: disableWindowBlurListener,
    autoHideDuration: otherSnack.autoHideDuration,
    className: (0,clsx_m/* default */.Z)(styles.wrappedRoot, classes.root, classes[toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
    SnackbarProps: SnackbarProps,
    onClose: handleClose
  }, react.createElement(TransitionComponent, Object.assign({}, transitionProps, {
    appear: true,
    "in": open,
    onExit: callbacks.onExit,
    onExited: handleExitedScreen,
    onEnter: callbacks.onEnter,
    // order matters. first callbacks.onEntered to set entered: true,
    // then handleEntered to check if there's a request for closing
    onEntered: createChainedFunction([callbacks.onEntered, handleEntered], otherSnack.id)
  }), content || react.createElement(Component, Object.assign({}, otherSnack)))));
};

var _root$1, _rootDense, _left, _right, _center;
var indents = {
  view: {
    "default": 20,
    dense: 4
  },
  snackbar: {
    "default": 6,
    dense: 2
  }
};
var collapseWrapper = "." + ComponentClasses.CollapseWrapper;
var xsWidthMargin = 16;
var styles$1 = /*#__PURE__*/makeStyles({
  root: (_root$1 = {
    boxSizing: 'border-box',
    display: 'flex',
    maxHeight: '100%',
    position: 'fixed',
    zIndex: 1400,
    height: 'auto',
    width: 'auto',
    transition: /*#__PURE__*/createTransition(['top', 'right', 'bottom', 'left', 'max-width'], {
      duration: 300,
      easing: 'ease'
    }),
    // container itself is invisible and should not block clicks, clicks should be passed to its children
    // a pointerEvents: all is applied in the collapse component
    pointerEvents: 'none'
  }, _root$1[collapseWrapper] = {
    padding: indents.snackbar["default"] + "px 0px",
    transition: 'padding 300ms ease 0ms'
  }, _root$1.maxWidth = "calc(100% - " + indents.view["default"] * 2 + "px)", _root$1[breakpoints.downXs] = {
    width: '100%',
    maxWidth: "calc(100% - " + xsWidthMargin * 2 + "px)"
  }, _root$1),
  rootDense: (_rootDense = {}, _rootDense[collapseWrapper] = {
    padding: indents.snackbar.dense + "px 0px"
  }, _rootDense),
  top: {
    top: indents.view["default"] - indents.snackbar["default"] + "px",
    flexDirection: 'column'
  },
  bottom: {
    bottom: indents.view["default"] - indents.snackbar["default"] + "px",
    flexDirection: 'column-reverse'
  },
  left: (_left = {
    left: indents.view["default"] + "px"
  }, _left[breakpoints.upSm] = {
    alignItems: 'flex-start'
  }, _left[breakpoints.downXs] = {
    left: xsWidthMargin + "px"
  }, _left),
  right: (_right = {
    right: indents.view["default"] + "px"
  }, _right[breakpoints.upSm] = {
    alignItems: 'flex-end'
  }, _right[breakpoints.downXs] = {
    right: xsWidthMargin + "px"
  }, _right),
  center: (_center = {
    left: '50%',
    transform: 'translateX(-50%)'
  }, _center[breakpoints.upSm] = {
    alignItems: 'center'
  }, _center)
});

var SnackbarContainer = function SnackbarContainer(props) {
  var _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      anchorOrigin = props.anchorOrigin,
      dense = props.dense,
      children = props.children;
  var combinedClassname = (0,clsx_m/* default */.Z)(ComponentClasses.SnackbarContainer, styles$1[anchorOrigin.vertical], styles$1[anchorOrigin.horizontal], styles$1.root, // root should come after others to override maxWidth
  classes.containerRoot, classes["containerAnchorOrigin" + originKeyExtractor(anchorOrigin)], dense && styles$1.rootDense);
  return react.createElement("div", {
    className: combinedClassname
  }, children);
};

var SnackbarContainer$1 = /*#__PURE__*/(0,react.memo)(SnackbarContainer);

/* eslint-disable */
var __DEV__ = (/* unused pure expression or super */ null && ("production" !== 'production'));

var messages = {
  NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var warning = (function (messageKey) {
  if (!__DEV__) return;
  var message = messages[messageKey];

  if (typeof console !== 'undefined') {
    console.error("WARNING - notistack: " + message);
  }

  try {
    throw new Error(message);
  } catch (x) {}
});

var isOptions = function isOptions(messageOrOptions) {
  var isMessage = typeof messageOrOptions === 'string' || (0,react.isValidElement)(messageOrOptions);
  return !isMessage;
};

var enqueueSnackbar;
var closeSnackbar;

var SnackbarProvider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SnackbarProvider, _Component);

  function SnackbarProvider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */

    _this.enqueueSnackbar = function (messageOrOptions, optsOrUndefined) {
      if (optsOrUndefined === void 0) {
        optsOrUndefined = {};
      }

      if (messageOrOptions === undefined || messageOrOptions === null) {
        throw new Error('enqueueSnackbar called with invalid argument');
      }

      var opts = isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
      var message = isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;

      var key = opts.key,
          preventDuplicate = opts.preventDuplicate,
          options = _objectWithoutPropertiesLoose(opts, ["key", "preventDuplicate"]);

      var hasSpecifiedKey = isDefined(key);
      var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
      var merger = merge(options, _this.props);

      var snack = _extends({
        id: id
      }, options, {
        message: message,
        open: true,
        entered: false,
        requestClose: false,
        persist: merger('persist'),
        action: merger('action'),
        content: merger('content'),
        variant: merger('variant'),
        anchorOrigin: merger('anchorOrigin'),
        disableWindowBlurListener: merger('disableWindowBlurListener'),
        autoHideDuration: merger('autoHideDuration'),
        hideIconVariant: merger('hideIconVariant'),
        TransitionComponent: merger('TransitionComponent'),
        transitionDuration: merger('transitionDuration'),
        TransitionProps: merger('TransitionProps', true),
        iconVariant: merger('iconVariant', true),
        style: merger('style', true),
        SnackbarProps: merger('SnackbarProps', true),
        className: (0,clsx_m/* default */.Z)(_this.props.className, options.className)
      });

      if (snack.persist) {
        snack.autoHideDuration = undefined;
      }

      _this.setState(function (state) {
        if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
          var compareFunction = function compareFunction(item) {
            return hasSpecifiedKey ? item.id === id : item.message === message;
          };

          var inQueue = state.queue.findIndex(compareFunction) > -1;
          var inView = state.snacks.findIndex(compareFunction) > -1;

          if (inQueue || inView) {
            return state;
          }
        }

        return _this.handleDisplaySnack(_extends({}, state, {
          queue: [].concat(state.queue, [snack])
        }));
      });

      return id;
    };
    /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */


    _this.handleDisplaySnack = function (state) {
      var snacks = state.snacks;

      if (snacks.length >= _this.maxSnack) {
        return _this.handleDismissOldest(state);
      }

      return _this.processQueue(state);
    };
    /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */


    _this.processQueue = function (state) {
      var queue = state.queue,
          snacks = state.snacks;

      if (queue.length > 0) {
        return _extends({}, state, {
          snacks: [].concat(snacks, [queue[0]]),
          queue: queue.slice(1, queue.length)
        });
      }

      return state;
    };
    /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */


    _this.handleDismissOldest = function (state) {
      if (state.snacks.some(function (item) {
        return !item.open || item.requestClose;
      })) {
        return state;
      }

      var popped = false;
      var ignore = false;
      var persistentCount = state.snacks.reduce(function (acc, current) {
        return acc + (current.open && current.persist ? 1 : 0);
      }, 0);

      if (persistentCount === _this.maxSnack) {
         false ? 0 : void 0;
        ignore = true;
      }

      var snacks = state.snacks.map(function (item) {
        if (!popped && (!item.persist || ignore)) {
          popped = true;

          if (!item.entered) {
            return _extends({}, item, {
              requestClose: true
            });
          }

          if (item.onClose) {
            item.onClose(null, 'maxsnack', item.id);
          }

          if (_this.props.onClose) {
            _this.props.onClose(null, 'maxsnack', item.id);
          }

          return _extends({}, item, {
            open: false
          });
        }

        return _extends({}, item);
      });
      return _extends({}, state, {
        snacks: snacks
      });
    };
    /**
     * Set the entered state of the snackbar with the given key.
     */


    _this.handleEnteredSnack = function (node, isAppearing, key) {
      if (!isDefined(key)) {
        throw new Error('handleEnteredSnack Cannot be called with undefined key');
      }

      _this.setState(function (_ref) {
        var snacks = _ref.snacks;
        return {
          snacks: snacks.map(function (item) {
            return item.id === key ? _extends({}, item, {
              entered: true
            }) : _extends({}, item);
          })
        };
      });
    };
    /**
     * Hide a snackbar after its timeout.
     */


    _this.handleCloseSnack = function (event, reason, key) {
      // should not use createChainedFunction for onClose.
      // because this.closeSnackbar called this function
      if (_this.props.onClose) {
        _this.props.onClose(event, reason, key);
      }

      var shouldCloseAll = key === undefined;

      _this.setState(function (_ref2) {
        var snacks = _ref2.snacks,
            queue = _ref2.queue;
        return {
          snacks: snacks.map(function (item) {
            if (!shouldCloseAll && item.id !== key) {
              return _extends({}, item);
            }

            return item.entered ? _extends({}, item, {
              open: false
            }) : _extends({}, item, {
              requestClose: true
            });
          }),
          queue: queue.filter(function (item) {
            return item.id !== key;
          })
        };
      });
    };
    /**
     * Close snackbar with the given key
     */


    _this.closeSnackbar = function (key) {
      // call individual snackbar onClose callback passed through options parameter
      var toBeClosed = _this.state.snacks.find(function (item) {
        return item.id === key;
      });

      if (isDefined(key) && toBeClosed && toBeClosed.onClose) {
        toBeClosed.onClose(null, 'instructed', key);
      }

      _this.handleCloseSnack(null, 'instructed', key);
    };
    /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */


    _this.handleExitedSnack = function (node, key) {
      if (!isDefined(key)) {
        throw new Error('handleExitedSnack Cannot be called with undefined key');
      }

      _this.setState(function (state) {
        var newState = _this.processQueue(_extends({}, state, {
          snacks: state.snacks.filter(function (item) {
            return item.id !== key;
          })
        }));

        if (newState.queue.length === 0) {
          return newState;
        }

        return _this.handleDismissOldest(newState);
      });
    };

    enqueueSnackbar = _this.enqueueSnackbar;
    closeSnackbar = _this.closeSnackbar;
    _this.state = {
      snacks: [],
      queue: [],
      contextValue: {
        enqueueSnackbar: _this.enqueueSnackbar.bind(_assertThisInitialized(_this)),
        closeSnackbar: _this.closeSnackbar.bind(_assertThisInitialized(_this))
      }
    };
    return _this;
  }

  var _proto = SnackbarProvider.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var contextValue = this.state.contextValue;
    var _this$props = this.props,
        domRoot = _this$props.domRoot,
        children = _this$props.children,
        _this$props$dense = _this$props.dense,
        dense = _this$props$dense === void 0 ? false : _this$props$dense,
        _this$props$Component = _this$props.Components,
        Components = _this$props$Component === void 0 ? {} : _this$props$Component,
        classes = _this$props.classes;
    var categ = this.state.snacks.reduce(function (acc, current) {
      var _extends2;

      var category = originKeyExtractor(current.anchorOrigin);
      var existingOfCategory = acc[category] || [];
      return _extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [current]), _extends2));
    }, {});
    var snackbars = Object.keys(categ).map(function (origin) {
      var snacks = categ[origin];
      var nomineeSnack = snacks[0];
      return react.createElement(SnackbarContainer$1, {
        key: origin,
        dense: dense,
        anchorOrigin: nomineeSnack.anchorOrigin,
        classes: classes
      }, snacks.map(function (snack) {
        return react.createElement(SnackbarItem, {
          key: snack.id,
          snack: snack,
          classes: classes,
          Component: Components[snack.variant],
          onClose: _this2.handleCloseSnack,
          onEnter: _this2.props.onEnter,
          onExit: _this2.props.onExit,
          onExited: createChainedFunction([_this2.handleExitedSnack, _this2.props.onExited], snack.id),
          onEntered: createChainedFunction([_this2.handleEnteredSnack, _this2.props.onEntered], snack.id)
        });
      }));
    });
    return react.createElement(SnackbarContext.Provider, {
      value: contextValue
    }, children, domRoot ? (0,react_dom.createPortal)(snackbars, domRoot) : snackbars);
  };

  _createClass(SnackbarProvider, [{
    key: "maxSnack",
    get: function get() {
      return this.props.maxSnack || defaults.maxSnack;
    }
  }]);

  return SnackbarProvider;
}(react.Component);

var useSnackbar = (function () {
  return (0,react.useContext)(SnackbarContext);
});


//# sourceMappingURL=notistack.esm.js.map


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 11914:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),

/***/ 42283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": function() { return /* binding */ useFieldArray; },
/* harmony export */   "Gc": function() { return /* binding */ useFormContext; },
/* harmony export */   "Qr": function() { return /* binding */ Controller; },
/* harmony export */   "RV": function() { return /* binding */ FormProvider; },
/* harmony export */   "bc": function() { return /* binding */ useController; },
/* harmony export */   "cI": function() { return /* binding */ useForm; }
/* harmony export */ });
/* unused harmony exports appendErrors, get, set, useFormState, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (data) => data instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getControllerValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/.\d/)) || name;

var isNameInFieldArray = (names, name) => [...names].some((current) => getNodeParentName(name) === current);

var compact = (value) => value.filter(Boolean);

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (isObject(obj) && path) {
        const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => (isNullOrUndefined(result) ? result : result[key]), obj);
        return isUndefined(result) || result === obj
            ? isUndefined(obj[path])
                ? defaultValue
                : obj[path]
            : result;
    }
    return undefined;
};

const EVENTS = {
    BLUR: 'blur',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

var omit = (source, key) => {
    const copy = Object.assign({}, source);
    delete copy[key];
    return copy;
};

const FormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
FormContext.displayName = 'RHFContext';
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(FormContext);
const FormProvider = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormContext.Provider, { value: omit(props, 'children') }, props.children));

var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
    function createGetter(prop) {
        return () => {
            if (prop in formState) {
                if (_proxyFormState[prop] !== VALIDATION_MODE.all) {
                    _proxyFormState[prop] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[prop] = true);
                return formState[prop];
            }
            return undefined;
        };
    }
    const result = {};
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: createGetter(key),
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const formState = omit(formStateData, 'name');
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];

function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name } = props || {};
    const nameRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._formState);
    const _localProxyFormState = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    nameRef.current = name;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const formStateSubscription = control._subjects.state.subscribe({
            next: (formState) => (!nameRef.current ||
                !formState.name ||
                convertToArrayPayload(nameRef.current).includes(formState.name)) &&
                shouldRenderFormState(formState, _localProxyFormState.current) &&
                updateFormState(Object.assign(Object.assign({}, control._formState), formState)),
        });
        disabled && formStateSubscription.unsubscribe();
        return () => formStateSubscription.unsubscribe();
    }, [disabled, control]);
    return getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}

function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const [value, setInputStateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)));
    const formState = useFormState({
        control: control || methods.control,
        name,
    });
    const registerProps = control.register(name, Object.assign(Object.assign({}, props.rules), { value }));
    const updateMounted = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((name, value) => {
        const field = get(control._fields, name);
        if (field) {
            field._f.mount = value;
        }
    }, [control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const controllerSubscription = control._subjects.control.subscribe({
            next: (data) => (!data.name || name === data.name) &&
                setInputStateValue(get(data.values, name)),
        });
        updateMounted(name, true);
        return () => {
            controllerSubscription.unsubscribe();
            const _shouldUnregisterField = control._shouldUnregister || shouldUnregister;
            if (isNameInFieldArray(control._names.array, name)
                ? _shouldUnregisterField && !control._stateFlags.action
                : _shouldUnregisterField) {
                control.unregister(name);
            }
            else {
                updateMounted(name, false);
            }
        };
    }, [name, control, shouldUnregister, updateMounted]);
    return {
        field: {
            onChange: (event) => {
                const value = getControllerValue(event);
                setInputStateValue(value);
                registerProps.onChange({
                    target: {
                        value,
                        name: name,
                    },
                    type: EVENTS.CHANGE,
                });
            },
            onBlur: () => {
                registerProps.onBlur({
                    target: {
                        value,
                        name: name,
                    },
                    type: EVENTS.BLUR,
                });
            },
            name,
            value,
            ref: (elm) => {
                const field = get(control._fields, name);
                if (elm && field && elm.focus) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: {
            invalid: !!get(formState.errors, name),
            isDirty: !!get(formState.dirtyFields, name),
            isTouched: !!get(formState.touchedFields, name),
            error: get(formState.errors, name),
        },
    };
}

const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? Object.assign(Object.assign({}, errors[name]), { types: Object.assign(Object.assign({}, (errors[name] && errors[name].types ? errors[name].types : {})), { [type]: message || true }) }) : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const _f = field._f;
            const current = omit(field, '_f');
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && isUndefined(_f.ref.focus())) {
                    break;
                }
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(current)) {
                focusFieldBy(current, callback);
            }
        }
    }
};

var getFocusFieldName = (name, index, options) => options && !options.shouldFocus
    ? options.focusName || `${name}.${options.focusIndex}.`
    : `${name}.${index}.`;

var mapCurrentIds = (values, _fieldIds, keyName) => values.map((value, index) => {
    const output = _fieldIds.current[index];
    return Object.assign(Object.assign({}, value), (output ? { [keyName]: output[keyName] } : {}));
});

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var mapIds = (values = [], keyName) => values.map((value) => (Object.assign(Object.assign({}, (value[keyName] ? {} : { [keyName]: generateId() })), value)));

function append(data, value) {
    return [...convertToArrayPayload(data), ...convertToArrayPayload(value)];
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (Array.isArray(data)) {
        if (isUndefined(data[to])) {
            data[to] = undefined;
        }
        data.splice(to, 0, data.splice(from, 1)[0]);
        return data;
    }
    return [];
};

var omitKey = (fields, keyName) => fields.map((field = {}) => omit(field, keyName));

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

const useFieldArray = (props) => {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = react__WEBPACK_IMPORTED_MODULE_0__.useState(mapIds(control._getFieldArrayValue(name), keyName));
    const _fieldIds = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fields);
    _fieldIds.current = fields;
    control._names.array.add(name);
    const updateValues = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((updatedFieldArrayValuesWithKey) => {
        const updatedFieldArrayValues = omitKey(updatedFieldArrayValuesWithKey, keyName);
        set(control._formValues, name, updatedFieldArrayValues);
        setFields(updatedFieldArrayValuesWithKey);
        return updatedFieldArrayValues;
    }, [control, name, keyName]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(value);
        const updatedFieldArrayValuesWithKey = append(mapCurrentIds(control._getFieldArrayValue(name), _fieldIds, keyName), mapIds(appendValue, keyName));
        control._updateFieldArray(keyName, name, append, {
            argA: fillEmptyArray(value),
        }, updateValues(updatedFieldArrayValuesWithKey));
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValuesWithKey.length - appendValue.length, options);
    };
    const prepend$1 = (value, options) => {
        const updatedFieldArrayValuesWithKey = prepend(mapCurrentIds(control._getFieldArrayValue(name), _fieldIds, keyName), mapIds(convertToArrayPayload(value), keyName));
        control._updateFieldArray(keyName, name, prepend, {
            argA: fillEmptyArray(value),
        }, updateValues(updatedFieldArrayValuesWithKey));
        control._names.focus = getFocusFieldName(name, 0, options);
    };
    const remove = (index) => {
        const updatedFieldArrayValuesWithKey = removeArrayAt(mapCurrentIds(control._getFieldArrayValue(name), _fieldIds, keyName), index);
        control._updateFieldArray(keyName, name, removeArrayAt, {
            argA: index,
        }, updateValues(updatedFieldArrayValuesWithKey));
    };
    const insert$1 = (index, value, options) => {
        const updatedFieldArrayValuesWithKey = insert(mapCurrentIds(control._getFieldArrayValue(name), _fieldIds, keyName), index, mapIds(convertToArrayPayload(value), keyName));
        control._updateFieldArray(keyName, name, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        }, updateValues(updatedFieldArrayValuesWithKey));
        control._names.focus = getFocusFieldName(name, index, options);
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValuesWithKey = mapCurrentIds(control._getFieldArrayValue(name), _fieldIds, keyName);
        swapArrayAt(updatedFieldArrayValuesWithKey, indexA, indexB);
        control._updateFieldArray(keyName, name, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, updateValues(updatedFieldArrayValuesWithKey), false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValuesWithKey = mapCurrentIds(control._getFieldArrayValue(name), _fieldIds, keyName);
        moveArrayAt(updatedFieldArrayValuesWithKey, from, to);
        control._updateFieldArray(keyName, name, moveArrayAt, {
            argA: from,
            argB: to,
        }, updateValues(updatedFieldArrayValuesWithKey), false);
    };
    const update = (index, value) => {
        const updatedFieldArrayValuesWithKey = mapCurrentIds(control._getFieldArrayValue(name), _fieldIds, keyName);
        const updatedFieldArrayValues = updateAt(updatedFieldArrayValuesWithKey, index, value);
        _fieldIds.current = mapIds(updatedFieldArrayValues, keyName);
        control._updateFieldArray(keyName, name, updateAt, {
            argA: index,
            argB: value,
        }, updateValues(_fieldIds.current), true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValuesWithKey = mapIds(convertToArrayPayload(value), keyName);
        control._updateFieldArray(keyName, name, () => updatedFieldArrayValuesWithKey, {}, updateValues(updatedFieldArrayValuesWithKey), true, false);
    };
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        control._stateFlags.action = false;
        if (control._names.watchAll) {
            control._subjects.state.next({});
        }
        else {
            for (const watchField of control._names.watch) {
                if (name.startsWith(watchField)) {
                    control._subjects.state.next({});
                    break;
                }
            }
        }
        control._subjects.watch.next({
            name,
            values: control._formValues,
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => key.startsWith(control._names.focus));
        control._names.focus = '';
        control._proxyFormState.isValid && control._updateValid();
    }, [fields, name, control, keyName]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const fieldArraySubscription = control._subjects.array.subscribe({
            next({ values, name: fieldArrayName }) {
                if (fieldArrayName === name || !fieldArrayName) {
                    setFields(mapIds(get(values, name), keyName));
                }
            },
        });
        !get(control._formValues, name) && set(control._formValues, name, []);
        return () => {
            fieldArraySubscription.unsubscribe();
            if (control._shouldUnregister || shouldUnregister) {
                control.unregister(name);
            }
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(swap, [updateValues, name, control, keyName]),
        move: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(move, [updateValues, name, control, keyName]),
        prepend: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(prepend$1, [updateValues, name, control, keyName]),
        append: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(append$1, [updateValues, name, control, keyName]),
        remove: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(remove, [updateValues, name, control, keyName]),
        insert: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(insert$1, [updateValues, name, control, keyName]),
        update: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(update, [updateValues, name, control, keyName]),
        replace: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(replace, [updateValues, name, control, keyName]),
        fields: fields,
    };
};

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (isArray || isObject(data)) {
        copy = isArray ? [] : {};
        for (const key in data) {
            copy[key] = cloneObject(data[key]);
        }
    }
    else {
        return data;
    }
    return copy;
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) ||
        isPrimitive(object2) ||
        isDateObject(object1) ||
        isDateObject(object2)) {
        return object1 === object2;
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isObject(val1) || Array.isArray(val1)) &&
                (isObject(val2) || Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => value instanceof HTMLElement;

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioInput = (element) => element.type === 'radio';

var isRadioOrCheckboxFunction = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var isString = (value) => typeof value === 'string';

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

var live = (ref) => !isHTMLElement(ref) || !document.contains(ref);

class Subscription {
    constructor() {
        this.tearDowns = [];
    }
    add(tearDown) {
        this.tearDowns.push(tearDown);
    }
    unsubscribe() {
        for (const teardown of this.tearDowns) {
            teardown();
        }
        this.tearDowns = [];
    }
}
class Subscriber {
    constructor(observer, subscription) {
        this.observer = observer;
        this.closed = false;
        subscription.add(() => (this.closed = true));
    }
    next(value) {
        if (!this.closed) {
            this.observer.next(value);
        }
    }
}
class Subject {
    constructor() {
        this.observers = [];
    }
    next(value) {
        for (const observer of this.observers) {
            observer.next(value);
        }
    }
    subscribe(observer) {
        const subscription = new Subscription();
        const subscriber = new Subscriber(observer, subscription);
        this.observers.push(subscriber);
        return subscription;
    }
    unsubscribe() {
        this.observers = [];
    }
}

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) &&
                        !objectRef.filter((data) => (isObject(data) && !isEmptyObject(data)) || isBoolean(data)).length))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : +value
        : valueAsDate
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

var getMultipleSelectValue = (options) => [...options]
    .filter(({ selected }) => selected)
    .map(({ value }) => value);

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return getMultipleSelectValue(ref.options);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function deepMerge(target, source) {
    if (isPrimitive(target) || isPrimitive(source)) {
        return source;
    }
    for (const key in source) {
        const targetValue = target[key];
        const sourceValue = source[key];
        try {
            target[key] =
                (isObject(targetValue) && isObject(sourceValue)) ||
                    (Array.isArray(targetValue) && Array.isArray(sourceValue))
                    ? deepMerge(targetValue, sourceValue)
                    : sourceValue;
        }
        catch (_a) { }
    }
    return target;
}

function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
    let index = -1;
    while (++index < values.length) {
        for (const key in values[index]) {
            if (Array.isArray(values[index][key])) {
                !dirtyFields[index] && (dirtyFields[index] = {});
                dirtyFields[index][key] = [];
                setDirtyFields(values[index][key], get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
            }
            else {
                !isNullOrUndefined(defaultValues) &&
                    deepEqual(get(defaultValues[index] || {}, key), values[index][key])
                    ? set(dirtyFields[index] || {}, key)
                    : (dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), { [key]: true }));
            }
        }
        parentNode &&
            !dirtyFields.length &&
            delete parentNode[parentName];
    }
    return dirtyFields;
}
var setFieldArrayDirtyFields = (values, defaultValues, dirtyFields) => deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name, [])).length && unset(ref, name);

var isMessage = (value) => isString(value) || react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(value);

var isRegex = (value) => value instanceof RegExp;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidty = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || ' ');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = Object.assign({ type: exceedMax ? maxType : minType, message,
            ref }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (required &&
        ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
            (isBoolean(inputValue) && !inputValue) ||
            (isCheckBox && !getCheckboxValue(refs).isValid) ||
            (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.required, message, ref: inputRef }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                setCustomValidty(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || parseFloat(inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidty(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && isString(inputValue)) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidty(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.pattern, message,
                ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                setCustomValidty(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    setCustomValidty(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));
                    setCustomValidty(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = Object.assign({ ref: inputRef }, validationResult);
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidty(true);
    return error;
};

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
const isWindowUndefined = typeof window === 'undefined';
function createFormControl(props = {}) {
    let formOptions = Object.assign(Object.assign({}, defaultOptions), props);
    let _delayCallback;
    let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    };
    let _fields = {};
    let _defaultValues = formOptions.defaultValues || {};
    let _formValues = formOptions.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _timer = 0;
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let _validateCount = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: new Subject(),
        control: new Subject(),
        array: new Subject(),
        state: new Subject(),
    };
    const validationMode = getValidationModes(formOptions.mode);
    const reValidateMode = getValidationModes(formOptions.reValidateMode);
    const isValidateAllFieldCriteria = formOptions.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback, wait) => (...args) => {
        clearTimeout(_timer);
        _timer = window.setTimeout(() => callback(...args), wait);
    };
    const isFieldWatched = (name) => _names.watchAll ||
        _names.watch.has(name) ||
        _names.watch.has((name.match(/\w+/) || [])[0]);
    const updateErrorState = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const shouldRenderBaseOnError = async (shouldSkipRender, name, isValid, error, fieldState) => {
        const previousError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
            _delayCallback =
                _delayCallback || debounce(updateErrorState, props.delayError);
            _delayCallback(name, error);
        }
        else {
            clearTimeout(_timer);
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if (((error ? !deepEqual(previousError, error) : previousError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) &&
            !shouldSkipRender) {
            const updatedFormState = Object.assign(Object.assign(Object.assign({}, fieldState), (shouldUpdateValid ? { isValid } : {})), { errors: _formState.errors, name });
            _formState = Object.assign(Object.assign({}, _formState), updatedFormState);
            _subjects.state.next(updatedFormState);
        }
        _validateCount[name]--;
        if (_proxyFormState.isValidating && !_validateCount[name]) {
            _subjects.state.next({
                isValidating: false,
            });
            _validateCount = {};
        }
    };
    const setFieldValue = (name, value, options = {}, shouldRender) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const _f = field._f;
            if (_f) {
                set(_formValues, name, getFieldValueAs(value, _f));
                fieldValue =
                    isWeb && isHTMLElement(_f.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isFileInput(_f.ref) && !isString(fieldValue)) {
                    _f.ref.files = fieldValue;
                }
                else if (isMultipleSelect(_f.ref)) {
                    [..._f.ref.options].forEach((selectRef) => (selectRef.selected = fieldValue.includes(selectRef.value)));
                }
                else if (_f.refs) {
                    if (isCheckBoxInput(_f.ref)) {
                        _f.refs.length > 1
                            ? _f.refs.forEach((checkboxRef) => (checkboxRef.checked = Array.isArray(fieldValue)
                                ? !!fieldValue.find((data) => data === checkboxRef.value)
                                : fieldValue === checkboxRef.value))
                            : (_f.refs[0].checked = !!fieldValue);
                    }
                    else {
                        _f.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else {
                    _f.ref.value = fieldValue;
                }
                if (shouldRender) {
                    _subjects.control.next({
                        values: _formValues,
                        name,
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirtyState(name, fieldValue, options.shouldTouch);
        options.shouldValidate && trigger(name);
    };
    const updateTouchAndDirtyState = (name, inputValue, isCurrentTouched, shouldRender = true) => {
        const state = {
            name,
        };
        let isChanged = false;
        if (_proxyFormState.isDirty) {
            const previousIsDirty = _formState.isDirty;
            _formState.isDirty = _getIsDirty();
            state.isDirty = _formState.isDirty;
            isChanged = previousIsDirty !== state.isDirty;
        }
        if (_proxyFormState.dirtyFields && !isCurrentTouched) {
            const isPreviousFieldDirty = get(_formState.dirtyFields, name);
            const isCurrentFieldDirty = !deepEqual(get(_defaultValues, name), inputValue);
            isCurrentFieldDirty
                ? set(_formState.dirtyFields, name, true)
                : unset(_formState.dirtyFields, name);
            state.dirtyFields = _formState.dirtyFields;
            isChanged =
                isChanged || isPreviousFieldDirty !== get(_formState.dirtyFields, name);
        }
        const isPreviousFieldTouched = get(_formState.touchedFields, name);
        if (isCurrentTouched && !isPreviousFieldTouched) {
            set(_formState.touchedFields, name, isCurrentTouched);
            state.touchedFields = _formState.touchedFields;
            isChanged =
                isChanged ||
                    (_proxyFormState.touchedFields &&
                        isPreviousFieldTouched !== isCurrentTouched);
        }
        isChanged && shouldRender && _subjects.state.next(state);
        return isChanged ? state : {};
    };
    const executeResolver = async (name) => {
        return formOptions.resolver
            ? await formOptions.resolver(Object.assign({}, _formValues), formOptions.context, getResolverOptions(name || _names.mount, _fields, formOptions.criteriaMode, formOptions.shouldUseNativeValidation))
            : {};
    };
    const executeResolverValidation = async (names) => {
        const { errors } = await executeResolver();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const validateForm = async (_fields, shouldCheckValid, context = {
        valid: true,
    }) => {
        for (const name in _fields) {
            const field = _fields[name];
            if (field) {
                const _f = field._f;
                const fieldValue = omit(field, '_f');
                if (_f) {
                    const fieldError = await validateField(field, get(_formValues, _f.name), isValidateAllFieldCriteria, formOptions.shouldUseNativeValidation);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldCheckValid) {
                            break;
                        }
                    }
                    if (!shouldCheckValid) {
                        fieldError[_f.name]
                            ? set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name);
                    }
                }
                fieldValue &&
                    (await validateForm(fieldValue, shouldCheckValid, context));
            }
        }
        return context.valid;
    };
    const handleChange = async ({ type, target, target: { value, name, type: inputType }, }) => {
        const field = get(_fields, name);
        if (field) {
            let error;
            let isValid;
            const inputValue = inputType ? getFieldValue(field._f) : value;
            const isBlurEvent = type === EVENTS.BLUR;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !formOptions.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, reValidateMode, validationMode);
            const isWatched = !isBlurEvent && isFieldWatched(name);
            set(_formValues, name, inputValue);
            const fieldState = updateTouchAndDirtyState(name, inputValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || isWatched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type,
                });
            if (shouldSkipValidation) {
                return (shouldRender &&
                    _subjects.state.next(Object.assign({ name }, (isWatched ? {} : fieldState))));
            }
            !isBlurEvent && isWatched && _subjects.state.next({});
            _validateCount[name] = _validateCount[name] ? +1 : 1;
            _proxyFormState.isValidating &&
                _subjects.state.next({
                    isValidating: true,
                });
            if (formOptions.resolver) {
                const { errors } = await executeResolver([name]);
                error = get(errors, name);
                if (isCheckBoxInput(target) && !error) {
                    const parentNodeName = getNodeParentName(name);
                    const parentField = get(_fields, parentNodeName);
                    if (Array.isArray(parentField) &&
                        parentField.every((field) => field._f && isCheckBoxInput(field._f.ref))) {
                        const parentError = get(errors, parentNodeName, {});
                        parentError.type && (error = parentError);
                        name = parentNodeName;
                    }
                }
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, get(_formValues, name), isValidateAllFieldCriteria, formOptions.shouldUseNativeValidation))[name];
                isValid = await _updateValid(true);
            }
            if (field._f.deps) {
                trigger(field._f.deps);
            }
            shouldRenderBaseOnError(false, name, isValid, error, fieldState);
        }
    };
    const _updateValidAndInputValue = (name, shouldSkipValueAs, ref) => {
        const field = get(_fields, name);
        if (field) {
            const fieldValue = get(_formValues, name);
            const defaultValue = isUndefined(fieldValue)
                ? get(_defaultValues, name)
                : fieldValue;
            if (isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipValueAs) {
                set(_formValues, name, shouldSkipValueAs ? defaultValue : getFieldValue(field._f));
            }
            else {
                setFieldValue(name, defaultValue);
            }
        }
        _stateFlags.mount && _updateValid();
    };
    const _getIsDirty = (name, data) => {
        name && data && set(_formValues, name, data);
        return !deepEqual(Object.assign({}, getValues()), _defaultValues);
    };
    const _updateValid = async (skipRender) => {
        let isValid = false;
        if (_proxyFormState.isValid) {
            isValid = formOptions.resolver
                ? isEmptyObject((await executeResolver()).errors)
                : await validateForm(_fields, true);
            if (!skipRender && isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid,
                });
            }
        }
        return isValid;
    };
    const setValues = (name, value, options) => Object.entries(value).forEach(([fieldKey, fieldValue]) => {
        const fieldName = `${name}.${fieldKey}`;
        const field = get(_fields, fieldName);
        (_names.array.has(name) ||
            !isPrimitive(fieldValue) ||
            (field && !field._f)) &&
            !isDateObject(fieldValue)
            ? setValues(fieldName, fieldValue, options)
            : setFieldValue(fieldName, fieldValue, options, true);
    });
    const _getWatch = (fieldNames, defaultValue, isMounted, isGlobal) => {
        const fieldValues = Object.assign({}, (isMounted || _stateFlags.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(fieldNames)
                    ? { [fieldNames]: defaultValue }
                    : defaultValue));
        if (!fieldNames) {
            isGlobal && (_names.watchAll = true);
            return fieldValues;
        }
        const result = [];
        for (const fieldName of convertToArrayPayload(fieldNames)) {
            isGlobal && _names.watch.add(fieldName);
            result.push(get(fieldValues, fieldName));
        }
        return Array.isArray(fieldNames) ? result : result[0];
    };
    const _updateFieldArray = (keyName, name, method, args, values = [], shouldSet = true, shouldSetFields = true) => {
        let output;
        _stateFlags.action = true;
        if (shouldSetFields && get(_fields, name)) {
            output = method(get(_fields, name), args.argA, args.argB);
            shouldSet && set(_fields, name, output);
        }
        if (Array.isArray(get(_formState.errors, name))) {
            const output = method(get(_formState.errors, name), args.argA, args.argB);
            shouldSet && set(_formState.errors, name, output);
            unsetEmptyArray(_formState.errors, name);
        }
        if (_proxyFormState.touchedFields && get(_formState.touchedFields, name)) {
            const output = method(get(_formState.touchedFields, name), args.argA, args.argB);
            shouldSet && set(_formState.touchedFields, name, output);
            unsetEmptyArray(_formState.touchedFields, name);
        }
        if (_proxyFormState.dirtyFields || _proxyFormState.isDirty) {
            set(_formState.dirtyFields, name, setFieldArrayDirtyFields(omitKey(values, keyName), get(_defaultValues, name, []), get(_formState.dirtyFields, name, [])));
            values &&
                set(_formState.dirtyFields, name, setFieldArrayDirtyFields(omitKey(values, keyName), get(_defaultValues, name, []), get(_formState.dirtyFields, name, [])));
            unsetEmptyArray(_formState.dirtyFields, name);
        }
        _subjects.state.next({
            isDirty: _getIsDirty(name, omitKey(values, keyName)),
            dirtyFields: _formState.dirtyFields,
            errors: _formState.errors,
            isValid: _formState.isValid,
        });
    };
    const _getFieldArrayValue = (name) => get(_stateFlags.mount ? _formValues : _defaultValues, name, []);
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        set(_formValues, name, value);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                set(_formState.dirtyFields, name, setFieldArrayDirtyFields(value, get(_defaultValues, name, []), get(_formState.dirtyFields, name, [])));
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getIsDirty(name, value),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(value)
                ? setValues(name, value, options)
                : setFieldValue(name, value, options, true);
        }
        isFieldWatched(name) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
    };
    const trigger = async (name, options = {}) => {
        const fieldNames = convertToArrayPayload(name);
        let isValid;
        _subjects.state.next({
            isValidating: true,
        });
        if (formOptions.resolver) {
            const schemaResult = await executeResolverValidation(isUndefined(name) ? name : fieldNames);
            isValid = name
                ? fieldNames.every((name) => !get(schemaResult, name))
                : isEmptyObject(schemaResult);
        }
        else {
            if (name) {
                isValid = (await Promise.all(fieldNames.map(async (fieldName) => {
                    const field = get(_fields, fieldName);
                    return await validateForm(field._f ? { [fieldName]: field } : field);
                }))).every(Boolean);
                _updateValid();
            }
            else {
                isValid = await validateForm(_fields);
            }
        }
        _subjects.state.next(Object.assign(Object.assign({}, (isString(name) ? { name } : {})), { errors: _formState.errors, isValid, isValidating: false }));
        if (options.shouldFocus && !isValid) {
            focusFieldBy(_fields, (key) => get(_formState.errors, key), name ? fieldNames : _names.mount);
        }
        return isValid;
    };
    const getValues = (fieldNames) => {
        const values = Object.assign(Object.assign({}, _defaultValues), (_stateFlags.mount ? _formValues : {}));
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName))
            : (_formState.errors = {});
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, Object.assign(Object.assign({}, error), { ref }));
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (fieldName, defaultValue) => isFunction(fieldName)
        ? _subjects.watch.subscribe({
            next: (info) => fieldName(_getWatch(undefined, defaultValue), info),
        })
        : _getWatch(fieldName, defaultValue, false, true);
    const unregister = (name, options = {}) => {
        for (const inputName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(inputName);
            _names.array.delete(inputName);
            if (get(_fields, inputName)) {
                if (!options.keepValue) {
                    unset(_fields, inputName);
                    unset(_formValues, inputName);
                }
                !options.keepError && unset(_formState.errors, inputName);
                !options.keepDirty && unset(_formState.dirtyFields, inputName);
                !options.keepTouched && unset(_formState.touchedFields, inputName);
                !formOptions.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, inputName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next(Object.assign(Object.assign({}, _formState), (!options.keepDirty ? {} : { isDirty: _getIsDirty() })));
        !options.keepIsValid && _updateValid();
    };
    const registerFieldRef = (name, fieldRef, options) => {
        register(name, options);
        let field = get(_fields, name);
        const ref = isUndefined(fieldRef.value)
            ? fieldRef.querySelectorAll
                ? fieldRef.querySelectorAll('input,select,textarea')[0] ||
                    fieldRef
                : fieldRef
            : fieldRef;
        const isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
        if (ref === field._f.ref ||
            (isRadioOrCheckbox &&
                compact(field._f.refs || []).find((option) => option === ref))) {
            return;
        }
        field = {
            _f: isRadioOrCheckbox
                ? Object.assign(Object.assign({}, field._f), { refs: [
                        ...compact(field._f.refs || []).filter((ref) => isHTMLElement(ref) && document.contains(ref)),
                        ref,
                    ], ref: { type: ref.type, name } }) : Object.assign(Object.assign({}, field._f), { ref }),
        };
        set(_fields, name, field);
        (!options || !options.disabled) &&
            _updateValidAndInputValue(name, false, ref);
    };
    const register = (name, options = {}) => {
        const field = get(_fields, name);
        set(_fields, name, {
            _f: Object.assign(Object.assign(Object.assign({}, (field && field._f ? field._f : { ref: { name } })), { name, mount: true }), options),
        });
        _names.mount.add(name);
        if (!isUndefined(options.value)) {
            set(_formValues, name, options.value);
        }
        if (field && isBoolean(options.disabled)) {
            set(_formValues, name, options.disabled
                ? undefined
                : get(_formValues, name, getFieldValue(field._f)));
        }
        !field && _updateValidAndInputValue(name, true);
        return isWindowUndefined
            ? { name: name }
            : Object.assign(Object.assign({ name }, (isBoolean(options.disabled)
                ? { disabled: options.disabled }
                : {})), { onChange: handleChange, onBlur: handleChange, ref: (ref) => {
                    if (ref) {
                        registerFieldRef(name, ref, options);
                    }
                    else {
                        const field = get(_fields, name, {});
                        const _shouldUnregister = formOptions.shouldUnregister || options.shouldUnregister;
                        if (field._f) {
                            field._f.mount = false;
                        }
                        _shouldUnregister &&
                            !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                            _names.unMount.add(name);
                    }
                } });
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = Object.assign({}, _formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        try {
            if (formOptions.resolver) {
                const { errors, values } = await executeResolver();
                _formState.errors = errors;
                fieldValues = values;
            }
            else {
                await validateForm(_fields);
            }
            if (isEmptyObject(_formState.errors) &&
                Object.keys(_formState.errors).every((name) => get(fieldValues, name))) {
                _subjects.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                onInvalid && (await onInvalid(_formState.errors, e));
                formOptions.shouldFocusError &&
                    focusFieldBy(_fields, (key) => get(_formState.errors, key), _names.mount);
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            _formState.isSubmitted = true;
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors,
            });
        }
    };
    const reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const values = cloneObject(updatedValues);
        if (!keepStateOptions.keepValues) {
            _formValues = props.shouldUnregister ? {} : values;
        }
        if (isWeb && !keepStateOptions.keepValues) {
            for (const name of _names.mount) {
                const field = get(_fields, name);
                if (field && field._f) {
                    const inputRef = Array.isArray(field._f.refs)
                        ? field._f.refs[0]
                        : field._f.ref;
                    try {
                        isHTMLElement(inputRef) && inputRef.closest('form').reset();
                        break;
                    }
                    catch (_a) { }
                }
            }
        }
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = Object.assign({}, updatedValues);
        }
        if (!keepStateOptions.keepValues) {
            _fields = {};
            _subjects.control.next({
                values: keepStateOptions.keepDefaultValues
                    ? _defaultValues
                    : Object.assign({}, updatedValues),
            });
            _subjects.watch.next({});
            _subjects.array.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : keepStateOptions.keepDefaultValues
                    ? deepEqual(formValues, _defaultValues)
                    : false,
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty
                ? _formState.dirtyFields
                : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors
                ? _formState.errors
                : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
    };
    const setFocus = (name) => get(_fields, name)._f.ref.focus();
    const _removeFields = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs ? field._f.refs.every(live) : live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    return {
        control: {
            register,
            unregister,
            _getWatch,
            _getIsDirty,
            _updateValid,
            _removeFields,
            _updateFieldArray,
            _getFieldArrayValue,
            _subjects,
            _shouldUnregister: formOptions.shouldUnregister,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            set _fields(value) {
                _fields = value;
            },
            get _formValues() {
                return _formValues;
            },
            set _formValues(value) {
                _formValues = value;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            set _defaultValues(value) {
                _defaultValues = value;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            _updateProps: (options) => {
                formOptions = Object.assign(Object.assign({}, defaultOptions), options);
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        clearErrors,
        unregister,
        setError,
        setFocus,
    };
}

function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    });
    if (_formControl.current) {
        _formControl.current.control._updateProps(props);
    }
    else {
        _formControl.current = Object.assign(Object.assign({}, createFormControl(props)), { formState });
    }
    const control = _formControl.current.control;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const formStateSubscription = control._subjects.state.subscribe({
            next(formState) {
                if (shouldRenderFormState(formState, control._proxyFormState, true)) {
                    control._formState = Object.assign(Object.assign({}, control._formState), formState);
                    updateFormState(Object.assign({}, control._formState));
                }
            },
        });
        return () => {
            formStateSubscription.unsubscribe();
        };
    }, [control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeFields();
    });
    _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}

function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, } = props || {};
    const _name = React.useRef(name);
    _name.current = name;
    const [value, updateValue] = React.useState(isUndefined(defaultValue)
        ? control._getWatch(name)
        : defaultValue);
    React.useEffect(() => {
        const watchSubscription = control._subjects.watch.subscribe({
            next: ({ name }) => {
                if (!_name.current ||
                    !name ||
                    convertToArrayPayload(_name.current).some((fieldName) => name &&
                        fieldName &&
                        (fieldName.startsWith(name) ||
                            name.startsWith(fieldName)))) {
                    const result = control._getWatch(_name.current, defaultValue, true);
                    updateValue(isObject(result)
                        ? Object.assign({}, result) : Array.isArray(result)
                        ? [...result]
                        : result);
                }
            },
        });
        disabled && watchSubscription.unsubscribe();
        return () => watchSubscription.unsubscribe();
    }, [disabled, control, defaultValue]);
    React.useEffect(() => {
        control._removeFields();
    });
    return value;
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 6082:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(6082);
} else {}


/***/ }),

/***/ 98885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(59391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) (0,reflow/* forceReflow */.Q)(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_TransitionGroup; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(75068);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind((0,assertThisInitialized/* default */.Z)(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = (0,esm_extends/* default */.Z)({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);

/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 59391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ forceReflow; }
/* harmony export */ });
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

/***/ }),

/***/ 13913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ YouTube_default; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64063);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var youtube_player__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11062);
/* harmony import */ var youtube_player__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(youtube_player__WEBPACK_IMPORTED_MODULE_2__);
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/YouTube.tsx




function shouldUpdateVideo(prevProps, props) {
  var _a, _b;
  if (prevProps.videoId !== props.videoId) {
    return true;
  }
  const prevVars = ((_a = prevProps.opts) == null ? void 0 : _a.playerVars) || {};
  const vars = ((_b = props.opts) == null ? void 0 : _b.playerVars) || {};
  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}
function filterResetOptions(opts = {}) {
  return __spreadProps(__spreadValues({}, opts), {
    height: 0,
    width: 0,
    playerVars: __spreadProps(__spreadValues({}, opts.playerVars), {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}
function shouldResetPlayer(prevProps, props) {
  return prevProps.videoId !== props.videoId || !fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}
function shouldUpdatePlayer(prevProps, props) {
  var _a, _b, _c, _d;
  return prevProps.id !== props.id || prevProps.className !== props.className || ((_a = prevProps.opts) == null ? void 0 : _a.width) !== ((_b = props.opts) == null ? void 0 : _b.width) || ((_c = prevProps.opts) == null ? void 0 : _c.height) !== ((_d = props.opts) == null ? void 0 : _d.height) || prevProps.iframeClassName !== props.iframeClassName || prevProps.title !== props.title;
}
var defaultProps = {
  videoId: "",
  id: "",
  className: "",
  iframeClassName: "",
  style: {},
  title: "",
  loading: void 0,
  opts: {},
  onReady: () => {
  },
  onError: () => {
  },
  onPlay: () => {
  },
  onPause: () => {
  },
  onEnd: () => {
  },
  onStateChange: () => {
  },
  onPlaybackRateChange: () => {
  },
  onPlaybackQualityChange: () => {
  }
};
var propTypes = {
  videoId: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  iframeClassName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  style: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  loading: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(["lazy", "eager"]),
  opts: prop_types__WEBPACK_IMPORTED_MODULE_3___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().any)),
  onReady: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  onError: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  onPlay: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  onPause: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  onEnd: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  onStateChange: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  onPlaybackRateChange: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  onPlaybackQualityChange: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
var _YouTube = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.destroyPlayerPromise = void 0;
    this.onPlayerReady = (event) => {
      var _a, _b;
      return (_b = (_a = this.props).onReady) == null ? void 0 : _b.call(_a, event);
    };
    this.onPlayerError = (event) => {
      var _a, _b;
      return (_b = (_a = this.props).onError) == null ? void 0 : _b.call(_a, event);
    };
    this.onPlayerStateChange = (event) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      (_b = (_a = this.props).onStateChange) == null ? void 0 : _b.call(_a, event);
      switch (event.data) {
        case _YouTube.PlayerState.ENDED:
          (_d = (_c = this.props).onEnd) == null ? void 0 : _d.call(_c, event);
          break;
        case _YouTube.PlayerState.PLAYING:
          (_f = (_e = this.props).onPlay) == null ? void 0 : _f.call(_e, event);
          break;
        case _YouTube.PlayerState.PAUSED:
          (_h = (_g = this.props).onPause) == null ? void 0 : _h.call(_g, event);
          break;
        default:
      }
    };
    this.onPlayerPlaybackRateChange = (event) => {
      var _a, _b;
      return (_b = (_a = this.props).onPlaybackRateChange) == null ? void 0 : _b.call(_a, event);
    };
    this.onPlayerPlaybackQualityChange = (event) => {
      var _a, _b;
      return (_b = (_a = this.props).onPlaybackQualityChange) == null ? void 0 : _b.call(_a, event);
    };
    this.destroyPlayer = () => {
      if (this.internalPlayer) {
        this.destroyPlayerPromise = this.internalPlayer.destroy().then(() => this.destroyPlayerPromise = void 0);
        return this.destroyPlayerPromise;
      }
      return Promise.resolve();
    };
    this.createPlayer = () => {
      if (typeof document === "undefined")
        return;
      if (this.destroyPlayerPromise) {
        this.destroyPlayerPromise.then(this.createPlayer);
        return;
      }
      const playerOpts = __spreadProps(__spreadValues({}, this.props.opts), {
        videoId: this.props.videoId
      });
      this.internalPlayer = youtube_player__WEBPACK_IMPORTED_MODULE_2___default()(this.container, playerOpts);
      this.internalPlayer.on("ready", this.onPlayerReady);
      this.internalPlayer.on("error", this.onPlayerError);
      this.internalPlayer.on("stateChange", this.onPlayerStateChange);
      this.internalPlayer.on("playbackRateChange", this.onPlayerPlaybackRateChange);
      this.internalPlayer.on("playbackQualityChange", this.onPlayerPlaybackQualityChange);
      if (this.props.title || this.props.loading) {
        this.internalPlayer.getIframe().then((iframe) => {
          if (this.props.title)
            iframe.setAttribute("title", this.props.title);
          if (this.props.loading)
            iframe.setAttribute("loading", this.props.loading);
        });
      }
    };
    this.resetPlayer = () => this.destroyPlayer().then(this.createPlayer);
    this.updatePlayer = () => {
      var _a;
      (_a = this.internalPlayer) == null ? void 0 : _a.getIframe().then((iframe) => {
        if (this.props.id)
          iframe.setAttribute("id", this.props.id);
        else
          iframe.removeAttribute("id");
        if (this.props.iframeClassName)
          iframe.setAttribute("class", this.props.iframeClassName);
        else
          iframe.removeAttribute("class");
        if (this.props.opts && this.props.opts.width)
          iframe.setAttribute("width", this.props.opts.width.toString());
        else
          iframe.removeAttribute("width");
        if (this.props.opts && this.props.opts.height)
          iframe.setAttribute("height", this.props.opts.height.toString());
        else
          iframe.removeAttribute("height");
        if (this.props.title)
          iframe.setAttribute("title", this.props.title);
        else
          iframe.setAttribute("title", "YouTube video player");
        if (this.props.loading)
          iframe.setAttribute("loading", this.props.loading);
        else
          iframe.removeAttribute("loading");
      });
    };
    this.getInternalPlayer = () => {
      return this.internalPlayer;
    };
    this.updateVideo = () => {
      var _a, _b, _c, _d;
      if (typeof this.props.videoId === "undefined" || this.props.videoId === null) {
        (_a = this.internalPlayer) == null ? void 0 : _a.stopVideo();
        return;
      }
      let autoplay = false;
      const opts = {
        videoId: this.props.videoId
      };
      if ((_b = this.props.opts) == null ? void 0 : _b.playerVars) {
        autoplay = this.props.opts.playerVars.autoplay === 1;
        if ("start" in this.props.opts.playerVars) {
          opts.startSeconds = this.props.opts.playerVars.start;
        }
        if ("end" in this.props.opts.playerVars) {
          opts.endSeconds = this.props.opts.playerVars.end;
        }
      }
      if (autoplay) {
        (_c = this.internalPlayer) == null ? void 0 : _c.loadVideoById(opts);
        return;
      }
      (_d = this.internalPlayer) == null ? void 0 : _d.cueVideoById(opts);
    };
    this.refContainer = (container) => {
      this.container = container;
    };
    this.container = null;
    this.internalPlayer = null;
  }
  componentDidMount() {
    this.createPlayer();
  }
  componentDidUpdate(prevProps) {
    return __async(this, null, function* () {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }
      if (shouldResetPlayer(prevProps, this.props)) {
        yield this.resetPlayer();
      }
      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    });
  }
  componentWillUnmount() {
    this.destroyPlayer();
  }
  render() {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: this.props.className,
      style: this.props.style
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      id: this.props.id,
      className: this.props.iframeClassName,
      ref: this.refContainer
    }));
  }
};
var YouTube = _YouTube;
YouTube.propTypes = propTypes;
YouTube.defaultProps = defaultProps;
YouTube.PlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};
var YouTube_default = YouTube;

//# sourceMappingURL=YouTube.esm.js.map

/***/ }),

/***/ 33988:
/***/ (function(module) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),

/***/ 98123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es; }
});

;// CONCATENATED MODULE: ./node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

;// CONCATENATED MODULE: ./node_modules/symbol-observable/es/index.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof __webpack_require__.g !== 'undefined') {
  root = __webpack_require__.g;
} else if (true) {
  root = module;
} else {}

var result = symbolObservablePonyfill(root);
/* harmony default export */ var es = (result);


/***/ }),

/***/ 87929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.wsMachine = exports.update = exports.calcBackoff = exports.Effects = exports.Actions = exports.States = void 0;
var unionize_1 = __importStar(__webpack_require__(13904));
var atom_1 = __webpack_require__(17553);
exports.States = unionize_1.default({
    INITIAL: unionize_1.ofType(),
    CONNECTING: unionize_1.ofType(),
    OPEN: unionize_1.ofType(),
    CLOSED: unionize_1.ofType(),
    RECONNECTING: unionize_1.ofType(),
});
exports.Actions = unionize_1.default({
    CONNECT: {},
    OPEN: {},
    HEARTBEAT: {},
    PING_TIMEOUT: {},
    PONG_TIMEOUT: {},
    CLOSE: {},
    RECONNECT: {},
});
exports.Effects = unionize_1.default({
    CONNECT_WS: unionize_1.ofType(),
    SCHEDULE_TIMEOUT: unionize_1.ofType(),
    SEND_PING: unionize_1.ofType(),
    CLEAR_TIMEOUT: unionize_1.ofType(),
    TRIGGER_ACTION: unionize_1.ofType(),
});
var calcBackoff = function (attempt, randSeed, maxVal) {
    if (maxVal === void 0) { maxVal = 30000; }
    if (attempt === 0) {
        return 0;
    }
    return Math.min(maxVal, Math.pow(attempt, 2) * 1000) + 2000 * randSeed;
};
exports.calcBackoff = calcBackoff;
var connect = function (state) { return [
    exports.States.CONNECTING(state),
    [
        exports.Effects.CLEAR_TIMEOUT({ key: "connect" }),
        exports.Effects.CONNECT_WS({
            url: state.url,
            onOpen: exports.Actions.OPEN(),
            onClose: exports.Actions.CLOSE(),
            onPongMessage: exports.Actions.HEARTBEAT(),
        }),
    ],
]; };
var clearTimeoutEffect = function (key) { return exports.Effects.CLEAR_TIMEOUT({ key: key }); };
var clearAllTimeoutsEffects = [
    clearTimeoutEffect("connect"),
    clearTimeoutEffect("ping"),
    clearTimeoutEffect("pong"),
];
var scheduleConnect = function (state) {
    return exports.Effects.SCHEDULE_TIMEOUT({
        key: "connect",
        timeoutMillis: state.backoffFn(state.reconnectAttempt + 1, state.randSeed),
        onTimeout: exports.Actions.CONNECT(),
    });
};
var schedulePing = function (state) {
    return exports.Effects.SCHEDULE_TIMEOUT({
        key: "ping",
        timeoutMillis: state.pingTimeoutMillis,
        onTimeout: exports.Actions.PING_TIMEOUT(),
    });
};
var waitForPong = function (state) {
    return exports.Effects.SCHEDULE_TIMEOUT({
        key: "pong",
        timeoutMillis: state.pongTimeoutMillis,
        onTimeout: exports.Actions.PONG_TIMEOUT(),
    });
};
var update = function (action, state) {
    return exports.States.match(state, {
        INITIAL: function () {
            return exports.Actions.match(action, {
                CONNECT: function () { return connect(state); },
                default: function () { return [state, []]; },
            });
        },
        CONNECTING: function () {
            return exports.Actions.match(action, {
                OPEN: function () { return [
                    exports.States.OPEN(__assign(__assign({}, state), { reconnectAttempt: 0 })),
                    [schedulePing(state)],
                ]; },
                CLOSE: function () { return [exports.States.CLOSED(state), clearAllTimeoutsEffects]; },
                default: function () { return [state, []]; },
            });
        },
        OPEN: function () {
            return exports.Actions.match(action, {
                PING_TIMEOUT: function () { return [
                    state,
                    [
                        exports.Effects.CLEAR_TIMEOUT({ key: "ping" }),
                        exports.Effects.SEND_PING(),
                        waitForPong(state),
                    ],
                ]; },
                PONG_TIMEOUT: function () { return [
                    state,
                    [
                        exports.Effects.TRIGGER_ACTION({ action: exports.Actions.CLOSE() }),
                        exports.Effects.TRIGGER_ACTION({ action: exports.Actions.RECONNECT() }),
                    ],
                ]; },
                HEARTBEAT: function () { return [
                    state,
                    [
                        exports.Effects.CLEAR_TIMEOUT({ key: "ping" }),
                        exports.Effects.CLEAR_TIMEOUT({ key: "pong" }),
                        schedulePing(state),
                    ],
                ]; },
                CLOSE: function () { return [exports.States.CLOSED(state), clearAllTimeoutsEffects]; },
                default: function () { return [state, []]; },
            });
        },
        CLOSED: function () {
            return exports.Actions.match(action, {
                RECONNECT: function () { return [
                    exports.States.RECONNECTING(__assign(__assign({}, state), { reconnectAttempt: state.reconnectAttempt + 1 })),
                    [scheduleConnect(state)],
                ]; },
                default: function () { return [state, []]; },
            });
        },
        RECONNECTING: function () {
            return exports.Actions.match(action, {
                CONNECT: function () { return connect(state); },
                default: function () { return [state, []]; },
            });
        },
    });
};
exports.update = update;
var wsMachine = function (config) {
    var ws;
    var wsState = atom_1.Atom.of(exports.States.INITIAL(__assign(__assign({}, config), { reconnectAttempt: 0, randSeed: Math.random() })));
    var timeouts = new Map();
    var wsHandlers = new Map();
    var addEventListener = function (webSocket, type, handler) {
        webSocket.addEventListener(type, handler);
        wsHandlers.set(type, handler);
    };
    var removeEventListeners = function (webSocket) {
        wsHandlers.forEach(function (h, k) {
            webSocket.removeEventListener(k, h);
        });
    };
    var nukeTimeout = function (k) {
        var t = timeouts.get(k);
        if (t) {
            clearTimeout(t);
        }
    };
    var clearTimeouts = function () {
        timeouts.forEach(function (v, k) {
            nukeTimeout(k);
        });
    };
    var transition = function (a) {
        var _a = exports.update(a, atom_1.deref(wsState)), newState = _a[0], effects = _a[1];
        atom_1.swap(wsState, function () { return newState; });
        handleEffects(effects);
    };
    var handleEffect = function (effect) {
        exports.Effects.match(effect, {
            CONNECT_WS: function (conn) {
                if (ws) {
                    removeEventListeners(ws);
                    clearTimeouts();
                    ws.close();
                }
                ws = new WebSocket(conn.url);
                var onOpen = function () { return transition(conn.onOpen); };
                addEventListener(ws, "open", onOpen);
                var onClose = function () {
                    transition(conn.onClose);
                    transition(exports.Actions.RECONNECT());
                };
                addEventListener(ws, "close", onClose);
                var onMessage = function (ev) {
                    var _a;
                    var msg = ev.data;
                    if ((_a = msg !== config.pongMsg) !== null && _a !== void 0 ? _a : "pong") {
                        config.onMessage(ev);
                    }
                    transition(conn.onPongMessage);
                };
                addEventListener(ws, "message", onMessage);
            },
            SCHEDULE_TIMEOUT: function (t) {
                timeouts.set(t.key, setTimeout(function () { return transition(t.onTimeout); }, t.timeoutMillis));
            },
            SEND_PING: function () {
                var _a;
                if (ws) {
                    ws.send((_a = config.pingMsg) !== null && _a !== void 0 ? _a : "ping");
                }
            },
            CLEAR_TIMEOUT: function (t) { return nukeTimeout(t.key); },
            TRIGGER_ACTION: function (a) { return transition(a.action); },
        });
    };
    var handleEffects = function (effects) {
        effects.forEach(function (e) {
            handleEffect(e);
        });
    };
    var send = function (data) {
        if (exports.States.is.OPEN(atom_1.deref(wsState)) && ws instanceof WebSocket) {
            ws.send(data);
        }
        else {
            var errorMsg = "Can't send message when websocket connection isn't in an open state. State is: " + atom_1.deref(wsState).tag;
            throw Error(errorMsg);
        }
    };
    if (config.onStateChange) {
        atom_1.addChangeHandler(wsState, "wsStateHandler", config.onStateChange);
    }
    return {
        connect: function () { return transition(exports.Actions.CONNECT()); },
        send: send,
        currentState: function () { return atom_1.deref(wsState); },
        disconnect: function () {
            atom_1.removeChangeHandler(wsState, "wsStateHandler");
            if (ws) {
                removeEventListeners(ws);
                clearTimeouts();
                atom_1.swap(wsState, function (currState) {
                    return exports.States.INITIAL(__assign(__assign({}, currState), { reconnectAttempt: 0 }));
                });
                ws.close();
            }
        },
    };
};
exports.wsMachine = wsMachine;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 13904:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
function unionize(record, config) {
    var _a = config || {}, _b = _a.value, valProp = _b === void 0 ? undefined : _b, _c = _a.tag, tagProp = _c === void 0 ? 'tag' : _c;
    var creators = {};
    var _loop_1 = function (tag) {
        creators[tag] = (function (value) {
            var _a, _b;
            if (value === void 0) { value = {}; }
            return valProp ? (_a = {}, _a[tagProp] = tag, _a[valProp] = value, _a) : __assign({}, value, (_b = {}, _b[tagProp] = tag, _b));
        });
    };
    for (var tag in record) {
        _loop_1(tag);
    }
    var is = {};
    var _loop_2 = function (tag) {
        is[tag] = (function (variant) { return variant[tagProp] === tag; });
    };
    for (var tag in record) {
        _loop_2(tag);
    }
    function evalMatch(variant, cases, defaultCase) {
        if (defaultCase === void 0) { defaultCase = cases.default; }
        var handler = cases[variant[tagProp]];
        return handler ? handler(valProp ? variant[valProp] : variant) : defaultCase(variant);
    }
    var match = function (first, second) {
        return second ? evalMatch(first, second) : function (variant) { return evalMatch(variant, first); };
    };
    var identity = function (x) { return x; };
    var transform = function (first, second) {
        return second
            ? evalMatch(first, second, identity)
            : function (variant) { return evalMatch(variant, first, identity); };
    };
    var as = {};
    var _loop_3 = function (expectedTag) {
        var _a;
        as[expectedTag] = match((_a = {},
            _a[expectedTag] = function (x) { return x; },
            _a.default = function (val) {
                throw new Error("Attempted to cast " + val[tagProp] + " as " + expectedTag);
            },
            _a));
    };
    for (var expectedTag in record) {
        _loop_3(expectedTag);
    }
    return Object.assign({
        is: is,
        as: as,
        match: match,
        transform: transform,
        _Record: record,
    }, creators);
}
exports.unionize = unionize;
/**
 * Creates a pseudo-witness of a given type. That is, it pretends to return a value of
 * type `T` for any `T`, but it's really just returning `undefined`. This white lie
 * allows convenient expression of the value types in the record you pass to `unionize`.
 */
exports.ofType = function () { return undefined; };
exports["default"] = unionize;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66006:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _PlayerStates = __webpack_require__(22275);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),

/***/ 89125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _debug = __webpack_require__(9215);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(28255);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(65279);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(66006);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports["default"] = YouTubePlayer;
module.exports = exports['default'];

/***/ }),

/***/ 22275:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),

/***/ 65279:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports["default"] = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),

/***/ 28255:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports["default"] = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),

/***/ 11062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(33988);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(55900);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(89125);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports["default"] = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),

/***/ 55900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _loadScript = __webpack_require__(49090);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),

/***/ 9215:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(55046);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),

/***/ 55046:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(57824);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 55721:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = newDateUTC;

/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  var utcDate = new Date(0);
  utcDate.setUTCFullYear(fullYear, month, day);
  utcDate.setUTCHours(hour, minute, second, millisecond);
  return utcDate;
}

module.exports = exports.default;

/***/ }),

/***/ 25855:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzIntlTimeZoneName;

/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */
function tzIntlTimeZoneName(length, date, options) {
  var dtf = getDTF(length, options.timeZone, options.locale);
  return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}

function partsTimeZone(dtf, date) {
  var formatted = dtf.formatToParts(date);

  for (var i = formatted.length - 1; i >= 0; --i) {
    if (formatted[i].type === 'timeZoneName') {
      return formatted[i].value;
    }
  }
}

function hackyTimeZone(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
  return tzNameMatch ? tzNameMatch[0].substr(1) : '';
} // If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.


function getDTF(length, timeZone, locale) {
  if (locale && !locale.code) {
    throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
  }

  return new Intl.DateTimeFormat(locale ? [locale.code, 'en-US'] : undefined, {
    timeZone: timeZone,
    timeZoneName: length
  });
}

module.exports = exports.default;

/***/ }),

/***/ 32734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzParseTimezone;

var _index = _interopRequireDefault(__webpack_require__(2712));

var _index2 = _interopRequireDefault(__webpack_require__(55721));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var patterns = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
}; // Parse various time zone offset formats to an offset in milliseconds

function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token;
  var absoluteOffset; // Empty string

  if (!timezoneString) {
    return 0;
  } // Z


  token = patterns.timezoneZ.exec(timezoneString);

  if (token) {
    return 0;
  }

  var hours; // ±hh

  token = patterns.timezoneHH.exec(timezoneString);

  if (token) {
    hours = parseInt(token[1], 10);

    if (!validateTimezone(hours)) {
      return NaN;
    }

    return -(hours * MILLISECONDS_IN_HOUR);
  } // ±hh:mm or ±hhmm


  token = patterns.timezoneHHMM.exec(timezoneString);

  if (token) {
    hours = parseInt(token[1], 10);
    var minutes = parseInt(token[2], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }

    absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    return hours > 0 ? -absoluteOffset : absoluteOffset;
  } // IANA time zone


  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now());
    var utcDate = isUtcDate ? date : toUtcDate(date);
    var offset = calcOffset(utcDate, timezoneString);
    var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
    return -fixedOffset;
  }

  return NaN;
}

function toUtcDate(date) {
  return (0, _index2.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}

function calcOffset(date, timezoneString) {
  var tokens = (0, _index.default)(date, timezoneString); // ms dropped because it's not provided by tzTokenizeDate

  var asUTC = (0, _index2.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
  var asTS = date.getTime();
  var over = asTS % 1000;
  asTS -= over >= 0 ? over : 1000 + over;
  return asUTC - asTS;
}

function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime(); // Our UTC time is just a guess because our offset is just a guess

  var utcGuess = localTS - offset; // Test whether the zone matches the offset for this ts

  var o2 = calcOffset(new Date(utcGuess), timezoneString); // If so, offset didn't change, and we're done

  if (offset === o2) {
    return offset;
  } // If not, change the ts by the difference in the offset


  utcGuess -= o2 - offset; // If that gives us the local time we want, we're done

  var o3 = calcOffset(new Date(utcGuess), timezoneString);

  if (o2 === o3) {
    return o2;
  } // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time


  return Math.max(o2, o3);
}

function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}

var validIANATimezoneCache = {};

function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return true;

  try {
    new Intl.DateTimeFormat(undefined, {
      timeZone: timeZoneString
    });
    validIANATimezoneCache[timeZoneString] = true;
    return true;
  } catch (error) {
    return false;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 7048:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var _default = tzPattern;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 2712:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzTokenizeDate;

/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function partsOffset(dtf, date) {
  try {
    var formatted = dtf.formatToParts(date);
    var filled = [];

    for (var i = 0; i < formatted.length; i++) {
      var pos = typeToPos[formatted[i].type];

      if (pos >= 0) {
        filled[pos] = parseInt(formatted[i].value, 10);
      }
    }

    return filled;
  } catch (error) {
    if (error instanceof RangeError) {
      return [NaN];
    }

    throw error;
  }
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted); // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]

  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
} // Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.


var dtfCache = {};

function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
    var testDateFormatted = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(new Date('2014-06-25T04:00:00.123Z'));
    var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === '‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00';
    dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
      hourCycle: 'h23',
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  return dtfCache[timeZone];
}

module.exports = exports.default;

/***/ }),

/***/ 33826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(25855));

var _index2 = _interopRequireDefault(__webpack_require__(32734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_MINUTE = 60 * 1000;
var formatters = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return (0, _index.default)('short', originalDate, options);
      // Long

      case 'zzzz':
      default:
        return (0, _index.default)('long', originalDate, options);
    }
  }
};

function getTimeZoneOffset(timeZone, originalDate) {
  var timeZoneOffset = timeZone ? (0, _index2.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();

  if (Number.isNaN(timeZoneOffset)) {
    throw new RangeError('Invalid time zone specified: ' + timeZone);
  }

  return timeZoneOffset;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
  return sign + hours + delimeter + minutes;
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimeter);
}

function formatTimezoneShort(offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2);
}

var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 56558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;

var _index = _interopRequireDefault(__webpack_require__(15616));

var _index2 = _interopRequireDefault(__webpack_require__(33826));

var _index3 = _interopRequireDefault(__webpack_require__(21476));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | PDT, EST, CEST                    | 6     |
 * |                                 | zzzz    | Pacific Daylight Time             | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are created using the Intl browser API. The output is determined by the
 *    preferred standard of the current locale (en-US by default) which may not always give the expected result.
 *    For this reason it is recommended to supply a `locale` in the format options when formatting a time zone name.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole
 *   library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard
 *   #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). See [this
 *   post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see:
 *   https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var matches = formatStr.match(tzFormattingTokensRegExp);

  if (matches) {
    var date = (0, _index3.default)(dirtyDate, options); // Work through each match and replace the tz token in the format string with the quoted
    // formatted time zone so the remaining tokens can be filled in by date-fns#format.

    formatStr = matches.reduce(function (result, token) {
      if (token[0] === "'") {
        return result; // This is a quoted portion, matched only to ensure we don't match inside it
      }

      var pos = result.indexOf(token);
      var precededByQuotedSection = result[pos - 1] === "'";
      var replaced = result.replace(token, "'" + _index2.default[token[0]](date, token, null, options) + "'"); // If the replacement results in two adjoining quoted strings, the back to back quotes
      // are removed, so it doesn't look like an escaped quote.

      return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
    }, formatStr);
  }

  return (0, _index.default)(dirtyDate, formatStr, options);
}

module.exports = exports.default;

/***/ }),

/***/ 26645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = formatInTimeZone;

var _index = _interopRequireDefault(__webpack_require__(46420));

var _index2 = _interopRequireDefault(__webpack_require__(56558));

var _index3 = _interopRequireDefault(__webpack_require__(1132));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name formatInTimeZone
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @param {Date|String|Number} date - the date representing the local time / real UTC time
 * @param {String} timeZone - the time zone this date should be formatted for; can be an offset or IANA time zone
 * @param {String} formatStr - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 */
function formatInTimeZone(date, timeZone, formatStr, options) {
  var extendedOptions = (0, _index.default)(options);
  extendedOptions.timeZone = timeZone;
  return (0, _index2.default)((0, _index3.default)(date, timeZone), formatStr, extendedOptions);
}

module.exports = exports.default;

/***/ }),

/***/ 24992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffset;

var _index = _interopRequireDefault(__webpack_require__(32734));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getTimezoneOffset
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @description
 * Returns the time zone offset from UTC time in milliseconds for IANA time zones as well
 * as other time zone offset string formats.
 *
 * For time zones where daylight savings time is applicable a `Date` should be passed on
 * the second parameter to ensure the offset correctly accounts for DST at that time of
 * year. When omitted, the current date is used.
 *
 * @param {String} timeZone - the time zone of this local time, can be an offset or IANA time zone
 * @param {Date|Number} [date] - the date with values representing the local time
 * @returns {Number} the time zone offset in milliseconds
 *
 * @example
 * const result = getTimezoneOffset('-07:00')
 *   //=> -18000000 (-7 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('Africa/Johannesburg')
 *   //=> 7200000 (2 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('America/New_York', new Date(2016, 0, 1))
 *   //=> -18000000 (-5 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('America/New_York', new Date(2016, 6, 1))
 *   //=> -14400000 (-4 * 60 * 60 * 1000)
 */
function getTimezoneOffset(timeZone, date) {
  return -(0, _index.default)(timeZone, date);
}

module.exports = exports.default;

/***/ }),

/***/ 70722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
module.exports = {
  format: __webpack_require__(56558),
  formatInTimeZone: __webpack_require__(26645),
  getTimezoneOffset: __webpack_require__(24992),
  toDate: __webpack_require__(21476),
  utcToZonedTime: __webpack_require__(1132),
  zonedTimeToUtc: __webpack_require__(68516)
};

/***/ }),

/***/ 21476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;

var _index = _interopRequireDefault(__webpack_require__(82084));

var _index2 = _interopRequireDefault(__webpack_require__(93561));

var _index3 = _interopRequireDefault(__webpack_require__(32734));

var _index4 = _interopRequireDefault(__webpack_require__(7048));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: _index4.default
};
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */

function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  if (argument === null) {
    return new Date(NaN);
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  } // Clone the date


  if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument);
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;
  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN);
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN);
      }
    }

    if (dateStrings.timeZone || options.timeZone) {
      offset = (0, _index3.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));

      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      // get offset accurate to hour in time zones that change offset
      offset = (0, _index2.default)(new Date(timestamp + time));
      offset = (0, _index2.default)(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset);
  } else {
    return new Date(NaN);
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var parts = patterns.dateTimePattern.exec(dateString);
  var timeString;

  if (!parts) {
    parts = patterns.datePattern.exec(dateString);

    if (parts) {
      dateStrings.date = parts[1];
      timeString = parts[2];
    } else {
      dateStrings.date = null;
      timeString = dateString;
    }
  } else {
    dateStrings.date = parts[1];
    timeString = parts[3];
  }

  if (timeString) {
    var token = patterns.timeZone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timeZone = token[1].trim();
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];
  var token; // YYYY or ±YYYYY

  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);

  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  } // YY or ±YYY


  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);

  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  } // Invalid ISO-formatted year


  return {
    year: null
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null;
  }

  var token;
  var date;
  var month;
  var week; // YYYY

  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date;
  } // YYYY-MM


  token = patterns.MM.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month);
    return date;
  } // YYYY-DDD or YYYYDDD


  token = patterns.DDD.exec(dateString);

  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  } // yyyy-MM-dd or YYYYMMDD


  token = patterns.MMDD.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, day);
    return date;
  } // YYYY-Www or YYYYWww


  token = patterns.Www.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week);
  } // YYYY-Www-D or YYYYWwwD


  token = patterns.WwwD.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } // Invalid ISO-formatted date


  return null;
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes; // hh

  token = patterns.HH.exec(timeString);

  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR;
  } // hh:mm or hhmm


  token = patterns.HHMM.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
  } // hh:mm:ss or hhmmss


  token = patterns.HHMMSS.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
  } // Invalid ISO-formatted time


  return null;
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions


var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false;
  }

  if (date != null) {
    if (date < 1) {
      return false;
    }

    var isLeapYear = isLeapYearIndex(year);

    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false;
    }

    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false;
    }
  }

  return true;
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false;
  }

  var isLeapYear = isLeapYearIndex(year);

  if (isLeapYear && dayOfYear > 366) {
    return false;
  }

  if (!isLeapYear && dayOfYear > 365) {
    return false;
  }

  return true;
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false;
  }

  if (day != null && (day < 0 || day > 6)) {
    return false;
  }

  return true;
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false;
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false;
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false;
  }

  return true;
}

module.exports = exports.default;

/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = utcToZonedTime;

var _index = _interopRequireDefault(__webpack_require__(32734));

var _index2 = _interopRequireDefault(__webpack_require__(21476));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name utcToZonedTime
 * @category Time Zone Helpers
 * @summary Get a date/time representing local time in a given time zone from the UTC date
 *
 * @description
 * Returns a date instance with values representing the local time in the time zone
 * specified of the UTC time from the date provided. In other words, when the new date
 * is formatted it will show the equivalent hours in the target time zone regardless
 * of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with the relevant UTC time
 * @param {String} timeZone - the time zone to get local time for, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am UTC is 6am in New York (-04:00)
 * const result = utcToZonedTime('2014-06-25T10:00:00.000Z', 'America/New_York')
 * //=> Jun 25 2014 06:00:00
 */
function utcToZonedTime(dirtyDate, timeZone, options) {
  var date = (0, _index2.default)(dirtyDate, options);
  var offsetMilliseconds = (0, _index.default)(timeZone, date, true);
  var d = new Date(date.getTime() - offsetMilliseconds);
  var resultDate = new Date(0);
  resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
  return resultDate;
}

module.exports = exports.default;

/***/ }),

/***/ 68516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = zonedTimeToUtc;

var _index = _interopRequireDefault(__webpack_require__(46420));

var _index2 = _interopRequireDefault(__webpack_require__(21476));

var _index3 = _interopRequireDefault(__webpack_require__(7048));

var _index4 = _interopRequireDefault(__webpack_require__(32734));

var _index5 = _interopRequireDefault(__webpack_require__(55721));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name zonedTimeToUtc
 * @category Time Zone Helpers
 * @summary Get the UTC date/time from a date representing local time in a given time zone
 *
 * @description
 * Returns a date instance with the UTC time of the provided date of which the values
 * represented the local time in the time zone specified. In other words, if the input
 * date represented local time in time time zone, the timestamp of the output date will
 * give the equivalent UTC of that local time regardless of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with values representing the local time
 * @param {String} timeZone - the time zone of this local time, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am in Los Angeles is 5pm UTC
 * const result = zonedTimeToUtc(new Date(2014, 5, 25, 10, 0, 0), 'America/Los_Angeles')
 * //=> 2014-06-25T17:00:00.000Z
 */
function zonedTimeToUtc(date, timeZone, options) {
  if (typeof date === 'string' && !date.match(_index3.default)) {
    var extendedOptions = (0, _index.default)(options);
    extendedOptions.timeZone = timeZone;
    return (0, _index2.default)(date, extendedOptions);
  }

  var d = (0, _index2.default)(date, options);
  var utc = (0, _index5.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
  var offsetMilliseconds = (0, _index4.default)(timeZone, new Date(utc));
  return new Date(utc + offsetMilliseconds);
}

module.exports = exports.default;

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 75068:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inheritsLoose; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 39474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 4111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 71418:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs
var _possible_constructor_return = __webpack_require__(41357);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0,_possible_constructor_return/* default */.Z)(this, result);
    };
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 45785:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _get; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_super_prop_base.mjs


function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = (0,_get_prototype_of/* default */.Z)(object);
    if (object === null) break;
  }

  return object;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get.mjs


function get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    get = Reflect.get;
  } else {
    get = function get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver || target);
      }

      return desc.value;
    };
  }

  return get(target, property, receiver);
}

function _get(target, property, receiver) {
  return get(target, property, receiver);
}


/***/ }),

/***/ 82662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 28668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 53128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 41357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4111);
/* harmony import */ var _type_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82222);



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}


/***/ }),

/***/ 44998:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 10253:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91566);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 59637:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91566);





function _toArray(arr) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 25892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _wrapNativeSuper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(44998);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}


/***/ }),

/***/ 15880:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sG": function() { return /* binding */ esm_parseDate; }
});

// UNUSED EXPORTS: Chrono, Meridiem, ParsingResult, Weekday, casual, de, en, es, fr, ja, nl, parse, pt, ru, strict, uk, zh

// EXTERNAL MODULE: ./node_modules/dayjs/plugin/quarterOfYear.js
var quarterOfYear = __webpack_require__(96671);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/types.js
var types_Meridiem;
(function (Meridiem) {
    Meridiem[Meridiem["AM"] = 0] = "AM";
    Meridiem[Meridiem["PM"] = 1] = "PM";
})(types_Meridiem || (types_Meridiem = {}));
var Weekday;
(function (Weekday) {
    Weekday[Weekday["SUNDAY"] = 0] = "SUNDAY";
    Weekday[Weekday["MONDAY"] = 1] = "MONDAY";
    Weekday[Weekday["TUESDAY"] = 2] = "TUESDAY";
    Weekday[Weekday["WEDNESDAY"] = 3] = "WEDNESDAY";
    Weekday[Weekday["THURSDAY"] = 4] = "THURSDAY";
    Weekday[Weekday["FRIDAY"] = 5] = "FRIDAY";
    Weekday[Weekday["SATURDAY"] = 6] = "SATURDAY";
})(Weekday || (Weekday = {}));
var Month;
(function (Month) {
    Month[Month["JANUARY"] = 1] = "JANUARY";
    Month[Month["FEBRUARY"] = 2] = "FEBRUARY";
    Month[Month["MARCH"] = 3] = "MARCH";
    Month[Month["APRIL"] = 4] = "APRIL";
    Month[Month["MAY"] = 5] = "MAY";
    Month[Month["JUNE"] = 6] = "JUNE";
    Month[Month["JULY"] = 7] = "JULY";
    Month[Month["AUGUST"] = 8] = "AUGUST";
    Month[Month["SEPTEMBER"] = 9] = "SEPTEMBER";
    Month[Month["OCTOBER"] = 10] = "OCTOBER";
    Month[Month["NOVEMBER"] = 11] = "NOVEMBER";
    Month[Month["DECEMBER"] = 12] = "DECEMBER";
})(Month || (Month = {}));
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/utils/dayjs.js

function assignTheNextDay(component, targetDayJs) {
    targetDayJs = targetDayJs.add(1, "day");
    dayjs_assignSimilarDate(component, targetDayJs);
    implySimilarTime(component, targetDayJs);
}
function implyTheNextDay(component, targetDayJs) {
    targetDayJs = targetDayJs.add(1, "day");
    implySimilarDate(component, targetDayJs);
    implySimilarTime(component, targetDayJs);
}
function dayjs_assignSimilarDate(component, targetDayJs) {
    component.assign("day", targetDayJs.date());
    component.assign("month", targetDayJs.month() + 1);
    component.assign("year", targetDayJs.year());
}
function assignSimilarTime(component, targetDayJs) {
    component.assign("hour", targetDayJs.hour());
    component.assign("minute", targetDayJs.minute());
    component.assign("second", targetDayJs.second());
    component.assign("millisecond", targetDayJs.millisecond());
    if (component.get("hour") < 12) {
        component.assign("meridiem", types_Meridiem.AM);
    }
    else {
        component.assign("meridiem", types_Meridiem.PM);
    }
}
function implySimilarDate(component, targetDayJs) {
    component.imply("day", targetDayJs.date());
    component.imply("month", targetDayJs.month() + 1);
    component.imply("year", targetDayJs.year());
}
function implySimilarTime(component, targetDayJs) {
    component.imply("hour", targetDayJs.hour());
    component.imply("minute", targetDayJs.minute());
    component.imply("second", targetDayJs.second());
    component.imply("millisecond", targetDayJs.millisecond());
}
//# sourceMappingURL=dayjs.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/timezone.js


const TIMEZONE_ABBR_MAP = {
    ACDT: 630,
    ACST: 570,
    ADT: -180,
    AEDT: 660,
    AEST: 600,
    AFT: 270,
    AKDT: -480,
    AKST: -540,
    ALMT: 360,
    AMST: -180,
    AMT: -240,
    ANAST: 720,
    ANAT: 720,
    AQTT: 300,
    ART: -180,
    AST: -240,
    AWDT: 540,
    AWST: 480,
    AZOST: 0,
    AZOT: -60,
    AZST: 300,
    AZT: 240,
    BNT: 480,
    BOT: -240,
    BRST: -120,
    BRT: -180,
    BST: 60,
    BTT: 360,
    CAST: 480,
    CAT: 120,
    CCT: 390,
    CDT: -300,
    CEST: 120,
    CET: {
        timezoneOffsetDuringDst: 2 * 60,
        timezoneOffsetNonDst: 60,
        dstStart: (year) => getLastWeekdayOfMonth(year, Month.MARCH, Weekday.SUNDAY, 2),
        dstEnd: (year) => getLastWeekdayOfMonth(year, Month.OCTOBER, Weekday.SUNDAY, 3),
    },
    CHADT: 825,
    CHAST: 765,
    CKT: -600,
    CLST: -180,
    CLT: -240,
    COT: -300,
    CST: -360,
    CT: {
        timezoneOffsetDuringDst: -5 * 60,
        timezoneOffsetNonDst: -6 * 60,
        dstStart: (year) => getNthWeekdayOfMonth(year, Month.MARCH, Weekday.SUNDAY, 2, 2),
        dstEnd: (year) => getNthWeekdayOfMonth(year, Month.NOVEMBER, Weekday.SUNDAY, 1, 2),
    },
    CVT: -60,
    CXT: 420,
    ChST: 600,
    DAVT: 420,
    EASST: -300,
    EAST: -360,
    EAT: 180,
    ECT: -300,
    EDT: -240,
    EEST: 180,
    EET: 120,
    EGST: 0,
    EGT: -60,
    EST: -300,
    ET: {
        timezoneOffsetDuringDst: -4 * 60,
        timezoneOffsetNonDst: -5 * 60,
        dstStart: (year) => getNthWeekdayOfMonth(year, Month.MARCH, Weekday.SUNDAY, 2, 2),
        dstEnd: (year) => getNthWeekdayOfMonth(year, Month.NOVEMBER, Weekday.SUNDAY, 1, 2),
    },
    FJST: 780,
    FJT: 720,
    FKST: -180,
    FKT: -240,
    FNT: -120,
    GALT: -360,
    GAMT: -540,
    GET: 240,
    GFT: -180,
    GILT: 720,
    GMT: 0,
    GST: 240,
    GYT: -240,
    HAA: -180,
    HAC: -300,
    HADT: -540,
    HAE: -240,
    HAP: -420,
    HAR: -360,
    HAST: -600,
    HAT: -90,
    HAY: -480,
    HKT: 480,
    HLV: -210,
    HNA: -240,
    HNC: -360,
    HNE: -300,
    HNP: -480,
    HNR: -420,
    HNT: -150,
    HNY: -540,
    HOVT: 420,
    ICT: 420,
    IDT: 180,
    IOT: 360,
    IRDT: 270,
    IRKST: 540,
    IRKT: 540,
    IRST: 210,
    IST: 330,
    JST: 540,
    KGT: 360,
    KRAST: 480,
    KRAT: 480,
    KST: 540,
    KUYT: 240,
    LHDT: 660,
    LHST: 630,
    LINT: 840,
    MAGST: 720,
    MAGT: 720,
    MART: -510,
    MAWT: 300,
    MDT: -360,
    MESZ: 120,
    MEZ: 60,
    MHT: 720,
    MMT: 390,
    MSD: 240,
    MSK: 180,
    MST: -420,
    MT: {
        timezoneOffsetDuringDst: -6 * 60,
        timezoneOffsetNonDst: -7 * 60,
        dstStart: (year) => getNthWeekdayOfMonth(year, Month.MARCH, Weekday.SUNDAY, 2, 2),
        dstEnd: (year) => getNthWeekdayOfMonth(year, Month.NOVEMBER, Weekday.SUNDAY, 1, 2),
    },
    MUT: 240,
    MVT: 300,
    MYT: 480,
    NCT: 660,
    NDT: -90,
    NFT: 690,
    NOVST: 420,
    NOVT: 360,
    NPT: 345,
    NST: -150,
    NUT: -660,
    NZDT: 780,
    NZST: 720,
    OMSST: 420,
    OMST: 420,
    PDT: -420,
    PET: -300,
    PETST: 720,
    PETT: 720,
    PGT: 600,
    PHOT: 780,
    PHT: 480,
    PKT: 300,
    PMDT: -120,
    PMST: -180,
    PONT: 660,
    PST: -480,
    PT: {
        timezoneOffsetDuringDst: -7 * 60,
        timezoneOffsetNonDst: -8 * 60,
        dstStart: (year) => getNthWeekdayOfMonth(year, Month.MARCH, Weekday.SUNDAY, 2, 2),
        dstEnd: (year) => getNthWeekdayOfMonth(year, Month.NOVEMBER, Weekday.SUNDAY, 1, 2),
    },
    PWT: 540,
    PYST: -180,
    PYT: -240,
    RET: 240,
    SAMT: 240,
    SAST: 120,
    SBT: 660,
    SCT: 240,
    SGT: 480,
    SRT: -180,
    SST: -660,
    TAHT: -600,
    TFT: 300,
    TJT: 300,
    TKT: 780,
    TLT: 540,
    TMT: 300,
    TVT: 720,
    ULAT: 480,
    UTC: 0,
    UYST: -120,
    UYT: -180,
    UZT: 300,
    VET: -210,
    VLAST: 660,
    VLAT: 660,
    VUT: 660,
    WAST: 120,
    WAT: 60,
    WEST: 60,
    WESZ: 60,
    WET: 0,
    WEZ: 0,
    WFT: 720,
    WGST: -120,
    WGT: -180,
    WIB: 420,
    WIT: 540,
    WITA: 480,
    WST: 780,
    WT: 0,
    YAKST: 600,
    YAKT: 600,
    YAPT: 600,
    YEKST: 360,
    YEKT: 360,
};
function getNthWeekdayOfMonth(year, month, weekday, n, hour = 0) {
    let dayOfMonth = 0;
    let i = 0;
    while (i < n) {
        dayOfMonth++;
        const date = new Date(year, month - 1, dayOfMonth);
        if (date.getDay() === weekday)
            i++;
    }
    return new Date(year, month - 1, dayOfMonth, hour);
}
function getLastWeekdayOfMonth(year, month, weekday, hour = 0) {
    const oneIndexedWeekday = weekday === 0 ? 7 : weekday;
    const date = new Date(year, month - 1 + 1, 1, 12);
    const firstWeekdayNextMonth = date.getDay() === 0 ? 7 : date.getDay();
    let dayDiff;
    if (firstWeekdayNextMonth === oneIndexedWeekday)
        dayDiff = 7;
    else if (firstWeekdayNextMonth < oneIndexedWeekday)
        dayDiff = 7 + firstWeekdayNextMonth - oneIndexedWeekday;
    else
        dayDiff = firstWeekdayNextMonth - oneIndexedWeekday;
    date.setDate(date.getDate() - dayDiff);
    return new Date(year, month - 1, date.getDate(), hour);
}
function toTimezoneOffset(timezoneInput, date, timezoneOverrides = {}) {
    if (timezoneInput == null) {
        return null;
    }
    if (typeof timezoneInput === "number") {
        return timezoneInput;
    }
    const matchedTimezone = timezoneOverrides[timezoneInput] ?? TIMEZONE_ABBR_MAP[timezoneInput];
    if (matchedTimezone == null) {
        return null;
    }
    if (typeof matchedTimezone == "number") {
        return matchedTimezone;
    }
    if (date == null) {
        return null;
    }
    if (dayjs_min(date).isAfter(matchedTimezone.dstStart(date.getFullYear())) &&
        !dayjs_min(date).isAfter(matchedTimezone.dstEnd(date.getFullYear()))) {
        return matchedTimezone.timezoneOffsetDuringDst;
    }
    return matchedTimezone.timezoneOffsetNonDst;
}
//# sourceMappingURL=timezone.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/results.js




dayjs_min.extend(quarterOfYear);
class ReferenceWithTimezone {
    constructor(input) {
        input = input ?? new Date();
        if (input instanceof Date) {
            this.instant = input;
        }
        else {
            this.instant = input.instant ?? new Date();
            this.timezoneOffset = toTimezoneOffset(input.timezone, this.instant);
        }
    }
    getDateWithAdjustedTimezone() {
        return new Date(this.instant.getTime() + this.getSystemTimezoneAdjustmentMinute(this.instant) * 60000);
    }
    getSystemTimezoneAdjustmentMinute(date, overrideTimezoneOffset) {
        if (!date || date.getTime() < 0) {
            date = new Date();
        }
        const currentTimezoneOffset = -date.getTimezoneOffset();
        const targetTimezoneOffset = overrideTimezoneOffset ?? this.timezoneOffset ?? currentTimezoneOffset;
        return currentTimezoneOffset - targetTimezoneOffset;
    }
}
class results_ParsingComponents {
    constructor(reference, knownComponents) {
        this.reference = reference;
        this.knownValues = {};
        this.impliedValues = {};
        if (knownComponents) {
            for (const key in knownComponents) {
                this.knownValues[key] = knownComponents[key];
            }
        }
        const refDayJs = dayjs_min(reference.instant);
        this.imply("day", refDayJs.date());
        this.imply("month", refDayJs.month() + 1);
        this.imply("year", refDayJs.year());
        this.imply("hour", 12);
        this.imply("minute", 0);
        this.imply("second", 0);
        this.imply("millisecond", 0);
    }
    get(component) {
        if (component in this.knownValues) {
            return this.knownValues[component];
        }
        if (component in this.impliedValues) {
            return this.impliedValues[component];
        }
        return null;
    }
    isCertain(component) {
        return component in this.knownValues;
    }
    getCertainComponents() {
        return Object.keys(this.knownValues);
    }
    imply(component, value) {
        if (component in this.knownValues) {
            return this;
        }
        this.impliedValues[component] = value;
        return this;
    }
    assign(component, value) {
        this.knownValues[component] = value;
        delete this.impliedValues[component];
        return this;
    }
    delete(component) {
        delete this.knownValues[component];
        delete this.impliedValues[component];
    }
    clone() {
        const component = new results_ParsingComponents(this.reference);
        component.knownValues = {};
        component.impliedValues = {};
        for (const key in this.knownValues) {
            component.knownValues[key] = this.knownValues[key];
        }
        for (const key in this.impliedValues) {
            component.impliedValues[key] = this.impliedValues[key];
        }
        return component;
    }
    isOnlyDate() {
        return !this.isCertain("hour") && !this.isCertain("minute") && !this.isCertain("second");
    }
    isOnlyTime() {
        return !this.isCertain("weekday") && !this.isCertain("day") && !this.isCertain("month");
    }
    isOnlyWeekdayComponent() {
        return this.isCertain("weekday") && !this.isCertain("day") && !this.isCertain("month");
    }
    isDateWithUnknownYear() {
        return this.isCertain("month") && !this.isCertain("year");
    }
    isValidDate() {
        const date = this.dateWithoutTimezoneAdjustment();
        if (date.getFullYear() !== this.get("year"))
            return false;
        if (date.getMonth() !== this.get("month") - 1)
            return false;
        if (date.getDate() !== this.get("day"))
            return false;
        if (this.get("hour") != null && date.getHours() != this.get("hour"))
            return false;
        if (this.get("minute") != null && date.getMinutes() != this.get("minute"))
            return false;
        return true;
    }
    toString() {
        return `[ParsingComponents {knownValues: ${JSON.stringify(this.knownValues)}, impliedValues: ${JSON.stringify(this.impliedValues)}}, reference: ${JSON.stringify(this.reference)}]`;
    }
    dayjs() {
        return dayjs_min(this.date());
    }
    date() {
        const date = this.dateWithoutTimezoneAdjustment();
        const timezoneAdjustment = this.reference.getSystemTimezoneAdjustmentMinute(date, this.get("timezoneOffset"));
        return new Date(date.getTime() + timezoneAdjustment * 60000);
    }
    dateWithoutTimezoneAdjustment() {
        const date = new Date(this.get("year"), this.get("month") - 1, this.get("day"), this.get("hour"), this.get("minute"), this.get("second"), this.get("millisecond"));
        date.setFullYear(this.get("year"));
        return date;
    }
    static createRelativeFromReference(reference, fragments) {
        let date = dayjs_min(reference.instant);
        for (const key in fragments) {
            date = date.add(fragments[key], key);
        }
        const components = new results_ParsingComponents(reference);
        if (fragments["hour"] || fragments["minute"] || fragments["second"]) {
            assignSimilarTime(components, date);
            dayjs_assignSimilarDate(components, date);
            if (reference.timezoneOffset !== null) {
                components.assign("timezoneOffset", -reference.instant.getTimezoneOffset());
            }
        }
        else {
            implySimilarTime(components, date);
            if (reference.timezoneOffset !== null) {
                components.imply("timezoneOffset", -reference.instant.getTimezoneOffset());
            }
            if (fragments["d"]) {
                components.assign("day", date.date());
                components.assign("month", date.month() + 1);
                components.assign("year", date.year());
            }
            else {
                if (fragments["week"]) {
                    components.imply("weekday", date.day());
                }
                components.imply("day", date.date());
                if (fragments["month"]) {
                    components.assign("month", date.month() + 1);
                    components.assign("year", date.year());
                }
                else {
                    components.imply("month", date.month() + 1);
                    if (fragments["year"]) {
                        components.assign("year", date.year());
                    }
                    else {
                        components.imply("year", date.year());
                    }
                }
            }
        }
        return components;
    }
}
class ParsingResult {
    constructor(reference, index, text, start, end) {
        this.reference = reference;
        this.refDate = reference.instant;
        this.index = index;
        this.text = text;
        this.start = start || new results_ParsingComponents(reference);
        this.end = end;
    }
    clone() {
        const result = new ParsingResult(this.reference, this.index, this.text);
        result.start = this.start ? this.start.clone() : null;
        result.end = this.end ? this.end.clone() : null;
        return result;
    }
    date() {
        return this.start.date();
    }
    toString() {
        return `[ParsingResult {index: ${this.index}, text: '${this.text}', ...}]`;
    }
}
//# sourceMappingURL=results.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/utils/pattern.js
function repeatedTimeunitPattern(prefix, singleTimeunitPattern) {
    const singleTimeunitPatternNoCapture = singleTimeunitPattern.replace(/\((?!\?)/g, "(?:");
    return `${prefix}${singleTimeunitPatternNoCapture}\\s{0,5}(?:,?\\s{0,5}${singleTimeunitPatternNoCapture}){0,10}`;
}
function extractTerms(dictionary) {
    let keys;
    if (dictionary instanceof Array) {
        keys = [...dictionary];
    }
    else if (dictionary instanceof Map) {
        keys = Array.from(dictionary.keys());
    }
    else {
        keys = Object.keys(dictionary);
    }
    return keys;
}
function matchAnyPattern(dictionary) {
    const joinedTerms = extractTerms(dictionary)
        .sort((a, b) => b.length - a.length)
        .join("|")
        .replace(/\./g, "\\.");
    return `(?:${joinedTerms})`;
}
//# sourceMappingURL=pattern.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/calculation/years.js

function findMostLikelyADYear(yearNumber) {
    if (yearNumber < 100) {
        if (yearNumber > 50) {
            yearNumber = yearNumber + 1900;
        }
        else {
            yearNumber = yearNumber + 2000;
        }
    }
    return yearNumber;
}
function findYearClosestToRef(refDate, day, month) {
    const refMoment = dayjs_min(refDate);
    let dateMoment = refMoment;
    dateMoment = dateMoment.month(month - 1);
    dateMoment = dateMoment.date(day);
    dateMoment = dateMoment.year(refMoment.year());
    const nextYear = dateMoment.add(1, "y");
    const lastYear = dateMoment.add(-1, "y");
    if (Math.abs(nextYear.diff(refMoment)) < Math.abs(dateMoment.diff(refMoment))) {
        dateMoment = nextYear;
    }
    else if (Math.abs(lastYear.diff(refMoment)) < Math.abs(dateMoment.diff(refMoment))) {
        dateMoment = lastYear;
    }
    return dateMoment.year();
}
//# sourceMappingURL=years.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/constants.js


const WEEKDAY_DICTIONARY = {
    sunday: 0,
    sun: 0,
    "sun.": 0,
    monday: 1,
    mon: 1,
    "mon.": 1,
    tuesday: 2,
    tue: 2,
    "tue.": 2,
    wednesday: 3,
    wed: 3,
    "wed.": 3,
    thursday: 4,
    thurs: 4,
    "thurs.": 4,
    thur: 4,
    "thur.": 4,
    thu: 4,
    "thu.": 4,
    friday: 5,
    fri: 5,
    "fri.": 5,
    saturday: 6,
    sat: 6,
    "sat.": 6,
};
const FULL_MONTH_NAME_DICTIONARY = {
    january: 1,
    february: 2,
    march: 3,
    april: 4,
    may: 5,
    june: 6,
    july: 7,
    august: 8,
    september: 9,
    october: 10,
    november: 11,
    december: 12,
};
const MONTH_DICTIONARY = {
    ...FULL_MONTH_NAME_DICTIONARY,
    jan: 1,
    "jan.": 1,
    feb: 2,
    "feb.": 2,
    mar: 3,
    "mar.": 3,
    apr: 4,
    "apr.": 4,
    jun: 6,
    "jun.": 6,
    jul: 7,
    "jul.": 7,
    aug: 8,
    "aug.": 8,
    sep: 9,
    "sep.": 9,
    sept: 9,
    "sept.": 9,
    oct: 10,
    "oct.": 10,
    nov: 11,
    "nov.": 11,
    dec: 12,
    "dec.": 12,
};
const INTEGER_WORD_DICTIONARY = {
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
    seven: 7,
    eight: 8,
    nine: 9,
    ten: 10,
    eleven: 11,
    twelve: 12,
};
const ORDINAL_WORD_DICTIONARY = {
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
    fifth: 5,
    sixth: 6,
    seventh: 7,
    eighth: 8,
    ninth: 9,
    tenth: 10,
    eleventh: 11,
    twelfth: 12,
    thirteenth: 13,
    fourteenth: 14,
    fifteenth: 15,
    sixteenth: 16,
    seventeenth: 17,
    eighteenth: 18,
    nineteenth: 19,
    twentieth: 20,
    "twenty first": 21,
    "twenty-first": 21,
    "twenty second": 22,
    "twenty-second": 22,
    "twenty third": 23,
    "twenty-third": 23,
    "twenty fourth": 24,
    "twenty-fourth": 24,
    "twenty fifth": 25,
    "twenty-fifth": 25,
    "twenty sixth": 26,
    "twenty-sixth": 26,
    "twenty seventh": 27,
    "twenty-seventh": 27,
    "twenty eighth": 28,
    "twenty-eighth": 28,
    "twenty ninth": 29,
    "twenty-ninth": 29,
    "thirtieth": 30,
    "thirty first": 31,
    "thirty-first": 31,
};
const TIME_UNIT_DICTIONARY_NO_ABBR = {
    second: "second",
    seconds: "second",
    minute: "minute",
    minutes: "minute",
    hour: "hour",
    hours: "hour",
    day: "d",
    days: "d",
    week: "week",
    weeks: "week",
    month: "month",
    months: "month",
    quarter: "quarter",
    quarters: "quarter",
    year: "year",
    years: "year",
};
const TIME_UNIT_DICTIONARY = {
    s: "second",
    sec: "second",
    second: "second",
    seconds: "second",
    m: "minute",
    min: "minute",
    mins: "minute",
    minute: "minute",
    minutes: "minute",
    h: "hour",
    hr: "hour",
    hrs: "hour",
    hour: "hour",
    hours: "hour",
    d: "d",
    day: "d",
    days: "d",
    w: "w",
    week: "week",
    weeks: "week",
    mo: "month",
    mon: "month",
    mos: "month",
    month: "month",
    months: "month",
    qtr: "quarter",
    quarter: "quarter",
    quarters: "quarter",
    y: "year",
    yr: "year",
    year: "year",
    years: "year",
    ...TIME_UNIT_DICTIONARY_NO_ABBR,
};
const NUMBER_PATTERN = `(?:${matchAnyPattern(INTEGER_WORD_DICTIONARY)}|[0-9]+|[0-9]+\\.[0-9]+|half(?:\\s{0,2}an?)?|an?\\b(?:\\s{0,2}few)?|few|several|the|a?\\s{0,2}couple\\s{0,2}(?:of)?)`;
function parseNumberPattern(match) {
    const num = match.toLowerCase();
    if (INTEGER_WORD_DICTIONARY[num] !== undefined) {
        return INTEGER_WORD_DICTIONARY[num];
    }
    else if (num === "a" || num === "an" || num == "the") {
        return 1;
    }
    else if (num.match(/few/)) {
        return 3;
    }
    else if (num.match(/half/)) {
        return 0.5;
    }
    else if (num.match(/couple/)) {
        return 2;
    }
    else if (num.match(/several/)) {
        return 7;
    }
    return parseFloat(num);
}
const ORDINAL_NUMBER_PATTERN = `(?:${matchAnyPattern(ORDINAL_WORD_DICTIONARY)}|[0-9]{1,2}(?:st|nd|rd|th)?)`;
function parseOrdinalNumberPattern(match) {
    let num = match.toLowerCase();
    if (ORDINAL_WORD_DICTIONARY[num] !== undefined) {
        return ORDINAL_WORD_DICTIONARY[num];
    }
    num = num.replace(/(?:st|nd|rd|th)$/i, "");
    return parseInt(num);
}
const YEAR_PATTERN = `(?:[1-9][0-9]{0,3}\\s{0,2}(?:BE|AD|BC|BCE|CE)|[1-2][0-9]{3}|[5-9][0-9])`;
function parseYear(match) {
    if (/BE/i.test(match)) {
        match = match.replace(/BE/i, "");
        return parseInt(match) - 543;
    }
    if (/BCE?/i.test(match)) {
        match = match.replace(/BCE?/i, "");
        return -parseInt(match);
    }
    if (/(AD|CE)/i.test(match)) {
        match = match.replace(/(AD|CE)/i, "");
        return parseInt(match);
    }
    const rawYearNumber = parseInt(match);
    return findMostLikelyADYear(rawYearNumber);
}
const SINGLE_TIME_UNIT_PATTERN = `(${NUMBER_PATTERN})\\s{0,3}(${matchAnyPattern(TIME_UNIT_DICTIONARY)})`;
const SINGLE_TIME_UNIT_REGEX = new RegExp(SINGLE_TIME_UNIT_PATTERN, "i");
const SINGLE_TIME_UNIT_NO_ABBR_PATTERN = `(${NUMBER_PATTERN})\\s{0,3}(${matchAnyPattern(TIME_UNIT_DICTIONARY_NO_ABBR)})`;
const TIME_UNITS_PATTERN = repeatedTimeunitPattern(`(?:(?:about|around)\\s{0,3})?`, SINGLE_TIME_UNIT_PATTERN);
const TIME_UNITS_NO_ABBR_PATTERN = repeatedTimeunitPattern(`(?:(?:about|around)\\s{0,3})?`, SINGLE_TIME_UNIT_NO_ABBR_PATTERN);
function parseTimeUnits(timeunitText) {
    const fragments = {};
    let remainingText = timeunitText;
    let match = SINGLE_TIME_UNIT_REGEX.exec(remainingText);
    while (match) {
        collectDateTimeFragment(fragments, match);
        remainingText = remainingText.substring(match[0].length).trim();
        match = SINGLE_TIME_UNIT_REGEX.exec(remainingText);
    }
    return fragments;
}
function collectDateTimeFragment(fragments, match) {
    const num = parseNumberPattern(match[1]);
    const unit = TIME_UNIT_DICTIONARY[match[2].toLowerCase()];
    fragments[unit] = num;
}
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/parsers/AbstractParserWithWordBoundary.js
class AbstractParserWithWordBoundaryChecking {
    constructor() {
        this.cachedInnerPattern = null;
        this.cachedPattern = null;
    }
    patternLeftBoundary() {
        return `(\\W|^)`;
    }
    pattern(context) {
        const innerPattern = this.innerPattern(context);
        if (innerPattern == this.cachedInnerPattern) {
            return this.cachedPattern;
        }
        this.cachedPattern = new RegExp(`${this.patternLeftBoundary()}${innerPattern.source}`, innerPattern.flags);
        this.cachedInnerPattern = innerPattern;
        return this.cachedPattern;
    }
    extract(context, match) {
        const header = match[1] ?? "";
        match.index = match.index + header.length;
        match[0] = match[0].substring(header.length);
        for (let i = 2; i < match.length; i++) {
            match[i - 1] = match[i];
        }
        return this.innerExtract(context, match);
    }
}
//# sourceMappingURL=AbstractParserWithWordBoundary.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENTimeUnitWithinFormatParser.js



const PATTERN_WITHOUT_PREFIX = new RegExp(`(?:(?:about|around|roughly|approximately|just)\\s*(?:~\\s*)?)?(${TIME_UNITS_PATTERN})(?=\\W|$)`, "i");
const PATTERN_WITH_PREFIX = new RegExp(`(?:within|in|for)\\s*` +
    `(?:(?:about|around|roughly|approximately|just)\\s*(?:~\\s*)?)?(${TIME_UNITS_PATTERN})(?=\\W|$)`, "i");
const PATTERN_WITH_PREFIX_STRICT = new RegExp(`(?:within|in|for)\\s*` +
    `(?:(?:about|around|roughly|approximately|just)\\s*(?:~\\s*)?)?(${TIME_UNITS_NO_ABBR_PATTERN})(?=\\W|$)`, "i");
class ENTimeUnitWithinFormatParser extends AbstractParserWithWordBoundaryChecking {
    constructor(strictMode) {
        super();
        this.strictMode = strictMode;
    }
    innerPattern(context) {
        if (this.strictMode) {
            return PATTERN_WITH_PREFIX_STRICT;
        }
        return context.option.forwardDate ? PATTERN_WITHOUT_PREFIX : PATTERN_WITH_PREFIX;
    }
    innerExtract(context, match) {
        const timeUnits = parseTimeUnits(match[1]);
        return results_ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
    }
}
//# sourceMappingURL=ENTimeUnitWithinFormatParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENMonthNameLittleEndianParser.js






const PATTERN = new RegExp(`(?:on\\s{0,3})?` +
    `(${ORDINAL_NUMBER_PATTERN})` +
    `(?:` +
    `\\s{0,3}(?:to|\\-|\\–|until|through|till)?\\s{0,3}` +
    `(${ORDINAL_NUMBER_PATTERN})` +
    ")?" +
    `(?:-|/|\\s{0,3}(?:of)?\\s{0,3})` +
    `(${matchAnyPattern(MONTH_DICTIONARY)})` +
    "(?:" +
    `(?:-|/|,?\\s{0,3})` +
    `(${YEAR_PATTERN}(?![^\\s]\\d))` +
    ")?" +
    "(?=\\W|$)", "i");
const DATE_GROUP = 1;
const DATE_TO_GROUP = 2;
const MONTH_NAME_GROUP = 3;
const YEAR_GROUP = 4;
class ENMonthNameLittleEndianParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return PATTERN;
    }
    innerExtract(context, match) {
        const result = context.createParsingResult(match.index, match[0]);
        const month = MONTH_DICTIONARY[match[MONTH_NAME_GROUP].toLowerCase()];
        const day = parseOrdinalNumberPattern(match[DATE_GROUP]);
        if (day > 31) {
            match.index = match.index + match[DATE_GROUP].length;
            return null;
        }
        result.start.assign("month", month);
        result.start.assign("day", day);
        if (match[YEAR_GROUP]) {
            const yearNumber = parseYear(match[YEAR_GROUP]);
            result.start.assign("year", yearNumber);
        }
        else {
            const year = findYearClosestToRef(context.refDate, day, month);
            result.start.imply("year", year);
        }
        if (match[DATE_TO_GROUP]) {
            const endDate = parseOrdinalNumberPattern(match[DATE_TO_GROUP]);
            result.end = result.start.clone();
            result.end.assign("day", endDate);
        }
        return result;
    }
}
//# sourceMappingURL=ENMonthNameLittleEndianParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENMonthNameMiddleEndianParser.js






const ENMonthNameMiddleEndianParser_PATTERN = new RegExp(`(${matchAnyPattern(MONTH_DICTIONARY)})` +
    "(?:-|/|\\s*,?\\s*)" +
    `(${ORDINAL_NUMBER_PATTERN})(?!\\s*(?:am|pm))\\s*` +
    "(?:" +
    "(?:to|\\-)\\s*" +
    `(${ORDINAL_NUMBER_PATTERN})\\s*` +
    ")?" +
    "(?:" +
    "(?:-|/|\\s*,?\\s*)" +
    `(${YEAR_PATTERN})` +
    ")?" +
    "(?=\\W|$)(?!\\:\\d)", "i");
const ENMonthNameMiddleEndianParser_MONTH_NAME_GROUP = 1;
const ENMonthNameMiddleEndianParser_DATE_GROUP = 2;
const ENMonthNameMiddleEndianParser_DATE_TO_GROUP = 3;
const ENMonthNameMiddleEndianParser_YEAR_GROUP = 4;
class ENMonthNameMiddleEndianParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return ENMonthNameMiddleEndianParser_PATTERN;
    }
    innerExtract(context, match) {
        const month = MONTH_DICTIONARY[match[ENMonthNameMiddleEndianParser_MONTH_NAME_GROUP].toLowerCase()];
        const day = parseOrdinalNumberPattern(match[ENMonthNameMiddleEndianParser_DATE_GROUP]);
        if (day > 31) {
            return null;
        }
        const components = context.createParsingComponents({
            day: day,
            month: month,
        });
        if (match[ENMonthNameMiddleEndianParser_YEAR_GROUP]) {
            const year = parseYear(match[ENMonthNameMiddleEndianParser_YEAR_GROUP]);
            components.assign("year", year);
        }
        else {
            const year = findYearClosestToRef(context.refDate, day, month);
            components.imply("year", year);
        }
        if (!match[ENMonthNameMiddleEndianParser_DATE_TO_GROUP]) {
            return components;
        }
        const endDate = parseOrdinalNumberPattern(match[ENMonthNameMiddleEndianParser_DATE_TO_GROUP]);
        const result = context.createParsingResult(match.index, match[0]);
        result.start = components;
        result.end = components.clone();
        result.end.assign("day", endDate);
        return result;
    }
}
//# sourceMappingURL=ENMonthNameMiddleEndianParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENMonthNameParser.js





const ENMonthNameParser_PATTERN = new RegExp(`((?:in)\\s*)?` +
    `(${matchAnyPattern(MONTH_DICTIONARY)})` +
    `\\s*` +
    `(?:` +
    `[,-]?\\s*(${YEAR_PATTERN})?` +
    ")?" +
    "(?=[^\\s\\w]|\\s+[^0-9]|\\s+$|$)", "i");
const PREFIX_GROUP = 1;
const ENMonthNameParser_MONTH_NAME_GROUP = 2;
const ENMonthNameParser_YEAR_GROUP = 3;
class ENMonthNameParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return ENMonthNameParser_PATTERN;
    }
    innerExtract(context, match) {
        const monthName = match[ENMonthNameParser_MONTH_NAME_GROUP].toLowerCase();
        if (match[0].length <= 3 && !FULL_MONTH_NAME_DICTIONARY[monthName]) {
            return null;
        }
        const result = context.createParsingResult(match.index + (match[PREFIX_GROUP] || "").length, match.index + match[0].length);
        result.start.imply("day", 1);
        const month = MONTH_DICTIONARY[monthName];
        result.start.assign("month", month);
        if (match[ENMonthNameParser_YEAR_GROUP]) {
            const year = parseYear(match[ENMonthNameParser_YEAR_GROUP]);
            result.start.assign("year", year);
        }
        else {
            const year = findYearClosestToRef(context.refDate, 1, month);
            result.start.imply("year", year);
        }
        return result;
    }
}
//# sourceMappingURL=ENMonthNameParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENCasualYearMonthDayParser.js



const ENCasualYearMonthDayParser_PATTERN = new RegExp(`([0-9]{4})[\\.\\/\\s]` +
    `(?:(${matchAnyPattern(MONTH_DICTIONARY)})|([0-9]{1,2}))[\\.\\/\\s]` +
    `([0-9]{1,2})` +
    "(?=\\W|$)", "i");
const YEAR_NUMBER_GROUP = 1;
const ENCasualYearMonthDayParser_MONTH_NAME_GROUP = 2;
const MONTH_NUMBER_GROUP = 3;
const DATE_NUMBER_GROUP = 4;
class ENCasualYearMonthDayParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return ENCasualYearMonthDayParser_PATTERN;
    }
    innerExtract(context, match) {
        const month = match[MONTH_NUMBER_GROUP]
            ? parseInt(match[MONTH_NUMBER_GROUP])
            : MONTH_DICTIONARY[match[ENCasualYearMonthDayParser_MONTH_NAME_GROUP].toLowerCase()];
        if (month < 1 || month > 12) {
            return null;
        }
        const year = parseInt(match[YEAR_NUMBER_GROUP]);
        const day = parseInt(match[DATE_NUMBER_GROUP]);
        return {
            day: day,
            month: month,
            year: year,
        };
    }
}
//# sourceMappingURL=ENCasualYearMonthDayParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENSlashMonthFormatParser.js

const ENSlashMonthFormatParser_PATTERN = new RegExp("([0-9]|0[1-9]|1[012])/([0-9]{4})" + "", "i");
const MONTH_GROUP = 1;
const ENSlashMonthFormatParser_YEAR_GROUP = 2;
class ENSlashMonthFormatParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return ENSlashMonthFormatParser_PATTERN;
    }
    innerExtract(context, match) {
        const year = parseInt(match[ENSlashMonthFormatParser_YEAR_GROUP]);
        const month = parseInt(match[MONTH_GROUP]);
        return context.createParsingComponents().imply("day", 1).assign("month", month).assign("year", year);
    }
}
//# sourceMappingURL=ENSlashMonthFormatParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/parsers/AbstractTimeExpressionParser.js

function primaryTimePattern(leftBoundary, primaryPrefix, primarySuffix, flags) {
    return new RegExp(`${leftBoundary}` +
        `${primaryPrefix}` +
        `(\\d{1,4})` +
        `(?:` +
        `(?:\\.|:|：)` +
        `(\\d{1,2})` +
        `(?:` +
        `(?::|：)` +
        `(\\d{2})` +
        `(?:\\.(\\d{1,6}))?` +
        `)?` +
        `)?` +
        `(?:\\s*(a\\.m\\.|p\\.m\\.|am?|pm?))?` +
        `${primarySuffix}`, flags);
}
function followingTimePatten(followingPhase, followingSuffix) {
    return new RegExp(`^(${followingPhase})` +
        `(\\d{1,4})` +
        `(?:` +
        `(?:\\.|\\:|\\：)` +
        `(\\d{1,2})` +
        `(?:` +
        `(?:\\.|\\:|\\：)` +
        `(\\d{1,2})(?:\\.(\\d{1,6}))?` +
        `)?` +
        `)?` +
        `(?:\\s*(a\\.m\\.|p\\.m\\.|am?|pm?))?` +
        `${followingSuffix}`, "i");
}
const HOUR_GROUP = 2;
const MINUTE_GROUP = 3;
const SECOND_GROUP = 4;
const MILLI_SECOND_GROUP = 5;
const AM_PM_HOUR_GROUP = 6;
class AbstractTimeExpressionParser {
    constructor(strictMode = false) {
        this.cachedPrimaryPrefix = null;
        this.cachedPrimarySuffix = null;
        this.cachedPrimaryTimePattern = null;
        this.cachedFollowingPhase = null;
        this.cachedFollowingSuffix = null;
        this.cachedFollowingTimePatten = null;
        this.strictMode = strictMode;
    }
    patternFlags() {
        return "i";
    }
    primaryPatternLeftBoundary() {
        return `(^|\\s|T|\\b)`;
    }
    primarySuffix() {
        return `(?=\\W|$)`;
    }
    followingSuffix() {
        return `(?=\\W|$)`;
    }
    pattern(context) {
        return this.getPrimaryTimePatternThroughCache();
    }
    extract(context, match) {
        const startComponents = this.extractPrimaryTimeComponents(context, match);
        if (!startComponents) {
            match.index += match[0].length;
            return null;
        }
        const index = match.index + match[1].length;
        const text = match[0].substring(match[1].length);
        const result = context.createParsingResult(index, text, startComponents);
        match.index += match[0].length;
        const remainingText = context.text.substring(match.index);
        const followingPattern = this.getFollowingTimePatternThroughCache();
        const followingMatch = followingPattern.exec(remainingText);
        if (text.match(/^\d{3,4}/) && followingMatch && followingMatch[0].match(/^\s*([+-])\s*\d{2,4}$/)) {
            return null;
        }
        if (!followingMatch ||
            followingMatch[0].match(/^\s*([+-])\s*\d{3,4}$/)) {
            return this.checkAndReturnWithoutFollowingPattern(result);
        }
        result.end = this.extractFollowingTimeComponents(context, followingMatch, result);
        if (result.end) {
            result.text += followingMatch[0];
        }
        return this.checkAndReturnWithFollowingPattern(result);
    }
    extractPrimaryTimeComponents(context, match, strict = false) {
        const components = context.createParsingComponents();
        let minute = 0;
        let meridiem = null;
        let hour = parseInt(match[HOUR_GROUP]);
        if (hour > 100) {
            if (this.strictMode || match[MINUTE_GROUP] != null) {
                return null;
            }
            minute = hour % 100;
            hour = Math.floor(hour / 100);
        }
        if (hour > 24) {
            return null;
        }
        if (match[MINUTE_GROUP] != null) {
            if (match[MINUTE_GROUP].length == 1 && !match[AM_PM_HOUR_GROUP]) {
                return null;
            }
            minute = parseInt(match[MINUTE_GROUP]);
        }
        if (minute >= 60) {
            return null;
        }
        if (hour > 12) {
            meridiem = types_Meridiem.PM;
        }
        if (match[AM_PM_HOUR_GROUP] != null) {
            if (hour > 12)
                return null;
            const ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
            if (ampm == "a") {
                meridiem = types_Meridiem.AM;
                if (hour == 12) {
                    hour = 0;
                }
            }
            if (ampm == "p") {
                meridiem = types_Meridiem.PM;
                if (hour != 12) {
                    hour += 12;
                }
            }
        }
        components.assign("hour", hour);
        components.assign("minute", minute);
        if (meridiem !== null) {
            components.assign("meridiem", meridiem);
        }
        else {
            if (hour < 12) {
                components.imply("meridiem", types_Meridiem.AM);
            }
            else {
                components.imply("meridiem", types_Meridiem.PM);
            }
        }
        if (match[MILLI_SECOND_GROUP] != null) {
            const millisecond = parseInt(match[MILLI_SECOND_GROUP].substring(0, 3));
            if (millisecond >= 1000)
                return null;
            components.assign("millisecond", millisecond);
        }
        if (match[SECOND_GROUP] != null) {
            const second = parseInt(match[SECOND_GROUP]);
            if (second >= 60)
                return null;
            components.assign("second", second);
        }
        return components;
    }
    extractFollowingTimeComponents(context, match, result) {
        const components = context.createParsingComponents();
        if (match[MILLI_SECOND_GROUP] != null) {
            const millisecond = parseInt(match[MILLI_SECOND_GROUP].substring(0, 3));
            if (millisecond >= 1000)
                return null;
            components.assign("millisecond", millisecond);
        }
        if (match[SECOND_GROUP] != null) {
            const second = parseInt(match[SECOND_GROUP]);
            if (second >= 60)
                return null;
            components.assign("second", second);
        }
        let hour = parseInt(match[HOUR_GROUP]);
        let minute = 0;
        let meridiem = -1;
        if (match[MINUTE_GROUP] != null) {
            minute = parseInt(match[MINUTE_GROUP]);
        }
        else if (hour > 100) {
            minute = hour % 100;
            hour = Math.floor(hour / 100);
        }
        if (minute >= 60 || hour > 24) {
            return null;
        }
        if (hour >= 12) {
            meridiem = types_Meridiem.PM;
        }
        if (match[AM_PM_HOUR_GROUP] != null) {
            if (hour > 12) {
                return null;
            }
            const ampm = match[AM_PM_HOUR_GROUP][0].toLowerCase();
            if (ampm == "a") {
                meridiem = types_Meridiem.AM;
                if (hour == 12) {
                    hour = 0;
                    if (!components.isCertain("day")) {
                        components.imply("day", components.get("day") + 1);
                    }
                }
            }
            if (ampm == "p") {
                meridiem = types_Meridiem.PM;
                if (hour != 12)
                    hour += 12;
            }
            if (!result.start.isCertain("meridiem")) {
                if (meridiem == types_Meridiem.AM) {
                    result.start.imply("meridiem", types_Meridiem.AM);
                    if (result.start.get("hour") == 12) {
                        result.start.assign("hour", 0);
                    }
                }
                else {
                    result.start.imply("meridiem", types_Meridiem.PM);
                    if (result.start.get("hour") != 12) {
                        result.start.assign("hour", result.start.get("hour") + 12);
                    }
                }
            }
        }
        components.assign("hour", hour);
        components.assign("minute", minute);
        if (meridiem >= 0) {
            components.assign("meridiem", meridiem);
        }
        else {
            const startAtPM = result.start.isCertain("meridiem") && result.start.get("hour") > 12;
            if (startAtPM) {
                if (result.start.get("hour") - 12 > hour) {
                    components.imply("meridiem", types_Meridiem.AM);
                }
                else if (hour <= 12) {
                    components.assign("hour", hour + 12);
                    components.assign("meridiem", types_Meridiem.PM);
                }
            }
            else if (hour > 12) {
                components.imply("meridiem", types_Meridiem.PM);
            }
            else if (hour <= 12) {
                components.imply("meridiem", types_Meridiem.AM);
            }
        }
        if (components.date().getTime() < result.start.date().getTime()) {
            components.imply("day", components.get("day") + 1);
        }
        return components;
    }
    checkAndReturnWithoutFollowingPattern(result) {
        if (result.text.match(/^\d$/)) {
            return null;
        }
        if (result.text.match(/^\d\d\d+$/)) {
            return null;
        }
        if (result.text.match(/\d[apAP]$/)) {
            return null;
        }
        const endingWithNumbers = result.text.match(/[^\d:.](\d[\d.]+)$/);
        if (endingWithNumbers) {
            const endingNumbers = endingWithNumbers[1];
            if (this.strictMode) {
                return null;
            }
            if (endingNumbers.includes(".") && !endingNumbers.match(/\d(\.\d{2})+$/)) {
                return null;
            }
            const endingNumberVal = parseInt(endingNumbers);
            if (endingNumberVal > 24) {
                return null;
            }
        }
        return result;
    }
    checkAndReturnWithFollowingPattern(result) {
        if (result.text.match(/^\d+-\d+$/)) {
            return null;
        }
        const endingWithNumbers = result.text.match(/[^\d:.](\d[\d.]+)\s*-\s*(\d[\d.]+)$/);
        if (endingWithNumbers) {
            if (this.strictMode) {
                return null;
            }
            const startingNumbers = endingWithNumbers[1];
            const endingNumbers = endingWithNumbers[2];
            if (endingNumbers.includes(".") && !endingNumbers.match(/\d(\.\d{2})+$/)) {
                return null;
            }
            const endingNumberVal = parseInt(endingNumbers);
            const startingNumberVal = parseInt(startingNumbers);
            if (endingNumberVal > 24 || startingNumberVal > 24) {
                return null;
            }
        }
        return result;
    }
    getPrimaryTimePatternThroughCache() {
        const primaryPrefix = this.primaryPrefix();
        const primarySuffix = this.primarySuffix();
        if (this.cachedPrimaryPrefix === primaryPrefix && this.cachedPrimarySuffix === primarySuffix) {
            return this.cachedPrimaryTimePattern;
        }
        this.cachedPrimaryTimePattern = primaryTimePattern(this.primaryPatternLeftBoundary(), primaryPrefix, primarySuffix, this.patternFlags());
        this.cachedPrimaryPrefix = primaryPrefix;
        this.cachedPrimarySuffix = primarySuffix;
        return this.cachedPrimaryTimePattern;
    }
    getFollowingTimePatternThroughCache() {
        const followingPhase = this.followingPhase();
        const followingSuffix = this.followingSuffix();
        if (this.cachedFollowingPhase === followingPhase && this.cachedFollowingSuffix === followingSuffix) {
            return this.cachedFollowingTimePatten;
        }
        this.cachedFollowingTimePatten = followingTimePatten(followingPhase, followingSuffix);
        this.cachedFollowingPhase = followingPhase;
        this.cachedFollowingSuffix = followingSuffix;
        return this.cachedFollowingTimePatten;
    }
}
//# sourceMappingURL=AbstractTimeExpressionParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENTimeExpressionParser.js


class ENTimeExpressionParser extends AbstractTimeExpressionParser {
    constructor(strictMode) {
        super(strictMode);
    }
    followingPhase() {
        return "\\s*(?:\\-|\\–|\\~|\\〜|to|until|through|till|\\?)\\s*";
    }
    primaryPrefix() {
        return "(?:(?:at|from)\\s*)??";
    }
    primarySuffix() {
        return "(?:\\s*(?:o\\W*clock|at\\s*night|in\\s*the\\s*(?:morning|afternoon)))?(?!/)(?=\\W|$)";
    }
    extractPrimaryTimeComponents(context, match) {
        const components = super.extractPrimaryTimeComponents(context, match);
        if (components) {
            if (match[0].endsWith("night")) {
                const hour = components.get("hour");
                if (hour >= 6 && hour < 12) {
                    components.assign("hour", components.get("hour") + 12);
                    components.assign("meridiem", types_Meridiem.PM);
                }
                else if (hour < 6) {
                    components.assign("meridiem", types_Meridiem.AM);
                }
            }
            if (match[0].endsWith("afternoon")) {
                components.assign("meridiem", types_Meridiem.PM);
                const hour = components.get("hour");
                if (hour >= 0 && hour <= 6) {
                    components.assign("hour", components.get("hour") + 12);
                }
            }
            if (match[0].endsWith("morning")) {
                components.assign("meridiem", types_Meridiem.AM);
                const hour = components.get("hour");
                if (hour < 12) {
                    components.assign("hour", components.get("hour"));
                }
            }
        }
        return components;
    }
}
//# sourceMappingURL=ENTimeExpressionParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/utils/timeunits.js
function reverseTimeUnits(timeUnits) {
    const reversed = {};
    for (const key in timeUnits) {
        reversed[key] = -timeUnits[key];
    }
    return reversed;
}
function addImpliedTimeUnits(components, timeUnits) {
    const output = components.clone();
    let date = components.dayjs();
    for (const key in timeUnits) {
        date = date.add(timeUnits[key], key);
    }
    if ("day" in timeUnits || "d" in timeUnits || "week" in timeUnits || "month" in timeUnits || "year" in timeUnits) {
        output.imply("day", date.date());
        output.imply("month", date.month() + 1);
        output.imply("year", date.year());
    }
    if ("second" in timeUnits || "minute" in timeUnits || "hour" in timeUnits) {
        output.imply("second", date.second());
        output.imply("minute", date.minute());
        output.imply("hour", date.hour());
    }
    return output;
}
//# sourceMappingURL=timeunits.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENTimeUnitAgoFormatParser.js




const ENTimeUnitAgoFormatParser_PATTERN = new RegExp(`(${TIME_UNITS_PATTERN})\\s{0,5}(?:ago|before|earlier)(?=\\W|$)`, "i");
const STRICT_PATTERN = new RegExp(`(${TIME_UNITS_NO_ABBR_PATTERN})\\s{0,5}(?:ago|before|earlier)(?=\\W|$)`, "i");
class ENTimeUnitAgoFormatParser extends AbstractParserWithWordBoundaryChecking {
    constructor(strictMode) {
        super();
        this.strictMode = strictMode;
    }
    innerPattern() {
        return this.strictMode ? STRICT_PATTERN : ENTimeUnitAgoFormatParser_PATTERN;
    }
    innerExtract(context, match) {
        const timeUnits = parseTimeUnits(match[1]);
        const outputTimeUnits = reverseTimeUnits(timeUnits);
        return results_ParsingComponents.createRelativeFromReference(context.reference, outputTimeUnits);
    }
}
//# sourceMappingURL=ENTimeUnitAgoFormatParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENTimeUnitLaterFormatParser.js



const ENTimeUnitLaterFormatParser_PATTERN = new RegExp(`(${TIME_UNITS_PATTERN})\\s{0,5}(?:later|after|from now|henceforth|forward|out)` + "(?=(?:\\W|$))", "i");
const ENTimeUnitLaterFormatParser_STRICT_PATTERN = new RegExp("" + "(" + TIME_UNITS_NO_ABBR_PATTERN + ")" + "(later|from now)" + "(?=(?:\\W|$))", "i");
const GROUP_NUM_TIMEUNITS = 1;
class ENTimeUnitLaterFormatParser extends AbstractParserWithWordBoundaryChecking {
    constructor(strictMode) {
        super();
        this.strictMode = strictMode;
    }
    innerPattern() {
        return this.strictMode ? ENTimeUnitLaterFormatParser_STRICT_PATTERN : ENTimeUnitLaterFormatParser_PATTERN;
    }
    innerExtract(context, match) {
        const fragments = parseTimeUnits(match[GROUP_NUM_TIMEUNITS]);
        return results_ParsingComponents.createRelativeFromReference(context.reference, fragments);
    }
}
//# sourceMappingURL=ENTimeUnitLaterFormatParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/abstractRefiners.js
class Filter {
    refine(context, results) {
        return results.filter((r) => this.isValid(context, r));
    }
}
class MergingRefiner {
    refine(context, results) {
        if (results.length < 2) {
            return results;
        }
        const mergedResults = [];
        let curResult = results[0];
        let nextResult = null;
        for (let i = 1; i < results.length; i++) {
            nextResult = results[i];
            const textBetween = context.text.substring(curResult.index + curResult.text.length, nextResult.index);
            if (!this.shouldMergeResults(textBetween, curResult, nextResult, context)) {
                mergedResults.push(curResult);
                curResult = nextResult;
            }
            else {
                const left = curResult;
                const right = nextResult;
                const mergedResult = this.mergeResults(textBetween, left, right, context);
                context.debug(() => {
                    console.log(`${this.constructor.name} merged ${left} and ${right} into ${mergedResult}`);
                });
                curResult = mergedResult;
            }
        }
        if (curResult != null) {
            mergedResults.push(curResult);
        }
        return mergedResults;
    }
}
//# sourceMappingURL=abstractRefiners.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/refiners/AbstractMergeDateRangeRefiner.js

class AbstractMergeDateRangeRefiner extends MergingRefiner {
    shouldMergeResults(textBetween, currentResult, nextResult) {
        return !currentResult.end && !nextResult.end && textBetween.match(this.patternBetween()) != null;
    }
    mergeResults(textBetween, fromResult, toResult) {
        if (!fromResult.start.isOnlyWeekdayComponent() && !toResult.start.isOnlyWeekdayComponent()) {
            toResult.start.getCertainComponents().forEach((key) => {
                if (!fromResult.start.isCertain(key)) {
                    fromResult.start.imply(key, toResult.start.get(key));
                }
            });
            fromResult.start.getCertainComponents().forEach((key) => {
                if (!toResult.start.isCertain(key)) {
                    toResult.start.imply(key, fromResult.start.get(key));
                }
            });
        }
        if (fromResult.start.date().getTime() > toResult.start.date().getTime()) {
            let fromMoment = fromResult.start.dayjs();
            let toMoment = toResult.start.dayjs();
            if (toResult.start.isOnlyWeekdayComponent() && toMoment.add(7, "days").isAfter(fromMoment)) {
                toMoment = toMoment.add(7, "days");
                toResult.start.imply("day", toMoment.date());
                toResult.start.imply("month", toMoment.month() + 1);
                toResult.start.imply("year", toMoment.year());
            }
            else if (fromResult.start.isOnlyWeekdayComponent() && fromMoment.add(-7, "days").isBefore(toMoment)) {
                fromMoment = fromMoment.add(-7, "days");
                fromResult.start.imply("day", fromMoment.date());
                fromResult.start.imply("month", fromMoment.month() + 1);
                fromResult.start.imply("year", fromMoment.year());
            }
            else if (toResult.start.isDateWithUnknownYear() && toMoment.add(1, "years").isAfter(fromMoment)) {
                toMoment = toMoment.add(1, "years");
                toResult.start.imply("year", toMoment.year());
            }
            else if (fromResult.start.isDateWithUnknownYear() && fromMoment.add(-1, "years").isBefore(toMoment)) {
                fromMoment = fromMoment.add(-1, "years");
                fromResult.start.imply("year", fromMoment.year());
            }
            else {
                [toResult, fromResult] = [fromResult, toResult];
            }
        }
        const result = fromResult.clone();
        result.start = fromResult.start;
        result.end = toResult.start;
        result.index = Math.min(fromResult.index, toResult.index);
        if (fromResult.index < toResult.index) {
            result.text = fromResult.text + textBetween + toResult.text;
        }
        else {
            result.text = toResult.text + textBetween + fromResult.text;
        }
        return result;
    }
}
//# sourceMappingURL=AbstractMergeDateRangeRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/refiners/ENMergeDateRangeRefiner.js

class ENMergeDateRangeRefiner extends AbstractMergeDateRangeRefiner {
    patternBetween() {
        return /^\s*(to|-|–|until|through|till)\s*$/i;
    }
}
//# sourceMappingURL=ENMergeDateRangeRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/calculation/mergingCalculation.js


function mergeDateTimeResult(dateResult, timeResult) {
    const result = dateResult.clone();
    const beginDate = dateResult.start;
    const beginTime = timeResult.start;
    result.start = mergeDateTimeComponent(beginDate, beginTime);
    if (dateResult.end != null || timeResult.end != null) {
        const endDate = dateResult.end == null ? dateResult.start : dateResult.end;
        const endTime = timeResult.end == null ? timeResult.start : timeResult.end;
        const endDateTime = mergeDateTimeComponent(endDate, endTime);
        if (dateResult.end == null && endDateTime.date().getTime() < result.start.date().getTime()) {
            const nextDayJs = endDateTime.dayjs().add(1, "day");
            if (endDateTime.isCertain("day")) {
                dayjs_assignSimilarDate(endDateTime, nextDayJs);
            }
            else {
                implySimilarDate(endDateTime, nextDayJs);
            }
        }
        result.end = endDateTime;
    }
    return result;
}
function mergeDateTimeComponent(dateComponent, timeComponent) {
    const dateTimeComponent = dateComponent.clone();
    if (timeComponent.isCertain("hour")) {
        dateTimeComponent.assign("hour", timeComponent.get("hour"));
        dateTimeComponent.assign("minute", timeComponent.get("minute"));
        if (timeComponent.isCertain("second")) {
            dateTimeComponent.assign("second", timeComponent.get("second"));
            if (timeComponent.isCertain("millisecond")) {
                dateTimeComponent.assign("millisecond", timeComponent.get("millisecond"));
            }
            else {
                dateTimeComponent.imply("millisecond", timeComponent.get("millisecond"));
            }
        }
        else {
            dateTimeComponent.imply("second", timeComponent.get("second"));
            dateTimeComponent.imply("millisecond", timeComponent.get("millisecond"));
        }
    }
    else {
        dateTimeComponent.imply("hour", timeComponent.get("hour"));
        dateTimeComponent.imply("minute", timeComponent.get("minute"));
        dateTimeComponent.imply("second", timeComponent.get("second"));
        dateTimeComponent.imply("millisecond", timeComponent.get("millisecond"));
    }
    if (timeComponent.isCertain("timezoneOffset")) {
        dateTimeComponent.assign("timezoneOffset", timeComponent.get("timezoneOffset"));
    }
    if (timeComponent.isCertain("meridiem")) {
        dateTimeComponent.assign("meridiem", timeComponent.get("meridiem"));
    }
    else if (timeComponent.get("meridiem") != null && dateTimeComponent.get("meridiem") == null) {
        dateTimeComponent.imply("meridiem", timeComponent.get("meridiem"));
    }
    if (dateTimeComponent.get("meridiem") == types_Meridiem.PM && dateTimeComponent.get("hour") < 12) {
        if (timeComponent.isCertain("hour")) {
            dateTimeComponent.assign("hour", dateTimeComponent.get("hour") + 12);
        }
        else {
            dateTimeComponent.imply("hour", dateTimeComponent.get("hour") + 12);
        }
    }
    return dateTimeComponent;
}
//# sourceMappingURL=mergingCalculation.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/refiners/AbstractMergeDateTimeRefiner.js


class AbstractMergeDateTimeRefiner extends MergingRefiner {
    shouldMergeResults(textBetween, currentResult, nextResult) {
        return (((currentResult.start.isOnlyDate() && nextResult.start.isOnlyTime()) ||
            (nextResult.start.isOnlyDate() && currentResult.start.isOnlyTime())) &&
            textBetween.match(this.patternBetween()) != null);
    }
    mergeResults(textBetween, currentResult, nextResult) {
        const result = currentResult.start.isOnlyDate()
            ? mergeDateTimeResult(currentResult, nextResult)
            : mergeDateTimeResult(nextResult, currentResult);
        result.index = currentResult.index;
        result.text = currentResult.text + textBetween + nextResult.text;
        return result;
    }
}
//# sourceMappingURL=AbstractMergeDateTimeRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/refiners/ENMergeDateTimeRefiner.js

class ENMergeDateTimeRefiner extends AbstractMergeDateTimeRefiner {
    patternBetween() {
        return new RegExp("^\\s*(T|at|after|before|on|of|,|-)?\\s*$");
    }
}
//# sourceMappingURL=ENMergeDateTimeRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/refiners/ExtractTimezoneAbbrRefiner.js

const TIMEZONE_NAME_PATTERN = new RegExp("^\\s*,?\\s*\\(?([A-Z]{2,4})\\)?(?=\\W|$)", "i");
class ExtractTimezoneAbbrRefiner {
    constructor(timezoneOverrides) {
        this.timezoneOverrides = timezoneOverrides;
    }
    refine(context, results) {
        const timezoneOverrides = context.option.timezones ?? {};
        results.forEach((result) => {
            const suffix = context.text.substring(result.index + result.text.length);
            const match = TIMEZONE_NAME_PATTERN.exec(suffix);
            if (!match) {
                return;
            }
            const timezoneAbbr = match[1].toUpperCase();
            const refDate = result.start.date() ?? result.refDate ?? new Date();
            const tzOverrides = { ...this.timezoneOverrides, ...timezoneOverrides };
            const extractedTimezoneOffset = toTimezoneOffset(timezoneAbbr, refDate, tzOverrides);
            if (extractedTimezoneOffset == null) {
                return;
            }
            context.debug(() => {
                console.log(`Extracting timezone: '${timezoneAbbr}' into: ${extractedTimezoneOffset} for: ${result.start}`);
            });
            const currentTimezoneOffset = result.start.get("timezoneOffset");
            if (currentTimezoneOffset !== null && extractedTimezoneOffset != currentTimezoneOffset) {
                if (result.start.isCertain("timezoneOffset")) {
                    return;
                }
                if (timezoneAbbr != match[1]) {
                    return;
                }
            }
            if (result.start.isOnlyDate()) {
                if (timezoneAbbr != match[1]) {
                    return;
                }
            }
            result.text += match[0];
            if (!result.start.isCertain("timezoneOffset")) {
                result.start.assign("timezoneOffset", extractedTimezoneOffset);
            }
            if (result.end != null && !result.end.isCertain("timezoneOffset")) {
                result.end.assign("timezoneOffset", extractedTimezoneOffset);
            }
        });
        return results;
    }
}
//# sourceMappingURL=ExtractTimezoneAbbrRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/refiners/ExtractTimezoneOffsetRefiner.js
const TIMEZONE_OFFSET_PATTERN = new RegExp("^\\s*(?:\\(?(?:GMT|UTC)\\s?)?([+-])(\\d{1,2})(?::?(\\d{2}))?\\)?", "i");
const TIMEZONE_OFFSET_SIGN_GROUP = 1;
const TIMEZONE_OFFSET_HOUR_OFFSET_GROUP = 2;
const TIMEZONE_OFFSET_MINUTE_OFFSET_GROUP = 3;
class ExtractTimezoneOffsetRefiner {
    refine(context, results) {
        results.forEach(function (result) {
            if (result.start.isCertain("timezoneOffset")) {
                return;
            }
            const suffix = context.text.substring(result.index + result.text.length);
            const match = TIMEZONE_OFFSET_PATTERN.exec(suffix);
            if (!match) {
                return;
            }
            context.debug(() => {
                console.log(`Extracting timezone: '${match[0]}' into : ${result}`);
            });
            const hourOffset = parseInt(match[TIMEZONE_OFFSET_HOUR_OFFSET_GROUP]);
            const minuteOffset = parseInt(match[TIMEZONE_OFFSET_MINUTE_OFFSET_GROUP] || "0");
            let timezoneOffset = hourOffset * 60 + minuteOffset;
            if (timezoneOffset > 14 * 60) {
                return;
            }
            if (match[TIMEZONE_OFFSET_SIGN_GROUP] === "-") {
                timezoneOffset = -timezoneOffset;
            }
            if (result.end != null) {
                result.end.assign("timezoneOffset", timezoneOffset);
            }
            result.start.assign("timezoneOffset", timezoneOffset);
            result.text += match[0];
        });
        return results;
    }
}
//# sourceMappingURL=ExtractTimezoneOffsetRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/refiners/OverlapRemovalRefiner.js
class OverlapRemovalRefiner {
    refine(context, results) {
        if (results.length < 2) {
            return results;
        }
        const filteredResults = [];
        let prevResult = results[0];
        for (let i = 1; i < results.length; i++) {
            const result = results[i];
            if (result.index < prevResult.index + prevResult.text.length) {
                if (result.text.length > prevResult.text.length) {
                    prevResult = result;
                }
            }
            else {
                filteredResults.push(prevResult);
                prevResult = result;
            }
        }
        if (prevResult != null) {
            filteredResults.push(prevResult);
        }
        return filteredResults;
    }
}
//# sourceMappingURL=OverlapRemovalRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/refiners/ForwardDateRefiner.js


class ForwardDateRefiner {
    refine(context, results) {
        if (!context.option.forwardDate) {
            return results;
        }
        results.forEach(function (result) {
            let refMoment = dayjs_min(context.refDate);
            if (result.start.isOnlyTime() && refMoment.isAfter(result.start.dayjs())) {
                refMoment = refMoment.add(1, "day");
                implySimilarDate(result.start, refMoment);
                if (result.end && result.end.isOnlyTime()) {
                    implySimilarDate(result.end, refMoment);
                    if (result.start.dayjs().isAfter(result.end.dayjs())) {
                        refMoment = refMoment.add(1, "day");
                        implySimilarDate(result.end, refMoment);
                    }
                }
            }
            if (result.start.isOnlyWeekdayComponent() && refMoment.isAfter(result.start.dayjs())) {
                if (refMoment.day() >= result.start.get("weekday")) {
                    refMoment = refMoment.day(result.start.get("weekday") + 7);
                }
                else {
                    refMoment = refMoment.day(result.start.get("weekday"));
                }
                result.start.imply("day", refMoment.date());
                result.start.imply("month", refMoment.month() + 1);
                result.start.imply("year", refMoment.year());
                context.debug(() => {
                    console.log(`Forward weekly adjusted for ${result} (${result.start})`);
                });
                if (result.end && result.end.isOnlyWeekdayComponent()) {
                    if (refMoment.day() > result.end.get("weekday")) {
                        refMoment = refMoment.day(result.end.get("weekday") + 7);
                    }
                    else {
                        refMoment = refMoment.day(result.end.get("weekday"));
                    }
                    result.end.imply("day", refMoment.date());
                    result.end.imply("month", refMoment.month() + 1);
                    result.end.imply("year", refMoment.year());
                    context.debug(() => {
                        console.log(`Forward weekly adjusted for ${result} (${result.end})`);
                    });
                }
            }
            if (result.start.isDateWithUnknownYear() && refMoment.isAfter(result.start.dayjs())) {
                for (let i = 0; i < 3 && refMoment.isAfter(result.start.dayjs()); i++) {
                    result.start.imply("year", result.start.get("year") + 1);
                    context.debug(() => {
                        console.log(`Forward yearly adjusted for ${result} (${result.start})`);
                    });
                    if (result.end && !result.end.isCertain("year")) {
                        result.end.imply("year", result.end.get("year") + 1);
                        context.debug(() => {
                            console.log(`Forward yearly adjusted for ${result} (${result.end})`);
                        });
                    }
                }
            }
        });
        return results;
    }
}
//# sourceMappingURL=ForwardDateRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/refiners/UnlikelyFormatFilter.js

class UnlikelyFormatFilter extends Filter {
    constructor(strictMode) {
        super();
        this.strictMode = strictMode;
    }
    isValid(context, result) {
        if (result.text.replace(" ", "").match(/^\d*(\.\d*)?$/)) {
            context.debug(() => {
                console.log(`Removing unlikely result '${result.text}'`);
            });
            return false;
        }
        if (!result.start.isValidDate()) {
            context.debug(() => {
                console.log(`Removing invalid result: ${result} (${result.start})`);
            });
            return false;
        }
        if (result.end && !result.end.isValidDate()) {
            context.debug(() => {
                console.log(`Removing invalid result: ${result} (${result.end})`);
            });
            return false;
        }
        if (this.strictMode) {
            return this.isStrictModeValid(context, result);
        }
        return true;
    }
    isStrictModeValid(context, result) {
        if (result.start.isOnlyWeekdayComponent()) {
            context.debug(() => {
                console.log(`(Strict) Removing weekday only component: ${result} (${result.end})`);
            });
            return false;
        }
        if (result.start.isOnlyTime() && (!result.start.isCertain("hour") || !result.start.isCertain("minute"))) {
            context.debug(() => {
                console.log(`(Strict) Removing uncertain time component: ${result} (${result.end})`);
            });
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=UnlikelyFormatFilter.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/parsers/ISOFormatParser.js

const ISOFormatParser_PATTERN = new RegExp("([0-9]{4})\\-([0-9]{1,2})\\-([0-9]{1,2})" +
    "(?:T" +
    "([0-9]{1,2}):([0-9]{1,2})" +
    "(?:" +
    ":([0-9]{1,2})(?:\\.(\\d{1,4}))?" +
    ")?" +
    "(?:" +
    "Z|([+-]\\d{2}):?(\\d{2})?" +
    ")?" +
    ")?" +
    "(?=\\W|$)", "i");
const ISOFormatParser_YEAR_NUMBER_GROUP = 1;
const ISOFormatParser_MONTH_NUMBER_GROUP = 2;
const ISOFormatParser_DATE_NUMBER_GROUP = 3;
const HOUR_NUMBER_GROUP = 4;
const MINUTE_NUMBER_GROUP = 5;
const SECOND_NUMBER_GROUP = 6;
const MILLISECOND_NUMBER_GROUP = 7;
const TZD_HOUR_OFFSET_GROUP = 8;
const TZD_MINUTE_OFFSET_GROUP = 9;
class ISOFormatParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return ISOFormatParser_PATTERN;
    }
    innerExtract(context, match) {
        const components = {};
        components["year"] = parseInt(match[ISOFormatParser_YEAR_NUMBER_GROUP]);
        components["month"] = parseInt(match[ISOFormatParser_MONTH_NUMBER_GROUP]);
        components["day"] = parseInt(match[ISOFormatParser_DATE_NUMBER_GROUP]);
        if (match[HOUR_NUMBER_GROUP] != null) {
            components["hour"] = parseInt(match[HOUR_NUMBER_GROUP]);
            components["minute"] = parseInt(match[MINUTE_NUMBER_GROUP]);
            if (match[SECOND_NUMBER_GROUP] != null) {
                components["second"] = parseInt(match[SECOND_NUMBER_GROUP]);
            }
            if (match[MILLISECOND_NUMBER_GROUP] != null) {
                components["millisecond"] = parseInt(match[MILLISECOND_NUMBER_GROUP]);
            }
            if (match[TZD_HOUR_OFFSET_GROUP] == null) {
                components["timezoneOffset"] = 0;
            }
            else {
                const hourOffset = parseInt(match[TZD_HOUR_OFFSET_GROUP]);
                let minuteOffset = 0;
                if (match[TZD_MINUTE_OFFSET_GROUP] != null) {
                    minuteOffset = parseInt(match[TZD_MINUTE_OFFSET_GROUP]);
                }
                let offset = hourOffset * 60;
                if (offset < 0) {
                    offset -= minuteOffset;
                }
                else {
                    offset += minuteOffset;
                }
                components["timezoneOffset"] = offset;
            }
        }
        return components;
    }
}
//# sourceMappingURL=ISOFormatParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/refiners/MergeWeekdayComponentRefiner.js

class MergeWeekdayComponentRefiner extends MergingRefiner {
    mergeResults(textBetween, currentResult, nextResult) {
        const newResult = nextResult.clone();
        newResult.index = currentResult.index;
        newResult.text = currentResult.text + textBetween + newResult.text;
        newResult.start.assign("weekday", currentResult.start.get("weekday"));
        if (newResult.end) {
            newResult.end.assign("weekday", currentResult.start.get("weekday"));
        }
        return newResult;
    }
    shouldMergeResults(textBetween, currentResult, nextResult) {
        const weekdayThenNormalDate = currentResult.start.isOnlyWeekdayComponent() &&
            !currentResult.start.isCertain("hour") &&
            nextResult.start.isCertain("day");
        return weekdayThenNormalDate && textBetween.match(/^,?\s*$/) != null;
    }
}
//# sourceMappingURL=MergeWeekdayComponentRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/configurations.js







function includeCommonConfiguration(configuration, strictMode = false) {
    configuration.parsers.unshift(new ISOFormatParser());
    configuration.refiners.unshift(new MergeWeekdayComponentRefiner());
    configuration.refiners.unshift(new ExtractTimezoneOffsetRefiner());
    configuration.refiners.unshift(new OverlapRemovalRefiner());
    configuration.refiners.push(new ExtractTimezoneAbbrRefiner());
    configuration.refiners.push(new OverlapRemovalRefiner());
    configuration.refiners.push(new ForwardDateRefiner());
    configuration.refiners.push(new UnlikelyFormatFilter(strictMode));
    return configuration;
}
//# sourceMappingURL=configurations.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/casualReferences.js




function now(reference) {
    const targetDate = dayjs_min(reference.instant);
    const component = new results_ParsingComponents(reference, {});
    dayjs_assignSimilarDate(component, targetDate);
    assignSimilarTime(component, targetDate);
    if (reference.timezoneOffset !== null) {
        component.assign("timezoneOffset", targetDate.utcOffset());
    }
    return component;
}
function today(reference) {
    const targetDate = dayjs_min(reference.instant);
    const component = new results_ParsingComponents(reference, {});
    dayjs_assignSimilarDate(component, targetDate);
    implySimilarTime(component, targetDate);
    return component;
}
function yesterday(reference) {
    return theDayBefore(reference, 1);
}
function theDayBefore(reference, numDay) {
    return theDayAfter(reference, -numDay);
}
function tomorrow(reference) {
    return theDayAfter(reference, 1);
}
function theDayAfter(reference, nDays) {
    let targetDate = dayjs_min(reference.instant);
    const component = new results_ParsingComponents(reference, {});
    targetDate = targetDate.add(nDays, "day");
    dayjs_assignSimilarDate(component, targetDate);
    implySimilarTime(component, targetDate);
    return component;
}
function tonight(reference, implyHour = 22) {
    const targetDate = dayjs_min(reference.instant);
    const component = new results_ParsingComponents(reference, {});
    component.imply("hour", implyHour);
    component.imply("meridiem", types_Meridiem.PM);
    dayjs_assignSimilarDate(component, targetDate);
    return component;
}
function lastNight(reference, implyHour = 0) {
    let targetDate = dayjs(reference.instant);
    const component = new ParsingComponents(reference, {});
    if (targetDate.hour() < 6) {
        targetDate = targetDate.add(-1, "day");
    }
    assignSimilarDate(component, targetDate);
    component.imply("hour", implyHour);
    return component;
}
function evening(reference, implyHour = 20) {
    const component = new results_ParsingComponents(reference, {});
    component.imply("meridiem", types_Meridiem.PM);
    component.imply("hour", implyHour);
    return component;
}
function yesterdayEvening(reference, implyHour = 20) {
    let targetDate = dayjs(reference.instant);
    const component = new ParsingComponents(reference, {});
    targetDate = targetDate.add(-1, "day");
    assignSimilarDate(component, targetDate);
    component.imply("hour", implyHour);
    component.imply("meridiem", Meridiem.PM);
    return component;
}
function midnight(reference) {
    const component = new results_ParsingComponents(reference, {});
    const targetDate = dayjs_min(reference.instant);
    if (targetDate.hour() > 2) {
        implyTheNextDay(component, targetDate);
    }
    component.assign("hour", 0);
    component.imply("minute", 0);
    component.imply("second", 0);
    component.imply("millisecond", 0);
    return component;
}
function morning(reference, implyHour = 6) {
    const component = new results_ParsingComponents(reference, {});
    component.imply("meridiem", types_Meridiem.AM);
    component.imply("hour", implyHour);
    component.imply("minute", 0);
    component.imply("second", 0);
    component.imply("millisecond", 0);
    return component;
}
function afternoon(reference, implyHour = 15) {
    const component = new results_ParsingComponents(reference, {});
    component.imply("meridiem", types_Meridiem.PM);
    component.imply("hour", implyHour);
    component.imply("minute", 0);
    component.imply("second", 0);
    component.imply("millisecond", 0);
    return component;
}
function noon(reference) {
    const component = new results_ParsingComponents(reference, {});
    component.imply("meridiem", types_Meridiem.AM);
    component.imply("hour", 12);
    component.imply("minute", 0);
    component.imply("second", 0);
    component.imply("millisecond", 0);
    return component;
}
//# sourceMappingURL=casualReferences.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENCasualDateParser.js




const ENCasualDateParser_PATTERN = /(now|today|tonight|tomorrow|tmr|tmrw|yesterday|last\s*night)(?=\W|$)/i;
class ENCasualDateParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern(context) {
        return ENCasualDateParser_PATTERN;
    }
    innerExtract(context, match) {
        let targetDate = dayjs_min(context.refDate);
        const lowerText = match[0].toLowerCase();
        const component = context.createParsingComponents();
        switch (lowerText) {
            case "now":
                return now(context.reference);
            case "today":
                return today(context.reference);
            case "yesterday":
                return yesterday(context.reference);
            case "tomorrow":
            case "tmr":
            case "tmrw":
                return tomorrow(context.reference);
            case "tonight":
                return tonight(context.reference);
            default:
                if (lowerText.match(/last\s*night/)) {
                    if (targetDate.hour() > 6) {
                        targetDate = targetDate.add(-1, "day");
                    }
                    dayjs_assignSimilarDate(component, targetDate);
                    component.imply("hour", 0);
                }
                break;
        }
        return component;
    }
}
//# sourceMappingURL=ENCasualDateParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENCasualTimeParser.js


const ENCasualTimeParser_PATTERN = /(?:this)?\s{0,3}(morning|afternoon|evening|night|midnight|midday|noon)(?=\W|$)/i;
class ENCasualTimeParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return ENCasualTimeParser_PATTERN;
    }
    innerExtract(context, match) {
        switch (match[1].toLowerCase()) {
            case "afternoon":
                return afternoon(context.reference);
            case "evening":
            case "night":
                return evening(context.reference);
            case "midnight":
                return midnight(context.reference);
            case "morning":
                return morning(context.reference);
            case "noon":
            case "midday":
                return noon(context.reference);
        }
        return null;
    }
}
//# sourceMappingURL=ENCasualTimeParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/calculation/weekdays.js



function createParsingComponentsAtWeekday(reference, weekday, modifier) {
    const refDate = reference.getDateWithAdjustedTimezone();
    const daysToWeekday = getDaysToWeekday(refDate, weekday, modifier);
    let components = new results_ParsingComponents(reference);
    components = addImpliedTimeUnits(components, { "day": daysToWeekday });
    components.assign("weekday", weekday);
    return components;
}
function getDaysToWeekday(refDate, weekday, modifier) {
    const refWeekday = refDate.getDay();
    switch (modifier) {
        case "this":
            return getDaysForwardToWeekday(refDate, weekday);
        case "last":
            return getBackwardDaysToWeekday(refDate, weekday);
        case "next":
            if (refWeekday == Weekday.SUNDAY) {
                return weekday == Weekday.SUNDAY ? 7 : weekday;
            }
            if (refWeekday == Weekday.SATURDAY) {
                if (weekday == Weekday.SATURDAY)
                    return 7;
                if (weekday == Weekday.SUNDAY)
                    return 8;
                return 1 + weekday;
            }
            if (weekday < refWeekday && weekday != Weekday.SUNDAY) {
                return getDaysForwardToWeekday(refDate, weekday);
            }
            else {
                return getDaysForwardToWeekday(refDate, weekday) + 7;
            }
    }
    return getDaysToWeekdayClosest(refDate, weekday);
}
function getDaysToWeekdayClosest(refDate, weekday) {
    const backward = getBackwardDaysToWeekday(refDate, weekday);
    const forward = getDaysForwardToWeekday(refDate, weekday);
    return forward < -backward ? forward : backward;
}
function getDaysForwardToWeekday(refDate, weekday) {
    const refWeekday = refDate.getDay();
    let forwardCount = weekday - refWeekday;
    if (forwardCount < 0) {
        forwardCount += 7;
    }
    return forwardCount;
}
function getBackwardDaysToWeekday(refDate, weekday) {
    const refWeekday = refDate.getDay();
    let backwardCount = weekday - refWeekday;
    if (backwardCount >= 0) {
        backwardCount -= 7;
    }
    return backwardCount;
}
//# sourceMappingURL=weekdays.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENWeekdayParser.js




const ENWeekdayParser_PATTERN = new RegExp("(?:(?:\\,|\\(|\\（)\\s*)?" +
    "(?:on\\s*?)?" +
    "(?:(this|last|past|next)\\s*)?" +
    `(${matchAnyPattern(WEEKDAY_DICTIONARY)})` +
    "(?:\\s*(?:\\,|\\)|\\）))?" +
    "(?:\\s*(this|last|past|next)\\s*week)?" +
    "(?=\\W|$)", "i");
const ENWeekdayParser_PREFIX_GROUP = 1;
const WEEKDAY_GROUP = 2;
const POSTFIX_GROUP = 3;
class ENWeekdayParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return ENWeekdayParser_PATTERN;
    }
    innerExtract(context, match) {
        const dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
        const weekday = WEEKDAY_DICTIONARY[dayOfWeek];
        const prefix = match[ENWeekdayParser_PREFIX_GROUP];
        const postfix = match[POSTFIX_GROUP];
        let modifierWord = prefix || postfix;
        modifierWord = modifierWord || "";
        modifierWord = modifierWord.toLowerCase();
        let modifier = null;
        if (modifierWord == "last" || modifierWord == "past") {
            modifier = "last";
        }
        else if (modifierWord == "next") {
            modifier = "next";
        }
        else if (modifierWord == "this") {
            modifier = "this";
        }
        return createParsingComponentsAtWeekday(context.reference, weekday, modifier);
    }
}
//# sourceMappingURL=ENWeekdayParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENRelativeDateFormatParser.js





const ENRelativeDateFormatParser_PATTERN = new RegExp(`(this|last|past|next|after\\s*this)\\s*(${matchAnyPattern(TIME_UNIT_DICTIONARY)})(?=\\s*)` + "(?=\\W|$)", "i");
const MODIFIER_WORD_GROUP = 1;
const RELATIVE_WORD_GROUP = 2;
class ENRelativeDateFormatParser extends AbstractParserWithWordBoundaryChecking {
    innerPattern() {
        return ENRelativeDateFormatParser_PATTERN;
    }
    innerExtract(context, match) {
        const modifier = match[MODIFIER_WORD_GROUP].toLowerCase();
        const unitWord = match[RELATIVE_WORD_GROUP].toLowerCase();
        const timeunit = TIME_UNIT_DICTIONARY[unitWord];
        if (modifier == "next" || modifier.startsWith("after")) {
            const timeUnits = {};
            timeUnits[timeunit] = 1;
            return results_ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
        }
        if (modifier == "last" || modifier == "past") {
            const timeUnits = {};
            timeUnits[timeunit] = -1;
            return results_ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
        }
        const components = context.createParsingComponents();
        let date = dayjs_min(context.reference.instant);
        if (unitWord.match(/week/i)) {
            date = date.add(-date.get("d"), "d");
            components.imply("day", date.date());
            components.imply("month", date.month() + 1);
            components.imply("year", date.year());
        }
        else if (unitWord.match(/month/i)) {
            date = date.add(-date.date() + 1, "d");
            components.imply("day", date.date());
            components.assign("year", date.year());
            components.assign("month", date.month() + 1);
        }
        else if (unitWord.match(/year/i)) {
            date = date.add(-date.date() + 1, "d");
            date = date.add(-date.month(), "month");
            components.imply("day", date.date());
            components.imply("month", date.month() + 1);
            components.assign("year", date.year());
        }
        return components;
    }
}
//# sourceMappingURL=ENRelativeDateFormatParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/common/parsers/SlashDateFormatParser.js

const SlashDateFormatParser_PATTERN = new RegExp("([^\\d]|^)" +
    "([0-3]{0,1}[0-9]{1})[\\/\\.\\-]([0-3]{0,1}[0-9]{1})" +
    "(?:[\\/\\.\\-]([0-9]{4}|[0-9]{2}))?" +
    "(\\W|$)", "i");
const OPENING_GROUP = 1;
const ENDING_GROUP = 5;
const FIRST_NUMBERS_GROUP = 2;
const SECOND_NUMBERS_GROUP = 3;
const SlashDateFormatParser_YEAR_GROUP = 4;
class SlashDateFormatParser {
    constructor(littleEndian) {
        this.groupNumberMonth = littleEndian ? SECOND_NUMBERS_GROUP : FIRST_NUMBERS_GROUP;
        this.groupNumberDay = littleEndian ? FIRST_NUMBERS_GROUP : SECOND_NUMBERS_GROUP;
    }
    pattern() {
        return SlashDateFormatParser_PATTERN;
    }
    extract(context, match) {
        if (match[OPENING_GROUP].length == 0 && match.index > 0 && match.index < context.text.length) {
            const previousChar = context.text[match.index - 1];
            if (previousChar >= "0" && previousChar <= "9") {
                return;
            }
        }
        const index = match.index + match[OPENING_GROUP].length;
        const text = match[0].substr(match[OPENING_GROUP].length, match[0].length - match[OPENING_GROUP].length - match[ENDING_GROUP].length);
        if (text.match(/^\d\.\d$/) || text.match(/^\d\.\d{1,2}\.\d{1,2}\s*$/)) {
            return;
        }
        if (!match[SlashDateFormatParser_YEAR_GROUP] && match[0].indexOf("/") < 0) {
            return;
        }
        const result = context.createParsingResult(index, text);
        let month = parseInt(match[this.groupNumberMonth]);
        let day = parseInt(match[this.groupNumberDay]);
        if (month < 1 || month > 12) {
            if (month > 12) {
                if (day >= 1 && day <= 12 && month <= 31) {
                    [day, month] = [month, day];
                }
                else {
                    return null;
                }
            }
        }
        if (day < 1 || day > 31) {
            return null;
        }
        result.start.assign("day", day);
        result.start.assign("month", month);
        if (match[SlashDateFormatParser_YEAR_GROUP]) {
            const rawYearNumber = parseInt(match[SlashDateFormatParser_YEAR_GROUP]);
            const year = findMostLikelyADYear(rawYearNumber);
            result.start.assign("year", year);
        }
        else {
            const year = findYearClosestToRef(context.refDate, day, month);
            result.start.imply("year", year);
        }
        return result;
    }
}
//# sourceMappingURL=SlashDateFormatParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/parsers/ENTimeUnitCasualRelativeFormatParser.js




const ENTimeUnitCasualRelativeFormatParser_PATTERN = new RegExp(`(this|last|past|next|after|\\+|-)\\s*(${TIME_UNITS_PATTERN})(?=\\W|$)`, "i");
const PATTERN_NO_ABBR = new RegExp(`(this|last|past|next|after|\\+|-)\\s*(${TIME_UNITS_NO_ABBR_PATTERN})(?=\\W|$)`, "i");
class ENTimeUnitCasualRelativeFormatParser extends AbstractParserWithWordBoundaryChecking {
    constructor(allowAbbreviations = true) {
        super();
        this.allowAbbreviations = allowAbbreviations;
    }
    innerPattern() {
        return this.allowAbbreviations ? ENTimeUnitCasualRelativeFormatParser_PATTERN : PATTERN_NO_ABBR;
    }
    innerExtract(context, match) {
        const prefix = match[1].toLowerCase();
        let timeUnits = parseTimeUnits(match[2]);
        switch (prefix) {
            case "last":
            case "past":
            case "-":
                timeUnits = reverseTimeUnits(timeUnits);
                break;
        }
        return results_ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
    }
}
//# sourceMappingURL=ENTimeUnitCasualRelativeFormatParser.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/refiners/ENMergeRelativeDateRefiner.js




function hasImpliedEarlierReferenceDate(result) {
    return result.text.match(/\s+(before|from)$/i) != null;
}
function hasImpliedLaterReferenceDate(result) {
    return result.text.match(/\s+(after|since)$/i) != null;
}
class ENMergeRelativeDateRefiner extends MergingRefiner {
    patternBetween() {
        return /^\s*$/i;
    }
    shouldMergeResults(textBetween, currentResult, nextResult) {
        if (!textBetween.match(this.patternBetween())) {
            return false;
        }
        if (!hasImpliedEarlierReferenceDate(currentResult) && !hasImpliedLaterReferenceDate(currentResult)) {
            return false;
        }
        return !!nextResult.start.get("day") && !!nextResult.start.get("month") && !!nextResult.start.get("year");
    }
    mergeResults(textBetween, currentResult, nextResult) {
        let timeUnits = parseTimeUnits(currentResult.text);
        if (hasImpliedEarlierReferenceDate(currentResult)) {
            timeUnits = reverseTimeUnits(timeUnits);
        }
        const components = results_ParsingComponents.createRelativeFromReference(new ReferenceWithTimezone(nextResult.start.date()), timeUnits);
        return new ParsingResult(nextResult.reference, currentResult.index, `${currentResult.text}${textBetween}${nextResult.text}`, components);
    }
}
//# sourceMappingURL=ENMergeRelativeDateRefiner.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/configuration.js



















class ENDefaultConfiguration {
    createCasualConfiguration(littleEndian = false) {
        const option = this.createConfiguration(false, littleEndian);
        option.parsers.unshift(new ENCasualDateParser());
        option.parsers.unshift(new ENCasualTimeParser());
        option.parsers.unshift(new ENMonthNameParser());
        option.parsers.unshift(new ENRelativeDateFormatParser());
        option.parsers.unshift(new ENTimeUnitCasualRelativeFormatParser());
        return option;
    }
    createConfiguration(strictMode = true, littleEndian = false) {
        return includeCommonConfiguration({
            parsers: [
                new SlashDateFormatParser(littleEndian),
                new ENTimeUnitWithinFormatParser(strictMode),
                new ENMonthNameLittleEndianParser(),
                new ENMonthNameMiddleEndianParser(),
                new ENWeekdayParser(),
                new ENCasualYearMonthDayParser(),
                new ENSlashMonthFormatParser(),
                new ENTimeExpressionParser(strictMode),
                new ENTimeUnitAgoFormatParser(strictMode),
                new ENTimeUnitLaterFormatParser(strictMode),
            ],
            refiners: [
                new ENMergeRelativeDateRefiner(),
                new ENMergeDateTimeRefiner(),
                new ENMergeDateRangeRefiner(),
            ],
        }, strictMode);
    }
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/chrono.js


class Chrono {
    constructor(configuration) {
        this.defaultConfig = new ENDefaultConfiguration();
        configuration = configuration || this.defaultConfig.createCasualConfiguration();
        this.parsers = [...configuration.parsers];
        this.refiners = [...configuration.refiners];
    }
    clone() {
        return new Chrono({
            parsers: [...this.parsers],
            refiners: [...this.refiners],
        });
    }
    parseDate(text, referenceDate, option) {
        const results = this.parse(text, referenceDate, option);
        return results.length > 0 ? results[0].start.date() : null;
    }
    parse(text, referenceDate, option) {
        const context = new ParsingContext(text, referenceDate, option);
        let results = [];
        this.parsers.forEach((parser) => {
            const parsedResults = Chrono.executeParser(context, parser);
            results = results.concat(parsedResults);
        });
        results.sort((a, b) => {
            return a.index - b.index;
        });
        this.refiners.forEach(function (refiner) {
            results = refiner.refine(context, results);
        });
        return results;
    }
    static executeParser(context, parser) {
        const results = [];
        const pattern = parser.pattern(context);
        const originalText = context.text;
        let remainingText = context.text;
        let match = pattern.exec(remainingText);
        while (match) {
            const index = match.index + originalText.length - remainingText.length;
            match.index = index;
            const result = parser.extract(context, match);
            if (!result) {
                remainingText = originalText.substring(match.index + 1);
                match = pattern.exec(remainingText);
                continue;
            }
            let parsedResult = null;
            if (result instanceof ParsingResult) {
                parsedResult = result;
            }
            else if (result instanceof results_ParsingComponents) {
                parsedResult = context.createParsingResult(match.index, match[0]);
                parsedResult.start = result;
            }
            else {
                parsedResult = context.createParsingResult(match.index, match[0], result);
            }
            const parsedIndex = parsedResult.index;
            const parsedText = parsedResult.text;
            context.debug(() => console.log(`${parser.constructor.name} extracted (at index=${parsedIndex}) '${parsedText}'`));
            results.push(parsedResult);
            remainingText = originalText.substring(parsedIndex + parsedText.length);
            match = pattern.exec(remainingText);
        }
        return results;
    }
}
class ParsingContext {
    constructor(text, refDate, option) {
        this.text = text;
        this.reference = new ReferenceWithTimezone(refDate);
        this.option = option ?? {};
        this.refDate = this.reference.instant;
    }
    createParsingComponents(components) {
        if (components instanceof results_ParsingComponents) {
            return components;
        }
        return new results_ParsingComponents(this.reference, components);
    }
    createParsingResult(index, textOrEndIndex, startComponents, endComponents) {
        const text = typeof textOrEndIndex === "string" ? textOrEndIndex : this.text.substring(index, textOrEndIndex);
        const start = startComponents ? this.createParsingComponents(startComponents) : null;
        const end = endComponents ? this.createParsingComponents(endComponents) : null;
        return new ParsingResult(this.reference, index, text, start, end);
    }
    debug(block) {
        if (this.option.debug) {
            if (this.option.debug instanceof Function) {
                this.option.debug(block);
            }
            else {
                const handler = this.option.debug;
                handler.debug(block);
            }
        }
    }
}
//# sourceMappingURL=chrono.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/locales/en/index.js






const enConfig = new ENDefaultConfiguration();
const casual = new Chrono(enConfig.createCasualConfiguration(false));
const strict = new Chrono(enConfig.createConfiguration(true, false));
const GB = new Chrono(enConfig.createConfiguration(false, true));
function parse(text, ref, option) {
    return casual.parse(text, ref, option);
}
function parseDate(text, ref, option) {
    return casual.parseDate(text, ref, option);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/chrono-node/dist/esm/index.js
















const esm_strict = strict;
const esm_casual = casual;
function esm_parse(text, ref, option) {
    return esm_casual.parse(text, ref, option);
}
function esm_parseDate(text, ref, option) {
    return esm_casual.parseDate(text, ref, option);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 13665:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dv": function() { return /* binding */ useAtomValue; },
/* harmony export */   "KO": function() { return /* binding */ useAtom; },
/* harmony export */   "b9": function() { return /* binding */ useSetAtom; },
/* harmony export */   "cn": function() { return /* binding */ atom; }
/* harmony export */ });
/* unused harmony exports Provider, SECRET_INTERNAL_getScopeContext, SECRET_INTERNAL_registerPromiseAbort, unstable_createStore */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var jotai_vanilla__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15103);



const SUSPENSE_PROMISE = Symbol();
const isSuspensePromise = (promise) => !!promise[SUSPENSE_PROMISE];
const isSuspensePromiseAlreadyCancelled = (suspensePromise) => !suspensePromise[SUSPENSE_PROMISE].c;
const cancelSuspensePromise = (suspensePromise) => {
  var _a;
  const { b: basePromise, c: cancelPromise } = suspensePromise[SUSPENSE_PROMISE];
  if (cancelPromise) {
    cancelPromise();
    (_a = promiseAbortMap.get(basePromise)) == null ? void 0 : _a();
  }
};
const isEqualSuspensePromise = (oldSuspensePromise, newSuspensePromise) => {
  const oldOriginalPromise = oldSuspensePromise[SUSPENSE_PROMISE].o;
  const newOriginalPromise = newSuspensePromise[SUSPENSE_PROMISE].o;
  return oldOriginalPromise === newOriginalPromise || oldSuspensePromise === newOriginalPromise || isSuspensePromise(oldOriginalPromise) && isEqualSuspensePromise(oldOriginalPromise, newSuspensePromise);
};
const createSuspensePromise = (basePromise, promise) => {
  const suspensePromiseExtra = {
    b: basePromise,
    o: promise,
    c: null
  };
  const suspensePromise = new Promise((resolve) => {
    suspensePromiseExtra.c = () => {
      suspensePromiseExtra.c = null;
      resolve();
    };
    promise.finally(suspensePromiseExtra.c);
  });
  suspensePromise[SUSPENSE_PROMISE] = suspensePromiseExtra;
  return suspensePromise;
};
const copySuspensePromise = (suspensePromise) => createSuspensePromise(
  suspensePromise[SUSPENSE_PROMISE].b,
  suspensePromise[SUSPENSE_PROMISE].o
);
const promiseAbortMap = /* @__PURE__ */ new WeakMap();
const registerPromiseAbort = (basePromise, abort) => {
  promiseAbortMap.set(basePromise, abort);
};

const hasInitialValue = (atom) => "init" in atom;
const READ_ATOM = "r";
const WRITE_ATOM = "w";
const COMMIT_ATOM = "c";
const SUBSCRIBE_ATOM = "s";
const RESTORE_ATOMS = "h";
const DEV_SUBSCRIBE_STATE = "n";
const DEV_GET_MOUNTED_ATOMS = "l";
const DEV_GET_ATOM_STATE = "a";
const DEV_GET_MOUNTED = "m";
const createStore = (initialValues) => {
  const committedAtomStateMap = /* @__PURE__ */ new WeakMap();
  const mountedMap = /* @__PURE__ */ new WeakMap();
  const pendingMap = /* @__PURE__ */ new Map();
  let stateListeners;
  let mountedAtoms;
  if (true) {
    stateListeners = /* @__PURE__ */ new Set();
    mountedAtoms = /* @__PURE__ */ new Set();
  }
  if (initialValues) {
    for (const [atom, value] of initialValues) {
      const atomState = {
        v: value,
        r: 0,
        y: true,
        // not invalidated
        d: /* @__PURE__ */ new Map()
      };
      if (true) {
        Object.freeze(atomState);
        if (!hasInitialValue(atom)) {
          console.warn(
            "Found initial value for derived atom which can cause unexpected behavior",
            atom
          );
        }
      }
      committedAtomStateMap.set(atom, atomState);
    }
  }
  const suspensePromiseCacheMap = /* @__PURE__ */ new WeakMap();
  const addSuspensePromiseToCache = (version, atom, suspensePromise) => {
    let cache = suspensePromiseCacheMap.get(atom);
    if (!cache) {
      cache = /* @__PURE__ */ new Map();
      suspensePromiseCacheMap.set(atom, cache);
    }
    suspensePromise.then(() => {
      if (cache.get(version) === suspensePromise) {
        cache.delete(version);
        if (!cache.size) {
          suspensePromiseCacheMap.delete(atom);
        }
      }
    });
    cache.set(version, suspensePromise);
  };
  const cancelAllSuspensePromiseInCache = (atom) => {
    const versionSet = /* @__PURE__ */ new Set();
    const cache = suspensePromiseCacheMap.get(atom);
    if (cache) {
      suspensePromiseCacheMap.delete(atom);
      cache.forEach((suspensePromise, version) => {
        cancelSuspensePromise(suspensePromise);
        versionSet.add(version);
      });
    }
    return versionSet;
  };
  const versionedAtomStateMapMap = /* @__PURE__ */ new WeakMap();
  const getVersionedAtomStateMap = (version) => {
    let versionedAtomStateMap = versionedAtomStateMapMap.get(version);
    if (!versionedAtomStateMap) {
      versionedAtomStateMap = /* @__PURE__ */ new Map();
      versionedAtomStateMapMap.set(version, versionedAtomStateMap);
    }
    return versionedAtomStateMap;
  };
  const getAtomState = (version, atom) => {
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      let atomState = versionedAtomStateMap.get(atom);
      if (!atomState) {
        atomState = getAtomState(version.p, atom);
        if (atomState && "p" in atomState && isSuspensePromiseAlreadyCancelled(atomState.p)) {
          atomState = void 0;
        }
        if (atomState) {
          versionedAtomStateMap.set(atom, atomState);
        }
      }
      return atomState;
    }
    return committedAtomStateMap.get(atom);
  };
  const setAtomState = (version, atom, atomState) => {
    if (true) {
      Object.freeze(atomState);
    }
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      versionedAtomStateMap.set(atom, atomState);
    } else {
      const prevAtomState = committedAtomStateMap.get(atom);
      committedAtomStateMap.set(atom, atomState);
      if (!pendingMap.has(atom)) {
        pendingMap.set(atom, prevAtomState);
      }
    }
  };
  const createReadDependencies = (version, prevReadDependencies = /* @__PURE__ */ new Map(), dependencies) => {
    if (!dependencies) {
      return prevReadDependencies;
    }
    const readDependencies = /* @__PURE__ */ new Map();
    let changed = false;
    dependencies.forEach((atom) => {
      var _a;
      const revision = ((_a = getAtomState(version, atom)) == null ? void 0 : _a.r) || 0;
      readDependencies.set(atom, revision);
      if (prevReadDependencies.get(atom) !== revision) {
        changed = true;
      }
    });
    if (prevReadDependencies.size === readDependencies.size && !changed) {
      return prevReadDependencies;
    }
    return readDependencies;
  };
  const setAtomValue = (version, atom, value, dependencies, suspensePromise) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      if (suspensePromise && (!("p" in atomState) || !isEqualSuspensePromise(atomState.p, suspensePromise))) {
        return atomState;
      }
      if ("p" in atomState) {
        cancelSuspensePromise(atomState.p);
      }
    }
    const nextAtomState = {
      v: value,
      r: (atomState == null ? void 0 : atomState.r) || 0,
      y: true,
      // not invalidated
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    let changed = !(atomState == null ? void 0 : atomState.y);
    if (!atomState || !("v" in atomState) || // new value, or
    !Object.is(atomState.v, value)) {
      changed = true;
      ++nextAtomState.r;
      if (nextAtomState.d.has(atom)) {
        nextAtomState.d = new Map(nextAtomState.d).set(atom, nextAtomState.r);
      }
    } else if (nextAtomState.d !== atomState.d && (nextAtomState.d.size !== atomState.d.size || !Array.from(nextAtomState.d.keys()).every((a) => atomState.d.has(a)))) {
      changed = true;
      Promise.resolve().then(() => {
        flushPending(version);
      });
    }
    if (atomState && !changed) {
      return atomState;
    }
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomReadError = (version, atom, error, dependencies, suspensePromise) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      if (suspensePromise && (!("p" in atomState) || !isEqualSuspensePromise(atomState.p, suspensePromise))) {
        return atomState;
      }
      if ("p" in atomState) {
        cancelSuspensePromise(atomState.p);
      }
    }
    const nextAtomState = {
      e: error,
      // set read error
      r: ((atomState == null ? void 0 : atomState.r) || 0) + 1,
      y: true,
      // not invalidated
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomSuspensePromise = (version, atom, suspensePromise, dependencies) => {
    const atomState = getAtomState(version, atom);
    if (atomState && "p" in atomState) {
      if (isEqualSuspensePromise(atomState.p, suspensePromise) && !isSuspensePromiseAlreadyCancelled(atomState.p)) {
        if (!atomState.y) {
          return { ...atomState, y: true };
        }
        return atomState;
      }
      cancelSuspensePromise(atomState.p);
    }
    addSuspensePromiseToCache(version, atom, suspensePromise);
    const nextAtomState = {
      p: suspensePromise,
      r: ((atomState == null ? void 0 : atomState.r) || 0) + 1,
      y: true,
      // not invalidated
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomPromiseOrValue = (version, atom, promiseOrValue, dependencies) => {
    if (promiseOrValue instanceof Promise) {
      const suspensePromise = createSuspensePromise(
        promiseOrValue,
        promiseOrValue.then((value) => {
          setAtomValue(version, atom, value, dependencies, suspensePromise);
        }).catch((e) => {
          if (e instanceof Promise) {
            if (isSuspensePromise(e)) {
              return e.then(() => {
                readAtomState(version, atom, true);
              });
            }
            return e;
          }
          setAtomReadError(version, atom, e, dependencies, suspensePromise);
        })
      );
      return setAtomSuspensePromise(
        version,
        atom,
        suspensePromise,
        dependencies
      );
    }
    return setAtomValue(
      version,
      atom,
      promiseOrValue,
      dependencies
    );
  };
  const setAtomInvalidated = (version, atom) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      const nextAtomState = {
        ...atomState,
        // copy everything
        y: false
        // invalidated
      };
      setAtomState(version, atom, nextAtomState);
    } else if (true) {
      console.warn("[Bug] could not invalidate non existing atom", atom);
    }
  };
  const readAtomState = (version, atom, force) => {
    if (!force) {
      const atomState = getAtomState(version, atom);
      if (atomState) {
        if (atomState.y && // not invalidated
        "p" in atomState && !isSuspensePromiseAlreadyCancelled(atomState.p)) {
          return atomState;
        }
        atomState.d.forEach((_, a) => {
          if (a !== atom) {
            if (!mountedMap.has(a)) {
              readAtomState(version, a);
            } else {
              const aState = getAtomState(version, a);
              if (aState && !aState.y) {
                readAtomState(version, a);
              }
            }
          }
        });
        if (Array.from(atomState.d).every(([a, r]) => {
          const aState = getAtomState(version, a);
          return aState && !("p" in aState) && // has no suspense promise
          aState.r === r;
        })) {
          if (!atomState.y) {
            return { ...atomState, y: true };
          }
          return atomState;
        }
      }
    }
    const dependencies = /* @__PURE__ */ new Set();
    try {
      const promiseOrValue = atom.read((a) => {
        dependencies.add(a);
        const aState = a === atom ? getAtomState(version, a) : readAtomState(version, a);
        if (aState) {
          if ("e" in aState) {
            throw aState.e;
          }
          if ("p" in aState) {
            throw aState.p;
          }
          return aState.v;
        }
        if (hasInitialValue(a)) {
          return a.init;
        }
        throw new Error("no atom init");
      });
      return setAtomPromiseOrValue(version, atom, promiseOrValue, dependencies);
    } catch (errorOrPromise) {
      if (errorOrPromise instanceof Promise) {
        const suspensePromise = isSuspensePromise(errorOrPromise) && isSuspensePromiseAlreadyCancelled(errorOrPromise) ? copySuspensePromise(errorOrPromise) : createSuspensePromise(errorOrPromise, errorOrPromise);
        return setAtomSuspensePromise(
          version,
          atom,
          suspensePromise,
          dependencies
        );
      }
      return setAtomReadError(version, atom, errorOrPromise, dependencies);
    }
  };
  const readAtom = (readingAtom, version) => {
    const atomState = readAtomState(version, readingAtom);
    return atomState;
  };
  const addAtom = (version, addingAtom) => {
    let mounted = mountedMap.get(addingAtom);
    if (!mounted) {
      mounted = mountAtom(version, addingAtom);
    }
    return mounted;
  };
  const canUnmountAtom = (atom, mounted) => !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
  const delAtom = (version, deletingAtom) => {
    const mounted = mountedMap.get(deletingAtom);
    if (mounted && canUnmountAtom(deletingAtom, mounted)) {
      unmountAtom(version, deletingAtom);
    }
  };
  const invalidateDependents = (version, atom) => {
    const mounted = mountedMap.get(atom);
    mounted == null ? void 0 : mounted.t.forEach((dependent) => {
      if (dependent !== atom) {
        setAtomInvalidated(version, dependent);
        invalidateDependents(version, dependent);
      }
    });
  };
  const writeAtomState = (version, atom, update) => {
    let isSync = true;
    const writeGetter = (a, options) => {
      const aState = readAtomState(version, a);
      if ("e" in aState) {
        throw aState.e;
      }
      if ("p" in aState) {
        if (options == null ? void 0 : options.unstable_promise) {
          return aState.p.then(() => {
            const s = getAtomState(version, a);
            if (s && "p" in s && s.p === aState.p) {
              return new Promise((resolve) => setTimeout(resolve)).then(
                () => writeGetter(a, options)
              );
            }
            return writeGetter(a, options);
          });
        }
        if (true) {
          console.info(
            "Reading pending atom state in write operation. We throw a promise for now.",
            a
          );
        }
        throw aState.p;
      }
      if ("v" in aState) {
        return aState.v;
      }
      if (true) {
        console.warn(
          "[Bug] no value found while reading atom in write operation. This is probably a bug.",
          a
        );
      }
      throw new Error("no value found");
    };
    const setter = (a, v) => {
      let promiseOrVoid2;
      if (a === atom) {
        if (!hasInitialValue(a)) {
          throw new Error("atom not writable");
        }
        const versionSet = cancelAllSuspensePromiseInCache(a);
        versionSet.forEach((cancelledVersion) => {
          if (cancelledVersion !== version) {
            setAtomPromiseOrValue(cancelledVersion, a, v);
          }
        });
        const prevAtomState = getAtomState(version, a);
        const nextAtomState = setAtomPromiseOrValue(version, a, v);
        if (prevAtomState !== nextAtomState) {
          invalidateDependents(version, a);
        }
      } else {
        promiseOrVoid2 = writeAtomState(version, a, v);
      }
      if (!isSync) {
        flushPending(version);
      }
      return promiseOrVoid2;
    };
    const promiseOrVoid = atom.write(writeGetter, setter, update);
    isSync = false;
    return promiseOrVoid;
  };
  const writeAtom = (writingAtom, update, version) => {
    const promiseOrVoid = writeAtomState(version, writingAtom, update);
    flushPending(version);
    return promiseOrVoid;
  };
  const isActuallyWritableAtom = (atom) => !!atom.write;
  const mountAtom = (version, atom, initialDependent) => {
    const mounted = {
      t: new Set(initialDependent && [initialDependent]),
      l: /* @__PURE__ */ new Set()
    };
    mountedMap.set(atom, mounted);
    if (true) {
      mountedAtoms.add(atom);
    }
    const atomState = readAtomState(void 0, atom);
    atomState.d.forEach((_, a) => {
      const aMounted = mountedMap.get(a);
      if (aMounted) {
        aMounted.t.add(atom);
      } else {
        if (a !== atom) {
          mountAtom(version, a, atom);
        }
      }
    });
    if (isActuallyWritableAtom(atom) && atom.onMount) {
      const setAtom = (update) => writeAtom(atom, update, version);
      const onUnmount = atom.onMount(setAtom);
      version = void 0;
      if (onUnmount) {
        mounted.u = onUnmount;
      }
    }
    return mounted;
  };
  const unmountAtom = (version, atom) => {
    var _a;
    const onUnmount = (_a = mountedMap.get(atom)) == null ? void 0 : _a.u;
    if (onUnmount) {
      onUnmount();
    }
    mountedMap.delete(atom);
    if (true) {
      mountedAtoms.delete(atom);
    }
    const atomState = getAtomState(version, atom);
    if (atomState) {
      if ("p" in atomState) {
        cancelSuspensePromise(atomState.p);
      }
      atomState.d.forEach((_, a) => {
        if (a !== atom) {
          const mounted = mountedMap.get(a);
          if (mounted) {
            mounted.t.delete(atom);
            if (canUnmountAtom(a, mounted)) {
              unmountAtom(version, a);
            }
          }
        }
      });
    } else if (true) {
      console.warn("[Bug] could not find atom state to unmount", atom);
    }
  };
  const mountDependencies = (version, atom, atomState, prevReadDependencies) => {
    const dependencies = new Set(atomState.d.keys());
    prevReadDependencies == null ? void 0 : prevReadDependencies.forEach((_, a) => {
      if (dependencies.has(a)) {
        dependencies.delete(a);
        return;
      }
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.delete(atom);
        if (canUnmountAtom(a, mounted)) {
          unmountAtom(version, a);
        }
      }
    });
    dependencies.forEach((a) => {
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.add(atom);
      } else if (mountedMap.has(atom)) {
        mountAtom(version, a, atom);
      }
    });
  };
  const flushPending = (version) => {
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      versionedAtomStateMap.forEach((atomState, atom) => {
        const committedAtomState = committedAtomStateMap.get(atom);
        if (atomState !== committedAtomState) {
          const mounted = mountedMap.get(atom);
          mounted == null ? void 0 : mounted.l.forEach((listener) => listener(version));
        }
      });
      return;
    }
    while (pendingMap.size) {
      const pending = Array.from(pendingMap);
      pendingMap.clear();
      pending.forEach(([atom, prevAtomState]) => {
        const atomState = getAtomState(void 0, atom);
        if (atomState && atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
          mountDependencies(void 0, atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
        }
        if (prevAtomState && !prevAtomState.y && // invalidated
        (atomState == null ? void 0 : atomState.y)) {
          return;
        }
        const mounted = mountedMap.get(atom);
        mounted == null ? void 0 : mounted.l.forEach((listener) => listener());
      });
    }
    if (true) {
      stateListeners.forEach((l) => l());
    }
  };
  const commitVersionedAtomStateMap = (version) => {
    const versionedAtomStateMap = getVersionedAtomStateMap(version);
    versionedAtomStateMap.forEach((atomState, atom) => {
      const prevAtomState = committedAtomStateMap.get(atom);
      if (!prevAtomState || atomState.r > prevAtomState.r || atomState.y !== prevAtomState.y || atomState.r === prevAtomState.r && atomState.d !== prevAtomState.d) {
        committedAtomStateMap.set(atom, atomState);
        if (atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
          mountDependencies(version, atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
        }
      }
    });
  };
  const commitAtom = (_atom, version) => {
    if (version) {
      commitVersionedAtomStateMap(version);
    }
    flushPending(void 0);
  };
  const subscribeAtom = (atom, callback, version) => {
    const mounted = addAtom(version, atom);
    const listeners = mounted.l;
    listeners.add(callback);
    return () => {
      listeners.delete(callback);
      delAtom(version, atom);
    };
  };
  const restoreAtoms = (values, version) => {
    for (const [atom, value] of values) {
      if (hasInitialValue(atom)) {
        setAtomPromiseOrValue(version, atom, value);
        invalidateDependents(version, atom);
      }
    }
    flushPending(version);
  };
  if (true) {
    return {
      [READ_ATOM]: readAtom,
      [WRITE_ATOM]: writeAtom,
      [COMMIT_ATOM]: commitAtom,
      [SUBSCRIBE_ATOM]: subscribeAtom,
      [RESTORE_ATOMS]: restoreAtoms,
      [DEV_SUBSCRIBE_STATE]: (l) => {
        stateListeners.add(l);
        return () => {
          stateListeners.delete(l);
        };
      },
      [DEV_GET_MOUNTED_ATOMS]: () => mountedAtoms.values(),
      [DEV_GET_ATOM_STATE]: (a) => committedAtomStateMap.get(a),
      [DEV_GET_MOUNTED]: (a) => mountedMap.get(a)
    };
  }
  return {
    [READ_ATOM]: readAtom,
    [WRITE_ATOM]: writeAtom,
    [COMMIT_ATOM]: commitAtom,
    [SUBSCRIBE_ATOM]: subscribeAtom,
    [RESTORE_ATOMS]: restoreAtoms
  };
};
const createStoreForExport = (initialValues) => {
  const store = createStore(initialValues);
  const get = (atom) => {
    const atomState = store[READ_ATOM](atom);
    if ("e" in atomState) {
      throw atomState.e;
    }
    if ("p" in atomState) {
      return void 0;
    }
    return atomState.v;
  };
  const asyncGet = (atom) => new Promise((resolve, reject) => {
    const atomState = store[READ_ATOM](atom);
    if ("e" in atomState) {
      reject(atomState.e);
    } else if ("p" in atomState) {
      resolve(atomState.p.then(() => asyncGet(atom)));
    } else {
      resolve(atomState.v);
    }
  });
  const set = (atom, update) => store[WRITE_ATOM](atom, update);
  const sub = (atom, callback) => store[SUBSCRIBE_ATOM](atom, callback);
  return {
    get,
    asyncGet,
    set,
    sub,
    SECRET_INTERNAL_store: store
  };
};

const createScopeContainer = (initialValues, unstable_createStore) => {
  const store = unstable_createStore ? unstable_createStore(initialValues).SECRET_INTERNAL_store : createStore(initialValues);
  return { s: store };
};
const ScopeContextMap = /* @__PURE__ */ new Map();
const getScopeContext = (scope) => {
  if (!ScopeContextMap.has(scope)) {
    ScopeContextMap.set(scope, (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(createScopeContainer()));
  }
  return ScopeContextMap.get(scope);
};

const Provider = ({
  children,
  initialValues,
  scope,
  unstable_createStore,
  unstable_enableVersionedWrite
}) => {
  const [version, setVersion] = useState({});
  useEffect(() => {
    const scopeContainer = scopeContainerRef.current;
    if (scopeContainer.w) {
      scopeContainer.s[COMMIT_ATOM](null, version);
      delete version.p;
      scopeContainer.v = version;
    }
  }, [version]);
  const scopeContainerRef = useRef();
  if (!scopeContainerRef.current) {
    const scopeContainer = createScopeContainer(
      initialValues,
      unstable_createStore
    );
    if (unstable_enableVersionedWrite) {
      let retrying = 0;
      scopeContainer.w = (write) => {
        setVersion((parentVersion) => {
          const nextVersion = retrying ? parentVersion : { p: parentVersion };
          write(nextVersion);
          return nextVersion;
        });
      };
      scopeContainer.v = version;
      scopeContainer.r = (fn) => {
        ++retrying;
        fn();
        --retrying;
      };
    }
    scopeContainerRef.current = scopeContainer;
  }
  const ScopeContainerContext = getScopeContext(scope);
  return createElement(
    ScopeContainerContext.Provider,
    {
      value: scopeContainerRef.current
    },
    children
  );
};

function atom(read, write) {
  return (0,jotai_vanilla__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)(read, write);
}

function useAtomValue(atom, scope) {
  const ScopeContext = getScopeContext(scope);
  const scopeContainer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ScopeContext);
  const { s: store, v: versionFromProvider } = scopeContainer;
  const getAtomValue = (version2) => {
    const atomState = store[READ_ATOM](atom, version2);
    if ( true && !atomState.y) {
      throw new Error("should not be invalidated");
    }
    if ("e" in atomState) {
      throw atomState.e;
    }
    if ("p" in atomState) {
      throw atomState.p;
    }
    if ("v" in atomState) {
      return atomState.v;
    }
    throw new Error("no atom value");
  };
  const [[version, valueFromReducer, atomFromReducer], rerenderIfChanged] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(
    (prev, nextVersion) => {
      const nextValue = getAtomValue(nextVersion);
      if (Object.is(prev[1], nextValue) && prev[2] === atom) {
        return prev;
      }
      return [nextVersion, nextValue, atom];
    },
    versionFromProvider,
    (initialVersion) => {
      const initialValue = getAtomValue(initialVersion);
      return [initialVersion, initialValue, atom];
    }
  );
  let value = valueFromReducer;
  if (atomFromReducer !== atom) {
    rerenderIfChanged(version);
    value = getAtomValue(version);
  }
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const { v: versionFromProvider2 } = scopeContainer;
    if (versionFromProvider2) {
      store[COMMIT_ATOM](atom, versionFromProvider2);
    }
    const unsubscribe = store[SUBSCRIBE_ATOM](
      atom,
      rerenderIfChanged,
      versionFromProvider2
    );
    rerenderIfChanged(versionFromProvider2);
    return unsubscribe;
  }, [store, atom, scopeContainer]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    store[COMMIT_ATOM](atom, version);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(value);
  return value;
}

function useSetAtom(atom, scope) {
  const ScopeContext = getScopeContext(scope);
  const { s: store, w: versionedWrite } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ScopeContext);
  const setAtom = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (update) => {
      if ( true && !("write" in atom)) {
        throw new Error("not writable atom");
      }
      const write = (version) => store[WRITE_ATOM](atom, update, version);
      return versionedWrite ? versionedWrite(write) : write();
    },
    [store, versionedWrite, atom]
  );
  return setAtom;
}

function useAtom(atom, scope) {
  if ("scope" in atom) {
    console.warn(
      "atom.scope is deprecated. Please do useAtom(atom, scope) instead."
    );
    scope = atom.scope;
  }
  return [
    useAtomValue(atom, scope),
    // We do wrong type assertion here, which results in throwing an error.
    useSetAtom(atom, scope)
  ];
}




/***/ }),

/***/ 99079:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xu": function() { return /* binding */ utils_atomFamily; },
  "qs": function() { return /* binding */ utils_atomWithDefault; },
  "O4": function() { return /* binding */ utils_atomWithStorage; },
  "FL": function() { return /* binding */ utils_createJSONStorage; },
  "n7": function() { return /* binding */ utils_loadable; }
});

// UNUSED EXPORTS: RESET, abortableAtom, atomWithHash, atomWithObservable, atomWithReducer, atomWithReset, freezeAtom, freezeAtomCreator, selectAtom, splitAtom, unstable_NO_STORAGE_VALUE, useAtomCallback, useAtomValue, useHydrateAtoms, useReducerAtom, useResetAtom, useUpdateAtom, waitForAll

;// CONCATENATED MODULE: ./node_modules/jotai/esm/vanilla/utils.mjs


const utils_RESET = Symbol();

function atomWithReset(initialValue) {
  const anAtom = atom(
    initialValue,
    (get, set, update) => {
      const nextValue = typeof update === "function" ? update(get(anAtom)) : update;
      set(anAtom, nextValue === utils_RESET ? initialValue : nextValue);
    }
  );
  return anAtom;
}

function atomWithReducer(initialValue, reducer) {
  const anAtom = atom(
    initialValue,
    (get, set, action) => set(anAtom, reducer(get(anAtom), action))
  );
  return anAtom;
}

function atomFamily(initializeAtom, areEqual) {
  let shouldRemove = null;
  const atoms = /* @__PURE__ */ new Map();
  const createAtom = (param) => {
    let item;
    if (areEqual === void 0) {
      item = atoms.get(param);
    } else {
      for (const [key, value] of atoms) {
        if (areEqual(key, param)) {
          item = value;
          break;
        }
      }
    }
    if (item !== void 0) {
      if (shouldRemove == null ? void 0 : shouldRemove(item[1], param)) {
        createAtom.remove(param);
      } else {
        return item[0];
      }
    }
    const newAtom = initializeAtom(param);
    atoms.set(param, [newAtom, Date.now()]);
    return newAtom;
  };
  createAtom.remove = (param) => {
    if (areEqual === void 0) {
      atoms.delete(param);
    } else {
      for (const [key] of atoms) {
        if (areEqual(key, param)) {
          atoms.delete(key);
          break;
        }
      }
    }
  };
  createAtom.setShouldRemove = (fn) => {
    shouldRemove = fn;
    if (!shouldRemove)
      return;
    for (const [key, value] of atoms) {
      if (shouldRemove(value[1], key)) {
        atoms.delete(key);
      }
    }
  };
  return createAtom;
}

const getCached$2 = (c, m, k) => (m.has(k) ? m : m.set(k, c())).get(k);
const cache1$4 = /* @__PURE__ */ new WeakMap();
const memo3 = (create, dep1, dep2, dep3) => {
  const cache2 = getCached$2(() => /* @__PURE__ */ new WeakMap(), cache1$4, dep1);
  const cache3 = getCached$2(() => /* @__PURE__ */ new WeakMap(), cache2, dep2);
  return getCached$2(create, cache3, dep3);
};
function selectAtom(anAtom, selector, equalityFn = Object.is) {
  return memo3(
    () => {
      const EMPTY = Symbol();
      const selectValue = ([value, prevSlice]) => {
        const slice = selector(value);
        if (prevSlice !== EMPTY && equalityFn(prevSlice, slice)) {
          return prevSlice;
        }
        return slice;
      };
      const derivedAtom = atom((get) => {
        const prev = get(derivedAtom);
        const value = get(anAtom);
        if (value instanceof Promise || prev instanceof Promise) {
          return Promise.all([value, prev]).then(selectValue);
        }
        return selectValue([value, prev]);
      });
      derivedAtom.init = EMPTY;
      return derivedAtom;
    },
    anAtom,
    selector,
    equalityFn
  );
}

const cache1$3 = /* @__PURE__ */ new WeakMap();
const memo1$1 = (create, dep1) => (cache1$3.has(dep1) ? cache1$3 : cache1$3.set(dep1, create())).get(dep1);
const deepFreeze = (obj) => {
  if (typeof obj !== "object" || obj === null)
    return;
  Object.freeze(obj);
  const propNames = Object.getOwnPropertyNames(obj);
  for (const name of propNames) {
    const value = obj[name];
    deepFreeze(value);
  }
  return obj;
};
function freezeAtom(anAtom) {
  return memo1$1(() => {
    const frozenAtom = atom(
      (get) => deepFreeze(get(anAtom)),
      (_get, set, arg) => set(anAtom, arg)
    );
    return frozenAtom;
  }, anAtom);
}
function freezeAtomCreator(createAtom) {
  return (...params) => {
    const anAtom = createAtom(...params);
    const origRead = anAtom.read;
    anAtom.read = (get, options) => deepFreeze(origRead(get, options));
    return anAtom;
  };
}

const getCached$1 = (c, m, k) => (m.has(k) ? m : m.set(k, c())).get(k);
const cache1$2 = /* @__PURE__ */ new WeakMap();
const memo2$1 = (create, dep1, dep2) => {
  const cache2 = getCached$1(() => /* @__PURE__ */ new WeakMap(), cache1$2, dep1);
  return getCached$1(create, cache2, dep2);
};
const cacheKeyForEmptyKeyExtractor = {};
const isWritable = (atom2) => !!atom2.write;
const isFunction = (x) => typeof x === "function";
function splitAtom(arrAtom, keyExtractor) {
  return memo2$1(
    () => {
      const mappingCache = /* @__PURE__ */ new WeakMap();
      const getMapping = (arr, prev) => {
        let mapping = mappingCache.get(arr);
        if (mapping) {
          return mapping;
        }
        const prevMapping = prev && mappingCache.get(prev);
        const atomList = [];
        const keyList = [];
        arr.forEach((item, index) => {
          const key = keyExtractor ? keyExtractor(item) : index;
          keyList[index] = key;
          const cachedAtom = prevMapping && prevMapping.atomList[prevMapping.keyList.indexOf(key)];
          if (cachedAtom) {
            atomList[index] = cachedAtom;
            return;
          }
          const read = (get) => {
            const prev2 = get(mappingAtom);
            const currArr = get(arrAtom);
            const mapping2 = getMapping(currArr, prev2 == null ? void 0 : prev2.arr);
            const index2 = mapping2.keyList.indexOf(key);
            if (index2 < 0 || index2 >= currArr.length) {
              const prevItem = arr[getMapping(arr).keyList.indexOf(key)];
              if (prevItem) {
                return prevItem;
              }
              throw new Error("splitAtom: index out of bounds for read");
            }
            return currArr[index2];
          };
          const write = (get, set, update) => {
            const prev2 = get(mappingAtom);
            const arr2 = get(arrAtom);
            const mapping2 = getMapping(arr2, prev2 == null ? void 0 : prev2.arr);
            const index2 = mapping2.keyList.indexOf(key);
            if (index2 < 0 || index2 >= arr2.length) {
              throw new Error("splitAtom: index out of bounds for write");
            }
            const nextItem = isFunction(update) ? update(arr2[index2]) : update;
            set(arrAtom, [
              ...arr2.slice(0, index2),
              nextItem,
              ...arr2.slice(index2 + 1)
            ]);
          };
          atomList[index] = isWritable(arrAtom) ? atom(read, write) : atom(read);
        });
        if (prevMapping && prevMapping.keyList.length === keyList.length && prevMapping.keyList.every((x, i) => x === keyList[i])) {
          mapping = prevMapping;
        } else {
          mapping = { arr, atomList, keyList };
        }
        mappingCache.set(arr, mapping);
        return mapping;
      };
      const mappingAtom = atom((get) => {
        const prev = get(mappingAtom);
        const arr = get(arrAtom);
        const mapping = getMapping(arr, prev == null ? void 0 : prev.arr);
        return mapping;
      });
      mappingAtom.init = void 0;
      const splittedAtom = isWritable(arrAtom) ? atom(
        (get) => get(mappingAtom).atomList,
        (get, set, action) => {
          switch (action.type) {
            case "remove": {
              const index = get(splittedAtom).indexOf(action.atom);
              if (index >= 0) {
                const arr = get(arrAtom);
                set(arrAtom, [
                  ...arr.slice(0, index),
                  ...arr.slice(index + 1)
                ]);
              }
              break;
            }
            case "insert": {
              const index = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
              if (index >= 0) {
                const arr = get(arrAtom);
                set(arrAtom, [
                  ...arr.slice(0, index),
                  action.value,
                  ...arr.slice(index)
                ]);
              }
              break;
            }
            case "move": {
              const index1 = get(splittedAtom).indexOf(action.atom);
              const index2 = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
              if (index1 >= 0 && index2 >= 0) {
                const arr = get(arrAtom);
                if (index1 < index2) {
                  set(arrAtom, [
                    ...arr.slice(0, index1),
                    ...arr.slice(index1 + 1, index2),
                    arr[index1],
                    ...arr.slice(index2)
                  ]);
                } else {
                  set(arrAtom, [
                    ...arr.slice(0, index2),
                    arr[index1],
                    ...arr.slice(index2, index1),
                    ...arr.slice(index1 + 1)
                  ]);
                }
              }
              break;
            }
          }
        }
      ) : atom((get) => get(mappingAtom).atomList);
      return splittedAtom;
    },
    arrAtom,
    keyExtractor || cacheKeyForEmptyKeyExtractor
  );
}

const updateValue = (prevValue, update) => typeof update === "function" ? update(prevValue) : update;
function atomWithDefault(getDefault) {
  const EMPTY = Symbol();
  const overwrittenAtom = atom(EMPTY);
  const anAtom = atom(
    (get, options) => {
      const overwritten = get(overwrittenAtom);
      if (overwritten !== EMPTY) {
        return overwritten;
      }
      return getDefault(get, options);
    },
    (get, set, update) => {
      if (update === utils_RESET) {
        return set(overwrittenAtom, EMPTY);
      }
      const prevValue = get(anAtom);
      if (prevValue instanceof Promise) {
        return prevValue.then(
          (v) => set(overwrittenAtom, updateValue(v, update))
        );
      }
      return set(
        overwrittenAtom,
        updateValue(prevValue, update)
      );
    }
  );
  return anAtom;
}

const NO_STORAGE_VALUE = Symbol();
function createJSONStorage(getStringStorage) {
  let lastStr;
  let lastValue;
  const storage = {
    getItem: (key) => {
      var _a, _b;
      const parse = (str2) => {
        str2 = str2 || "";
        if (lastStr !== str2) {
          try {
            lastValue = JSON.parse(str2);
          } catch {
            return NO_STORAGE_VALUE;
          }
          lastStr = str2;
        }
        return lastValue;
      };
      const str = (_b = (_a = getStringStorage()) == null ? void 0 : _a.getItem(key)) != null ? _b : null;
      if (str instanceof Promise) {
        return str.then(parse);
      }
      return parse(str);
    },
    setItem: (key, newValue) => {
      var _a;
      return (_a = getStringStorage()) == null ? void 0 : _a.setItem(key, JSON.stringify(newValue));
    },
    removeItem: (key) => {
      var _a;
      return (_a = getStringStorage()) == null ? void 0 : _a.removeItem(key);
    }
  };
  if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
    storage.subscribe = (key, callback) => {
      const storageEventCallback = (e) => {
        if (e.key === key && e.newValue) {
          callback(JSON.parse(e.newValue));
        }
      };
      window.addEventListener("storage", storageEventCallback);
      return () => {
        window.removeEventListener("storage", storageEventCallback);
      };
    };
  }
  return storage;
}
const defaultStorage = createJSONStorage(
  () => typeof window !== "undefined" ? window.localStorage : void 0
);
function atomWithStorage(key, initialValue, storage = defaultStorage) {
  const baseAtom = atom(initialValue);
  baseAtom.onMount = (setAtom) => {
    const value = storage.getItem(key);
    if (value instanceof Promise) {
      value.then((v) => setAtom(v === NO_STORAGE_VALUE ? initialValue : v));
    } else {
      setAtom(value === NO_STORAGE_VALUE ? initialValue : value);
    }
    let unsub;
    if (storage.subscribe) {
      unsub = storage.subscribe(key, setAtom);
    }
    return unsub;
  };
  const anAtom = atom(
    (get) => get(baseAtom),
    (get, set, update) => {
      const nextValue = typeof update === "function" ? update(get(baseAtom)) : update;
      if (nextValue === utils_RESET) {
        set(baseAtom, initialValue);
        return storage.removeItem(key);
      }
      set(baseAtom, nextValue);
      return storage.setItem(key, nextValue);
    }
  );
  return anAtom;
}

function atomWithObservable(getObservable, options) {
  const returnResultData = (result) => {
    if ("e" in result) {
      throw result.e;
    }
    return result.d;
  };
  const observableResultAtom = atom((get) => {
    var _a;
    let observable = getObservable(get);
    const itself = (_a = observable[Symbol.observable]) == null ? void 0 : _a.call(observable);
    if (itself) {
      observable = itself;
    }
    let resolve;
    const makePending = () => new Promise((r) => {
      resolve = r;
    });
    const initialResult = options && "initialValue" in options ? {
      d: typeof options.initialValue === "function" ? options.initialValue() : options.initialValue
    } : makePending();
    let setResult;
    let lastResult;
    const listener = (result) => {
      lastResult = result;
      resolve == null ? void 0 : resolve(result);
      setResult == null ? void 0 : setResult(result);
    };
    let subscription;
    let timer;
    const isNotMounted = () => !setResult;
    const start = () => {
      if (subscription) {
        clearTimeout(timer);
        subscription.unsubscribe();
      }
      subscription = observable.subscribe({
        next: (d) => listener({ d }),
        error: (e) => listener({ e }),
        complete: () => {
        }
      });
      if (isNotMounted() && (options == null ? void 0 : options.unstable_timeout)) {
        timer = setTimeout(() => {
          if (subscription) {
            subscription.unsubscribe();
            subscription = void 0;
          }
        }, options.unstable_timeout);
      }
    };
    start();
    const resultAtom = atom(lastResult || initialResult);
    resultAtom.onMount = (update) => {
      setResult = update;
      if (lastResult) {
        update(lastResult);
      }
      if (subscription) {
        clearTimeout(timer);
      } else {
        start();
      }
      return () => {
        setResult = void 0;
        if (subscription) {
          subscription.unsubscribe();
          subscription = void 0;
        }
      };
    };
    return [resultAtom, observable, makePending, start, isNotMounted];
  });
  const observableAtom = atom(
    (get) => {
      const [resultAtom] = get(observableResultAtom);
      const result = get(resultAtom);
      if (result instanceof Promise) {
        return result.then(returnResultData);
      }
      return returnResultData(result);
    },
    (get, set, data) => {
      const [resultAtom, observable, makePending, start, isNotMounted] = get(observableResultAtom);
      if ("next" in observable) {
        if (isNotMounted()) {
          set(resultAtom, makePending());
          start();
        }
        observable.next(data);
      } else {
        throw new Error("observable is not subject");
      }
    }
  );
  return observableAtom;
}

const cache1$1 = /* @__PURE__ */ new WeakMap();
const memo1 = (create, dep1) => (cache1$1.has(dep1) ? cache1$1 : cache1$1.set(dep1, create())).get(dep1);
const LOADING = { state: "loading" };
function loadable(anAtom) {
  return memo1(() => {
    const loadableCache = /* @__PURE__ */ new WeakMap();
    const refreshAtom = atom(0);
    const derivedAtom = atom(
      (get, { setSelf }) => {
        get(refreshAtom);
        const promise = get(anAtom);
        if (!(promise instanceof Promise)) {
          return { state: "hasData", data: promise };
        }
        const cached = loadableCache.get(promise);
        if (cached) {
          return cached;
        }
        loadableCache.set(promise, LOADING);
        promise.then(
          (data) => {
            loadableCache.set(promise, { state: "hasData", data });
          },
          (error) => {
            loadableCache.set(promise, { state: "hasError", error });
          }
        ).finally(setSelf);
        return LOADING;
      },
      (_get, set) => {
        set(refreshAtom, (c) => c + 1);
      }
    );
    return atom((get) => get(derivedAtom));
  }, anAtom);
}

const getCached = (c, m, k) => (m.has(k) ? m : m.set(k, c())).get(k);
const cache1 = /* @__PURE__ */ new WeakMap();
const memo2 = (create, dep1, dep2) => {
  const cache2 = getCached(() => /* @__PURE__ */ new WeakMap(), cache1, dep1);
  return getCached(create, cache2, dep2);
};
const defaultFallback = () => void 0;
function unwrap(anAtom, fallback = defaultFallback) {
  return memo2(
    () => {
      const promiseErrorCache = /* @__PURE__ */ new WeakMap();
      const promiseResultCache = /* @__PURE__ */ new WeakMap();
      const refreshAtom = atom(0);
      const promiseAndValueAtom = atom(
        (get, { setSelf }) => {
          get(refreshAtom);
          const prev = get(promiseAndValueAtom);
          const promise = get(anAtom);
          if (promise === (prev == null ? void 0 : prev.p)) {
            if (promiseErrorCache.has(promise)) {
              throw promiseErrorCache.get(promise);
            }
            if (promiseResultCache.has(promise)) {
              return {
                p: promise,
                v: promiseResultCache.get(promise)
              };
            }
          }
          if (promise !== (prev == null ? void 0 : prev.p)) {
            promise.then(
              (v) => promiseResultCache.set(promise, v),
              (e) => promiseErrorCache.set(promise, e)
            ).finally(setSelf);
          }
          if (prev && "v" in prev) {
            return { p: promise, f: fallback(prev.v) };
          }
          return { p: promise, f: fallback() };
        },
        (_get, set) => {
          set(refreshAtom, (c) => c + 1);
        }
      );
      promiseAndValueAtom.init = void 0;
      return atom((get) => {
        const state = get(promiseAndValueAtom);
        if ("v" in state) {
          return state.v;
        }
        return state.f;
      });
    },
    anAtom,
    fallback
  );
}



// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(13665);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/jotai/esm/utils.mjs






function utils_atomWithReset(initialValue) {
  const anAtom = atom(initialValue, (get, set, update) => {
    const nextValue = typeof update === "function" ? update(get(anAtom)) : update;
    set(anAtom, nextValue === RESET ? initialValue : nextValue);
  });
  return anAtom;
}

const WRITE_ATOM = "w";
const RESTORE_ATOMS = "h";

function useResetAtom(anAtom, scope) {
  const ScopeContext = SECRET_INTERNAL_getScopeContext(scope);
  const store = useContext(ScopeContext).s;
  const setAtom = useCallback(
    () => store[WRITE_ATOM](anAtom, RESET),
    [store, anAtom]
  );
  return setAtom;
}

function useReducerAtom(anAtom, reducer, scope) {
  const [state, setState] = useAtom(anAtom, scope);
  const dispatch = useCallback(
    (action) => {
      setState((prev) => reducer(prev, action));
    },
    [setState, reducer]
  );
  return [state, dispatch];
}

function utils_atomWithReducer(initialValue, reducer) {
  const anAtom = atom(
    initialValue,
    (get, set, action) => set(anAtom, reducer(get(anAtom), action))
  );
  return anAtom;
}

function utils_atomFamily(initializeAtom, areEqual) {
  let shouldRemove = null;
  const atoms = /* @__PURE__ */ new Map();
  const createAtom = (param) => {
    let item;
    if (areEqual === void 0) {
      item = atoms.get(param);
    } else {
      for (const [key, value] of atoms) {
        if (areEqual(key, param)) {
          item = value;
          break;
        }
      }
    }
    if (item !== void 0) {
      if (shouldRemove == null ? void 0 : shouldRemove(item[1], param)) {
        createAtom.remove(param);
      } else {
        return item[0];
      }
    }
    const newAtom = initializeAtom(param);
    atoms.set(param, [newAtom, Date.now()]);
    return newAtom;
  };
  createAtom.remove = (param) => {
    if (areEqual === void 0) {
      atoms.delete(param);
    } else {
      for (const [key] of atoms) {
        if (areEqual(key, param)) {
          atoms.delete(key);
          break;
        }
      }
    }
  };
  createAtom.setShouldRemove = (fn) => {
    shouldRemove = fn;
    if (!shouldRemove)
      return;
    for (const [key, value] of atoms) {
      if (shouldRemove(value[1], key)) {
        atoms.delete(key);
      }
    }
  };
  return createAtom;
}

const getWeakCacheItem = (cache, deps) => {
  do {
    const [dep, ...rest] = deps;
    const entry = cache.get(dep);
    if (!entry) {
      return;
    }
    if (!rest.length) {
      return entry[1];
    }
    cache = entry[0];
    deps = rest;
  } while (deps.length);
};
const setWeakCacheItem = (cache, deps, item) => {
  do {
    const [dep, ...rest] = deps;
    let entry = cache.get(dep);
    if (!entry) {
      entry = [ new WeakMap()];
      cache.set(dep, entry);
    }
    if (!rest.length) {
      entry[1] = item;
      return;
    }
    cache = entry[0];
    deps = rest;
  } while (deps.length);
};
const createMemoizeAtom = () => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizeAtom = (createAtom, deps) => {
    const cachedAtom = getWeakCacheItem(cache, deps);
    if (cachedAtom) {
      return cachedAtom;
    }
    const createdAtom = createAtom();
    setWeakCacheItem(cache, deps, createdAtom);
    return createdAtom;
  };
  return memoizeAtom;
};

const memoizeAtom$4 = createMemoizeAtom();
function utils_selectAtom(anAtom, selector, equalityFn = Object.is) {
  return memoizeAtom$4(() => {
    const refAtom = atom(() => ({}));
    const derivedAtom = atom((get) => {
      const slice = selector(get(anAtom));
      const ref = get(refAtom);
      if ("prev" in ref && equalityFn(ref.prev, slice)) {
        return ref.prev;
      }
      ref.prev = slice;
      return slice;
    });
    return derivedAtom;
  }, [anAtom, selector, equalityFn]);
}

function useAtomCallback(callback, scope) {
  const anAtom = useMemo(
    () => atom(
      null,
      (get, set, [arg, resolve, reject]) => {
        try {
          resolve(callback(get, set, arg));
        } catch (e) {
          reject(e);
        }
      }
    ),
    [callback]
  );
  const invoke = useSetAtom(anAtom, scope);
  return useCallback(
    (arg) => {
      let isSync = true;
      let settled = {};
      const promise = new Promise((resolve, reject) => {
        invoke([
          arg,
          (v) => {
            if (isSync) {
              settled = { v };
            } else {
              resolve(v);
            }
          },
          (e) => {
            if (isSync) {
              settled = { e };
            } else {
              reject(e);
            }
          }
        ]);
      });
      isSync = false;
      if ("e" in settled) {
        throw settled.e;
      }
      if ("v" in settled) {
        return settled.v;
      }
      return promise;
    },
    [invoke]
  );
}

const memoizeAtom$3 = createMemoizeAtom();
const utils_deepFreeze = (obj) => {
  if (typeof obj !== "object" || obj === null)
    return;
  Object.freeze(obj);
  const propNames = Object.getOwnPropertyNames(obj);
  for (const name of propNames) {
    const value = obj[name];
    utils_deepFreeze(value);
  }
  return obj;
};
function utils_freezeAtom(anAtom) {
  return memoizeAtom$3(() => {
    const frozenAtom = atom(
      (get) => utils_deepFreeze(get(anAtom)),
      (_get, set, arg) => set(anAtom, arg)
    );
    return frozenAtom;
  }, [anAtom]);
}
function utils_freezeAtomCreator(createAtom) {
  return (...params) => {
    const anAtom = createAtom(...params);
    const origRead = anAtom.read;
    anAtom.read = (get) => utils_deepFreeze(origRead(get));
    return anAtom;
  };
}

const memoizeAtom$2 = createMemoizeAtom();
const utils_isWritable = (atom2) => !!atom2.write;
const utils_isFunction = (x) => typeof x === "function";
function utils_splitAtom(arrAtom, keyExtractor) {
  return memoizeAtom$2(
    () => {
      const mappingCache = /* @__PURE__ */ new WeakMap();
      const getMapping = (arr, prev) => {
        let mapping = mappingCache.get(arr);
        if (mapping) {
          return mapping;
        }
        const prevMapping = prev && mappingCache.get(prev);
        const atomList = [];
        const keyList = [];
        arr.forEach((item, index) => {
          const key = keyExtractor ? keyExtractor(item) : index;
          keyList[index] = key;
          const cachedAtom = prevMapping && prevMapping.atomList[prevMapping.keyList.indexOf(key)];
          if (cachedAtom) {
            atomList[index] = cachedAtom;
            return;
          }
          const read2 = (get) => {
            const ref = get(refAtom);
            const currArr = get(arrAtom);
            const mapping2 = getMapping(currArr, ref.prev);
            const index2 = mapping2.keyList.indexOf(key);
            if (index2 < 0 || index2 >= currArr.length) {
              const prevItem = arr[getMapping(arr).keyList.indexOf(key)];
              if (prevItem) {
                return prevItem;
              }
              throw new Error("splitAtom: index out of bounds for read");
            }
            return currArr[index2];
          };
          const write2 = (get, set, update) => {
            const ref = get(refAtom);
            const arr2 = get(arrAtom);
            const mapping2 = getMapping(arr2, ref.prev);
            const index2 = mapping2.keyList.indexOf(key);
            if (index2 < 0 || index2 >= arr2.length) {
              throw new Error("splitAtom: index out of bounds for write");
            }
            const nextItem = utils_isFunction(update) ? update(arr2[index2]) : update;
            set(arrAtom, [
              ...arr2.slice(0, index2),
              nextItem,
              ...arr2.slice(index2 + 1)
            ]);
          };
          atomList[index] = utils_isWritable(arrAtom) ? atom(read2, write2) : atom(read2);
        });
        if (prevMapping && prevMapping.keyList.length === keyList.length && prevMapping.keyList.every((x, i) => x === keyList[i])) {
          mapping = prevMapping;
        } else {
          mapping = { atomList, keyList };
        }
        mappingCache.set(arr, mapping);
        return mapping;
      };
      const refAtom = atom(() => ({}));
      const read = (get) => {
        const ref = get(refAtom);
        const arr = get(arrAtom);
        const mapping = getMapping(arr, ref.prev);
        ref.prev = arr;
        return mapping.atomList;
      };
      const write = (get, set, action) => {
        if ("read" in action) {
          console.warn("atomToRemove is deprecated. use action with type");
          action = { type: "remove", atom: action };
        }
        switch (action.type) {
          case "remove": {
            const index = get(splittedAtom).indexOf(action.atom);
            if (index >= 0) {
              const arr = get(arrAtom);
              set(arrAtom, [
                ...arr.slice(0, index),
                ...arr.slice(index + 1)
              ]);
            }
            break;
          }
          case "insert": {
            const index = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
            if (index >= 0) {
              const arr = get(arrAtom);
              set(arrAtom, [
                ...arr.slice(0, index),
                action.value,
                ...arr.slice(index)
              ]);
            }
            break;
          }
          case "move": {
            const index1 = get(splittedAtom).indexOf(action.atom);
            const index2 = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
            if (index1 >= 0 && index2 >= 0) {
              const arr = get(arrAtom);
              if (index1 < index2) {
                set(arrAtom, [
                  ...arr.slice(0, index1),
                  ...arr.slice(index1 + 1, index2),
                  arr[index1],
                  ...arr.slice(index2)
                ]);
              } else {
                set(arrAtom, [
                  ...arr.slice(0, index2),
                  arr[index1],
                  ...arr.slice(index2, index1),
                  ...arr.slice(index1 + 1)
                ]);
              }
            }
            break;
          }
        }
      };
      const splittedAtom = utils_isWritable(arrAtom) ? atom(read, write) : atom(read);
      return splittedAtom;
    },
    keyExtractor ? [arrAtom, keyExtractor] : [arrAtom]
  );
}

function utils_atomWithDefault(getDefault) {
  const EMPTY = Symbol();
  const overwrittenAtom = (0,esm/* atom */.cn)(EMPTY);
  const anAtom = (0,esm/* atom */.cn)(
    (get) => {
      const overwritten = get(overwrittenAtom);
      if (overwritten !== EMPTY) {
        return overwritten;
      }
      return getDefault(get);
    },
    (get, set, update) => {
      if (update === utils_RESET) {
        return set(overwrittenAtom, EMPTY);
      }
      return set(
        overwrittenAtom,
        typeof update === "function" ? update(get(anAtom)) : update
      );
    }
  );
  return anAtom;
}

const memoizeAtom$1 = createMemoizeAtom();
const emptyArrayAtom = (0,esm/* atom */.cn)(() => []);
function waitForAll(atoms) {
  const createAtom = () => {
    const unwrappedAtoms = unwrapAtoms(atoms);
    const derivedAtom = atom((get) => {
      const promises = [];
      const values = unwrappedAtoms.map((anAtom, index) => {
        try {
          return get(anAtom);
        } catch (e) {
          if (e instanceof Promise) {
            promises[index] = e;
          } else {
            throw e;
          }
        }
      });
      if (promises.length) {
        throw Promise.all(promises);
      }
      return wrapResults(atoms, values);
    });
    return derivedAtom;
  };
  if (Array.isArray(atoms)) {
    if (atoms.length) {
      return memoizeAtom$1(createAtom, atoms);
    }
    return emptyArrayAtom;
  }
  return createAtom();
}
const unwrapAtoms = (atoms) => Array.isArray(atoms) ? atoms : Object.getOwnPropertyNames(atoms).map((key) => atoms[key]);
const wrapResults = (atoms, results) => Array.isArray(atoms) ? results : Object.getOwnPropertyNames(atoms).reduce(
  (out, key, idx) => ({ ...out, [key]: results[idx] }),
  {}
);

function utils_createJSONStorage(getStringStorage) {
  let lastStr;
  let lastValue;
  const storage = {
    getItem: (key) => {
      var _a, _b;
      const parse = (str2) => {
        str2 = str2 || "";
        if (lastStr !== str2) {
          try {
            lastValue = JSON.parse(str2);
          } catch {
            return NO_STORAGE_VALUE;
          }
          lastStr = str2;
        }
        return lastValue;
      };
      const str = (_b = (_a = getStringStorage()) == null ? void 0 : _a.getItem(key)) != null ? _b : null;
      if (str instanceof Promise) {
        return str.then(parse);
      }
      return parse(str);
    },
    setItem: (key, newValue) => {
      var _a;
      return (_a = getStringStorage()) == null ? void 0 : _a.setItem(key, JSON.stringify(newValue));
    },
    removeItem: (key) => {
      var _a;
      return (_a = getStringStorage()) == null ? void 0 : _a.removeItem(key);
    }
  };
  if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
    storage.subscribe = (key, callback) => {
      const storageEventCallback = (e) => {
        if (e.key === key && e.newValue) {
          callback(JSON.parse(e.newValue));
        }
      };
      window.addEventListener("storage", storageEventCallback);
      return () => {
        window.removeEventListener("storage", storageEventCallback);
      };
    };
  }
  return storage;
}
const utils_defaultStorage = utils_createJSONStorage(
  () => typeof window !== "undefined" ? window.localStorage : void 0
);
function utils_atomWithStorage(key, initialValue, storage = utils_defaultStorage) {
  const getInitialValue = () => {
    const value = storage.getItem(key);
    if (value instanceof Promise) {
      return value.then((v) => v === NO_STORAGE_VALUE ? initialValue : v);
    }
    return value === NO_STORAGE_VALUE ? initialValue : value;
  };
  const baseAtom = (0,esm/* atom */.cn)(storage.delayInit ? initialValue : getInitialValue());
  baseAtom.onMount = (setAtom) => {
    let unsub;
    if (storage.subscribe) {
      unsub = storage.subscribe(key, setAtom);
      setAtom(getInitialValue());
    }
    if (storage.delayInit) {
      const value = getInitialValue();
      if (value instanceof Promise) {
        value.then(setAtom);
      } else {
        setAtom(value);
      }
    }
    return unsub;
  };
  const anAtom = (0,esm/* atom */.cn)(
    (get) => get(baseAtom),
    (get, set, update) => {
      const nextValue = typeof update === "function" ? update(get(baseAtom)) : update;
      if (nextValue === utils_RESET) {
        set(baseAtom, initialValue);
        return storage.removeItem(key);
      }
      set(baseAtom, nextValue);
      return storage.setItem(key, nextValue);
    }
  );
  return anAtom;
}
function atomWithHash(key, initialValue, options) {
  const serialize = (options == null ? void 0 : options.serialize) || JSON.stringify;
  const deserialize = (options == null ? void 0 : options.deserialize) || ((str) => {
    try {
      return JSON.parse(str || "");
    } catch {
      return unstable_NO_STORAGE_VALUE;
    }
  });
  const subscribe = (options == null ? void 0 : options.subscribe) || ((callback) => {
    window.addEventListener("hashchange", callback);
    return () => {
      window.removeEventListener("hashchange", callback);
    };
  });
  const hashStorage = {
    getItem: (key2) => {
      if (typeof location === "undefined") {
        return unstable_NO_STORAGE_VALUE;
      }
      const searchParams = new URLSearchParams(location.hash.slice(1));
      const storedValue = searchParams.get(key2);
      return deserialize(storedValue);
    },
    setItem: (key2, newValue) => {
      const searchParams = new URLSearchParams(location.hash.slice(1));
      searchParams.set(key2, serialize(newValue));
      if (options == null ? void 0 : options.replaceState) {
        history.replaceState(
          null,
          "",
          location.pathname + location.search + "#" + searchParams.toString()
        );
      } else {
        location.hash = searchParams.toString();
      }
    },
    removeItem: (key2) => {
      const searchParams = new URLSearchParams(location.hash.slice(1));
      searchParams.delete(key2);
      if (options == null ? void 0 : options.replaceState) {
        history.replaceState(
          null,
          "",
          location.pathname + location.search + "#" + searchParams.toString()
        );
      } else {
        location.hash = searchParams.toString();
      }
    },
    ...(options == null ? void 0 : options.delayInit) && { delayInit: true },
    subscribe: (key2, setValue) => {
      const callback = () => {
        const searchParams = new URLSearchParams(location.hash.slice(1));
        const str = searchParams.get(key2);
        if (str !== null) {
          setValue(deserialize(str));
        } else {
          setValue(initialValue);
        }
      };
      return subscribe(callback);
    }
  };
  return utils_atomWithStorage(key, initialValue, hashStorage);
}

function utils_atomWithObservable(getObservable, options) {
  const observableResultAtom = atom((get) => {
    var _a;
    let observable = getObservable(get);
    const itself = (_a = observable[Symbol.observable]) == null ? void 0 : _a.call(observable);
    if (itself) {
      observable = itself;
    }
    let resolve;
    const makePending = () => new Promise((r) => {
      resolve = r;
    });
    const initialResult = options && "initialValue" in options ? {
      d: typeof options.initialValue === "function" ? options.initialValue() : options.initialValue
    } : makePending();
    let setResult;
    let lastResult;
    const listener = (result) => {
      lastResult = result;
      resolve == null ? void 0 : resolve(result);
      setResult == null ? void 0 : setResult(result);
    };
    let subscription;
    let timer;
    const isNotMounted = () => !setResult;
    const start = () => {
      if (subscription) {
        clearTimeout(timer);
        subscription.unsubscribe();
      }
      subscription = observable.subscribe({
        next: (d) => listener({ d }),
        error: (e) => listener({ e }),
        complete: () => {
        }
      });
      if (isNotMounted() && (options == null ? void 0 : options.unstable_timeout)) {
        timer = setTimeout(() => {
          if (subscription) {
            subscription.unsubscribe();
            subscription = void 0;
          }
        }, options.unstable_timeout);
      }
    };
    start();
    const resultAtom = atom(lastResult || initialResult);
    resultAtom.onMount = (update) => {
      setResult = update;
      if (lastResult) {
        update(lastResult);
      }
      if (subscription) {
        clearTimeout(timer);
      } else {
        start();
      }
      return () => {
        setResult = void 0;
        if (subscription) {
          subscription.unsubscribe();
          subscription = void 0;
        }
      };
    };
    return [resultAtom, observable, makePending, start, isNotMounted];
  });
  const observableAtom = atom(
    (get) => {
      const [resultAtom] = get(observableResultAtom);
      const result = get(resultAtom);
      if ("e" in result) {
        throw result.e;
      }
      return result.d;
    },
    (get, set, data) => {
      const [resultAtom, observable, makePending, start, isNotMounted] = get(observableResultAtom);
      if ("next" in observable) {
        if (isNotMounted()) {
          set(resultAtom, makePending());
          start();
        }
        observable.next(data);
      } else {
        throw new Error("observable is not subject");
      }
    }
  );
  return observableAtom;
}

const hydratedMap = /* @__PURE__ */ new WeakMap();
function useHydrateAtoms(values, scope) {
  const ScopeContext = SECRET_INTERNAL_getScopeContext(scope);
  const scopeContainer = useContext(ScopeContext);
  const store = scopeContainer.s;
  const hydratedSet = getHydratedSet(scopeContainer);
  const tuplesToRestore = [];
  for (const tuple of values) {
    const atom = tuple[0];
    if (!hydratedSet.has(atom)) {
      hydratedSet.add(atom);
      tuplesToRestore.push(tuple);
    }
  }
  if (tuplesToRestore.length) {
    store[RESTORE_ATOMS](tuplesToRestore);
  }
}
function getHydratedSet(scopeContainer) {
  let hydratedSet = hydratedMap.get(scopeContainer);
  if (!hydratedSet) {
    hydratedSet = /* @__PURE__ */ new WeakSet();
    hydratedMap.set(scopeContainer, hydratedSet);
  }
  return hydratedSet;
}

const memoizeAtom = createMemoizeAtom();
const utils_LOADING = { state: "loading" };
function utils_loadable(anAtom) {
  return memoizeAtom(() => {
    const loadableAtomCache = /* @__PURE__ */ new WeakMap();
    const catchAtom = (0,esm/* atom */.cn)((get) => {
      let promise;
      try {
        const data = get(anAtom);
        const loadableAtom2 = (0,esm/* atom */.cn)({ state: "hasData", data });
        return loadableAtom2;
      } catch (error) {
        if (error instanceof Promise) {
          promise = error;
        } else {
          const loadableAtom2 = (0,esm/* atom */.cn)({
            state: "hasError",
            error
          });
          return loadableAtom2;
        }
      }
      const cached = loadableAtomCache.get(promise);
      if (cached) {
        return cached;
      }
      const loadableAtom = (0,esm/* atom */.cn)(
        utils_LOADING,
        async (get2, set) => {
          try {
            const data = await get2(anAtom, { unstable_promise: true });
            set(loadableAtom, { state: "hasData", data });
          } catch (error) {
            set(loadableAtom, { state: "hasError", error });
          }
        }
      );
      loadableAtom.onMount = (init) => {
        init();
      };
      loadableAtomCache.set(promise, loadableAtom);
      return loadableAtom;
    });
    const derivedAtom = (0,esm/* atom */.cn)((get) => {
      const loadableAtom = get(catchAtom);
      return get(loadableAtom);
    });
    return derivedAtom;
  }, [anAtom]);
}

function abortableAtom(read, write) {
  return atom((get) => {
    const controller = new AbortController();
    const promise = read(get, { signal: controller.signal });
    if (promise instanceof Promise) {
      SECRET_INTERNAL_registerPromiseAbort(promise, () => controller.abort());
    }
    return promise;
  }, write);
}

const useAtomValue = (...args) => {
  console.warn("[DEPRECATED]: use `useAtomValue` from `jotai` instead.");
  return Jotai.useAtomValue(...args);
};
const useUpdateAtom = (...args) => {
  console.warn("[DEPRECATED]: use `useSetAtom` from `jotai` instead.");
  return Jotai.useSetAtom(...args);
};




/***/ }),

/***/ 15103:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MT": function() { return /* binding */ createStore; },
/* harmony export */   "cn": function() { return /* binding */ atom; }
/* harmony export */ });
/* unused harmony export getDefaultStore */
let keyCount = 0;
function atom(read, write) {
  const key = `atom${++keyCount}`;
  const config = {
    toString: () => key
  };
  if (typeof read === "function") {
    config.read = read;
  } else {
    config.init = read;
    config.read = (get) => get(config);
    config.write = (get, set, arg) => set(
      config,
      typeof arg === "function" ? arg(get(config)) : arg
    );
  }
  if (write) {
    config.write = write;
  }
  return config;
}

const hasInitialValue = (atom) => "init" in atom;
const isActuallyWritableAtom = (atom) => !!atom.write;
const cancelPromiseMap = /* @__PURE__ */ new WeakMap();
const registerCancelPromise = (promise, cancel) => {
  cancelPromiseMap.set(promise, cancel);
  promise.catch(() => {
  }).finally(() => cancelPromiseMap.delete(promise));
};
const cancelPromise = (promise, next) => {
  const cancel = cancelPromiseMap.get(promise);
  if (cancel) {
    cancelPromiseMap.delete(promise);
    cancel(next);
  }
};
const resolvePromise = (promise, value) => {
  promise.status = "fulfilled";
  promise.value = value;
};
const rejectPromise = (promise, e) => {
  promise.status = "rejected";
  promise.reason = e;
};
const isEqualAtomValue = (a, b) => "v" in a && "v" in b && Object.is(a.v, b.v);
const isEqualAtomError = (a, b) => "e" in a && "e" in b && Object.is(a.e, b.e);
const hasPromiseAtomValue = (a) => "v" in a && a.v instanceof Promise;
const returnAtomValue = (atomState) => {
  if ("e" in atomState) {
    throw atomState.e;
  }
  return atomState.v;
};
const createStore = () => {
  const atomStateMap = /* @__PURE__ */ new WeakMap();
  const mountedMap = /* @__PURE__ */ new WeakMap();
  const pendingMap = /* @__PURE__ */ new Map();
  let stateListeners;
  let mountedAtoms;
  if (true) {
    stateListeners = /* @__PURE__ */ new Set();
    mountedAtoms = /* @__PURE__ */ new Set();
  }
  const getAtomState = (atom) => atomStateMap.get(atom);
  const setAtomState = (atom, atomState) => {
    if (true) {
      Object.freeze(atomState);
    }
    const prevAtomState = atomStateMap.get(atom);
    atomStateMap.set(atom, atomState);
    if (!pendingMap.has(atom)) {
      pendingMap.set(atom, prevAtomState);
    }
    if (prevAtomState && hasPromiseAtomValue(prevAtomState)) {
      const next = "v" in atomState ? atomState.v instanceof Promise ? atomState.v : Promise.resolve(atomState.v) : Promise.reject(atomState.e);
      cancelPromise(prevAtomState.v, next);
    }
  };
  const updateDependencies = (atom, nextAtomState, depSet) => {
    const dependencies = /* @__PURE__ */ new Map();
    let changed = false;
    depSet.forEach((a) => {
      const aState = a === atom ? nextAtomState : getAtomState(a);
      if (aState) {
        dependencies.set(a, aState);
        if (nextAtomState.d.get(a) !== aState) {
          changed = true;
        }
      } else if (true) {
        console.warn("[Bug] atom state not found");
      }
    });
    if (changed || nextAtomState.d.size !== dependencies.size) {
      nextAtomState.d = dependencies;
    }
  };
  const setAtomValue = (atom, value, depSet) => {
    const prevAtomState = getAtomState(atom);
    const nextAtomState = {
      d: (prevAtomState == null ? void 0 : prevAtomState.d) || /* @__PURE__ */ new Map(),
      v: value
    };
    if (depSet) {
      updateDependencies(atom, nextAtomState, depSet);
    }
    if (prevAtomState && isEqualAtomValue(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) {
      return prevAtomState;
    }
    setAtomState(atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomError = (atom, error, depSet) => {
    const prevAtomState = getAtomState(atom);
    const nextAtomState = {
      d: (prevAtomState == null ? void 0 : prevAtomState.d) || /* @__PURE__ */ new Map(),
      e: error
    };
    if (depSet) {
      updateDependencies(atom, nextAtomState, depSet);
    }
    if (prevAtomState && isEqualAtomError(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) {
      return prevAtomState;
    }
    setAtomState(atom, nextAtomState);
    return nextAtomState;
  };
  const readAtomState = (atom) => {
    const atomState = getAtomState(atom);
    if (atomState) {
      atomState.d.forEach((_, a) => {
        if (a !== atom && !mountedMap.has(a)) {
          readAtomState(a);
        }
      });
      if (Array.from(atomState.d).every(
        ([a, s]) => a === atom || getAtomState(a) === s
      )) {
        return atomState;
      }
    }
    const depSet = /* @__PURE__ */ new Set();
    let isSync = true;
    const getter = (a) => {
      depSet.add(a);
      if (a === atom) {
        const aState2 = getAtomState(a);
        if (aState2) {
          return returnAtomValue(aState2);
        }
        if (hasInitialValue(a)) {
          return a.init;
        }
        throw new Error("no atom init");
      }
      const aState = readAtomState(a);
      return returnAtomValue(aState);
    };
    let controller;
    let setSelf;
    const options = {
      get signal() {
        if (!controller) {
          controller = new AbortController();
        }
        return controller.signal;
      },
      get setSelf() {
        if ( true && !isActuallyWritableAtom(atom)) {
          console.warn("setSelf function cannot be used with read-only atom");
        }
        if (!setSelf && isActuallyWritableAtom(atom)) {
          setSelf = (...args) => {
            if ( true && isSync) {
              console.warn("setSelf function cannot be called in sync");
            }
            if (!isSync) {
              return writeAtom(atom, ...args);
            }
          };
        }
        return setSelf;
      }
    };
    try {
      const value = atom.read(getter, options);
      if (value instanceof Promise) {
        let continuePromise;
        const promise = new Promise((resolve, reject) => {
          let settled = false;
          value.then(
            (v) => {
              if (!settled) {
                resolvePromise(promise, v);
                resolve(v);
              }
            },
            (e) => {
              if (!settled) {
                rejectPromise(promise, e);
                reject(e);
              }
            }
          ).finally(() => {
            if (!settled) {
              settled = true;
              setAtomValue(atom, promise, depSet);
            }
          });
          continuePromise = (next) => {
            if (!settled) {
              settled = true;
              next.then(
                (v) => resolvePromise(promise, v),
                (e) => rejectPromise(promise, e)
              );
              resolve(next);
            }
          };
        });
        promise.status = "pending";
        registerCancelPromise(promise, (next) => {
          if (next) {
            continuePromise(next);
          }
          controller == null ? void 0 : controller.abort();
        });
        return setAtomValue(atom, promise, depSet);
      }
      return setAtomValue(atom, value, depSet);
    } catch (error) {
      return setAtomError(atom, error, depSet);
    } finally {
      isSync = false;
    }
  };
  const readAtom = (atom) => returnAtomValue(readAtomState(atom));
  const addAtom = (atom) => {
    let mounted = mountedMap.get(atom);
    if (!mounted) {
      mounted = mountAtom(atom);
    }
    return mounted;
  };
  const canUnmountAtom = (atom, mounted) => !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
  const delAtom = (atom) => {
    const mounted = mountedMap.get(atom);
    if (mounted && canUnmountAtom(atom, mounted)) {
      unmountAtom(atom);
    }
  };
  const recomputeDependents = (atom) => {
    const mounted = mountedMap.get(atom);
    mounted == null ? void 0 : mounted.t.forEach((dependent) => {
      if (dependent !== atom) {
        const prevAtomState = getAtomState(dependent);
        const nextAtomState = readAtomState(dependent);
        if (!prevAtomState || !isEqualAtomValue(prevAtomState, nextAtomState)) {
          recomputeDependents(dependent);
        }
      }
    });
  };
  const writeAtomState = (atom, ...args) => {
    let isSync = true;
    const getter = (a) => returnAtomValue(readAtomState(a));
    const setter = (a, ...args2) => {
      let r;
      if (a === atom) {
        if (!hasInitialValue(a)) {
          throw new Error("atom not writable");
        }
        const prevAtomState = getAtomState(a);
        const nextAtomState = setAtomValue(a, args2[0]);
        if (!prevAtomState || !isEqualAtomValue(prevAtomState, nextAtomState)) {
          recomputeDependents(a);
        }
      } else {
        r = writeAtomState(a, ...args2);
      }
      if (!isSync) {
        flushPending();
      }
      return r;
    };
    const result = atom.write(getter, setter, ...args);
    isSync = false;
    return result;
  };
  const writeAtom = (atom, ...args) => {
    const result = writeAtomState(atom, ...args);
    flushPending();
    return result;
  };
  const mountAtom = (atom, initialDependent) => {
    const mounted = {
      t: new Set(initialDependent && [initialDependent]),
      l: /* @__PURE__ */ new Set()
    };
    mountedMap.set(atom, mounted);
    if (true) {
      mountedAtoms.add(atom);
    }
    readAtomState(atom).d.forEach((_, a) => {
      const aMounted = mountedMap.get(a);
      if (aMounted) {
        aMounted.t.add(atom);
      } else {
        if (a !== atom) {
          mountAtom(a, atom);
        }
      }
    });
    readAtomState(atom);
    if (isActuallyWritableAtom(atom) && atom.onMount) {
      const onUnmount = atom.onMount((...args) => writeAtom(atom, ...args));
      if (onUnmount) {
        mounted.u = onUnmount;
      }
    }
    return mounted;
  };
  const unmountAtom = (atom) => {
    var _a;
    const onUnmount = (_a = mountedMap.get(atom)) == null ? void 0 : _a.u;
    if (onUnmount) {
      onUnmount();
    }
    mountedMap.delete(atom);
    if (true) {
      mountedAtoms.delete(atom);
    }
    const atomState = getAtomState(atom);
    if (atomState) {
      if (hasPromiseAtomValue(atomState)) {
        cancelPromise(atomState.v);
      }
      atomState.d.forEach((_, a) => {
        if (a !== atom) {
          const mounted = mountedMap.get(a);
          if (mounted) {
            mounted.t.delete(atom);
            if (canUnmountAtom(a, mounted)) {
              unmountAtom(a);
            }
          }
        }
      });
    } else if (true) {
      console.warn("[Bug] could not find atom state to unmount", atom);
    }
  };
  const mountDependencies = (atom, atomState, prevDependencies) => {
    const depSet = new Set(atomState.d.keys());
    prevDependencies == null ? void 0 : prevDependencies.forEach((_, a) => {
      if (depSet.has(a)) {
        depSet.delete(a);
        return;
      }
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.delete(atom);
        if (canUnmountAtom(a, mounted)) {
          unmountAtom(a);
        }
      }
    });
    depSet.forEach((a) => {
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.add(atom);
      } else if (mountedMap.has(atom)) {
        mountAtom(a, atom);
      }
    });
  };
  const flushPending = () => {
    while (pendingMap.size) {
      const pending = Array.from(pendingMap);
      pendingMap.clear();
      pending.forEach(([atom, prevAtomState]) => {
        const atomState = getAtomState(atom);
        if (atomState) {
          if (atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
            mountDependencies(atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
          }
          const mounted = mountedMap.get(atom);
          if (mounted && !// TODO This seems pretty hacky. Hope to fix it.
          // Maybe we could `mountDependencies` in `setAtomState`?
          (prevAtomState && !hasPromiseAtomValue(prevAtomState) && (isEqualAtomValue(prevAtomState, atomState) || isEqualAtomError(prevAtomState, atomState)))) {
            mounted.l.forEach((listener) => listener());
          }
        } else if (true) {
          console.warn("[Bug] no atom state to flush");
        }
      });
    }
    if (true) {
      stateListeners.forEach((l) => l());
    }
  };
  const subscribeAtom = (atom, listener) => {
    const mounted = addAtom(atom);
    flushPending();
    const listeners = mounted.l;
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
      delAtom(atom);
    };
  };
  if (true) {
    return {
      get: readAtom,
      set: writeAtom,
      sub: subscribeAtom,
      // store dev methods (these are tentative and subject to change)
      dev_subscribe_state: (l) => {
        stateListeners.add(l);
        return () => {
          stateListeners.delete(l);
        };
      },
      dev_get_mounted_atoms: () => mountedAtoms.values(),
      dev_get_atom_state: (a) => atomStateMap.get(a),
      dev_get_mounted: (a) => mountedMap.get(a),
      dev_restore_atoms: (values) => {
        for (const [atom, value] of values) {
          if (hasInitialValue(atom)) {
            setAtomValue(atom, value);
            recomputeDependents(atom);
          }
        }
        flushPending();
      }
    };
  }
  return {
    get: readAtom,
    set: writeAtom,
    sub: subscribeAtom
  };
};
let defaultStore;
const getDefaultStore = () => {
  if (!defaultStore) {
    defaultStore = createStore();
  }
  return defaultStore;
};




/***/ }),

/***/ 41608:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ le; },
/* harmony export */   "o": function() { return /* binding */ ue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var re=Object.defineProperty;var R=Object.getOwnPropertySymbols;var j=Object.prototype.hasOwnProperty,F=Object.prototype.propertyIsEnumerable;var W=(e,t,r)=>t in e?re(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))j.call(t,r)&&W(e,r,t[r]);if(R)for(var r of R(t))F.call(t,r)&&W(e,r,t[r]);return e};var H=(e,t)=>{var r={};for(var c in e)j.call(e,c)&&t.indexOf(c)<0&&(r[c]=e[c]);if(e!=null&&R)for(var c of R(e))t.indexOf(c)<0&&F.call(e,c)&&(r[c]=e[c]);return r};var p=(e,t)=>{let r="[react-use-intercom]";switch(e){case"info":console.log(`${r} ${t}`);break;case"warn":console.warn(`${r} ${t}`);break;case"error":console.error(`${r} ${t}`);break;default:console.log(`${r} ${t}`);}};var I=typeof window=="undefined",A=e=>(Object.keys(e).forEach(t=>{e[t]&&typeof e[t]=="object"?A(e[t]):e[t]===void 0&&delete e[t];}),e);var ne=(e,...t)=>{if(!I&&window.Intercom)return window.Intercom.apply(null,[e,...t]);p("error",`${e} Intercom instance is not initalized yet`);},s=ne;var ae=react__WEBPACK_IMPORTED_MODULE_0__.createContext(void 0),P=ae;var se=(e,t=0)=>{var r=window,c=r.Intercom;if(typeof c=="function")c("reattach_activator"),c("update",r.intercomSettings);else {var w=document,l=function(){l.c(arguments);};l.q=[],l.c=function(u){l.q.push(u);},r.Intercom=l;var f=function(){setTimeout(function(){var u=w.createElement("script");u.type="text/javascript",u.async=!0,u.src="https://widget.intercom.io/widget/"+e;var d=w.getElementsByTagName("script")[0];d.parentNode.insertBefore(u,d);},t);};document.readyState==="complete"?f():r.attachEvent?r.attachEvent("onload",f):r.addEventListener("load",f,!1);}},J=se;var ce=e=>({custom_launcher_selector:e.customLauncherSelector,alignment:e.alignment,vertical_padding:e.verticalPadding,horizontal_padding:e.horizontalPadding,hide_default_launcher:e.hideDefaultLauncher,session_duration:e.sessionDuration,action_color:e.actionColor,background_color:e.backgroundColor}),Q=e=>m({company_id:e.companyId,name:e.name,created_at:e.createdAt,plan:e.plan,monthly_spend:e.monthlySpend,user_count:e.userCount,size:e.size,website:e.website,industry:e.industry},e.customAttributes),ie=e=>({type:e.type,image_url:e.imageUrl}),me=e=>{var t;return m({email:e.email,user_id:e.userId,created_at:e.createdAt,name:e.name,phone:e.phone,last_request_at:e.lastRequestAt,unsubscribed_from_emails:e.unsubscribedFromEmails,language_override:e.languageOverride,utm_campaign:e.utmCampaign,utm_content:e.utmContent,utm_medium:e.utmMedium,utm_source:e.utmSource,utm_term:e.utmTerm,avatar:e.avatar&&ie(e.avatar),user_hash:e.userHash,company:e.company&&Q(e.company),companies:(t=e.companies)==null?void 0:t.map(Q)},e.customAttributes)},y=e=>A(m(m({},ce(e)),me(e)));var le=de=>{var _=de,{appId:e,autoBoot:t=!1,autoBootProps:r,children:c,onHide:w,onShow:l,onUnreadCountChange:f,onUserEmailSupplied:u,shouldInitialize:d=!I,apiBase:v,initializeDelay:Y}=_,Z=H(_,["appId","autoBoot","autoBootProps","children","onHide","onShow","onUnreadCountChange","onUserEmailSupplied","shouldInitialize","apiBase","initializeDelay"]);let g=react__WEBPACK_IMPORTED_MODULE_0__.useRef(!1),b=react__WEBPACK_IMPORTED_MODULE_0__.useRef(!1),x=Object.keys(Z).filter(n=>!n.startsWith("data-"));x.length>0&&p("warn",["some invalid props were passed to IntercomProvider. ",`Please check following props: ${x.join(", ")}.`].join(""));let C=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(n=>{if(!window.Intercom&&!d){p("warn","Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");return}let i=m(m({app_id:e},v&&{api_base:v}),n&&y(n));window.intercomSettings=i,s("boot",i),g.current=!0;},[v,e,d]),[k,h]=react__WEBPACK_IMPORTED_MODULE_0__.useState(!1),ee=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{h(!1),w&&w();},[w,h]),te=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{h(!0),l&&l();},[l,h]);!I&&d&&!b.current&&(J(e,Y),s("onHide",ee),s("onShow",te),s("onUserEmailSupplied",u),f&&s("onUnreadCountChange",f),t&&C(r),b.current=!0);let a=react__WEBPACK_IMPORTED_MODULE_0__.useCallback((n,i)=>{if(!window.Intercom&&!d){p("warn","Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");return}if(!g.current){p("warn",[`"${n}" was called but Intercom has not booted yet. `,`Please call 'boot' before calling '${n}' or `,"set 'autoBoot' to true in the IntercomProvider."].join(""));return}return i()},[d]),S=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{g.current&&(s("shutdown"),delete window.intercomSettings,g.current=!1);},[]),D=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{g.current&&(s("shutdown"),delete window.Intercom,delete window.intercomSettings,g.current=!1);},[]),M=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{a("update",()=>{let n=Math.floor(new Date().getTime()/1e3);s("update",{last_request_at:n});});},[a]),E=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(n=>{a("update",()=>{if(!n){M();return}let i=y(n);window.intercomSettings=m(m({},window.intercomSettings),i),s("update",i);});},[a,M]),T=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{a("hide",()=>{s("hide");});},[a]),$=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{a("show",()=>s("show"));},[a]),V=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>{a("showMessages",()=>{s("showMessages");});},[a]),z=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(n=>{a("showNewMessage",()=>{n?s("showNewMessage",n):s("showNewMessage");});},[a]),L=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(()=>a("getVisitorId",()=>s("getVisitorId")),[a]),N=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(n=>{a("startTour",()=>{s("startTour",n);});},[a]),q=react__WEBPACK_IMPORTED_MODULE_0__.useCallback((n,i)=>{a("trackEvent",()=>{i?s("trackEvent",n,i):s("trackEvent",n);});},[a]),O=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(n=>a("showArticle",()=>{s("showArticle",n);}),[a]),B=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(n=>a("showSpace",()=>{s("showSpace",n);}),[a]),U=react__WEBPACK_IMPORTED_MODULE_0__.useCallback(n=>{a("startSurvey",()=>{s("startSurvey",n);});},[a]),oe=react__WEBPACK_IMPORTED_MODULE_0__.useMemo(()=>({boot:C,shutdown:S,hardShutdown:D,update:E,hide:T,show:$,isOpen:k,showMessages:V,showNewMessage:z,getVisitorId:L,startTour:N,trackEvent:q,showArticle:O,startSurvey:U,showSpace:B}),[C,S,D,E,T,$,k,V,z,L,N,q,O,U,B]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(P.Provider,{value:oe},c)},X=()=>{let e=react__WEBPACK_IMPORTED_MODULE_0__.useContext(P);if(e===void 0)throw new Error('"useIntercom" must be used within `IntercomProvider`.');return e};var ue=()=>X();


//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ 63496:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce$1; },
/* harmony export */   "Ed": function() { return /* binding */ forEach$1; },
/* harmony export */   "FG": function() { return /* binding */ interval$1; },
/* harmony export */   "Hr": function() { return /* binding */ onStart$1; },
/* harmony export */   "Kj": function() { return /* binding */ scan$1; },
/* harmony export */   "Ld": function() { return /* binding */ N; },
/* harmony export */   "TS": function() { return /* binding */ merge$1; },
/* harmony export */   "UI": function() { return /* binding */ map$1; },
/* harmony export */   "_A": function() { return /* binding */ fromValue$1; },
/* harmony export */   "f3": function() { return /* binding */ buffer$1; },
/* harmony export */   "hX": function() { return /* binding */ filter$1; },
/* harmony export */   "nF": function() { return /* binding */ skipWhile$1; },
/* harmony export */   "nI": function() { return /* binding */ p; },
/* harmony export */   "nN": function() { return /* binding */ makeSubject$1; },
/* harmony export */   "ok": function() { return /* binding */ onEnd$1; },
/* harmony export */   "p4": function() { return /* binding */ fromPromise$1; },
/* harmony export */   "qn": function() { return /* binding */ take$1; },
/* harmony export */   "zG": function() { return /* binding */ pipe; },
/* harmony export */   "zo": function() { return /* binding */ concat$1; }
/* harmony export */ });
/* unused harmony exports combine, concatAll, concatMap, delay, empty, flatten, fromCallbag, fromDomEvent, fromList, fromObservable, make, mergeAll, mergeMap, never, onPush, publish, sample, share, skip, skipUntil, switchAll, switchMap, takeLast, takeUntil, takeWhile, tap, throttle, toArray, toCallbag, toObservable, toPromise */
function l(a, b) {
  b.tag = a;
  return b;
}

function m() {}

function p(a) {
  return function (b) {
    var c = a.length;
    let d = !1,
      e = !1,
      f = !1,
      g = 0;
    b(
      l(0, [
        function (h) {
          if (h) {
            d = !0;
          } else if (e) {
            f = !0;
          } else {
            for (e = f = !0; f && !d; ) {
              g < c ? ((h = a[g]), (g = (g + 1) | 0), (f = !1), b(l(1, [h]))) : ((d = !0), b(0));
            }
            e = !1;
          }
        },
      ])
    );
  };
}

function r() {}

function t(a) {
  a(0);
}

function u(a) {
  let b = !1;
  a(
    l(0, [
      function (c) {
        c ? (b = !0) : b || a(0);
      },
    ])
  );
}

function w(a) {
  if (void 0 === a) {
    return ((a = [v, 0]).tag = 256), a;
  }
  if (null === a || a[0] !== v) {
    return a;
  }
  (a = [v, (a[1] + 1) | 0]).tag = 256;
  return a;
}

function x(a) {
  if (null === a || a[0] !== v) {
    return a;
  }
  if (0 !== (a = a[1])) {
    return [v, (a - 1) | 0];
  }
}

function z(a) {
  return function (b) {
    return function (c) {
      function d(b) {
        'number' == typeof b
          ? k &&
            ((k = !1),
            void 0 !== (b = e.shift())
              ? ((b = a(x(b))), (k = !0), b(d))
              : q
              ? c(0)
              : g || ((g = !0), f(0)))
          : b.tag
          ? k && (c(b), n ? (n = !1) : h(0))
          : ((h = b = b[0]), (n = !1), b(0));
      }
      let e = [],
        f = m,
        g = !1,
        h = m,
        k = !1,
        n = !1,
        q = !1;
      b(function (b) {
        'number' == typeof b
          ? q || ((q = !0), k || 0 !== e.length || c(0))
          : b.tag
          ? q || ((b = b[0]), (g = !1), k ? e.push(b) : ((b = a(b)), (k = !0), b(d)))
          : (f = b[0]);
      });
      c(
        l(0, [
          function (c) {
            if (c) {
              if ((q || ((q = !0), f(1)), k)) {
                return (k = !1), h(1);
              }
            } else {
              q || g || ((g = !0), f(0)), k && !n && ((n = !0), h(0));
            }
          },
        ])
      );
    };
  };
}

function A(a) {
  return a;
}

function B(a) {
  return a;
}

function C(a) {
  return a(0);
}

function D(a) {
  return function (b) {
    return function (c) {
      let e = m,
        f = !1,
        g = [],
        h = !1;
      b(function (b) {
        'number' == typeof b
          ? h || ((h = !0), 0 === g.length && c(0))
          : b.tag
          ? h ||
            ((f = !1),
            (function (a) {
              function b(a) {
                'number' == typeof a
                  ? 0 !== g.length &&
                    ((g = g.filter(d)),
                    (a = 0 === g.length),
                    h && a ? c(0) : !f && a && ((f = !0), e(0)))
                  : a.tag
                  ? 0 !== g.length && (c(l(1, [a[0]])), k(0))
                  : ((k = a = a[0]), (g = g.concat(a)), a(0));
              }
              function d(a) {
                return a !== k;
              }
              let k = m;
              1 === a.length ? a(b) : a.bind(null, b);
            })(a(b[0])),
            f || ((f = !0), e(0)))
          : (e = b[0]);
      });
      c(
        l(0, [
          function (a) {
            a
              ? (h || ((h = !0), e(a)),
                g.forEach(function (c) {
                  return c(a);
                }),
                (g = []))
              : (f || h ? (f = !1) : ((f = !0), e(0)), g.forEach(C));
          },
        ])
      );
    };
  };
}

function E(a) {
  return a;
}

function F(a) {
  return a;
}

function G(a) {
  return D(F)(a);
}

function H(a) {
  return function (b) {
    return function (c) {
      let d = !1;
      return b(function (e) {
        if ('number' == typeof e) {
          d || ((d = !0), c(e));
        } else if (e.tag) {
          d || (a(e[0]), c(e));
        } else {
          var g = e[0];
          c(
            l(0, [
              function (a) {
                if (!d) {
                  return a && (d = !0), g(a);
                }
              },
            ])
          );
        }
      });
    };
  };
}

function J(a) {
  a(0);
}

function K(a) {
  return function (b) {
    return function (c) {
      function d(a) {
        h &&
          ('number' == typeof a
            ? ((h = !1), n ? c(a) : f || ((f = !0), e(0)))
            : a.tag
            ? (c(a), k ? (k = !1) : g(0))
            : ((g = a = a[0]), (k = !1), a(0)));
      }
      let e = m,
        f = !1,
        g = m,
        h = !1,
        k = !1,
        n = !1;
      b(function (b) {
        'number' == typeof b
          ? n || ((n = !0), h || c(0))
          : b.tag
          ? n ||
            (h && (g(1), (g = m)), f ? (f = !1) : ((f = !0), e(0)), (b = a(b[0])), (h = !0), b(d))
          : (e = b[0]);
      });
      c(
        l(0, [
          function (a) {
            if (a) {
              if ((n || ((n = !0), e(1)), h)) {
                return (h = !1), g(1);
              }
            } else {
              n || f || ((f = !0), e(0)), h && !k && ((k = !0), g(0));
            }
          },
        ])
      );
    };
  };
}

function L(a) {
  return a;
}

function M(a) {
  return function (b) {
    return function (c) {
      let d = [],
        e = m;
      return b(function (b) {
        'number' == typeof b
          ? p(d)(c)
          : b.tag
          ? (d.length >= a && 0 < a && d.shift(), d.push(b[0]), e(0))
          : ((b = b[0]), 0 >= a ? (b(1), u(c)) : ((e = b), b(0)));
      });
    };
  };
}

function N(a) {
  return function (b) {
    let c = m,
      d = !1;
    b(function (e) {
      'number' == typeof e ? (d = !0) : e.tag ? d || (a(e[0]), c(0)) : ((c = e = e[0]), e(0));
    });
    return {
      unsubscribe: function () {
        if (!d) {
          return (d = !0), c(1);
        }
      },
    };
  };
}

function O() {}

function Q() {}

function R() {}

function S() {}

function buffer$1(a) {
  return function (b) {
    return function (c) {
      function d(a) {
        'number' == typeof a
          ? k || ((k = !0), f(1), 0 < e.length && c(l(1, [e])), c(0))
          : a.tag
          ? !k && 0 < e.length && ((a = e), (e = []), c(l(1, [a])))
          : (g = a[0]);
      }
      let e = [],
        f = m,
        g = m,
        h = !1,
        k = !1;
      b(function (b) {
        'number' == typeof b
          ? k || ((k = !0), g(1), 0 < e.length && c(l(1, [e])), c(0))
          : b.tag
          ? k || (e.push(b[0]), h ? (h = !1) : ((h = !0), f(0), g(0)))
          : ((f = b[0]), a(d));
      });
      c(
        l(0, [
          function (a) {
            if (!k) {
              if (a) {
                return (k = !0), f(1), g(1);
              }
              if (!h) {
                return (h = !0), f(0), g(0);
              }
            }
          },
        ])
      );
    };
  };
}

function combine$1(a, b) {
  return (function (a, b) {
    return function (c) {
      let d = m,
        e = m,
        f = void 0,
        g = void 0,
        h = !1,
        k = 0,
        n = !1;
      a(function (a) {
        var b = g;
        'number' == typeof a
          ? 1 > k
            ? (k = (k + 1) | 0)
            : n || ((n = !0), c(0))
          : a.tag
          ? ((a = a[0]),
            void 0 !== b
              ? n || ((f = w(a)), (h = !1), c(l(1, [[a, x(b)]])))
              : ((f = w(a)), h ? (h = !1) : e(0)))
          : (d = a[0]);
      });
      b(function (a) {
        var b = f;
        'number' == typeof a
          ? 1 > k
            ? (k = (k + 1) | 0)
            : n || ((n = !0), c(0))
          : a.tag
          ? ((a = a[0]),
            void 0 !== b
              ? n || ((g = w(a)), (h = !1), c(l(1, [[x(b), a]])))
              : ((g = w(a)), h ? (h = !1) : d(0)))
          : (e = a[0]);
      });
      c(
        l(0, [
          function (c) {
            if (!n) {
              if (c) {
                return (n = !0), d(1), e(1);
              }
              if (!h) {
                return (h = !0), d(c), e(c);
              }
            }
          },
        ])
      );
    };
  })(a, b);
}

function concat$1(a) {
  return z(B)(p(a));
}

function concatAll$1(a) {
  return z(A)(a);
}

function debounce$1(a) {
  return function (b) {
    return function (c) {
      function d() {
        var a = e;
        void 0 !== a && ((e = void 0), clearTimeout(x(a)));
      }
      let e = void 0,
        f = !1,
        g = !1;
      return b(function (b) {
        if ('number' == typeof b) {
          g || ((g = !0), void 0 !== e ? (f = !0) : c(0));
        } else if (b.tag) {
          g ||
            (d(),
            (e = w(
              setTimeout(function () {
                e = void 0;
                c(b);
                f && c(0);
              }, a(b[0]))
            )));
        } else {
          var n = b[0];
          c(
            l(0, [
              function (a) {
                if (!g) {
                  return a ? ((g = !0), (f = !1), d(), n(1)) : n(0);
                }
              },
            ])
          );
        }
      });
    };
  };
}

function delay$1(a) {
  return function (b) {
    return function (c) {
      let d = 0;
      return b(function (b) {
        'number' == typeof b || b.tag
          ? ((d = (d + 1) | 0),
            setTimeout(function () {
              0 !== d && ((d = (d - 1) | 0), c(b));
            }, a))
          : c(b);
      });
    };
  };
}

function filter$1(a) {
  return function (b) {
    return function (c) {
      let d = m;
      return b(function (b) {
        'number' == typeof b ? c(b) : b.tag ? (a(b[0]) ? c(b) : d(0)) : ((d = b[0]), c(b));
      });
    };
  };
}

function forEach$1(a) {
  return function (b) {
    N(a)(b);
  };
}

function fromCallbag$2(a) {
  return function (b) {
    function c(a, c) {
      switch (a) {
        case 0:
          b(
            l(0, [
              function (a) {
                return a ? c(2) : c(1);
              },
            ])
          );
          break;

        case 1:
          b(l(1, [c]));
          break;

        case 2:
          b(0);
      }
    }
    return 2 === a.length ? a(0, c) : a.bind(null, 0, c);
  };
}

function fromDomEvent$1(a, b) {
  return (function (a, b) {
    return function (c) {
      function d(a) {
        c(l(1, [a]));
      }
      c(
        l(0, [
          function (c) {
            c && a.removeEventListener(b, d);
          },
        ])
      );
      a.addEventListener(b, d);
    };
  })(a, b);
}

function fromList$1(a) {
  return function (b) {
    let c = !1,
      d = !1,
      e = !1,
      f = a;
    b(
      l(0, [
        function (a) {
          if (a) {
            c = !0;
          } else if (d) {
            e = !0;
          } else {
            for (d = e = !0; e && !c; ) {
              (a = f) ? ((f = a[1]), (e = !1), b(l(1, [a[0]]))) : ((c = !0), b(0));
            }
            d = !1;
          }
        },
      ])
    );
  };
}

function fromObservable$2(a) {
  var b = void 0 !== a[P] ? a[P]() : a;
  return function (a) {
    var c = b.subscribe({
      next: function (c) {
        a(l(1, [c]));
      },
      complete: function () {
        a(0);
      },
      error: Q,
    });
    a(
      l(0, [
        function (a) {
          if (a) {
            return c.unsubscribe();
          }
        },
      ])
    );
  };
}

function fromPromise$1(a) {
  return function (b) {
    let c = !1;
    a.then(function (a) {
      c || (b(l(1, [a])), b(0));
      return Promise.resolve(void 0);
    });
    b(
      l(0, [
        function (a) {
          a && (c = !0);
        },
      ])
    );
  };
}

function fromValue$1(a) {
  return function (b) {
    let c = !1;
    b(
      l(0, [
        function (d) {
          d ? (c = !0) : c || ((c = !0), b(l(1, [a])), b(0));
        },
      ])
    );
  };
}

function interval$1(a) {
  return function (b) {
    let c = 0;
    var d = setInterval(function () {
      var a = c;
      c = (c + 1) | 0;
      b(l(1, [a]));
    }, a);
    b(
      l(0, [
        function (a) {
          a && clearInterval(d);
        },
      ])
    );
  };
}

function make$1(a) {
  return function (b) {
    let c = r,
      d = !1;
    c = a({
      next: function (a) {
        d || b(l(1, [a]));
      },
      complete: function () {
        d || ((d = !0), b(0));
      },
    });
    b(
      l(0, [
        function (a) {
          if (a && !d) {
            return (d = !0), c();
          }
        },
      ])
    );
  };
}

function makeSubject$1() {
  let a = [],
    b = !1;
  return {
    source: function (c) {
      function b(a) {
        return a !== c;
      }
      a = a.concat(c);
      c(
        l(0, [
          function (c) {
            c && (a = a.filter(b));
          },
        ])
      );
    },
    next: function (c) {
      b ||
        a.forEach(function (a) {
          a(l(1, [c]));
        });
    },
    complete: function () {
      b || ((b = !0), a.forEach(t));
    },
  };
}

function map$1(a) {
  return function (b) {
    return function (c) {
      return b(function (b) {
        b = 'number' == typeof b ? 0 : b.tag ? l(1, [a(b[0])]) : l(0, [b[0]]);
        c(b);
      });
    };
  };
}

function merge$1(a) {
  return D(E)(p(a));
}

function never$1(a) {
  a(l(0, [m]));
}

function onEnd$1(a) {
  return function (b) {
    return function (c) {
      let d = !1;
      return b(function (b) {
        if ('number' == typeof b) {
          if (d) {
            return;
          }
          d = !0;
          c(b);
          return a();
        }
        if (b.tag) {
          d || c(b);
        } else {
          var e = b[0];
          c(
            l(0, [
              function (c) {
                if (!d) {
                  return c ? ((d = !0), e(c), a()) : e(c);
                }
              },
            ])
          );
        }
      });
    };
  };
}

function onStart$1(a) {
  return function (b) {
    return function (c) {
      return b(function (b) {
        'number' == typeof b ? c(b) : b.tag ? c(b) : (c(b), a());
      });
    };
  };
}

function pipe() {
  for (var a = arguments, b = arguments[0], c = 1, d = arguments.length; c < d; c++) {
    b = a[c](b);
  }
  return b;
}

function publish$1(a) {
  return N(O)(a);
}

function sample$1(a) {
  return function (b) {
    return function (c) {
      let d = m,
        e = m,
        f = void 0,
        g = !1,
        h = !1;
      b(function (a) {
        'number' == typeof a
          ? h || ((h = !0), e(1), c(0))
          : a.tag
          ? ((f = w(a[0])), g ? (g = !1) : ((g = !0), e(0), d(0)))
          : (d = a[0]);
      });
      a(function (a) {
        var b = f;
        'number' == typeof a
          ? h || ((h = !0), d(1), c(0))
          : a.tag
          ? void 0 === b || h || ((f = void 0), c(l(1, [x(b)])))
          : (e = a[0]);
      });
      c(
        l(0, [
          function (a) {
            if (!h) {
              if (a) {
                return (h = !0), d(1), e(1);
              }
              if (!g) {
                return (g = !0), d(0), e(0);
              }
            }
          },
        ])
      );
    };
  };
}

function scan$1(a, b) {
  return (function (a, b) {
    return function (c) {
      return function (d) {
        let e = b;
        return c(function (c) {
          'number' == typeof c
            ? (c = 0)
            : c.tag
            ? ((e = a(e, c[0])), (c = l(1, [e])))
            : (c = l(0, [c[0]]));
          d(c);
        });
      };
    };
  })(a, b);
}

function share$1(a) {
  function b(a) {
    'number' == typeof a
      ? (c.forEach(J), (c = []))
      : a.tag
      ? ((e = !1),
        c.forEach(function (b) {
          b(a);
        }))
      : (d = a[0]);
  }
  let c = [],
    d = m,
    e = !1;
  return function (f) {
    function g(a) {
      return a !== f;
    }
    c = c.concat(f);
    1 === c.length && a(b);
    f(
      l(0, [
        function (a) {
          if (a) {
            if (((c = c.filter(g)), 0 === c.length)) {
              return d(1);
            }
          } else {
            e || ((e = !0), d(a));
          }
        },
      ])
    );
  };
}

function skip$1(a) {
  return function (b) {
    return function (c) {
      let d = m,
        e = a;
      return b(function (a) {
        'number' == typeof a
          ? c(a)
          : a.tag
          ? 0 < e
            ? ((e = (e - 1) | 0), d(0))
            : c(a)
          : ((d = a[0]), c(a));
      });
    };
  };
}

function skipUntil$1(a) {
  return function (b) {
    return function (c) {
      function d(a) {
        'number' == typeof a
          ? g && ((k = !0), e(1))
          : a.tag
          ? ((g = !1), f(1))
          : ((f = a = a[0]), a(0));
      }
      let e = m,
        f = m,
        g = !0,
        h = !1,
        k = !1;
      b(function (b) {
        'number' == typeof b
          ? (g && f(1), (k = !0), c(0))
          : b.tag
          ? g || k
            ? h
              ? (h = !1)
              : ((h = !0), e(0), f(0))
            : ((h = !1), c(b))
          : ((e = b[0]), a(d));
      });
      c(
        l(0, [
          function (a) {
            if (!k) {
              if (a) {
                if (((k = !0), e(1), g)) {
                  return f(1);
                }
              } else {
                h || ((h = !0), g && f(0), e(0));
              }
            }
          },
        ])
      );
    };
  };
}

function skipWhile$1(a) {
  return function (b) {
    return function (c) {
      let d = m,
        e = !0;
      return b(function (b) {
        'number' == typeof b
          ? c(b)
          : b.tag
          ? e
            ? a(b[0])
              ? d(0)
              : ((e = !1), c(b))
            : c(b)
          : ((d = b[0]), c(b));
      });
    };
  };
}

function switchAll$1(a) {
  return K(L)(a);
}

function take$1(a) {
  return function (b) {
    return function (c) {
      let d = !1,
        e = 0,
        f = m;
      b(function (b) {
        'number' == typeof b
          ? d || ((d = !0), c(0))
          : b.tag
          ? e < a && !d && ((e = (e + 1) | 0), c(b), !d && e >= a && ((d = !0), c(0), f(1)))
          : ((b = b[0]), 0 >= a ? ((d = !0), c(0), b(1)) : (f = b));
      });
      c(
        l(0, [
          function (b) {
            if (!d) {
              if (b) {
                return (d = !0), f(1);
              }
              if (e < a) {
                return f(0);
              }
            }
          },
        ])
      );
    };
  };
}

function takeUntil$1(a) {
  return function (b) {
    return function (c) {
      function d(a) {
        'number' != typeof a && (a.tag ? ((e = !0), f(1), c(0)) : ((g = a = a[0]), a(0)));
      }
      let e = !1,
        f = m,
        g = m;
      b(function (b) {
        'number' == typeof b ? e || ((e = !0), g(1), c(0)) : b.tag ? e || c(b) : ((f = b[0]), a(d));
      });
      c(
        l(0, [
          function (a) {
            if (!e) {
              return a ? ((e = !0), f(1), g(1)) : f(0);
            }
          },
        ])
      );
    };
  };
}

function takeWhile$1(a) {
  return function (b) {
    return function (c) {
      let d = m,
        e = !1;
      return b(function (b) {
        'number' == typeof b
          ? e || ((e = !0), c(0))
          : b.tag
          ? e || (a(b[0]) ? c(b) : ((e = !0), c(0), d(1)))
          : ((d = b[0]), c(b));
      });
    };
  };
}

function throttle$1(a) {
  return function (b) {
    return function (c) {
      function d() {
        void 0 !== g && clearTimeout(x(g));
      }
      function e() {
        g = void 0;
        f = !1;
      }
      let f = !1,
        g = void 0;
      return b(function (b) {
        if ('number' == typeof b) {
          d(), c(0);
        } else if (b.tag) {
          f || ((f = !0), d(), (g = w(setTimeout(e, a(b[0])))), c(b));
        } else {
          var h = b[0];
          c(
            l(0, [
              function (a) {
                return a ? (d(), h(1)) : h(a);
              },
            ])
          );
        }
      });
    };
  };
}

function toArray$1(a) {
  let b = [],
    c = m,
    d = !1;
  a(function (a) {
    'number' == typeof a ? (d = !0) : a.tag ? (b.push(a[0]), c(0)) : ((c = a = a[0]), a(0));
  });
  d || c(1);
  return b;
}

function toCallbag$2(a) {
  return function (b, c) {
    if (0 === b) {
      return a(function (a) {
        function b(a) {
          switch (a) {
            case 1:
              d(0);
              break;

            case 2:
              d(1);
          }
        }
        if ('number' == typeof a) {
          return 2 === c.length ? c(2, void 0) : c.bind(null, 2, void 0);
        }
        if (a.tag) {
          return (a = a[0]), 2 === c.length ? c(1, a) : c.bind(null, 1, a);
        }
        var d = a[0];
        return 2 === c.length ? c(0, b) : c.bind(null, 0, b);
      });
    }
  };
}

function toObservable$2(a) {
  var b = {
    subscribe: function (b, d, e) {
      var c = ('object' == typeof b ? b.next.bind(b) : b) || R,
        g = ('object' == typeof b ? b.complete.bind(b) : e) || S;
      let h = m,
        k = !1;
      a(function (a) {
        if ('number' == typeof a) {
          return (k = !0), g();
        }
        if (a.tag) {
          if (k) {
            return;
          }
          c(a[0]);
          return h(0);
        }
        h = a = a[0];
        a(0);
      });
      return {
        unsubscribe: function () {
          if (!k) {
            return (this.closed = !1), (k = !0), h(1);
          }
        },
        closed: !1,
      };
    },
  };
  b[P] = function () {
    return b;
  };
  return b;
}

function toPromise$1(a) {
  return new Promise(function (b) {
    M(1)(a)(function (a) {
      if ('number' != typeof a) {
        if (a.tag) {
          b(a[0]);
        } else {
          a[0](0);
        }
      }
    });
  });
}

var v = [],
  P =
    'function' == typeof Symbol
      ? Symbol.observable || (Symbol.observable = Symbol('observable'))
      : '@@observable';




/***/ }),

/***/ 88593:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(17109), __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);